{
  "license": {
    "type": "Creative Commons Attribution-ShareAlike 4.0 International",
    "url": "https://creativecommons.org/licenses/by-sa/4.0/"
  },
  "attribution": {
    "adaptive-palette": {
      "author": "IDRC, OCAD University",
      "source": "https://idrc.ocadu.ca/"
    },
    "blissary": {
      "author": "Hannes Ljusås",
      "source": "https://blissary.com"
    },
    "bci-av": {
      "author": "Blissymbolics Communication International",
      "source": "https://blissymbolics.org/index.php/bci-av-2026"
    }
  },
  "data": [
    {
      "id": 1,
      "bciAvId": 8483,
      "gloss": "exclamation mark",
      "glossSv": "utropstecken",
      "pos": "expression",
      "explanation": "punctuation mark - 1. used as punctuation in symbol sentences; 2. used to indicate that the symbol statement that follows it is in the imperative form",
      "isCharacter": true
    },
    {
      "id": 2,
      "bciAvId": 8484,
      "gloss": "percent, percentage, %",
      "glossSv": "procent, %",
      "pos": "noun",
      "explanation": "international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 3,
      "bciAvId": 8485,
      "gloss": "question mark",
      "glossSv": "frågetecken",
      "pos": "noun",
      "explanation": "punctuation mark - used as punctuation in symbol sentences",
      "isCharacter": true
    },
    {
      "id": 4,
      "bciAvId": 8486,
      "gloss": "period, point, full stop, decimal point",
      "glossSv": "punkt",
      "pos": "expression",
      "explanation": "punctuation mark - 1. used as punctuation in symbol sentences; 2. international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 5,
      "bciAvId": 8487,
      "gloss": "comma",
      "glossSv": "kommatecken",
      "pos": "expression",
      "explanation": "punctuation mark - 1. used as punctuation in symbol sentences; 2. used to divide component parts of compound and combined symbols, in order to clarify meaning",
      "isCharacter": true
    },
    {
      "id": 6,
      "bciAvId": 8488,
      "gloss": "colon",
      "glossSv": "kolon",
      "pos": "expression",
      "explanation": "punctuation mark",
      "isCharacter": true
    },
    {
      "id": 7,
      "bciAvId": 8489,
      "gloss": "apostrophe",
      "pos": "expression",
      "explanation": "punctuation mark",
      "isCharacter": true
    },
    {
      "id": 8,
      "bciAvId": 8490,
      "gloss": "degree",
      "pos": "expression",
      "explanation": "punctuation mark",
      "isCharacter": true
    },
    {
      "id": 9,
      "bciAvId": 8496,
      "gloss": "zero (digit), 0",
      "glossSv": "noll, 0",
      "pos": "expression",
      "explanation": "Arabic numeral 0",
      "isCharacter": true
    },
    {
      "id": 10,
      "bciAvId": 8497,
      "gloss": "one (digit), 1, modifier (first person)",
      "glossSv": "ett, 1",
      "pos": "expression",
      "explanation": "Arabic numeral 1",
      "isCharacter": true
    },
    {
      "id": 11,
      "bciAvId": 8498,
      "gloss": "two (digit), 2, modifier (second person)",
      "glossSv": "två, 2",
      "pos": "expression",
      "explanation": "Arabic numeral 2",
      "isCharacter": true
    },
    {
      "id": 12,
      "bciAvId": 8499,
      "gloss": "three (digit), 3, modifier (third person)",
      "glossSv": "tre, 3",
      "pos": "expression",
      "explanation": "Arabic numeral 3",
      "isCharacter": true
    },
    {
      "id": 13,
      "bciAvId": 8500,
      "gloss": "four (digit), 4",
      "glossSv": "fyra, 4",
      "pos": "expression",
      "explanation": "Arabic numeral 4",
      "isCharacter": true
    },
    {
      "id": 14,
      "bciAvId": 8501,
      "gloss": "five (digit), 5",
      "glossSv": "fem, 5",
      "pos": "expression",
      "explanation": "Arabic numeral 5",
      "isCharacter": true
    },
    {
      "id": 15,
      "bciAvId": 8502,
      "gloss": "six (digit), 6",
      "glossSv": "sex, 6",
      "pos": "expression",
      "explanation": "Arabic numeral 6",
      "isCharacter": true
    },
    {
      "id": 16,
      "bciAvId": 8503,
      "gloss": "seven (digit), 7",
      "glossSv": "sju, 7",
      "pos": "expression",
      "explanation": "Arabic numeral 7",
      "isCharacter": true
    },
    {
      "id": 17,
      "bciAvId": 8504,
      "gloss": "eight (digit), 8",
      "glossSv": "åtta, 8",
      "pos": "expression",
      "explanation": "Arabic numeral 8",
      "isCharacter": true
    },
    {
      "id": 18,
      "bciAvId": 8505,
      "gloss": "nine (digit), 9",
      "glossSv": "nio, 9",
      "pos": "expression",
      "explanation": "Arabic numeral 9",
      "isCharacter": true
    },
    {
      "id": 19,
      "bciAvId": 8510,
      "gloss": "zero (index number)",
      "glossSv": "noll (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 0 - small",
      "isCharacter": true
    },
    {
      "id": 20,
      "bciAvId": 8511,
      "gloss": "one (index number)",
      "glossSv": "ett (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 1 - small",
      "isCharacter": true
    },
    {
      "id": 21,
      "bciAvId": 8512,
      "gloss": "two (index number)",
      "glossSv": "två (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 2 - small",
      "isCharacter": true
    },
    {
      "id": 22,
      "bciAvId": 8513,
      "gloss": "three (index number)",
      "glossSv": "tre (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 3 - small",
      "isCharacter": true
    },
    {
      "id": 23,
      "bciAvId": 8514,
      "gloss": "four (index number)",
      "glossSv": "fyra (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 4 - small",
      "isCharacter": true
    },
    {
      "id": 24,
      "bciAvId": 8515,
      "gloss": "five (index number)",
      "glossSv": "fem (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 5 - small",
      "isCharacter": true
    },
    {
      "id": 25,
      "bciAvId": 8516,
      "gloss": "six (index number)",
      "glossSv": "sex (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 6 - small",
      "isCharacter": true
    },
    {
      "id": 26,
      "bciAvId": 8517,
      "gloss": "seven (index number)",
      "glossSv": "sju (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 7 - small",
      "isCharacter": true
    },
    {
      "id": 27,
      "bciAvId": 8518,
      "gloss": "eight (index number)",
      "glossSv": "åtta (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 8 - small",
      "isCharacter": true
    },
    {
      "id": 28,
      "bciAvId": 8519,
      "gloss": "nine (index number)",
      "glossSv": "nio (indexsiffra)",
      "pos": "expression",
      "explanation": "Arabic numeral 9 - small",
      "isCharacter": true
    },
    {
      "id": 29,
      "bciAvId": 8521,
      "gloss": "a (lowercase)",
      "glossSv": "a (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter a",
      "isCharacter": true
    },
    {
      "id": 30,
      "bciAvId": 8522,
      "gloss": "b (lowercase)",
      "glossSv": "b (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter b",
      "isCharacter": true
    },
    {
      "id": 31,
      "bciAvId": 8523,
      "gloss": "c (lowercase)",
      "glossSv": "c (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter c",
      "isCharacter": true
    },
    {
      "id": 32,
      "bciAvId": 8524,
      "gloss": "d (lowercase)",
      "glossSv": "d (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter d",
      "isCharacter": true
    },
    {
      "id": 33,
      "bciAvId": 8525,
      "gloss": "e (lowercase)",
      "glossSv": "e (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter e",
      "isCharacter": true
    },
    {
      "id": 34,
      "bciAvId": 8526,
      "gloss": "f (lowercase)",
      "glossSv": "f (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter f",
      "isCharacter": true
    },
    {
      "id": 35,
      "bciAvId": 8527,
      "gloss": "g (lowercase)",
      "glossSv": "g (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter g",
      "isCharacter": true
    },
    {
      "id": 36,
      "bciAvId": 8528,
      "gloss": "h (lowercase)",
      "glossSv": "h (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter h",
      "isCharacter": true
    },
    {
      "id": 37,
      "bciAvId": 8529,
      "gloss": "i (lowercase)",
      "glossSv": "i (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter i",
      "isCharacter": true
    },
    {
      "id": 38,
      "bciAvId": 8530,
      "gloss": "j (lowercase)",
      "glossSv": "j (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter j",
      "isCharacter": true
    },
    {
      "id": 39,
      "bciAvId": 8531,
      "gloss": "k (lowercase)",
      "glossSv": "k (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter k",
      "isCharacter": true
    },
    {
      "id": 40,
      "bciAvId": 8532,
      "gloss": "l (lowercase)",
      "glossSv": "l (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter l",
      "isCharacter": true
    },
    {
      "id": 41,
      "bciAvId": 8533,
      "gloss": "m (lowercase)",
      "glossSv": "m (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter m",
      "isCharacter": true
    },
    {
      "id": 42,
      "bciAvId": 8534,
      "gloss": "n (lowercase)",
      "glossSv": "n (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter n",
      "isCharacter": true
    },
    {
      "id": 43,
      "bciAvId": 8535,
      "gloss": "o (lowercase)",
      "glossSv": "o (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter o",
      "isCharacter": true
    },
    {
      "id": 44,
      "bciAvId": 8536,
      "gloss": "p (lowercase)",
      "glossSv": "p (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter p",
      "isCharacter": true
    },
    {
      "id": 45,
      "bciAvId": 8537,
      "gloss": "q (lowercase)",
      "glossSv": "q (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter q",
      "isCharacter": true
    },
    {
      "id": 46,
      "bciAvId": 8538,
      "gloss": "r (lowercase)",
      "glossSv": "r (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter r",
      "isCharacter": true
    },
    {
      "id": 47,
      "bciAvId": 8539,
      "gloss": "s (lowercase)",
      "glossSv": "s (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter s",
      "isCharacter": true
    },
    {
      "id": 48,
      "bciAvId": 8540,
      "gloss": "t (lowercase)",
      "glossSv": "t (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter t",
      "isCharacter": true
    },
    {
      "id": 49,
      "bciAvId": 8541,
      "gloss": "u (lowercase)",
      "glossSv": "u (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter u",
      "isCharacter": true
    },
    {
      "id": 50,
      "bciAvId": 8542,
      "gloss": "v (lowercase)",
      "glossSv": "v (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter v",
      "isCharacter": true
    },
    {
      "id": 51,
      "bciAvId": 8543,
      "gloss": "w (lowercase)",
      "glossSv": "w (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter w",
      "isCharacter": true
    },
    {
      "id": 52,
      "bciAvId": 8544,
      "gloss": "x (lowercase)",
      "glossSv": "x (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter x",
      "isCharacter": true
    },
    {
      "id": 53,
      "bciAvId": 8545,
      "gloss": "y (lowercase)",
      "glossSv": "y (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter y",
      "isCharacter": true
    },
    {
      "id": 54,
      "bciAvId": 8546,
      "gloss": "z (lowercase)",
      "glossSv": "z (lilla)",
      "pos": "expression",
      "explanation": "Latin English lowercase letter z",
      "isCharacter": true
    },
    {
      "id": 55,
      "bciAvId": 8551,
      "gloss": "A (uppercase)",
      "glossSv": "A (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter A",
      "isCharacter": true
    },
    {
      "id": 56,
      "bciAvId": 8552,
      "gloss": "B (uppercase)",
      "glossSv": "B (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter B",
      "isCharacter": true
    },
    {
      "id": 57,
      "bciAvId": 8553,
      "gloss": "C (uppercase)",
      "glossSv": "C (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter C",
      "isCharacter": true
    },
    {
      "id": 58,
      "bciAvId": 8554,
      "gloss": "D (uppercase)",
      "glossSv": "D (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter D",
      "isCharacter": true
    },
    {
      "id": 59,
      "bciAvId": 8555,
      "gloss": "E (uppercase)",
      "glossSv": "E (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter E",
      "isCharacter": true
    },
    {
      "id": 60,
      "bciAvId": 8556,
      "gloss": "F (uppercase)",
      "glossSv": "F (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter F",
      "isCharacter": true
    },
    {
      "id": 61,
      "bciAvId": 8557,
      "gloss": "G (uppercase)",
      "glossSv": "G (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter G",
      "isCharacter": true
    },
    {
      "id": 62,
      "bciAvId": 8558,
      "gloss": "H (uppercase)",
      "glossSv": "H (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter H",
      "isCharacter": true
    },
    {
      "id": 63,
      "bciAvId": 8559,
      "gloss": "I (uppercase)",
      "glossSv": "I (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter I",
      "isCharacter": true
    },
    {
      "id": 64,
      "bciAvId": 8560,
      "gloss": "J (uppercase)",
      "glossSv": "J (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter J",
      "isCharacter": true
    },
    {
      "id": 65,
      "bciAvId": 8561,
      "gloss": "K (uppercase)",
      "glossSv": "K (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter K",
      "isCharacter": true
    },
    {
      "id": 66,
      "bciAvId": 8562,
      "gloss": "L (uppercase)",
      "glossSv": "L (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter L",
      "isCharacter": true
    },
    {
      "id": 67,
      "bciAvId": 8563,
      "gloss": "M (uppercase)",
      "glossSv": "M (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter M",
      "isCharacter": true
    },
    {
      "id": 68,
      "bciAvId": 8564,
      "gloss": "N (uppercase)",
      "glossSv": "N (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter N",
      "isCharacter": true
    },
    {
      "id": 69,
      "bciAvId": 8565,
      "gloss": "O (uppercase)",
      "glossSv": "O (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter O",
      "isCharacter": true
    },
    {
      "id": 70,
      "bciAvId": 8566,
      "gloss": "P (uppercase)",
      "glossSv": "P (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter P",
      "isCharacter": true
    },
    {
      "id": 71,
      "bciAvId": 8567,
      "gloss": "Q (uppercase)",
      "glossSv": "Q (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter Q",
      "isCharacter": true
    },
    {
      "id": 72,
      "bciAvId": 8568,
      "gloss": "R (uppercase)",
      "glossSv": "R (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter R",
      "isCharacter": true
    },
    {
      "id": 73,
      "bciAvId": 8569,
      "gloss": "S (uppercase)",
      "glossSv": "S (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter S",
      "isCharacter": true
    },
    {
      "id": 74,
      "bciAvId": 8570,
      "gloss": "T (uppercase)",
      "glossSv": "T (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter T",
      "isCharacter": true
    },
    {
      "id": 75,
      "bciAvId": 8571,
      "gloss": "U (uppercase)",
      "glossSv": "U (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter U",
      "isCharacter": true
    },
    {
      "id": 76,
      "bciAvId": 8572,
      "gloss": "V (uppercase)",
      "glossSv": "V (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter V",
      "isCharacter": true
    },
    {
      "id": 77,
      "bciAvId": 8573,
      "gloss": "W (uppercase)",
      "glossSv": "W (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter W",
      "isCharacter": true
    },
    {
      "id": 78,
      "bciAvId": 8574,
      "gloss": "X (uppercase)",
      "glossSv": "X (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter X",
      "isCharacter": true
    },
    {
      "id": 79,
      "bciAvId": 8575,
      "gloss": "Y (uppercase)",
      "glossSv": "Y (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter Y",
      "isCharacter": true
    },
    {
      "id": 80,
      "bciAvId": 8576,
      "gloss": "Z (uppercase)",
      "glossSv": "Z (stora)",
      "pos": "expression",
      "explanation": "Latin English uppercase letter Z",
      "isCharacter": true
    },
    {
      "id": 81,
      "bciAvId": 8993,
      "gloss": "indicator (action)",
      "glossSv": "operator (handling, infinitiv)",
      "pos": "function",
      "explanation": "action [quarter-sized]: placed above a symbol to create (1) the infinitive form of a verb, and (2) the present tense of a verb",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 82,
      "bciAvId": 8994,
      "gloss": "indicator (active)",
      "glossSv": "operator (handling aktiv form)",
      "pos": "function",
      "explanation": "action indicator [modification]: turned on its side and pointing forward: placed above a symbol to emphasize that something is acting on something else. The symbol is logically related to about.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 83,
      "bciAvId": 8995,
      "gloss": "indicator (conditional)",
      "glossSv": "operator (konditionalis)",
      "pos": "function",
      "explanation": "question mark [quarter-sized]: placed above a symbol to indicate the equivalent of the English present conditional form",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 84,
      "bciAvId": 8996,
      "gloss": "indicator (description after fact)",
      "glossSv": "operator (värdering efter faktum)",
      "pos": "function",
      "explanation": "description indicator + dot: placed above a symbol to indicate meanings equivalent to an English past participle, usually with an -ed or -en ending",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 85,
      "bciAvId": 8997,
      "gloss": "indicator (description before fact)",
      "glossSv": "operator (värdering före faktum)",
      "pos": "function",
      "explanation": "dot + description indicator: the dot comes before the indicator: placed above a symbol to produce meanings equivalent to English words ending in -able",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 86,
      "bciAvId": 8998,
      "gloss": "indicator (description)",
      "glossSv": "operator (värdering, adjektiv, adverb)",
      "pos": "function",
      "explanation": "evaluation [quarter-sized]: placed above a symbol to show that it is describing or evaluating something. This indicator produces meanings equivalent to English adjectives and adverbs.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 87,
      "bciAvId": 8999,
      "gloss": "indicator (future action)",
      "glossSv": "operator (handling framtid, futurum)",
      "pos": "function",
      "explanation": "future [quarter-sized]: placed above a symbol to indicate future action",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 88,
      "bciAvId": 9000,
      "gloss": "indicator (future conditional)",
      "glossSv": "operator (konditionalis framtid)",
      "pos": "function",
      "explanation": "conditional indicator + future action indicator: placed above a symbol to indicate the future conditional form",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 89,
      "bciAvId": 9001,
      "gloss": "indicator (future passive)",
      "glossSv": "operator (passiv form framtid)",
      "pos": "function",
      "explanation": "passive indicator + future action indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 90,
      "bciAvId": 9002,
      "gloss": "indicator (future passive conditional)",
      "glossSv": "operator (konditionalis passiv form i framtiden)",
      "pos": "function",
      "explanation": "passive indicator + future conditional indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 91,
      "bciAvId": 9003,
      "gloss": "indicator (passive)",
      "glossSv": "operator (passiv form)",
      "pos": "function",
      "explanation": "action indicator [modification]: turned on its side and pointing backward: placed above a symbol to emphasize that something is being acted upon. The symbol is logically related to by.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 92,
      "bciAvId": 9004,
      "gloss": "indicator (past action)",
      "glossSv": "operator (handling i förfluten tid)",
      "pos": "function",
      "explanation": "past [quarter-sized]: placed above a symbol to indicate past action",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 93,
      "bciAvId": 9005,
      "gloss": "indicator (past conditional)",
      "glossSv": "operator (konditionalis i förfluten tid)",
      "pos": "function",
      "explanation": "conditional indicator + past action indicator: placed above a symbol to indicate the past conditional form",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 94,
      "bciAvId": 9006,
      "gloss": "indicator (past passive conditional)",
      "glossSv": "operator (konditionalis passiv form i förfluten tid)",
      "pos": "function",
      "explanation": "passive indicator + past conditional indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 95,
      "bciAvId": 9007,
      "gloss": "indicator (past passive)",
      "glossSv": "operator (passiv form i förfluten tid)",
      "pos": "function",
      "explanation": "passive indicator + past action indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 96,
      "bciAvId": 9008,
      "gloss": "indicator (present passive conditional)",
      "glossSv": "operator (konditionalis i passiv form)",
      "pos": "function",
      "explanation": "passive indicator + conditional indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 97,
      "bciAvId": 9009,
      "gloss": "indicator (thing)",
      "glossSv": "operator (konkretisering)",
      "pos": "function",
      "explanation": "thing [quarter-sized]: placed above a symbol to represent a concrete object",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 98,
      "bciAvId": 9010,
      "gloss": "indicator (thing plural)",
      "glossSv": "operator (konkretisering i plural)",
      "pos": "function",
      "explanation": "thing indicator + plural indicator",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 99,
      "bciAvId": 9011,
      "gloss": "indicator (plural)",
      "glossSv": "operator (flertal, plural)",
      "pos": "function",
      "explanation": "multiplication [quarter-sized]: placed above a symbol to indicate a plural form",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 100,
      "bciAvId": 12321,
      "gloss": "a, an, any",
      "glossSv": "en, ett",
      "pos": "expression",
      "explanation": "diagonal line suggests an index finger pointing at something unspecific. The diagonal line has the opposite orientation to the one used in the, this and that.",
      "isCharacter": true
    },
    {
      "id": 101,
      "bciAvId": 12322,
      "gloss": "ability, capability, capacity, potential",
      "glossSv": "förmåga, kapacitet",
      "pos": "noun",
      "explanation": "dot + evaluation: evaluation beforehand of one’s potential to do something",
      "isCharacter": true
    },
    {
      "id": 102,
      "bciAvId": 12324,
      "gloss": "about, concerning, regarding, in relation to, of, on",
      "glossSv": "om, på",
      "pos": "expression",
      "explanation": "relation [half-sized], pointing forward: used to mean on when the symbol refers to time, e.g. on Wednesday",
      "isCharacter": true
    },
    {
      "id": 103,
      "bciAvId": 12330,
      "gloss": "account",
      "glossSv": "konto",
      "pos": "noun",
      "explanation": "paper [modification] + container: written (financial) record of something held",
      "isCharacter": true
    },
    {
      "id": 104,
      "bciAvId": 12333,
      "gloss": "across",
      "glossSv": "tvärs över",
      "pos": "expression",
      "explanation": "pictograph: a vertical line with two horizontal lines [half sized] across it: CKB says this is a small road crossing a main road",
      "isCharacter": true
    },
    {
      "id": 105,
      "bciAvId": 12334,
      "gloss": "action, act, deed",
      "glossSv": "handling",
      "pos": "noun",
      "explanation": "symbol suggests the shape of a volcano cone, which CKB says represents \"one of the primeval actions of our earth\". The Action [full-sized], is used primarily as the source of activity - action [half-sized]",
      "isCharacter": true
    },
    {
      "id": 106,
      "bciAvId": 12335,
      "gloss": "activity, male gender (in combinations)",
      "glossSv": "aktivitet, hankön (i kombinationer)",
      "pos": "noun",
      "explanation": "action [half-sized]",
      "isCharacter": true
    },
    {
      "id": 107,
      "bciAvId": 12339,
      "gloss": "addition, gain",
      "glossSv": "tillägg, vinst, addition",
      "pos": "noun",
      "explanation": "based upon the international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 108,
      "bciAvId": 12341,
      "gloss": "adult, grownup",
      "glossSv": "vuxen",
      "pos": "person",
      "explanation": "flower + big: CKB suggests that an adult is a person reaching \"full flower\"",
      "isCharacter": true
    },
    {
      "id": 109,
      "bciAvId": 12348,
      "gloss": "after, behind",
      "glossSv": "efter, bakom",
      "pos": "expression",
      "explanation": "reference line + dot: dot comes after the reference line. This symbol refers to both time and space.",
      "isCharacter": true
    },
    {
      "id": 110,
      "bciAvId": 12350,
      "gloss": "again",
      "glossSv": "igen",
      "pos": "expression",
      "explanation": "dot is repeated: it appears once and then again",
      "isCharacter": true
    },
    {
      "id": 111,
      "bciAvId": 12351,
      "gloss": "against, opposed to",
      "glossSv": "mot",
      "pos": "expression",
      "explanation": "opposition [half-sized]",
      "isCharacter": true
    },
    {
      "id": 112,
      "bciAvId": 12352,
      "gloss": "ago, then (past)",
      "glossSv": "förut, då",
      "pos": "expression",
      "explanation": "past [half-sized]",
      "isCharacter": true
    },
    {
      "id": 113,
      "bciAvId": 12354,
      "gloss": "agreement",
      "glossSv": "enighet",
      "pos": "noun",
      "explanation": "two parallel arrows: to be in harmony",
      "isCharacter": true
    },
    {
      "id": 114,
      "bciAvId": 12356,
      "gloss": "air, atmosphere",
      "glossSv": "luft",
      "pos": "noun",
      "explanation": "sky + nose: one breathes air from the sky",
      "isCharacter": true
    },
    {
      "id": 115,
      "bciAvId": 12357,
      "gloss": "aeroplane, airplane, plane",
      "glossSv": "flygplan",
      "pos": "noun",
      "explanation": "wings + wheel",
      "isCharacter": true
    },
    {
      "id": 116,
      "bciAvId": 12359,
      "gloss": "alcoholic drink, alcoholic beverage, liquor",
      "glossSv": "dryck med alkohol, sprit",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a wine glass",
      "isCharacter": true
    },
    {
      "id": 117,
      "bciAvId": 12360,
      "gloss": "all, every, everything, total, whole",
      "glossSv": "all, hel",
      "pos": "expression",
      "explanation": "multitude + enclosure: symbol reminds us that “all” can only refer to some restricted multitude",
      "isCharacter": true
    },
    {
      "id": 118,
      "bciAvId": 12366,
      "gloss": "alphabet, letters (lowercase) (Latin alphabet)",
      "glossSv": "alfabetet, bokstäver (gemener)",
      "pos": "noun",
      "explanation": "a (lowercase) + b (lowercase) + c (lowercase): first three letters of the English alphabet, representing the entire alphabet",
      "isCharacter": true
    },
    {
      "id": 119,
      "bciAvId": 12367,
      "gloss": "although",
      "glossSv": "fastän, även om",
      "pos": "expression",
      "explanation": "three arrowheads: one arrowhead moves forward between and beyond two opposing arrowheads",
      "isCharacter": true
    },
    {
      "id": 120,
      "bciAvId": 12374,
      "gloss": "and, also, plus, too",
      "glossSv": "och, också, plus",
      "pos": "expression",
      "explanation": "addition [half-sized] with the crossbar located in the midline",
      "isCharacter": true
    },
    {
      "id": 121,
      "bciAvId": 12376,
      "gloss": "angle",
      "glossSv": "vinkel",
      "pos": "noun",
      "explanation": "international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 122,
      "bciAvId": 12378,
      "gloss": "animal, beast",
      "glossSv": "djur",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a creature with four legs",
      "isCharacter": true
    },
    {
      "id": 123,
      "bciAvId": 12379,
      "gloss": "animal (bovine, ovine), bovid, bovine",
      "glossSv": "ko, tjur, nötboskap",
      "pos": "noun",
      "explanation": "animal + horn(s) pictograph",
      "isCharacter": true
    },
    {
      "id": 124,
      "bciAvId": 12380,
      "gloss": "dog, canine (animal), canid",
      "glossSv": "hund, hunddjur",
      "pos": "noun",
      "explanation": "animal + curved line (representing a tail): the waving tail being characteristic of a dog",
      "isCharacter": true
    },
    {
      "id": 125,
      "bciAvId": 12381,
      "gloss": "deer, cervine (animal), cervid",
      "glossSv": "hjort, hjortdjur",
      "pos": "noun",
      "explanation": "animal + horn(s) pictograph: horns are raised to signify that males shed their horns annually",
      "isCharacter": true
    },
    {
      "id": 126,
      "bciAvId": 12383,
      "gloss": "cat, feline (animal), felid",
      "glossSv": "katt, kattdjur",
      "pos": "noun",
      "explanation": "animal + small curved lines (representing claws): the claws being characteristic of cats",
      "isCharacter": true
    },
    {
      "id": 127,
      "bciAvId": 12389,
      "gloss": "animal (water)",
      "glossSv": "djur (i vatten)",
      "pos": "noun",
      "explanation": "animal + water [modification, under earthline]",
      "isCharacter": true
    },
    {
      "id": 128,
      "bciAvId": 12391,
      "gloss": "ankle",
      "glossSv": "ankel, fotled",
      "pos": "noun",
      "explanation": "kneeling (kneeling person) + pointer, to ankle joint",
      "isCharacter": true
    },
    {
      "id": 129,
      "bciAvId": 12393,
      "gloss": "answer, reply",
      "glossSv": "svar",
      "pos": "noun",
      "explanation": "question + enclosure [combination]: an answer \"closes\" a question",
      "isCharacter": true
    },
    {
      "id": 130,
      "bciAvId": 12402,
      "gloss": "anywhere, anyplace, someplace, somewhere",
      "glossSv": "någonstans, var som helst",
      "pos": "expression",
      "explanation": "any + earth,ground,land: can be interpreted as a combination of any and place",
      "isCharacter": true
    },
    {
      "id": 131,
      "bciAvId": 12405,
      "gloss": "apple",
      "glossSv": "äpple",
      "pos": "noun",
      "explanation": "pictograph of apple with stem",
      "isCharacter": true
    },
    {
      "id": 132,
      "bciAvId": 12577,
      "gloss": "arm",
      "glossSv": "arm",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests an arm bent upward",
      "isCharacter": true
    },
    {
      "id": 133,
      "bciAvId": 12578,
      "gloss": "armchair",
      "glossSv": "fåtölj",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a chair with support added for the arm",
      "isCharacter": true
    },
    {
      "id": 134,
      "bciAvId": 12580,
      "gloss": "around",
      "glossSv": "omkring",
      "pos": "expression",
      "explanation": "curved line + dot: half circle is around the dot",
      "isCharacter": true
    },
    {
      "id": 135,
      "bciAvId": 12591,
      "gloss": "at",
      "glossSv": "vid, bredvid, hos",
      "pos": "expression",
      "explanation": "position [half-sized]",
      "isCharacter": true
    },
    {
      "id": 136,
      "bciAvId": 12592,
      "gloss": "atom",
      "glossSv": "atom",
      "pos": "noun",
      "explanation": "pictograph of an atom with inner nucleus + pointer showing the movement of a circling electron",
      "isCharacter": true
    },
    {
      "id": 137,
      "bciAvId": 12596,
      "gloss": "aunt",
      "glossSv": "faster, moster",
      "pos": "person",
      "explanation": "sister + parent: the sister of one's father or mother",
      "isCharacter": true
    },
    {
      "id": 138,
      "bciAvId": 12600,
      "gloss": "avocado",
      "glossSv": "avocado",
      "pos": "noun",
      "explanation": "pear + pit",
      "isCharacter": true
    },
    {
      "id": 139,
      "bciAvId": 12602,
      "gloss": "away, at a distance, off",
      "glossSv": "iväg, bort (FD)",
      "pos": "expression",
      "explanation": "reference line [half-sized] + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.",
      "isCharacter": true
    },
    {
      "id": 140,
      "bciAvId": 12603,
      "gloss": "baby, infant",
      "glossSv": "baby",
      "pos": "person",
      "explanation": "child [modification, turned on its side]: child too young to stand",
      "isCharacter": true
    },
    {
      "id": 141,
      "bciAvId": 12604,
      "gloss": "baby boy",
      "glossSv": "baby (pojke)",
      "pos": "person",
      "explanation": "boy [modification, turned on its side]: boy too young to stand",
      "isCharacter": true
    },
    {
      "id": 142,
      "bciAvId": 12607,
      "gloss": "baby girl",
      "glossSv": "baby (flicka)",
      "pos": "person",
      "explanation": "girl [modification, turned on its side]: girl too young to stand",
      "isCharacter": true
    },
    {
      "id": 143,
      "bciAvId": 12609,
      "gloss": "back (body)",
      "glossSv": "rygg",
      "pos": "noun",
      "explanation": "standing person + pointer, to back",
      "isCharacter": true
    },
    {
      "id": 144,
      "bciAvId": 12610,
      "gloss": "back and forth, backward and forward, to and fro, alternation",
      "glossSv": "fram och tillbaka",
      "pos": "expression",
      "explanation": "backward [modification, on earthline] + forward",
      "isCharacter": true
    },
    {
      "id": 145,
      "bciAvId": 12613,
      "gloss": "backward, back",
      "glossSv": "tillbaka, bakåt",
      "pos": "expression",
      "explanation": "arrow, pointing backward",
      "isCharacter": true
    },
    {
      "id": 146,
      "bciAvId": 12616,
      "gloss": "badge, shield",
      "glossSv": "märke, sköld",
      "pos": "noun",
      "explanation": "pictograph: symbol is shaped like a badge",
      "isCharacter": true
    },
    {
      "id": 147,
      "bciAvId": 12618,
      "gloss": "baggage, bag, luggage, suitcase",
      "glossSv": "väska, bagage",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 148,
      "bciAvId": 12621,
      "gloss": "ball",
      "glossSv": "boll",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a small stitched ball",
      "isCharacter": true
    },
    {
      "id": 149,
      "bciAvId": 12622,
      "gloss": "balloon",
      "glossSv": "ballong",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 150,
      "bciAvId": 12623,
      "gloss": "banana",
      "glossSv": "banan",
      "pos": "noun",
      "explanation": "pictograph with stem: crescent-shaped fruit suggesting a banana",
      "isCharacter": true
    },
    {
      "id": 151,
      "bciAvId": 12631,
      "gloss": "barrier (contraceptive)",
      "glossSv": "preventivmedel",
      "pos": "noun",
      "explanation": "sperm + vertical line: combination of sperm and stop (to)",
      "isCharacter": true
    },
    {
      "id": 152,
      "bciAvId": 12636,
      "gloss": "bat (animal)",
      "glossSv": "fladdermus",
      "pos": "noun",
      "explanation": "animal + wing(s): flying animal",
      "isCharacter": true
    },
    {
      "id": 153,
      "bciAvId": 12640,
      "gloss": "beach, bank, coast, shore",
      "glossSv": "strand, kust",
      "pos": "noun",
      "explanation": "earth + water (ground level): place where land touches water",
      "isCharacter": true
    },
    {
      "id": 154,
      "bciAvId": 12642,
      "gloss": "bean",
      "glossSv": "böna",
      "pos": "noun",
      "explanation": "pictograph: cross section of bean in a pod",
      "isCharacter": true
    },
    {
      "id": 155,
      "bciAvId": 12644,
      "gloss": "beard",
      "glossSv": "skägg",
      "pos": "noun",
      "explanation": "face with beard + pointer, to beard",
      "isCharacter": true
    },
    {
      "id": 156,
      "bciAvId": 12649,
      "gloss": "bed",
      "glossSv": "säng, bädd",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a bed with a pillow at the head",
      "isCharacter": true
    },
    {
      "id": 157,
      "bciAvId": 12655,
      "gloss": "beetle",
      "glossSv": "skalbagge",
      "pos": "noun",
      "explanation": "insect + pictograph of wing cases [hard shell]",
      "isCharacter": true
    },
    {
      "id": 158,
      "bciAvId": 12656,
      "gloss": "before, in front of, prior to",
      "glossSv": "före, framför",
      "pos": "expression",
      "explanation": "dot + reference line: the dot comes before the reference line. This symbol refers to both time and space.",
      "isCharacter": true
    },
    {
      "id": 159,
      "bciAvId": 12658,
      "gloss": "beginning, start",
      "glossSv": "början, start",
      "pos": "noun",
      "explanation": "reference line + forward: advancing arrow begins at the reference line",
      "isCharacter": true
    },
    {
      "id": 160,
      "bciAvId": 12663,
      "gloss": "belongs to, of (possessive)",
      "glossSv": "tillhör, hör ihop med...",
      "pos": "function",
      "explanation": "addition [half-sized, modification, with the crossbar located on the earthline]",
      "isCharacter": true
    },
    {
      "id": 161,
      "bciAvId": 12666,
      "gloss": "berry",
      "glossSv": "bär",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a berry with a curved stem, in the position it would have if protruding from a bush",
      "isCharacter": true
    },
    {
      "id": 162,
      "bciAvId": 12669,
      "gloss": "between",
      "glossSv": "mellan",
      "pos": "expression",
      "explanation": "two reference lines + dot, between them",
      "isCharacter": true
    },
    {
      "id": 163,
      "bciAvId": 12837,
      "gloss": "bird",
      "glossSv": "fågel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the wings and feet of a bird",
      "isCharacter": true
    },
    {
      "id": 164,
      "bciAvId": 12840,
      "gloss": "duck, bird (water), waterbird, waterfowl, seabird, seafowl",
      "glossSv": "and, anka, sjöfågel",
      "pos": "noun",
      "explanation": "bird + water [modification, under earthline]: aquatic bird",
      "isCharacter": true
    },
    {
      "id": 165,
      "bciAvId": 12842,
      "gloss": "birth, giving birth, parturition, delivery",
      "glossSv": "födelse, födande",
      "pos": "noun",
      "explanation": "fetus [modification, opening in body] + down,downward [modification]: combination illustrating the birth of a baby",
      "isCharacter": true
    },
    {
      "id": 166,
      "bciAvId": 12843,
      "gloss": "birth",
      "glossSv": "födelse",
      "pos": "noun",
      "explanation": "protection,shelter + star: someone new under the roof. CKB points out that newspapers often use a star to denote a birth.",
      "isCharacter": true
    },
    {
      "id": 167,
      "bciAvId": 12857,
      "gloss": "blissymbol, Bliss-word",
      "glossSv": "blissymbol",
      "pos": "noun",
      "explanation": "world + pen: writing for the world",
      "isCharacter": true
    },
    {
      "id": 168,
      "bciAvId": 12860,
      "gloss": "block, brick",
      "glossSv": "kloss",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a three-dimensional block. It is half the size of box.",
      "isCharacter": true
    },
    {
      "id": 169,
      "bciAvId": 12868,
      "gloss": "board (material)",
      "glossSv": "platta, skiva (material)",
      "pos": "noun",
      "explanation": "table + pointer, to underside: the top of a table is frequently made of boards",
      "isCharacter": true
    },
    {
      "id": 170,
      "bciAvId": 12869,
      "gloss": "boat, ship",
      "glossSv": "båt, fartyg, skepp",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a boat with a mast and also incorporates container.",
      "isCharacter": true
    },
    {
      "id": 171,
      "bciAvId": 12870,
      "gloss": "body, trunk",
      "glossSv": "kropp",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the trunk of the body, without head and limbs. The symbol may be used for body in a general sense.",
      "isCharacter": true
    },
    {
      "id": 172,
      "bciAvId": 12873,
      "gloss": "bone",
      "glossSv": "ben (skelett-)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a bone shaft with ends",
      "isCharacter": true
    },
    {
      "id": 173,
      "bciAvId": 12875,
      "gloss": "book",
      "glossSv": "bok",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests an open book. It can also be explained as: two page symbols.",
      "isCharacter": true
    },
    {
      "id": 174,
      "bciAvId": 12880,
      "gloss": "bottle, flask",
      "glossSv": "flaska",
      "pos": "noun",
      "explanation": "pictograph: suggests bottle with body and neck",
      "isCharacter": true
    },
    {
      "id": 175,
      "bciAvId": 12881,
      "gloss": "bottom, base",
      "glossSv": "undersida",
      "pos": "noun",
      "explanation": "enclosure + pointer, to bottom",
      "isCharacter": true
    },
    {
      "id": 176,
      "bciAvId": 12882,
      "gloss": "bow (knot)",
      "glossSv": "rosett (etc)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 177,
      "bciAvId": 12886,
      "gloss": "box, cube",
      "glossSv": "låda, kub",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a three-dimensional box",
      "isCharacter": true
    },
    {
      "id": 178,
      "bciAvId": 12888,
      "gloss": "boy, lad",
      "glossSv": "pojke, pojk, kille, grabb",
      "pos": "person",
      "explanation": "child + male [combination]",
      "isCharacter": true
    },
    {
      "id": 179,
      "bciAvId": 12894,
      "gloss": "branch",
      "glossSv": "gren, kvist",
      "pos": "noun",
      "explanation": "tree + pointer, to branch",
      "isCharacter": true
    },
    {
      "id": 180,
      "bciAvId": 12895,
      "gloss": "bread, loaf of bread, loaf",
      "glossSv": "bröd",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a loaf of bread",
      "isCharacter": true
    },
    {
      "id": 181,
      "bciAvId": 12899,
      "gloss": "breast(s)",
      "glossSv": "bröst",
      "pos": "noun",
      "explanation": "body + two pointers, to breasts",
      "isCharacter": true
    },
    {
      "id": 182,
      "bciAvId": 12902,
      "gloss": "bridge, overpass",
      "glossSv": "bro",
      "pos": "noun",
      "explanation": "earth [modification, half-sized] + bow,arc + earth [half-sized]: the symbol suggests a bridge between two banks of a river",
      "isCharacter": true
    },
    {
      "id": 183,
      "bciAvId": 12908,
      "gloss": "broom",
      "glossSv": "kvast",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a broom",
      "isCharacter": true
    },
    {
      "id": 184,
      "bciAvId": 12912,
      "gloss": "brush",
      "glossSv": "borste, pensel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a brush in an upright position",
      "isCharacter": true
    },
    {
      "id": 185,
      "bciAvId": 12916,
      "gloss": "bubble(s)",
      "glossSv": "bubbla",
      "pos": "noun",
      "explanation": "gas + pointer, to bubble",
      "isCharacter": true
    },
    {
      "id": 186,
      "bciAvId": 12917,
      "gloss": "buffalo, bison",
      "glossSv": "bisonoxe, buffel",
      "pos": "noun",
      "explanation": "bovine + hump",
      "isCharacter": true
    },
    {
      "id": 187,
      "bciAvId": 12919,
      "gloss": "bulb (flower)",
      "glossSv": "blomsterlök",
      "pos": "noun",
      "explanation": "bulbous plant + pointer, to bulb",
      "isCharacter": true
    },
    {
      "id": 188,
      "bciAvId": 13089,
      "gloss": "bus, coach",
      "glossSv": "buss",
      "pos": "noun",
      "explanation": "vehicle (long) + pictograph of a steering wheel: suggests a bus with many wheels and a steering wheel",
      "isCharacter": true
    },
    {
      "id": 189,
      "bciAvId": 13090,
      "gloss": "bus stop, bus bay",
      "glossSv": "busshållplats (FD)",
      "pos": "noun",
      "explanation": "platform + earth [modification, extended] + bus",
      "isCharacter": true
    },
    {
      "id": 190,
      "bciAvId": 13092,
      "gloss": "bush, shrub",
      "glossSv": "buske",
      "pos": "noun",
      "explanation": "pictograph: small tree growing close to the ground",
      "isCharacter": true
    },
    {
      "id": 191,
      "bciAvId": 13093,
      "gloss": "business, economy, commerce, trade",
      "glossSv": "handel",
      "pos": "noun",
      "explanation": "money + to hold: money is taken into the till",
      "isCharacter": true
    },
    {
      "id": 192,
      "bciAvId": 13094,
      "gloss": "but, except, except for (preposition)",
      "glossSv": "men",
      "pos": "expression",
      "explanation": "CKB likens the but that halts a free flow of speech to a vertical line that stops a horizontal flowing line",
      "isCharacter": true
    },
    {
      "id": 193,
      "bciAvId": 13096,
      "gloss": "butterfly, moth",
      "glossSv": "fjäril, mal",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a butterfly or a moth",
      "isCharacter": true
    },
    {
      "id": 194,
      "bciAvId": 13097,
      "gloss": "buttocks, bottom, bum, rear, ass",
      "glossSv": "stjärt",
      "pos": "noun",
      "explanation": "standing person + pointer, to buttocks",
      "isCharacter": true
    },
    {
      "id": 195,
      "bciAvId": 13100,
      "gloss": "by, by means of, of",
      "glossSv": "av",
      "pos": "expression",
      "explanation": "relation [half-sized], pointing backwards",
      "isCharacter": true
    },
    {
      "id": 196,
      "bciAvId": 13101,
      "gloss": "cabbage",
      "glossSv": "kål",
      "pos": "noun",
      "explanation": "pictograph incorporating leafy vegetable",
      "isCharacter": true
    },
    {
      "id": 197,
      "bciAvId": 13110,
      "gloss": "camel",
      "glossSv": "kamel",
      "pos": "noun",
      "explanation": "animal + pictograph of head and neck and two humps",
      "isCharacter": true
    },
    {
      "id": 198,
      "bciAvId": 13111,
      "gloss": "camera",
      "glossSv": "kamera",
      "pos": "noun",
      "explanation": "enclosure + light: box that uses the sunlight to record what the eye sees",
      "isCharacter": true
    },
    {
      "id": 199,
      "bciAvId": 13113,
      "gloss": "camper, caravan, mobile home",
      "glossSv": "husvagn",
      "pos": "noun",
      "explanation": "vehicle + house [modification, high position] [combination]",
      "isCharacter": true
    },
    {
      "id": 200,
      "bciAvId": 13115,
      "gloss": "cylinder, can",
      "glossSv": "burk, rulle, cylinder",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 201,
      "bciAvId": 13120,
      "gloss": "cannon, gun",
      "glossSv": "kanon",
      "pos": "noun",
      "explanation": "pictograph incorporating wheel and to destroy",
      "isCharacter": true
    },
    {
      "id": 202,
      "bciAvId": 13121,
      "gloss": "car, automobile, motor vehicle",
      "glossSv": "bil",
      "pos": "noun",
      "explanation": "vehicle + pictograph of a steering wheel: suggests a car with a steering wheel",
      "isCharacter": true
    },
    {
      "id": 203,
      "bciAvId": 13124,
      "gloss": "carrot, vegetable (wedge-shaped)",
      "glossSv": "morot, rotfrukt",
      "pos": "noun",
      "explanation": "vegetable (below ground) + pictograph of wedge shape [combination]",
      "isCharacter": true
    },
    {
      "id": 204,
      "bciAvId": 13127,
      "gloss": "cart, carriage",
      "glossSv": "kärra, vagn",
      "pos": "noun",
      "explanation": "transport,transportation + forward [modification, short arrow, high position]: can also be interpreted as a combination of transport and to pull",
      "isCharacter": true
    },
    {
      "id": 205,
      "bciAvId": 13128,
      "gloss": "cassette, audiocassette, videocassette",
      "glossSv": "kassettband, videoband",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 206,
      "bciAvId": 13134,
      "gloss": "cause",
      "glossSv": "orsak",
      "pos": "noun",
      "explanation": "wedge shape that incorporates relation: the wedge presses into the thing on which it has an effect",
      "isCharacter": true
    },
    {
      "id": 207,
      "bciAvId": 13138,
      "gloss": "cavity, caries",
      "glossSv": "hål (i tand)",
      "pos": "noun",
      "explanation": "teeth + dot",
      "isCharacter": true
    },
    {
      "id": 208,
      "bciAvId": 13139,
      "gloss": "ceiling",
      "glossSv": "tak, innertak",
      "pos": "noun",
      "explanation": "room + pointer, to ceiling",
      "isCharacter": true
    },
    {
      "id": 209,
      "bciAvId": 13140,
      "gloss": "celery",
      "glossSv": "bladselleri",
      "pos": "noun",
      "explanation": "vegetable (above ground) [modification] + pictograph of a cluster of stalks",
      "isCharacter": true
    },
    {
      "id": 210,
      "bciAvId": 13143,
      "gloss": "cent",
      "glossSv": "cent",
      "pos": "noun",
      "explanation": "international symbol for cent",
      "isCharacter": true
    },
    {
      "id": 211,
      "bciAvId": 13145,
      "gloss": "cereal",
      "glossSv": "flingor, müsli",
      "pos": "noun",
      "explanation": "dish + grain",
      "isCharacter": true
    },
    {
      "id": 212,
      "bciAvId": 13148,
      "gloss": "chair, seat",
      "glossSv": "stol",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 213,
      "bciAvId": 13151,
      "gloss": "change, alteration, conversion",
      "glossSv": "förändring, omväxling",
      "pos": "noun",
      "explanation": "weather [modification]: CKB says that weather is ever-changing. Can also be interpreted as; life + water, ever-changing in state. The symbol represents change in a general sense.",
      "isCharacter": true
    },
    {
      "id": 214,
      "bciAvId": 13156,
      "gloss": "cheek",
      "glossSv": "kind",
      "pos": "noun",
      "explanation": "face + pointer, to cheek",
      "isCharacter": true
    },
    {
      "id": 215,
      "bciAvId": 13157,
      "gloss": "cheese",
      "glossSv": "ost",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a wedge of cheese",
      "isCharacter": true
    },
    {
      "id": 216,
      "bciAvId": 13158,
      "gloss": "chemical product",
      "glossSv": "kemisk produkt",
      "pos": "noun",
      "explanation": "pictograph symbol suggests the outline of a chemical retort + thing [modification, lower position] [combination]",
      "isCharacter": true
    },
    {
      "id": 217,
      "bciAvId": 13159,
      "gloss": "cherry, cherries",
      "glossSv": "körsbär",
      "pos": "noun",
      "explanation": "fruit + pit,stone [modification,lower position] + fruit [modification] + pit,stone [modification,lower position]: pictograph of cherries combined in a cluster",
      "isCharacter": true
    },
    {
      "id": 218,
      "bciAvId": 13161,
      "gloss": "chest",
      "glossSv": "bröstkorg",
      "pos": "noun",
      "explanation": "body + pointer, to chest",
      "isCharacter": true
    },
    {
      "id": 219,
      "bciAvId": 13162,
      "gloss": "chest of drawers, bureau, dresser",
      "glossSv": "byrå",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 220,
      "bciAvId": 13166,
      "gloss": "child, kid, youngster",
      "glossSv": "barn",
      "pos": "person",
      "explanation": "flower + little [combination]: CKB writes: A child is like a \"little flower\". The symbol also can be explained as a pictograph showing the head, arms, feet and body of a child.",
      "isCharacter": true
    },
    {
      "id": 221,
      "bciAvId": 13168,
      "gloss": "chimney",
      "glossSv": "skorsten",
      "pos": "noun",
      "explanation": "building with chimney + pointer, to chimney",
      "isCharacter": true
    },
    {
      "id": 222,
      "bciAvId": 13169,
      "gloss": "chin",
      "glossSv": "haka",
      "pos": "noun",
      "explanation": "face + pointer, to chin",
      "isCharacter": true
    },
    {
      "id": 223,
      "bciAvId": 13175,
      "gloss": "choice, selection, election",
      "glossSv": "val, urval",
      "pos": "noun",
      "explanation": "comparative more + eye [modification, low position]: combination of eye and to divide [half-sized] and many: the eye makes a choice among many things",
      "isCharacter": true
    },
    {
      "id": 224,
      "bciAvId": 13346,
      "gloss": "cigarette",
      "glossSv": "cigarett",
      "pos": "noun",
      "explanation": "smoking (cigarette) + pointer, to cigarette",
      "isCharacter": true
    },
    {
      "id": 225,
      "bciAvId": 13349,
      "gloss": "citizen",
      "glossSv": "invånare",
      "pos": "person",
      "explanation": "earth + man + woman [combination]: man or woman having a relationship to a country or territory",
      "isCharacter": true
    },
    {
      "id": 226,
      "bciAvId": 13354,
      "gloss": "claw (animal)",
      "glossSv": "klo (djur)",
      "pos": "noun",
      "explanation": "feline + pointer, to claw",
      "isCharacter": true
    },
    {
      "id": 227,
      "bciAvId": 13355,
      "gloss": "claw (bird)",
      "glossSv": "klo (fågel)",
      "pos": "noun",
      "explanation": "bird + pictograph of claws + pointer, to claw",
      "isCharacter": true
    },
    {
      "id": 228,
      "bciAvId": 13365,
      "gloss": "cloth, fabric, material, textile, net",
      "glossSv": "tyg",
      "pos": "noun",
      "explanation": "pictograph: symbol looks like woven threads, suggesting cloth",
      "isCharacter": true
    },
    {
      "id": 229,
      "bciAvId": 13366,
      "gloss": "clothing, clothes, garment",
      "glossSv": "kläder",
      "pos": "noun",
      "explanation": "cloth + protection",
      "isCharacter": true
    },
    {
      "id": 230,
      "bciAvId": 13367,
      "gloss": "cloud",
      "glossSv": "moln",
      "pos": "noun",
      "explanation": "water + sky: formation of water droplets in the sky",
      "isCharacter": true
    },
    {
      "id": 231,
      "bciAvId": 13378,
      "gloss": "comb",
      "glossSv": "kam",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a side view of a comb",
      "isCharacter": true
    },
    {
      "id": 232,
      "bciAvId": 13380,
      "gloss": "combination, connection",
      "glossSv": "kombination",
      "pos": "noun",
      "explanation": "circle [half-sized] + circle [half-sized]: two interlocking circles",
      "isCharacter": true
    },
    {
      "id": 233,
      "bciAvId": 13382,
      "gloss": "combine marker",
      "glossSv": "operator (kombination)",
      "pos": "function",
      "explanation": "circle [quarter-sized] + circle [quarter-sized]: two small interlocking circles ¼ space above skyline, used before and after a novel multi-character Bliss-word created by a user to represent a new meaning. This signals that a Bliss-word is not contained in the published Blissymbol Vocabulary.",
      "isCharacter": true
    },
    {
      "id": 234,
      "bciAvId": 13384,
      "gloss": "comet",
      "glossSv": "komet",
      "pos": "noun",
      "explanation": "star [modification, on earthline] + curve,curved line: pictograph that suggests a star with a curved tail",
      "isCharacter": true
    },
    {
      "id": 235,
      "bciAvId": 13388,
      "gloss": "commandments",
      "glossSv": "budorden",
      "pos": "noun",
      "explanation": "pictograph of two tablets of the laws: two tablets on which the ten commandments were inscribed",
      "isCharacter": true
    },
    {
      "id": 236,
      "bciAvId": 13395,
      "gloss": "conception, fertilisation, fertilised egg, fertilization, fertilized egg",
      "glossSv": "befruktning, befruktat ägg",
      "pos": "noun",
      "explanation": "sperm + egg [combination]",
      "isCharacter": true
    },
    {
      "id": 237,
      "bciAvId": 13400,
      "gloss": "cone",
      "glossSv": "kägla, kon",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the outline of a cone",
      "isCharacter": true
    },
    {
      "id": 238,
      "bciAvId": 13401,
      "gloss": "conscience",
      "glossSv": "samvete",
      "pos": "noun",
      "explanation": "mind + mind [modification, at a higher level]: another level of consciousness super-imposed on the rational mind",
      "isCharacter": true
    },
    {
      "id": 239,
      "bciAvId": 13403,
      "gloss": "container, bowl, holder, pouch, basket",
      "glossSv": "behållare, skål, korg (etc)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the outline of a bowl",
      "isCharacter": true
    },
    {
      "id": 240,
      "bciAvId": 13413,
      "gloss": "corn",
      "glossSv": "majs",
      "pos": "noun",
      "explanation": "vegetable (oval-shaped) + dot + dot [modification, higher] + dot [modification, lower]: dots suggesting kernels of corn",
      "isCharacter": true
    },
    {
      "id": 241,
      "bciAvId": 13414,
      "gloss": "corner (room)",
      "glossSv": "hörn, hörna (rum)",
      "pos": "noun",
      "explanation": "room + pointer, to corner",
      "isCharacter": true
    },
    {
      "id": 242,
      "bciAvId": 13419,
      "gloss": "couch, chesterfield, sofa",
      "glossSv": "soffa",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a couch with a reclining back",
      "isCharacter": true
    },
    {
      "id": 243,
      "bciAvId": 13423,
      "gloss": "country, state",
      "glossSv": "land, stat",
      "pos": "noun",
      "explanation": "flag + earth: territory identified by a flag",
      "isCharacter": true
    },
    {
      "id": 244,
      "bciAvId": 13424,
      "gloss": "countryside, country, nature",
      "glossSv": "landsbygd, landet",
      "pos": "noun",
      "explanation": "tree + earth: place where trees dominate the landscape",
      "isCharacter": true
    },
    {
      "id": 245,
      "bciAvId": 13425,
      "gloss": "couple (heterosexual)",
      "glossSv": "par (heterosex.)",
      "pos": "person",
      "explanation": "man + woman",
      "isCharacter": true
    },
    {
      "id": 246,
      "bciAvId": 13427,
      "gloss": "family, couple",
      "glossSv": "familj, makar, sambopar",
      "pos": "person",
      "explanation": "man + protection + woman: a man and a woman living under one roof",
      "isCharacter": true
    },
    {
      "id": 247,
      "bciAvId": 13607,
      "gloss": "creation, nature",
      "glossSv": "skapelse, natur",
      "pos": "noun",
      "explanation": "equal-sided triangle: CKB points out that the Greeks considered the equal-sided triangle to be the simplest and most harmonious geometrical creation, and proof that the world is not chaos, but organized according to harmonious lines",
      "isCharacter": true
    },
    {
      "id": 248,
      "bciAvId": 13613,
      "gloss": "cross, Christianity (in combinations)",
      "glossSv": "kors, kristendom (i kombination)",
      "pos": "noun",
      "explanation": "pictograph, of a cross: symbol for Christianity",
      "isCharacter": true
    },
    {
      "id": 249,
      "bciAvId": 13615,
      "gloss": "crotch",
      "glossSv": "skrev, underliv",
      "pos": "noun",
      "explanation": "body + pointer, to crotch",
      "isCharacter": true
    },
    {
      "id": 250,
      "bciAvId": 13619,
      "gloss": "crystal",
      "glossSv": "kristall",
      "pos": "noun",
      "explanation": "thing + pictograph, of the plane facet-like faces of a crystal",
      "isCharacter": true
    },
    {
      "id": 251,
      "bciAvId": 13621,
      "gloss": "mug, cup",
      "glossSv": "mugg, kopp",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a cup or a glass with a handle",
      "isCharacter": true
    },
    {
      "id": 252,
      "bciAvId": 13622,
      "gloss": "cupboard, closet, wardrobe",
      "glossSv": "skåp, garderob",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests double doors of a cupboard/closet",
      "isCharacter": true
    },
    {
      "id": 253,
      "bciAvId": 13623,
      "gloss": "currant(s)",
      "glossSv": "vinbär",
      "pos": "noun",
      "explanation": "pictograph of cluster of currants",
      "isCharacter": true
    },
    {
      "id": 254,
      "bciAvId": 13626,
      "gloss": "curtain(s), drape(s)",
      "glossSv": "gardin, draperi",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a curtained window",
      "isCharacter": true
    },
    {
      "id": 255,
      "bciAvId": 13627,
      "gloss": "curve, curved line",
      "glossSv": "båge, krök, kurva",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 256,
      "bciAvId": 13632,
      "gloss": "danger",
      "glossSv": "fara",
      "pos": "noun",
      "explanation": "creation + intensity: CKB says that this symbol implies that we must take care that we do not harm ourselves or others, since we are all part of a divine Creation",
      "isCharacter": true
    },
    {
      "id": 257,
      "bciAvId": 13638,
      "gloss": "daughter",
      "glossSv": "dotter",
      "pos": "person",
      "explanation": "protection + female: female born under the family roof",
      "isCharacter": true
    },
    {
      "id": 258,
      "bciAvId": 13639,
      "gloss": "day",
      "glossSv": "dag",
      "pos": "noun",
      "explanation": "sun + earth: sun appears above the horizon; it shines on the earth during the day",
      "isCharacter": true
    },
    {
      "id": 259,
      "bciAvId": 13645,
      "gloss": "death",
      "glossSv": "död (subst.)",
      "pos": "noun",
      "explanation": "life + to cross out: life destroyed",
      "isCharacter": true
    },
    {
      "id": 260,
      "bciAvId": 13649,
      "gloss": "decision",
      "glossSv": "beslut",
      "pos": "noun",
      "explanation": "to think + to arrive: arrival at a rational position",
      "isCharacter": true
    },
    {
      "id": 261,
      "bciAvId": 13667,
      "gloss": "development",
      "glossSv": "utveckling",
      "pos": "noun",
      "explanation": "change + forward [modification, short arrow]: change through progression",
      "isCharacter": true
    },
    {
      "id": 262,
      "bciAvId": 13675,
      "gloss": "different, other, difference",
      "glossSv": "olika, annorlunda, olikhet",
      "pos": "expression",
      "explanation": "to cross out + same",
      "isCharacter": true
    },
    {
      "id": 263,
      "bciAvId": 13685,
      "gloss": "disc, disk",
      "glossSv": "skiva, platta",
      "pos": "noun",
      "explanation": "pictograph: simplified three-dimensional drawing of a disc",
      "isCharacter": true
    },
    {
      "id": 264,
      "bciAvId": 13687,
      "gloss": "discomfort",
      "glossSv": "obehag",
      "pos": "noun",
      "explanation": "comfort + to destroy",
      "isCharacter": true
    },
    {
      "id": 265,
      "bciAvId": 13690,
      "gloss": "dish, plate, platter",
      "glossSv": "tallrik, fat",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a dish",
      "isCharacter": true
    },
    {
      "id": 266,
      "bciAvId": 13857,
      "gloss": "division",
      "glossSv": "division, delning",
      "pos": "noun",
      "explanation": "based upon the international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 267,
      "bciAvId": 13863,
      "gloss": "dollar",
      "glossSv": "dollar",
      "pos": "noun",
      "explanation": "international symbol for dollar",
      "isCharacter": true
    },
    {
      "id": 268,
      "bciAvId": 13864,
      "gloss": "dolphin, porpoise, water mammal (with tail)",
      "glossSv": "delfin, tumlare",
      "pos": "noun",
      "explanation": "pictograph: the shape contains water creature + pictograph of a tail fin",
      "isCharacter": true
    },
    {
      "id": 269,
      "bciAvId": 13866,
      "gloss": "door",
      "glossSv": "dörr",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a doorway",
      "isCharacter": true
    },
    {
      "id": 270,
      "bciAvId": 13867,
      "gloss": "dot",
      "glossSv": "punkt, prick",
      "pos": "noun",
      "explanation": "pictograph: often used to create a meaning based on the relationship between the dot and an associated symbol",
      "isCharacter": true
    },
    {
      "id": 271,
      "bciAvId": 13869,
      "gloss": "down, downward",
      "glossSv": "ner, nedåt",
      "pos": "expression",
      "explanation": "arrow, pointing downward",
      "isCharacter": true
    },
    {
      "id": 272,
      "bciAvId": 13870,
      "gloss": "downward and backward",
      "glossSv": "nedåt bakåt",
      "pos": "expression",
      "explanation": "arrow, pointing downward and backward",
      "isCharacter": true
    },
    {
      "id": 273,
      "bciAvId": 13871,
      "gloss": "downward and forward",
      "glossSv": "nedåt framåt",
      "pos": "expression",
      "explanation": "arrow, pointing downward and forward",
      "isCharacter": true
    },
    {
      "id": 274,
      "bciAvId": 13874,
      "gloss": "drawer",
      "glossSv": "byrålåda (etc)",
      "pos": "noun",
      "explanation": "chest of drawers + pointer, to drawer",
      "isCharacter": true
    },
    {
      "id": 275,
      "bciAvId": 13881,
      "gloss": "drink, beverage",
      "glossSv": "dryck",
      "pos": "noun",
      "explanation": "liquid + food",
      "isCharacter": true
    },
    {
      "id": 276,
      "bciAvId": 13885,
      "gloss": "dromedary",
      "glossSv": "dromedar",
      "pos": "noun",
      "explanation": "animal + pictograph of head and neck and one hump",
      "isCharacter": true
    },
    {
      "id": 277,
      "bciAvId": 13892,
      "gloss": "during, while",
      "glossSv": "medan, under tiden",
      "pos": "expression",
      "explanation": "limited time + dot (in position above sky line): occurring at a time limited by reference to another event",
      "isCharacter": true
    },
    {
      "id": 278,
      "bciAvId": 13894,
      "gloss": "ear",
      "glossSv": "öra",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a side view of an ear",
      "isCharacter": true
    },
    {
      "id": 279,
      "bciAvId": 13895,
      "gloss": "ear mold",
      "glossSv": "öroninsats",
      "pos": "noun",
      "explanation": "thing + ear: part of a hearing aid that fits into the ear",
      "isCharacter": true
    },
    {
      "id": 280,
      "bciAvId": 13900,
      "gloss": "earth, globe, world",
      "glossSv": "jorden, jordklotet",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the planet rotating on its diagonal axis",
      "isCharacter": true
    },
    {
      "id": 281,
      "bciAvId": 13901,
      "gloss": "earth, ground, land",
      "glossSv": "mark, jord",
      "pos": "noun",
      "explanation": "horizontal line, on the earthline of the symbol drawing area",
      "isCharacter": true
    },
    {
      "id": 282,
      "bciAvId": 13902,
      "gloss": "east",
      "glossSv": "öster",
      "pos": "noun",
      "explanation": "sun + pointer, to east",
      "isCharacter": true
    },
    {
      "id": 283,
      "bciAvId": 13907,
      "gloss": "edge",
      "glossSv": "kant",
      "pos": "noun",
      "explanation": "table + pointer, to edge",
      "isCharacter": true
    },
    {
      "id": 284,
      "bciAvId": 13910,
      "gloss": "effect, result",
      "glossSv": "effekt, verkan",
      "pos": "noun",
      "explanation": "greater than (relation) + pictograph, of imprint: the effect is the imprint left by the wedge-shaped cause",
      "isCharacter": true
    },
    {
      "id": 285,
      "bciAvId": 13912,
      "gloss": "egg, ovum (2)",
      "glossSv": "ägg (2)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 286,
      "bciAvId": 13914,
      "gloss": "either",
      "glossSv": "antingen",
      "pos": "expression",
      "explanation": "relation [half-sized], pointing forward + dot: altered form of position in order to represent the meaning “the first alternative”. The dot is within the relation symbol because, as CKB writes, \"We have not decided where to place it.\"",
      "isCharacter": true
    },
    {
      "id": 287,
      "bciAvId": 13916,
      "gloss": "elbow",
      "glossSv": "armbåge",
      "pos": "noun",
      "explanation": "arm + pointer, to elbow",
      "isCharacter": true
    },
    {
      "id": 288,
      "bciAvId": 13918,
      "gloss": "electricity",
      "glossSv": "elektricitet",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a lightning bolt",
      "isCharacter": true
    },
    {
      "id": 289,
      "bciAvId": 13922,
      "gloss": "electromagnetic radiation",
      "glossSv": "elektromagnetism",
      "pos": "noun",
      "explanation": "electricity: derived from",
      "isCharacter": true
    },
    {
      "id": 290,
      "bciAvId": 13929,
      "gloss": "embryo",
      "glossSv": "embryo",
      "pos": "noun",
      "explanation": "body + being (state of): an embryo is a potential living being, which cannot live outside the mother's body",
      "isCharacter": true
    },
    {
      "id": 291,
      "bciAvId": 13934,
      "gloss": "enclosure",
      "glossSv": "sluten enhet",
      "pos": "noun",
      "explanation": "pictograph: an enclosed space",
      "isCharacter": true
    },
    {
      "id": 292,
      "bciAvId": 13935,
      "gloss": "end, arrival, stop",
      "glossSv": "slut, stopp, ankomst",
      "pos": "noun",
      "explanation": "forward + reference line: the arrow arrives at the line and stops",
      "isCharacter": true
    },
    {
      "id": 293,
      "bciAvId": 13936,
      "gloss": "energy",
      "glossSv": "energi",
      "pos": "noun",
      "explanation": "sun + electromagnetic radiation: potential energy, as received from the sun",
      "isCharacter": true
    },
    {
      "id": 294,
      "bciAvId": 13942,
      "gloss": "environment",
      "glossSv": "miljö, omvärld",
      "pos": "noun",
      "explanation": "earth + water + sky: complete physical world that surrounds us",
      "isCharacter": true
    },
    {
      "id": 295,
      "bciAvId": 13944,
      "gloss": "erection, erect penis",
      "glossSv": "erektion, stånd",
      "pos": "noun",
      "explanation": "standing (standing person) + pictograph, of erect penis",
      "isCharacter": true
    },
    {
      "id": 296,
      "bciAvId": 13946,
      "gloss": "etrog",
      "glossSv": "etrog (Israel)",
      "pos": "noun",
      "explanation": "pictograph: citrus fruit used as a Jewish ceremonial object (Hebrew)",
      "isCharacter": true
    },
    {
      "id": 297,
      "bciAvId": 13949,
      "gloss": "evaluation, value",
      "glossSv": "värde, värdering",
      "pos": "noun",
      "explanation": "symbol represents a cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable",
      "isCharacter": true
    },
    {
      "id": 298,
      "bciAvId": 13950,
      "gloss": "evening",
      "glossSv": "kväll",
      "pos": "noun",
      "explanation": "moon [modification, upper half] + earth: the moon begins to appear above the horizon",
      "isCharacter": true
    },
    {
      "id": 299,
      "bciAvId": 14114,
      "gloss": "event, happening, occasion",
      "glossSv": "händelse",
      "pos": "noun",
      "explanation": "to be + earth [half-sized]: occurrence on earth",
      "isCharacter": true
    },
    {
      "id": 300,
      "bciAvId": 14116,
      "gloss": "evergreen tree, spruce, fir, fir tree",
      "glossSv": "gran, tall, barrträd",
      "pos": "noun",
      "explanation": "tree + pictograph of spruce branches: pictograph symbol that suggests a spruce or pine tree. The symbol can be used for any tree that does not lose its leaves annually.",
      "isCharacter": true
    },
    {
      "id": 301,
      "bciAvId": 14128,
      "gloss": "expectation, anticipation",
      "glossSv": "antagande, förväntan",
      "pos": "noun",
      "explanation": "mind + future (uncertain): thinking about an unknown future",
      "isCharacter": true
    },
    {
      "id": 302,
      "bciAvId": 14132,
      "gloss": "explosion, detonation, blowup",
      "glossSv": "explosion",
      "pos": "noun",
      "explanation": "thing + four arrows [modification, short arrows], moving outwards",
      "isCharacter": true
    },
    {
      "id": 303,
      "bciAvId": 14133,
      "gloss": "eye",
      "glossSv": "öga",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests an eye with a pupil in the centre",
      "isCharacter": true
    },
    {
      "id": 304,
      "bciAvId": 14134,
      "gloss": "eyebrow",
      "glossSv": "ögonbryn",
      "pos": "noun",
      "explanation": "eye + line [half-sized] + pointer",
      "isCharacter": true
    },
    {
      "id": 305,
      "bciAvId": 14136,
      "gloss": "eyelid (upper)",
      "glossSv": "ögonlock (övre)",
      "pos": "noun",
      "explanation": "eye + pointer, to upper eyelid",
      "isCharacter": true
    },
    {
      "id": 306,
      "bciAvId": 14138,
      "gloss": "face",
      "glossSv": "ansikte",
      "pos": "noun",
      "explanation": "head + dot [modification, higher position] + dot [modification, higher position]: pictograph, suggesting a face with mouth, nose and two eyes",
      "isCharacter": true
    },
    {
      "id": 307,
      "bciAvId": 14139,
      "gloss": "fact",
      "glossSv": "faktum",
      "pos": "noun",
      "explanation": "mind + real: something that one thinks is real",
      "isCharacter": true
    },
    {
      "id": 308,
      "bciAvId": 14144,
      "gloss": "family (traditional)",
      "glossSv": "familj, släkt",
      "pos": "person",
      "explanation": "man + protection + protection + woman: a man and a woman join their roofs to create a family unit. The symbol also can be explained as husband + wife.",
      "isCharacter": true
    },
    {
      "id": 309,
      "bciAvId": 14145,
      "gloss": "family (cohabiting)",
      "glossSv": "familj, makar, sambopar (könsneutral)",
      "pos": "person",
      "explanation": "person + protection + person: caring people, i.e., people joined together to protect those in their care",
      "isCharacter": true
    },
    {
      "id": 310,
      "bciAvId": 14149,
      "gloss": "fan",
      "glossSv": "solfjäder",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 311,
      "bciAvId": 14151,
      "gloss": "farm",
      "glossSv": "bondgård, lantbruk",
      "pos": "noun",
      "explanation": "protection + field: place where the fields are cared for",
      "isCharacter": true
    },
    {
      "id": 312,
      "bciAvId": 14157,
      "gloss": "father, dad, daddy, papa, pa, pop",
      "glossSv": "pappa, far",
      "pos": "person",
      "explanation": "protection + man: man who gives protection to his family",
      "isCharacter": true
    },
    {
      "id": 313,
      "bciAvId": 14164,
      "gloss": "feeling, emotion, sensation",
      "glossSv": "känsla",
      "pos": "noun",
      "explanation": "symbol is the familiar heart shape: traditionally one's feelings are supposed to come from the heart. In a few cases, this symbol is used to represent sensation.",
      "isCharacter": true
    },
    {
      "id": 314,
      "bciAvId": 14166,
      "gloss": "female (gender)",
      "glossSv": "hona, honkön",
      "pos": "noun",
      "explanation": "woman [modification], and also creation [half sized]: this form of woman is used only in compound symbols to specify gender or sex",
      "isCharacter": true
    },
    {
      "id": 315,
      "bciAvId": 14167,
      "gloss": "fence, wall",
      "glossSv": "staket, häck (etc)",
      "pos": "noun",
      "explanation": "building with yard and fence + pointer, to fence",
      "isCharacter": true
    },
    {
      "id": 316,
      "bciAvId": 14170,
      "gloss": "fetus",
      "glossSv": "foster",
      "pos": "noun",
      "explanation": "body + baby",
      "isCharacter": true
    },
    {
      "id": 317,
      "bciAvId": 14173,
      "gloss": "field",
      "glossSv": "fält, åker",
      "pos": "noun",
      "explanation": "grain + earth: ground covered with grain or crops",
      "isCharacter": true
    },
    {
      "id": 318,
      "bciAvId": 14180,
      "gloss": "finger",
      "glossSv": "finger",
      "pos": "noun",
      "explanation": "hand + pointer, to finger",
      "isCharacter": true
    },
    {
      "id": 319,
      "bciAvId": 14183,
      "gloss": "fire",
      "glossSv": "eld",
      "pos": "noun",
      "explanation": "symbol looks like a flame, suggesting fire",
      "isCharacter": true
    },
    {
      "id": 320,
      "bciAvId": 14185,
      "gloss": "fireplace",
      "glossSv": "öppen spis",
      "pos": "noun",
      "explanation": "fire + open: opening in which a fire can be built",
      "isCharacter": true
    },
    {
      "id": 321,
      "bciAvId": 14188,
      "gloss": "fish (animal)",
      "glossSv": "fisk",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a fish",
      "isCharacter": true
    },
    {
      "id": 322,
      "bciAvId": 14193,
      "gloss": "flag",
      "glossSv": "flagga",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a flag",
      "isCharacter": true
    },
    {
      "id": 323,
      "bciAvId": 14202,
      "gloss": "floor",
      "glossSv": "golv",
      "pos": "noun",
      "explanation": "room + pointer, to floor from underneath",
      "isCharacter": true
    },
    {
      "id": 324,
      "bciAvId": 14203,
      "gloss": "floor covering, linoleum",
      "glossSv": "korkmatta, parkett (etc)",
      "pos": "noun",
      "explanation": "room + pointer, to floor from above",
      "isCharacter": true
    },
    {
      "id": 325,
      "bciAvId": 14205,
      "gloss": "flower",
      "glossSv": "blomma",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a flower",
      "isCharacter": true
    },
    {
      "id": 326,
      "bciAvId": 14206,
      "gloss": "flower (from bulb)",
      "glossSv": "lökväxt",
      "pos": "noun",
      "explanation": "flower + bulb + pointer, to flower",
      "isCharacter": true
    },
    {
      "id": 327,
      "bciAvId": 14371,
      "gloss": "fly, flying insect",
      "glossSv": "fluga",
      "pos": "noun",
      "explanation": "insect + to fly",
      "isCharacter": true
    },
    {
      "id": 328,
      "bciAvId": 14374,
      "gloss": "fog",
      "glossSv": "dimma",
      "pos": "noun",
      "explanation": "sky + water: formation of water droplets below the sky",
      "isCharacter": true
    },
    {
      "id": 329,
      "bciAvId": 14377,
      "gloss": "food",
      "glossSv": "mat, livsmedel",
      "pos": "noun",
      "explanation": "mouth + earth [half-sized]: what the mouth gets from the earth",
      "isCharacter": true
    },
    {
      "id": 330,
      "bciAvId": 14379,
      "gloss": "foot",
      "glossSv": "fot",
      "pos": "noun",
      "explanation": "legs and feet + pointer, to foot",
      "isCharacter": true
    },
    {
      "id": 331,
      "bciAvId": 14381,
      "gloss": "for (in exchange for), instead",
      "glossSv": "för, i stället för, i utbyte mot",
      "pos": "expression",
      "explanation": "to exchange [modification]",
      "isCharacter": true
    },
    {
      "id": 332,
      "bciAvId": 14382,
      "gloss": "for (the purpose of), in order to",
      "glossSv": "för, för att",
      "pos": "expression",
      "explanation": "purpose [half-sized]",
      "isCharacter": true
    },
    {
      "id": 333,
      "bciAvId": 14384,
      "gloss": "forehead",
      "glossSv": "panna",
      "pos": "noun",
      "explanation": "face + pointer, to forehead",
      "isCharacter": true
    },
    {
      "id": 334,
      "bciAvId": 14389,
      "gloss": "fork",
      "glossSv": "gaffel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a fork. The diagonal orientation of fork is the same as that of spoon and knife.",
      "isCharacter": true
    },
    {
      "id": 335,
      "bciAvId": 14390,
      "gloss": "forward",
      "glossSv": "fram, framåt",
      "pos": "expression",
      "explanation": "arrow, pointing forward",
      "isCharacter": true
    },
    {
      "id": 336,
      "bciAvId": 14396,
      "gloss": "freedom, liberty",
      "glossSv": "frihet",
      "pos": "noun",
      "explanation": "feeling + open: feeling of being unconfined",
      "isCharacter": true
    },
    {
      "id": 337,
      "bciAvId": 14403,
      "gloss": "from",
      "glossSv": "från",
      "pos": "expression",
      "explanation": "reference line [half-sized] + arrowhead: the arrowhead departs from the reference line. This symbol is a simplified form of departure.",
      "isCharacter": true
    },
    {
      "id": 338,
      "bciAvId": 14405,
      "gloss": "fruit",
      "glossSv": "frukt",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a piece of fruit with a curved stem, in the position it would have if hanging from a tree",
      "isCharacter": true
    },
    {
      "id": 339,
      "bciAvId": 14412,
      "gloss": "fuel",
      "glossSv": "bränsle",
      "pos": "noun",
      "explanation": "energy + enclosure: energy that can be put into an enclosure and used to power something",
      "isCharacter": true
    },
    {
      "id": 340,
      "bciAvId": 14415,
      "gloss": "fur, coat (animal), hair (animal)",
      "glossSv": "päls",
      "pos": "noun",
      "explanation": "furred animal + pointer, to hair: hair protecting the skin of an animal",
      "isCharacter": true
    },
    {
      "id": 341,
      "bciAvId": 14417,
      "gloss": "future",
      "glossSv": "framtid",
      "pos": "noun",
      "explanation": "outline of parabolic mirror focused on what lies ahead of it",
      "isCharacter": true
    },
    {
      "id": 342,
      "bciAvId": 14420,
      "gloss": "garage",
      "glossSv": "garage",
      "pos": "noun",
      "explanation": "building + vehicle [modification]: the two wheels representing a modified vehicle, building for vehicles",
      "isCharacter": true
    },
    {
      "id": 343,
      "bciAvId": 14421,
      "gloss": "garbage can, rubbish bin, trash can",
      "glossSv": "papperskorg, soppåse, soptunna (etc)",
      "pos": "noun",
      "explanation": "container + waste",
      "isCharacter": true
    },
    {
      "id": 344,
      "bciAvId": 14422,
      "gloss": "garden",
      "glossSv": "trädgård",
      "pos": "noun",
      "explanation": "flower + earth: place with flowers",
      "isCharacter": true
    },
    {
      "id": 345,
      "bciAvId": 14424,
      "gloss": "gas",
      "glossSv": "gas",
      "pos": "noun",
      "explanation": "up + pictograph of a bubble: symbol suggests a gas bubble rising upward",
      "isCharacter": true
    },
    {
      "id": 346,
      "bciAvId": 14427,
      "gloss": "gathering, assembly, meeting, conference",
      "glossSv": "samling, möte",
      "pos": "noun",
      "explanation": "four arrows [modification], pointing inward towards each other, i.e., gathering together",
      "isCharacter": true
    },
    {
      "id": 347,
      "bciAvId": 14428,
      "gloss": "gender, sex",
      "glossSv": "kön",
      "pos": "noun",
      "explanation": "male + female: having either a male or female gender",
      "isCharacter": true
    },
    {
      "id": 348,
      "bciAvId": 14430,
      "gloss": "generalisation, generalization",
      "glossSv": "kategori, generalisering",
      "pos": "noun",
      "explanation": "mouth + many: what one says to characterize many things: CKB describes this symbol as \"a saying about a multitude\".",
      "isCharacter": true
    },
    {
      "id": 349,
      "bciAvId": 14431,
      "gloss": "genitals, sex organs",
      "glossSv": "könsorgan",
      "pos": "noun",
      "explanation": "standing person + pointer, to genital area",
      "isCharacter": true
    },
    {
      "id": 350,
      "bciAvId": 14438,
      "gloss": "giraffe",
      "glossSv": "giraff",
      "pos": "noun",
      "explanation": "animal + pictograph of head and long neck",
      "isCharacter": true
    },
    {
      "id": 351,
      "bciAvId": 14439,
      "gloss": "girl",
      "glossSv": "flicka, tjej, tös",
      "pos": "person",
      "explanation": "child + female [combination]",
      "isCharacter": true
    },
    {
      "id": 352,
      "bciAvId": 14442,
      "gloss": "glass, drinking glass",
      "glossSv": "glas (att dricka ur)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a drinking glass",
      "isCharacter": true
    },
    {
      "id": 353,
      "bciAvId": 14443,
      "gloss": "glasses, eyeglasses",
      "glossSv": "glasögon",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pair of glasses and incorporates two eye symbols",
      "isCharacter": true
    },
    {
      "id": 354,
      "bciAvId": 14450,
      "gloss": "goal",
      "glossSv": "mål",
      "pos": "noun",
      "explanation": "door + ball: also a pictograph where the symbol suggests a goal with a ball in it",
      "isCharacter": true
    },
    {
      "id": 355,
      "bciAvId": 14451,
      "gloss": "God",
      "glossSv": "Gud",
      "pos": "person",
      "explanation": "creation + creation [modification, on a higher level]: above our created world is a higher Creator",
      "isCharacter": true
    },
    {
      "id": 356,
      "bciAvId": 14457,
      "gloss": "goods, contents",
      "glossSv": "innehåll, varor",
      "pos": "noun",
      "explanation": "container + thing",
      "isCharacter": true
    },
    {
      "id": 357,
      "bciAvId": 14625,
      "gloss": "grain, cereal",
      "glossSv": "säd",
      "pos": "noun",
      "explanation": "grass + grass: pictograph where symbol suggests two stalks of grain.",
      "isCharacter": true
    },
    {
      "id": 358,
      "bciAvId": 14626,
      "gloss": "grandfather, granddad, grandpa",
      "glossSv": "farfar, morfar",
      "pos": "person",
      "explanation": "father + parent: father of one's father or mother",
      "isCharacter": true
    },
    {
      "id": 359,
      "bciAvId": 14627,
      "gloss": "grandfather (maternal)",
      "glossSv": "morfar",
      "pos": "person",
      "explanation": "father + mother: father of one’s mother",
      "isCharacter": true
    },
    {
      "id": 360,
      "bciAvId": 14628,
      "gloss": "grandfather (paternal)",
      "glossSv": "farfar",
      "pos": "person",
      "explanation": "father + father: father of one’s father",
      "isCharacter": true
    },
    {
      "id": 361,
      "bciAvId": 14629,
      "gloss": "grandmother, grandma, granny",
      "glossSv": "farmor, mormor",
      "pos": "person",
      "explanation": "mother + parent: mother of one's father or mother",
      "isCharacter": true
    },
    {
      "id": 362,
      "bciAvId": 14630,
      "gloss": "grandmother (maternal)",
      "glossSv": "mormor",
      "pos": "person",
      "explanation": "mother + mother: mother of one’s mother",
      "isCharacter": true
    },
    {
      "id": 363,
      "bciAvId": 14631,
      "gloss": "grandmother (paternal)",
      "glossSv": "farmor",
      "pos": "person",
      "explanation": "mother + father: mother of one’s father",
      "isCharacter": true
    },
    {
      "id": 364,
      "bciAvId": 14632,
      "gloss": "grandparent",
      "glossSv": "farförälder, morförälder",
      "pos": "person",
      "explanation": "parent + parent: the parent of one's father or mother",
      "isCharacter": true
    },
    {
      "id": 365,
      "bciAvId": 14635,
      "gloss": "grape, grapes",
      "glossSv": "vindruvor",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a cluster of grapes hanging from a stem",
      "isCharacter": true
    },
    {
      "id": 366,
      "bciAvId": 14636,
      "gloss": "grass",
      "glossSv": "gräs",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a blade of grass",
      "isCharacter": true
    },
    {
      "id": 367,
      "bciAvId": 14638,
      "gloss": "grave",
      "glossSv": "grav",
      "pos": "noun",
      "explanation": "earth + reclining,lying (person lying down) [modification, under earthline]: place of rest below the earth",
      "isCharacter": true
    },
    {
      "id": 368,
      "bciAvId": 14647,
      "gloss": "group of, much of, many of, quantity of",
      "glossSv": "mängd, grupp av, mycket, många",
      "pos": "noun",
      "explanation": "multiplication [half-sized]: used before another symbol to create a collective or quantitative meaning",
      "isCharacter": true
    },
    {
      "id": 369,
      "bciAvId": 14655,
      "gloss": "gun, firearm",
      "glossSv": "skjutvapen",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a gun with a trigger area",
      "isCharacter": true
    },
    {
      "id": 370,
      "bciAvId": 14659,
      "gloss": "hail",
      "glossSv": "hagel",
      "pos": "noun",
      "explanation": "ice + down: ice particles that fall down from the sky",
      "isCharacter": true
    },
    {
      "id": 371,
      "bciAvId": 14660,
      "gloss": "hair",
      "glossSv": "hår",
      "pos": "noun",
      "explanation": "pictograph: used only in association with a body part or animal symbol",
      "isCharacter": true
    },
    {
      "id": 372,
      "bciAvId": 14661,
      "gloss": "hair (head)",
      "glossSv": "hår (på huvudet)",
      "pos": "noun",
      "explanation": "head with hair + pointer, to hair",
      "isCharacter": true
    },
    {
      "id": 373,
      "bciAvId": 14666,
      "gloss": "hammer, gavel, mallet",
      "glossSv": "hammare, klubba, yxa",
      "pos": "noun",
      "explanation": "pictograph: symbol looks like a hammer ready to strike",
      "isCharacter": true
    },
    {
      "id": 374,
      "bciAvId": 14667,
      "gloss": "hand",
      "glossSv": "hand",
      "pos": "noun",
      "explanation": "pictograph: symbol reproduces the shape formed by the thumb and the index finger",
      "isCharacter": true
    },
    {
      "id": 375,
      "bciAvId": 14668,
      "gloss": "handbag, shopping bag, carrier bag",
      "glossSv": "handväska",
      "pos": "noun",
      "explanation": "container + pictograph of top with a handle: pictograph that suggests a handbag with a handle",
      "isCharacter": true
    },
    {
      "id": 376,
      "bciAvId": 14689,
      "gloss": "head",
      "glossSv": "huvud",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a human head, with two lines indicating nose and mouth",
      "isCharacter": true
    },
    {
      "id": 377,
      "bciAvId": 14690,
      "gloss": "health",
      "glossSv": "hälsa",
      "pos": "noun",
      "explanation": "person [modification] + arm: symbol suggests the outline of a person, arm bent, as if exercising to maintain health",
      "isCharacter": true
    },
    {
      "id": 378,
      "bciAvId": 14696,
      "gloss": "heat",
      "glossSv": "värme",
      "pos": "noun",
      "explanation": "pointer (left) + fire + pointer (right): suggesting radiation of heat",
      "isCharacter": true
    },
    {
      "id": 379,
      "bciAvId": 14699,
      "gloss": "hedgehog",
      "glossSv": "igelkott (FD)",
      "pos": "noun",
      "explanation": "animal + obsolete old pictograph of spines",
      "isCharacter": true
    },
    {
      "id": 380,
      "bciAvId": 14700,
      "gloss": "heel",
      "glossSv": "häl",
      "pos": "noun",
      "explanation": "legs and feet + pointer, to heel",
      "isCharacter": true
    },
    {
      "id": 381,
      "bciAvId": 14701,
      "gloss": "helicopter",
      "glossSv": "helikopter",
      "pos": "noun",
      "explanation": "wheel + propeller,rotor (blades): pictograph derived from airplane",
      "isCharacter": true
    },
    {
      "id": 382,
      "bciAvId": 14704,
      "gloss": "help, aid, assistance, support",
      "glossSv": "hjälp, stöd",
      "pos": "noun",
      "explanation": "diagonal line + person: the person symbol appears to be helping the leaning line",
      "isCharacter": true
    },
    {
      "id": 383,
      "bciAvId": 14708,
      "gloss": "here",
      "glossSv": "här",
      "pos": "expression",
      "explanation": "dot + dot + pointer to the left dot: two dots in relation to eachother with the pointer pointing to the nearest one, \"here\"",
      "isCharacter": true
    },
    {
      "id": 384,
      "bciAvId": 14713,
      "gloss": "hip",
      "glossSv": "höft",
      "pos": "noun",
      "explanation": "legs and feet + pointer, to hip",
      "isCharacter": true
    },
    {
      "id": 385,
      "bciAvId": 14714,
      "gloss": "hippopotamus",
      "glossSv": "flodhäst",
      "pos": "noun",
      "explanation": "animal (water) + horse [combination]: taken from Greek, \"horse of the river\", an animal that spends much time in water",
      "isCharacter": true
    },
    {
      "id": 386,
      "bciAvId": 14883,
      "gloss": "hole",
      "glossSv": "hål, håla, grop",
      "pos": "noun",
      "explanation": "earth [half-sized] + container (low) + earth [half-sized]: symbol suggests a hole in the ground",
      "isCharacter": true
    },
    {
      "id": 387,
      "bciAvId": 14891,
      "gloss": "hook, hanger",
      "glossSv": "hängare, krok",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 388,
      "bciAvId": 14894,
      "gloss": "horizon",
      "glossSv": "horisont",
      "pos": "noun",
      "explanation": "early morning + pointer to horizon",
      "isCharacter": true
    },
    {
      "id": 389,
      "bciAvId": 14895,
      "gloss": "trumpet, horn, cornet (1)",
      "glossSv": "trumpet, kornett (1)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 390,
      "bciAvId": 14896,
      "gloss": "horn(s)",
      "glossSv": "horn (på djur)",
      "pos": "noun",
      "explanation": "animal (bovine,ovine),bovid,bovine + pointer, to horns",
      "isCharacter": true
    },
    {
      "id": 391,
      "bciAvId": 14897,
      "gloss": "horse",
      "glossSv": "häst",
      "pos": "noun",
      "explanation": "animal + pictograph of horse's head and neck",
      "isCharacter": true
    },
    {
      "id": 392,
      "bciAvId": 14905,
      "gloss": "house, building, dwelling, residence",
      "glossSv": "hus, byggnad",
      "pos": "noun",
      "explanation": "foundation + protection: pictograph of the outline of a house.The symbol can also be explained as: combination of enclosure and protection.",
      "isCharacter": true
    },
    {
      "id": 393,
      "bciAvId": 14914,
      "gloss": "husband",
      "glossSv": "man, make",
      "pos": "person",
      "explanation": "man + protection: this symbol, joined to the symbol for wife, produces family",
      "isCharacter": true
    },
    {
      "id": 394,
      "bciAvId": 14919,
      "gloss": "ice",
      "glossSv": "is",
      "pos": "noun",
      "explanation": "water + thing: water transformed into a solid thing",
      "isCharacter": true
    },
    {
      "id": 395,
      "bciAvId": 14921,
      "gloss": "ice cream (cone)",
      "glossSv": "glass, glasstrut",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 396,
      "bciAvId": 14924,
      "gloss": "ice skates",
      "glossSv": "skridskor",
      "pos": "noun",
      "explanation": "legs and feet + pictograph of two curved lines, suggesting skates",
      "isCharacter": true
    },
    {
      "id": 397,
      "bciAvId": 14926,
      "gloss": "idea, thought",
      "glossSv": "idé, tanke",
      "pos": "noun",
      "explanation": "mind + down: a thought issuing from the mind",
      "isCharacter": true
    },
    {
      "id": 398,
      "bciAvId": 14932,
      "gloss": "in, inside, interior, internal",
      "glossSv": "i, inne, innanför",
      "pos": "expression",
      "explanation": "enclosure + dot, inside the enclosure",
      "isCharacter": true
    },
    {
      "id": 399,
      "bciAvId": 14941,
      "gloss": "injection, inoculation, shot",
      "glossSv": "injektion, spruta",
      "pos": "noun",
      "explanation": "pictograph of hypodermic syringe",
      "isCharacter": true
    },
    {
      "id": 400,
      "bciAvId": 14943,
      "gloss": "insect, bug",
      "glossSv": "insekt",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a creature with six legs",
      "isCharacter": true
    },
    {
      "id": 401,
      "bciAvId": 14947,
      "gloss": "intensity",
      "glossSv": "uppmaning, förstärkning",
      "pos": "expression",
      "explanation": "exclamation mark: used following another symbol to enhance meaning in a qualitative way",
      "isCharacter": true
    },
    {
      "id": 402,
      "bciAvId": 14952,
      "gloss": "into, entrance",
      "glossSv": "in, ingång",
      "pos": "expression",
      "explanation": "forward + enclosure: the arrow is entering the enclosure",
      "isCharacter": true
    },
    {
      "id": 403,
      "bciAvId": 14955,
      "gloss": "iron, smoothing iron",
      "glossSv": "strykjärn",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 404,
      "bciAvId": 14958,
      "gloss": "island",
      "glossSv": "ö",
      "pos": "noun",
      "explanation": "water (ground level) + earth + water (ground level): land surrounded by water on ground level",
      "isCharacter": true
    },
    {
      "id": 405,
      "bciAvId": 14960,
      "gloss": "it, itself",
      "glossSv": "den, det (pronomen)",
      "pos": "expression",
      "explanation": "CKB says that this symbol is derived from small. The symbol also looks like the top part of the symbols for man and woman minus the specific gender parts. It refers to things rather than to people.",
      "isCharacter": true
    },
    {
      "id": 406,
      "bciAvId": 14973,
      "gloss": "joint",
      "glossSv": "led",
      "pos": "noun",
      "explanation": "bones with joint + pointer to the junction where they meet",
      "isCharacter": true
    },
    {
      "id": 407,
      "bciAvId": 15144,
      "gloss": "key",
      "glossSv": "nyckel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a key",
      "isCharacter": true
    },
    {
      "id": 408,
      "bciAvId": 15152,
      "gloss": "kiss",
      "glossSv": "kyss, puss",
      "pos": "noun",
      "explanation": "mouth + mouth: two mouths touching",
      "isCharacter": true
    },
    {
      "id": 409,
      "bciAvId": 15155,
      "gloss": "kite",
      "glossSv": "drake",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 410,
      "bciAvId": 15157,
      "gloss": "knee",
      "glossSv": "knä",
      "pos": "noun",
      "explanation": "kneeling (kneeling person) + pointer, to knee joint",
      "isCharacter": true
    },
    {
      "id": 411,
      "bciAvId": 15159,
      "gloss": "knife, sword",
      "glossSv": "kniv, svärd",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a knife or sword. The diagonal orientation of knife is the same as that of fork and spoon.",
      "isCharacter": true
    },
    {
      "id": 412,
      "bciAvId": 15162,
      "gloss": "knowledge, class (in combinations)",
      "glossSv": "kunskap, skolämne (i kombinationer)",
      "pos": "noun",
      "explanation": "mind + enclosure [combination]: store house of the mind",
      "isCharacter": true
    },
    {
      "id": 413,
      "bciAvId": 15166,
      "gloss": "ladder",
      "glossSv": "stege",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 414,
      "bciAvId": 15172,
      "gloss": "language",
      "glossSv": "språk",
      "pos": "noun",
      "explanation": "mouth + ear: what is spoken and heard",
      "isCharacter": true
    },
    {
      "id": 415,
      "bciAvId": 15180,
      "gloss": "lawn, meadow",
      "glossSv": "gräsmatta, äng",
      "pos": "noun",
      "explanation": "grass + earth: land covered with grass",
      "isCharacter": true
    },
    {
      "id": 416,
      "bciAvId": 15183,
      "gloss": "leaf",
      "glossSv": "blad, löv",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 417,
      "bciAvId": 15188,
      "gloss": "leg",
      "glossSv": "ben",
      "pos": "noun",
      "explanation": "legs and feet + pointer, to leg",
      "isCharacter": true
    },
    {
      "id": 418,
      "bciAvId": 15189,
      "gloss": "legs and feet",
      "glossSv": "ben och fötter",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a side view of a pair of legs and feet",
      "isCharacter": true
    },
    {
      "id": 419,
      "bciAvId": 15190,
      "gloss": "lemon",
      "glossSv": "citron",
      "pos": "noun",
      "explanation": "pictograph: suggests a lemon with stem",
      "isCharacter": true
    },
    {
      "id": 420,
      "bciAvId": 15193,
      "gloss": "length, longness",
      "glossSv": "längd",
      "pos": "noun",
      "explanation": "horizontal line bounded by two reference lines [half-sized]: the horizontal line extends full length within the symbol square",
      "isCharacter": true
    },
    {
      "id": 421,
      "bciAvId": 15198,
      "gloss": "letter, mail, post",
      "glossSv": "brev, post",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests an envelope",
      "isCharacter": true
    },
    {
      "id": 422,
      "bciAvId": 15200,
      "gloss": "lettuce, leafy vegetable",
      "glossSv": "sallad, spenat (etc)",
      "pos": "noun",
      "explanation": "earth + outline of leaves: symbol suggests a leafy vegetable with the grass-like edible portion above ground",
      "isCharacter": true
    },
    {
      "id": 423,
      "bciAvId": 15206,
      "gloss": "life",
      "glossSv": "liv",
      "pos": "noun",
      "explanation": "sun + person, in combination: energy produced by the sun supports life on earth",
      "isCharacter": true
    },
    {
      "id": 424,
      "bciAvId": 15208,
      "gloss": "light",
      "glossSv": "ljus",
      "pos": "noun",
      "explanation": "sun + eye: we see by the light of the sun",
      "isCharacter": true
    },
    {
      "id": 425,
      "bciAvId": 15209,
      "gloss": "lightning",
      "glossSv": "blixt",
      "pos": "noun",
      "explanation": "sky + electricity: electricity that comes from the sky",
      "isCharacter": true
    },
    {
      "id": 426,
      "bciAvId": 15212,
      "gloss": "limited time, interval, period, awhile, for a while",
      "glossSv": "begränsad tid, period, stund",
      "pos": "noun",
      "explanation": "time + limit(s)",
      "isCharacter": true
    },
    {
      "id": 427,
      "bciAvId": 15213,
      "gloss": "limit(s), limitation",
      "glossSv": "begränsning, gränser (FD)",
      "pos": "noun",
      "explanation": "two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them",
      "isCharacter": true
    },
    {
      "id": 428,
      "bciAvId": 15214,
      "gloss": "line, stripe",
      "glossSv": "linje, rad, rand, streck",
      "pos": "noun",
      "explanation": "symbol is a full-sized vertical line",
      "isCharacter": true
    },
    {
      "id": 429,
      "bciAvId": 15218,
      "gloss": "lip(s)",
      "glossSv": "läppar",
      "pos": "noun",
      "explanation": "mouth + pointer, from above + pointer, from below: the pointers indicating the lips",
      "isCharacter": true
    },
    {
      "id": 430,
      "bciAvId": 15226,
      "gloss": "crab, shellfish (with claws)",
      "glossSv": "hummer, krabba, kräfta, skaldjur",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a crustacean with pincers",
      "isCharacter": true
    },
    {
      "id": 431,
      "bciAvId": 15399,
      "gloss": "love, affection",
      "glossSv": "kärlek",
      "pos": "noun",
      "explanation": "feeling + arrow [modification, prolonged and as if partly hidden]: feeling as if an arrow is piercing one's heart",
      "isCharacter": true
    },
    {
      "id": 432,
      "bciAvId": 15406,
      "gloss": "machine, appliance, engine, motor",
      "glossSv": "maskin, apparat, motor",
      "pos": "noun",
      "explanation": "sun + wheel: the sun provides the energy that drives the wheels of machinery",
      "isCharacter": true
    },
    {
      "id": 433,
      "bciAvId": 15416,
      "gloss": "man, male",
      "glossSv": "man, karl, gubbe, farbror",
      "pos": "person",
      "explanation": "person [modification] + action [combination]: CKB says man embodies the action principle in society. The symbol also looks like a stick figure of a man wearing trousers. See also: activity,male gender (in combinations) 12335, and male,masculine (person) 15414.",
      "isCharacter": true
    },
    {
      "id": 434,
      "bciAvId": 15417,
      "gloss": "male genitals (man with penis)",
      "glossSv": "manligt könsorgan (man med penis)",
      "pos": "noun",
      "explanation": "standing (standing person) + pictograph of penis: used as the base character for penis",
      "isCharacter": true
    },
    {
      "id": 435,
      "bciAvId": 15419,
      "gloss": "mango",
      "glossSv": "mango",
      "pos": "noun",
      "explanation": "pictograph, mango with stem + pit",
      "isCharacter": true
    },
    {
      "id": 436,
      "bciAvId": 15422,
      "gloss": "maple-leaf",
      "glossSv": "lönnlöv",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 437,
      "bciAvId": 15425,
      "gloss": "marriage",
      "glossSv": "äktenskap",
      "pos": "noun",
      "explanation": "protection + combination,connection: joining together and living under one roof",
      "isCharacter": true
    },
    {
      "id": 438,
      "bciAvId": 15431,
      "gloss": "material, raw material, stuff",
      "glossSv": "material",
      "pos": "noun",
      "explanation": "thing + earth [half-sized]: thing that you get from the earth, i.e., raw material. The symbol is also used for material in a general sense.",
      "isCharacter": true
    },
    {
      "id": 439,
      "bciAvId": 15432,
      "gloss": "mathematics, arithmetic, math (2)",
      "glossSv": "matematik (2)",
      "pos": "noun",
      "explanation": "science + digits (computer): science of numbers",
      "isCharacter": true
    },
    {
      "id": 440,
      "bciAvId": 15441,
      "gloss": "meaning, sense, significance",
      "glossSv": "betydelse",
      "pos": "noun",
      "explanation": "to think + to say + to write: significance the mind attaches to what is spoken or written",
      "isCharacter": true
    },
    {
      "id": 441,
      "bciAvId": 15443,
      "gloss": "measurement, measure",
      "glossSv": "mått, längdmått",
      "pos": "noun",
      "explanation": "length,longness + shortness (distance,length): combination of long and short",
      "isCharacter": true
    },
    {
      "id": 442,
      "bciAvId": 15452,
      "gloss": "melon",
      "glossSv": "melon",
      "pos": "noun",
      "explanation": "fruit [modification]: pictograph showing a fruit with a thick rind and a stem",
      "isCharacter": true
    },
    {
      "id": 443,
      "bciAvId": 15454,
      "gloss": "menorah",
      "glossSv": "menorah (Israel)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the nine branched candelabra used on Chanukah",
      "isCharacter": true
    },
    {
      "id": 444,
      "bciAvId": 15460,
      "gloss": "metaphor",
      "glossSv": "bildlig betydelse, metafor, liknelse (allmän)",
      "pos": "noun",
      "explanation": "mouth [modification, up in the sky] + flower [modification, longer stem] + earth [half-sized] [combination]: \"flowery speech\", a signal that what follows should not be taken literally",
      "isCharacter": true
    },
    {
      "id": 445,
      "bciAvId": 15463,
      "gloss": "microwave oven",
      "glossSv": "mikrovågsugn, mikro",
      "pos": "noun",
      "explanation": "enclosure + electromagnetic radiation",
      "isCharacter": true
    },
    {
      "id": 446,
      "bciAvId": 15464,
      "gloss": "middle, centre, center",
      "glossSv": "mitt",
      "pos": "noun",
      "explanation": "enclosure + pointer, to centre",
      "isCharacter": true
    },
    {
      "id": 447,
      "bciAvId": 15471,
      "gloss": "mind, intellect, reason",
      "glossSv": "förstånd, tankar",
      "pos": "noun",
      "explanation": "symbol suggests an outline of a skull",
      "isCharacter": true
    },
    {
      "id": 448,
      "bciAvId": 15472,
      "gloss": "mine",
      "glossSv": "gruva",
      "pos": "noun",
      "explanation": "mountain + dot: dot locates the position of a mine deep within the mountain",
      "isCharacter": true
    },
    {
      "id": 449,
      "bciAvId": 15474,
      "gloss": "minus, no, without",
      "glossSv": "utan, minus",
      "pos": "expression",
      "explanation": "subtraction [half-sized]: the small meaning of subtraction. The symbol is used before another symbol to create a negative meaning, e.g. (minus + sound) to represent silence.",
      "isCharacter": true
    },
    {
      "id": 450,
      "bciAvId": 15476,
      "gloss": "arrow (bent)",
      "glossSv": "pil (böjd), reflex",
      "pos": "noun",
      "explanation": "pictograph: arrow bent into another direction as if reflected",
      "isCharacter": true
    },
    {
      "id": 451,
      "bciAvId": 15484,
      "gloss": "money, cash",
      "glossSv": "pengar",
      "pos": "noun",
      "explanation": "symbol suggests a modified rod of Mercury, the traditional symbol for trade and commerce",
      "isCharacter": true
    },
    {
      "id": 452,
      "bciAvId": 15649,
      "gloss": "month",
      "glossSv": "månad",
      "pos": "noun",
      "explanation": "moon [modification, as of half-moon]",
      "isCharacter": true
    },
    {
      "id": 453,
      "bciAvId": 15651,
      "gloss": "moon",
      "glossSv": "måne",
      "pos": "noun",
      "explanation": "pictograph: crescent shape resembling the curved shape of the moon in its first quarters",
      "isCharacter": true
    },
    {
      "id": 454,
      "bciAvId": 15656,
      "gloss": "morning (early)",
      "glossSv": "morgon",
      "pos": "noun",
      "explanation": "sun + earth [combination]: time when the sun appears above the horizon",
      "isCharacter": true
    },
    {
      "id": 455,
      "bciAvId": 15662,
      "gloss": "mother, mom, mommy, mum",
      "glossSv": "mamma, mor",
      "pos": "person",
      "explanation": "protection + woman: woman who gives protection to her family",
      "isCharacter": true
    },
    {
      "id": 456,
      "bciAvId": 15663,
      "gloss": "mountain",
      "glossSv": "berg, fjäll",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the side view of a mountain slope",
      "isCharacter": true
    },
    {
      "id": 457,
      "bciAvId": 15666,
      "gloss": "mouth",
      "glossSv": "mun",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a round open mouth",
      "isCharacter": true
    },
    {
      "id": 458,
      "bciAvId": 15672,
      "gloss": "mud, clay",
      "glossSv": "lera",
      "pos": "noun",
      "explanation": "earth [modification, extended line] + water (ground level): mixture composed of more earth than water",
      "isCharacter": true
    },
    {
      "id": 459,
      "bciAvId": 15673,
      "gloss": "multiplication",
      "glossSv": "multiplikation",
      "pos": "noun",
      "explanation": "based upon the international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 460,
      "bciAvId": 15676,
      "gloss": "muscle",
      "glossSv": "muskel (FD)",
      "pos": "noun",
      "explanation": "arm + pictograph of bulging biceps + pointer",
      "isCharacter": true
    },
    {
      "id": 461,
      "bciAvId": 15678,
      "gloss": "mushroom",
      "glossSv": "svamp",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 462,
      "bciAvId": 15682,
      "gloss": "musical note, music (in combinations)",
      "glossSv": "ton",
      "pos": "noun",
      "explanation": "international symbol",
      "isCharacter": true
    },
    {
      "id": 463,
      "bciAvId": 15689,
      "gloss": "nail",
      "glossSv": "spik",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a nail. It is twice the height of the pin symbol",
      "isCharacter": true
    },
    {
      "id": 464,
      "bciAvId": 15691,
      "gloss": "name, label, term, title",
      "glossSv": "namn, titel",
      "pos": "noun",
      "explanation": "pen + mouth: something that can be spoken or written",
      "isCharacter": true
    },
    {
      "id": 465,
      "bciAvId": 15699,
      "gloss": "neck (head)",
      "glossSv": "hals",
      "pos": "noun",
      "explanation": "head + pictograph of neck + pointer, to neck",
      "isCharacter": true
    },
    {
      "id": 466,
      "bciAvId": 15700,
      "gloss": "neck (body)",
      "glossSv": "nacke",
      "pos": "noun",
      "explanation": "body + pointer, to neck",
      "isCharacter": true
    },
    {
      "id": 467,
      "bciAvId": 15701,
      "gloss": "need (needy person)",
      "glossSv": "behov (behövande person)",
      "pos": "noun",
      "explanation": "person, leaning, as if in need of support",
      "isCharacter": true
    },
    {
      "id": 468,
      "bciAvId": 15703,
      "gloss": "needle",
      "glossSv": "nål, synål",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a sewing needle with an eye",
      "isCharacter": true
    },
    {
      "id": 469,
      "bciAvId": 15712,
      "gloss": "news",
      "glossSv": "nyhet",
      "pos": "noun",
      "explanation": "eye + ear: information received through the eye and the ear",
      "isCharacter": true
    },
    {
      "id": 470,
      "bciAvId": 15719,
      "gloss": "night",
      "glossSv": "natt",
      "pos": "noun",
      "explanation": "moon + earth: the moon appears above the horizon; it shines on the earth during the night",
      "isCharacter": true
    },
    {
      "id": 471,
      "bciAvId": 15726,
      "gloss": "nonsense",
      "glossSv": "struntprat, nonsens",
      "pos": "noun",
      "explanation": "meaning + deletion,cancellation,destruction: something that has no meaning",
      "isCharacter": true
    },
    {
      "id": 472,
      "bciAvId": 15730,
      "gloss": "north",
      "glossSv": "norr",
      "pos": "noun",
      "explanation": "sun + pointer, to north",
      "isCharacter": true
    },
    {
      "id": 473,
      "bciAvId": 15732,
      "gloss": "nose",
      "glossSv": "näsa, nos",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the side view of a nose",
      "isCharacter": true
    },
    {
      "id": 474,
      "bciAvId": 15736,
      "gloss": "now",
      "glossSv": "nu",
      "pos": "expression",
      "explanation": "ago,then (past) + then,so,later: present [half-sized]",
      "isCharacter": true
    },
    {
      "id": 475,
      "bciAvId": 15737,
      "gloss": "nowhere, no place",
      "glossSv": "ingenstans",
      "pos": "expression",
      "explanation": "minus + ground: a combination of minus and place",
      "isCharacter": true
    },
    {
      "id": 476,
      "bciAvId": 15740,
      "gloss": "nuclear radiation, radioactivity",
      "glossSv": "radioaktivitet",
      "pos": "noun",
      "explanation": "pointer (left) + nucleus + pointer (right): suggesting radiation of radioactive particles",
      "isCharacter": true
    },
    {
      "id": 477,
      "bciAvId": 15741,
      "gloss": "nucleus (atom)",
      "glossSv": "atomkärna",
      "pos": "noun",
      "explanation": "atom + pointer (small), to inner nucleus",
      "isCharacter": true
    },
    {
      "id": 478,
      "bciAvId": 15742,
      "gloss": "number",
      "glossSv": "nummer, siffra",
      "pos": "noun",
      "explanation": "international symbol",
      "isCharacter": true
    },
    {
      "id": 479,
      "bciAvId": 15912,
      "gloss": "offspring, child",
      "glossSv": "barn, avkomma",
      "pos": "person",
      "explanation": "protection + male + female: male or female born under the family roof",
      "isCharacter": true
    },
    {
      "id": 480,
      "bciAvId": 15914,
      "gloss": "oil, lubricant",
      "glossSv": "olja",
      "pos": "noun",
      "explanation": "water,fluid,liquid + water (ground level): two parallel liquid symbols, suggesting oil that floats on water",
      "isCharacter": true
    },
    {
      "id": 481,
      "bciAvId": 15917,
      "gloss": "olive",
      "glossSv": "oliv",
      "pos": "noun",
      "explanation": "pictograph: fruit [oval shaped] with stem",
      "isCharacter": true
    },
    {
      "id": 482,
      "bciAvId": 15918,
      "gloss": "on",
      "glossSv": "på",
      "pos": "expression",
      "explanation": "earth [half-sized] + pointer: refers only to space, e.g. on the table",
      "isCharacter": true
    },
    {
      "id": 483,
      "bciAvId": 15920,
      "gloss": "bulb (plant)",
      "glossSv": "lök (allmänt)",
      "pos": "noun",
      "explanation": "pictograph + earth",
      "isCharacter": true
    },
    {
      "id": 484,
      "bciAvId": 15923,
      "gloss": "opening",
      "glossSv": "öppning",
      "pos": "noun",
      "explanation": "enclosure, open at the top",
      "isCharacter": true
    },
    {
      "id": 485,
      "bciAvId": 15925,
      "gloss": "opinion",
      "glossSv": "åsikt, mening",
      "pos": "noun",
      "explanation": "mind + mouth: expression of what one thinks",
      "isCharacter": true
    },
    {
      "id": 486,
      "bciAvId": 15927,
      "gloss": "opposite meaning, opposite of, opposite",
      "glossSv": "motsatt betydelse, motsats",
      "pos": "function",
      "explanation": "up + down [combination]: up is the opposite of down. The symbol is placed before a second symbol to create an antonym or meaning that is the opposite of that of the second symbol.",
      "isCharacter": true
    },
    {
      "id": 487,
      "bciAvId": 15928,
      "gloss": "opposition, counter purpose",
      "glossSv": "motstånd, motsatt avsikt",
      "pos": "noun",
      "explanation": "less than (relation) + less than (relation), pointing in the opposite direction from the purpose symbol",
      "isCharacter": true
    },
    {
      "id": 488,
      "bciAvId": 15929,
      "gloss": "or",
      "glossSv": "eller, antingen eller",
      "pos": "expression",
      "explanation": "by,by means of,of (relation [half-sized], pointing backward) + dot: the second alternative, the reverse of either",
      "isCharacter": true
    },
    {
      "id": 489,
      "bciAvId": 15933,
      "gloss": "orange, citrus fruit",
      "glossSv": "apelsin, citrusfrukt",
      "pos": "noun",
      "explanation": "fruit + pictograph of segments",
      "isCharacter": true
    },
    {
      "id": 490,
      "bciAvId": 15942,
      "gloss": "out, exterior, external, outside",
      "glossSv": "ute, utanför",
      "pos": "expression",
      "explanation": "enclosure + dot, outside the enclosure",
      "isCharacter": true
    },
    {
      "id": 491,
      "bciAvId": 15943,
      "gloss": "out of, exit (forward)",
      "glossSv": "ut, ur, utgång",
      "pos": "expression",
      "explanation": "enclosure + forward: the arrow is moving out of the enclosure",
      "isCharacter": true
    },
    {
      "id": 492,
      "bciAvId": 15944,
      "gloss": "out of, exit (downward)",
      "glossSv": "ut, ur, nedgång",
      "pos": "expression",
      "explanation": "enclosure + downward",
      "isCharacter": true
    },
    {
      "id": 493,
      "bciAvId": 15948,
      "gloss": "over, above, superior",
      "glossSv": "över, ovanför",
      "pos": "expression",
      "explanation": "dot + horizontal reference line: the dot is over or above the line",
      "isCharacter": true
    },
    {
      "id": 494,
      "bciAvId": 15952,
      "gloss": "oyster, clam, mussel",
      "glossSv": "mussla, ostron",
      "pos": "noun",
      "explanation": "pictograph of shell + water",
      "isCharacter": true
    },
    {
      "id": 495,
      "bciAvId": 15953,
      "gloss": "pail, bucket",
      "glossSv": "hink, korg, spann",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pail with a handle",
      "isCharacter": true
    },
    {
      "id": 496,
      "bciAvId": 15960,
      "gloss": "palm",
      "glossSv": "palm",
      "pos": "noun",
      "explanation": "pictograph: the symbols suggests a tree with curved fronds",
      "isCharacter": true
    },
    {
      "id": 497,
      "bciAvId": 15962,
      "gloss": "paper, card, page",
      "glossSv": "papper, sida",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a sheet of paper or a page of a book",
      "isCharacter": true
    },
    {
      "id": 498,
      "bciAvId": 15964,
      "gloss": "parallel",
      "glossSv": "parallell",
      "pos": "noun",
      "explanation": "line + line: international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 499,
      "bciAvId": 15966,
      "gloss": "parcel, package",
      "glossSv": "paket",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 500,
      "bciAvId": 15968,
      "gloss": "parent",
      "glossSv": "förälder",
      "pos": "person",
      "explanation": "protection + person: person who gives protection to his or her family",
      "isCharacter": true
    },
    {
      "id": 501,
      "bciAvId": 15969,
      "gloss": "park",
      "glossSv": "park",
      "pos": "noun",
      "explanation": "flower + earth + tree: place with flowers and trees",
      "isCharacter": true
    },
    {
      "id": 502,
      "bciAvId": 15972,
      "gloss": "part, bit, piece, portion, part of",
      "glossSv": "del, bit, stycke, del av",
      "pos": "function",
      "explanation": "division [half-sized]: a part is created when something is divided: With the gloss \"part of\", the symbol is used before another symbol to create a new meaning, which is part of the meaning of the original symbol, i.e., part of + language = word.",
      "isCharacter": true
    },
    {
      "id": 503,
      "bciAvId": 15975,
      "gloss": "past",
      "glossSv": "förfluten tid",
      "pos": "noun",
      "explanation": "outline of parabolic mirror focused on what lies behind it",
      "isCharacter": true
    },
    {
      "id": 504,
      "bciAvId": 15978,
      "gloss": "paw",
      "glossSv": "tass, labb (etc)",
      "pos": "noun",
      "explanation": "animal + pointer, to paw or hoof",
      "isCharacter": true
    },
    {
      "id": 505,
      "bciAvId": 15981,
      "gloss": "peace, peace of mind, serenity",
      "glossSv": "frid, ro, lugn",
      "pos": "noun",
      "explanation": "feeling + world: feeling of being at one with the world",
      "isCharacter": true
    },
    {
      "id": 506,
      "bciAvId": 15983,
      "gloss": "peach, nectarine",
      "glossSv": "persika, nektarin",
      "pos": "noun",
      "explanation": "pictograph with stem + pit",
      "isCharacter": true
    },
    {
      "id": 507,
      "bciAvId": 15986,
      "gloss": "pear",
      "glossSv": "päron",
      "pos": "noun",
      "explanation": "pictograph with stem",
      "isCharacter": true
    },
    {
      "id": 508,
      "bciAvId": 15987,
      "gloss": "pea(s)",
      "glossSv": "ärtor",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a cross section of two peas in a pod",
      "isCharacter": true
    },
    {
      "id": 509,
      "bciAvId": 15991,
      "gloss": "pen, pencil",
      "glossSv": "penna",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pen or pencil in writing position",
      "isCharacter": true
    },
    {
      "id": 510,
      "bciAvId": 15994,
      "gloss": "penis",
      "glossSv": "penis, snopp",
      "pos": "noun",
      "explanation": "male genitals (man with penis) + pointer",
      "isCharacter": true
    },
    {
      "id": 511,
      "bciAvId": 15995,
      "gloss": "pepper (vegetable)",
      "glossSv": "paprika",
      "pos": "noun",
      "explanation": "pictograph with stem",
      "isCharacter": true
    },
    {
      "id": 512,
      "bciAvId": 15998,
      "gloss": "perpendicular",
      "glossSv": "lod",
      "pos": "noun",
      "explanation": "line,stripe + ground: international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 513,
      "bciAvId": 16161,
      "gloss": "person, human being, individual, human",
      "glossSv": "person, människa",
      "pos": "person",
      "explanation": "symbol suggests a human being standing, with feet turned out",
      "isCharacter": true
    },
    {
      "id": 514,
      "bciAvId": 16162,
      "gloss": "kneeling (kneeling person)",
      "glossSv": "knäböjande (person på knä)",
      "pos": "person",
      "explanation": "person [modification]: showing knees bent",
      "isCharacter": true
    },
    {
      "id": 515,
      "bciAvId": 16163,
      "gloss": "reclining, lying (person lying down)",
      "glossSv": "liggande (liggande person)",
      "pos": "person",
      "explanation": "person [modification]: lying on his back",
      "isCharacter": true
    },
    {
      "id": 516,
      "bciAvId": 16164,
      "gloss": "illness, disease, sickness (sick person)",
      "glossSv": "sjukdom (sjuk person)",
      "pos": "noun",
      "explanation": "person [modification]: lying on his back with knees drawn up as if sick or in pain",
      "isCharacter": true
    },
    {
      "id": 517,
      "bciAvId": 16165,
      "gloss": "seat, sitting (sitting person)",
      "glossSv": "sits, säte (sittande person)",
      "pos": "noun",
      "explanation": "person [modification]: in sitting position",
      "isCharacter": true
    },
    {
      "id": 518,
      "bciAvId": 16166,
      "gloss": "standing (standing person)",
      "glossSv": "stående (stående person)",
      "pos": "person",
      "explanation": "person [modification]: in standing position",
      "isCharacter": true
    },
    {
      "id": 519,
      "bciAvId": 16167,
      "gloss": "weakness (weak person)",
      "glossSv": "svaghet (svag person)",
      "pos": "noun",
      "explanation": "person [modification]: buckling at the knees as though weak",
      "isCharacter": true
    },
    {
      "id": 520,
      "bciAvId": 16174,
      "gloss": "pier",
      "glossSv": "brygga, kaj (FD)",
      "pos": "noun",
      "explanation": "platform + combination of boat and to float",
      "isCharacter": true
    },
    {
      "id": 521,
      "bciAvId": 16175,
      "gloss": "pig",
      "glossSv": "gris",
      "pos": "noun",
      "explanation": "animal + pictograph of curly tail",
      "isCharacter": true
    },
    {
      "id": 522,
      "bciAvId": 16177,
      "gloss": "pillow, cushion",
      "glossSv": "kudde",
      "pos": "noun",
      "explanation": "bed + pointer, to pillow",
      "isCharacter": true
    },
    {
      "id": 523,
      "bciAvId": 16180,
      "gloss": "pimple, blemish",
      "glossSv": "finne, utslag",
      "pos": "noun",
      "explanation": "face + dot + pointer, to dot",
      "isCharacter": true
    },
    {
      "id": 524,
      "bciAvId": 16181,
      "gloss": "pin",
      "glossSv": "stift (etc)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pin. It is half the height of the nail symbol.",
      "isCharacter": true
    },
    {
      "id": 525,
      "bciAvId": 16182,
      "gloss": "pineapple",
      "glossSv": "ananas",
      "pos": "noun",
      "explanation": "pictograph with stem and leaves",
      "isCharacter": true
    },
    {
      "id": 526,
      "bciAvId": 16186,
      "gloss": "pipe, smoking pipe",
      "glossSv": "pipa",
      "pos": "noun",
      "explanation": "smoking (pipe) + pointer, to the pipe bowl",
      "isCharacter": true
    },
    {
      "id": 527,
      "bciAvId": 16187,
      "gloss": "pipe, hose, tube (1)",
      "glossSv": "rör, slang (1)",
      "pos": "noun",
      "explanation": "pictograph: horizontal orientation",
      "isCharacter": true
    },
    {
      "id": 528,
      "bciAvId": 16188,
      "gloss": "pit, stone",
      "glossSv": "kärna",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pit or stone",
      "isCharacter": true
    },
    {
      "id": 529,
      "bciAvId": 16190,
      "gloss": "pita",
      "glossSv": "pitabröd",
      "pos": "noun",
      "explanation": "pictograph: Middle Eastern bread, the line in the middle suggests that the bread is hollow inside",
      "isCharacter": true
    },
    {
      "id": 530,
      "bciAvId": 16191,
      "gloss": "pitcher, jug, kettle, pot",
      "glossSv": "kanna, tillbringare",
      "pos": "noun",
      "explanation": "pictograph with handle and spout",
      "isCharacter": true
    },
    {
      "id": 531,
      "bciAvId": 16193,
      "gloss": "place, area, location, space",
      "glossSv": "plats, ställe",
      "pos": "noun",
      "explanation": "earth + pointer: place on the earth",
      "isCharacter": true
    },
    {
      "id": 532,
      "bciAvId": 16194,
      "gloss": "plan, design, method, system",
      "glossSv": "plan, metod, mönster",
      "pos": "noun",
      "explanation": "mind + man-made: rational way for making something",
      "isCharacter": true
    },
    {
      "id": 533,
      "bciAvId": 16196,
      "gloss": "plant",
      "glossSv": "växt",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a flower with a leaf",
      "isCharacter": true
    },
    {
      "id": 534,
      "bciAvId": 16198,
      "gloss": "stop, platform (vehicle)",
      "glossSv": "plattform (FD)",
      "pos": "noun",
      "explanation": "platform + earth [modification, extended] + vehicle",
      "isCharacter": true
    },
    {
      "id": 535,
      "bciAvId": 16205,
      "gloss": "pliers, tongs, tweezer(s), pincer(s) (pair of)",
      "glossSv": "tång",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pair of pliers in an open position",
      "isCharacter": true
    },
    {
      "id": 536,
      "bciAvId": 16206,
      "gloss": "plough",
      "glossSv": "plog",
      "pos": "noun",
      "explanation": "knife + earth: heavy blade that cuts the soil in preparation for planting",
      "isCharacter": true
    },
    {
      "id": 537,
      "bciAvId": 16208,
      "gloss": "plum, drupe",
      "glossSv": "plommon",
      "pos": "noun",
      "explanation": "fruit + pit",
      "isCharacter": true
    },
    {
      "id": 538,
      "bciAvId": 16212,
      "gloss": "point, tip, peak",
      "glossSv": "spets",
      "pos": "noun",
      "explanation": "knife + pointer, to tip",
      "isCharacter": true
    },
    {
      "id": 539,
      "bciAvId": 16219,
      "gloss": "pool",
      "glossSv": "bassäng, pool",
      "pos": "noun",
      "explanation": "foundation,base,fundament + water: could also be interpreted as a combination of enclosure and water",
      "isCharacter": true
    },
    {
      "id": 540,
      "bciAvId": 16224,
      "gloss": "position",
      "glossSv": "läge, position",
      "pos": "noun",
      "explanation": "greater than (relation) + dot: forward pointing relation to a certain point in space",
      "isCharacter": true
    },
    {
      "id": 541,
      "bciAvId": 16227,
      "gloss": "postcard",
      "glossSv": "kort, vykort",
      "pos": "noun",
      "explanation": "enclosure + stamp [combination]: pictograph, which suggests a postcard with a stamp in the upper right corner",
      "isCharacter": true
    },
    {
      "id": 542,
      "bciAvId": 16229,
      "gloss": "pot, pan",
      "glossSv": "kastrull, stekpanna (etc)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pan with a handle",
      "isCharacter": true
    },
    {
      "id": 543,
      "bciAvId": 16232,
      "gloss": "pound sterling",
      "glossSv": "pund",
      "pos": "noun",
      "explanation": "international symbol for British pound sterling",
      "isCharacter": true
    },
    {
      "id": 544,
      "bciAvId": 16233,
      "gloss": "powder, dust",
      "glossSv": "pulver, damm, korn, stoft",
      "pos": "noun",
      "explanation": "three powder-like dots: located at the corner points of the stone symbol",
      "isCharacter": true
    },
    {
      "id": 545,
      "bciAvId": 16234,
      "gloss": "power (physics)",
      "glossSv": "kraft",
      "pos": "noun",
      "explanation": "action + electromagnetic radiation: energy in action",
      "isCharacter": true
    },
    {
      "id": 546,
      "bciAvId": 16246,
      "gloss": "present",
      "glossSv": "nutid",
      "pos": "noun",
      "explanation": "past + future: time between past and future",
      "isCharacter": true
    },
    {
      "id": 547,
      "bciAvId": 16254,
      "gloss": "projector",
      "glossSv": "projektor",
      "pos": "noun",
      "explanation": "camera + forward [modification, short arrow]: device that projects the picture produced by a camera forward onto a screen",
      "isCharacter": true
    },
    {
      "id": 548,
      "bciAvId": 16420,
      "gloss": "protection, shelter",
      "glossSv": "skydd, beskydd",
      "pos": "noun",
      "explanation": "symbol looks like a roof, suggesting the protection provided by a roof",
      "isCharacter": true
    },
    {
      "id": 549,
      "bciAvId": 16426,
      "gloss": "pubic hair",
      "glossSv": "könshår",
      "pos": "noun",
      "explanation": "hair + body + pointer, to hair",
      "isCharacter": true
    },
    {
      "id": 550,
      "bciAvId": 16430,
      "gloss": "public room",
      "glossSv": "offentlig lokal",
      "pos": "noun",
      "explanation": "ground + room, room with extended floor line [adaptation]: room opening out onto the street",
      "isCharacter": true
    },
    {
      "id": 551,
      "bciAvId": 16437,
      "gloss": "purpose",
      "glossSv": "avsikt",
      "pos": "noun",
      "explanation": "greater than (relation) + greater than (relation): the forward pointing doubled symbol stresses a purposeful relationship",
      "isCharacter": true
    },
    {
      "id": 552,
      "bciAvId": 16443,
      "gloss": "pyramid",
      "glossSv": "pyramid",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a three-dimensional outline of a pyramid",
      "isCharacter": true
    },
    {
      "id": 553,
      "bciAvId": 16445,
      "gloss": "question",
      "glossSv": "fråga (subst.)",
      "pos": "noun",
      "explanation": "what,question mark + open: the question is open-ended. This symbol is also used to introduce a question.",
      "isCharacter": true
    },
    {
      "id": 554,
      "bciAvId": 16451,
      "gloss": "race, competition, contest",
      "glossSv": "tävling, match",
      "pos": "noun",
      "explanation": "forward + forward [modification, lower position]: two forward arrows, one overtaking another, appear to be competing",
      "isCharacter": true
    },
    {
      "id": 555,
      "bciAvId": 16452,
      "gloss": "racket, racquet",
      "glossSv": "racket",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 556,
      "bciAvId": 16455,
      "gloss": "rain",
      "glossSv": "regn",
      "pos": "noun",
      "explanation": "water + down: water that falls down from the sky",
      "isCharacter": true
    },
    {
      "id": 557,
      "bciAvId": 16463,
      "gloss": "raspberry, blackberry, compound berry",
      "glossSv": "björnbär, hallon, hjortron",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 558,
      "bciAvId": 16479,
      "gloss": "less than (relation)",
      "glossSv": "mindre än (relation)",
      "pos": "expression",
      "explanation": "symbol is derived from the mathematical symbol for “smaller than”. This symbol in half-size is the basis for against, by, and there.",
      "isCharacter": true
    },
    {
      "id": 559,
      "bciAvId": 16480,
      "gloss": "greater than (relation)",
      "glossSv": "större än (relation)",
      "pos": "expression",
      "explanation": "symbol is derived from the mathematical symbol for \"greater than\". This symbol in half-size is the basis for about, at, for, here and on.",
      "isCharacter": true
    },
    {
      "id": 560,
      "bciAvId": 16481,
      "gloss": "relative, relation",
      "glossSv": "släkting, släkt",
      "pos": "person",
      "explanation": "protection + person + protection: two adjoining roofs are used to mean person who is related",
      "isCharacter": true
    },
    {
      "id": 561,
      "bciAvId": 16482,
      "gloss": "who, that, which - (relative)",
      "glossSv": "som",
      "pos": "expression",
      "explanation": "double commas, apostrophes or ditto marks in a sentence [modification, on the midline]: This symbol is equivalent to a relative pronoun or a conjunction used to introduce a relative clause.",
      "isCharacter": true
    },
    {
      "id": 562,
      "bciAvId": 16495,
      "gloss": "rest, comfort",
      "glossSv": "vila (subst.)",
      "pos": "noun",
      "explanation": "feeling + earth: feeling at rest on the earth. CKB points out that poets use the earth as a symbol for rest.",
      "isCharacter": true
    },
    {
      "id": 563,
      "bciAvId": 16499,
      "gloss": "return",
      "glossSv": "återkomst",
      "pos": "noun",
      "explanation": "reference line + backward: the arrow, moving backward, returns toward the reference line",
      "isCharacter": true
    },
    {
      "id": 564,
      "bciAvId": 16501,
      "gloss": "rhinoceros",
      "glossSv": "noshörning",
      "pos": "noun",
      "explanation": "animal + pictograph of head and horn: animal with a distinctive horn protruding from its nose",
      "isCharacter": true
    },
    {
      "id": 565,
      "bciAvId": 16505,
      "gloss": "rice",
      "glossSv": "ris",
      "pos": "noun",
      "explanation": "grain + water (ground level): grain that grows in water",
      "isCharacter": true
    },
    {
      "id": 566,
      "bciAvId": 16674,
      "gloss": "angle (right), right angle",
      "glossSv": "vinkel (rät), rät vinkel",
      "pos": "noun",
      "explanation": "international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 567,
      "bciAvId": 16675,
      "gloss": "ring",
      "glossSv": "ring",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 568,
      "bciAvId": 16677,
      "gloss": "river, stream, current",
      "glossSv": "flod, å, älv (etc)",
      "pos": "noun",
      "explanation": "water (ground level) + forward: water that flows forward",
      "isCharacter": true
    },
    {
      "id": 569,
      "bciAvId": 16678,
      "gloss": "road (1)",
      "glossSv": "väg, körbana (1)",
      "pos": "noun",
      "explanation": "road and car + pointer, to road: place where cars travel",
      "isCharacter": true
    },
    {
      "id": 570,
      "bciAvId": 16683,
      "gloss": "roll, bun",
      "glossSv": "bulle, småfranska (etc)",
      "pos": "noun",
      "explanation": "bread [modification, reduced width]: pictograph of a bun",
      "isCharacter": true
    },
    {
      "id": 571,
      "bciAvId": 16685,
      "gloss": "roller skates",
      "glossSv": "rullskridskor",
      "pos": "noun",
      "explanation": "legs and feet + wheel [modification, low position] + wheel [modification, low position]: wheeled skates",
      "isCharacter": true
    },
    {
      "id": 572,
      "bciAvId": 16687,
      "gloss": "room",
      "glossSv": "rum",
      "pos": "noun",
      "explanation": "enclosure, open on the left side",
      "isCharacter": true
    },
    {
      "id": 573,
      "bciAvId": 16688,
      "gloss": "root(s), rootage, root system",
      "glossSv": "rötter, rotsystem",
      "pos": "noun",
      "explanation": "earth + pictograph of roots: symbol suggests two roots below the ground.",
      "isCharacter": true
    },
    {
      "id": 574,
      "bciAvId": 16701,
      "gloss": "sack, bag",
      "glossSv": "påse, säck, kasse",
      "pos": "noun",
      "explanation": "pictograph: the sides of the symbol for container are extended",
      "isCharacter": true
    },
    {
      "id": 575,
      "bciAvId": 16706,
      "gloss": "sail",
      "glossSv": "segel (FD)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a sail on a mast",
      "isCharacter": true
    },
    {
      "id": 576,
      "bciAvId": 16707,
      "gloss": "sailboat",
      "glossSv": "segelbåt (FD)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the outline of a sailboat.The symbol also can be explained as: combination of boat and sail",
      "isCharacter": true
    },
    {
      "id": 577,
      "bciAvId": 16709,
      "gloss": "salad",
      "glossSv": "sallad",
      "pos": "noun",
      "explanation": "lettuce + dish [combination]: used in a general sense for all salads",
      "isCharacter": true
    },
    {
      "id": 578,
      "bciAvId": 16713,
      "gloss": "same, equal, equality",
      "glossSv": "lika, samma, lika med, likhet",
      "pos": "expression",
      "explanation": "international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 579,
      "bciAvId": 16727,
      "gloss": "saw",
      "glossSv": "såg",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a saw and incorporates teeth",
      "isCharacter": true
    },
    {
      "id": 580,
      "bciAvId": 16735,
      "gloss": "science, body of learning",
      "glossSv": "vetenskap, kunskapsområde",
      "pos": "noun",
      "explanation": "mind + nature: reasoned approach to nature",
      "isCharacter": true
    },
    {
      "id": 581,
      "bciAvId": 16736,
      "gloss": "scissors",
      "glossSv": "sax",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pair of closed scissors",
      "isCharacter": true
    },
    {
      "id": 582,
      "bciAvId": 16739,
      "gloss": "screw",
      "glossSv": "skruv",
      "pos": "noun",
      "explanation": "line + wavy line (as of fire) + line: pictograph that suggests the path made by the thread of a screw",
      "isCharacter": true
    },
    {
      "id": 583,
      "bciAvId": 16745,
      "gloss": "secret",
      "glossSv": "hemlighet",
      "pos": "noun",
      "explanation": "enclosure + mouth: the mouth is closed",
      "isCharacter": true
    },
    {
      "id": 584,
      "bciAvId": 16749,
      "gloss": "seed",
      "glossSv": "frö",
      "pos": "noun",
      "explanation": "earth + two dots below, to represent seeds",
      "isCharacter": true
    },
    {
      "id": 585,
      "bciAvId": 16751,
      "gloss": "seesaw, teeter-totter, teeter board",
      "glossSv": "gungbräda",
      "pos": "noun",
      "explanation": "pictograph: slanted line on top of triangle, suggesting a seesaw",
      "isCharacter": true
    },
    {
      "id": 586,
      "bciAvId": 16939,
      "gloss": "shamrock, clover",
      "glossSv": "klöver",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 587,
      "bciAvId": 16953,
      "gloss": "shelf",
      "glossSv": "hylla",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a shelf",
      "isCharacter": true
    },
    {
      "id": 588,
      "bciAvId": 16954,
      "gloss": "shell, crust",
      "glossSv": "skal, hölje",
      "pos": "noun",
      "explanation": "case,casing + pointer, to enclosure: a crust or shell surrounds the thing",
      "isCharacter": true
    },
    {
      "id": 589,
      "bciAvId": 16964,
      "gloss": "shoulder",
      "glossSv": "axel, skuldra",
      "pos": "noun",
      "explanation": "body + pointer, to shoulder",
      "isCharacter": true
    },
    {
      "id": 590,
      "bciAvId": 16966,
      "gloss": "shovel, spade",
      "glossSv": "spade",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 591,
      "bciAvId": 16968,
      "gloss": "shower",
      "glossSv": "dusch",
      "pos": "noun",
      "explanation": "room + water + down: room where water pours down for bathing",
      "isCharacter": true
    },
    {
      "id": 592,
      "bciAvId": 16974,
      "gloss": "side (body)",
      "glossSv": "sida (på kroppen)",
      "pos": "noun",
      "explanation": "body + pointer, to side",
      "isCharacter": true
    },
    {
      "id": 593,
      "bciAvId": 16975,
      "gloss": "side (enclosure)",
      "glossSv": "sida",
      "pos": "noun",
      "explanation": "enclosure + pointer, to side",
      "isCharacter": true
    },
    {
      "id": 594,
      "bciAvId": 16976,
      "gloss": "sieve, colander, strainer",
      "glossSv": "sil, durkslag, filter",
      "pos": "noun",
      "explanation": "container + downward [modification, low position]: container through which something can pass",
      "isCharacter": true
    },
    {
      "id": 595,
      "bciAvId": 16992,
      "gloss": "bath, washing",
      "glossSv": "bad, tvätt",
      "pos": "noun",
      "explanation": "container + water",
      "isCharacter": true
    },
    {
      "id": 596,
      "bciAvId": 16997,
      "gloss": "skateboard",
      "glossSv": "rullbräda, skateboard",
      "pos": "noun",
      "explanation": "vehicle + ski,runner [modification, high position]: pictograph, combination of vehicle and ski",
      "isCharacter": true
    },
    {
      "id": 597,
      "bciAvId": 17006,
      "gloss": "sky",
      "glossSv": "himmel",
      "pos": "noun",
      "explanation": "horizontal line, on the skyline of the symbol drawing area",
      "isCharacter": true
    },
    {
      "id": 598,
      "bciAvId": 17007,
      "gloss": "sled, sledge, sleigh, toboggan",
      "glossSv": "kälke, pulka, släde",
      "pos": "noun",
      "explanation": "thing [modification, on earthline] + ski,runner (sled etc): pictograph, symbol suggests a sled, a snow vehicle to carry things",
      "isCharacter": true
    },
    {
      "id": 599,
      "bciAvId": 17008,
      "gloss": "sleep",
      "glossSv": "sömn",
      "pos": "noun",
      "explanation": "eye + to close: one's eyes are closed in sleep",
      "isCharacter": true
    },
    {
      "id": 600,
      "bciAvId": 17017,
      "gloss": "smell, odour, odor",
      "glossSv": "lukt, doft",
      "pos": "noun",
      "explanation": "nose + earth [half-sized]: what the nose gets from the earth",
      "isCharacter": true
    },
    {
      "id": 601,
      "bciAvId": 17188,
      "gloss": "snail",
      "glossSv": "snigel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a snail",
      "isCharacter": true
    },
    {
      "id": 602,
      "bciAvId": 17189,
      "gloss": "snake",
      "glossSv": "orm",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a snake",
      "isCharacter": true
    },
    {
      "id": 603,
      "bciAvId": 17190,
      "gloss": "water snake",
      "glossSv": "vattenorm",
      "pos": "noun",
      "explanation": "snake + water [modification, low position under the earthline]: snake that spends much time in the water",
      "isCharacter": true
    },
    {
      "id": 604,
      "bciAvId": 17192,
      "gloss": "snow",
      "glossSv": "snö",
      "pos": "noun",
      "explanation": "water + down [modification] + star [modification, on earthline] [combination]: water that comes down from the sky in star-shaped flakes",
      "isCharacter": true
    },
    {
      "id": 605,
      "bciAvId": 17195,
      "gloss": "snowflake",
      "glossSv": "snöflinga",
      "pos": "noun",
      "explanation": "snow + pointer, to star-shaped flake",
      "isCharacter": true
    },
    {
      "id": 606,
      "bciAvId": 17205,
      "gloss": "solid thing",
      "glossSv": "fast föremål",
      "pos": "noun",
      "explanation": "thing [modification, low position] + thing [modification, high position]: simplified three dimensional drawing of a solid object",
      "isCharacter": true
    },
    {
      "id": 607,
      "bciAvId": 17209,
      "gloss": "son",
      "glossSv": "son",
      "pos": "person",
      "explanation": "protection + male: male born under the family roof",
      "isCharacter": true
    },
    {
      "id": 608,
      "bciAvId": 17216,
      "gloss": "sound",
      "glossSv": "ljud",
      "pos": "noun",
      "explanation": "ear + earth [half-sized]: what the ear receives from the earth",
      "isCharacter": true
    },
    {
      "id": 609,
      "bciAvId": 17218,
      "gloss": "soup, broth",
      "glossSv": "soppa, buljong",
      "pos": "noun",
      "explanation": "dish + liquid",
      "isCharacter": true
    },
    {
      "id": 610,
      "bciAvId": 17219,
      "gloss": "south",
      "glossSv": "söder",
      "pos": "noun",
      "explanation": "sun + pointer, to south",
      "isCharacter": true
    },
    {
      "id": 611,
      "bciAvId": 17221,
      "gloss": "space, dimension",
      "glossSv": "rymd, utrymme, dimension",
      "pos": "noun",
      "explanation": "three coordinate axes drawn in perspective, illustrating the three dimensions of space",
      "isCharacter": true
    },
    {
      "id": 612,
      "bciAvId": 17226,
      "gloss": "sperm",
      "glossSv": "spermie",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 613,
      "bciAvId": 17229,
      "gloss": "spider",
      "glossSv": "spindel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a spider",
      "isCharacter": true
    },
    {
      "id": 614,
      "bciAvId": 17233,
      "gloss": "spoon",
      "glossSv": "sked",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a spoon. The diagonal orientation of spoon is the same as that of fork and knife.",
      "isCharacter": true
    },
    {
      "id": 615,
      "bciAvId": 17235,
      "gloss": "sport stick",
      "glossSv": "klubba",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a hockey stick",
      "isCharacter": true
    },
    {
      "id": 616,
      "bciAvId": 17237,
      "gloss": "spouse, cohabitant, partner",
      "glossSv": "maka, make, sambo, partner",
      "pos": "person",
      "explanation": "person + protection: person who shares one's roof",
      "isCharacter": true
    },
    {
      "id": 617,
      "bciAvId": 17238,
      "gloss": "spread, paste",
      "glossSv": "pålägg",
      "pos": "noun",
      "explanation": "food + on [combination]: food that is put on something else",
      "isCharacter": true
    },
    {
      "id": 618,
      "bciAvId": 17244,
      "gloss": "squash, pumpkin",
      "glossSv": "squash, pumpa",
      "pos": "noun",
      "explanation": "vegetable (above ground) [modification] + pictograph of thick rind",
      "isCharacter": true
    },
    {
      "id": 619,
      "bciAvId": 17247,
      "gloss": "stairs, steps",
      "glossSv": "trappa",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a side view of a flight of stairs",
      "isCharacter": true
    },
    {
      "id": 620,
      "bciAvId": 17248,
      "gloss": "stamp",
      "glossSv": "frimärke",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a stamp in the upper corner of an envelope",
      "isCharacter": true
    },
    {
      "id": 621,
      "bciAvId": 17251,
      "gloss": "star of David",
      "glossSv": "davidsstjärna",
      "pos": "noun",
      "explanation": "symbol for Judaism",
      "isCharacter": true
    },
    {
      "id": 622,
      "bciAvId": 17252,
      "gloss": "star",
      "glossSv": "stjärna",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a star giving off rays of light",
      "isCharacter": true
    },
    {
      "id": 623,
      "bciAvId": 17255,
      "gloss": "steam",
      "glossSv": "ånga (subst.)",
      "pos": "noun",
      "explanation": "water + up: when water is converted into steam by boiling, it rises",
      "isCharacter": true
    },
    {
      "id": 624,
      "bciAvId": 17257,
      "gloss": "steam bath",
      "glossSv": "bastu, ångbad",
      "pos": "noun",
      "explanation": "room + steam",
      "isCharacter": true
    },
    {
      "id": 625,
      "bciAvId": 17259,
      "gloss": "stem, stalk",
      "glossSv": "stjälk",
      "pos": "noun",
      "explanation": "flower + pointer, to stem",
      "isCharacter": true
    },
    {
      "id": 626,
      "bciAvId": 17260,
      "gloss": "stepfather",
      "glossSv": "styvfar",
      "pos": "person",
      "explanation": "husband + mother: husband of one's mother",
      "isCharacter": true
    },
    {
      "id": 627,
      "bciAvId": 17261,
      "gloss": "stepmother",
      "glossSv": "styvmor",
      "pos": "person",
      "explanation": "wife + father: wife of one's father",
      "isCharacter": true
    },
    {
      "id": 628,
      "bciAvId": 17265,
      "gloss": "stomach, abdomen, belly",
      "glossSv": "mage, buk",
      "pos": "noun",
      "explanation": "body + pointer to stomach",
      "isCharacter": true
    },
    {
      "id": 629,
      "bciAvId": 17267,
      "gloss": "stone, rock",
      "glossSv": "sten, klippa",
      "pos": "noun",
      "explanation": "mountain [half-sized]",
      "isCharacter": true
    },
    {
      "id": 630,
      "bciAvId": 17273,
      "gloss": "stove, furnace, heater, oven",
      "glossSv": "spis, ugn",
      "pos": "noun",
      "explanation": "fire + enclosure: enclosed source of heat",
      "isCharacter": true
    },
    {
      "id": 631,
      "bciAvId": 17278,
      "gloss": "strawberry",
      "glossSv": "jordgubbe",
      "pos": "noun",
      "explanation": "berry + pictograph of seeds showing on the outside",
      "isCharacter": true
    },
    {
      "id": 632,
      "bciAvId": 17441,
      "gloss": "street",
      "glossSv": "gata, väg",
      "pos": "noun",
      "explanation": "street and building + pointer, to street: ground, next to a building, used as a public thoroughfare",
      "isCharacter": true
    },
    {
      "id": 633,
      "bciAvId": 17445,
      "gloss": "structure, construction",
      "glossSv": "konstruktion",
      "pos": "noun",
      "explanation": "enclosure [modification, formed of lines and dots]",
      "isCharacter": true
    },
    {
      "id": 634,
      "bciAvId": 17449,
      "gloss": "subtraction, loss",
      "glossSv": "avdrag, förlust, subtraktion",
      "pos": "noun",
      "explanation": "based upon the international mathematical symbol",
      "isCharacter": true
    },
    {
      "id": 635,
      "bciAvId": 17451,
      "gloss": "success",
      "glossSv": "framgång",
      "pos": "noun",
      "explanation": "opposing forces,counter-forces + forward: the forward arrow moves forward through the two arrows of opposing forces, i.e., it has success in overcoming the opposing forces",
      "isCharacter": true
    },
    {
      "id": 636,
      "bciAvId": 17462,
      "gloss": "sun",
      "glossSv": "sol",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 637,
      "bciAvId": 17472,
      "gloss": "swamp, bog, marsh",
      "glossSv": "mosse, myr, sankmark",
      "pos": "noun",
      "explanation": "water (ground level) + earth [half-sized]: more water than earth",
      "isCharacter": true
    },
    {
      "id": 638,
      "bciAvId": 17473,
      "gloss": "swan",
      "glossSv": "svan",
      "pos": "noun",
      "explanation": "water creature + pictograph of swan neck and head: symbol also incorporates water",
      "isCharacter": true
    },
    {
      "id": 639,
      "bciAvId": 17493,
      "gloss": "table",
      "glossSv": "bord",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the side view of a table",
      "isCharacter": true
    },
    {
      "id": 640,
      "bciAvId": 17496,
      "gloss": "tail",
      "glossSv": "svans",
      "pos": "noun",
      "explanation": "canine (animal) + pointer, to tail",
      "isCharacter": true
    },
    {
      "id": 641,
      "bciAvId": 17504,
      "gloss": "tank",
      "glossSv": "stridsvagn",
      "pos": "noun",
      "explanation": "bus,coach [modification, prolonged] + cannon [modification, higher position]",
      "isCharacter": true
    },
    {
      "id": 642,
      "bciAvId": 17506,
      "gloss": "taste",
      "glossSv": "smak",
      "pos": "noun",
      "explanation": "nose + mouth: the nose and mouth are both used in tasting",
      "isCharacter": true
    },
    {
      "id": 643,
      "bciAvId": 17516,
      "gloss": "teenager, adolescent, youth",
      "glossSv": "tonåring, ungdom",
      "pos": "person",
      "explanation": "child + adult [combination]: person between childhood and adulthood",
      "isCharacter": true
    },
    {
      "id": 644,
      "bciAvId": 17517,
      "gloss": "teeth",
      "glossSv": "tänder",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests two teeth",
      "isCharacter": true
    },
    {
      "id": 645,
      "bciAvId": 17520,
      "gloss": "temperature",
      "glossSv": "temperatur",
      "pos": "noun",
      "explanation": "scale,measurement + point [low position under earthline]: symbol suggests a thermometer and incorporates measurement in a vertical position",
      "isCharacter": true
    },
    {
      "id": 646,
      "bciAvId": 17697,
      "gloss": "that (there)",
      "glossSv": "den där, det där",
      "pos": "expression",
      "explanation": "dot [low position] + the: the diagonal line has the same orientation as the one used in the and this",
      "isCharacter": true
    },
    {
      "id": 647,
      "bciAvId": 17700,
      "gloss": "the",
      "glossSv": "den, det (bestämd form)",
      "pos": "expression",
      "explanation": "diagonal line suggests an index finger pointing at something specific. The diagonal line has the same orientation as the one used in this and that.",
      "isCharacter": true
    },
    {
      "id": 648,
      "bciAvId": 17705,
      "gloss": "then, so, later",
      "glossSv": "senare, sedan",
      "pos": "expression",
      "explanation": "future [half-sized]",
      "isCharacter": true
    },
    {
      "id": 649,
      "bciAvId": 17707,
      "gloss": "there",
      "glossSv": "där",
      "pos": "expression",
      "explanation": "dot + dot + pointer to the right dot: two dots in relation to eachother with the pointer pointing to the one further away, \"there\"",
      "isCharacter": true
    },
    {
      "id": 650,
      "bciAvId": 17708,
      "gloss": "therefore, so, so that",
      "glossSv": "så, alltså",
      "pos": "expression",
      "explanation": "cause [half-sized]",
      "isCharacter": true
    },
    {
      "id": 651,
      "bciAvId": 17717,
      "gloss": "thing, object",
      "glossSv": "sak, föremål",
      "pos": "noun",
      "explanation": "symbol suggests the two dimensional outline of a crystal",
      "isCharacter": true
    },
    {
      "id": 652,
      "bciAvId": 17720,
      "gloss": "this",
      "glossSv": "den här, det här, denna, detta",
      "pos": "expression",
      "explanation": "the + dot [high position]: the diagonal line has the same orientation as the one used in the and that",
      "isCharacter": true
    },
    {
      "id": 653,
      "bciAvId": 17724,
      "gloss": "through",
      "glossSv": "genom",
      "pos": "expression",
      "explanation": "forward + reference line: arrow is passing through the reference line",
      "isCharacter": true
    },
    {
      "id": 654,
      "bciAvId": 17726,
      "gloss": "thumb",
      "glossSv": "tumme",
      "pos": "noun",
      "explanation": "hand + pointer, to thumb",
      "isCharacter": true
    },
    {
      "id": 655,
      "bciAvId": 17732,
      "gloss": "time",
      "glossSv": "tid",
      "pos": "noun",
      "explanation": "symbol looks like a clock face, suggesting time",
      "isCharacter": true
    },
    {
      "id": 656,
      "bciAvId": 17734,
      "gloss": "tire, tyre",
      "glossSv": "däck (till hjul)",
      "pos": "noun",
      "explanation": "wheel + pointer, to tire",
      "isCharacter": true
    },
    {
      "id": 657,
      "bciAvId": 17739,
      "gloss": "to, toward, towards",
      "glossSv": "till, mot, fram mot",
      "pos": "expression",
      "explanation": "arrowhead + reference line [half-sized]: the arrowhead approaches the reference line. This symbol is a simplified form of approach.",
      "isCharacter": true
    },
    {
      "id": 658,
      "bciAvId": 17745,
      "gloss": "toe",
      "glossSv": "tå",
      "pos": "noun",
      "explanation": "legs and feet + pointer, to toe",
      "isCharacter": true
    },
    {
      "id": 659,
      "bciAvId": 17747,
      "gloss": "toilet",
      "glossSv": "toalett",
      "pos": "noun",
      "explanation": "seat + water (ground level): water closet",
      "isCharacter": true
    },
    {
      "id": 660,
      "bciAvId": 17755,
      "gloss": "tool, instrument",
      "glossSv": "verktyg, redskap",
      "pos": "noun",
      "explanation": "thing + hand: thing used by the hand to extend its capabilities",
      "isCharacter": true
    },
    {
      "id": 661,
      "bciAvId": 17758,
      "gloss": "top",
      "glossSv": "översida",
      "pos": "noun",
      "explanation": "enclosure + pointer, to top",
      "isCharacter": true
    },
    {
      "id": 662,
      "bciAvId": 17759,
      "gloss": "dreidel top",
      "glossSv": "snurra",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 663,
      "bciAvId": 17760,
      "gloss": "Torah",
      "glossSv": "Torah (Israel)",
      "pos": "noun",
      "explanation": "pictograph of a scroll on two posts: the Torah contains the Old Testament",
      "isCharacter": true
    },
    {
      "id": 664,
      "bciAvId": 17765,
      "gloss": "tractor",
      "glossSv": "traktor",
      "pos": "noun",
      "explanation": "car [modification, full sized back wheel]: pictograph of a tractor",
      "isCharacter": true
    },
    {
      "id": 665,
      "bciAvId": 17773,
      "gloss": "tray",
      "glossSv": "bricka",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 666,
      "bciAvId": 17775,
      "gloss": "tree",
      "glossSv": "träd",
      "pos": "noun",
      "explanation": "pictograph, of tree with trunk and branches",
      "isCharacter": true
    },
    {
      "id": 667,
      "bciAvId": 17779,
      "gloss": "trip, journey, travel, voyage",
      "glossSv": "resa (subst.)",
      "pos": "noun",
      "explanation": "wheel + earth: movement along the earth",
      "isCharacter": true
    },
    {
      "id": 668,
      "bciAvId": 17781,
      "gloss": "truck, lorry",
      "glossSv": "lastbil",
      "pos": "noun",
      "explanation": "transport,transportation + car: large motor vehicle for carrying things",
      "isCharacter": true
    },
    {
      "id": 669,
      "bciAvId": 17783,
      "gloss": "trunk, tree trunk, bole",
      "glossSv": "stam, trädstam",
      "pos": "noun",
      "explanation": "tree + pointer, to trunk",
      "isCharacter": true
    },
    {
      "id": 670,
      "bciAvId": 17786,
      "gloss": "truth",
      "glossSv": "sanning",
      "pos": "noun",
      "explanation": "mind + hypothesis,theory: the mind believes itself to understand the nature of things, but it may be in error",
      "isCharacter": true
    },
    {
      "id": 671,
      "bciAvId": 17958,
      "gloss": "turnip, rutabaga, vegetable (large-leafed)",
      "glossSv": "kålrot, beta (etc)",
      "pos": "noun",
      "explanation": "vegetable (below ground) [modification] + leaf [combination]: large-leafed vegetable with an edible root",
      "isCharacter": true
    },
    {
      "id": 672,
      "bciAvId": 17959,
      "gloss": "turtle, tortoise",
      "glossSv": "sköldpadda",
      "pos": "noun",
      "explanation": "animal + pictograph of head and protective shell",
      "isCharacter": true
    },
    {
      "id": 673,
      "bciAvId": 17961,
      "gloss": "type, kind, sort, category",
      "glossSv": "sort, slag, typ",
      "pos": "noun",
      "explanation": "mind + division [half-sized]: the mind’s division of things into categories",
      "isCharacter": true
    },
    {
      "id": 674,
      "bciAvId": 17966,
      "gloss": "umbrella",
      "glossSv": "paraply, parasoll",
      "pos": "noun",
      "explanation": "protection + pictograph of an umbrella handle: symbol suggests an umbrella",
      "isCharacter": true
    },
    {
      "id": 675,
      "bciAvId": 17967,
      "gloss": "uncle",
      "glossSv": "farbror, morbror",
      "pos": "person",
      "explanation": "brother + parent: brother of one's father or mother",
      "isCharacter": true
    },
    {
      "id": 676,
      "bciAvId": 17969,
      "gloss": "under, below, inferior",
      "glossSv": "under, nedanför",
      "pos": "expression",
      "explanation": "horizontal reference line + dot [low position]: the dot is under or below the line",
      "isCharacter": true
    },
    {
      "id": 677,
      "bciAvId": 17982,
      "gloss": "until, till, to",
      "glossSv": "intill, tills",
      "pos": "expression",
      "explanation": "arrowhead + reference line [half-sized]: the arrowhead has arrived at and touches the reference line. This symbol is a simplified form of arrival, end.",
      "isCharacter": true
    },
    {
      "id": 678,
      "bciAvId": 17983,
      "gloss": "up, upward",
      "glossSv": "upp, uppåt",
      "pos": "expression",
      "explanation": "arrow, pointing upward",
      "isCharacter": true
    },
    {
      "id": 679,
      "bciAvId": 17986,
      "gloss": "upward and backward",
      "glossSv": "uppåt bakåt",
      "pos": "expression",
      "explanation": "diagonal arrow, pointing upward and backward",
      "isCharacter": true
    },
    {
      "id": 680,
      "bciAvId": 17987,
      "gloss": "upward and forward",
      "glossSv": "uppåt framåt",
      "pos": "expression",
      "explanation": "diagonal arrow, pointing upward and forward",
      "isCharacter": true
    },
    {
      "id": 681,
      "bciAvId": 17994,
      "gloss": "uterus, womb",
      "glossSv": "livmoder",
      "pos": "noun",
      "explanation": "body + female (gender): part of a woman’s body where new life is nurtured",
      "isCharacter": true
    },
    {
      "id": 682,
      "bciAvId": 17996,
      "gloss": "vagina",
      "glossSv": "slida",
      "pos": "noun",
      "explanation": "uterus [modification, opening in body] + pointer, to passage",
      "isCharacter": true
    },
    {
      "id": 683,
      "bciAvId": 17999,
      "gloss": "valley",
      "glossSv": "dal",
      "pos": "noun",
      "explanation": "mountains with valley + pointer: the low place between two mountains",
      "isCharacter": true
    },
    {
      "id": 684,
      "bciAvId": 18004,
      "gloss": "vegetable (above ground)",
      "glossSv": "grönsak",
      "pos": "noun",
      "explanation": "earth + fruit [modification, upside down]: symbol suggests a vegetable with the edible portion above ground and the root below",
      "isCharacter": true
    },
    {
      "id": 685,
      "bciAvId": 18005,
      "gloss": "vegetable (below ground)",
      "glossSv": "rotfrukt",
      "pos": "noun",
      "explanation": "earth + fruit [modification, low position]: symbol looks like a vegetable with the edible portion below ground and the leafy portion above",
      "isCharacter": true
    },
    {
      "id": 686,
      "bciAvId": 18006,
      "gloss": "onion, vegetable (bulb)",
      "glossSv": "lök (grönsak)",
      "pos": "noun",
      "explanation": "vegetable (below ground) + bulb (plant) [combination]",
      "isCharacter": true
    },
    {
      "id": 687,
      "bciAvId": 18007,
      "gloss": "vegetable (oval-shaped)",
      "glossSv": "grönsak (avlång)",
      "pos": "noun",
      "explanation": "vegetable (above ground) + oval [combination]",
      "isCharacter": true
    },
    {
      "id": 688,
      "bciAvId": 18010,
      "gloss": "vehicle, carriage, railway car",
      "glossSv": "fordon, vagn",
      "pos": "noun",
      "explanation": "wheel + wheel + horizontal line: pictograph, symbol suggests a vehicle such as a railroad car or a horse-drawn carriage that does not operate under its own power",
      "isCharacter": true
    },
    {
      "id": 689,
      "bciAvId": 18028,
      "gloss": "wagon, cart, truck",
      "glossSv": "vagn, lastkärra (etc)",
      "pos": "noun",
      "explanation": "vehicle + diagonal line, representing a handle",
      "isCharacter": true
    },
    {
      "id": 690,
      "bciAvId": 18029,
      "gloss": "waist",
      "glossSv": "midja",
      "pos": "noun",
      "explanation": "body + pointer + pointer, to waist",
      "isCharacter": true
    },
    {
      "id": 691,
      "bciAvId": 18033,
      "gloss": "wall",
      "glossSv": "vägg",
      "pos": "noun",
      "explanation": "room + pointer, to wall",
      "isCharacter": true
    },
    {
      "id": 692,
      "bciAvId": 18034,
      "gloss": "wand",
      "glossSv": "trollspö",
      "pos": "noun",
      "explanation": "vertical line + star [modification, position and shape at the top of the wand]: pictograph",
      "isCharacter": true
    },
    {
      "id": 693,
      "bciAvId": 18036,
      "gloss": "war",
      "glossSv": "krig, strid",
      "pos": "noun",
      "explanation": "knife,sword + knife sword [modification, mirrored]: two crossed swords, suggesting armed conflict",
      "isCharacter": true
    },
    {
      "id": 694,
      "bciAvId": 18043,
      "gloss": "waste, garbage, rubbish, trash",
      "glossSv": "skräp, avfall, sopor",
      "pos": "noun",
      "explanation": "thing + to destroy: something discarded or no longer of use",
      "isCharacter": true
    },
    {
      "id": 695,
      "bciAvId": 18209,
      "gloss": "water, fluid, liquid",
      "glossSv": "vatten, vätska",
      "pos": "noun",
      "explanation": "symbol looks like a wave, suggesting water or liquid",
      "isCharacter": true
    },
    {
      "id": 696,
      "bciAvId": 18214,
      "gloss": "weather",
      "glossSv": "väder",
      "pos": "noun",
      "explanation": "sun + rain: these symbols represent the two major types of weather conditions",
      "isCharacter": true
    },
    {
      "id": 697,
      "bciAvId": 18221,
      "gloss": "weight",
      "glossSv": "vikt",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a scale on which weight is measured",
      "isCharacter": true
    },
    {
      "id": 698,
      "bciAvId": 18224,
      "gloss": "west",
      "glossSv": "väster",
      "pos": "noun",
      "explanation": "sun + pointer, to west",
      "isCharacter": true
    },
    {
      "id": 699,
      "bciAvId": 18229,
      "gloss": "what, question mark (small)",
      "glossSv": "fråga (använd som symboldel)",
      "pos": "expression",
      "explanation": "question mark [half-sized]: interrogative",
      "isCharacter": true
    },
    {
      "id": 700,
      "bciAvId": 18232,
      "gloss": "wheel",
      "glossSv": "hjul",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a wheel with spokes",
      "isCharacter": true
    },
    {
      "id": 701,
      "bciAvId": 18233,
      "gloss": "wheelchair",
      "glossSv": "rullstol",
      "pos": "noun",
      "explanation": "chair + wheel",
      "isCharacter": true
    },
    {
      "id": 702,
      "bciAvId": 18236,
      "gloss": "where",
      "glossSv": "var, var som",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + earth,ground,land: can be viewed as a combination of who,that,which-(relative) and place, conjunction used to introduce a relative clause",
      "isCharacter": true
    },
    {
      "id": 703,
      "bciAvId": 18237,
      "gloss": "where - (question)",
      "glossSv": "var (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + earth,ground,land: can be viewed as a combination of what,question mark and place: interrogative",
      "isCharacter": true
    },
    {
      "id": 704,
      "bciAvId": 18251,
      "gloss": "wife",
      "glossSv": "fru, hustru, maka",
      "pos": "person",
      "explanation": "protection + woman: this symbol, joined to husband, produces family",
      "isCharacter": true
    },
    {
      "id": 705,
      "bciAvId": 18255,
      "gloss": "wind",
      "glossSv": "vind, blåst",
      "pos": "noun",
      "explanation": "air + forward: air that moves forward",
      "isCharacter": true
    },
    {
      "id": 706,
      "bciAvId": 18256,
      "gloss": "window",
      "glossSv": "fönster",
      "pos": "noun",
      "explanation": "enclosure + pictograph of two traversing bars",
      "isCharacter": true
    },
    {
      "id": 707,
      "bciAvId": 18257,
      "gloss": "barred window",
      "glossSv": "galler, fönster med galler",
      "pos": "noun",
      "explanation": "enclosure + pictograph of bars of a lattice",
      "isCharacter": true
    },
    {
      "id": 708,
      "bciAvId": 18259,
      "gloss": "wing(s)",
      "glossSv": "vinge, vingar",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a pair of wings in flight",
      "isCharacter": true
    },
    {
      "id": 709,
      "bciAvId": 18267,
      "gloss": "with",
      "glossSv": "med",
      "pos": "expression",
      "explanation": "addition [half-sized, modification with the crossbar located on the skyline]",
      "isCharacter": true
    },
    {
      "id": 710,
      "bciAvId": 18269,
      "gloss": "woman, female",
      "glossSv": "kvinna, tant",
      "pos": "person",
      "explanation": "person [modification] + creation [half-sized] [combination]: CKB says woman embodies the creative principle in society. The symbol also looks like a stick figure of a woman wearing a skirt.",
      "isCharacter": true
    },
    {
      "id": 711,
      "bciAvId": 18273,
      "gloss": "work, employment, job",
      "glossSv": "arbete, jobb, anställning",
      "pos": "noun",
      "explanation": "activity + activity [modification, high position]: two action symbols [half-sized], one above the other to \"heighten\" the meaning: actions done with a purpose",
      "isCharacter": true
    },
    {
      "id": 712,
      "bciAvId": 18278,
      "gloss": "world",
      "glossSv": "värld",
      "pos": "noun",
      "explanation": "sky + earth: what exists between sky and earth",
      "isCharacter": true
    },
    {
      "id": 713,
      "bciAvId": 18279,
      "gloss": "worm",
      "glossSv": "mask",
      "pos": "noun",
      "explanation": "earth [modification, extended] + snake [modification, under earthline]: snake-like creature that lives underground",
      "isCharacter": true
    },
    {
      "id": 714,
      "bciAvId": 18284,
      "gloss": "wrist",
      "glossSv": "handled",
      "pos": "noun",
      "explanation": "arm + pointer, to wrist",
      "isCharacter": true
    },
    {
      "id": 715,
      "bciAvId": 18287,
      "gloss": "yard",
      "glossSv": "gård",
      "pos": "noun",
      "explanation": "building with yard and fence + pointer, to yard: area next to a building",
      "isCharacter": true
    },
    {
      "id": 716,
      "bciAvId": 18289,
      "gloss": "year",
      "glossSv": "år",
      "pos": "noun",
      "explanation": "sun + arrow head: indicating movement around, the earth completes one circuit around the sun in a year",
      "isCharacter": true
    },
    {
      "id": 717,
      "bciAvId": 18293,
      "gloss": "yen",
      "glossSv": "yen",
      "pos": "noun",
      "explanation": "international symbol for Japanese yen",
      "isCharacter": true
    },
    {
      "id": 718,
      "bciAvId": 20517,
      "gloss": "muscle",
      "glossSv": "muskel",
      "pos": "noun",
      "explanation": "arm + the pictograph of a protruding biceps",
      "isCharacter": true
    },
    {
      "id": 719,
      "bciAvId": 20518,
      "gloss": "sport",
      "glossSv": "sport",
      "pos": "noun",
      "explanation": "activity + health",
      "isCharacter": true
    },
    {
      "id": 720,
      "bciAvId": 20519,
      "gloss": "sail",
      "glossSv": "segel",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a sail on a mast",
      "isCharacter": true
    },
    {
      "id": 721,
      "bciAvId": 20520,
      "gloss": "sailboat, sailing boat, yacht",
      "glossSv": "segelbåt",
      "pos": "noun",
      "explanation": "boat + sail [combination]: pictograph, suggests the outline of a sailboat. The symbol can be explained as: combination of boat and sail",
      "isCharacter": true
    },
    {
      "id": 722,
      "bciAvId": 20522,
      "gloss": "sauce, gravy, relish, dressing",
      "glossSv": "sås, dressing (etc)",
      "pos": "noun",
      "explanation": "spread + liquid",
      "isCharacter": true
    },
    {
      "id": 723,
      "bciAvId": 20524,
      "gloss": "up and down",
      "glossSv": "upp och ner",
      "pos": "expression",
      "explanation": "up,upward + down,downward",
      "isCharacter": true
    },
    {
      "id": 724,
      "bciAvId": 20528,
      "gloss": "can, tin, jar",
      "glossSv": "burk",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 725,
      "bciAvId": 20561,
      "gloss": "religion (God based)",
      "glossSv": "religion, tro",
      "pos": "noun",
      "explanation": "feeling + God: God-based religion",
      "isCharacter": true
    },
    {
      "id": 726,
      "bciAvId": 20563,
      "gloss": "religion, naturalism",
      "glossSv": "tro, naturalism",
      "pos": "noun",
      "explanation": "feeling + creation: doctrine that all religious truths are derived from nature",
      "isCharacter": true
    },
    {
      "id": 727,
      "bciAvId": 20564,
      "gloss": "belief (supernatural)",
      "glossSv": "tro (övernaturlig)",
      "pos": "noun",
      "explanation": "feeling + supernatural",
      "isCharacter": true
    },
    {
      "id": 728,
      "bciAvId": 20568,
      "gloss": "devil (1)",
      "glossSv": "djävul (1)",
      "pos": "person",
      "explanation": "person + horn(s) [modification, higher position]",
      "isCharacter": true
    },
    {
      "id": 729,
      "bciAvId": 20571,
      "gloss": "angel (1)",
      "glossSv": "ängel (1)",
      "pos": "person",
      "explanation": "person + wings",
      "isCharacter": true
    },
    {
      "id": 730,
      "bciAvId": 20572,
      "gloss": "family",
      "glossSv": "familj, kärnfamilj",
      "pos": "person",
      "explanation": "couple + star, representing a child or children",
      "isCharacter": true
    },
    {
      "id": 731,
      "bciAvId": 20599,
      "gloss": "board",
      "glossSv": "bräda",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 732,
      "bciAvId": 20769,
      "gloss": "bun (food)",
      "glossSv": "bröd (att lägga mat i)",
      "pos": "noun",
      "explanation": "roll,bun + horizontal line: pictograph, a bun cut horizontally for food to be placed in between",
      "isCharacter": true
    },
    {
      "id": 733,
      "bciAvId": 21036,
      "gloss": "supernatural - (noun)",
      "glossSv": "övernaturliga (det)",
      "pos": "noun",
      "explanation": "nature + mind [modification, at a higher position]: claimed to be experienced at a higher level of consciousness",
      "isCharacter": true
    },
    {
      "id": 734,
      "bciAvId": 21040,
      "gloss": "grace, grace of God",
      "glossSv": "nåd",
      "pos": "noun",
      "explanation": "pointer (left) + God + pointer (right): suggesting the grace radiating from God",
      "isCharacter": true
    },
    {
      "id": 735,
      "bciAvId": 21044,
      "gloss": "spirit",
      "glossSv": "ande",
      "pos": "noun",
      "explanation": "feeling + to be: a feeling of being: a vital force, traditionally believed to be within living beings",
      "isCharacter": true
    },
    {
      "id": 736,
      "bciAvId": 21054,
      "gloss": "leader, director, guide, coach (1)",
      "glossSv": "ledare (1), chef",
      "pos": "person",
      "explanation": "person + leadership,guidance",
      "isCharacter": true
    },
    {
      "id": 737,
      "bciAvId": 21061,
      "gloss": "horn(s), antler(s)",
      "glossSv": "horn",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 738,
      "bciAvId": 21082,
      "gloss": "holiness",
      "glossSv": "helighet, gloria",
      "pos": "noun",
      "explanation": "pictograph: the symbol suggests a halo",
      "isCharacter": true
    },
    {
      "id": 739,
      "bciAvId": 21090,
      "gloss": "single parent",
      "glossSv": "ensamstående förälder",
      "pos": "person",
      "explanation": "parent + protection: one parent who offers protection to a child or children",
      "isCharacter": true
    },
    {
      "id": 740,
      "bciAvId": 21091,
      "gloss": "single mother",
      "glossSv": "ensamstående mamma",
      "pos": "person",
      "explanation": "mother + protection",
      "isCharacter": true
    },
    {
      "id": 741,
      "bciAvId": 21092,
      "gloss": "single father",
      "glossSv": "ensamstående pappa",
      "pos": "person",
      "explanation": "father + protection",
      "isCharacter": true
    },
    {
      "id": 742,
      "bciAvId": 21093,
      "gloss": "single parent family",
      "glossSv": "familj med en förälder",
      "pos": "person",
      "explanation": "single parent + star: family consisting of a single parent and a child or children",
      "isCharacter": true
    },
    {
      "id": 743,
      "bciAvId": 21098,
      "gloss": "insight",
      "glossSv": "insikt",
      "pos": "noun",
      "explanation": "to see + world: to be able to see the world as it is",
      "isCharacter": true
    },
    {
      "id": 744,
      "bciAvId": 21116,
      "gloss": "coffin",
      "glossSv": "kista",
      "pos": "noun",
      "explanation": "enclosure [modification, rectangular] + reclining,lying (person lying down) [modification, higher position, shortened line for feet]",
      "isCharacter": true
    },
    {
      "id": 745,
      "bciAvId": 21282,
      "gloss": "vase, urn, trophy cup",
      "glossSv": "vas, urna, pokal",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 746,
      "bciAvId": 21297,
      "gloss": "mystery, unknown",
      "glossSv": "gåta, mysterium, oförklarlighet",
      "pos": "noun",
      "explanation": "knowledge + what,question mark: something known, but not fully understood",
      "isCharacter": true
    },
    {
      "id": 747,
      "bciAvId": 21363,
      "gloss": "goblet, wineglass",
      "glossSv": "bägare, vinglas",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 748,
      "bciAvId": 21540,
      "gloss": "cell",
      "glossSv": "cell",
      "pos": "noun",
      "explanation": "pictograph, of circular cell + being (state of): the symbol suggests a cell, with the symbol for to live [half-sized] as a cell nucleus in it",
      "isCharacter": true
    },
    {
      "id": 749,
      "bciAvId": 21541,
      "gloss": "Euro",
      "glossSv": "euro",
      "pos": "noun",
      "explanation": "international symbol for Euro",
      "isCharacter": true
    },
    {
      "id": 750,
      "bciAvId": 21589,
      "gloss": "therapy",
      "glossSv": "terapi",
      "pos": "noun",
      "explanation": "need (needy person) + need [modification, mirrored]: mutual aid",
      "isCharacter": true
    },
    {
      "id": 751,
      "bciAvId": 21607,
      "gloss": "view of life",
      "glossSv": "livssyn",
      "pos": "noun",
      "explanation": "mind + activity: how people think or act",
      "isCharacter": true
    },
    {
      "id": 752,
      "bciAvId": 21623,
      "gloss": "cap",
      "glossSv": "keps",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 753,
      "bciAvId": 21624,
      "gloss": "bliss-name",
      "glossSv": "blissnamn",
      "pos": "noun",
      "explanation": "name + Blissymbol: combination of name and Blissymbol",
      "isCharacter": true
    },
    {
      "id": 754,
      "bciAvId": 21807,
      "gloss": "rugby ball, football (N.A.)",
      "glossSv": "rugbyboll",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 755,
      "bciAvId": 21809,
      "gloss": "wicket",
      "glossSv": "kricketgrind",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 756,
      "bciAvId": 21813,
      "gloss": "prone board, scooter-board",
      "glossSv": "rullbräda, magrullbräda",
      "pos": "noun",
      "explanation": "vehicle [modification, horizontal line replaced by board] + board [modification, higer position] [combination]: Vehicles have different names in different countries.",
      "isCharacter": true
    },
    {
      "id": 757,
      "bciAvId": 21820,
      "gloss": "stander (wheeled)",
      "glossSv": "stårullstol",
      "pos": "noun",
      "explanation": "wheel + standing (standing person)",
      "isCharacter": true
    },
    {
      "id": 758,
      "bciAvId": 21841,
      "gloss": "relay",
      "glossSv": "stafett",
      "pos": "noun",
      "explanation": "to stop + to start",
      "isCharacter": true
    },
    {
      "id": 759,
      "bciAvId": 21849,
      "gloss": "chain",
      "glossSv": "kedja",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 760,
      "bciAvId": 21855,
      "gloss": "bow and arrow",
      "glossSv": "pil och båge",
      "pos": "noun",
      "explanation": "curve,curved line + forward: pictograph, suggesting a bow and arrow",
      "isCharacter": true
    },
    {
      "id": 761,
      "bciAvId": 21880,
      "gloss": "wave",
      "glossSv": "våg (vatten)",
      "pos": "noun",
      "explanation": "water + pointer, to wave",
      "isCharacter": true
    },
    {
      "id": 762,
      "bciAvId": 22059,
      "gloss": "mast",
      "glossSv": "mast",
      "pos": "noun",
      "explanation": "sail + pointer, to the mast",
      "isCharacter": true
    },
    {
      "id": 763,
      "bciAvId": 22060,
      "gloss": "boom",
      "glossSv": "bom",
      "pos": "noun",
      "explanation": "sail + pointer, to the boom",
      "isCharacter": true
    },
    {
      "id": 764,
      "bciAvId": 22061,
      "gloss": "deck",
      "glossSv": "däck (på båt)",
      "pos": "noun",
      "explanation": "boat + pointer, to the deck",
      "isCharacter": true
    },
    {
      "id": 765,
      "bciAvId": 22062,
      "gloss": "bow, fore",
      "glossSv": "för",
      "pos": "noun",
      "explanation": "boat + pointer, to the bow",
      "isCharacter": true
    },
    {
      "id": 766,
      "bciAvId": 22063,
      "gloss": "stern",
      "glossSv": "akter",
      "pos": "noun",
      "explanation": "boat + pointer, to the stern",
      "isCharacter": true
    },
    {
      "id": 767,
      "bciAvId": 22064,
      "gloss": "keel",
      "glossSv": "köl",
      "pos": "noun",
      "explanation": "boat + pointer, to the keel",
      "isCharacter": true
    },
    {
      "id": 768,
      "bciAvId": 22065,
      "gloss": "hull, body",
      "glossSv": "skrov",
      "pos": "noun",
      "explanation": "boat + pointer, to the hull",
      "isCharacter": true
    },
    {
      "id": 769,
      "bciAvId": 22066,
      "gloss": "rudder",
      "glossSv": "roder",
      "pos": "noun",
      "explanation": "boat + pictograph, of rudder",
      "isCharacter": true
    },
    {
      "id": 770,
      "bciAvId": 22067,
      "gloss": "paddle, oar",
      "glossSv": "paddel, åra",
      "pos": "noun",
      "explanation": "water (ground level) + pictograph, of paddle in water",
      "isCharacter": true
    },
    {
      "id": 771,
      "bciAvId": 22068,
      "gloss": "paddle (two blades)",
      "glossSv": "paddel med två blad",
      "pos": "noun",
      "explanation": "water (ground level) + pictograph, of paddle with two blades in water",
      "isCharacter": true
    },
    {
      "id": 772,
      "bciAvId": 22069,
      "gloss": "freighter",
      "glossSv": "fraktfartyg",
      "pos": "noun",
      "explanation": "boat + thing [modification, higher position]: boat carrying goods",
      "isCharacter": true
    },
    {
      "id": 773,
      "bciAvId": 22105,
      "gloss": "parachute",
      "glossSv": "fallskärm",
      "pos": "noun",
      "explanation": "from sky + pictograph, of the parachute canopy",
      "isCharacter": true
    },
    {
      "id": 774,
      "bciAvId": 22107,
      "gloss": "balloon (hot air)",
      "glossSv": "luftballong, varmluftsballong",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 775,
      "bciAvId": 22116,
      "gloss": "indoor (character)",
      "glossSv": "inomhustecken",
      "pos": "noun",
      "explanation": "house + dot (inside the house): can also be seen as a combination of house and inside",
      "isCharacter": true
    },
    {
      "id": 776,
      "bciAvId": 22307,
      "gloss": "pudding, cream",
      "glossSv": "pudding, kräm, gröt",
      "pos": "noun",
      "explanation": "plate + pictograph of pudding",
      "isCharacter": true
    },
    {
      "id": 777,
      "bciAvId": 22362,
      "gloss": "lump(s)",
      "glossSv": "klump, klumpar",
      "pos": "noun",
      "explanation": "four dots (two in high and two in low positions): indicating bits from thing",
      "isCharacter": true
    },
    {
      "id": 778,
      "bciAvId": 22365,
      "gloss": "lollipop, sucker",
      "glossSv": "klubba (godis)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 779,
      "bciAvId": 22366,
      "gloss": "ice cream (lollipop)",
      "glossSv": "glass (pinne)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 780,
      "bciAvId": 22369,
      "gloss": "ice cream, sherbet, sorbet",
      "glossSv": "glass, sorbet",
      "pos": "noun",
      "explanation": "ice cream cone + pointer, to the ice cream",
      "isCharacter": true
    },
    {
      "id": 781,
      "bciAvId": 22371,
      "gloss": "bar, cake",
      "glossSv": "kaka",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 782,
      "bciAvId": 22375,
      "gloss": "candy",
      "glossSv": "karamell, kola",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 783,
      "bciAvId": 22377,
      "gloss": "mixture",
      "glossSv": "blandning",
      "pos": "noun",
      "explanation": "two curved arrows mingling",
      "isCharacter": true
    },
    {
      "id": 784,
      "bciAvId": 22384,
      "gloss": "reflection",
      "glossSv": "reflektion",
      "pos": "noun",
      "explanation": "arrow (bent) + vertical line: a ray of light strikes a mirror and is reflected back from it",
      "isCharacter": true
    },
    {
      "id": 785,
      "bciAvId": 22386,
      "gloss": "shine",
      "glossSv": "glans, sken",
      "pos": "noun",
      "explanation": "reflection + arrow (bent) [modification, flipped vertically]",
      "isCharacter": true
    },
    {
      "id": 786,
      "bciAvId": 22561,
      "gloss": "kitchen tool, utensil",
      "glossSv": "köksredskap (i sammansättningar)",
      "pos": "noun",
      "explanation": "hand + food [modification]: tool for food]",
      "isCharacter": true
    },
    {
      "id": 787,
      "bciAvId": 22574,
      "gloss": "funnel",
      "glossSv": "tratt",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 788,
      "bciAvId": 22577,
      "gloss": "stovetop",
      "glossSv": "spishäll",
      "pos": "noun",
      "explanation": "stove + pointer, to the top",
      "isCharacter": true
    },
    {
      "id": 789,
      "bciAvId": 22578,
      "gloss": "cup",
      "glossSv": "kopp",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 790,
      "bciAvId": 22579,
      "gloss": "saucepan",
      "glossSv": "såskastrull",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 791,
      "bciAvId": 22583,
      "gloss": "lid",
      "glossSv": "lock",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 792,
      "bciAvId": 22584,
      "gloss": "pot, kettle, boiler",
      "glossSv": "gryta, kittel",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 793,
      "bciAvId": 22592,
      "gloss": "rolling pin",
      "glossSv": "kavel",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 794,
      "bciAvId": 22598,
      "gloss": "equator",
      "glossSv": "ekvatorn",
      "pos": "noun",
      "explanation": "earth + pointer, to the equator",
      "isCharacter": true
    },
    {
      "id": 795,
      "bciAvId": 22599,
      "gloss": "South Pole",
      "glossSv": "Sydpolen",
      "pos": "noun",
      "explanation": "earth + pointer, to the south pole",
      "isCharacter": true
    },
    {
      "id": 796,
      "bciAvId": 22600,
      "gloss": "North Pole",
      "glossSv": "Nordpolen",
      "pos": "noun",
      "explanation": "earth + pointer, to the north pole",
      "isCharacter": true
    },
    {
      "id": 797,
      "bciAvId": 22613,
      "gloss": "fjord",
      "glossSv": "fjord",
      "pos": "noun",
      "explanation": "water (ground level) + mountain: a long and narrow inlet of the sea in between steep mountains",
      "isCharacter": true
    },
    {
      "id": 798,
      "bciAvId": 22618,
      "gloss": "crown",
      "glossSv": "krona",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 799,
      "bciAvId": 22625,
      "gloss": "inlet",
      "glossSv": "sund (vatten)",
      "pos": "noun",
      "explanation": "earth + water (ground level) + earth: an arm of water reaching into land",
      "isCharacter": true
    },
    {
      "id": 800,
      "bciAvId": 22834,
      "gloss": "planet",
      "glossSv": "planet",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests the planet rotating on its horizontal axis",
      "isCharacter": true
    },
    {
      "id": 801,
      "bciAvId": 22837,
      "gloss": "pod, seedcase, seedpod",
      "glossSv": "fröskida",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 802,
      "bciAvId": 22911,
      "gloss": "doubt, uncertainty",
      "glossSv": "undran, tvivel, osäkerhet",
      "pos": "noun",
      "explanation": "to think + what,question mark",
      "isCharacter": true
    },
    {
      "id": 803,
      "bciAvId": 22913,
      "gloss": "leadership, guidance",
      "glossSv": "ledarskap, ledning",
      "pos": "noun",
      "explanation": "mind + forward [modification, short arrow]: the use of mental powers to carry events or persons forward",
      "isCharacter": true
    },
    {
      "id": 804,
      "bciAvId": 22914,
      "gloss": "must, force - (a)",
      "glossSv": "tvång",
      "pos": "noun",
      "explanation": "mind + strong [modification]: the use of the power of the mind, and/or physical strength, to make something happen",
      "isCharacter": true
    },
    {
      "id": 805,
      "bciAvId": 23026,
      "gloss": "attic",
      "glossSv": "vind (hus)",
      "pos": "noun",
      "explanation": "building with attic + pointer, to the attic",
      "isCharacter": true
    },
    {
      "id": 806,
      "bciAvId": 23029,
      "gloss": "basement, cellar",
      "glossSv": "källare",
      "pos": "noun",
      "explanation": "building with cellar + pointer, to cellar",
      "isCharacter": true
    },
    {
      "id": 807,
      "bciAvId": 23044,
      "gloss": "cod, codfish",
      "glossSv": "torsk",
      "pos": "noun",
      "explanation": "fish + pictograph of beard",
      "isCharacter": true
    },
    {
      "id": 808,
      "bciAvId": 23085,
      "gloss": "floor, storey, level, etage",
      "glossSv": "våning",
      "pos": "noun",
      "explanation": "building with storey + pointer",
      "isCharacter": true
    },
    {
      "id": 809,
      "bciAvId": 23089,
      "gloss": "foundation (building)",
      "glossSv": "husgrund",
      "pos": "noun",
      "explanation": "building with foundation + pointer (to foundation)",
      "isCharacter": true
    },
    {
      "id": 810,
      "bciAvId": 23097,
      "gloss": "goat",
      "glossSv": "get",
      "pos": "noun",
      "explanation": "ovine + pictograph of beard",
      "isCharacter": true
    },
    {
      "id": 811,
      "bciAvId": 23117,
      "gloss": "horizontal - (a)",
      "glossSv": "horisontallinje",
      "pos": "noun",
      "explanation": "right angle + pointer to horizontal arm of angle",
      "isCharacter": true
    },
    {
      "id": 812,
      "bciAvId": 23124,
      "gloss": "jellyfish",
      "glossSv": "manet",
      "pos": "noun",
      "explanation": "water creature + pictograph of jellyfish tentacles",
      "isCharacter": true
    },
    {
      "id": 813,
      "bciAvId": 23127,
      "gloss": "judgement, law (in combinations)",
      "glossSv": "juridik (i kombinationer)",
      "pos": "noun",
      "explanation": "mind + weight [modification, shorter horizontal line]: the mind weighs something to reach a judgement",
      "isCharacter": true
    },
    {
      "id": 814,
      "bciAvId": 23150,
      "gloss": "metal bar",
      "glossSv": "metall (stång, tacka)",
      "pos": "noun",
      "explanation": "thing + thing: a combination of rectangular shape + thing",
      "isCharacter": true
    },
    {
      "id": 815,
      "bciAvId": 23169,
      "gloss": "pressure",
      "glossSv": "tryck",
      "pos": "noun",
      "explanation": "enclosure + up and down: the arrows press against the top and bottom of the enclosure",
      "isCharacter": true
    },
    {
      "id": 816,
      "bciAvId": 23193,
      "gloss": "row house, attached houses",
      "glossSv": "radhus",
      "pos": "noun",
      "explanation": "semi-detached house + semi-detached house: pictograph of attached houses",
      "isCharacter": true
    },
    {
      "id": 817,
      "bciAvId": 23201,
      "gloss": "semi-detached house",
      "glossSv": "parhus",
      "pos": "noun",
      "explanation": "house + line: the line separating the building into two parts, creating a pictograph of a semi-detached house",
      "isCharacter": true
    },
    {
      "id": 818,
      "bciAvId": 23204,
      "gloss": "shellfish (without claws)",
      "glossSv": "skaldjur utan klor",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 819,
      "bciAvId": 23223,
      "gloss": "store, shop",
      "glossSv": "affär, butik",
      "pos": "noun",
      "explanation": "public room + business: public room where money is exchanged for goods",
      "isCharacter": true
    },
    {
      "id": 820,
      "bciAvId": 23230,
      "gloss": "tax",
      "glossSv": "skatt",
      "pos": "noun",
      "explanation": "money + leadership: money + to govern [contraction]",
      "isCharacter": true
    },
    {
      "id": 821,
      "bciAvId": 23240,
      "gloss": "tower",
      "glossSv": "torn",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 822,
      "bciAvId": 23250,
      "gloss": "vertical - (a)",
      "glossSv": "lodlinje",
      "pos": "noun",
      "explanation": "right angle + pointer, to vertical arm of angle",
      "isCharacter": true
    },
    {
      "id": 823,
      "bciAvId": 23409,
      "gloss": "attachment, fastening, joint, seam, appendix, annex",
      "glossSv": "bilaga, sammansättning, tillbehör",
      "pos": "noun",
      "explanation": "vertical line + plus + vertical line: representing something attached to something else",
      "isCharacter": true
    },
    {
      "id": 824,
      "bciAvId": 23431,
      "gloss": "card",
      "glossSv": "kort (bank- etc)",
      "pos": "noun",
      "explanation": "pictograph: horizontally oriented rectangle representing a lying card",
      "isCharacter": true
    },
    {
      "id": 825,
      "bciAvId": 23437,
      "gloss": "castle, palace",
      "glossSv": "slott",
      "pos": "noun",
      "explanation": "tower [modification] + house [modification] + tower [modification]: pictograph suggests a castle as a combination of house and towers",
      "isCharacter": true
    },
    {
      "id": 826,
      "bciAvId": 23439,
      "gloss": "causality",
      "glossSv": "orsakssammanhang",
      "pos": "noun",
      "explanation": "mind + cause: mental reflection on cause and effect",
      "isCharacter": true
    },
    {
      "id": 827,
      "bciAvId": 23472,
      "gloss": "Dharma wheel",
      "glossSv": "dharmahjulet",
      "pos": "noun",
      "explanation": "wheel [modification, to full size]: forms a pictograph of a big wheel with spokes, used as a symbol in Buddhism",
      "isCharacter": true
    },
    {
      "id": 828,
      "bciAvId": 23475,
      "gloss": "digital processing, artificial intelligence, calculation",
      "glossSv": "artificiell intelligens, AI, digital intelligens",
      "pos": "noun",
      "explanation": "mind + digits (computer)",
      "isCharacter": true
    },
    {
      "id": 829,
      "bciAvId": 23476,
      "gloss": "digits (computer)",
      "glossSv": "digitala siffror, binärtal",
      "pos": "expression",
      "explanation": "quarter-sized vertical line + quarter-sized circle: representing the two digits 1 and 0",
      "isCharacter": true
    },
    {
      "id": 830,
      "bciAvId": 23477,
      "gloss": "dinosaur",
      "glossSv": "dinosaurie",
      "pos": "noun",
      "explanation": "animal + pictograph of dinosaur head and tail",
      "isCharacter": true
    },
    {
      "id": 831,
      "bciAvId": 23488,
      "gloss": "enter (computer)",
      "glossSv": "enter (dator), retur",
      "pos": "noun",
      "explanation": "backward + short vertical line: pictograph, looks like the enter symbol on a computer keyboard",
      "isCharacter": true
    },
    {
      "id": 832,
      "bciAvId": 23500,
      "gloss": "file, data file (digital)",
      "glossSv": "fil (dator)",
      "pos": "noun",
      "explanation": "container + digits (computer)",
      "isCharacter": true
    },
    {
      "id": 833,
      "bciAvId": 23511,
      "gloss": "folder",
      "glossSv": "mapp, dokumentmapp",
      "pos": "noun",
      "explanation": "pictograph: looks like a paper folder, or a folder icon on a computer",
      "isCharacter": true
    },
    {
      "id": 834,
      "bciAvId": 23527,
      "gloss": "hedgehog",
      "glossSv": "igelkott",
      "pos": "noun",
      "explanation": "animal + quill(s),spine(s): pictograph of animal with spines",
      "isCharacter": true
    },
    {
      "id": 835,
      "bciAvId": 23542,
      "gloss": "information",
      "glossSv": "information",
      "pos": "noun",
      "explanation": "mind + up,upward: upward arrow, bringing information into the mind",
      "isCharacter": true
    },
    {
      "id": 836,
      "bciAvId": 23550,
      "gloss": "jump",
      "glossSv": "hopp, skutt",
      "pos": "noun",
      "explanation": "curved line + arrowhead: curved arrow, forward, indicating the path of a jump",
      "isCharacter": true
    },
    {
      "id": 837,
      "bciAvId": 23576,
      "gloss": "make-believe man",
      "glossSv": "övernaturligt manligt väsen",
      "pos": "person",
      "explanation": "man + fantasy,phantasy,imagination,illusion",
      "isCharacter": true
    },
    {
      "id": 838,
      "bciAvId": 23577,
      "gloss": "make-believe person, imaginary person",
      "glossSv": "övernaturligt väsen, fantasifigur",
      "pos": "person",
      "explanation": "person + fantasy,phantasy,imagination,illusion",
      "isCharacter": true
    },
    {
      "id": 839,
      "bciAvId": 23581,
      "gloss": "make-believe woman",
      "glossSv": "övernaturligt kvinnligt väsen",
      "pos": "person",
      "explanation": "woman + fantasy,phantasy,imagination,illusion",
      "isCharacter": true
    },
    {
      "id": 840,
      "bciAvId": 23583,
      "gloss": "making, production, fashioning",
      "glossSv": "tillverkning, produktion",
      "pos": "noun",
      "explanation": "creation [modification, half height]: imperfect version of creation, represents man-made",
      "isCharacter": true
    },
    {
      "id": 841,
      "bciAvId": 23589,
      "gloss": "memory",
      "glossSv": "minne",
      "pos": "noun",
      "explanation": "knowledge + dot (inside the knowledge): can also be seen as a combination of knowledge and inside",
      "isCharacter": true
    },
    {
      "id": 842,
      "bciAvId": 23599,
      "gloss": "oval",
      "glossSv": "ovalform",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 843,
      "bciAvId": 23603,
      "gloss": "pancake, crepe, tortilla",
      "glossSv": "pannkaka, crêpe, tortilla",
      "pos": "noun",
      "explanation": "dish + horizontal line [low, in the dish]",
      "isCharacter": true
    },
    {
      "id": 844,
      "bciAvId": 23619,
      "gloss": "pointing",
      "glossSv": "pekare",
      "pos": "noun",
      "explanation": "hand [modification, on its side, as if pointing]",
      "isCharacter": true
    },
    {
      "id": 845,
      "bciAvId": 23627,
      "gloss": "quill(s), spine(s)",
      "glossSv": "taggar, piggar",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 846,
      "bciAvId": 23629,
      "gloss": "ramp",
      "glossSv": "ramp",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 847,
      "bciAvId": 23658,
      "gloss": "seaweed",
      "glossSv": "sjögräs, tång",
      "pos": "noun",
      "explanation": "water (ground level) + grass: representing plants growing in water",
      "isCharacter": true
    },
    {
      "id": 848,
      "bciAvId": 23673,
      "gloss": "tabletop",
      "glossSv": "bordsskiva",
      "pos": "noun",
      "explanation": "table + pointer to the top",
      "isCharacter": true
    },
    {
      "id": 849,
      "bciAvId": 23690,
      "gloss": "track",
      "glossSv": "spår, räls",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 850,
      "bciAvId": 23702,
      "gloss": "unicorn",
      "glossSv": "enhörning",
      "pos": "noun",
      "explanation": "horse + pictograph of a single horn",
      "isCharacter": true
    },
    {
      "id": 851,
      "bciAvId": 23706,
      "gloss": "water creature",
      "glossSv": "vattendjur",
      "pos": "noun",
      "explanation": "water (ground level) + arc: pictograph that could be associated with smooth water creatures: Used in conjunction with a specifier.",
      "isCharacter": true
    },
    {
      "id": 852,
      "bciAvId": 23803,
      "gloss": "alto",
      "glossSv": "altstämma, alt",
      "pos": "noun",
      "explanation": "stave + pointer, to alto position in stave",
      "isCharacter": true
    },
    {
      "id": 853,
      "bciAvId": 23809,
      "gloss": "bass",
      "glossSv": "basstämma, bas",
      "pos": "noun",
      "explanation": "stave + pointer, to bass position in stave",
      "isCharacter": true
    },
    {
      "id": 854,
      "bciAvId": 23817,
      "gloss": "bow, arc",
      "glossSv": "båge, valv",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 855,
      "bciAvId": 23818,
      "gloss": "bow (musical instrument)",
      "glossSv": "stråke",
      "pos": "noun",
      "explanation": "bow and string (musical) + pointer, to bow",
      "isCharacter": true
    },
    {
      "id": 856,
      "bciAvId": 23819,
      "gloss": "bow and string (musical)",
      "glossSv": "stråke och sträng",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 857,
      "bciAvId": 23833,
      "gloss": "celeriac, celery",
      "glossSv": "rotselleri, selleri",
      "pos": "noun",
      "explanation": "celery [modification, upper part] + vegetable (below ground) [modification, lower part] [combination]: pictograph",
      "isCharacter": true
    },
    {
      "id": 858,
      "bciAvId": 23839,
      "gloss": "condensation",
      "glossSv": "kondens, imma",
      "pos": "noun",
      "explanation": "seven dots + liquid: the symbol suggests droplets converting into liquid",
      "isCharacter": true
    },
    {
      "id": 859,
      "bciAvId": 23854,
      "gloss": "drum (1)",
      "glossSv": "trumma (1)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 860,
      "bciAvId": 23859,
      "gloss": "dryness, drought",
      "glossSv": "torka, torrhet",
      "pos": "noun",
      "explanation": "water + to delete",
      "isCharacter": true
    },
    {
      "id": 861,
      "bciAvId": 23871,
      "gloss": "flute, recorder",
      "glossSv": "flöjt",
      "pos": "noun",
      "explanation": "pipe,hose,tube (2) + dot + dot (high position): pictograph",
      "isCharacter": true
    },
    {
      "id": 862,
      "bciAvId": 23872,
      "gloss": "flute, transverse flute",
      "glossSv": "flöjt, tvärflöjt",
      "pos": "noun",
      "explanation": "pipe,hose,tube (1) + dot + dot: pictograph",
      "isCharacter": true
    },
    {
      "id": 863,
      "bciAvId": 23886,
      "gloss": "humidity",
      "glossSv": "fukt, fuktighet",
      "pos": "noun",
      "explanation": "air + water",
      "isCharacter": true
    },
    {
      "id": 864,
      "bciAvId": 23892,
      "gloss": "keyboard",
      "glossSv": "klaviatur, keyboard",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 865,
      "bciAvId": 23904,
      "gloss": "musical instrument (in combinations)",
      "glossSv": "musikinstrument (i kombinationer)",
      "pos": "noun",
      "explanation": "thing + musical note: Used as classifier to create Bliss-words denoting musical instruments.",
      "isCharacter": true
    },
    {
      "id": 866,
      "bciAvId": 23926,
      "gloss": "pipe, hose, tube (2)",
      "glossSv": "rör, slang (2)",
      "pos": "noun",
      "explanation": "pictograph: vertical orientation",
      "isCharacter": true
    },
    {
      "id": 867,
      "bciAvId": 23927,
      "gloss": "pipe, tube (closed)",
      "glossSv": "tub",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 868,
      "bciAvId": 23929,
      "gloss": "pitch (sound)",
      "glossSv": "tonhöjd, stämma (allmän)",
      "pos": "noun",
      "explanation": "stave,staff + pointer",
      "isCharacter": true
    },
    {
      "id": 869,
      "bciAvId": 23942,
      "gloss": "reed",
      "glossSv": "rörblad",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 870,
      "bciAvId": 23952,
      "gloss": "soprano",
      "glossSv": "sopranstämma, sopran",
      "pos": "noun",
      "explanation": "stave + pointer, to soprano position in stave",
      "isCharacter": true
    },
    {
      "id": 871,
      "bciAvId": 23955,
      "gloss": "stave, staff",
      "glossSv": "notplan, notlinjer",
      "pos": "noun",
      "explanation": "pictograph: five half-sized horizontal lines, as in a stave for musical notation",
      "isCharacter": true
    },
    {
      "id": 872,
      "bciAvId": 23958,
      "gloss": "string",
      "glossSv": "sträng",
      "pos": "noun",
      "explanation": "line + pointer, to the line",
      "isCharacter": true
    },
    {
      "id": 873,
      "bciAvId": 23959,
      "gloss": "string (for musical instrument)",
      "glossSv": "sträng (på musikinstrument)",
      "pos": "noun",
      "explanation": "bow and string (musical) + pointer, to string",
      "isCharacter": true
    },
    {
      "id": 874,
      "bciAvId": 23966,
      "gloss": "tenor",
      "glossSv": "tenorstämma, tenor",
      "pos": "noun",
      "explanation": "stave + pointer, to tenor position in stave",
      "isCharacter": true
    },
    {
      "id": 875,
      "bciAvId": 24015,
      "gloss": "asparagus",
      "glossSv": "sparris",
      "pos": "noun",
      "explanation": "root(s) + line,stripe: the line representing a modified stalk of asparagus, pictograph",
      "isCharacter": true
    },
    {
      "id": 876,
      "bciAvId": 24051,
      "gloss": "chairman",
      "glossSv": "ordförande",
      "pos": "person",
      "explanation": "leader + meeting [modification, short arrows] [combination]",
      "isCharacter": true
    },
    {
      "id": 877,
      "bciAvId": 24098,
      "gloss": "existence, being (1)",
      "glossSv": "tillvaro, existens (1)",
      "pos": "noun",
      "explanation": "life + world",
      "isCharacter": true
    },
    {
      "id": 878,
      "bciAvId": 24120,
      "gloss": "foundation, base, fundament",
      "glossSv": "grund, bas",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 879,
      "bciAvId": 24155,
      "gloss": "hoof",
      "glossSv": "hov, klöv",
      "pos": "noun",
      "explanation": "horse + pointer, to hoof",
      "isCharacter": true
    },
    {
      "id": 880,
      "bciAvId": 24176,
      "gloss": "kidney",
      "glossSv": "njure",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 881,
      "bciAvId": 24196,
      "gloss": "muzzle",
      "glossSv": "mule, nos",
      "pos": "noun",
      "explanation": "horse + pointer, to muzzle",
      "isCharacter": true
    },
    {
      "id": 882,
      "bciAvId": 24198,
      "gloss": "navel",
      "glossSv": "navel",
      "pos": "noun",
      "explanation": "body with navel + pointer, to navel",
      "isCharacter": true
    },
    {
      "id": 883,
      "bciAvId": 24210,
      "gloss": "personality",
      "glossSv": "personlighet, utstrålning",
      "pos": "noun",
      "explanation": "pointer (left) + person + pointer (right): suggesting the charisma radiating from a person",
      "isCharacter": true
    },
    {
      "id": 884,
      "bciAvId": 24214,
      "gloss": "platform, stage",
      "glossSv": "plattform, scen (etc)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 885,
      "bciAvId": 24216,
      "gloss": "politics",
      "glossSv": "politik",
      "pos": "noun",
      "explanation": "leadership + say,speak,talk,tell,express-(to): combination of opinion and to lead",
      "isCharacter": true
    },
    {
      "id": 886,
      "bciAvId": 24240,
      "gloss": "responsibility",
      "glossSv": "ansvar",
      "pos": "noun",
      "explanation": "conscience + other",
      "isCharacter": true
    },
    {
      "id": 887,
      "bciAvId": 24249,
      "gloss": "rotation, circulation, orbit, lap, circle, round",
      "glossSv": "rotation, cirkulation, omloppsbana, runda, varv",
      "pos": "noun",
      "explanation": "curved line + arrowhead: curved arrow suggesting circular motion",
      "isCharacter": true
    },
    {
      "id": 888,
      "bciAvId": 24272,
      "gloss": "somersault",
      "glossSv": "kullerbytta (1)",
      "pos": "noun",
      "explanation": "rotation + ground",
      "isCharacter": true
    },
    {
      "id": 889,
      "bciAvId": 24281,
      "gloss": "square (public)",
      "glossSv": "torg",
      "pos": "noun",
      "explanation": "buildings with courtyard + pointer, to courtyard",
      "isCharacter": true
    },
    {
      "id": 890,
      "bciAvId": 24302,
      "gloss": "tadpole",
      "glossSv": "grodyngel",
      "pos": "noun",
      "explanation": "pictograph: the symbol also incorporates water",
      "isCharacter": true
    },
    {
      "id": 891,
      "bciAvId": 24309,
      "gloss": "that (conjunction)",
      "glossSv": "att",
      "pos": "expression",
      "explanation": "ideograph: “…indicates a halt and afterwards a free flow” [C.K. Bliss, Semantography. p. 449]",
      "isCharacter": true
    },
    {
      "id": 892,
      "bciAvId": 24332,
      "gloss": "vehicle (long)",
      "glossSv": "fordon (långt), vagn",
      "pos": "noun",
      "explanation": "vehicle [modification, lengthened] + wheel: pictograph of a long vehicle that does not operate under its own power",
      "isCharacter": true
    },
    {
      "id": 893,
      "bciAvId": 24422,
      "gloss": "bump, press, pressing",
      "glossSv": "stöt",
      "pos": "noun",
      "explanation": "down,downward + earth,ground,land",
      "isCharacter": true
    },
    {
      "id": 894,
      "bciAvId": 24443,
      "gloss": "being (state of)",
      "glossSv": "tillvaro, existens (2)",
      "pos": "noun",
      "explanation": "life [half sized]",
      "isCharacter": true
    },
    {
      "id": 895,
      "bciAvId": 24445,
      "gloss": "failure",
      "glossSv": "misslyckande",
      "pos": "noun",
      "explanation": "success + stop",
      "isCharacter": true
    },
    {
      "id": 896,
      "bciAvId": 24451,
      "gloss": "galaxy",
      "glossSv": "galax",
      "pos": "noun",
      "explanation": "sun + star: the sun here representing a circular gathering of stars",
      "isCharacter": true
    },
    {
      "id": 897,
      "bciAvId": 24482,
      "gloss": "mental illness",
      "glossSv": "mental sjukdom",
      "pos": "noun",
      "explanation": "illness + mind",
      "isCharacter": true
    },
    {
      "id": 898,
      "bciAvId": 24515,
      "gloss": "substance, element",
      "glossSv": "substans, ämne",
      "pos": "noun",
      "explanation": "material + dot, in the material: can also be seen as a combination of material and in [modification, half-sized]; what is in a material",
      "isCharacter": true
    },
    {
      "id": 899,
      "bciAvId": 24518,
      "gloss": "tile",
      "glossSv": "spelbricka",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 900,
      "bciAvId": 24605,
      "gloss": "Earth axis, axis",
      "glossSv": "jordaxel",
      "pos": "noun",
      "explanation": "earth,globe,world + pointer [modification, at an angle], to the axis of the earth",
      "isCharacter": true
    },
    {
      "id": 901,
      "bciAvId": 24638,
      "gloss": "digital device",
      "glossSv": "digital enhet, digital apparat",
      "pos": "noun",
      "explanation": "enclosure + digits (computer)",
      "isCharacter": true
    },
    {
      "id": 902,
      "bciAvId": 24665,
      "gloss": "indicator (adverb)",
      "glossSv": "operator (adverb)",
      "pos": "function",
      "explanation": "indicator (description) + indicator (action): may be placed above a symbol to show that it is representing an adverb in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 903,
      "bciAvId": 28043,
      "gloss": "indicator (continuous form)",
      "glossSv": "operator (pågående handling)",
      "pos": "function",
      "explanation": "horizontal line [quarter-sized]: may be placed above a symbol to show that it is representing a verb in continuous form in a natural language.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 904,
      "bciAvId": 24667,
      "gloss": "indicator (definite form)",
      "glossSv": "operator (bestämd form)",
      "pos": "function",
      "explanation": "the [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in definite form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 905,
      "bciAvId": 24668,
      "gloss": "indicator (female)",
      "glossSv": "operator (femininum)",
      "pos": "function",
      "explanation": "female (gender) [quarter-sized]: may be placed above a symbol to show that it is representing a word in feminine form in a natural language (male = unmarked). Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 906,
      "bciAvId": 24669,
      "gloss": "indicator (first person)",
      "glossSv": "operator (första person)",
      "pos": "function",
      "explanation": "one (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in first person form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 907,
      "bciAvId": 24670,
      "gloss": "indicator (imperative form)",
      "glossSv": "operator (imperativ)",
      "pos": "function",
      "explanation": "exclamation mark [quarter-sized]: may be placed above a symbol to show that it is representing a verb in imperative form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 908,
      "bciAvId": 24671,
      "gloss": "indicator (indefinite form)",
      "glossSv": "operator (obestämd form)",
      "pos": "function",
      "explanation": "a,an,any [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in indefinite form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 909,
      "bciAvId": 24672,
      "gloss": "indicator (neutral)",
      "glossSv": "operator (neutrum)",
      "pos": "function",
      "explanation": "vertical line [quarter-sized]: may be placed above a symbol to show that it is representing a word in neutral form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 910,
      "bciAvId": 24673,
      "gloss": "indicator (object form)",
      "glossSv": "operator (objektform)",
      "pos": "function",
      "explanation": "to,toward,towards [quarter-sized]: may be placed above a symbol to show that it is representing a word in object form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 911,
      "bciAvId": 24674,
      "gloss": "indicator (past participle 1)",
      "glossSv": "operator (perfektparticip 1)",
      "pos": "function",
      "explanation": "indicator (past action) + indicator (description): may be placed above a symbol to show that it is representing a verb in past participle form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 912,
      "bciAvId": 24675,
      "gloss": "indicator (past participle 2)",
      "glossSv": "operator (perfektparticip 2)",
      "pos": "function",
      "explanation": "indicator (past action) + dot: may be placed above a symbol to show that it is representing a verb in past participle form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 913,
      "bciAvId": 24676,
      "gloss": "indicator (possessive form)",
      "glossSv": "operator (possessiv form)",
      "pos": "function",
      "explanation": "plus [quarter-sized]: may be placed above a symbol to show that it is representing a word in possessive form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 914,
      "bciAvId": 24677,
      "gloss": "indicator (present participle)",
      "glossSv": "operator (presensparticip)",
      "pos": "function",
      "explanation": "indicator (present action) + indicator (description): may be placed above a symbol to show that it is representing a verb in present participle form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 915,
      "bciAvId": 24678,
      "gloss": "indicator (second person)",
      "glossSv": "operator (andra person)",
      "pos": "function",
      "explanation": "two (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in second person form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 916,
      "bciAvId": 24679,
      "gloss": "indicator (third person)",
      "glossSv": "operator (tredje person)",
      "pos": "function",
      "explanation": "three (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in third person form in a natural language. Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 917,
      "bciAvId": 24714,
      "gloss": "portability",
      "glossSv": "bärbarhet, portabilitet",
      "pos": "noun",
      "explanation": "container + forward [modification, short arrow]",
      "isCharacter": true
    },
    {
      "id": 918,
      "bciAvId": 24717,
      "gloss": "potty, chamber pot, bedpan",
      "glossSv": "potta, bäcken (etc)",
      "pos": "noun",
      "explanation": "container + pictograph of a handle",
      "isCharacter": true
    },
    {
      "id": 919,
      "bciAvId": 24726,
      "gloss": "receiver, dish",
      "glossSv": "parabol, parabolantenn, mottagare",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 920,
      "bciAvId": 24727,
      "gloss": "acquiring, getting, receiving",
      "glossSv": "mottagande",
      "pos": "noun",
      "explanation": "down + container: drawing into what one holds",
      "isCharacter": true
    },
    {
      "id": 921,
      "bciAvId": 24739,
      "gloss": "satellite",
      "glossSv": "satellit",
      "pos": "noun",
      "explanation": "planet [half-sized]",
      "isCharacter": true
    },
    {
      "id": 922,
      "bciAvId": 24750,
      "gloss": "signal, broadcast, transmitting",
      "glossSv": "signal, sändning, överföring",
      "pos": "noun",
      "explanation": "pictograph: as of waves spreading in water",
      "isCharacter": true
    },
    {
      "id": 923,
      "bciAvId": 24761,
      "gloss": "step, stair",
      "glossSv": "trappsteg",
      "pos": "noun",
      "explanation": "stairs + pointer, to step",
      "isCharacter": true
    },
    {
      "id": 924,
      "bciAvId": 24778,
      "gloss": "water flower, water lily",
      "glossSv": "näckros, vattenväxt",
      "pos": "noun",
      "explanation": "flower + water",
      "isCharacter": true
    },
    {
      "id": 925,
      "bciAvId": 24801,
      "gloss": "bear's head",
      "glossSv": "björnhuvud",
      "pos": "noun",
      "explanation": "pictograph: of a bear's head",
      "isCharacter": true
    },
    {
      "id": 926,
      "bciAvId": 24805,
      "gloss": "jump (backward)",
      "glossSv": "hopp (bakåt)",
      "pos": "noun",
      "explanation": "curved line + arrowhead: curved arrow, backward, indicating the path of a backward jump",
      "isCharacter": true
    },
    {
      "id": 927,
      "bciAvId": 24806,
      "gloss": "scale, measurement",
      "glossSv": "skala, mått",
      "pos": "noun",
      "explanation": "height,tallness + lowness,shortness (height): combination of high,tall and short",
      "isCharacter": true
    },
    {
      "id": 928,
      "bciAvId": 24807,
      "gloss": "indicator (present action)",
      "glossSv": "operator (presens)",
      "pos": "function",
      "explanation": "indicator (past action) + indicator (future action): may be placed above a symbol to show that it is representing a verb in present action form in a natural language: Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 929,
      "bciAvId": 24825,
      "gloss": "push, pushing",
      "glossSv": "knuff",
      "pos": "noun",
      "explanation": "forward + thing: the forward moving arrow seems to be pushing the thing",
      "isCharacter": true
    },
    {
      "id": 930,
      "bciAvId": 24833,
      "gloss": "wish, desire",
      "glossSv": "önskan, önskning",
      "pos": "noun",
      "explanation": "mind + fire: a rational desire, a strong feeling shown by fire",
      "isCharacter": true
    },
    {
      "id": 931,
      "bciAvId": 24846,
      "gloss": "observation",
      "glossSv": "observation",
      "pos": "noun",
      "explanation": "mind + eye: to look at something thoughtfully",
      "isCharacter": true
    },
    {
      "id": 932,
      "bciAvId": 24847,
      "gloss": "usage, use",
      "glossSv": "användning",
      "pos": "noun",
      "explanation": "mind + tool: rational manipulation of a tool",
      "isCharacter": true
    },
    {
      "id": 933,
      "bciAvId": 24852,
      "gloss": "break, fracture, injury, damage",
      "glossSv": "brott, bristning",
      "pos": "noun",
      "explanation": "horizontal line [broken]",
      "isCharacter": true
    },
    {
      "id": 934,
      "bciAvId": 24855,
      "gloss": "fight, combat",
      "glossSv": "slagsmål, bråk",
      "pos": "noun",
      "explanation": "hand [modification, at an angle] + hand [modification, mirrored at an angle]: crossing hands, symbol represents physical conflict but may be used in a general sense to represent any sort of conflict or struggle",
      "isCharacter": true
    },
    {
      "id": 935,
      "bciAvId": 24859,
      "gloss": "visit",
      "glossSv": "besök",
      "pos": "noun",
      "explanation": "forward + house: can be understood as a combination of house and to enter",
      "isCharacter": true
    },
    {
      "id": 936,
      "bciAvId": 24875,
      "gloss": "bigness, largeness",
      "glossSv": "storhet",
      "pos": "noun",
      "explanation": "vertical line bounded by two horizontal reference lines [half-sized]: the vertical line extends to the biggest possible size within the symbol square",
      "isCharacter": true
    },
    {
      "id": 937,
      "bciAvId": 24879,
      "gloss": "comparative more",
      "glossSv": "mer (för komparation av adj.)",
      "pos": "expression",
      "explanation": "horizontal reference line [modification, half-sized on midline] + much,many,very [modification, higher position]: much, many on a higher level",
      "isCharacter": true
    },
    {
      "id": 938,
      "bciAvId": 24880,
      "gloss": "consideration, thoughtfulness",
      "glossSv": "omtänksamhet",
      "pos": "noun",
      "explanation": "mind + other: mindfulness of others",
      "isCharacter": true
    },
    {
      "id": 939,
      "bciAvId": 24883,
      "gloss": "deletion, cancellation, destruction",
      "glossSv": "förstörelse, strykning, radering, borttagning, utplåning",
      "pos": "noun",
      "explanation": "diagonal line used to cross out something: in the top-right to bottom left orientation",
      "isCharacter": true
    },
    {
      "id": 940,
      "bciAvId": 24884,
      "gloss": "difficulty",
      "glossSv": "svårighet",
      "pos": "noun",
      "explanation": "forward + reference line [modification, the line has an opening]: the forward arrow is halted at the reference line as by a difficulty passing through the opening",
      "isCharacter": true
    },
    {
      "id": 941,
      "bciAvId": 24887,
      "gloss": "dispersion, dissemination, scattering, spread, spreading",
      "glossSv": "spridning",
      "pos": "noun",
      "explanation": "backward + upward + downward + forward [modification, short arrows]: the four arrows pointing outward from each other, i.e. spreading out",
      "isCharacter": true
    },
    {
      "id": 942,
      "bciAvId": 24889,
      "gloss": "earmuffs (general)",
      "glossSv": "öronmuff(ar)",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 943,
      "bciAvId": 24890,
      "gloss": "ease, easiness, simplicity",
      "glossSv": "enkelhet, lätthet",
      "pos": "noun",
      "explanation": "forward + reference line [modification, the line has an opening]: the forward arrow easily passing through the broken reference line",
      "isCharacter": true
    },
    {
      "id": 944,
      "bciAvId": 24891,
      "gloss": "emptying, voidance, evacuation",
      "glossSv": "tömning",
      "pos": "noun",
      "explanation": "container + jump [modification, higher position]: the curved forward arrow representing content moving out of the container",
      "isCharacter": true
    },
    {
      "id": 945,
      "bciAvId": 24895,
      "gloss": "fantasy, phantasy, imagination, illusion",
      "glossSv": "fantasi",
      "pos": "noun",
      "explanation": "being (state of) [modification, high position over the skyline] + sky: imaginary existence up the sky, or up in the clouds",
      "isCharacter": true
    },
    {
      "id": 946,
      "bciAvId": 24896,
      "gloss": "farness, remoteness, farawayness",
      "glossSv": "långt avstånd (FD)",
      "pos": "noun",
      "explanation": "reference line [half-sized + reference line [half-sized]]: with a full square between them, the lines are relatively far apart",
      "isCharacter": true
    },
    {
      "id": 947,
      "bciAvId": 24897,
      "gloss": "filling, fill, fullness",
      "glossSv": "fyllning",
      "pos": "noun",
      "explanation": "container + horizontal line: the container is closed over, as if filled up",
      "isCharacter": true
    },
    {
      "id": 948,
      "bciAvId": 24899,
      "gloss": "forgetting, amnesia",
      "glossSv": "glömska",
      "pos": "noun",
      "explanation": "knowledge + forward: combination of knowledge and out of",
      "isCharacter": true
    },
    {
      "id": 949,
      "bciAvId": 24903,
      "gloss": "giving, gift",
      "glossSv": "givande",
      "pos": "noun",
      "explanation": "up + container: drawing from what one holds",
      "isCharacter": true
    },
    {
      "id": 950,
      "bciAvId": 24904,
      "gloss": "grid, matrix",
      "glossSv": "rutnät",
      "pos": "noun",
      "explanation": "enclosure + pictograph, of a matrix grid",
      "isCharacter": true
    },
    {
      "id": 951,
      "bciAvId": 24906,
      "gloss": "half, one-half",
      "glossSv": "halv, en halv",
      "pos": "expression",
      "explanation": "one (digit),1 [modification, higher position] + slash (slanted line) + two (digit),2: a common way to write 1/2",
      "isCharacter": true
    },
    {
      "id": 952,
      "bciAvId": 24909,
      "gloss": "height, tallness",
      "glossSv": "höjd",
      "pos": "noun",
      "explanation": "two horizontal reference lines [half-sized]: the space between the reference lines is the highest possible within the symbol square",
      "isCharacter": true
    },
    {
      "id": 953,
      "bciAvId": 24912,
      "gloss": "holding",
      "glossSv": "innehav",
      "pos": "noun",
      "explanation": "plus sign (low) + earth,ground,land [half-sized]: ownership,possession [half-sized], something in one's possession without necessarily being owned",
      "isCharacter": true
    },
    {
      "id": 954,
      "bciAvId": 24913,
      "gloss": "importance, significance",
      "glossSv": "viktighet",
      "pos": "noun",
      "explanation": "interest [modification, intensity moved to the left to make room for another one] + intensity: of intense interest",
      "isCharacter": true
    },
    {
      "id": 955,
      "bciAvId": 24916,
      "gloss": "interest",
      "glossSv": "intresse",
      "pos": "noun",
      "explanation": "mind + intensity: engaging the mind",
      "isCharacter": true
    },
    {
      "id": 956,
      "bciAvId": 24917,
      "gloss": "littleness, smallness",
      "glossSv": "litenhet",
      "pos": "noun",
      "explanation": "vertical line [half-sized] bounded by two horizontal reference lines [half-sized]: the vertical line is relatively little",
      "isCharacter": true
    },
    {
      "id": 957,
      "bciAvId": 24918,
      "gloss": "lowness, shortness (height)",
      "glossSv": "låghet",
      "pos": "noun",
      "explanation": "two horizontal reference lines [half-sized]: the space between the reference lines is relatively low",
      "isCharacter": true
    },
    {
      "id": 958,
      "bciAvId": 24920,
      "gloss": "medicine, medical practice",
      "glossSv": "läkekonst",
      "pos": "noun",
      "explanation": "symbol suggests a modified caduceus (modeled after the staff with a snake - of Hermes), the traditional medical symbol",
      "isCharacter": true
    },
    {
      "id": 959,
      "bciAvId": 24925,
      "gloss": "ownership, possession",
      "glossSv": "ägande",
      "pos": "noun",
      "explanation": "addition + earth: CKB writes \"an addition, a gain, a plus of some very earthly (material) thing”",
      "isCharacter": true
    },
    {
      "id": 960,
      "bciAvId": 24926,
      "gloss": "permission, allowance",
      "glossSv": "tillåtelse",
      "pos": "noun",
      "explanation": "mind + through: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier",
      "isCharacter": true
    },
    {
      "id": 961,
      "bciAvId": 24927,
      "gloss": "persuasion",
      "glossSv": "övertygande",
      "pos": "noun",
      "explanation": "leadership + agreement [modification, short arrows] [combination]: leadership to agreement",
      "isCharacter": true
    },
    {
      "id": 962,
      "bciAvId": 24932,
      "gloss": "quarter, one quarter",
      "glossSv": "kvart, fjärdedel",
      "pos": "expression",
      "explanation": "one (digit),1 [modification, higher position] + slash (slanted line) + four (digit),4: a common way to write 1/4",
      "isCharacter": true
    },
    {
      "id": 963,
      "bciAvId": 24934,
      "gloss": "repetition, copying, duplication, replication",
      "glossSv": "upprepning",
      "pos": "noun",
      "explanation": "line,stripe + line,stripe + action indicator: the vertical line is repeated",
      "isCharacter": true
    },
    {
      "id": 964,
      "bciAvId": 24937,
      "gloss": "selfishness, egoism",
      "glossSv": "egoism, själviskhet",
      "pos": "noun",
      "explanation": "mind + self: thinking only about oneself",
      "isCharacter": true
    },
    {
      "id": 965,
      "bciAvId": 24938,
      "gloss": "shortness (distance, length)",
      "glossSv": "korthet",
      "pos": "noun",
      "explanation": "horizontal line [half-sized] bounded by reference lines [half-sized]: horizontal line is relatively short",
      "isCharacter": true
    },
    {
      "id": 966,
      "bciAvId": 24940,
      "gloss": "spray, vaporisation, vaporization",
      "glossSv": "sprej",
      "pos": "noun",
      "explanation": "water,fluid,liquid + a cluster of seven dots: a liquid transformed into a spray of small drops",
      "isCharacter": true
    },
    {
      "id": 967,
      "bciAvId": 24941,
      "gloss": "strength",
      "glossSv": "styrka, muskelkraft",
      "pos": "noun",
      "explanation": "health + muscle [combination]: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength",
      "isCharacter": true
    },
    {
      "id": 968,
      "bciAvId": 24944,
      "gloss": "superlative most",
      "glossSv": "mest (för komparation av adj.)",
      "pos": "expression",
      "explanation": "horizontal reference line [modification, half-sized on skyline] + much,many,very [modification, higher position]: much, many on the highest level",
      "isCharacter": true
    },
    {
      "id": 969,
      "bciAvId": 24949,
      "gloss": "wakefulness, alertness",
      "glossSv": "vakenhet",
      "pos": "noun",
      "explanation": "eye + open: state one is in when one's eyes are open",
      "isCharacter": true
    },
    {
      "id": 970,
      "bciAvId": 24961,
      "gloss": "slang",
      "glossSv": "slang (språk)",
      "pos": "noun",
      "explanation": "feeling + to speak: emotional talk",
      "isCharacter": true
    },
    {
      "id": 971,
      "bciAvId": 24962,
      "gloss": "coarse slang, swear word, swearing",
      "glossSv": "svordom, grov slang",
      "pos": "noun",
      "explanation": "knife + to speak: sharp talk",
      "isCharacter": true
    },
    {
      "id": 972,
      "bciAvId": 25011,
      "gloss": "alphabet, letters (uppercase) (Latin alphabet)",
      "glossSv": "alfabetet (versaler)",
      "pos": "noun",
      "explanation": "A (uppercase) + B (uppercase) + C (uppercase): first three letters of the English alphabet, representing the entire alphabet",
      "isCharacter": true
    },
    {
      "id": 973,
      "bciAvId": 25070,
      "gloss": "gravity, gravitation",
      "glossSv": "tyngdkraft, gravitation",
      "pos": "noun",
      "explanation": "thing + down [modification, short arrow]",
      "isCharacter": true
    },
    {
      "id": 974,
      "bciAvId": 25119,
      "gloss": "move, movement",
      "glossSv": "förflyttning",
      "pos": "noun",
      "explanation": "wheel + earth [half-sized]: the wheel moves by rolling over the ground",
      "isCharacter": true
    },
    {
      "id": 975,
      "bciAvId": 25132,
      "gloss": "oppression, captivity, slavery",
      "glossSv": "ofrihet, fångenskap, förtryck",
      "pos": "noun",
      "explanation": "feeling + enclosure: feeling of being confined",
      "isCharacter": true
    },
    {
      "id": 976,
      "bciAvId": 25133,
      "gloss": "out of (backward)",
      "glossSv": "ut ur (bakåt)",
      "pos": "expression",
      "explanation": "enclosure + backward",
      "isCharacter": true
    },
    {
      "id": 977,
      "bciAvId": 25134,
      "gloss": "out of (upward)",
      "glossSv": "ut ur (uppåt)",
      "pos": "expression",
      "explanation": "enclosure + upward",
      "isCharacter": true
    },
    {
      "id": 978,
      "bciAvId": 25267,
      "gloss": "bird of prey, raptor, falcon, hawk, eagle",
      "glossSv": "rovfågel",
      "pos": "noun",
      "explanation": "bird + pictograph of claws",
      "isCharacter": true
    },
    {
      "id": 979,
      "bciAvId": 25290,
      "gloss": "electric field",
      "glossSv": "elektriskt fält",
      "pos": "noun",
      "explanation": "pointer (left) + electricity + pointer (right): suggesting the field of force surrounding an electrically charged particle or varying magnetic field",
      "isCharacter": true
    },
    {
      "id": 980,
      "bciAvId": 25311,
      "gloss": "front, front of a thing",
      "glossSv": "framsida, framdel, front, främre del",
      "pos": "expression",
      "explanation": "thing + pointer: pointer pointing to the left on the \"front\" right-hand side of the thing",
      "isCharacter": true
    },
    {
      "id": 981,
      "bciAvId": 25339,
      "gloss": "magnetic field",
      "glossSv": "magnetfält",
      "pos": "noun",
      "explanation": "pointer (left) + magnetism + pointer (right): suggesting the lines of force surrounding a permanent magnet or a moving charged particle",
      "isCharacter": true
    },
    {
      "id": 982,
      "bciAvId": 25340,
      "gloss": "magnetism",
      "glossSv": "magnetism",
      "pos": "noun",
      "explanation": "metal bar + pictograph of lines of flux",
      "isCharacter": true
    },
    {
      "id": 983,
      "bciAvId": 25362,
      "gloss": "propeller, rotor (blades)",
      "glossSv": "propeller, rotorblad",
      "pos": "noun",
      "explanation": "pictograph: suggesting the rotor blades of a propeller",
      "isCharacter": true
    },
    {
      "id": 984,
      "bciAvId": 25364,
      "gloss": "rear, back of a thing",
      "glossSv": "baksida, bakdel, bakre del",
      "pos": "expression",
      "explanation": "pointer + thing: pointer pointing to the right on the \"back\" left-hand side of the thing",
      "isCharacter": true
    },
    {
      "id": 985,
      "bciAvId": 25379,
      "gloss": "state of mind",
      "glossSv": "sinnestillstånd",
      "pos": "noun",
      "explanation": "mind + being (state of): what you think exists",
      "isCharacter": true
    },
    {
      "id": 986,
      "bciAvId": 25387,
      "gloss": "top, top of a thing",
      "glossSv": "ovansida, överdel, övre del",
      "pos": "expression",
      "explanation": "pointer + thing: pointer pointing down on the \"top\" of the thing",
      "isCharacter": true
    },
    {
      "id": 987,
      "bciAvId": 25396,
      "gloss": "voltage",
      "glossSv": "elektrisk spänning",
      "pos": "noun",
      "explanation": "vertical line + electricity + vertical line: a combination of limit(s) and electricity",
      "isCharacter": true
    },
    {
      "id": 988,
      "bciAvId": 25401,
      "gloss": "ascending and descending",
      "glossSv": "start och landning, upp- och nedgående",
      "pos": "noun",
      "explanation": "upward and forward + downward and backward",
      "isCharacter": true
    },
    {
      "id": 989,
      "bciAvId": 25406,
      "gloss": "swing, swinging",
      "glossSv": "svängning, gungning",
      "pos": "noun",
      "explanation": "two-headed curved arrow suggests swinging motion",
      "isCharacter": true
    },
    {
      "id": 990,
      "bciAvId": 25408,
      "gloss": "bottom, bottom of a thing",
      "glossSv": "undersida, underdel, botten, undre del",
      "pos": "expression",
      "explanation": "pointer + thing: pointer pointing up on the \"bottom\" of the thing",
      "isCharacter": true
    },
    {
      "id": 991,
      "bciAvId": 25434,
      "gloss": "brain signal",
      "glossSv": "signal (hjärna)",
      "pos": "noun",
      "explanation": "mind + electricity: the electrical impulses of the brain (and CNS)",
      "isCharacter": true
    },
    {
      "id": 992,
      "bciAvId": 25458,
      "gloss": "indicator (diminutive form)",
      "glossSv": "operator (diminutiv)",
      "pos": "function",
      "explanation": "little [quarter-sized]: may be placed above a symbol to show that it is representing a word in diminutive form in a natural language: Used restrictively, primarily for language teaching purposes.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 993,
      "bciAvId": 25480,
      "gloss": "organ, inner organ, inner body part",
      "glossSv": "organ, inre organ",
      "pos": "noun",
      "explanation": "body [modification, reduced width] + dot: a reduced body with a dot inside that represents an inner organ",
      "isCharacter": true
    },
    {
      "id": 994,
      "bciAvId": 25520,
      "gloss": "ability (half sized)",
      "glossSv": "förmåga (halv storlek), kunnande",
      "pos": "noun",
      "explanation": "dot + evaluation,value (half-sized): evaluation beforehand of one’s potential to do something - half sized, used in can,be able-(to)",
      "isCharacter": true
    },
    {
      "id": 995,
      "bciAvId": 25521,
      "gloss": "animal (bushy tailed)",
      "glossSv": "djur (med yvig svans)",
      "pos": "noun",
      "explanation": "animal + raised wavy line: pictograph of an animal with a wavy line in high position as tail, used for representing animals with a bushy tail, e.g. a squirrel",
      "isCharacter": true
    },
    {
      "id": 996,
      "bciAvId": 25522,
      "gloss": "away, at a distance, off",
      "glossSv": "iväg, bort",
      "pos": "expression",
      "explanation": "reference line [half-sized] + three connecting dots + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.",
      "isCharacter": true
    },
    {
      "id": 997,
      "bciAvId": 25523,
      "gloss": "bad conscience",
      "glossSv": "samvete (dåligt), dåligt samvete",
      "pos": "noun",
      "explanation": "conscience + minus,no,without: conscience in a negative state",
      "isCharacter": true
    },
    {
      "id": 998,
      "bciAvId": 25524,
      "gloss": "ball field",
      "glossSv": "bollplan",
      "pos": "noun",
      "explanation": "ball + earth,ground,land",
      "isCharacter": true
    },
    {
      "id": 999,
      "bciAvId": 25525,
      "gloss": "biochemical product, organic compound",
      "glossSv": "biokemisk produkt, organisk förening",
      "pos": "noun",
      "explanation": "chemical product + life [modification] [combination]: chemical substances that constitute biological processes",
      "isCharacter": true
    },
    {
      "id": 1000,
      "bciAvId": 25526,
      "gloss": "blindness",
      "glossSv": "blindhet",
      "pos": "noun",
      "explanation": "eye + deletion,cancellation,destruction: for destroyed vision and lack of sight",
      "isCharacter": true
    },
    {
      "id": 1001,
      "bciAvId": 25527,
      "gloss": "boarding, embarkation (to sea)",
      "glossSv": "ombordstigning (till sjöss)",
      "pos": "noun",
      "explanation": "shore + forward: going forward from shore to water",
      "isCharacter": true
    },
    {
      "id": 1002,
      "bciAvId": 25528,
      "gloss": "bones with joint",
      "glossSv": "ben med led",
      "pos": "noun",
      "explanation": "bone + bone [modification, horizontal]: indicating the junction where bones meet",
      "isCharacter": true
    },
    {
      "id": 1003,
      "bciAvId": 25529,
      "gloss": "bottleneck, bottle opening",
      "glossSv": "flaskhals, flasköppning",
      "pos": "noun",
      "explanation": "bottle + pointer, to neck or opening",
      "isCharacter": true
    },
    {
      "id": 1004,
      "bciAvId": 25530,
      "gloss": "bread surface",
      "glossSv": "brödyta",
      "pos": "noun",
      "explanation": "bread + pointer, down to top of bread + pointer, up to bottom of bread",
      "isCharacter": true
    },
    {
      "id": 1005,
      "bciAvId": 25531,
      "gloss": "buttocks and genitals",
      "glossSv": "stjärt och könsorgan",
      "pos": "noun",
      "explanation": "standing person + pointer, to the right to buttocks + pointer, to the left to genitals",
      "isCharacter": true
    },
    {
      "id": 1006,
      "bciAvId": 25532,
      "gloss": "case, casing",
      "glossSv": "fodral, ask, skrin",
      "pos": "noun",
      "explanation": "enclosure + thing: a crust or shell surrounds the thing",
      "isCharacter": true
    },
    {
      "id": 1007,
      "bciAvId": 25533,
      "gloss": "coldness, cold",
      "glossSv": "kyla",
      "pos": "noun",
      "explanation": "pointer (left) + ice + pointer (right): suggesting the spreading of cold from something cold like ice",
      "isCharacter": true
    },
    {
      "id": 1008,
      "bciAvId": 25534,
      "gloss": "compression, compressing, squeezing",
      "glossSv": "tryck, press, kompression, komprimering",
      "pos": "noun",
      "explanation": "forward + thing + backward: squeezing a thing by pressure from two directions",
      "isCharacter": true
    },
    {
      "id": 1009,
      "bciAvId": 25535,
      "gloss": "container, basket (high)",
      "glossSv": "behållare (högt läge)",
      "pos": "noun",
      "explanation": "container [modification, high position, under the skyline]",
      "isCharacter": true
    },
    {
      "id": 1010,
      "bciAvId": 25536,
      "gloss": "container (low)",
      "glossSv": "behållare (lågt läge)",
      "pos": "noun",
      "explanation": "container [modification, low position, under the earthline]",
      "isCharacter": true
    },
    {
      "id": 1011,
      "bciAvId": 25537,
      "gloss": "corner",
      "glossSv": "hörn",
      "pos": "noun",
      "explanation": "square (oblique) + pointer to the right corner",
      "isCharacter": true
    },
    {
      "id": 1012,
      "bciAvId": 25538,
      "gloss": "correct thinking",
      "glossSv": "korrekt tänkande",
      "pos": "noun",
      "explanation": "mind + plus",
      "isCharacter": true
    },
    {
      "id": 1013,
      "bciAvId": 25539,
      "gloss": "incorrect thinking",
      "glossSv": "felaktigt tänkande",
      "pos": "noun",
      "explanation": "mind + minus",
      "isCharacter": true
    },
    {
      "id": 1014,
      "bciAvId": 25540,
      "gloss": "couple (female)",
      "glossSv": "par (kvinnligt)",
      "pos": "person",
      "explanation": "woman + woman",
      "isCharacter": true
    },
    {
      "id": 1015,
      "bciAvId": 25541,
      "gloss": "couple (male)",
      "glossSv": "par (manligt)",
      "pos": "person",
      "explanation": "man + man",
      "isCharacter": true
    },
    {
      "id": 1016,
      "bciAvId": 25542,
      "gloss": "crossed racquets",
      "glossSv": "racketar i kors",
      "pos": "noun",
      "explanation": "racket,racquet + racket,racquet [modification, mirrored]: pictograph of two crossed racquets",
      "isCharacter": true
    },
    {
      "id": 1017,
      "bciAvId": 25543,
      "gloss": "deafness",
      "glossSv": "dövhet",
      "pos": "noun",
      "explanation": "ear + deletion,cancellation,destruction: representing destroyed hearing, lack of hearing",
      "isCharacter": true
    },
    {
      "id": 1018,
      "bciAvId": 25544,
      "gloss": "debarkation, disembarkation (ashore)",
      "glossSv": "ilandstigning",
      "pos": "noun",
      "explanation": "shore + backward,back: going back to shore from water",
      "isCharacter": true
    },
    {
      "id": 1019,
      "bciAvId": 25545,
      "gloss": "adversity, hardship, setback",
      "glossSv": "motgång, bakslag, prövning",
      "pos": "noun",
      "explanation": "forward + arrow, high position pointing backward + arrow, low position pointing backward: one arrow is \"frustrated\" in its efforts to penetrate the opposition of the other two",
      "isCharacter": true
    },
    {
      "id": 1020,
      "bciAvId": 25546,
      "gloss": "depth",
      "glossSv": "djup",
      "pos": "noun",
      "explanation": "vertical line + vertical line + pointer: the pointer points downward to the bottom of a relatively deep space",
      "isCharacter": true
    },
    {
      "id": 1021,
      "bciAvId": 25547,
      "gloss": "miscarriage, abortion (general)",
      "glossSv": "missfall, abort (generellt)",
      "pos": "noun",
      "explanation": "conception + to cancel: cancelled pregnancy due to the natural death of an embryo",
      "isCharacter": true
    },
    {
      "id": 1022,
      "bciAvId": 25548,
      "gloss": "detachment, separation, breakup",
      "glossSv": "avskiljande, isärtagning",
      "pos": "noun",
      "explanation": "vertical line + minus + vertical line: representing the separation of two things previously attached",
      "isCharacter": true
    },
    {
      "id": 1023,
      "bciAvId": 25549,
      "gloss": "diamond (character)",
      "glossSv": "ruter (tecken)",
      "pos": "noun",
      "explanation": "pictograph, of a diamond shape",
      "isCharacter": true
    },
    {
      "id": 1024,
      "bciAvId": 25550,
      "gloss": "digging, excavation",
      "glossSv": "grävning, utgrävning (allmän)",
      "pos": "noun",
      "explanation": "shovel + earth",
      "isCharacter": true
    },
    {
      "id": 1025,
      "bciAvId": 25551,
      "gloss": "digital space (limited)",
      "glossSv": "digital domän",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction [modification] + digits (computer)",
      "isCharacter": true
    },
    {
      "id": 1026,
      "bciAvId": 25552,
      "gloss": "digital world",
      "glossSv": "digital värld",
      "pos": "noun",
      "explanation": "world + digits (computer)",
      "isCharacter": true
    },
    {
      "id": 1027,
      "bciAvId": 25553,
      "gloss": "disturbance, unrest",
      "glossSv": "oro, ängslan",
      "pos": "noun",
      "explanation": "peace,peace of mind,serenity + deletion,cancellation,destruction: used in harassment 14677 and sexual harassment 16930",
      "isCharacter": true
    },
    {
      "id": 1028,
      "bciAvId": 25554,
      "gloss": "evaluation, value (half-sized)",
      "glossSv": "värdering (halv storlek)",
      "pos": "noun",
      "explanation": "ideograph: symbol represents a half-sized cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable",
      "isCharacter": true
    },
    {
      "id": 1029,
      "bciAvId": 25555,
      "gloss": "exchange, substitution",
      "glossSv": "byte, utbyte",
      "pos": "noun",
      "explanation": "receiving + giving,gift [combination]",
      "isCharacter": true
    },
    {
      "id": 1030,
      "bciAvId": 25556,
      "gloss": "extinction, extinguishing (fire)",
      "glossSv": "eldsläckning",
      "pos": "noun",
      "explanation": "fire + deletion,cancellation,destruction",
      "isCharacter": true
    },
    {
      "id": 1031,
      "bciAvId": 25557,
      "gloss": "eyelid(s)",
      "glossSv": "ögonlock",
      "pos": "noun",
      "explanation": "eye + pointer, to upper eyelid (and eyelashes) + pointer, to lower eyelid",
      "isCharacter": true
    },
    {
      "id": 1032,
      "bciAvId": 25558,
      "gloss": "eyelid (lower)",
      "glossSv": "ögonlock (nedre)",
      "pos": "noun",
      "explanation": "eye + pointer, to lower eyelid",
      "isCharacter": true
    },
    {
      "id": 1033,
      "bciAvId": 25559,
      "gloss": "farness, remoteness, farawayness",
      "glossSv": "långt avstånd, avlägsenhet",
      "pos": "noun",
      "explanation": "reference line [half-sized] + three connecting dots + reference line [half-sized]: full square between the reference lines emphasizes distance.",
      "isCharacter": true
    },
    {
      "id": 1034,
      "bciAvId": 25560,
      "gloss": "fatness, thickness",
      "glossSv": "tjockhet",
      "pos": "noun",
      "explanation": "reference line + three connecting dots + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.",
      "isCharacter": true
    },
    {
      "id": 1035,
      "bciAvId": 25561,
      "gloss": "fatness, thickness",
      "glossSv": "tjockhet (FD)",
      "pos": "noun",
      "explanation": "reference line + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.",
      "isCharacter": true
    },
    {
      "id": 1036,
      "bciAvId": 25562,
      "gloss": "floating container",
      "glossSv": "flytetyg, flytande behållare",
      "pos": "noun",
      "explanation": "container + water (ground level): container appears to float on water",
      "isCharacter": true
    },
    {
      "id": 1037,
      "bciAvId": 25563,
      "gloss": "flower, bloom, blossom",
      "glossSv": "blomkrona, blomställning, blomma",
      "pos": "noun",
      "explanation": "flower + pointer, to blossom",
      "isCharacter": true
    },
    {
      "id": 1038,
      "bciAvId": 25564,
      "gloss": "fold, folding, pleating",
      "glossSv": "veck, vikning",
      "pos": "noun",
      "explanation": "vertical reference line + horizontal reference line + pictograph, of a small curved arrow (to the right and down): the arrow pulls the vertical reference line down onto the horizontal one, as if closing a folder",
      "isCharacter": true
    },
    {
      "id": 1039,
      "bciAvId": 25565,
      "gloss": "freezing, hardening, solidifying",
      "glossSv": "infrysning, tillfrysning, stelning",
      "pos": "noun",
      "explanation": "water + thing: the conversion of water to solid ice",
      "isCharacter": true
    },
    {
      "id": 1040,
      "bciAvId": 25566,
      "gloss": "from sky",
      "glossSv": "från skyn",
      "pos": "noun",
      "explanation": "sky + down",
      "isCharacter": true
    },
    {
      "id": 1041,
      "bciAvId": 25567,
      "gloss": "fruit (pointed)",
      "glossSv": "frukt (kilformad)",
      "pos": "noun",
      "explanation": "fruit + pictograph of wedge shape [combination]",
      "isCharacter": true
    },
    {
      "id": 1042,
      "bciAvId": 25568,
      "gloss": "future (uncertain)",
      "glossSv": "framtid (oviss), oviss framtid",
      "pos": "noun",
      "explanation": "future + what,question mark: unpredictable future",
      "isCharacter": true
    },
    {
      "id": 1043,
      "bciAvId": 25569,
      "gloss": "good conscience",
      "glossSv": "samvete (gott)",
      "pos": "noun",
      "explanation": "conscience + and also,plus,too: conscience in a positive state",
      "isCharacter": true
    },
    {
      "id": 1044,
      "bciAvId": 25570,
      "gloss": "hidden thing",
      "glossSv": "gömt föremål",
      "pos": "noun",
      "explanation": "thing + earth: something half hidden in the earth",
      "isCharacter": true
    },
    {
      "id": 1045,
      "bciAvId": 25571,
      "gloss": "horse neck",
      "glossSv": "hästnacke, nacke (hovdjur)",
      "pos": "noun",
      "explanation": "horse + pointer, to neck",
      "isCharacter": true
    },
    {
      "id": 1046,
      "bciAvId": 25572,
      "gloss": "horse rump",
      "glossSv": "hästbak, hästrumpa",
      "pos": "noun",
      "explanation": "horse + pointer, to tail",
      "isCharacter": true
    },
    {
      "id": 1047,
      "bciAvId": 25573,
      "gloss": "hypodermic needlepoint",
      "glossSv": "nålspets (injektionsspruta etc)",
      "pos": "noun",
      "explanation": "injection,inoculation,shot + pointer, to the needlepoint",
      "isCharacter": true
    },
    {
      "id": 1048,
      "bciAvId": 25574,
      "gloss": "hypothesis, theory",
      "glossSv": "hypotes, teori",
      "pos": "noun",
      "explanation": "creation + what,question mark [modification, lower position]: the nature of things, but with uncertainty",
      "isCharacter": true
    },
    {
      "id": 1049,
      "bciAvId": 25575,
      "gloss": "imprint, depression",
      "glossSv": "fördjupning, avtryck",
      "pos": "noun",
      "explanation": "pictograph of impression, like made by a thumb pressed into something soft",
      "isCharacter": true
    },
    {
      "id": 1050,
      "bciAvId": 25576,
      "gloss": "insurance",
      "glossSv": "försäkring",
      "pos": "noun",
      "explanation": "protection + future (uncertain): protection against unpredictable future problems and expense",
      "isCharacter": true
    },
    {
      "id": 1051,
      "bciAvId": 25577,
      "gloss": "left turn, left (position or direction)",
      "glossSv": "vänsterriktning",
      "pos": "noun",
      "explanation": "horizontal line [modification, half-sized, on skyline, extending to the left] + vertical line",
      "isCharacter": true
    },
    {
      "id": 1052,
      "bciAvId": 25578,
      "gloss": "leg and foot",
      "glossSv": "ben och fot",
      "pos": "noun",
      "explanation": "legs and feet + two pointers: to leg and foot",
      "isCharacter": true
    },
    {
      "id": 1053,
      "bciAvId": 25579,
      "gloss": "limit(s), limitation, restriction",
      "glossSv": "begränsning, gränser",
      "pos": "noun",
      "explanation": "line,stripe + three connecting dots + line,stripe: two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them",
      "isCharacter": true
    },
    {
      "id": 1054,
      "bciAvId": 25580,
      "gloss": "mane (lion etc)",
      "glossSv": "man (djur)",
      "pos": "noun",
      "explanation": "body + hair + pointer, to mane: specifier for species that has a mane",
      "isCharacter": true
    },
    {
      "id": 1055,
      "bciAvId": 25581,
      "gloss": "mash, mush, pulp (food)",
      "glossSv": "mos, pure",
      "pos": "noun",
      "explanation": "forward + food + backward: crushed food",
      "isCharacter": true
    },
    {
      "id": 1056,
      "bciAvId": 25582,
      "gloss": "mask (disguise)",
      "glossSv": "ansiktsmask, förklädnad",
      "pos": "noun",
      "explanation": "pictograph of mask",
      "isCharacter": true
    },
    {
      "id": 1057,
      "bciAvId": 25583,
      "gloss": "meeting, encounter",
      "glossSv": "möte",
      "pos": "noun",
      "explanation": "forward + backward: two arrows approaching each other from opposite directions",
      "isCharacter": true
    },
    {
      "id": 1058,
      "bciAvId": 25584,
      "gloss": "meeting and parting",
      "glossSv": "möte och avsked",
      "pos": "noun",
      "explanation": "meeting,encounter [modification, higher position] + parting [modification, lower position]",
      "isCharacter": true
    },
    {
      "id": 1059,
      "bciAvId": 25585,
      "gloss": "metaphor (winged)",
      "glossSv": "metafor (bevingad)",
      "pos": "noun",
      "explanation": "metaphor + wings: \"winged speech\", used in poetry",
      "isCharacter": true
    },
    {
      "id": 1060,
      "bciAvId": 25586,
      "gloss": "nearness, closeness, proximity",
      "glossSv": "närhet",
      "pos": "noun",
      "explanation": "reference line [half-sized] + reference line [half-sized]: with a half square between them, the lines are relatively near each other",
      "isCharacter": true
    },
    {
      "id": 1061,
      "bciAvId": 25587,
      "gloss": "newness, novelty",
      "glossSv": "nyhet, något nytt",
      "pos": "noun",
      "explanation": "existence,being [modification: without sky and earth] + beginning,start: something that starts to exist is a novelty",
      "isCharacter": true
    },
    {
      "id": 1062,
      "bciAvId": 25588,
      "gloss": "no speech, anarthria",
      "glossSv": "stumhet, utan tal",
      "pos": "noun",
      "explanation": "to speak + deletion,cancellation,destruction: unable to speak",
      "isCharacter": true
    },
    {
      "id": 1063,
      "bciAvId": 25589,
      "gloss": "opposing forces, counter-forces",
      "glossSv": "motverkan, motkrafter",
      "pos": "noun",
      "explanation": "backward,back [modification, on skyline] + backward,back [modification, on earthline]: forces working against something",
      "isCharacter": true
    },
    {
      "id": 1064,
      "bciAvId": 25590,
      "gloss": "out of body (upward), regurgitation",
      "glossSv": "upp ur kropp",
      "pos": "noun",
      "explanation": "body + up,upward: e.g., used in burp,belch-(to) 12925",
      "isCharacter": true
    },
    {
      "id": 1065,
      "bciAvId": 25591,
      "gloss": "outdoor (character)",
      "glossSv": "utomhustecken",
      "pos": "noun",
      "explanation": "house + dot (outside the house): can also be seen as a combination of house and out,exterior,external,outside",
      "isCharacter": true
    },
    {
      "id": 1066,
      "bciAvId": 25592,
      "gloss": "parting",
      "glossSv": "avsked, åtskiljande (allmänt)",
      "pos": "noun",
      "explanation": "backward + forward: two arrows, pointing away from each other",
      "isCharacter": true
    },
    {
      "id": 1067,
      "bciAvId": 25593,
      "gloss": "permission, allowance (moral)",
      "glossSv": "tillåtelse",
      "pos": "noun",
      "explanation": "conscience + permission,allowance [combination]: represents a moral consideration that is allowed to pass through a mental barrier",
      "isCharacter": true
    },
    {
      "id": 1068,
      "bciAvId": 25594,
      "gloss": "pizza slice(s), sector(s), circle sector(s)",
      "glossSv": "sektor(er), cirkelsektor(er), sektion(er)",
      "pos": "noun",
      "explanation": "pictograph of pizza divided into pieces, a circle divided into circle sectors",
      "isCharacter": true
    },
    {
      "id": 1069,
      "bciAvId": 25595,
      "gloss": "plus minus",
      "glossSv": "plus minus",
      "pos": "expression",
      "explanation": "plus sign (low) + minus [modification, higher position]",
      "isCharacter": true
    },
    {
      "id": 1070,
      "bciAvId": 25596,
      "gloss": "plus sign (low)",
      "glossSv": "plustecken (lågt läge)",
      "pos": "noun",
      "explanation": "and,also,plus,too [modification, on earthline]",
      "isCharacter": true
    },
    {
      "id": 1071,
      "bciAvId": 25597,
      "gloss": "protected water",
      "glossSv": "skyddat vatten",
      "pos": "noun",
      "explanation": "protection + water (ground level): water with protection",
      "isCharacter": true
    },
    {
      "id": 1072,
      "bciAvId": 25598,
      "gloss": "protection with pointer",
      "glossSv": "skydd med pilspets",
      "pos": "noun",
      "explanation": "protection + pointer",
      "isCharacter": true
    },
    {
      "id": 1073,
      "bciAvId": 25599,
      "gloss": "pull, pulling",
      "glossSv": "drag",
      "pos": "noun",
      "explanation": "thing + forward [modification, short arrow]: the forward moving arrow seems to be pulling the thing",
      "isCharacter": true
    },
    {
      "id": 1075,
      "bciAvId": 25601,
      "gloss": "recording disk",
      "glossSv": "skiva (för inspelning etc)",
      "pos": "noun",
      "explanation": "pictograph, of a disk or record: circle (as in sun) + dot (in the middle), suggesting any kind of rotating recording disk, gramophone, CD, DVD, video, etc.",
      "isCharacter": true
    },
    {
      "id": 1076,
      "bciAvId": 25602,
      "gloss": "reflection (mental), consideration",
      "glossSv": "reflektion, fundering, eftertanke",
      "pos": "noun",
      "explanation": "mind + reflection: mirroring thoughts in the mind",
      "isCharacter": true
    },
    {
      "id": 1077,
      "bciAvId": 25603,
      "gloss": "ride, drive",
      "glossSv": "åktur, färd",
      "pos": "noun",
      "explanation": "seat,sitting (sitting person) + forward [modification, on groundlevel]: going forward in a sitting position",
      "isCharacter": true
    },
    {
      "id": 1078,
      "bciAvId": 25604,
      "gloss": "right turn, right (position or direction)",
      "glossSv": "högerriktning",
      "pos": "noun",
      "explanation": "vertical line + horizontal line [modification, half-sized, on skyline, extending to the right]",
      "isCharacter": true
    },
    {
      "id": 1079,
      "bciAvId": 25605,
      "gloss": "dilapidated, ruined (building) (1)",
      "glossSv": "ruin (1)",
      "pos": "noun",
      "explanation": "house,building,dwelling,residence + deletion,cancellation,destruction",
      "isCharacter": true
    },
    {
      "id": 1080,
      "bciAvId": 25606,
      "gloss": "shallowness",
      "glossSv": "grundhet",
      "pos": "noun",
      "explanation": "two vertical lines [half-sized] + pointer: pointer points downward into a relatively shallow space",
      "isCharacter": true
    },
    {
      "id": 1081,
      "bciAvId": 25607,
      "gloss": "shekel (character)",
      "glossSv": "shekeltecken",
      "pos": "noun",
      "explanation": "international symbol for Israeli shekel",
      "isCharacter": true
    },
    {
      "id": 1082,
      "bciAvId": 25608,
      "gloss": "shuttlecock, birdie (badminton)",
      "glossSv": "badmintonboll",
      "pos": "noun",
      "explanation": "ball + wing(s)",
      "isCharacter": true
    },
    {
      "id": 1083,
      "bciAvId": 25609,
      "gloss": "sitski, sit ski",
      "glossSv": "sitski",
      "pos": "noun",
      "explanation": "ski,runner (sled etc) + seat,sitting (sitting person)",
      "isCharacter": true
    },
    {
      "id": 1084,
      "bciAvId": 25610,
      "gloss": "ski, runner (sled etc)",
      "glossSv": "skida, med (släde etc)",
      "pos": "noun",
      "explanation": "pictograph of a ski",
      "isCharacter": true
    },
    {
      "id": 1085,
      "bciAvId": 25611,
      "gloss": "smoking (cigarette)",
      "glossSv": "rökning (cigarett)",
      "pos": "noun",
      "explanation": "mouth [modification, on earthline] + pictograph of cigarette + fire: symbol suggests a mouth holding a smoking cigarette",
      "isCharacter": true
    },
    {
      "id": 1086,
      "bciAvId": 25612,
      "gloss": "smoking (pipe)",
      "glossSv": "rökning (pipa)",
      "pos": "noun",
      "explanation": "mouth [modification, on earthline] + pictograph of smoking pipe + fire:combination of smoking (cigarette) and pictograph of a smoking pipe",
      "isCharacter": true
    },
    {
      "id": 1087,
      "bciAvId": 25613,
      "gloss": "snowshoe",
      "glossSv": "snösko",
      "pos": "noun",
      "explanation": "pictograph of a snowshoe: special shoe for walking over snow",
      "isCharacter": true
    },
    {
      "id": 1088,
      "bciAvId": 25614,
      "gloss": "projectile, rocket, spacecraft",
      "glossSv": "projektil, raket, rymdfarkost",
      "pos": "noun",
      "explanation": "thing [modification, on earthline] + pictograph of a pointed top: together, a pictograph suggesting a projectile or a rocket",
      "isCharacter": true
    },
    {
      "id": 1089,
      "bciAvId": 25615,
      "gloss": "sperm destruction",
      "glossSv": "spermiedöd",
      "pos": "noun",
      "explanation": "sperm + deletion,cancellation,destruction",
      "isCharacter": true
    },
    {
      "id": 1090,
      "bciAvId": 25616,
      "gloss": "spiral",
      "glossSv": "spiral",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 1091,
      "bciAvId": 25617,
      "gloss": "spitting",
      "glossSv": "spottande",
      "pos": "noun",
      "explanation": "mouth + downward curving arrow: to expel from one's mouth",
      "isCharacter": true
    },
    {
      "id": 1092,
      "bciAvId": 25618,
      "gloss": "sport stick and ball, bandy stick",
      "glossSv": "klubba och boll, bandyklubba",
      "pos": "noun",
      "explanation": "sport stick + ball",
      "isCharacter": true
    },
    {
      "id": 1093,
      "bciAvId": 25619,
      "gloss": "sport stick and puck, hockey stick",
      "glossSv": "klubba och puck, hockeyklubba",
      "pos": "noun",
      "explanation": "sport stick + disk",
      "isCharacter": true
    },
    {
      "id": 1094,
      "bciAvId": 25620,
      "gloss": "square (oblique)",
      "glossSv": "fyrkant (snedställd)",
      "pos": "noun",
      "explanation": "pictograph: a square standing on a corner",
      "isCharacter": true
    },
    {
      "id": 1095,
      "bciAvId": 25621,
      "gloss": "thawing, melting",
      "glossSv": "upptining, smältning",
      "pos": "noun",
      "explanation": "thing + water: solid ice becoming water",
      "isCharacter": true
    },
    {
      "id": 1096,
      "bciAvId": 25622,
      "gloss": "thinness, narrowness",
      "glossSv": "tunnhet, smalhet",
      "pos": "noun",
      "explanation": "two reference lines + two pointers: the pointers point inward toward the narrow space formed by the reference lines",
      "isCharacter": true
    },
    {
      "id": 1097,
      "bciAvId": 25623,
      "gloss": "three Danish waters",
      "glossSv": "tre vatten (Danmark) (FD)",
      "pos": "noun",
      "explanation": "water [modification, higher position] + water + water [modification, lower position]: three channels of water used in the old Bliss-word for Denmark",
      "isCharacter": true
    },
    {
      "id": 1098,
      "bciAvId": 25624,
      "gloss": "trailer, container transport",
      "glossSv": "släp, släpvagn, trailer",
      "pos": "noun",
      "explanation": "vehicle + enclosure [modification, high position] [combination]",
      "isCharacter": true
    },
    {
      "id": 1099,
      "bciAvId": 25625,
      "gloss": "transport, transportation",
      "glossSv": "transport",
      "pos": "noun",
      "explanation": "thing [modification, high position] + wheel: moving something by vehicle",
      "isCharacter": true
    },
    {
      "id": 1100,
      "bciAvId": 25626,
      "gloss": "tree or wood destruction",
      "glossSv": "träddöd, träförstörelse",
      "pos": "noun",
      "explanation": "tree + deletion,cancellation,destruction: processes that destroy trees or wood",
      "isCharacter": true
    },
    {
      "id": 1101,
      "bciAvId": 25627,
      "gloss": "turn, turning",
      "glossSv": "vändning",
      "pos": "noun",
      "explanation": "curved line + arrowhead: curved arrow from skyline - down, forward and backward, to earthline",
      "isCharacter": true
    },
    {
      "id": 1102,
      "bciAvId": 25628,
      "gloss": "under (ground level)",
      "glossSv": "under (marknivå)",
      "pos": "expression",
      "explanation": "earth,ground,land + reference dot (under ground level): combination of ground and under",
      "isCharacter": true
    },
    {
      "id": 1103,
      "bciAvId": 25629,
      "gloss": "understanding, comprehension",
      "glossSv": "förståelse",
      "pos": "noun",
      "explanation": "into + knowledge: combination of knowledge and into - to enter into one's store of knowledge",
      "isCharacter": true
    },
    {
      "id": 1104,
      "bciAvId": 25630,
      "gloss": "unfolding",
      "glossSv": "utvikning, uppslagning, uppveckling",
      "pos": "noun",
      "explanation": "vertical reference line + horizontal reference line + pictograph, of a small curved arrow (to the left and up): the arrow has pushed the vertical reference line up from the horizontal line, as if opening a folder",
      "isCharacter": true
    },
    {
      "id": 1105,
      "bciAvId": 25631,
      "gloss": "Union Jack pattern",
      "glossSv": "Union-Jackmönster",
      "pos": "noun",
      "explanation": "pictograph of Union Jack flag pattern",
      "isCharacter": true
    },
    {
      "id": 1106,
      "bciAvId": 25632,
      "gloss": "water animal (big tail)",
      "glossSv": "vattendjur (stor svans)",
      "pos": "noun",
      "explanation": "animal (water) + pictograph, of a big tail: used in beaver 12646",
      "isCharacter": true
    },
    {
      "id": 1107,
      "bciAvId": 25633,
      "gloss": "water on ground (flooding)",
      "glossSv": "vattensamling (översvämmande)",
      "pos": "noun",
      "explanation": "water + land: water flooding over land",
      "isCharacter": true
    },
    {
      "id": 1108,
      "bciAvId": 25634,
      "gloss": "wideness, broadness",
      "glossSv": "vidd, bredd",
      "pos": "noun",
      "explanation": "reference line + pointer (left) + pointer (right) + reference line: the pointers point outward to the widest space bounded by the reference lines",
      "isCharacter": true
    },
    {
      "id": 1109,
      "bciAvId": 25635,
      "gloss": "wok, wok pan",
      "glossSv": "wok, wokpanna",
      "pos": "noun",
      "explanation": "container,bowl,holder,pouch,basket + pictograph, of a handle",
      "isCharacter": true
    },
    {
      "id": 1110,
      "bciAvId": 25636,
      "gloss": "woman (below waist)",
      "glossSv": "kvinna (nederdel)",
      "pos": "noun",
      "explanation": "woman + pointer, to lower part of the body",
      "isCharacter": true
    },
    {
      "id": 1111,
      "bciAvId": 25681,
      "gloss": "claw (shellfish)",
      "glossSv": "klo (skaldjur)",
      "pos": "noun",
      "explanation": "crab,shellfish (with claws) + pointer, to claw",
      "isCharacter": true
    },
    {
      "id": 1112,
      "bciAvId": 25710,
      "gloss": "family, couple (female)",
      "glossSv": "par, familj (kvinnor)",
      "pos": "person",
      "explanation": "woman + protection + woman",
      "isCharacter": true
    },
    {
      "id": 1113,
      "bciAvId": 25711,
      "gloss": "family, couple (male)",
      "glossSv": "par, familj (män)",
      "pos": "person",
      "explanation": "man + protection + man",
      "isCharacter": true
    },
    {
      "id": 1114,
      "bciAvId": 25712,
      "gloss": "family (female)",
      "glossSv": "familj (kvinnor)",
      "pos": "person",
      "explanation": "woman + birth + woman",
      "isCharacter": true
    },
    {
      "id": 1115,
      "bciAvId": 25713,
      "gloss": "family (male)",
      "glossSv": "familj (män)",
      "pos": "person",
      "explanation": "man + birth + man",
      "isCharacter": true
    },
    {
      "id": 1116,
      "bciAvId": 25748,
      "gloss": "layer, level",
      "glossSv": "lager, skikt",
      "pos": "noun",
      "explanation": "pictograph: three half-sized horizontal reference lines on top of each other suggesting layers or levels",
      "isCharacter": true
    },
    {
      "id": 1117,
      "bciAvId": 25777,
      "gloss": "puddle, pool, water (ground level)",
      "glossSv": "vattenpöl, vattenpuss",
      "pos": "noun",
      "explanation": "water,fluid,liquid [modification, on the ground]",
      "isCharacter": true
    },
    {
      "id": 1118,
      "bciAvId": 25779,
      "gloss": "reality",
      "glossSv": "verklighet",
      "pos": "noun",
      "explanation": "life + earth,ground,land",
      "isCharacter": true
    },
    {
      "id": 1119,
      "bciAvId": 25783,
      "gloss": "root",
      "glossSv": "rot",
      "pos": "noun",
      "explanation": "earth + pictograph of root",
      "isCharacter": true
    },
    {
      "id": 1120,
      "bciAvId": 25812,
      "gloss": "stepparent, step-parent",
      "glossSv": "styvförälder",
      "pos": "person",
      "explanation": "spouse + parent",
      "isCharacter": true
    },
    {
      "id": 1121,
      "bciAvId": 25822,
      "gloss": "tooth",
      "glossSv": "tand",
      "pos": "noun",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 1122,
      "bciAvId": 25878,
      "gloss": "fiber, fibre, fibril, filament, strand",
      "glossSv": "fiber, filament, fibrill, tråd (otvinnad)",
      "pos": "noun",
      "explanation": "pictograph, of a fiber",
      "isCharacter": true
    },
    {
      "id": 1123,
      "bciAvId": 25894,
      "gloss": "into (backward)",
      "glossSv": "in i (bakåt)",
      "pos": "expression",
      "explanation": "backward + enclosure: the arrow going backward into an enclosure",
      "isCharacter": true
    },
    {
      "id": 1124,
      "bciAvId": 25895,
      "gloss": "into (downward)",
      "glossSv": "in i (nedåt)",
      "pos": "expression",
      "explanation": "downward [modification, higher position] + enclosure: the arrow going downward into an enclosure",
      "isCharacter": true
    },
    {
      "id": 1125,
      "bciAvId": 25896,
      "gloss": "into (upward)",
      "glossSv": "in i (uppåt)",
      "pos": "expression",
      "explanation": "upward [modification, lower position] + enclosure: the arrow going upward into an enclosure",
      "isCharacter": true
    },
    {
      "id": 1126,
      "bciAvId": 25972,
      "gloss": "zigzag line",
      "glossSv": "sicksacklinje",
      "pos": "expression",
      "explanation": "pictograph",
      "isCharacter": true
    },
    {
      "id": 1127,
      "bciAvId": 26040,
      "gloss": "body with mane",
      "glossSv": "kropp (med man)",
      "pos": "noun",
      "explanation": "body + hair (on top)",
      "isCharacter": true
    },
    {
      "id": 1128,
      "bciAvId": 26041,
      "gloss": "body with navel",
      "glossSv": "kropp (med navel)",
      "pos": "noun",
      "explanation": "body + dot",
      "isCharacter": true
    },
    {
      "id": 1129,
      "bciAvId": 26042,
      "gloss": "body with pubic hair",
      "glossSv": "krop (med pubeshår)",
      "pos": "noun",
      "explanation": "body + hair (at bottom)",
      "isCharacter": true
    },
    {
      "id": 1130,
      "bciAvId": 26043,
      "gloss": "building with attic",
      "glossSv": "hus ( med vindsvåning)",
      "pos": "noun",
      "explanation": "house + pictograph of attic",
      "isCharacter": true
    },
    {
      "id": 1131,
      "bciAvId": 26044,
      "gloss": "building with cellar",
      "glossSv": "hus (med källare)",
      "pos": "noun",
      "explanation": "house + pictograph of cellar",
      "isCharacter": true
    },
    {
      "id": 1132,
      "bciAvId": 26045,
      "gloss": "building with chimney",
      "glossSv": "hus (med skorsten)",
      "pos": "noun",
      "explanation": "house + pictograph of chimney",
      "isCharacter": true
    },
    {
      "id": 1133,
      "bciAvId": 26046,
      "gloss": "building with foundation",
      "glossSv": "hus (med grund)",
      "pos": "noun",
      "explanation": "house + pictograph of foundation",
      "isCharacter": true
    },
    {
      "id": 1134,
      "bciAvId": 26047,
      "gloss": "building with storey",
      "glossSv": "hus (med våningar)",
      "pos": "noun",
      "explanation": "house + pictograph of storey",
      "isCharacter": true
    },
    {
      "id": 1135,
      "bciAvId": 26048,
      "gloss": "building with yard and fence",
      "glossSv": "hus ( med gård och staket)",
      "pos": "noun",
      "explanation": "house + pictograph of yard and fence",
      "isCharacter": true
    },
    {
      "id": 1136,
      "bciAvId": 26049,
      "gloss": "buildings with courtyard",
      "glossSv": "hus (med gårdsplan)",
      "pos": "noun",
      "explanation": "house + ground + house",
      "isCharacter": true
    },
    {
      "id": 1137,
      "bciAvId": 26050,
      "gloss": "bulbous plant",
      "glossSv": "lökväxt",
      "pos": "noun",
      "explanation": "bulb (plant) + flower",
      "isCharacter": true
    },
    {
      "id": 1138,
      "bciAvId": 26051,
      "gloss": "eye with eyebrow",
      "glossSv": "öga (med ögonbryn)",
      "pos": "noun",
      "explanation": "eye + line [half-sized, above]",
      "isCharacter": true
    },
    {
      "id": 1139,
      "bciAvId": 26052,
      "gloss": "face with beard",
      "glossSv": "ansikte (med skägg)",
      "pos": "noun",
      "explanation": "face + hair [modification, below chin]",
      "isCharacter": true
    },
    {
      "id": 1140,
      "bciAvId": 26053,
      "gloss": "face with pimple",
      "glossSv": "ansikte (med finne)",
      "pos": "noun",
      "explanation": "face + dot (on cheek)",
      "isCharacter": true
    },
    {
      "id": 1141,
      "bciAvId": 26054,
      "gloss": "furred animal",
      "glossSv": "pälsdjur",
      "pos": "noun",
      "explanation": "animal + hair (on top)",
      "isCharacter": true
    },
    {
      "id": 1142,
      "bciAvId": 26055,
      "gloss": "throat",
      "glossSv": "huvud och hals",
      "pos": "noun",
      "explanation": "head + pictograph of neck",
      "isCharacter": true
    },
    {
      "id": 1143,
      "bciAvId": 26056,
      "gloss": "head with hair",
      "glossSv": "huvud (med hår)",
      "pos": "noun",
      "explanation": "head + hair [modification, on top of head]",
      "isCharacter": true
    },
    {
      "id": 1144,
      "bciAvId": 26057,
      "gloss": "mountains with valley",
      "glossSv": "berg (med dal)",
      "pos": "noun",
      "explanation": "mountain + ground + mountain [modification, mirrored]",
      "isCharacter": true
    },
    {
      "id": 1145,
      "bciAvId": 26058,
      "gloss": "out of body (downward), excretion",
      "glossSv": "ut ur kropp (nedåt), utsöndring, avsöndring, avföring",
      "pos": "noun",
      "explanation": "body + down,downward",
      "isCharacter": true
    },
    {
      "id": 1146,
      "bciAvId": 26059,
      "gloss": "pointer, arrowhead",
      "glossSv": "pekare, pilspets",
      "pos": "noun",
      "explanation": "pictograph of pointer or arrowhead: pointing downward, but can be in any of 8 directions",
      "isCharacter": true
    },
    {
      "id": 1147,
      "bciAvId": 26060,
      "gloss": "pointer, arrowhead (small)",
      "glossSv": "pekare, pilspets (liten)",
      "pos": "noun",
      "explanation": "pictograph of small pointer or arrowhead: pointing downward, but can be in any of 8 directions",
      "isCharacter": true
    },
    {
      "id": 1148,
      "bciAvId": 26061,
      "gloss": "road and car",
      "glossSv": "väg, bilväg",
      "pos": "noun",
      "explanation": "ground [modification, prolonged] + car",
      "isCharacter": true
    },
    {
      "id": 1149,
      "bciAvId": 26062,
      "gloss": "steering wheel",
      "glossSv": "ratt",
      "pos": "noun",
      "explanation": "car,automobile,motor vehicle + pointer to steering wheel",
      "isCharacter": true
    },
    {
      "id": 1150,
      "bciAvId": 26063,
      "gloss": "street and building",
      "glossSv": "bebyggelse",
      "pos": "noun",
      "explanation": "ground + house",
      "isCharacter": true
    },
    {
      "id": 1151,
      "bciAvId": 26064,
      "gloss": "one third",
      "glossSv": "en tredjedel",
      "pos": "expression",
      "explanation": "one (digit),1 [modification, higher position] + slash (slanted line) + three (digit),3: a common way to write 1/3",
      "isCharacter": true
    },
    {
      "id": 1152,
      "bciAvId": 26065,
      "gloss": "two thirds",
      "glossSv": "två tredjedelar",
      "pos": "expression",
      "explanation": "two (digit),2 [modification, higher position] + slash (slanted line) + three (digit),3: a common way to write 2/3",
      "isCharacter": true
    },
    {
      "id": 1153,
      "bciAvId": 26066,
      "gloss": "three quarters",
      "glossSv": "tre fjärdedelar",
      "pos": "expression",
      "explanation": "three (digit),3 [modification, higher position] + slash (slanted line) + four (digit),4: a common way to write ¾",
      "isCharacter": true
    },
    {
      "id": 1154,
      "bciAvId": 26165,
      "gloss": "environs",
      "glossSv": "omgivning",
      "pos": "noun",
      "explanation": "earth,ground,land [half-sized]",
      "isCharacter": true
    },
    {
      "id": 1155,
      "bciAvId": 26197,
      "gloss": "membrane, drumhead, drum skin",
      "glossSv": "trumskinn, membran",
      "pos": "noun",
      "explanation": "drum (1) + pointer, to the membrane of the drum skin",
      "isCharacter": true
    },
    {
      "id": 1156,
      "bciAvId": 26211,
      "gloss": "northeast",
      "glossSv": "nordöst",
      "pos": "noun",
      "explanation": "sun + pointer, to northeast",
      "isCharacter": true
    },
    {
      "id": 1157,
      "bciAvId": 26212,
      "gloss": "northwest",
      "glossSv": "nordväst",
      "pos": "noun",
      "explanation": "sun + pointer, to northwest",
      "isCharacter": true
    },
    {
      "id": 1158,
      "bciAvId": 26245,
      "gloss": "southeast",
      "glossSv": "sydöst",
      "pos": "noun",
      "explanation": "sun + pointer, to southeast",
      "isCharacter": true
    },
    {
      "id": 1159,
      "bciAvId": 26246,
      "gloss": "southwest",
      "glossSv": "sydväst",
      "pos": "noun",
      "explanation": "sun + pointer, to southwest",
      "isCharacter": true
    },
    {
      "id": 1160,
      "bciAvId": 26323,
      "gloss": "pate, crown (body part)",
      "glossSv": "hjässa",
      "pos": "noun",
      "explanation": "head + pointer to the top of the head",
      "isCharacter": true
    },
    {
      "id": 1161,
      "bciAvId": 13377,
      "gloss": "colour, color",
      "glossSv": "färg",
      "pos": "noun",
      "explanation": "eye + earth [half-sized]: what the eye receives from things on earth",
      "isCharacter": true
    },
    {
      "id": 1162,
      "bciAvId": 24881,
      "gloss": "continuance, continuation",
      "glossSv": "fortsättning",
      "pos": "noun",
      "explanation": "forward [modification, extended] + reference line [half-sized]: the arrow passes a reference line and continues on",
      "isCharacter": true
    },
    {
      "id": 1163,
      "bciAvId": 25257,
      "gloss": "stretch, expansion",
      "glossSv": "växling, omväxling",
      "pos": "noun",
      "explanation": "forward + backward [modification, short arrows]",
      "isCharacter": true
    },
    {
      "id": 1164,
      "bciAvId": 12323,
      "gloss": "abortion (induced)",
      "glossSv": "abort",
      "pos": "noun",
      "explanation": "to cause + miscarriage,abortion (spontaneous)",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        1021,
        "/",
        710
      ]
    },
    {
      "id": 1165,
      "bciAvId": 12325,
      "gloss": "absorbent material, sponge",
      "glossSv": "absorberande material, tvättsvamp",
      "pos": "noun",
      "explanation": "material + into",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        402
      ]
    },
    {
      "id": 1166,
      "bciAvId": 12326,
      "gloss": "celibacy, chastity, abstinence",
      "glossSv": "avhållsamhet (sexuell)",
      "pos": "noun",
      "explanation": "to decide + without + sexual intercourse",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        232,
        "/",
        349
      ]
    },
    {
      "id": 1167,
      "bciAvId": 12327,
      "gloss": "abuse, assault, violence",
      "glossSv": "misshandel, våld",
      "pos": "noun",
      "explanation": "force + intensity",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401
      ]
    },
    {
      "id": 1168,
      "bciAvId": 12328,
      "gloss": "accessory",
      "glossSv": "accessoarer",
      "pos": "noun",
      "explanation": "thing + plus + clothing: something added to one's clothing",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        120,
        "/",
        229
      ]
    },
    {
      "id": 1169,
      "bciAvId": 12329,
      "gloss": "accident, chance event",
      "glossSv": "slump, tillfällighet",
      "pos": "noun",
      "explanation": "event + without + to expect: unexpected event",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        449,
        "/",
        301
      ]
    },
    {
      "id": 1170,
      "bciAvId": 12331,
      "gloss": "ache",
      "glossSv": "värk",
      "pos": "noun",
      "explanation": "pain + to continue: pain that goes on and on",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        1162
      ]
    },
    {
      "id": 1171,
      "bciAvId": 12332,
      "gloss": "acne",
      "glossSv": "acne, finnar, utslag",
      "pos": "noun",
      "explanation": "many + pimple",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        523
      ]
    },
    {
      "id": 1172,
      "bciAvId": 12336,
      "gloss": "active, actively",
      "glossSv": "aktiv, verksam",
      "pos": "description",
      "explanation": "activity + description indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        86
      ]
    },
    {
      "id": 1173,
      "bciAvId": 12337,
      "gloss": "Adar",
      "glossSv": "Adar (Israel)",
      "pos": "noun",
      "explanation": "month + megillah: month of Purim (Hebrew)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        1999
      ]
    },
    {
      "id": 1174,
      "bciAvId": 12338,
      "gloss": "to add, to gain",
      "glossSv": "lägga till, sätta till, addera",
      "pos": "action",
      "explanation": "addition + action indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        81
      ]
    },
    {
      "id": 1175,
      "bciAvId": 12340,
      "gloss": "adolescence",
      "glossSv": "tonåren",
      "pos": "noun",
      "explanation": "limited time + adolescent",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        643
      ]
    },
    {
      "id": 1176,
      "bciAvId": 12342,
      "gloss": "adult, mature",
      "glossSv": "vuxen, mogen",
      "pos": "description",
      "explanation": "adult + description indicator",
      "isCharacter": false,
      "composition": [
        108,
        ";",
        86
      ]
    },
    {
      "id": 1177,
      "bciAvId": 12343,
      "gloss": "to advance, to go",
      "glossSv": "gå, gå framåt",
      "pos": "action",
      "explanation": "forward + action indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81
      ]
    },
    {
      "id": 1178,
      "bciAvId": 12344,
      "gloss": "advertisement",
      "glossSv": "annons, reklamblad",
      "pos": "noun",
      "explanation": "page + attention: paper that attracts one's attention",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        303,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1179,
      "bciAvId": 12345,
      "gloss": "advice, counsel, recommendation",
      "glossSv": "råd",
      "pos": "noun",
      "explanation": "suggestion + to help",
      "isCharacter": false,
      "composition": [
        485,
        "/",
        551,
        "/",
        "RK:-2",
        "/",
        382
      ]
    },
    {
      "id": 1180,
      "bciAvId": 12346,
      "gloss": "to advise, to counsel, to recommend",
      "glossSv": "råda",
      "pos": "action",
      "explanation": "advice + action indicator",
      "isCharacter": false,
      "composition": [
        485,
        ";",
        81,
        "/",
        551,
        "/",
        "RK:-2",
        "/",
        382
      ]
    },
    {
      "id": 1181,
      "bciAvId": 12347,
      "gloss": "afraid, frightened, scared",
      "glossSv": "rädd",
      "pos": "description",
      "explanation": "fear,fright,concern + description indicator: sad about the future because of its uncertainties",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        271,
        "/",
        1042
      ]
    },
    {
      "id": 1182,
      "bciAvId": 12349,
      "gloss": "afternoon",
      "glossSv": "eftermiddag",
      "pos": "noun",
      "explanation": "day + after + 12: the part of the day after noon",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        109,
        "/",
        10,
        "/",
        11
      ]
    },
    {
      "id": 1183,
      "bciAvId": 12353,
      "gloss": "to agree",
      "glossSv": "hålla med, komma överens",
      "pos": "action",
      "explanation": "agreement + action indicator",
      "isCharacter": false,
      "composition": [
        113,
        ";",
        81
      ]
    },
    {
      "id": 1184,
      "bciAvId": 12355,
      "gloss": "aid, device, support",
      "glossSv": "hjälpmedel",
      "pos": "noun",
      "explanation": "help + thing indicator: concrete thing that aids or supports a person. The symbol is the concrete form of help.",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97
      ]
    },
    {
      "id": 1185,
      "bciAvId": 12358,
      "gloss": "airport",
      "glossSv": "flygplats",
      "pos": "noun",
      "explanation": "building + airplane",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        115
      ]
    },
    {
      "id": 1186,
      "bciAvId": 12361,
      "gloss": "all gone",
      "glossSv": "borta, slut, väck",
      "pos": "expression",
      "explanation": "all + to take away: all taken away",
      "isCharacter": false,
      "composition": [
        117,
        "/",
        634
      ]
    },
    {
      "id": 1187,
      "bciAvId": 12362,
      "gloss": "alligator, crocodile",
      "glossSv": "krokodil (etc)",
      "pos": "noun",
      "explanation": "animal (water) + snake + teeth: combination of water animal and reptile + teeth",
      "isCharacter": false,
      "composition": [
        127,
        "/",
        602,
        "/",
        644
      ]
    },
    {
      "id": 1188,
      "bciAvId": 12363,
      "gloss": "alone, just, only, solitary",
      "glossSv": "bara, endast",
      "pos": "description",
      "explanation": "to be + 1 + description indicator: to be only one",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        86,
        "/",
        10
      ]
    },
    {
      "id": 1189,
      "bciAvId": 12364,
      "gloss": "along with",
      "glossSv": "dessutom",
      "pos": "expression",
      "explanation": "and + and: in addition to",
      "isCharacter": false,
      "composition": [
        120,
        "/",
        120
      ]
    },
    {
      "id": 1190,
      "bciAvId": 12365,
      "gloss": "alpana, rangoli (decoration)",
      "glossSv": "alpana (Indien)",
      "pos": "noun",
      "explanation": "design + floor: decoration used on special occasions",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        323
      ]
    },
    {
      "id": 1191,
      "bciAvId": 12368,
      "gloss": "always, ever, forever",
      "glossSv": "alltid",
      "pos": "description",
      "explanation": "time + all + description indicator: all the time",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 1192,
      "bciAvId": 12369,
      "gloss": "ambulance",
      "glossSv": "ambulans",
      "pos": "noun",
      "explanation": "car + medical",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        958
      ]
    },
    {
      "id": 1193,
      "bciAvId": 12370,
      "gloss": "amenorrhea",
      "glossSv": "mensbortfall",
      "pos": "noun",
      "explanation": "without + menstruation",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        695,
        "/",
        681,
        "/",
        452
      ]
    },
    {
      "id": 1194,
      "bciAvId": 12371,
      "gloss": "amphibian",
      "glossSv": "amfibie",
      "pos": "noun",
      "explanation": "animal + water + earth: animal adapted to life in water and on land",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        1107
      ]
    },
    {
      "id": 1195,
      "bciAvId": 12372,
      "gloss": "to amuse, to entertain, to please",
      "glossSv": "roa, underhålla",
      "pos": "action",
      "explanation": "to give + happiness + action indicator: to give happiness or pleasure",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1196,
      "bciAvId": 12373,
      "gloss": "anal intercourse",
      "glossSv": "analsex, analt samlag",
      "pos": "noun",
      "explanation": "to combine + erect penis + anus [contraction]",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        295,
        "/",
        194
      ]
    },
    {
      "id": 1197,
      "bciAvId": 12375,
      "gloss": "angel",
      "glossSv": "ängel (FD)",
      "pos": "person",
      "explanation": "angel (1) + God: winged person sent by God",
      "isCharacter": false,
      "composition": [
        729,
        "/",
        "RK:-2",
        "/",
        355
      ]
    },
    {
      "id": 1198,
      "bciAvId": 12377,
      "gloss": "angry, angrily, mad",
      "glossSv": "arg, ilsken",
      "pos": "description",
      "explanation": "much + feeling + opposition + description indicator: having strong feelings against someone or something",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        313,
        ";",
        86,
        "/",
        487
      ]
    },
    {
      "id": 1199,
      "bciAvId": 12382,
      "gloss": "domestic animal",
      "glossSv": "husdjur",
      "pos": "noun",
      "explanation": "animal + protection: animal that is cared for in a domestic setting",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        548
      ]
    },
    {
      "id": 1200,
      "bciAvId": 12384,
      "gloss": "marsupial (animal), pouched mammal",
      "glossSv": "känguru, pungdjur",
      "pos": "noun",
      "explanation": "animal + pouch",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        239
      ]
    },
    {
      "id": 1201,
      "bciAvId": 12385,
      "gloss": "animal (protected)",
      "glossSv": "fridlyst djur",
      "pos": "noun",
      "explanation": "animal + protection + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        548,
        ";",
        84
      ]
    },
    {
      "id": 1202,
      "bciAvId": 12386,
      "gloss": "rat, rodent, gnawer, gnawing animal",
      "glossSv": "råtta, gnagare",
      "pos": "noun",
      "explanation": "animal + teeth: animal that gnaws to file its continuously growing teeth",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644
      ]
    },
    {
      "id": 1203,
      "bciAvId": 12387,
      "gloss": "animal skin, hide, pelt",
      "glossSv": "djurhud, skinn",
      "pos": "noun",
      "explanation": "protection + animal: protective covering of an animal",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        122
      ]
    },
    {
      "id": 1204,
      "bciAvId": 12388,
      "gloss": "lizard, reptile (snake like animal)",
      "glossSv": "ödla, kräldjur",
      "pos": "noun",
      "explanation": "animal + snake: snake-like animal",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        602
      ]
    },
    {
      "id": 1205,
      "bciAvId": 12390,
      "gloss": "animal (wild)",
      "glossSv": "vilt djur",
      "pos": "noun",
      "explanation": "animal + open: untamed animal that lives in the open",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        484
      ]
    },
    {
      "id": 1206,
      "bciAvId": 12392,
      "gloss": "anniversary",
      "glossSv": "årsdag",
      "pos": "noun",
      "explanation": "year + again: occasion that comes again every year",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        110
      ]
    },
    {
      "id": 1207,
      "bciAvId": 12394,
      "gloss": "to answer, to reply",
      "glossSv": "svara",
      "pos": "action",
      "explanation": "answer + action indicator",
      "isCharacter": false,
      "composition": [
        129,
        ";",
        81
      ]
    },
    {
      "id": 1208,
      "bciAvId": 12395,
      "gloss": "ant",
      "glossSv": "myra",
      "pos": "noun",
      "explanation": "insect + work + intensity: industrious insect",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        711,
        "/",
        401
      ]
    },
    {
      "id": 1209,
      "bciAvId": 12396,
      "gloss": "anus",
      "glossSv": "analöppning",
      "pos": "noun",
      "explanation": "opening + buttocks",
      "isCharacter": false,
      "composition": [
        484,
        "/",
        194
      ]
    },
    {
      "id": 1210,
      "bciAvId": 12397,
      "gloss": "anxiety",
      "glossSv": "nervositet, oro",
      "pos": "noun",
      "explanation": "upset + future (uncertain): upset about an uncertain future",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        723,
        "/",
        1042
      ]
    },
    {
      "id": 1211,
      "bciAvId": 12398,
      "gloss": "anxious, anxiously",
      "glossSv": "nervös, orolig",
      "pos": "description",
      "explanation": "anxiety + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        723,
        "/",
        1042
      ]
    },
    {
      "id": 1212,
      "bciAvId": 12399,
      "gloss": "anyone, anybody, somebody, someone",
      "glossSv": "någon, vem som helst",
      "pos": "person",
      "explanation": "any + person",
      "isCharacter": false,
      "composition": [
        100,
        "/",
        513
      ]
    },
    {
      "id": 1213,
      "bciAvId": 12400,
      "gloss": "anything, something",
      "glossSv": "någon, något, vad som helst",
      "pos": "expression",
      "explanation": "any + thing",
      "isCharacter": false,
      "composition": [
        100,
        "/",
        651
      ]
    },
    {
      "id": 1214,
      "bciAvId": 12401,
      "gloss": "anytime, sometime",
      "glossSv": "någonsin, när som helst",
      "pos": "expression",
      "explanation": "any + time",
      "isCharacter": false,
      "composition": [
        100,
        "/",
        655
      ]
    },
    {
      "id": 1215,
      "bciAvId": 12403,
      "gloss": "apartment, flat, unit",
      "glossSv": "lägenhet",
      "pos": "noun",
      "explanation": "house + inside + house: dwelling inside a larger building",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        398,
        "/",
        392
      ]
    },
    {
      "id": 1216,
      "bciAvId": 12404,
      "gloss": "to apologise, to apologize, to regret (express)",
      "glossSv": "be om förlåtelse, be om ursäkt",
      "pos": "action",
      "explanation": "to speak + comma + to regret + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        5,
        "/",
        313,
        "/",
        271,
        "/",
        102,
        "/",
        503
      ]
    },
    {
      "id": 1217,
      "bciAvId": 12406,
      "gloss": "appointment",
      "glossSv": "avtalad tid",
      "pos": "noun",
      "explanation": "time + to meet: time agreed upon for a meeting",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        1057
      ]
    },
    {
      "id": 1218,
      "bciAvId": 12407,
      "gloss": "approach",
      "glossSv": "ankommande",
      "pos": "noun",
      "explanation": "forward + reference line: advancing arrow approaches the line but does not reach it",
      "isCharacter": true
    },
    {
      "id": 1219,
      "bciAvId": 12408,
      "gloss": "to approve",
      "glossSv": "godkänna, godta",
      "pos": "action",
      "explanation": "evaluation + correct + action indicator: to evaluate as correct or good in a rational sense",
      "isCharacter": false,
      "composition": [
        297,
        ";",
        81,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 1220,
      "bciAvId": 12409,
      "gloss": "apricot",
      "glossSv": "aprikos",
      "pos": "noun",
      "explanation": "peach + small",
      "isCharacter": false,
      "composition": [
        506,
        "/",
        956
      ]
    },
    {
      "id": 1221,
      "bciAvId": 12410,
      "gloss": "April",
      "glossSv": "april",
      "pos": "noun",
      "explanation": "month + 4: fourth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        13
      ]
    },
    {
      "id": 1222,
      "bciAvId": 12411,
      "gloss": "apron, coverall, smock, overall",
      "glossSv": "förkläde, overall (etc)",
      "pos": "noun",
      "explanation": "protection + clothing: protective covering worn over other clothing",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        229
      ]
    },
    {
      "id": 1223,
      "bciAvId": 12412,
      "gloss": "architect",
      "glossSv": "arkitekt",
      "pos": "person",
      "explanation": "person + to plan + building: person who designs buildings",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        392
      ]
    },
    {
      "id": 1224,
      "bciAvId": 12413,
      "gloss": "to argue, to dispute, to quarrel",
      "glossSv": "diskutera",
      "pos": "action",
      "explanation": "argument + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        144,
        "/",
        401
      ]
    },
    {
      "id": 1225,
      "bciAvId": 12414,
      "gloss": "argument, dispute, quarrel",
      "glossSv": "diskussion",
      "pos": "noun",
      "explanation": "discussion + intensity",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        144,
        "/",
        401
      ]
    },
    {
      "id": 1226,
      "bciAvId": 12579,
      "gloss": "military, armed forces, armed services",
      "glossSv": "militär, väpnade styrkor",
      "pos": "noun",
      "explanation": "group (people) + war: group trained for war",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693
      ]
    },
    {
      "id": 1227,
      "bciAvId": 12581,
      "gloss": "art",
      "glossSv": "konst",
      "pos": "noun",
      "explanation": "man-made + feeling: process of making or producing something that inspires emotion in the beholder",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 1228,
      "bciAvId": 12582,
      "gloss": "art gallery, gallery",
      "glossSv": "konstmuseum, konstgalleri",
      "pos": "noun",
      "explanation": "building + work of art + thing indicator: building where works of art are displayed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 1229,
      "bciAvId": 12583,
      "gloss": "artificial insemination",
      "glossSv": "konstgjord befruktning",
      "pos": "noun",
      "explanation": "aid + medical + conception",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        958,
        "/",
        236
      ]
    },
    {
      "id": 1230,
      "bciAvId": 12584,
      "gloss": "artificial respiration",
      "glossSv": "konstgjord andning",
      "pos": "noun",
      "explanation": "to cause + to breathe",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        "RK:-2",
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 1231,
      "bciAvId": 12585,
      "gloss": "to give artificial respiration, to resuscitate, to revive",
      "glossSv": "ge konstgjord andning",
      "pos": "action",
      "explanation": "artificial respiration + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 1232,
      "bciAvId": 12586,
      "gloss": "ashes",
      "glossSv": "aska",
      "pos": "noun",
      "explanation": "waste + fire",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        319
      ]
    },
    {
      "id": 1233,
      "bciAvId": 12587,
      "gloss": "ashtray",
      "glossSv": "askfat",
      "pos": "noun",
      "explanation": "container + ashes",
      "isCharacter": false,
      "composition": [
        343,
        "/",
        319
      ]
    },
    {
      "id": 1234,
      "bciAvId": 12588,
      "gloss": "to ask, to inquire, to question",
      "glossSv": "fråga (verb)",
      "pos": "action",
      "explanation": "question + action indicator",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81
      ]
    },
    {
      "id": 1235,
      "bciAvId": 12589,
      "gloss": "asleep",
      "glossSv": "sovande",
      "pos": "description",
      "explanation": "sleep + description indicator",
      "isCharacter": false,
      "composition": [
        599,
        ";",
        86
      ]
    },
    {
      "id": 1236,
      "bciAvId": 12590,
      "gloss": "astronaut, cosmonaut",
      "glossSv": "astronaut, rymdfarare",
      "pos": "person",
      "explanation": "person + rocket: person who goes up in a rocket",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1088,
        "/",
        678
      ]
    },
    {
      "id": 1237,
      "bciAvId": 12593,
      "gloss": "attack (of illness)",
      "glossSv": "anfall, attack",
      "pos": "noun",
      "explanation": "illness + limited time",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        426
      ]
    },
    {
      "id": 1238,
      "bciAvId": 12594,
      "gloss": "attention",
      "glossSv": "uppmärksamhet",
      "pos": "noun",
      "explanation": "eye + intensity + intensity: using the eyes intently",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1239,
      "bciAvId": 12595,
      "gloss": "August",
      "glossSv": "augusti",
      "pos": "noun",
      "explanation": "month + 8: eighth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        17
      ]
    },
    {
      "id": 1240,
      "bciAvId": 12597,
      "gloss": "autumn, fall (ckb)",
      "glossSv": "höst (CKB)",
      "pos": "noun",
      "explanation": "sun + 3: third season",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        12
      ]
    },
    {
      "id": 1241,
      "bciAvId": 12598,
      "gloss": "autumn, fall",
      "glossSv": "höst",
      "pos": "noun",
      "explanation": "sun + 3 + leaf + down: third season when the leaves fall",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        12,
        "/",
        416,
        "/",
        271
      ]
    },
    {
      "id": 1242,
      "bciAvId": 12599,
      "gloss": "Av (Hebrew month)",
      "glossSv": "Av (Israel)",
      "pos": "noun",
      "explanation": "month + church ruin,temple ruin,wreck,wreckage (church,temple,mosque) (1): month of the Tisha B'Av, the destruction of the Holy Temple (Hebrew)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        1079,
        "/",
        355
      ]
    },
    {
      "id": 1243,
      "bciAvId": 12601,
      "gloss": "awake",
      "glossSv": "vaken",
      "pos": "description",
      "explanation": "wakefulness,alertness + description indicator: state one is in when one's eyes are open",
      "isCharacter": false,
      "composition": [
        969,
        ";",
        86
      ]
    },
    {
      "id": 1244,
      "bciAvId": 12605,
      "gloss": "baby carriage, buggy, pram, pushchair, stroller",
      "glossSv": "barnvagn, sulky",
      "pos": "noun",
      "explanation": "wagon + baby: carriage for a baby",
      "isCharacter": false,
      "composition": [
        689,
        "/",
        140
      ]
    },
    {
      "id": 1245,
      "bciAvId": 12606,
      "gloss": "baby clinic",
      "glossSv": "barnavårdscentral",
      "pos": "noun",
      "explanation": "clinic + baby",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        958,
        "/",
        140
      ]
    },
    {
      "id": 1246,
      "bciAvId": 12608,
      "gloss": "babysitter",
      "glossSv": "barnvakt",
      "pos": "person",
      "explanation": "person + to protect + child: person who cares for a child",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        548,
        "/",
        220
      ]
    },
    {
      "id": 1247,
      "bciAvId": 12611,
      "gloss": "backpack, rucksack",
      "glossSv": "ryggsäck",
      "pos": "noun",
      "explanation": "sack + back",
      "isCharacter": false,
      "composition": [
        574,
        "/",
        143
      ]
    },
    {
      "id": 1248,
      "bciAvId": 12612,
      "gloss": "to back up",
      "glossSv": "gå tillbaka, gå bakåt, backa",
      "pos": "action",
      "explanation": "backward + action indicator",
      "isCharacter": false,
      "composition": [
        145,
        ";",
        81
      ]
    },
    {
      "id": 1249,
      "bciAvId": 12614,
      "gloss": "bacon",
      "glossSv": "bacon, fläsk",
      "pos": "noun",
      "explanation": "pork + linear thing: pork in strips",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        521,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 1250,
      "bciAvId": 12615,
      "gloss": "bad, wrong",
      "glossSv": "dålig",
      "pos": "description",
      "explanation": "feeling + negative + description indicator: felt to be negative or bad in an emotional sense",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1251,
      "bciAvId": 12617,
      "gloss": "badminton (activity)",
      "glossSv": "badminton (aktivitet)",
      "pos": "noun",
      "explanation": "activity + shuttlecock: game played with a feathered shuttlecock",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1082
      ]
    },
    {
      "id": 1252,
      "bciAvId": 12619,
      "gloss": "to bake, to cook, to roast",
      "glossSv": "baka, grädda, steka (i ugn)",
      "pos": "action",
      "explanation": "to cook + enclosure + action indicator: to cook inside an enclosure e.g. oven",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        291
      ]
    },
    {
      "id": 1253,
      "bciAvId": 12620,
      "gloss": "balcony, porch, veranda",
      "glossSv": "balkong, uterum, veranda",
      "pos": "noun",
      "explanation": "room + outside",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        490
      ]
    },
    {
      "id": 1254,
      "bciAvId": 12624,
      "gloss": "band, orchestra",
      "glossSv": "orkester, band, musikkår (FD)",
      "pos": "person",
      "explanation": "group (people) + musical instrument",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        660,
        "/",
        462
      ]
    },
    {
      "id": 1255,
      "bciAvId": 12625,
      "gloss": "bandage, dressing",
      "glossSv": "bandage, förband, plåster",
      "pos": "noun",
      "explanation": "cloth + protection + medical",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        548,
        "/",
        958
      ]
    },
    {
      "id": 1256,
      "bciAvId": 12626,
      "gloss": "bank",
      "glossSv": "bank",
      "pos": "noun",
      "explanation": "building + money",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        451
      ]
    },
    {
      "id": 1257,
      "bciAvId": 12627,
      "gloss": "bar, pub",
      "glossSv": "bar, pub",
      "pos": "noun",
      "explanation": "public room + alcoholic drink",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        116
      ]
    },
    {
      "id": 1258,
      "bciAvId": 12628,
      "gloss": "barber, hairdresser",
      "glossSv": "frisör, hårfrisörska",
      "pos": "person",
      "explanation": "person + hair",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        372
      ]
    },
    {
      "id": 1259,
      "bciAvId": 12629,
      "gloss": "barbershop, beauty shop",
      "glossSv": "frisersalong",
      "pos": "noun",
      "explanation": "public room + hair",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        372
      ]
    },
    {
      "id": 1260,
      "bciAvId": 12630,
      "gloss": "barn, stable, shed",
      "glossSv": "ladugård, stall",
      "pos": "noun",
      "explanation": "building + animal: building for animals",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        122
      ]
    },
    {
      "id": 1261,
      "bciAvId": 12632,
      "gloss": "baseball (activity)",
      "glossSv": "baseboll (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball + corner: the corner character here represents the baseball diamond with the pointer to a base in a corner: ball game played on a diamond",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        148,
        "/",
        1011
      ]
    },
    {
      "id": 1262,
      "bciAvId": 12633,
      "gloss": "base camp",
      "glossSv": "samlingsplats",
      "pos": "noun",
      "explanation": "place + to gather",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        346
      ]
    },
    {
      "id": 1263,
      "bciAvId": 12634,
      "gloss": "basketball (activity)",
      "glossSv": "basketboll (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball + container,basket (high): game in which a ball is tossed into a high basket",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        148,
        "/",
        1009
      ]
    },
    {
      "id": 1264,
      "bciAvId": 12635,
      "gloss": "bat (sport)",
      "glossSv": "slagträ",
      "pos": "noun",
      "explanation": "linear thing + ball + thing indicator: linear thing used to hit a ball",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        148
      ]
    },
    {
      "id": 1265,
      "bciAvId": 12637,
      "gloss": "bathroom, washroom",
      "glossSv": "badrum, tvättrum",
      "pos": "noun",
      "explanation": "room + bath",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        595
      ]
    },
    {
      "id": 1266,
      "bciAvId": 12638,
      "gloss": "battery",
      "glossSv": "batteri",
      "pos": "noun",
      "explanation": "container + electricity: receptacle that stores and generates electricity",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        288
      ]
    },
    {
      "id": 1267,
      "bciAvId": 12639,
      "gloss": "to be, to am, to are, to is, to exist",
      "glossSv": "vara, finnas",
      "pos": "action",
      "explanation": "to live [half-sized] + action indicator: the \"little meaning\" of to live",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        81
      ]
    },
    {
      "id": 1268,
      "bciAvId": 12641,
      "gloss": "beach tennis (activity)",
      "glossSv": "strandtennis (aktivitet) (FD)",
      "pos": "noun",
      "explanation": "tennis (activity) (OLD) + beach",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1016,
        "/",
        153
      ]
    },
    {
      "id": 1269,
      "bciAvId": 12643,
      "gloss": "bear",
      "glossSv": "björn",
      "pos": "noun",
      "explanation": "animal + bear's head: animal + pictograph of a bear's head",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        925
      ]
    },
    {
      "id": 1270,
      "bciAvId": 12645,
      "gloss": "beautiful, attractive, good-looking, handsome, pretty",
      "glossSv": "vacker, snygg, söt",
      "pos": "description",
      "explanation": "beauty + description indicator: pleasing to the eye",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1271,
      "bciAvId": 12646,
      "gloss": "beaver",
      "glossSv": "bäver",
      "pos": "noun",
      "explanation": "water animal (big tail) + teeth: can be interpreted as a combination of water animal (with a big tail) and rodent, a large, flat-tailed rodent that makes its home in water",
      "isCharacter": false,
      "composition": [
        1106,
        "/",
        644
      ]
    },
    {
      "id": 1272,
      "bciAvId": 12647,
      "gloss": "because",
      "glossSv": "därför",
      "pos": "expression",
      "explanation": "cause [half-sized] + what,question mark. CKB points out that this symbol is the reverse of why, and reminds us that the question mark remains to show that not all answers beginning with \"because\" are complete or satisfactory.",
      "isCharacter": false,
      "composition": [
        650,
        "/",
        699
      ]
    },
    {
      "id": 1273,
      "bciAvId": 12648,
      "gloss": "to become",
      "glossSv": "bli",
      "pos": "action",
      "explanation": "to advance + to be + action indicator: to come to be",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        894
      ]
    },
    {
      "id": 1274,
      "bciAvId": 12650,
      "gloss": "bedroom",
      "glossSv": "sovrum",
      "pos": "noun",
      "explanation": "room + to sleep",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        599
      ]
    },
    {
      "id": 1275,
      "bciAvId": 12651,
      "gloss": "bee, bumblebee, hoverfly",
      "glossSv": "bi",
      "pos": "noun",
      "explanation": "fly + flower: flying insect that obtains nectar and pollen from flowers",
      "isCharacter": false,
      "composition": [
        327,
        "/",
        325
      ]
    },
    {
      "id": 1276,
      "bciAvId": 12652,
      "gloss": "beef",
      "glossSv": "nötkött",
      "pos": "noun",
      "explanation": "food + bovine: food that comes from a steer or cow. The symbol also can be explained as: combination of meat and bovine",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        123
      ]
    },
    {
      "id": 1277,
      "bciAvId": 12653,
      "gloss": "beer",
      "glossSv": "öl",
      "pos": "noun",
      "explanation": "alcoholic drink + gas: alcoholic drink that has bubbles or foam",
      "isCharacter": false,
      "composition": [
        116,
        "/",
        345
      ]
    },
    {
      "id": 1278,
      "bciAvId": 12654,
      "gloss": "beet, beetroot",
      "glossSv": "rödbeta",
      "pos": "noun",
      "explanation": "vegetable (large-leafed) + red: vegetable with a red, edible root",
      "isCharacter": false,
      "composition": [
        671,
        "/",
        1161,
        "/",
        457
      ]
    },
    {
      "id": 1279,
      "bciAvId": 12657,
      "gloss": "to begin, to start",
      "glossSv": "börja, starta",
      "pos": "action",
      "explanation": "beginning + action indicator",
      "isCharacter": false,
      "composition": [
        159,
        ";",
        81
      ]
    },
    {
      "id": 1280,
      "bciAvId": 12659,
      "gloss": "behaviour, behavior",
      "glossSv": "beteende, uppträdande",
      "pos": "noun",
      "explanation": "action + creature + thing indicator: action of a living being",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        423,
        ";",
        97
      ]
    },
    {
      "id": 1281,
      "bciAvId": 12660,
      "gloss": "belief",
      "glossSv": "tro (subst.)",
      "pos": "noun",
      "explanation": "feeling + hypothesis,theory: where hypothesis,theory represents truth [contraction], what one feels to be true, without needing proof",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1048
      ]
    },
    {
      "id": 1282,
      "bciAvId": 12661,
      "gloss": "to believe",
      "glossSv": "tro (verb)",
      "pos": "action",
      "explanation": "belief + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        1048
      ]
    },
    {
      "id": 1283,
      "bciAvId": 12662,
      "gloss": "bell",
      "glossSv": "ringklocka, klocka",
      "pos": "noun",
      "explanation": "thing + 1 + musical note: thing with one musical note",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        10,
        "/",
        462
      ]
    },
    {
      "id": 1284,
      "bciAvId": 12664,
      "gloss": "belt, sash",
      "glossSv": "bälte, skärp",
      "pos": "noun",
      "explanation": "linear thing + waist + thing indicator: linear thing worn at the waist",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        690
      ]
    },
    {
      "id": 1285,
      "bciAvId": 12665,
      "gloss": "bench, pew",
      "glossSv": "bänk",
      "pos": "noun",
      "explanation": "seat + long",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        420
      ]
    },
    {
      "id": 1286,
      "bciAvId": 12667,
      "gloss": "best",
      "glossSv": "bäst",
      "pos": "description",
      "explanation": "most + good + description indicator",
      "isCharacter": false,
      "composition": [
        968,
        "/",
        313,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1287,
      "bciAvId": 12668,
      "gloss": "better",
      "glossSv": "bättre",
      "pos": "description",
      "explanation": "more + good + description indicator",
      "isCharacter": false,
      "composition": [
        937,
        "/",
        313,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1288,
      "bciAvId": 12670,
      "gloss": "beyond, past",
      "glossSv": "bortom (FD)",
      "pos": "description",
      "explanation": "outside + limit(s),limitation (OLD) + description indicator",
      "isCharacter": false,
      "composition": [
        490,
        "/",
        427,
        ";",
        86
      ]
    },
    {
      "id": 1289,
      "bciAvId": 12833,
      "gloss": "bib",
      "glossSv": "haklapp",
      "pos": "noun",
      "explanation": "protection + chest: protective covering for the upper body",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        218
      ]
    },
    {
      "id": 1290,
      "bciAvId": 12834,
      "gloss": "bicycle",
      "glossSv": "cykel",
      "pos": "noun",
      "explanation": "2 + wheel: two wheeled cycle",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700
      ]
    },
    {
      "id": 1291,
      "bciAvId": 12835,
      "gloss": "big, large",
      "glossSv": "stor",
      "pos": "description",
      "explanation": "bigness,largeness + description indicator: the vertical line extends to the biggest possible size within the symbol square",
      "isCharacter": false,
      "composition": [
        936,
        ";",
        86
      ]
    },
    {
      "id": 1292,
      "bciAvId": 12836,
      "gloss": "bindi, tika (decoration)",
      "glossSv": "bindi, tiki (Indien)",
      "pos": "noun",
      "explanation": "dot + colour + forehead: spot worn on the forehead of Hindu women",
      "isCharacter": false,
      "composition": [
        270,
        "/",
        1161,
        "/",
        333
      ]
    },
    {
      "id": 1293,
      "bciAvId": 12838,
      "gloss": "bird (domestic)",
      "glossSv": "tamfågel",
      "pos": "noun",
      "explanation": "bird + protection: bird that is cared for in a domestic setting",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        548
      ]
    },
    {
      "id": 1294,
      "bciAvId": 12839,
      "gloss": "bird (protected)",
      "glossSv": "fridlyst fågel",
      "pos": "noun",
      "explanation": "bird + protection + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        548,
        ";",
        84
      ]
    },
    {
      "id": 1295,
      "bciAvId": 12841,
      "gloss": "bird (wild)",
      "glossSv": "vildfågel",
      "pos": "noun",
      "explanation": "bird + open: untamed bird that lives in the open",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        484
      ]
    },
    {
      "id": 1296,
      "bciAvId": 12844,
      "gloss": "birth control",
      "glossSv": "födelsekontroll",
      "pos": "noun",
      "explanation": "to stop + conception",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        236
      ]
    },
    {
      "id": 1297,
      "bciAvId": 12845,
      "gloss": "birth control pill, pill",
      "glossSv": "p-piller",
      "pos": "noun",
      "explanation": "pill + without + egg: pill that prevents the release of an egg",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        958,
        "/",
        449,
        "/",
        285
      ]
    },
    {
      "id": 1298,
      "bciAvId": 12846,
      "gloss": "birthday",
      "glossSv": "födelsedag",
      "pos": "noun",
      "explanation": "day + birth: day of one's birth",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        166
      ]
    },
    {
      "id": 1299,
      "bciAvId": 12847,
      "gloss": "to bite",
      "glossSv": "bita",
      "pos": "action",
      "explanation": "teeth + action indicator",
      "isCharacter": false,
      "composition": [
        644,
        ";",
        81
      ]
    },
    {
      "id": 1300,
      "bciAvId": 12848,
      "gloss": "bitter",
      "glossSv": "besk, bitter (smak)",
      "pos": "description",
      "explanation": "taste + down + description indicator: unpleasant taste",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        271
      ]
    },
    {
      "id": 1301,
      "bciAvId": 12849,
      "gloss": "black (bci)",
      "glossSv": "svart",
      "pos": "expression",
      "explanation": "colour + night",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        470
      ]
    },
    {
      "id": 1302,
      "bciAvId": 12850,
      "gloss": "black (ckb)",
      "glossSv": "svart (CKB)",
      "pos": "expression",
      "explanation": "colour + zero: the absence of colour",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        9
      ]
    },
    {
      "id": 1303,
      "bciAvId": 12851,
      "gloss": "blackbird, crow, raven",
      "glossSv": "kaja, koltrast, korp (etc)",
      "pos": "noun",
      "explanation": "bird + black",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        1161,
        "/",
        470
      ]
    },
    {
      "id": 1304,
      "bciAvId": 12852,
      "gloss": "blackboard, chalkboard, whiteboard, writing board",
      "glossSv": "skrivtavla",
      "pos": "noun",
      "explanation": "enclosure + to write: panel on which one writes, usually with chalk",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        509
      ]
    },
    {
      "id": 1305,
      "bciAvId": 12853,
      "gloss": "bladder",
      "glossSv": "urinblåsa",
      "pos": "noun",
      "explanation": "container + urine",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        694,
        "/",
        349
      ]
    },
    {
      "id": 1306,
      "bciAvId": 12854,
      "gloss": "blanket, duvet, quilt",
      "glossSv": "filt, pläd, täcke",
      "pos": "noun",
      "explanation": "cloth + protection + bed",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        548,
        "/",
        156
      ]
    },
    {
      "id": 1307,
      "bciAvId": 12855,
      "gloss": "to bleed",
      "glossSv": "blöda",
      "pos": "action",
      "explanation": "blood + action indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        81,
        "/",
        423
      ]
    },
    {
      "id": 1308,
      "bciAvId": 12856,
      "gloss": "blind",
      "glossSv": "blind",
      "pos": "description",
      "explanation": "blindness + description indicator: unable to see",
      "isCharacter": false,
      "composition": [
        1000,
        ";",
        86
      ]
    },
    {
      "id": 1309,
      "bciAvId": 12858,
      "gloss": "blissymbol part",
      "glossSv": "del av blissymbol",
      "pos": "function",
      "explanation": "part + blissymbol: used with a compound symbol to produce a new meaning, represented by one of the component parts of the compound symbol",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        167
      ]
    },
    {
      "id": 1310,
      "bciAvId": 12859,
      "gloss": "blissymbolics resource centre",
      "glossSv": "blissymbolcenter",
      "pos": "noun",
      "explanation": "resource centre + blissymbol",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        332,
        "/",
        1029,
        "/",
        412,
        "/",
        167
      ]
    },
    {
      "id": 1311,
      "bciAvId": 12861,
      "gloss": "blood",
      "glossSv": "blod",
      "pos": "noun",
      "explanation": "liquid + life: body fluid that sustains life",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        423
      ]
    },
    {
      "id": 1312,
      "bciAvId": 12862,
      "gloss": "to blow (wind)",
      "glossSv": "blåsa (vind)",
      "pos": "action",
      "explanation": "wind + action indicator",
      "isCharacter": false,
      "composition": [
        705,
        ";",
        81
      ]
    },
    {
      "id": 1313,
      "bciAvId": 12863,
      "gloss": "to blow (mouth)",
      "glossSv": "blåsa",
      "pos": "action",
      "explanation": "mouth + wind + action indicator: to use the mouth to make a wind",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        705
      ]
    },
    {
      "id": 1314,
      "bciAvId": 12864,
      "gloss": "blue (bci)",
      "glossSv": "blå",
      "pos": "expression",
      "explanation": "colour + sky",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        597
      ]
    },
    {
      "id": 1315,
      "bciAvId": 12865,
      "gloss": "blue (ckb)",
      "glossSv": "blå (CKB)",
      "pos": "expression",
      "explanation": "colour + 5",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        14
      ]
    },
    {
      "id": 1316,
      "bciAvId": 12866,
      "gloss": "blueberry",
      "glossSv": "blåbär",
      "pos": "noun",
      "explanation": "berry + blue",
      "isCharacter": false,
      "composition": [
        161,
        "/",
        1161,
        "/",
        597
      ]
    },
    {
      "id": 1317,
      "bciAvId": 12867,
      "gloss": "bluebird",
      "glossSv": "blåmes",
      "pos": "noun",
      "explanation": "bird + blue",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        1161,
        "/",
        597
      ]
    },
    {
      "id": 1318,
      "bciAvId": 12871,
      "gloss": "to boil (food)",
      "glossSv": "koka (mat)",
      "pos": "action",
      "explanation": "fire + water + intensity + action indicator: to bring water or a liquid to a boil",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        695,
        "/",
        401
      ]
    },
    {
      "id": 1319,
      "bciAvId": 12872,
      "gloss": "to boil (liquid)",
      "glossSv": "koka (vätska)",
      "pos": "action",
      "explanation": "fire + water + intensity + action indicator: to cook in boiling water",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        695,
        "/",
        401
      ]
    },
    {
      "id": 1320,
      "bciAvId": 12874,
      "gloss": "bonfire, barbeque, campfire",
      "glossSv": "brasa, bål, lägereld",
      "pos": "noun",
      "explanation": "fire + happiness: a fire to enjoy",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1321,
      "bciAvId": 12876,
      "gloss": "boot",
      "glossSv": "stövel, stövlar",
      "pos": "noun",
      "explanation": "protection + leg and foot",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        1052
      ]
    },
    {
      "id": 1322,
      "bciAvId": 12877,
      "gloss": "to borrow",
      "glossSv": "låna",
      "pos": "action",
      "explanation": "to receive + limited time + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        426
      ]
    },
    {
      "id": 1323,
      "bciAvId": 12878,
      "gloss": "boss, supervisor",
      "glossSv": "chef, arbetsledare, föreståndare (FD)",
      "pos": "person",
      "explanation": "person + to guide + work: person who directs work",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        803,
        "/",
        711
      ]
    },
    {
      "id": 1324,
      "bciAvId": 12879,
      "gloss": "both",
      "glossSv": "båda",
      "pos": "expression",
      "explanation": "2 + all: two of all",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        117
      ]
    },
    {
      "id": 1325,
      "bciAvId": 12883,
      "gloss": "bowel, intestine",
      "glossSv": "tarm (FD)",
      "pos": "noun",
      "explanation": "tube + bowel movement",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        694,
        "/",
        194
      ]
    },
    {
      "id": 1326,
      "bciAvId": 12884,
      "gloss": "bowel movement, defecation, shitting, feces, shit, poop",
      "glossSv": "avföring, bajs",
      "pos": "noun",
      "explanation": "waste + buttocks",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        194
      ]
    },
    {
      "id": 1327,
      "bciAvId": 12885,
      "gloss": "bowling (activity)",
      "glossSv": "bowling (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball field: sport in which a ball is rolled along the ground",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        998
      ]
    },
    {
      "id": 1328,
      "bciAvId": 12887,
      "gloss": "boxing (activity)",
      "glossSv": "boxning (aktivitet)",
      "pos": "noun",
      "explanation": "activity + fight",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        934
      ]
    },
    {
      "id": 1329,
      "bciAvId": 12889,
      "gloss": "bra, brassiere",
      "glossSv": "bh",
      "pos": "noun",
      "explanation": "clothing + breasts",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        181
      ]
    },
    {
      "id": 1330,
      "bciAvId": 12890,
      "gloss": "medical aid",
      "glossSv": "hjälpmedel (medicinskt)",
      "pos": "noun",
      "explanation": "support + medical + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958
      ]
    },
    {
      "id": 1331,
      "bciAvId": 12891,
      "gloss": "bracha, berakah, prayer (small)",
      "glossSv": "bracha, liten bön (Israel)",
      "pos": "noun",
      "explanation": "prayer + comma + little (Hebrew)",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        657,
        "/",
        355,
        "/",
        5,
        "/",
        956
      ]
    },
    {
      "id": 1332,
      "bciAvId": 12892,
      "gloss": "Brahma",
      "glossSv": "Brahma (Indien)",
      "pos": "person",
      "explanation": "god + creation: Hindu god for the creator",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        247
      ]
    },
    {
      "id": 1333,
      "bciAvId": 12893,
      "gloss": "brain",
      "glossSv": "hjärna",
      "pos": "noun",
      "explanation": "mind + thing indicator: organ of the body. The symbol is the concrete form of mind.",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        97
      ]
    },
    {
      "id": 1334,
      "bciAvId": 12896,
      "gloss": "to break, to crack, to fracture, to tear, to injure, to damage",
      "glossSv": "gå sönder, ha sönder, bryta",
      "pos": "action",
      "explanation": "break,fracture,injury,damage + action indicator",
      "isCharacter": false,
      "composition": [
        933,
        ";",
        81
      ]
    },
    {
      "id": 1335,
      "bciAvId": 12897,
      "gloss": "breakable, fragile, vulnerable",
      "glossSv": "ömtålig, skör",
      "pos": "description",
      "explanation": "break,fracture,injury,damage + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        933,
        ";",
        85
      ]
    },
    {
      "id": 1336,
      "bciAvId": 12898,
      "gloss": "breakfast",
      "glossSv": "frukost",
      "pos": "noun",
      "explanation": "meal + 1: first meal of the day",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        329,
        "/",
        10
      ]
    },
    {
      "id": 1337,
      "bciAvId": 12900,
      "gloss": "breath, breathing, respiration",
      "glossSv": "andedräkt, andning",
      "pos": "noun",
      "explanation": "nose + mouth: mouth and nose are both used in breathing",
      "isCharacter": false,
      "composition": [
        473,
        "/",
        457
      ]
    },
    {
      "id": 1338,
      "bciAvId": 12901,
      "gloss": "to breathe",
      "glossSv": "andas",
      "pos": "action",
      "explanation": "breath + action indicator",
      "isCharacter": false,
      "composition": [
        473,
        ";",
        81,
        "/",
        457
      ]
    },
    {
      "id": 1339,
      "bciAvId": 12903,
      "gloss": "bright",
      "glossSv": "ljusstark, bländande, lysande, skinande",
      "pos": "description",
      "explanation": "light + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 1340,
      "bciAvId": 12904,
      "gloss": "to bring",
      "glossSv": "flytta, hämta, komma med",
      "pos": "action",
      "explanation": "to carry + forward + reference line + action indicator: to carry toward a given location",
      "isCharacter": false,
      "composition": [
        1099,
        ";",
        81,
        "/",
        1218
      ]
    },
    {
      "id": 1341,
      "bciAvId": 12905,
      "gloss": "broccoli",
      "glossSv": "broccoli",
      "pos": "noun",
      "explanation": "cabbage + flower + green: cabbage with green flowerets",
      "isCharacter": false,
      "composition": [
        196,
        "/",
        325,
        "/",
        1161,
        "/",
        366
      ]
    },
    {
      "id": 1342,
      "bciAvId": 12906,
      "gloss": "to broil, to barbecue, to grill",
      "glossSv": "grilla",
      "pos": "action",
      "explanation": "to cook + intensity + action indicator: to cook with intense heat",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        401
      ]
    },
    {
      "id": 1343,
      "bciAvId": 12907,
      "gloss": "broken, injured, damaged",
      "glossSv": "trasig, sönder, avbruten",
      "pos": "description",
      "explanation": "break,fracture,injury,damage + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        933,
        ";",
        84
      ]
    },
    {
      "id": 1344,
      "bciAvId": 12909,
      "gloss": "brother",
      "glossSv": "bror",
      "pos": "person",
      "explanation": "son + 2: a son considered in relation to another child of his parents",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        11
      ]
    },
    {
      "id": 1345,
      "bciAvId": 12910,
      "gloss": "brown (bci)",
      "glossSv": "brun",
      "pos": "expression",
      "explanation": "colour + earth",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        281
      ]
    },
    {
      "id": 1346,
      "bciAvId": 12911,
      "gloss": "brown (ckb)",
      "glossSv": "brun (CKB)",
      "pos": "expression",
      "explanation": "colour + 1 + comma + 0: combination of red and black",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        10,
        "/",
        5,
        "/",
        9
      ]
    },
    {
      "id": 1347,
      "bciAvId": 12913,
      "gloss": "to brush",
      "glossSv": "borsta",
      "pos": "action",
      "explanation": "brush + action indicator",
      "isCharacter": false,
      "composition": [
        184,
        ";",
        81
      ]
    },
    {
      "id": 1348,
      "bciAvId": 12914,
      "gloss": "to brush teeth",
      "glossSv": "borsta tänderna",
      "pos": "action",
      "explanation": "toothbrush + action indicator",
      "isCharacter": false,
      "composition": [
        184,
        ";",
        81,
        "/",
        644
      ]
    },
    {
      "id": 1349,
      "bciAvId": 12915,
      "gloss": "brussels sprout(s)",
      "glossSv": "brysselkål",
      "pos": "noun",
      "explanation": "cabbage + little",
      "isCharacter": false,
      "composition": [
        196,
        "/",
        956
      ]
    },
    {
      "id": 1350,
      "bciAvId": 12920,
      "gloss": "bull",
      "glossSv": "tjur",
      "pos": "noun",
      "explanation": "bovine + male",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        106
      ]
    },
    {
      "id": 1351,
      "bciAvId": 12921,
      "gloss": "bull (fighting)",
      "glossSv": "tjur (för tjurfäktning)",
      "pos": "noun",
      "explanation": "bovine + to fight",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        934
      ]
    },
    {
      "id": 1352,
      "bciAvId": 12922,
      "gloss": "to burn",
      "glossSv": "brinna, bränna",
      "pos": "action",
      "explanation": "fire + action indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81
      ]
    },
    {
      "id": 1353,
      "bciAvId": 12923,
      "gloss": "burned, burnt",
      "glossSv": "bränd",
      "pos": "description",
      "explanation": "fire + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        84
      ]
    },
    {
      "id": 1354,
      "bciAvId": 12924,
      "gloss": "burning",
      "glossSv": "brinnande",
      "pos": "description",
      "explanation": "fire + description indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        86
      ]
    },
    {
      "id": 1355,
      "bciAvId": 12925,
      "gloss": "to burp, to belch",
      "glossSv": "rapa",
      "pos": "action",
      "explanation": "wind + out of body (upward) + action indicator: to expel wind from the stomach",
      "isCharacter": false,
      "composition": [
        705,
        ";",
        81,
        "/",
        1064
      ]
    },
    {
      "id": 1356,
      "bciAvId": 12926,
      "gloss": "to bury (person)",
      "glossSv": "begrava (person)",
      "pos": "action",
      "explanation": "grave + action indicator: to lay to rest below the earth",
      "isCharacter": false,
      "composition": [
        367,
        ";",
        81
      ]
    },
    {
      "id": 1357,
      "bciAvId": 13091,
      "gloss": "bus driver",
      "glossSv": "busschaufför",
      "pos": "person",
      "explanation": "person + bus",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        188
      ]
    },
    {
      "id": 1358,
      "bciAvId": 13095,
      "gloss": "butter",
      "glossSv": "smör",
      "pos": "noun",
      "explanation": "spread + cream: spread made from cream",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        275,
        "/",
        423,
        "/",
        401
      ]
    },
    {
      "id": 1359,
      "bciAvId": 13098,
      "gloss": "button, gripper, snap",
      "glossSv": "knapp",
      "pos": "noun",
      "explanation": "disc + clothing",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        229
      ]
    },
    {
      "id": 1360,
      "bciAvId": 13099,
      "gloss": "to buy, to purchase",
      "glossSv": "köpa, handla",
      "pos": "action",
      "explanation": "money + thing + action indicator: first you must have money, which you can then spend to buy something",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        81,
        "/",
        651
      ]
    },
    {
      "id": 1361,
      "bciAvId": 13102,
      "gloss": "cabin, cottage, hut",
      "glossSv": "stuga",
      "pos": "noun",
      "explanation": "house + little",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        956
      ]
    },
    {
      "id": 1362,
      "bciAvId": 13103,
      "gloss": "caesarean section, cesarean section, C-section",
      "glossSv": "kejsarsnitt",
      "pos": "noun",
      "explanation": "to remove + medical + fetus",
      "isCharacter": false,
      "composition": [
        634,
        "/",
        958,
        "/",
        316
      ]
    },
    {
      "id": 1363,
      "bciAvId": 13104,
      "gloss": "cafe, coffee house, snack bar",
      "glossSv": "kafé, konditori",
      "pos": "noun",
      "explanation": "public room + snack",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        368,
        "/",
        329,
        "/",
        956
      ]
    },
    {
      "id": 1364,
      "bciAvId": 13105,
      "gloss": "cage",
      "glossSv": "bur, cell",
      "pos": "noun",
      "explanation": "enclosure + pictograph of a barred window: enclosed space with bars that prevent escape",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        707
      ]
    },
    {
      "id": 1365,
      "bciAvId": 13106,
      "gloss": "cake, bread with sugar",
      "glossSv": "sockerkaka, mjuk kaka, kaffebröd",
      "pos": "noun",
      "explanation": "bread + sweet",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 1366,
      "bciAvId": 13107,
      "gloss": "to calculate",
      "glossSv": "beräkna, räkna ut",
      "pos": "action",
      "explanation": "digital processing,artificial intelligence,calculation + action indicator: to think using numbers",
      "isCharacter": false,
      "composition": [
        828,
        ";",
        81
      ]
    },
    {
      "id": 1367,
      "bciAvId": 13108,
      "gloss": "calculator",
      "glossSv": "räknare",
      "pos": "noun",
      "explanation": "machine + to calculate",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        828
      ]
    },
    {
      "id": 1368,
      "bciAvId": 13109,
      "gloss": "calendar",
      "glossSv": "almanacka, kalender",
      "pos": "noun",
      "explanation": "page + day + month",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        258,
        "/",
        452
      ]
    },
    {
      "id": 1369,
      "bciAvId": 13112,
      "gloss": "camp",
      "glossSv": "läger",
      "pos": "noun",
      "explanation": "gathering + countryside + limited time: temporary gathering in the country",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        244,
        "/",
        426
      ]
    },
    {
      "id": 1370,
      "bciAvId": 13114,
      "gloss": "to can, to be able",
      "glossSv": "kunna",
      "pos": "action",
      "explanation": "ability (half sized) + action indicator",
      "isCharacter": false,
      "composition": [
        994,
        ";",
        81
      ]
    },
    {
      "id": 1371,
      "bciAvId": 13116,
      "gloss": "Canada",
      "glossSv": "Kanada",
      "pos": "noun",
      "explanation": "country + maple-leaf",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        436
      ]
    },
    {
      "id": 1372,
      "bciAvId": 13117,
      "gloss": "candle",
      "glossSv": "stearinljus",
      "pos": "noun",
      "explanation": "linear thing + fire + light + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        319,
        "/",
        424
      ]
    },
    {
      "id": 1373,
      "bciAvId": 13118,
      "gloss": "candy",
      "glossSv": "godis (FD)",
      "pos": "noun",
      "explanation": "food + sweet + intensity",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        642,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 1374,
      "bciAvId": 13119,
      "gloss": "cane, stick, walking stick",
      "glossSv": "käpp",
      "pos": "noun",
      "explanation": "linear thing + to walk + thing indicator: linear thing used to help a person walk",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        418
      ]
    },
    {
      "id": 1375,
      "bciAvId": 13122,
      "gloss": "cards, playing cards",
      "glossSv": "spelkort",
      "pos": "noun",
      "explanation": "paper + to play + plural indicator",
      "isCharacter": false,
      "composition": [
        497,
        ";",
        99,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1376,
      "bciAvId": 13123,
      "gloss": "careful",
      "glossSv": "försiktig, noggrann",
      "pos": "description",
      "explanation": "observation + intensity + intensity + description indicator: also a combination of to observe and attention",
      "isCharacter": false,
      "composition": [
        931,
        ";",
        86,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1377,
      "bciAvId": 13125,
      "gloss": "to carry, to move, to transport",
      "glossSv": "förflytta, transportera",
      "pos": "action",
      "explanation": "transport,transportation + action indicator: to move something by vehicle",
      "isCharacter": false,
      "composition": [
        1099,
        ";",
        81
      ]
    },
    {
      "id": 1378,
      "bciAvId": 13126,
      "gloss": "carrycot, bassinet",
      "glossSv": "babykorg (etc)",
      "pos": "noun",
      "explanation": "container + baby: holder for a baby",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        140
      ]
    },
    {
      "id": 1379,
      "bciAvId": 13129,
      "gloss": "plaster cast, cast (medical)",
      "glossSv": "stödkorsett (gjuten)",
      "pos": "noun",
      "explanation": "enclosure + medical + body: medical enclosure for the body",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        958,
        "/",
        171
      ]
    },
    {
      "id": 1380,
      "bciAvId": 13131,
      "gloss": "to catch, to grab",
      "glossSv": "ta, fånga",
      "pos": "action",
      "explanation": "hand + to receive + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        920
      ]
    },
    {
      "id": 1381,
      "bciAvId": 13132,
      "gloss": "caterpillar",
      "glossSv": "larv",
      "pos": "noun",
      "explanation": "worm + butterfly: larva of the butterfly",
      "isCharacter": false,
      "composition": [
        713,
        "/",
        193
      ]
    },
    {
      "id": 1382,
      "bciAvId": 13133,
      "gloss": "cauliflower",
      "glossSv": "blomkål",
      "pos": "noun",
      "explanation": "cabbage + flower: cabbage with flowerets",
      "isCharacter": false,
      "composition": [
        196,
        "/",
        325
      ]
    },
    {
      "id": 1383,
      "bciAvId": 13135,
      "gloss": "to cause",
      "glossSv": "orsaka",
      "pos": "action",
      "explanation": "cause + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81
      ]
    },
    {
      "id": 1384,
      "bciAvId": 13136,
      "gloss": "to be caused by",
      "glossSv": "orsakas av",
      "pos": "action",
      "explanation": "cause + passive indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        91
      ]
    },
    {
      "id": 1385,
      "bciAvId": 13137,
      "gloss": "cave",
      "glossSv": "grotta",
      "pos": "noun",
      "explanation": "hole + mountain: hole in a mountainside",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        456
      ]
    },
    {
      "id": 1386,
      "bciAvId": 13141,
      "gloss": "celibacy, chastity",
      "glossSv": "kyskhet, oskuld",
      "pos": "noun",
      "explanation": "without + sexual intercourse",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        232,
        "/",
        349
      ]
    },
    {
      "id": 1387,
      "bciAvId": 13142,
      "gloss": "cemetery",
      "glossSv": "kyrkogård, begravningsplats",
      "pos": "noun",
      "explanation": "place + grave",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        367
      ]
    },
    {
      "id": 1388,
      "bciAvId": 13144,
      "gloss": "century",
      "glossSv": "århundrade, sekel",
      "pos": "noun",
      "explanation": "100 + year: period of one hundred years",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        9,
        "/",
        9,
        "/",
        716
      ]
    },
    {
      "id": 1389,
      "bciAvId": 13146,
      "gloss": "certain",
      "glossSv": "säker (FD)",
      "pos": "description",
      "explanation": "opposite meaning + to doubt + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        802,
        ";",
        86
      ]
    },
    {
      "id": 1390,
      "bciAvId": 13147,
      "gloss": "cervix",
      "glossSv": "livmoderhals",
      "pos": "noun",
      "explanation": "part of + uterus",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        681
      ]
    },
    {
      "id": 1391,
      "bciAvId": 13149,
      "gloss": "challah",
      "glossSv": "challah (Israel)",
      "pos": "noun",
      "explanation": "bread + Sabbath: traditional bread eaten on the Sabbath (Hebrew)",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        258,
        "/",
        562
      ]
    },
    {
      "id": 1392,
      "bciAvId": 13150,
      "gloss": "chameleon",
      "glossSv": "kameleont",
      "pos": "noun",
      "explanation": "lizard + to change: lizard that is able to change colour",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        602,
        "/",
        213
      ]
    },
    {
      "id": 1393,
      "bciAvId": 13152,
      "gloss": "to change, to alter, to convert",
      "glossSv": "ändra, växla",
      "pos": "action",
      "explanation": "change + action indicator",
      "isCharacter": false,
      "composition": [
        213,
        ";",
        81
      ]
    },
    {
      "id": 1394,
      "bciAvId": 13153,
      "gloss": "Chanukah, Hanukkah",
      "glossSv": "Chanukah (Israel)",
      "pos": "noun",
      "explanation": "holiday + light: holiday of lights (Hebrew)",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        313,
        "/",
        678,
        "/",
        424
      ]
    },
    {
      "id": 1395,
      "bciAvId": 13154,
      "gloss": "charity",
      "glossSv": "hjälpverksamhet, välgörenhet",
      "pos": "noun",
      "explanation": "help + needy person + feeling",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        467,
        "/",
        313
      ]
    },
    {
      "id": 1396,
      "bciAvId": 13155,
      "gloss": "cheap",
      "glossSv": "billig (FD)",
      "pos": "description",
      "explanation": "opposite meaning + expensive + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        368,
        "/",
        451,
        ";",
        86,
        "/",
        331,
        "/",
        651
      ]
    },
    {
      "id": 1397,
      "bciAvId": 13160,
      "gloss": "Cheshvan",
      "glossSv": "Cheshvan (Israel)",
      "pos": "noun",
      "explanation": "month + beginning + rain: month when rainy season begins (Hebrew)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        159,
        "/",
        556
      ]
    },
    {
      "id": 1398,
      "bciAvId": 13163,
      "gloss": "to chew",
      "glossSv": "tugga",
      "pos": "action",
      "explanation": "many + to bite + action indicator: to bite many times",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        644,
        ";",
        81
      ]
    },
    {
      "id": 1399,
      "bciAvId": 13164,
      "gloss": "chicken (bird)",
      "glossSv": "höna, hönsfågel",
      "pos": "noun",
      "explanation": "bird + food: bird commonly used for food",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        329
      ]
    },
    {
      "id": 1400,
      "bciAvId": 13165,
      "gloss": "chicken (food), poultry",
      "glossSv": "kyckling, höna (mat)",
      "pos": "noun",
      "explanation": "food + bird",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        163
      ]
    },
    {
      "id": 1401,
      "bciAvId": 13167,
      "gloss": "child abuse",
      "glossSv": "barnmisshandel",
      "pos": "noun",
      "explanation": "abuse + child",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        220
      ]
    },
    {
      "id": 1402,
      "bciAvId": 13170,
      "gloss": "chipmunk",
      "glossSv": "jordekorre",
      "pos": "noun",
      "explanation": "rodent + stripe",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        428
      ]
    },
    {
      "id": 1403,
      "bciAvId": 13171,
      "gloss": "chocolate",
      "glossSv": "choklad (FD)",
      "pos": "noun",
      "explanation": "food + powder + brown",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        1161,
        "/",
        281
      ]
    },
    {
      "id": 1404,
      "bciAvId": 13172,
      "gloss": "chocolate drink",
      "glossSv": "choklad (dryck), O'boy (FD)",
      "pos": "noun",
      "explanation": "drink + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        544,
        "/",
        1161,
        "/",
        281
      ]
    },
    {
      "id": 1405,
      "bciAvId": 13173,
      "gloss": "chocolate flavouring, chocolate flavoring, cocoa, cacao powder",
      "glossSv": "kakao (FD)",
      "pos": "noun",
      "explanation": "adding,additive + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        1161,
        "/",
        281
      ]
    },
    {
      "id": 1406,
      "bciAvId": 13174,
      "gloss": "chocolate spread",
      "glossSv": "choklad (pålägg) (FD)",
      "pos": "noun",
      "explanation": "spread + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        544,
        "/",
        1161,
        "/",
        281
      ]
    },
    {
      "id": 1407,
      "bciAvId": 13176,
      "gloss": "choir, chorus",
      "glossSv": "kör, sånggrupp",
      "pos": "person",
      "explanation": "group (people) + to sing",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 1408,
      "bciAvId": 13177,
      "gloss": "to choke, to gag",
      "glossSv": "sätta i halsen",
      "pos": "action",
      "explanation": "to swallow + negative + action indicator: to swallow badly",
      "isCharacter": false,
      "composition": [
        271,
        ";",
        81,
        "/",
        275,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1409,
      "bciAvId": 13178,
      "gloss": "to choose, to pick, to select",
      "glossSv": "välja",
      "pos": "action",
      "explanation": "choice + action indicator",
      "isCharacter": false,
      "composition": [
        223,
        ";",
        81
      ]
    },
    {
      "id": 1410,
      "bciAvId": 13179,
      "gloss": "to chop",
      "glossSv": "hacka, hugga",
      "pos": "action",
      "explanation": "to cut + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 1411,
      "bciAvId": 13180,
      "gloss": "christian",
      "glossSv": "kristen",
      "pos": "description",
      "explanation": "cross + description indicator",
      "isCharacter": false,
      "composition": [
        248,
        ";",
        86
      ]
    },
    {
      "id": 1412,
      "bciAvId": 13181,
      "gloss": "Christmas",
      "glossSv": "jul",
      "pos": "noun",
      "explanation": "birthday + Christ [contraction]: day of Christ's birth",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 1413,
      "bciAvId": 13182,
      "gloss": "Chumash, Pentateuch",
      "glossSv": "Chumash (Israel)",
      "pos": "noun",
      "explanation": "5 + book + Torah (Hebrew)",
      "isCharacter": false,
      "composition": [
        14,
        "/",
        173,
        "/",
        663
      ]
    },
    {
      "id": 1414,
      "bciAvId": 13345,
      "gloss": "church, mosque, temple",
      "glossSv": "kyrka, moské, tempel",
      "pos": "noun",
      "explanation": "building + God: building devoted to the worship of God",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        355
      ]
    },
    {
      "id": 1415,
      "bciAvId": 13347,
      "gloss": "circle (shape)",
      "glossSv": "cirkel",
      "pos": "noun",
      "explanation": "shape + circular shape [as of sun]: circle, a geometric shape",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        636
      ]
    },
    {
      "id": 1416,
      "bciAvId": 13348,
      "gloss": "circumcision",
      "glossSv": "omskärelse",
      "pos": "noun",
      "explanation": "to remove + foreskin",
      "isCharacter": false,
      "composition": [
        634,
        "/",
        548,
        "/",
        434
      ]
    },
    {
      "id": 1417,
      "bciAvId": 13351,
      "gloss": "town, city (small)",
      "glossSv": "stad, småstad",
      "pos": "noun",
      "explanation": "many + many + building: a large group of buildings comprise a city",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        392
      ]
    },
    {
      "id": 1418,
      "bciAvId": 13352,
      "gloss": "class",
      "glossSv": "klass, studiegrupp",
      "pos": "noun",
      "explanation": "group (people) + to learn: group of people who come together to learn",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        920,
        "/",
        412
      ]
    },
    {
      "id": 1419,
      "bciAvId": 13353,
      "gloss": "classroom",
      "glossSv": "klassrum, föreläsningssal",
      "pos": "noun",
      "explanation": "room + to teach",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        949,
        "/",
        412
      ]
    },
    {
      "id": 1420,
      "bciAvId": 13356,
      "gloss": "clean",
      "glossSv": "ren (FD)",
      "pos": "description",
      "explanation": "opposite meaning + dirty + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        368,
        "/",
        303,
        ";",
        86,
        "/",
        270
      ]
    },
    {
      "id": 1421,
      "bciAvId": 13357,
      "gloss": "to clean",
      "glossSv": "städa, göra ren",
      "pos": "action",
      "explanation": "to remove + dirty + action indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 1422,
      "bciAvId": 13358,
      "gloss": "clear, transparent",
      "glossSv": "genomskinlig, klar",
      "pos": "description",
      "explanation": "clearness,clarity,transparency,transparence + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        653
      ]
    },
    {
      "id": 1423,
      "bciAvId": 13359,
      "gloss": "clerk",
      "glossSv": "affärsbiträde, expedit",
      "pos": "person",
      "explanation": "helper + business: person who helps in a business",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382,
        "/",
        191
      ]
    },
    {
      "id": 1424,
      "bciAvId": 13360,
      "gloss": "to climb",
      "glossSv": "klättra",
      "pos": "action",
      "explanation": "to walk + up + action indicator",
      "isCharacter": false,
      "composition": [
        418,
        ";",
        81,
        "/",
        678
      ]
    },
    {
      "id": 1425,
      "bciAvId": 13361,
      "gloss": "clinic",
      "glossSv": "klinik, vårdcentral",
      "pos": "noun",
      "explanation": "public room + medical",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        958
      ]
    },
    {
      "id": 1426,
      "bciAvId": 13362,
      "gloss": "clitoris",
      "glossSv": "klitoris",
      "pos": "noun",
      "explanation": "part of + female genitals + intensity: part of the body that produces intense sexual excitement",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        349,
        "/",
        314,
        "/",
        401
      ]
    },
    {
      "id": 1427,
      "bciAvId": 13363,
      "gloss": "clock, timepiece",
      "glossSv": "klocka",
      "pos": "noun",
      "explanation": "time + thing indicator: object for telling time.The symbol is the concrete form of time.",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        97
      ]
    },
    {
      "id": 1428,
      "bciAvId": 13364,
      "gloss": "to close, to enclose, to shut",
      "glossSv": "stänga",
      "pos": "action",
      "explanation": "enclosure + action indicator",
      "isCharacter": false,
      "composition": [
        291,
        ";",
        81
      ]
    },
    {
      "id": 1429,
      "bciAvId": 13368,
      "gloss": "cloudy",
      "glossSv": "molnig",
      "pos": "description",
      "explanation": "cloud + description indicator",
      "isCharacter": false,
      "composition": [
        230,
        ";",
        86
      ]
    },
    {
      "id": 1430,
      "bciAvId": 13369,
      "gloss": "club",
      "glossSv": "förening, klubb",
      "pos": "noun",
      "explanation": "gathering + interest: gathering of people sharing the same interest",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        955
      ]
    },
    {
      "id": 1431,
      "bciAvId": 13370,
      "gloss": "biomass, biofuel",
      "glossSv": "biobränsle",
      "pos": "noun",
      "explanation": "fuel + plant: fuel derived from plants",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        533
      ]
    },
    {
      "id": 1432,
      "bciAvId": 13371,
      "gloss": "coat, jacket",
      "glossSv": "ytterkläder, jacka, kappa, rock (etc)",
      "pos": "noun",
      "explanation": "clothing + over: clothing worn over other clothing",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        493
      ]
    },
    {
      "id": 1433,
      "bciAvId": 13372,
      "gloss": "coconut",
      "glossSv": "kokosnöt",
      "pos": "noun",
      "explanation": "fruit + palm tree",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        496
      ]
    },
    {
      "id": 1434,
      "bciAvId": 13373,
      "gloss": "coffee",
      "glossSv": "kaffe",
      "pos": "noun",
      "explanation": "drink + bean: drink made from coffee beans",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        154
      ]
    },
    {
      "id": 1435,
      "bciAvId": 13374,
      "gloss": "coin",
      "glossSv": "mynt, slant",
      "pos": "noun",
      "explanation": "disc + money: money in the form of a disc",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        451
      ]
    },
    {
      "id": 1436,
      "bciAvId": 13375,
      "gloss": "cold",
      "glossSv": "kall",
      "pos": "description",
      "explanation": "coldness,cold + description indicator",
      "isCharacter": false,
      "composition": [
        1007,
        ";",
        86
      ]
    },
    {
      "id": 1437,
      "bciAvId": 13376,
      "gloss": "cold (opposite hot)",
      "glossSv": "kall (FD)",
      "pos": "description",
      "explanation": "opposite meaning + hot + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        378,
        ";",
        86
      ]
    },
    {
      "id": 1438,
      "bciAvId": 13379,
      "gloss": "to comb",
      "glossSv": "kamma",
      "pos": "action",
      "explanation": "comb + action indicator",
      "isCharacter": false,
      "composition": [
        231,
        ";",
        81
      ]
    },
    {
      "id": 1439,
      "bciAvId": 13381,
      "gloss": "to combine, to connect, to link",
      "glossSv": "kombinera",
      "pos": "action",
      "explanation": "combination + action indicator",
      "isCharacter": false,
      "composition": [
        232,
        ";",
        81
      ]
    },
    {
      "id": 1440,
      "bciAvId": 13383,
      "gloss": "to come, to approach",
      "glossSv": "komma, närma sig",
      "pos": "action",
      "explanation": "approach + action indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        428
      ]
    },
    {
      "id": 1441,
      "bciAvId": 13385,
      "gloss": "to comfort, to console",
      "glossSv": "trösta",
      "pos": "action",
      "explanation": "to give + peace + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        505
      ]
    },
    {
      "id": 1442,
      "bciAvId": 13386,
      "gloss": "comfortable, restful",
      "glossSv": "behaglig, bekväm, skön",
      "pos": "description",
      "explanation": "rest + description indicator: feeling at rest",
      "isCharacter": false,
      "composition": [
        562,
        ";",
        86
      ]
    },
    {
      "id": 1443,
      "bciAvId": 13389,
      "gloss": "to communicate",
      "glossSv": "kommunicera",
      "pos": "action",
      "explanation": "communication + action indicator",
      "isCharacter": false,
      "composition": [
        1029,
        ";",
        81,
        "/",
        440
      ]
    },
    {
      "id": 1444,
      "bciAvId": 13390,
      "gloss": "communication",
      "glossSv": "kommunikation",
      "pos": "noun",
      "explanation": "exchange,substitution + meaning",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        440
      ]
    },
    {
      "id": 1445,
      "bciAvId": 13391,
      "gloss": "to compare",
      "glossSv": "jämföra",
      "pos": "action",
      "explanation": "to observe + same + action indicator: to observe the similarities between two or more persons or things",
      "isCharacter": false,
      "composition": [
        931,
        ";",
        81,
        "/",
        578
      ]
    },
    {
      "id": 1446,
      "bciAvId": 13392,
      "gloss": "to compete, to race",
      "glossSv": "tävla",
      "pos": "action",
      "explanation": "race + action indicator",
      "isCharacter": false,
      "composition": [
        554,
        ";",
        81
      ]
    },
    {
      "id": 1447,
      "bciAvId": 13393,
      "gloss": "composer",
      "glossSv": "kompositör, tonsättare",
      "pos": "person",
      "explanation": "person + tune: person who creates tunes",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        462
      ]
    },
    {
      "id": 1448,
      "bciAvId": 13394,
      "gloss": "computer",
      "glossSv": "dator (FD)",
      "pos": "noun",
      "explanation": "machine + mind: machine that works like a mind",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        447
      ]
    },
    {
      "id": 1449,
      "bciAvId": 13396,
      "gloss": "concert hall",
      "glossSv": "konserthus",
      "pos": "noun",
      "explanation": "building + music: building where music is performed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 1450,
      "bciAvId": 13397,
      "gloss": "concrete, cement",
      "glossSv": "betong, cement",
      "pos": "noun",
      "explanation": "material + stone + man-made: man-made material that can be used like stone",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        629,
        "/",
        840
      ]
    },
    {
      "id": 1451,
      "bciAvId": 13398,
      "gloss": "condom",
      "glossSv": "kondom",
      "pos": "noun",
      "explanation": "barrier (contraceptive) + male",
      "isCharacter": false,
      "composition": [
        151,
        "/",
        106
      ]
    },
    {
      "id": 1452,
      "bciAvId": 13399,
      "gloss": "conductor (music)",
      "glossSv": "dirigent (FD)",
      "pos": "person",
      "explanation": "person + to lead + musical note: person who leads or directs musicians",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        803,
        "/",
        462
      ]
    },
    {
      "id": 1453,
      "bciAvId": 13402,
      "gloss": "considerate, thoughtful",
      "glossSv": "omtänksam",
      "pos": "description",
      "explanation": "consideration + description indicator: mindful of others",
      "isCharacter": false,
      "composition": [
        938,
        ";",
        86
      ]
    },
    {
      "id": 1454,
      "bciAvId": 13404,
      "gloss": "to continue, to pass",
      "glossSv": "fortsätta, passera",
      "pos": "action",
      "explanation": "continuance,continuation (forward [extended] + reference line [half-sized]) + action indicator: the arrow passes a reference line and continues on",
      "isCharacter": false,
      "composition": [
        1162,
        ";",
        81
      ]
    },
    {
      "id": 1455,
      "bciAvId": 13405,
      "gloss": "uterine contraction",
      "glossSv": "sammandragning, värk (i livmodern)",
      "pos": "noun",
      "explanation": "work + uterus",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        681
      ]
    },
    {
      "id": 1456,
      "bciAvId": 13406,
      "gloss": "to contrast",
      "glossSv": "jämföra, särskilja",
      "pos": "action",
      "explanation": "to observe + different + action indicator: to observe the differences between two persons or things",
      "isCharacter": false,
      "composition": [
        931,
        ";",
        81,
        "/",
        262
      ]
    },
    {
      "id": 1457,
      "bciAvId": 13407,
      "gloss": "to control oneself",
      "glossSv": "behärska sig",
      "pos": "action",
      "explanation": "self-control + action indicator",
      "isCharacter": false,
      "composition": [
        803,
        ";",
        81,
        "/",
        2343
      ]
    },
    {
      "id": 1458,
      "bciAvId": 13408,
      "gloss": "to cook",
      "glossSv": "laga mat",
      "pos": "action",
      "explanation": "fire + food + action indicator: to use fire (heat) to prepare food",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329
      ]
    },
    {
      "id": 1459,
      "bciAvId": 13409,
      "gloss": "cookie, biscuit",
      "glossSv": "kaka, kex",
      "pos": "noun",
      "explanation": "disc + sweet: sweet, disc-shaped food",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 1460,
      "bciAvId": 13410,
      "gloss": "cool, chilly",
      "glossSv": "kylig",
      "pos": "description",
      "explanation": "cold + little + description indicator",
      "isCharacter": false,
      "composition": [
        1007,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 1461,
      "bciAvId": 13411,
      "gloss": "cool, chilly (opposite warm)",
      "glossSv": "kylig (motsats varm)",
      "pos": "description",
      "explanation": "opposite meaning + warm + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        378,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 1462,
      "bciAvId": 13412,
      "gloss": "copy, duplicate",
      "glossSv": "kopia",
      "pos": "noun",
      "explanation": "to repeat + thing indicator",
      "isCharacter": false,
      "composition": [
        963,
        ";",
        97
      ]
    },
    {
      "id": 1463,
      "bciAvId": 13415,
      "gloss": "cornmeal",
      "glossSv": "majsmjöl",
      "pos": "noun",
      "explanation": "powder + corn",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        240
      ]
    },
    {
      "id": 1464,
      "bciAvId": 13416,
      "gloss": "correct, accurate, good, right",
      "glossSv": "rätt, riktig",
      "pos": "description",
      "explanation": "correctness + description indicator: thought to be correct, good, or right in a rational sense",
      "isCharacter": false,
      "composition": [
        1012,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 1465,
      "bciAvId": 13417,
      "gloss": "cost, price",
      "glossSv": "pris, kostnad",
      "pos": "noun",
      "explanation": "money + for (in exchange for) + thing",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        651
      ]
    },
    {
      "id": 1466,
      "bciAvId": 13418,
      "gloss": "costume, disguise",
      "glossSv": "maskeraddräkt, utklädningskläder",
      "pos": "noun",
      "explanation": "clothing + make believe",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        945
      ]
    },
    {
      "id": 1467,
      "bciAvId": 13420,
      "gloss": "to cough",
      "glossSv": "hosta",
      "pos": "action",
      "explanation": "to blow (mouth) + intensity + action indicator: to blow air forcefully from one's mouth",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        705,
        "/",
        401
      ]
    },
    {
      "id": 1468,
      "bciAvId": 13421,
      "gloss": "counsellor, adviser",
      "glossSv": "konsulent, konsult, rådgivare",
      "pos": "person",
      "explanation": "person + suggestion + to help: person who makes suggestions in order to help",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        485,
        "/",
        551,
        "/",
        "RK:-2",
        "/",
        382
      ]
    },
    {
      "id": 1469,
      "bciAvId": 13422,
      "gloss": "to count",
      "glossSv": "räkna",
      "pos": "action",
      "explanation": "number + action indicator",
      "isCharacter": false,
      "composition": [
        478,
        ";",
        81
      ]
    },
    {
      "id": 1470,
      "bciAvId": 13426,
      "gloss": "couple (two persons)",
      "glossSv": "par (två personer)",
      "pos": "person",
      "explanation": "person + person",
      "isCharacter": true
    },
    {
      "id": 1471,
      "bciAvId": 13428,
      "gloss": "court, field",
      "glossSv": "idrottsplats, idrottsplan (FD)",
      "pos": "noun",
      "explanation": "place + sport (OLD): place where sports are played",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        377
      ]
    },
    {
      "id": 1472,
      "bciAvId": 13429,
      "gloss": "cousin",
      "glossSv": "kusin",
      "pos": "person",
      "explanation": "offspring + sibling + parent: child of one's uncle or aunt",
      "isCharacter": false,
      "composition": [
        479,
        "/",
        479,
        "/",
        11,
        "/",
        500
      ]
    },
    {
      "id": 1473,
      "bciAvId": 13430,
      "gloss": "cow",
      "glossSv": "ko",
      "pos": "noun",
      "explanation": "bovine + female",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        314
      ]
    },
    {
      "id": 1474,
      "bciAvId": 13431,
      "gloss": "craft",
      "glossSv": "hantverk, slöjd, pyssel",
      "pos": "noun",
      "explanation": "man-made + hand: production of things by hand, e.g. quilting or wood carving",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 1475,
      "bciAvId": 13432,
      "gloss": "cramp, spasm",
      "glossSv": "kramp",
      "pos": "noun",
      "explanation": "pain + muscle: pain caused by muscle spasm or contraction",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        718
      ]
    },
    {
      "id": 1476,
      "bciAvId": 13433,
      "gloss": "cranberry",
      "glossSv": "tranbär",
      "pos": "noun",
      "explanation": "berry + bog: berry that grows in marsh land",
      "isCharacter": false,
      "composition": [
        161,
        "/",
        637
      ]
    },
    {
      "id": 1477,
      "bciAvId": 13434,
      "gloss": "crane",
      "glossSv": "lyft, lyftkran",
      "pos": "noun",
      "explanation": "machine + up and down: equipment to raise and lower",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        723
      ]
    },
    {
      "id": 1478,
      "bciAvId": 13435,
      "gloss": "crash (forward)",
      "glossSv": "kollision, krock",
      "pos": "noun",
      "explanation": "to stop + intensity",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        401
      ]
    },
    {
      "id": 1479,
      "bciAvId": 13436,
      "gloss": "to crash (downward)",
      "glossSv": "krascha, störta",
      "pos": "action",
      "explanation": "crash (downward) + action indicator",
      "isCharacter": false,
      "composition": [
        893,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 1480,
      "bciAvId": 13437,
      "gloss": "crash (air), plane crash, air crash",
      "glossSv": "flygkrash",
      "pos": "noun",
      "explanation": "crash (downward) + airplane",
      "isCharacter": false,
      "composition": [
        893,
        "/",
        401,
        "/",
        115
      ]
    },
    {
      "id": 1481,
      "bciAvId": 13438,
      "gloss": "crash (car), car crash",
      "glossSv": "krock (-bil)",
      "pos": "noun",
      "explanation": "crash (forward) + car",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        401,
        "/",
        202
      ]
    },
    {
      "id": 1482,
      "bciAvId": 13439,
      "gloss": "to crash (forward)",
      "glossSv": "kollidera, krocka",
      "pos": "action",
      "explanation": "crash (forward) + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 1483,
      "bciAvId": 13440,
      "gloss": "crash (downward)",
      "glossSv": "krasch",
      "pos": "noun",
      "explanation": "bump,press,pressing + intensity: an intense fall and hit onto the ground",
      "isCharacter": false,
      "composition": [
        893,
        "/",
        401
      ]
    },
    {
      "id": 1484,
      "bciAvId": 13603,
      "gloss": "to crawl",
      "glossSv": "krypa, gå på knä",
      "pos": "action",
      "explanation": "kneeling (kneeling person) + forward + action indicator: to go forward on one's knees",
      "isCharacter": false,
      "composition": [
        514,
        ";",
        81,
        "/",
        335
      ]
    },
    {
      "id": 1485,
      "bciAvId": 13604,
      "gloss": "crayon, coloured pencil, colored pencil, marker",
      "glossSv": "krita, färgpenna",
      "pos": "noun",
      "explanation": "pencil + colour",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        1161
      ]
    },
    {
      "id": 1486,
      "bciAvId": 13605,
      "gloss": "cream",
      "glossSv": "grädde",
      "pos": "noun",
      "explanation": "milk + intensity: the intensity symbol suggests that cream is rich milk",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        423,
        "/",
        401
      ]
    },
    {
      "id": 1487,
      "bciAvId": 13606,
      "gloss": "to create",
      "glossSv": "skapa",
      "pos": "action",
      "explanation": "creation + action indicator",
      "isCharacter": false,
      "composition": [
        247,
        ";",
        81
      ]
    },
    {
      "id": 1488,
      "bciAvId": 13608,
      "gloss": "creative",
      "glossSv": "kreativ, skapande",
      "pos": "description",
      "explanation": "creation + description indicator",
      "isCharacter": false,
      "composition": [
        247,
        ";",
        86
      ]
    },
    {
      "id": 1489,
      "bciAvId": 13609,
      "gloss": "creature, being",
      "glossSv": "figur, gestalt, levande varelse",
      "pos": "noun",
      "explanation": "life + thing indicator: a living creature. The symbol is the concrete form of life.",
      "isCharacter": false,
      "composition": [
        423,
        ";",
        97
      ]
    },
    {
      "id": 1490,
      "bciAvId": 13610,
      "gloss": "crescent",
      "glossSv": "månform",
      "pos": "noun",
      "explanation": "shape + crescent shape",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        453
      ]
    },
    {
      "id": 1491,
      "bciAvId": 13611,
      "gloss": "to crochet",
      "glossSv": "virka",
      "pos": "action",
      "explanation": "to make + cloth + hook + action indicator: to make cloth with a hook",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        228,
        "/",
        387
      ]
    },
    {
      "id": 1492,
      "bciAvId": 13612,
      "gloss": "croquet (activity)",
      "glossSv": "krocket (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball + hammer: game in which a mallet is used to move a ball",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        148,
        "/",
        373
      ]
    },
    {
      "id": 1493,
      "bciAvId": 13614,
      "gloss": "to cross",
      "glossSv": "gå över, korsa",
      "pos": "action",
      "explanation": "across + action indicator",
      "isCharacter": false,
      "composition": [
        104,
        ";",
        81
      ]
    },
    {
      "id": 1494,
      "bciAvId": 13616,
      "gloss": "to crush, to squeeze",
      "glossSv": "pressa, trycka, klämma",
      "pos": "action",
      "explanation": "compression,compressing,squeezing + action indicator: to crush a thing by pressure from two directions",
      "isCharacter": false,
      "composition": [
        1008,
        ";",
        81
      ]
    },
    {
      "id": 1495,
      "bciAvId": 13617,
      "gloss": "crutches",
      "glossSv": "kryckor",
      "pos": "noun",
      "explanation": "tools + medical + to walk + plural indicator: medical devices for walking",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        99,
        "/",
        958,
        "/",
        418
      ]
    },
    {
      "id": 1496,
      "bciAvId": 13618,
      "gloss": "to cry, to weep",
      "glossSv": "gråta",
      "pos": "action",
      "explanation": "eye + rain + action indicator: to have water falling from one's eyes like raindrops",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81,
        "/",
        556
      ]
    },
    {
      "id": 1497,
      "bciAvId": 13620,
      "gloss": "cucumber",
      "glossSv": "gurka",
      "pos": "noun",
      "explanation": "vegetable (oval-shaped) + long",
      "isCharacter": false,
      "composition": [
        687,
        "/",
        420
      ]
    },
    {
      "id": 1498,
      "bciAvId": 13624,
      "gloss": "current",
      "glossSv": "aktuell, nuvarande, på gång",
      "pos": "description",
      "explanation": "now + description indicator",
      "isCharacter": false,
      "composition": [
        474,
        ";",
        86
      ]
    },
    {
      "id": 1499,
      "bciAvId": 13625,
      "gloss": "current events",
      "glossSv": "aktuella händelser, nyheter",
      "pos": "noun",
      "explanation": "event + now + plural indicator",
      "isCharacter": false,
      "composition": [
        299,
        ";",
        99,
        "/",
        474
      ]
    },
    {
      "id": 1500,
      "bciAvId": 13628,
      "gloss": "to cut (scissors)",
      "glossSv": "klippa",
      "pos": "action",
      "explanation": "scissors + action indicator",
      "isCharacter": false,
      "composition": [
        581,
        ";",
        81
      ]
    },
    {
      "id": 1501,
      "bciAvId": 13629,
      "gloss": "to cut (knife)",
      "glossSv": "skära",
      "pos": "action",
      "explanation": "knife + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81
      ]
    },
    {
      "id": 1502,
      "bciAvId": 13630,
      "gloss": "cutlery",
      "glossSv": "bestick",
      "pos": "noun",
      "explanation": "generalization + knife",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        411
      ]
    },
    {
      "id": 1503,
      "bciAvId": 13631,
      "gloss": "to dance",
      "glossSv": "dansa",
      "pos": "action",
      "explanation": "dance,dancing + action indicator: to step to the rhythm of the music",
      "isCharacter": false,
      "composition": [
        418,
        ";",
        81,
        "/",
        462
      ]
    },
    {
      "id": 1504,
      "bciAvId": 13633,
      "gloss": "dangerous",
      "glossSv": "farlig",
      "pos": "description",
      "explanation": "danger + description indicator",
      "isCharacter": false,
      "composition": [
        256,
        ";",
        86
      ]
    },
    {
      "id": 1505,
      "bciAvId": 13634,
      "gloss": "dark",
      "glossSv": "mörk (FD)",
      "pos": "description",
      "explanation": "opposite meaning + light + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        424,
        ";",
        86
      ]
    },
    {
      "id": 1506,
      "bciAvId": 13635,
      "gloss": "date (man woman)",
      "glossSv": "träff (man kvinna)",
      "pos": "noun",
      "explanation": "to meet + man + woman: a man and a woman meeting each other socially",
      "isCharacter": false,
      "composition": [
        1057,
        "/",
        433,
        "/",
        710
      ]
    },
    {
      "id": 1507,
      "bciAvId": 13636,
      "gloss": "date (two persons)",
      "glossSv": "träff (två personer)",
      "pos": "noun",
      "explanation": "to meet + person + person",
      "isCharacter": false,
      "composition": [
        1057,
        "/",
        513,
        "/",
        513
      ]
    },
    {
      "id": 1508,
      "bciAvId": 13637,
      "gloss": "date (fruit)",
      "glossSv": "dadel",
      "pos": "noun",
      "explanation": "plum (fruit + pit) + palm tree: fruit that grows on a palm tree",
      "isCharacter": false,
      "composition": [
        537,
        "/",
        496
      ]
    },
    {
      "id": 1509,
      "bciAvId": 13640,
      "gloss": "daycare",
      "glossSv": "dagvård",
      "pos": "noun",
      "explanation": "protection + day",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        258
      ]
    },
    {
      "id": 1510,
      "bciAvId": 13641,
      "gloss": "day care centre",
      "glossSv": "daghem (etc)",
      "pos": "noun",
      "explanation": "building + day care",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        548,
        "/",
        258
      ]
    },
    {
      "id": 1511,
      "bciAvId": 13642,
      "gloss": "dead, deceased",
      "glossSv": "död (adj.)",
      "pos": "description",
      "explanation": "death + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        84
      ]
    },
    {
      "id": 1512,
      "bciAvId": 13643,
      "gloss": "deaf",
      "glossSv": "döv",
      "pos": "description",
      "explanation": "deafness + description indicator: unable to hear",
      "isCharacter": false,
      "composition": [
        1017,
        ";",
        86
      ]
    },
    {
      "id": 1513,
      "bciAvId": 13644,
      "gloss": "dear",
      "glossSv": "kära",
      "pos": "function",
      "explanation": "feeling + toward: symbol showing affectionate or friendly feelings toward someone. It is used as a salutation in letters.",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        657
      ]
    },
    {
      "id": 1514,
      "bciAvId": 13646,
      "gloss": "decade",
      "glossSv": "årtionde, decennium",
      "pos": "noun",
      "explanation": "10 + year: a period of ten years",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        9,
        "/",
        716
      ]
    },
    {
      "id": 1515,
      "bciAvId": 13647,
      "gloss": "December",
      "glossSv": "december",
      "pos": "noun",
      "explanation": "month + 12: twelfth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        10,
        "/",
        11
      ]
    },
    {
      "id": 1516,
      "bciAvId": 13648,
      "gloss": "to decide",
      "glossSv": "besluta, bestämma",
      "pos": "action",
      "explanation": "decision + action indicator",
      "isCharacter": false,
      "composition": [
        260,
        ";",
        81
      ]
    },
    {
      "id": 1517,
      "bciAvId": 13650,
      "gloss": "decoration",
      "glossSv": "prydnadssak, dekoration (FD)",
      "pos": "noun",
      "explanation": "thing + plus + beautiful: thing added to beautify",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        120,
        "/",
        303,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1518,
      "bciAvId": 13651,
      "gloss": "to decrease, to reduce",
      "glossSv": "minska, förminska",
      "pos": "action",
      "explanation": "little + action indicator: to become smaller",
      "isCharacter": false,
      "composition": [
        956,
        ";",
        81
      ]
    },
    {
      "id": 1519,
      "bciAvId": 13652,
      "gloss": "deep",
      "glossSv": "djup",
      "pos": "description",
      "explanation": "depth + description indicator: the pointer points downward to the bottom of a relatively deep space",
      "isCharacter": false,
      "composition": [
        1020,
        ";",
        86
      ]
    },
    {
      "id": 1520,
      "bciAvId": 13653,
      "gloss": "to deep-fry",
      "glossSv": "fritera",
      "pos": "action",
      "explanation": "to fry + intensity + action indicator: to fry at a high temperature",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        480,
        "/",
        401
      ]
    },
    {
      "id": 1521,
      "bciAvId": 13654,
      "gloss": "Denmark",
      "glossSv": "Danmark (FD)",
      "pos": "noun",
      "explanation": "country + three Danish waters (OLD): country divided by three channels of water",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        1097
      ]
    },
    {
      "id": 1522,
      "bciAvId": 13655,
      "gloss": "toothpick",
      "glossSv": "tandpetare, tandtråd",
      "pos": "noun",
      "explanation": "linear thing + teeth + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        644
      ]
    },
    {
      "id": 1523,
      "bciAvId": 13656,
      "gloss": "dentist",
      "glossSv": "tandläkare",
      "pos": "person",
      "explanation": "doctor + teeth",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        644
      ]
    },
    {
      "id": 1524,
      "bciAvId": 13657,
      "gloss": "deodorant",
      "glossSv": "deodorant",
      "pos": "noun",
      "explanation": "chemical product + against + odour",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        111,
        "/",
        600
      ]
    },
    {
      "id": 1525,
      "bciAvId": 13658,
      "gloss": "departure",
      "glossSv": "avresa, avgång",
      "pos": "noun",
      "explanation": "reference line + forward: advancing arrow departs from the line",
      "isCharacter": true
    },
    {
      "id": 1526,
      "bciAvId": 13659,
      "gloss": "depression",
      "glossSv": "depression",
      "pos": "noun",
      "explanation": "mood + fall-(to): also a combination of mood and sad + intensity",
      "isCharacter": false,
      "composition": [
        985,
        "/",
        313,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 1527,
      "bciAvId": 13660,
      "gloss": "to descend, to go down",
      "glossSv": "gå ner, sjunka",
      "pos": "action",
      "explanation": "down + action indicator",
      "isCharacter": false,
      "composition": [
        271,
        ";",
        81
      ]
    },
    {
      "id": 1528,
      "bciAvId": 13661,
      "gloss": "to describe",
      "glossSv": "beskriva",
      "pos": "action",
      "explanation": "to say + state of mind + action indicator: to say what you think exists",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        985
      ]
    },
    {
      "id": 1529,
      "bciAvId": 13662,
      "gloss": "desirable",
      "glossSv": "efterlängtad, åtråvärd",
      "pos": "description",
      "explanation": "to want + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        85,
        "/",
        319
      ]
    },
    {
      "id": 1530,
      "bciAvId": 13663,
      "gloss": "desk, worktable, work table",
      "glossSv": "arbetsbord, skrivbord",
      "pos": "noun",
      "explanation": "table + work",
      "isCharacter": false,
      "composition": [
        639,
        "/",
        711
      ]
    },
    {
      "id": 1531,
      "bciAvId": 13664,
      "gloss": "dessert",
      "glossSv": "efterrätt, dessert",
      "pos": "noun",
      "explanation": "food + end: food that one eats at the end of a meal",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        292
      ]
    },
    {
      "id": 1532,
      "bciAvId": 13665,
      "gloss": "to destroy, to annul, to cancel, to cross out, to delete",
      "glossSv": "förstöra, stryka ut, stryka, radera, sudda, ta bort, utplåna",
      "pos": "action",
      "explanation": "deletion,cancellation,destruction + action indicator: diagonal line used to cross out something",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        81
      ]
    },
    {
      "id": 1533,
      "bciAvId": 13666,
      "gloss": "to develop",
      "glossSv": "utveckla",
      "pos": "action",
      "explanation": "development + action indicator",
      "isCharacter": false,
      "composition": [
        6015,
        ";",
        81
      ]
    },
    {
      "id": 1534,
      "bciAvId": 13668,
      "gloss": "dhoti, lungi",
      "glossSv": "dhoti, lungi (Indien)",
      "pos": "noun",
      "explanation": "clothing + around + man",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        134,
        "/",
        433
      ]
    },
    {
      "id": 1535,
      "bciAvId": 13669,
      "gloss": "diamond (shape), rhombus, rhomb",
      "glossSv": "romb",
      "pos": "noun",
      "explanation": "shape + diamond (character)",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        1023
      ]
    },
    {
      "id": 1536,
      "bciAvId": 13670,
      "gloss": "diaper, nappy",
      "glossSv": "blöja",
      "pos": "noun",
      "explanation": "absorbent material + buttocks and genitals",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        402,
        "/",
        1005
      ]
    },
    {
      "id": 1537,
      "bciAvId": 13671,
      "gloss": "diaphragm (contraceptive), pessary",
      "glossSv": "pessar",
      "pos": "noun",
      "explanation": "barrier (contraceptive) + female",
      "isCharacter": false,
      "composition": [
        151,
        "/",
        314
      ]
    },
    {
      "id": 1538,
      "bciAvId": 13672,
      "gloss": "to die",
      "glossSv": "dö, avlida",
      "pos": "action",
      "explanation": "death + action indicator",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        81
      ]
    },
    {
      "id": 1539,
      "bciAvId": 13673,
      "gloss": "diet",
      "glossSv": "bantning, diet",
      "pos": "noun",
      "explanation": "plan + to eat",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        329
      ]
    },
    {
      "id": 1540,
      "bciAvId": 13674,
      "gloss": "to diet",
      "glossSv": "banta, hålla diet",
      "pos": "action",
      "explanation": "to eat + plan + action indicator: to eat according to a plan",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        81,
        "/",
        532
      ]
    },
    {
      "id": 1541,
      "bciAvId": 13676,
      "gloss": "difficult, hard, challenging",
      "glossSv": "svår",
      "pos": "description",
      "explanation": "difficulty + description indicator",
      "isCharacter": false,
      "composition": [
        940,
        ";",
        86
      ]
    },
    {
      "id": 1542,
      "bciAvId": 13677,
      "gloss": "to dig",
      "glossSv": "gräva",
      "pos": "action",
      "explanation": "digging,excavation + action indicator",
      "isCharacter": false,
      "composition": [
        1024,
        ";",
        81
      ]
    },
    {
      "id": 1543,
      "bciAvId": 13678,
      "gloss": "to digest",
      "glossSv": "smälta maten",
      "pos": "action",
      "explanation": "digestion + action indicator",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        81,
        "/",
        653
      ]
    },
    {
      "id": 1544,
      "bciAvId": 13679,
      "gloss": "digestion",
      "glossSv": "matsmältning",
      "pos": "noun",
      "explanation": "food + through: food passing through the body",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        653
      ]
    },
    {
      "id": 1545,
      "bciAvId": 13680,
      "gloss": "dining room",
      "glossSv": "matrum, matsal",
      "pos": "noun",
      "explanation": "room + to eat",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        329
      ]
    },
    {
      "id": 1546,
      "bciAvId": 13681,
      "gloss": "dinosaur",
      "glossSv": "dinosaurie (FD)",
      "pos": "noun",
      "explanation": "lizard,reptile (snake like animal) + past: extinct reptile",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        602,
        "/",
        503
      ]
    },
    {
      "id": 1547,
      "bciAvId": 13682,
      "gloss": "direction, cardinal point",
      "glossSv": "riktning",
      "pos": "noun",
      "explanation": "generalization + forward",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        335
      ]
    },
    {
      "id": 1548,
      "bciAvId": 13683,
      "gloss": "dirty, soiled",
      "glossSv": "smutsig, fläckig",
      "pos": "description",
      "explanation": "many + spot + description indicator: having many spots",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        303,
        ";",
        86,
        "/",
        270
      ]
    },
    {
      "id": 1549,
      "bciAvId": 13684,
      "gloss": "disability, handicap, impairment",
      "glossSv": "handikapp (FD)",
      "pos": "noun",
      "explanation": "ability + limit(s): limited ability",
      "isCharacter": false,
      "composition": [
        101,
        "/",
        427
      ]
    },
    {
      "id": 1550,
      "bciAvId": 13686,
      "gloss": "disco",
      "glossSv": "disco",
      "pos": "noun",
      "explanation": "gathering + record: gathering to listen to recorded music",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        1075,
        "/",
        278
      ]
    },
    {
      "id": 1551,
      "bciAvId": 13688,
      "gloss": "to discuss, to converse, to debate",
      "glossSv": "samtala",
      "pos": "action",
      "explanation": "discussion + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        144
      ]
    },
    {
      "id": 1552,
      "bciAvId": 13689,
      "gloss": "discussion, conversation, debate, chat",
      "glossSv": "samtal",
      "pos": "noun",
      "explanation": "to speak + back and forth: talk that goes back and forth",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        144
      ]
    },
    {
      "id": 1553,
      "bciAvId": 13691,
      "gloss": "dislike",
      "glossSv": "motvilja, ogillande",
      "pos": "noun",
      "explanation": "feeling + negative",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1554,
      "bciAvId": 13692,
      "gloss": "to dislike",
      "glossSv": "tycka illa om, ogilla",
      "pos": "action",
      "explanation": "dislike + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1555,
      "bciAvId": 13694,
      "gloss": "to divide",
      "glossSv": "dela, dividera",
      "pos": "action",
      "explanation": "division + action indicator",
      "isCharacter": false,
      "composition": [
        266,
        ";",
        81
      ]
    },
    {
      "id": 1556,
      "bciAvId": 13858,
      "gloss": "divorce",
      "glossSv": "skilsmässa",
      "pos": "noun",
      "explanation": "marriage + division: legal division of a marriage",
      "isCharacter": false,
      "composition": [
        437,
        "/",
        266
      ]
    },
    {
      "id": 1557,
      "bciAvId": 13859,
      "gloss": "to divorce",
      "glossSv": "skiljas",
      "pos": "action",
      "explanation": "divorce + action indicator",
      "isCharacter": false,
      "composition": [
        437,
        ";",
        81,
        "/",
        266
      ]
    },
    {
      "id": 1558,
      "bciAvId": 13860,
      "gloss": "to do, to act",
      "glossSv": "göra",
      "pos": "action",
      "explanation": "action + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81
      ]
    },
    {
      "id": 1559,
      "bciAvId": 13861,
      "gloss": "doctor, physician",
      "glossSv": "läkare, doktor",
      "pos": "person",
      "explanation": "person + medical",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958
      ]
    },
    {
      "id": 1560,
      "bciAvId": 13862,
      "gloss": "doll",
      "glossSv": "docka",
      "pos": "noun",
      "explanation": "child + man-made",
      "isCharacter": false,
      "composition": [
        220,
        "/",
        840
      ]
    },
    {
      "id": 1561,
      "bciAvId": 13865,
      "gloss": "donkey, mule",
      "glossSv": "åsna, mula",
      "pos": "noun",
      "explanation": "horse + work: animal that resembles a horse and is commonly used to assist with work",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        711
      ]
    },
    {
      "id": 1562,
      "bciAvId": 13868,
      "gloss": "to doubt",
      "glossSv": "undra, vara osäker",
      "pos": "action",
      "explanation": "doubt,uncertainty + action indicator",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        81
      ]
    },
    {
      "id": 1563,
      "bciAvId": 13872,
      "gloss": "to drain, to sift, to strain",
      "glossSv": "sila, filtrera, tömma",
      "pos": "action",
      "explanation": "sieve + action indicator",
      "isCharacter": false,
      "composition": [
        594,
        ";",
        81
      ]
    },
    {
      "id": 1564,
      "bciAvId": 13873,
      "gloss": "to draw, to sketch",
      "glossSv": "rita, teckna",
      "pos": "action",
      "explanation": "pencil + picture + action indicator: to use a pencil or pen to make a picture",
      "isCharacter": false,
      "composition": [
        509,
        ";",
        81,
        "/",
        303,
        "/",
        291
      ]
    },
    {
      "id": 1565,
      "bciAvId": 13875,
      "gloss": "to dream",
      "glossSv": "drömma",
      "pos": "action",
      "explanation": "to think + to sleep + action indicator: to think in one's sleep",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        81,
        "/",
        599
      ]
    },
    {
      "id": 1566,
      "bciAvId": 13876,
      "gloss": "dress",
      "glossSv": "klänning",
      "pos": "noun",
      "explanation": "clothing + woman",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        710
      ]
    },
    {
      "id": 1567,
      "bciAvId": 13877,
      "gloss": "to dress, to wear",
      "glossSv": "klä på, ha på sig",
      "pos": "action",
      "explanation": "clothing + action indicator",
      "isCharacter": false,
      "composition": [
        229,
        ";",
        81
      ]
    },
    {
      "id": 1568,
      "bciAvId": 13878,
      "gloss": "to dress up, to disguise",
      "glossSv": "klä ut sig",
      "pos": "action",
      "explanation": "costume + action indicator: people \"dress up\" to imagine themselves as someone or something else, e.g. at Halloween",
      "isCharacter": false,
      "composition": [
        229,
        ";",
        81,
        "/",
        945
      ]
    },
    {
      "id": 1569,
      "bciAvId": 13879,
      "gloss": "dressing gown, housecoat, robe",
      "glossSv": "morgonrock, hemmadress",
      "pos": "noun",
      "explanation": "clothing + comfort",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        562
      ]
    },
    {
      "id": 1570,
      "bciAvId": 13880,
      "gloss": "dried bean",
      "glossSv": "torkad böna (FD)",
      "pos": "noun",
      "explanation": "bean + dry",
      "isCharacter": false,
      "composition": [
        154,
        "/",
        486,
        "/",
        695
      ]
    },
    {
      "id": 1571,
      "bciAvId": 13882,
      "gloss": "to drink",
      "glossSv": "dricka",
      "pos": "action",
      "explanation": "drink + action indicator",
      "isCharacter": false,
      "composition": [
        275,
        ";",
        81
      ]
    },
    {
      "id": 1572,
      "bciAvId": 13883,
      "gloss": "to drive",
      "glossSv": "köra bil, åka bil",
      "pos": "action",
      "explanation": "car + action indicator",
      "isCharacter": false,
      "composition": [
        202,
        ";",
        81
      ]
    },
    {
      "id": 1573,
      "bciAvId": 13884,
      "gloss": "driver, chauffeur",
      "glossSv": "bilförare, chaufför",
      "pos": "person",
      "explanation": "person + car",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        202
      ]
    },
    {
      "id": 1574,
      "bciAvId": 13886,
      "gloss": "drunk",
      "glossSv": "berusad, full",
      "pos": "description",
      "explanation": "weak person + alcoholic drink + description indicator: when drunk a person’s knees may buckle",
      "isCharacter": false,
      "composition": [
        519,
        ";",
        86,
        "/",
        116
      ]
    },
    {
      "id": 1575,
      "bciAvId": 13887,
      "gloss": "dry",
      "glossSv": "torr (FD)",
      "pos": "description",
      "explanation": "opposite meaning + wet + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        695,
        ";",
        84
      ]
    },
    {
      "id": 1576,
      "bciAvId": 13888,
      "gloss": "to dry",
      "glossSv": "torka (FD)",
      "pos": "action",
      "explanation": "to cause + dry + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        486,
        "/",
        695
      ]
    },
    {
      "id": 1577,
      "bciAvId": 13889,
      "gloss": "duck (food)",
      "glossSv": "anka (mat)",
      "pos": "noun",
      "explanation": "food + duck",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        164
      ]
    },
    {
      "id": 1578,
      "bciAvId": 13890,
      "gloss": "dump truck, dumper, tipper lorry, tipper",
      "glossSv": "tippbil, dumper",
      "pos": "noun",
      "explanation": "truck + out of (downward)",
      "isCharacter": false,
      "composition": [
        668,
        "/",
        492
      ]
    },
    {
      "id": 1579,
      "bciAvId": 13891,
      "gloss": "Durga",
      "glossSv": "Durga (Indien)",
      "pos": "person",
      "explanation": "god + 10 + hand: Hindu goddess",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        10,
        "/",
        9,
        "/",
        374
      ]
    },
    {
      "id": 1580,
      "bciAvId": 13893,
      "gloss": "each, every",
      "glossSv": "varje, var och en",
      "pos": "expression",
      "explanation": "1 + all: one of all",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        117
      ]
    },
    {
      "id": 1581,
      "bciAvId": 13896,
      "gloss": "early",
      "glossSv": "tidig",
      "pos": "description",
      "explanation": "before + time + description indicator: before the appointed time",
      "isCharacter": false,
      "composition": [
        158,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 1582,
      "bciAvId": 13897,
      "gloss": "earmuffs (protection)",
      "glossSv": "öronlappar",
      "pos": "noun",
      "explanation": "protection + ear",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        278
      ]
    },
    {
      "id": 1583,
      "bciAvId": 13898,
      "gloss": "to earn",
      "glossSv": "tjäna, förtjäna",
      "pos": "action",
      "explanation": "to work + for (in exchange for) + money: to work in exchange for money",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81,
        "/",
        331,
        "/",
        451
      ]
    },
    {
      "id": 1584,
      "bciAvId": 13899,
      "gloss": "earphones, headphones",
      "glossSv": "hörlurar",
      "pos": "noun",
      "explanation": "earmuffs (general) + electricity",
      "isCharacter": false,
      "composition": [
        942,
        "/",
        288
      ]
    },
    {
      "id": 1585,
      "bciAvId": 13903,
      "gloss": "easter",
      "glossSv": "påsk",
      "pos": "noun",
      "explanation": "day + to rise + Christ [contraction]: the day of Christ's rising from the dead",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        678,
        "/",
        248
      ]
    },
    {
      "id": 1586,
      "bciAvId": 13904,
      "gloss": "eastern",
      "glossSv": "ostlig",
      "pos": "description",
      "explanation": "east + description indicator",
      "isCharacter": false,
      "composition": [
        282,
        ";",
        86
      ]
    },
    {
      "id": 1587,
      "bciAvId": 13905,
      "gloss": "easy",
      "glossSv": "enkel, lätt (FD)",
      "pos": "description",
      "explanation": "opposite meaning + difficult + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        940,
        ";",
        86
      ]
    },
    {
      "id": 1588,
      "bciAvId": 13906,
      "gloss": "to eat",
      "glossSv": "äta",
      "pos": "action",
      "explanation": "food + action indicator",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        81
      ]
    },
    {
      "id": 1589,
      "bciAvId": 13908,
      "gloss": "education",
      "glossSv": "utbildning",
      "pos": "noun",
      "explanation": "to exchange + knowledge",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        412
      ]
    },
    {
      "id": 1590,
      "bciAvId": 13909,
      "gloss": "eel",
      "glossSv": "ål",
      "pos": "noun",
      "explanation": "fish + snake: snake-like fish",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        602
      ]
    },
    {
      "id": 1591,
      "bciAvId": 13911,
      "gloss": "egg, ovum (1)",
      "glossSv": "ägg (1)",
      "pos": "noun",
      "explanation": "seed + life",
      "isCharacter": false,
      "composition": [
        584,
        "/",
        423
      ]
    },
    {
      "id": 1592,
      "bciAvId": 13913,
      "gloss": "eggplant, aubergine, brinjal",
      "glossSv": "aubergine, äggplanta",
      "pos": "noun",
      "explanation": "vegetable (oval-shaped) + purple",
      "isCharacter": false,
      "composition": [
        687,
        "/",
        1161,
        "/",
        457,
        "/",
        597
      ]
    },
    {
      "id": 1593,
      "bciAvId": 13915,
      "gloss": "ejaculation",
      "glossSv": "utlösning",
      "pos": "noun",
      "explanation": "erection + sperm + intensity",
      "isCharacter": false,
      "composition": [
        295,
        "/",
        612,
        "/",
        401
      ]
    },
    {
      "id": 1594,
      "bciAvId": 13917,
      "gloss": "electric, electrical",
      "glossSv": "elektrisk",
      "pos": "description",
      "explanation": "electricity + description indicator",
      "isCharacter": false,
      "composition": [
        288,
        ";",
        86
      ]
    },
    {
      "id": 1595,
      "bciAvId": 13919,
      "gloss": "electric light, lamp",
      "glossSv": "lampa",
      "pos": "noun",
      "explanation": "light + electricity + thing indicator: object that provides light by means of electricity",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        288
      ]
    },
    {
      "id": 1596,
      "bciAvId": 13920,
      "gloss": "electric wheelchair",
      "glossSv": "elrullstol",
      "pos": "noun",
      "explanation": "wheelchair + electricity",
      "isCharacter": false,
      "composition": [
        701,
        "/",
        288
      ]
    },
    {
      "id": 1597,
      "bciAvId": 13921,
      "gloss": "electric wire, electric cord, cord, cable, lead",
      "glossSv": "sladd, ledning",
      "pos": "noun",
      "explanation": "linear thing + electricity + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        288
      ]
    },
    {
      "id": 1598,
      "bciAvId": 13923,
      "gloss": "elephant",
      "glossSv": "elefant",
      "pos": "noun",
      "explanation": "animal + nose: animal distinguished by its nose, i.e., trunk",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        473
      ]
    },
    {
      "id": 1599,
      "bciAvId": 13924,
      "gloss": "elevator, lift",
      "glossSv": "hiss",
      "pos": "noun",
      "explanation": "room + up and down",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        723
      ]
    },
    {
      "id": 1600,
      "bciAvId": 13925,
      "gloss": "Elul",
      "glossSv": "Elul (Israel)",
      "pos": "noun",
      "explanation": "month + before + shofar: month before Rosh Hashana (Hebrew)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        158,
        "/",
        389,
        "/",
        621
      ]
    },
    {
      "id": 1601,
      "bciAvId": 13926,
      "gloss": "embarrassed",
      "glossSv": "generad",
      "pos": "description",
      "explanation": "embarrassment + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        264,
        ";",
        84,
        "/",
        723
      ]
    },
    {
      "id": 1602,
      "bciAvId": 13927,
      "gloss": "embarrassing",
      "glossSv": "pinsam",
      "pos": "description",
      "explanation": "embarrassment + description indicator",
      "isCharacter": false,
      "composition": [
        264,
        ";",
        86,
        "/",
        723
      ]
    },
    {
      "id": 1603,
      "bciAvId": 13928,
      "gloss": "embarrassment",
      "glossSv": "pinsamhet",
      "pos": "noun",
      "explanation": "discomfort + up and down: also a combination of uncomfortable and upset",
      "isCharacter": false,
      "composition": [
        264,
        "/",
        723
      ]
    },
    {
      "id": 1604,
      "bciAvId": 13930,
      "gloss": "emergency",
      "glossSv": "nöd, nödläge",
      "pos": "noun",
      "explanation": "danger + limited time",
      "isCharacter": false,
      "composition": [
        256,
        "/",
        426
      ]
    },
    {
      "id": 1605,
      "bciAvId": 13931,
      "gloss": "empathy",
      "glossSv": "medkänsla",
      "pos": "noun",
      "explanation": "feeling + understanding,comprehension",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        1103
      ]
    },
    {
      "id": 1606,
      "bciAvId": 13932,
      "gloss": "empty",
      "glossSv": "tom (FD)",
      "pos": "description",
      "explanation": "opposite meaning + full + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        947,
        ";",
        86
      ]
    },
    {
      "id": 1607,
      "bciAvId": 13933,
      "gloss": "to empty",
      "glossSv": "tömma (FD)",
      "pos": "action",
      "explanation": "empty + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        947,
        ";",
        81
      ]
    },
    {
      "id": 1608,
      "bciAvId": 13937,
      "gloss": "engaged",
      "glossSv": "förlovad",
      "pos": "description",
      "explanation": "before + marriage + description indicator",
      "isCharacter": false,
      "composition": [
        158,
        "/",
        437,
        ";",
        86
      ]
    },
    {
      "id": 1609,
      "bciAvId": 13938,
      "gloss": "to enjoy",
      "glossSv": "glädja",
      "pos": "action",
      "explanation": "happiness + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        678
      ]
    },
    {
      "id": 1610,
      "bciAvId": 13939,
      "gloss": "enough",
      "glossSv": "nog, tillräckligt",
      "pos": "description",
      "explanation": "minus + more + description indicator: no more needed, i.e.,the right amount or number",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        937,
        ";",
        86
      ]
    },
    {
      "id": 1611,
      "bciAvId": 13940,
      "gloss": "to enter, to absorb, to insert, to penetrate",
      "glossSv": "gå in, komma in, sätta in (etc)",
      "pos": "action",
      "explanation": "into + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81
      ]
    },
    {
      "id": 1612,
      "bciAvId": 13941,
      "gloss": "envious",
      "glossSv": "avundsjuk",
      "pos": "description",
      "explanation": "to want + comma + other + to have + description indicator: wanting what another person has",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        319,
        "/",
        5,
        "/",
        428,
        "/",
        11,
        "/",
        953
      ]
    },
    {
      "id": 1613,
      "bciAvId": 13943,
      "gloss": "to equal",
      "glossSv": "likna, vara lika med",
      "pos": "action",
      "explanation": "equal + action indicator",
      "isCharacter": false,
      "composition": [
        578,
        ";",
        81
      ]
    },
    {
      "id": 1614,
      "bciAvId": 13945,
      "gloss": "eternal life, immortality (after death)",
      "glossSv": "evigt liv",
      "pos": "noun",
      "explanation": "life + after + death",
      "isCharacter": false,
      "composition": [
        423,
        "/",
        109,
        "/",
        259
      ]
    },
    {
      "id": 1615,
      "bciAvId": 13947,
      "gloss": "to evaluate",
      "glossSv": "värdera",
      "pos": "action",
      "explanation": "evaluation + action indicator",
      "isCharacter": false,
      "composition": [
        297,
        ";",
        81
      ]
    },
    {
      "id": 1616,
      "bciAvId": 13948,
      "gloss": "to appreciate, to value, to treasure",
      "glossSv": "uppskatta",
      "pos": "action",
      "explanation": "to evaluate + good + action indicator",
      "isCharacter": false,
      "composition": [
        297,
        ";",
        81,
        "/",
        313,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1617,
      "bciAvId": 14113,
      "gloss": "evening before holiday, evening of Sabbath",
      "glossSv": "afton, kväll före helgdag",
      "pos": "noun",
      "explanation": "evening + before + Sabbath,day of rest",
      "isCharacter": false,
      "composition": [
        298,
        "/",
        158,
        "/",
        258,
        "/",
        562
      ]
    },
    {
      "id": 1618,
      "bciAvId": 14115,
      "gloss": "ever, whenever",
      "glossSv": "någonsin",
      "pos": "description",
      "explanation": "anytime + description indicator",
      "isCharacter": false,
      "composition": [
        100,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 1619,
      "bciAvId": 14117,
      "gloss": "everybody, everyone",
      "glossSv": "alla",
      "pos": "expression",
      "explanation": "all + person",
      "isCharacter": false,
      "composition": [
        117,
        "/",
        513
      ]
    },
    {
      "id": 1620,
      "bciAvId": 14118,
      "gloss": "to exchange, to substitute, to trade",
      "glossSv": "byta",
      "pos": "action",
      "explanation": "exchange,substitution + action indicator",
      "isCharacter": false,
      "composition": [
        1029,
        ";",
        81
      ]
    },
    {
      "id": 1621,
      "bciAvId": 14119,
      "gloss": "ecstatic",
      "glossSv": "extatisk, exalterad",
      "pos": "description",
      "explanation": "ecstasy + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1622,
      "bciAvId": 14120,
      "gloss": "ecstasy",
      "glossSv": "extas",
      "pos": "noun",
      "explanation": "feeling + three intensity symbols: experiencing very intense feelings",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1623,
      "bciAvId": 14121,
      "gloss": "to exclude",
      "glossSv": "stänga ute, utesluta",
      "pos": "action",
      "explanation": "outside + action indicator",
      "isCharacter": false,
      "composition": [
        490,
        ";",
        81
      ]
    },
    {
      "id": 1624,
      "bciAvId": 14122,
      "gloss": "excuse",
      "glossSv": "förlåtelse, ursäkt",
      "pos": "noun",
      "explanation": "to allow + after: condoning of something after it has occurred",
      "isCharacter": false,
      "composition": [
        960,
        "/",
        109
      ]
    },
    {
      "id": 1625,
      "bciAvId": 14123,
      "gloss": "to excuse",
      "glossSv": "förlåta, ursäkta",
      "pos": "action",
      "explanation": "excuse + action indicator",
      "isCharacter": false,
      "composition": [
        960,
        ";",
        81,
        "/",
        109
      ]
    },
    {
      "id": 1626,
      "bciAvId": 14124,
      "gloss": "to exercise, to work out",
      "glossSv": "träna",
      "pos": "action",
      "explanation": "exercise (physical) + action indicator: to work in order to maintain health",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81,
        "/",
        377
      ]
    },
    {
      "id": 1627,
      "bciAvId": 14125,
      "gloss": "exhibitionism, immodesty, indecent exposure",
      "glossSv": "blottande",
      "pos": "noun",
      "explanation": "to cause + to see + genitals",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        303,
        "/",
        349
      ]
    },
    {
      "id": 1628,
      "bciAvId": 14126,
      "gloss": "to exit",
      "glossSv": "gå ut, komma ut",
      "pos": "action",
      "explanation": "out of,exit (forward) + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81
      ]
    },
    {
      "id": 1629,
      "bciAvId": 14127,
      "gloss": "to expect, to anticipate",
      "glossSv": "anta, förvänta",
      "pos": "action",
      "explanation": "expectation + action indicator",
      "isCharacter": false,
      "composition": [
        301,
        ";",
        81
      ]
    },
    {
      "id": 1630,
      "bciAvId": 14129,
      "gloss": "expensive",
      "glossSv": "dyr (FD)",
      "pos": "description",
      "explanation": "much + cost + description indicator: costing a lot of money",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        451,
        ";",
        86,
        "/",
        331,
        "/",
        651
      ]
    },
    {
      "id": 1631,
      "bciAvId": 14130,
      "gloss": "to explain, to give a reason",
      "glossSv": "förklara",
      "pos": "action",
      "explanation": "to say + understanding,comprehension + action indicator: to say something in such a way that another person understands it",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        1103
      ]
    },
    {
      "id": 1632,
      "bciAvId": 14131,
      "gloss": "to explode, to blow up, to detonate, to burst",
      "glossSv": "explodera, spränga",
      "pos": "action",
      "explanation": "explosion + action indicator",
      "isCharacter": false,
      "composition": [
        302,
        ";",
        81
      ]
    },
    {
      "id": 1633,
      "bciAvId": 14135,
      "gloss": "eyebrow pencil",
      "glossSv": "kajalpenna, ögonpenna",
      "pos": "noun",
      "explanation": "pencil + eyebrow",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        304
      ]
    },
    {
      "id": 1634,
      "bciAvId": 14137,
      "gloss": "eye makeup",
      "glossSv": "mascara",
      "pos": "noun",
      "explanation": "colour + plus + eyelid(s): colour added to eyelids and eyelashes",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        1031
      ]
    },
    {
      "id": 1635,
      "bciAvId": 14140,
      "gloss": "factory, plant",
      "glossSv": "fabrik, verkstad",
      "pos": "noun",
      "explanation": "building + to make: building where things are manufactured",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        840
      ]
    },
    {
      "id": 1636,
      "bciAvId": 14141,
      "gloss": "falafel",
      "glossSv": "falafel",
      "pos": "noun",
      "explanation": "food + ball + bean: Middle Eastern food made from chick-pea meal and shaped into balls",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        148,
        "/",
        154
      ]
    },
    {
      "id": 1637,
      "bciAvId": 14142,
      "gloss": "to fall",
      "glossSv": "falla, ramla, tappa",
      "pos": "action",
      "explanation": "fall,drop,spill,tumble + action indicator",
      "isCharacter": false,
      "composition": [
        271,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 1638,
      "bciAvId": 14143,
      "gloss": "fallopian tube",
      "glossSv": "äggledare",
      "pos": "noun",
      "explanation": "tube + egg",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        285
      ]
    },
    {
      "id": 1639,
      "bciAvId": 14146,
      "gloss": "police force, police",
      "glossSv": "polisstyrka, poliskår, polismakt, polis",
      "pos": "person",
      "explanation": "group (people) + protection: group of caring people",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        548
      ]
    },
    {
      "id": 1640,
      "bciAvId": 14147,
      "gloss": "family planning",
      "glossSv": "familjeplanering",
      "pos": "noun",
      "explanation": "plan + conception",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        236
      ]
    },
    {
      "id": 1641,
      "bciAvId": 14148,
      "gloss": "family planning clinic",
      "glossSv": "mottagning för familjeplanering",
      "pos": "noun",
      "explanation": "public room + family planning",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        532,
        "/",
        236
      ]
    },
    {
      "id": 1642,
      "bciAvId": 14150,
      "gloss": "far, distant",
      "glossSv": "långt bort, avlägsen (FD)",
      "pos": "description",
      "explanation": "farness,remoteness,farawayness (OLD) + description indicator: a full space between the two lines, the lines are relatively far apart",
      "isCharacter": false,
      "composition": [
        946,
        ";",
        86
      ]
    },
    {
      "id": 1643,
      "bciAvId": 14152,
      "gloss": "farmer",
      "glossSv": "bonde, lantbrukare",
      "pos": "person",
      "explanation": "person + farm: person who farms",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        311
      ]
    },
    {
      "id": 1644,
      "bciAvId": 14153,
      "gloss": "fast day",
      "glossSv": "fastedag",
      "pos": "noun",
      "explanation": "day + without + food",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        449,
        "/",
        329
      ]
    },
    {
      "id": 1645,
      "bciAvId": 14154,
      "gloss": "to fasten, to attach, to join, to append, to connect",
      "glossSv": "sätta ihop, sätta fast",
      "pos": "action",
      "explanation": "together + action indicator",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        81
      ]
    },
    {
      "id": 1646,
      "bciAvId": 14155,
      "gloss": "fastener, gripper, velcro, zipper",
      "glossSv": "dragkedja, kardborrband, spänne (etc)",
      "pos": "noun",
      "explanation": "thing + to fasten + clothing",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        823,
        "/",
        229
      ]
    },
    {
      "id": 1647,
      "bciAvId": 14156,
      "gloss": "fat, thick",
      "glossSv": "tjock, fet (FD)",
      "pos": "description",
      "explanation": "fatness,thickness (OLD) + description indicator: the pointers point inward to the widest space bounded by the reference lines",
      "isCharacter": false,
      "composition": [
        1035,
        ";",
        86
      ]
    },
    {
      "id": 1648,
      "bciAvId": 14158,
      "gloss": "favourite, favorite",
      "glossSv": "favorit-, älsklings-",
      "pos": "description",
      "explanation": "to choose + first + description after the fact indicator: one's first choice",
      "isCharacter": false,
      "composition": [
        223,
        ";",
        86,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 1649,
      "bciAvId": 14159,
      "gloss": "to fear, to be afraid, to dread",
      "glossSv": "vara rädd",
      "pos": "action",
      "explanation": "afraid + action indicator: to feel afraid of the future because of its uncertainties",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        271,
        "/",
        1042
      ]
    },
    {
      "id": 1650,
      "bciAvId": 14160,
      "gloss": "feather",
      "glossSv": "fjäder",
      "pos": "noun",
      "explanation": "part of + wings",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        708
      ]
    },
    {
      "id": 1651,
      "bciAvId": 14161,
      "gloss": "February",
      "glossSv": "februari",
      "pos": "noun",
      "explanation": "month + 2: second month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        11
      ]
    },
    {
      "id": 1652,
      "bciAvId": 14162,
      "gloss": "to feed",
      "glossSv": "mata",
      "pos": "action",
      "explanation": "to give + food + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        329
      ]
    },
    {
      "id": 1653,
      "bciAvId": 14163,
      "gloss": "to feel",
      "glossSv": "känna",
      "pos": "action",
      "explanation": "feeling + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81
      ]
    },
    {
      "id": 1654,
      "bciAvId": 14165,
      "gloss": "female, feminine (person)",
      "glossSv": "kvinnlig, feminin",
      "pos": "description",
      "explanation": "woman + description indicator",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        86
      ]
    },
    {
      "id": 1655,
      "bciAvId": 14168,
      "gloss": "fertile",
      "glossSv": "fertil, fruktsam",
      "pos": "description",
      "explanation": "conception + description before the fact indicator: capable of conception",
      "isCharacter": false,
      "composition": [
        236,
        ";",
        85
      ]
    },
    {
      "id": 1656,
      "bciAvId": 14169,
      "gloss": "fertility counselling",
      "glossSv": "fertilitetsrådgivning",
      "pos": "noun",
      "explanation": "help + conception",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        236
      ]
    },
    {
      "id": 1657,
      "bciAvId": 14171,
      "gloss": "few, little",
      "glossSv": "lite, få (FD)",
      "pos": "description",
      "explanation": "opposite meaning + much/many + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        368,
        ";",
        86
      ]
    },
    {
      "id": 1658,
      "bciAvId": 14172,
      "gloss": "fidelity, loyalty, solidarity",
      "glossSv": "trohet, samhörighet, solidaritet",
      "pos": "noun",
      "explanation": "feeling + attachment",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        823
      ]
    },
    {
      "id": 1659,
      "bciAvId": 14174,
      "gloss": "field hockey, hockey (activity)",
      "glossSv": "landhockey",
      "pos": "noun",
      "explanation": "activity + sport stick and ball: game played with a stick and a ball",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1092
      ]
    },
    {
      "id": 1660,
      "bciAvId": 14175,
      "gloss": "to fight, to combat",
      "glossSv": "bråka, slåss",
      "pos": "action",
      "explanation": "fight + action indicator",
      "isCharacter": false,
      "composition": [
        934,
        ";",
        81
      ]
    },
    {
      "id": 1661,
      "bciAvId": 14176,
      "gloss": "to fill",
      "glossSv": "fylla",
      "pos": "action",
      "explanation": "filling,fill,fullness + action indicator",
      "isCharacter": false,
      "composition": [
        947,
        ";",
        81
      ]
    },
    {
      "id": 1662,
      "bciAvId": 14177,
      "gloss": "film",
      "glossSv": "filmrulle",
      "pos": "noun",
      "explanation": "cylinder + camera",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        198
      ]
    },
    {
      "id": 1663,
      "bciAvId": 14178,
      "gloss": "finally, at last",
      "glossSv": "slutligen, till sist",
      "pos": "description",
      "explanation": "time + last + description indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        486,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 1664,
      "bciAvId": 14179,
      "gloss": "to find",
      "glossSv": "hitta, upptäcka",
      "pos": "action",
      "explanation": "eye + hidden thing + action indicator: to see something that was hidden",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81,
        "/",
        1044
      ]
    },
    {
      "id": 1665,
      "bciAvId": 14181,
      "gloss": "to finish, to complete",
      "glossSv": "avsluta",
      "pos": "action",
      "explanation": "to do + all + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        117
      ]
    },
    {
      "id": 1666,
      "bciAvId": 14182,
      "gloss": "Finland",
      "glossSv": "Finland",
      "pos": "noun",
      "explanation": "country + sauna",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        624,
        "/",
        629
      ]
    },
    {
      "id": 1667,
      "bciAvId": 14184,
      "gloss": "firefighter, fireman",
      "glossSv": "brandman",
      "pos": "person",
      "explanation": "person + extinction,extinguishing (fire): person who puts out fires",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1030
      ]
    },
    {
      "id": 1668,
      "bciAvId": 14186,
      "gloss": "fire truck, fire engine",
      "glossSv": "brandbil",
      "pos": "noun",
      "explanation": "truck + extinction,extinguishing (fire): truck used to put out fires",
      "isCharacter": false,
      "composition": [
        668,
        "/",
        1030
      ]
    },
    {
      "id": 1669,
      "bciAvId": 14187,
      "gloss": "first, primary",
      "glossSv": "första, först",
      "pos": "description",
      "explanation": "1 + decimal point + description indicator: the dot indicates an ordinal numeral",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        86,
        "/",
        4
      ]
    },
    {
      "id": 1670,
      "bciAvId": 14189,
      "gloss": "fish (food)",
      "glossSv": "fisk (mat)",
      "pos": "noun",
      "explanation": "food + fish: food obtained from a fish",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        321
      ]
    },
    {
      "id": 1671,
      "bciAvId": 14190,
      "gloss": "to fish",
      "glossSv": "fiska, meta",
      "pos": "action",
      "explanation": "fishing + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        321
      ]
    },
    {
      "id": 1672,
      "bciAvId": 14191,
      "gloss": "fishing, angling",
      "glossSv": "fiske",
      "pos": "noun",
      "explanation": "getting + fish: catching fish",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        321
      ]
    },
    {
      "id": 1673,
      "bciAvId": 14192,
      "gloss": "to fix, to mend, to repair",
      "glossSv": "laga, reparera",
      "pos": "action",
      "explanation": "fixing,fix,mending,mend,repair,reparation + work + action indicator: to make something work again",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        711
      ]
    },
    {
      "id": 1674,
      "bciAvId": 14194,
      "gloss": "flame",
      "glossSv": "låga",
      "pos": "noun",
      "explanation": "part of + fire",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        319
      ]
    },
    {
      "id": 1675,
      "bciAvId": 14195,
      "gloss": "burnable, combustible, ignitable",
      "glossSv": "brännbar",
      "pos": "description",
      "explanation": "fire + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        85
      ]
    },
    {
      "id": 1676,
      "bciAvId": 14196,
      "gloss": "flashlight, lantern",
      "glossSv": "ficklampa, lykta",
      "pos": "noun",
      "explanation": "light + hand + thing indicator: portable lamp",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        374
      ]
    },
    {
      "id": 1677,
      "bciAvId": 14197,
      "gloss": "flat",
      "glossSv": "platt, plan, flat",
      "pos": "description",
      "explanation": "without + mountain + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        456,
        ";",
        86
      ]
    },
    {
      "id": 1678,
      "bciAvId": 14198,
      "gloss": "flavouring, flavoring, condiment, seasoning",
      "glossSv": "krydda, smaktillsats",
      "pos": "noun",
      "explanation": "addition + taste + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642
      ]
    },
    {
      "id": 1679,
      "bciAvId": 14199,
      "gloss": "flea",
      "glossSv": "loppa",
      "pos": "noun",
      "explanation": "louse,stinging insect + to jump: stinging insect that jumps",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        538,
        "/",
        836
      ]
    },
    {
      "id": 1680,
      "bciAvId": 14200,
      "gloss": "to float",
      "glossSv": "flyta",
      "pos": "action",
      "explanation": "floating container + action indicator: container appears to float on water",
      "isCharacter": false,
      "composition": [
        1036,
        ";",
        81
      ]
    },
    {
      "id": 1681,
      "bciAvId": 14201,
      "gloss": "flood",
      "glossSv": "översvämning",
      "pos": "noun",
      "explanation": "much + water on ground (flooding)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1107
      ]
    },
    {
      "id": 1682,
      "bciAvId": 14204,
      "gloss": "flour",
      "glossSv": "mjöl, gryn",
      "pos": "noun",
      "explanation": "powder + grain: powder made from grain",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        357
      ]
    },
    {
      "id": 1683,
      "bciAvId": 14369,
      "gloss": "flower (protected)",
      "glossSv": "fridlyst blomma",
      "pos": "noun",
      "explanation": "flower + protection + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        548,
        ";",
        84
      ]
    },
    {
      "id": 1684,
      "bciAvId": 14370,
      "gloss": "wildflower",
      "glossSv": "vild blomma",
      "pos": "noun",
      "explanation": "flower + open: uncultivated flower that grows in the open",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        484
      ]
    },
    {
      "id": 1685,
      "bciAvId": 14372,
      "gloss": "to fly",
      "glossSv": "flyga",
      "pos": "action",
      "explanation": "wings + action indicator",
      "isCharacter": false,
      "composition": [
        708,
        ";",
        81
      ]
    },
    {
      "id": 1686,
      "bciAvId": 14373,
      "gloss": "flying",
      "glossSv": "flyg-, flygande",
      "pos": "description",
      "explanation": "wings + description indicator",
      "isCharacter": false,
      "composition": [
        708,
        ";",
        86
      ]
    },
    {
      "id": 1687,
      "bciAvId": 14375,
      "gloss": "to fold, to pleat",
      "glossSv": "vika, vecka",
      "pos": "action",
      "explanation": "fold,folding,pleating + action indicator",
      "isCharacter": false,
      "composition": [
        1038,
        ";",
        81
      ]
    },
    {
      "id": 1688,
      "bciAvId": 14376,
      "gloss": "to follow",
      "glossSv": "följa (FD)",
      "pos": "action",
      "explanation": "opposite meaning + to lead + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        803,
        ";",
        81
      ]
    },
    {
      "id": 1689,
      "bciAvId": 14378,
      "gloss": "food ball",
      "glossSv": "matboll",
      "pos": "noun",
      "explanation": "food + ball: food shaped into a ball",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        148
      ]
    },
    {
      "id": 1690,
      "bciAvId": 14380,
      "gloss": "football, soccer (activity)",
      "glossSv": "fotboll (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball + legs and feet: game in which legs and feet are used to move the ball",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 1691,
      "bciAvId": 14383,
      "gloss": "forced, compelled, obliged",
      "glossSv": "tvungen",
      "pos": "description",
      "explanation": "must (a) + description indicator",
      "isCharacter": false,
      "composition": [
        804,
        ";",
        86
      ]
    },
    {
      "id": 1692,
      "bciAvId": 14385,
      "gloss": "foreskin",
      "glossSv": "förhud",
      "pos": "noun",
      "explanation": "protection + penis [contraction]",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        434
      ]
    },
    {
      "id": 1693,
      "bciAvId": 14386,
      "gloss": "forest, bush, wood, woods",
      "glossSv": "skog",
      "pos": "noun",
      "explanation": "many + many + trees: large group of trees",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        666
      ]
    },
    {
      "id": 1694,
      "bciAvId": 14387,
      "gloss": "to forget",
      "glossSv": "glömma",
      "pos": "action",
      "explanation": "forgetting,amnesia + action indicator",
      "isCharacter": false,
      "composition": [
        948,
        ";",
        81
      ]
    },
    {
      "id": 1695,
      "bciAvId": 14388,
      "gloss": "to forgive, to pardon",
      "glossSv": "förlåta",
      "pos": "action",
      "explanation": "permission,allowance (moral) + after + action indicator: to give moral permission for a misdeed after it is done",
      "isCharacter": false,
      "composition": [
        1067,
        ";",
        81,
        "/",
        109
      ]
    },
    {
      "id": 1696,
      "bciAvId": 14391,
      "gloss": "foster mother",
      "glossSv": "fostermamma, fostermor",
      "pos": "person",
      "explanation": "woman + similar + mother: woman who acts as a mother",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        1060,
        "/",
        578,
        "/",
        455
      ]
    },
    {
      "id": 1697,
      "bciAvId": 14392,
      "gloss": "foster parent",
      "glossSv": "fosterförälder",
      "pos": "person",
      "explanation": "similar + parent: unrelated person who cares for a child like a parent",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        500
      ]
    },
    {
      "id": 1698,
      "bciAvId": 14393,
      "gloss": "four o'clock eating break",
      "glossSv": "four o'clock eating break (Israel)",
      "pos": "noun",
      "explanation": "food + time + 4: break for eating at four o’clock",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        655,
        "/",
        13
      ]
    },
    {
      "id": 1699,
      "bciAvId": 14394,
      "gloss": "fox, jackal, coyote",
      "glossSv": "räv",
      "pos": "noun",
      "explanation": "canine (animal) + little + open: small, wild animal similar to a dog",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        956,
        "/",
        484
      ]
    },
    {
      "id": 1700,
      "bciAvId": 14395,
      "gloss": "free, freely",
      "glossSv": "fri",
      "pos": "description",
      "explanation": "freedom + description indicator",
      "isCharacter": false,
      "composition": [
        336,
        ";",
        86
      ]
    },
    {
      "id": 1701,
      "bciAvId": 14397,
      "gloss": "to freeze, to solidify",
      "glossSv": "frysa, stelna",
      "pos": "action",
      "explanation": "freezing,hardening,solidifying + action indicator: to convert water to solid ice",
      "isCharacter": false,
      "composition": [
        1039,
        ";",
        81
      ]
    },
    {
      "id": 1702,
      "bciAvId": 14398,
      "gloss": "French fries, chips",
      "glossSv": "pommes frites (FD)",
      "pos": "noun",
      "explanation": "potato + linear thing + plural indicator + thing indicator: potatoes cut in strips",
      "isCharacter": false,
      "composition": [
        685,
        ";",
        99,
        "/",
        1161,
        "/",
        604,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 1703,
      "bciAvId": 14399,
      "gloss": "fresh",
      "glossSv": "färsk",
      "pos": "description",
      "explanation": "taste + new + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        1061
      ]
    },
    {
      "id": 1704,
      "bciAvId": 14400,
      "gloss": "Friday",
      "glossSv": "fredag (FD)",
      "pos": "noun",
      "explanation": "day + 6: sixth day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        15
      ]
    },
    {
      "id": 1705,
      "bciAvId": 14401,
      "gloss": "friend",
      "glossSv": "vän, kamrat, kompis",
      "pos": "person",
      "explanation": "person + to like: person whom one likes",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1706,
      "bciAvId": 14402,
      "gloss": "frog, toad",
      "glossSv": "groda, padda, groddjur",
      "pos": "noun",
      "explanation": "amphibian + to jump: amphibian that hops",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        1107,
        "/",
        836
      ]
    },
    {
      "id": 1707,
      "bciAvId": 14404,
      "gloss": "food (frozen)",
      "glossSv": "djupfryst mat",
      "pos": "noun",
      "explanation": "food + ice",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        394
      ]
    },
    {
      "id": 1708,
      "bciAvId": 14406,
      "gloss": "fruit juice, juice",
      "glossSv": "juice, saft",
      "pos": "noun",
      "explanation": "drink + fruit",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        338
      ]
    },
    {
      "id": 1709,
      "bciAvId": 14407,
      "gloss": "fruit yogurt, fruit yoghurt",
      "glossSv": "fruktyoghurt",
      "pos": "noun",
      "explanation": "yogurt + fruit",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        275,
        "/",
        423,
        "/",
        338
      ]
    },
    {
      "id": 1710,
      "bciAvId": 14408,
      "gloss": "frustrated",
      "glossSv": "besviken, missräknad",
      "pos": "description",
      "explanation": "frustration + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        1019
      ]
    },
    {
      "id": 1711,
      "bciAvId": 14409,
      "gloss": "frustrating",
      "glossSv": "frustrerande",
      "pos": "description",
      "explanation": "frustration + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1019
      ]
    },
    {
      "id": 1712,
      "bciAvId": 14410,
      "gloss": "frustration",
      "glossSv": "besvikelse, missräkning",
      "pos": "noun",
      "explanation": "feeling + adversity,hardship,setback",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        1019
      ]
    },
    {
      "id": 1713,
      "bciAvId": 14411,
      "gloss": "to fry, to saute",
      "glossSv": "steka",
      "pos": "action",
      "explanation": "to cook + oil + action indicator: to cook with oil or fat",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        480
      ]
    },
    {
      "id": 1714,
      "bciAvId": 14413,
      "gloss": "full",
      "glossSv": "full",
      "pos": "description",
      "explanation": "filling,fill,fullness + description indicator",
      "isCharacter": false,
      "composition": [
        947,
        ";",
        86
      ]
    },
    {
      "id": 1715,
      "bciAvId": 14414,
      "gloss": "funny, humorous",
      "glossSv": "rolig",
      "pos": "description",
      "explanation": "laugh,laughter + description indicator: causing laughter",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 1716,
      "bciAvId": 14416,
      "gloss": "furniture",
      "glossSv": "möbler",
      "pos": "noun",
      "explanation": "generalization + chair + table: two common pieces of furniture stand for furniture in general",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        212,
        "/",
        639
      ]
    },
    {
      "id": 1717,
      "bciAvId": 14418,
      "gloss": "game",
      "glossSv": "spel",
      "pos": "noun",
      "explanation": "competition + to enjoy",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1718,
      "bciAvId": 14419,
      "gloss": "Ganesh",
      "glossSv": "Ganesha (Indien)",
      "pos": "person",
      "explanation": "god + elephant: Hindu god",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        122,
        "/",
        473
      ]
    },
    {
      "id": 1719,
      "bciAvId": 14423,
      "gloss": "garlic",
      "glossSv": "vitlök",
      "pos": "noun",
      "explanation": "onion,vegetable (bulb) + smell + intensity: bulb vegetable having a strong odour",
      "isCharacter": false,
      "composition": [
        686,
        "/",
        600,
        "/",
        401
      ]
    },
    {
      "id": 1720,
      "bciAvId": 14425,
      "gloss": "gasoline, gas, petrol",
      "glossSv": "bensin",
      "pos": "noun",
      "explanation": "liquid + wheel: liquid that powers machinery and vehicles",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        700
      ]
    },
    {
      "id": 1721,
      "bciAvId": 14426,
      "gloss": "to gather, to assemble",
      "glossSv": "samla, samlas",
      "pos": "action",
      "explanation": "gathering + action indicator",
      "isCharacter": false,
      "composition": [
        346,
        ";",
        81
      ]
    },
    {
      "id": 1722,
      "bciAvId": 14429,
      "gloss": "indefinite",
      "glossSv": "obestämd",
      "pos": "description",
      "explanation": "a + description indicator",
      "isCharacter": false,
      "composition": [
        100,
        ";",
        86
      ]
    },
    {
      "id": 1723,
      "bciAvId": 14432,
      "gloss": "genitals, sex organs (female)",
      "glossSv": "könsorgan (kvinnligt)",
      "pos": "noun",
      "explanation": "genitals + female",
      "isCharacter": false,
      "composition": [
        349,
        "/",
        314
      ]
    },
    {
      "id": 1724,
      "bciAvId": 14433,
      "gloss": "genitals, sex organs (male)",
      "glossSv": "könsorgan (manligt)",
      "pos": "noun",
      "explanation": "genitals + male",
      "isCharacter": false,
      "composition": [
        349,
        "/",
        106
      ]
    },
    {
      "id": 1725,
      "bciAvId": 14434,
      "gloss": "gerbil, guinea pig, hamster",
      "glossSv": "hamster, marsvin",
      "pos": "noun",
      "explanation": "rodent + feeling: combination of rodent and pet, rodent often kept as a pet",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        313
      ]
    },
    {
      "id": 1726,
      "bciAvId": 14435,
      "gloss": "to get, to acquire, to receive",
      "glossSv": "få, ta emot",
      "pos": "action",
      "explanation": "receiving + action indicator: to draw into what one holds",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81
      ]
    },
    {
      "id": 1727,
      "bciAvId": 14436,
      "gloss": "ghost",
      "glossSv": "ande, spöke, vålnad (FD)",
      "pos": "person",
      "explanation": "person + transparent: person that you can see through",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        303,
        "/",
        653
      ]
    },
    {
      "id": 1728,
      "bciAvId": 14437,
      "gloss": "gift, offering, present",
      "glossSv": "present, gåva",
      "pos": "noun",
      "explanation": "thing + giving: thing that is given",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        949
      ]
    },
    {
      "id": 1729,
      "bciAvId": 14440,
      "gloss": "to give, to offer, to provide",
      "glossSv": "ge",
      "pos": "action",
      "explanation": "giving + action indicator: to draw from what one holds",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81
      ]
    },
    {
      "id": 1730,
      "bciAvId": 14441,
      "gloss": "glass material",
      "glossSv": "glas (material)",
      "pos": "noun",
      "explanation": "material + glass: material of which drinking glasses are made",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        352
      ]
    },
    {
      "id": 1731,
      "bciAvId": 14444,
      "gloss": "glassware",
      "glossSv": "glasvaror",
      "pos": "noun",
      "explanation": "generalization + glass",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        352
      ]
    },
    {
      "id": 1732,
      "bciAvId": 14445,
      "gloss": "sports glove, glove, mitt",
      "glossSv": "handske (sport)",
      "pos": "noun",
      "explanation": "glove + receiving: combination of glove and to catch, glove for use when catching a ball",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        374,
        "/",
        920
      ]
    },
    {
      "id": 1733,
      "bciAvId": 14446,
      "gloss": "glove(s), mitt(s), mitten(s)",
      "glossSv": "handskar, vantar",
      "pos": "noun",
      "explanation": "protection + hand: protective covering for the hand",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        374
      ]
    },
    {
      "id": 1734,
      "bciAvId": 14447,
      "gloss": "glue, adhesive, paste",
      "glossSv": "klister, lim",
      "pos": "noun",
      "explanation": "chemical product + attachment: chemical product to fasten",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        823
      ]
    },
    {
      "id": 1735,
      "bciAvId": 14448,
      "gloss": "to glue, to paste, to stick",
      "glossSv": "klistra, limma",
      "pos": "action",
      "explanation": "glue + action indicator",
      "isCharacter": false,
      "composition": [
        216,
        ";",
        81,
        "/",
        823
      ]
    },
    {
      "id": 1736,
      "bciAvId": 14449,
      "gloss": "to go, to depart, to leave",
      "glossSv": "ge sig av, lämna",
      "pos": "action",
      "explanation": "departure + action indicator",
      "isCharacter": false,
      "composition": [
        1525,
        ";",
        81
      ]
    },
    {
      "id": 1737,
      "bciAvId": 14452,
      "gloss": "goldfish, guppy, pet fish",
      "glossSv": "akvariefisk",
      "pos": "noun",
      "explanation": "fish + feeling: fish frequently kept as a pet",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        313
      ]
    },
    {
      "id": 1738,
      "bciAvId": 14453,
      "gloss": "golf (activity)",
      "glossSv": "golf (aktivitet)",
      "pos": "noun",
      "explanation": "activity + sport stick and ball + container (low): game in which a stick is used to propel the ball into a hole",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1092,
        "/",
        1010
      ]
    },
    {
      "id": 1739,
      "bciAvId": 14454,
      "gloss": "goodbye, farewell",
      "glossSv": "hej då, adjö",
      "pos": "function",
      "explanation": "mouth + parting: what you say when you part from someone",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1066
      ]
    },
    {
      "id": 1740,
      "bciAvId": 14455,
      "gloss": "Good Friday",
      "glossSv": "långfredag",
      "pos": "noun",
      "explanation": "day + death + Christ [contraction]: day Christ died on the cross",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        259,
        "/",
        248
      ]
    },
    {
      "id": 1741,
      "bciAvId": 14456,
      "gloss": "goodness",
      "glossSv": "godhet",
      "pos": "noun",
      "explanation": "feeling + positive",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1742,
      "bciAvId": 14458,
      "gloss": "goose (bird)",
      "glossSv": "gås",
      "pos": "noun",
      "explanation": "water bird + big",
      "isCharacter": false,
      "composition": [
        164,
        "/",
        936
      ]
    },
    {
      "id": 1743,
      "bciAvId": 14459,
      "gloss": "goose (food)",
      "glossSv": "gås (mat)",
      "pos": "noun",
      "explanation": "food + goose",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        164,
        "/",
        936
      ]
    },
    {
      "id": 1744,
      "bciAvId": 14460,
      "gloss": "gopher, ground hog",
      "glossSv": "mullvad, sork (etc)",
      "pos": "noun",
      "explanation": "rodent + hole: rodent that lives in a burrow underground",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        386
      ]
    },
    {
      "id": 1745,
      "bciAvId": 14461,
      "gloss": "to govern, to rule",
      "glossSv": "regera",
      "pos": "action",
      "explanation": "to lead + country + action indicator: to lead a country",
      "isCharacter": false,
      "composition": [
        803,
        ";",
        81,
        "/",
        243
      ]
    },
    {
      "id": 1746,
      "bciAvId": 14462,
      "gloss": "government",
      "glossSv": "regering (FD)",
      "pos": "noun",
      "explanation": "group (people) + leadership + country",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        803,
        "/",
        243
      ]
    },
    {
      "id": 1747,
      "bciAvId": 14463,
      "gloss": "good, well, fine, ok, okay, all right",
      "glossSv": "bra, god, fin, OK",
      "pos": "description",
      "explanation": "goodness + description indicator: felt to be positive or good in an emotional sense",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1748,
      "bciAvId": 14633,
      "gloss": "grape juice",
      "glossSv": "druvjuice",
      "pos": "noun",
      "explanation": "drink + grape,grapes",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        365
      ]
    },
    {
      "id": 1749,
      "bciAvId": 14634,
      "gloss": "grapefruit",
      "glossSv": "grapefrukt",
      "pos": "noun",
      "explanation": "citrus fruit + big",
      "isCharacter": false,
      "composition": [
        489,
        "/",
        936
      ]
    },
    {
      "id": 1750,
      "bciAvId": 14637,
      "gloss": "grasshopper",
      "glossSv": "gräshoppa, syrsa",
      "pos": "noun",
      "explanation": "insect + to jump",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        836
      ]
    },
    {
      "id": 1751,
      "bciAvId": 14639,
      "gloss": "gray, grey",
      "glossSv": "grå",
      "pos": "expression",
      "explanation": "colour + night + snow: combination of black and white",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        470,
        "/",
        604
      ]
    },
    {
      "id": 1752,
      "bciAvId": 14640,
      "gloss": "great experience",
      "glossSv": "upplevelse (stark)",
      "pos": "noun",
      "explanation": "good + intensity: intensely good feeling",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        120,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1753,
      "bciAvId": 14641,
      "gloss": "green (bci)",
      "glossSv": "grön",
      "pos": "expression",
      "explanation": "colour + grass",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        366
      ]
    },
    {
      "id": 1754,
      "bciAvId": 14642,
      "gloss": "green (ckb)",
      "glossSv": "grön (CKB)",
      "pos": "expression",
      "explanation": "colour + 4",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        13
      ]
    },
    {
      "id": 1755,
      "bciAvId": 14643,
      "gloss": "greenhouse, glasshouse, hothouse",
      "glossSv": "växthus",
      "pos": "noun",
      "explanation": "building + plant: building for cultivating plants",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        533
      ]
    },
    {
      "id": 1756,
      "bciAvId": 14644,
      "gloss": "green onion, scallion, spring onion",
      "glossSv": "smålök (etc)",
      "pos": "noun",
      "explanation": "onion + little",
      "isCharacter": false,
      "composition": [
        686,
        "/",
        956
      ]
    },
    {
      "id": 1757,
      "bciAvId": 14645,
      "gloss": "grocery store, food store, supermarket",
      "glossSv": "livsmedelsbutik (FD)",
      "pos": "noun",
      "explanation": "store (OLD) + food",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        191,
        "/",
        329
      ]
    },
    {
      "id": 1758,
      "bciAvId": 14646,
      "gloss": "group (people)",
      "glossSv": "grupp",
      "pos": "person",
      "explanation": "group of + person: a number of people considered together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513
      ]
    },
    {
      "id": 1759,
      "bciAvId": 14648,
      "gloss": "grove",
      "glossSv": "dunge",
      "pos": "noun",
      "explanation": "group of + tree",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        666
      ]
    },
    {
      "id": 1760,
      "bciAvId": 14649,
      "gloss": "to grow",
      "glossSv": "växa",
      "pos": "action",
      "explanation": "growth,growing + action indicator: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a general sense, such as \"children grow up\".",
      "isCharacter": false,
      "composition": [
        325,
        ";",
        81,
        "/",
        678
      ]
    },
    {
      "id": 1761,
      "bciAvId": 14650,
      "gloss": "guard duty",
      "glossSv": "bevakning, vakt",
      "pos": "noun",
      "explanation": "limited time + person + to watch",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        513,
        "/",
        969,
        "/",
        401
      ]
    },
    {
      "id": 1762,
      "bciAvId": 14651,
      "gloss": "to guess, to estimate",
      "glossSv": "gissa",
      "pos": "action",
      "explanation": "doubt + plus minus + action indicator: to reason on the basis of information of uncertain accuracy",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        81,
        "/",
        1069
      ]
    },
    {
      "id": 1763,
      "bciAvId": 14652,
      "gloss": "guilt",
      "glossSv": "skuld",
      "pos": "noun",
      "explanation": "judgement + negative: the mind weighs something and judges it to be negative",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1764,
      "bciAvId": 14653,
      "gloss": "guilty",
      "glossSv": "skyldig",
      "pos": "description",
      "explanation": "guilt + description indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1765,
      "bciAvId": 14654,
      "gloss": "gull, seagull, sea gull",
      "glossSv": "mås, trut",
      "pos": "noun",
      "explanation": "water bird + waste: water bird that feeds on refuse, a scavenger",
      "isCharacter": false,
      "composition": [
        164,
        "/",
        694
      ]
    },
    {
      "id": 1766,
      "bciAvId": 14656,
      "gloss": "gym, gymnasium",
      "glossSv": "gymnastiksal, gym (FD)",
      "pos": "noun",
      "explanation": "room + activity + health: room for activity that keeps one healthy",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        106,
        "/",
        377
      ]
    },
    {
      "id": 1767,
      "bciAvId": 14657,
      "gloss": "gym mat",
      "glossSv": "gymnastikmatta (FD)",
      "pos": "noun",
      "explanation": "floor covering + sport (OLD): floor covering used for sports",
      "isCharacter": false,
      "composition": [
        324,
        "/",
        106,
        "/",
        377
      ]
    },
    {
      "id": 1768,
      "bciAvId": 14658,
      "gloss": "Haggadah",
      "glossSv": "Haggadah (Israel)",
      "pos": "noun",
      "explanation": "book + Passover: book used at Passover ceremonial meal (Hebrew)",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        16,
        "/",
        258,
        "/",
        180,
        "/",
        957
      ]
    },
    {
      "id": 1769,
      "bciAvId": 14662,
      "gloss": "Halloween",
      "glossSv": "Halloween (FD)",
      "pos": "noun",
      "explanation": "day + ghost (OLD): day for ghosts",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        513,
        "/",
        303,
        "/",
        653
      ]
    },
    {
      "id": 1770,
      "bciAvId": 14663,
      "gloss": "halva, halvah, halwa",
      "glossSv": "halvah",
      "pos": "noun",
      "explanation": "food + sweet + grain: Middle Eastern sweet",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        642,
        "/",
        678,
        "/",
        357
      ]
    },
    {
      "id": 1771,
      "bciAvId": 14664,
      "gloss": "hamburger",
      "glossSv": "hamburgare (FD)",
      "pos": "noun",
      "explanation": "roll + meat",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        329,
        "/",
        122
      ]
    },
    {
      "id": 1772,
      "bciAvId": 14665,
      "gloss": "hamentasch",
      "glossSv": "hamantasch (Israel)",
      "pos": "noun",
      "explanation": "cookie + ear: cookie shaped like an ear, eaten on Purim (Hebrew)",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        642,
        "/",
        678,
        "/",
        278
      ]
    },
    {
      "id": 1773,
      "bciAvId": 14669,
      "gloss": "handball (activity)",
      "glossSv": "handboll (aktivitet)",
      "pos": "noun",
      "explanation": "activity + ball + hand",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        148,
        "/",
        374
      ]
    },
    {
      "id": 1774,
      "bciAvId": 14670,
      "gloss": "handgun, pistol",
      "glossSv": "pistol",
      "pos": "noun",
      "explanation": "gun + small",
      "isCharacter": false,
      "composition": [
        369,
        "/",
        965
      ]
    },
    {
      "id": 1775,
      "bciAvId": 14671,
      "gloss": "handkerchief",
      "glossSv": "näsduk",
      "pos": "noun",
      "explanation": "cloth + nose",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        473
      ]
    },
    {
      "id": 1776,
      "bciAvId": 14672,
      "gloss": "handmade object, handicraft",
      "glossSv": "hantverksprodukt",
      "pos": "noun",
      "explanation": "craft + thing indicator: handmade object produced by a craftsman, e.g. a quilt or a plaque",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 1777,
      "bciAvId": 14673,
      "gloss": "to hang, to hook",
      "glossSv": "hänga",
      "pos": "action",
      "explanation": "hook + action indicator",
      "isCharacter": false,
      "composition": [
        387,
        ";",
        81
      ]
    },
    {
      "id": 1778,
      "bciAvId": 14674,
      "gloss": "to happen, to occur",
      "glossSv": "hända, ske",
      "pos": "action",
      "explanation": "event + action indicator",
      "isCharacter": false,
      "composition": [
        299,
        ";",
        81
      ]
    },
    {
      "id": 1779,
      "bciAvId": 14675,
      "gloss": "happiness, fun, joy, pleasure",
      "glossSv": "glädje, lycka",
      "pos": "noun",
      "explanation": "feeling + up: uplifted feeling",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678
      ]
    },
    {
      "id": 1780,
      "bciAvId": 14676,
      "gloss": "happy, glad, gladly, happily",
      "glossSv": "glad, lycklig",
      "pos": "description",
      "explanation": "happiness + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        678
      ]
    },
    {
      "id": 1781,
      "bciAvId": 14677,
      "gloss": "harassment",
      "glossSv": "mobbing, trakasserier",
      "pos": "noun",
      "explanation": "group of,much of,many of,quantity of + disturbance,unrest: harassment is destroying peace of mind",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1027
      ]
    },
    {
      "id": 1782,
      "bciAvId": 14678,
      "gloss": "harbour, harbor",
      "glossSv": "hamn",
      "pos": "noun",
      "explanation": "protected water + boat",
      "isCharacter": false,
      "composition": [
        1071,
        "/",
        170
      ]
    },
    {
      "id": 1783,
      "bciAvId": 14679,
      "gloss": "hard",
      "glossSv": "hård (FD)",
      "pos": "description",
      "explanation": "opposite meaning + soft + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        374,
        ";",
        86,
        "/",
        1049
      ]
    },
    {
      "id": 1784,
      "bciAvId": 14680,
      "gloss": "harmony, harmoniousness, concord, concordance",
      "glossSv": "samförstånd",
      "pos": "noun",
      "explanation": "feeling + agreement: feeling of agreement",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        113
      ]
    },
    {
      "id": 1785,
      "bciAvId": 14681,
      "gloss": "harvest",
      "glossSv": "skörd",
      "pos": "noun",
      "explanation": "knife + grain: cutting of grain",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        "RK:-2",
        "/",
        357
      ]
    },
    {
      "id": 1786,
      "bciAvId": 14682,
      "gloss": "hat, cap, hood",
      "glossSv": "hatt, mössa",
      "pos": "noun",
      "explanation": "protection + head: protective covering for the head",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        376
      ]
    },
    {
      "id": 1787,
      "bciAvId": 14683,
      "gloss": "to hate",
      "glossSv": "hata, avsky (FD)",
      "pos": "action",
      "explanation": "opposite meaning + to love + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        431,
        ";",
        81
      ]
    },
    {
      "id": 1788,
      "bciAvId": 14684,
      "gloss": "Havdalah",
      "glossSv": "havdalah (Israel)",
      "pos": "noun",
      "explanation": "end + Sabbath: ceremony to mark the end of the Sabbath (Hebrew)",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        258,
        "/",
        562
      ]
    },
    {
      "id": 1789,
      "bciAvId": 14685,
      "gloss": "to have",
      "glossSv": "ha",
      "pos": "action",
      "explanation": "holding + action indicator: to have something in one's possession without necessarily owning it, thus the half-size of own,possess-(to) 15950",
      "isCharacter": false,
      "composition": [
        953,
        ";",
        81
      ]
    },
    {
      "id": 1790,
      "bciAvId": 14686,
      "gloss": "hawk, eagle",
      "glossSv": "hök, örn (etc)",
      "pos": "noun",
      "explanation": "bird + up + intensity: bird that soars",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 1791,
      "bciAvId": 14687,
      "gloss": "he, him, himself",
      "glossSv": "han, honom, sig",
      "pos": "person",
      "explanation": "male + 3: third person (m.sing.)",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        12
      ]
    },
    {
      "id": 1792,
      "bciAvId": 14688,
      "gloss": "he, she, him, her, one",
      "glossSv": "man, sig",
      "pos": "person",
      "explanation": "person + 3: third person (sing.), unmarked for gender",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        12
      ]
    },
    {
      "id": 1793,
      "bciAvId": 14691,
      "gloss": "healthy, well",
      "glossSv": "frisk, kry",
      "pos": "description",
      "explanation": "health + description indicator",
      "isCharacter": false,
      "composition": [
        377,
        ";",
        86
      ]
    },
    {
      "id": 1794,
      "bciAvId": 14692,
      "gloss": "to hear, to listen",
      "glossSv": "höra, lyssna",
      "pos": "action",
      "explanation": "ear + action indicator",
      "isCharacter": false,
      "composition": [
        278,
        ";",
        81
      ]
    },
    {
      "id": 1795,
      "bciAvId": 14693,
      "gloss": "hearing aid",
      "glossSv": "hörapparat",
      "pos": "noun",
      "explanation": "aid + ear + electricity + thing indicator: electrical aid for the ear",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        278,
        "/",
        288
      ]
    },
    {
      "id": 1796,
      "bciAvId": 14694,
      "gloss": "hearing-impaired",
      "glossSv": "hörselskadad (FD)",
      "pos": "description",
      "explanation": "limit(s),limitation (OLD) + to hear + description indicator",
      "isCharacter": false,
      "composition": [
        427,
        ";",
        86,
        "/",
        278
      ]
    },
    {
      "id": 1797,
      "bciAvId": 14695,
      "gloss": "heart",
      "glossSv": "hjärta",
      "pos": "noun",
      "explanation": "feeling + thing indicator: organ of the body. The symbol is the concrete form of feeling, emotion.",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        97
      ]
    },
    {
      "id": 1798,
      "bciAvId": 14697,
      "gloss": "to heat",
      "glossSv": "värma",
      "pos": "action",
      "explanation": "heat + action indicator",
      "isCharacter": false,
      "composition": [
        378,
        ";",
        81
      ]
    },
    {
      "id": 1799,
      "bciAvId": 14698,
      "gloss": "heavy",
      "glossSv": "tung",
      "pos": "description",
      "explanation": "weight + down + description indicator: causing the scales to go down",
      "isCharacter": false,
      "composition": [
        697,
        ";",
        86,
        "/",
        271
      ]
    },
    {
      "id": 1800,
      "bciAvId": 14702,
      "gloss": "hello, greetings",
      "glossSv": "hej, goddag",
      "pos": "function",
      "explanation": "mouth + meeting,encounter: what you say when you meet someone",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057
      ]
    },
    {
      "id": 1801,
      "bciAvId": 14703,
      "gloss": "helmet",
      "glossSv": "hjälm (FD)",
      "pos": "noun",
      "explanation": "hat + intensity: reinforced hat",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        376,
        "/",
        401
      ]
    },
    {
      "id": 1802,
      "bciAvId": 14705,
      "gloss": "to help, to aid, to assist, to serve, to support",
      "glossSv": "hjälpa, stödja",
      "pos": "action",
      "explanation": "help + action indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        81
      ]
    },
    {
      "id": 1803,
      "bciAvId": 14706,
      "gloss": "helper, aide, assistant, personal assistant",
      "glossSv": "assistent, medhjälpare",
      "pos": "person",
      "explanation": "person + help: person who gives aid",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382
      ]
    },
    {
      "id": 1804,
      "bciAvId": 14707,
      "gloss": "her, hers",
      "glossSv": "hennes, sin, sitt, sina",
      "pos": "person",
      "explanation": "she + belongs to: third person (f.sing.) possessive",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 1805,
      "bciAvId": 14709,
      "gloss": "heterosexuality",
      "glossSv": "heterosexualitet",
      "pos": "noun",
      "explanation": "feeling + couple (heterosexual): intimate sexual relationship between a man and a woman",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        245
      ]
    },
    {
      "id": 1806,
      "bciAvId": 14710,
      "gloss": "to hide, to conceal",
      "glossSv": "gömma, dölja",
      "pos": "action",
      "explanation": "to make + minus + to see + action indicator: to make invisible",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        449,
        "/",
        303
      ]
    },
    {
      "id": 1807,
      "bciAvId": 14711,
      "gloss": "high, tall",
      "glossSv": "hög",
      "pos": "description",
      "explanation": "height,tallness + description indicator: the space between the reference lines is the highest possible within the symbol square",
      "isCharacter": false,
      "composition": [
        952,
        ";",
        86
      ]
    },
    {
      "id": 1808,
      "bciAvId": 14712,
      "gloss": "hill",
      "glossSv": "kulle",
      "pos": "noun",
      "explanation": "mountain + little: small mountain",
      "isCharacter": false,
      "composition": [
        456,
        "/",
        956
      ]
    },
    {
      "id": 1809,
      "bciAvId": 14715,
      "gloss": "his",
      "glossSv": "hans, sin, sitt, sina",
      "pos": "person",
      "explanation": "he + belongs to: third person (m.sing.) possessive",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 1810,
      "bciAvId": 14716,
      "gloss": "his, her, hers, one's",
      "glossSv": "sin, sitt, sina",
      "pos": "person",
      "explanation": "he,she,him,her,one + belongs to: third person (sing.) possessive, unmarked for gender",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 1811,
      "bciAvId": 14717,
      "gloss": "to hit",
      "glossSv": "slå",
      "pos": "action",
      "explanation": "to touch + intensity + intensity + action indicator: to use the hand forcefully",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 1812,
      "bciAvId": 14718,
      "gloss": "hobby, pastime",
      "glossSv": "hobby",
      "pos": "noun",
      "explanation": "activity + interesting",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        955
      ]
    },
    {
      "id": 1813,
      "bciAvId": 14881,
      "gloss": "hoist, lift",
      "glossSv": "lyft",
      "pos": "noun",
      "explanation": "aid + up and down + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        723
      ]
    },
    {
      "id": 1814,
      "bciAvId": 14882,
      "gloss": "to hold, to contain (1)",
      "glossSv": "innehålla, rymma (1)",
      "pos": "action",
      "explanation": "container + action indicator",
      "isCharacter": false,
      "composition": [
        239,
        ";",
        81
      ]
    },
    {
      "id": 1815,
      "bciAvId": 14884,
      "gloss": "holiday, festival",
      "glossSv": "helgdag",
      "pos": "noun",
      "explanation": "day + happy: day for happy activities",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1816,
      "bciAvId": 14885,
      "gloss": "home",
      "glossSv": "hem, bostad",
      "pos": "noun",
      "explanation": "house + feeling: house to which one is emotionally tied",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        313
      ]
    },
    {
      "id": 1817,
      "bciAvId": 14886,
      "gloss": "home run",
      "glossSv": "home run (Am)",
      "pos": "noun",
      "explanation": "4 + corner: a run around all four bases in baseball",
      "isCharacter": false,
      "composition": [
        13,
        "/",
        1011
      ]
    },
    {
      "id": 1818,
      "bciAvId": 14887,
      "gloss": "homosexuality (female), lesbianism",
      "glossSv": "homosexualitet, kvinnlig",
      "pos": "noun",
      "explanation": "feeling + couple (female): intimate sexual relationship between two women",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1014
      ]
    },
    {
      "id": 1819,
      "bciAvId": 14888,
      "gloss": "homosexuality (male)",
      "glossSv": "homosexualitet, manlig",
      "pos": "noun",
      "explanation": "feeling + couple (male): intimate sexual relationship between two men",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1015
      ]
    },
    {
      "id": 1820,
      "bciAvId": 14889,
      "gloss": "honey (spread)",
      "glossSv": "honung (pålägg)",
      "pos": "noun",
      "explanation": "spread + flower: spread obtained from the nectar of flowers",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        325
      ]
    },
    {
      "id": 1821,
      "bciAvId": 14890,
      "gloss": "honey (food)",
      "glossSv": "honung",
      "pos": "noun",
      "explanation": "food + flower: food obtained from the nectar of flowers",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        325
      ]
    },
    {
      "id": 1822,
      "bciAvId": 14892,
      "gloss": "to hop",
      "glossSv": "hoppa på ett ben",
      "pos": "action",
      "explanation": "1 + foot + action indicator: to go on one foot",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        330,
        ";",
        81
      ]
    },
    {
      "id": 1823,
      "bciAvId": 14893,
      "gloss": "to hope",
      "glossSv": "hoppas",
      "pos": "action",
      "explanation": "hope + action indicator: to have a happy feeling about the future despite its uncertainties",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        678,
        "/",
        1042
      ]
    },
    {
      "id": 1824,
      "bciAvId": 14898,
      "gloss": "horseradish",
      "glossSv": "pepparrot",
      "pos": "noun",
      "explanation": "vegetable (wedge-shaped) + hot,spicy,peppery: wedge-shaped vegetable with a hot-tasting edible root",
      "isCharacter": false,
      "composition": [
        203,
        "/",
        642,
        "/",
        319
      ]
    },
    {
      "id": 1825,
      "bciAvId": 14899,
      "gloss": "hospital, clinic",
      "glossSv": "sjukhus, vårdcentral",
      "pos": "noun",
      "explanation": "building + medical: building where medical services are available",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        958
      ]
    },
    {
      "id": 1826,
      "bciAvId": 14900,
      "gloss": "hot (temperature)",
      "glossSv": "varm, het",
      "pos": "description",
      "explanation": "heat + description indicator",
      "isCharacter": false,
      "composition": [
        378,
        ";",
        86
      ]
    },
    {
      "id": 1827,
      "bciAvId": 14901,
      "gloss": "hot, spicy, peppery",
      "glossSv": "kryddstark",
      "pos": "description",
      "explanation": "taste + fire + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        319
      ]
    },
    {
      "id": 1828,
      "bciAvId": 14902,
      "gloss": "hot dog, frankfurter",
      "glossSv": "varm korv",
      "pos": "noun",
      "explanation": "roll + meat + long",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        329,
        "/",
        122,
        "/",
        420
      ]
    },
    {
      "id": 1829,
      "bciAvId": 14903,
      "gloss": "hotel, motel",
      "glossSv": "hotell, motell",
      "pos": "noun",
      "explanation": "building + person + to travel: building where travellers stay",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        513,
        "/",
        667
      ]
    },
    {
      "id": 1830,
      "bciAvId": 14904,
      "gloss": "hour, o'clock",
      "glossSv": "timme, klockan...",
      "pos": "noun",
      "explanation": "time + degree, to indicate an hour",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        8
      ]
    },
    {
      "id": 1831,
      "bciAvId": 14906,
      "gloss": "how",
      "glossSv": "hur",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + action",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        106
      ]
    },
    {
      "id": 1832,
      "bciAvId": 14907,
      "gloss": "how - (question)",
      "glossSv": "hur (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + action: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        106
      ]
    },
    {
      "id": 1833,
      "bciAvId": 14908,
      "gloss": "how much, how many",
      "glossSv": "hur mycket, hur många",
      "pos": "expression",
      "explanation": "what,question mark + quantity",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        368
      ]
    },
    {
      "id": 1834,
      "bciAvId": 14909,
      "gloss": "to hug, to cuddle, to embrace",
      "glossSv": "krama, hålla om",
      "pos": "action",
      "explanation": "hug,squeeze,embrace + action indicator",
      "isCharacter": false,
      "composition": [
        132,
        ";",
        81,
        "/",
        134
      ]
    },
    {
      "id": 1835,
      "bciAvId": 14910,
      "gloss": "humble, meek",
      "glossSv": "underlägsen, ödmjuk",
      "pos": "description",
      "explanation": "feeling + inferior + description indicator: lacking a feeling of pride",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        676
      ]
    },
    {
      "id": 1836,
      "bciAvId": 14911,
      "gloss": "hummus",
      "glossSv": "hummus",
      "pos": "noun",
      "explanation": "spread + bean: Middle Eastern spread made from chick-peas",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        154
      ]
    },
    {
      "id": 1837,
      "bciAvId": 14912,
      "gloss": "hungry",
      "glossSv": "hungrig",
      "pos": "description",
      "explanation": "feeling + minus + food + description indicator: having a feeling caused by the lack of food",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        329
      ]
    },
    {
      "id": 1838,
      "bciAvId": 14913,
      "gloss": "to hurt, to pain (feel), to suffer",
      "glossSv": "göra ont, ha ont",
      "pos": "action",
      "explanation": "pain + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 1839,
      "bciAvId": 14915,
      "gloss": "hysterectomy",
      "glossSv": "hysterektomi (bortoperation av livmodern)",
      "pos": "noun",
      "explanation": "to remove + medical + uterus",
      "isCharacter": false,
      "composition": [
        634,
        "/",
        958,
        "/",
        681
      ]
    },
    {
      "id": 1840,
      "bciAvId": 14916,
      "gloss": "I, me, myself",
      "glossSv": "jag, mig",
      "pos": "person",
      "explanation": "person + 1: the first person singular",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        10
      ]
    },
    {
      "id": 1841,
      "bciAvId": 14917,
      "gloss": "I, me, myself - (feminine)",
      "glossSv": "jag, mig (fem.)",
      "pos": "person",
      "explanation": "female + l: first person singular (f.)",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        10
      ]
    },
    {
      "id": 1842,
      "bciAvId": 14918,
      "gloss": "I, me, myself - (masculine)",
      "glossSv": "jag, mig (mask.)",
      "pos": "person",
      "explanation": "male + 1: first person singular (m.)",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        10
      ]
    },
    {
      "id": 1843,
      "bciAvId": 14920,
      "gloss": "ice cream",
      "glossSv": "glass, sorbet (FD)",
      "pos": "noun",
      "explanation": "food + sweet + ice: sweet frozen food",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        642,
        "/",
        678,
        "/",
        394
      ]
    },
    {
      "id": 1844,
      "bciAvId": 14922,
      "gloss": "ice hockey (activity)",
      "glossSv": "ishockey (aktivitet)",
      "pos": "noun",
      "explanation": "activity + sport stick and puck,hockey stick + ice: game played on ice with a stick and a rubber disc",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1093,
        "/",
        394
      ]
    },
    {
      "id": 1845,
      "bciAvId": 14923,
      "gloss": "Iceland",
      "glossSv": "Island",
      "pos": "noun",
      "explanation": "country + ice + fire: country characterized by ice and fiery volcanoes",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        394,
        "/",
        319
      ]
    },
    {
      "id": 1846,
      "bciAvId": 14925,
      "gloss": "icy, frozen",
      "glossSv": "frusen, isig, djupfryst",
      "pos": "description",
      "explanation": "ice + description indicator",
      "isCharacter": false,
      "composition": [
        394,
        ";",
        86
      ]
    },
    {
      "id": 1847,
      "bciAvId": 14927,
      "gloss": "if",
      "glossSv": "om, ifall",
      "pos": "expression",
      "explanation": "what,question mark + either",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        286
      ]
    },
    {
      "id": 1848,
      "bciAvId": 14929,
      "gloss": "immoral, bad, wrong, morally wrong",
      "glossSv": "orätt, omoralisk",
      "pos": "description",
      "explanation": "bad conscience + intensity + description indicator: morally wrong or bad",
      "isCharacter": false,
      "composition": [
        997,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 1849,
      "bciAvId": 14930,
      "gloss": "important, significant",
      "glossSv": "viktig",
      "pos": "description",
      "explanation": "importance,significance + description indicator: of intense interest",
      "isCharacter": false,
      "composition": [
        954,
        ";",
        86
      ]
    },
    {
      "id": 1850,
      "bciAvId": 14931,
      "gloss": "to improve",
      "glossSv": "förbättra",
      "pos": "action",
      "explanation": "to cause + more + correct + action indicator: to cause to be better, in a rational sense.",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        937,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 1851,
      "bciAvId": 14933,
      "gloss": "incest",
      "glossSv": "incest",
      "pos": "noun",
      "explanation": "sexual intercourse + relative",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        349,
        "/",
        560
      ]
    },
    {
      "id": 1852,
      "bciAvId": 14934,
      "gloss": "to include",
      "glossSv": "innesluta, omfatta, vara inne",
      "pos": "action",
      "explanation": "inside + action indicator",
      "isCharacter": false,
      "composition": [
        398,
        ";",
        81
      ]
    },
    {
      "id": 1853,
      "bciAvId": 14935,
      "gloss": "incorrect, bad, inaccurate, wrong",
      "glossSv": "fel, oriktig",
      "pos": "description",
      "explanation": "incorrect thinking + intensity + description indicator: thought to be wrong or bad in a rational sense",
      "isCharacter": false,
      "composition": [
        1013,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 1854,
      "bciAvId": 14936,
      "gloss": "to increase, to enlarge",
      "glossSv": "förstora, öka",
      "pos": "action",
      "explanation": "big + action indicator: to become bigger",
      "isCharacter": false,
      "composition": [
        936,
        ";",
        81
      ]
    },
    {
      "id": 1855,
      "bciAvId": 14937,
      "gloss": "Independence Day (Israel)",
      "glossSv": "Independence Day (Israel)",
      "pos": "noun",
      "explanation": "day + Israel",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        243,
        "/",
        621
      ]
    },
    {
      "id": 1856,
      "bciAvId": 14938,
      "gloss": "indigo",
      "glossSv": "indigo (CKB)",
      "pos": "expression",
      "explanation": "colour + 6",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        15
      ]
    },
    {
      "id": 1857,
      "bciAvId": 14939,
      "gloss": "infertile, sterile",
      "glossSv": "steril, ofruktsam",
      "pos": "description",
      "explanation": "without + fertilization + description before the fact indicator: incapable of conception",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        236,
        ";",
        85
      ]
    },
    {
      "id": 1858,
      "bciAvId": 14940,
      "gloss": "infinite, limitless",
      "glossSv": "obegränsad (FD)",
      "pos": "description",
      "explanation": "infiniteness,boundlessness,limitlessness (OLD) + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        427,
        ";",
        86
      ]
    },
    {
      "id": 1859,
      "bciAvId": 14942,
      "gloss": "to injure, to hurt",
      "glossSv": "skada, såra",
      "pos": "action",
      "explanation": "to cause + pain + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 1860,
      "bciAvId": 14944,
      "gloss": "insect (pest)",
      "glossSv": "skadeinsekt",
      "pos": "noun",
      "explanation": "insect + negative: undesirable insect, a pest",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 1861,
      "bciAvId": 14945,
      "gloss": "instruction, teaching",
      "glossSv": "undervisning",
      "pos": "noun",
      "explanation": "to give + knowledge",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        412
      ]
    },
    {
      "id": 1862,
      "bciAvId": 14946,
      "gloss": "instruction(s), direction(s)",
      "glossSv": "bruksanvisning",
      "pos": "noun",
      "explanation": "page + to use: paper that tells one how to use something",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        932
      ]
    },
    {
      "id": 1863,
      "bciAvId": 14948,
      "gloss": "interesting, interested",
      "glossSv": "intressant, intresserad",
      "pos": "description",
      "explanation": "interest + description indicator: engaging the mind",
      "isCharacter": false,
      "composition": [
        955,
        ";",
        86
      ]
    },
    {
      "id": 1864,
      "bciAvId": 14949,
      "gloss": "international, multinational",
      "glossSv": "internationell",
      "pos": "description",
      "explanation": "country + all + description indicator",
      "isCharacter": false,
      "composition": [
        243,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 1865,
      "bciAvId": 14950,
      "gloss": "intimacy, closeness",
      "glossSv": "förtrolighet, närhet",
      "pos": "noun",
      "explanation": "feeling + close",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        1060
      ]
    },
    {
      "id": 1866,
      "bciAvId": 14951,
      "gloss": "intimate, close",
      "glossSv": "förtrolig, intim, nära",
      "pos": "description",
      "explanation": "intimacy + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1060
      ]
    },
    {
      "id": 1867,
      "bciAvId": 14953,
      "gloss": "to invent",
      "glossSv": "uppfinna",
      "pos": "action",
      "explanation": "plan + first + action indicator: to plan for the first time",
      "isCharacter": false,
      "composition": [
        532,
        ";",
        81,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 1868,
      "bciAvId": 14954,
      "gloss": "Ireland",
      "glossSv": "Irland",
      "pos": "noun",
      "explanation": "country + shamrock",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        586
      ]
    },
    {
      "id": 1869,
      "bciAvId": 14956,
      "gloss": "to iron",
      "glossSv": "stryka",
      "pos": "action",
      "explanation": "iron + action indicator",
      "isCharacter": false,
      "composition": [
        403,
        ";",
        81
      ]
    },
    {
      "id": 1870,
      "bciAvId": 14957,
      "gloss": "ironing board",
      "glossSv": "strykbräda",
      "pos": "noun",
      "explanation": "table + iron",
      "isCharacter": false,
      "composition": [
        639,
        "/",
        403
      ]
    },
    {
      "id": 1871,
      "bciAvId": 14959,
      "gloss": "Israel",
      "glossSv": "Israel",
      "pos": "noun",
      "explanation": "country + Star of David",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        621
      ]
    },
    {
      "id": 1872,
      "bciAvId": 14961,
      "gloss": "apparent(ly), clear(ly), evident(ly), obvious(ly), plain(ly)",
      "glossSv": "självklart",
      "pos": "description",
      "explanation": "understanding,comprehension + through + description indicator",
      "isCharacter": false,
      "composition": [
        1103,
        ";",
        86,
        "/",
        653
      ]
    },
    {
      "id": 1873,
      "bciAvId": 14962,
      "gloss": "its",
      "glossSv": "dess, sin, sitt, sina",
      "pos": "expression",
      "explanation": "it,itself + belongs to: refers to things rather than to people",
      "isCharacter": false,
      "composition": [
        405,
        "/",
        160
      ]
    },
    {
      "id": 1874,
      "bciAvId": 14963,
      "gloss": "intrauterine device, IUD",
      "glossSv": "spiral (prev)",
      "pos": "noun",
      "explanation": "birth control + uterus",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        236,
        "/",
        681
      ]
    },
    {
      "id": 1875,
      "bciAvId": 14964,
      "gloss": "Iyar",
      "glossSv": "Iyar (Israel)",
      "pos": "noun",
      "explanation": "month + Israel: month of Independence Day",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        243,
        "/",
        621
      ]
    },
    {
      "id": 1876,
      "bciAvId": 14965,
      "gloss": "jam, jelly, marmalade, preserves",
      "glossSv": "marmelad, sylt",
      "pos": "noun",
      "explanation": "spread + fruit",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        338
      ]
    },
    {
      "id": 1877,
      "bciAvId": 14966,
      "gloss": "January",
      "glossSv": "januari",
      "pos": "noun",
      "explanation": "month + 1: first month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        10
      ]
    },
    {
      "id": 1878,
      "bciAvId": 14967,
      "gloss": "jealous",
      "glossSv": "missunnsam, svartsjuk",
      "pos": "description",
      "explanation": "to resent + other + to have + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        111,
        "/",
        428,
        "/",
        11,
        "/",
        953
      ]
    },
    {
      "id": 1879,
      "bciAvId": 14968,
      "gloss": "Jerusalem Day",
      "glossSv": "Jerusalem Day (Israel)",
      "pos": "noun",
      "explanation": "day + city + first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        368,
        "/",
        368,
        "/",
        392,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 1880,
      "bciAvId": 14969,
      "gloss": "Jesus (of Nazareth), Jesus Christ, Christ",
      "glossSv": "Jesus, Kristus",
      "pos": "person",
      "explanation": "man + cross: a man regarded by Christians as being the Son of God, who died on the cross - biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        248
      ]
    },
    {
      "id": 1881,
      "bciAvId": 14970,
      "gloss": "jet, jet plane",
      "glossSv": "jetplan",
      "pos": "noun",
      "explanation": "plane + out of: plane driven forward by expelling gas",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        491
      ]
    },
    {
      "id": 1882,
      "bciAvId": 14971,
      "gloss": "jewel, gem, gemstone",
      "glossSv": "juvel, ädelsten",
      "pos": "noun",
      "explanation": "stone + to shine",
      "isCharacter": false,
      "composition": [
        629,
        "/",
        622
      ]
    },
    {
      "id": 1883,
      "bciAvId": 14972,
      "gloss": "Jewish",
      "glossSv": "judisk",
      "pos": "description",
      "explanation": "Star of David + description indicator: having to do with Judaism, for which the Star of David is a symbol",
      "isCharacter": false,
      "composition": [
        621,
        ";",
        86
      ]
    },
    {
      "id": 1884,
      "bciAvId": 14974,
      "gloss": "to joke (spoken)",
      "glossSv": "skoja, skämta",
      "pos": "action",
      "explanation": "to say + comma + funny + action indicator: to say something in order to be funny",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        5,
        "/",
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 1885,
      "bciAvId": 15137,
      "gloss": "July",
      "glossSv": "juli",
      "pos": "noun",
      "explanation": "month + 7: seventh month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        16
      ]
    },
    {
      "id": 1886,
      "bciAvId": 15138,
      "gloss": "jump rope, skipping rope",
      "glossSv": "hopprep",
      "pos": "noun",
      "explanation": "linear thing + to jump + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        836
      ]
    },
    {
      "id": 1887,
      "bciAvId": 15139,
      "gloss": "to jump",
      "glossSv": "hoppa",
      "pos": "action",
      "explanation": "jump + action indicator",
      "isCharacter": false,
      "composition": [
        836,
        ";",
        81
      ]
    },
    {
      "id": 1888,
      "bciAvId": 15140,
      "gloss": "June",
      "glossSv": "juni",
      "pos": "noun",
      "explanation": "month + 6: sixth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        15
      ]
    },
    {
      "id": 1889,
      "bciAvId": 15141,
      "gloss": "Kabbalat Shabbat",
      "glossSv": "Kabbalat Shabbat (Israel)",
      "pos": "expression",
      "explanation": "greeting + Sabbath: ceremony to welcome the Sabbath",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057,
        "/",
        258,
        "/",
        562
      ]
    },
    {
      "id": 1890,
      "bciAvId": 15142,
      "gloss": "Kali",
      "glossSv": "Kali (Indien)",
      "pos": "person",
      "explanation": "god + black: Hindu goddess",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        1161,
        "/",
        470
      ]
    },
    {
      "id": 1891,
      "bciAvId": 15143,
      "gloss": "to keep, to preserve, to save",
      "glossSv": "behålla, spara",
      "pos": "action",
      "explanation": "to hold + future + action indicator: to hold for the future",
      "isCharacter": false,
      "composition": [
        239,
        ";",
        81,
        "/",
        341
      ]
    },
    {
      "id": 1892,
      "bciAvId": 15145,
      "gloss": "kibbutz",
      "glossSv": "kibbutz (Israel)",
      "pos": "noun",
      "explanation": "village + to work + to live + together: collective settlement (Israel)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        392,
        "/",
        711,
        "/",
        423,
        "/",
        823
      ]
    },
    {
      "id": 1893,
      "bciAvId": 15146,
      "gloss": "to kick",
      "glossSv": "sparka",
      "pos": "action",
      "explanation": "leg and foot + intensity + action indicator: to move legs and feet forcefully",
      "isCharacter": false,
      "composition": [
        1052,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 1894,
      "bciAvId": 15147,
      "gloss": "kiddush, blessing over wine",
      "glossSv": "kiddush, välsignelse av vin (Israel)",
      "pos": "noun",
      "explanation": "prayer + wine: blessing over wine",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        657,
        "/",
        355,
        "/",
        116,
        "/",
        365
      ]
    },
    {
      "id": 1895,
      "bciAvId": 15148,
      "gloss": "to kill, to murder",
      "glossSv": "döda, mörda, avliva, dräpa",
      "pos": "action",
      "explanation": "to cause + to die + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        259
      ]
    },
    {
      "id": 1896,
      "bciAvId": 15149,
      "gloss": "kind, kindly",
      "glossSv": "hjälpsam, vänlig",
      "pos": "description",
      "explanation": "feeling + help + description indicator: feeling of wanting to be helpful",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        382
      ]
    },
    {
      "id": 1897,
      "bciAvId": 15151,
      "gloss": "Kislev",
      "glossSv": "Kislev (Israel)",
      "pos": "noun",
      "explanation": "month + happy + light: month of Chanukah",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        313,
        "/",
        678,
        "/",
        424
      ]
    },
    {
      "id": 1898,
      "bciAvId": 15153,
      "gloss": "to kiss",
      "glossSv": "kyssa, pussa",
      "pos": "action",
      "explanation": "kiss + action indicator",
      "isCharacter": false,
      "composition": [
        408,
        ";",
        81
      ]
    },
    {
      "id": 1899,
      "bciAvId": 15154,
      "gloss": "kitchen",
      "glossSv": "kök",
      "pos": "noun",
      "explanation": "room + to prepare food",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        840,
        "/",
        329
      ]
    },
    {
      "id": 1900,
      "bciAvId": 15156,
      "gloss": "kitten",
      "glossSv": "kattunge (FD)",
      "pos": "noun",
      "explanation": "cat + baby",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        140
      ]
    },
    {
      "id": 1901,
      "bciAvId": 15158,
      "gloss": "to kneel",
      "glossSv": "stå på knä",
      "pos": "action",
      "explanation": "kneeling (kneeling person) + action indicator",
      "isCharacter": false,
      "composition": [
        514,
        ";",
        81
      ]
    },
    {
      "id": 1902,
      "bciAvId": 15160,
      "gloss": "to knit",
      "glossSv": "sticka (kläder)",
      "pos": "action",
      "explanation": "to make + cloth + 2 + linear thing + thing indicator + action indicator: to make cloth using two linear things, i.e., knitting needles",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        228,
        "/",
        11,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 1903,
      "bciAvId": 15161,
      "gloss": "to know",
      "glossSv": "veta",
      "pos": "action",
      "explanation": "knowledge + action indicator",
      "isCharacter": false,
      "composition": [
        412,
        ";",
        81
      ]
    },
    {
      "id": 1904,
      "bciAvId": 15163,
      "gloss": "koala",
      "glossSv": "koala",
      "pos": "noun",
      "explanation": "marsupial (animal) + tree: marsupial adapted to living in trees",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        239,
        "/",
        666
      ]
    },
    {
      "id": 1905,
      "bciAvId": 15164,
      "gloss": "eyeliner, kohl",
      "glossSv": "eyeliner",
      "pos": "noun",
      "explanation": "colour + plus + eyelid (lower): eye make-up,traditionally used by women in African, Middle East, and Eastern cultures",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        1032
      ]
    },
    {
      "id": 1906,
      "bciAvId": 15165,
      "gloss": "labour, labor",
      "glossSv": "förlossning",
      "pos": "noun",
      "explanation": "work + birth",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        165
      ]
    },
    {
      "id": 1907,
      "bciAvId": 15167,
      "gloss": "Lag B'Omer",
      "glossSv": "Lag B'Omer (Israel)",
      "pos": "noun",
      "explanation": "night + comma + bonfire",
      "isCharacter": false,
      "composition": [
        470,
        "/",
        5,
        "/",
        319,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1908,
      "bciAvId": 15168,
      "gloss": "lake, pond",
      "glossSv": "sjö",
      "pos": "noun",
      "explanation": "much + water: body of water",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1117
      ]
    },
    {
      "id": 1909,
      "bciAvId": 15169,
      "gloss": "Lakshmi",
      "glossSv": "Lakshmi (Indien)",
      "pos": "person",
      "explanation": "God + money: Hindu goddess",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        451
      ]
    },
    {
      "id": 1910,
      "bciAvId": 15170,
      "gloss": "lamb, mutton",
      "glossSv": "lammkött",
      "pos": "noun",
      "explanation": "food + sheep: food that comes from a lamb or sheep. The symbol also can be explained as: combination of meat and sheep.",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 1911,
      "bciAvId": 15171,
      "gloss": "landing, airplane landing",
      "glossSv": "landning",
      "pos": "noun",
      "explanation": "airplane + downward and forward",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        273
      ]
    },
    {
      "id": 1912,
      "bciAvId": 15173,
      "gloss": "last, final",
      "glossSv": "sista, sist",
      "pos": "description",
      "explanation": "opposite meaning + first + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        10,
        ";",
        86,
        "/",
        4
      ]
    },
    {
      "id": 1913,
      "bciAvId": 15174,
      "gloss": "last night",
      "glossSv": "igår natt",
      "pos": "noun",
      "explanation": "night + ago,then (past)",
      "isCharacter": false,
      "composition": [
        470,
        "/",
        112
      ]
    },
    {
      "id": 1914,
      "bciAvId": 15175,
      "gloss": "last week",
      "glossSv": "förra veckan",
      "pos": "noun",
      "explanation": "week + ago,then (past)",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        112
      ]
    },
    {
      "id": 1915,
      "bciAvId": 15176,
      "gloss": "last year",
      "glossSv": "förra året",
      "pos": "noun",
      "explanation": "year + ago,then (past)",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        112
      ]
    },
    {
      "id": 1916,
      "bciAvId": 15177,
      "gloss": "late",
      "glossSv": "sen, för sen, försenad",
      "pos": "description",
      "explanation": "after + time + description indicator: after the appointed time",
      "isCharacter": false,
      "composition": [
        109,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 1917,
      "bciAvId": 15178,
      "gloss": "to laugh",
      "glossSv": "skratta",
      "pos": "action",
      "explanation": "laugh,laughter + action indicator: to express happiness with the mouth by laughing",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 1918,
      "bciAvId": 15179,
      "gloss": "laundromat, launderette, laundry",
      "glossSv": "tvättinrättning",
      "pos": "noun",
      "explanation": "public room + bath,washing + clothing",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        595,
        "/",
        229
      ]
    },
    {
      "id": 1919,
      "bciAvId": 15181,
      "gloss": "to lead, to direct, to guide",
      "glossSv": "leda, styra",
      "pos": "action",
      "explanation": "leadership,guidance + action indicator: to use mental powers to carry events or persons forward",
      "isCharacter": false,
      "composition": [
        803,
        ";",
        81
      ]
    },
    {
      "id": 1920,
      "bciAvId": 15182,
      "gloss": "leader, director, guide, coach (2)",
      "glossSv": "ledare (2)",
      "pos": "person",
      "explanation": "person + leadership",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        803
      ]
    },
    {
      "id": 1921,
      "bciAvId": 15184,
      "gloss": "to learn",
      "glossSv": "lära sig, studera",
      "pos": "action",
      "explanation": "to receive + knowledge + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        412
      ]
    },
    {
      "id": 1922,
      "bciAvId": 15185,
      "gloss": "fewest, least, minimum",
      "glossSv": "minst",
      "pos": "description",
      "explanation": "opposite meaning + most + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        968,
        ";",
        86
      ]
    },
    {
      "id": 1923,
      "bciAvId": 15186,
      "gloss": "leather",
      "glossSv": "läder, skinn",
      "pos": "noun",
      "explanation": "material + animal skin: material made from an animal skin",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        548,
        "/",
        122
      ]
    },
    {
      "id": 1924,
      "bciAvId": 15187,
      "gloss": "left",
      "glossSv": "vänster",
      "pos": "description",
      "explanation": "left turn,left (position or direction) + description indicator",
      "isCharacter": false,
      "composition": [
        1051,
        ";",
        86
      ]
    },
    {
      "id": 1925,
      "bciAvId": 15191,
      "gloss": "lemonade",
      "glossSv": "citronsaft",
      "pos": "noun",
      "explanation": "drink + lemon",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        419
      ]
    },
    {
      "id": 1926,
      "bciAvId": 15192,
      "gloss": "to lend, to loan",
      "glossSv": "låna ut",
      "pos": "action",
      "explanation": "to give + limited time + action indicator: to give for a limited time",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        426
      ]
    },
    {
      "id": 1927,
      "bciAvId": 15194,
      "gloss": "leopard",
      "glossSv": "leopard",
      "pos": "noun",
      "explanation": "feline + spot: feline with spots",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 1928,
      "bciAvId": 15195,
      "gloss": "fewer, less",
      "glossSv": "mindre, färre",
      "pos": "description",
      "explanation": "opposite meaning + more + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        937,
        ";",
        86
      ]
    },
    {
      "id": 1929,
      "bciAvId": 15196,
      "gloss": "to let, to allow, to permit",
      "glossSv": "tillåta, låta, få",
      "pos": "action",
      "explanation": "permission,allowance + action indicator: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier",
      "isCharacter": false,
      "composition": [
        960,
        ";",
        81
      ]
    },
    {
      "id": 1930,
      "bciAvId": 15197,
      "gloss": "let us, let's",
      "glossSv": "låt oss",
      "pos": "action",
      "explanation": "command + to let + us + action indicator + plural indicator: the first person plural imperative of \"to let\"",
      "isCharacter": false,
      "composition": [
        401,
        "/",
        960,
        ";",
        81,
        "/",
        513,
        ";",
        99,
        "/",
        10
      ]
    },
    {
      "id": 1931,
      "bciAvId": 15199,
      "gloss": "letter carrier, postman, mailman",
      "glossSv": "brevbärare",
      "pos": "person",
      "explanation": "person + letter",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        421
      ]
    },
    {
      "id": 1932,
      "bciAvId": 15201,
      "gloss": "library (building)",
      "glossSv": "bibliotek (byggnad)",
      "pos": "noun",
      "explanation": "building + book: building that contains a collection of books",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        173
      ]
    },
    {
      "id": 1933,
      "bciAvId": 15202,
      "gloss": "library (room)",
      "glossSv": "bibliotek (rum)",
      "pos": "noun",
      "explanation": "room + book: room that contains a collection of books",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        173
      ]
    },
    {
      "id": 1934,
      "bciAvId": 15203,
      "gloss": "lie",
      "glossSv": "lögn, osanning (FD)",
      "pos": "noun",
      "explanation": "opposite meaning + truth",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        670
      ]
    },
    {
      "id": 1935,
      "bciAvId": 15204,
      "gloss": "to lie",
      "glossSv": "ljuga (FD)",
      "pos": "action",
      "explanation": "lie + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        670,
        ";",
        81
      ]
    },
    {
      "id": 1936,
      "bciAvId": 15205,
      "gloss": "to lie down, to lie",
      "glossSv": "ligga",
      "pos": "action",
      "explanation": "reclining,lying (person lying down) + action indicator",
      "isCharacter": false,
      "composition": [
        515,
        ";",
        81
      ]
    },
    {
      "id": 1937,
      "bciAvId": 15207,
      "gloss": "to lift, to raise",
      "glossSv": "lyfta",
      "pos": "action",
      "explanation": "up + weight + action indicator: to raise a weight",
      "isCharacter": false,
      "composition": [
        678,
        ";",
        81,
        "/",
        697
      ]
    },
    {
      "id": 1938,
      "bciAvId": 15210,
      "gloss": "to like",
      "glossSv": "tycka om, gilla",
      "pos": "action",
      "explanation": "goodness + action indicator: to have a positive or good feeling toward someone or something",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 1939,
      "bciAvId": 15211,
      "gloss": "lime",
      "glossSv": "lime",
      "pos": "noun",
      "explanation": "citrus fruit + green",
      "isCharacter": false,
      "composition": [
        489,
        "/",
        1161,
        "/",
        366
      ]
    },
    {
      "id": 1940,
      "bciAvId": 15215,
      "gloss": "linear, straight",
      "glossSv": "rak",
      "pos": "description",
      "explanation": "line + description indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        86
      ]
    },
    {
      "id": 1941,
      "bciAvId": 15216,
      "gloss": "linear thing",
      "glossSv": "rak sak, sticka, strå (etc)",
      "pos": "noun",
      "explanation": "line + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97
      ]
    },
    {
      "id": 1942,
      "bciAvId": 15217,
      "gloss": "lion",
      "glossSv": "lejon",
      "pos": "noun",
      "explanation": "feline + mane (lion etc): male of the species has a mane",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        1054
      ]
    },
    {
      "id": 1943,
      "bciAvId": 15219,
      "gloss": "lipstick",
      "glossSv": "läppstift",
      "pos": "noun",
      "explanation": "colour + plus + lips: colour added to lips",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        429
      ]
    },
    {
      "id": 1944,
      "bciAvId": 15220,
      "gloss": "list, inventory",
      "glossSv": "lista",
      "pos": "noun",
      "explanation": "paper + many + thing: written record of many things",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        368,
        "/",
        651
      ]
    },
    {
      "id": 1945,
      "bciAvId": 15221,
      "gloss": "little, small",
      "glossSv": "liten",
      "pos": "description",
      "explanation": "vertical line [half-sized] bounded by two horizontal reference lines [half-sized] + description indicator: the vertical line is relatively little",
      "isCharacter": false,
      "composition": [
        956,
        ";",
        86
      ]
    },
    {
      "id": 1946,
      "bciAvId": 15222,
      "gloss": "to live (life)",
      "glossSv": "leva",
      "pos": "action",
      "explanation": "life + action indicator",
      "isCharacter": false,
      "composition": [
        423,
        ";",
        81
      ]
    },
    {
      "id": 1947,
      "bciAvId": 15223,
      "gloss": "to live, to dwell, to reside",
      "glossSv": "bo",
      "pos": "action",
      "explanation": "house + action indicator",
      "isCharacter": false,
      "composition": [
        392,
        ";",
        81
      ]
    },
    {
      "id": 1948,
      "bciAvId": 15224,
      "gloss": "living room, lounge, sitting room, front room, parlor, parlour, waiting room",
      "glossSv": "vardagsrum, dagrum",
      "pos": "noun",
      "explanation": "room + chair: room where one can sit",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        212
      ]
    },
    {
      "id": 1949,
      "bciAvId": 15227,
      "gloss": "to lock",
      "glossSv": "låsa",
      "pos": "action",
      "explanation": "key + action indicator",
      "isCharacter": false,
      "composition": [
        407,
        ";",
        81
      ]
    },
    {
      "id": 1950,
      "bciAvId": 15228,
      "gloss": "lonely, lonesome",
      "glossSv": "ensam",
      "pos": "description",
      "explanation": "feeling + minus + person + description indicator: feeling of being without companionship",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        513
      ]
    },
    {
      "id": 1951,
      "bciAvId": 15229,
      "gloss": "long",
      "glossSv": "lång",
      "pos": "description",
      "explanation": "length + description indicator",
      "isCharacter": false,
      "composition": [
        420,
        ";",
        86
      ]
    },
    {
      "id": 1952,
      "bciAvId": 15230,
      "gloss": "longer",
      "glossSv": "längre",
      "pos": "description",
      "explanation": "more + long + description indicator",
      "isCharacter": false,
      "composition": [
        937,
        "/",
        420,
        ";",
        86
      ]
    },
    {
      "id": 1953,
      "bciAvId": 15393,
      "gloss": "longest",
      "glossSv": "längst",
      "pos": "description",
      "explanation": "most + long + description indicator",
      "isCharacter": false,
      "composition": [
        968,
        "/",
        420,
        ";",
        86
      ]
    },
    {
      "id": 1954,
      "bciAvId": 15394,
      "gloss": "to lose (fail to keep)",
      "glossSv": "förlora, tappa bort",
      "pos": "action",
      "explanation": "opposite meaning + to find + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        303,
        ";",
        81,
        "/",
        1044
      ]
    },
    {
      "id": 1955,
      "bciAvId": 15395,
      "gloss": "to lose (fail to win)",
      "glossSv": "förlora (FD)",
      "pos": "action",
      "explanation": "opposite meaning + to win + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        554,
        ";",
        81,
        "/",
        107
      ]
    },
    {
      "id": 1956,
      "bciAvId": 15396,
      "gloss": "loss (emotional)",
      "glossSv": "saknad",
      "pos": "noun",
      "explanation": "feeling + to take away: emotional response to the loss of someone or something",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        634
      ]
    },
    {
      "id": 1957,
      "bciAvId": 15397,
      "gloss": "loud, noisy",
      "glossSv": "hög, högljudd, ljudlig",
      "pos": "description",
      "explanation": "noise (loud) + description indicator",
      "isCharacter": false,
      "composition": [
        608,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 1958,
      "bciAvId": 15398,
      "gloss": "lovable",
      "glossSv": "förtjusande, älskvärd",
      "pos": "description",
      "explanation": "love + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        431,
        ";",
        85
      ]
    },
    {
      "id": 1959,
      "bciAvId": 15400,
      "gloss": "to love",
      "glossSv": "älska",
      "pos": "action",
      "explanation": "love + action indicator",
      "isCharacter": false,
      "composition": [
        431,
        ";",
        81
      ]
    },
    {
      "id": 1960,
      "bciAvId": 15401,
      "gloss": "low, short",
      "glossSv": "låg",
      "pos": "description",
      "explanation": "lowness,shortness (height) + description indicator: the space between the reference lines is relatively low",
      "isCharacter": false,
      "composition": [
        957,
        ";",
        86
      ]
    },
    {
      "id": 1961,
      "bciAvId": 15402,
      "gloss": "luck, fortune",
      "glossSv": "tur",
      "pos": "noun",
      "explanation": "feeling + addition: having a \"big plus\" or advantage",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        107
      ]
    },
    {
      "id": 1962,
      "bciAvId": 15403,
      "gloss": "lucky, fortunate",
      "glossSv": "lyckosam, tursam",
      "pos": "description",
      "explanation": "luck + description after the fact indicator: feeling one has a \"big plus\" or advantage",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        107
      ]
    },
    {
      "id": 1963,
      "bciAvId": 15404,
      "gloss": "lulav",
      "glossSv": "lulav (Israel)",
      "pos": "noun",
      "explanation": "3 + branch + Sukkot",
      "isCharacter": false,
      "composition": [
        12,
        "/",
        179,
        "/",
        16,
        "/",
        258,
        "/",
        548,
        ";",
        97,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 1964,
      "bciAvId": 15405,
      "gloss": "lunch, dinner",
      "glossSv": "lunch",
      "pos": "noun",
      "explanation": "meal + 2: second meal of the day",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        329,
        "/",
        11
      ]
    },
    {
      "id": 1965,
      "bciAvId": 15407,
      "gloss": "magazine, journal",
      "glossSv": "tidning, tidskrift",
      "pos": "noun",
      "explanation": "book + often: book that is published at frequent intervals",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        368,
        "/",
        655
      ]
    },
    {
      "id": 1966,
      "bciAvId": 15408,
      "gloss": "to mail, to post",
      "glossSv": "posta",
      "pos": "action",
      "explanation": "mail + action indicator",
      "isCharacter": false,
      "composition": [
        421,
        ";",
        81
      ]
    },
    {
      "id": 1967,
      "bciAvId": 15409,
      "gloss": "mailbox, letterbox, postbox",
      "glossSv": "brevlåda, postlåda",
      "pos": "noun",
      "explanation": "enclosure + letter",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        421
      ]
    },
    {
      "id": 1968,
      "bciAvId": 15410,
      "gloss": "to make, to manufacture, to produce",
      "glossSv": "göra, tillverka",
      "pos": "action",
      "explanation": "making,production,fashioning + action indicator: imperfect version of creation, represents man-made",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81
      ]
    },
    {
      "id": 1969,
      "bciAvId": 15411,
      "gloss": "make-believe, pretend, imaginary",
      "glossSv": "overklig, på låtsas",
      "pos": "description",
      "explanation": "fantasy,phantasy,imagination,illusion + description indicator: to let one's mind soar into the sky, or up into the clouds",
      "isCharacter": false,
      "composition": [
        945,
        ";",
        86
      ]
    },
    {
      "id": 1970,
      "bciAvId": 15412,
      "gloss": "maker, manufacturer, producer",
      "glossSv": "producent, tillverkare",
      "pos": "person",
      "explanation": "person + to make",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        840
      ]
    },
    {
      "id": 1971,
      "bciAvId": 15413,
      "gloss": "makeup",
      "glossSv": "smink",
      "pos": "noun",
      "explanation": "colour + plus + face: colour added to the face",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        306
      ]
    },
    {
      "id": 1972,
      "bciAvId": 15414,
      "gloss": "male, masculine (person)",
      "glossSv": "manlig, maskulin",
      "pos": "description",
      "explanation": "man + description indicator",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        86
      ]
    },
    {
      "id": 1973,
      "bciAvId": 15418,
      "gloss": "manager, secretary",
      "glossSv": "chef, direktör, föreståndare",
      "pos": "person",
      "explanation": "person + to plan + work: person who organizes the work",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        711
      ]
    },
    {
      "id": 1974,
      "bciAvId": 15420,
      "gloss": "man-made, produced",
      "glossSv": "tillverkad",
      "pos": "description",
      "explanation": "making,production,fashioning + description indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        86
      ]
    },
    {
      "id": 1975,
      "bciAvId": 15421,
      "gloss": "map",
      "glossSv": "karta",
      "pos": "noun",
      "explanation": "paper + earth: graphic representation of the earth",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        281
      ]
    },
    {
      "id": 1976,
      "bciAvId": 15423,
      "gloss": "March",
      "glossSv": "mars",
      "pos": "noun",
      "explanation": "month + 3: third month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        12
      ]
    },
    {
      "id": 1977,
      "bciAvId": 15424,
      "gloss": "margarine",
      "glossSv": "margarin",
      "pos": "noun",
      "explanation": "spread + oil",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        480
      ]
    },
    {
      "id": 1978,
      "bciAvId": 15426,
      "gloss": "to marry",
      "glossSv": "gifta sig",
      "pos": "action",
      "explanation": "marriage + action indicator",
      "isCharacter": false,
      "composition": [
        437,
        ";",
        81
      ]
    },
    {
      "id": 1979,
      "bciAvId": 15427,
      "gloss": "to mash, to crush, to squeeze, to squash (food)",
      "glossSv": "mosa",
      "pos": "action",
      "explanation": "mash,mush,pulp (food) + action indicator: to crush food",
      "isCharacter": false,
      "composition": [
        1055,
        ";",
        81
      ]
    },
    {
      "id": 1980,
      "bciAvId": 15428,
      "gloss": "mask, false face",
      "glossSv": "ansiktsmask",
      "pos": "noun",
      "explanation": "face + fantasy,phantasy,imagination,illusion",
      "isCharacter": false,
      "composition": [
        306,
        "/",
        945
      ]
    },
    {
      "id": 1981,
      "bciAvId": 15429,
      "gloss": "masturbation",
      "glossSv": "onani",
      "pos": "noun",
      "explanation": "genitals + to touch + pleasure",
      "isCharacter": false,
      "composition": [
        349,
        "/",
        374,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 1982,
      "bciAvId": 15430,
      "gloss": "match",
      "glossSv": "tändsticka",
      "pos": "noun",
      "explanation": "linear thing + fire + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        319
      ]
    },
    {
      "id": 1983,
      "bciAvId": 15433,
      "gloss": "maturation",
      "glossSv": "mognad",
      "pos": "noun",
      "explanation": "to advance + adult: advancing toward adulthood",
      "isCharacter": false,
      "composition": [
        335,
        "/",
        108
      ]
    },
    {
      "id": 1984,
      "bciAvId": 15434,
      "gloss": "matzo",
      "glossSv": "knäckebröd, tunnbröd (etc)",
      "pos": "noun",
      "explanation": "bread + low: unleavened bread eaten on Passover",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        957
      ]
    },
    {
      "id": 1985,
      "bciAvId": 15435,
      "gloss": "May",
      "glossSv": "maj",
      "pos": "noun",
      "explanation": "month + 5: fifth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        14
      ]
    },
    {
      "id": 1986,
      "bciAvId": 15436,
      "gloss": "possibility",
      "glossSv": "möjlighet",
      "pos": "noun",
      "explanation": "being (state of) + what,question mark: expression that indicates doubt or uncertainty",
      "isCharacter": false,
      "composition": [
        894,
        "/",
        699
      ]
    },
    {
      "id": 1987,
      "bciAvId": 15437,
      "gloss": "to congratulate",
      "glossSv": "gratulera, lyckönska",
      "pos": "action",
      "explanation": "congratulations + action indicator",
      "isCharacter": false,
      "composition": [
        401,
        "/",
        313,
        ";",
        81,
        "/",
        107
      ]
    },
    {
      "id": 1988,
      "bciAvId": 15438,
      "gloss": "meal",
      "glossSv": "måltid",
      "pos": "noun",
      "explanation": "group of + food: group of foods served and eaten in a single sitting",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        329
      ]
    },
    {
      "id": 1989,
      "bciAvId": 15439,
      "gloss": "mean, cruel",
      "glossSv": "elak, ond",
      "pos": "description",
      "explanation": "feeling + sharp + description indicator: sharp or “cutting” in one’s manner",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        411
      ]
    },
    {
      "id": 1990,
      "bciAvId": 15440,
      "gloss": "to mean, to signify",
      "glossSv": "betyda",
      "pos": "action",
      "explanation": "meaning + action indicator",
      "isCharacter": false,
      "composition": [
        440,
        ";",
        81
      ]
    },
    {
      "id": 1991,
      "bciAvId": 15442,
      "gloss": "to measure",
      "glossSv": "mäta",
      "pos": "action",
      "explanation": "measurement + action indicator",
      "isCharacter": false,
      "composition": [
        441,
        ";",
        81
      ]
    },
    {
      "id": 1992,
      "bciAvId": 15444,
      "gloss": "meat",
      "glossSv": "kött",
      "pos": "noun",
      "explanation": "food + animal: food that comes from an animal",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122
      ]
    },
    {
      "id": 1993,
      "bciAvId": 15445,
      "gloss": "meatball",
      "glossSv": "köttbulle",
      "pos": "noun",
      "explanation": "meat + ball: meat shaped into a ball",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        148
      ]
    },
    {
      "id": 1994,
      "bciAvId": 15446,
      "gloss": "medical, medically",
      "glossSv": "medicinsk, sjuk-",
      "pos": "description",
      "explanation": "medicine,medical practice + description indicator",
      "isCharacter": false,
      "composition": [
        958,
        ";",
        86
      ]
    },
    {
      "id": 1995,
      "bciAvId": 15447,
      "gloss": "medical insurance",
      "glossSv": "sjukförsäkring",
      "pos": "noun",
      "explanation": "insurance + medical: protection against unpredictable future medical expense",
      "isCharacter": false,
      "composition": [
        1050,
        "/",
        958
      ]
    },
    {
      "id": 1996,
      "bciAvId": 15448,
      "gloss": "medicine, medication",
      "glossSv": "medicin",
      "pos": "noun",
      "explanation": "chemical product + medical",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        958
      ]
    },
    {
      "id": 1997,
      "bciAvId": 15449,
      "gloss": "to meet, to encounter, to see",
      "glossSv": "möta, träffa",
      "pos": "action",
      "explanation": "meeting,encounter + action indicator",
      "isCharacter": false,
      "composition": [
        1057,
        ";",
        81
      ]
    },
    {
      "id": 1998,
      "bciAvId": 15450,
      "gloss": "meeting, assembly, conference",
      "glossSv": "konferens, sammanträde",
      "pos": "noun",
      "explanation": "gathering + discussion",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        457,
        "/",
        144
      ]
    },
    {
      "id": 1999,
      "bciAvId": 15451,
      "gloss": "Megillah (Book of Esther)",
      "glossSv": "megillah (Israel)",
      "pos": "noun",
      "explanation": "pictograph: symbol suggests a scroll on one post",
      "isCharacter": true
    },
    {
      "id": 2000,
      "bciAvId": 15453,
      "gloss": "menopause",
      "glossSv": "klimakteriet",
      "pos": "noun",
      "explanation": "end + menstruation",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        695,
        "/",
        681,
        "/",
        452
      ]
    },
    {
      "id": 2001,
      "bciAvId": 15455,
      "gloss": "menstruation, menstrual period, period",
      "glossSv": "mens, menstruation",
      "pos": "noun",
      "explanation": "liquid + uterus + month",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        681,
        "/",
        452
      ]
    },
    {
      "id": 2002,
      "bciAvId": 15456,
      "gloss": "mental, intellectual, rational, thinking",
      "glossSv": "intellektuell, tänkande, mental",
      "pos": "description",
      "explanation": "mind + description indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        86
      ]
    },
    {
      "id": 2003,
      "bciAvId": 15457,
      "gloss": "disabled, handicapped (intellectually, mentally)",
      "glossSv": "förståndshandikappad, utvecklingsstörd (FD)",
      "pos": "description",
      "explanation": "limit(s),limitation (OLD) + mind + description indicator: having limits to one's mental abilities",
      "isCharacter": false,
      "composition": [
        427,
        ";",
        86,
        "/",
        447
      ]
    },
    {
      "id": 2004,
      "bciAvId": 15458,
      "gloss": "merry-go-round, carousel",
      "glossSv": "karusell",
      "pos": "noun",
      "explanation": "to circle + happy + thing indicator: thing to enjoy by going around and around",
      "isCharacter": false,
      "composition": [
        887,
        ";",
        97,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2005,
      "bciAvId": 15459,
      "gloss": "metal",
      "glossSv": "metall",
      "pos": "noun",
      "explanation": "material + metal bar",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        814
      ]
    },
    {
      "id": 2006,
      "bciAvId": 15461,
      "gloss": "mezuzah",
      "glossSv": "mezuzah (Israel)",
      "pos": "noun",
      "explanation": "part of + Torah + door",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        663,
        "/",
        269
      ]
    },
    {
      "id": 2007,
      "bciAvId": 15462,
      "gloss": "to microwave",
      "glossSv": "använda mikrovågsugn, mikra",
      "pos": "action",
      "explanation": "microwave oven + action indicator",
      "isCharacter": false,
      "composition": [
        445,
        ";",
        81
      ]
    },
    {
      "id": 2008,
      "bciAvId": 15465,
      "gloss": "midsummer",
      "glossSv": "midsommar",
      "pos": "noun",
      "explanation": "day + most + sun",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        968,
        "/",
        636
      ]
    },
    {
      "id": 2009,
      "bciAvId": 15466,
      "gloss": "military plane",
      "glossSv": "militärplan",
      "pos": "noun",
      "explanation": "airplane + war",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        693
      ]
    },
    {
      "id": 2010,
      "bciAvId": 15467,
      "gloss": "military reserve duty",
      "glossSv": "militärtjänst",
      "pos": "noun",
      "explanation": "limited time + soldier: service as a soldier for a limited time only",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        513,
        "/",
        693
      ]
    },
    {
      "id": 2011,
      "bciAvId": 15468,
      "gloss": "milk",
      "glossSv": "mjölk",
      "pos": "noun",
      "explanation": "drink + life: drink that sustains life",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        423
      ]
    },
    {
      "id": 2012,
      "bciAvId": 15469,
      "gloss": "milkman",
      "glossSv": "mjölkbud",
      "pos": "person",
      "explanation": "person + milk",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 2013,
      "bciAvId": 15470,
      "gloss": "milkshake",
      "glossSv": "milkshake, mjölkdrink",
      "pos": "noun",
      "explanation": "milk + to shake",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        423,
        "/",
        723
      ]
    },
    {
      "id": 2014,
      "bciAvId": 15473,
      "gloss": "minister, pastor, preacher, priest, rabbi",
      "glossSv": "präst, pastor",
      "pos": "person",
      "explanation": "person + to teach + God: person who gives us knowledge about God",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        949,
        "/",
        412,
        "/",
        355
      ]
    },
    {
      "id": 2015,
      "bciAvId": 15475,
      "gloss": "minute",
      "glossSv": "minut",
      "pos": "noun",
      "explanation": "time + apostrophe, used in astronomy to indicate a minute",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        7
      ]
    },
    {
      "id": 2016,
      "bciAvId": 15477,
      "gloss": "miscarriage, abortion (spontaneous)",
      "glossSv": "missfall",
      "pos": "noun",
      "explanation": "miscarriage,abortion (general) + woman: cancelled human pregnancy due to the natural death of an embryo",
      "isCharacter": false,
      "composition": [
        1021,
        "/",
        710
      ]
    },
    {
      "id": 2017,
      "bciAvId": 15478,
      "gloss": "to miss, to lose",
      "glossSv": "sakna",
      "pos": "action",
      "explanation": "loss + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        634
      ]
    },
    {
      "id": 2018,
      "bciAvId": 15479,
      "gloss": "mistake, error, fault",
      "glossSv": "fel, misstag",
      "pos": "noun",
      "explanation": "action + incorrect",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 2019,
      "bciAvId": 15480,
      "gloss": "mite, tick",
      "glossSv": "fästing, kvalster (etc)",
      "pos": "noun",
      "explanation": "spider + little: tiny spider-like insect",
      "isCharacter": false,
      "composition": [
        613,
        "/",
        956
      ]
    },
    {
      "id": 2020,
      "bciAvId": 15481,
      "gloss": "to mix, to blend",
      "glossSv": "blanda",
      "pos": "action",
      "explanation": "mixture + action indicator",
      "isCharacter": false,
      "composition": [
        783,
        ";",
        81
      ]
    },
    {
      "id": 2021,
      "bciAvId": 15482,
      "gloss": "recreation room, moadan",
      "glossSv": "sällskapsrum",
      "pos": "noun",
      "explanation": "room + happiness: room for social gatherings",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2022,
      "bciAvId": 15483,
      "gloss": "Monday",
      "glossSv": "måndag (FD)",
      "pos": "noun",
      "explanation": "day + 2: second day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        11
      ]
    },
    {
      "id": 2023,
      "bciAvId": 15485,
      "gloss": "monkey, ape, gorilla, primate",
      "glossSv": "apa, gorilla",
      "pos": "noun",
      "explanation": "animal + similar to + person: animal that resembles a person",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        1060,
        "/",
        578,
        "/",
        513
      ]
    },
    {
      "id": 2024,
      "bciAvId": 15486,
      "gloss": "monster",
      "glossSv": "monster, seriefigur (etc)",
      "pos": "noun",
      "explanation": "creature + strange + thing indicator: creature that is strange or unusual",
      "isCharacter": false,
      "composition": [
        423,
        ";",
        97,
        "/",
        313,
        "/",
        699
      ]
    },
    {
      "id": 2025,
      "bciAvId": 15487,
      "gloss": "congratulations, best of luck, mazel tov",
      "glossSv": "grattis, gratulation",
      "pos": "function",
      "explanation": "command + luck",
      "isCharacter": false,
      "composition": [
        401,
        "/",
        313,
        "/",
        107
      ]
    },
    {
      "id": 2026,
      "bciAvId": 15650,
      "gloss": "mood",
      "glossSv": "humör, sinnesstämning",
      "pos": "noun",
      "explanation": "state of mind + feeling: state of one’s mind and emotions",
      "isCharacter": false,
      "composition": [
        985,
        "/",
        313
      ]
    },
    {
      "id": 2027,
      "bciAvId": 15652,
      "gloss": "moose, elk",
      "glossSv": "älg",
      "pos": "noun",
      "explanation": "cervine (animal) + big",
      "isCharacter": false,
      "composition": [
        125,
        "/",
        936
      ]
    },
    {
      "id": 2028,
      "bciAvId": 15653,
      "gloss": "moral, good, right, morally right",
      "glossSv": "rätt, moralisk",
      "pos": "description",
      "explanation": "good conscience + intensity + description indicator: can also be seen as a combination of conscience + positive",
      "isCharacter": false,
      "composition": [
        1043,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2029,
      "bciAvId": 15654,
      "gloss": "more",
      "glossSv": "mer, fler",
      "pos": "description",
      "explanation": "comparative more + description indicator: much/many on a higher level",
      "isCharacter": false,
      "composition": [
        937,
        ";",
        86
      ]
    },
    {
      "id": 2030,
      "bciAvId": 15655,
      "gloss": "morning (before noon)",
      "glossSv": "förmiddag",
      "pos": "noun",
      "explanation": "day + before + 12: part of the day before noon",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        158,
        "/",
        10,
        "/",
        11
      ]
    },
    {
      "id": 2031,
      "bciAvId": 15657,
      "gloss": "mortal",
      "glossSv": "dödlig",
      "pos": "description",
      "explanation": "death + description before the fact indicator: pertaining to beings who must eventually die",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        85
      ]
    },
    {
      "id": 2032,
      "bciAvId": 15658,
      "gloss": "moshav",
      "glossSv": "Moshav (Israel)",
      "pos": "noun",
      "explanation": "village + to work + together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        392,
        "/",
        711,
        "/",
        823
      ]
    },
    {
      "id": 2033,
      "bciAvId": 15659,
      "gloss": "Muslim, Moslem, Islamic",
      "glossSv": "muslimsk",
      "pos": "description",
      "explanation": "star + crescent moon + description indicator: the star and crescent are traditional symbols for Islam",
      "isCharacter": false,
      "composition": [
        622,
        ";",
        86,
        "/",
        453
      ]
    },
    {
      "id": 2034,
      "bciAvId": 15660,
      "gloss": "mosquito, gadfly, horsefly, cleg",
      "glossSv": "mygga",
      "pos": "noun",
      "explanation": "insect + to fly + to puncture: flying insect that punctures the skin",
      "isCharacter": false,
      "composition": [
        327,
        "/",
        538
      ]
    },
    {
      "id": 2035,
      "bciAvId": 15661,
      "gloss": "most, maximum",
      "glossSv": "mest, flest",
      "pos": "description",
      "explanation": "superlative most + description indicator: much/many on the highest level",
      "isCharacter": false,
      "composition": [
        968,
        ";",
        86
      ]
    },
    {
      "id": 2036,
      "bciAvId": 15664,
      "gloss": "mountain berry, cowberry, lingonberry",
      "glossSv": "lingon",
      "pos": "noun",
      "explanation": "berry + mountain: berry that grows in uplands",
      "isCharacter": false,
      "composition": [
        161,
        "/",
        456
      ]
    },
    {
      "id": 2037,
      "bciAvId": 15665,
      "gloss": "mouse",
      "glossSv": "mus",
      "pos": "noun",
      "explanation": "rodent + little: rodent that is smaller than a rat",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        956
      ]
    },
    {
      "id": 2038,
      "bciAvId": 15667,
      "gloss": "to move",
      "glossSv": "förflytta, flytta, köra",
      "pos": "action",
      "explanation": "move,movement + action indicator: the wheel moves by rolling over the ground",
      "isCharacter": false,
      "composition": [
        974,
        ";",
        81
      ]
    },
    {
      "id": 2039,
      "bciAvId": 15668,
      "gloss": "to move bowels, to defecate, to stool, to shit, to ca-ca",
      "glossSv": "baja, bajsa, ha avföring",
      "pos": "action",
      "explanation": "bowel movement + action indicator",
      "isCharacter": false,
      "composition": [
        694,
        ";",
        81,
        "/",
        194
      ]
    },
    {
      "id": 2040,
      "bciAvId": 15669,
      "gloss": "movie, film",
      "glossSv": "film",
      "pos": "noun",
      "explanation": "cylinder + projector",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        547
      ]
    },
    {
      "id": 2041,
      "bciAvId": 15670,
      "gloss": "movie theatre, movie theater, cinema",
      "glossSv": "bio",
      "pos": "noun",
      "explanation": "building + projector",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        547
      ]
    },
    {
      "id": 2042,
      "bciAvId": 15671,
      "gloss": "much, many, very",
      "glossSv": "mycket, många",
      "pos": "description",
      "explanation": "group of,much of,many of,quantity of + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        ";",
        86
      ]
    },
    {
      "id": 2043,
      "bciAvId": 15674,
      "gloss": "to multiply",
      "glossSv": "multiplicera",
      "pos": "action",
      "explanation": "multiplication + action indicator",
      "isCharacter": false,
      "composition": [
        459,
        ";",
        81
      ]
    },
    {
      "id": 2044,
      "bciAvId": 15675,
      "gloss": "multitude",
      "glossSv": "mängd",
      "pos": "noun",
      "explanation": "multiplication + thing indicator: large number of people or things. The symbol is the concrete form of multiplication.",
      "isCharacter": false,
      "composition": [
        459,
        ";",
        97
      ]
    },
    {
      "id": 2045,
      "bciAvId": 15677,
      "gloss": "museum",
      "glossSv": "museum",
      "pos": "noun",
      "explanation": "building + thing + interesting + plural indicator: building where interesting things are displayed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        651,
        ";",
        99,
        "/",
        955
      ]
    },
    {
      "id": 2046,
      "bciAvId": 15679,
      "gloss": "music",
      "glossSv": "musik",
      "pos": "noun",
      "explanation": "ear + musical note",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462
      ]
    },
    {
      "id": 2047,
      "bciAvId": 15680,
      "gloss": "musical group",
      "glossSv": "musikgrupp",
      "pos": "person",
      "explanation": "group (people) + musical note",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        462
      ]
    },
    {
      "id": 2048,
      "bciAvId": 15681,
      "gloss": "musical instrument",
      "glossSv": "musikinstrument",
      "pos": "noun",
      "explanation": "instrument + musical note",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        462
      ]
    },
    {
      "id": 2049,
      "bciAvId": 15683,
      "gloss": "musician",
      "glossSv": "musiker",
      "pos": "person",
      "explanation": "person + musical note: person who makes music",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        462
      ]
    },
    {
      "id": 2050,
      "bciAvId": 15684,
      "gloss": "muskrat",
      "glossSv": "vattenråtta, bisamråtta",
      "pos": "noun",
      "explanation": "water animal + rodent [combination]: rodent at home in water",
      "isCharacter": false,
      "composition": [
        127,
        "/",
        644
      ]
    },
    {
      "id": 2051,
      "bciAvId": 15685,
      "gloss": "to must, to have to, to be forced to",
      "glossSv": "måste",
      "pos": "action",
      "explanation": "must (a) + action indicator: Note, original derivation in BRG is: (to force + passive indicator: to be forced to do something)",
      "isCharacter": false,
      "composition": [
        804,
        ";",
        81
      ]
    },
    {
      "id": 2052,
      "bciAvId": 15686,
      "gloss": "my, mine",
      "glossSv": "min, mitt, mina",
      "pos": "person",
      "explanation": "I + belongs to: first person singular, possessive",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2053,
      "bciAvId": 15687,
      "gloss": "my, mine - (feminine)",
      "glossSv": "min, mitt, mina (fem.)",
      "pos": "person",
      "explanation": "female + 1 + belongs to: first person singular (f.), possessive",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2054,
      "bciAvId": 15688,
      "gloss": "my, mine - (masculine)",
      "glossSv": "min, mitt, mina (mask.)",
      "pos": "person",
      "explanation": "male + 1 + belongs to: first person singular (m.), possessive",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2055,
      "bciAvId": 15690,
      "gloss": "nail polish, nail varnish",
      "glossSv": "nagellack",
      "pos": "noun",
      "explanation": "colour + plus + finger: colour added to fingernails",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        318
      ]
    },
    {
      "id": 2056,
      "bciAvId": 15692,
      "gloss": "napkin, serviette",
      "glossSv": "servett",
      "pos": "noun",
      "explanation": "cloth + to eat",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        329
      ]
    },
    {
      "id": 2057,
      "bciAvId": 15693,
      "gloss": "narrow",
      "glossSv": "trång, smal",
      "pos": "description",
      "explanation": "opposite meaning + wide + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        1108,
        ";",
        86
      ]
    },
    {
      "id": 2058,
      "bciAvId": 15694,
      "gloss": "naughty",
      "glossSv": "olydig",
      "pos": "description",
      "explanation": "bad + comma + little + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        401,
        "/",
        5,
        "/",
        956
      ]
    },
    {
      "id": 2059,
      "bciAvId": 15695,
      "gloss": "naughty, not nice",
      "glossSv": "otrevlig",
      "pos": "description",
      "explanation": "feeling + incorrect + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 2060,
      "bciAvId": 15696,
      "gloss": "navy",
      "glossSv": "marin, flotta (militär)",
      "pos": "noun",
      "explanation": "group (people) + war + water: group trained for war at sea",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693,
        "/",
        1117
      ]
    },
    {
      "id": 2061,
      "bciAvId": 15697,
      "gloss": "near, almost, close, nearly",
      "glossSv": "nära, nästan",
      "pos": "description",
      "explanation": "nearness,closeness,proximity + description indicator",
      "isCharacter": false,
      "composition": [
        1060,
        ";",
        86
      ]
    },
    {
      "id": 2062,
      "bciAvId": 15698,
      "gloss": "necessary, necessarily, needed",
      "glossSv": "nödvändig",
      "pos": "description",
      "explanation": "need + description indicator",
      "isCharacter": false,
      "composition": [
        467,
        ";",
        86
      ]
    },
    {
      "id": 2063,
      "bciAvId": 15702,
      "gloss": "to need",
      "glossSv": "behöva",
      "pos": "action",
      "explanation": "need + action indicator: the leaning person needs support",
      "isCharacter": false,
      "composition": [
        467,
        ";",
        81
      ]
    },
    {
      "id": 2064,
      "bciAvId": 15704,
      "gloss": "hypodermic needle",
      "glossSv": "injektionsnål",
      "pos": "noun",
      "explanation": "hypodermic needlepoint + thing indicator: or semantically more reasonable; syringe + pointer, to needlepoint",
      "isCharacter": false,
      "composition": [
        1047,
        ";",
        97
      ]
    },
    {
      "id": 2065,
      "bciAvId": 15705,
      "gloss": "neighbour, neighbor",
      "glossSv": "granne",
      "pos": "person",
      "explanation": "person + to live + near",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        392,
        "/",
        1060
      ]
    },
    {
      "id": 2066,
      "bciAvId": 15706,
      "gloss": "neither",
      "glossSv": "varken",
      "pos": "expression",
      "explanation": "minus + either",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        286
      ]
    },
    {
      "id": 2067,
      "bciAvId": 15707,
      "gloss": "nephew",
      "glossSv": "brorson, systerson",
      "pos": "person",
      "explanation": "son + sibling: son of one's brother or sister",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        479,
        "/",
        11
      ]
    },
    {
      "id": 2068,
      "bciAvId": 15708,
      "gloss": "Netherlands (The), Holland",
      "glossSv": "Holland, Nederländerna",
      "pos": "noun",
      "explanation": "country + low",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        957
      ]
    },
    {
      "id": 2069,
      "bciAvId": 15709,
      "gloss": "never",
      "glossSv": "aldrig (FD)",
      "pos": "description",
      "explanation": "opposite meaning + always + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        655,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 2070,
      "bciAvId": 15710,
      "gloss": "new",
      "glossSv": "ny",
      "pos": "description",
      "explanation": "newness,novelty + description indicator",
      "isCharacter": false,
      "composition": [
        1061,
        ";",
        86
      ]
    },
    {
      "id": 2071,
      "bciAvId": 15711,
      "gloss": "New Year's Day",
      "glossSv": "nyår",
      "pos": "noun",
      "explanation": "birthday + year: day that a new year is born",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        166,
        "/",
        716
      ]
    },
    {
      "id": 2072,
      "bciAvId": 15713,
      "gloss": "newspaper, bulletin, newsletter",
      "glossSv": "dagstidning, bulletin",
      "pos": "noun",
      "explanation": "page + news",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        469
      ]
    },
    {
      "id": 2073,
      "bciAvId": 15714,
      "gloss": "next",
      "glossSv": "nästa",
      "pos": "description",
      "explanation": "first + after + description indicator: coming directly after",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        86,
        "/",
        4,
        "/",
        109
      ]
    },
    {
      "id": 2074,
      "bciAvId": 15715,
      "gloss": "next week",
      "glossSv": "nästa vecka",
      "pos": "noun",
      "explanation": "week + then (future)",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        648
      ]
    },
    {
      "id": 2075,
      "bciAvId": 15716,
      "gloss": "next year",
      "glossSv": "nästa år",
      "pos": "noun",
      "explanation": "year + then (future)",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        "RK:-2",
        "/",
        648
      ]
    },
    {
      "id": 2076,
      "bciAvId": 15717,
      "gloss": "nice, pleasant",
      "glossSv": "trevlig",
      "pos": "description",
      "explanation": "feeling + correct + description indicator: felt to be socially \"correct\"",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 2077,
      "bciAvId": 15718,
      "gloss": "niece",
      "glossSv": "brorsdotter, systerdotter",
      "pos": "person",
      "explanation": "daughter + sibling: daughter of one's brother or sister",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        479,
        "/",
        11
      ]
    },
    {
      "id": 2078,
      "bciAvId": 15720,
      "gloss": "nipple(s)",
      "glossSv": "bröstvårtor",
      "pos": "noun",
      "explanation": "part of + breasts",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        181
      ]
    },
    {
      "id": 2079,
      "bciAvId": 15721,
      "gloss": "Nisan, Nissan",
      "glossSv": "Nissan (Israel)",
      "pos": "noun",
      "explanation": "month + unleavened bread: month of Passover, the first month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        180,
        "/",
        957
      ]
    },
    {
      "id": 2080,
      "bciAvId": 15722,
      "gloss": "no - (exclamatory)",
      "glossSv": "nej",
      "pos": "function",
      "explanation": "not + intensity: strong negative response",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2081,
      "bciAvId": 15723,
      "gloss": "no one, nobody",
      "glossSv": "ingen",
      "pos": "person",
      "explanation": "minus + person",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        513
      ]
    },
    {
      "id": 2082,
      "bciAvId": 15724,
      "gloss": "nocturnal emission, wet dream",
      "glossSv": "utlösning i sömnen",
      "pos": "noun",
      "explanation": "ejaculation + to sleep",
      "isCharacter": false,
      "composition": [
        295,
        "/",
        612,
        "/",
        401,
        "/",
        599
      ]
    },
    {
      "id": 2083,
      "bciAvId": 15725,
      "gloss": "none, nothing",
      "glossSv": "ingen, inget, ingenting (FD)",
      "pos": "expression",
      "explanation": "opposite meaning + all",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        117
      ]
    },
    {
      "id": 2084,
      "bciAvId": 15727,
      "gloss": "nonsense - (exclamatory)",
      "glossSv": "dumheter",
      "pos": "function",
      "explanation": "nonsense + intensity symbol: exclamation",
      "isCharacter": false,
      "composition": [
        471,
        "/",
        401
      ]
    },
    {
      "id": 2085,
      "bciAvId": 15728,
      "gloss": "nonspeaking",
      "glossSv": "stum",
      "pos": "description",
      "explanation": "no speech,anarthria + description indicator: unable to speak",
      "isCharacter": false,
      "composition": [
        1062,
        ";",
        86
      ]
    },
    {
      "id": 2086,
      "bciAvId": 15729,
      "gloss": "nor",
      "glossSv": "eller, varken eller",
      "pos": "expression",
      "explanation": "minus + or",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        488
      ]
    },
    {
      "id": 2087,
      "bciAvId": 15731,
      "gloss": "northern",
      "glossSv": "nordlig",
      "pos": "description",
      "explanation": "north + description indicator",
      "isCharacter": false,
      "composition": [
        472,
        ";",
        86
      ]
    },
    {
      "id": 2088,
      "bciAvId": 15733,
      "gloss": "not, negative, no, don't, doesn't",
      "glossSv": "inte, negativ",
      "pos": "expression",
      "explanation": "minus + intensity: also used before a verb to create a negative sentence",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        401
      ]
    },
    {
      "id": 2089,
      "bciAvId": 15734,
      "gloss": "notebook, writing book",
      "glossSv": "anteckningsbok, skrivbok",
      "pos": "noun",
      "explanation": "book + to write",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        509
      ]
    },
    {
      "id": 2090,
      "bciAvId": 15735,
      "gloss": "November",
      "glossSv": "november",
      "pos": "noun",
      "explanation": "month + 11: eleventh month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        10,
        "/",
        10
      ]
    },
    {
      "id": 2091,
      "bciAvId": 15738,
      "gloss": "nuclear energy",
      "glossSv": "kärnkraft, atomenergi",
      "pos": "noun",
      "explanation": "energy + nucleus: energy released by a nuclear reaction",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        477
      ]
    },
    {
      "id": 2092,
      "bciAvId": 15739,
      "gloss": "nuclear fallout, radioactive dust",
      "glossSv": "radioaktivt stoft",
      "pos": "noun",
      "explanation": "dust + nucleus",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        477
      ]
    },
    {
      "id": 2093,
      "bciAvId": 15905,
      "gloss": "nurse",
      "glossSv": "sjuksköterska",
      "pos": "person",
      "explanation": "person + to care for + medical: person who gives medical care",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        548,
        "/",
        958
      ]
    },
    {
      "id": 2094,
      "bciAvId": 15906,
      "gloss": "nut",
      "glossSv": "nöt",
      "pos": "noun",
      "explanation": "seed + tree: edible seed from a tree",
      "isCharacter": false,
      "composition": [
        584,
        "/",
        666
      ]
    },
    {
      "id": 2095,
      "bciAvId": 15907,
      "gloss": "to obey, to comply",
      "glossSv": "lyda",
      "pos": "action",
      "explanation": "to do + by + to guide + action indicator: to do something by the rules",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        195,
        "/",
        803
      ]
    },
    {
      "id": 2096,
      "bciAvId": 15908,
      "gloss": "to observe",
      "glossSv": "lägga märke till, observera",
      "pos": "action",
      "explanation": "observation + action indicator: to look at something thoughtfully",
      "isCharacter": false,
      "composition": [
        931,
        ";",
        81
      ]
    },
    {
      "id": 2097,
      "bciAvId": 15909,
      "gloss": "ocean, sea",
      "glossSv": "hav, ocean",
      "pos": "noun",
      "explanation": "much + much + water: large body of water",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 2098,
      "bciAvId": 15910,
      "gloss": "October",
      "glossSv": "oktober",
      "pos": "noun",
      "explanation": "month + 10: tenth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        10,
        "/",
        9
      ]
    },
    {
      "id": 2099,
      "bciAvId": 15911,
      "gloss": "office",
      "glossSv": "arbetsrum, kontor",
      "pos": "noun",
      "explanation": "room + work + pencil: room where work is done",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        711,
        "/",
        509
      ]
    },
    {
      "id": 2100,
      "bciAvId": 15913,
      "gloss": "often, frequent, frequently",
      "glossSv": "ofta",
      "pos": "description",
      "explanation": "many + time + description indicator: on many occasions",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 2101,
      "bciAvId": 15915,
      "gloss": "old (opposite new)",
      "glossSv": "gammal (FD)",
      "pos": "description",
      "explanation": "opposite meaning + new + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        1061,
        ";",
        86
      ]
    },
    {
      "id": 2102,
      "bciAvId": 15916,
      "gloss": "old, elderly",
      "glossSv": "gammal, äldre (motsats ung)",
      "pos": "description",
      "explanation": "opposite meaning + young + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        220,
        ";",
        86
      ]
    },
    {
      "id": 2103,
      "bciAvId": 15919,
      "gloss": "once",
      "glossSv": "en gång",
      "pos": "description",
      "explanation": "1 + time + description indicator: on one occasion",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 2104,
      "bciAvId": 15921,
      "gloss": "open",
      "glossSv": "öppen",
      "pos": "description",
      "explanation": "opening + description indicator",
      "isCharacter": false,
      "composition": [
        484,
        ";",
        86
      ]
    },
    {
      "id": 2105,
      "bciAvId": 15922,
      "gloss": "to open",
      "glossSv": "öppna",
      "pos": "action",
      "explanation": "opening + action indicator",
      "isCharacter": false,
      "composition": [
        484,
        ";",
        81
      ]
    },
    {
      "id": 2106,
      "bciAvId": 15924,
      "gloss": "operation",
      "glossSv": "operation",
      "pos": "noun",
      "explanation": "to cut + medical",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        958
      ]
    },
    {
      "id": 2107,
      "bciAvId": 15926,
      "gloss": "opossum, possum",
      "glossSv": "opossum, pungråtta",
      "pos": "noun",
      "explanation": "marsupial (animal) + night: marsupial that comes out at night",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        239,
        "/",
        470
      ]
    },
    {
      "id": 2108,
      "bciAvId": 15930,
      "gloss": "oral sex",
      "glossSv": "munsex, oralt samlag",
      "pos": "noun",
      "explanation": "to combine + genitals + mouth",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        349,
        "/",
        457
      ]
    },
    {
      "id": 2109,
      "bciAvId": 15931,
      "gloss": "orange (bci)",
      "glossSv": "orange",
      "pos": "expression",
      "explanation": "colour + mouth + sun: combination of red and yellow",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        457,
        "/",
        636
      ]
    },
    {
      "id": 2110,
      "bciAvId": 15932,
      "gloss": "orange (ckb)",
      "glossSv": "orange (CKB)",
      "pos": "expression",
      "explanation": "colour + 2",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        11
      ]
    },
    {
      "id": 2111,
      "bciAvId": 15934,
      "gloss": "orchard",
      "glossSv": "fruktträdgård",
      "pos": "noun",
      "explanation": "grove + fruit",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        666,
        "/",
        338
      ]
    },
    {
      "id": 2112,
      "bciAvId": 15935,
      "gloss": "to organise, to organize, to arrange",
      "glossSv": "ordna, organisera",
      "pos": "action",
      "explanation": "to plan + many + thing + action indicator: to make a system from many things",
      "isCharacter": false,
      "composition": [
        532,
        ";",
        81,
        "/",
        368,
        "/",
        651
      ]
    },
    {
      "id": 2113,
      "bciAvId": 15936,
      "gloss": "orgasm",
      "glossSv": "orgasm",
      "pos": "noun",
      "explanation": "ecstasy + genitals",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        401,
        "/",
        401,
        "/",
        401,
        "/",
        349
      ]
    },
    {
      "id": 2114,
      "bciAvId": 15937,
      "gloss": "ostrich",
      "glossSv": "struts",
      "pos": "noun",
      "explanation": "bird + to walk: bird that walks or runs but does not fly",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        418
      ]
    },
    {
      "id": 2115,
      "bciAvId": 15938,
      "gloss": "other, another (person)",
      "glossSv": "annan (person)",
      "pos": "person",
      "explanation": "person [modification] + 2: referring to a second person",
      "isCharacter": true
    },
    {
      "id": 2116,
      "bciAvId": 15939,
      "gloss": "our, ours - (feminine)",
      "glossSv": "vår, vårt, våra (fem.)",
      "pos": "person",
      "explanation": "female + 1 + belongs to + plural indicator: first person plural (f.), possessive",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2117,
      "bciAvId": 15940,
      "gloss": "our, ours - (masculine)",
      "glossSv": "vår, vårt, våra (mask.)",
      "pos": "person",
      "explanation": "male + 1 + belongs to + plural indicator: first person plural (m.), possessive",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2118,
      "bciAvId": 15941,
      "gloss": "our, ours",
      "glossSv": "vår, vårt, våra",
      "pos": "person",
      "explanation": "we + belongs to + plural indicator: first person plural, possessive",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        10,
        "/",
        160
      ]
    },
    {
      "id": 2119,
      "bciAvId": 15945,
      "gloss": "outing, excursion",
      "glossSv": "utflykt, utfärd",
      "pos": "noun",
      "explanation": "legs and feet + out of",
      "isCharacter": false,
      "composition": [
        418,
        "/",
        491
      ]
    },
    {
      "id": 2120,
      "bciAvId": 15946,
      "gloss": "oval, ellipse (shape)",
      "glossSv": "oval, ellips",
      "pos": "noun",
      "explanation": "shape + oval",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        842
      ]
    },
    {
      "id": 2121,
      "bciAvId": 15947,
      "gloss": "ovary",
      "glossSv": "äggstock",
      "pos": "noun",
      "explanation": "container + egg",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        285
      ]
    },
    {
      "id": 2122,
      "bciAvId": 15949,
      "gloss": "owl, night bird",
      "glossSv": "uggla, uv",
      "pos": "noun",
      "explanation": "bird + night",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        470
      ]
    },
    {
      "id": 2123,
      "bciAvId": 15950,
      "gloss": "to own, to possess",
      "glossSv": "äga",
      "pos": "action",
      "explanation": "ownership,possession + action indicator: CKB writes \"an addition, a gain, a plus of some very earthly (material) thing”",
      "isCharacter": false,
      "composition": [
        959,
        ";",
        81
      ]
    },
    {
      "id": 2124,
      "bciAvId": 15951,
      "gloss": "ox",
      "glossSv": "oxe",
      "pos": "noun",
      "explanation": "bovine + work: horned animal commonly used to assist with heavy labour",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        711
      ]
    },
    {
      "id": 2125,
      "bciAvId": 15954,
      "gloss": "pain, suffering",
      "glossSv": "smärta",
      "pos": "noun",
      "explanation": "feeling + sick: discomfort that makes one \"draw up one's knees\". The symbol usually represents physical pain but also can be used to represent emotional distress and suffering.",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 2126,
      "bciAvId": 15955,
      "gloss": "painful, painfully, sore",
      "glossSv": "ont, smärtsam",
      "pos": "description",
      "explanation": "pain + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 2127,
      "bciAvId": 15956,
      "gloss": "paint, dye",
      "glossSv": "färg (målarfärg etc)",
      "pos": "noun",
      "explanation": "chemical product + colour + liquid",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        1161,
        "/",
        695
      ]
    },
    {
      "id": 2128,
      "bciAvId": 15957,
      "gloss": "to paint, to dye",
      "glossSv": "måla, färga",
      "pos": "action",
      "explanation": "paint + action indicator",
      "isCharacter": false,
      "composition": [
        216,
        ";",
        81,
        "/",
        1161,
        "/",
        695
      ]
    },
    {
      "id": 2129,
      "bciAvId": 15958,
      "gloss": "painter",
      "glossSv": "målare",
      "pos": "person",
      "explanation": "person + paint [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1161,
        "/",
        695
      ]
    },
    {
      "id": 2130,
      "bciAvId": 15959,
      "gloss": "pair",
      "glossSv": "par (ej mänskligt)",
      "pos": "noun",
      "explanation": "2 + thing indicator: two items",
      "isCharacter": false,
      "composition": [
        11,
        ";",
        97
      ]
    },
    {
      "id": 2131,
      "bciAvId": 15961,
      "gloss": "pants, jeans, slacks, trousers",
      "glossSv": "byxor, jeans",
      "pos": "noun",
      "explanation": "clothing + leg: clothing that covers the legs",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        417
      ]
    },
    {
      "id": 2132,
      "bciAvId": 15963,
      "gloss": "parakeet, budgie",
      "glossSv": "undulat (etc)",
      "pos": "noun",
      "explanation": "parrot + little: small bird that can be trained to talk",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        "RK:-2",
        "/",
        457,
        "/",
        5,
        "/",
        956
      ]
    },
    {
      "id": 2133,
      "bciAvId": 15965,
      "gloss": "paratrooper",
      "glossSv": "fallskärmsjägare",
      "pos": "person",
      "explanation": "soldier + from sky: soldier trained to jump down from the sky using a parachute",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        693,
        "/",
        1040
      ]
    },
    {
      "id": 2134,
      "bciAvId": 15967,
      "gloss": "pardon, what did you say",
      "glossSv": "hur sa, vad",
      "pos": "function",
      "explanation": "what,question mark + to say + action indicator",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        457,
        ";",
        81
      ]
    },
    {
      "id": 2135,
      "bciAvId": 15970,
      "gloss": "parrot, myna, talking bird",
      "glossSv": "papegoja",
      "pos": "noun",
      "explanation": "bird + to talk: bird that can be trained to talk",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        "RK:-2",
        "/",
        457
      ]
    },
    {
      "id": 2136,
      "bciAvId": 15971,
      "gloss": "parsnip",
      "glossSv": "palsternacka",
      "pos": "noun",
      "explanation": "vegetable (wedge-shaped) + white: vegetable with a long, white, edible root",
      "isCharacter": false,
      "composition": [
        203,
        "/",
        1161,
        "/",
        604
      ]
    },
    {
      "id": 2137,
      "bciAvId": 15973,
      "gloss": "party",
      "glossSv": "fest, kalas",
      "pos": "noun",
      "explanation": "gathering + happy",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2138,
      "bciAvId": 15974,
      "gloss": "Passover",
      "glossSv": "Passover (Israel)",
      "pos": "noun",
      "explanation": "week + bread + low: the week when unleavened bread, matzo, is eaten",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        180,
        "/",
        957
      ]
    },
    {
      "id": 2139,
      "bciAvId": 15976,
      "gloss": "patience",
      "glossSv": "tålamod",
      "pos": "noun",
      "explanation": "ability + to wait",
      "isCharacter": false,
      "composition": [
        101,
        "/",
        292,
        "/",
        426
      ]
    },
    {
      "id": 2140,
      "bciAvId": 15977,
      "gloss": "to be patient",
      "glossSv": "ha tålamod",
      "pos": "action",
      "explanation": "patience + action indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        81,
        "/",
        292,
        "/",
        426
      ]
    },
    {
      "id": 2141,
      "bciAvId": 15979,
      "gloss": "to pay, to spend",
      "glossSv": "betala",
      "pos": "action",
      "explanation": "to give + money + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        451
      ]
    },
    {
      "id": 2142,
      "bciAvId": 15980,
      "gloss": "peace (opposite war)",
      "glossSv": "fred",
      "pos": "noun",
      "explanation": "opposite meaning + war",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        693
      ]
    },
    {
      "id": 2143,
      "bciAvId": 15982,
      "gloss": "peaceful, serene, calm",
      "glossSv": "lugn, fridfull",
      "pos": "description",
      "explanation": "peace + description indicator",
      "isCharacter": false,
      "composition": [
        505,
        ";",
        86
      ]
    },
    {
      "id": 2144,
      "bciAvId": 15984,
      "gloss": "peacock",
      "glossSv": "påfågel",
      "pos": "noun",
      "explanation": "bird + fan: bird with a tail that opens like a fan",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        310
      ]
    },
    {
      "id": 2145,
      "bciAvId": 15985,
      "gloss": "peanut butter",
      "glossSv": "jordnötssmör",
      "pos": "noun",
      "explanation": "spread + seed",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        584
      ]
    },
    {
      "id": 2146,
      "bciAvId": 15988,
      "gloss": "peel",
      "glossSv": "skal",
      "pos": "noun",
      "explanation": "protection + fruit",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        338
      ]
    },
    {
      "id": 2147,
      "bciAvId": 15989,
      "gloss": "to peel",
      "glossSv": "skala",
      "pos": "action",
      "explanation": "to remove + peel + action indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        548,
        "/",
        338
      ]
    },
    {
      "id": 2148,
      "bciAvId": 15990,
      "gloss": "pelican",
      "glossSv": "pelikan",
      "pos": "noun",
      "explanation": "water bird + pouch: water bird with a pouch-shaped bill",
      "isCharacter": false,
      "composition": [
        164,
        "/",
        239
      ]
    },
    {
      "id": 2149,
      "bciAvId": 15992,
      "gloss": "to penetrate, to go through",
      "glossSv": "gå igenom",
      "pos": "action",
      "explanation": "through + action indicator",
      "isCharacter": false,
      "composition": [
        653,
        ";",
        81
      ]
    },
    {
      "id": 2150,
      "bciAvId": 15993,
      "gloss": "penguin",
      "glossSv": "pingvin",
      "pos": "noun",
      "explanation": "water bird + to walk: water bird that walks",
      "isCharacter": false,
      "composition": [
        164,
        "/",
        418
      ]
    },
    {
      "id": 2151,
      "bciAvId": 15996,
      "gloss": "pepper (seasoning)",
      "glossSv": "peppar",
      "pos": "noun",
      "explanation": "adding,additive + taste + fire: combination of seasoning and hot + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        319
      ]
    },
    {
      "id": 2152,
      "bciAvId": 15997,
      "gloss": "perfume, fragrance, aroma, scent",
      "glossSv": "parfym",
      "pos": "noun",
      "explanation": "smell + happy: pleasant smell",
      "isCharacter": false,
      "composition": [
        600,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2153,
      "bciAvId": 16168,
      "gloss": "pet",
      "glossSv": "sällskapsdjur",
      "pos": "noun",
      "explanation": "animal + feeling: animal for which one has feeling",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        313
      ]
    },
    {
      "id": 2154,
      "bciAvId": 16169,
      "gloss": "photograph, photo, pic",
      "glossSv": "foto, kort",
      "pos": "noun",
      "explanation": "paper + camera",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        198
      ]
    },
    {
      "id": 2155,
      "bciAvId": 16170,
      "gloss": "disabled, handicapped (physically)",
      "glossSv": "rörelsehindrad (FD)",
      "pos": "description",
      "explanation": "limit(s),limitation (OLD) + body + description indicator: having limits to one's physical abilities",
      "isCharacter": false,
      "composition": [
        427,
        ";",
        86,
        "/",
        171
      ]
    },
    {
      "id": 2156,
      "bciAvId": 16171,
      "gloss": "picnic",
      "glossSv": "picknick",
      "pos": "noun",
      "explanation": "food + outside: food eaten outside",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        490
      ]
    },
    {
      "id": 2157,
      "bciAvId": 16172,
      "gloss": "picture, image, icon, painting",
      "glossSv": "bild, tavla",
      "pos": "noun",
      "explanation": "eye + enclosure: what the eyes see in a frame",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291
      ]
    },
    {
      "id": 2158,
      "bciAvId": 16173,
      "gloss": "pie, tart",
      "glossSv": "paj",
      "pos": "noun",
      "explanation": "food + protection: food with a crust covering it",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        548
      ]
    },
    {
      "id": 2159,
      "bciAvId": 16176,
      "gloss": "pill, tablet",
      "glossSv": "tablett, piller",
      "pos": "noun",
      "explanation": "disc + medical: medicine in disc form",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        958
      ]
    },
    {
      "id": 2160,
      "bciAvId": 16178,
      "gloss": "pillowcase",
      "glossSv": "örngott, kuddvar",
      "pos": "noun",
      "explanation": "cloth + pillow",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        522
      ]
    },
    {
      "id": 2161,
      "bciAvId": 16179,
      "gloss": "pilot",
      "glossSv": "pilot",
      "pos": "person",
      "explanation": "person + airplane",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        115
      ]
    },
    {
      "id": 2162,
      "bciAvId": 16183,
      "gloss": "table tennis, ping-pong (activity)",
      "glossSv": "bordtennis (aktivitet) (FD)",
      "pos": "noun",
      "explanation": "tennis (activity) (OLD) + table: game like tennis, played on a table",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1016,
        "/",
        639
      ]
    },
    {
      "id": 2163,
      "bciAvId": 16184,
      "gloss": "pink (bci)",
      "glossSv": "rosa",
      "pos": "expression",
      "explanation": "colour + mouth + sun: combination of red and white",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        457,
        "/",
        604
      ]
    },
    {
      "id": 2164,
      "bciAvId": 16185,
      "gloss": "pink (ckb)",
      "glossSv": "rosa (CKB)",
      "pos": "expression",
      "explanation": "colour + 1 + sun: combination of red and white",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        10,
        "/",
        636
      ]
    },
    {
      "id": 2165,
      "bciAvId": 16189,
      "gloss": "to pit, to stone",
      "glossSv": "kärna ur",
      "pos": "action",
      "explanation": "to remove + pit + action indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        528
      ]
    },
    {
      "id": 2166,
      "bciAvId": 16192,
      "gloss": "pizza",
      "glossSv": "pizza",
      "pos": "noun",
      "explanation": "food + pizza slice(s),sector(s),circle sector(s)",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        1068
      ]
    },
    {
      "id": 2167,
      "bciAvId": 16195,
      "gloss": "to plan, to design",
      "glossSv": "planera",
      "pos": "action",
      "explanation": "plan + action indicator",
      "isCharacter": false,
      "composition": [
        532,
        ";",
        81
      ]
    },
    {
      "id": 2168,
      "bciAvId": 16197,
      "gloss": "plastic",
      "glossSv": "plast",
      "pos": "noun",
      "explanation": "chemical product + many + shape: chemical product that can be formed into many shapes",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        368,
        "/",
        303,
        "/",
        651
      ]
    },
    {
      "id": 2169,
      "bciAvId": 16199,
      "gloss": "play, recreation",
      "glossSv": "lek",
      "pos": "noun",
      "explanation": "activity + happy",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2170,
      "bciAvId": 16200,
      "gloss": "to play",
      "glossSv": "leka",
      "pos": "action",
      "explanation": "play + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2171,
      "bciAvId": 16201,
      "gloss": "to play football",
      "glossSv": "spela fotboll",
      "pos": "action",
      "explanation": "football,soccer (activity) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 2172,
      "bciAvId": 16202,
      "gloss": "playground",
      "glossSv": "lekplats",
      "pos": "noun",
      "explanation": "place + to play",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2173,
      "bciAvId": 16203,
      "gloss": "playroom, family room, recreation room",
      "glossSv": "lekrum",
      "pos": "noun",
      "explanation": "room + to play",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2174,
      "bciAvId": 16204,
      "gloss": "please",
      "glossSv": "var snäll, var så god",
      "pos": "function",
      "explanation": "command + feeling: polite command",
      "isCharacter": false,
      "composition": [
        401,
        "/",
        313
      ]
    },
    {
      "id": 2175,
      "bciAvId": 16207,
      "gloss": "plug",
      "glossSv": "elkontakt",
      "pos": "noun",
      "explanation": "into + electricity + thing indicator: fitting inserted into an electrical socket",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        97,
        "/",
        288
      ]
    },
    {
      "id": 2176,
      "bciAvId": 16209,
      "gloss": "pocket",
      "glossSv": "ficka",
      "pos": "noun",
      "explanation": "container + clothing: container sewn into an article of clothing",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        229
      ]
    },
    {
      "id": 2177,
      "bciAvId": 16210,
      "gloss": "poem",
      "glossSv": "dikt",
      "pos": "noun",
      "explanation": "page + poetry",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        1059,
        "/",
        313
      ]
    },
    {
      "id": 2178,
      "bciAvId": 16211,
      "gloss": "poetry",
      "glossSv": "poesi",
      "pos": "noun",
      "explanation": "metaphor (winged) + feeling: \"winged speech\", which appeals to the emotions",
      "isCharacter": false,
      "composition": [
        1059,
        "/",
        313
      ]
    },
    {
      "id": 2179,
      "bciAvId": 16213,
      "gloss": "to point, to indicate",
      "glossSv": "peka",
      "pos": "action",
      "explanation": "pointer + action indicator",
      "isCharacter": false,
      "composition": [
        844,
        ";",
        81
      ]
    },
    {
      "id": 2180,
      "bciAvId": 16214,
      "gloss": "point of view",
      "glossSv": "ståndpunkt",
      "pos": "noun",
      "explanation": "mind + position: rational position in regard to something",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        540
      ]
    },
    {
      "id": 2181,
      "bciAvId": 16215,
      "gloss": "poison",
      "glossSv": "gift",
      "pos": "noun",
      "explanation": "chemical product + death: chemical product that kills",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        259
      ]
    },
    {
      "id": 2182,
      "bciAvId": 16216,
      "gloss": "polenta",
      "glossSv": "mat av majsmjöl, polenta",
      "pos": "noun",
      "explanation": "food + cornmeal: dish made with cornmeal",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        240
      ]
    },
    {
      "id": 2183,
      "bciAvId": 16217,
      "gloss": "police officer, policeman, policewoman",
      "glossSv": "polis",
      "pos": "person",
      "explanation": "person + protection: Note: (The similarity between police and parent, and the lacking aspect of law enforcement, can be seen as problematic.)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        548
      ]
    },
    {
      "id": 2184,
      "bciAvId": 16218,
      "gloss": "pollution",
      "glossSv": "förorening, miljöförstöring",
      "pos": "noun",
      "explanation": "waste + environment: waste products that spoil the environment",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        294
      ]
    },
    {
      "id": 2185,
      "bciAvId": 16220,
      "gloss": "poor (little money)",
      "glossSv": "fattig (utan pengar)",
      "pos": "description",
      "explanation": "without + money + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        451,
        ";",
        86
      ]
    },
    {
      "id": 2186,
      "bciAvId": 16221,
      "gloss": "popcorn",
      "glossSv": "popcorn",
      "pos": "noun",
      "explanation": "corn + to jump: corn that jumps as it cooks",
      "isCharacter": false,
      "composition": [
        240,
        "/",
        836
      ]
    },
    {
      "id": 2187,
      "bciAvId": 16222,
      "gloss": "porcupine",
      "glossSv": "piggsvin (FD)",
      "pos": "noun",
      "explanation": "hedgehog (OLD) + teeth: combination of rodent + pictograph of spines (OLD)",
      "isCharacter": false,
      "composition": [
        379,
        "/",
        644
      ]
    },
    {
      "id": 2188,
      "bciAvId": 16223,
      "gloss": "pork, ham",
      "glossSv": "fläskkött",
      "pos": "noun",
      "explanation": "food + pig: food that comes from a pig. The symbol also can be explained as a combination of meat and pig.",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        521
      ]
    },
    {
      "id": 2189,
      "bciAvId": 16225,
      "gloss": "positive",
      "glossSv": "gärna, positiv",
      "pos": "expression",
      "explanation": "plus + intensity",
      "isCharacter": false,
      "composition": [
        120,
        "/",
        401
      ]
    },
    {
      "id": 2190,
      "bciAvId": 16226,
      "gloss": "maybe, perhaps, possibly",
      "glossSv": "kanske, möjligen, eventuellt",
      "pos": "description",
      "explanation": "possibility + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        85,
        "/",
        699
      ]
    },
    {
      "id": 2191,
      "bciAvId": 16228,
      "gloss": "post office",
      "glossSv": "postkontor",
      "pos": "noun",
      "explanation": "building + letter: building where mail is processed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        421
      ]
    },
    {
      "id": 2192,
      "bciAvId": 16230,
      "gloss": "potato",
      "glossSv": "potatis",
      "pos": "noun",
      "explanation": "vegetable (below ground) + white: starchy, white tuber",
      "isCharacter": false,
      "composition": [
        685,
        "/",
        1161,
        "/",
        604
      ]
    },
    {
      "id": 2193,
      "bciAvId": 16231,
      "gloss": "potato chips, crisps",
      "glossSv": "chips (FD)",
      "pos": "noun",
      "explanation": "potato + disc + plural indicator: potatoes cut in disc shapes",
      "isCharacter": false,
      "composition": [
        685,
        ";",
        99,
        "/",
        1161,
        "/",
        604,
        "/",
        263
      ]
    },
    {
      "id": 2194,
      "bciAvId": 16235,
      "gloss": "to practise, to practice, to drill, to exercise, to rehearse",
      "glossSv": "öva",
      "pos": "action",
      "explanation": "to work + repetition + action indicator: to work at something repeatedly",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81,
        "/",
        963
      ]
    },
    {
      "id": 2195,
      "bciAvId": 16236,
      "gloss": "to pray",
      "glossSv": "bedja",
      "pos": "action",
      "explanation": "prayer + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        657,
        "/",
        355
      ]
    },
    {
      "id": 2196,
      "bciAvId": 16237,
      "gloss": "prayer",
      "glossSv": "bön",
      "pos": "noun",
      "explanation": "to speak + to,toward,towards + God: talking to God",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        657,
        "/",
        355
      ]
    },
    {
      "id": 2197,
      "bciAvId": 16238,
      "gloss": "prayer book, Siddur",
      "glossSv": "bönbok",
      "pos": "noun",
      "explanation": "book + prayer",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        457,
        "/",
        657,
        "/",
        355
      ]
    },
    {
      "id": 2198,
      "bciAvId": 16239,
      "gloss": "preceding",
      "glossSv": "föregående (FD)",
      "pos": "description",
      "explanation": "opposite meaning + next + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        10,
        ";",
        86,
        "/",
        4,
        "/",
        109
      ]
    },
    {
      "id": 2199,
      "bciAvId": 16240,
      "gloss": "pregnancy",
      "glossSv": "graviditet, havandeskap",
      "pos": "noun",
      "explanation": "conception + woman",
      "isCharacter": false,
      "composition": [
        236,
        "/",
        710
      ]
    },
    {
      "id": 2200,
      "bciAvId": 16241,
      "gloss": "pregnant",
      "glossSv": "gravid",
      "pos": "description",
      "explanation": "pregnancy + description indicator",
      "isCharacter": false,
      "composition": [
        236,
        ";",
        86,
        "/",
        710
      ]
    },
    {
      "id": 2201,
      "bciAvId": 16242,
      "gloss": "pregnant (ckb)",
      "glossSv": "gravid (CKB)",
      "pos": "description",
      "explanation": "before + birth + description indicator: woman's condition before she bears a child",
      "isCharacter": false,
      "composition": [
        158,
        "/",
        166,
        ";",
        86
      ]
    },
    {
      "id": 2202,
      "bciAvId": 16243,
      "gloss": "premature birth",
      "glossSv": "för tidig födsel",
      "pos": "noun",
      "explanation": "birth + early",
      "isCharacter": false,
      "composition": [
        165,
        "/",
        158,
        "/",
        655
      ]
    },
    {
      "id": 2203,
      "bciAvId": 16244,
      "gloss": "to prepare, to set, to set up, to ready, to gear up, to fix",
      "glossSv": "förbereda",
      "pos": "action",
      "explanation": "preparation,readying,readiness,preparedness + action indicator: to do something in order to be ready for the future",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        332,
        "/",
        341
      ]
    },
    {
      "id": 2204,
      "bciAvId": 16245,
      "gloss": "to prepare food, to cook",
      "glossSv": "laga mat, tillaga",
      "pos": "action",
      "explanation": "cooking,cookery,preparation (general) + action indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        329
      ]
    },
    {
      "id": 2205,
      "bciAvId": 16247,
      "gloss": "to pretend, to make believe",
      "glossSv": "låtsas, fantisera",
      "pos": "action",
      "explanation": "fantasy + action indicator: to let one's mind soar into the sky, or up into the clouds",
      "isCharacter": false,
      "composition": [
        945,
        ";",
        81
      ]
    },
    {
      "id": 2206,
      "bciAvId": 16250,
      "gloss": "prison, jail",
      "glossSv": "fängelse",
      "pos": "noun",
      "explanation": "building + barred window: building where people are put behind bars",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        707
      ]
    },
    {
      "id": 2207,
      "bciAvId": 16251,
      "gloss": "private",
      "glossSv": "privat",
      "pos": "description",
      "explanation": "to close + public + description indicator",
      "isCharacter": false,
      "composition": [
        291,
        ";",
        86,
        "/",
        368,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 2208,
      "bciAvId": 16252,
      "gloss": "probable, likely, probably",
      "glossSv": "trolig, tänkbar",
      "pos": "description",
      "explanation": "to doubt + plus + description before the fact indicator: in doubt, but tending towards the positive",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        85,
        "/",
        120
      ]
    },
    {
      "id": 2209,
      "bciAvId": 16253,
      "gloss": "problem",
      "glossSv": "problem",
      "pos": "noun",
      "explanation": "question + difficult: difficult question to solve",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        940
      ]
    },
    {
      "id": 2210,
      "bciAvId": 16417,
      "gloss": "to promise, to pledge",
      "glossSv": "lova",
      "pos": "action",
      "explanation": "promise + action indicator: to say that something will be done in the future",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        106,
        "/",
        341
      ]
    },
    {
      "id": 2211,
      "bciAvId": 16418,
      "gloss": "prostitution",
      "glossSv": "prostitution",
      "pos": "noun",
      "explanation": "sexual intercourse + money",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        349,
        "/",
        451
      ]
    },
    {
      "id": 2212,
      "bciAvId": 16419,
      "gloss": "to protect, to cover, to shelter, to take care of",
      "glossSv": "skydda, beskydda",
      "pos": "action",
      "explanation": "protection + action indicator",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        81
      ]
    },
    {
      "id": 2213,
      "bciAvId": 16421,
      "gloss": "to protest, to object, to oppose",
      "glossSv": "protestera, säga emot",
      "pos": "action",
      "explanation": "to say + against + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        111
      ]
    },
    {
      "id": 2214,
      "bciAvId": 16422,
      "gloss": "proud",
      "glossSv": "stolt, överlägsen",
      "pos": "description",
      "explanation": "feeling + above + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        493
      ]
    },
    {
      "id": 2215,
      "bciAvId": 16423,
      "gloss": "province, county, region, state",
      "glossSv": "landskap, län",
      "pos": "noun",
      "explanation": "part of + country",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        243
      ]
    },
    {
      "id": 2216,
      "bciAvId": 16424,
      "gloss": "prune",
      "glossSv": "katrinplommon (FD)",
      "pos": "noun",
      "explanation": "plum + dry (OLD)",
      "isCharacter": false,
      "composition": [
        537,
        "/",
        486,
        "/",
        695
      ]
    },
    {
      "id": 2217,
      "bciAvId": 16425,
      "gloss": "puberty",
      "glossSv": "pubertet",
      "pos": "noun",
      "explanation": "awake + sexuality",
      "isCharacter": false,
      "composition": [
        969,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        347
      ]
    },
    {
      "id": 2218,
      "bciAvId": 16427,
      "gloss": "public (of the public)",
      "glossSv": "allmän",
      "pos": "description",
      "explanation": "public (the public) + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        513,
        ";",
        86
      ]
    },
    {
      "id": 2219,
      "bciAvId": 16428,
      "gloss": "public (not private)",
      "glossSv": "offentlig",
      "pos": "description",
      "explanation": "open + public + description indicator",
      "isCharacter": false,
      "composition": [
        484,
        ";",
        86,
        "/",
        368,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 2220,
      "bciAvId": 16429,
      "gloss": "public (the public)",
      "glossSv": "allmänheten, folk",
      "pos": "person",
      "explanation": "many + many + person: large group of people",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 2221,
      "bciAvId": 16431,
      "gloss": "to pull, to drag, to tow, to tug",
      "glossSv": "dra",
      "pos": "action",
      "explanation": "pull,pulling + action indicator: the forward moving arrow seems to be pulling the thing",
      "isCharacter": false,
      "composition": [
        1073,
        ";",
        81
      ]
    },
    {
      "id": 2222,
      "bciAvId": 16432,
      "gloss": "to puncture, to prick",
      "glossSv": "sticka, sticka hål, punktera",
      "pos": "action",
      "explanation": "point + action indicator",
      "isCharacter": false,
      "composition": [
        538,
        ";",
        81
      ]
    },
    {
      "id": 2223,
      "bciAvId": 16433,
      "gloss": "puppet",
      "glossSv": "handdocka",
      "pos": "noun",
      "explanation": "doll + hand: doll manipulated by the hand",
      "isCharacter": false,
      "composition": [
        220,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 2224,
      "bciAvId": 16434,
      "gloss": "puppy",
      "glossSv": "valp",
      "pos": "noun",
      "explanation": "dog + baby",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        140
      ]
    },
    {
      "id": 2225,
      "bciAvId": 16435,
      "gloss": "Purim",
      "glossSv": "Purim (Israel)",
      "pos": "noun",
      "explanation": "holiday + megillah: the holiday on which megillah or story of Esther is read",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        313,
        "/",
        678,
        "/",
        1999
      ]
    },
    {
      "id": 2226,
      "bciAvId": 16436,
      "gloss": "purple, violet (bci)",
      "glossSv": "lila",
      "pos": "expression",
      "explanation": "colour + mouth + sky: combination of red and blue",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        457,
        "/",
        597
      ]
    },
    {
      "id": 2227,
      "bciAvId": 16438,
      "gloss": "purse, pocketbook, wallet",
      "glossSv": "plånbok, portmonnä",
      "pos": "noun",
      "explanation": "container + money + person: personal container for money",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        451,
        "/",
        513
      ]
    },
    {
      "id": 2228,
      "bciAvId": 16439,
      "gloss": "to push, to shove",
      "glossSv": "knuffa, skjuta på",
      "pos": "action",
      "explanation": "push,pushing + action indicator: the forward moving arrow seems to be pushing the thing",
      "isCharacter": false,
      "composition": [
        929,
        ";",
        81
      ]
    },
    {
      "id": 2229,
      "bciAvId": 16440,
      "gloss": "to put, to locate, to place",
      "glossSv": "lägga, ställa, sätta",
      "pos": "action",
      "explanation": "place + action indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81
      ]
    },
    {
      "id": 2230,
      "bciAvId": 16441,
      "gloss": "jigsaw puzzle",
      "glossSv": "pussel",
      "pos": "noun",
      "explanation": "picture + piece: picture made from many pieces",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        502
      ]
    },
    {
      "id": 2231,
      "bciAvId": 16442,
      "gloss": "pyjama(s), nightgown, nightie, pajama(s)",
      "glossSv": "nattdräkt, nattlinne, pyjamas",
      "pos": "noun",
      "explanation": "clothing + to sleep",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        599
      ]
    },
    {
      "id": 2232,
      "bciAvId": 16446,
      "gloss": "quick, fast, quickly, rapid, rapidly",
      "glossSv": "fort, snabb",
      "pos": "description",
      "explanation": "quickness,rapidity,speediness + description indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2233,
      "bciAvId": 16447,
      "gloss": "quiet, quietly",
      "glossSv": "tyst, ljudlös",
      "pos": "description",
      "explanation": "minus + loud + description indicator: absence of noise",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        608,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2234,
      "bciAvId": 16448,
      "gloss": "rabbit, hare",
      "glossSv": "hare, kanin",
      "pos": "noun",
      "explanation": "rodent + ear: animal known for its long ears",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        278
      ]
    },
    {
      "id": 2235,
      "bciAvId": 16449,
      "gloss": "rabies",
      "glossSv": "rabies",
      "pos": "noun",
      "explanation": "illness + animal + comma + to bite: viral nervous system illness of animals (including humans), usually spread by bite of infected animal",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        122,
        "/",
        5,
        "/",
        644
      ]
    },
    {
      "id": 2236,
      "bciAvId": 16450,
      "gloss": "raccoon",
      "glossSv": "tvättbjörn",
      "pos": "noun",
      "explanation": "animal + mask (disguise): animal with a dark band across the eyes, which resembles a mask",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        1056
      ]
    },
    {
      "id": 2237,
      "bciAvId": 16453,
      "gloss": "radio (1)",
      "glossSv": "radio (1)",
      "pos": "noun",
      "explanation": "enclosure + ear + electricity: box for hearing by means of electricity",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        278,
        "/",
        288
      ]
    },
    {
      "id": 2238,
      "bciAvId": 16454,
      "gloss": "radish",
      "glossSv": "rädisa",
      "pos": "noun",
      "explanation": "vegetable (large-leafed) + hot: large-leafed vegetable with a hot-tasting, edible root",
      "isCharacter": false,
      "composition": [
        671,
        "/",
        642,
        "/",
        319
      ]
    },
    {
      "id": 2239,
      "bciAvId": 16456,
      "gloss": "to rain",
      "glossSv": "regna",
      "pos": "action",
      "explanation": "rain + action indicator",
      "isCharacter": false,
      "composition": [
        556,
        ";",
        81
      ]
    },
    {
      "id": 2240,
      "bciAvId": 16457,
      "gloss": "raincoat",
      "glossSv": "regnkläder",
      "pos": "noun",
      "explanation": "clothing + rain",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        556
      ]
    },
    {
      "id": 2241,
      "bciAvId": 16458,
      "gloss": "rainy",
      "glossSv": "regnig",
      "pos": "description",
      "explanation": "rain + description indicator",
      "isCharacter": false,
      "composition": [
        556,
        ";",
        86
      ]
    },
    {
      "id": 2242,
      "bciAvId": 16459,
      "gloss": "to raise, to grow, to bring up, to cultivate",
      "glossSv": "odla",
      "pos": "action",
      "explanation": "to cause + to grow + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 2243,
      "bciAvId": 16460,
      "gloss": "raisins",
      "glossSv": "russin (FD)",
      "pos": "noun",
      "explanation": "grape,grapes + dry (OLD)",
      "isCharacter": false,
      "composition": [
        365,
        "/",
        486,
        "/",
        695
      ]
    },
    {
      "id": 2244,
      "bciAvId": 16461,
      "gloss": "rake",
      "glossSv": "kratta",
      "pos": "noun",
      "explanation": "comb + garden",
      "isCharacter": false,
      "composition": [
        231,
        "/",
        344
      ]
    },
    {
      "id": 2245,
      "bciAvId": 16462,
      "gloss": "rape",
      "glossSv": "våldtäkt",
      "pos": "noun",
      "explanation": "assault + sexual intercourse",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        232,
        "/",
        349
      ]
    },
    {
      "id": 2246,
      "bciAvId": 16464,
      "gloss": "raw, uncooked",
      "glossSv": "rå, okokt",
      "pos": "description",
      "explanation": "without + to cook + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        319,
        ";",
        86,
        "/",
        329
      ]
    },
    {
      "id": 2247,
      "bciAvId": 16465,
      "gloss": "to read",
      "glossSv": "läsa",
      "pos": "action",
      "explanation": "reading + action indicator: to see and perceive what is written on the printed page",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81,
        "/",
        497
      ]
    },
    {
      "id": 2248,
      "bciAvId": 16466,
      "gloss": "ready, prepared",
      "glossSv": "förberedd",
      "pos": "description",
      "explanation": "to prepare + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        84,
        "/",
        332,
        "/",
        341
      ]
    },
    {
      "id": 2249,
      "bciAvId": 16467,
      "gloss": "real, really",
      "glossSv": "verklig",
      "pos": "description",
      "explanation": "event,happening,occasion + description indicator: existing on earth",
      "isCharacter": false,
      "composition": [
        299,
        ";",
        86
      ]
    },
    {
      "id": 2250,
      "bciAvId": 16468,
      "gloss": "recent, recently",
      "glossSv": "nyss, nyligen",
      "pos": "description",
      "explanation": "past + near + description indicator: in the near past",
      "isCharacter": false,
      "composition": [
        503,
        ";",
        86,
        "/",
        1060
      ]
    },
    {
      "id": 2251,
      "bciAvId": 16469,
      "gloss": "recipe",
      "glossSv": "recept",
      "pos": "noun",
      "explanation": "page + to prepare food: written instructions for cooking",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        840,
        "/",
        329
      ]
    },
    {
      "id": 2252,
      "bciAvId": 16470,
      "gloss": "CD, record",
      "glossSv": "cd-skiva, grammofonskiva",
      "pos": "noun",
      "explanation": "recording disk + ear: represents music or sound in general, recorded on any kind of disk medium",
      "isCharacter": false,
      "composition": [
        1075,
        "/",
        278
      ]
    },
    {
      "id": 2253,
      "bciAvId": 16471,
      "gloss": "CD player, record player, stereo",
      "glossSv": "cd-spelare, skivspelare",
      "pos": "noun",
      "explanation": "machine + record",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        1075,
        "/",
        278
      ]
    },
    {
      "id": 2254,
      "bciAvId": 16472,
      "gloss": "rectangle, oblong (shape)",
      "glossSv": "rektangel",
      "pos": "noun",
      "explanation": "shape + rectangular shape [as of card]: rectangle, a geometric shape",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        824
      ]
    },
    {
      "id": 2255,
      "bciAvId": 16473,
      "gloss": "rectangular, oblong",
      "glossSv": "rektangulär, avlång",
      "pos": "description",
      "explanation": "rectangle + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        651,
        "/",
        824
      ]
    },
    {
      "id": 2256,
      "bciAvId": 16474,
      "gloss": "red (bci)",
      "glossSv": "röd",
      "pos": "expression",
      "explanation": "colour + mouth",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        457
      ]
    },
    {
      "id": 2257,
      "bciAvId": 16475,
      "gloss": "red (ckb)",
      "glossSv": "röd (CKB)",
      "pos": "expression",
      "explanation": "colour + 1",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        10
      ]
    },
    {
      "id": 2258,
      "bciAvId": 16476,
      "gloss": "refrigerator",
      "glossSv": "kylskåp, frys (FD)",
      "pos": "noun",
      "explanation": "cupboard + ice + electricity: electrically powered ice box",
      "isCharacter": false,
      "composition": [
        252,
        "/",
        394,
        "/",
        288
      ]
    },
    {
      "id": 2259,
      "bciAvId": 16477,
      "gloss": "to regret",
      "glossSv": "ångra",
      "pos": "action",
      "explanation": "sorry + action indicator: to feel sorry about something that occurred in the past",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        271,
        "/",
        102,
        "/",
        503
      ]
    },
    {
      "id": 2260,
      "bciAvId": 16478,
      "gloss": "reindeer, caribou",
      "glossSv": "ren (djuret)",
      "pos": "noun",
      "explanation": "cervine (animal) + north: animal common to Northern regions",
      "isCharacter": false,
      "composition": [
        125,
        "/",
        472
      ]
    },
    {
      "id": 2261,
      "bciAvId": 16483,
      "gloss": "religion, naturalism",
      "glossSv": "religion (FD)",
      "pos": "noun",
      "explanation": "feeling + creation: feeling in relation to creation",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        247
      ]
    },
    {
      "id": 2262,
      "bciAvId": 16484,
      "gloss": "religious",
      "glossSv": "religiös (FD)",
      "pos": "description",
      "explanation": "religion + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        247
      ]
    },
    {
      "id": 2263,
      "bciAvId": 16485,
      "gloss": "to remember",
      "glossSv": "komma ihåg, minnas (FD)",
      "pos": "action",
      "explanation": "opposite meaning + to forget + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        948,
        ";",
        81
      ]
    },
    {
      "id": 2264,
      "bciAvId": 16486,
      "gloss": "remembrance day",
      "glossSv": "minnesdag",
      "pos": "noun",
      "explanation": "day + to remember",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        486,
        "/",
        948
      ]
    },
    {
      "id": 2265,
      "bciAvId": 16487,
      "gloss": "to repeat, to copy, to duplicate, to reproduce",
      "glossSv": "upprepa, kopiera",
      "pos": "action",
      "explanation": "repetition,copying,duplication,replication + action indicator: the line is repeated",
      "isCharacter": false,
      "composition": [
        963,
        ";",
        81
      ]
    },
    {
      "id": 2266,
      "bciAvId": 16488,
      "gloss": "reproduction",
      "glossSv": "fortplantning",
      "pos": "noun",
      "explanation": "conception + to cause + baby",
      "isCharacter": false,
      "composition": [
        236,
        "/",
        206,
        "/",
        140
      ]
    },
    {
      "id": 2267,
      "bciAvId": 16489,
      "gloss": "to request",
      "glossSv": "be om, begära",
      "pos": "action",
      "explanation": "to ask + please + action indicator: to ask politely",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81,
        "/",
        401,
        "/",
        313
      ]
    },
    {
      "id": 2268,
      "bciAvId": 16490,
      "gloss": "to resent",
      "glossSv": "ta illa upp",
      "pos": "action",
      "explanation": "feeling + against + action indicator: to harbour feelings against someone or something",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        111
      ]
    },
    {
      "id": 2269,
      "bciAvId": 16491,
      "gloss": "resident",
      "glossSv": "boende, bofast person",
      "pos": "person",
      "explanation": "person + house: person who lives in a house",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        392
      ]
    },
    {
      "id": 2270,
      "bciAvId": 16492,
      "gloss": "residential institution, group home, hostel, residential home",
      "glossSv": "gruppbostad, elevhem, internat",
      "pos": "noun",
      "explanation": "house + many + person: house in which a group of people live",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 2271,
      "bciAvId": 16493,
      "gloss": "resource centre",
      "glossSv": "resurscenter",
      "pos": "noun",
      "explanation": "building + for (the purpose of) + to exchange + knowledge: building where knowledge is given out and received",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        332,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 2272,
      "bciAvId": 16494,
      "gloss": "respect, admiration",
      "glossSv": "beundran, respekt",
      "pos": "noun",
      "explanation": "feeling + about + person + superior: feeling one has about a person who is superior",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        102,
        "/",
        513,
        "/",
        493
      ]
    },
    {
      "id": 2273,
      "bciAvId": 16496,
      "gloss": "to rest",
      "glossSv": "vila (verb)",
      "pos": "action",
      "explanation": "rest + action indicator",
      "isCharacter": false,
      "composition": [
        562,
        ";",
        81
      ]
    },
    {
      "id": 2274,
      "bciAvId": 16497,
      "gloss": "rest period, break",
      "glossSv": "rast, paus",
      "pos": "noun",
      "explanation": "limited time + rest",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        562
      ]
    },
    {
      "id": 2275,
      "bciAvId": 16498,
      "gloss": "restaurant, cafeteria",
      "glossSv": "restaurang, matställe",
      "pos": "noun",
      "explanation": "public room + to eat",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        329
      ]
    },
    {
      "id": 2276,
      "bciAvId": 16500,
      "gloss": "to return, to come back, to reverse",
      "glossSv": "komma tillbaka, återvända",
      "pos": "action",
      "explanation": "return + action indicator",
      "isCharacter": false,
      "composition": [
        563,
        ";",
        81
      ]
    },
    {
      "id": 2277,
      "bciAvId": 16502,
      "gloss": "rhyme",
      "glossSv": "rim",
      "pos": "noun",
      "explanation": "similar sound + end: the effect produced when words have a similar sound. The symbol applies particularly to ends of lines of poetry.",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        608,
        "/",
        292
      ]
    },
    {
      "id": 2278,
      "bciAvId": 16503,
      "gloss": "rhythm method",
      "glossSv": "säker period",
      "pos": "noun",
      "explanation": "birth control + month: birth control based upon a woman’s monthly cycle",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        236,
        "/",
        452
      ]
    },
    {
      "id": 2279,
      "bciAvId": 16504,
      "gloss": "ribbon, tape",
      "glossSv": "band, remsa",
      "pos": "noun",
      "explanation": "linear thing + cloth + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        228
      ]
    },
    {
      "id": 2280,
      "bciAvId": 16506,
      "gloss": "rich (taste)",
      "glossSv": "läcker",
      "pos": "description",
      "explanation": "taste + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2281,
      "bciAvId": 16507,
      "gloss": "rich, wealthy",
      "glossSv": "rik",
      "pos": "description",
      "explanation": "much + money + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        451,
        ";",
        86
      ]
    },
    {
      "id": 2282,
      "bciAvId": 16508,
      "gloss": "rickshaw",
      "glossSv": "ricksha",
      "pos": "noun",
      "explanation": "cart + person: cart pulled by a person",
      "isCharacter": false,
      "composition": [
        204,
        "/",
        513
      ]
    },
    {
      "id": 2283,
      "bciAvId": 16509,
      "gloss": "to ride",
      "glossSv": "åka",
      "pos": "action",
      "explanation": "ride,drive + action indicator: to go forward in a sitting position",
      "isCharacter": false,
      "composition": [
        1077,
        ";",
        81
      ]
    },
    {
      "id": 2284,
      "bciAvId": 16510,
      "gloss": "rifle, shotgun",
      "glossSv": "gevär",
      "pos": "noun",
      "explanation": "gun + long",
      "isCharacter": false,
      "composition": [
        369,
        "/",
        420
      ]
    },
    {
      "id": 2285,
      "bciAvId": 16673,
      "gloss": "right",
      "glossSv": "höger",
      "pos": "description",
      "explanation": "right turn,right (position or direction) + description indicator",
      "isCharacter": false,
      "composition": [
        1078,
        ";",
        86
      ]
    },
    {
      "id": 2286,
      "bciAvId": 16676,
      "gloss": "to rise, to ascend, to go up",
      "glossSv": "gå upp, stiga",
      "pos": "action",
      "explanation": "up + action indicator",
      "isCharacter": false,
      "composition": [
        678,
        ";",
        81
      ]
    },
    {
      "id": 2287,
      "bciAvId": 16679,
      "gloss": "roadrunner (bird)",
      "glossSv": "roadrunner, tuppgök (fågel)",
      "pos": "noun",
      "explanation": "bird + to walk + little: small bird that walks or runs but does not fly",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        418,
        "/",
        956
      ]
    },
    {
      "id": 2288,
      "bciAvId": 16680,
      "gloss": "rocket, spaceship",
      "glossSv": "raket, rymdskepp",
      "pos": "noun",
      "explanation": "projectile,rocket,spacecraft + upward",
      "isCharacter": false,
      "composition": [
        1088,
        "/",
        678
      ]
    },
    {
      "id": 2289,
      "bciAvId": 16681,
      "gloss": "rocking chair",
      "glossSv": "gungstol",
      "pos": "noun",
      "explanation": "chair + to rock: chair that rocks back and forth",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        989
      ]
    },
    {
      "id": 2290,
      "bciAvId": 16682,
      "gloss": "rocking horse",
      "glossSv": "gunghäst (FD)",
      "pos": "noun",
      "explanation": "horse + to rock",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        989
      ]
    },
    {
      "id": 2291,
      "bciAvId": 16684,
      "gloss": "to roller skate",
      "glossSv": "åka rullskridskor",
      "pos": "action",
      "explanation": "roller skates + action indicator",
      "isCharacter": false,
      "composition": [
        571,
        ";",
        81
      ]
    },
    {
      "id": 2292,
      "bciAvId": 16686,
      "gloss": "roof, cover",
      "glossSv": "tak, yttertak",
      "pos": "noun",
      "explanation": "protection + thing indicator: thing that provides protective cover. The symbol is the concrete form of protection.",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        97
      ]
    },
    {
      "id": 2293,
      "bciAvId": 16689,
      "gloss": "Rosh Hashana",
      "glossSv": "Rosh Hashana (Israel)",
      "pos": "noun",
      "explanation": "day + horn + Jewish: Jewish New Year, the day on which the shofar or ram's horn is blown",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        389,
        "/",
        621
      ]
    },
    {
      "id": 2294,
      "bciAvId": 16690,
      "gloss": "to rotate, to circle, to circulate, to wind up, to orbit",
      "glossSv": "rotera, cirkulera, snurra, kretsa kring, vrida, veva",
      "pos": "action",
      "explanation": "rotation,circulation,orbit,lap,circle,round + action indicator",
      "isCharacter": false,
      "composition": [
        887,
        ";",
        81
      ]
    },
    {
      "id": 2295,
      "bciAvId": 16691,
      "gloss": "roti, chapati, flatbread",
      "glossSv": "roti, chapati (Indien)",
      "pos": "noun",
      "explanation": "toast + disc: disc-shaped toasted bread",
      "isCharacter": false,
      "composition": [
        1004,
        "/",
        319,
        "/",
        263
      ]
    },
    {
      "id": 2296,
      "bciAvId": 16692,
      "gloss": "rouge, blusher",
      "glossSv": "rouge",
      "pos": "noun",
      "explanation": "colour + plus + cheek: colour added to cheeks",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        120,
        "/",
        214
      ]
    },
    {
      "id": 2297,
      "bciAvId": 16693,
      "gloss": "round, circular",
      "glossSv": "cirkelformad, rund",
      "pos": "description",
      "explanation": "circle + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        651,
        "/",
        636
      ]
    },
    {
      "id": 2298,
      "bciAvId": 16695,
      "gloss": "to rub, to massage",
      "glossSv": "gnugga, gnida, massera",
      "pos": "action",
      "explanation": "hand + back and forth + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        144,
        "/",
        401
      ]
    },
    {
      "id": 2299,
      "bciAvId": 16696,
      "gloss": "rug, carpet, mat",
      "glossSv": "matta",
      "pos": "noun",
      "explanation": "cloth + floor covering",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        324
      ]
    },
    {
      "id": 2300,
      "bciAvId": 16697,
      "gloss": "rule, regulation",
      "glossSv": "regel, föreskrift",
      "pos": "noun",
      "explanation": "page + to guide: written guidance",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803
      ]
    },
    {
      "id": 2301,
      "bciAvId": 16698,
      "gloss": "ruler, measuring stick, tapeline, tape measure",
      "glossSv": "linjal, måttband (etc)",
      "pos": "noun",
      "explanation": "measurement + thing indicator",
      "isCharacter": false,
      "composition": [
        441,
        ";",
        97
      ]
    },
    {
      "id": 2302,
      "bciAvId": 16699,
      "gloss": "to run, to jog",
      "glossSv": "springa",
      "pos": "action",
      "explanation": "to walk + fast + action indicator",
      "isCharacter": false,
      "composition": [
        418,
        ";",
        81,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 2303,
      "bciAvId": 16700,
      "gloss": "Sabbath, day of rest",
      "glossSv": "vilodag",
      "pos": "noun",
      "explanation": "day + rest: day for resting",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        562
      ]
    },
    {
      "id": 2304,
      "bciAvId": 16702,
      "gloss": "sad, sadly, unhappily, unhappy",
      "glossSv": "ledsen, olycklig",
      "pos": "description",
      "explanation": "sadness + description indicator: having a downhearted feeling",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        271
      ]
    },
    {
      "id": 2305,
      "bciAvId": 16703,
      "gloss": "sadness, sorrow, unhappiness",
      "glossSv": "sorg",
      "pos": "noun",
      "explanation": "feeling + down",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271
      ]
    },
    {
      "id": 2306,
      "bciAvId": 16704,
      "gloss": "safe, safely, secure, securely",
      "glossSv": "säker, trygg",
      "pos": "description",
      "explanation": "safety + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        548
      ]
    },
    {
      "id": 2307,
      "bciAvId": 16705,
      "gloss": "safety, security",
      "glossSv": "säkerhet, trygghet",
      "pos": "noun",
      "explanation": "feeling + protection: feeling of being protected",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        548
      ]
    },
    {
      "id": 2308,
      "bciAvId": 16708,
      "gloss": "sailor",
      "glossSv": "sjöman",
      "pos": "person",
      "explanation": "person + boat",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        170
      ]
    },
    {
      "id": 2309,
      "bciAvId": 16710,
      "gloss": "saliva, spit",
      "glossSv": "saliv, spott",
      "pos": "noun",
      "explanation": "liquid + mouth: liquid contained in the mouth",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        457
      ]
    },
    {
      "id": 2310,
      "bciAvId": 16711,
      "gloss": "salt crystal",
      "glossSv": "saltkristall",
      "pos": "noun",
      "explanation": "crystal + sea",
      "isCharacter": false,
      "composition": [
        250,
        "/",
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 2311,
      "bciAvId": 16712,
      "gloss": "salty",
      "glossSv": "salt (adj.)",
      "pos": "description",
      "explanation": "taste + sea + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 2312,
      "bciAvId": 16714,
      "gloss": "same sound",
      "glossSv": "låter lika, låter som",
      "pos": "function",
      "explanation": "same + sound: used before a second symbol to create a meaning that is a homonym of the second symbol",
      "isCharacter": false,
      "composition": [
        578,
        "/",
        608
      ]
    },
    {
      "id": 2313,
      "bciAvId": 16715,
      "gloss": "sand",
      "glossSv": "sand, grus",
      "pos": "noun",
      "explanation": "powder + rock: powder made from a rock",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        629
      ]
    },
    {
      "id": 2314,
      "bciAvId": 16716,
      "gloss": "sandal(s)",
      "glossSv": "sandaler",
      "pos": "noun",
      "explanation": "shoe + comma + open",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        330,
        "/",
        5,
        "/",
        484
      ]
    },
    {
      "id": 2315,
      "bciAvId": 16717,
      "gloss": "sandbox, sandpit, sandtray",
      "glossSv": "sandlåda",
      "pos": "noun",
      "explanation": "foundation + sand: could also be interpreted as enclosure [modification] + sand",
      "isCharacter": false,
      "composition": [
        878,
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 2316,
      "bciAvId": 16718,
      "gloss": "sandwich",
      "glossSv": "sandwich, smörgås, baguette",
      "pos": "noun",
      "explanation": "food + between + bread",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        162,
        "/",
        180
      ]
    },
    {
      "id": 2317,
      "bciAvId": 16719,
      "gloss": "sanitary napkin, sanitary towel, tampon",
      "glossSv": "binda, tampong",
      "pos": "noun",
      "explanation": "absorbent material + woman",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        402,
        "/",
        710
      ]
    },
    {
      "id": 2318,
      "bciAvId": 16720,
      "gloss": "sari",
      "glossSv": "sari (Indien)",
      "pos": "noun",
      "explanation": "clothing + around + woman",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        134,
        "/",
        710
      ]
    },
    {
      "id": 2319,
      "bciAvId": 16721,
      "gloss": "satisfaction, contentment",
      "glossSv": "tillfredsställelse, belåtenhet",
      "pos": "noun",
      "explanation": "mind + full: CKB quotes the Chinese phrase to describe a contented man: “his rice bowl is full”",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        947
      ]
    },
    {
      "id": 2320,
      "bciAvId": 16722,
      "gloss": "Saturday",
      "glossSv": "lördag (FD)",
      "pos": "noun",
      "explanation": "day + 7: seventh day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16
      ]
    },
    {
      "id": 2321,
      "bciAvId": 16723,
      "gloss": "sauce, gravy, relish, dressing",
      "glossSv": "sås (FD)",
      "pos": "noun",
      "explanation": "spread,paste + liquid: liquid served on or to accompany food",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        695
      ]
    },
    {
      "id": 2322,
      "bciAvId": 16724,
      "gloss": "sauerkraut",
      "glossSv": "surkål",
      "pos": "noun",
      "explanation": "cabbage + sour",
      "isCharacter": false,
      "composition": [
        196,
        "/",
        642,
        "/",
        411
      ]
    },
    {
      "id": 2323,
      "bciAvId": 16725,
      "gloss": "sauna",
      "glossSv": "bastu",
      "pos": "noun",
      "explanation": "steam bath + rock",
      "isCharacter": false,
      "composition": [
        624,
        "/",
        629
      ]
    },
    {
      "id": 2324,
      "bciAvId": 16726,
      "gloss": "sausage, frankfurter, hotdog, hot dog",
      "glossSv": "korv",
      "pos": "noun",
      "explanation": "meat + long",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        420
      ]
    },
    {
      "id": 2325,
      "bciAvId": 16728,
      "gloss": "to say, to speak, to talk, to tell, to express",
      "glossSv": "säga, tala, prata",
      "pos": "action",
      "explanation": "mouth + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81
      ]
    },
    {
      "id": 2326,
      "bciAvId": 16729,
      "gloss": "scales",
      "glossSv": "våg (apparat)",
      "pos": "noun",
      "explanation": "machine + to weigh",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        697
      ]
    },
    {
      "id": 2327,
      "bciAvId": 16730,
      "gloss": "scarf",
      "glossSv": "halsduk, scarf",
      "pos": "noun",
      "explanation": "clothing + neck",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        465
      ]
    },
    {
      "id": 2328,
      "bciAvId": 16731,
      "gloss": "scenery, landscape",
      "glossSv": "landskap",
      "pos": "noun",
      "explanation": "generalization + countryside: general term for the countryside, which is characteristic of a particular area or region, e.g. a prairie landscape",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        244
      ]
    },
    {
      "id": 2329,
      "bciAvId": 16732,
      "gloss": "schach",
      "glossSv": "schach (Israel)",
      "pos": "noun",
      "explanation": "roof + tree + thing indicator + plural indicator: material used in making roof for Sukkot",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        97,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 2330,
      "bciAvId": 16733,
      "gloss": "schedule, timetable",
      "glossSv": "schema, tidtabell",
      "pos": "noun",
      "explanation": "paper + time: paper that gives the times of events",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        655
      ]
    },
    {
      "id": 2331,
      "bciAvId": 16734,
      "gloss": "school",
      "glossSv": "skola",
      "pos": "noun",
      "explanation": "building + to teach: building used for teaching",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        949,
        "/",
        412
      ]
    },
    {
      "id": 2332,
      "bciAvId": 16737,
      "gloss": "score",
      "glossSv": "poäng",
      "pos": "noun",
      "explanation": "number + competition",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        "RK:-2",
        "/",
        554
      ]
    },
    {
      "id": 2333,
      "bciAvId": 16738,
      "gloss": "scorpion",
      "glossSv": "skorpion",
      "pos": "noun",
      "explanation": "spider + to puncture: spider-like insect with a poisonous sting",
      "isCharacter": false,
      "composition": [
        613,
        "/",
        538
      ]
    },
    {
      "id": 2334,
      "bciAvId": 16740,
      "gloss": "screwdriver",
      "glossSv": "skruvmejsel",
      "pos": "noun",
      "explanation": "tool + screw",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        582
      ]
    },
    {
      "id": 2335,
      "bciAvId": 16741,
      "gloss": "scrotum",
      "glossSv": "pung",
      "pos": "noun",
      "explanation": "protection + testicle",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        239,
        "/",
        612
      ]
    },
    {
      "id": 2336,
      "bciAvId": 16742,
      "gloss": "to search",
      "glossSv": "leta, söka",
      "pos": "action",
      "explanation": "to watch + intensity + action indicator: to watch very intently",
      "isCharacter": false,
      "composition": [
        969,
        ";",
        81,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2337,
      "bciAvId": 16743,
      "gloss": "second (time)",
      "glossSv": "sekund",
      "pos": "noun",
      "explanation": "time + two apostrophes, used in astronomy to indicate a second",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        7,
        "/",
        7
      ]
    },
    {
      "id": 2338,
      "bciAvId": 16744,
      "gloss": "second (ordinal)",
      "glossSv": "andra (ordningstal)",
      "pos": "description",
      "explanation": "2 + decimal point + description indicator: the dot indicates an ordinal numeral",
      "isCharacter": false,
      "composition": [
        11,
        ";",
        86,
        "/",
        4
      ]
    },
    {
      "id": 2339,
      "bciAvId": 16746,
      "gloss": "secretary",
      "glossSv": "sekreterare",
      "pos": "person",
      "explanation": "person + secret: historically, a person who keeps the boss's secrets",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        583
      ]
    },
    {
      "id": 2340,
      "bciAvId": 16747,
      "gloss": "to see, to look, to watch",
      "glossSv": "se, titta",
      "pos": "action",
      "explanation": "eye + action indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81
      ]
    },
    {
      "id": 2341,
      "bciAvId": 16748,
      "gloss": "see you again",
      "glossSv": "vi ses",
      "pos": "function",
      "explanation": "to see + again + action indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81,
        "/",
        110
      ]
    },
    {
      "id": 2342,
      "bciAvId": 16750,
      "gloss": "to seem",
      "glossSv": "verka, förefalla",
      "pos": "action",
      "explanation": "state of mind + what,question mark (small) + action indicator: can also be interpreted as mind + maybe + action indicator: to give the impression of being",
      "isCharacter": false,
      "composition": [
        985,
        ";",
        81,
        "/",
        699
      ]
    },
    {
      "id": 2343,
      "bciAvId": 16752,
      "gloss": "self, oneself, ego (person)",
      "glossSv": "själv, ego",
      "pos": "person",
      "explanation": "1 + person [modification]: referring to oneself as person number one",
      "isCharacter": true
    },
    {
      "id": 2344,
      "bciAvId": 16753,
      "gloss": "self-harm",
      "glossSv": "självdestruktivitet",
      "pos": "noun",
      "explanation": "abuse,assault,violence + self",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        2343
      ]
    },
    {
      "id": 2345,
      "bciAvId": 16754,
      "gloss": "self-control",
      "glossSv": "självbehärskning, självkontroll",
      "pos": "noun",
      "explanation": "to lead + self: guidance of oneself",
      "isCharacter": false,
      "composition": [
        803,
        "/",
        2343
      ]
    },
    {
      "id": 2346,
      "bciAvId": 16755,
      "gloss": "selfish, self-centred, self-centered, egoistic, egoistical, egocentric",
      "glossSv": "egoistisk, självisk",
      "pos": "description",
      "explanation": "selfishness,egoism + description indicator: thinking only about oneself",
      "isCharacter": false,
      "composition": [
        964,
        ";",
        86
      ]
    },
    {
      "id": 2347,
      "bciAvId": 16756,
      "gloss": "to sell",
      "glossSv": "sälja",
      "pos": "action",
      "explanation": "thing + money + action indicator: first you must have something, which you can then sell for money",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        451
      ]
    },
    {
      "id": 2348,
      "bciAvId": 16757,
      "gloss": "semen",
      "glossSv": "sädesvätska",
      "pos": "noun",
      "explanation": "liquid + sperm",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        612
      ]
    },
    {
      "id": 2349,
      "bciAvId": 16758,
      "gloss": "seminal vesicle",
      "glossSv": "sädesblåsa",
      "pos": "noun",
      "explanation": "container + semen: pouch in which semen is produced",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        695,
        "/",
        612
      ]
    },
    {
      "id": 2350,
      "bciAvId": 16759,
      "gloss": "to send",
      "glossSv": "skicka, sända",
      "pos": "action",
      "explanation": "to carry + departure + action indicator: to carry away from a given location",
      "isCharacter": false,
      "composition": [
        1099,
        ";",
        81,
        "/",
        1525
      ]
    },
    {
      "id": 2351,
      "bciAvId": 16760,
      "gloss": "sentence, clause, phrase",
      "glossSv": "mening, sats",
      "pos": "noun",
      "explanation": "group of + word: a group of words considered together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 2352,
      "bciAvId": 16761,
      "gloss": "September",
      "glossSv": "september",
      "pos": "noun",
      "explanation": "month + 9: ninth month of the year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        18
      ]
    },
    {
      "id": 2353,
      "bciAvId": 16762,
      "gloss": "several",
      "glossSv": "flera, åtskilliga",
      "pos": "expression",
      "explanation": "greater than (relation) + 2: greater than two",
      "isCharacter": false,
      "composition": [
        559,
        "/",
        11
      ]
    },
    {
      "id": 2354,
      "bciAvId": 16763,
      "gloss": "to sew",
      "glossSv": "sy",
      "pos": "action",
      "explanation": "needle + action indicator",
      "isCharacter": false,
      "composition": [
        468,
        ";",
        81
      ]
    },
    {
      "id": 2355,
      "bciAvId": 16764,
      "gloss": "sewing machine",
      "glossSv": "symaskin",
      "pos": "noun",
      "explanation": "machine + to sew",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        468
      ]
    },
    {
      "id": 2356,
      "bciAvId": 16765,
      "gloss": "sex drive, sexual urge, libido",
      "glossSv": "könsdrift",
      "pos": "noun",
      "explanation": "fire + gender,sex: sexual desire",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        347
      ]
    },
    {
      "id": 2357,
      "bciAvId": 16766,
      "gloss": "sexual abuse, sexual assault, sexual violence",
      "glossSv": "sexuellt våld",
      "pos": "noun",
      "explanation": "abuse,assault,violence + gender,sex",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        347
      ]
    },
    {
      "id": 2358,
      "bciAvId": 16929,
      "gloss": "sexual arousal, sexual excitement",
      "glossSv": "sexuell upphetsning",
      "pos": "noun",
      "explanation": "excitement + gender,sex",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        401,
        "/",
        401,
        "/",
        347
      ]
    },
    {
      "id": 2359,
      "bciAvId": 16930,
      "gloss": "sexual harassment",
      "glossSv": "sexuella trakasserier",
      "pos": "noun",
      "explanation": "harassment + gender,sex",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1027,
        "/",
        347
      ]
    },
    {
      "id": 2360,
      "bciAvId": 16931,
      "gloss": "sexual intercourse, intercourse, copulation",
      "glossSv": "samlag",
      "pos": "noun",
      "explanation": "to combine + gender,sex",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        349
      ]
    },
    {
      "id": 2361,
      "bciAvId": 16932,
      "gloss": "sexual pleasure",
      "glossSv": "sexuell njutning",
      "pos": "noun",
      "explanation": "pleasure + gender,sex",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678,
        "/",
        347
      ]
    },
    {
      "id": 2362,
      "bciAvId": 16933,
      "gloss": "sexuality",
      "glossSv": "erotik, sexualitet",
      "pos": "noun",
      "explanation": "feeling + gender,sex",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        347
      ]
    },
    {
      "id": 2363,
      "bciAvId": 16934,
      "gloss": "to shake, to jiggle",
      "glossSv": "skaka",
      "pos": "action",
      "explanation": "up and down + action indicator",
      "isCharacter": false,
      "composition": [
        723,
        ";",
        81
      ]
    },
    {
      "id": 2364,
      "bciAvId": 16935,
      "gloss": "shallow",
      "glossSv": "grund",
      "pos": "description",
      "explanation": "shallowness + description indicator: pointer points downward into a relatively shallow space",
      "isCharacter": false,
      "composition": [
        1080,
        ";",
        86
      ]
    },
    {
      "id": 2365,
      "bciAvId": 16936,
      "gloss": "greeting, shalom, salam (etc)",
      "glossSv": "hälsning",
      "pos": "noun",
      "explanation": "mouth + meeting and parting: a combination of hello and goodbye, expression of greeting, either when meeting or parting",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1058
      ]
    },
    {
      "id": 2366,
      "bciAvId": 16937,
      "gloss": "shame",
      "glossSv": "skam",
      "pos": "noun",
      "explanation": "sad + wrong: feeling of sadness about one's wrong behaviour",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 2367,
      "bciAvId": 16938,
      "gloss": "shampoo",
      "glossSv": "schampo",
      "pos": "noun",
      "explanation": "soap + hair",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        595,
        "/",
        372
      ]
    },
    {
      "id": 2368,
      "bciAvId": 16940,
      "gloss": "shape, form",
      "glossSv": "form",
      "pos": "noun",
      "explanation": "eye + thing: how the eye perceives an object",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651
      ]
    },
    {
      "id": 2369,
      "bciAvId": 16941,
      "gloss": "to share",
      "glossSv": "dela, ha tillsammans",
      "pos": "action",
      "explanation": "to have + together + action indicator",
      "isCharacter": false,
      "composition": [
        953,
        ";",
        81,
        "/",
        823
      ]
    },
    {
      "id": 2370,
      "bciAvId": 16942,
      "gloss": "shark",
      "glossSv": "haj",
      "pos": "noun",
      "explanation": "fish + teeth",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        644
      ]
    },
    {
      "id": 2371,
      "bciAvId": 16943,
      "gloss": "sharp (knife)",
      "glossSv": "skarp, vass",
      "pos": "description",
      "explanation": "knife + description indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        86
      ]
    },
    {
      "id": 2372,
      "bciAvId": 16944,
      "gloss": "sharp (taste), acid, sour",
      "glossSv": "sur, skarp (smak)",
      "pos": "description",
      "explanation": "taste + sharp + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        411
      ]
    },
    {
      "id": 2373,
      "bciAvId": 16945,
      "gloss": "to shave (beard)",
      "glossSv": "raka, raka sig",
      "pos": "action",
      "explanation": "to cut + beard + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        155
      ]
    },
    {
      "id": 2374,
      "bciAvId": 16946,
      "gloss": "shaver, razor",
      "glossSv": "rakapparat, rakhyvel",
      "pos": "noun",
      "explanation": "knife + beard",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        155
      ]
    },
    {
      "id": 2375,
      "bciAvId": 16947,
      "gloss": "shaving soap, shaving cream",
      "glossSv": "rakkräm, raktvål",
      "pos": "noun",
      "explanation": "soap + beard",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        595,
        "/",
        155
      ]
    },
    {
      "id": 2376,
      "bciAvId": 16948,
      "gloss": "Shavuot",
      "glossSv": "Shavuot (Israel)",
      "pos": "noun",
      "explanation": "day + commandments",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        235
      ]
    },
    {
      "id": 2377,
      "bciAvId": 16949,
      "gloss": "she, her, herself",
      "glossSv": "hon, henne, sig",
      "pos": "person",
      "explanation": "female + 3: third person singular (f.)",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        12
      ]
    },
    {
      "id": 2378,
      "bciAvId": 16950,
      "gloss": "sheep",
      "glossSv": "får",
      "pos": "noun",
      "explanation": "ovine + cloth: animal whose fleece is used to make cloth",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        228
      ]
    },
    {
      "id": 2379,
      "bciAvId": 16951,
      "gloss": "sheet(s), bedclothes, bed linen",
      "glossSv": "lakan",
      "pos": "noun",
      "explanation": "cloth + bed",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        156
      ]
    },
    {
      "id": 2380,
      "bciAvId": 16952,
      "gloss": "shekel",
      "glossSv": "shekel",
      "pos": "noun",
      "explanation": "money + shekel (character); the Israeli currency shekel",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        1081
      ]
    },
    {
      "id": 2381,
      "bciAvId": 16955,
      "gloss": "shelter, refuge",
      "glossSv": "skyddsrum",
      "pos": "noun",
      "explanation": "room + protection",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        548
      ]
    },
    {
      "id": 2382,
      "bciAvId": 16956,
      "gloss": "to shine, to beam",
      "glossSv": "lysa, skina",
      "pos": "action",
      "explanation": "sun + action indicator",
      "isCharacter": false,
      "composition": [
        636,
        ";",
        81
      ]
    },
    {
      "id": 2383,
      "bciAvId": 16957,
      "gloss": "shirt, blouse",
      "glossSv": "blus, skjorta, tröja (etc)",
      "pos": "noun",
      "explanation": "clothing + chest: clothing that covers the upper part of the body",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        218
      ]
    },
    {
      "id": 2384,
      "bciAvId": 16958,
      "gloss": "Shiva",
      "glossSv": "Shiva (Indien)",
      "pos": "person",
      "explanation": "god + destruction: Hindu god",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        939
      ]
    },
    {
      "id": 2385,
      "bciAvId": 16959,
      "gloss": "shoe",
      "glossSv": "skor",
      "pos": "noun",
      "explanation": "protection + foot: protective covering for the feet",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        330
      ]
    },
    {
      "id": 2386,
      "bciAvId": 16960,
      "gloss": "shofar",
      "glossSv": "shofar (Israel)",
      "pos": "noun",
      "explanation": "horn + Jewish",
      "isCharacter": false,
      "composition": [
        389,
        "/",
        621
      ]
    },
    {
      "id": 2387,
      "bciAvId": 16961,
      "gloss": "shopping centre",
      "glossSv": "center, köpcentrum (FD)",
      "pos": "noun",
      "explanation": "many + public room: group of stores",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        550
      ]
    },
    {
      "id": 2388,
      "bciAvId": 16962,
      "gloss": "short",
      "glossSv": "kort",
      "pos": "description",
      "explanation": "shortness (distance,length) + description indicator: horizontal line is relatively short",
      "isCharacter": false,
      "composition": [
        965,
        ";",
        86
      ]
    },
    {
      "id": 2389,
      "bciAvId": 16963,
      "gloss": "shorts",
      "glossSv": "kortbyxor, shorts",
      "pos": "noun",
      "explanation": "trousers + comma + short",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        417,
        "/",
        5,
        "/",
        965
      ]
    },
    {
      "id": 2390,
      "bciAvId": 16965,
      "gloss": "to shout",
      "glossSv": "skrika",
      "pos": "action",
      "explanation": "to say + two intensity symbols + action indicator: to say forcefully",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2391,
      "bciAvId": 16967,
      "gloss": "to show, to demonstrate",
      "glossSv": "visa, demonstrera",
      "pos": "action",
      "explanation": "to cause + to observe + action indicator: to cause to be seen",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        931
      ]
    },
    {
      "id": 2392,
      "bciAvId": 16969,
      "gloss": "to shower",
      "glossSv": "duscha",
      "pos": "action",
      "explanation": "shower + action indicator",
      "isCharacter": false,
      "composition": [
        591,
        ";",
        81
      ]
    },
    {
      "id": 2393,
      "bciAvId": 16970,
      "gloss": "exhibition hall, showplace",
      "glossSv": "utställningshall, galleri",
      "pos": "noun",
      "explanation": "building + to see: building in which to see shows",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        303
      ]
    },
    {
      "id": 2394,
      "bciAvId": 16971,
      "gloss": "Shevat, Shvat",
      "glossSv": "Shvat, Shevat",
      "pos": "noun",
      "explanation": "month + birth + tree + plural indicator: month of Tu B’Shvat",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        166,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 2395,
      "bciAvId": 16972,
      "gloss": "sibling(s)",
      "glossSv": "syskon",
      "pos": "person",
      "explanation": "offspring,child + 2: male or female family member considered in relation to another child of the same parents",
      "isCharacter": false,
      "composition": [
        479,
        "/",
        11
      ]
    },
    {
      "id": 2396,
      "bciAvId": 16973,
      "gloss": "sick, ill",
      "glossSv": "sjuk",
      "pos": "description",
      "explanation": "illness + description indicator",
      "isCharacter": false,
      "composition": [
        516,
        ";",
        86
      ]
    },
    {
      "id": 2397,
      "bciAvId": 16977,
      "gloss": "sign, advertisement",
      "glossSv": "signal, skylt",
      "pos": "noun",
      "explanation": "enclosure + attention: large square that attracts one's attention",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        303,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2398,
      "bciAvId": 16978,
      "gloss": "sign",
      "glossSv": "tecken (FD)",
      "pos": "noun",
      "explanation": "to point + thing: the hand points to the thing",
      "isCharacter": false,
      "composition": [
        844,
        "/",
        651
      ]
    },
    {
      "id": 2399,
      "bciAvId": 16979,
      "gloss": "signature",
      "glossSv": "namnteckning",
      "pos": "noun",
      "explanation": "to write + name: writing of one's name",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        "RK:-2",
        "/",
        464
      ]
    },
    {
      "id": 2400,
      "bciAvId": 16980,
      "gloss": "signature stamp",
      "glossSv": "namnstämpel",
      "pos": "noun",
      "explanation": "tool + signature",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        509,
        "/",
        "RK:-2",
        "/",
        464
      ]
    },
    {
      "id": 2401,
      "bciAvId": 16981,
      "gloss": "silence, quiet",
      "glossSv": "tystnad",
      "pos": "noun",
      "explanation": "minus + sound: absence of sound",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        608
      ]
    },
    {
      "id": 2402,
      "bciAvId": 16982,
      "gloss": "silent",
      "glossSv": "tyst, låg, lågmäld",
      "pos": "description",
      "explanation": "silence + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        608,
        ";",
        86
      ]
    },
    {
      "id": 2403,
      "bciAvId": 16983,
      "gloss": "Simchat Torah",
      "glossSv": "Simchat Torah (Israel)",
      "pos": "noun",
      "explanation": "holiday + Torah",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        313,
        "/",
        678,
        "/",
        663
      ]
    },
    {
      "id": 2404,
      "bciAvId": 16984,
      "gloss": "similar, like, alike",
      "glossSv": "nästan samma som, liknande",
      "pos": "function",
      "explanation": "near + same: nearly the same",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578
      ]
    },
    {
      "id": 2405,
      "bciAvId": 16985,
      "gloss": "similar looking, looks similar",
      "glossSv": "ser nästan ut som",
      "pos": "function",
      "explanation": "similar + eye",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        303
      ]
    },
    {
      "id": 2406,
      "bciAvId": 16986,
      "gloss": "similar sound, sounds like",
      "glossSv": "låter nästan lika, låter nästan som",
      "pos": "function",
      "explanation": "similar + sound",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        608
      ]
    },
    {
      "id": 2407,
      "bciAvId": 16987,
      "gloss": "to simmer, to poach",
      "glossSv": "sjuda",
      "pos": "action",
      "explanation": "to cook + water + action indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        329,
        "/",
        695
      ]
    },
    {
      "id": 2408,
      "bciAvId": 16988,
      "gloss": "sin",
      "glossSv": "synd",
      "pos": "noun",
      "explanation": "wrong + God: something wrong in God's eyes",
      "isCharacter": false,
      "composition": [
        997,
        "/",
        401,
        "/",
        355
      ]
    },
    {
      "id": 2409,
      "bciAvId": 16989,
      "gloss": "to sin",
      "glossSv": "synda",
      "pos": "action",
      "explanation": "sin + action indicator",
      "isCharacter": false,
      "composition": [
        997,
        ";",
        81,
        "/",
        401,
        "/",
        355
      ]
    },
    {
      "id": 2410,
      "bciAvId": 16990,
      "gloss": "to sing",
      "glossSv": "sjunga",
      "pos": "action",
      "explanation": "song + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        462
      ]
    },
    {
      "id": 2411,
      "bciAvId": 16991,
      "gloss": "singer",
      "glossSv": "sångare, sångerska",
      "pos": "person",
      "explanation": "person + to sing",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 2412,
      "bciAvId": 16993,
      "gloss": "sinner",
      "glossSv": "syndare",
      "pos": "person",
      "explanation": "person + sin: person who sins",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        997,
        "/",
        401,
        "/",
        355
      ]
    },
    {
      "id": 2413,
      "bciAvId": 16994,
      "gloss": "sister",
      "glossSv": "syster",
      "pos": "person",
      "explanation": "daughter + 2: daughter considered in relation to another child of her parents",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        11
      ]
    },
    {
      "id": 2414,
      "bciAvId": 16995,
      "gloss": "to sit",
      "glossSv": "sitta",
      "pos": "action",
      "explanation": "seat,sitting (sitting person) + action indicator",
      "isCharacter": false,
      "composition": [
        517,
        ";",
        81
      ]
    },
    {
      "id": 2415,
      "bciAvId": 16996,
      "gloss": "Sivan",
      "glossSv": "Sivan (Israel)",
      "pos": "noun",
      "explanation": "month + commandments: month of the holiday of Shavout",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        235
      ]
    },
    {
      "id": 2416,
      "bciAvId": 16998,
      "gloss": "skeleton",
      "glossSv": "skelett",
      "pos": "noun",
      "explanation": "structure + creature + thing indicator: supporting structure of a living creature",
      "isCharacter": false,
      "composition": [
        633,
        "/",
        423,
        ";",
        97
      ]
    },
    {
      "id": 2417,
      "bciAvId": 16999,
      "gloss": "ski boot(s)",
      "glossSv": "kängor, pjäxor",
      "pos": "noun",
      "explanation": "boot + ski",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        1052,
        "/",
        1084
      ]
    },
    {
      "id": 2418,
      "bciAvId": 17000,
      "gloss": "ski pole(s)",
      "glossSv": "stavar",
      "pos": "noun",
      "explanation": "2 + linear thing + ski + thing indicator",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        428,
        ";",
        97,
        "/",
        1084
      ]
    },
    {
      "id": 2419,
      "bciAvId": 17001,
      "gloss": "skin",
      "glossSv": "hud, skinn",
      "pos": "noun",
      "explanation": "protection + body: protective covering for the body",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        171
      ]
    },
    {
      "id": 2420,
      "bciAvId": 17002,
      "gloss": "skirt",
      "glossSv": "kjol",
      "pos": "noun",
      "explanation": "clothing,clothes,garment + woman (below waist): can also be explained as dress + pointer, to skirt",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        1110
      ]
    },
    {
      "id": 2421,
      "bciAvId": 17003,
      "gloss": "skis (pair of)",
      "glossSv": "skidor",
      "pos": "noun",
      "explanation": "2 + ski",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        1084
      ]
    },
    {
      "id": 2422,
      "bciAvId": 17004,
      "gloss": "skullcap, kipa, yarmulke",
      "glossSv": "kalott (Israel)",
      "pos": "noun",
      "explanation": "hat + Jewish: head covering for religious purposes",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        376,
        "/",
        621
      ]
    },
    {
      "id": 2423,
      "bciAvId": 17005,
      "gloss": "skunk",
      "glossSv": "skunk",
      "pos": "noun",
      "explanation": "animal + to smell bad: animal that gives off a disagreeable smell",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        600,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 2424,
      "bciAvId": 17009,
      "gloss": "to sleep",
      "glossSv": "sova",
      "pos": "action",
      "explanation": "sleep + action indicator",
      "isCharacter": false,
      "composition": [
        599,
        ";",
        81
      ]
    },
    {
      "id": 2425,
      "bciAvId": 17010,
      "gloss": "sleeping bag",
      "glossSv": "sovsäck",
      "pos": "noun",
      "explanation": "sack + to sleep",
      "isCharacter": false,
      "composition": [
        574,
        "/",
        599
      ]
    },
    {
      "id": 2426,
      "bciAvId": 17011,
      "gloss": "slide",
      "glossSv": "rutschbana",
      "pos": "noun",
      "explanation": "downward and forward + thing indicator: thing for sliding",
      "isCharacter": false,
      "composition": [
        273,
        ";",
        97
      ]
    },
    {
      "id": 2427,
      "bciAvId": 17012,
      "gloss": "slip, petticoat, half-slip, underskirt",
      "glossSv": "underkjol, underklänning",
      "pos": "noun",
      "explanation": "dress + under",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        710,
        "/",
        676
      ]
    },
    {
      "id": 2428,
      "bciAvId": 17013,
      "gloss": "slipper(s)",
      "glossSv": "tofflor, inneskor",
      "pos": "noun",
      "explanation": "shoe + house: shoe(s) worn mainly indoors",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        330,
        "/",
        392
      ]
    },
    {
      "id": 2429,
      "bciAvId": 17014,
      "gloss": "slow, slowly",
      "glossSv": "långsam, sakta (FD)",
      "pos": "description",
      "explanation": "opposite meaning + fast + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        335,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2430,
      "bciAvId": 17015,
      "gloss": "smart, bright, clever, intelligent",
      "glossSv": "klok, begåvad, förståndig",
      "pos": "description",
      "explanation": "smartness,brightness,cleverness,intelligence + description indicator: having striking mental abilities",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2431,
      "bciAvId": 17016,
      "gloss": "to smash, to grind, to shatter, to splinter",
      "glossSv": "mala, krossa",
      "pos": "action",
      "explanation": "to break + many + piece + action indicator",
      "isCharacter": false,
      "composition": [
        933,
        ";",
        81,
        "/",
        368,
        "/",
        502
      ]
    },
    {
      "id": 2432,
      "bciAvId": 17018,
      "gloss": "to smell",
      "glossSv": "lukta, nosa",
      "pos": "action",
      "explanation": "nose + action indicator",
      "isCharacter": false,
      "composition": [
        473,
        ";",
        81
      ]
    },
    {
      "id": 2433,
      "bciAvId": 17019,
      "gloss": "to smell, to give off odour, to give off odor",
      "glossSv": "lukta",
      "pos": "action",
      "explanation": "smell + action indicator: to give off a smell or odour",
      "isCharacter": false,
      "composition": [
        600,
        ";",
        81
      ]
    },
    {
      "id": 2434,
      "bciAvId": 17020,
      "gloss": "to smell bad, to stink",
      "glossSv": "lukta illa, stinka",
      "pos": "action",
      "explanation": "to smell + negative + action indicator",
      "isCharacter": false,
      "composition": [
        600,
        ";",
        81,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 2435,
      "bciAvId": 17021,
      "gloss": "to smile, to grin",
      "glossSv": "le",
      "pos": "action",
      "explanation": "happy + face + action indicator: to make a happy face",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        678,
        "/",
        306
      ]
    },
    {
      "id": 2436,
      "bciAvId": 17022,
      "gloss": "smoke",
      "glossSv": "rök",
      "pos": "noun",
      "explanation": "cloud + fire",
      "isCharacter": false,
      "composition": [
        230,
        "/",
        319
      ]
    },
    {
      "id": 2437,
      "bciAvId": 17185,
      "gloss": "to smoke",
      "glossSv": "röka",
      "pos": "action",
      "explanation": "smoking (cigarette) + action indicator",
      "isCharacter": false,
      "composition": [
        1085,
        ";",
        81
      ]
    },
    {
      "id": 2438,
      "bciAvId": 17186,
      "gloss": "smooth",
      "glossSv": "jämn, slät",
      "pos": "description",
      "explanation": "hand + glass + description indicator: feeling like glass",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        86,
        "/",
        352
      ]
    },
    {
      "id": 2439,
      "bciAvId": 17187,
      "gloss": "snack (food)",
      "glossSv": "mellanmål (litet mål)",
      "pos": "noun",
      "explanation": "meal + comma + little: small or light meal",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        329,
        "/",
        5,
        "/",
        956
      ]
    },
    {
      "id": 2440,
      "bciAvId": 17191,
      "gloss": "to sneeze",
      "glossSv": "nysa",
      "pos": "action",
      "explanation": "nose + to blow + intensity + action indicator: to blow air forcefully from one's nose",
      "isCharacter": false,
      "composition": [
        473,
        ";",
        81,
        "/",
        705,
        "/",
        401
      ]
    },
    {
      "id": 2441,
      "bciAvId": 17193,
      "gloss": "to snow",
      "glossSv": "snöa",
      "pos": "action",
      "explanation": "snow + action indicator",
      "isCharacter": false,
      "composition": [
        604,
        ";",
        81
      ]
    },
    {
      "id": 2442,
      "bciAvId": 17194,
      "gloss": "snowball",
      "glossSv": "snöboll",
      "pos": "noun",
      "explanation": "snow + ball: snow shaped into a ball",
      "isCharacter": false,
      "composition": [
        604,
        "/",
        148
      ]
    },
    {
      "id": 2443,
      "bciAvId": 17196,
      "gloss": "snowman",
      "glossSv": "snögubbe",
      "pos": "noun",
      "explanation": "snow + man: snow shaped like a man",
      "isCharacter": false,
      "composition": [
        604,
        "/",
        433
      ]
    },
    {
      "id": 2444,
      "bciAvId": 17197,
      "gloss": "snowshoe",
      "glossSv": "snöskor (FD)",
      "pos": "noun",
      "explanation": "snowshoe + legs and feet + snow: special shoe for walking over snow",
      "isCharacter": false,
      "composition": [
        1087,
        "/",
        418,
        "/",
        604
      ]
    },
    {
      "id": 2445,
      "bciAvId": 17198,
      "gloss": "snowstorm",
      "glossSv": "snöstorm",
      "pos": "noun",
      "explanation": "storm + snow",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        705,
        "/",
        604
      ]
    },
    {
      "id": 2446,
      "bciAvId": 17199,
      "gloss": "snowsuit, winter clothing",
      "glossSv": "vinterkläder",
      "pos": "noun",
      "explanation": "clothing + snow",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        604
      ]
    },
    {
      "id": 2447,
      "bciAvId": 17200,
      "gloss": "soap, detergent",
      "glossSv": "tvål, tvättmedel",
      "pos": "noun",
      "explanation": "thing + to wash",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        595
      ]
    },
    {
      "id": 2448,
      "bciAvId": 17201,
      "gloss": "social worker",
      "glossSv": "kurator (etc)",
      "pos": "person",
      "explanation": "worker + to help + person: person whose work consists of helping others",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        382,
        "/",
        513
      ]
    },
    {
      "id": 2449,
      "bciAvId": 17202,
      "gloss": "soda pop, pop, soft drink",
      "glossSv": "läskedryck, dryck med kolsyra",
      "pos": "noun",
      "explanation": "drink + gas: carbonated drink",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        345
      ]
    },
    {
      "id": 2450,
      "bciAvId": 17203,
      "gloss": "soft",
      "glossSv": "mjuk",
      "pos": "description",
      "explanation": "hand + imprint,depression + description indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        86,
        "/",
        1049
      ]
    },
    {
      "id": 2451,
      "bciAvId": 17204,
      "gloss": "soldier, warrior",
      "glossSv": "soldat, militär",
      "pos": "person",
      "explanation": "person + war",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        693
      ]
    },
    {
      "id": 2452,
      "bciAvId": 17206,
      "gloss": "to solve",
      "glossSv": "lösa (problem), klara",
      "pos": "action",
      "explanation": "to answer + difficult + action indicator: to answer a difficult question",
      "isCharacter": false,
      "composition": [
        129,
        ";",
        81,
        "/",
        940
      ]
    },
    {
      "id": 2453,
      "bciAvId": 17207,
      "gloss": "some, any",
      "glossSv": "endera, någon, en del, vissa",
      "pos": "description",
      "explanation": "part + description indicator",
      "isCharacter": false,
      "composition": [
        502,
        ";",
        86
      ]
    },
    {
      "id": 2454,
      "bciAvId": 17208,
      "gloss": "sometimes",
      "glossSv": "ibland",
      "pos": "description",
      "explanation": "part of + time: part of the time, i.e., sometimes",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 2455,
      "bciAvId": 17210,
      "gloss": "song",
      "glossSv": "sång",
      "pos": "noun",
      "explanation": "mouth + musical note: vocal music",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462
      ]
    },
    {
      "id": 2456,
      "bciAvId": 17211,
      "gloss": "songbird, finch, thrush",
      "glossSv": "sångfågel",
      "pos": "noun",
      "explanation": "bird + song",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        "RK:-2",
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 2457,
      "bciAvId": 17212,
      "gloss": "soon",
      "glossSv": "snart",
      "pos": "description",
      "explanation": "future + near + description indicator: in the near future",
      "isCharacter": false,
      "composition": [
        341,
        ";",
        86,
        "/",
        1060
      ]
    },
    {
      "id": 2458,
      "bciAvId": 17213,
      "gloss": "wound, cut, sore",
      "glossSv": "sår",
      "pos": "noun",
      "explanation": "to break + skin",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 2459,
      "bciAvId": 17214,
      "gloss": "sorry",
      "glossSv": "förlåt, ursäkta",
      "pos": "function",
      "explanation": "sadness + about + past",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        102,
        "/",
        503
      ]
    },
    {
      "id": 2460,
      "bciAvId": 17215,
      "gloss": "sufganiya",
      "glossSv": "soufganiya, Chanukah kaka (Israel)",
      "pos": "noun",
      "explanation": "disc + Chanukah: traditional sweet eaten at Chanukah",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        258,
        "/",
        313,
        "/",
        678,
        "/",
        424
      ]
    },
    {
      "id": 2461,
      "bciAvId": 17217,
      "gloss": "to sound",
      "glossSv": "ljuda, låta",
      "pos": "action",
      "explanation": "sound + action indicator",
      "isCharacter": false,
      "composition": [
        608,
        ";",
        81
      ]
    },
    {
      "id": 2462,
      "bciAvId": 17220,
      "gloss": "southern",
      "glossSv": "sydlig",
      "pos": "description",
      "explanation": "south + description indicator",
      "isCharacter": false,
      "composition": [
        610,
        ";",
        86
      ]
    },
    {
      "id": 2463,
      "bciAvId": 17222,
      "gloss": "spaghetti",
      "glossSv": "spagetti (FD)",
      "pos": "noun",
      "explanation": "food + flour + linear thing + thing indicator: long, thin pasta",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 2464,
      "bciAvId": 17223,
      "gloss": "special, particular",
      "glossSv": "särskild",
      "pos": "description",
      "explanation": "feeling + interesting + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        955
      ]
    },
    {
      "id": 2465,
      "bciAvId": 17224,
      "gloss": "specific, definite",
      "glossSv": "bestämd",
      "pos": "description",
      "explanation": "the + description indicator",
      "isCharacter": false,
      "composition": [
        647,
        ";",
        86
      ]
    },
    {
      "id": 2466,
      "bciAvId": 17225,
      "gloss": "speech impaired",
      "glossSv": "talskadad (FD)",
      "pos": "description",
      "explanation": "limit(s),limitation (OLD) + to speak + description indicator: having difficulties to speak intelligibly",
      "isCharacter": false,
      "composition": [
        427,
        ";",
        86,
        "/",
        457
      ]
    },
    {
      "id": 2467,
      "bciAvId": 17227,
      "gloss": "spermicide",
      "glossSv": "spermiedödande medel",
      "pos": "noun",
      "explanation": "chemical product + sperm destruction",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        1089
      ]
    },
    {
      "id": 2468,
      "bciAvId": 17228,
      "gloss": "spice box",
      "glossSv": "kryddburk (etc)",
      "pos": "noun",
      "explanation": "container + seasoning",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        107,
        ";",
        97,
        "/",
        642
      ]
    },
    {
      "id": 2469,
      "bciAvId": 17230,
      "gloss": "spiral, curl (shape)",
      "glossSv": "spiral",
      "pos": "noun",
      "explanation": "shape + spiral",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        1090
      ]
    },
    {
      "id": 2470,
      "bciAvId": 17231,
      "gloss": "to spit",
      "glossSv": "spotta",
      "pos": "action",
      "explanation": "spitting + action indicator: to expel from one's mouth",
      "isCharacter": false,
      "composition": [
        1091,
        ";",
        81
      ]
    },
    {
      "id": 2471,
      "bciAvId": 17232,
      "gloss": "to splash",
      "glossSv": "plaska",
      "pos": "action",
      "explanation": "to hit + water + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        401,
        "/",
        401,
        "/",
        695
      ]
    },
    {
      "id": 2472,
      "bciAvId": 17234,
      "gloss": "sport",
      "glossSv": "sport, idrott (FD)",
      "pos": "noun",
      "explanation": "activity + healthy",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        377
      ]
    },
    {
      "id": 2473,
      "bciAvId": 17236,
      "gloss": "spot, mark",
      "glossSv": "fläck, märke",
      "pos": "noun",
      "explanation": "eye + dot: dot perceived by the eye",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        270
      ]
    },
    {
      "id": 2474,
      "bciAvId": 17239,
      "gloss": "to spread (cover with spread)",
      "glossSv": "bre på",
      "pos": "action",
      "explanation": "spread + action indicator",
      "isCharacter": false,
      "composition": [
        617,
        ";",
        81
      ]
    },
    {
      "id": 2475,
      "bciAvId": 17240,
      "gloss": "spring (ckb)",
      "glossSv": "vår (CKB)",
      "pos": "noun",
      "explanation": "sun + 1: first season",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        10
      ]
    },
    {
      "id": 2476,
      "bciAvId": 17241,
      "gloss": "spring",
      "glossSv": "vår",
      "pos": "noun",
      "explanation": "sun + 1 + flower + up: first season when flowers begin to grow",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        10,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 2477,
      "bciAvId": 17242,
      "gloss": "square (shape)",
      "glossSv": "kvadrat",
      "pos": "noun",
      "explanation": "shape + enclosure (with a square shape): square, a geometric shape",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        291
      ]
    },
    {
      "id": 2478,
      "bciAvId": 17243,
      "gloss": "square (description)",
      "glossSv": "kvadratisk, fyrkantig",
      "pos": "description",
      "explanation": "square (shape) + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        651,
        "/",
        291
      ]
    },
    {
      "id": 2479,
      "bciAvId": 17245,
      "gloss": "squirrel",
      "glossSv": "ekorre",
      "pos": "noun",
      "explanation": "animal (bushy tailed) + teeth: rodent with a bushy tail",
      "isCharacter": false,
      "composition": [
        995,
        "/",
        644
      ]
    },
    {
      "id": 2480,
      "bciAvId": 17246,
      "gloss": "staff",
      "glossSv": "personal, vårdpersonal",
      "pos": "person",
      "explanation": "group (people) + to serve: group of people working to serve others",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        382
      ]
    },
    {
      "id": 2481,
      "bciAvId": 17249,
      "gloss": "to stand",
      "glossSv": "stå",
      "pos": "action",
      "explanation": "standing (standing person) + action indicator",
      "isCharacter": false,
      "composition": [
        518,
        ";",
        81
      ]
    },
    {
      "id": 2482,
      "bciAvId": 17250,
      "gloss": "stander",
      "glossSv": "tippbräda, ståstöd",
      "pos": "noun",
      "explanation": "support + medical + to stand + thing indicator: medical device for standing",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        518
      ]
    },
    {
      "id": 2483,
      "bciAvId": 17253,
      "gloss": "starfish",
      "glossSv": "sjöstjärna (FD)",
      "pos": "noun",
      "explanation": "fish + star",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        622
      ]
    },
    {
      "id": 2484,
      "bciAvId": 17254,
      "gloss": "to stay, to remain",
      "glossSv": "stanna, stå stilla",
      "pos": "action",
      "explanation": "without + to advance + action indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        335,
        ";",
        81
      ]
    },
    {
      "id": 2485,
      "bciAvId": 17256,
      "gloss": "to steam",
      "glossSv": "ånga (verb)",
      "pos": "action",
      "explanation": "steam + action indicator",
      "isCharacter": false,
      "composition": [
        623,
        ";",
        81
      ]
    },
    {
      "id": 2486,
      "bciAvId": 17258,
      "gloss": "steel",
      "glossSv": "stål",
      "pos": "noun",
      "explanation": "material + knife: the material of which knives are made",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        411
      ]
    },
    {
      "id": 2487,
      "bciAvId": 17262,
      "gloss": "sterilisation, sterilization",
      "glossSv": "sterilisering",
      "pos": "noun",
      "explanation": "to cause + infertile",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        449,
        "/",
        236
      ]
    },
    {
      "id": 2488,
      "bciAvId": 17263,
      "gloss": "stick, log",
      "glossSv": "bräda, pinne, stock (etc)",
      "pos": "noun",
      "explanation": "linear thing + tree + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        666
      ]
    },
    {
      "id": 2489,
      "bciAvId": 17264,
      "gloss": "stocking(s), sock(s), pantyhose, tights",
      "glossSv": "strumpor, strumpbyxor, sockor",
      "pos": "noun",
      "explanation": "clothing + leg and foot: clothing worn on legs and feet",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        1052
      ]
    },
    {
      "id": 2490,
      "bciAvId": 17266,
      "gloss": "stone (material)",
      "glossSv": "sten",
      "pos": "noun",
      "explanation": "material + stone",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        629
      ]
    },
    {
      "id": 2491,
      "bciAvId": 17268,
      "gloss": "to stop, to arrive, to end",
      "glossSv": "sluta, stoppa, komma fram",
      "pos": "action",
      "explanation": "end + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81
      ]
    },
    {
      "id": 2492,
      "bciAvId": 17269,
      "gloss": "store",
      "glossSv": "affär, butik (FD)",
      "pos": "noun",
      "explanation": "public room + business: public room where money is exchanged for goods",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        191
      ]
    },
    {
      "id": 2493,
      "bciAvId": 17270,
      "gloss": "storeroom",
      "glossSv": "förråd",
      "pos": "noun",
      "explanation": "room + to hold",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        239
      ]
    },
    {
      "id": 2494,
      "bciAvId": 17271,
      "gloss": "gale",
      "glossSv": "kuling",
      "pos": "noun",
      "explanation": "much + wind",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        705
      ]
    },
    {
      "id": 2495,
      "bciAvId": 17272,
      "gloss": "story, report, tale",
      "glossSv": "berättelse, historia, saga",
      "pos": "noun",
      "explanation": "page + mouth: spoken narrative. The symbol is used for story in a general sense, whether spoken, written, or printed.",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457
      ]
    },
    {
      "id": 2496,
      "bciAvId": 17274,
      "gloss": "strange",
      "glossSv": "konstig, okänd",
      "pos": "description",
      "explanation": "feeling + what,question mark + description indicator: characteristic of someone or something about which one feels doubtful",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        699
      ]
    },
    {
      "id": 2497,
      "bciAvId": 17275,
      "gloss": "stranger",
      "glossSv": "konstig person, kuf",
      "pos": "person",
      "explanation": "person + strange: person who is strange, unknown",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        699
      ]
    },
    {
      "id": 2498,
      "bciAvId": 17276,
      "gloss": "strap, string, velcro, rope, cord",
      "glossSv": "snöre, tråd (etc)",
      "pos": "noun",
      "explanation": "linear thing + to fasten + thing indicator: linear thing that fastens or joins",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        823
      ]
    },
    {
      "id": 2499,
      "bciAvId": 17277,
      "gloss": "straw, drinking straw",
      "glossSv": "sugrör",
      "pos": "noun",
      "explanation": "linear thing + drink + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        275
      ]
    },
    {
      "id": 2500,
      "bciAvId": 17442,
      "gloss": "string bean, green bean, runner bean, wax bean",
      "glossSv": "skärböna (etc)",
      "pos": "noun",
      "explanation": "bean + long",
      "isCharacter": false,
      "composition": [
        154,
        "/",
        420
      ]
    },
    {
      "id": 2501,
      "bciAvId": 17443,
      "gloss": "to stroke",
      "glossSv": "smeka, stryka, klappa",
      "pos": "action",
      "explanation": "hand + back and forth + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        144
      ]
    },
    {
      "id": 2502,
      "bciAvId": 17444,
      "gloss": "strong, powerful",
      "glossSv": "stark",
      "pos": "description",
      "explanation": "strength + description indicator: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength",
      "isCharacter": false,
      "composition": [
        967,
        ";",
        86
      ]
    },
    {
      "id": 2503,
      "bciAvId": 17446,
      "gloss": "student, pupil",
      "glossSv": "elev, studerande",
      "pos": "person",
      "explanation": "person + to learn",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        412
      ]
    },
    {
      "id": 2504,
      "bciAvId": 17447,
      "gloss": "stupid, dumb",
      "glossSv": "dum, obegåvad (FD)",
      "pos": "description",
      "explanation": "opposite meaning + smart + description indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        447,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2505,
      "bciAvId": 17448,
      "gloss": "to subtract, to remove, to take away",
      "glossSv": "dra ifrån, förlora, ta bort, subtrahera",
      "pos": "action",
      "explanation": "subtraction + action indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81
      ]
    },
    {
      "id": 2506,
      "bciAvId": 17450,
      "gloss": "to succeed",
      "glossSv": "gå bra, ha framgång, lyckas",
      "pos": "action",
      "explanation": "success + action indicator",
      "isCharacter": false,
      "composition": [
        635,
        ";",
        81
      ]
    },
    {
      "id": 2507,
      "bciAvId": 17452,
      "gloss": "suddenly, abrupt, sudden",
      "glossSv": "plötsligt",
      "pos": "description",
      "explanation": "time + lightning + description indicator: occurring as suddenly as a bolt of lightning",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        425
      ]
    },
    {
      "id": 2508,
      "bciAvId": 17453,
      "gloss": "sugar, sweetener",
      "glossSv": "socker, sötningsmedel",
      "pos": "noun",
      "explanation": "adding,additive + sweetness + thing indicator: combination of flavouring and sweet",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 2509,
      "bciAvId": 17454,
      "gloss": "to suggest, to propose",
      "glossSv": "föreslå",
      "pos": "action",
      "explanation": "suggestion + action indicator",
      "isCharacter": false,
      "composition": [
        485,
        ";",
        81,
        "/",
        551
      ]
    },
    {
      "id": 2510,
      "bciAvId": 17455,
      "gloss": "suggestion, proposal",
      "glossSv": "förslag",
      "pos": "noun",
      "explanation": "opinion + purpose",
      "isCharacter": false,
      "composition": [
        485,
        "/",
        551
      ]
    },
    {
      "id": 2511,
      "bciAvId": 17456,
      "gloss": "suit",
      "glossSv": "dräkt, kostym",
      "pos": "noun",
      "explanation": "clothing + 2 + part: two piece clothing",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        11,
        "/",
        502
      ]
    },
    {
      "id": 2512,
      "bciAvId": 17457,
      "gloss": "sukkah",
      "glossSv": "sukkah (Israel)",
      "pos": "noun",
      "explanation": "house + roof + tree + thing indicator + plural indicator: house for Sukkot",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        548,
        ";",
        97,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 2513,
      "bciAvId": 17458,
      "gloss": "Sukkot",
      "glossSv": "Sukkot (Israel)",
      "pos": "noun",
      "explanation": "week + roof + tree + thing indicator + plural indicator: week-long holiday when a ceremonial hut is built from branches",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        548,
        ";",
        97,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 2514,
      "bciAvId": 17459,
      "gloss": "summer (ckb)",
      "glossSv": "sommar (CKB)",
      "pos": "noun",
      "explanation": "sun + 2: second season",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        11
      ]
    },
    {
      "id": 2515,
      "bciAvId": 17460,
      "gloss": "summer",
      "glossSv": "sommar",
      "pos": "noun",
      "explanation": "sun + 2 + hot: second season when it is hot",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        11,
        "/",
        378
      ]
    },
    {
      "id": 2516,
      "bciAvId": 17461,
      "gloss": "summer day camp",
      "glossSv": "dagläger",
      "pos": "noun",
      "explanation": "gathering + day + summer",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        258,
        "/",
        636,
        "/",
        11,
        "/",
        378
      ]
    },
    {
      "id": 2517,
      "bciAvId": 17463,
      "gloss": "sunscreen, sunblock, sun lotion",
      "glossSv": "solkräm",
      "pos": "noun",
      "explanation": "chemical product + against + sun",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        111,
        "/",
        636
      ]
    },
    {
      "id": 2518,
      "bciAvId": 17464,
      "gloss": "Sunday",
      "glossSv": "söndag (FD)",
      "pos": "noun",
      "explanation": "day + 1: first day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        10
      ]
    },
    {
      "id": 2519,
      "bciAvId": 17465,
      "gloss": "sunny",
      "glossSv": "solig",
      "pos": "description",
      "explanation": "sun + description indicator",
      "isCharacter": false,
      "composition": [
        636,
        ";",
        86
      ]
    },
    {
      "id": 2520,
      "bciAvId": 17466,
      "gloss": "sunrise",
      "glossSv": "soluppgång",
      "pos": "noun",
      "explanation": "morning (early) + up: half sun going up",
      "isCharacter": false,
      "composition": [
        454,
        "/",
        678
      ]
    },
    {
      "id": 2521,
      "bciAvId": 17467,
      "gloss": "sunset",
      "glossSv": "solnedgång",
      "pos": "noun",
      "explanation": "morning (early) + down: half sun going down",
      "isCharacter": false,
      "composition": [
        454,
        "/",
        271
      ]
    },
    {
      "id": 2522,
      "bciAvId": 17468,
      "gloss": "supper, dinner",
      "glossSv": "middag, kvällsmål",
      "pos": "noun",
      "explanation": "meal + 3: third meal of the day",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        329,
        "/",
        12
      ]
    },
    {
      "id": 2523,
      "bciAvId": 17469,
      "gloss": "to support",
      "glossSv": "ge bidrag, finansiera",
      "pos": "action",
      "explanation": "to help + with (the help of) + money + action indicator: to provide financial support",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        81,
        "/",
        709,
        "/",
        451
      ]
    },
    {
      "id": 2524,
      "bciAvId": 17470,
      "gloss": "to surprise",
      "glossSv": "överraska (FD)",
      "pos": "action",
      "explanation": "feeling + two intensity symbols + action indicator: to produce an intense emotional reaction",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2525,
      "bciAvId": 17471,
      "gloss": "to swallow",
      "glossSv": "svälja",
      "pos": "action",
      "explanation": "down + drink,beverage + action indicator: combination of food and liquid going down",
      "isCharacter": false,
      "composition": [
        271,
        ";",
        81,
        "/",
        275
      ]
    },
    {
      "id": 2526,
      "bciAvId": 17474,
      "gloss": "to sweat, to perspire",
      "glossSv": "svettas",
      "pos": "action",
      "explanation": "sweat,perspiration + action indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        81,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 2527,
      "bciAvId": 17475,
      "gloss": "sweat, perspiration",
      "glossSv": "svett",
      "pos": "noun",
      "explanation": "liquid + skin",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 2528,
      "bciAvId": 17477,
      "gloss": "sweet (metaphor)",
      "glossSv": "söt, gullig",
      "pos": "description",
      "explanation": "metaphor + sweet + description indicator: \"sweet\" as in \"a sweet child\"",
      "isCharacter": false,
      "composition": [
        444,
        "/",
        642,
        ";",
        86,
        "/",
        678
      ]
    },
    {
      "id": 2529,
      "bciAvId": 17478,
      "gloss": "sweet (taste)",
      "glossSv": "söt",
      "pos": "description",
      "explanation": "sweetness,sweet + description indicator: pleasant taste",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        678
      ]
    },
    {
      "id": 2530,
      "bciAvId": 17479,
      "gloss": "sweet, confection",
      "glossSv": "sötsak",
      "pos": "noun",
      "explanation": "food + sweet",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 2531,
      "bciAvId": 17480,
      "gloss": "sweet potato, yam",
      "glossSv": "sötpotatis",
      "pos": "noun",
      "explanation": "vegetable (below ground) + sweet",
      "isCharacter": false,
      "composition": [
        685,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 2532,
      "bciAvId": 17481,
      "gloss": "sweetheart, lover",
      "glossSv": "älskling",
      "pos": "person",
      "explanation": "person + to love",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        431
      ]
    },
    {
      "id": 2533,
      "bciAvId": 17482,
      "gloss": "to swim",
      "glossSv": "simma",
      "pos": "action",
      "explanation": "swimming,swim + action indicator: to move through water",
      "isCharacter": false,
      "composition": [
        653,
        ";",
        81,
        "/",
        695
      ]
    },
    {
      "id": 2534,
      "bciAvId": 17483,
      "gloss": "swimming pool",
      "glossSv": "simbassäng",
      "pos": "noun",
      "explanation": "pool + swimming",
      "isCharacter": false,
      "composition": [
        539,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 2535,
      "bciAvId": 17484,
      "gloss": "swimsuit, swimwear, bathing suit",
      "glossSv": "badbyxor, baddräkt",
      "pos": "noun",
      "explanation": "clothing + comma + to swim",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 2536,
      "bciAvId": 17485,
      "gloss": "swing",
      "glossSv": "gunga (subst.)",
      "pos": "noun",
      "explanation": "swing,swinging + thing indicator: thing to swing upon",
      "isCharacter": false,
      "composition": [
        989,
        ";",
        97
      ]
    },
    {
      "id": 2537,
      "bciAvId": 17486,
      "gloss": "to swing, to sway, to rock",
      "glossSv": "gunga (verb)",
      "pos": "action",
      "explanation": "swing,swinging + action indicator",
      "isCharacter": false,
      "composition": [
        989,
        ";",
        81
      ]
    },
    {
      "id": 2538,
      "bciAvId": 17487,
      "gloss": "handle, switch",
      "glossSv": "handtag",
      "pos": "noun",
      "explanation": "thing + hand: thing operated by the hand",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        374
      ]
    },
    {
      "id": 2539,
      "bciAvId": 17488,
      "gloss": "to switch",
      "glossSv": "sätta på",
      "pos": "action",
      "explanation": "handle + action indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        374
      ]
    },
    {
      "id": 2540,
      "bciAvId": 17489,
      "gloss": "symbol display, symbol board, symbol chart",
      "glossSv": "blisskarta, symbolkarta",
      "pos": "noun",
      "explanation": "paper + plus + Blissymbol",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        120,
        "/",
        167
      ]
    },
    {
      "id": 2541,
      "bciAvId": 17490,
      "gloss": "synagogue",
      "glossSv": "synagoga",
      "pos": "noun",
      "explanation": "house + commandments: building for Jewish religious services and instruction",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        235
      ]
    },
    {
      "id": 2542,
      "bciAvId": 17491,
      "gloss": "syringe",
      "glossSv": "spruta",
      "pos": "noun",
      "explanation": "injection + thing indicator",
      "isCharacter": false,
      "composition": [
        399,
        ";",
        97
      ]
    },
    {
      "id": 2543,
      "bciAvId": 17492,
      "gloss": "table game",
      "glossSv": "sällskapsspel",
      "pos": "noun",
      "explanation": "to play + table: enjoyable activity that uses a table",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678,
        "/",
        639
      ]
    },
    {
      "id": 2544,
      "bciAvId": 17494,
      "gloss": "tablecloth",
      "glossSv": "duk",
      "pos": "noun",
      "explanation": "cloth + table",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        639
      ]
    },
    {
      "id": 2545,
      "bciAvId": 17495,
      "gloss": "tahini, sesame seed spread",
      "glossSv": "tahini, sesampasta",
      "pos": "noun",
      "explanation": "spread + seed + white: Middle Eastern food, used rather like peanut butter",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        584,
        "/",
        1161,
        "/",
        604
      ]
    },
    {
      "id": 2546,
      "bciAvId": 17497,
      "gloss": "to take, to bring, to carry, to move",
      "glossSv": "bära, ta med",
      "pos": "action",
      "explanation": "portability + action indicator",
      "isCharacter": false,
      "composition": [
        917,
        ";",
        81
      ]
    },
    {
      "id": 2547,
      "bciAvId": 17498,
      "gloss": "to take away, to remove",
      "glossSv": "ta bort",
      "pos": "action",
      "explanation": "hand + to take away + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        634
      ]
    },
    {
      "id": 2548,
      "bciAvId": 17499,
      "gloss": "takeoff, take-off, airplane take-off",
      "glossSv": "start (flyg)",
      "pos": "noun",
      "explanation": "airplane + upward and forward",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        "RK:-2",
        "/",
        680
      ]
    },
    {
      "id": 2549,
      "bciAvId": 17500,
      "gloss": "talcum powder",
      "glossSv": "talkpuder",
      "pos": "noun",
      "explanation": "powder + body",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        171
      ]
    },
    {
      "id": 2550,
      "bciAvId": 17501,
      "gloss": "tallith",
      "glossSv": "tallit (Israel)",
      "pos": "noun",
      "explanation": "clothing + comma + to pray + Jewish",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        5,
        "/",
        457,
        "/",
        657,
        "/",
        355,
        "/",
        621
      ]
    },
    {
      "id": 2551,
      "bciAvId": 17502,
      "gloss": "Tammuz",
      "glossSv": "Tamuz (Israel)",
      "pos": "noun",
      "explanation": "month + summer: month that is the heart of summer",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        636,
        "/",
        11,
        "/",
        195,
        "/",
        319,
        "/",
        102
      ]
    },
    {
      "id": 2552,
      "bciAvId": 17503,
      "gloss": "tangerine, clementine, mandarin",
      "glossSv": "klementin (etc)",
      "pos": "noun",
      "explanation": "citrus fruit + little",
      "isCharacter": false,
      "composition": [
        489,
        "/",
        956
      ]
    },
    {
      "id": 2553,
      "bciAvId": 17505,
      "gloss": "sound recorder, tape recorder",
      "glossSv": "bandspelare",
      "pos": "noun",
      "explanation": "machine + to reproduce + ear: machine to reproduce material for listening",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        963,
        "/",
        278
      ]
    },
    {
      "id": 2554,
      "bciAvId": 17507,
      "gloss": "to taste",
      "glossSv": "smaka",
      "pos": "action",
      "explanation": "taste + action indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        81
      ]
    },
    {
      "id": 2555,
      "bciAvId": 17509,
      "gloss": "taxi, cab",
      "glossSv": "taxi, hyrbil",
      "pos": "noun",
      "explanation": "car + limited time: car hired for a short time",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        426
      ]
    },
    {
      "id": 2556,
      "bciAvId": 17510,
      "gloss": "taxi driver, cab driver",
      "glossSv": "taxichaufför",
      "pos": "person",
      "explanation": "person + taxi",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        202,
        "/",
        426
      ]
    },
    {
      "id": 2557,
      "bciAvId": 17511,
      "gloss": "tea",
      "glossSv": "te",
      "pos": "noun",
      "explanation": "drink + leaf: drink made from tea leaves",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        416
      ]
    },
    {
      "id": 2558,
      "bciAvId": 17512,
      "gloss": "to teach, to instruct",
      "glossSv": "lära ut, undervisa",
      "pos": "action",
      "explanation": "to give + knowledge + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        412
      ]
    },
    {
      "id": 2559,
      "bciAvId": 17513,
      "gloss": "teacher, instructor",
      "glossSv": "lärare, instruktör",
      "pos": "person",
      "explanation": "person + to teach",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        949,
        "/",
        412
      ]
    },
    {
      "id": 2560,
      "bciAvId": 17514,
      "gloss": "team",
      "glossSv": "arbetslag, team, arbetsgrupp",
      "pos": "person",
      "explanation": "group (people) + to work + together: group that works together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        711,
        "/",
        823
      ]
    },
    {
      "id": 2561,
      "bciAvId": 17515,
      "gloss": "to tease",
      "glossSv": "reta",
      "pos": "action",
      "explanation": "to act + upset + action indicator: to act in a way that upsets someone",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        723
      ]
    },
    {
      "id": 2562,
      "bciAvId": 17518,
      "gloss": "telephone, call",
      "glossSv": "telefon",
      "pos": "noun",
      "explanation": "language + electricity: electrical device for speaking and listening",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288
      ]
    },
    {
      "id": 2563,
      "bciAvId": 17519,
      "gloss": "television",
      "glossSv": "tv",
      "pos": "noun",
      "explanation": "enclosure + eye + ear + electricity: box for seeing and hearing by a means of electricity",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        303,
        "/",
        278,
        "/",
        288
      ]
    },
    {
      "id": 2564,
      "bciAvId": 17521,
      "gloss": "ten o'clock eating break",
      "glossSv": "ten o'clock eating break (Israel)",
      "pos": "noun",
      "explanation": "food + time + 10",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        655,
        "/",
        10,
        "/",
        9
      ]
    },
    {
      "id": 2565,
      "bciAvId": 17522,
      "gloss": "tennis (activity)",
      "glossSv": "tennis (FD)",
      "pos": "noun",
      "explanation": "activity + crossed racquets: game played with racquets",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        1016
      ]
    },
    {
      "id": 2566,
      "bciAvId": 17523,
      "gloss": "tent",
      "glossSv": "tält",
      "pos": "noun",
      "explanation": "house + cloth: shelter made of cloth",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        228
      ]
    },
    {
      "id": 2567,
      "bciAvId": 17524,
      "gloss": "termite, wood destroying insect",
      "glossSv": "termit",
      "pos": "noun",
      "explanation": "insect + tree or wood destruction: insect that destroys trees or wood",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        1100
      ]
    },
    {
      "id": 2568,
      "bciAvId": 17525,
      "gloss": "terrified",
      "glossSv": "skräckslagen, vettskrämd",
      "pos": "description",
      "explanation": "terror + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        271,
        "/",
        1042,
        "/",
        401
      ]
    },
    {
      "id": 2569,
      "bciAvId": 17526,
      "gloss": "terrorist",
      "glossSv": "terrorist",
      "pos": "person",
      "explanation": "person + terrorism",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        206,
        "/",
        313,
        "/",
        271,
        "/",
        1042,
        "/",
        401
      ]
    },
    {
      "id": 2570,
      "bciAvId": 17527,
      "gloss": "to terrorise - (to), to terrorize",
      "glossSv": "terrorisera",
      "pos": "action",
      "explanation": "terrorism + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        271,
        "/",
        1042,
        "/",
        401
      ]
    },
    {
      "id": 2571,
      "bciAvId": 17528,
      "gloss": "test, assessment, exam",
      "glossSv": "prov, test",
      "pos": "noun",
      "explanation": "question + for (the purpose of) + evaluation",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        332,
        "/",
        "RK:-2",
        "/",
        297
      ]
    },
    {
      "id": 2572,
      "bciAvId": 17529,
      "gloss": "testicle",
      "glossSv": "testikel",
      "pos": "noun",
      "explanation": "container + sperm",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        612
      ]
    },
    {
      "id": 2573,
      "bciAvId": 17530,
      "gloss": "Tevet",
      "glossSv": "Tevet (Israel)",
      "pos": "noun",
      "explanation": "month + winter: month of rain, typifying winter",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        636,
        "/",
        13,
        "/",
        556
      ]
    },
    {
      "id": 2574,
      "bciAvId": 17531,
      "gloss": "tefillin",
      "glossSv": "tfillim (Israel)",
      "pos": "noun",
      "explanation": "2 + box + part + Torah: two boxes with part of Torah",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        177,
        "/",
        502,
        "/",
        663
      ]
    },
    {
      "id": 2575,
      "bciAvId": 17532,
      "gloss": "to thank",
      "glossSv": "tacka",
      "pos": "action",
      "explanation": "thanks + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        949
      ]
    },
    {
      "id": 2576,
      "bciAvId": 17533,
      "gloss": "thanks, thank you",
      "glossSv": "tack",
      "pos": "function",
      "explanation": "feeling + to give: polite phrase used to express gratitude to another",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        949
      ]
    },
    {
      "id": 2577,
      "bciAvId": 17534,
      "gloss": "thanksgiving",
      "glossSv": "tacksägelsedagen",
      "pos": "noun",
      "explanation": "day + thanks: day for giving thanks",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        313,
        "/",
        949
      ]
    },
    {
      "id": 2578,
      "bciAvId": 17698,
      "gloss": "too bad, I'm sorry, I'm so sorry",
      "glossSv": "tyvärr",
      "pos": "function",
      "explanation": "sad + about",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        102
      ]
    },
    {
      "id": 2579,
      "bciAvId": 17699,
      "gloss": "to thaw, to melt",
      "glossSv": "smälta, tina",
      "pos": "action",
      "explanation": "thawing,melting + action indicator: solid ice turns into water",
      "isCharacter": false,
      "composition": [
        1095,
        ";",
        81
      ]
    },
    {
      "id": 2580,
      "bciAvId": 17701,
      "gloss": "their, theirs - (persons)",
      "glossSv": "deras, sin, sitt, sina",
      "pos": "person",
      "explanation": "they + belongs to + plural indicator",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 2581,
      "bciAvId": 17702,
      "gloss": "their, theirs - (indefinite)",
      "glossSv": "deras, sin, sitt, sina (opersonligt)",
      "pos": "expression",
      "explanation": "its + plural indicator: refers to things rather than to people",
      "isCharacter": false,
      "composition": [
        405,
        ";",
        99,
        "/",
        160
      ]
    },
    {
      "id": 2582,
      "bciAvId": 17703,
      "gloss": "their, theirs - (feminine plural)",
      "glossSv": "deras, sin, sitt, sina (fem.)",
      "pos": "person",
      "explanation": "female + 3 + belongs to + plural indicator: third person (f. pl.)",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 2583,
      "bciAvId": 17704,
      "gloss": "their, theirs - (masculine plural)",
      "glossSv": "deras, sin, sitt, sina (mask.)",
      "pos": "person",
      "explanation": "male + 3 + belongs to + plural indicator: third person (m.pl.)",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        12,
        "/",
        160
      ]
    },
    {
      "id": 2584,
      "bciAvId": 17706,
      "gloss": "therapist",
      "glossSv": "terapeut (FD)",
      "pos": "person",
      "explanation": "therapy + forward + person: person working cooperatively with another person to produce one free-standing person",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        "RK:-2",
        "/",
        335,
        "/",
        513
      ]
    },
    {
      "id": 2585,
      "bciAvId": 17709,
      "gloss": "thermometer",
      "glossSv": "termometer",
      "pos": "noun",
      "explanation": "temperature + thing indicator: The symbol is the concrete form of temperature",
      "isCharacter": false,
      "composition": [
        645,
        ";",
        97
      ]
    },
    {
      "id": 2586,
      "bciAvId": 17710,
      "gloss": "thermos, cooler, flask",
      "glossSv": "termos, kylväska (etc)",
      "pos": "noun",
      "explanation": "container + same + temperature: container that keeps food or drink at a constant temperature for several hours",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        578,
        "/",
        645
      ]
    },
    {
      "id": 2587,
      "bciAvId": 17711,
      "gloss": "these",
      "glossSv": "de här, dom här, dessa",
      "pos": "expression",
      "explanation": "this + plural indicator",
      "isCharacter": false,
      "composition": [
        652,
        ";",
        99
      ]
    },
    {
      "id": 2588,
      "bciAvId": 17712,
      "gloss": "they, them, themselves - (indefinite)",
      "glossSv": "de, dem, sig (obestämd plur)",
      "pos": "expression",
      "explanation": "it,itself + plural indicator: refers to things rather than to people",
      "isCharacter": false,
      "composition": [
        405,
        ";",
        99
      ]
    },
    {
      "id": 2589,
      "bciAvId": 17713,
      "gloss": "they, them, themselves - (persons)",
      "glossSv": "de, dem, sig (plur.)",
      "pos": "person",
      "explanation": "person + 3 + plural indicator: third person plural",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        12
      ]
    },
    {
      "id": 2590,
      "bciAvId": 17714,
      "gloss": "they, them, themselves - (feminine plural)",
      "glossSv": "de, dem, sig (fem. plur)",
      "pos": "person",
      "explanation": "female + 3 + plural indicator",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        12
      ]
    },
    {
      "id": 2591,
      "bciAvId": 17715,
      "gloss": "they, them, themselves - (masculine plural)",
      "glossSv": "de, dem, sig (mask. plur.)",
      "pos": "person",
      "explanation": "male + 3 + plural indicator",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        12
      ]
    },
    {
      "id": 2592,
      "bciAvId": 17716,
      "gloss": "thin, slim, narrow",
      "glossSv": "smal, tunn",
      "pos": "description",
      "explanation": "thinness,narrowness + description indicator: the pointers point inward toward the narrow space formed by the reference lines",
      "isCharacter": false,
      "composition": [
        1096,
        ";",
        86
      ]
    },
    {
      "id": 2593,
      "bciAvId": 17718,
      "gloss": "to think, to reason",
      "glossSv": "tänka, tycka, tro",
      "pos": "action",
      "explanation": "mind + action indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        81
      ]
    },
    {
      "id": 2594,
      "bciAvId": 17719,
      "gloss": "thirsty",
      "glossSv": "törstig",
      "pos": "description",
      "explanation": "feeling + minus + drink + description indicator: having a feeling caused by the lack of drink",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        275
      ]
    },
    {
      "id": 2595,
      "bciAvId": 17721,
      "gloss": "this week",
      "glossSv": "den här veckan",
      "pos": "noun",
      "explanation": "week + now",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        474
      ]
    },
    {
      "id": 2596,
      "bciAvId": 17722,
      "gloss": "this year",
      "glossSv": "i år",
      "pos": "noun",
      "explanation": "year + now",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        474
      ]
    },
    {
      "id": 2597,
      "bciAvId": 17723,
      "gloss": "those",
      "glossSv": "de där, dom där, de, dom",
      "pos": "expression",
      "explanation": "that + plural indicator",
      "isCharacter": false,
      "composition": [
        646,
        ";",
        99
      ]
    },
    {
      "id": 2598,
      "bciAvId": 17725,
      "gloss": "to throw",
      "glossSv": "kasta",
      "pos": "action",
      "explanation": "hand + to give + intensity + action indicator: to discharge into the air with a swift motion of the arm",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        949,
        "/",
        401
      ]
    },
    {
      "id": 2599,
      "bciAvId": 17727,
      "gloss": "thunder",
      "glossSv": "åska",
      "pos": "noun",
      "explanation": "ear + lightning: sound that accompanies lightning",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        425
      ]
    },
    {
      "id": 2600,
      "bciAvId": 17728,
      "gloss": "Thursday",
      "glossSv": "torsdag (FD)",
      "pos": "noun",
      "explanation": "day + 5: fifth day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        14
      ]
    },
    {
      "id": 2601,
      "bciAvId": 17729,
      "gloss": "ticket, pass",
      "glossSv": "biljett",
      "pos": "noun",
      "explanation": "paper + to enter: piece of paper that allows you to enter",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        402
      ]
    },
    {
      "id": 2602,
      "bciAvId": 17730,
      "gloss": "tie, necktie",
      "glossSv": "slips",
      "pos": "noun",
      "explanation": "linear thing + neck + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        465
      ]
    },
    {
      "id": 2603,
      "bciAvId": 17731,
      "gloss": "tiger",
      "glossSv": "tiger",
      "pos": "noun",
      "explanation": "feline + stripe",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        428
      ]
    },
    {
      "id": 2604,
      "bciAvId": 17733,
      "gloss": "to tiptoe",
      "glossSv": "gå på tå, trippa",
      "pos": "action",
      "explanation": "toe + action indicator: to walk on one's toes",
      "isCharacter": false,
      "composition": [
        658,
        ";",
        81
      ]
    },
    {
      "id": 2605,
      "bciAvId": 17735,
      "gloss": "tired, exhausted, weary",
      "glossSv": "trött",
      "pos": "description",
      "explanation": "rest + to need + description after the fact indicator: feeling in need of rest",
      "isCharacter": false,
      "composition": [
        562,
        ";",
        84,
        "/",
        467
      ]
    },
    {
      "id": 2606,
      "bciAvId": 17736,
      "gloss": "Tisha B'Av",
      "glossSv": "Tisha B'Av (Israel)",
      "pos": "noun",
      "explanation": "day + temple ruin: day of temple destruction",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        1079,
        "/",
        355
      ]
    },
    {
      "id": 2607,
      "bciAvId": 17737,
      "gloss": "Tishri",
      "glossSv": "Tishrai (Israel)",
      "pos": "noun",
      "explanation": "month + shofar: month of Rosh Hashana",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        389,
        "/",
        621
      ]
    },
    {
      "id": 2608,
      "bciAvId": 17738,
      "gloss": "tissue",
      "glossSv": "pappersnäsduk",
      "pos": "noun",
      "explanation": "paper + nose",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        473
      ]
    },
    {
      "id": 2609,
      "bciAvId": 17740,
      "gloss": "toast",
      "glossSv": "rostat bröd",
      "pos": "noun",
      "explanation": "bread surface + fire: bread browned on both sides",
      "isCharacter": false,
      "composition": [
        1004,
        "/",
        319
      ]
    },
    {
      "id": 2610,
      "bciAvId": 17741,
      "gloss": "to toast",
      "glossSv": "rosta bröd",
      "pos": "action",
      "explanation": "fire + bread surface + action indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        1004
      ]
    },
    {
      "id": 2611,
      "bciAvId": 17742,
      "gloss": "toaster",
      "glossSv": "brödrost",
      "pos": "noun",
      "explanation": "machine + to toast",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        319,
        "/",
        1004
      ]
    },
    {
      "id": 2612,
      "bciAvId": 17743,
      "gloss": "tobacco",
      "glossSv": "tobak",
      "pos": "noun",
      "explanation": "leaf + to smoke: leaf used for smoking",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        1085
      ]
    },
    {
      "id": 2613,
      "bciAvId": 17744,
      "gloss": "today",
      "glossSv": "idag",
      "pos": "noun",
      "explanation": "day + now",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        474
      ]
    },
    {
      "id": 2614,
      "bciAvId": 17746,
      "gloss": "together, attached, appended, fastened, joined",
      "glossSv": "tillsammans, ihop",
      "pos": "description",
      "explanation": "attachment,fastening,joint,seam,appendix,annex + description indicator",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        86
      ]
    },
    {
      "id": 2615,
      "bciAvId": 17748,
      "gloss": "toilet paper",
      "glossSv": "toalettpapper",
      "pos": "noun",
      "explanation": "paper + toilet",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        659
      ]
    },
    {
      "id": 2616,
      "bciAvId": 17749,
      "gloss": "tomato",
      "glossSv": "tomat",
      "pos": "noun",
      "explanation": "vegetable (above ground) + red",
      "isCharacter": false,
      "composition": [
        684,
        "/",
        1161,
        "/",
        457
      ]
    },
    {
      "id": 2617,
      "bciAvId": 17750,
      "gloss": "tomorrow",
      "glossSv": "imorgon",
      "pos": "noun",
      "explanation": "day + then (future)",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        648
      ]
    },
    {
      "id": 2618,
      "bciAvId": 17751,
      "gloss": "tomorrow night",
      "glossSv": "imorgon natt",
      "pos": "noun",
      "explanation": "night + then (future)",
      "isCharacter": false,
      "composition": [
        470,
        "/",
        648
      ]
    },
    {
      "id": 2619,
      "bciAvId": 17752,
      "gloss": "tongue",
      "glossSv": "tunga",
      "pos": "noun",
      "explanation": "part of + mouth + up and down: the part of the mouth that moves up and down",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        457,
        "/",
        723
      ]
    },
    {
      "id": 2620,
      "bciAvId": 17753,
      "gloss": "tonight",
      "glossSv": "inatt",
      "pos": "noun",
      "explanation": "night + now",
      "isCharacter": false,
      "composition": [
        470,
        "/",
        474
      ]
    },
    {
      "id": 2621,
      "bciAvId": 17754,
      "gloss": "too much, too many",
      "glossSv": "för mycket, för många",
      "pos": "description",
      "explanation": "over + much/many + description indicator: over the amount or number needed",
      "isCharacter": false,
      "composition": [
        493,
        "/",
        368,
        ";",
        86
      ]
    },
    {
      "id": 2622,
      "bciAvId": 17756,
      "gloss": "toothbrush",
      "glossSv": "tandborste",
      "pos": "noun",
      "explanation": "brush + teeth",
      "isCharacter": false,
      "composition": [
        184,
        "/",
        644
      ]
    },
    {
      "id": 2623,
      "bciAvId": 17757,
      "gloss": "toothpaste",
      "glossSv": "tandkräm",
      "pos": "noun",
      "explanation": "chemical product + brush + teeth: chemical product for brushing teeth",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        184,
        "/",
        644
      ]
    },
    {
      "id": 2624,
      "bciAvId": 17761,
      "gloss": "to touch, to feel",
      "glossSv": "röra, beröra, känna",
      "pos": "action",
      "explanation": "hand + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81
      ]
    },
    {
      "id": 2625,
      "bciAvId": 17762,
      "gloss": "towel",
      "glossSv": "handduk (FD)",
      "pos": "noun",
      "explanation": "cloth + dry (OLD)",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        486,
        "/",
        695
      ]
    },
    {
      "id": 2626,
      "bciAvId": 17763,
      "gloss": "toy",
      "glossSv": "leksak",
      "pos": "noun",
      "explanation": "thing + play: a plaything",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2627,
      "bciAvId": 17764,
      "gloss": "toy animal, stuffed animal",
      "glossSv": "leksaksdjur",
      "pos": "noun",
      "explanation": "animal + man-made",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        840
      ]
    },
    {
      "id": 2628,
      "bciAvId": 17766,
      "gloss": "traffic",
      "glossSv": "trafik",
      "pos": "noun",
      "explanation": "many + car",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        202
      ]
    },
    {
      "id": 2629,
      "bciAvId": 17767,
      "gloss": "train",
      "glossSv": "tåg",
      "pos": "noun",
      "explanation": "many + railway car: many connected railway cars",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        688
      ]
    },
    {
      "id": 2630,
      "bciAvId": 17768,
      "gloss": "trampoline",
      "glossSv": "studsmatta, trampolin (etc)",
      "pos": "noun",
      "explanation": "platform + to jump",
      "isCharacter": false,
      "composition": [
        639,
        "/",
        836
      ]
    },
    {
      "id": 2631,
      "bciAvId": 17769,
      "gloss": "to translate",
      "glossSv": "översätta",
      "pos": "action",
      "explanation": "bridge + language + action indicator: to form a bridge of understanding between languages",
      "isCharacter": false,
      "composition": [
        182,
        ";",
        81,
        "/",
        414
      ]
    },
    {
      "id": 2632,
      "bciAvId": 17770,
      "gloss": "transvestite (female)",
      "glossSv": "transvestit (kvinna)",
      "pos": "person",
      "explanation": "woman + to dress + man: woman who dresses like a man",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        229,
        "/",
        433
      ]
    },
    {
      "id": 2633,
      "bciAvId": 17771,
      "gloss": "transvestite (male)",
      "glossSv": "transvestit (man)",
      "pos": "person",
      "explanation": "man + to dress + woman: man who dresses like a woman",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        229,
        "/",
        710
      ]
    },
    {
      "id": 2634,
      "bciAvId": 17772,
      "gloss": "to travel",
      "glossSv": "resa (verb)",
      "pos": "action",
      "explanation": "trip + action indicator",
      "isCharacter": false,
      "composition": [
        667,
        ";",
        81
      ]
    },
    {
      "id": 2635,
      "bciAvId": 17774,
      "gloss": "treat",
      "glossSv": "nöje, upplevelse, belöning",
      "pos": "noun",
      "explanation": "thing + special: a thing or occurrence that causes special pleasure or delight",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313,
        "/",
        954
      ]
    },
    {
      "id": 2636,
      "bciAvId": 17776,
      "gloss": "triangle",
      "glossSv": "triangel",
      "pos": "noun",
      "explanation": "shape + triangular shape: triangle, a geometric shape",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        247
      ]
    },
    {
      "id": 2637,
      "bciAvId": 17777,
      "gloss": "triangular",
      "glossSv": "trekantig",
      "pos": "description",
      "explanation": "triangle + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        651,
        "/",
        247
      ]
    },
    {
      "id": 2638,
      "bciAvId": 17778,
      "gloss": "tricycle",
      "glossSv": "trehjuling",
      "pos": "noun",
      "explanation": "3 + wheel: three-wheeled cycle",
      "isCharacter": false,
      "composition": [
        12,
        "/",
        700
      ]
    },
    {
      "id": 2639,
      "bciAvId": 17780,
      "gloss": "trouble",
      "glossSv": "besvär",
      "pos": "noun",
      "explanation": "feeling + opposing forces,counter-forces: feeling of being beset by opposing forces",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        1063
      ]
    },
    {
      "id": 2640,
      "bciAvId": 17782,
      "gloss": "true, truly, truthful, truthfully",
      "glossSv": "sann",
      "pos": "description",
      "explanation": "truth + description indicator",
      "isCharacter": false,
      "composition": [
        670,
        ";",
        86
      ]
    },
    {
      "id": 2641,
      "bciAvId": 17784,
      "gloss": "to trust",
      "glossSv": "lita på",
      "pos": "action",
      "explanation": "trust + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        486,
        "/",
        802
      ]
    },
    {
      "id": 2642,
      "bciAvId": 17785,
      "gloss": "trust, confidence",
      "glossSv": "förtroende, tillit",
      "pos": "noun",
      "explanation": "feeling + certain",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        486,
        "/",
        802
      ]
    },
    {
      "id": 2643,
      "bciAvId": 17787,
      "gloss": "to try, to attempt",
      "glossSv": "försöka, pröva",
      "pos": "action",
      "explanation": "attempt,effort,try + action indicator: to move forward with difficulty",
      "isCharacter": false,
      "composition": [
        5640,
        ";",
        81
      ]
    },
    {
      "id": 2644,
      "bciAvId": 17788,
      "gloss": "Tu Bishvat",
      "glossSv": "Tu Bishvat, Tu B'Shvat",
      "pos": "noun",
      "explanation": "day + birth + tree + plural indicator",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        166,
        "/",
        666,
        ";",
        99
      ]
    },
    {
      "id": 2645,
      "bciAvId": 17789,
      "gloss": "tubal ligation",
      "glossSv": "sterilisering (kvinna)",
      "pos": "noun",
      "explanation": "operation + fallopian tube",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        958,
        "/",
        866,
        "/",
        285
      ]
    },
    {
      "id": 2646,
      "bciAvId": 17790,
      "gloss": "Tuesday",
      "glossSv": "tisdag (FD)",
      "pos": "noun",
      "explanation": "day + 3: third day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        12
      ]
    },
    {
      "id": 2647,
      "bciAvId": 17953,
      "gloss": "tune, melody",
      "glossSv": "melodi, musikstycke",
      "pos": "noun",
      "explanation": "plan + musical note: planned sequence of notes",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        462
      ]
    },
    {
      "id": 2648,
      "bciAvId": 17954,
      "gloss": "turkey (bird)",
      "glossSv": "kalkon",
      "pos": "noun",
      "explanation": "bird + food + big: large bird used for food",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        329,
        "/",
        936
      ]
    },
    {
      "id": 2649,
      "bciAvId": 17955,
      "gloss": "turkey (food)",
      "glossSv": "kalkon (mat)",
      "pos": "noun",
      "explanation": "food + bird + big: turkey as a dish",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        163,
        "/",
        936
      ]
    },
    {
      "id": 2650,
      "bciAvId": 17956,
      "gloss": "turn, play",
      "glossSv": "tur, turordning",
      "pos": "noun",
      "explanation": "time + activity: person's time to do something",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        106
      ]
    },
    {
      "id": 2651,
      "bciAvId": 17957,
      "gloss": "to turn",
      "glossSv": "svänga, vända",
      "pos": "action",
      "explanation": "turn,turning + action indicator",
      "isCharacter": false,
      "composition": [
        1101,
        ";",
        81
      ]
    },
    {
      "id": 2652,
      "bciAvId": 17960,
      "gloss": "to twinkle, to shine, to sparkle",
      "glossSv": "lysa, stråla, blinka",
      "pos": "action",
      "explanation": "star + action indicator",
      "isCharacter": false,
      "composition": [
        622,
        ";",
        81
      ]
    },
    {
      "id": 2653,
      "bciAvId": 17962,
      "gloss": "printer, typewriter",
      "glossSv": "skrivare, skrivmaskin",
      "pos": "noun",
      "explanation": "machine + to write",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        509
      ]
    },
    {
      "id": 2654,
      "bciAvId": 17963,
      "gloss": "ugh, yuk - (exclamatory)",
      "glossSv": "urdålig, botten (etc)",
      "pos": "function",
      "explanation": "to speak + bad + description indicator: expressing a bad or negative feeling about something.The symbol does not have a specific word equivalent: it can represent ugh!, yuk! or similar negative expressions.",
      "isCharacter": false,
      "composition": [
        970,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 2655,
      "bciAvId": 17964,
      "gloss": "ugly, unattractive",
      "glossSv": "ful",
      "pos": "description",
      "explanation": "eye + sad + description indicator: displeasing to the eye",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        313,
        "/",
        271
      ]
    },
    {
      "id": 2656,
      "bciAvId": 17965,
      "gloss": "umbilical cord",
      "glossSv": "navelsträng",
      "pos": "noun",
      "explanation": "tube + fetus",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        316
      ]
    },
    {
      "id": 2657,
      "bciAvId": 17968,
      "gloss": "uncomfortable",
      "glossSv": "obehaglig, obekväm",
      "pos": "description",
      "explanation": "discomfort + description indicator",
      "isCharacter": false,
      "composition": [
        264,
        ";",
        86
      ]
    },
    {
      "id": 2658,
      "bciAvId": 17970,
      "gloss": "bomb shelter",
      "glossSv": "skyddsrum under jord",
      "pos": "noun",
      "explanation": "shelter + under",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        548,
        "/",
        676
      ]
    },
    {
      "id": 2659,
      "bciAvId": 17971,
      "gloss": "underpants, briefs, panties",
      "glossSv": "kalsonger, trosor",
      "pos": "noun",
      "explanation": "pants + under",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        417,
        "/",
        676
      ]
    },
    {
      "id": 2660,
      "bciAvId": 17972,
      "gloss": "undershirt",
      "glossSv": "linne, undertröja",
      "pos": "noun",
      "explanation": "shirt + under",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        218,
        "/",
        676
      ]
    },
    {
      "id": 2661,
      "bciAvId": 17973,
      "gloss": "to understand, to see",
      "glossSv": "förstå",
      "pos": "action",
      "explanation": "understanding,comprehension + action indicator: to enter into one's store of knowledge",
      "isCharacter": false,
      "composition": [
        1103,
        ";",
        81
      ]
    },
    {
      "id": 2662,
      "bciAvId": 17974,
      "gloss": "underwear, underclothes",
      "glossSv": "underkläder",
      "pos": "noun",
      "explanation": "clothing + under: clothing worn under other clothing",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        676
      ]
    },
    {
      "id": 2663,
      "bciAvId": 17975,
      "gloss": "unemployment",
      "glossSv": "arbetslöshet",
      "pos": "noun",
      "explanation": "without + work",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        711
      ]
    },
    {
      "id": 2664,
      "bciAvId": 17976,
      "gloss": "to unfold",
      "glossSv": "veckla ut, vika upp (FD)",
      "pos": "action",
      "explanation": "opposite meaning + to fold + action indicator",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        1038,
        ";",
        81
      ]
    },
    {
      "id": 2665,
      "bciAvId": 17977,
      "gloss": "unidentified object (suspected explosive)",
      "glossSv": "oidentifierat föremål (misstänkt bomb)",
      "pos": "noun",
      "explanation": "explosive + maybe",
      "isCharacter": false,
      "composition": [
        302,
        "/",
        894,
        "/",
        699
      ]
    },
    {
      "id": 2666,
      "bciAvId": 17978,
      "gloss": "unit, example, sample, for example, e.g.",
      "glossSv": "exemplar",
      "pos": "noun",
      "explanation": "1 + thing indicator: a single item",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97
      ]
    },
    {
      "id": 2667,
      "bciAvId": 17979,
      "gloss": "United Kingdom",
      "glossSv": "Storbritannien",
      "pos": "noun",
      "explanation": "country + Union Jack pattern",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        1105
      ]
    },
    {
      "id": 2668,
      "bciAvId": 17980,
      "gloss": "university",
      "glossSv": "högskola, universitet",
      "pos": "noun",
      "explanation": "building + to exchange + knowledge",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 2669,
      "bciAvId": 17981,
      "gloss": "unless, except (conjunction)",
      "glossSv": "utom",
      "pos": "expression",
      "explanation": "but + or",
      "isCharacter": false,
      "composition": [
        192,
        "/",
        488
      ]
    },
    {
      "id": 2671,
      "bciAvId": 17985,
      "gloss": "upset",
      "glossSv": "upprörd",
      "pos": "description",
      "explanation": "upset,disturbance,agitation + description indicator: having unsettled feelings",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        723
      ]
    },
    {
      "id": 2672,
      "bciAvId": 17988,
      "gloss": "urethra",
      "glossSv": "urinrör",
      "pos": "noun",
      "explanation": "tube + urine",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        694,
        "/",
        349
      ]
    },
    {
      "id": 2673,
      "bciAvId": 17989,
      "gloss": "to urinate, to make water, to pass water, to micturate, to pee, to piddle, to piss, to wee",
      "glossSv": "kissa, kasta vatten",
      "pos": "action",
      "explanation": "urine + action indicator",
      "isCharacter": false,
      "composition": [
        694,
        ";",
        81,
        "/",
        349
      ]
    },
    {
      "id": 2674,
      "bciAvId": 17990,
      "gloss": "urine, piss, pee, piddle, weewee, water",
      "glossSv": "urin, kiss",
      "pos": "noun",
      "explanation": "waste + genitals",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        349
      ]
    },
    {
      "id": 2675,
      "bciAvId": 17991,
      "gloss": "to use",
      "glossSv": "använda",
      "pos": "action",
      "explanation": "usage,use + action indicator: to manipulate a tool rationally",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        81
      ]
    },
    {
      "id": 2676,
      "bciAvId": 17992,
      "gloss": "usually, usual",
      "glossSv": "oftast, vanligen",
      "pos": "description",
      "explanation": "most + time + description indicator: on most occasions",
      "isCharacter": false,
      "composition": [
        968,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 2677,
      "bciAvId": 17993,
      "gloss": "utensil",
      "glossSv": "köksredskap",
      "pos": "noun",
      "explanation": "tool + food",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        329
      ]
    },
    {
      "id": 2678,
      "bciAvId": 17995,
      "gloss": "vacation, holiday",
      "glossSv": "ledighet, lov, semester",
      "pos": "noun",
      "explanation": "unemployment + happy: time of not working, which is happy",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        711,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 2679,
      "bciAvId": 17997,
      "gloss": "Valentine (card)",
      "glossSv": "kärleksbrev",
      "pos": "noun",
      "explanation": "paper + love: message of love",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        431
      ]
    },
    {
      "id": 2680,
      "bciAvId": 17998,
      "gloss": "Valentine's Day",
      "glossSv": "alla hjärtans dag",
      "pos": "noun",
      "explanation": "day + love: day to celebrate love",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        431
      ]
    },
    {
      "id": 2681,
      "bciAvId": 18000,
      "gloss": "van, minibus",
      "glossSv": "minibuss, skåpbil",
      "pos": "noun",
      "explanation": "bus + little",
      "isCharacter": false,
      "composition": [
        188,
        "/",
        956
      ]
    },
    {
      "id": 2682,
      "bciAvId": 18001,
      "gloss": "vas deferens",
      "glossSv": "sädesledare",
      "pos": "noun",
      "explanation": "tube + sperm",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        612
      ]
    },
    {
      "id": 2683,
      "bciAvId": 18002,
      "gloss": "vasectomy",
      "glossSv": "sterilisering (man)",
      "pos": "noun",
      "explanation": "operation + vas deferens",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        958,
        "/",
        866,
        "/",
        612
      ]
    },
    {
      "id": 2684,
      "bciAvId": 18003,
      "gloss": "veal",
      "glossSv": "kalvkött",
      "pos": "noun",
      "explanation": "food + calf: food that comes from a calf: The symbol also can be explained as: combination of meat and calf.)",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        123,
        "/",
        140
      ]
    },
    {
      "id": 2685,
      "bciAvId": 18011,
      "gloss": "video recorder",
      "glossSv": "video",
      "pos": "noun",
      "explanation": "machine + to reproduce + eye + ear: machine to reproduce materials to see and to hear",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        963,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 2686,
      "bciAvId": 18012,
      "gloss": "village",
      "glossSv": "by, samhälle",
      "pos": "noun",
      "explanation": "group of + building",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        392
      ]
    },
    {
      "id": 2687,
      "bciAvId": 18013,
      "gloss": "vinegar",
      "glossSv": "vinäger",
      "pos": "noun",
      "explanation": "flavouring + sharp (taste) + thing indicator [combination]",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        411
      ]
    },
    {
      "id": 2688,
      "bciAvId": 18014,
      "gloss": "purple, violet (ckb)",
      "glossSv": "violett (CKB)",
      "pos": "expression",
      "explanation": "colour + 7",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        16
      ]
    },
    {
      "id": 2689,
      "bciAvId": 18015,
      "gloss": "virginity",
      "glossSv": "oskuld",
      "pos": "noun",
      "explanation": "without + sexual intercourse + past",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        232,
        "/",
        349,
        "/",
        503
      ]
    },
    {
      "id": 2690,
      "bciAvId": 18016,
      "gloss": "Vishnu",
      "glossSv": "Vishnu (Indien)",
      "pos": "person",
      "explanation": "god + protection: Hindu god",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        548
      ]
    },
    {
      "id": 2691,
      "bciAvId": 18017,
      "gloss": "to visit",
      "glossSv": "besöka, hälsa på",
      "pos": "action",
      "explanation": "visit + action indicator",
      "isCharacter": false,
      "composition": [
        935,
        ";",
        81
      ]
    },
    {
      "id": 2692,
      "bciAvId": 18018,
      "gloss": "visitor, guest",
      "glossSv": "besökare, gäst",
      "pos": "person",
      "explanation": "person + visit: person who comes to visit",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        935
      ]
    },
    {
      "id": 2693,
      "bciAvId": 18019,
      "gloss": "visually impaired",
      "glossSv": "synskadad (FD)",
      "pos": "description",
      "explanation": "limit(s),limitation (OLD) + to see + description indicator",
      "isCharacter": false,
      "composition": [
        427,
        ";",
        86,
        "/",
        303
      ]
    },
    {
      "id": 2694,
      "bciAvId": 18020,
      "gloss": "volcano",
      "glossSv": "vulkan",
      "pos": "noun",
      "explanation": "mountain + fire",
      "isCharacter": false,
      "composition": [
        456,
        "/",
        319
      ]
    },
    {
      "id": 2695,
      "bciAvId": 18021,
      "gloss": "volunteer",
      "glossSv": "frivillig medhjälpare",
      "pos": "person",
      "explanation": "helper + free: person who gives assistance freely",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382,
        "/",
        336
      ]
    },
    {
      "id": 2696,
      "bciAvId": 18022,
      "gloss": "to vomit, to throw up, to puke",
      "glossSv": "kräkas",
      "pos": "action",
      "explanation": "vomiting,vomit,puking + action indicator: to expel food",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        329
      ]
    },
    {
      "id": 2697,
      "bciAvId": 18023,
      "gloss": "voyeurism",
      "glossSv": "smygtittande",
      "pos": "noun",
      "explanation": "to watch + sex",
      "isCharacter": false,
      "composition": [
        969,
        "/",
        401,
        "/",
        347
      ]
    },
    {
      "id": 2698,
      "bciAvId": 18024,
      "gloss": "vulture",
      "glossSv": "gam",
      "pos": "noun",
      "explanation": "bird + death: bird that feeds upon decaying flesh",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        259
      ]
    },
    {
      "id": 2699,
      "bciAvId": 18025,
      "gloss": "vulva",
      "glossSv": "blygd",
      "pos": "noun",
      "explanation": "protection + vagina",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        682
      ]
    },
    {
      "id": 2700,
      "bciAvId": 18026,
      "gloss": "wading pool, paddling pool",
      "glossSv": "barnbassäng, plaskdamm",
      "pos": "noun",
      "explanation": "pool + child: pool for a child to wade in",
      "isCharacter": false,
      "composition": [
        539,
        "/",
        220
      ]
    },
    {
      "id": 2701,
      "bciAvId": 18027,
      "gloss": "wage(s), pay, salary",
      "glossSv": "lön, inkomst",
      "pos": "noun",
      "explanation": "money + for (in exchange for) + work",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        711
      ]
    },
    {
      "id": 2702,
      "bciAvId": 18030,
      "gloss": "to wait",
      "glossSv": "vänta",
      "pos": "action",
      "explanation": "wait,waiting + action indicator: to halt for a limited time",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        426
      ]
    },
    {
      "id": 2703,
      "bciAvId": 18031,
      "gloss": "to walk, to go",
      "glossSv": "gå",
      "pos": "action",
      "explanation": "legs and feet + action indicator",
      "isCharacter": false,
      "composition": [
        418,
        ";",
        81
      ]
    },
    {
      "id": 2704,
      "bciAvId": 18032,
      "gloss": "walker, walking aid (2)",
      "glossSv": "rollator, gåstol (etc)",
      "pos": "noun",
      "explanation": "aid + medical + to walk + thing indicator: medical support that helps a person to walk",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        418
      ]
    },
    {
      "id": 2705,
      "bciAvId": 18035,
      "gloss": "to want, to desire",
      "glossSv": "vilja (verb)",
      "pos": "action",
      "explanation": "want,desire + action indicator: to have an emotional desire, a strong feeling shown by fire",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        319
      ]
    },
    {
      "id": 2706,
      "bciAvId": 18037,
      "gloss": "warm",
      "glossSv": "ljummen",
      "pos": "description",
      "explanation": "hot + little + description indicator",
      "isCharacter": false,
      "composition": [
        378,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 2707,
      "bciAvId": 18038,
      "gloss": "to wash, to bathe, to bath",
      "glossSv": "bada, tvätta",
      "pos": "action",
      "explanation": "bath,washing + action indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        81
      ]
    },
    {
      "id": 2708,
      "bciAvId": 18039,
      "gloss": "washable",
      "glossSv": "tvättbar",
      "pos": "description",
      "explanation": "bath,washing + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        85
      ]
    },
    {
      "id": 2709,
      "bciAvId": 18040,
      "gloss": "washcloth, washrag, flannel",
      "glossSv": "tvättlapp",
      "pos": "noun",
      "explanation": "cloth + to wash",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        595
      ]
    },
    {
      "id": 2710,
      "bciAvId": 18041,
      "gloss": "washer",
      "glossSv": "maskin som tvättar",
      "pos": "noun",
      "explanation": "machine + to wash",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        595
      ]
    },
    {
      "id": 2711,
      "bciAvId": 18042,
      "gloss": "washing machine, washer",
      "glossSv": "tvättmaskin",
      "pos": "noun",
      "explanation": "machine + to wash + clothing",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        595,
        "/",
        229
      ]
    },
    {
      "id": 2712,
      "bciAvId": 18044,
      "gloss": "watch, wristwatch",
      "glossSv": "armbandsur",
      "pos": "noun",
      "explanation": "clock + hand + thing indicator: clock worn on the wrist or carried in a pocket",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        97,
        "/",
        374
      ]
    },
    {
      "id": 2713,
      "bciAvId": 18045,
      "gloss": "to watch",
      "glossSv": "vakta",
      "pos": "action",
      "explanation": "wakefulness,alertness + intensity + action indicator: to be wide awake and attentive",
      "isCharacter": false,
      "composition": [
        969,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 2714,
      "bciAvId": 18046,
      "gloss": "watchful, alert",
      "glossSv": "vaksam",
      "pos": "description",
      "explanation": "wakefulness,alertness + description indicator",
      "isCharacter": false,
      "composition": [
        969,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2715,
      "bciAvId": 18210,
      "gloss": "we, us, ourselves - (feminine)",
      "glossSv": "vi, oss (fem.)",
      "pos": "person",
      "explanation": "female + 1 + plural indicator: first person plural, (f.)",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        10
      ]
    },
    {
      "id": 2716,
      "bciAvId": 18211,
      "gloss": "we, us, ourselves - (masculine)",
      "glossSv": "vi, oss (mask.)",
      "pos": "person",
      "explanation": "male + 1 + plural indicator: first person plural, (m.)",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        10
      ]
    },
    {
      "id": 2717,
      "bciAvId": 18212,
      "gloss": "we, us, ourselves",
      "glossSv": "vi, oss",
      "pos": "person",
      "explanation": "person + 1 + plural indicator: first person plural",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        10
      ]
    },
    {
      "id": 2718,
      "bciAvId": 18213,
      "gloss": "weak",
      "glossSv": "svag",
      "pos": "description",
      "explanation": "weakness (weak person) + description indicator: feeling experienced by a person whose knees are giving out",
      "isCharacter": false,
      "composition": [
        519,
        ";",
        86
      ]
    },
    {
      "id": 2719,
      "bciAvId": 18215,
      "gloss": "to weave",
      "glossSv": "väva",
      "pos": "action",
      "explanation": "to make + cloth + action indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        228
      ]
    },
    {
      "id": 2720,
      "bciAvId": 18216,
      "gloss": "Wednesday",
      "glossSv": "onsdag (FD)",
      "pos": "noun",
      "explanation": "day + 4: fourth day of the week - based on the convention of Sunday being the first",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        13
      ]
    },
    {
      "id": 2721,
      "bciAvId": 18217,
      "gloss": "week",
      "glossSv": "vecka",
      "pos": "noun",
      "explanation": "7 + day: period of seven days",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258
      ]
    },
    {
      "id": 2722,
      "bciAvId": 18218,
      "gloss": "weekend (6-7)",
      "glossSv": "veckoslut (sverige)",
      "pos": "noun",
      "explanation": "day + 6 + plus sign (low) + 7: a combination of Saturday and Sunday in modern western week day numbering",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        15,
        "/",
        1070,
        "/",
        16
      ]
    },
    {
      "id": 2723,
      "bciAvId": 18219,
      "gloss": "weekend (7-1)",
      "glossSv": "veckoslut (int)",
      "pos": "noun",
      "explanation": "day + 7 + plus sign (low) + 1: a combination of Saturday and Sunday in traditional English or US week day numbering, and (possibly) Friday and Saturday in Israel",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16,
        "/",
        1070,
        "/",
        10
      ]
    },
    {
      "id": 2724,
      "bciAvId": 18220,
      "gloss": "to weigh",
      "glossSv": "väga",
      "pos": "action",
      "explanation": "weight + action indicator",
      "isCharacter": false,
      "composition": [
        697,
        ";",
        81
      ]
    },
    {
      "id": 2725,
      "bciAvId": 18222,
      "gloss": "weight - (a)",
      "glossSv": "vikt, tyngd",
      "pos": "noun",
      "explanation": "weight + thing indicator",
      "isCharacter": false,
      "composition": [
        697,
        ";",
        97
      ]
    },
    {
      "id": 2726,
      "bciAvId": 18223,
      "gloss": "welcome",
      "glossSv": "välkommen",
      "pos": "function",
      "explanation": "feeling + visitor [contraction]: feeling expressed to visitors",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        935
      ]
    },
    {
      "id": 2727,
      "bciAvId": 18225,
      "gloss": "western",
      "glossSv": "västlig",
      "pos": "description",
      "explanation": "west + description indicator",
      "isCharacter": false,
      "composition": [
        698,
        ";",
        86
      ]
    },
    {
      "id": 2728,
      "bciAvId": 18226,
      "gloss": "wet, damp, moist, watery",
      "glossSv": "våt, fuktig, vattnig",
      "pos": "description",
      "explanation": "water + description indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        86
      ]
    },
    {
      "id": 2729,
      "bciAvId": 18227,
      "gloss": "whale",
      "glossSv": "val (djur)",
      "pos": "noun",
      "explanation": "water mammal (with tail) + big: bigger whale, noted for its size",
      "isCharacter": false,
      "composition": [
        268,
        "/",
        936
      ]
    },
    {
      "id": 2730,
      "bciAvId": 18228,
      "gloss": "what",
      "glossSv": "vad, vad som",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + thing: relative pronoun",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        651
      ]
    },
    {
      "id": 2731,
      "bciAvId": 18230,
      "gloss": "what kind - (question)",
      "glossSv": "vilken sort (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + type",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        673
      ]
    },
    {
      "id": 2732,
      "bciAvId": 18231,
      "gloss": "what (thing) - (question)",
      "glossSv": "vad (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + thing: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        651
      ]
    },
    {
      "id": 2733,
      "bciAvId": 18234,
      "gloss": "when",
      "glossSv": "när",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + time: conjunction used to introduce a relative clause",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        655
      ]
    },
    {
      "id": 2734,
      "bciAvId": 18235,
      "gloss": "when, what time - (question)",
      "glossSv": "när (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + time: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        655
      ]
    },
    {
      "id": 2735,
      "bciAvId": 18238,
      "gloss": "which, that - (relative)",
      "glossSv": "vilken, vilken som",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + part: relative pronoun",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        502
      ]
    },
    {
      "id": 2736,
      "bciAvId": 18239,
      "gloss": "which - (question)",
      "glossSv": "vilken (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + part: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        502
      ]
    },
    {
      "id": 2737,
      "bciAvId": 18240,
      "gloss": "to whisper",
      "glossSv": "viska",
      "pos": "action",
      "explanation": "to say + quiet + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        449,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 2738,
      "bciAvId": 18241,
      "gloss": "to whistle",
      "glossSv": "vissla",
      "pos": "action",
      "explanation": "to sing + teeth + action indicator: to make musical sounds through your teeth",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        462,
        "/",
        644
      ]
    },
    {
      "id": 2739,
      "bciAvId": 18242,
      "gloss": "white",
      "glossSv": "vit",
      "pos": "expression",
      "explanation": "colour + snow",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        604
      ]
    },
    {
      "id": 2740,
      "bciAvId": 18244,
      "gloss": "who, whom - (question)",
      "glossSv": "vem (fråga)",
      "pos": "expression",
      "explanation": "what,question mark + person: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        513
      ]
    },
    {
      "id": 2741,
      "bciAvId": 18245,
      "gloss": "who, whom, that - (relative)",
      "glossSv": "vem, vem som",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + person: relative pronoun",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        513
      ]
    },
    {
      "id": 2742,
      "bciAvId": 18246,
      "gloss": "whose (neutral)",
      "glossSv": "vars, vilkens",
      "pos": "expression",
      "explanation": "who,that,which-(relative) + belongs to: relative pronoun, possessive form",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        160
      ]
    },
    {
      "id": 2743,
      "bciAvId": 18247,
      "gloss": "whose (person)",
      "glossSv": "vems, vars",
      "pos": "expression",
      "explanation": "who,whom,that-(relative) + belongs to: relative pronoun, possessive form",
      "isCharacter": false,
      "composition": [
        561,
        "/",
        513,
        "/",
        160
      ]
    },
    {
      "id": 2744,
      "bciAvId": 18248,
      "gloss": "whose - (question)",
      "glossSv": "vems (fråga)",
      "pos": "expression",
      "explanation": "who,whom-(question) + belongs to: interrogative",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        513,
        "/",
        160
      ]
    },
    {
      "id": 2745,
      "bciAvId": 18249,
      "gloss": "why - (question)",
      "glossSv": "varför",
      "pos": "expression",
      "explanation": "what,question mark + cause [half-sized]",
      "isCharacter": false,
      "composition": [
        699,
        "/",
        650
      ]
    },
    {
      "id": 2746,
      "bciAvId": 18250,
      "gloss": "wide, broad",
      "glossSv": "bred, vid",
      "pos": "description",
      "explanation": "wideness,broadness + description indicator: the pointers point outward to the widest space bounded by the reference lines",
      "isCharacter": false,
      "composition": [
        1108,
        ";",
        86
      ]
    },
    {
      "id": 2747,
      "bciAvId": 18252,
      "gloss": "to wiggle, to squirm",
      "glossSv": "slingra",
      "pos": "action",
      "explanation": "worm + action indicator: to wriggle like a worm",
      "isCharacter": false,
      "composition": [
        713,
        ";",
        81
      ]
    },
    {
      "id": 2748,
      "bciAvId": 18253,
      "gloss": "wiggly",
      "glossSv": "krokig, slingrig",
      "pos": "description",
      "explanation": "worm + description indicator: wriggling like a worm",
      "isCharacter": false,
      "composition": [
        713,
        ";",
        86
      ]
    },
    {
      "id": 2749,
      "bciAvId": 18254,
      "gloss": "to win",
      "glossSv": "vinna",
      "pos": "action",
      "explanation": "competition + gain + action indicator: to achieve a victory in a competition or contest",
      "isCharacter": false,
      "composition": [
        554,
        ";",
        81,
        "/",
        107
      ]
    },
    {
      "id": 2750,
      "bciAvId": 18258,
      "gloss": "wine",
      "glossSv": "vin",
      "pos": "noun",
      "explanation": "alcoholic drink + grape,grapes",
      "isCharacter": false,
      "composition": [
        116,
        "/",
        365
      ]
    },
    {
      "id": 2751,
      "bciAvId": 18260,
      "gloss": "to wink, to blink",
      "glossSv": "blinka",
      "pos": "action",
      "explanation": "eyelid (upper) + action indicator",
      "isCharacter": false,
      "composition": [
        305,
        ";",
        81
      ]
    },
    {
      "id": 2752,
      "bciAvId": 18261,
      "gloss": "winter (ckb)",
      "glossSv": "vinter (CKB)",
      "pos": "noun",
      "explanation": "sun + 4: fourth season",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        13
      ]
    },
    {
      "id": 2753,
      "bciAvId": 18262,
      "gloss": "winter (snow)",
      "glossSv": "vinter",
      "pos": "noun",
      "explanation": "sun + 4 + snow: fourth season when it snows",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        13,
        "/",
        604
      ]
    },
    {
      "id": 2754,
      "bciAvId": 18263,
      "gloss": "winter (rain)",
      "glossSv": "vinter (regn)",
      "pos": "noun",
      "explanation": "sun + 4 + rain: for use in parts of the world where it rains in winter",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        13,
        "/",
        556
      ]
    },
    {
      "id": 2755,
      "bciAvId": 18264,
      "gloss": "to wipe, to dust, to polish",
      "glossSv": "damma, putsa, torka av",
      "pos": "action",
      "explanation": "cloth + back and forth + action indicator",
      "isCharacter": false,
      "composition": [
        228,
        ";",
        81,
        "/",
        144
      ]
    },
    {
      "id": 2756,
      "bciAvId": 18265,
      "gloss": "wire, cable",
      "glossSv": "ståltråd (etc)",
      "pos": "noun",
      "explanation": "linear thing + metal + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        814
      ]
    },
    {
      "id": 2757,
      "bciAvId": 18266,
      "gloss": "to wish, to desire",
      "glossSv": "önska",
      "pos": "action",
      "explanation": "wish,desire + action indicator: to have a rational desire, a strong feeling shown by fire",
      "isCharacter": false,
      "composition": [
        930,
        ";",
        81
      ]
    },
    {
      "id": 2758,
      "bciAvId": 18268,
      "gloss": "wolf, dingo, wild dog",
      "glossSv": "varg, vildhund",
      "pos": "noun",
      "explanation": "dog + open: untamed animal similar to a dog that lives in the open",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        484
      ]
    },
    {
      "id": 2759,
      "bciAvId": 18270,
      "gloss": "wood, lumber, timber",
      "glossSv": "trä",
      "pos": "noun",
      "explanation": "material + tree",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        666
      ]
    },
    {
      "id": 2760,
      "bciAvId": 18271,
      "gloss": "wool",
      "glossSv": "ull, ylle",
      "pos": "noun",
      "explanation": "material + sheep: material obtained from the fleece of sheep",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 2761,
      "bciAvId": 18272,
      "gloss": "word",
      "glossSv": "ord",
      "pos": "noun",
      "explanation": "part of + language",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414
      ]
    },
    {
      "id": 2762,
      "bciAvId": 18274,
      "gloss": "to work",
      "glossSv": "arbeta, jobba",
      "pos": "action",
      "explanation": "work + action indicator: to do with a purpose",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81
      ]
    },
    {
      "id": 2763,
      "bciAvId": 18275,
      "gloss": "work of art, art object",
      "glossSv": "konstverk",
      "pos": "noun",
      "explanation": "man-made + feeling + thing indicator: man-made thing that inspires emotion in the beholder",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 2764,
      "bciAvId": 18276,
      "gloss": "workbook",
      "glossSv": "arbetsbok",
      "pos": "noun",
      "explanation": "book + to work",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        711
      ]
    },
    {
      "id": 2765,
      "bciAvId": 18277,
      "gloss": "worker",
      "glossSv": "arbetare",
      "pos": "person",
      "explanation": "person + to work",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711
      ]
    },
    {
      "id": 2766,
      "bciAvId": 18280,
      "gloss": "worry",
      "glossSv": "bekymmer, motgång",
      "pos": "noun",
      "explanation": "mind + opposing forces,counter-forces: thinking that one is beset by opposing forces",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        1063
      ]
    },
    {
      "id": 2767,
      "bciAvId": 18281,
      "gloss": "to worry",
      "glossSv": "bekymra, gå emot",
      "pos": "action",
      "explanation": "worry + action indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        81,
        "/",
        1063
      ]
    },
    {
      "id": 2768,
      "bciAvId": 18282,
      "gloss": "wow, super, great, neat, cool - (exclamatory)",
      "glossSv": "jättebra, toppen (etc)",
      "pos": "function",
      "explanation": "slang + positive + description indicator: expressing a positive feeling about something. It can represent wow!, great!, or similar positive expressions.",
      "isCharacter": false,
      "composition": [
        970,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 2769,
      "bciAvId": 18283,
      "gloss": "wrestling (activity)",
      "glossSv": "brottning, judo",
      "pos": "noun",
      "explanation": "activity + 2 + person + to mix: informal activity in which two people grapple with each other",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        11,
        "/",
        513,
        "/",
        783
      ]
    },
    {
      "id": 2770,
      "bciAvId": 18285,
      "gloss": "to write",
      "glossSv": "skriva",
      "pos": "action",
      "explanation": "pen + action indicator",
      "isCharacter": false,
      "composition": [
        509,
        ";",
        81
      ]
    },
    {
      "id": 2771,
      "bciAvId": 18286,
      "gloss": "Yahrzeit",
      "glossSv": "yahrzeit (Israel)",
      "pos": "noun",
      "explanation": "anniversary + death",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        110,
        "/",
        259
      ]
    },
    {
      "id": 2772,
      "bciAvId": 18288,
      "gloss": "to yawn",
      "glossSv": "gäspa",
      "pos": "action",
      "explanation": "mouth + to sleep + action indicator: what one's mouth does when one is sleepy",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        599
      ]
    },
    {
      "id": 2773,
      "bciAvId": 18290,
      "gloss": "to yell, to scream",
      "glossSv": "vråla",
      "pos": "action",
      "explanation": "to say + three intensity symbols + action indicator: to say very forcefully",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2774,
      "bciAvId": 18291,
      "gloss": "yellow (bci)",
      "glossSv": "gul",
      "pos": "expression",
      "explanation": "colour + sun",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        636
      ]
    },
    {
      "id": 2775,
      "bciAvId": 18292,
      "gloss": "yellow (ckb)",
      "glossSv": "gul (CKB)",
      "pos": "expression",
      "explanation": "colour + 3",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        12
      ]
    },
    {
      "id": 2776,
      "bciAvId": 18294,
      "gloss": "yes - (exclamatory)",
      "glossSv": "ja",
      "pos": "function",
      "explanation": "positive + intensity: strong positive response",
      "isCharacter": false,
      "composition": [
        120,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2777,
      "bciAvId": 18295,
      "gloss": "yesterday",
      "glossSv": "igår",
      "pos": "noun",
      "explanation": "day + then (past)",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        112
      ]
    },
    {
      "id": 2778,
      "bciAvId": 18296,
      "gloss": "yogurt, yoghurt",
      "glossSv": "fil, yoghurt",
      "pos": "noun",
      "explanation": "food + comma + milk: food made from fermented milk",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 2779,
      "bciAvId": 18297,
      "gloss": "Yom Kippur",
      "glossSv": "Yom Kippur (Israel)",
      "pos": "noun",
      "explanation": "day + to forgive: the Day of Atonement, a holiday when one atones for sins and asks for forgiveness",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        1067,
        "/",
        109
      ]
    },
    {
      "id": 2780,
      "bciAvId": 18298,
      "gloss": "you, yourselves - (feminine plural)",
      "glossSv": "ni, er (fem.)",
      "pos": "person",
      "explanation": "female + 2 + plural indicator: second person (f.pl.)",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        11
      ]
    },
    {
      "id": 2781,
      "bciAvId": 18299,
      "gloss": "you, yourself - (feminine singular)",
      "glossSv": "du, dig (fem.)",
      "pos": "person",
      "explanation": "female + 2: second person (f.sing.)",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        11
      ]
    },
    {
      "id": 2782,
      "bciAvId": 18300,
      "gloss": "you, yourselves - (masculine plural)",
      "glossSv": "ni, er (mask.)",
      "pos": "person",
      "explanation": "male + 2 + plural indicator: second person (m.pl.)",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        11
      ]
    },
    {
      "id": 2783,
      "bciAvId": 18301,
      "gloss": "you, yourself - (masculine singular)",
      "glossSv": "du, dig (mask.)",
      "pos": "person",
      "explanation": "male + 2: second person (m.sing.)",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        11
      ]
    },
    {
      "id": 2784,
      "bciAvId": 18302,
      "gloss": "you, yourselves - (plural)",
      "glossSv": "ni, er",
      "pos": "person",
      "explanation": "person + 2 + plural indicator: second person plural",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        11
      ]
    },
    {
      "id": 2785,
      "bciAvId": 18465,
      "gloss": "you, yourself",
      "glossSv": "du, dig",
      "pos": "person",
      "explanation": "person + 2: second person singular",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        11
      ]
    },
    {
      "id": 2786,
      "bciAvId": 18466,
      "gloss": "you are welcome, you're welcome",
      "glossSv": "ingen orsak",
      "pos": "function",
      "explanation": "happy + to help + action indicator: polite phrase used in response to thank you",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678,
        "/",
        382
      ]
    },
    {
      "id": 2787,
      "bciAvId": 18467,
      "gloss": "young",
      "glossSv": "ung",
      "pos": "description",
      "explanation": "child + description indicator",
      "isCharacter": false,
      "composition": [
        220,
        ";",
        86
      ]
    },
    {
      "id": 2788,
      "bciAvId": 18468,
      "gloss": "your, yours - (feminine plural)",
      "glossSv": "er, ert, era (fem.)",
      "pos": "person",
      "explanation": "female + 2 + belongs to + plural indicator: second person plural (f.), possessive",
      "isCharacter": false,
      "composition": [
        710,
        ";",
        99,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2789,
      "bciAvId": 18469,
      "gloss": "your, yours - (feminine singular)",
      "glossSv": "din, ditt, dina (fem.)",
      "pos": "person",
      "explanation": "female + 2 + belongs to: second person singular (f.), possessive",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2790,
      "bciAvId": 18470,
      "gloss": "your, yours - (masculine plural)",
      "glossSv": "er, ert, era (mask.)",
      "pos": "person",
      "explanation": "male + 2 + belongs to + plural indicator: second person plural (m.), possessive",
      "isCharacter": false,
      "composition": [
        433,
        ";",
        99,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2791,
      "bciAvId": 18471,
      "gloss": "your, yours - (masculine singular)",
      "glossSv": "din, ditt, dina (mask.)",
      "pos": "person",
      "explanation": "male + 2 + belongs to: second person singular (m.), possessive",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2792,
      "bciAvId": 18472,
      "gloss": "your, yours - (plural)",
      "glossSv": "er, ert, era",
      "pos": "person",
      "explanation": "you + belongs to + plural indicator",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2793,
      "bciAvId": 18473,
      "gloss": "your, yours - (singular)",
      "glossSv": "din, ditt, dina",
      "pos": "person",
      "explanation": "you + belongs to: second person (sing.), possessive",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        11,
        "/",
        160
      ]
    },
    {
      "id": 2794,
      "bciAvId": 18474,
      "gloss": "zebra",
      "glossSv": "zebra",
      "pos": "noun",
      "explanation": "horse + stripe: striped animal that resembles a horse",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        428
      ]
    },
    {
      "id": 2795,
      "bciAvId": 18475,
      "gloss": "zoo",
      "glossSv": "djurpark, zoo",
      "pos": "noun",
      "explanation": "park + animal",
      "isCharacter": false,
      "composition": [
        501,
        "/",
        122
      ]
    },
    {
      "id": 2796,
      "bciAvId": 20513,
      "gloss": "cross - (a)",
      "glossSv": "kors",
      "pos": "noun",
      "explanation": "cross + thing indicator",
      "isCharacter": false,
      "composition": [
        248,
        ";",
        97
      ]
    },
    {
      "id": 2797,
      "bciAvId": 20514,
      "gloss": "eternal life, immortality",
      "glossSv": "evigt liv, odödlighet",
      "pos": "noun",
      "explanation": "life + without + end",
      "isCharacter": false,
      "composition": [
        423,
        "/",
        449,
        "/",
        292
      ]
    },
    {
      "id": 2798,
      "bciAvId": 20515,
      "gloss": "star of David - (a)",
      "glossSv": "Davidsstjärna (konkret)",
      "pos": "noun",
      "explanation": "star of David + thing indicator",
      "isCharacter": false,
      "composition": [
        621,
        ";",
        97
      ]
    },
    {
      "id": 2799,
      "bciAvId": 20516,
      "gloss": "therapist",
      "glossSv": "terapeut",
      "pos": "person",
      "explanation": "person + therapy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750
      ]
    },
    {
      "id": 2800,
      "bciAvId": 20521,
      "gloss": "spaghetti",
      "glossSv": "spaghetti",
      "pos": "noun",
      "explanation": "pasta + line",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        428
      ]
    },
    {
      "id": 2801,
      "bciAvId": 20523,
      "gloss": "salt",
      "glossSv": "salt (subst.)",
      "pos": "noun",
      "explanation": "flavouring + sea + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 2802,
      "bciAvId": 20526,
      "gloss": "tasty, good, appetising, appetizing",
      "glossSv": "god, smaklig, välsmakande",
      "pos": "description",
      "explanation": "taste + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 2803,
      "bciAvId": 20527,
      "gloss": "mirror",
      "glossSv": "spegel",
      "pos": "noun",
      "explanation": "reflection + thing indicator: a ray of light is reflected by a mirror",
      "isCharacter": false,
      "composition": [
        784,
        ";",
        97
      ]
    },
    {
      "id": 2804,
      "bciAvId": 20530,
      "gloss": "hard, firm",
      "glossSv": "hård",
      "pos": "description",
      "explanation": "hand + table + description indicator: a table top is hard to touch",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        86,
        "/",
        639
      ]
    },
    {
      "id": 2805,
      "bciAvId": 20562,
      "gloss": "religious",
      "glossSv": "religiös, troende",
      "pos": "description",
      "explanation": "religion,naturalism + description indicator",
      "isCharacter": false,
      "composition": [
        726,
        ";",
        86
      ]
    },
    {
      "id": 2806,
      "bciAvId": 20565,
      "gloss": "believer (in God)",
      "glossSv": "religiös person, troende",
      "pos": "person",
      "explanation": "person + religion (God based)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        725
      ]
    },
    {
      "id": 2807,
      "bciAvId": 20566,
      "gloss": "believer",
      "glossSv": "troende (person)",
      "pos": "person",
      "explanation": "person + religion,naturalism",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        726
      ]
    },
    {
      "id": 2808,
      "bciAvId": 20567,
      "gloss": "Jesus Christ",
      "glossSv": "Jesus Kristus",
      "pos": "person",
      "explanation": "man + Christianity",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        725,
        "/",
        248
      ]
    },
    {
      "id": 2809,
      "bciAvId": 20569,
      "gloss": "devil (2)",
      "glossSv": "djävul (2)",
      "pos": "person",
      "explanation": "spirit + supernatural + incorrect,bad,inaccurate,wrong + intensity: very bad supernatural spirit",
      "isCharacter": false,
      "composition": [
        735,
        "/",
        733,
        "/",
        1013,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2810,
      "bciAvId": 20570,
      "gloss": "angel (2)",
      "glossSv": "ängel (2)",
      "pos": "person",
      "explanation": "spirit + supernatural + peace",
      "isCharacter": false,
      "composition": [
        735,
        "/",
        733,
        "/",
        505
      ]
    },
    {
      "id": 2811,
      "bciAvId": 20573,
      "gloss": "religious ceremony",
      "glossSv": "religiös ceremoni",
      "pos": "noun",
      "explanation": "ceremony + religion,naturalism",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        726
      ]
    },
    {
      "id": 2812,
      "bciAvId": 20574,
      "gloss": "religious ceremony (God based)",
      "glossSv": "religiös ceremoni (gudsbaserad)",
      "pos": "noun",
      "explanation": "ceremony + religion (God based)",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725
      ]
    },
    {
      "id": 2813,
      "bciAvId": 20575,
      "gloss": "marriage, wedding",
      "glossSv": "bröllop, vigsel",
      "pos": "noun",
      "explanation": "ceremony + marriage",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        437
      ]
    },
    {
      "id": 2814,
      "bciAvId": 20576,
      "gloss": "marriage (religious)",
      "glossSv": "vigsel (religiös)",
      "pos": "noun",
      "explanation": "religious ceremony + marriage",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        437
      ]
    },
    {
      "id": 2815,
      "bciAvId": 20577,
      "gloss": "funeral (religious)",
      "glossSv": "begravningsakt (religiös)",
      "pos": "noun",
      "explanation": "religious ceremony + death",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        259
      ]
    },
    {
      "id": 2816,
      "bciAvId": 20578,
      "gloss": "funeral",
      "glossSv": "begravningsakt",
      "pos": "noun",
      "explanation": "ceremony + death",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        259
      ]
    },
    {
      "id": 2817,
      "bciAvId": 20579,
      "gloss": "burial",
      "glossSv": "begravning, gravsättning",
      "pos": "noun",
      "explanation": "ceremony + grave",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        367
      ]
    },
    {
      "id": 2818,
      "bciAvId": 20580,
      "gloss": "burial (religious)",
      "glossSv": "begravning, gravsättning (religiös)",
      "pos": "noun",
      "explanation": "religious ceremony + grave",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        367
      ]
    },
    {
      "id": 2819,
      "bciAvId": 20581,
      "gloss": "to bury",
      "glossSv": "begrava, placera under jord, gräva ner",
      "pos": "action",
      "explanation": "burial site + action indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81,
        "/",
        1102
      ]
    },
    {
      "id": 2820,
      "bciAvId": 20582,
      "gloss": "poor (without possessions)",
      "glossSv": "fattig (utan ägodelar)",
      "pos": "description",
      "explanation": "poverty + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        959,
        ";",
        86
      ]
    },
    {
      "id": 2821,
      "bciAvId": 20583,
      "gloss": "football, soccer (sport)",
      "glossSv": "fotboll (sport)",
      "pos": "noun",
      "explanation": "sport + ball + legs and feet",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 2822,
      "bciAvId": 20584,
      "gloss": "baseball (sport)",
      "glossSv": "baseboll (sport)",
      "pos": "noun",
      "explanation": "sport + ball + corner: the corner character here representing the baseball diamond with the pointer to a base in the corner: ball game played on a diamond",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        1011
      ]
    },
    {
      "id": 2823,
      "bciAvId": 20585,
      "gloss": "basketball (sport)",
      "glossSv": "basketboll (sport)",
      "pos": "noun",
      "explanation": "sport + ball + container,basket (high)",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        1009
      ]
    },
    {
      "id": 2824,
      "bciAvId": 20586,
      "gloss": "croquet (sport)",
      "glossSv": "krocket (sport)",
      "pos": "noun",
      "explanation": "sport + ball + hammer,gavel,mallet",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        373
      ]
    },
    {
      "id": 2825,
      "bciAvId": 20587,
      "gloss": "bowling (sport)",
      "glossSv": "bowling (sport)",
      "pos": "noun",
      "explanation": "sport + ball field",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        998
      ]
    },
    {
      "id": 2826,
      "bciAvId": 20588,
      "gloss": "badminton (sport)",
      "glossSv": "badminton (sport)",
      "pos": "noun",
      "explanation": "sport + shuttlecock,birdie (badminton)",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1082
      ]
    },
    {
      "id": 2827,
      "bciAvId": 20589,
      "gloss": "handball (sport)",
      "glossSv": "handboll (sport)",
      "pos": "noun",
      "explanation": "sport + ball + hand",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        374
      ]
    },
    {
      "id": 2828,
      "bciAvId": 20590,
      "gloss": "ice hockey (sport)",
      "glossSv": "ishockey (sport)",
      "pos": "noun",
      "explanation": "sport + sport stick and puck,hockey stick + ice",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1093,
        "/",
        394
      ]
    },
    {
      "id": 2829,
      "bciAvId": 20591,
      "gloss": "field hockey, hockey (sport)",
      "glossSv": "landhockey, innebandy",
      "pos": "noun",
      "explanation": "sport + sport stick and ball,bandy stick",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1092
      ]
    },
    {
      "id": 2830,
      "bciAvId": 20592,
      "gloss": "golf (sport)",
      "glossSv": "golf (sport)",
      "pos": "noun",
      "explanation": "sport + sport stick and ball,bandy stick + container (low): the container below ground representing the golf hole",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1092,
        "/",
        1010
      ]
    },
    {
      "id": 2831,
      "bciAvId": 20593,
      "gloss": "rugby, football (N.A.)",
      "glossSv": "rugby",
      "pos": "noun",
      "explanation": "sport + rugby ball + legs and feet",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        754,
        "/",
        418
      ]
    },
    {
      "id": 2832,
      "bciAvId": 20594,
      "gloss": "wrestling (sport)",
      "glossSv": "brottning",
      "pos": "noun",
      "explanation": "sport + fight + mixture",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        783
      ]
    },
    {
      "id": 2833,
      "bciAvId": 20595,
      "gloss": "judo",
      "glossSv": "judo (etc)",
      "pos": "noun",
      "explanation": "sport + fight + east + mixture",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        282,
        "/",
        783
      ]
    },
    {
      "id": 2834,
      "bciAvId": 20596,
      "gloss": "boxing (sport)",
      "glossSv": "boxning (sport)",
      "pos": "noun",
      "explanation": "sport + fight + hand",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        374
      ]
    },
    {
      "id": 2835,
      "bciAvId": 20597,
      "gloss": "skiing (sport)",
      "glossSv": "skidsport",
      "pos": "noun",
      "explanation": "sport + skis",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084
      ]
    },
    {
      "id": 2836,
      "bciAvId": 20598,
      "gloss": "skiing (activity)",
      "glossSv": "skidåkning",
      "pos": "noun",
      "explanation": "activity + skis",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        11,
        "/",
        1084
      ]
    },
    {
      "id": 2837,
      "bciAvId": 20600,
      "gloss": "stable",
      "glossSv": "stall",
      "pos": "noun",
      "explanation": "house + horse",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        391
      ]
    },
    {
      "id": 2838,
      "bciAvId": 20601,
      "gloss": "carriage",
      "glossSv": "hästvagn, hästkärra",
      "pos": "noun",
      "explanation": "cart,carriage + big + horse",
      "isCharacter": false,
      "composition": [
        204,
        "/",
        936,
        "/",
        391
      ]
    },
    {
      "id": 2839,
      "bciAvId": 20602,
      "gloss": "tennis, racquet sports",
      "glossSv": "tennis, racketsport (FD)",
      "pos": "noun",
      "explanation": "sport + crossed racquets",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1016
      ]
    },
    {
      "id": 2840,
      "bciAvId": 20603,
      "gloss": "table tennis, ping-pong (sport)",
      "glossSv": "bordtennis (sport) (FD)",
      "pos": "noun",
      "explanation": "tennis,racquet sports (OLD) + table",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1016,
        "/",
        639
      ]
    },
    {
      "id": 2841,
      "bciAvId": 20604,
      "gloss": "beach tennis (sport)",
      "glossSv": "strandtennis (sport) (FD)",
      "pos": "noun",
      "explanation": "tennis,racquet sports (OLD) + beach",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1016,
        "/",
        153
      ]
    },
    {
      "id": 2842,
      "bciAvId": 20605,
      "gloss": "team (sport)",
      "glossSv": "lag (sport)",
      "pos": "noun",
      "explanation": "group (people) + sport: group which comes together to play a sport",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        719
      ]
    },
    {
      "id": 2843,
      "bciAvId": 20606,
      "gloss": "snack (meal)",
      "glossSv": "mellanmål",
      "pos": "noun",
      "explanation": "food + between",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        162
      ]
    },
    {
      "id": 2844,
      "bciAvId": 20770,
      "gloss": "hamburger",
      "glossSv": "hamburgare",
      "pos": "noun",
      "explanation": "bun (food) + animal (meat [contraction])",
      "isCharacter": false,
      "composition": [
        732,
        "/",
        122
      ]
    },
    {
      "id": 2845,
      "bciAvId": 20771,
      "gloss": "chocolate flavouring, chocolate flavoring",
      "glossSv": "choklad (smaktillsats)",
      "pos": "noun",
      "explanation": "flavouring + chocolate [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 2846,
      "bciAvId": 20772,
      "gloss": "chocolate drink",
      "glossSv": "chokladdryck, O'boy",
      "pos": "noun",
      "explanation": "drink + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 2847,
      "bciAvId": 21025,
      "gloss": "monotheism",
      "glossSv": "monoteism",
      "pos": "noun",
      "explanation": "religion (God based) + 1 + God: belief that there is only one God",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        10,
        "/",
        355
      ]
    },
    {
      "id": 2848,
      "bciAvId": 21026,
      "gloss": "polytheism",
      "glossSv": "polyteism",
      "pos": "noun",
      "explanation": "religion (God based) + many + God: belief in more than one God",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        368,
        "/",
        355
      ]
    },
    {
      "id": 2849,
      "bciAvId": 21027,
      "gloss": "Christianity",
      "glossSv": "kristendom",
      "pos": "noun",
      "explanation": "religion (God based) + Christ [contraction]: religion founded on the teachings of Christ",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        248
      ]
    },
    {
      "id": 2850,
      "bciAvId": 21028,
      "gloss": "Judaism",
      "glossSv": "judendom",
      "pos": "noun",
      "explanation": "religion (God based) + Star of David: religion of the Jewish people",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        621
      ]
    },
    {
      "id": 2851,
      "bciAvId": 21029,
      "gloss": "Islam",
      "glossSv": "islam",
      "pos": "noun",
      "explanation": "religion (God based) + Muslim: religion based on the teaching of the prophet Muhammed",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 2852,
      "bciAvId": 21030,
      "gloss": "Eastern Orthodox Church",
      "glossSv": "ortodoxa kyrkan",
      "pos": "noun",
      "explanation": "Christianity + east: group of churches, including Greek and Russian Orthodox",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        248,
        "/",
        282
      ]
    },
    {
      "id": 2853,
      "bciAvId": 21031,
      "gloss": "Christian (person)",
      "glossSv": "kristen (person)",
      "pos": "person",
      "explanation": "person + Christianity [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        248
      ]
    },
    {
      "id": 2854,
      "bciAvId": 21032,
      "gloss": "Jew",
      "glossSv": "jude",
      "pos": "person",
      "explanation": "person + Star of David",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        621
      ]
    },
    {
      "id": 2855,
      "bciAvId": 21033,
      "gloss": "Muslim, Moslem",
      "glossSv": "muslim",
      "pos": "person",
      "explanation": "person + Muslim",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 2856,
      "bciAvId": 21034,
      "gloss": "Muhammad, Mohammed, Muhammed",
      "glossSv": "Mohammed",
      "pos": "person",
      "explanation": "man + Islam: founder of Islam",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        725,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 2857,
      "bciAvId": 21035,
      "gloss": "Allah",
      "glossSv": "Allah",
      "pos": "person",
      "explanation": "God + ALLAH",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        "XA",
        "/",
        "XL",
        "/",
        "XL",
        "/",
        "XA",
        "/",
        "XH"
      ]
    },
    {
      "id": 2858,
      "bciAvId": 21037,
      "gloss": "Vatican, Vatican City",
      "glossSv": "Vatikanen, Vatikanstaten",
      "pos": "noun",
      "explanation": "country + Christian: the Vatican is the seat of papal government",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        248
      ]
    },
    {
      "id": 2859,
      "bciAvId": 21038,
      "gloss": "Roman Catholicism, Roman Catholic Church",
      "glossSv": "katolicism (romersk)",
      "pos": "noun",
      "explanation": "religion + Vatican: the doctrines, practices and organization of the Roman Catholic Church",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        243,
        "/",
        248
      ]
    },
    {
      "id": 2860,
      "bciAvId": 21039,
      "gloss": "protestantism",
      "glossSv": "protestantism",
      "pos": "noun",
      "explanation": "religion + Christ [contraction] + group: Christian religion, which emphasizes the importance of the congregation",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        248,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 2861,
      "bciAvId": 21041,
      "gloss": "divine, holy",
      "glossSv": "gudomlig",
      "pos": "description",
      "explanation": "God + description indicator",
      "isCharacter": false,
      "composition": [
        355,
        ";",
        86
      ]
    },
    {
      "id": 2862,
      "bciAvId": 21042,
      "gloss": "bandy (sport)",
      "glossSv": "bandy (sport)",
      "pos": "noun",
      "explanation": "sport + sport stick and ball,bandy stick + ice",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1092,
        "/",
        394
      ]
    },
    {
      "id": 2863,
      "bciAvId": 21043,
      "gloss": "Messiah",
      "glossSv": "Messias",
      "pos": "person",
      "explanation": "man + God + peace: Jesus Christ - biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        355,
        "/",
        505
      ]
    },
    {
      "id": 2864,
      "bciAvId": 21045,
      "gloss": "soul",
      "glossSv": "själ",
      "pos": "noun",
      "explanation": "spirit + person: the animating vital principal in man",
      "isCharacter": false,
      "composition": [
        735,
        "/",
        513
      ]
    },
    {
      "id": 2865,
      "bciAvId": 21046,
      "gloss": "Mary (Mother of Christ)",
      "glossSv": "Maria, Jesu mor",
      "pos": "person",
      "explanation": "mother + Christ [contraction]: biblical figure",
      "isCharacter": false,
      "composition": [
        455,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 2866,
      "bciAvId": 21047,
      "gloss": "Joseph, Saint Joseph",
      "glossSv": "Josef",
      "pos": "person",
      "explanation": "father + Christ [contraction] + earth: the earthly father of Christ - biblical figure",
      "isCharacter": false,
      "composition": [
        312,
        "/",
        248,
        "/",
        281
      ]
    },
    {
      "id": 2867,
      "bciAvId": 21048,
      "gloss": "prophecy, prediction",
      "glossSv": "profetsia, spådom",
      "pos": "noun",
      "explanation": "to speak + future: what is said about the future",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        341
      ]
    },
    {
      "id": 2868,
      "bciAvId": 21049,
      "gloss": "to prophesy",
      "glossSv": "profetera, spå",
      "pos": "action",
      "explanation": "prophecy + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        341
      ]
    },
    {
      "id": 2869,
      "bciAvId": 21050,
      "gloss": "prophet",
      "glossSv": "profet, spåman, spåkvinna",
      "pos": "person",
      "explanation": "person + to prophesy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        457,
        "/",
        341
      ]
    },
    {
      "id": 2870,
      "bciAvId": 21051,
      "gloss": "to predict",
      "glossSv": "förutsäga",
      "pos": "action",
      "explanation": "to prophesy + fact + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        341,
        "/",
        307
      ]
    },
    {
      "id": 2871,
      "bciAvId": 21053,
      "gloss": "to follow",
      "glossSv": "följa, följa efter",
      "pos": "action",
      "explanation": "to go + leadership,guidance + action indicator: to go behind a leader",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        803
      ]
    },
    {
      "id": 2872,
      "bciAvId": 21055,
      "gloss": "religious leader",
      "glossSv": "religiös ledare",
      "pos": "person",
      "explanation": "leader + religion",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        725
      ]
    },
    {
      "id": 2873,
      "bciAvId": 21056,
      "gloss": "bishop",
      "glossSv": "biskop",
      "pos": "person",
      "explanation": "leader + Christian",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        248
      ]
    },
    {
      "id": 2874,
      "bciAvId": 21057,
      "gloss": "Pope",
      "glossSv": "påve",
      "pos": "person",
      "explanation": "leader + Vatican: bishop of Rome and leader of the Roman Catholic Church",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        243,
        "/",
        248
      ]
    },
    {
      "id": 2875,
      "bciAvId": 21058,
      "gloss": "to disperse, to disseminate, to scatter, to spread",
      "glossSv": "sprida, skingra (etc)",
      "pos": "action",
      "explanation": "dispersion,dissemination,scattering,spread,spreading + action indicator",
      "isCharacter": false,
      "composition": [
        941,
        ";",
        81
      ]
    },
    {
      "id": 2876,
      "bciAvId": 21059,
      "gloss": "apostle",
      "glossSv": "apostel, lärjunge",
      "pos": "person",
      "explanation": "man + past + to disseminate + Christianity [contraction]: one of Christ's 12 disciples, whom he chose to preach the gospel",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        503,
        "/",
        941,
        "/",
        248
      ]
    },
    {
      "id": 2877,
      "bciAvId": 21060,
      "gloss": "missionary",
      "glossSv": "missionär",
      "pos": "person",
      "explanation": "person + to disseminate + religion",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        941,
        "/",
        725
      ]
    },
    {
      "id": 2878,
      "bciAvId": 21062,
      "gloss": "hell",
      "glossSv": "helvetet",
      "pos": "noun",
      "explanation": "place + devil",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        728
      ]
    },
    {
      "id": 2879,
      "bciAvId": 21063,
      "gloss": "Adam",
      "glossSv": "Adam",
      "pos": "person",
      "explanation": "man + first: the first man on earth - biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 2880,
      "bciAvId": 21064,
      "gloss": "Eve",
      "glossSv": "Eva",
      "pos": "person",
      "explanation": "woman + first: the first woman on earth - biblical figure",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 2881,
      "bciAvId": 21065,
      "gloss": "Noah",
      "glossSv": "Noak",
      "pos": "person",
      "explanation": "man + boat + animal: biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        170,
        "/",
        122
      ]
    },
    {
      "id": 2882,
      "bciAvId": 21066,
      "gloss": "Abraham",
      "glossSv": "Abraham",
      "pos": "person",
      "explanation": "man + multitude + offspring: biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        459,
        "/",
        479
      ]
    },
    {
      "id": 2883,
      "bciAvId": 21067,
      "gloss": "Moses",
      "glossSv": "Moses",
      "pos": "person",
      "explanation": "man + commandments: biblical figure",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        235
      ]
    },
    {
      "id": 2884,
      "bciAvId": 21068,
      "gloss": "holy book",
      "glossSv": "helig bok",
      "pos": "noun",
      "explanation": "book + God",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        355
      ]
    },
    {
      "id": 2885,
      "bciAvId": 21069,
      "gloss": "Bible (Christian)",
      "glossSv": "Bibeln (kristen)",
      "pos": "noun",
      "explanation": "holy book + Christian",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        355,
        "/",
        248
      ]
    },
    {
      "id": 2886,
      "bciAvId": 21070,
      "gloss": "Old Testament",
      "glossSv": "Gamla Testamentet",
      "pos": "noun",
      "explanation": "holy book + before + Christ [contraction]",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        355,
        "/",
        158,
        "/",
        248
      ]
    },
    {
      "id": 2887,
      "bciAvId": 21071,
      "gloss": "New Testament",
      "glossSv": "Nya Testamentet",
      "pos": "noun",
      "explanation": "holy book + after + Christ [contraction]",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        355,
        "/",
        109,
        "/",
        248
      ]
    },
    {
      "id": 2888,
      "bciAvId": 21072,
      "gloss": "Koran",
      "glossSv": "Koranen",
      "pos": "noun",
      "explanation": "holy book + Muslim",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        355,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 2889,
      "bciAvId": 21073,
      "gloss": "hymnal, hymn book",
      "glossSv": "psalmbok, sångbok (religiös)",
      "pos": "noun",
      "explanation": "book + song + religion",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        457,
        "/",
        462,
        "/",
        725
      ]
    },
    {
      "id": 2890,
      "bciAvId": 21074,
      "gloss": "hymn, psalm, gospel song",
      "glossSv": "psalm, sång (religiös)",
      "pos": "noun",
      "explanation": "song + religion",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462,
        "/",
        725
      ]
    },
    {
      "id": 2891,
      "bciAvId": 21075,
      "gloss": "missal, liturgical book",
      "glossSv": "mässbok",
      "pos": "noun",
      "explanation": "book + action + religion",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        106,
        "/",
        725
      ]
    },
    {
      "id": 2892,
      "bciAvId": 21076,
      "gloss": "gospel",
      "glossSv": "evangelium",
      "pos": "noun",
      "explanation": "story + Jesus Christ [contraction]",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 2893,
      "bciAvId": 21078,
      "gloss": "appearance, manifestation",
      "glossSv": "framträdande, syn",
      "pos": "noun",
      "explanation": "beginning + to see: coming into view for the first time",
      "isCharacter": false,
      "composition": [
        159,
        "/",
        303
      ]
    },
    {
      "id": 2894,
      "bciAvId": 21079,
      "gloss": "to appear",
      "glossSv": "visa sig, synas",
      "pos": "action",
      "explanation": "appearance + action indicator",
      "isCharacter": false,
      "composition": [
        159,
        ";",
        81,
        "/",
        303
      ]
    },
    {
      "id": 2895,
      "bciAvId": 21080,
      "gloss": "disappearance",
      "glossSv": "försvinnande",
      "pos": "noun",
      "explanation": "end + to see",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        303
      ]
    },
    {
      "id": 2896,
      "bciAvId": 21081,
      "gloss": "to disappear",
      "glossSv": "försvinna",
      "pos": "action",
      "explanation": "disappearance + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        303
      ]
    },
    {
      "id": 2897,
      "bciAvId": 21083,
      "gloss": "holy",
      "glossSv": "helig",
      "pos": "description",
      "explanation": "holiness + description indicator",
      "isCharacter": false,
      "composition": [
        738,
        ";",
        86
      ]
    },
    {
      "id": 2898,
      "bciAvId": 21084,
      "gloss": "to sanctify, to consecrate",
      "glossSv": "helga",
      "pos": "action",
      "explanation": "holiness + action indicator",
      "isCharacter": false,
      "composition": [
        738,
        ";",
        81
      ]
    },
    {
      "id": 2899,
      "bciAvId": 21085,
      "gloss": "saint",
      "glossSv": "helgon",
      "pos": "person",
      "explanation": "person + holy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        738
      ]
    },
    {
      "id": 2900,
      "bciAvId": 21086,
      "gloss": "Holy Infant",
      "glossSv": "Jesusbarnet",
      "pos": "person",
      "explanation": "infant + holy",
      "isCharacter": false,
      "composition": [
        140,
        "/",
        738
      ]
    },
    {
      "id": 2901,
      "bciAvId": 21087,
      "gloss": "sanctity of life",
      "glossSv": "livets okränkbarhet",
      "pos": "noun",
      "explanation": "holiness + life",
      "isCharacter": false,
      "composition": [
        738,
        "/",
        423
      ]
    },
    {
      "id": 2902,
      "bciAvId": 21088,
      "gloss": "Holy City",
      "glossSv": "helig stad (Jerusalem etc)",
      "pos": "noun",
      "explanation": "city + holy",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        392,
        "/",
        738
      ]
    },
    {
      "id": 2903,
      "bciAvId": 21089,
      "gloss": "Holy Family",
      "glossSv": "heliga familjen",
      "pos": "person",
      "explanation": "family + holy",
      "isCharacter": false,
      "composition": [
        730,
        "/",
        738
      ]
    },
    {
      "id": 2904,
      "bciAvId": 21094,
      "gloss": "family (group home)",
      "glossSv": "storfamilj, familj i gruppbostad",
      "pos": "person",
      "explanation": "group of + family: family consisting of members of a group home",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        309
      ]
    },
    {
      "id": 2905,
      "bciAvId": 21095,
      "gloss": "religious event",
      "glossSv": "religiös händelse",
      "pos": "noun",
      "explanation": "event + religion",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        725
      ]
    },
    {
      "id": 2906,
      "bciAvId": 21096,
      "gloss": "ceremony",
      "glossSv": "ceremoni",
      "pos": "noun",
      "explanation": "event + plan: event which consists of an act or a set of acts which follow a plan",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532
      ]
    },
    {
      "id": 2907,
      "bciAvId": 21097,
      "gloss": "to meditate",
      "glossSv": "meditera",
      "pos": "action",
      "explanation": "to reflect + spirit + action indicator:to think and reflect within the spirit",
      "isCharacter": false,
      "composition": [
        1076,
        ";",
        81,
        "/",
        735
      ]
    },
    {
      "id": 2908,
      "bciAvId": 21099,
      "gloss": "to confess",
      "glossSv": "bekänna, erkänna",
      "pos": "action",
      "explanation": "to speak + guilty",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        813,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 2909,
      "bciAvId": 21100,
      "gloss": "Christian event",
      "glossSv": "kristen händelse",
      "pos": "noun",
      "explanation": "event + Christian [contraction]",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248
      ]
    },
    {
      "id": 2910,
      "bciAvId": 21101,
      "gloss": "holy event",
      "glossSv": "helig händelse",
      "pos": "noun",
      "explanation": "event + holy",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        738
      ]
    },
    {
      "id": 2911,
      "bciAvId": 21102,
      "gloss": "sacrament",
      "glossSv": "sakrament",
      "pos": "noun",
      "explanation": "Christian event + holy",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738
      ]
    },
    {
      "id": 2912,
      "bciAvId": 21103,
      "gloss": "sacrament of baptism",
      "glossSv": "dopet (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + water",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        695
      ]
    },
    {
      "id": 2913,
      "bciAvId": 21104,
      "gloss": "sacrament of confirmation",
      "glossSv": "konfirmationen (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + fire: Christian sacrament in commemoration of the flame of the Holy Spirit",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        319
      ]
    },
    {
      "id": 2914,
      "bciAvId": 21105,
      "gloss": "sacrament of communion",
      "glossSv": "nattvarden (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + food: Christian sacrament in which consecrated bread and wine are partaken of",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        329
      ]
    },
    {
      "id": 2915,
      "bciAvId": 21106,
      "gloss": "sacrament of absolution",
      "glossSv": "förlåtelsen (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + to forgive",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        1067,
        "/",
        109
      ]
    },
    {
      "id": 2916,
      "bciAvId": 21107,
      "gloss": "sacrament of holy orders",
      "glossSv": "prästvigning, biskopsvigning (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + person + belongs to + God",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        513,
        "/",
        160,
        "/",
        355
      ]
    },
    {
      "id": 2917,
      "bciAvId": 21108,
      "gloss": "sacrament of marriage",
      "glossSv": "äktenskapet (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + marriage",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        437
      ]
    },
    {
      "id": 2918,
      "bciAvId": 21109,
      "gloss": "sacrament of anointment of sick",
      "glossSv": "sista smörjelsen (som sakrament)",
      "pos": "noun",
      "explanation": "sacrament + oil + illness",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        248,
        "/",
        738,
        "/",
        480,
        "/",
        516
      ]
    },
    {
      "id": 2919,
      "bciAvId": 21110,
      "gloss": "confirmation",
      "glossSv": "konfirmation (som ceremoni)",
      "pos": "noun",
      "explanation": "religious ceremony + knowledge",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        412
      ]
    },
    {
      "id": 2920,
      "bciAvId": 21111,
      "gloss": "bat mitzvah (Hebrew)",
      "glossSv": "bat mitzvah (Israel)",
      "pos": "noun",
      "explanation": "religious ceremony + of + woman: religious ceremony that recognizes a Jewish girl as a woman",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        102,
        "/",
        "RK:-2",
        "/",
        710
      ]
    },
    {
      "id": 2921,
      "bciAvId": 21112,
      "gloss": "bar mitzvah (Hebrew)",
      "glossSv": "bar mitzvah (Israel)",
      "pos": "noun",
      "explanation": "religious ceremony + of + man: religious ceremony that recognizes a Jewish boy as a man",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        102,
        "/",
        "RK:-2",
        "/",
        433
      ]
    },
    {
      "id": 2922,
      "bciAvId": 21113,
      "gloss": "circumcision ceremony",
      "glossSv": "omskärelseceremoni",
      "pos": "noun",
      "explanation": "religious ceremony + circumcision: religious procedure performed on male babies",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        725,
        "/",
        634,
        "/",
        548,
        "/",
        434
      ]
    },
    {
      "id": 2923,
      "bciAvId": 21117,
      "gloss": "mausoleum",
      "glossSv": "mausoleum",
      "pos": "noun",
      "explanation": "building + coffin: building in which coffins or tombs are placed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        744
      ]
    },
    {
      "id": 2924,
      "bciAvId": 21118,
      "gloss": "to scatter ashes",
      "glossSv": "strö ut aska",
      "pos": "action",
      "explanation": "to scatter + ashes + action indicator",
      "isCharacter": false,
      "composition": [
        941,
        ";",
        81,
        "/",
        694,
        "/",
        319
      ]
    },
    {
      "id": 2925,
      "bciAvId": 21281,
      "gloss": "urn",
      "glossSv": "urna",
      "pos": "noun",
      "explanation": "vase + ashes: burial urn",
      "isCharacter": false,
      "composition": [
        745,
        "/",
        694,
        "/",
        319
      ]
    },
    {
      "id": 2926,
      "bciAvId": 21283,
      "gloss": "tomb",
      "glossSv": "grav, gravplats",
      "pos": "noun",
      "explanation": "place + coffin",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        744
      ]
    },
    {
      "id": 2927,
      "bciAvId": 21284,
      "gloss": "tombstone",
      "glossSv": "gravsten",
      "pos": "noun",
      "explanation": "stone + grave",
      "isCharacter": false,
      "composition": [
        629,
        "/",
        367
      ]
    },
    {
      "id": 2928,
      "bciAvId": 21285,
      "gloss": "cremation",
      "glossSv": "kremering",
      "pos": "noun",
      "explanation": "fire + death: death representing a dead person [contraction]",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        259
      ]
    },
    {
      "id": 2929,
      "bciAvId": 21286,
      "gloss": "to cremate",
      "glossSv": "kremera",
      "pos": "action",
      "explanation": "cremation + action indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        81,
        "/",
        259
      ]
    },
    {
      "id": 2930,
      "bciAvId": 21287,
      "gloss": "revelry, revel",
      "glossSv": "fest, party",
      "pos": "noun",
      "explanation": "party + intensity: lively or boisterous gathering",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        313,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 2931,
      "bciAvId": 21288,
      "gloss": "religious gathering",
      "glossSv": "gudstjänst, möte (religiöst)",
      "pos": "noun",
      "explanation": "gathering + religion",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        725
      ]
    },
    {
      "id": 2932,
      "bciAvId": 21289,
      "gloss": "awful, dreadful, terrible",
      "glossSv": "hemsk, förfärlig",
      "pos": "description",
      "explanation": "bad + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2933,
      "bciAvId": 21290,
      "gloss": "celebration",
      "glossSv": "firande",
      "pos": "noun",
      "explanation": "event + happy + purpose: event to mark a special occasion",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        678,
        "/",
        551
      ]
    },
    {
      "id": 2934,
      "bciAvId": 21291,
      "gloss": "celebration of life",
      "glossSv": "firande av livet",
      "pos": "noun",
      "explanation": "celebration + life",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        678,
        "/",
        551,
        "/",
        423
      ]
    },
    {
      "id": 2935,
      "bciAvId": 21292,
      "gloss": "misericordia (forgiveness from God)",
      "glossSv": "förbarmande, Guds förlåtelse",
      "pos": "noun",
      "explanation": "to forgive + God",
      "isCharacter": false,
      "composition": [
        1067,
        "/",
        109,
        "/",
        355
      ]
    },
    {
      "id": 2936,
      "bciAvId": 21293,
      "gloss": "forgiveness, pardon",
      "glossSv": "förlåtelse",
      "pos": "noun",
      "explanation": "permission,allowance (moral) + after: giving moral permission for a misdeed after it is done",
      "isCharacter": false,
      "composition": [
        1067,
        "/",
        109
      ]
    },
    {
      "id": 2937,
      "bciAvId": 21294,
      "gloss": "unforgivable, inexcusable",
      "glossSv": "oförlåtlig",
      "pos": "description",
      "explanation": "without + forgiveness + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        1067,
        ";",
        86,
        "/",
        109
      ]
    },
    {
      "id": 2938,
      "bciAvId": 21295,
      "gloss": "shiva (Judaism)",
      "glossSv": "shiva (Israel)",
      "pos": "noun",
      "explanation": "week + to mourn",
      "isCharacter": false,
      "composition": [
        16,
        "/",
        258,
        "/",
        313,
        "/",
        271,
        "/",
        634
      ]
    },
    {
      "id": 2939,
      "bciAvId": 21296,
      "gloss": "to mourn",
      "glossSv": "sörja, sakna",
      "pos": "action",
      "explanation": "sadness + loss + action indicator: to feel sadness or grief after a loss",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        271,
        "/",
        634
      ]
    },
    {
      "id": 2940,
      "bciAvId": 21298,
      "gloss": "mysterious, unknown",
      "glossSv": "okänd, gåtfull, mystisk, oförklarlig",
      "pos": "description",
      "explanation": "mystery + description indicator",
      "isCharacter": false,
      "composition": [
        746,
        ";",
        86
      ]
    },
    {
      "id": 2941,
      "bciAvId": 21299,
      "gloss": "miracle",
      "glossSv": "mirakel, under",
      "pos": "noun",
      "explanation": "supernatural + positive: something positive which cannot be explained by laws of nature",
      "isCharacter": false,
      "composition": [
        733,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 2942,
      "bciAvId": 21300,
      "gloss": "vision, apparition",
      "glossSv": "vision, uppenbarelse",
      "pos": "noun",
      "explanation": "event + supernatural + to see",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        733,
        "/",
        303
      ]
    },
    {
      "id": 2943,
      "bciAvId": 21301,
      "gloss": "atheism",
      "glossSv": "ateism",
      "pos": "noun",
      "explanation": "without + belief + God: disbelief or denial of existence of God",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        1048,
        "/",
        355
      ]
    },
    {
      "id": 2944,
      "bciAvId": 21302,
      "gloss": "Christian faith",
      "glossSv": "tro (kristen)",
      "pos": "noun",
      "explanation": "belief + Christian",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1048,
        "/",
        248
      ]
    },
    {
      "id": 2945,
      "bciAvId": 21303,
      "gloss": "Christian hope",
      "glossSv": "hopp (kristet)",
      "pos": "noun",
      "explanation": "hope + Christian",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678,
        "/",
        1042,
        "/",
        248
      ]
    },
    {
      "id": 2946,
      "bciAvId": 21304,
      "gloss": "Christian love",
      "glossSv": "kärlek (kristen)",
      "pos": "noun",
      "explanation": "love + Christian",
      "isCharacter": false,
      "composition": [
        431,
        "/",
        248
      ]
    },
    {
      "id": 2947,
      "bciAvId": 21305,
      "gloss": "Christian charity",
      "glossSv": "välgörenhet (kristen)",
      "pos": "noun",
      "explanation": "charity + Christian",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        467,
        "/",
        313,
        "/",
        248
      ]
    },
    {
      "id": 2948,
      "bciAvId": 21306,
      "gloss": "poverty",
      "glossSv": "fattigdom",
      "pos": "noun",
      "explanation": "without + ownership,possession: state of being without possessions",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        959
      ]
    },
    {
      "id": 2949,
      "bciAvId": 21307,
      "gloss": "to impoverish",
      "glossSv": "utarma, suga ut",
      "pos": "action",
      "explanation": "to cause + poverty + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        449,
        "/",
        959
      ]
    },
    {
      "id": 2950,
      "bciAvId": 21308,
      "gloss": "abstention",
      "glossSv": "avhållsamhet",
      "pos": "noun",
      "explanation": "decision + without + action: decision to not do something",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        106
      ]
    },
    {
      "id": 2951,
      "bciAvId": 21309,
      "gloss": "obedience",
      "glossSv": "lydnad",
      "pos": "noun",
      "explanation": "action + by + rule [contraction]: act of doing something according to the rules",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        195,
        "/",
        803
      ]
    },
    {
      "id": 2952,
      "bciAvId": 21310,
      "gloss": "to preach",
      "glossSv": "predika",
      "pos": "action",
      "explanation": "to speak + to persuade + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        961
      ]
    },
    {
      "id": 2953,
      "bciAvId": 21311,
      "gloss": "to persuade, to convince",
      "glossSv": "övertyga, övertala",
      "pos": "action",
      "explanation": "persuasion + action indicator: to lead to agreement",
      "isCharacter": false,
      "composition": [
        961,
        ";",
        81
      ]
    },
    {
      "id": 2954,
      "bciAvId": 21312,
      "gloss": "amen",
      "glossSv": "amen",
      "pos": "function",
      "explanation": "yes + religion",
      "isCharacter": false,
      "composition": [
        120,
        "/",
        401,
        "/",
        401,
        "/",
        726
      ]
    },
    {
      "id": 2955,
      "bciAvId": 21313,
      "gloss": "dead person",
      "glossSv": "död person",
      "pos": "person",
      "explanation": "person + dead",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        259
      ]
    },
    {
      "id": 2956,
      "bciAvId": 21314,
      "gloss": "dead (the dead)",
      "glossSv": "de döda",
      "pos": "person",
      "explanation": "dead person + plural indicator",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        99,
        "/",
        259
      ]
    },
    {
      "id": 2957,
      "bciAvId": 21315,
      "gloss": "corpse, cadaver, carrion",
      "glossSv": "lik, kadaver",
      "pos": "noun",
      "explanation": "body + dead",
      "isCharacter": false,
      "composition": [
        171,
        "/",
        259
      ]
    },
    {
      "id": 2958,
      "bciAvId": 21316,
      "gloss": "resurrection",
      "glossSv": "uppståndelse",
      "pos": "noun",
      "explanation": "up + dead: rising from the dead",
      "isCharacter": false,
      "composition": [
        678,
        "/",
        259
      ]
    },
    {
      "id": 2959,
      "bciAvId": 21317,
      "gloss": "ritual",
      "glossSv": "ritual",
      "pos": "noun",
      "explanation": "action + plan + to repeat: plan or procedures repeated over and over",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        532,
        "/",
        963
      ]
    },
    {
      "id": 2960,
      "bciAvId": 21318,
      "gloss": "perseverance",
      "glossSv": "envishet, ihärdighet",
      "pos": "noun",
      "explanation": "action + to repeat + intensity: repeated performance of actions",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        963,
        "/",
        401
      ]
    },
    {
      "id": 2961,
      "bciAvId": 21319,
      "gloss": "to persevere",
      "glossSv": "envisas, hålla fast vid",
      "pos": "action",
      "explanation": "perseverance + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        963,
        "/",
        401
      ]
    },
    {
      "id": 2962,
      "bciAvId": 21320,
      "gloss": "to convert (belief)",
      "glossSv": "konvertera, byta religion",
      "pos": "action",
      "explanation": "conversion + action indicator",
      "isCharacter": false,
      "composition": [
        213,
        ";",
        81,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        1048
      ]
    },
    {
      "id": 2963,
      "bciAvId": 21321,
      "gloss": "conversion (belief)",
      "glossSv": "konvertering, religionsbyte",
      "pos": "noun",
      "explanation": "change + belief",
      "isCharacter": false,
      "composition": [
        213,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        1048
      ]
    },
    {
      "id": 2964,
      "bciAvId": 21322,
      "gloss": "fast, go without food",
      "glossSv": "fasta (subst.)",
      "pos": "noun",
      "explanation": "decision + without + food: decision to go without food",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        329
      ]
    },
    {
      "id": 2965,
      "bciAvId": 21323,
      "gloss": "to fast",
      "glossSv": "fasta (verb)",
      "pos": "action",
      "explanation": "fast + action indicator",
      "isCharacter": false,
      "composition": [
        260,
        ";",
        81,
        "/",
        449,
        "/",
        329
      ]
    },
    {
      "id": 2966,
      "bciAvId": 21324,
      "gloss": "Ramadan",
      "glossSv": "Ramadan",
      "pos": "noun",
      "explanation": "fast + month + Muslim: month of fasting observed by Muslims",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        329,
        "/",
        452,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 2967,
      "bciAvId": 21325,
      "gloss": "forefather",
      "glossSv": "förfader, anfader",
      "pos": "person",
      "explanation": "father + past",
      "isCharacter": false,
      "composition": [
        312,
        "/",
        503
      ]
    },
    {
      "id": 2968,
      "bciAvId": 21326,
      "gloss": "foremother",
      "glossSv": "förmoder, anmoder",
      "pos": "person",
      "explanation": "mother + past",
      "isCharacter": false,
      "composition": [
        455,
        "/",
        503
      ]
    },
    {
      "id": 2969,
      "bciAvId": 21327,
      "gloss": "ancestor",
      "glossSv": "anfader",
      "pos": "person",
      "explanation": "parent + past",
      "isCharacter": false,
      "composition": [
        500,
        "/",
        503
      ]
    },
    {
      "id": 2970,
      "bciAvId": 21328,
      "gloss": "all knowing",
      "glossSv": "allvetande",
      "pos": "description",
      "explanation": "knowledge + all + description indicator",
      "isCharacter": false,
      "composition": [
        412,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 2971,
      "bciAvId": 21329,
      "gloss": "all powerful",
      "glossSv": "allsmäktig",
      "pos": "description",
      "explanation": "ability + all + description indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 2972,
      "bciAvId": 21331,
      "gloss": "unending, endless",
      "glossSv": "oändlig",
      "pos": "description",
      "explanation": "without + end + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        292,
        ";",
        86
      ]
    },
    {
      "id": 2973,
      "bciAvId": 21332,
      "gloss": "eternal",
      "glossSv": "evig (FD)",
      "pos": "description",
      "explanation": "eternity,infinity (OLD) + description indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        449,
        "/",
        427
      ]
    },
    {
      "id": 2974,
      "bciAvId": 21333,
      "gloss": "to interrogate",
      "glossSv": "förhöra",
      "pos": "action",
      "explanation": "to ask + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 2975,
      "bciAvId": 21334,
      "gloss": "to beg, to plead",
      "glossSv": "be om, vädja",
      "pos": "action",
      "explanation": "to ask + comma + please + action indicator",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81,
        "/",
        5,
        "/",
        401,
        "/",
        313
      ]
    },
    {
      "id": 2976,
      "bciAvId": 21335,
      "gloss": "to command, to order",
      "glossSv": "befalla",
      "pos": "action",
      "explanation": "to say + for the purpose of + action + action indicator: to speak with authority",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        332,
        "/",
        106
      ]
    },
    {
      "id": 2977,
      "bciAvId": 21336,
      "gloss": "to demand",
      "glossSv": "begära, kräva",
      "pos": "action",
      "explanation": "to say + to want + intensity + action indicator: to speak or ask with urgency",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        313,
        "/",
        319,
        "/",
        401
      ]
    },
    {
      "id": 2978,
      "bciAvId": 21337,
      "gloss": "to proclaim, to announce",
      "glossSv": "tillkännage, förkunna",
      "pos": "action",
      "explanation": "proclamation + action indicator: to make a public announcement",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        941
      ]
    },
    {
      "id": 2979,
      "bciAvId": 21338,
      "gloss": "proclamation, announcement",
      "glossSv": "tillkännagivande, förkunnelse",
      "pos": "noun",
      "explanation": "to say + to disseminate: a public announcement",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        941
      ]
    },
    {
      "id": 2980,
      "bciAvId": 21339,
      "gloss": "proclamation (written)",
      "glossSv": "skriftligt tillkännagivande",
      "pos": "noun",
      "explanation": "paper + proclamation",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        941
      ]
    },
    {
      "id": 2981,
      "bciAvId": 21340,
      "gloss": "flyer",
      "glossSv": "flygblad, reklamblad",
      "pos": "noun",
      "explanation": "paper + to disseminate",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        941
      ]
    },
    {
      "id": 2982,
      "bciAvId": 21341,
      "gloss": "correctness, rightness",
      "glossSv": "riktighet, rätt",
      "pos": "noun",
      "explanation": "correct thinking + intensity: a combination of mind and positive",
      "isCharacter": false,
      "composition": [
        1012,
        "/",
        401
      ]
    },
    {
      "id": 2983,
      "bciAvId": 21342,
      "gloss": "excellence",
      "glossSv": "förträfflighet",
      "pos": "noun",
      "explanation": "correctness + intensity",
      "isCharacter": false,
      "composition": [
        1012,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2984,
      "bciAvId": 21343,
      "gloss": "excellent",
      "glossSv": "förträfflig, utmärkt",
      "pos": "description",
      "explanation": "excellence + description indicator",
      "isCharacter": false,
      "composition": [
        1012,
        ";",
        86,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2985,
      "bciAvId": 21344,
      "gloss": "perfection",
      "glossSv": "perfektion",
      "pos": "noun",
      "explanation": "excellence + intensity",
      "isCharacter": false,
      "composition": [
        1012,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2986,
      "bciAvId": 21345,
      "gloss": "perfect",
      "glossSv": "perfekt",
      "pos": "description",
      "explanation": "perfection + description indicator",
      "isCharacter": false,
      "composition": [
        1012,
        ";",
        86,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2987,
      "bciAvId": 21346,
      "gloss": "to evangelise, to evangelize",
      "glossSv": "evangelisera",
      "pos": "action",
      "explanation": "to disseminate + news + positive + action indicator",
      "isCharacter": false,
      "composition": [
        941,
        ";",
        81,
        "/",
        469,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 2988,
      "bciAvId": 21347,
      "gloss": "to evangelise, to evangelize (christian)",
      "glossSv": "predika evangelium, missionera (kristendom)",
      "pos": "action",
      "explanation": "to disseminate + news + positive + Christianity [contraction] + action indicator",
      "isCharacter": false,
      "composition": [
        941,
        ";",
        81,
        "/",
        469,
        "/",
        120,
        "/",
        401,
        "/",
        248
      ]
    },
    {
      "id": 2989,
      "bciAvId": 21348,
      "gloss": "to drown",
      "glossSv": "drunkna",
      "pos": "action",
      "explanation": "drowning + action indicator",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        81,
        "/",
        695
      ]
    },
    {
      "id": 2990,
      "bciAvId": 21349,
      "gloss": "to drown (cause to)",
      "glossSv": "dränka",
      "pos": "action",
      "explanation": "to cause + drowning + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        259,
        "/",
        695
      ]
    },
    {
      "id": 2991,
      "bciAvId": 21350,
      "gloss": "desert",
      "glossSv": "öken",
      "pos": "noun",
      "explanation": "earth + without + water",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        449,
        "/",
        695
      ]
    },
    {
      "id": 2992,
      "bciAvId": 21351,
      "gloss": "wilderness",
      "glossSv": "vildmark",
      "pos": "noun",
      "explanation": "countryside + open/wild",
      "isCharacter": false,
      "composition": [
        244,
        "/",
        484
      ]
    },
    {
      "id": 2993,
      "bciAvId": 21352,
      "gloss": "huge",
      "glossSv": "jättestor",
      "pos": "description",
      "explanation": "big + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        936,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 2994,
      "bciAvId": 21353,
      "gloss": "enormous",
      "glossSv": "enorm",
      "pos": "description",
      "explanation": "huge + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        936,
        ";",
        86,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2995,
      "bciAvId": 21354,
      "gloss": "gigantic",
      "glossSv": "ofantlig",
      "pos": "description",
      "explanation": "enormous + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        936,
        ";",
        86,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 2996,
      "bciAvId": 21355,
      "gloss": "manna",
      "glossSv": "manna",
      "pos": "noun",
      "explanation": "food + from sky: food, or something, provided unexpectedly, as though it had dropped from heaven",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        1040
      ]
    },
    {
      "id": 2997,
      "bciAvId": 21356,
      "gloss": "uninhabited",
      "glossSv": "obebodd",
      "pos": "description",
      "explanation": "place + without + human being + description indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        86,
        "/",
        449,
        "/",
        513
      ]
    },
    {
      "id": 2998,
      "bciAvId": 21357,
      "gloss": "fishnet",
      "glossSv": "fisknät",
      "pos": "noun",
      "explanation": "cloth + fish",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        321
      ]
    },
    {
      "id": 2999,
      "bciAvId": 21358,
      "gloss": "incense",
      "glossSv": "rökelse",
      "pos": "noun",
      "explanation": "smoke + smell",
      "isCharacter": false,
      "composition": [
        230,
        "/",
        319,
        "/",
        600
      ]
    },
    {
      "id": 3000,
      "bciAvId": 21359,
      "gloss": "calling, vocation",
      "glossSv": "kall, livsuppgift",
      "pos": "noun",
      "explanation": "life + choice: chosen way of life",
      "isCharacter": false,
      "composition": [
        423,
        "/",
        223
      ]
    },
    {
      "id": 3001,
      "bciAvId": 21360,
      "gloss": "calling, profession, career",
      "glossSv": "yrke",
      "pos": "noun",
      "explanation": "work + choice: chosen work",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        223
      ]
    },
    {
      "id": 3002,
      "bciAvId": 21361,
      "gloss": "to nag",
      "glossSv": "tjata",
      "pos": "action",
      "explanation": "to say + to repeat + action indicator: to say repeatedly or over and over again",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        963
      ]
    },
    {
      "id": 3003,
      "bciAvId": 21362,
      "gloss": "oil lamp",
      "glossSv": "oljelampa",
      "pos": "noun",
      "explanation": "lamp + oil + thing indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        480
      ]
    },
    {
      "id": 3004,
      "bciAvId": 21364,
      "gloss": "chalice",
      "glossSv": "nattvardskalk",
      "pos": "noun",
      "explanation": "goblet + holy",
      "isCharacter": false,
      "composition": [
        747,
        "/",
        738
      ]
    },
    {
      "id": 3005,
      "bciAvId": 21365,
      "gloss": "ampullae",
      "glossSv": "ampulla",
      "pos": "noun",
      "explanation": "two + bottle + holy",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        174,
        "/",
        738
      ]
    },
    {
      "id": 3006,
      "bciAvId": 21366,
      "gloss": "paten, holy tray",
      "glossSv": "patén",
      "pos": "noun",
      "explanation": "plate + holy",
      "isCharacter": false,
      "composition": [
        265,
        "/",
        738
      ]
    },
    {
      "id": 3007,
      "bciAvId": 21367,
      "gloss": "Host, wafer (in religious ceremony)",
      "glossSv": "oblat",
      "pos": "noun",
      "explanation": "bread + holy",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        738
      ]
    },
    {
      "id": 3008,
      "bciAvId": 21368,
      "gloss": "altar",
      "glossSv": "altare",
      "pos": "noun",
      "explanation": "table + holy",
      "isCharacter": false,
      "composition": [
        639,
        "/",
        738
      ]
    },
    {
      "id": 3009,
      "bciAvId": 21369,
      "gloss": "altar cloth",
      "glossSv": "altarduk",
      "pos": "noun",
      "explanation": "cloth + altar",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        639,
        "/",
        738
      ]
    },
    {
      "id": 3010,
      "bciAvId": 21370,
      "gloss": "vestment",
      "glossSv": "kyrkskrud",
      "pos": "noun",
      "explanation": "clothing + holy",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        738
      ]
    },
    {
      "id": 3011,
      "bciAvId": 21371,
      "gloss": "Christmas tree",
      "glossSv": "julgran",
      "pos": "noun",
      "explanation": "tree + Christmas [contraction]",
      "isCharacter": false,
      "composition": [
        666,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 3012,
      "bciAvId": 21372,
      "gloss": "interview",
      "glossSv": "intervju, utfrågning",
      "pos": "noun",
      "explanation": "question + person",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        513
      ]
    },
    {
      "id": 3013,
      "bciAvId": 21373,
      "gloss": "to interview",
      "glossSv": "intervjua, fråga ut",
      "pos": "action",
      "explanation": "interview + action indicator",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81,
        "/",
        513
      ]
    },
    {
      "id": 3014,
      "bciAvId": 21374,
      "gloss": "interviewer",
      "glossSv": "intervjuare",
      "pos": "person",
      "explanation": "person + interview",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        553,
        "/",
        513
      ]
    },
    {
      "id": 3015,
      "bciAvId": 21380,
      "gloss": "universal, world-wide",
      "glossSv": "allomfattande, universell",
      "pos": "description",
      "explanation": "world + all + description indicator",
      "isCharacter": false,
      "composition": [
        712,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 3016,
      "bciAvId": 21381,
      "gloss": "forgiven",
      "glossSv": "förlåten",
      "pos": "description",
      "explanation": "forgiveness + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        1067,
        ";",
        84,
        "/",
        109
      ]
    },
    {
      "id": 3017,
      "bciAvId": 21537,
      "gloss": "to sign",
      "glossSv": "teckna, kommunicera med tecken",
      "pos": "action",
      "explanation": "sign language + action indicator",
      "isCharacter": false,
      "composition": [
        414,
        ";",
        81,
        "/",
        374
      ]
    },
    {
      "id": 3018,
      "bciAvId": 21538,
      "gloss": "sign language",
      "glossSv": "teckenspråk",
      "pos": "noun",
      "explanation": "language + hand: language expressed with the hands",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        374
      ]
    },
    {
      "id": 3019,
      "bciAvId": 21539,
      "gloss": "polder (Dutch)",
      "glossSv": "polder (Nederländerna)",
      "pos": "noun",
      "explanation": "earth + dryness: land protected by dykes which has been reclaimed from a body of water",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        860
      ]
    },
    {
      "id": 3020,
      "bciAvId": 21542,
      "gloss": "astronomy",
      "glossSv": "astronomi",
      "pos": "noun",
      "explanation": "science + star: scientific study of the universe beyond the earth",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        622
      ]
    },
    {
      "id": 3021,
      "bciAvId": 21543,
      "gloss": "economics",
      "glossSv": "ekonomi",
      "pos": "noun",
      "explanation": "science + business: science that deals with the production, distribution and consumption of commodities",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        191
      ]
    },
    {
      "id": 3022,
      "bciAvId": 21544,
      "gloss": "chemistry",
      "glossSv": "kemi",
      "pos": "noun",
      "explanation": "science + chemical product: science of the composition, structure, properties and reactions of matter",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        216
      ]
    },
    {
      "id": 3023,
      "bciAvId": 21545,
      "gloss": "biochemistry",
      "glossSv": "biokemi",
      "pos": "noun",
      "explanation": "science + biochemical product: chemistry of biological substances and processes",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        999
      ]
    },
    {
      "id": 3024,
      "bciAvId": 21546,
      "gloss": "biology",
      "glossSv": "biologi",
      "pos": "noun",
      "explanation": "science + combination of chemical product and life: science of living organisms and life processes",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        423
      ]
    },
    {
      "id": 3025,
      "bciAvId": 21547,
      "gloss": "botany",
      "glossSv": "botanik",
      "pos": "noun",
      "explanation": "science + plant: biological science of plants",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        533
      ]
    },
    {
      "id": 3026,
      "bciAvId": 21548,
      "gloss": "anthropology",
      "glossSv": "antropologi",
      "pos": "noun",
      "explanation": "science + human being: scientific study of human beings",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        513
      ]
    },
    {
      "id": 3027,
      "bciAvId": 21549,
      "gloss": "zoology",
      "glossSv": "zoologi",
      "pos": "noun",
      "explanation": "science + animal: biological science of animals",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        122
      ]
    },
    {
      "id": 3028,
      "bciAvId": 21550,
      "gloss": "geology",
      "glossSv": "geologi",
      "pos": "noun",
      "explanation": "science + earth: scientific study of the origins, history and structure of the earth",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        281
      ]
    },
    {
      "id": 3029,
      "bciAvId": 21551,
      "gloss": "sociology",
      "glossSv": "sociologi",
      "pos": "noun",
      "explanation": "science + life + group: study of human social behaviour",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        423,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 3030,
      "bciAvId": 21552,
      "gloss": "psychology",
      "glossSv": "psykologi (FD)",
      "pos": "noun",
      "explanation": "science + mind: science of mental processes and behaviour",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        447
      ]
    },
    {
      "id": 3031,
      "bciAvId": 21553,
      "gloss": "history",
      "glossSv": "historia",
      "pos": "noun",
      "explanation": "science + past: study of the past, especially as revealed in recorded materials",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        503
      ]
    },
    {
      "id": 3032,
      "bciAvId": 21554,
      "gloss": "archaeology, archeology",
      "glossSv": "arkeologi",
      "pos": "noun",
      "explanation": "history + thing: study of physical objects and material evidence from the past",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        503,
        "/",
        651
      ]
    },
    {
      "id": 3033,
      "bciAvId": 21555,
      "gloss": "meteorology",
      "glossSv": "meteorologi",
      "pos": "noun",
      "explanation": "science + weather: science dealing with the phenomena of the atmosphere, especially of weather",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        696
      ]
    },
    {
      "id": 3034,
      "bciAvId": 21556,
      "gloss": "physics",
      "glossSv": "fysik",
      "pos": "noun",
      "explanation": "science + energy: science of matter and energy and of interactions between them",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        293
      ]
    },
    {
      "id": 3035,
      "bciAvId": 21557,
      "gloss": "linguistics",
      "glossSv": "lingvistik",
      "pos": "noun",
      "explanation": "science + language: study of the nature and structure of language",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        414
      ]
    },
    {
      "id": 3036,
      "bciAvId": 21558,
      "gloss": "mathematics, arithmetic, math (1)",
      "glossSv": "matematik (1)",
      "pos": "noun",
      "explanation": "science + number: study of numbers, their form, arrangement and associated relationships",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        478
      ]
    },
    {
      "id": 3037,
      "bciAvId": 21559,
      "gloss": "scientist, academic",
      "glossSv": "vetenskapsman, forskare",
      "pos": "person",
      "explanation": "person + science",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580
      ]
    },
    {
      "id": 3038,
      "bciAvId": 21560,
      "gloss": "astronomer",
      "glossSv": "astronom",
      "pos": "person",
      "explanation": "person + astronomy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        622
      ]
    },
    {
      "id": 3039,
      "bciAvId": 21561,
      "gloss": "economist",
      "glossSv": "ekonom",
      "pos": "person",
      "explanation": "person + economics",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        191
      ]
    },
    {
      "id": 3040,
      "bciAvId": 21562,
      "gloss": "chemist",
      "glossSv": "kemist",
      "pos": "person",
      "explanation": "person + chemistry",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        216
      ]
    },
    {
      "id": 3041,
      "bciAvId": 21563,
      "gloss": "biochemist",
      "glossSv": "biokemist",
      "pos": "person",
      "explanation": "person + biochemistry",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        999
      ]
    },
    {
      "id": 3042,
      "bciAvId": 21564,
      "gloss": "biologist",
      "glossSv": "biolog",
      "pos": "person",
      "explanation": "person + biology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        423
      ]
    },
    {
      "id": 3043,
      "bciAvId": 21565,
      "gloss": "botanist",
      "glossSv": "botanist",
      "pos": "person",
      "explanation": "person + botany",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        533
      ]
    },
    {
      "id": 3044,
      "bciAvId": 21566,
      "gloss": "zoologist",
      "glossSv": "zoolog",
      "pos": "person",
      "explanation": "person + zoology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        122
      ]
    },
    {
      "id": 3045,
      "bciAvId": 21567,
      "gloss": "geologist",
      "glossSv": "geolog",
      "pos": "person",
      "explanation": "person + geology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        281
      ]
    },
    {
      "id": 3046,
      "bciAvId": 21568,
      "gloss": "sociologist",
      "glossSv": "sociolog",
      "pos": "person",
      "explanation": "person + sociology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        423,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 3047,
      "bciAvId": 21569,
      "gloss": "historian",
      "glossSv": "historiker",
      "pos": "person",
      "explanation": "person + history",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        503
      ]
    },
    {
      "id": 3048,
      "bciAvId": 21570,
      "gloss": "archaeologist, archeologist",
      "glossSv": "arkeolog",
      "pos": "person",
      "explanation": "person + archeology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        503,
        "/",
        651
      ]
    },
    {
      "id": 3049,
      "bciAvId": 21571,
      "gloss": "meteorologist",
      "glossSv": "meteorolog",
      "pos": "person",
      "explanation": "person + meteorology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        696
      ]
    },
    {
      "id": 3050,
      "bciAvId": 21572,
      "gloss": "linguist",
      "glossSv": "lingvist",
      "pos": "person",
      "explanation": "person + linguistics",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        414
      ]
    },
    {
      "id": 3051,
      "bciAvId": 21573,
      "gloss": "mathematician (academic)",
      "glossSv": "matematiker",
      "pos": "person",
      "explanation": "person + mathematics,arithmetic,math (1)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        478
      ]
    },
    {
      "id": 3052,
      "bciAvId": 21574,
      "gloss": "paediatrician, pediatrician",
      "glossSv": "barnläkare",
      "pos": "person",
      "explanation": "doctor + child",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        220
      ]
    },
    {
      "id": 3053,
      "bciAvId": 21575,
      "gloss": "surgeon",
      "glossSv": "kirurg",
      "pos": "person",
      "explanation": "doctor + knife",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        411
      ]
    },
    {
      "id": 3054,
      "bciAvId": 21576,
      "gloss": "otolaryngologist",
      "glossSv": "öron näs och halsläkare",
      "pos": "person",
      "explanation": "doctor + ear + nose + neck (head): specialist doctor of ear, nose and throat",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        278,
        "/",
        "RK:-2",
        "/",
        473,
        "/",
        465
      ]
    },
    {
      "id": 3055,
      "bciAvId": 21577,
      "gloss": "orthopaedist, orthopedist",
      "glossSv": "ortoped",
      "pos": "person",
      "explanation": "doctor + bone",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        172
      ]
    },
    {
      "id": 3056,
      "bciAvId": 21578,
      "gloss": "ophthalmologist, oculist",
      "glossSv": "ögonläkare",
      "pos": "person",
      "explanation": "doctor + eye",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        303
      ]
    },
    {
      "id": 3057,
      "bciAvId": 21579,
      "gloss": "doctor (rehab, hab)",
      "glossSv": "rehabiliteringsläkare, habiliteringsläkare",
      "pos": "person",
      "explanation": "doctor + to advance + ability: physician who works to improve or restore physical abilities",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        335,
        "/",
        101
      ]
    },
    {
      "id": 3058,
      "bciAvId": 21580,
      "gloss": "gynaecologist, gynecologist",
      "glossSv": "gynekolog",
      "pos": "person",
      "explanation": "doctor + woman: physician who diagnoses and treats female reproduction organs",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        710
      ]
    },
    {
      "id": 3059,
      "bciAvId": 21581,
      "gloss": "general practitioner",
      "glossSv": "allmänläkare",
      "pos": "person",
      "explanation": "doctor + generalization: physician who treats a variety of medical problems",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        348
      ]
    },
    {
      "id": 3060,
      "bciAvId": 21582,
      "gloss": "cardiologist",
      "glossSv": "kardiolog",
      "pos": "person",
      "explanation": "doctor + heart + thing indicator: physician who diagnoses and treats disorders of the heart",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        313,
        ";",
        97
      ]
    },
    {
      "id": 3061,
      "bciAvId": 21583,
      "gloss": "neurologist",
      "glossSv": "neurolog",
      "pos": "person",
      "explanation": "doctor + central nervous system + thing indicator: physician who diagnoses and treats disorders of the nervous system",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        991,
        ";",
        97
      ]
    },
    {
      "id": 3062,
      "bciAvId": 21584,
      "gloss": "psychiatrist",
      "glossSv": "psykiater",
      "pos": "person",
      "explanation": "doctor + mind: physician who diagnoses and treats mental illness",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        447
      ]
    },
    {
      "id": 3063,
      "bciAvId": 21585,
      "gloss": "central nervous system, CNS",
      "glossSv": "centrala nervsystem(et), CNS",
      "pos": "noun",
      "explanation": "brain signal + thing indicator: system consisting of brain and spinal cord which is activated by electrical impulses",
      "isCharacter": false,
      "composition": [
        991,
        ";",
        97
      ]
    },
    {
      "id": 3064,
      "bciAvId": 21586,
      "gloss": "psychologist (researcher)",
      "glossSv": "psykolog (forskare) (FD)",
      "pos": "person",
      "explanation": "person + psychology (OLD)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        447
      ]
    },
    {
      "id": 3065,
      "bciAvId": 21587,
      "gloss": "psychologist",
      "glossSv": "psykolog (FD)",
      "pos": "person",
      "explanation": "person + knowledge + mind",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        447
      ]
    },
    {
      "id": 3066,
      "bciAvId": 21588,
      "gloss": "psychology teacher",
      "glossSv": "psykologilärare (FD)",
      "pos": "person",
      "explanation": "teacher + mind",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        949,
        "/",
        412,
        "/",
        447
      ]
    },
    {
      "id": 3067,
      "bciAvId": 21590,
      "gloss": "speech therapist",
      "glossSv": "logoped",
      "pos": "person",
      "explanation": "therapist + language",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        414
      ]
    },
    {
      "id": 3068,
      "bciAvId": 21591,
      "gloss": "occupational therapist",
      "glossSv": "arbetsterapeut",
      "pos": "person",
      "explanation": "therapist + activity",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        106
      ]
    },
    {
      "id": 3069,
      "bciAvId": 21592,
      "gloss": "physiotherapist",
      "glossSv": "sjukgymnast",
      "pos": "person",
      "explanation": "therapist + muscle",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        718
      ]
    },
    {
      "id": 3070,
      "bciAvId": 21593,
      "gloss": "audiologist",
      "glossSv": "audionom, hörselassistent",
      "pos": "person",
      "explanation": "therapist + ear [hearing]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        278
      ]
    },
    {
      "id": 3071,
      "bciAvId": 21594,
      "gloss": "orthoptist",
      "glossSv": "ortoptist",
      "pos": "person",
      "explanation": "therapist + eye [vision]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        303
      ]
    },
    {
      "id": 3072,
      "bciAvId": 21595,
      "gloss": "communication therapist",
      "glossSv": "kommunikationsterapeut",
      "pos": "person",
      "explanation": "therapist + communication",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        1029,
        "/",
        440
      ]
    },
    {
      "id": 3073,
      "bciAvId": 21596,
      "gloss": "podiatrist, chiropodist",
      "glossSv": "fotterapeut, fotvårdare, fotvårdsspecialist",
      "pos": "person",
      "explanation": "therapist + foot",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        330
      ]
    },
    {
      "id": 3074,
      "bciAvId": 21597,
      "gloss": "hydrotherapist",
      "glossSv": "hydroterapeut",
      "pos": "person",
      "explanation": "therapist + water",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        695
      ]
    },
    {
      "id": 3075,
      "bciAvId": 21598,
      "gloss": "music therapist",
      "glossSv": "musikterapeut",
      "pos": "person",
      "explanation": "therapist + music",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 3076,
      "bciAvId": 21599,
      "gloss": "dance therapist",
      "glossSv": "dansterapeut",
      "pos": "person",
      "explanation": "therapist + dance",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        750,
        "/",
        418,
        "/",
        462
      ]
    },
    {
      "id": 3077,
      "bciAvId": 21600,
      "gloss": "osteopath",
      "glossSv": "osteopat",
      "pos": "person",
      "explanation": "person + hand + bone: person who treats medical disorders by manipulation techniques",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        172
      ]
    },
    {
      "id": 3078,
      "bciAvId": 21601,
      "gloss": "chiropractor",
      "glossSv": "kiropraktor",
      "pos": "person",
      "explanation": "person + hand + joint: person who treats medical disorders by manipulation of the spinal column and other structures",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        406
      ]
    },
    {
      "id": 3079,
      "bciAvId": 21602,
      "gloss": "masseur",
      "glossSv": "massör",
      "pos": "person",
      "explanation": "person + hand + muscle: person who manipulates the body to relax muscles",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        718
      ]
    },
    {
      "id": 3080,
      "bciAvId": 21603,
      "gloss": "aroma therapist",
      "glossSv": "aromterapeut",
      "pos": "person",
      "explanation": "person + hand + smell: person who gives therapy, based of different scents",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        600
      ]
    },
    {
      "id": 3081,
      "bciAvId": 21604,
      "gloss": "reflexologist",
      "glossSv": "reflexologist",
      "pos": "person",
      "explanation": "person + hand + foot: person who gives therapy, based on manipulation of different zones of the foot",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        330
      ]
    },
    {
      "id": 3082,
      "bciAvId": 21605,
      "gloss": "acupuncturist",
      "glossSv": "akupunktör",
      "pos": "person",
      "explanation": "person + hand + linear thing + thing indicator: person who treats illness by puncturing the body with needles",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        374,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 3083,
      "bciAvId": 21606,
      "gloss": "massage",
      "glossSv": "massage",
      "pos": "noun",
      "explanation": "action + hand + muscle: manipulation of the body to relax muscles",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        718
      ]
    },
    {
      "id": 3084,
      "bciAvId": 21608,
      "gloss": "culture",
      "glossSv": "kultur",
      "pos": "noun",
      "explanation": "view of life + group: view of life shared by a group of people",
      "isCharacter": false,
      "composition": [
        751,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 3085,
      "bciAvId": 21609,
      "gloss": "people, tribe, clan, folk",
      "glossSv": "folkgrupp, stam (etc)",
      "pos": "noun",
      "explanation": "group (people) + view of life: group of people who share a common culture",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        751
      ]
    },
    {
      "id": 3086,
      "bciAvId": 21610,
      "gloss": "nation",
      "glossSv": "nation",
      "pos": "noun",
      "explanation": "group (people) + country: group of people organized under a single government",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        243
      ]
    },
    {
      "id": 3087,
      "bciAvId": 21611,
      "gloss": "folk music",
      "glossSv": "folkmusik",
      "pos": "noun",
      "explanation": "music + culture",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        751,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 3088,
      "bciAvId": 21612,
      "gloss": "genocide, holocaust",
      "glossSv": "förintelse, holocaust",
      "pos": "noun",
      "explanation": "destruction + people: systematic annihilation of a racial, political or cultural group",
      "isCharacter": false,
      "composition": [
        939,
        "/",
        368,
        "/",
        513,
        "/",
        751
      ]
    },
    {
      "id": 3089,
      "bciAvId": 21613,
      "gloss": "headscarf",
      "glossSv": "scarf",
      "pos": "noun",
      "explanation": "clothing + head",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        376
      ]
    },
    {
      "id": 3090,
      "bciAvId": 21614,
      "gloss": "veil",
      "glossSv": "slöja",
      "pos": "noun",
      "explanation": "clothing + face",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        306
      ]
    },
    {
      "id": 3091,
      "bciAvId": 21615,
      "gloss": "helmet",
      "glossSv": "hjälm",
      "pos": "noun",
      "explanation": "protection + intensity + head: strong protection for the head",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        376
      ]
    },
    {
      "id": 3092,
      "bciAvId": 21616,
      "gloss": "riding helmet",
      "glossSv": "ridhjälm",
      "pos": "noun",
      "explanation": "helmet + horse: helmet worn when riding a horse",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        376,
        "/",
        391
      ]
    },
    {
      "id": 3093,
      "bciAvId": 21617,
      "gloss": "hockey helmet",
      "glossSv": "hockeyhjälm",
      "pos": "noun",
      "explanation": "helmet + sport stick and puck,hockey stick (ice hockey [contraction])",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        376,
        "/",
        1093
      ]
    },
    {
      "id": 3094,
      "bciAvId": 21618,
      "gloss": "bicycle helmet, crash helmet",
      "glossSv": "cykelhjälm",
      "pos": "noun",
      "explanation": "helmet + bicycle",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        376,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 3095,
      "bciAvId": 21619,
      "gloss": "knee pad",
      "glossSv": "knäskydd",
      "pos": "noun",
      "explanation": "protection + intensity + knee",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        410
      ]
    },
    {
      "id": 3096,
      "bciAvId": 21620,
      "gloss": "elbow pad",
      "glossSv": "armbågsskydd",
      "pos": "noun",
      "explanation": "protection + intensity + elbow",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        287
      ]
    },
    {
      "id": 3097,
      "bciAvId": 21621,
      "gloss": "protective mask",
      "glossSv": "skyddsmask",
      "pos": "noun",
      "explanation": "protection + intensity + face",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        306
      ]
    },
    {
      "id": 3098,
      "bciAvId": 21622,
      "gloss": "suit of armour, suit of armor",
      "glossSv": "rustning",
      "pos": "noun",
      "explanation": "protection + intensity + body",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        171
      ]
    },
    {
      "id": 3099,
      "bciAvId": 21625,
      "gloss": "ball sports",
      "glossSv": "bollsport",
      "pos": "noun",
      "explanation": "sport + ball",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148
      ]
    },
    {
      "id": 3100,
      "bciAvId": 21626,
      "gloss": "water sports",
      "glossSv": "vattensport",
      "pos": "noun",
      "explanation": "sport + water",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        695
      ]
    },
    {
      "id": 3101,
      "bciAvId": 21627,
      "gloss": "contact sports",
      "glossSv": "kampsport",
      "pos": "noun",
      "explanation": "sport + fight",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934
      ]
    },
    {
      "id": 3102,
      "bciAvId": 21628,
      "gloss": "athletics",
      "glossSv": "friidrott",
      "pos": "noun",
      "explanation": "sport + beginning: the original sports/contests",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        159
      ]
    },
    {
      "id": 3103,
      "bciAvId": 21629,
      "gloss": "equestrian sports",
      "glossSv": "hästsport",
      "pos": "noun",
      "explanation": "sport + horse",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391
      ]
    },
    {
      "id": 3104,
      "bciAvId": 21630,
      "gloss": "winter sports",
      "glossSv": "vintersport",
      "pos": "noun",
      "explanation": "sport + snow",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        604
      ]
    },
    {
      "id": 3105,
      "bciAvId": 21794,
      "gloss": "motor sports",
      "glossSv": "motorsport",
      "pos": "noun",
      "explanation": "sport + motor",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        432
      ]
    },
    {
      "id": 3106,
      "bciAvId": 21795,
      "gloss": "mountain sports",
      "glossSv": "klättersport",
      "pos": "noun",
      "explanation": "sport + mountain",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        456
      ]
    },
    {
      "id": 3107,
      "bciAvId": 21796,
      "gloss": "sky sports",
      "glossSv": "sport utövad i luften",
      "pos": "noun",
      "explanation": "sport + sky",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        597
      ]
    },
    {
      "id": 3108,
      "bciAvId": 21797,
      "gloss": "shooting sports",
      "glossSv": "skytte",
      "pos": "noun",
      "explanation": "sport + gun",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        369
      ]
    },
    {
      "id": 3109,
      "bciAvId": 21798,
      "gloss": "gymnastics",
      "glossSv": "gymnastik",
      "pos": "noun",
      "explanation": "sport + muscle + design: sport in which movements are carefully planned",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        718,
        "/",
        532
      ]
    },
    {
      "id": 3110,
      "bciAvId": 21799,
      "gloss": "mind sports",
      "glossSv": "tankesport",
      "pos": "noun",
      "explanation": "sport + mind",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        447
      ]
    },
    {
      "id": 3111,
      "bciAvId": 21800,
      "gloss": "table sports",
      "glossSv": "sport utövad på bord",
      "pos": "noun",
      "explanation": "sport + table",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        639
      ]
    },
    {
      "id": 3112,
      "bciAvId": 21801,
      "gloss": "boating",
      "glossSv": "båtsport",
      "pos": "noun",
      "explanation": "sport + boat",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        170
      ]
    },
    {
      "id": 3113,
      "bciAvId": 21803,
      "gloss": "stickball",
      "glossSv": "brännboll",
      "pos": "noun",
      "explanation": "sport + ball + linear thing (bat [contraction]) + thing indicator",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 3114,
      "bciAvId": 21804,
      "gloss": "volleyball",
      "glossSv": "volleyboll",
      "pos": "noun",
      "explanation": "sport + ball + to hit",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        374,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3115,
      "bciAvId": 21805,
      "gloss": "water polo",
      "glossSv": "vattenpolo",
      "pos": "noun",
      "explanation": "sport + ball + water",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        695
      ]
    },
    {
      "id": 3116,
      "bciAvId": 21806,
      "gloss": "boules, boccia (sport)",
      "glossSv": "boccia, boule",
      "pos": "noun",
      "explanation": "sport + ball field + measurement",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        998,
        "/",
        441
      ]
    },
    {
      "id": 3117,
      "bciAvId": 21808,
      "gloss": "cricket",
      "glossSv": "kricket",
      "pos": "noun",
      "explanation": "sport + ball + wicket",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        755
      ]
    },
    {
      "id": 3118,
      "bciAvId": 21810,
      "gloss": "motorcycle, scooter",
      "glossSv": "moped, motorcykel, skoter",
      "pos": "noun",
      "explanation": "bicycle + motor",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        432
      ]
    },
    {
      "id": 3119,
      "bciAvId": 21811,
      "gloss": "scooter",
      "glossSv": "sparkcykel",
      "pos": "noun",
      "explanation": "bicycle + legs and feet: bicycle operated with legs and feet: Vehicles have different names in different countries.",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        418
      ]
    },
    {
      "id": 3120,
      "bciAvId": 21812,
      "gloss": "scooter (3 wheeled electric)",
      "glossSv": "elmoped",
      "pos": "noun",
      "explanation": "tricycle + electricity: Vehicles have different names in different countries.",
      "isCharacter": false,
      "composition": [
        12,
        "/",
        700,
        "/",
        288
      ]
    },
    {
      "id": 3121,
      "bciAvId": 21814,
      "gloss": "handcycle",
      "glossSv": "handcykel",
      "pos": "noun",
      "explanation": "bicycle + hand: bicycle operated with the hands",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        374
      ]
    },
    {
      "id": 3122,
      "bciAvId": 21815,
      "gloss": "recumbent bicycle",
      "glossSv": "liggcykel",
      "pos": "noun",
      "explanation": "bicycle + reclining,lying (person lying down)",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        515
      ]
    },
    {
      "id": 3123,
      "bciAvId": 21816,
      "gloss": "tandem bicycle",
      "glossSv": "tandemcykel",
      "pos": "noun",
      "explanation": "bicycle + two + person",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        11,
        "/",
        513
      ]
    },
    {
      "id": 3124,
      "bciAvId": 21817,
      "gloss": "mountain bike",
      "glossSv": "mountainbike",
      "pos": "noun",
      "explanation": "bicycle + mountain",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        456
      ]
    },
    {
      "id": 3125,
      "bciAvId": 21818,
      "gloss": "ATB, all-terrain bike",
      "glossSv": "terrängcykel",
      "pos": "noun",
      "explanation": "bicycle + countryside",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        244
      ]
    },
    {
      "id": 3126,
      "bciAvId": 21819,
      "gloss": "wheelchair bike",
      "glossSv": "rullstolscykel",
      "pos": "noun",
      "explanation": "bicycle + wheelchair",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        "/",
        701
      ]
    },
    {
      "id": 3127,
      "bciAvId": 21821,
      "gloss": "sidecar (motorcycle)",
      "glossSv": "sidovagn",
      "pos": "noun",
      "explanation": "plus + transport,transportation (cart [modification]): a car added to another vehicle",
      "isCharacter": false,
      "composition": [
        120,
        "/",
        1099
      ]
    },
    {
      "id": 3128,
      "bciAvId": 21822,
      "gloss": "go-kart, kart",
      "glossSv": "gokart",
      "pos": "noun",
      "explanation": "car + small",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        956
      ]
    },
    {
      "id": 3129,
      "bciAvId": 21823,
      "gloss": "cycling",
      "glossSv": "cykelsport",
      "pos": "noun",
      "explanation": "sport + bicycle",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 3130,
      "bciAvId": 21824,
      "gloss": "speed cycling",
      "glossSv": "cykellopp",
      "pos": "noun",
      "explanation": "sport + bicycle + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3131,
      "bciAvId": 21825,
      "gloss": "mountain biking",
      "glossSv": "mountainbikecykling",
      "pos": "noun",
      "explanation": "sport + mountain bike",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700,
        "/",
        456
      ]
    },
    {
      "id": 3132,
      "bciAvId": 21826,
      "gloss": "motorcycling, motocross",
      "glossSv": "motorcykelsport, motocross",
      "pos": "noun",
      "explanation": "sport + motorcycle",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700,
        "/",
        432
      ]
    },
    {
      "id": 3133,
      "bciAvId": 21827,
      "gloss": "motorcycle racing",
      "glossSv": "motorcykellopp",
      "pos": "noun",
      "explanation": "sport + motorcycle + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700,
        "/",
        432,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3134,
      "bciAvId": 21828,
      "gloss": "sidecar (motorcycle sport)",
      "glossSv": "motorcykelsport (med sidovagn)",
      "pos": "noun",
      "explanation": "sport + motorcycle + side car",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        700,
        "/",
        432,
        "/",
        120,
        "/",
        1099
      ]
    },
    {
      "id": 3135,
      "bciAvId": 21829,
      "gloss": "car racing, auto racing",
      "glossSv": "bilsport",
      "pos": "noun",
      "explanation": "sport + car",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        202
      ]
    },
    {
      "id": 3136,
      "bciAvId": 21830,
      "gloss": "Formula One, NASCAR Kart",
      "glossSv": "biltävling, rally",
      "pos": "noun",
      "explanation": "sport + car + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        202,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3137,
      "bciAvId": 21831,
      "gloss": "kart racing, karting, go-karting",
      "glossSv": "karting, gokart",
      "pos": "noun",
      "explanation": "sport + car + small",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        202,
        "/",
        956
      ]
    },
    {
      "id": 3138,
      "bciAvId": 21832,
      "gloss": "to cycle, to ride a bike",
      "glossSv": "cykla",
      "pos": "action",
      "explanation": "bicycle + action indicator",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        700,
        ";",
        81
      ]
    },
    {
      "id": 3139,
      "bciAvId": 21833,
      "gloss": "to go by car",
      "glossSv": "åka bil",
      "pos": "action",
      "explanation": "ride + car + action indicator",
      "isCharacter": false,
      "composition": [
        1077,
        ";",
        81,
        "/",
        202
      ]
    },
    {
      "id": 3140,
      "bciAvId": 21834,
      "gloss": "to go by airplane, to fly",
      "glossSv": "flyga (åka flygplan)",
      "pos": "action",
      "explanation": "ride + airplane + action indicator",
      "isCharacter": false,
      "composition": [
        1077,
        ";",
        81,
        "/",
        115
      ]
    },
    {
      "id": 3141,
      "bciAvId": 21835,
      "gloss": "to go by horse",
      "glossSv": "åka häst",
      "pos": "action",
      "explanation": "ride + horse + action indicator",
      "isCharacter": false,
      "composition": [
        1077,
        ";",
        81,
        "/",
        391
      ]
    },
    {
      "id": 3142,
      "bciAvId": 21836,
      "gloss": "to ride (horse)",
      "glossSv": "rida",
      "pos": "action",
      "explanation": "riding,horseback riding + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        391
      ]
    },
    {
      "id": 3143,
      "bciAvId": 21837,
      "gloss": "fencing",
      "glossSv": "fäktning",
      "pos": "noun",
      "explanation": "sport + fight + sword",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        411
      ]
    },
    {
      "id": 3144,
      "bciAvId": 21838,
      "gloss": "martial arts",
      "glossSv": "kampsport (österländsk)",
      "pos": "noun",
      "explanation": "sport + fight + east",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        282
      ]
    },
    {
      "id": 3145,
      "bciAvId": 21839,
      "gloss": "running",
      "glossSv": "löpning",
      "pos": "noun",
      "explanation": "sport + legs and feet + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        418,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3146,
      "bciAvId": 21840,
      "gloss": "hurdles",
      "glossSv": "häcklöpning",
      "pos": "noun",
      "explanation": "running + jump",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        418,
        "/",
        335,
        "/",
        401,
        "/",
        836
      ]
    },
    {
      "id": 3147,
      "bciAvId": 21842,
      "gloss": "relay (sport)",
      "glossSv": "stafettlöpning (sport)",
      "pos": "noun",
      "explanation": "sport + relay",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        758
      ]
    },
    {
      "id": 3148,
      "bciAvId": 21843,
      "gloss": "high jump",
      "glossSv": "höjdhopp",
      "pos": "noun",
      "explanation": "sport + to jump + high",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        952
      ]
    },
    {
      "id": 3149,
      "bciAvId": 21844,
      "gloss": "pole vaulting",
      "glossSv": "stavhopp",
      "pos": "noun",
      "explanation": "sport + to jump + high + linear thing + thing indicator",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        952,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 3150,
      "bciAvId": 21845,
      "gloss": "long jump",
      "glossSv": "längdhopp (FD)",
      "pos": "noun",
      "explanation": "sport + jump + far,distant (OLD)",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        946
      ]
    },
    {
      "id": 3151,
      "bciAvId": 21846,
      "gloss": "shot put",
      "glossSv": "kulstötning",
      "pos": "noun",
      "explanation": "sport + ball + metal [contraction]",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        814
      ]
    },
    {
      "id": 3152,
      "bciAvId": 21847,
      "gloss": "discus",
      "glossSv": "diskus",
      "pos": "noun",
      "explanation": "sport + disc",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        263
      ]
    },
    {
      "id": 3153,
      "bciAvId": 21848,
      "gloss": "hammer throw",
      "glossSv": "släggkastning",
      "pos": "noun",
      "explanation": "sport + ball + chain",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        148,
        "/",
        759
      ]
    },
    {
      "id": 3154,
      "bciAvId": 21850,
      "gloss": "dart",
      "glossSv": "dartpil",
      "pos": "noun",
      "explanation": "arrow + small + thing indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 3155,
      "bciAvId": 21851,
      "gloss": "javelin throw",
      "glossSv": "spjutkastning",
      "pos": "noun",
      "explanation": "sport + javelin + thing indicator",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        335,
        ";",
        97,
        "/",
        936
      ]
    },
    {
      "id": 3156,
      "bciAvId": 21852,
      "gloss": "arrow",
      "glossSv": "pil",
      "pos": "noun",
      "explanation": "forward + thing indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        97
      ]
    },
    {
      "id": 3157,
      "bciAvId": 21853,
      "gloss": "darts",
      "glossSv": "dart, pilkastning",
      "pos": "noun",
      "explanation": "sport + dart + thing indicator",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        335,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 3158,
      "bciAvId": 21854,
      "gloss": "javelin, spear",
      "glossSv": "spjut",
      "pos": "noun",
      "explanation": "arrow + big + thing indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        97,
        "/",
        936
      ]
    },
    {
      "id": 3159,
      "bciAvId": 21856,
      "gloss": "archery",
      "glossSv": "bågskytte",
      "pos": "noun",
      "explanation": "sport + bow and arrow",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        760
      ]
    },
    {
      "id": 3160,
      "bciAvId": 21857,
      "gloss": "multi-sport event",
      "glossSv": "flerkamp",
      "pos": "noun",
      "explanation": "sport + many + activity: Many can be replaced by an appropriate number.",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        368,
        "/",
        106
      ]
    },
    {
      "id": 3161,
      "bciAvId": 21858,
      "gloss": "triathlon",
      "glossSv": "triatlon",
      "pos": "noun",
      "explanation": "sport + three + activity",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        12,
        "/",
        106
      ]
    },
    {
      "id": 3162,
      "bciAvId": 21859,
      "gloss": "weight lifting",
      "glossSv": "tyngdlyftning",
      "pos": "noun",
      "explanation": "sport + weight + thing indicator",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        697,
        ";",
        97
      ]
    },
    {
      "id": 3163,
      "bciAvId": 21860,
      "gloss": "skating",
      "glossSv": "skridskosport",
      "pos": "noun",
      "explanation": "sport + ice skates",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        396
      ]
    },
    {
      "id": 3164,
      "bciAvId": 21861,
      "gloss": "speed skating",
      "glossSv": "hastighetsåkning på skridskor",
      "pos": "noun",
      "explanation": "sport + ice skates + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        396,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3165,
      "bciAvId": 21862,
      "gloss": "figure skating",
      "glossSv": "konståkning",
      "pos": "noun",
      "explanation": "sport + ice skates + design",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        396,
        "/",
        532
      ]
    },
    {
      "id": 3166,
      "bciAvId": 21863,
      "gloss": "slalom",
      "glossSv": "slalom",
      "pos": "noun",
      "explanation": "sport + skis + to turn",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        1101
      ]
    },
    {
      "id": 3167,
      "bciAvId": 21864,
      "gloss": "downhill skiing",
      "glossSv": "utförsåkning",
      "pos": "noun",
      "explanation": "sport + skis + downward/forward",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        273
      ]
    },
    {
      "id": 3168,
      "bciAvId": 21865,
      "gloss": "cross country skiing",
      "glossSv": "längdåkning",
      "pos": "noun",
      "explanation": "sport + skis + forward",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        335
      ]
    },
    {
      "id": 3169,
      "bciAvId": 21866,
      "gloss": "ski jumping",
      "glossSv": "backhoppning",
      "pos": "noun",
      "explanation": "sport + skis + to jump",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        836
      ]
    },
    {
      "id": 3170,
      "bciAvId": 21867,
      "gloss": "freestyle skiing",
      "glossSv": "freestyleåkning",
      "pos": "noun",
      "explanation": "sport + skis + design",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        532
      ]
    },
    {
      "id": 3171,
      "bciAvId": 21868,
      "gloss": "snowboarding",
      "glossSv": "snowboardåkning",
      "pos": "noun",
      "explanation": "sport + snowboard",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        731,
        "/",
        604
      ]
    },
    {
      "id": 3172,
      "bciAvId": 21869,
      "gloss": "snowboard",
      "glossSv": "snowboard",
      "pos": "noun",
      "explanation": "board + snow",
      "isCharacter": false,
      "composition": [
        731,
        "/",
        604
      ]
    },
    {
      "id": 3173,
      "bciAvId": 21870,
      "gloss": "sled sport",
      "glossSv": "slädsport",
      "pos": "noun",
      "explanation": "sport + sled",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        598
      ]
    },
    {
      "id": 3174,
      "bciAvId": 21871,
      "gloss": "toboggan",
      "glossSv": "kälke, bob",
      "pos": "noun",
      "explanation": "sled + small",
      "isCharacter": false,
      "composition": [
        598,
        "/",
        956
      ]
    },
    {
      "id": 3175,
      "bciAvId": 21872,
      "gloss": "bobsleigh",
      "glossSv": "släde",
      "pos": "noun",
      "explanation": "sled + big",
      "isCharacter": false,
      "composition": [
        598,
        "/",
        936
      ]
    },
    {
      "id": 3176,
      "bciAvId": 21873,
      "gloss": "horse sled, horse-drawn sleigh",
      "glossSv": "hästsläde",
      "pos": "noun",
      "explanation": "sled + horse",
      "isCharacter": false,
      "composition": [
        598,
        "/",
        391
      ]
    },
    {
      "id": 3177,
      "bciAvId": 21874,
      "gloss": "dog sled",
      "glossSv": "hundsläde",
      "pos": "noun",
      "explanation": "sled + dog",
      "isCharacter": false,
      "composition": [
        598,
        "/",
        124
      ]
    },
    {
      "id": 3178,
      "bciAvId": 21875,
      "gloss": "horse sled sport",
      "glossSv": "hästslädsport",
      "pos": "noun",
      "explanation": "sport + horse sled",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        598,
        "/",
        391
      ]
    },
    {
      "id": 3179,
      "bciAvId": 21876,
      "gloss": "rocking horse",
      "glossSv": "gunghäst",
      "pos": "noun",
      "explanation": "horse + man-made + to rock",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        840,
        "/",
        989
      ]
    },
    {
      "id": 3180,
      "bciAvId": 21877,
      "gloss": "dogsled sport, dogsled racing",
      "glossSv": "hundslädsport",
      "pos": "noun",
      "explanation": "sport + dog sled",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        598,
        "/",
        124
      ]
    },
    {
      "id": 3181,
      "bciAvId": 21878,
      "gloss": "sled dog",
      "glossSv": "slädhund",
      "pos": "noun",
      "explanation": "dog + sled",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        598
      ]
    },
    {
      "id": 3182,
      "bciAvId": 21879,
      "gloss": "curling",
      "glossSv": "curling",
      "pos": "noun",
      "explanation": "sport + disc + broom + ice",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        263,
        "/",
        183,
        "/",
        394
      ]
    },
    {
      "id": 3183,
      "bciAvId": 21881,
      "gloss": "surfboard",
      "glossSv": "surfingbräda",
      "pos": "noun",
      "explanation": "board + wave",
      "isCharacter": false,
      "composition": [
        731,
        "/",
        761
      ]
    },
    {
      "id": 3184,
      "bciAvId": 21882,
      "gloss": "sailboard, windsurf board, windsurfing board",
      "glossSv": "vindsurfingbräda",
      "pos": "noun",
      "explanation": "board + sail",
      "isCharacter": false,
      "composition": [
        731,
        "/",
        720
      ]
    },
    {
      "id": 3185,
      "bciAvId": 21883,
      "gloss": "water ski",
      "glossSv": "vattenskidor",
      "pos": "noun",
      "explanation": "ski + water",
      "isCharacter": false,
      "composition": [
        1084,
        "/",
        1117
      ]
    },
    {
      "id": 3186,
      "bciAvId": 21884,
      "gloss": "jet ski, water scooter",
      "glossSv": "jet ski",
      "pos": "noun",
      "explanation": "ski + water + motor",
      "isCharacter": false,
      "composition": [
        1084,
        "/",
        1117,
        "/",
        432
      ]
    },
    {
      "id": 3187,
      "bciAvId": 21885,
      "gloss": "wind surfing",
      "glossSv": "vindsurfing",
      "pos": "noun",
      "explanation": "sport + sailboard",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        731,
        "/",
        720
      ]
    },
    {
      "id": 3188,
      "bciAvId": 21886,
      "gloss": "water skiing",
      "glossSv": "vattenskidåkning",
      "pos": "noun",
      "explanation": "sport + water ski",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1084,
        "/",
        1117
      ]
    },
    {
      "id": 3189,
      "bciAvId": 22049,
      "gloss": "sailing",
      "glossSv": "segling",
      "pos": "noun",
      "explanation": "sport + sailboat",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        721
      ]
    },
    {
      "id": 3190,
      "bciAvId": 22050,
      "gloss": "canoeing",
      "glossSv": "kanotpaddling",
      "pos": "noun",
      "explanation": "sport + boat + one + paddle",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        170,
        "/",
        10,
        "/",
        770
      ]
    },
    {
      "id": 3191,
      "bciAvId": 22051,
      "gloss": "rowing",
      "glossSv": "rodd",
      "pos": "noun",
      "explanation": "sport + boat + two + oar",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        170,
        "/",
        11,
        "/",
        770
      ]
    },
    {
      "id": 3192,
      "bciAvId": 22052,
      "gloss": "motorboat sport",
      "glossSv": "motorbåtsport",
      "pos": "noun",
      "explanation": "sport + boat + motor",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        170,
        "/",
        432
      ]
    },
    {
      "id": 3193,
      "bciAvId": 22053,
      "gloss": "swimming (sport)",
      "glossSv": "simning (sport)",
      "pos": "noun",
      "explanation": "sport + swimming",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 3194,
      "bciAvId": 22054,
      "gloss": "synchronised diving, synchronized diving, synchro diving (sport)",
      "glossSv": "parhopp, synkroniserat simhopp (sport)",
      "pos": "noun",
      "explanation": "sport + diving + design",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        1117,
        "/",
        532
      ]
    },
    {
      "id": 3195,
      "bciAvId": 22055,
      "gloss": "diving (sport)",
      "glossSv": "simhopp (sport)",
      "pos": "noun",
      "explanation": "sport + to jump + water",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        1117
      ]
    },
    {
      "id": 3196,
      "bciAvId": 22056,
      "gloss": "synchronised swimming, synchronized swimming (sport)",
      "glossSv": "konstsim, synkroniserad simning (sport)",
      "pos": "noun",
      "explanation": "sport + swimming + plan",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        653,
        "/",
        695,
        "/",
        532
      ]
    },
    {
      "id": 3197,
      "bciAvId": 22057,
      "gloss": "snorkeling, scuba diving, deep sea diving (sport)",
      "glossSv": "sportdykning",
      "pos": "noun",
      "explanation": "sport + under + water",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        676,
        "/",
        695
      ]
    },
    {
      "id": 3198,
      "bciAvId": 22058,
      "gloss": "sport fishing, fishing, angling (sport)",
      "glossSv": "sportfiske",
      "pos": "noun",
      "explanation": "sport + to fish",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        920,
        "/",
        321
      ]
    },
    {
      "id": 3199,
      "bciAvId": 22070,
      "gloss": "tanker",
      "glossSv": "tankfartyg",
      "pos": "noun",
      "explanation": "freighter + liquid",
      "isCharacter": false,
      "composition": [
        772,
        "/",
        695
      ]
    },
    {
      "id": 3200,
      "bciAvId": 22071,
      "gloss": "oil tanker",
      "glossSv": "oljetanker",
      "pos": "noun",
      "explanation": "freighter + oil",
      "isCharacter": false,
      "composition": [
        772,
        "/",
        480
      ]
    },
    {
      "id": 3201,
      "bciAvId": 22072,
      "gloss": "barge, river boat",
      "glossSv": "pråm, flodbåt",
      "pos": "noun",
      "explanation": "freighter + river",
      "isCharacter": false,
      "composition": [
        772,
        "/",
        568
      ]
    },
    {
      "id": 3202,
      "bciAvId": 22073,
      "gloss": "schooner",
      "glossSv": "skonare",
      "pos": "noun",
      "explanation": "sailing boat + many + mast: Many can be replaced by an appropriate number.",
      "isCharacter": false,
      "composition": [
        721,
        "/",
        368,
        "/",
        762
      ]
    },
    {
      "id": 3203,
      "bciAvId": 22074,
      "gloss": "motorboat",
      "glossSv": "motorbåt",
      "pos": "noun",
      "explanation": "boat + motor",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        432
      ]
    },
    {
      "id": 3204,
      "bciAvId": 22075,
      "gloss": "canoe",
      "glossSv": "kanot",
      "pos": "noun",
      "explanation": "boat + one + paddle",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        10,
        "/",
        770
      ]
    },
    {
      "id": 3205,
      "bciAvId": 22076,
      "gloss": "rowing boat",
      "glossSv": "roddbåt",
      "pos": "noun",
      "explanation": "boat + two + oar",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        11,
        "/",
        770
      ]
    },
    {
      "id": 3206,
      "bciAvId": 22077,
      "gloss": "kayak",
      "glossSv": "kajak",
      "pos": "noun",
      "explanation": "boat + paddle [two blades]",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        771
      ]
    },
    {
      "id": 3207,
      "bciAvId": 22078,
      "gloss": "lifeboat",
      "glossSv": "livbåt",
      "pos": "noun",
      "explanation": "boat + to aid",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        382
      ]
    },
    {
      "id": 3208,
      "bciAvId": 22079,
      "gloss": "pilot boat",
      "glossSv": "lotsbåt",
      "pos": "noun",
      "explanation": "boat + to guide",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        803
      ]
    },
    {
      "id": 3209,
      "bciAvId": 22080,
      "gloss": "towboat, tugboat",
      "glossSv": "bogserbåt",
      "pos": "noun",
      "explanation": "boat + pull,pulling: a boat that pulls other boats",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        1073
      ]
    },
    {
      "id": 3210,
      "bciAvId": 22081,
      "gloss": "pushboat",
      "glossSv": "bogserbåt (som skjuter på)",
      "pos": "noun",
      "explanation": "boat + to push",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        929
      ]
    },
    {
      "id": 3211,
      "bciAvId": 22082,
      "gloss": "cruise ship",
      "glossSv": "kryssningsfartyg",
      "pos": "noun",
      "explanation": "boat + person + to travel",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        513,
        "/",
        667
      ]
    },
    {
      "id": 3212,
      "bciAvId": 22083,
      "gloss": "ferry",
      "glossSv": "färja",
      "pos": "noun",
      "explanation": "boat + back and forth: vessel that makes regular return trips between two ports",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        144
      ]
    },
    {
      "id": 3213,
      "bciAvId": 22084,
      "gloss": "steamship",
      "glossSv": "ångbåt",
      "pos": "noun",
      "explanation": "boat + steam",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        623
      ]
    },
    {
      "id": 3214,
      "bciAvId": 22085,
      "gloss": "hovercraft",
      "glossSv": "svävare",
      "pos": "noun",
      "explanation": "boat + up + air: boat is pressed upward by air",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        678,
        "/",
        114
      ]
    },
    {
      "id": 3215,
      "bciAvId": 22086,
      "gloss": "rubber boat, dinghy",
      "glossSv": "gummibåt",
      "pos": "noun",
      "explanation": "boat + air: rubber boat inflated with air",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        114
      ]
    },
    {
      "id": 3216,
      "bciAvId": 22087,
      "gloss": "catamaran, pontoon boat",
      "glossSv": "katamaran",
      "pos": "noun",
      "explanation": "two + hull",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        768
      ]
    },
    {
      "id": 3217,
      "bciAvId": 22088,
      "gloss": "paddle boat, pedal boat, water bike, pedalo",
      "glossSv": "vattencykel",
      "pos": "noun",
      "explanation": "boat + legs and feet: boat propelled by the legs and feet",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        418
      ]
    },
    {
      "id": 3218,
      "bciAvId": 22089,
      "gloss": "houseboat",
      "glossSv": "husbåt",
      "pos": "noun",
      "explanation": "boat + house",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        392
      ]
    },
    {
      "id": 3219,
      "bciAvId": 22090,
      "gloss": "boathouse",
      "glossSv": "båthus",
      "pos": "noun",
      "explanation": "house + boat",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        170
      ]
    },
    {
      "id": 3220,
      "bciAvId": 22091,
      "gloss": "horse rider, equestrian",
      "glossSv": "ryttare",
      "pos": "person",
      "explanation": "person + horse",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        391
      ]
    },
    {
      "id": 3221,
      "bciAvId": 22092,
      "gloss": "jockey",
      "glossSv": "jockey",
      "pos": "person",
      "explanation": "horse rider + fast",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        391,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3222,
      "bciAvId": 22093,
      "gloss": "sulky",
      "glossSv": "sulky",
      "pos": "noun",
      "explanation": "cart + small + horse",
      "isCharacter": false,
      "composition": [
        204,
        "/",
        956,
        "/",
        391
      ]
    },
    {
      "id": 3223,
      "bciAvId": 22094,
      "gloss": "horse racing",
      "glossSv": "hästkapplöpning",
      "pos": "noun",
      "explanation": "sport + horse + fast",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3224,
      "bciAvId": 22095,
      "gloss": "carriage racing",
      "glossSv": "kapplöpning med häst och vagn",
      "pos": "noun",
      "explanation": "sport + horse + carriage",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391,
        "/",
        204
      ]
    },
    {
      "id": 3225,
      "bciAvId": 22096,
      "gloss": "showjumping (horse)",
      "glossSv": "hästhoppning",
      "pos": "noun",
      "explanation": "sport + horse + to jump",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391,
        "/",
        836
      ]
    },
    {
      "id": 3226,
      "bciAvId": 22097,
      "gloss": "dressage",
      "glossSv": "hästdressyr",
      "pos": "noun",
      "explanation": "sport + horse + plan",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391,
        "/",
        532
      ]
    },
    {
      "id": 3227,
      "bciAvId": 22098,
      "gloss": "polo",
      "glossSv": "hästpolo",
      "pos": "noun",
      "explanation": "sport + horse + sport stick and ball,bandy stick",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        391,
        "/",
        1092
      ]
    },
    {
      "id": 3228,
      "bciAvId": 22099,
      "gloss": "billiards",
      "glossSv": "biljard",
      "pos": "noun",
      "explanation": "sport + table + three + ball",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        639,
        "/",
        12,
        "/",
        148
      ]
    },
    {
      "id": 3229,
      "bciAvId": 22100,
      "gloss": "pool, snooker",
      "glossSv": "snooker (etc)",
      "pos": "noun",
      "explanation": "sport + table + many + ball: Many can be replaced by an appropriate number.",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        639,
        "/",
        368,
        "/",
        148
      ]
    },
    {
      "id": 3230,
      "bciAvId": 22101,
      "gloss": "squash (sport)",
      "glossSv": "squash (sport) (FD)",
      "pos": "noun",
      "explanation": "tennis,racquet sports (OLD) + room",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1016,
        "/",
        572
      ]
    },
    {
      "id": 3231,
      "bciAvId": 22102,
      "gloss": "lacrosse (sport)",
      "glossSv": "lacrosse (sport) (FD)",
      "pos": "noun",
      "explanation": "tennis,racquet sports (OLD) + group: group representing team (sport) [contraction]",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1016,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 3232,
      "bciAvId": 22103,
      "gloss": "glider",
      "glossSv": "segelflygplan",
      "pos": "noun",
      "explanation": "airplane + air: plane propelled by air currents",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        114
      ]
    },
    {
      "id": 3233,
      "bciAvId": 22104,
      "gloss": "seaplane",
      "glossSv": "sjöflygplan",
      "pos": "noun",
      "explanation": "airplane + water: plane that can land on water",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        1117
      ]
    },
    {
      "id": 3234,
      "bciAvId": 22106,
      "gloss": "parachuting",
      "glossSv": "fallskärmshoppning",
      "pos": "noun",
      "explanation": "sport + parachute",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        773
      ]
    },
    {
      "id": 3235,
      "bciAvId": 22108,
      "gloss": "ballooning",
      "glossSv": "ballongflygning",
      "pos": "noun",
      "explanation": "sport + balloon (hot air)",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        774
      ]
    },
    {
      "id": 3236,
      "bciAvId": 22109,
      "gloss": "mountain climbing",
      "glossSv": "bergsklättring",
      "pos": "noun",
      "explanation": "sport + mountain + to go up",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        456,
        "/",
        678
      ]
    },
    {
      "id": 3237,
      "bciAvId": 22110,
      "gloss": "abseiling, rappelling",
      "glossSv": "abseiling",
      "pos": "noun",
      "explanation": "sport + mountain + to go down",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        456,
        "/",
        271
      ]
    },
    {
      "id": 3238,
      "bciAvId": 22111,
      "gloss": "wall climbing",
      "glossSv": "väggklättring",
      "pos": "noun",
      "explanation": "sport + wall + to go up",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        691,
        "/",
        678
      ]
    },
    {
      "id": 3239,
      "bciAvId": 22112,
      "gloss": "parasailing",
      "glossSv": "parasailing",
      "pos": "noun",
      "explanation": "sport + parachute + boat",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        773,
        "/",
        170
      ]
    },
    {
      "id": 3240,
      "bciAvId": 22113,
      "gloss": "paraskiing",
      "glossSv": "paraskiing",
      "pos": "noun",
      "explanation": "sport + parachute + skis",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        773,
        "/",
        11,
        "/",
        1084
      ]
    },
    {
      "id": 3241,
      "bciAvId": 22114,
      "gloss": "hang gliding",
      "glossSv": "hängflygning",
      "pos": "noun",
      "explanation": "sport + wings + person: sport in which a person flies by hanging from wings propelled by air currents",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        708,
        "/",
        513
      ]
    },
    {
      "id": 3242,
      "bciAvId": 22115,
      "gloss": "kite flying",
      "glossSv": "drakflygning",
      "pos": "noun",
      "explanation": "sport + kite",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        409
      ]
    },
    {
      "id": 3243,
      "bciAvId": 22117,
      "gloss": "outdoor, outdoors",
      "glossSv": "utomhus",
      "pos": "description",
      "explanation": "outdoor (character) + description indicator: the dot is outside the house",
      "isCharacter": false,
      "composition": [
        1065,
        ";",
        86
      ]
    },
    {
      "id": 3244,
      "bciAvId": 22118,
      "gloss": "appetiser, appetizer, starter, entree",
      "glossSv": "förrätt",
      "pos": "noun",
      "explanation": "food + to start",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        159
      ]
    },
    {
      "id": 3245,
      "bciAvId": 22119,
      "gloss": "main dish, main course",
      "glossSv": "huvudrätt",
      "pos": "noun",
      "explanation": "food + middle",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        446
      ]
    },
    {
      "id": 3246,
      "bciAvId": 22120,
      "gloss": "fishburger",
      "glossSv": "fiskburgare",
      "pos": "noun",
      "explanation": "bun + fish [contraction]",
      "isCharacter": false,
      "composition": [
        732,
        "/",
        321
      ]
    },
    {
      "id": 3247,
      "bciAvId": 22121,
      "gloss": "decorated cake",
      "glossSv": "tårta",
      "pos": "noun",
      "explanation": "cake + intensity",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        642,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 3248,
      "bciAvId": 22122,
      "gloss": "muffin, bun (sweet)",
      "glossSv": "muffins, bulle",
      "pos": "noun",
      "explanation": "bun + sweet",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 3249,
      "bciAvId": 22123,
      "gloss": "cupcake, fancy cake, pastry",
      "glossSv": "bakelse",
      "pos": "noun",
      "explanation": "muffin + intensity",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        642,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 3250,
      "bciAvId": 22124,
      "gloss": "doughnut",
      "glossSv": "flottyrmunk",
      "pos": "noun",
      "explanation": "muffin + ring: muffin in the shape of a ring",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        642,
        "/",
        678,
        "/",
        567
      ]
    },
    {
      "id": 3251,
      "bciAvId": 22125,
      "gloss": "bagel",
      "glossSv": "bagel",
      "pos": "noun",
      "explanation": "bun (food) + ring: bun in the shape of a ring",
      "isCharacter": false,
      "composition": [
        732,
        "/",
        567
      ]
    },
    {
      "id": 3252,
      "bciAvId": 22126,
      "gloss": "waffle",
      "glossSv": "våffla",
      "pos": "noun",
      "explanation": "food + grid,matrix: the waffle iron creates a grid pattern",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        950
      ]
    },
    {
      "id": 3253,
      "bciAvId": 22127,
      "gloss": "fishball",
      "glossSv": "fiskbulle",
      "pos": "noun",
      "explanation": "fish (food) + ball: fish shaped into a ball",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        321,
        "/",
        148
      ]
    },
    {
      "id": 3254,
      "bciAvId": 22128,
      "gloss": "dumpling",
      "glossSv": "klimp (etc)",
      "pos": "noun",
      "explanation": "food + bun + ball: bun-like food shaped into a ball",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        570,
        "/",
        148
      ]
    },
    {
      "id": 3255,
      "bciAvId": 22129,
      "gloss": "pasta",
      "glossSv": "pasta",
      "pos": "noun",
      "explanation": "food + flour: food made from [wheat] flour",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357
      ]
    },
    {
      "id": 3256,
      "bciAvId": 22130,
      "gloss": "macaroni",
      "glossSv": "makaroner",
      "pos": "noun",
      "explanation": "pasta + tube",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        866
      ]
    },
    {
      "id": 3257,
      "bciAvId": 22131,
      "gloss": "farfalle",
      "glossSv": "fjärilsmakaroner",
      "pos": "noun",
      "explanation": "pasta + butterfly",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        193
      ]
    },
    {
      "id": 3258,
      "bciAvId": 22132,
      "gloss": "pasta wheel",
      "glossSv": "pastahjul",
      "pos": "noun",
      "explanation": "pasta + wheel",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        700
      ]
    },
    {
      "id": 3259,
      "bciAvId": 22133,
      "gloss": "lasagne, lasagna",
      "glossSv": "lasagne",
      "pos": "noun",
      "explanation": "pasta + page",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        497
      ]
    },
    {
      "id": 3260,
      "bciAvId": 22134,
      "gloss": "ravioli",
      "glossSv": "ravioli",
      "pos": "noun",
      "explanation": "pasta + filled",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        357,
        "/",
        947
      ]
    },
    {
      "id": 3261,
      "bciAvId": 22135,
      "gloss": "rice flour",
      "glossSv": "rismjöl",
      "pos": "noun",
      "explanation": "powder + rice",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        565
      ]
    },
    {
      "id": 3262,
      "bciAvId": 22136,
      "gloss": "rice noodle",
      "glossSv": "risnudlar",
      "pos": "noun",
      "explanation": "food + rice flour + line",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        544,
        "/",
        565,
        "/",
        428
      ]
    },
    {
      "id": 3263,
      "bciAvId": 22137,
      "gloss": "egg (boiled), boiled egg",
      "glossSv": "ägg (kokt)",
      "pos": "noun",
      "explanation": "egg + to boil [contraction]",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        319,
        "/",
        695,
        "/",
        401
      ]
    },
    {
      "id": 3264,
      "bciAvId": 22138,
      "gloss": "egg (fried), fried egg",
      "glossSv": "ägg (stekt)",
      "pos": "noun",
      "explanation": "egg + to fry [contraction]",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        319,
        "/",
        480
      ]
    },
    {
      "id": 3265,
      "bciAvId": 22139,
      "gloss": "omelette, omelet",
      "glossSv": "omelett",
      "pos": "noun",
      "explanation": "egg + mixture + to heat [modification]",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        783,
        "/",
        319
      ]
    },
    {
      "id": 3266,
      "bciAvId": 22140,
      "gloss": "scrambled eggs",
      "glossSv": "äggröra",
      "pos": "noun",
      "explanation": "egg + to heat [modification] + mixture",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        319,
        "/",
        783
      ]
    },
    {
      "id": 3267,
      "bciAvId": 22141,
      "gloss": "egg (poached), poached egg",
      "glossSv": "ägg (pocherat)",
      "pos": "noun",
      "explanation": "egg + heat [modification] + water: egg cooked in water",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        319,
        "/",
        695
      ]
    },
    {
      "id": 3268,
      "bciAvId": 22142,
      "gloss": "fruit salad",
      "glossSv": "fruktsallad",
      "pos": "noun",
      "explanation": "salad + fruit: The specifier fruit can be replaced with another appropriate one.",
      "isCharacter": false,
      "composition": [
        577,
        "/",
        338
      ]
    },
    {
      "id": 3269,
      "bciAvId": 22305,
      "gloss": "shellfish salad",
      "glossSv": "skaldjurssallad",
      "pos": "noun",
      "explanation": "salad + crab",
      "isCharacter": false,
      "composition": [
        577,
        "/",
        430
      ]
    },
    {
      "id": 3270,
      "bciAvId": 22306,
      "gloss": "pasta salad",
      "glossSv": "pastasallad",
      "pos": "noun",
      "explanation": "salad + pasta [contraction]",
      "isCharacter": false,
      "composition": [
        577,
        "/",
        544,
        "/",
        357
      ]
    },
    {
      "id": 3271,
      "bciAvId": 22308,
      "gloss": "Christmas pudding",
      "glossSv": "julpudding",
      "pos": "noun",
      "explanation": "pudding + Christmas [contraction]",
      "isCharacter": false,
      "composition": [
        776,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 3272,
      "bciAvId": 22309,
      "gloss": "flavouring, flavoring, seasoning (liquid)",
      "glossSv": "smaktillsats (flytande)",
      "pos": "noun",
      "explanation": "flavouring [contraction] + liquid + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695
      ]
    },
    {
      "id": 3273,
      "bciAvId": 22310,
      "gloss": "flavouring, flavoring, seasoning (powder)",
      "glossSv": "smaktillsats (pulverform)",
      "pos": "noun",
      "explanation": "flavouring [contraction] + powder + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544
      ]
    },
    {
      "id": 3274,
      "bciAvId": 22311,
      "gloss": "bark",
      "glossSv": "bark",
      "pos": "noun",
      "explanation": "protection + tree trunk",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        669
      ]
    },
    {
      "id": 3275,
      "bciAvId": 22312,
      "gloss": "cinnamon",
      "glossSv": "kanel",
      "pos": "noun",
      "explanation": "flavouring + bark + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        548,
        "/",
        669
      ]
    },
    {
      "id": 3276,
      "bciAvId": 22313,
      "gloss": "cinnamon (powder)",
      "glossSv": "kanel (pulverform)",
      "pos": "noun",
      "explanation": "flavouring (powder) + cinnamon [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        548,
        "/",
        669
      ]
    },
    {
      "id": 3277,
      "bciAvId": 22314,
      "gloss": "vanilla",
      "glossSv": "vanilj",
      "pos": "noun",
      "explanation": "flavouring + pod + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        801
      ]
    },
    {
      "id": 3278,
      "bciAvId": 22315,
      "gloss": "vanilla (powder)",
      "glossSv": "vanilj (pulverform)",
      "pos": "noun",
      "explanation": "flavouring (powder) + vanilla [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        801
      ]
    },
    {
      "id": 3279,
      "bciAvId": 22316,
      "gloss": "vanilla (liquid)",
      "glossSv": "vanilj (flytande)",
      "pos": "noun",
      "explanation": "flavouring (liquid) + vanilla [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        801
      ]
    },
    {
      "id": 3280,
      "bciAvId": 22317,
      "gloss": "vanilla sauce",
      "glossSv": "vaniljsås",
      "pos": "noun",
      "explanation": "sauce + vanilla [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        801
      ]
    },
    {
      "id": 3281,
      "bciAvId": 22318,
      "gloss": "ginger",
      "glossSv": "ingefära",
      "pos": "noun",
      "explanation": "flavouring + roots + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        573
      ]
    },
    {
      "id": 3282,
      "bciAvId": 22319,
      "gloss": "ginger (powder)",
      "glossSv": "ingefära (pulverform)",
      "pos": "noun",
      "explanation": "flavouring (powder) + ginger [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        573
      ]
    },
    {
      "id": 3283,
      "bciAvId": 22320,
      "gloss": "ginger sauce",
      "glossSv": "ingefärssås",
      "pos": "noun",
      "explanation": "sauce + ginger [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        573
      ]
    },
    {
      "id": 3284,
      "bciAvId": 22321,
      "gloss": "herb flavouring, herb flavoring (powder)",
      "glossSv": "örtkrydda (pulverform)",
      "pos": "noun",
      "explanation": "flavouring (powder) + herb flavouring [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        416
      ]
    },
    {
      "id": 3285,
      "bciAvId": 22322,
      "gloss": "herb flavouring, herb flavoring",
      "glossSv": "örtkrydda",
      "pos": "noun",
      "explanation": "flavouring + leaf + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        416
      ]
    },
    {
      "id": 3286,
      "bciAvId": 22323,
      "gloss": "herb sauce",
      "glossSv": "örtsås",
      "pos": "noun",
      "explanation": "sauce + herb flavouring [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        416
      ]
    },
    {
      "id": 3287,
      "bciAvId": 22324,
      "gloss": "salad dressing",
      "glossSv": "salladsdressing",
      "pos": "noun",
      "explanation": "sauce + salad",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        577
      ]
    },
    {
      "id": 3288,
      "bciAvId": 22325,
      "gloss": "pepper (powder)",
      "glossSv": "peppar (pulverform)",
      "pos": "noun",
      "explanation": "flavouring (powder) + pepper [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        319
      ]
    },
    {
      "id": 3289,
      "bciAvId": 22326,
      "gloss": "pepper sauce",
      "glossSv": "pepparsås",
      "pos": "noun",
      "explanation": "sauce + pepper [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        319
      ]
    },
    {
      "id": 3290,
      "bciAvId": 22327,
      "gloss": "curry",
      "glossSv": "curry",
      "pos": "noun",
      "explanation": "flavouring + mixture + hot [modification] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        783,
        "/",
        319
      ]
    },
    {
      "id": 3291,
      "bciAvId": 22328,
      "gloss": "curry (powder)",
      "glossSv": "curry (pulverform)",
      "pos": "noun",
      "explanation": "flavouring [contraction] + powder + mixture + hot [modification] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        783,
        "/",
        319
      ]
    },
    {
      "id": 3292,
      "bciAvId": 22329,
      "gloss": "curry sauce",
      "glossSv": "currysås",
      "pos": "noun",
      "explanation": "sauce + mixture + hot [modification]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        783,
        "/",
        319
      ]
    },
    {
      "id": 3293,
      "bciAvId": 22330,
      "gloss": "mustard",
      "glossSv": "senap",
      "pos": "noun",
      "explanation": "flavouring + seeds + intensity + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        584,
        "/",
        401
      ]
    },
    {
      "id": 3294,
      "bciAvId": 22331,
      "gloss": "mustard (powder)",
      "glossSv": "senap (pulverform)",
      "pos": "noun",
      "explanation": "flavouring [contraction] + powder + mustard [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        584,
        "/",
        401
      ]
    },
    {
      "id": 3295,
      "bciAvId": 22332,
      "gloss": "mustard sauce",
      "glossSv": "senapssås",
      "pos": "noun",
      "explanation": "sauce + mustard [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        584,
        "/",
        401
      ]
    },
    {
      "id": 3296,
      "bciAvId": 22333,
      "gloss": "sap (flavouring)",
      "glossSv": "sav (smaktillsats)",
      "pos": "noun",
      "explanation": "flavouring + trunk + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        669
      ]
    },
    {
      "id": 3297,
      "bciAvId": 22334,
      "gloss": "maple syrup flavouring, maple syrup flavoring",
      "glossSv": "lönnsirap (smaktillsats)",
      "pos": "noun",
      "explanation": "sap (flavouring) + maple-leaf",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        669,
        "/",
        436
      ]
    },
    {
      "id": 3298,
      "bciAvId": 22335,
      "gloss": "syrup",
      "glossSv": "sirap",
      "pos": "noun",
      "explanation": "flavouring [contraction] + liquid + sweet + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 3299,
      "bciAvId": 22336,
      "gloss": "sap",
      "glossSv": "sav",
      "pos": "noun",
      "explanation": "liquid + trunk",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        669
      ]
    },
    {
      "id": 3300,
      "bciAvId": 22337,
      "gloss": "syrup (from tree)",
      "glossSv": "sirap från träd",
      "pos": "noun",
      "explanation": "flavouring [contraction] + sap + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        669
      ]
    },
    {
      "id": 3301,
      "bciAvId": 22338,
      "gloss": "maple syrup",
      "glossSv": "lönnsirap",
      "pos": "noun",
      "explanation": "flavouring [contraction] + sap + maple-leaf + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        669,
        "/",
        436
      ]
    },
    {
      "id": 3302,
      "bciAvId": 22339,
      "gloss": "corn syrup",
      "glossSv": "majssirap",
      "pos": "noun",
      "explanation": "flavouring [contraction] + liquid + corn + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        240
      ]
    },
    {
      "id": 3303,
      "bciAvId": 22340,
      "gloss": "chocolate, cocoa, cacao (sweet powder)",
      "glossSv": "chokladpulver",
      "pos": "noun",
      "explanation": "flavouring [contraction] + powder + bean + sweet [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3304,
      "bciAvId": 22341,
      "gloss": "chocolate, cocoa, cacao (bitter powder)",
      "glossSv": "kakao (pulver)",
      "pos": "noun",
      "explanation": "flavouring [contraction] + powder + bean + bitter [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        544,
        "/",
        154,
        "/",
        271
      ]
    },
    {
      "id": 3305,
      "bciAvId": 22342,
      "gloss": "chocolate sauce",
      "glossSv": "chokladsås",
      "pos": "noun",
      "explanation": "sauce + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3306,
      "bciAvId": 22343,
      "gloss": "chocolate (hagel)",
      "glossSv": "chokladströssel",
      "pos": "noun",
      "explanation": "spread + piece + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        502,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3307,
      "bciAvId": 22344,
      "gloss": "sweet drink",
      "glossSv": "dryck (söt)",
      "pos": "noun",
      "explanation": "drink + sweet",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 3308,
      "bciAvId": 22345,
      "gloss": "sparkling wine",
      "glossSv": "vin (mousserande)",
      "pos": "noun",
      "explanation": "wine + gas",
      "isCharacter": false,
      "composition": [
        116,
        "/",
        365,
        "/",
        345
      ]
    },
    {
      "id": 3309,
      "bciAvId": 22346,
      "gloss": "champagne",
      "glossSv": "champagne",
      "pos": "noun",
      "explanation": "sparkling wine + intensity",
      "isCharacter": false,
      "composition": [
        116,
        "/",
        365,
        "/",
        345,
        "/",
        401
      ]
    },
    {
      "id": 3310,
      "bciAvId": 22347,
      "gloss": "cider",
      "glossSv": "cider",
      "pos": "noun",
      "explanation": "alcoholic drink + apple",
      "isCharacter": false,
      "composition": [
        116,
        "/",
        131
      ]
    },
    {
      "id": 3311,
      "bciAvId": 22349,
      "gloss": "juicy",
      "glossSv": "saftig",
      "pos": "description",
      "explanation": "liquid + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 3312,
      "bciAvId": 22350,
      "gloss": "pickled",
      "glossSv": "inlagd (t ex i ättikslag)",
      "pos": "description",
      "explanation": "taste + sharp + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        84,
        "/",
        411
      ]
    },
    {
      "id": 3313,
      "bciAvId": 22351,
      "gloss": "fried",
      "glossSv": "stekt",
      "pos": "description",
      "explanation": "to fry [contraction] + description indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        86,
        "/",
        480
      ]
    },
    {
      "id": 3314,
      "bciAvId": 22352,
      "gloss": "delicious, scrumptious, yummy",
      "glossSv": "jättegod, läcker",
      "pos": "description",
      "explanation": "tasty + one intensity character + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        120,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3315,
      "bciAvId": 22353,
      "gloss": "tasteless, not tasty, not good",
      "glossSv": "smaklös",
      "pos": "description",
      "explanation": "tasty + negative + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 3316,
      "bciAvId": 22354,
      "gloss": "disgusting (taste)",
      "glossSv": "äcklig, osmaklig",
      "pos": "description",
      "explanation": "not tasty + one intensity character + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3317,
      "bciAvId": 22355,
      "gloss": "meat (frozen), frozen meat",
      "glossSv": "kött (djupfryst)",
      "pos": "noun",
      "explanation": "meat + frozen",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        394
      ]
    },
    {
      "id": 3318,
      "bciAvId": 22356,
      "gloss": "fish (frozen)",
      "glossSv": "fisk (djupfryst)",
      "pos": "noun",
      "explanation": "fish + frozen",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        321,
        "/",
        394
      ]
    },
    {
      "id": 3319,
      "bciAvId": 22357,
      "gloss": "yogurt, yoghurt (frozen)",
      "glossSv": "yoghurt (frusen)",
      "pos": "noun",
      "explanation": "yoghurt + frozen",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        275,
        "/",
        423,
        "/",
        394
      ]
    },
    {
      "id": 3320,
      "bciAvId": 22358,
      "gloss": "hard cheese",
      "glossSv": "hårdost",
      "pos": "noun",
      "explanation": "cheese + hard",
      "isCharacter": false,
      "composition": [
        215,
        "/",
        374,
        "/",
        639
      ]
    },
    {
      "id": 3321,
      "bciAvId": 22359,
      "gloss": "soft cheese",
      "glossSv": "dessertost, mjukost",
      "pos": "noun",
      "explanation": "cheese + soft",
      "isCharacter": false,
      "composition": [
        215,
        "/",
        374,
        "/",
        1049
      ]
    },
    {
      "id": 3322,
      "bciAvId": 22360,
      "gloss": "spreadable cheese",
      "glossSv": "smältost",
      "pos": "noun",
      "explanation": "cheese + spread: cheese used as a spread",
      "isCharacter": false,
      "composition": [
        215,
        "/",
        617
      ]
    },
    {
      "id": 3323,
      "bciAvId": 22361,
      "gloss": "fresh cheese",
      "glossSv": "färskost",
      "pos": "noun",
      "explanation": "cheese + new",
      "isCharacter": false,
      "composition": [
        215,
        "/",
        1061
      ]
    },
    {
      "id": 3324,
      "bciAvId": 22363,
      "gloss": "lumpy",
      "glossSv": "klumpig",
      "pos": "description",
      "explanation": "lump(s) + description indicator",
      "isCharacter": false,
      "composition": [
        777,
        ";",
        86
      ]
    },
    {
      "id": 3325,
      "bciAvId": 22364,
      "gloss": "cottage cheese",
      "glossSv": "keso, kvarg",
      "pos": "noun",
      "explanation": "cheese + lump(s)",
      "isCharacter": false,
      "composition": [
        215,
        "/",
        777
      ]
    },
    {
      "id": 3326,
      "bciAvId": 22367,
      "gloss": "water ice lollipop",
      "glossSv": "isglass (pinne)",
      "pos": "noun",
      "explanation": "ice cream (lollipop) + frozen",
      "isCharacter": false,
      "composition": [
        779,
        "/",
        394
      ]
    },
    {
      "id": 3327,
      "bciAvId": 22368,
      "gloss": "popsicle",
      "glossSv": "isglass (cylinder)",
      "pos": "noun",
      "explanation": "cylinder + frozen",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        394
      ]
    },
    {
      "id": 3328,
      "bciAvId": 22370,
      "gloss": "ice cream (bar)",
      "glossSv": "glass (kaka)",
      "pos": "noun",
      "explanation": "ice cream + bar",
      "isCharacter": false,
      "composition": [
        780,
        "/",
        781
      ]
    },
    {
      "id": 3329,
      "bciAvId": 22372,
      "gloss": "candy bar",
      "glossSv": "chokladbit (etc)",
      "pos": "noun",
      "explanation": "bar + sweet",
      "isCharacter": false,
      "composition": [
        781,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 3330,
      "bciAvId": 22373,
      "gloss": "chocolate bar",
      "glossSv": "chokladkaka",
      "pos": "noun",
      "explanation": "bar + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        781,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3331,
      "bciAvId": 22374,
      "gloss": "to reflect, to consider, to regard",
      "glossSv": "reflektera, fundera",
      "pos": "action",
      "explanation": "reflection (mental),consideration + action indicator",
      "isCharacter": false,
      "composition": [
        1076,
        ";",
        81
      ]
    },
    {
      "id": 3332,
      "bciAvId": 22376,
      "gloss": "candy, sweets",
      "glossSv": "godis",
      "pos": "noun",
      "explanation": "generalization + candy",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        782
      ]
    },
    {
      "id": 3333,
      "bciAvId": 22378,
      "gloss": "dough",
      "glossSv": "deg",
      "pos": "noun",
      "explanation": "mixture + flour [contraction] + liquid",
      "isCharacter": false,
      "composition": [
        783,
        "/",
        544,
        "/",
        695
      ]
    },
    {
      "id": 3334,
      "bciAvId": 22379,
      "gloss": "batter",
      "glossSv": "smet",
      "pos": "noun",
      "explanation": "mixture + flour [contraction] + much + liquid",
      "isCharacter": false,
      "composition": [
        783,
        "/",
        544,
        "/",
        368,
        "/",
        695
      ]
    },
    {
      "id": 3335,
      "bciAvId": 22380,
      "gloss": "ingredient",
      "glossSv": "ingrediens",
      "pos": "noun",
      "explanation": "part of + mixture",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        783
      ]
    },
    {
      "id": 3336,
      "bciAvId": 22381,
      "gloss": "slice",
      "glossSv": "skiva (subst.)",
      "pos": "noun",
      "explanation": "thin + knife + thing indicator: a piece of food cut thin",
      "isCharacter": false,
      "composition": [
        1096,
        ";",
        97,
        "/",
        411
      ]
    },
    {
      "id": 3337,
      "bciAvId": 22382,
      "gloss": "to slice",
      "glossSv": "skiva (verb)",
      "pos": "action",
      "explanation": "slice + action indicator",
      "isCharacter": false,
      "composition": [
        1096,
        ";",
        81,
        "/",
        411
      ]
    },
    {
      "id": 3338,
      "bciAvId": 22383,
      "gloss": "sliced",
      "glossSv": "skivad",
      "pos": "description",
      "explanation": "slice + description indicator",
      "isCharacter": false,
      "composition": [
        1096,
        ";",
        86,
        "/",
        411
      ]
    },
    {
      "id": 3339,
      "bciAvId": 22385,
      "gloss": "reflector",
      "glossSv": "reflex, reflektor",
      "pos": "noun",
      "explanation": "thing + reflection",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        784
      ]
    },
    {
      "id": 3340,
      "bciAvId": 22387,
      "gloss": "to shine",
      "glossSv": "blänka, glänsa, skina",
      "pos": "action",
      "explanation": "shine + action indicator",
      "isCharacter": false,
      "composition": [
        785,
        ";",
        81
      ]
    },
    {
      "id": 3341,
      "bciAvId": 22388,
      "gloss": "shiny, glossy",
      "glossSv": "blank, glänsande, skinande",
      "pos": "description",
      "explanation": "shine + description indicator",
      "isCharacter": false,
      "composition": [
        785,
        ";",
        86
      ]
    },
    {
      "id": 3342,
      "bciAvId": 22389,
      "gloss": "to polish",
      "glossSv": "polera, putsa",
      "pos": "action",
      "explanation": "to rub [contraction] + shine + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        144,
        "/",
        785
      ]
    },
    {
      "id": 3343,
      "bciAvId": 22390,
      "gloss": "polisher",
      "glossSv": "polermaskin",
      "pos": "noun",
      "explanation": "machine + to polish [contraction]",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        144,
        "/",
        785
      ]
    },
    {
      "id": 3344,
      "bciAvId": 22391,
      "gloss": "vacuum cleaner",
      "glossSv": "dammsugare",
      "pos": "noun",
      "explanation": "machine + to clean",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        634,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 3345,
      "bciAvId": 22392,
      "gloss": "mixer, blender",
      "glossSv": "mixer",
      "pos": "noun",
      "explanation": "machine + mixture",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        783
      ]
    },
    {
      "id": 3346,
      "bciAvId": 22393,
      "gloss": "food processor, kitchen machine",
      "glossSv": "matberedare (etc)",
      "pos": "noun",
      "explanation": "machine + cooking,cookery,preparation (general)",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        840,
        "/",
        329
      ]
    },
    {
      "id": 3347,
      "bciAvId": 22394,
      "gloss": "opener",
      "glossSv": "öppnare",
      "pos": "noun",
      "explanation": "tool + to open",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        484
      ]
    },
    {
      "id": 3348,
      "bciAvId": 22395,
      "gloss": "bottle opener",
      "glossSv": "flasköppnare",
      "pos": "noun",
      "explanation": "opener + bottle",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        484,
        "/",
        174
      ]
    },
    {
      "id": 3349,
      "bciAvId": 22396,
      "gloss": "can opener",
      "glossSv": "burköppnare, konservöppnare",
      "pos": "noun",
      "explanation": "opener + can",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        484,
        "/",
        724
      ]
    },
    {
      "id": 3350,
      "bciAvId": 22397,
      "gloss": "cleaning tool",
      "glossSv": "städredskap",
      "pos": "noun",
      "explanation": "tool + to clean",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        634,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 3351,
      "bciAvId": 22398,
      "gloss": "cleaning cloth",
      "glossSv": "disktrasa, skurtrasa (etc)",
      "pos": "noun",
      "explanation": "cloth + to clean",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        634,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 3352,
      "bciAvId": 22562,
      "gloss": "grater, grinder",
      "glossSv": "rivjärn, kvarn (etc)",
      "pos": "noun",
      "explanation": "kitchen tool + to cut + piece",
      "isCharacter": false,
      "composition": [
        786,
        "/",
        411,
        "/",
        502
      ]
    },
    {
      "id": 3353,
      "bciAvId": 22563,
      "gloss": "whisk, beater",
      "glossSv": "visp",
      "pos": "noun",
      "explanation": "kitchen tool + to mix",
      "isCharacter": false,
      "composition": [
        786,
        "/",
        783
      ]
    },
    {
      "id": 3354,
      "bciAvId": 22564,
      "gloss": "corkscrew",
      "glossSv": "korkskruv",
      "pos": "noun",
      "explanation": "kitchen tool + screw",
      "isCharacter": false,
      "composition": [
        786,
        "/",
        582
      ]
    },
    {
      "id": 3355,
      "bciAvId": 22565,
      "gloss": "kitchen tongs",
      "glossSv": "kökstång",
      "pos": "noun",
      "explanation": "kitchen tool + tongs",
      "isCharacter": false,
      "composition": [
        786,
        "/",
        535
      ]
    },
    {
      "id": 3356,
      "bciAvId": 22566,
      "gloss": "nutcracker",
      "glossSv": "nötknäppare",
      "pos": "noun",
      "explanation": "kitchen tool + nut",
      "isCharacter": false,
      "composition": [
        786,
        "/",
        584,
        "/",
        666
      ]
    },
    {
      "id": 3357,
      "bciAvId": 22567,
      "gloss": "reaching aid, grabber",
      "glossSv": "gripverktyg",
      "pos": "noun",
      "explanation": "aid + to bring + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        917
      ]
    },
    {
      "id": 3358,
      "bciAvId": 22568,
      "gloss": "measuring spoon",
      "glossSv": "måttsked",
      "pos": "noun",
      "explanation": "spoon + to measure",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        441
      ]
    },
    {
      "id": 3359,
      "bciAvId": 22569,
      "gloss": "teaspoon",
      "glossSv": "tesked",
      "pos": "noun",
      "explanation": "spoon + small",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        956
      ]
    },
    {
      "id": 3360,
      "bciAvId": 22570,
      "gloss": "tablespoon",
      "glossSv": "matsked",
      "pos": "noun",
      "explanation": "spoon + big",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        936
      ]
    },
    {
      "id": 3361,
      "bciAvId": 22571,
      "gloss": "serving spoon",
      "glossSv": "serveringssked",
      "pos": "noun",
      "explanation": "spoon + to give",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        949
      ]
    },
    {
      "id": 3362,
      "bciAvId": 22572,
      "gloss": "mixing spoon",
      "glossSv": "slev",
      "pos": "noun",
      "explanation": "spoon + to mix",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        783
      ]
    },
    {
      "id": 3363,
      "bciAvId": 22573,
      "gloss": "ladle",
      "glossSv": "soppslev",
      "pos": "noun",
      "explanation": "spoon + container: spoon with deep bowl for serving liquids",
      "isCharacter": false,
      "composition": [
        614,
        "/",
        239
      ]
    },
    {
      "id": 3364,
      "bciAvId": 22575,
      "gloss": "oven tray",
      "glossSv": "bakplåt",
      "pos": "noun",
      "explanation": "tray + oven",
      "isCharacter": false,
      "composition": [
        665,
        "/",
        630
      ]
    },
    {
      "id": 3365,
      "bciAvId": 22576,
      "gloss": "baking tin, baking pan, ovenware",
      "glossSv": "bakform, eldfast form",
      "pos": "noun",
      "explanation": "container + oven",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        630
      ]
    },
    {
      "id": 3366,
      "bciAvId": 22580,
      "gloss": "electric pan",
      "glossSv": "kastrull (elektrisk)",
      "pos": "noun",
      "explanation": "pan + electricity",
      "isCharacter": false,
      "composition": [
        542,
        "/",
        "RK:-2",
        "/",
        288
      ]
    },
    {
      "id": 3367,
      "bciAvId": 22581,
      "gloss": "frying pan",
      "glossSv": "stekpanna",
      "pos": "noun",
      "explanation": "pan + oil",
      "isCharacter": false,
      "composition": [
        542,
        "/",
        480
      ]
    },
    {
      "id": 3368,
      "bciAvId": 22582,
      "gloss": "woking",
      "glossSv": "wokning",
      "pos": "noun",
      "explanation": "wok,wok pan + oil",
      "isCharacter": false,
      "composition": [
        1109,
        "/",
        480
      ]
    },
    {
      "id": 3369,
      "bciAvId": 22585,
      "gloss": "deep fryer",
      "glossSv": "fritös (elektrisk)",
      "pos": "noun",
      "explanation": "pot + oil + electricity",
      "isCharacter": false,
      "composition": [
        792,
        "/",
        480,
        "/",
        288
      ]
    },
    {
      "id": 3370,
      "bciAvId": 22586,
      "gloss": "steamer",
      "glossSv": "tryckkokare",
      "pos": "noun",
      "explanation": "pot + steam",
      "isCharacter": false,
      "composition": [
        792,
        "/",
        623
      ]
    },
    {
      "id": 3371,
      "bciAvId": 22587,
      "gloss": "electric kettle",
      "glossSv": "vattenkokare",
      "pos": "noun",
      "explanation": "pitcher,jug,kettle,pot + electricity",
      "isCharacter": false,
      "composition": [
        530,
        "/",
        288
      ]
    },
    {
      "id": 3372,
      "bciAvId": 22588,
      "gloss": "storage jar, preserving jar",
      "glossSv": "konservburk",
      "pos": "noun",
      "explanation": "can + future",
      "isCharacter": false,
      "composition": [
        724,
        "/",
        341
      ]
    },
    {
      "id": 3373,
      "bciAvId": 22589,
      "gloss": "glass jar",
      "glossSv": "glasburk",
      "pos": "noun",
      "explanation": "can + glass",
      "isCharacter": false,
      "composition": [
        724,
        "/",
        352
      ]
    },
    {
      "id": 3374,
      "bciAvId": 22590,
      "gloss": "tin, can",
      "glossSv": "plåtburk",
      "pos": "noun",
      "explanation": "can + metal [contraction]",
      "isCharacter": false,
      "composition": [
        724,
        "/",
        814
      ]
    },
    {
      "id": 3375,
      "bciAvId": 22591,
      "gloss": "cookie jar, biscuit tin",
      "glossSv": "kakburk",
      "pos": "noun",
      "explanation": "can + cookie/biscuit",
      "isCharacter": false,
      "composition": [
        724,
        "/",
        263,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 3376,
      "bciAvId": 22593,
      "gloss": "hot tray, chafing dish",
      "glossSv": "värmeplatta",
      "pos": "noun",
      "explanation": "tray + hot",
      "isCharacter": false,
      "composition": [
        665,
        "/",
        378
      ]
    },
    {
      "id": 3377,
      "bciAvId": 22594,
      "gloss": "table mat, placemat",
      "glossSv": "bordstablett",
      "pos": "noun",
      "explanation": "protection + table",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        639
      ]
    },
    {
      "id": 3378,
      "bciAvId": 22595,
      "gloss": "pot stand, trivet",
      "glossSv": "karottunderlägg",
      "pos": "noun",
      "explanation": "protection + table + hot",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        639,
        "/",
        378
      ]
    },
    {
      "id": 3379,
      "bciAvId": 22596,
      "gloss": "potholder, oven mitt",
      "glossSv": "grytlapp, grillvante",
      "pos": "noun",
      "explanation": "protection + hand + hot",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        374,
        "/",
        378
      ]
    },
    {
      "id": 3380,
      "bciAvId": 22597,
      "gloss": "dish gloves, rubber gloves",
      "glossSv": "gummihandskar",
      "pos": "noun",
      "explanation": "protection + hand + water",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        374,
        "/",
        695
      ]
    },
    {
      "id": 3381,
      "bciAvId": 22601,
      "gloss": "continent",
      "glossSv": "kontinent",
      "pos": "noun",
      "explanation": "part of + earth",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280
      ]
    },
    {
      "id": 3382,
      "bciAvId": 22602,
      "gloss": "Africa",
      "glossSv": "Afrika",
      "pos": "noun",
      "explanation": "part of + equator: should be understood as a combination of continent and equator",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        794
      ]
    },
    {
      "id": 3383,
      "bciAvId": 22603,
      "gloss": "Antarctic",
      "glossSv": "Antarktis",
      "pos": "noun",
      "explanation": "part of + South Pole: should be understood as a combination of continent and South Pole",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        795
      ]
    },
    {
      "id": 3384,
      "bciAvId": 22604,
      "gloss": "Asia",
      "glossSv": "Asien",
      "pos": "noun",
      "explanation": "continent + east",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        282
      ]
    },
    {
      "id": 3385,
      "bciAvId": 22605,
      "gloss": "Australia",
      "glossSv": "Australien",
      "pos": "noun",
      "explanation": "continent + south + east",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        610,
        "/",
        282
      ]
    },
    {
      "id": 3386,
      "bciAvId": 22606,
      "gloss": "Europe",
      "glossSv": "Europa",
      "pos": "noun",
      "explanation": "continent + north",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        472
      ]
    },
    {
      "id": 3387,
      "bciAvId": 22607,
      "gloss": "North America",
      "glossSv": "Nordamerika",
      "pos": "noun",
      "explanation": "continent + north + west",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        472,
        "/",
        698
      ]
    },
    {
      "id": 3388,
      "bciAvId": 22608,
      "gloss": "South America",
      "glossSv": "Sydamerika",
      "pos": "noun",
      "explanation": "continent + south + west",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        610,
        "/",
        698
      ]
    },
    {
      "id": 3389,
      "bciAvId": 22609,
      "gloss": "Belgium",
      "glossSv": "Belgien",
      "pos": "noun",
      "explanation": "country + strong + intensity: acc. to Caesar, Belgians were the bravest of all people in the Roman empire",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        967,
        "/",
        401
      ]
    },
    {
      "id": 3390,
      "bciAvId": 22610,
      "gloss": "England",
      "glossSv": "England",
      "pos": "noun",
      "explanation": "country + rose",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        325,
        "/",
        431
      ]
    },
    {
      "id": 3391,
      "bciAvId": 22611,
      "gloss": "rose",
      "glossSv": "ros",
      "pos": "noun",
      "explanation": "flower + love",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        431
      ]
    },
    {
      "id": 3392,
      "bciAvId": 22612,
      "gloss": "Norway",
      "glossSv": "Norge",
      "pos": "noun",
      "explanation": "country + fjord",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        797
      ]
    },
    {
      "id": 3393,
      "bciAvId": 22614,
      "gloss": "Scotland",
      "glossSv": "Skottland",
      "pos": "noun",
      "explanation": "country + cloth: cloth representing tartan",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        228
      ]
    },
    {
      "id": 3394,
      "bciAvId": 22615,
      "gloss": "South Africa",
      "glossSv": "Sydafrika",
      "pos": "noun",
      "explanation": "country + springbok",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        123,
        "/",
        836
      ]
    },
    {
      "id": 3395,
      "bciAvId": 22616,
      "gloss": "springbok",
      "glossSv": "springbock",
      "pos": "noun",
      "explanation": "animal (bovine,ovine),bovid,bovine + to jump",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        836
      ]
    },
    {
      "id": 3396,
      "bciAvId": 22617,
      "gloss": "Sweden",
      "glossSv": "Sverige",
      "pos": "noun",
      "explanation": "country + three + crown: three crowns have been the symbol for Sweden since The Middle-Ages",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        12,
        "/",
        798
      ]
    },
    {
      "id": 3397,
      "bciAvId": 22619,
      "gloss": "The Nordic countries",
      "glossSv": "Norden",
      "pos": "noun",
      "explanation": "5 + country + north",
      "isCharacter": false,
      "composition": [
        14,
        "/",
        243,
        "/",
        472
      ]
    },
    {
      "id": 3398,
      "bciAvId": 22620,
      "gloss": "earthquake",
      "glossSv": "jordbävning",
      "pos": "noun",
      "explanation": "earth + to shake + intensity",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        723,
        "/",
        401
      ]
    },
    {
      "id": 3399,
      "bciAvId": 22621,
      "gloss": "continental drift",
      "glossSv": "kontinentaldrift",
      "pos": "noun",
      "explanation": "continent + back and forth",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        280,
        "/",
        144
      ]
    },
    {
      "id": 3400,
      "bciAvId": 22622,
      "gloss": "waterfall",
      "glossSv": "vattenfall",
      "pos": "noun",
      "explanation": "water + to fall",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 3401,
      "bciAvId": 22623,
      "gloss": "rapid(s)",
      "glossSv": "fors",
      "pos": "noun",
      "explanation": "river + intensity + stone: part of a river moving fast over rocks in the river bed",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        401,
        "/",
        629
      ]
    },
    {
      "id": 3402,
      "bciAvId": 22624,
      "gloss": "tidal wave",
      "glossSv": "flodvåg",
      "pos": "noun",
      "explanation": "wave + enormous",
      "isCharacter": false,
      "composition": [
        761,
        "/",
        936,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3403,
      "bciAvId": 22626,
      "gloss": "tide",
      "glossSv": "tidvatten",
      "pos": "noun",
      "explanation": "sea + back and forth: daily variations in surface levels of oceans",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117,
        "/",
        144
      ]
    },
    {
      "id": 3404,
      "bciAvId": 22627,
      "gloss": "low tide, ebb",
      "glossSv": "ebb",
      "pos": "noun",
      "explanation": "tide + low",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117,
        "/",
        144,
        "/",
        957
      ]
    },
    {
      "id": 3405,
      "bciAvId": 22628,
      "gloss": "high tide",
      "glossSv": "flod",
      "pos": "noun",
      "explanation": "tide + high",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117,
        "/",
        144,
        "/",
        952
      ]
    },
    {
      "id": 3406,
      "bciAvId": 22629,
      "gloss": "low water",
      "glossSv": "lågvatten",
      "pos": "noun",
      "explanation": "sea + low",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117,
        "/",
        957
      ]
    },
    {
      "id": 3407,
      "bciAvId": 22630,
      "gloss": "high water",
      "glossSv": "högvatten",
      "pos": "noun",
      "explanation": "sea + high",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1117,
        "/",
        952
      ]
    },
    {
      "id": 3408,
      "bciAvId": 22631,
      "gloss": "spring (water)",
      "glossSv": "vattenkälla, springkälla",
      "pos": "noun",
      "explanation": "water (ground level) + up",
      "isCharacter": false,
      "composition": [
        1117,
        "/",
        678
      ]
    },
    {
      "id": 3409,
      "bciAvId": 22632,
      "gloss": "hot spring",
      "glossSv": "varmvattenkälla",
      "pos": "noun",
      "explanation": "spring (water) + hot",
      "isCharacter": false,
      "composition": [
        1117,
        "/",
        678,
        "/",
        378
      ]
    },
    {
      "id": 3410,
      "bciAvId": 22633,
      "gloss": "constellation of stars",
      "glossSv": "stjärnbild",
      "pos": "noun",
      "explanation": "group of + star",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622
      ]
    },
    {
      "id": 3411,
      "bciAvId": 22634,
      "gloss": "light year",
      "glossSv": "ljusår",
      "pos": "noun",
      "explanation": "distance [contraction] + light + year",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        424,
        "/",
        716
      ]
    },
    {
      "id": 3412,
      "bciAvId": 22635,
      "gloss": "telescope",
      "glossSv": "teleskop",
      "pos": "noun",
      "explanation": "tool + to see + star",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        622
      ]
    },
    {
      "id": 3413,
      "bciAvId": 22636,
      "gloss": "astrology",
      "glossSv": "astrologi",
      "pos": "noun",
      "explanation": "knowledge + star + person: knowledge of stars as they relate to human beings",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        622,
        "/",
        513
      ]
    },
    {
      "id": 3414,
      "bciAvId": 22637,
      "gloss": "weather forecast",
      "glossSv": "väderprognos",
      "pos": "noun",
      "explanation": "predict + weather",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        341,
        "/",
        696
      ]
    },
    {
      "id": 3415,
      "bciAvId": 22638,
      "gloss": "Aries (in zodiac)",
      "glossSv": "Väduren",
      "pos": "noun",
      "explanation": "constellation of stars + ram",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        123,
        "/",
        228,
        "/",
        106
      ]
    },
    {
      "id": 3416,
      "bciAvId": 22639,
      "gloss": "Taurus (in zodiac)",
      "glossSv": "Oxen",
      "pos": "noun",
      "explanation": "constellation of stars + bull",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        123,
        "/",
        106
      ]
    },
    {
      "id": 3417,
      "bciAvId": 22640,
      "gloss": "Cancer (in zodiac)",
      "glossSv": "Kräftan",
      "pos": "noun",
      "explanation": "constellation of stars + crab,shellfish (with claws)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        430
      ]
    },
    {
      "id": 3418,
      "bciAvId": 22641,
      "gloss": "Leo (in zodiac)",
      "glossSv": "Lejonet",
      "pos": "noun",
      "explanation": "constellation of stars + lion",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        126,
        "/",
        1054
      ]
    },
    {
      "id": 3419,
      "bciAvId": 22642,
      "gloss": "Virgo (in zodiac)",
      "glossSv": "Jungfrun",
      "pos": "noun",
      "explanation": "constellation of stars + woman,female",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        710
      ]
    },
    {
      "id": 3420,
      "bciAvId": 22643,
      "gloss": "Libra (in zodiac)",
      "glossSv": "Vågen",
      "pos": "noun",
      "explanation": "constellation of stars + weight (a)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        697,
        ";",
        97
      ]
    },
    {
      "id": 3421,
      "bciAvId": 22644,
      "gloss": "Scorpio (in zodiac)",
      "glossSv": "Skorpionen",
      "pos": "noun",
      "explanation": "constellation of stars + scorpion",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        613,
        "/",
        538
      ]
    },
    {
      "id": 3422,
      "bciAvId": 22645,
      "gloss": "Sagittarius (in zodiac)",
      "glossSv": "Skytten",
      "pos": "noun",
      "explanation": "constellation of stars + man + bow and arrow",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        433,
        "/",
        760
      ]
    },
    {
      "id": 3423,
      "bciAvId": 22646,
      "gloss": "Capricorn (in zodiac)",
      "glossSv": "Stenbocken",
      "pos": "noun",
      "explanation": "constellation of stars + animal (bovine,ovine),bovid,bovine + stone,rock",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        123,
        "/",
        629
      ]
    },
    {
      "id": 3424,
      "bciAvId": 22647,
      "gloss": "Aquarius (in zodiac)",
      "glossSv": "Vattumannen",
      "pos": "noun",
      "explanation": "constellation of stars + man + water",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        433,
        "/",
        695
      ]
    },
    {
      "id": 3425,
      "bciAvId": 22648,
      "gloss": "Pisces (in zodiac)",
      "glossSv": "Fiskarna",
      "pos": "noun",
      "explanation": "constellation of stars + fish (animal)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        321
      ]
    },
    {
      "id": 3426,
      "bciAvId": 22649,
      "gloss": "Nordic God, Nordic Goddess",
      "glossSv": "nordisk Gud",
      "pos": "person",
      "explanation": "God + north",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472
      ]
    },
    {
      "id": 3427,
      "bciAvId": 22650,
      "gloss": "Woden",
      "glossSv": "Oden",
      "pos": "person",
      "explanation": "Nordic God + eye: Woden gave away one eye in exchange for wisdom",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        303
      ]
    },
    {
      "id": 3428,
      "bciAvId": 22651,
      "gloss": "Frigg",
      "glossSv": "Frigg",
      "pos": "person",
      "explanation": "wife + Woden",
      "isCharacter": false,
      "composition": [
        704,
        "/",
        355,
        "/",
        472,
        "/",
        303
      ]
    },
    {
      "id": 3429,
      "bciAvId": 22652,
      "gloss": "Thor",
      "glossSv": "Tor",
      "pos": "person",
      "explanation": "Nordic God + hammer: the God of thunder; his hammer made the lightning",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        373
      ]
    },
    {
      "id": 3430,
      "bciAvId": 22653,
      "gloss": "Sif",
      "glossSv": "Siv",
      "pos": "person",
      "explanation": "wife + Thor",
      "isCharacter": false,
      "composition": [
        704,
        "/",
        355,
        "/",
        472,
        "/",
        373
      ]
    },
    {
      "id": 3431,
      "bciAvId": 22654,
      "gloss": "Mjolnir",
      "glossSv": "Mjölner",
      "pos": "noun",
      "explanation": "hammer + Nordic God: Thor's hammer",
      "isCharacter": false,
      "composition": [
        373,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3432,
      "bciAvId": 22655,
      "gloss": "Gemini (in zodiac)",
      "glossSv": "Tvillingarna",
      "pos": "noun",
      "explanation": "constellation of stars + twins",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        622,
        "/",
        11,
        "/",
        513,
        "/",
        578,
        "/",
        166
      ]
    },
    {
      "id": 3433,
      "bciAvId": 22817,
      "gloss": "Balder",
      "glossSv": "Balder",
      "pos": "person",
      "explanation": "Nordic God + light: the God of light and goodness",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        424
      ]
    },
    {
      "id": 3434,
      "bciAvId": 22818,
      "gloss": "Frey",
      "glossSv": "Frej, Frö",
      "pos": "person",
      "explanation": "Nordic God + plant: the God of growing power",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        533
      ]
    },
    {
      "id": 3435,
      "bciAvId": 22819,
      "gloss": "Freya",
      "glossSv": "Freja, Fröja",
      "pos": "person",
      "explanation": "Nordic God,Nordic Goddess + love: the Goddess of love",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        431
      ]
    },
    {
      "id": 3436,
      "bciAvId": 22820,
      "gloss": "Tyr",
      "glossSv": "Tyr",
      "pos": "person",
      "explanation": "Nordic God + war: the God of war",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        693
      ]
    },
    {
      "id": 3437,
      "bciAvId": 22821,
      "gloss": "Aegir",
      "glossSv": "Ägir",
      "pos": "person",
      "explanation": "Nordic God + sea: the God of the sea",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 3438,
      "bciAvId": 22822,
      "gloss": "Loki",
      "glossSv": "Loke (FD)",
      "pos": "person",
      "explanation": "Nordic God + lie (OLD): the God of falseness",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        486,
        "/",
        670
      ]
    },
    {
      "id": 3439,
      "bciAvId": 22823,
      "gloss": "Hugin and Munin",
      "glossSv": "Hugin och Munin",
      "pos": "noun",
      "explanation": "2 + bird + Nordic God: two ravens belonging to Woden",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        163,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3440,
      "bciAvId": 22824,
      "gloss": "Sleipnir",
      "glossSv": "Sleipner",
      "pos": "noun",
      "explanation": "horse + Nordic God: Woden's horse",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3441,
      "bciAvId": 22825,
      "gloss": "Saehrimnir",
      "glossSv": "Särimner",
      "pos": "noun",
      "explanation": "pig + Nordic God: a boar which was slaughtered every evening and healthy again every morning",
      "isCharacter": false,
      "composition": [
        521,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3442,
      "bciAvId": 22826,
      "gloss": "Midgard's serpent",
      "glossSv": "Midgårdsormen",
      "pos": "noun",
      "explanation": "snake + past time + north: a big snake curled around the world to keep it together",
      "isCharacter": false,
      "composition": [
        602,
        "/",
        503,
        "/",
        472
      ]
    },
    {
      "id": 3443,
      "bciAvId": 22827,
      "gloss": "Valhalla",
      "glossSv": "Valhall",
      "pos": "noun",
      "explanation": "house + Nordic God: home of the Gods",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3444,
      "bciAvId": 22828,
      "gloss": "Viking",
      "glossSv": "viking",
      "pos": "person",
      "explanation": "man + horns + sword",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        737,
        "/",
        411
      ]
    },
    {
      "id": 3445,
      "bciAvId": 22829,
      "gloss": "Viking ship",
      "glossSv": "vikingaskepp",
      "pos": "noun",
      "explanation": "boat + viking [contraction]",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        737,
        "/",
        411
      ]
    },
    {
      "id": 3446,
      "bciAvId": 22830,
      "gloss": "runes",
      "glossSv": "runor",
      "pos": "noun",
      "explanation": "alphabet + past + north",
      "isCharacter": false,
      "composition": [
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        503,
        "/",
        472
      ]
    },
    {
      "id": 3447,
      "bciAvId": 22831,
      "gloss": "to offer, to sacrifice",
      "glossSv": "offra",
      "pos": "action",
      "explanation": "to give + Nordic God + action indicator: to make a sacrifice the Gods",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3448,
      "bciAvId": 22832,
      "gloss": "sacrifice",
      "glossSv": "offer",
      "pos": "noun",
      "explanation": "gift + Nordic God",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        949,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3449,
      "bciAvId": 22833,
      "gloss": "blot",
      "glossSv": "blot",
      "pos": "noun",
      "explanation": "gathering + to sacrifice: ancient Scandinavian gathering to sacrifice to the Nordic Gods",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        949,
        "/",
        355,
        "/",
        472
      ]
    },
    {
      "id": 3450,
      "bciAvId": 22835,
      "gloss": "lawn bowling, bowls (sport)",
      "glossSv": "bowls, lawn bowling (sport)",
      "pos": "noun",
      "explanation": "bowling (sport) + lawn",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        998,
        "/",
        415
      ]
    },
    {
      "id": 3451,
      "bciAvId": 22836,
      "gloss": "solar system",
      "glossSv": "solsystem",
      "pos": "noun",
      "explanation": "all + planet",
      "isCharacter": false,
      "composition": [
        117,
        "/",
        800
      ]
    },
    {
      "id": 3452,
      "bciAvId": 22839,
      "gloss": "saddle",
      "glossSv": "sadel",
      "pos": "noun",
      "explanation": "seat + horse",
      "isCharacter": false,
      "composition": [
        517,
        "/",
        391
      ]
    },
    {
      "id": 3453,
      "bciAvId": 22840,
      "gloss": "court, field, sport field",
      "glossSv": "idrottsplats, idrottsplan",
      "pos": "noun",
      "explanation": "place + sport",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        719
      ]
    },
    {
      "id": 3454,
      "bciAvId": 22841,
      "gloss": "burial site",
      "glossSv": "gravplats",
      "pos": "noun",
      "explanation": "place + under (ground level)",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        1102
      ]
    },
    {
      "id": 3455,
      "bciAvId": 22901,
      "gloss": "astrologer, astrologist",
      "glossSv": "astrolog",
      "pos": "person",
      "explanation": "person + astrology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        622,
        "/",
        513
      ]
    },
    {
      "id": 3456,
      "bciAvId": 22903,
      "gloss": "beauty",
      "glossSv": "skönhet",
      "pos": "noun",
      "explanation": "eye + happiness,fun,joy,pleasure: pleasing to the eye",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 3457,
      "bciAvId": 22904,
      "gloss": "to call, to telephone, to ring",
      "glossSv": "ringa, telefonera",
      "pos": "action",
      "explanation": "telephone + action indicator",
      "isCharacter": false,
      "composition": [
        414,
        ";",
        81,
        "/",
        288
      ]
    },
    {
      "id": 3458,
      "bciAvId": 22905,
      "gloss": "chocolate",
      "glossSv": "choklad",
      "pos": "noun",
      "explanation": "food + bean + up (sweet [contraction])",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3459,
      "bciAvId": 22906,
      "gloss": "chocolate spread",
      "glossSv": "chokladpålägg",
      "pos": "noun",
      "explanation": "spread + chocolate [contraction]",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        154,
        "/",
        678
      ]
    },
    {
      "id": 3460,
      "bciAvId": 22907,
      "gloss": "cook, chef",
      "glossSv": "kock",
      "pos": "person",
      "explanation": "person + cooking,cookery,preparation (general)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        840,
        "/",
        329
      ]
    },
    {
      "id": 3461,
      "bciAvId": 22908,
      "gloss": "cooking, cookery, preparation (hot food)",
      "glossSv": "matlagning (varm mat)",
      "pos": "noun",
      "explanation": "fire + food: to use fire (heat) to prepare food",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        329
      ]
    },
    {
      "id": 3462,
      "bciAvId": 22909,
      "gloss": "cooking, cookery, preparation (general)",
      "glossSv": "matlagning",
      "pos": "noun",
      "explanation": "to make + food",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        329
      ]
    },
    {
      "id": 3463,
      "bciAvId": 22910,
      "gloss": "dirt, soil",
      "glossSv": "smuts",
      "pos": "noun",
      "explanation": "many + spot: many spots of dirt",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 3464,
      "bciAvId": 22912,
      "gloss": "fear, fright, concern",
      "glossSv": "rädsla",
      "pos": "noun",
      "explanation": "sadness + future (uncertain): concern about the future because of its uncertainties",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        1042
      ]
    },
    {
      "id": 3465,
      "bciAvId": 22915,
      "gloss": "religious (God based)",
      "glossSv": "religiös, troende (gudsbaserad)",
      "pos": "description",
      "explanation": "religion (God based) + description indicator",
      "isCharacter": false,
      "composition": [
        725,
        ";",
        86
      ]
    },
    {
      "id": 3466,
      "bciAvId": 22916,
      "gloss": "self-harming",
      "glossSv": "självdestruktiv",
      "pos": "description",
      "explanation": "self-harm + description indicator",
      "isCharacter": false,
      "composition": [
        804,
        ";",
        86,
        "/",
        401,
        "/",
        2343
      ]
    },
    {
      "id": 3467,
      "bciAvId": 22917,
      "gloss": "smartness, brightness, cleverness, intelligence",
      "glossSv": "klokhet, begåvning",
      "pos": "noun",
      "explanation": "mind + intensity: striking mental abilities",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        401
      ]
    },
    {
      "id": 3468,
      "bciAvId": 22918,
      "gloss": "uncertain, unsure",
      "glossSv": "osäker, obestämd",
      "pos": "description",
      "explanation": "doubt,uncertainty + description indicator",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        86
      ]
    },
    {
      "id": 3469,
      "bciAvId": 23001,
      "gloss": "accusation",
      "glossSv": "anklagelse, beskyllning, klander",
      "pos": "noun",
      "explanation": "to speak + opposition",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        487
      ]
    },
    {
      "id": 3470,
      "bciAvId": 23002,
      "gloss": "accusation (legal), charge, prosecution",
      "glossSv": "anklagelse (juridiskt), åtal",
      "pos": "noun",
      "explanation": "accusation + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        487,
        "/",
        813
      ]
    },
    {
      "id": 3471,
      "bciAvId": 23003,
      "gloss": "to accuse",
      "glossSv": "anklaga, beskylla, klandra",
      "pos": "action",
      "explanation": "accusation + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        487
      ]
    },
    {
      "id": 3472,
      "bciAvId": 23004,
      "gloss": "to accuse (legal), to charge, to prosecute",
      "glossSv": "anklaga (juridiskt), åtala",
      "pos": "action",
      "explanation": "accusation + judgement,law (in combinations) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        487,
        "/",
        813
      ]
    },
    {
      "id": 3473,
      "bciAvId": 23005,
      "gloss": "to act, to demonstrate (in favour of)",
      "glossSv": "agera, företräda, demonstrera (för)",
      "pos": "action",
      "explanation": "action,demonstration (in favour of) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        551
      ]
    },
    {
      "id": 3474,
      "bciAvId": 23006,
      "gloss": "to act in favour of, to act in favor of (legal)",
      "glossSv": "företräda (juridiskt)",
      "pos": "action",
      "explanation": "action,demonstration (in favour of) + judgement,law (in combinations) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        551,
        "/",
        813
      ]
    },
    {
      "id": 3475,
      "bciAvId": 23007,
      "gloss": "action, demonstration (in favour of)",
      "glossSv": "aktion, företrädande, demonstration (för)",
      "pos": "noun",
      "explanation": "activity + purpose",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        551
      ]
    },
    {
      "id": 3476,
      "bciAvId": 23008,
      "gloss": "activity centre",
      "glossSv": "aktivitetscenter",
      "pos": "noun",
      "explanation": "building + activity",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106
      ]
    },
    {
      "id": 3477,
      "bciAvId": 23009,
      "gloss": "activity centre (children)",
      "glossSv": "aktivitetscenter (barn)",
      "pos": "noun",
      "explanation": "activity centre + child",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106,
        "/",
        220
      ]
    },
    {
      "id": 3478,
      "bciAvId": 23010,
      "gloss": "activity centre (leisure time), after school club, youth club",
      "glossSv": "fritidsgård",
      "pos": "noun",
      "explanation": "activity centre + freedom",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106,
        "/",
        336
      ]
    },
    {
      "id": 3479,
      "bciAvId": 23011,
      "gloss": "activity centre (teenagers)",
      "glossSv": "aktivitetscenter (ungdom), ungdomsgård",
      "pos": "noun",
      "explanation": "activity centre + teenager",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106,
        "/",
        643
      ]
    },
    {
      "id": 3480,
      "bciAvId": 23012,
      "gloss": "advocate",
      "glossSv": "aktivist (för), företrädare",
      "pos": "person",
      "explanation": "person + action in favour of",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        551
      ]
    },
    {
      "id": 3481,
      "bciAvId": 23013,
      "gloss": "to advocate",
      "glossSv": "förespråka, propagera (för)",
      "pos": "action",
      "explanation": "advocacy + action indicator: to speak for a purpose",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        551
      ]
    },
    {
      "id": 3482,
      "bciAvId": 23014,
      "gloss": "advocate (legal)",
      "glossSv": "advokat",
      "pos": "person",
      "explanation": "legal person + action in favour of",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        106,
        "/",
        551
      ]
    },
    {
      "id": 3483,
      "bciAvId": 23015,
      "gloss": "to advocate (legal)",
      "glossSv": "representera (juridiskt)",
      "pos": "action",
      "explanation": "advocate-(to) + judgement,law (in combinations) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        551,
        "/",
        813
      ]
    },
    {
      "id": 3484,
      "bciAvId": 23016,
      "gloss": "advocate (legal, speaking)",
      "glossSv": "talesperson (juridisk), advokat",
      "pos": "person",
      "explanation": "legal person + advocate-(to)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        457,
        "/",
        551
      ]
    },
    {
      "id": 3485,
      "bciAvId": 23017,
      "gloss": "advocate (speaking), spokesperson",
      "glossSv": "förespråkare, talesperson",
      "pos": "person",
      "explanation": "person + advocate-(to)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        457,
        "/",
        551
      ]
    },
    {
      "id": 3486,
      "bciAvId": 23018,
      "gloss": "altimeter",
      "glossSv": "höjdmätare, altimeter",
      "pos": "noun",
      "explanation": "gauge + high + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        952
      ]
    },
    {
      "id": 3487,
      "bciAvId": 23019,
      "gloss": "anemometer",
      "glossSv": "vindmätare, anemometer",
      "pos": "noun",
      "explanation": "gauge + wind + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        705
      ]
    },
    {
      "id": 3488,
      "bciAvId": 23020,
      "gloss": "angle (measurement)",
      "glossSv": "vinkel, vinkelmått",
      "pos": "noun",
      "explanation": "measurement + angle",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        121
      ]
    },
    {
      "id": 3489,
      "bciAvId": 23021,
      "gloss": "any day, someday",
      "glossSv": "någon dag, endera dagen",
      "pos": "noun",
      "explanation": "a + day",
      "isCharacter": false,
      "composition": [
        100,
        "/",
        258
      ]
    },
    {
      "id": 3490,
      "bciAvId": 23022,
      "gloss": "apartment block",
      "glossSv": "höghus",
      "pos": "noun",
      "explanation": "many + many + floor,storey,level,etage",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        808
      ]
    },
    {
      "id": 3491,
      "bciAvId": 23023,
      "gloss": "archipelago",
      "glossSv": "skärgård",
      "pos": "noun",
      "explanation": "group of + island",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        404
      ]
    },
    {
      "id": 3492,
      "bciAvId": 23024,
      "gloss": "area (measurement)",
      "glossSv": "yta, ytmått, area, areal",
      "pos": "noun",
      "explanation": "measurement + enclosure",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        291
      ]
    },
    {
      "id": 3493,
      "bciAvId": 23025,
      "gloss": "to arrest",
      "glossSv": "anhålla, gripa",
      "pos": "action",
      "explanation": "capture,catch,seize-(to) + judgement,law (in combinations) + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        401,
        "/",
        813
      ]
    },
    {
      "id": 3494,
      "bciAvId": 23027,
      "gloss": "bakery",
      "glossSv": "bageri",
      "pos": "noun",
      "explanation": "store + bread",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        180
      ]
    },
    {
      "id": 3495,
      "bciAvId": 23028,
      "gloss": "barometer, manometer",
      "glossSv": "barometer, manometer",
      "pos": "noun",
      "explanation": "gauge + pressure + air + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        815,
        "/",
        114
      ]
    },
    {
      "id": 3496,
      "bciAvId": 23030,
      "gloss": "biology (class)",
      "glossSv": "biologi (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + biology [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        423
      ]
    },
    {
      "id": 3497,
      "bciAvId": 23031,
      "gloss": "Bliss, Bliss language, Blissymbolics",
      "glossSv": "bliss, blisspråket",
      "pos": "noun",
      "explanation": "language + Blissymbol",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        167
      ]
    },
    {
      "id": 3498,
      "bciAvId": 23032,
      "gloss": "Bliss (class)",
      "glossSv": "bliss (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + Bliss language",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        167
      ]
    },
    {
      "id": 3499,
      "bciAvId": 23033,
      "gloss": "to board",
      "glossSv": "bo inackorderad",
      "pos": "action",
      "explanation": "board and lodging,room and board + action indicator",
      "isCharacter": false,
      "composition": [
        392,
        ";",
        81,
        "/",
        120,
        "/",
        329
      ]
    },
    {
      "id": 3500,
      "bciAvId": 23034,
      "gloss": "bookshop",
      "glossSv": "bokhandel",
      "pos": "noun",
      "explanation": "store + book",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        173
      ]
    },
    {
      "id": 3501,
      "bciAvId": 23035,
      "gloss": "bronze",
      "glossSv": "brons",
      "pos": "noun",
      "explanation": "metal [contraction] + tin [contraction] + copper [contraction]",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        251,
        "/",
        542
      ]
    },
    {
      "id": 3502,
      "bciAvId": 23036,
      "gloss": "bronze age",
      "glossSv": "bronsåldern",
      "pos": "noun",
      "explanation": "past + bronze [contraction]",
      "isCharacter": false,
      "composition": [
        503,
        "/",
        251,
        "/",
        542
      ]
    },
    {
      "id": 3503,
      "bciAvId": 23037,
      "gloss": "butcher shop",
      "glossSv": "charkuteri",
      "pos": "noun",
      "explanation": "store + meat",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        329,
        "/",
        122
      ]
    },
    {
      "id": 3504,
      "bciAvId": 23038,
      "gloss": "care centre",
      "glossSv": "skyddat boende (etc)",
      "pos": "noun",
      "explanation": "house + protection",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        548
      ]
    },
    {
      "id": 3505,
      "bciAvId": 23039,
      "gloss": "cheap, inexpensive",
      "glossSv": "billig",
      "pos": "description",
      "explanation": "price + small + description indicator",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        86,
        "/",
        331,
        "/",
        651,
        "/",
        956
      ]
    },
    {
      "id": 3506,
      "bciAvId": 23040,
      "gloss": "chemistry (class)",
      "glossSv": "kemi (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + chemistry [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        216
      ]
    },
    {
      "id": 3507,
      "bciAvId": 23041,
      "gloss": "clerk, legal aid",
      "glossSv": "juridiskt biträde",
      "pos": "person",
      "explanation": "helper + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382,
        "/",
        813
      ]
    },
    {
      "id": 3508,
      "bciAvId": 23042,
      "gloss": "clothing shop",
      "glossSv": "klädaffär",
      "pos": "noun",
      "explanation": "store + clothing",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        229
      ]
    },
    {
      "id": 3509,
      "bciAvId": 23043,
      "gloss": "cockerel, rooster",
      "glossSv": "tupp",
      "pos": "noun",
      "explanation": "chicken (bird) + male",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        329,
        "/",
        106
      ]
    },
    {
      "id": 3510,
      "bciAvId": 23045,
      "gloss": "control tower",
      "glossSv": "kontrolltorn",
      "pos": "noun",
      "explanation": "tower + airplane",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        115
      ]
    },
    {
      "id": 3511,
      "bciAvId": 23046,
      "gloss": "copper",
      "glossSv": "koppar",
      "pos": "noun",
      "explanation": "metal [contraction] + pot + past time",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        542,
        "/",
        503
      ]
    },
    {
      "id": 3512,
      "bciAvId": 23047,
      "gloss": "corridor, hall",
      "glossSv": "korridor",
      "pos": "noun",
      "explanation": "room + long",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        420
      ]
    },
    {
      "id": 3513,
      "bciAvId": 23048,
      "gloss": "cotton",
      "glossSv": "bomull",
      "pos": "noun",
      "explanation": "material + flower,bloom,blossom + cloth: textile fibre made from the boll of the cotton plant",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        1037,
        "/",
        228
      ]
    },
    {
      "id": 3514,
      "bciAvId": 23049,
      "gloss": "cotton fabric",
      "glossSv": "bomullstyg",
      "pos": "noun",
      "explanation": "cloth + flower,bloom,blossom: fabric woven from cotton fibre [contraction]",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        1037
      ]
    },
    {
      "id": 3515,
      "bciAvId": 23050,
      "gloss": "count",
      "glossSv": "räknemått, antal",
      "pos": "noun",
      "explanation": "measurement + number",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        478
      ]
    },
    {
      "id": 3516,
      "bciAvId": 23051,
      "gloss": "court, courthouse",
      "glossSv": "domstol, rätt (juridisk)",
      "pos": "noun",
      "explanation": "building + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        813
      ]
    },
    {
      "id": 3517,
      "bciAvId": 23052,
      "gloss": "court, courtroom",
      "glossSv": "rättssal",
      "pos": "noun",
      "explanation": "public room + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        813
      ]
    },
    {
      "id": 3518,
      "bciAvId": 23053,
      "gloss": "crayfish",
      "glossSv": "kräfta",
      "pos": "noun",
      "explanation": "crab,shellfish (with claws) + small",
      "isCharacter": false,
      "composition": [
        430,
        "/",
        956
      ]
    },
    {
      "id": 3519,
      "bciAvId": 23054,
      "gloss": "day and night",
      "glossSv": "dygn",
      "pos": "noun",
      "explanation": "24 + hour",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        13,
        "/",
        655,
        "/",
        8
      ]
    },
    {
      "id": 3520,
      "bciAvId": 23055,
      "gloss": "day centre",
      "glossSv": "dagcentral",
      "pos": "noun",
      "explanation": "activity centre + day",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106,
        "/",
        258
      ]
    },
    {
      "id": 3521,
      "bciAvId": 23056,
      "gloss": "care, protection, defence",
      "glossSv": "omsorg, beskydd, försvar",
      "pos": "noun",
      "explanation": "activity + protection",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        548
      ]
    },
    {
      "id": 3522,
      "bciAvId": 23057,
      "gloss": "defence (legal)",
      "glossSv": "försvar (juridiskt)",
      "pos": "noun",
      "explanation": "to speak + to defend + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        106,
        "/",
        548,
        "/",
        813
      ]
    },
    {
      "id": 3523,
      "bciAvId": 23058,
      "gloss": "defence (spoken)",
      "glossSv": "försvar (muntligt)",
      "pos": "noun",
      "explanation": "to speak + to protect",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        548
      ]
    },
    {
      "id": 3524,
      "bciAvId": 23059,
      "gloss": "to care, to protect, to defend",
      "glossSv": "ha omsorg om, beskydda, försvara",
      "pos": "action",
      "explanation": "defence + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        548
      ]
    },
    {
      "id": 3525,
      "bciAvId": 23060,
      "gloss": "to defend (legal)",
      "glossSv": "försvara (juridiskt)",
      "pos": "action",
      "explanation": "defence (legal) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        106,
        "/",
        548,
        "/",
        813
      ]
    },
    {
      "id": 3526,
      "bciAvId": 23061,
      "gloss": "to defend (speak)",
      "glossSv": "försvara (muntligt)",
      "pos": "action",
      "explanation": "defence (spoken) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        548
      ]
    },
    {
      "id": 3527,
      "bciAvId": 23062,
      "gloss": "to defend (speak, legal)",
      "glossSv": "försvara (muntligt, juridiskt)",
      "pos": "action",
      "explanation": "defence (spoken) + judgement,law (in combinations) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        548,
        "/",
        813
      ]
    },
    {
      "id": 3528,
      "bciAvId": 23063,
      "gloss": "caregiver, protector, defender",
      "glossSv": "omsorgsgivare, beskyddare, försvarare",
      "pos": "person",
      "explanation": "person + care,protection,defence",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        548
      ]
    },
    {
      "id": 3529,
      "bciAvId": 23064,
      "gloss": "deflation",
      "glossSv": "deflation",
      "pos": "noun",
      "explanation": "value + money + plus: money will be worth more",
      "isCharacter": false,
      "composition": [
        297,
        "/",
        451,
        "/",
        120
      ]
    },
    {
      "id": 3530,
      "bciAvId": 23065,
      "gloss": "to act, to demonstrate (against)",
      "glossSv": "agera, demonstrera (mot)",
      "pos": "action",
      "explanation": "action,demonstration (against) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        487
      ]
    },
    {
      "id": 3531,
      "bciAvId": 23066,
      "gloss": "action, demonstration (against)",
      "glossSv": "aktion, demonstration (mot)",
      "pos": "noun",
      "explanation": "action + opposition,counter purpose",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        487
      ]
    },
    {
      "id": 3532,
      "bciAvId": 23067,
      "gloss": "department store",
      "glossSv": "varuhus",
      "pos": "noun",
      "explanation": "store + many + part",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        368,
        "/",
        502
      ]
    },
    {
      "id": 3533,
      "bciAvId": 23068,
      "gloss": "discount",
      "glossSv": "rabatt, avdrag",
      "pos": "noun",
      "explanation": "price + minus",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        651,
        "/",
        449
      ]
    },
    {
      "id": 3534,
      "bciAvId": 23069,
      "gloss": "discount sale",
      "glossSv": "realisation",
      "pos": "noun",
      "explanation": "event + discount",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        451,
        "/",
        331,
        "/",
        651,
        "/",
        449
      ]
    },
    {
      "id": 3535,
      "bciAvId": 23070,
      "gloss": "discount store",
      "glossSv": "lågprisbutik",
      "pos": "noun",
      "explanation": "store + discount [contraction]",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        331,
        "/",
        651,
        "/",
        449
      ]
    },
    {
      "id": 3536,
      "bciAvId": 23071,
      "gloss": "distance",
      "glossSv": "avstånd (FD)",
      "pos": "noun",
      "explanation": "measurement + farness,remoteness,farawayness (OLD)",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        946
      ]
    },
    {
      "id": 3537,
      "bciAvId": 23072,
      "gloss": "drugstore, pharmacy",
      "glossSv": "apotek",
      "pos": "noun",
      "explanation": "store + medical",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        958
      ]
    },
    {
      "id": 3538,
      "bciAvId": 23073,
      "gloss": "eaves",
      "glossSv": "takfot, takskägg",
      "pos": "noun",
      "explanation": "protection with pointer + thing indicator: roof with a pointer to the eaves",
      "isCharacter": false,
      "composition": [
        1072,
        ";",
        97
      ]
    },
    {
      "id": 3539,
      "bciAvId": 23074,
      "gloss": "economics (class)",
      "glossSv": "ekonomi (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + business",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        191
      ]
    },
    {
      "id": 3540,
      "bciAvId": 23075,
      "gloss": "electricity meter",
      "glossSv": "elmätare",
      "pos": "noun",
      "explanation": "gauge + electricity + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        288
      ]
    },
    {
      "id": 3541,
      "bciAvId": 23076,
      "gloss": "elementary school, primary school",
      "glossSv": "grundskola (låg- och mellanstadiet)",
      "pos": "noun",
      "explanation": "school [contraction] + child: Use appropriate specifier for other stages of schools",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        412,
        "/",
        220
      ]
    },
    {
      "id": 3542,
      "bciAvId": 23077,
      "gloss": "English (class)",
      "glossSv": "engelska (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + English",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        325,
        "/",
        431
      ]
    },
    {
      "id": 3543,
      "bciAvId": 23078,
      "gloss": "English (language)",
      "glossSv": "engelska",
      "pos": "noun",
      "explanation": "language + England [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        325,
        "/",
        431
      ]
    },
    {
      "id": 3544,
      "bciAvId": 23079,
      "gloss": "evidence",
      "glossSv": "bevis",
      "pos": "noun",
      "explanation": "fact + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        307,
        "/",
        813
      ]
    },
    {
      "id": 3545,
      "bciAvId": 23080,
      "gloss": "expensive",
      "glossSv": "dyr",
      "pos": "description",
      "explanation": "price + big + description indicator",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        86,
        "/",
        331,
        "/",
        651,
        "/",
        936
      ]
    },
    {
      "id": 3546,
      "bciAvId": 23081,
      "gloss": "just, fair",
      "glossSv": "rättvis",
      "pos": "description",
      "explanation": "judgement + equal + description indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        86,
        "/",
        578
      ]
    },
    {
      "id": 3547,
      "bciAvId": 23082,
      "gloss": "fine (penalty)",
      "glossSv": "böter, bot",
      "pos": "noun",
      "explanation": "money + after + guilt",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        109,
        "/",
        813,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 3548,
      "bciAvId": 23083,
      "gloss": "flatfish",
      "glossSv": "plattfisk",
      "pos": "noun",
      "explanation": "fish + low",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        957
      ]
    },
    {
      "id": 3549,
      "bciAvId": 23084,
      "gloss": "flax",
      "glossSv": "lin, linne",
      "pos": "noun",
      "explanation": "material + stalk + cloth: textile fibre made from the stalk of the flax plant",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        625,
        "/",
        228
      ]
    },
    {
      "id": 3550,
      "bciAvId": 23086,
      "gloss": "floor (42nd)",
      "glossSv": "våning (nr 42)",
      "pos": "noun",
      "explanation": "storey + 42: Use appropriate number for other floors.",
      "isCharacter": false,
      "composition": [
        808,
        "/",
        13,
        "/",
        11
      ]
    },
    {
      "id": 3551,
      "bciAvId": 23087,
      "gloss": "floor (first)",
      "glossSv": "våning (första)",
      "pos": "noun",
      "explanation": "storey + one: Use appropriate number for other floors.",
      "isCharacter": false,
      "composition": [
        808,
        "/",
        10
      ]
    },
    {
      "id": 3552,
      "bciAvId": 23088,
      "gloss": "florist",
      "glossSv": "blomsteraffär",
      "pos": "noun",
      "explanation": "store + flower",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        325
      ]
    },
    {
      "id": 3553,
      "bciAvId": 23090,
      "gloss": "fuel gauge",
      "glossSv": "bränslemätare",
      "pos": "noun",
      "explanation": "gauge + gasoline + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        695,
        "/",
        700
      ]
    },
    {
      "id": 3554,
      "bciAvId": 23091,
      "gloss": "garden centre",
      "glossSv": "trädgårdscentrum",
      "pos": "noun",
      "explanation": "store + garden",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        344
      ]
    },
    {
      "id": 3555,
      "bciAvId": 23092,
      "gloss": "gauge, gage, meter",
      "glossSv": "mätinstrument",
      "pos": "noun",
      "explanation": "scale,measurement + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97
      ]
    },
    {
      "id": 3556,
      "bciAvId": 23093,
      "gloss": "geography",
      "glossSv": "geografi",
      "pos": "noun",
      "explanation": "body of learning + earth",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        280
      ]
    },
    {
      "id": 3557,
      "bciAvId": 23094,
      "gloss": "geography (class)",
      "glossSv": "geografi (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + geography [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        280
      ]
    },
    {
      "id": 3558,
      "bciAvId": 23095,
      "gloss": "geology (class)",
      "glossSv": "geologi (skolämne)",
      "pos": "noun",
      "explanation": "science + earth: scientific study of the origins, history and structure of the earth",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        281
      ]
    },
    {
      "id": 3559,
      "bciAvId": 23096,
      "gloss": "gift shop",
      "glossSv": "presentaffär",
      "pos": "noun",
      "explanation": "store + gift",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        651,
        "/",
        949
      ]
    },
    {
      "id": 3560,
      "bciAvId": 23098,
      "gloss": "God the father",
      "glossSv": "Gud Fader, Fadern",
      "pos": "person",
      "explanation": "God + father",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        312
      ]
    },
    {
      "id": 3561,
      "bciAvId": 23099,
      "gloss": "God the son",
      "glossSv": "Guds Son, Sonen",
      "pos": "person",
      "explanation": "God + son",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        607
      ]
    },
    {
      "id": 3562,
      "bciAvId": 23100,
      "gloss": "gold",
      "glossSv": "guld",
      "pos": "noun",
      "explanation": "metal [contraction] + ring",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        567
      ]
    },
    {
      "id": 3563,
      "bciAvId": 23101,
      "gloss": "greengrocer",
      "glossSv": "grönsaksaffär",
      "pos": "noun",
      "explanation": "store + vegetable (above ground)",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        684
      ]
    },
    {
      "id": 3564,
      "bciAvId": 23102,
      "gloss": "grocery store, food store, supermarket",
      "glossSv": "livsmedelsbutik, mataffär, stormarknad",
      "pos": "noun",
      "explanation": "store + food",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        329
      ]
    },
    {
      "id": 3565,
      "bciAvId": 23103,
      "gloss": "gutter, eaves trough",
      "glossSv": "takränna",
      "pos": "noun",
      "explanation": "container + eaves + thing indicator",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        1072,
        ";",
        97
      ]
    },
    {
      "id": 3566,
      "bciAvId": 23104,
      "gloss": "half an hour",
      "glossSv": "halvtimma",
      "pos": "noun",
      "explanation": "30 + minute",
      "isCharacter": false,
      "composition": [
        12,
        "/",
        9,
        "/",
        655,
        "/",
        7
      ]
    },
    {
      "id": 3567,
      "bciAvId": 23105,
      "gloss": "hall",
      "glossSv": "hall",
      "pos": "noun",
      "explanation": "place + between + room: space between rooms",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        162,
        "/",
        572
      ]
    },
    {
      "id": 3568,
      "bciAvId": 23106,
      "gloss": "handicraft shop",
      "glossSv": "hemslöjdsaffär",
      "pos": "noun",
      "explanation": "store + craft",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 3569,
      "bciAvId": 23107,
      "gloss": "handwriting, penmanship (class)",
      "glossSv": "välskrivning, skrivstil (skolämne)",
      "pos": "noun",
      "explanation": "knowledge,class (in combinations) [contraction] + write + hand",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        509,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 3570,
      "bciAvId": 23108,
      "gloss": "health goods shop",
      "glossSv": "hälsokostaffär",
      "pos": "noun",
      "explanation": "store + health",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        377
      ]
    },
    {
      "id": 3571,
      "bciAvId": 23109,
      "gloss": "Hebrew (class)",
      "glossSv": "hebreiska (skolämne)",
      "pos": "noun",
      "explanation": "knowledge,class (in combinations) [contraction] + Hebrew",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        621
      ]
    },
    {
      "id": 3572,
      "bciAvId": 23110,
      "gloss": "Hebrew (language)",
      "glossSv": "hebreiska",
      "pos": "noun",
      "explanation": "language + Jewish (Israel [contraction])",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        621
      ]
    },
    {
      "id": 3573,
      "bciAvId": 23111,
      "gloss": "herb, spice plant",
      "glossSv": "kryddväxt",
      "pos": "noun",
      "explanation": "plant + taste",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        642
      ]
    },
    {
      "id": 3574,
      "bciAvId": 23112,
      "gloss": "history (class)",
      "glossSv": "historia (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + history [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        503
      ]
    },
    {
      "id": 3575,
      "bciAvId": 23113,
      "gloss": "history teacher",
      "glossSv": "historielärare",
      "pos": "person",
      "explanation": "person + history (class): teacher [contraction] + history [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        503
      ]
    },
    {
      "id": 3576,
      "bciAvId": 23114,
      "gloss": "Holy Spirit",
      "glossSv": "Anden, Den Helige Ande",
      "pos": "person",
      "explanation": "God + fire",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        319
      ]
    },
    {
      "id": 3577,
      "bciAvId": 23115,
      "gloss": "Holy Trinity",
      "glossSv": "treenigheten",
      "pos": "noun",
      "explanation": "God + three + life",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        12,
        "/",
        423
      ]
    },
    {
      "id": 3578,
      "bciAvId": 23116,
      "gloss": "horizontal",
      "glossSv": "vågrät, horisontell",
      "pos": "description",
      "explanation": "horizontal-(a) + description indicator",
      "isCharacter": false,
      "composition": [
        811,
        ";",
        86
      ]
    },
    {
      "id": 3579,
      "bciAvId": 23118,
      "gloss": "illegal, criminal",
      "glossSv": "olaglig",
      "pos": "description",
      "explanation": "without + law + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        813,
        ";",
        86,
        "/",
        497
      ]
    },
    {
      "id": 3580,
      "bciAvId": 23119,
      "gloss": "inflation",
      "glossSv": "inflation",
      "pos": "noun",
      "explanation": "value + money + minus: money will be worth less",
      "isCharacter": false,
      "composition": [
        297,
        "/",
        451,
        "/",
        449
      ]
    },
    {
      "id": 3581,
      "bciAvId": 23120,
      "gloss": "innocence",
      "glossSv": "oskuld (utan skuld)",
      "pos": "noun",
      "explanation": "judgement + positive: in a trial a person who is judged positively is judged not guilty",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 3582,
      "bciAvId": 23121,
      "gloss": "innocent, not guilty",
      "glossSv": "oskyldig",
      "pos": "description",
      "explanation": "innocence + description indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 3583,
      "bciAvId": 23122,
      "gloss": "iron",
      "glossSv": "järn",
      "pos": "noun",
      "explanation": "metal [contraction] + nail",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        463
      ]
    },
    {
      "id": 3584,
      "bciAvId": 23123,
      "gloss": "iron age",
      "glossSv": "järnåldern",
      "pos": "noun",
      "explanation": "past + nail [contraction]",
      "isCharacter": false,
      "composition": [
        503,
        "/",
        463
      ]
    },
    {
      "id": 3585,
      "bciAvId": 23125,
      "gloss": "judge",
      "glossSv": "domare",
      "pos": "person",
      "explanation": "legal person + above/superior: a person who presides over legal proceedings and hands down a judgement",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        493
      ]
    },
    {
      "id": 3586,
      "bciAvId": 23126,
      "gloss": "to judge",
      "glossSv": "döma",
      "pos": "action",
      "explanation": "judgement + action indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        81
      ]
    },
    {
      "id": 3587,
      "bciAvId": 23128,
      "gloss": "juridical",
      "glossSv": "juridisk",
      "pos": "description",
      "explanation": "judgement + description indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        86
      ]
    },
    {
      "id": 3588,
      "bciAvId": 23129,
      "gloss": "jury",
      "glossSv": "nämndemän, jury",
      "pos": "noun",
      "explanation": "group of + peer + legal [contraction]: a group of persons equal in standing before the law to the person being tried",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        578,
        "/",
        813
      ]
    },
    {
      "id": 3589,
      "bciAvId": 23130,
      "gloss": "justice",
      "glossSv": "rättvisa",
      "pos": "noun",
      "explanation": "judgement + same/equal",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        578
      ]
    },
    {
      "id": 3590,
      "bciAvId": 23131,
      "gloss": "language (class)",
      "glossSv": "språk (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + language",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414
      ]
    },
    {
      "id": 3591,
      "bciAvId": 23132,
      "gloss": "law",
      "glossSv": "juridik, rättsvetenskap",
      "pos": "noun",
      "explanation": "science,body of learning + judgement,law (in combinations)",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        813
      ]
    },
    {
      "id": 3592,
      "bciAvId": 23133,
      "gloss": "law - (a)",
      "glossSv": "lag (juridisk)",
      "pos": "noun",
      "explanation": "legal [contraction] + paper: judgement put into writing or recorded",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        497
      ]
    },
    {
      "id": 3593,
      "bciAvId": 23134,
      "gloss": "law, The Law",
      "glossSv": "lagen, lagbok",
      "pos": "noun",
      "explanation": "judgement + book",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        173
      ]
    },
    {
      "id": 3594,
      "bciAvId": 23135,
      "gloss": "lawyer",
      "glossSv": "jurist, advokat",
      "pos": "person",
      "explanation": "person + law",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        173
      ]
    },
    {
      "id": 3595,
      "bciAvId": 23136,
      "gloss": "lawyer (for the defence)",
      "glossSv": "försvarsadvokat",
      "pos": "person",
      "explanation": "legal person + to speak + to protect",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        457,
        "/",
        548
      ]
    },
    {
      "id": 3596,
      "bciAvId": 23137,
      "gloss": "lead",
      "glossSv": "bly",
      "pos": "noun",
      "explanation": "metal [contraction] + a weight",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        697,
        ";",
        97
      ]
    },
    {
      "id": 3597,
      "bciAvId": 23138,
      "gloss": "legal",
      "glossSv": "laglig",
      "pos": "description",
      "explanation": "law + description indicator",
      "isCharacter": false,
      "composition": [
        813,
        ";",
        86,
        "/",
        497
      ]
    },
    {
      "id": 3598,
      "bciAvId": 23139,
      "gloss": "legal aid",
      "glossSv": "rättshjälp",
      "pos": "person",
      "explanation": "help + legal [contraction]",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        813
      ]
    },
    {
      "id": 3599,
      "bciAvId": 23140,
      "gloss": "legal person (in combinations)",
      "glossSv": "juridisk person (i kombinationer)",
      "pos": "person",
      "explanation": "person + legal [contraction]: Used in conjunction with a specifier",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813
      ]
    },
    {
      "id": 3600,
      "bciAvId": 23141,
      "gloss": "leisure time",
      "glossSv": "fritid",
      "pos": "noun",
      "explanation": "time + free",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        336
      ]
    },
    {
      "id": 3601,
      "bciAvId": 23142,
      "gloss": "light meter",
      "glossSv": "ljusmätare",
      "pos": "noun",
      "explanation": "gauge + light + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        424
      ]
    },
    {
      "id": 3602,
      "bciAvId": 23143,
      "gloss": "lighthouse",
      "glossSv": "fyr",
      "pos": "noun",
      "explanation": "tower + lamp + thing indicator",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        424,
        ";",
        97
      ]
    },
    {
      "id": 3603,
      "bciAvId": 23144,
      "gloss": "linen, flax fabric",
      "glossSv": "linne",
      "pos": "noun",
      "explanation": "cloth + stalk: fabric woven from flax [contraction]",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        625
      ]
    },
    {
      "id": 3604,
      "bciAvId": 23145,
      "gloss": "liquor shop, liquor store",
      "glossSv": "Systembolag, spritbutik",
      "pos": "noun",
      "explanation": "store + liquor",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        116
      ]
    },
    {
      "id": 3605,
      "bciAvId": 23146,
      "gloss": "lobster",
      "glossSv": "hummer",
      "pos": "noun",
      "explanation": "crab,shellfish (with claws) + big",
      "isCharacter": false,
      "composition": [
        430,
        "/",
        936
      ]
    },
    {
      "id": 3606,
      "bciAvId": 23147,
      "gloss": "market",
      "glossSv": "marknad",
      "pos": "noun",
      "explanation": "group of + store + limited time",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        819,
        "/",
        426
      ]
    },
    {
      "id": 3607,
      "bciAvId": 23148,
      "gloss": "math, mathematics (class) (1)",
      "glossSv": "matte, matematik (skolämne) (1)",
      "pos": "noun",
      "explanation": "class [contraction] + mathematics [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        478
      ]
    },
    {
      "id": 3608,
      "bciAvId": 23149,
      "gloss": "mercury",
      "glossSv": "kvicksilver",
      "pos": "noun",
      "explanation": "metal [contraction] + thermometer + thing indicator",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        645,
        ";",
        97
      ]
    },
    {
      "id": 3609,
      "bciAvId": 23151,
      "gloss": "city, metropolis",
      "glossSv": "storstad, stad, metropol",
      "pos": "noun",
      "explanation": "many + many + many + building",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        368,
        "/",
        392
      ]
    },
    {
      "id": 3610,
      "bciAvId": 23152,
      "gloss": "midnight",
      "glossSv": "midnatt",
      "pos": "noun",
      "explanation": "hour + 24",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        8,
        "/",
        11,
        "/",
        13
      ]
    },
    {
      "id": 3611,
      "bciAvId": 23153,
      "gloss": "multi storey building",
      "glossSv": "flervåningshus",
      "pos": "noun",
      "explanation": "group of + storey",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        808
      ]
    },
    {
      "id": 3612,
      "bciAvId": 23154,
      "gloss": "multi storey home",
      "glossSv": "flerplansvilla",
      "pos": "noun",
      "explanation": "group of + combination of storey and home",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        808,
        "/",
        313
      ]
    },
    {
      "id": 3613,
      "bciAvId": 23155,
      "gloss": "naming ceremony",
      "glossSv": "namngivningsceremoni",
      "pos": "noun",
      "explanation": "ceremony + name",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        464
      ]
    },
    {
      "id": 3614,
      "bciAvId": 23156,
      "gloss": "naming ceremony (religious)",
      "glossSv": "namngivningsceremoni (religiös)",
      "pos": "noun",
      "explanation": "religious ceremony + name",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        532,
        "/",
        726,
        "/",
        464
      ]
    },
    {
      "id": 3615,
      "bciAvId": 23157,
      "gloss": "noon",
      "glossSv": "middagstid, mitt på dagen, lunchtid",
      "pos": "noun",
      "explanation": "hour + 12",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        8,
        "/",
        10,
        "/",
        11
      ]
    },
    {
      "id": 3616,
      "bciAvId": 23158,
      "gloss": "notary",
      "glossSv": "notarie, sekreterare (rättslig)",
      "pos": "person",
      "explanation": "person + paper + legal [contraction]: person working with legal issues",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        497,
        "/",
        813
      ]
    },
    {
      "id": 3617,
      "bciAvId": 23159,
      "gloss": "notary (lawyer)",
      "glossSv": "tingsnotarie",
      "pos": "person",
      "explanation": "legal person + paper: combination of legal person and law",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        497
      ]
    },
    {
      "id": 3618,
      "bciAvId": 23160,
      "gloss": "octopus",
      "glossSv": "bläckfisk",
      "pos": "noun",
      "explanation": "water creature + eight + arm",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        17,
        "/",
        132
      ]
    },
    {
      "id": 3619,
      "bciAvId": 23161,
      "gloss": "odometer",
      "glossSv": "vägmätare, odometer (FD)",
      "pos": "noun",
      "explanation": "gauge + farness,remoteness,farawayness (OLD) + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        946
      ]
    },
    {
      "id": 3620,
      "bciAvId": 23162,
      "gloss": "oil gauge",
      "glossSv": "oljemätare",
      "pos": "noun",
      "explanation": "gauge + oil + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        480
      ]
    },
    {
      "id": 3621,
      "bciAvId": 23163,
      "gloss": "one storey building, bungalow",
      "glossSv": "envåningshus",
      "pos": "noun",
      "explanation": "one + storey",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        808
      ]
    },
    {
      "id": 3622,
      "bciAvId": 23164,
      "gloss": "one storey home",
      "glossSv": "enplansvilla",
      "pos": "noun",
      "explanation": "one + storey + feeling: 1 + combination of storey and home",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        808,
        "/",
        313
      ]
    },
    {
      "id": 3623,
      "bciAvId": 23165,
      "gloss": "peer",
      "glossSv": "jämlike",
      "pos": "person",
      "explanation": "person + same,equal,equality",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        578
      ]
    },
    {
      "id": 3624,
      "bciAvId": 23166,
      "gloss": "pencil case, pencil box",
      "glossSv": "pennskrin",
      "pos": "noun",
      "explanation": "container + pen,pencil",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        509
      ]
    },
    {
      "id": 3625,
      "bciAvId": 23167,
      "gloss": "physics (class)",
      "glossSv": "fysik (skolämne)",
      "pos": "noun",
      "explanation": "knowledge + energy: class [contraction] + physics [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        293
      ]
    },
    {
      "id": 3626,
      "bciAvId": 23168,
      "gloss": "prawn",
      "glossSv": "jätteräka",
      "pos": "noun",
      "explanation": "shellfish (without claws) + big",
      "isCharacter": false,
      "composition": [
        818,
        "/",
        936
      ]
    },
    {
      "id": 3627,
      "bciAvId": 23170,
      "gloss": "pressure gauge",
      "glossSv": "tryckmätare",
      "pos": "noun",
      "explanation": "gauge + pressure + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        815
      ]
    },
    {
      "id": 3628,
      "bciAvId": 23171,
      "gloss": "price rise",
      "glossSv": "prisökning",
      "pos": "noun",
      "explanation": "price + plus",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        651,
        "/",
        120
      ]
    },
    {
      "id": 3629,
      "bciAvId": 23172,
      "gloss": "to promote",
      "glossSv": "verka för, stödja, gynna",
      "pos": "action",
      "explanation": "promotion + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        332
      ]
    },
    {
      "id": 3630,
      "bciAvId": 23173,
      "gloss": "promotion",
      "glossSv": "stöd för, gynnande",
      "pos": "noun",
      "explanation": "activity + in order to",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        332
      ]
    },
    {
      "id": 3631,
      "bciAvId": 23176,
      "gloss": "prosecutor",
      "glossSv": "åklagare",
      "pos": "person",
      "explanation": "legal person + to accuse",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        813,
        "/",
        457,
        "/",
        487
      ]
    },
    {
      "id": 3632,
      "bciAvId": 23177,
      "gloss": "protest, objection, opposition",
      "glossSv": "protest, motstånd, opposition",
      "pos": "noun",
      "explanation": "to speak + against",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        111
      ]
    },
    {
      "id": 3633,
      "bciAvId": 23178,
      "gloss": "to protest, to resist",
      "glossSv": "motsätta sig, protestera",
      "pos": "action",
      "explanation": "protest + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        111
      ]
    },
    {
      "id": 3634,
      "bciAvId": 23179,
      "gloss": "protest, resistance",
      "glossSv": "protest, motstånd",
      "pos": "noun",
      "explanation": "activity + against",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        111
      ]
    },
    {
      "id": 3635,
      "bciAvId": 23180,
      "gloss": "protractor",
      "glossSv": "vinkelmätare, gradskiva",
      "pos": "noun",
      "explanation": "gauge + angle + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        121
      ]
    },
    {
      "id": 3636,
      "bciAvId": 23181,
      "gloss": "psychologist",
      "glossSv": "psykolog",
      "pos": "person",
      "explanation": "person + mind + feeling: person + psychology [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 3637,
      "bciAvId": 23182,
      "gloss": "psychologist (researcher)",
      "glossSv": "psykolog (forskare)",
      "pos": "person",
      "explanation": "person + psychology: researcher + psychology [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 3638,
      "bciAvId": 23183,
      "gloss": "psychology",
      "glossSv": "psykologi",
      "pos": "noun",
      "explanation": "body of learning + mind + feeling",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 3639,
      "bciAvId": 23184,
      "gloss": "psychology teacher",
      "glossSv": "psykologilärare",
      "pos": "person",
      "explanation": "teacher,pedagogue,educator (in combinations) + mind + feeling: teacher + psychology [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 3640,
      "bciAvId": 23185,
      "gloss": "quarter of an hour",
      "glossSv": "kvart",
      "pos": "noun",
      "explanation": "15 + minute",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        14,
        "/",
        655,
        "/",
        7
      ]
    },
    {
      "id": 3641,
      "bciAvId": 23186,
      "gloss": "rain gauge",
      "glossSv": "regnmätare",
      "pos": "noun",
      "explanation": "gauge + rain + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        556
      ]
    },
    {
      "id": 3642,
      "bciAvId": 23187,
      "gloss": "reading (class)",
      "glossSv": "läsning (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + reading",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        303,
        "/",
        497
      ]
    },
    {
      "id": 3643,
      "bciAvId": 23188,
      "gloss": "reading lesson",
      "glossSv": "läslektion",
      "pos": "noun",
      "explanation": "lesson + reading",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        412,
        "/",
        303,
        "/",
        497
      ]
    },
    {
      "id": 3644,
      "bciAvId": 23189,
      "gloss": "religion (class)",
      "glossSv": "religionskunskap (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + religion",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        726
      ]
    },
    {
      "id": 3645,
      "bciAvId": 23190,
      "gloss": "religion (science of), theology",
      "glossSv": "religionsvetenskap",
      "pos": "noun",
      "explanation": "body of learning + religion",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        726
      ]
    },
    {
      "id": 3646,
      "bciAvId": 23191,
      "gloss": "religion teacher",
      "glossSv": "religionslärare",
      "pos": "person",
      "explanation": "teacher [contraction] + religion",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        726
      ]
    },
    {
      "id": 3647,
      "bciAvId": 23192,
      "gloss": "religious service",
      "glossSv": "religiös ritual",
      "pos": "noun",
      "explanation": "service + religion",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        532,
        "/",
        726
      ]
    },
    {
      "id": 3648,
      "bciAvId": 23194,
      "gloss": "sale",
      "glossSv": "försäljning",
      "pos": "noun",
      "explanation": "activity + to sell",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        651,
        "/",
        451
      ]
    },
    {
      "id": 3649,
      "bciAvId": 23195,
      "gloss": "salmon",
      "glossSv": "lax",
      "pos": "noun",
      "explanation": "fish + jump + river",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        836,
        "/",
        568
      ]
    },
    {
      "id": 3650,
      "bciAvId": 23196,
      "gloss": "sandwich (open face)",
      "glossSv": "smörgås",
      "pos": "noun",
      "explanation": "bread + spread",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        617
      ]
    },
    {
      "id": 3651,
      "bciAvId": 23197,
      "gloss": "scale (weighing)",
      "glossSv": "våg (vägning)",
      "pos": "noun",
      "explanation": "gauge + weight + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        697
      ]
    },
    {
      "id": 3652,
      "bciAvId": 23198,
      "gloss": "school (in combinations)",
      "glossSv": "skola (i kombinationer)",
      "pos": "noun",
      "explanation": "house + knowledge: house + to teach [contraction]: Used in conjunction with a specifier.",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        412
      ]
    },
    {
      "id": 3653,
      "bciAvId": 23199,
      "gloss": "season",
      "glossSv": "årstid",
      "pos": "noun",
      "explanation": "part of + year",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        716
      ]
    },
    {
      "id": 3654,
      "bciAvId": 23200,
      "gloss": "to capture, to catch, to seize",
      "glossSv": "fånga, gripa",
      "pos": "action",
      "explanation": "to get + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 3655,
      "bciAvId": 23202,
      "gloss": "to sentence, to condemn",
      "glossSv": "förklara skyldig, döma",
      "pos": "action",
      "explanation": "to say + other + guilty",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        428,
        "/",
        11,
        "/",
        813,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 3656,
      "bciAvId": 23203,
      "gloss": "service (work)",
      "glossSv": "service (tjänst)",
      "pos": "noun",
      "explanation": "activity + plan",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        532
      ]
    },
    {
      "id": 3657,
      "bciAvId": 23205,
      "gloss": "sheltered workshop",
      "glossSv": "daglig verksamhet",
      "pos": "noun",
      "explanation": "house + protection + work",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        548,
        "/",
        711
      ]
    },
    {
      "id": 3658,
      "bciAvId": 23206,
      "gloss": "shoal, school (of fish)",
      "glossSv": "fiskstim",
      "pos": "noun",
      "explanation": "group of + fish",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        321
      ]
    },
    {
      "id": 3659,
      "bciAvId": 23207,
      "gloss": "shopping centre, mall, plaza",
      "glossSv": "affärscentrum, köpcentrum",
      "pos": "noun",
      "explanation": "group of + store",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        819
      ]
    },
    {
      "id": 3660,
      "bciAvId": 23208,
      "gloss": "shopping mall",
      "glossSv": "köpcentrum, galleria",
      "pos": "noun",
      "explanation": "building + shopping centre",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        368,
        "/",
        819
      ]
    },
    {
      "id": 3661,
      "bciAvId": 23209,
      "gloss": "short time home",
      "glossSv": "bostad (tillfällig)",
      "pos": "noun",
      "explanation": "house + limited time: home [contraction] + limited time",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        426
      ]
    },
    {
      "id": 3662,
      "bciAvId": 23210,
      "gloss": "shrimp",
      "glossSv": "räka",
      "pos": "noun",
      "explanation": "shellfish (without claws) + small",
      "isCharacter": false,
      "composition": [
        818,
        "/",
        956
      ]
    },
    {
      "id": 3663,
      "bciAvId": 23211,
      "gloss": "silk",
      "glossSv": "silke",
      "pos": "noun",
      "explanation": "material + worm + cloth: textile fibre produced by silk worms",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        713,
        "/",
        228
      ]
    },
    {
      "id": 3664,
      "bciAvId": 23212,
      "gloss": "silk fabric",
      "glossSv": "siden",
      "pos": "noun",
      "explanation": "cloth + worm: fabric woven from silk fibre [contraction]",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        713
      ]
    },
    {
      "id": 3665,
      "bciAvId": 23213,
      "gloss": "silver",
      "glossSv": "silver",
      "pos": "noun",
      "explanation": "metal [contraction] + spoon",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        614
      ]
    },
    {
      "id": 3666,
      "bciAvId": 23214,
      "gloss": "size",
      "glossSv": "storlek",
      "pos": "noun",
      "explanation": "measurement + big",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        936
      ]
    },
    {
      "id": 3667,
      "bciAvId": 23215,
      "gloss": "skyscraper",
      "glossSv": "skyskrapa",
      "pos": "noun",
      "explanation": "many + many + many + storey: building with many storeys",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        368,
        "/",
        808
      ]
    },
    {
      "id": 3668,
      "bciAvId": 23216,
      "gloss": "speed",
      "glossSv": "fart, hastighet",
      "pos": "noun",
      "explanation": "measurement + fast",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3669,
      "bciAvId": 23217,
      "gloss": "speedometer",
      "glossSv": "hastighetsmätare",
      "pos": "noun",
      "explanation": "gauge + fast + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 3670,
      "bciAvId": 23218,
      "gloss": "sport lesson",
      "glossSv": "idrottslektion",
      "pos": "noun",
      "explanation": "lesson + sport",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        412,
        "/",
        719
      ]
    },
    {
      "id": 3671,
      "bciAvId": 23219,
      "gloss": "sport shop",
      "glossSv": "sportaffär",
      "pos": "noun",
      "explanation": "store + sport",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        719
      ]
    },
    {
      "id": 3672,
      "bciAvId": 23220,
      "gloss": "starfish",
      "glossSv": "sjöstjärna",
      "pos": "noun",
      "explanation": "water creature + star",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        622
      ]
    },
    {
      "id": 3673,
      "bciAvId": 23221,
      "gloss": "statement",
      "glossSv": "sakframställning",
      "pos": "noun",
      "explanation": "to write + to say + legal [contraction]: testimony written down or recorded",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        457,
        "/",
        813
      ]
    },
    {
      "id": 3674,
      "bciAvId": 23222,
      "gloss": "stone age",
      "glossSv": "stenåldern",
      "pos": "noun",
      "explanation": "past + stone",
      "isCharacter": false,
      "composition": [
        503,
        "/",
        "RK:-2",
        "/",
        629
      ]
    },
    {
      "id": 3675,
      "bciAvId": 23224,
      "gloss": "support (oral)",
      "glossSv": "bifall, uppmuntran, stöd (muntligt)",
      "pos": "noun",
      "explanation": "to speak + in order to",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        332
      ]
    },
    {
      "id": 3676,
      "bciAvId": 23225,
      "gloss": "to support (orally)",
      "glossSv": "tala för, stödja",
      "pos": "action",
      "explanation": "support (oral) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        332
      ]
    },
    {
      "id": 3677,
      "bciAvId": 23226,
      "gloss": "Swedish (class)",
      "glossSv": "svenska (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + Swedish",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        12,
        "/",
        798
      ]
    },
    {
      "id": 3678,
      "bciAvId": 23227,
      "gloss": "Swedish (language)",
      "glossSv": "svenska",
      "pos": "noun",
      "explanation": "language + 3 + crown: language + Sweden [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        12,
        "/",
        798
      ]
    },
    {
      "id": 3679,
      "bciAvId": 23228,
      "gloss": "sweet shop, candy store",
      "glossSv": "godisaffär",
      "pos": "noun",
      "explanation": "store + candy",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        348,
        "/",
        782
      ]
    },
    {
      "id": 3680,
      "bciAvId": 23229,
      "gloss": "synthetic fabric",
      "glossSv": "syntetiskt tyg",
      "pos": "noun",
      "explanation": "material + chemical product + cloth: textile fibre produced by a chemical process",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        216,
        "/",
        228
      ]
    },
    {
      "id": 3681,
      "bciAvId": 23231,
      "gloss": "tax (national, federal)",
      "glossSv": "skatt (statlig)",
      "pos": "noun",
      "explanation": "tax + country: tax + government [contraction]",
      "isCharacter": false,
      "composition": [
        820,
        "/",
        243
      ]
    },
    {
      "id": 3682,
      "bciAvId": 23232,
      "gloss": "tax (real estate)",
      "glossSv": "fastighetsskatt",
      "pos": "noun",
      "explanation": "tax + building",
      "isCharacter": false,
      "composition": [
        820,
        "/",
        392
      ]
    },
    {
      "id": 3683,
      "bciAvId": 23233,
      "gloss": "tax (sales)",
      "glossSv": "moms",
      "pos": "noun",
      "explanation": "tax + to sell",
      "isCharacter": false,
      "composition": [
        820,
        "/",
        651,
        "/",
        451
      ]
    },
    {
      "id": 3684,
      "bciAvId": 23234,
      "gloss": "tax (state, regional)",
      "glossSv": "landstingsskatt",
      "pos": "noun",
      "explanation": "tax + province",
      "isCharacter": false,
      "composition": [
        820,
        "/",
        502,
        "/",
        243
      ]
    },
    {
      "id": 3685,
      "bciAvId": 23235,
      "gloss": "to testify",
      "glossSv": "vittna",
      "pos": "action",
      "explanation": "testimony + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        931,
        "/",
        813
      ]
    },
    {
      "id": 3686,
      "bciAvId": 23236,
      "gloss": "testimony",
      "glossSv": "vittnesmål",
      "pos": "noun",
      "explanation": "to say + observation + legal [contraction]: to state under oath what one has observed",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        931,
        "/",
        813
      ]
    },
    {
      "id": 3687,
      "bciAvId": 23237,
      "gloss": "theatre, theater",
      "glossSv": "teater",
      "pos": "noun",
      "explanation": "building + to see + to hear",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 3688,
      "bciAvId": 23238,
      "gloss": "timer",
      "glossSv": "tidtagarur, timer",
      "pos": "noun",
      "explanation": "gauge + time + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        655
      ]
    },
    {
      "id": 3689,
      "bciAvId": 23239,
      "gloss": "tin",
      "glossSv": "tenn",
      "pos": "noun",
      "explanation": "metal [contraction] + cup + past time",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        251,
        "/",
        503
      ]
    },
    {
      "id": 3690,
      "bciAvId": 23241,
      "gloss": "toy shop",
      "glossSv": "leksaksaffär",
      "pos": "noun",
      "explanation": "store + toy",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        651,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 3691,
      "bciAvId": 23242,
      "gloss": "trial",
      "glossSv": "rättegång",
      "pos": "noun",
      "explanation": "gathering + legal [contraction]",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        813
      ]
    },
    {
      "id": 3692,
      "bciAvId": 23243,
      "gloss": "two storey building",
      "glossSv": "tvåvåningshus",
      "pos": "noun",
      "explanation": "two + storey",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        808
      ]
    },
    {
      "id": 3693,
      "bciAvId": 23244,
      "gloss": "unfair, unjust",
      "glossSv": "orättvis",
      "pos": "description",
      "explanation": "without + fair + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        813,
        ";",
        86,
        "/",
        578
      ]
    },
    {
      "id": 3694,
      "bciAvId": 23245,
      "gloss": "watch tower, observation tower",
      "glossSv": "vakttorn",
      "pos": "noun",
      "explanation": "tower + observation",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        931
      ]
    },
    {
      "id": 3695,
      "bciAvId": 23246,
      "gloss": "water meter",
      "glossSv": "vattenmätare",
      "pos": "noun",
      "explanation": "gauge + water + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        695
      ]
    },
    {
      "id": 3696,
      "bciAvId": 23247,
      "gloss": "water tower",
      "glossSv": "vattentorn",
      "pos": "noun",
      "explanation": "tower + water",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        695
      ]
    },
    {
      "id": 3697,
      "bciAvId": 23248,
      "gloss": "weight (measurement)",
      "glossSv": "viktmått",
      "pos": "noun",
      "explanation": "measurement + weight",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        697
      ]
    },
    {
      "id": 3698,
      "bciAvId": 23249,
      "gloss": "vertical",
      "glossSv": "lodrät",
      "pos": "description",
      "explanation": "vertical-(a) + description indicator",
      "isCharacter": false,
      "composition": [
        822,
        ";",
        86
      ]
    },
    {
      "id": 3699,
      "bciAvId": 23251,
      "gloss": "witness",
      "glossSv": "vittne",
      "pos": "person",
      "explanation": "person + observation + legal [contraction]: person + to testify [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        931,
        "/",
        813
      ]
    },
    {
      "id": 3700,
      "bciAvId": 23252,
      "gloss": "workplace",
      "glossSv": "arbetsplats",
      "pos": "noun",
      "explanation": "house + work",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        711
      ]
    },
    {
      "id": 3701,
      "bciAvId": 23253,
      "gloss": "writing (class)",
      "glossSv": "skrivning (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + to write",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        509
      ]
    },
    {
      "id": 3702,
      "bciAvId": 23401,
      "gloss": "aboard, on board",
      "glossSv": "ombord",
      "pos": "description",
      "explanation": "inside + vehicle + description indicator: Use appropriate specifier.",
      "isCharacter": false,
      "composition": [
        398,
        ";",
        86,
        "/",
        688
      ]
    },
    {
      "id": 3703,
      "bciAvId": 23402,
      "gloss": "address",
      "glossSv": "adress",
      "pos": "noun",
      "explanation": "name + place + house: Use appropriate specifier.",
      "isCharacter": false,
      "composition": [
        464,
        "/",
        531,
        "/",
        392
      ]
    },
    {
      "id": 3704,
      "bciAvId": 23403,
      "gloss": "anti-virus program",
      "glossSv": "antivirusprogram",
      "pos": "noun",
      "explanation": "computer program + protection",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829,
        "/",
        548
      ]
    },
    {
      "id": 3705,
      "bciAvId": 23404,
      "gloss": "ashore",
      "glossSv": "iland",
      "pos": "description",
      "explanation": "debarkation,disembarkation (ashore) + description indicator",
      "isCharacter": false,
      "composition": [
        1018,
        ";",
        86
      ]
    },
    {
      "id": 3706,
      "bciAvId": 23405,
      "gloss": "ATM, cash machine",
      "glossSv": "bankomat, uttagsautomat",
      "pos": "noun",
      "explanation": "machine + bank card",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        824,
        "/",
        451
      ]
    },
    {
      "id": 3707,
      "bciAvId": 23407,
      "gloss": "to attach (computer)",
      "glossSv": "bifoga (dator)",
      "pos": "action",
      "explanation": "attachment (computer) + action indicator",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        81,
        "/",
        832
      ]
    },
    {
      "id": 3708,
      "bciAvId": 23408,
      "gloss": "attached (computer)",
      "glossSv": "bifogad (dator)",
      "pos": "description",
      "explanation": "attachment (computer) + description indicator",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        86,
        "/",
        832
      ]
    },
    {
      "id": 3709,
      "bciAvId": 23410,
      "gloss": "attachment (computer)",
      "glossSv": "bilaga (dator)",
      "pos": "noun",
      "explanation": "attachment + file",
      "isCharacter": false,
      "composition": [
        823,
        "/",
        832
      ]
    },
    {
      "id": 3710,
      "bciAvId": 23411,
      "gloss": "to backspace (computer)",
      "glossSv": "radera (backspace) (dator)",
      "pos": "action",
      "explanation": "to delete + backwards",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        145
      ]
    },
    {
      "id": 3711,
      "bciAvId": 23412,
      "gloss": "baker",
      "glossSv": "bagare",
      "pos": "person",
      "explanation": "person + bread",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        180
      ]
    },
    {
      "id": 3712,
      "bciAvId": 23413,
      "gloss": "ball pool",
      "glossSv": "bollbad",
      "pos": "noun",
      "explanation": "foundation + many + ball: a partial enclosure containing many balls",
      "isCharacter": false,
      "composition": [
        878,
        "/",
        368,
        "/",
        148
      ]
    },
    {
      "id": 3713,
      "bciAvId": 23414,
      "gloss": "ballet",
      "glossSv": "balett",
      "pos": "noun",
      "explanation": "action + toe + music",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        658,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 3714,
      "bciAvId": 23415,
      "gloss": "bank card, money card",
      "glossSv": "bankkort",
      "pos": "noun",
      "explanation": "card + money",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        451
      ]
    },
    {
      "id": 3715,
      "bciAvId": 23416,
      "gloss": "barrow, garden cart, wheelbarrow",
      "glossSv": "skottkärra",
      "pos": "noun",
      "explanation": "wagon + garden",
      "isCharacter": false,
      "composition": [
        689,
        "/",
        344
      ]
    },
    {
      "id": 3716,
      "bciAvId": 23417,
      "gloss": "blackberry",
      "glossSv": "björnbär",
      "pos": "noun",
      "explanation": "compound berry + black",
      "isCharacter": false,
      "composition": [
        557,
        "/",
        1161,
        "/",
        470
      ]
    },
    {
      "id": 3717,
      "bciAvId": 23418,
      "gloss": "brave, courageous",
      "glossSv": "modig",
      "pos": "description",
      "explanation": "courage + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        967
      ]
    },
    {
      "id": 3718,
      "bciAvId": 23419,
      "gloss": "bricklayer",
      "glossSv": "murare",
      "pos": "person",
      "explanation": "person + brick",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        168
      ]
    },
    {
      "id": 3719,
      "bciAvId": 23420,
      "gloss": "briefcase",
      "glossSv": "portfölj",
      "pos": "noun",
      "explanation": "bag + paper",
      "isCharacter": false,
      "composition": [
        147,
        "/",
        497
      ]
    },
    {
      "id": 3720,
      "bciAvId": 23421,
      "gloss": "Brontosaurus",
      "glossSv": "Brontosaurie",
      "pos": "noun",
      "explanation": "dinosaur + big",
      "isCharacter": false,
      "composition": [
        830,
        "/",
        936
      ]
    },
    {
      "id": 3721,
      "bciAvId": 23422,
      "gloss": "brownie, house elf",
      "glossSv": "hustomte",
      "pos": "person",
      "explanation": "little person + house",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        392
      ]
    },
    {
      "id": 3722,
      "bciAvId": 23423,
      "gloss": "Buddha",
      "glossSv": "Buddha",
      "pos": "person",
      "explanation": "man + Buddhism",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        726,
        "/",
        827
      ]
    },
    {
      "id": 3723,
      "bciAvId": 23424,
      "gloss": "Buddhism",
      "glossSv": "buddhism",
      "pos": "noun",
      "explanation": "religion + dharma wheel",
      "isCharacter": false,
      "composition": [
        726,
        "/",
        827
      ]
    },
    {
      "id": 3724,
      "bciAvId": 23425,
      "gloss": "buddhist",
      "glossSv": "buddhistisk",
      "pos": "description",
      "explanation": "dharma wheel + description indicator",
      "isCharacter": false,
      "composition": [
        827,
        ";",
        86
      ]
    },
    {
      "id": 3725,
      "bciAvId": 23426,
      "gloss": "buddhist (person)",
      "glossSv": "buddhist",
      "pos": "person",
      "explanation": "person + dharma wheel: person + buddhist",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        827
      ]
    },
    {
      "id": 3726,
      "bciAvId": 23427,
      "gloss": "budget, business plan",
      "glossSv": "budget, affärsplan",
      "pos": "noun",
      "explanation": "plan + business",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        191
      ]
    },
    {
      "id": 3727,
      "bciAvId": 23428,
      "gloss": "butcher",
      "glossSv": "charkuterist",
      "pos": "person",
      "explanation": "person + meat",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        329,
        "/",
        122
      ]
    },
    {
      "id": 3728,
      "bciAvId": 23429,
      "gloss": "car mechanic",
      "glossSv": "bilmekaniker",
      "pos": "person",
      "explanation": "mechanic + car",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        432,
        "/",
        202
      ]
    },
    {
      "id": 3729,
      "bciAvId": 23430,
      "gloss": "car track",
      "glossSv": "bilbana",
      "pos": "noun",
      "explanation": "track + car",
      "isCharacter": false,
      "composition": [
        849,
        "/",
        202
      ]
    },
    {
      "id": 3730,
      "bciAvId": 23432,
      "gloss": "card game",
      "glossSv": "kortspel",
      "pos": "noun",
      "explanation": "play [contraction] + card",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        824
      ]
    },
    {
      "id": 3731,
      "bciAvId": 23433,
      "gloss": "cartographer",
      "glossSv": "kartograf",
      "pos": "person",
      "explanation": "person + cartography",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 3732,
      "bciAvId": 23434,
      "gloss": "cartography",
      "glossSv": "kartografi",
      "pos": "noun",
      "explanation": "body of learning + map",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 3733,
      "bciAvId": 23435,
      "gloss": "cartoon, animated picture",
      "glossSv": "film (tecknad)",
      "pos": "noun",
      "explanation": "film + pencil: film on which images are drawn",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        547,
        "/",
        "RK:-2",
        "/",
        509
      ]
    },
    {
      "id": 3734,
      "bciAvId": 23436,
      "gloss": "casserole",
      "glossSv": "gratäng, gryta (maträtt) (etc)",
      "pos": "noun",
      "explanation": "food + container + oven: a food baked and served in the container in which it was cooked",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        239,
        "/",
        630
      ]
    },
    {
      "id": 3735,
      "bciAvId": 23438,
      "gloss": "castle, palace (royal)",
      "glossSv": "slott, palats (kungligt)",
      "pos": "noun",
      "explanation": "castle + crown",
      "isCharacter": false,
      "composition": [
        825,
        "/",
        798
      ]
    },
    {
      "id": 3736,
      "bciAvId": 23440,
      "gloss": "chilly",
      "glossSv": "frusen, kall",
      "pos": "description",
      "explanation": "feeling + coldness,cold + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1007
      ]
    },
    {
      "id": 3737,
      "bciAvId": 23441,
      "gloss": "civil engineer",
      "glossSv": "ingenjör, civilingenjör",
      "pos": "person",
      "explanation": "designer + bridge",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        182
      ]
    },
    {
      "id": 3738,
      "bciAvId": 23443,
      "gloss": "clown",
      "glossSv": "clown",
      "pos": "person",
      "explanation": "person + face + colour",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        306,
        "/",
        1161
      ]
    },
    {
      "id": 3739,
      "bciAvId": 23444,
      "gloss": "to be cold",
      "glossSv": "frysa",
      "pos": "action",
      "explanation": "to feel + coldness,cold + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        1007
      ]
    },
    {
      "id": 3740,
      "bciAvId": 23445,
      "gloss": "comedy",
      "glossSv": "komedi",
      "pos": "noun",
      "explanation": "play + up: play + happy [contraction]",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457,
        "/",
        678
      ]
    },
    {
      "id": 3741,
      "bciAvId": 23446,
      "gloss": "community centre, town hall, village hall",
      "glossSv": "folkets hus, stadshus",
      "pos": "noun",
      "explanation": "house + gathering",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        346
      ]
    },
    {
      "id": 3742,
      "bciAvId": 23447,
      "gloss": "computer",
      "glossSv": "dator",
      "pos": "noun",
      "explanation": "machine + digits (computer)",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829
      ]
    },
    {
      "id": 3743,
      "bciAvId": 23448,
      "gloss": "computer case",
      "glossSv": "datorlåda, datorchassi",
      "pos": "noun",
      "explanation": "enclosure + computer",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        432,
        "/",
        829
      ]
    },
    {
      "id": 3744,
      "bciAvId": 23449,
      "gloss": "computer game",
      "glossSv": "dataspel",
      "pos": "noun",
      "explanation": "computer program + to play [contraction]",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 3745,
      "bciAvId": 23450,
      "gloss": "computer peripheral",
      "glossSv": "datortillbehör",
      "pos": "noun",
      "explanation": "tool + computer",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        432,
        "/",
        829
      ]
    },
    {
      "id": 3746,
      "bciAvId": 23451,
      "gloss": "computer screen, monitor",
      "glossSv": "bildskärm, monitor, dataskärm",
      "pos": "noun",
      "explanation": "enclosure + eye + digits (computer)",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        303,
        "/",
        829
      ]
    },
    {
      "id": 3747,
      "bciAvId": 23452,
      "gloss": "concert",
      "glossSv": "konsert",
      "pos": "noun",
      "explanation": "action + music",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 3748,
      "bciAvId": 23453,
      "gloss": "to conjure, to turn to, to transform",
      "glossSv": "trolla",
      "pos": "action",
      "explanation": "wand + action indicator",
      "isCharacter": false,
      "composition": [
        692,
        ";",
        81
      ]
    },
    {
      "id": 3749,
      "bciAvId": 23454,
      "gloss": "constructional blocks, lego (etc)",
      "glossSv": "byggkloss, legobit (etc)",
      "pos": "noun",
      "explanation": "block + together",
      "isCharacter": false,
      "composition": [
        168,
        "/",
        823
      ]
    },
    {
      "id": 3750,
      "bciAvId": 23455,
      "gloss": "constructional toy",
      "glossSv": "byggleksak, lego (etc)",
      "pos": "noun",
      "explanation": "toy [contraction] + structure",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313,
        "/",
        633
      ]
    },
    {
      "id": 3751,
      "bciAvId": 23456,
      "gloss": "copier, photocopier",
      "glossSv": "kopiator",
      "pos": "noun",
      "explanation": "machine + copy + paper",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        963,
        "/",
        497
      ]
    },
    {
      "id": 3752,
      "bciAvId": 23457,
      "gloss": "coral",
      "glossSv": "korall",
      "pos": "noun",
      "explanation": "water creature + plant: water animals forming structures that may appear similar to plants and flowers",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        533
      ]
    },
    {
      "id": 3753,
      "bciAvId": 23458,
      "gloss": "coral reef",
      "glossSv": "korallrev",
      "pos": "noun",
      "explanation": "many + many + coral",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        851,
        "/",
        533
      ]
    },
    {
      "id": 3754,
      "bciAvId": 23459,
      "gloss": "cordless phone",
      "glossSv": "telefon (trådlös)",
      "pos": "noun",
      "explanation": "telephone + back and forth: telephone that can be carried around",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288,
        "/",
        144
      ]
    },
    {
      "id": 3755,
      "bciAvId": 23460,
      "gloss": "courage",
      "glossSv": "mod",
      "pos": "noun",
      "explanation": "feeling + strong",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        967
      ]
    },
    {
      "id": 3756,
      "bciAvId": 23461,
      "gloss": "coward",
      "glossSv": "feg person, fegis",
      "pos": "person",
      "explanation": "person + cowardice",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        449,
        "/",
        313,
        "/",
        967
      ]
    },
    {
      "id": 3757,
      "bciAvId": 23462,
      "gloss": "cowardice",
      "glossSv": "feghet",
      "pos": "noun",
      "explanation": "minus + courage",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        "/",
        967
      ]
    },
    {
      "id": 3758,
      "bciAvId": 23463,
      "gloss": "cowardly",
      "glossSv": "feg",
      "pos": "description",
      "explanation": "cowardice + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        ";",
        86,
        "/",
        967
      ]
    },
    {
      "id": 3759,
      "bciAvId": 23464,
      "gloss": "currency",
      "glossSv": "valuta",
      "pos": "noun",
      "explanation": "money + country",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        243
      ]
    },
    {
      "id": 3760,
      "bciAvId": 23465,
      "gloss": "to cut and paste (computer)",
      "glossSv": "flytta (dator)",
      "pos": "action",
      "explanation": "take,bring,carry,move-(to) + digits (computer): to move digitally",
      "isCharacter": false,
      "composition": [
        917,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 3761,
      "bciAvId": 23466,
      "gloss": "to dare",
      "glossSv": "våga",
      "pos": "action",
      "explanation": "brave + activity + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        967,
        "/",
        106
      ]
    },
    {
      "id": 3762,
      "bciAvId": 23467,
      "gloss": "data (digital information)",
      "glossSv": "datainformation, data",
      "pos": "noun",
      "explanation": "information + digits (computer): digital information",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        829
      ]
    },
    {
      "id": 3763,
      "bciAvId": 23468,
      "gloss": "to delete (computer)",
      "glossSv": "radera (delete) (dator)",
      "pos": "action",
      "explanation": "to delete + forward + action indicator",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        81,
        "/",
        335
      ]
    },
    {
      "id": 3764,
      "bciAvId": 23469,
      "gloss": "designer, planner",
      "glossSv": "designer, formgivare",
      "pos": "person",
      "explanation": "person + design",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532
      ]
    },
    {
      "id": 3765,
      "bciAvId": 23470,
      "gloss": "desktop computer",
      "glossSv": "dator (stationär), desktop",
      "pos": "noun",
      "explanation": "computer + tabletop",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829,
        "/",
        848
      ]
    },
    {
      "id": 3766,
      "bciAvId": 23471,
      "gloss": "to detach, to take apart",
      "glossSv": "ta isär, skilja",
      "pos": "action",
      "explanation": "detachment,separation,breakup + action indicator",
      "isCharacter": false,
      "composition": [
        1022,
        ";",
        81
      ]
    },
    {
      "id": 3767,
      "bciAvId": 23473,
      "gloss": "meat (diced), diced meat, chunks of meat",
      "glossSv": "kött i bitar, grytbitar",
      "pos": "noun",
      "explanation": "meat + piece: meat cut into small pieces",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        502
      ]
    },
    {
      "id": 3768,
      "bciAvId": 23474,
      "gloss": "digital",
      "glossSv": "digital",
      "pos": "description",
      "explanation": "digits (computer) + description indicator",
      "isCharacter": false,
      "composition": [
        829,
        ";",
        86
      ]
    },
    {
      "id": 3769,
      "bciAvId": 23478,
      "gloss": "to disembark",
      "glossSv": "gå av (fordon)",
      "pos": "action",
      "explanation": "to exit + vehicle + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        688
      ]
    },
    {
      "id": 3770,
      "bciAvId": 23479,
      "gloss": "document, written record",
      "glossSv": "dokument",
      "pos": "noun",
      "explanation": "paper + pen",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        509
      ]
    },
    {
      "id": 3771,
      "bciAvId": 23480,
      "gloss": "drama",
      "glossSv": "drama",
      "pos": "noun",
      "explanation": "play + up and down: play portraying conflicting emotions and upsetting events",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457,
        "/",
        723
      ]
    },
    {
      "id": 3772,
      "bciAvId": 23481,
      "gloss": "dwarf, gnome",
      "glossSv": "dvärg, tomte (etc)",
      "pos": "person",
      "explanation": "little person + beard: imaginary small person with beard",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        155
      ]
    },
    {
      "id": 3773,
      "bciAvId": 23482,
      "gloss": "electrical engineer",
      "glossSv": "elektroingenjör",
      "pos": "person",
      "explanation": "designer + electricity",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        288
      ]
    },
    {
      "id": 3774,
      "bciAvId": 23483,
      "gloss": "elf (fog)",
      "glossSv": "älva, alf, alv (dimma)",
      "pos": "person",
      "explanation": "little person + fog",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        328
      ]
    },
    {
      "id": 3775,
      "bciAvId": 23484,
      "gloss": "elf (star)",
      "glossSv": "älva, alf, alv (stjärna)",
      "pos": "person",
      "explanation": "little person + star",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        622
      ]
    },
    {
      "id": 3776,
      "bciAvId": 23485,
      "gloss": "e-mail, email",
      "glossSv": "e-post, e-brev, mejl",
      "pos": "noun",
      "explanation": "letter + digits (computer)",
      "isCharacter": false,
      "composition": [
        421,
        "/",
        829
      ]
    },
    {
      "id": 3777,
      "bciAvId": 23486,
      "gloss": "e-mail address, email address",
      "glossSv": "e-postadress, mejladress",
      "pos": "noun",
      "explanation": "name + place + e-mail",
      "isCharacter": false,
      "composition": [
        464,
        "/",
        531,
        "/",
        421,
        "/",
        829
      ]
    },
    {
      "id": 3778,
      "bciAvId": 23487,
      "gloss": "to embark, to board",
      "glossSv": "gå på (fordon), gå ombord",
      "pos": "action",
      "explanation": "to enter + vehicle + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        688
      ]
    },
    {
      "id": 3779,
      "bciAvId": 23489,
      "gloss": "export",
      "glossSv": "export",
      "pos": "noun",
      "explanation": "out of,exit (forward) + contents",
      "isCharacter": false,
      "composition": [
        491,
        "/",
        356
      ]
    },
    {
      "id": 3780,
      "bciAvId": 23490,
      "gloss": "to export",
      "glossSv": "exportera",
      "pos": "action",
      "explanation": "export + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        356
      ]
    },
    {
      "id": 3781,
      "bciAvId": 23491,
      "gloss": "to export (computer)",
      "glossSv": "exportera (dator)",
      "pos": "action",
      "explanation": "out of,exit (forward) + digits (computer) + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        835,
        "/",
        829
      ]
    },
    {
      "id": 3782,
      "bciAvId": 23492,
      "gloss": "exported",
      "glossSv": "exporterad",
      "pos": "description",
      "explanation": "export + description indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        86,
        "/",
        356
      ]
    },
    {
      "id": 3783,
      "bciAvId": 23493,
      "gloss": "eye controller, eye gaze controller",
      "glossSv": "ögonstyrning",
      "pos": "noun",
      "explanation": "pointing device + eye",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844,
        "/",
        303
      ]
    },
    {
      "id": 3784,
      "bciAvId": 23494,
      "gloss": "fairy, fairy godmother",
      "glossSv": "fe",
      "pos": "person",
      "explanation": "make-believe woman + wand",
      "isCharacter": false,
      "composition": [
        839,
        "/",
        692
      ]
    },
    {
      "id": 3785,
      "bciAvId": 23495,
      "gloss": "to fall asleep",
      "glossSv": "somna",
      "pos": "action",
      "explanation": "to go + asleep + action indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        599
      ]
    },
    {
      "id": 3786,
      "bciAvId": 23496,
      "gloss": "fashion designer",
      "glossSv": "kläddesigner, modeskapare",
      "pos": "person",
      "explanation": "designer + clothes",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        229
      ]
    },
    {
      "id": 3787,
      "bciAvId": 23497,
      "gloss": "fax",
      "glossSv": "fax",
      "pos": "noun",
      "explanation": "paper + telephone",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 3788,
      "bciAvId": 23498,
      "gloss": "to fax",
      "glossSv": "faxa",
      "pos": "action",
      "explanation": "fax + action indicator",
      "isCharacter": false,
      "composition": [
        497,
        ";",
        81,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 3789,
      "bciAvId": 23499,
      "gloss": "fax (machine)",
      "glossSv": "fax (maskin)",
      "pos": "noun",
      "explanation": "machine + fax",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        497,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 3790,
      "bciAvId": 23501,
      "gloss": "filled, stuffed",
      "glossSv": "fylld",
      "pos": "description",
      "explanation": "filling,fill,fullness + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        947,
        ";",
        84
      ]
    },
    {
      "id": 3791,
      "bciAvId": 23502,
      "gloss": "filled cabbage, stuffed cabbage",
      "glossSv": "kåldolmar",
      "pos": "noun",
      "explanation": "cabbage + filled",
      "isCharacter": false,
      "composition": [
        196,
        "/",
        947
      ]
    },
    {
      "id": 3792,
      "bciAvId": 23503,
      "gloss": "filled food, stuffed food",
      "glossSv": "mat med fyllning",
      "pos": "noun",
      "explanation": "food + filled",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        947
      ]
    },
    {
      "id": 3793,
      "bciAvId": 23504,
      "gloss": "filled leaf, dolma",
      "glossSv": "dolme, dolma, blad med fyllning",
      "pos": "noun",
      "explanation": "leaf + filled",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        947
      ]
    },
    {
      "id": 3794,
      "bciAvId": 23505,
      "gloss": "filled vegetable, stuffed vegetable",
      "glossSv": "grönsak med fyllning",
      "pos": "noun",
      "explanation": "vegetable (above ground) + filled",
      "isCharacter": false,
      "composition": [
        684,
        "/",
        947
      ]
    },
    {
      "id": 3795,
      "bciAvId": 23506,
      "gloss": "finger spelling, finger alphabet",
      "glossSv": "handalfabetet",
      "pos": "noun",
      "explanation": "alphabet + hand",
      "isCharacter": false,
      "composition": [
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        374
      ]
    },
    {
      "id": 3796,
      "bciAvId": 23507,
      "gloss": "to fingerspell",
      "glossSv": "stava med handalfabetet",
      "pos": "action",
      "explanation": "finger spelling + action indicator",
      "isCharacter": false,
      "composition": [
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        "RK:-7",
        "/",
        81,
        "/",
        "RK:3",
        "/",
        374
      ]
    },
    {
      "id": 3797,
      "bciAvId": 23508,
      "gloss": "fish finger",
      "glossSv": "fiskpinne",
      "pos": "noun",
      "explanation": "fish + linear thing + thing indicator: fish food shaped into sticks",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        321,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 3798,
      "bciAvId": 23509,
      "gloss": "fisherman",
      "glossSv": "fiskare",
      "pos": "person",
      "explanation": "person + fish",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        321
      ]
    },
    {
      "id": 3799,
      "bciAvId": 23510,
      "gloss": "flower fairy",
      "glossSv": "blomsterälva, blomsteralv",
      "pos": "person",
      "explanation": "little person + flower",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        325
      ]
    },
    {
      "id": 3800,
      "bciAvId": 23512,
      "gloss": "folder (digital)",
      "glossSv": "mapp (dator)",
      "pos": "noun",
      "explanation": "container + file",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        832
      ]
    },
    {
      "id": 3801,
      "bciAvId": 23513,
      "gloss": "foster home",
      "glossSv": "fosterhem",
      "pos": "noun",
      "explanation": "similar + home",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        392,
        "/",
        313
      ]
    },
    {
      "id": 3802,
      "bciAvId": 23514,
      "gloss": "freezer",
      "glossSv": "frys",
      "pos": "noun",
      "explanation": "cupboard + ice",
      "isCharacter": false,
      "composition": [
        252,
        "/",
        394
      ]
    },
    {
      "id": 3803,
      "bciAvId": 23515,
      "gloss": "fruit cream, compote",
      "glossSv": "kräm, fruktkräm, kompott",
      "pos": "noun",
      "explanation": "pudding,cream + fruit",
      "isCharacter": false,
      "composition": [
        776,
        "/",
        338
      ]
    },
    {
      "id": 3804,
      "bciAvId": 23516,
      "gloss": "function",
      "glossSv": "funktion",
      "pos": "noun",
      "explanation": "ability (half sized) + work",
      "isCharacter": false,
      "composition": [
        994,
        "/",
        711
      ]
    },
    {
      "id": 3805,
      "bciAvId": 23517,
      "gloss": "to function",
      "glossSv": "fungera",
      "pos": "action",
      "explanation": "function + action indicator",
      "isCharacter": false,
      "composition": [
        994,
        ";",
        81,
        "/",
        711
      ]
    },
    {
      "id": 3806,
      "bciAvId": 23518,
      "gloss": "functional",
      "glossSv": "fungerande",
      "pos": "description",
      "explanation": "function + description indicator",
      "isCharacter": false,
      "composition": [
        994,
        ";",
        86,
        "/",
        711
      ]
    },
    {
      "id": 3807,
      "bciAvId": 23519,
      "gloss": "gardener",
      "glossSv": "trädgårdsmästare",
      "pos": "person",
      "explanation": "person + garden",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        344
      ]
    },
    {
      "id": 3808,
      "bciAvId": 23520,
      "gloss": "ghost, phantom",
      "glossSv": "spöke",
      "pos": "person",
      "explanation": "make-believe person + transparent",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        303,
        "/",
        653
      ]
    },
    {
      "id": 3809,
      "bciAvId": 23521,
      "gloss": "giant",
      "glossSv": "jätte",
      "pos": "person",
      "explanation": "make-believe person + gigantic",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        936,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3810,
      "bciAvId": 23522,
      "gloss": "giant (human)",
      "glossSv": "jätte (mänsklig)",
      "pos": "person",
      "explanation": "person + gigantic",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        936,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3811,
      "bciAvId": 23523,
      "gloss": "to go ashore",
      "glossSv": "gå iland",
      "pos": "action",
      "explanation": "debarkation,disembarkation (ashore) + action indicator",
      "isCharacter": false,
      "composition": [
        1018,
        ";",
        81
      ]
    },
    {
      "id": 3812,
      "bciAvId": 23524,
      "gloss": "to go to sea",
      "glossSv": "gå till sjöss",
      "pos": "action",
      "explanation": "boarding,embarkation (to sea) + action indicator",
      "isCharacter": false,
      "composition": [
        1001,
        ";",
        81
      ]
    },
    {
      "id": 3813,
      "bciAvId": 23525,
      "gloss": "goblin",
      "glossSv": "svartalf",
      "pos": "person",
      "explanation": "make-believe person + night",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        470
      ]
    },
    {
      "id": 3814,
      "bciAvId": 23526,
      "gloss": "headmouse",
      "glossSv": "huvudmus",
      "pos": "noun",
      "explanation": "pointing device + head",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844,
        "/",
        376
      ]
    },
    {
      "id": 3815,
      "bciAvId": 23528,
      "gloss": "hero",
      "glossSv": "hjälte",
      "pos": "noun",
      "explanation": "person + heroic",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        967,
        "/",
        401
      ]
    },
    {
      "id": 3816,
      "bciAvId": 23529,
      "gloss": "heroic",
      "glossSv": "djärv, hjältemodig, tapper",
      "pos": "description",
      "explanation": "brave + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        967,
        "/",
        401
      ]
    },
    {
      "id": 3817,
      "bciAvId": 23530,
      "gloss": "herring, sardine",
      "glossSv": "sill, sardin",
      "pos": "noun",
      "explanation": "fish + colour + silver [contraction]: often called “silver of the sea”",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        1161,
        "/",
        614
      ]
    },
    {
      "id": 3818,
      "bciAvId": 23531,
      "gloss": "hobbit",
      "glossSv": "hobbit",
      "pos": "person",
      "explanation": "little person + foot",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        330
      ]
    },
    {
      "id": 3819,
      "bciAvId": 23532,
      "gloss": "to hold (with hand)",
      "glossSv": "hålla",
      "pos": "action",
      "explanation": "hand + goods + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        356
      ]
    },
    {
      "id": 3820,
      "bciAvId": 23533,
      "gloss": "homework, home studying",
      "glossSv": "läxa",
      "pos": "noun",
      "explanation": "work + knowledge + house: study work done at home [contraction]",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        412,
        "/",
        392
      ]
    },
    {
      "id": 3821,
      "bciAvId": 23534,
      "gloss": "hope",
      "glossSv": "hopp",
      "pos": "noun",
      "explanation": "happy + future (uncertain)",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678,
        "/",
        1042
      ]
    },
    {
      "id": 3822,
      "bciAvId": 23535,
      "gloss": "hopeful",
      "glossSv": "hoppfull",
      "pos": "description",
      "explanation": "hope + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        678,
        "/",
        1042
      ]
    },
    {
      "id": 3823,
      "bciAvId": 23536,
      "gloss": "house work, housekeeping, housework",
      "glossSv": "hushållsarbete, hemarbete",
      "pos": "noun",
      "explanation": "work + house: work to maintain a house",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        392
      ]
    },
    {
      "id": 3824,
      "bciAvId": 23537,
      "gloss": "to hunt",
      "glossSv": "jaga, skjuta",
      "pos": "action",
      "explanation": "hunt,hunting + action indicator",
      "isCharacter": false,
      "composition": [
        369,
        ";",
        81,
        "/",
        122
      ]
    },
    {
      "id": 3825,
      "bciAvId": 23538,
      "gloss": "import",
      "glossSv": "import",
      "pos": "noun",
      "explanation": "into + contents",
      "isCharacter": false,
      "composition": [
        402,
        "/",
        356
      ]
    },
    {
      "id": 3826,
      "bciAvId": 23539,
      "gloss": "to import",
      "glossSv": "importera",
      "pos": "action",
      "explanation": "import + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        356
      ]
    },
    {
      "id": 3827,
      "bciAvId": 23540,
      "gloss": "to import (computer)",
      "glossSv": "importera (dator)",
      "pos": "action",
      "explanation": "into + data (digital information) + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        835,
        "/",
        829
      ]
    },
    {
      "id": 3828,
      "bciAvId": 23541,
      "gloss": "imported",
      "glossSv": "importerad",
      "pos": "description",
      "explanation": "import + description indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        86,
        "/",
        356
      ]
    },
    {
      "id": 3829,
      "bciAvId": 23543,
      "gloss": "internet (1)",
      "glossSv": "internet (1)",
      "pos": "noun",
      "explanation": "net + digital world",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        1026
      ]
    },
    {
      "id": 3830,
      "bciAvId": 23544,
      "gloss": "internet (2)",
      "glossSv": "internet (2)",
      "pos": "noun",
      "explanation": "exchange + digital world",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        1026
      ]
    },
    {
      "id": 3831,
      "bciAvId": 23545,
      "gloss": "intranet (1)",
      "glossSv": "intranet (1)",
      "pos": "noun",
      "explanation": "net + digital space (limited)",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        1025
      ]
    },
    {
      "id": 3832,
      "bciAvId": 23546,
      "gloss": "intranet (2)",
      "glossSv": "intranet (2)",
      "pos": "noun",
      "explanation": "exchange + digital space (limited)",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        1025
      ]
    },
    {
      "id": 3833,
      "bciAvId": 23547,
      "gloss": "to introduce, to present",
      "glossSv": "presentera",
      "pos": "action",
      "explanation": "to say + name + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        464
      ]
    },
    {
      "id": 3834,
      "bciAvId": 23548,
      "gloss": "journalist",
      "glossSv": "journalist",
      "pos": "person",
      "explanation": "writer + news",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        509,
        "/",
        469
      ]
    },
    {
      "id": 3835,
      "bciAvId": 23549,
      "gloss": "joystick",
      "glossSv": "joystick, styrspak",
      "pos": "noun",
      "explanation": "pointing device + linear thing + thing indicator",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 3836,
      "bciAvId": 23551,
      "gloss": "Kazakhstan",
      "glossSv": "Kazakstan",
      "pos": "noun",
      "explanation": "country + horse",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        391
      ]
    },
    {
      "id": 3837,
      "bciAvId": 23552,
      "gloss": "ketchup",
      "glossSv": "ketchup",
      "pos": "noun",
      "explanation": "tomato sauce + intensity",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        684,
        "/",
        1161,
        "/",
        457,
        "/",
        401
      ]
    },
    {
      "id": 3838,
      "bciAvId": 23553,
      "gloss": "key (computer)",
      "glossSv": "tangent (dator)",
      "pos": "noun",
      "explanation": "part + keyboard",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc"
      ]
    },
    {
      "id": 3839,
      "bciAvId": 23554,
      "gloss": "key guard",
      "glossSv": "tangentbordsöverlägg, raster (dator)",
      "pos": "noun",
      "explanation": "help + keyboard + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc"
      ]
    },
    {
      "id": 3840,
      "bciAvId": 23555,
      "gloss": "keyboard (computer)",
      "glossSv": "tangentbord (dator)",
      "pos": "noun",
      "explanation": "tool + alphabet",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc"
      ]
    },
    {
      "id": 3841,
      "bciAvId": 23556,
      "gloss": "keyboard (expanded)",
      "glossSv": "tangentbord (förstorat)",
      "pos": "noun",
      "explanation": "keyboard + big",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        936
      ]
    },
    {
      "id": 3842,
      "bciAvId": 23557,
      "gloss": "keyboard (mini)",
      "glossSv": "tangentbord (förminskat)",
      "pos": "noun",
      "explanation": "keyboard + small",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        956
      ]
    },
    {
      "id": 3843,
      "bciAvId": 23558,
      "gloss": "kindergarten, preschool, nursery, play group",
      "glossSv": "förskola",
      "pos": "noun",
      "explanation": "house + child",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        220
      ]
    },
    {
      "id": 3844,
      "bciAvId": 23559,
      "gloss": "king",
      "glossSv": "kung",
      "pos": "person",
      "explanation": "man + crown",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        798
      ]
    },
    {
      "id": 3845,
      "bciAvId": 23560,
      "gloss": "landscape design",
      "glossSv": "landskapsarkitektur",
      "pos": "noun",
      "explanation": "design + garden",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        344
      ]
    },
    {
      "id": 3846,
      "bciAvId": 23561,
      "gloss": "landscape designer",
      "glossSv": "landskapsarkitekt",
      "pos": "person",
      "explanation": "designer + garden",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        344
      ]
    },
    {
      "id": 3847,
      "bciAvId": 23562,
      "gloss": "laptop",
      "glossSv": "dator (bärbar), laptop",
      "pos": "noun",
      "explanation": "computer + to carry",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829,
        "/",
        917
      ]
    },
    {
      "id": 3848,
      "bciAvId": 23563,
      "gloss": "to lay the table",
      "glossSv": "duka",
      "pos": "action",
      "explanation": "tabletop + glassware + action indicator",
      "isCharacter": false,
      "composition": [
        848,
        ";",
        81,
        "/",
        348,
        "/",
        352
      ]
    },
    {
      "id": 3849,
      "bciAvId": 23564,
      "gloss": "lecture",
      "glossSv": "föreläsning",
      "pos": "noun",
      "explanation": "to speak + knowledge + limited time",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        412,
        "/",
        426
      ]
    },
    {
      "id": 3850,
      "bciAvId": 23565,
      "gloss": "to lecture",
      "glossSv": "föreläsa",
      "pos": "action",
      "explanation": "lecture + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        412,
        "/",
        426
      ]
    },
    {
      "id": 3851,
      "bciAvId": 23566,
      "gloss": "leprechaun",
      "glossSv": "leprechaun (Irland)",
      "pos": "person",
      "explanation": "little person + shamrock",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        586
      ]
    },
    {
      "id": 3852,
      "bciAvId": 23567,
      "gloss": "lesson, lecture, class",
      "glossSv": "lektion",
      "pos": "noun",
      "explanation": "limited time + to learn [contraction]",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        412
      ]
    },
    {
      "id": 3853,
      "bciAvId": 23568,
      "gloss": "librarian",
      "glossSv": "bibliotekarie",
      "pos": "person",
      "explanation": "person + library",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        392,
        "/",
        173
      ]
    },
    {
      "id": 3854,
      "bciAvId": 23569,
      "gloss": "light switch",
      "glossSv": "kontakt, strömbrytare",
      "pos": "noun",
      "explanation": "tool + cause + light",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        206,
        "/",
        424
      ]
    },
    {
      "id": 3855,
      "bciAvId": 23570,
      "gloss": "little person",
      "glossSv": "pyssling, vätte (etc)",
      "pos": "person",
      "explanation": "make-believe person + little",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956
      ]
    },
    {
      "id": 3856,
      "bciAvId": 23571,
      "gloss": "lotto, bingo (etc)",
      "glossSv": "lotto, bingo (etc)",
      "pos": "noun",
      "explanation": "play [contraction] + card + number",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        824,
        "/",
        478
      ]
    },
    {
      "id": 3857,
      "bciAvId": 23572,
      "gloss": "lumberjack",
      "glossSv": "skogsarbetare",
      "pos": "person",
      "explanation": "person + to cut + tree",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        411,
        "/",
        666
      ]
    },
    {
      "id": 3858,
      "bciAvId": 23573,
      "gloss": "lunch box",
      "glossSv": "matlåda",
      "pos": "noun",
      "explanation": "bag + food: Use appropriate classifier.",
      "isCharacter": false,
      "composition": [
        147,
        "/",
        329
      ]
    },
    {
      "id": 3859,
      "bciAvId": 23574,
      "gloss": "magician",
      "glossSv": "trollkonstnär, magiker",
      "pos": "person",
      "explanation": "person + to cause + mystery",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        206,
        "/",
        746
      ]
    },
    {
      "id": 3860,
      "bciAvId": 23575,
      "gloss": "to make the bed",
      "glossSv": "bädda",
      "pos": "action",
      "explanation": "to cover + bed + action indicator",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        81,
        "/",
        156
      ]
    },
    {
      "id": 3861,
      "bciAvId": 23578,
      "gloss": "make-believe person (in forest)",
      "glossSv": "övernaturligt väsen (i skogen)",
      "pos": "person",
      "explanation": "make-believe person + tree",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        666
      ]
    },
    {
      "id": 3862,
      "bciAvId": 23579,
      "gloss": "make-believe person (in water), water nymph",
      "glossSv": "övernaturligt väsen (i vatten)",
      "pos": "person",
      "explanation": "make-believe person + water",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        695
      ]
    },
    {
      "id": 3863,
      "bciAvId": 23580,
      "gloss": "make-believe person (under ground)",
      "glossSv": "övernaturligt väsen (under jord)",
      "pos": "person",
      "explanation": "make-believe person + under (ground level)",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        1102
      ]
    },
    {
      "id": 3864,
      "bciAvId": 23582,
      "gloss": "man doll (e.g. Ken)",
      "glossSv": "docka (manlig) (t ex Ken)",
      "pos": "noun",
      "explanation": "man + man-made",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        840
      ]
    },
    {
      "id": 3865,
      "bciAvId": 23584,
      "gloss": "matching game",
      "glossSv": "matchningsspel",
      "pos": "noun",
      "explanation": "play [contraction] + same",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        578
      ]
    },
    {
      "id": 3866,
      "bciAvId": 23585,
      "gloss": "math, mathematics (class) (2)",
      "glossSv": "matte, matematik (skolämne) (2)",
      "pos": "noun",
      "explanation": "subject [contraction] + mathematics",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        439
      ]
    },
    {
      "id": 3867,
      "bciAvId": 23586,
      "gloss": "meat sauce",
      "glossSv": "köttfärssås",
      "pos": "noun",
      "explanation": "sauce + animal + lump(s): combination of sauce and minced meat",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        122,
        "/",
        777
      ]
    },
    {
      "id": 3868,
      "bciAvId": 23587,
      "gloss": "mechanic, technician",
      "glossSv": "mekaniker, tekniker",
      "pos": "person",
      "explanation": "person + machine",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        432
      ]
    },
    {
      "id": 3869,
      "bciAvId": 23588,
      "gloss": "mechanical engineer",
      "glossSv": "maskiningenjör",
      "pos": "person",
      "explanation": "designer + machine",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        532,
        "/",
        432
      ]
    },
    {
      "id": 3870,
      "bciAvId": 23590,
      "gloss": "mermaid",
      "glossSv": "sjöjungfru",
      "pos": "person",
      "explanation": "make-believe woman + fish: imaginary woman having a tail of a fish",
      "isCharacter": false,
      "composition": [
        839,
        "/",
        321
      ]
    },
    {
      "id": 3871,
      "bciAvId": 23591,
      "gloss": "meat (minced), minced meat, ground meat",
      "glossSv": "köttfärs",
      "pos": "noun",
      "explanation": "meat + bits",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        777
      ]
    },
    {
      "id": 3872,
      "bciAvId": 23592,
      "gloss": "mobile phone, cellphone",
      "glossSv": "mobiltelefon",
      "pos": "noun",
      "explanation": "telephone + to carry",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288,
        "/",
        917
      ]
    },
    {
      "id": 3873,
      "bciAvId": 23593,
      "gloss": "mouse, pointing device",
      "glossSv": "mus (dator), pekdon",
      "pos": "noun",
      "explanation": "tool + pointer",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844
      ]
    },
    {
      "id": 3874,
      "bciAvId": 23594,
      "gloss": "musical",
      "glossSv": "musikal",
      "pos": "noun",
      "explanation": "play + music [contraction]",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 3875,
      "bciAvId": 23595,
      "gloss": "net",
      "glossSv": "nät, fångstnät",
      "pos": "noun",
      "explanation": "net + to catch",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        374,
        "/",
        920
      ]
    },
    {
      "id": 3876,
      "bciAvId": 23596,
      "gloss": "noisemaker, musical toy",
      "glossSv": "ljudleksak",
      "pos": "noun",
      "explanation": "toy [contraction] + sound",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313,
        "/",
        608
      ]
    },
    {
      "id": 3877,
      "bciAvId": 23597,
      "gloss": "opera",
      "glossSv": "opera",
      "pos": "noun",
      "explanation": "play + music [contraction] + up and down: play and music portraying conflicting emotions and upsetting events",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457,
        "/",
        462,
        "/",
        723
      ]
    },
    {
      "id": 3878,
      "bciAvId": 23598,
      "gloss": "optician",
      "glossSv": "optiker",
      "pos": "person",
      "explanation": "person + glasses",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        353
      ]
    },
    {
      "id": 3879,
      "bciAvId": 23600,
      "gloss": "overlay",
      "glossSv": "överlägg",
      "pos": "noun",
      "explanation": "paper + on",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        482
      ]
    },
    {
      "id": 3880,
      "bciAvId": 23601,
      "gloss": "overlay keyboard, membrane keyboard",
      "glossSv": "styrplatta, membrantangentbord",
      "pos": "noun",
      "explanation": "keyboard + plan",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        532
      ]
    },
    {
      "id": 3881,
      "bciAvId": 23602,
      "gloss": "palmtop, PDA",
      "glossSv": "handdator",
      "pos": "noun",
      "explanation": "tablet + little",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829,
        "/",
        374,
        "/",
        956
      ]
    },
    {
      "id": 3882,
      "bciAvId": 23604,
      "gloss": "paper money, bill",
      "glossSv": "sedel",
      "pos": "noun",
      "explanation": "money + paper",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        451
      ]
    },
    {
      "id": 3883,
      "bciAvId": 23605,
      "gloss": "passenger",
      "glossSv": "passagerare",
      "pos": "noun",
      "explanation": "person + to ride",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1077
      ]
    },
    {
      "id": 3884,
      "bciAvId": 23606,
      "gloss": "educationalist, educationist (academic)",
      "glossSv": "pedagog (forskare), didaktiker",
      "pos": "person",
      "explanation": "person + education,didactics,pedagogy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 3885,
      "bciAvId": 23607,
      "gloss": "education, didactics, pedagogy",
      "glossSv": "pedagogik, didaktik",
      "pos": "noun",
      "explanation": "body of learning + to exchange + knowledge",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 3886,
      "bciAvId": 23608,
      "gloss": "Pegasus",
      "glossSv": "Pegasus",
      "pos": "noun",
      "explanation": "horse + wings",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        708
      ]
    },
    {
      "id": 3887,
      "bciAvId": 23609,
      "gloss": "to perform",
      "glossSv": "uppföra, uppträda",
      "pos": "action",
      "explanation": "performance + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        392,
        "/",
        303
      ]
    },
    {
      "id": 3888,
      "bciAvId": 23610,
      "gloss": "performance, show",
      "glossSv": "föreställning, show",
      "pos": "noun",
      "explanation": "action + showplace",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        392,
        "/",
        303
      ]
    },
    {
      "id": 3889,
      "bciAvId": 23611,
      "gloss": "pharmacist",
      "glossSv": "apotekare, farmaceut",
      "pos": "person",
      "explanation": "person + medicine",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        216,
        "/",
        958
      ]
    },
    {
      "id": 3890,
      "bciAvId": 23612,
      "gloss": "philosopher",
      "glossSv": "filosof",
      "pos": "person",
      "explanation": "person + causality",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        826
      ]
    },
    {
      "id": 3891,
      "bciAvId": 23613,
      "gloss": "philosopher (academic)",
      "glossSv": "filosof (akademiker)",
      "pos": "person",
      "explanation": "person + philosophy",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        826
      ]
    },
    {
      "id": 3892,
      "bciAvId": 23614,
      "gloss": "philosophy",
      "glossSv": "filosofi",
      "pos": "noun",
      "explanation": "body of learning + causality",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        826
      ]
    },
    {
      "id": 3893,
      "bciAvId": 23615,
      "gloss": "philosophy (class)",
      "glossSv": "filosofi (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + causality",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        826
      ]
    },
    {
      "id": 3894,
      "bciAvId": 23616,
      "gloss": "pirate",
      "glossSv": "sjörövare, pirat",
      "pos": "person",
      "explanation": "sailor + receiving + negative + intensity: sailor + to rob [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        170,
        "/",
        920,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3895,
      "bciAvId": 23617,
      "gloss": "play (theater)",
      "glossSv": "skådespel",
      "pos": "noun",
      "explanation": "action + story",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457
      ]
    },
    {
      "id": 3896,
      "bciAvId": 23618,
      "gloss": "play, game (in combinations)",
      "glossSv": "lek, spel (i kombinationer)",
      "pos": "noun",
      "explanation": "activity + feeling: contraction of play,recreation: Used in conjunction with a specifier.",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 3897,
      "bciAvId": 23620,
      "gloss": "porcupine",
      "glossSv": "piggsvin",
      "pos": "noun",
      "explanation": "hedgehog + teeth: combination of hedgehog and rodent",
      "isCharacter": false,
      "composition": [
        834,
        "/",
        644
      ]
    },
    {
      "id": 3898,
      "bciAvId": 23621,
      "gloss": "porridge",
      "glossSv": "gröt, pudding",
      "pos": "noun",
      "explanation": "pudding,cream + grain,cereal",
      "isCharacter": false,
      "composition": [
        776,
        "/",
        357
      ]
    },
    {
      "id": 3899,
      "bciAvId": 23622,
      "gloss": "prince",
      "glossSv": "prins",
      "pos": "person",
      "explanation": "boy + crown",
      "isCharacter": false,
      "composition": [
        178,
        "/",
        798
      ]
    },
    {
      "id": 3900,
      "bciAvId": 23623,
      "gloss": "princess",
      "glossSv": "prinsessa",
      "pos": "person",
      "explanation": "girl + crown",
      "isCharacter": false,
      "composition": [
        351,
        "/",
        798
      ]
    },
    {
      "id": 3901,
      "bciAvId": 23624,
      "gloss": "to print",
      "glossSv": "skriva ut (från skrivare)",
      "pos": "action",
      "explanation": "machine + to write + action indicator",
      "isCharacter": false,
      "composition": [
        432,
        ";",
        81,
        "/",
        509
      ]
    },
    {
      "id": 3902,
      "bciAvId": 23625,
      "gloss": "Pterosaur, Pterodactyl",
      "glossSv": "Pterosaurie, flygödla",
      "pos": "noun",
      "explanation": "dinosaur + wings",
      "isCharacter": false,
      "composition": [
        830,
        "/",
        708
      ]
    },
    {
      "id": 3903,
      "bciAvId": 23626,
      "gloss": "queen",
      "glossSv": "drottning",
      "pos": "person",
      "explanation": "woman + crown",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        798
      ]
    },
    {
      "id": 3904,
      "bciAvId": 23628,
      "gloss": "railway track",
      "glossSv": "järnvägsspår, räls",
      "pos": "noun",
      "explanation": "track + train",
      "isCharacter": false,
      "composition": [
        849,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 3905,
      "bciAvId": 23630,
      "gloss": "to redo",
      "glossSv": "göra om",
      "pos": "action",
      "explanation": "to add + action + before,in front of,prior to + action indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        81,
        "/",
        106,
        "/",
        158
      ]
    },
    {
      "id": 3906,
      "bciAvId": 23631,
      "gloss": "to redo (computer)",
      "glossSv": "göra om (dator)",
      "pos": "action",
      "explanation": "jump + digits (computer) + action indicator",
      "isCharacter": false,
      "composition": [
        836,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 3907,
      "bciAvId": 23632,
      "gloss": "refrigerator, fridge",
      "glossSv": "kylskåp",
      "pos": "noun",
      "explanation": "cupboard + cold",
      "isCharacter": false,
      "composition": [
        252,
        "/",
        1007
      ]
    },
    {
      "id": 3908,
      "bciAvId": 23634,
      "gloss": "to remember, to recall",
      "glossSv": "komma ihåg, minnas",
      "pos": "action",
      "explanation": "memory + action indicator",
      "isCharacter": false,
      "composition": [
        841,
        ";",
        81
      ]
    },
    {
      "id": 3909,
      "bciAvId": 23635,
      "gloss": "research",
      "glossSv": "forskning",
      "pos": "noun",
      "explanation": "activity + science",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        826,
        "/",
        299
      ]
    },
    {
      "id": 3910,
      "bciAvId": 23636,
      "gloss": "rice pudding, rice porridge",
      "glossSv": "risgrynsgröt, risgrynspudding",
      "pos": "noun",
      "explanation": "pudding + rice",
      "isCharacter": false,
      "composition": [
        776,
        "/",
        "RK:-2",
        "/",
        565
      ]
    },
    {
      "id": 3911,
      "bciAvId": 23637,
      "gloss": "to rob",
      "glossSv": "råna",
      "pos": "action",
      "explanation": "to steal + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        920,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3912,
      "bciAvId": 23638,
      "gloss": "robber",
      "glossSv": "rånare",
      "pos": "person",
      "explanation": "person + to rob [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3913,
      "bciAvId": 23639,
      "gloss": "robot doll",
      "glossSv": "robotdocka",
      "pos": "noun",
      "explanation": "machine + person + man-made",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        513,
        "/",
        840
      ]
    },
    {
      "id": 3914,
      "bciAvId": 23640,
      "gloss": "to roll",
      "glossSv": "rulla",
      "pos": "action",
      "explanation": "rotation + ground + action indicator",
      "isCharacter": false,
      "composition": [
        887,
        ";",
        81,
        "/",
        281
      ]
    },
    {
      "id": 3915,
      "bciAvId": 23641,
      "gloss": "dilapidated, ruined (building) (2)",
      "glossSv": "ruin (2)",
      "pos": "noun",
      "explanation": "building + destroyed",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        939
      ]
    },
    {
      "id": 3916,
      "bciAvId": 23642,
      "gloss": "Russia",
      "glossSv": "Ryssland",
      "pos": "noun",
      "explanation": "country + bear's head: the country of the bear",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        925
      ]
    },
    {
      "id": 3917,
      "bciAvId": 23643,
      "gloss": "samosa, pirogue",
      "glossSv": "pirog",
      "pos": "noun",
      "explanation": "bread + filled",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        947
      ]
    },
    {
      "id": 3918,
      "bciAvId": 23644,
      "gloss": "sand play",
      "glossSv": "sandlek",
      "pos": "noun",
      "explanation": "play [contraction] + sand",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 3919,
      "bciAvId": 23645,
      "gloss": "sand toy",
      "glossSv": "sandleksak",
      "pos": "noun",
      "explanation": "toy [contraction] + sand",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 3920,
      "bciAvId": 23646,
      "gloss": "Sandman",
      "glossSv": "John Blund",
      "pos": "person",
      "explanation": "make-believe man + to sleep: make-believe man who puts one to sleep",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        599
      ]
    },
    {
      "id": 3921,
      "bciAvId": 23647,
      "gloss": "Santa Claus, Father Christmas",
      "glossSv": "jultomte, jultomten",
      "pos": "person",
      "explanation": "man + beard + evergreen tree",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        155,
        "/",
        300
      ]
    },
    {
      "id": 3922,
      "bciAvId": 23648,
      "gloss": "to save (computer)",
      "glossSv": "spara (dator)",
      "pos": "action",
      "explanation": "file,data file (digital) + future: combination of to keep and file + action indicator",
      "isCharacter": false,
      "composition": [
        832,
        ";",
        81,
        "/",
        341
      ]
    },
    {
      "id": 3923,
      "bciAvId": 23649,
      "gloss": "to save as (computer)",
      "glossSv": "spara som (dator)",
      "pos": "action",
      "explanation": "save (computer)-(to) + name + action indicator",
      "isCharacter": false,
      "composition": [
        832,
        ";",
        81,
        "/",
        341,
        "/",
        464
      ]
    },
    {
      "id": 3924,
      "bciAvId": 23650,
      "gloss": "schoolbag",
      "glossSv": "skolväska",
      "pos": "noun",
      "explanation": "bag + book: Use appropriate classifier.",
      "isCharacter": false,
      "composition": [
        147,
        "/",
        173
      ]
    },
    {
      "id": 3925,
      "bciAvId": 23651,
      "gloss": "science",
      "glossSv": "vetenskap",
      "pos": "noun",
      "explanation": "causality + event: to research the cause of events",
      "isCharacter": false,
      "composition": [
        826,
        "/",
        299
      ]
    },
    {
      "id": 3926,
      "bciAvId": 23652,
      "gloss": "scientist, researcher",
      "glossSv": "forskare, vetenskapsman",
      "pos": "person",
      "explanation": "person + science",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        826,
        "/",
        299
      ]
    },
    {
      "id": 3927,
      "bciAvId": 23653,
      "gloss": "sea anemone",
      "glossSv": "havsanemon, sjöanemon",
      "pos": "noun",
      "explanation": "water creature + flower: water creature looking similar to a flower",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        325
      ]
    },
    {
      "id": 3928,
      "bciAvId": 23654,
      "gloss": "sea cucumber",
      "glossSv": "sjögurka",
      "pos": "noun",
      "explanation": "water creature + oval shape",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        842
      ]
    },
    {
      "id": 3929,
      "bciAvId": 23655,
      "gloss": "sea lion",
      "glossSv": "sjölejon",
      "pos": "noun",
      "explanation": "water mammal (with tail) + to shout",
      "isCharacter": false,
      "composition": [
        268,
        "/",
        457,
        "/",
        401
      ]
    },
    {
      "id": 3930,
      "bciAvId": 23656,
      "gloss": "sea urchin",
      "glossSv": "sjöborre",
      "pos": "noun",
      "explanation": "water creature + quills",
      "isCharacter": false,
      "composition": [
        851,
        "/",
        "RK:-2",
        "/",
        845
      ]
    },
    {
      "id": 3931,
      "bciAvId": 23657,
      "gloss": "seal",
      "glossSv": "säl",
      "pos": "noun",
      "explanation": "water mammal (with tail) + fur",
      "isCharacter": false,
      "composition": [
        268,
        "/",
        "RK:-2",
        "/",
        371
      ]
    },
    {
      "id": 3932,
      "bciAvId": 23659,
      "gloss": "to select all, to mark all",
      "glossSv": "markera allt",
      "pos": "action",
      "explanation": "to select + all + action indicator",
      "isCharacter": false,
      "composition": [
        223,
        ";",
        81,
        "/",
        117
      ]
    },
    {
      "id": 3933,
      "bciAvId": 23660,
      "gloss": "shellfish",
      "glossSv": "skaldjur",
      "pos": "noun",
      "explanation": "generalization + clam",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        494
      ]
    },
    {
      "id": 3934,
      "bciAvId": 23661,
      "gloss": "shepherd",
      "glossSv": "herde",
      "pos": "person",
      "explanation": "person + sheep",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 3935,
      "bciAvId": 23662,
      "gloss": "to shoot",
      "glossSv": "skjuta",
      "pos": "action",
      "explanation": "gun + action indicator",
      "isCharacter": false,
      "composition": [
        369,
        ";",
        81
      ]
    },
    {
      "id": 3936,
      "bciAvId": 23663,
      "gloss": "siren of the woods",
      "glossSv": "skogsrå, huldra",
      "pos": "person",
      "explanation": "make-believe woman + tree",
      "isCharacter": false,
      "composition": [
        839,
        "/",
        666
      ]
    },
    {
      "id": 3937,
      "bciAvId": 23664,
      "gloss": "software, computer program, application, app",
      "glossSv": "dataprogram, program (dator), applikation, app",
      "pos": "noun",
      "explanation": "plan + digits (computer)",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829
      ]
    },
    {
      "id": 3938,
      "bciAvId": 23665,
      "gloss": "to spell",
      "glossSv": "stava",
      "pos": "action",
      "explanation": "alphabet + action indicator",
      "isCharacter": false,
      "composition": [
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        "RK:-7",
        "/",
        81,
        "/",
        "RK:3"
      ]
    },
    {
      "id": 3939,
      "bciAvId": 23666,
      "gloss": "sport elf",
      "glossSv": "sportälva, sportalf",
      "pos": "person",
      "explanation": "little person + sport",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        956,
        "/",
        719
      ]
    },
    {
      "id": 3940,
      "bciAvId": 23667,
      "gloss": "to steal",
      "glossSv": "stjäla",
      "pos": "action",
      "explanation": "to take + negative + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        920,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 3941,
      "bciAvId": 23668,
      "gloss": "stew",
      "glossSv": "köttgryta",
      "pos": "noun",
      "explanation": "sauce + animal + part: combination of sauce and diced meat",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        122,
        "/",
        502
      ]
    },
    {
      "id": 3942,
      "bciAvId": 23669,
      "gloss": "subject (of study)",
      "glossSv": "ämneskunskap, ämne",
      "pos": "noun",
      "explanation": "part of + knowledge",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        412
      ]
    },
    {
      "id": 3943,
      "bciAvId": 23670,
      "gloss": "switch",
      "glossSv": "kontakt",
      "pos": "noun",
      "explanation": "tool + cause + action",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        206,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 3944,
      "bciAvId": 23671,
      "gloss": "swordfish",
      "glossSv": "svärdfisk",
      "pos": "noun",
      "explanation": "fish + sword",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        411
      ]
    },
    {
      "id": 3945,
      "bciAvId": 23672,
      "gloss": "tablet computer, tablet, tablet PC (2)",
      "glossSv": "datorplatta, pekdator (2)",
      "pos": "noun",
      "explanation": "computer + hand",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829,
        "/",
        374
      ]
    },
    {
      "id": 3946,
      "bciAvId": 23674,
      "gloss": "tailor, dressmaker, seamstress",
      "glossSv": "skräddare, sömmerska",
      "pos": "person",
      "explanation": "person + to make + clothes",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        840,
        "/",
        229
      ]
    },
    {
      "id": 3947,
      "bciAvId": 23675,
      "gloss": "teacher, pedagogue, educator",
      "glossSv": "lärare, pedagog",
      "pos": "person",
      "explanation": "person + to exchange + knowledge",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 3948,
      "bciAvId": 23676,
      "gloss": "teacher, pedagogue, educator (in combinations)",
      "glossSv": "lärare, pedagog (i kombinationer)",
      "pos": "person",
      "explanation": "person + knowledge: person + to teach [contraction]: Used in conjunction with a specifier.",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412
      ]
    },
    {
      "id": 3949,
      "bciAvId": 23677,
      "gloss": "telephone card",
      "glossSv": "telefonkort",
      "pos": "noun",
      "explanation": "card + telephone",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 3950,
      "bciAvId": 23678,
      "gloss": "temporary home",
      "glossSv": "korttidshem",
      "pos": "noun",
      "explanation": "home + limited time",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        313,
        "/",
        426
      ]
    },
    {
      "id": 3951,
      "bciAvId": 23679,
      "gloss": "text phone",
      "glossSv": "texttelefon",
      "pos": "noun",
      "explanation": "telephone + alphabet",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288,
        "/",
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc"
      ]
    },
    {
      "id": 3952,
      "bciAvId": 23680,
      "gloss": "theologian, theologist",
      "glossSv": "teolog",
      "pos": "person",
      "explanation": "person + theology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        725
      ]
    },
    {
      "id": 3953,
      "bciAvId": 23681,
      "gloss": "theology, philosophy of religion",
      "glossSv": "teologi",
      "pos": "noun",
      "explanation": "body of learning + God-based religion: system of religious beliefs and theories",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        725
      ]
    },
    {
      "id": 3954,
      "bciAvId": 23682,
      "gloss": "therapy centre, rehabilitation centre",
      "glossSv": "rehabiliteringscenter, habiliteringscenter",
      "pos": "noun",
      "explanation": "building + therapy",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        750
      ]
    },
    {
      "id": 3955,
      "bciAvId": 23683,
      "gloss": "thief",
      "glossSv": "tjuv",
      "pos": "person",
      "explanation": "person + receiving + negative: person + to steal [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 3956,
      "bciAvId": 23684,
      "gloss": "Tibet",
      "glossSv": "Tibet",
      "pos": "noun",
      "explanation": "country + dharma wheel",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        827
      ]
    },
    {
      "id": 3957,
      "bciAvId": 23685,
      "gloss": "tomato sauce",
      "glossSv": "tomatsås, tomatpuré",
      "pos": "noun",
      "explanation": "sauce + tomato",
      "isCharacter": false,
      "composition": [
        722,
        "/",
        684,
        "/",
        1161,
        "/",
        457
      ]
    },
    {
      "id": 3958,
      "bciAvId": 23686,
      "gloss": "tooth fairy",
      "glossSv": "tandfe",
      "pos": "person",
      "explanation": "fairy + teeth",
      "isCharacter": false,
      "composition": [
        839,
        "/",
        692,
        "/",
        644
      ]
    },
    {
      "id": 3959,
      "bciAvId": 23687,
      "gloss": "touch screen",
      "glossSv": "pekskärm",
      "pos": "noun",
      "explanation": "computer screen,monitor + hand",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        303,
        "/",
        829,
        "/",
        374
      ]
    },
    {
      "id": 3960,
      "bciAvId": 23688,
      "gloss": "touchpad, trackpad",
      "glossSv": "styrplatta (pekdon)",
      "pos": "noun",
      "explanation": "pointing device + finger",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844,
        "/",
        318
      ]
    },
    {
      "id": 3961,
      "bciAvId": 23689,
      "gloss": "toy (in combinations)",
      "glossSv": "leksak (i kombinationer)",
      "pos": "noun",
      "explanation": "thing + feeling: thing + play [contraction]: Used in conjunction with a specifier.",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313
      ]
    },
    {
      "id": 3962,
      "bciAvId": 23691,
      "gloss": "trackball",
      "glossSv": "styrkula, rullboll",
      "pos": "noun",
      "explanation": "pointing device + ball",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        844,
        "/",
        148
      ]
    },
    {
      "id": 3963,
      "bciAvId": 23692,
      "gloss": "tragedy",
      "glossSv": "tragedi",
      "pos": "noun",
      "explanation": "play (theater) + down: play (theater) + sad [contraction]",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        457,
        "/",
        271
      ]
    },
    {
      "id": 3964,
      "bciAvId": 23693,
      "gloss": "traveller",
      "glossSv": "resenär",
      "pos": "person",
      "explanation": "person + travel",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        667
      ]
    },
    {
      "id": 3965,
      "bciAvId": 23694,
      "gloss": "Triceratops",
      "glossSv": "Triceratops",
      "pos": "noun",
      "explanation": "dinosaur + three + horn",
      "isCharacter": false,
      "composition": [
        830,
        "/",
        12,
        "/",
        737
      ]
    },
    {
      "id": 3966,
      "bciAvId": 23695,
      "gloss": "troll",
      "glossSv": "troll",
      "pos": "person",
      "explanation": "make-believe person + stone: trolls turn into stones when the sun rises",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        629
      ]
    },
    {
      "id": 3967,
      "bciAvId": 23696,
      "gloss": "troll (tailed)",
      "glossSv": "troll (med svans)",
      "pos": "person",
      "explanation": "make-believe person + linear thing + buttocks + thing indicator: trolls that have tails",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        428,
        ";",
        97,
        "/",
        194
      ]
    },
    {
      "id": 3968,
      "bciAvId": 23697,
      "gloss": "tuna fish",
      "glossSv": "tonfisk",
      "pos": "noun",
      "explanation": "fish + huge",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        936,
        "/",
        401
      ]
    },
    {
      "id": 3969,
      "bciAvId": 23698,
      "gloss": "to type",
      "glossSv": "skriva (på tangentbord)",
      "pos": "action",
      "explanation": "to write + machine + action indicator",
      "isCharacter": false,
      "composition": [
        509,
        ";",
        81,
        "/",
        432
      ]
    },
    {
      "id": 3970,
      "bciAvId": 23699,
      "gloss": "Tyrannosaurus Rex",
      "glossSv": "Tyrannosaurus Rex",
      "pos": "noun",
      "explanation": "dinosaur + crown: the “King” of dinosaurs",
      "isCharacter": false,
      "composition": [
        830,
        "/",
        798
      ]
    },
    {
      "id": 3971,
      "bciAvId": 23700,
      "gloss": "to undo",
      "glossSv": "ångra, ändra sig",
      "pos": "action",
      "explanation": "to take away + action + in front of + action indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        106,
        "/",
        158
      ]
    },
    {
      "id": 3972,
      "bciAvId": 23701,
      "gloss": "to undo (computer)",
      "glossSv": "ångra (dator)",
      "pos": "action",
      "explanation": "jump (backward) + digits (computer) + action indicator",
      "isCharacter": false,
      "composition": [
        926,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 3973,
      "bciAvId": 23703,
      "gloss": "to wake up",
      "glossSv": "vakna",
      "pos": "action",
      "explanation": "to go + awake + action indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        969
      ]
    },
    {
      "id": 3974,
      "bciAvId": 23704,
      "gloss": "walrus",
      "glossSv": "valross",
      "pos": "noun",
      "explanation": "water creature with tail + teeth",
      "isCharacter": false,
      "composition": [
        268,
        "/",
        644
      ]
    },
    {
      "id": 3975,
      "bciAvId": 23705,
      "gloss": "to wash up, to do the dishes",
      "glossSv": "diska",
      "pos": "action",
      "explanation": "to wash + glassware + action indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        81,
        "/",
        348,
        "/",
        352
      ]
    },
    {
      "id": 3976,
      "bciAvId": 23707,
      "gloss": "water play",
      "glossSv": "vattenlek",
      "pos": "noun",
      "explanation": "play [contraction] + water",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        695
      ]
    },
    {
      "id": 3977,
      "bciAvId": 23708,
      "gloss": "water toy",
      "glossSv": "vattenleksak",
      "pos": "noun",
      "explanation": "toy [contraction] + water",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        313,
        "/",
        695
      ]
    },
    {
      "id": 3978,
      "bciAvId": 23709,
      "gloss": "website, domain name, homepage, internet domain",
      "glossSv": "webbsida",
      "pos": "noun",
      "explanation": "name + place + digital world",
      "isCharacter": false,
      "composition": [
        464,
        "/",
        531,
        "/",
        1026
      ]
    },
    {
      "id": 3979,
      "bciAvId": 23710,
      "gloss": "vegetable(s)",
      "glossSv": "grönsak, grönsaker (allmänt)",
      "pos": "noun",
      "explanation": "generalization + vegetable (above ground)",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        684
      ]
    },
    {
      "id": 3980,
      "bciAvId": 23711,
      "gloss": "virus (computer)",
      "glossSv": "virus (dator)",
      "pos": "noun",
      "explanation": "program + to destroy",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829,
        "/",
        939
      ]
    },
    {
      "id": 3981,
      "bciAvId": 23712,
      "gloss": "witch",
      "glossSv": "häxa",
      "pos": "person",
      "explanation": "make-believe woman + broom",
      "isCharacter": false,
      "composition": [
        839,
        "/",
        183
      ]
    },
    {
      "id": 3982,
      "bciAvId": 23713,
      "gloss": "wizard",
      "glossSv": "trollkarl",
      "pos": "person",
      "explanation": "make-believe man + wand",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        692
      ]
    },
    {
      "id": 3983,
      "bciAvId": 23714,
      "gloss": "woman doll (e.g. Barbie)",
      "glossSv": "docka (kvinnlig) (t ex Barbie)",
      "pos": "noun",
      "explanation": "woman + man-made",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        840
      ]
    },
    {
      "id": 3984,
      "bciAvId": 23715,
      "gloss": "worksheet",
      "glossSv": "arbetsblad",
      "pos": "noun",
      "explanation": "paper + to work",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        711
      ]
    },
    {
      "id": 3985,
      "bciAvId": 23716,
      "gloss": "writer, author",
      "glossSv": "författare",
      "pos": "person",
      "explanation": "person + to write",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        509
      ]
    },
    {
      "id": 3986,
      "bciAvId": 23801,
      "gloss": "accident",
      "glossSv": "olycka, olyckshändelse",
      "pos": "noun",
      "explanation": "event + negative + intensity",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 3987,
      "bciAvId": 23802,
      "gloss": "accordion",
      "glossSv": "dragspel",
      "pos": "noun",
      "explanation": "wind instrument + back and forth",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        144
      ]
    },
    {
      "id": 3988,
      "bciAvId": 23804,
      "gloss": "amplifier (1)",
      "glossSv": "förstärkare (ljud) (1)",
      "pos": "noun",
      "explanation": "machine + more + sound + intensity",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        937,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 3989,
      "bciAvId": 23805,
      "gloss": "amplifier (2)",
      "glossSv": "förstärkare (ljud) (2)",
      "pos": "noun",
      "explanation": "thing + more + sound + intensity",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        937,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 3990,
      "bciAvId": 23806,
      "gloss": "autoharp, zither, kantele",
      "glossSv": "cittra, kantele (etc)",
      "pos": "noun",
      "explanation": "musical instrument + group of + string + table",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        368,
        "/",
        872,
        "/",
        639
      ]
    },
    {
      "id": 3991,
      "bciAvId": 23807,
      "gloss": "bagpipe",
      "glossSv": "säckpipa",
      "pos": "noun",
      "explanation": "wind instrument + bag",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        574
      ]
    },
    {
      "id": 3992,
      "bciAvId": 23808,
      "gloss": "banjo",
      "glossSv": "banjo",
      "pos": "noun",
      "explanation": "string instrument + metal [contraction]",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        872,
        "/",
        814
      ]
    },
    {
      "id": 3993,
      "bciAvId": 23810,
      "gloss": "bass clarinet",
      "glossSv": "basklarinett",
      "pos": "noun",
      "explanation": "clarinet + big",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        869,
        "/",
        936
      ]
    },
    {
      "id": 3994,
      "bciAvId": 23811,
      "gloss": "bass guitar",
      "glossSv": "basgitarr",
      "pos": "noun",
      "explanation": "string instrument + bass",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        872,
        "/",
        853
      ]
    },
    {
      "id": 3995,
      "bciAvId": 23812,
      "gloss": "bassoon (1)",
      "glossSv": "fagott (1)",
      "pos": "noun",
      "explanation": "oboe (1) + big",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        11,
        "/",
        869,
        "/",
        936
      ]
    },
    {
      "id": 3996,
      "bciAvId": 23813,
      "gloss": "bassoon (2)",
      "glossSv": "fagott (2)",
      "pos": "noun",
      "explanation": "oboe (2) + tenor",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        11,
        "/",
        869,
        "/",
        874
      ]
    },
    {
      "id": 3997,
      "bciAvId": 23814,
      "gloss": "bells, chime bars, tubular bells",
      "glossSv": "klockspel",
      "pos": "noun",
      "explanation": "group of + bell,chime bar",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        865,
        "/",
        10,
        "/",
        462
      ]
    },
    {
      "id": 3998,
      "bciAvId": 23815,
      "gloss": "block, city block",
      "glossSv": "kvarter",
      "pos": "noun",
      "explanation": "place + between + street",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        162,
        "/",
        632
      ]
    },
    {
      "id": 3999,
      "bciAvId": 23816,
      "gloss": "bongo drum, hand drum",
      "glossSv": "bongotrumma, handtrumma",
      "pos": "noun",
      "explanation": "musical instrument + hand + to repeat",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        374,
        "/",
        963
      ]
    },
    {
      "id": 4000,
      "bciAvId": 23820,
      "gloss": "bow and string instrument",
      "glossSv": "stråk- och stränginstrument",
      "pos": "noun",
      "explanation": "musical instrument + bow and string",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        856
      ]
    },
    {
      "id": 4001,
      "bciAvId": 23821,
      "gloss": "brake (general)",
      "glossSv": "broms (allmänt)",
      "pos": "noun",
      "explanation": "tool + stop",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        292
      ]
    },
    {
      "id": 4002,
      "bciAvId": 23822,
      "gloss": "brake (vehicle)",
      "glossSv": "broms (på fordon)",
      "pos": "noun",
      "explanation": "tool + stop + to move",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        292,
        "/",
        974
      ]
    },
    {
      "id": 4003,
      "bciAvId": 23823,
      "gloss": "brass instrument",
      "glossSv": "mässingsinstrument",
      "pos": "noun",
      "explanation": "musical instrument + metal [contraction]",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814
      ]
    },
    {
      "id": 4004,
      "bciAvId": 23824,
      "gloss": "breeze",
      "glossSv": "bris",
      "pos": "noun",
      "explanation": "wind + little",
      "isCharacter": false,
      "composition": [
        705,
        "/",
        956
      ]
    },
    {
      "id": 4005,
      "bciAvId": 23825,
      "gloss": "bugle (1)",
      "glossSv": "signalhorn, bygelhorn (etc) (1)",
      "pos": "noun",
      "explanation": "horn + combat",
      "isCharacter": false,
      "composition": [
        389,
        "/",
        693
      ]
    },
    {
      "id": 4006,
      "bciAvId": 23826,
      "gloss": "bugle (2)",
      "glossSv": "signalhorn, bygelhorn (etc) (2)",
      "pos": "noun",
      "explanation": "brass instrument + 0 + disc: horn with no valves",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814,
        "/",
        9,
        "/",
        263
      ]
    },
    {
      "id": 4007,
      "bciAvId": 23827,
      "gloss": "burned out, burnt out",
      "glossSv": "utbränd (om person)",
      "pos": "description",
      "explanation": "sickness + without + energy (mental) + description indicator",
      "isCharacter": false,
      "composition": [
        516,
        ";",
        86,
        "/",
        449,
        "/",
        288,
        "/",
        447
      ]
    },
    {
      "id": 4008,
      "bciAvId": 23828,
      "gloss": "calm, lull",
      "glossSv": "stiltje",
      "pos": "noun",
      "explanation": "without + wind",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        705
      ]
    },
    {
      "id": 4009,
      "bciAvId": 23829,
      "gloss": "calm (weather)",
      "glossSv": "vindstilla",
      "pos": "description",
      "explanation": "calm + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        705,
        ";",
        86
      ]
    },
    {
      "id": 4010,
      "bciAvId": 23830,
      "gloss": "castanets (1)",
      "glossSv": "kastanjett (1)",
      "pos": "noun",
      "explanation": "disc + finger",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        318
      ]
    },
    {
      "id": 4011,
      "bciAvId": 23831,
      "gloss": "castanets (2)",
      "glossSv": "kastanjett (2)",
      "pos": "noun",
      "explanation": "musical instrument + up and down + disc + finger",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        723,
        "/",
        263,
        "/",
        318
      ]
    },
    {
      "id": 4012,
      "bciAvId": 23832,
      "gloss": "CD cover",
      "glossSv": "cd-fodral",
      "pos": "noun",
      "explanation": "protection + CD,record",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        1075,
        "/",
        278
      ]
    },
    {
      "id": 4013,
      "bciAvId": 23834,
      "gloss": "cello",
      "glossSv": "cello",
      "pos": "noun",
      "explanation": "bow and string instrument + tenor",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        856,
        "/",
        874
      ]
    },
    {
      "id": 4014,
      "bciAvId": 23835,
      "gloss": "children's song, nursery rhyme",
      "glossSv": "barnvisa",
      "pos": "noun",
      "explanation": "song + child",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462,
        "/",
        220
      ]
    },
    {
      "id": 4015,
      "bciAvId": 23836,
      "gloss": "chronic fatigue syndrome",
      "glossSv": "kroniskt trötthetssyndrom",
      "pos": "noun",
      "explanation": "sickness + tired + intensity + intensity + intensity",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        562,
        "/",
        467,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4016,
      "bciAvId": 23837,
      "gloss": "clarinet, reed instrument (1)",
      "glossSv": "klarinett, rörbladsinstrument (1)",
      "pos": "noun",
      "explanation": "flute,recorder + reed",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        869
      ]
    },
    {
      "id": 4017,
      "bciAvId": 23838,
      "gloss": "clarinet, reed instrument (2)",
      "glossSv": "klarinett, rörbladsinstrument (2)",
      "pos": "noun",
      "explanation": "musical instrument + reed",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        869
      ]
    },
    {
      "id": 4018,
      "bciAvId": 23840,
      "gloss": "to condense",
      "glossSv": "kondensera",
      "pos": "action",
      "explanation": "condensation + action indicator",
      "isCharacter": false,
      "composition": [
        858,
        ";",
        81
      ]
    },
    {
      "id": 4019,
      "bciAvId": 23841,
      "gloss": "country music",
      "glossSv": "countrymusik",
      "pos": "noun",
      "explanation": "music + countryside",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        244
      ]
    },
    {
      "id": 4020,
      "bciAvId": 23842,
      "gloss": "cymbal",
      "glossSv": "cymbal",
      "pos": "noun",
      "explanation": "musical instrument + disc + together",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        263,
        "/",
        823
      ]
    },
    {
      "id": 4021,
      "bciAvId": 23843,
      "gloss": "dance music",
      "glossSv": "dansmusik",
      "pos": "noun",
      "explanation": "music + legs and feet: music + dance [contraction]",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        418
      ]
    },
    {
      "id": 4022,
      "bciAvId": 23844,
      "gloss": "dark",
      "glossSv": "mörk",
      "pos": "description",
      "explanation": "without + light + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        424,
        ";",
        86
      ]
    },
    {
      "id": 4023,
      "bciAvId": 23845,
      "gloss": "to detest, to despise",
      "glossSv": "avsky (verb)",
      "pos": "action",
      "explanation": "feeling + negative + intensity + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        449,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4024,
      "bciAvId": 23846,
      "gloss": "disaster, catastrophe",
      "glossSv": "katastrof",
      "pos": "noun",
      "explanation": "event + negative + intensity + intensity",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        449,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4025,
      "bciAvId": 23847,
      "gloss": "district, area, neighbourhood, neighborhood (country)",
      "glossSv": "distrikt, bygd, trakt, område",
      "pos": "noun",
      "explanation": "part of + countryside",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        244
      ]
    },
    {
      "id": 4026,
      "bciAvId": 23848,
      "gloss": "district, city district, neighbourhood, neighborhood (town)",
      "glossSv": "stadsdel",
      "pos": "noun",
      "explanation": "part of + city",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        368,
        "/",
        368,
        "/",
        392
      ]
    },
    {
      "id": 4027,
      "bciAvId": 23849,
      "gloss": "double bass, bass fiddle, contrabass",
      "glossSv": "basfiol, kontrabas",
      "pos": "noun",
      "explanation": "bow and string instrument + bass",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        856,
        "/",
        853
      ]
    },
    {
      "id": 4028,
      "bciAvId": 23850,
      "gloss": "contrabassoon, double bassoon (1)",
      "glossSv": "kontrafagott (1)",
      "pos": "noun",
      "explanation": "bassoon (1) + bass",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        11,
        "/",
        869,
        "/",
        936,
        "/",
        853
      ]
    },
    {
      "id": 4029,
      "bciAvId": 23851,
      "gloss": "contrabassoon, double bassoon (2)",
      "glossSv": "kontrafagott (2)",
      "pos": "noun",
      "explanation": "oboe (2) + bass",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        11,
        "/",
        869,
        "/",
        853
      ]
    },
    {
      "id": 4030,
      "bciAvId": 23852,
      "gloss": "dried",
      "glossSv": "torkad",
      "pos": "description",
      "explanation": "dryness + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        860,
        ";",
        84
      ]
    },
    {
      "id": 4031,
      "bciAvId": 23853,
      "gloss": "driving license",
      "glossSv": "körkort",
      "pos": "noun",
      "explanation": "card + activity + vehicle",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        106,
        "/",
        688
      ]
    },
    {
      "id": 4032,
      "bciAvId": 23855,
      "gloss": "drum (2)",
      "glossSv": "trumma (2)",
      "pos": "noun",
      "explanation": "percussion instrument + to repeat",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        373,
        "/",
        963
      ]
    },
    {
      "id": 4033,
      "bciAvId": 23856,
      "gloss": "drumstick",
      "glossSv": "trumpinne, trumstock",
      "pos": "noun",
      "explanation": "linear thing + drum",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        859
      ]
    },
    {
      "id": 4034,
      "bciAvId": 23857,
      "gloss": "dry",
      "glossSv": "torr",
      "pos": "description",
      "explanation": "dryness + description indicator",
      "isCharacter": false,
      "composition": [
        860,
        ";",
        86
      ]
    },
    {
      "id": 4035,
      "bciAvId": 23858,
      "gloss": "to dry",
      "glossSv": "torka",
      "pos": "action",
      "explanation": "dryness + action indicator",
      "isCharacter": false,
      "composition": [
        860,
        ";",
        81
      ]
    },
    {
      "id": 4036,
      "bciAvId": 23860,
      "gloss": "eager, keen, willing",
      "glossSv": "ivrig, pigg på",
      "pos": "description",
      "explanation": "feeling + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 4037,
      "bciAvId": 23861,
      "gloss": "easy, easily",
      "glossSv": "lätt, enkel",
      "pos": "description",
      "explanation": "ease,easiness,simplicity + description indicator",
      "isCharacter": false,
      "composition": [
        943,
        ";",
        86
      ]
    },
    {
      "id": 4038,
      "bciAvId": 23862,
      "gloss": "electric piano",
      "glossSv": "elpiano",
      "pos": "noun",
      "explanation": "musical instrument + keyboard + electricity",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        864,
        "/",
        288
      ]
    },
    {
      "id": 4039,
      "bciAvId": 23863,
      "gloss": "empty",
      "glossSv": "tom",
      "pos": "description",
      "explanation": "emptying,voidance,evacuation + description indicator",
      "isCharacter": false,
      "composition": [
        944,
        ";",
        86
      ]
    },
    {
      "id": 4040,
      "bciAvId": 23864,
      "gloss": "to empty, to evacuate, to throw away, to void",
      "glossSv": "tömma, hälla ut",
      "pos": "action",
      "explanation": "emptying,voidance,evacuation + description indicator",
      "isCharacter": false,
      "composition": [
        944,
        ";",
        81
      ]
    },
    {
      "id": 4041,
      "bciAvId": 23865,
      "gloss": "energy (mental)",
      "glossSv": "energi (mental)",
      "pos": "noun",
      "explanation": "electricity + mind",
      "isCharacter": false,
      "composition": [
        288,
        "/",
        447
      ]
    },
    {
      "id": 4042,
      "bciAvId": 23866,
      "gloss": "energy (physical)",
      "glossSv": "energi (fysisk)",
      "pos": "noun",
      "explanation": "electricity + body",
      "isCharacter": false,
      "composition": [
        288,
        "/",
        171
      ]
    },
    {
      "id": 4043,
      "bciAvId": 23867,
      "gloss": "error, mishap",
      "glossSv": "missöde",
      "pos": "noun",
      "explanation": "event + negative",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4044,
      "bciAvId": 23868,
      "gloss": "exciting, excitingly, excited, excitedly",
      "glossSv": "upphetsad, upphetsande",
      "pos": "description",
      "explanation": "excitement + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4045,
      "bciAvId": 23869,
      "gloss": "excitement",
      "glossSv": "upphetsning",
      "pos": "noun",
      "explanation": "feeling + intensity + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4046,
      "bciAvId": 23870,
      "gloss": "exhausted, worn out",
      "glossSv": "utmattad, utsliten, slutkörd",
      "pos": "description",
      "explanation": "feeling + without + energy (mental) + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        288,
        "/",
        447
      ]
    },
    {
      "id": 4047,
      "bciAvId": 23873,
      "gloss": "flute (alto)",
      "glossSv": "flöjt (alt)",
      "pos": "noun",
      "explanation": "wind instrument + alto",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        852
      ]
    },
    {
      "id": 4048,
      "bciAvId": 23874,
      "gloss": "flute (soprano)",
      "glossSv": "flöjt (sopran)",
      "pos": "noun",
      "explanation": "wind instrument + soprano",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        870
      ]
    },
    {
      "id": 4049,
      "bciAvId": 23875,
      "gloss": "foam, mousse",
      "glossSv": "skum, mousse",
      "pos": "noun",
      "explanation": "many + many + bubble",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        185
      ]
    },
    {
      "id": 4050,
      "bciAvId": 23876,
      "gloss": "French horn, horn (1)",
      "glossSv": "valthorn (1)",
      "pos": "noun",
      "explanation": "horn + to circle: instrument with circularly coiled tubing",
      "isCharacter": false,
      "composition": [
        389,
        "/",
        887
      ]
    },
    {
      "id": 4051,
      "bciAvId": 23877,
      "gloss": "French horn, horn (2)",
      "glossSv": "valthorn (2)",
      "pos": "noun",
      "explanation": "brass instrument + to circle: instrument with circularly coiled tubing",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814,
        "/",
        887
      ]
    },
    {
      "id": 4052,
      "bciAvId": 23878,
      "gloss": "gong",
      "glossSv": "gong-gong",
      "pos": "noun",
      "explanation": "percussion instrument + 1 + musical note",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        373,
        "/",
        10,
        "/",
        462
      ]
    },
    {
      "id": 4053,
      "bciAvId": 23879,
      "gloss": "guitar, string instrument",
      "glossSv": "gitarr, stränginstrument",
      "pos": "noun",
      "explanation": "musical instrument + string",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        872
      ]
    },
    {
      "id": 4054,
      "bciAvId": 23880,
      "gloss": "hair spray",
      "glossSv": "hårspray",
      "pos": "noun",
      "explanation": "spray + hair",
      "isCharacter": false,
      "composition": [
        966,
        "/",
        372
      ]
    },
    {
      "id": 4055,
      "bciAvId": 23881,
      "gloss": "harp",
      "glossSv": "harpa",
      "pos": "noun",
      "explanation": "musical instrument + many + string + finger",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        368,
        "/",
        872,
        "/",
        318
      ]
    },
    {
      "id": 4056,
      "bciAvId": 23882,
      "gloss": "harpsichord",
      "glossSv": "cembalo",
      "pos": "noun",
      "explanation": "musical instrument + hook + string",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        387,
        "/",
        872
      ]
    },
    {
      "id": 4057,
      "bciAvId": 23883,
      "gloss": "to hate",
      "glossSv": "hata",
      "pos": "action",
      "explanation": "hate,hatred + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4058,
      "bciAvId": 23884,
      "gloss": "to hum",
      "glossSv": "nynna",
      "pos": "action",
      "explanation": "to sing + without + word + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        462,
        "/",
        449,
        "/",
        414
      ]
    },
    {
      "id": 4059,
      "bciAvId": 23885,
      "gloss": "humid, damp, moist",
      "glossSv": "fuktig",
      "pos": "description",
      "explanation": "humidity + description indicator",
      "isCharacter": false,
      "composition": [
        863,
        ";",
        86
      ]
    },
    {
      "id": 4060,
      "bciAvId": 23887,
      "gloss": "hurricane, cyclone, typhoon",
      "glossSv": "orkan, tyfon, cyklon",
      "pos": "noun",
      "explanation": "much + storm: i.e., much + much + much + wind",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        368,
        "/",
        705
      ]
    },
    {
      "id": 4061,
      "bciAvId": 23888,
      "gloss": "kazoo",
      "glossSv": "kazoo",
      "pos": "noun",
      "explanation": "musical instrument + sound + mouth: device which modifies the sound of a persons voice",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        608,
        "/",
        457
      ]
    },
    {
      "id": 4062,
      "bciAvId": 23889,
      "gloss": "kebab (Middle East)",
      "glossSv": "kebab (Mellanöstern)",
      "pos": "noun",
      "explanation": "meat + hot + long",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        642,
        "/",
        319,
        "/",
        420
      ]
    },
    {
      "id": 4063,
      "bciAvId": 23890,
      "gloss": "kebab (Scandinavia)",
      "glossSv": "kebab",
      "pos": "noun",
      "explanation": "meat + rotation + to cut",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        887,
        "/",
        411
      ]
    },
    {
      "id": 4064,
      "bciAvId": 23891,
      "gloss": "kebab (UK, NL)",
      "glossSv": "kebab (Storbritannien, Holland)",
      "pos": "noun",
      "explanation": "meat + part of + linear thing",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        502,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 4065,
      "bciAvId": 23893,
      "gloss": "last (person, etc)",
      "glossSv": "sist",
      "pos": "description",
      "explanation": "person + end + description indicator: Person can be replaced by an appropriate other classifier.",
      "isCharacter": false,
      "composition": [
        513,
        ";",
        86,
        "/",
        292
      ]
    },
    {
      "id": 4066,
      "bciAvId": 23894,
      "gloss": "lie",
      "glossSv": "lögn",
      "pos": "noun",
      "explanation": "purpose + without + truth",
      "isCharacter": false,
      "composition": [
        551,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 4067,
      "bciAvId": 23895,
      "gloss": "to lie",
      "glossSv": "ljuga",
      "pos": "action",
      "explanation": "lie + action indicator",
      "isCharacter": false,
      "composition": [
        551,
        ";",
        81,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 4068,
      "bciAvId": 23896,
      "gloss": "line, queue",
      "glossSv": "kö",
      "pos": "noun",
      "explanation": "line + many + person: Person can be replaced by an appropriate other specifier.",
      "isCharacter": false,
      "composition": [
        428,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 4069,
      "bciAvId": 23897,
      "gloss": "to lose (fail to win)",
      "glossSv": "förlora",
      "pos": "action",
      "explanation": "competition + loss + action indicator",
      "isCharacter": false,
      "composition": [
        554,
        ";",
        81,
        "/",
        634
      ]
    },
    {
      "id": 4070,
      "bciAvId": 23898,
      "gloss": "loudspeaker",
      "glossSv": "högtalare",
      "pos": "noun",
      "explanation": "thing + sound + intensity + out",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        608,
        "/",
        401,
        "/",
        491
      ]
    },
    {
      "id": 4071,
      "bciAvId": 23899,
      "gloss": "mandolin",
      "glossSv": "mandolin",
      "pos": "noun",
      "explanation": "string instrument + man + blissymbolics: an instrument associated with Charles Bliss",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        872,
        "/",
        433,
        "/",
        167
      ]
    },
    {
      "id": 4072,
      "bciAvId": 23900,
      "gloss": "maracas, calabash (etc)",
      "glossSv": "maracas (etc)",
      "pos": "noun",
      "explanation": "rhythm instrument + fruit",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        723,
        "/",
        338
      ]
    },
    {
      "id": 4073,
      "bciAvId": 23901,
      "gloss": "melodica, blow-organ",
      "glossSv": "melodika",
      "pos": "noun",
      "explanation": "wind instrument + mouth + keyboard",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        457,
        "/",
        864
      ]
    },
    {
      "id": 4074,
      "bciAvId": 23902,
      "gloss": "microphone",
      "glossSv": "mikrofon",
      "pos": "noun",
      "explanation": "thing + sound + into",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        608,
        "/",
        402
      ]
    },
    {
      "id": 4075,
      "bciAvId": 23903,
      "gloss": "MP3 player, iPod (etc)",
      "glossSv": "MP3-spelare, iPod (etc)",
      "pos": "noun",
      "explanation": "machine + to listen + carry",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        278,
        "/",
        917
      ]
    },
    {
      "id": 4076,
      "bciAvId": 23905,
      "gloss": "musical instrument (with many strings)",
      "glossSv": "stränginstrument",
      "pos": "noun",
      "explanation": "musical instrument + many + string",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        368,
        "/",
        872
      ]
    },
    {
      "id": 4077,
      "bciAvId": 23906,
      "gloss": "never",
      "glossSv": "aldrig",
      "pos": "description",
      "explanation": "without + time + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        655,
        ";",
        86
      ]
    },
    {
      "id": 4078,
      "bciAvId": 23907,
      "gloss": "nothing, none",
      "glossSv": "ingen, ingenting",
      "pos": "expression",
      "explanation": "without + thing",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        651
      ]
    },
    {
      "id": 4079,
      "bciAvId": 23908,
      "gloss": "oboe (1)",
      "glossSv": "oboe (1)",
      "pos": "noun",
      "explanation": "flute,recorder + 2 + reed",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        11,
        "/",
        869
      ]
    },
    {
      "id": 4080,
      "bciAvId": 23909,
      "gloss": "oboe (2)",
      "glossSv": "oboe (2)",
      "pos": "noun",
      "explanation": "musical instrument + 2 + reed",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        11,
        "/",
        869
      ]
    },
    {
      "id": 4081,
      "bciAvId": 23910,
      "gloss": "old",
      "glossSv": "gammal",
      "pos": "description",
      "explanation": "many + year + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        716,
        ";",
        86
      ]
    },
    {
      "id": 4082,
      "bciAvId": 23911,
      "gloss": "organ, pipe organ",
      "glossSv": "orgel, piporgel",
      "pos": "noun",
      "explanation": "wind instrument + many + tube",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        368,
        "/",
        866
      ]
    },
    {
      "id": 4083,
      "bciAvId": 23912,
      "gloss": "panpipe",
      "glossSv": "panflöjt",
      "pos": "noun",
      "explanation": "wood instrument + many + tube",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        666,
        "/",
        368,
        "/",
        866
      ]
    },
    {
      "id": 4084,
      "bciAvId": 23913,
      "gloss": "to park",
      "glossSv": "parkera",
      "pos": "action",
      "explanation": "parking lot + action indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81,
        "/",
        688
      ]
    },
    {
      "id": 4085,
      "bciAvId": 23914,
      "gloss": "parking permit",
      "glossSv": "parkeringstillstånd",
      "pos": "noun",
      "explanation": "card + parking lot",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        531,
        "/",
        688
      ]
    },
    {
      "id": 4086,
      "bciAvId": 23915,
      "gloss": "parking ticket",
      "glossSv": "parkeringsbiljett",
      "pos": "noun",
      "explanation": "paper + parking place",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        531,
        "/",
        688
      ]
    },
    {
      "id": 4087,
      "bciAvId": 23916,
      "gloss": "participant",
      "glossSv": "deltagare",
      "pos": "person",
      "explanation": "person + participation",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        823
      ]
    },
    {
      "id": 4088,
      "bciAvId": 23917,
      "gloss": "to participate",
      "glossSv": "delta",
      "pos": "action",
      "explanation": "participation + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        823
      ]
    },
    {
      "id": 4089,
      "bciAvId": 23918,
      "gloss": "participation",
      "glossSv": "deltagande, medverkan",
      "pos": "noun",
      "explanation": "activity + together",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        823
      ]
    },
    {
      "id": 4090,
      "bciAvId": 23919,
      "gloss": "participation, involvement",
      "glossSv": "delaktighet, gemenskap",
      "pos": "noun",
      "explanation": "feeling + participation",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        106,
        "/",
        823
      ]
    },
    {
      "id": 4091,
      "bciAvId": 23920,
      "gloss": "pennywhistle, tin whistle",
      "glossSv": "bleckflöjt, irländsk flöjt",
      "pos": "noun",
      "explanation": "musical instrument + downwards + soprano: explanation?",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        271,
        "/",
        870
      ]
    },
    {
      "id": 4092,
      "bciAvId": 23921,
      "gloss": "percussion instrument",
      "glossSv": "slaginstrument, slagverk",
      "pos": "noun",
      "explanation": "musical instrument + mallet",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        373
      ]
    },
    {
      "id": 4093,
      "bciAvId": 23922,
      "gloss": "piano (1)",
      "glossSv": "piano (1)",
      "pos": "noun",
      "explanation": "musical instrument + keyboard",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        864
      ]
    },
    {
      "id": 4094,
      "bciAvId": 23923,
      "gloss": "piano (2)",
      "glossSv": "piano (2)",
      "pos": "noun",
      "explanation": "percussion instrument + string",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        373,
        "/",
        872
      ]
    },
    {
      "id": 4095,
      "bciAvId": 23924,
      "gloss": "piccolo (1)",
      "glossSv": "piccolaflöjt (1)",
      "pos": "noun",
      "explanation": "flute,transverse flute + little",
      "isCharacter": false,
      "composition": [
        862,
        "/",
        956
      ]
    },
    {
      "id": 4096,
      "bciAvId": 23925,
      "gloss": "piccolo (2)",
      "glossSv": "piccolaflöjt (2)",
      "pos": "noun",
      "explanation": "wind instrument + soprano + little",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        870,
        "/",
        956
      ]
    },
    {
      "id": 4097,
      "bciAvId": 23928,
      "gloss": "key, tonality",
      "glossSv": "tonläge, tonhöjd (musik)",
      "pos": "noun",
      "explanation": "stave,staff + musical note",
      "isCharacter": false,
      "composition": [
        871,
        "/",
        462
      ]
    },
    {
      "id": 4098,
      "bciAvId": 23930,
      "gloss": "to play (instrument)",
      "glossSv": "spela (instrument)",
      "pos": "action",
      "explanation": "musical instrument + action indicator",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        81,
        "/",
        462
      ]
    },
    {
      "id": 4099,
      "bciAvId": 23931,
      "gloss": "pop music",
      "glossSv": "popmusik",
      "pos": "noun",
      "explanation": "music + many + many + person",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        368,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 4100,
      "bciAvId": 23932,
      "gloss": "punk rock",
      "glossSv": "punkmusik",
      "pos": "noun",
      "explanation": "music + hair + up",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        371,
        "/",
        678
      ]
    },
    {
      "id": 4101,
      "bciAvId": 23933,
      "gloss": "rainbow",
      "glossSv": "regnbåge",
      "pos": "noun",
      "explanation": "bow,arc + many + colour",
      "isCharacter": false,
      "composition": [
        854,
        "/",
        368,
        "/",
        1161
      ]
    },
    {
      "id": 4102,
      "bciAvId": 23934,
      "gloss": "rap (music)",
      "glossSv": "rap, rapmusik",
      "pos": "noun",
      "explanation": "song + same + speak-(to)",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462,
        "/",
        578,
        "/",
        457
      ]
    },
    {
      "id": 4103,
      "bciAvId": 23935,
      "gloss": "rattle",
      "glossSv": "skallra",
      "pos": "noun",
      "explanation": "thing + rotation + noise (loud)",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        887,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 4104,
      "bciAvId": 23936,
      "gloss": "rattle (musical instrument)",
      "glossSv": "skrammelinstrument",
      "pos": "noun",
      "explanation": "musical instrument + rotation + noise (loud)",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        887,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 4105,
      "bciAvId": 23937,
      "gloss": "recorder",
      "glossSv": "blockflöjt",
      "pos": "noun",
      "explanation": "flute,recorder + tree: where tree is a contraction of wood",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        666
      ]
    },
    {
      "id": 4106,
      "bciAvId": 23938,
      "gloss": "recorder (alto)",
      "glossSv": "blockflöjt (alt)",
      "pos": "noun",
      "explanation": "recorder + alto",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        666,
        "/",
        852
      ]
    },
    {
      "id": 4107,
      "bciAvId": 23939,
      "gloss": "recorder (bass)",
      "glossSv": "blockflöjt (bas)",
      "pos": "noun",
      "explanation": "recorder + bass",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        666,
        "/",
        853
      ]
    },
    {
      "id": 4108,
      "bciAvId": 23940,
      "gloss": "recorder (soprano)",
      "glossSv": "blockflöjt (sopran)",
      "pos": "noun",
      "explanation": "recorder + soprano",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        666,
        "/",
        870
      ]
    },
    {
      "id": 4109,
      "bciAvId": 23941,
      "gloss": "recorder (tenor)",
      "glossSv": "blockflöjt (tenor)",
      "pos": "noun",
      "explanation": "recorder + tenor",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        666,
        "/",
        874
      ]
    },
    {
      "id": 4110,
      "bciAvId": 23943,
      "gloss": "rhythm instrument",
      "glossSv": "rytminstrument",
      "pos": "noun",
      "explanation": "musical instrument + up and down",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        723
      ]
    },
    {
      "id": 4111,
      "bciAvId": 23944,
      "gloss": "roe deer",
      "glossSv": "rådjur",
      "pos": "noun",
      "explanation": "deer + little",
      "isCharacter": false,
      "composition": [
        125,
        "/",
        956
      ]
    },
    {
      "id": 4112,
      "bciAvId": 23945,
      "gloss": "rotisserie, spit",
      "glossSv": "grillkött",
      "pos": "noun",
      "explanation": "meat + rotation",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        887
      ]
    },
    {
      "id": 4113,
      "bciAvId": 23946,
      "gloss": "saxophone (1)",
      "glossSv": "saxofon (1)",
      "pos": "noun",
      "explanation": "clarinet,reed instrument (1) + metal [contraction]",
      "isCharacter": false,
      "composition": [
        861,
        "/",
        869,
        "/",
        814
      ]
    },
    {
      "id": 4114,
      "bciAvId": 23947,
      "gloss": "saxophone (2)",
      "glossSv": "saxofon (2)",
      "pos": "noun",
      "explanation": "clarinet,reed instrument (2) + metal [contraction]",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        869,
        "/",
        814
      ]
    },
    {
      "id": 4115,
      "bciAvId": 23948,
      "gloss": "sit ski",
      "glossSv": "sitski (FD)",
      "pos": "noun",
      "explanation": "2 + sitski,sit ski",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        1083
      ]
    },
    {
      "id": 4116,
      "bciAvId": 23949,
      "gloss": "small pancake, blini",
      "glossSv": "plättar, blinier",
      "pos": "noun",
      "explanation": "pancake + little",
      "isCharacter": false,
      "composition": [
        843,
        "/",
        956
      ]
    },
    {
      "id": 4117,
      "bciAvId": 23950,
      "gloss": "snowmobile",
      "glossSv": "snöskoter",
      "pos": "noun",
      "explanation": "vehicle + snow",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        604
      ]
    },
    {
      "id": 4118,
      "bciAvId": 23951,
      "gloss": "snowplow, snowplough",
      "glossSv": "snöplog",
      "pos": "noun",
      "explanation": "vehicle + minus + snow",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        449,
        "/",
        604
      ]
    },
    {
      "id": 4119,
      "bciAvId": 23953,
      "gloss": "to spray, to vaporise, to vaporize",
      "glossSv": "spreja, förånga",
      "pos": "action",
      "explanation": "spray,vaporization + action indicator",
      "isCharacter": false,
      "composition": [
        966,
        ";",
        81
      ]
    },
    {
      "id": 4120,
      "bciAvId": 23954,
      "gloss": "spray bottle, vaporiser, vaporizer, spray can",
      "glossSv": "sprejflaska",
      "pos": "noun",
      "explanation": "bottle + spray,vaporization",
      "isCharacter": false,
      "composition": [
        174,
        "/",
        966
      ]
    },
    {
      "id": 4121,
      "bciAvId": 23956,
      "gloss": "storm",
      "glossSv": "storm",
      "pos": "noun",
      "explanation": "much + gale: i.e., much + much + wind",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        705
      ]
    },
    {
      "id": 4122,
      "bciAvId": 23957,
      "gloss": "stressed (for time), pushed (for time), in a rush",
      "glossSv": "stressad, jäktad",
      "pos": "description",
      "explanation": "stress (for time) + description indicator: having a feeling of lacking time for an activity",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        655,
        "/",
        106
      ]
    },
    {
      "id": 4123,
      "bciAvId": 23960,
      "gloss": "surprise",
      "glossSv": "överraskning",
      "pos": "noun",
      "explanation": "feeling + what,question mark + intensity: a feeling of unexpectedness",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        699,
        "/",
        401
      ]
    },
    {
      "id": 4124,
      "bciAvId": 23961,
      "gloss": "to surprise",
      "glossSv": "överraska",
      "pos": "action",
      "explanation": "cause-(to) + surprise + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        699,
        "/",
        401
      ]
    },
    {
      "id": 4125,
      "bciAvId": 23962,
      "gloss": "surprised",
      "glossSv": "överraskad",
      "pos": "description",
      "explanation": "surprise + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        699,
        "/",
        401
      ]
    },
    {
      "id": 4126,
      "bciAvId": 23963,
      "gloss": "synthesiser, synthesizer, keyboard",
      "glossSv": "synt, synthesizer, keyboard",
      "pos": "noun",
      "explanation": "piano (1) + digits (computer): a digital keyboard instrument",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        864,
        "/",
        829
      ]
    },
    {
      "id": 4127,
      "bciAvId": 23964,
      "gloss": "tambourine (1)",
      "glossSv": "tamburin (1)",
      "pos": "noun",
      "explanation": "drum (1) + up and down",
      "isCharacter": false,
      "composition": [
        859,
        "/",
        723
      ]
    },
    {
      "id": 4128,
      "bciAvId": 23965,
      "gloss": "tambourine (2)",
      "glossSv": "tamburin (2)",
      "pos": "noun",
      "explanation": "rhythm instrument + disk + hand",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        723,
        "/",
        263,
        "/",
        374
      ]
    },
    {
      "id": 4129,
      "bciAvId": 23967,
      "gloss": "tornado",
      "glossSv": "virvelstorm, tornado",
      "pos": "noun",
      "explanation": "gale + rotation: a strong rotating wind",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        705,
        "/",
        887
      ]
    },
    {
      "id": 4130,
      "bciAvId": 23968,
      "gloss": "triangle (instrument) (1)",
      "glossSv": "triangel (instrument) (1)",
      "pos": "noun",
      "explanation": "triangle [contraction] + mallet",
      "isCharacter": false,
      "composition": [
        247,
        "/",
        373
      ]
    },
    {
      "id": 4131,
      "bciAvId": 23969,
      "gloss": "triangle (instrument) (2)",
      "glossSv": "triangel (instrument) (2)",
      "pos": "noun",
      "explanation": "musical instrument + triangle (instrument) (1)",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        247,
        "/",
        373
      ]
    },
    {
      "id": 4132,
      "bciAvId": 23970,
      "gloss": "trombone",
      "glossSv": "trombon",
      "pos": "noun",
      "explanation": "brass instrument + back and forth",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814,
        "/",
        144
      ]
    },
    {
      "id": 4133,
      "bciAvId": 23971,
      "gloss": "trumpet, horn, cornet (2)",
      "glossSv": "trumpet, kornett (2)",
      "pos": "noun",
      "explanation": "brass instrument + 3 + disc: the three discs representing the three valves of a trumpet",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814,
        "/",
        12,
        "/",
        263
      ]
    },
    {
      "id": 4134,
      "bciAvId": 23972,
      "gloss": "tsunami",
      "glossSv": "tsunami",
      "pos": "noun",
      "explanation": "tidal wave + intensity: a very big tidal wave",
      "isCharacter": false,
      "composition": [
        761,
        "/",
        936,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4135,
      "bciAvId": 23973,
      "gloss": "tuba (1)",
      "glossSv": "tuba (1)",
      "pos": "noun",
      "explanation": "trumpet + big",
      "isCharacter": false,
      "composition": [
        389,
        "/",
        936
      ]
    },
    {
      "id": 4136,
      "bciAvId": 23974,
      "gloss": "tuba (2)",
      "glossSv": "tuba (2)",
      "pos": "noun",
      "explanation": "brass instrument + bass",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        814,
        "/",
        853
      ]
    },
    {
      "id": 4137,
      "bciAvId": 23975,
      "gloss": "tuning fork",
      "glossSv": "stämgaffel",
      "pos": "noun",
      "explanation": "fork + musical note",
      "isCharacter": false,
      "composition": [
        334,
        "/",
        462
      ]
    },
    {
      "id": 4138,
      "bciAvId": 23976,
      "gloss": "twin brother",
      "glossSv": "tvillingbror",
      "pos": "person",
      "explanation": "brother + same + birth",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        11,
        "/",
        578,
        "/",
        166
      ]
    },
    {
      "id": 4139,
      "bciAvId": 23977,
      "gloss": "twin sister",
      "glossSv": "tvillingsyster",
      "pos": "person",
      "explanation": "sister + same + birth",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        11,
        "/",
        578,
        "/",
        166
      ]
    },
    {
      "id": 4140,
      "bciAvId": 23978,
      "gloss": "twins",
      "glossSv": "tvillingar",
      "pos": "person",
      "explanation": "2 + person + same + birth",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        513,
        "/",
        578,
        "/",
        166
      ]
    },
    {
      "id": 4141,
      "bciAvId": 23979,
      "gloss": "ukulele",
      "glossSv": "ukulele",
      "pos": "noun",
      "explanation": "guitar,string instrument + little",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        872,
        "/",
        956
      ]
    },
    {
      "id": 4142,
      "bciAvId": 23980,
      "gloss": "to unfold",
      "glossSv": "vika upp, veckla ut",
      "pos": "action",
      "explanation": "unfolding + action indicator",
      "isCharacter": false,
      "composition": [
        1104,
        ";",
        81
      ]
    },
    {
      "id": 4143,
      "bciAvId": 23981,
      "gloss": "wind instrument",
      "glossSv": "blåsinstrument",
      "pos": "noun",
      "explanation": "musical instrument + wind",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705
      ]
    },
    {
      "id": 4144,
      "bciAvId": 23982,
      "gloss": "viola",
      "glossSv": "viola",
      "pos": "noun",
      "explanation": "bow and string instrument + alto",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        856,
        "/",
        852
      ]
    },
    {
      "id": 4145,
      "bciAvId": 23983,
      "gloss": "violin",
      "glossSv": "fiol, violin",
      "pos": "noun",
      "explanation": "bow and string instrument + soprano",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        856,
        "/",
        870
      ]
    },
    {
      "id": 4146,
      "bciAvId": 23984,
      "gloss": "voice",
      "glossSv": "röst",
      "pos": "noun",
      "explanation": "sound + mouth",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        457
      ]
    },
    {
      "id": 4147,
      "bciAvId": 23985,
      "gloss": "woodwind instrument",
      "glossSv": "träblåsinstrument",
      "pos": "noun",
      "explanation": "wind instrument + wood [contraction]",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        705,
        "/",
        666
      ]
    },
    {
      "id": 4148,
      "bciAvId": 23986,
      "gloss": "xylophone, vibraphone (1)",
      "glossSv": "xylofon, vibrafon (1)",
      "pos": "noun",
      "explanation": "keyboard + mallet",
      "isCharacter": false,
      "composition": [
        864,
        "/",
        373
      ]
    },
    {
      "id": 4149,
      "bciAvId": 23987,
      "gloss": "xylophone, vibraphone (2)",
      "glossSv": "xylofon, vibrafon (2)",
      "pos": "noun",
      "explanation": "percussion instrument + keyboard",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        373,
        "/",
        864
      ]
    },
    {
      "id": 4150,
      "bciAvId": 24001,
      "gloss": "acrobat",
      "glossSv": "akrobat",
      "pos": "person",
      "explanation": "person + gymnastics + show [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        718,
        "/",
        532,
        "/",
        303
      ]
    },
    {
      "id": 4151,
      "bciAvId": 24002,
      "gloss": "acrobatics",
      "glossSv": "akrobatik",
      "pos": "noun",
      "explanation": "activity + gymnastics + show [contraction]",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        718,
        "/",
        532,
        "/",
        303
      ]
    },
    {
      "id": 4152,
      "bciAvId": 24003,
      "gloss": "adding, additive",
      "glossSv": "tillsats",
      "pos": "noun",
      "explanation": "addition + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97
      ]
    },
    {
      "id": 4153,
      "bciAvId": 24004,
      "gloss": "Advent",
      "glossSv": "advent",
      "pos": "noun",
      "explanation": "limited time + before + Christmas",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        158,
        "/",
        258,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 4154,
      "bciAvId": 24005,
      "gloss": "agnosticism",
      "glossSv": "agnosticism",
      "pos": "noun",
      "explanation": "doubt + God: belief that we don't know of either the existence or the nonexistence of God",
      "isCharacter": false,
      "composition": [
        802,
        "/",
        355
      ]
    },
    {
      "id": 4155,
      "bciAvId": 24006,
      "gloss": "agreement (spoken)",
      "glossSv": "överenskommelse (muntlig), avtal",
      "pos": "noun",
      "explanation": "mouth + agreement: spoken agreement",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        113
      ]
    },
    {
      "id": 4156,
      "bciAvId": 24007,
      "gloss": "agreement (written), contract",
      "glossSv": "överenskommelse (skriven), kontrakt",
      "pos": "noun",
      "explanation": "paper + agreement: agreement by a written document",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        113
      ]
    },
    {
      "id": 4157,
      "bciAvId": 24008,
      "gloss": "aid store room",
      "glossSv": "hjälpmedelsförråd",
      "pos": "noun",
      "explanation": "storeroom + aid",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        239,
        "/",
        382,
        ";",
        97
      ]
    },
    {
      "id": 4158,
      "bciAvId": 24009,
      "gloss": "animal droppings",
      "glossSv": "djurspillning",
      "pos": "noun",
      "explanation": "waste + animal",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        122
      ]
    },
    {
      "id": 4159,
      "bciAvId": 24010,
      "gloss": "ankle splint",
      "glossSv": "fotskena",
      "pos": "noun",
      "explanation": "aid + bones with joint + ankle + thing indicator: support for the ankle joint",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002,
        "/",
        128
      ]
    },
    {
      "id": 4160,
      "bciAvId": 24011,
      "gloss": "other, another (thing)",
      "glossSv": "annan, annat",
      "pos": "expression",
      "explanation": "thing + two",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        11
      ]
    },
    {
      "id": 4161,
      "bciAvId": 24012,
      "gloss": "apricot (dried)",
      "glossSv": "aprikos (torkad)",
      "pos": "noun",
      "explanation": "apricot + dry",
      "isCharacter": false,
      "composition": [
        506,
        "/",
        956,
        "/",
        860
      ]
    },
    {
      "id": 4162,
      "bciAvId": 24013,
      "gloss": "Ascension (of Christ)",
      "glossSv": "Kristi himmelsfärd",
      "pos": "noun",
      "explanation": "up + Christ",
      "isCharacter": false,
      "composition": [
        678,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 4163,
      "bciAvId": 24014,
      "gloss": "Ascension Day",
      "glossSv": "Kristi himmelsfärdsdag",
      "pos": "noun",
      "explanation": "day + Ascension",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        678,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 4164,
      "bciAvId": 24016,
      "gloss": "assessment room",
      "glossSv": "utredningsrum, utprovningsrum",
      "pos": "noun",
      "explanation": "room + assessment",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        553,
        "/",
        332,
        "/",
        "RK:-2",
        "/",
        297
      ]
    },
    {
      "id": 4165,
      "bciAvId": 24017,
      "gloss": "at one's destination, there",
      "glossSv": "framme",
      "pos": "description",
      "explanation": "end + description indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        86
      ]
    },
    {
      "id": 4166,
      "bciAvId": 24018,
      "gloss": "auditor, accountant",
      "glossSv": "revisor, kamrer",
      "pos": "person",
      "explanation": "person + watch [contraction] + money",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        969,
        "/",
        451
      ]
    },
    {
      "id": 4167,
      "bciAvId": 24019,
      "gloss": "avalanche",
      "glossSv": "lavin",
      "pos": "noun",
      "explanation": "snow + down + mountain",
      "isCharacter": false,
      "composition": [
        604,
        "/",
        271,
        "/",
        "RK:-2",
        "/",
        456
      ]
    },
    {
      "id": 4168,
      "bciAvId": 24020,
      "gloss": "to bark, to woof",
      "glossSv": "skälla (hund)",
      "pos": "action",
      "explanation": "to talk + dog + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        124
      ]
    },
    {
      "id": 4169,
      "bciAvId": 24021,
      "gloss": "bean (dried), chick-pea, kidney bean, pinto bean",
      "glossSv": "böna (torkad)",
      "pos": "noun",
      "explanation": "bean + dry",
      "isCharacter": false,
      "composition": [
        154,
        "/",
        860
      ]
    },
    {
      "id": 4170,
      "bciAvId": 24022,
      "gloss": "bicycle path",
      "glossSv": "cykelbana",
      "pos": "noun",
      "explanation": "place + activity + bicycle",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 4171,
      "bciAvId": 24023,
      "gloss": "bisexual",
      "glossSv": "bisexuell",
      "pos": "description",
      "explanation": "bisexuality + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        245,
        "/",
        11,
        "/",
        117
      ]
    },
    {
      "id": 4172,
      "bciAvId": 24024,
      "gloss": "bisexuality",
      "glossSv": "bisexualitet",
      "pos": "noun",
      "explanation": "feeling + male and female + both",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        245,
        "/",
        11,
        "/",
        117
      ]
    },
    {
      "id": 4173,
      "bciAvId": 24025,
      "gloss": "bit (horse)",
      "glossSv": "betsel",
      "pos": "noun",
      "explanation": "metal [contraction] + mouth + horse",
      "isCharacter": false,
      "composition": [
        814,
        "/",
        457,
        "/",
        391
      ]
    },
    {
      "id": 4174,
      "bciAvId": 24026,
      "gloss": "to bleat, to baa",
      "glossSv": "bräka",
      "pos": "action",
      "explanation": "to talk + sheep + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 4175,
      "bciAvId": 24027,
      "gloss": "Bliss fanatic",
      "glossSv": "blissfanatiker",
      "pos": "person",
      "explanation": "fanatic + blissymbol",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954,
        "/",
        401,
        "/",
        167
      ]
    },
    {
      "id": 4176,
      "bciAvId": 24028,
      "gloss": "blood vessel",
      "glossSv": "blodkärl",
      "pos": "noun",
      "explanation": "tube + blood [contraction]",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        423
      ]
    },
    {
      "id": 4177,
      "bciAvId": 24029,
      "gloss": "to blush",
      "glossSv": "rodna",
      "pos": "action",
      "explanation": "face + red + action indicator",
      "isCharacter": false,
      "composition": [
        306,
        ";",
        81,
        "/",
        1161,
        "/",
        457
      ]
    },
    {
      "id": 4178,
      "bciAvId": 24030,
      "gloss": "body brace, corset",
      "glossSv": "stödkorsett",
      "pos": "noun",
      "explanation": "aid + bones with joint + body + thing indicator: bones with joint representing joint [contraction], support for the hip joint and the spine",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002,
        "/",
        171
      ]
    },
    {
      "id": 4179,
      "bciAvId": 24031,
      "gloss": "body fluid",
      "glossSv": "kroppsvätska",
      "pos": "noun",
      "explanation": "liquid + body",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        171
      ]
    },
    {
      "id": 4180,
      "bciAvId": 24032,
      "gloss": "body hair",
      "glossSv": "kroppshår",
      "pos": "noun",
      "explanation": "hair + body",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        171
      ]
    },
    {
      "id": 4181,
      "bciAvId": 24033,
      "gloss": "body part",
      "glossSv": "kroppsdel",
      "pos": "noun",
      "explanation": "part of + body",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        171
      ]
    },
    {
      "id": 4182,
      "bciAvId": 24034,
      "gloss": "body temperature",
      "glossSv": "kroppstemperatur",
      "pos": "noun",
      "explanation": "temperature + body",
      "isCharacter": false,
      "composition": [
        645,
        "/",
        171
      ]
    },
    {
      "id": 4183,
      "bciAvId": 24035,
      "gloss": "to bolt (horse)",
      "glossSv": "skena (häst)",
      "pos": "action",
      "explanation": "horse + three intensity characters + danger + action indicator",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        401,
        "/",
        401,
        "/",
        401,
        "/",
        256
      ]
    },
    {
      "id": 4184,
      "bciAvId": 24036,
      "gloss": "bomb, explosive",
      "glossSv": "bomb, sprängämne",
      "pos": "noun",
      "explanation": "explosion + thing indicator",
      "isCharacter": false,
      "composition": [
        302,
        ";",
        97
      ]
    },
    {
      "id": 4185,
      "bciAvId": 24037,
      "gloss": "bow",
      "glossSv": "båge",
      "pos": "noun",
      "explanation": "curve + thing indicator: bow, as in \"bow and arrow\", etc.",
      "isCharacter": false,
      "composition": [
        255,
        ";",
        97
      ]
    },
    {
      "id": 4186,
      "bciAvId": 24038,
      "gloss": "bridle, headstall",
      "glossSv": "träns",
      "pos": "noun",
      "explanation": "harness + muzzle + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        881
      ]
    },
    {
      "id": 4187,
      "bciAvId": 24039,
      "gloss": "bus lane",
      "glossSv": "bussfil",
      "pos": "noun",
      "explanation": "place + activity + bus",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        188
      ]
    },
    {
      "id": 4188,
      "bciAvId": 24040,
      "gloss": "bus station",
      "glossSv": "busstation",
      "pos": "noun",
      "explanation": "station + bus",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        884,
        "/",
        188
      ]
    },
    {
      "id": 4189,
      "bciAvId": 24041,
      "gloss": "bus stop, bus bay",
      "glossSv": "busshållplats",
      "pos": "noun",
      "explanation": "platform + bus",
      "isCharacter": false,
      "composition": [
        884,
        "/",
        188
      ]
    },
    {
      "id": 4190,
      "bciAvId": 24042,
      "gloss": "cable car",
      "glossSv": "linbana, kabinbana",
      "pos": "noun",
      "explanation": "enclosure + ascending and descending",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        988
      ]
    },
    {
      "id": 4191,
      "bciAvId": 24043,
      "gloss": "cancer",
      "glossSv": "cancer",
      "pos": "noun",
      "explanation": "illness + cell + repetition",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        748,
        "/",
        963
      ]
    },
    {
      "id": 4192,
      "bciAvId": 24044,
      "gloss": "to canter",
      "glossSv": "rida i kort galopp",
      "pos": "action",
      "explanation": "trot (horse)-(to) + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4193,
      "bciAvId": 24047,
      "gloss": "celibacy (religious)",
      "glossSv": "celibat, avhållsamhet (sexuell)",
      "pos": "noun",
      "explanation": "chastity + religion",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        232,
        "/",
        349,
        "/",
        726
      ]
    },
    {
      "id": 4194,
      "bciAvId": 24048,
      "gloss": "ceramics, pottery",
      "glossSv": "keramik",
      "pos": "noun",
      "explanation": "craft + clay",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        458
      ]
    },
    {
      "id": 4195,
      "bciAvId": 24049,
      "gloss": "certain, sure",
      "glossSv": "säker, bestämd, tillförlitlig",
      "pos": "description",
      "explanation": "without + doubt + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        802,
        ";",
        86
      ]
    },
    {
      "id": 4196,
      "bciAvId": 24050,
      "gloss": "chairlift",
      "glossSv": "sittlift, stollift",
      "pos": "noun",
      "explanation": "seat,sitting (sitting person) + ascending and descending",
      "isCharacter": false,
      "composition": [
        517,
        "/",
        988
      ]
    },
    {
      "id": 4197,
      "bciAvId": 24052,
      "gloss": "challenge",
      "glossSv": "utmaning",
      "pos": "noun",
      "explanation": "opposition + cause + action",
      "isCharacter": false,
      "composition": [
        487,
        "/",
        206,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 4198,
      "bciAvId": 24053,
      "gloss": "charm",
      "glossSv": "charm",
      "pos": "noun",
      "explanation": "personality + positive",
      "isCharacter": false,
      "composition": [
        883,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 4199,
      "bciAvId": 24054,
      "gloss": "charming",
      "glossSv": "charmig",
      "pos": "description",
      "explanation": "charm + description indicator",
      "isCharacter": false,
      "composition": [
        883,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 4200,
      "bciAvId": 24055,
      "gloss": "checked",
      "glossSv": "rutig",
      "pos": "description",
      "explanation": "many + grid + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        950,
        ";",
        86
      ]
    },
    {
      "id": 4201,
      "bciAvId": 24056,
      "gloss": "chest hair",
      "glossSv": "hår på bröstet",
      "pos": "noun",
      "explanation": "hair + chest",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        218
      ]
    },
    {
      "id": 4202,
      "bciAvId": 24057,
      "gloss": "child care",
      "glossSv": "barnomsorg",
      "pos": "noun",
      "explanation": "care + child: Child can be replaced by an appropriate specifier.",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        548,
        "/",
        220
      ]
    },
    {
      "id": 4203,
      "bciAvId": 24058,
      "gloss": "child harness, walking reins",
      "glossSv": "barnsele",
      "pos": "noun",
      "explanation": "harness + child",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        220
      ]
    },
    {
      "id": 4204,
      "bciAvId": 24059,
      "gloss": "Children's Day",
      "glossSv": "Barnens dag",
      "pos": "noun",
      "explanation": "day + child",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        220
      ]
    },
    {
      "id": 4205,
      "bciAvId": 24060,
      "gloss": "to chirp, to twitter",
      "glossSv": "kvittra",
      "pos": "action",
      "explanation": "to talk + bird + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        163
      ]
    },
    {
      "id": 4206,
      "bciAvId": 24061,
      "gloss": "circus",
      "glossSv": "cirkus",
      "pos": "noun",
      "explanation": "showplace + cloth: i.e. showplace + tent [contraction]",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        303,
        "/",
        228
      ]
    },
    {
      "id": 4207,
      "bciAvId": 24062,
      "gloss": "clean",
      "glossSv": "ren",
      "pos": "description",
      "explanation": "without + spot + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        303,
        ";",
        86,
        "/",
        270
      ]
    },
    {
      "id": 4208,
      "bciAvId": 24063,
      "gloss": "cloakroom, walk-in closet",
      "glossSv": "klädkammare, garderob",
      "pos": "noun",
      "explanation": "room + clothes",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        229
      ]
    },
    {
      "id": 4209,
      "bciAvId": 24064,
      "gloss": "cloudberry",
      "glossSv": "hjortron",
      "pos": "noun",
      "explanation": "compound berry + marsh",
      "isCharacter": false,
      "composition": [
        557,
        "/",
        637
      ]
    },
    {
      "id": 4210,
      "bciAvId": 24065,
      "gloss": "cold, common cold",
      "glossSv": "förkylning",
      "pos": "noun",
      "explanation": "illness + liquid + nose",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        695,
        "/",
        473
      ]
    },
    {
      "id": 4211,
      "bciAvId": 24066,
      "gloss": "common, mutual, shared",
      "glossSv": "gemensam",
      "pos": "description",
      "explanation": "to have + together + description indicator",
      "isCharacter": false,
      "composition": [
        953,
        ";",
        86,
        "/",
        823
      ]
    },
    {
      "id": 4212,
      "bciAvId": 24067,
      "gloss": "commuter train",
      "glossSv": "pendeltåg",
      "pos": "noun",
      "explanation": "train + back and forth",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        688,
        "/",
        144
      ]
    },
    {
      "id": 4213,
      "bciAvId": 24068,
      "gloss": "conductive education",
      "glossSv": "konduktiv pedagogik",
      "pos": "noun",
      "explanation": "education + plus + therapy",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        412,
        "/",
        120,
        "/",
        750
      ]
    },
    {
      "id": 4214,
      "bciAvId": 24069,
      "gloss": "conductor (teacher, therapist)",
      "glossSv": "konduktor",
      "pos": "person",
      "explanation": "person + conductive education",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        1029,
        "/",
        412,
        "/",
        120,
        "/",
        750
      ]
    },
    {
      "id": 4215,
      "bciAvId": 24070,
      "gloss": "constipation (1)",
      "glossSv": "förstoppning (1)",
      "pos": "noun",
      "explanation": "bowel movement [contraction] + stop",
      "isCharacter": false,
      "composition": [
        194,
        "/",
        292
      ]
    },
    {
      "id": 4216,
      "bciAvId": 24071,
      "gloss": "constipation (2)",
      "glossSv": "förstoppning (2)",
      "pos": "noun",
      "explanation": "illness + bowel movement [contraction] + stop",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        194,
        "/",
        292
      ]
    },
    {
      "id": 4217,
      "bciAvId": 24072,
      "gloss": "constitution",
      "glossSv": "författning, konstitution",
      "pos": "noun",
      "explanation": "plan,design,method,system + country",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        243
      ]
    },
    {
      "id": 4218,
      "bciAvId": 24073,
      "gloss": "to croak (frog)",
      "glossSv": "kväka",
      "pos": "action",
      "explanation": "to talk + frog + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        122,
        "/",
        1107,
        "/",
        836
      ]
    },
    {
      "id": 4219,
      "bciAvId": 24074,
      "gloss": "crown prince",
      "glossSv": "kronprins",
      "pos": "person",
      "explanation": "prince + future",
      "isCharacter": false,
      "composition": [
        178,
        "/",
        798,
        "/",
        341
      ]
    },
    {
      "id": 4220,
      "bciAvId": 24075,
      "gloss": "crown princess",
      "glossSv": "kronprinsessa",
      "pos": "person",
      "explanation": "princess + future",
      "isCharacter": false,
      "composition": [
        351,
        "/",
        798,
        "/",
        341
      ]
    },
    {
      "id": 4221,
      "bciAvId": 24076,
      "gloss": "to cuddle",
      "glossSv": "kela",
      "pos": "action",
      "explanation": "hug + feeling + action indicator",
      "isCharacter": false,
      "composition": [
        132,
        ";",
        81,
        "/",
        134,
        "/",
        313
      ]
    },
    {
      "id": 4222,
      "bciAvId": 24077,
      "gloss": "to cure",
      "glossSv": "bota",
      "pos": "action",
      "explanation": "to destroy + illness + action indicator",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 4223,
      "bciAvId": 24078,
      "gloss": "dancing therapy",
      "glossSv": "dansterapi",
      "pos": "noun",
      "explanation": "therapy + dance",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        418,
        "/",
        462
      ]
    },
    {
      "id": 4224,
      "bciAvId": 24079,
      "gloss": "decoration, ornament",
      "glossSv": "prydnadssak, dekoration, utsmyckning",
      "pos": "noun",
      "explanation": "adding + beautiful + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        303,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 4225,
      "bciAvId": 24080,
      "gloss": "democracy (country)",
      "glossSv": "demokrati (stat)",
      "pos": "noun",
      "explanation": "country + to permit + choice",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        960,
        "/",
        223
      ]
    },
    {
      "id": 4226,
      "bciAvId": 27065,
      "gloss": "helpful, assistive, supportive",
      "glossSv": "hjälpsam, assisterande, stödjande",
      "pos": "description",
      "explanation": "help+aid+assistant+support+description indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        86
      ]
    },
    {
      "id": 4227,
      "bciAvId": 24082,
      "gloss": "devoted",
      "glossSv": "engagerad, hängiven",
      "pos": "description",
      "explanation": "devotion + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        954
      ]
    },
    {
      "id": 4228,
      "bciAvId": 24083,
      "gloss": "devotee, fan",
      "glossSv": "anhängare, fantast",
      "pos": "person",
      "explanation": "person + devotion",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954
      ]
    },
    {
      "id": 4229,
      "bciAvId": 24084,
      "gloss": "devotion",
      "glossSv": "engagemang, hängivenhet, inlevelse",
      "pos": "noun",
      "explanation": "feeling + important",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        954
      ]
    },
    {
      "id": 4230,
      "bciAvId": 24085,
      "gloss": "diarrhea, diarrhoea",
      "glossSv": "diarré",
      "pos": "noun",
      "explanation": "illness + bowel movement + intensity",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        694,
        "/",
        194,
        "/",
        401
      ]
    },
    {
      "id": 4231,
      "bciAvId": 24086,
      "gloss": "domestic",
      "glossSv": "inrikes, inhemsk",
      "pos": "description",
      "explanation": "in + country + description indicator",
      "isCharacter": false,
      "composition": [
        398,
        "/",
        243,
        ";",
        86
      ]
    },
    {
      "id": 4232,
      "bciAvId": 24087,
      "gloss": "dotted",
      "glossSv": "prickig",
      "pos": "description",
      "explanation": "many + dot + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        270,
        ";",
        86
      ]
    },
    {
      "id": 4233,
      "bciAvId": 24088,
      "gloss": "drying cupboard, airing cupboard",
      "glossSv": "torkskåp",
      "pos": "noun",
      "explanation": "cupboard + to dry + cloth",
      "isCharacter": false,
      "composition": [
        252,
        "/",
        860,
        "/",
        228
      ]
    },
    {
      "id": 4234,
      "bciAvId": 24089,
      "gloss": "drying room, drying chamber",
      "glossSv": "torkrum",
      "pos": "noun",
      "explanation": "room + to dry + cloth",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        860,
        "/",
        228
      ]
    },
    {
      "id": 4235,
      "bciAvId": 24090,
      "gloss": "to dump, to dispose",
      "glossSv": "slänga, kasta, kassera",
      "pos": "action",
      "explanation": "waste + action indicator",
      "isCharacter": false,
      "composition": [
        694,
        ";",
        81
      ]
    },
    {
      "id": 4236,
      "bciAvId": 24091,
      "gloss": "elbow splint",
      "glossSv": "armbågsskena",
      "pos": "noun",
      "explanation": "aid + bones with joint + elbow + thing indicator: bones with joint representing joint [contraction], support for the elbow joint",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002,
        "/",
        287
      ]
    },
    {
      "id": 4237,
      "bciAvId": 24092,
      "gloss": "voter, elector",
      "glossSv": "väljare",
      "pos": "person",
      "explanation": "person + to choose: person who chooses or votes for a public official",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        223
      ]
    },
    {
      "id": 4238,
      "bciAvId": 24093,
      "gloss": "electorate",
      "glossSv": "väljarkår",
      "pos": "person",
      "explanation": "electorate + plural indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        223
      ]
    },
    {
      "id": 4239,
      "bciAvId": 24094,
      "gloss": "endangered",
      "glossSv": "utrotningshotad",
      "pos": "description",
      "explanation": "danger + delete + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        256,
        ";",
        85,
        "/",
        939
      ]
    },
    {
      "id": 4240,
      "bciAvId": 24095,
      "gloss": "Epiphany",
      "glossSv": "trettondagen",
      "pos": "noun",
      "explanation": "event + to observe + Christ",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        931,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 4241,
      "bciAvId": 24096,
      "gloss": "escalator, moving stairs",
      "glossSv": "rulltrappa",
      "pos": "noun",
      "explanation": "stairs + up and down",
      "isCharacter": false,
      "composition": [
        619,
        "/",
        723
      ]
    },
    {
      "id": 4242,
      "bciAvId": 24097,
      "gloss": "Estonia",
      "glossSv": "Estland",
      "pos": "noun",
      "explanation": "country + song: in E. singing, e g in choirs, is very important",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 4243,
      "bciAvId": 24099,
      "gloss": "to experiment",
      "glossSv": "experimentera",
      "pos": "action",
      "explanation": "experiment + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        551,
        "/",
        129
      ]
    },
    {
      "id": 4244,
      "bciAvId": 24100,
      "gloss": "exploded",
      "glossSv": "exploderad, sprängd",
      "pos": "description",
      "explanation": "explosion + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        302,
        ";",
        84
      ]
    },
    {
      "id": 4245,
      "bciAvId": 24101,
      "gloss": "explosive",
      "glossSv": "explosiv",
      "pos": "description",
      "explanation": "explosion + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        302,
        ";",
        85
      ]
    },
    {
      "id": 4246,
      "bciAvId": 24102,
      "gloss": "facial hair",
      "glossSv": "ansiktshår",
      "pos": "noun",
      "explanation": "hair + face",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        306
      ]
    },
    {
      "id": 4247,
      "bciAvId": 24103,
      "gloss": "Family Day",
      "glossSv": "Familjens dag",
      "pos": "noun",
      "explanation": "day + family",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        730
      ]
    },
    {
      "id": 4248,
      "bciAvId": 24104,
      "gloss": "fan (machine)",
      "glossSv": "fläkt",
      "pos": "noun",
      "explanation": "machine + wind",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        705
      ]
    },
    {
      "id": 4249,
      "bciAvId": 24105,
      "gloss": "fanatic",
      "glossSv": "fanatisk",
      "pos": "description",
      "explanation": "devotion + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        954,
        "/",
        401
      ]
    },
    {
      "id": 4250,
      "bciAvId": 24106,
      "gloss": "fanatic (person)",
      "glossSv": "fanatiker",
      "pos": "person",
      "explanation": "devotee + intensity",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954,
        "/",
        401
      ]
    },
    {
      "id": 4251,
      "bciAvId": 24107,
      "gloss": "farrier",
      "glossSv": "hovslagare",
      "pos": "person",
      "explanation": "person + hoof",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        879
      ]
    },
    {
      "id": 4252,
      "bciAvId": 24108,
      "gloss": "Father's Day",
      "glossSv": "Fars dag",
      "pos": "noun",
      "explanation": "day + father",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        312
      ]
    },
    {
      "id": 4253,
      "bciAvId": 24109,
      "gloss": "fee",
      "glossSv": "avgift",
      "pos": "noun",
      "explanation": "money + for + activity",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        106
      ]
    },
    {
      "id": 4254,
      "bciAvId": 24110,
      "gloss": "fertilised, fertilized",
      "glossSv": "befruktad",
      "pos": "description",
      "explanation": "conception + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        236,
        ";",
        84
      ]
    },
    {
      "id": 4255,
      "bciAvId": 24111,
      "gloss": "few, little",
      "glossSv": "lite, få",
      "pos": "description",
      "explanation": "number + small + description indicator",
      "isCharacter": false,
      "composition": [
        478,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 4256,
      "bciAvId": 24112,
      "gloss": "fever, temperature",
      "glossSv": "feber",
      "pos": "noun",
      "explanation": "body temperature + high",
      "isCharacter": false,
      "composition": [
        645,
        "/",
        171,
        "/",
        952
      ]
    },
    {
      "id": 4257,
      "bciAvId": 24113,
      "gloss": "financial support",
      "glossSv": "stöd (ekonomiskt)",
      "pos": "noun",
      "explanation": "help + with + money",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        709,
        "/",
        451
      ]
    },
    {
      "id": 4258,
      "bciAvId": 24114,
      "gloss": "fingernail, nail",
      "glossSv": "nagel, fingernagel",
      "pos": "noun",
      "explanation": "protection + finger",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        318
      ]
    },
    {
      "id": 4259,
      "bciAvId": 24115,
      "gloss": "fish (dried)",
      "glossSv": "fisk (torkad)",
      "pos": "noun",
      "explanation": "fish + dry",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        321,
        "/",
        860
      ]
    },
    {
      "id": 4260,
      "bciAvId": 24116,
      "gloss": "flower (dried)",
      "glossSv": "blomma (torkad)",
      "pos": "noun",
      "explanation": "flower + dry",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        860
      ]
    },
    {
      "id": 4261,
      "bciAvId": 24117,
      "gloss": "flu, influenza",
      "glossSv": "influensa",
      "pos": "noun",
      "explanation": "illness + body + intensity: your entire body is aching",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        171,
        "/",
        401
      ]
    },
    {
      "id": 4262,
      "bciAvId": 24118,
      "gloss": "foreign",
      "glossSv": "utrikes, utländsk",
      "pos": "description",
      "explanation": "out + country + description indicator",
      "isCharacter": false,
      "composition": [
        490,
        "/",
        243,
        ";",
        86
      ]
    },
    {
      "id": 4263,
      "bciAvId": 24119,
      "gloss": "fort, fortress",
      "glossSv": "fästning, borg",
      "pos": "noun",
      "explanation": "castle + war",
      "isCharacter": false,
      "composition": [
        825,
        "/",
        693
      ]
    },
    {
      "id": 4264,
      "bciAvId": 24121,
      "gloss": "fruit (dried)",
      "glossSv": "frukt (torkad)",
      "pos": "noun",
      "explanation": "fruit + dry",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        860
      ]
    },
    {
      "id": 4265,
      "bciAvId": 24122,
      "gloss": "fundamental, basic",
      "glossSv": "grundläggande, basal, grund-, bas-",
      "pos": "description",
      "explanation": "foundation + description indicator",
      "isCharacter": false,
      "composition": [
        878,
        ";",
        86
      ]
    },
    {
      "id": 4266,
      "bciAvId": 24123,
      "gloss": "fundamental law",
      "glossSv": "grundlag",
      "pos": "noun",
      "explanation": "law + fundamental",
      "isCharacter": false,
      "composition": [
        813,
        "/",
        497,
        "/",
        878
      ]
    },
    {
      "id": 4267,
      "bciAvId": 24124,
      "gloss": "fundamental rule",
      "glossSv": "grundregel",
      "pos": "noun",
      "explanation": "rule + fundamental",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        878
      ]
    },
    {
      "id": 4268,
      "bciAvId": 24125,
      "gloss": "fundamentalism",
      "glossSv": "fundamentalism",
      "pos": "noun",
      "explanation": "belief + fundamental",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1048,
        "/",
        878
      ]
    },
    {
      "id": 4269,
      "bciAvId": 24126,
      "gloss": "fundamentalism (religious)",
      "glossSv": "fundamentalism (religiös)",
      "pos": "noun",
      "explanation": "religion + fundamental",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        878
      ]
    },
    {
      "id": 4270,
      "bciAvId": 24127,
      "gloss": "fundamentalist",
      "glossSv": "fundamentalist",
      "pos": "person",
      "explanation": "person + fundamentalism",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        1048,
        "/",
        878
      ]
    },
    {
      "id": 4271,
      "bciAvId": 24128,
      "gloss": "fundamentalist (religious)",
      "glossSv": "fundamentalist (religiös)",
      "pos": "person",
      "explanation": "person + fundamentalism (religious)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        725,
        "/",
        878
      ]
    },
    {
      "id": 4272,
      "bciAvId": 24129,
      "gloss": "to gallop",
      "glossSv": "galoppera",
      "pos": "action",
      "explanation": "gallop + action indicator",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4273,
      "bciAvId": 24130,
      "gloss": "gelding",
      "glossSv": "valack",
      "pos": "noun",
      "explanation": "stallion + sterilized",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        106,
        "/",
        449,
        "/",
        236
      ]
    },
    {
      "id": 4274,
      "bciAvId": 24131,
      "gloss": "general",
      "glossSv": "generell",
      "pos": "description",
      "explanation": "generalization + description indicator",
      "isCharacter": false,
      "composition": [
        348,
        ";",
        86
      ]
    },
    {
      "id": 4275,
      "bciAvId": 24132,
      "gloss": "girth, cinch",
      "glossSv": "sadelgjord",
      "pos": "noun",
      "explanation": "linear thing + waist + horse + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        690,
        "/",
        391
      ]
    },
    {
      "id": 4276,
      "bciAvId": 24133,
      "gloss": "glacier",
      "glossSv": "glaciär",
      "pos": "noun",
      "explanation": "ice + river: ice that moves in response to gravity",
      "isCharacter": false,
      "composition": [
        394,
        "/",
        568
      ]
    },
    {
      "id": 4277,
      "bciAvId": 24134,
      "gloss": "glass craft",
      "glossSv": "glaskonst",
      "pos": "noun",
      "explanation": "craft + glass [contraction]",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        352
      ]
    },
    {
      "id": 4278,
      "bciAvId": 24135,
      "gloss": "glow",
      "glossSv": "glöd",
      "pos": "noun",
      "explanation": "light + fire + end",
      "isCharacter": false,
      "composition": [
        424,
        "/",
        319,
        "/",
        292
      ]
    },
    {
      "id": 4279,
      "bciAvId": 24136,
      "gloss": "to glow",
      "glossSv": "glöda",
      "pos": "action",
      "explanation": "glow + action indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        81,
        "/",
        319,
        "/",
        292
      ]
    },
    {
      "id": 4280,
      "bciAvId": 24137,
      "gloss": "groom (horse)",
      "glossSv": "hästskötare",
      "pos": "person",
      "explanation": "person + to work + to protect + horse",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        548,
        "/",
        391
      ]
    },
    {
      "id": 4281,
      "bciAvId": 24138,
      "gloss": "to groom (horse)",
      "glossSv": "rykta",
      "pos": "action",
      "explanation": "horse brush + action indicator",
      "isCharacter": false,
      "composition": [
        184,
        ";",
        81,
        "/",
        391
      ]
    },
    {
      "id": 4282,
      "bciAvId": 24139,
      "gloss": "to growl (dog)",
      "glossSv": "morra",
      "pos": "action",
      "explanation": "to talk + opposition + dog + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        487,
        "/",
        124
      ]
    },
    {
      "id": 4283,
      "bciAvId": 24140,
      "gloss": "to grunt (pig)",
      "glossSv": "grymta",
      "pos": "action",
      "explanation": "to talk + pig + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        521
      ]
    },
    {
      "id": 4284,
      "bciAvId": 24141,
      "gloss": "hair drier, blow dryer",
      "glossSv": "hårtork",
      "pos": "noun",
      "explanation": "tool + to dry + hair",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        860,
        "/",
        371
      ]
    },
    {
      "id": 4285,
      "bciAvId": 24142,
      "gloss": "hand splint",
      "glossSv": "handskena, handortos",
      "pos": "noun",
      "explanation": "aid + joint [contr ] + hand + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002,
        "/",
        374
      ]
    },
    {
      "id": 4286,
      "bciAvId": 24143,
      "gloss": "harness",
      "glossSv": "sele, bälte",
      "pos": "noun",
      "explanation": "group of + linear thing + combination + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232
      ]
    },
    {
      "id": 4287,
      "bciAvId": 24144,
      "gloss": "to harness",
      "glossSv": "sätta på sele, sätta på bälte",
      "pos": "action",
      "explanation": "harness + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        81,
        ";",
        97,
        "/",
        232
      ]
    },
    {
      "id": 4288,
      "bciAvId": 24145,
      "gloss": "harness (horse)",
      "glossSv": "seldon",
      "pos": "noun",
      "explanation": "harness + horse + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        391
      ]
    },
    {
      "id": 4289,
      "bciAvId": 24146,
      "gloss": "to harness (horse)",
      "glossSv": "sela på",
      "pos": "action",
      "explanation": "harness + horse + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        81,
        ";",
        97,
        "/",
        232,
        "/",
        391
      ]
    },
    {
      "id": 4290,
      "bciAvId": 24147,
      "gloss": "hay",
      "glossSv": "hö",
      "pos": "noun",
      "explanation": "grass + dry",
      "isCharacter": false,
      "composition": [
        366,
        "/",
        860
      ]
    },
    {
      "id": 4291,
      "bciAvId": 24148,
      "gloss": "to heal",
      "glossSv": "läka, tillfriskna",
      "pos": "action",
      "explanation": "to become + healthy + action indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        894,
        "/",
        377
      ]
    },
    {
      "id": 4292,
      "bciAvId": 24149,
      "gloss": "Heaven, Kingdom of God",
      "glossSv": "Himlen",
      "pos": "noun",
      "explanation": "world + God",
      "isCharacter": false,
      "composition": [
        712,
        "/",
        355
      ]
    },
    {
      "id": 4293,
      "bciAvId": 24150,
      "gloss": "hibernation",
      "glossSv": "vinterdvala",
      "pos": "noun",
      "explanation": "sleep + winter",
      "isCharacter": false,
      "composition": [
        599,
        "/",
        636,
        "/",
        13,
        "/",
        604
      ]
    },
    {
      "id": 4294,
      "bciAvId": 24151,
      "gloss": "to hiss (cat)",
      "glossSv": "fräsa (katt)",
      "pos": "action",
      "explanation": "to talk + opposition + cat + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        487,
        "/",
        126
      ]
    },
    {
      "id": 4295,
      "bciAvId": 24152,
      "gloss": "to hitch, to tie up, to fix up",
      "glossSv": "binda fast, tjudra",
      "pos": "action",
      "explanation": "to fasten + animal + action indicator",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        81,
        "/",
        122
      ]
    },
    {
      "id": 4296,
      "bciAvId": 24153,
      "gloss": "homosexual",
      "glossSv": "homosexuell",
      "pos": "description",
      "explanation": "homosexuality + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        1015,
        "/",
        1014
      ]
    },
    {
      "id": 4297,
      "bciAvId": 24154,
      "gloss": "homosexuality",
      "glossSv": "homosexualitet",
      "pos": "noun",
      "explanation": "feeling + couple (male) + couple (female): combination of male and female homosexuality, representing homosexuality in general, either male or female",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        1015,
        "/",
        1014
      ]
    },
    {
      "id": 4298,
      "bciAvId": 24156,
      "gloss": "hoof pick",
      "glossSv": "hovskrapa",
      "pos": "noun",
      "explanation": "tool + hoof",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        879
      ]
    },
    {
      "id": 4299,
      "bciAvId": 24157,
      "gloss": "horse box, stall",
      "glossSv": "spilta, hästbox",
      "pos": "noun",
      "explanation": "room + horse",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        391
      ]
    },
    {
      "id": 4300,
      "bciAvId": 24158,
      "gloss": "horse brush, body brush",
      "glossSv": "ryktborste",
      "pos": "noun",
      "explanation": "brush + horse",
      "isCharacter": false,
      "composition": [
        184,
        "/",
        391
      ]
    },
    {
      "id": 4301,
      "bciAvId": 24159,
      "gloss": "horse cloth",
      "glossSv": "hästtäcke",
      "pos": "noun",
      "explanation": "cloth + protection + horse",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        548,
        "/",
        391
      ]
    },
    {
      "id": 4302,
      "bciAvId": 24160,
      "gloss": "horse droppings",
      "glossSv": "hästspillning",
      "pos": "noun",
      "explanation": "waste + horse",
      "isCharacter": false,
      "composition": [
        694,
        "/",
        391
      ]
    },
    {
      "id": 4303,
      "bciAvId": 24161,
      "gloss": "horse trailer, horsebox",
      "glossSv": "hästtransport (kärra)",
      "pos": "noun",
      "explanation": "trailer,container transport + horse",
      "isCharacter": false,
      "composition": [
        1098,
        "/",
        391
      ]
    },
    {
      "id": 4304,
      "bciAvId": 24162,
      "gloss": "horsehair",
      "glossSv": "hästtagel",
      "pos": "noun",
      "explanation": "material + hair + horse",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        371,
        "/",
        391
      ]
    },
    {
      "id": 4305,
      "bciAvId": 24163,
      "gloss": "horseshoe",
      "glossSv": "hästsko",
      "pos": "noun",
      "explanation": "protection + hoof",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        879
      ]
    },
    {
      "id": 4306,
      "bciAvId": 24164,
      "gloss": "horseshoe nail",
      "glossSv": "hästskosöm",
      "pos": "noun",
      "explanation": "pin + horseshoe",
      "isCharacter": false,
      "composition": [
        524,
        "/",
        548,
        "/",
        879
      ]
    },
    {
      "id": 4307,
      "bciAvId": 24165,
      "gloss": "Hungary",
      "glossSv": "Ungern",
      "pos": "noun",
      "explanation": "a country that is a bridge between East and West",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        182,
        "/",
        282,
        "/",
        698
      ]
    },
    {
      "id": 4308,
      "bciAvId": 24166,
      "gloss": "hurry, rush",
      "glossSv": "brådska",
      "pos": "noun",
      "explanation": "time + fast",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 4309,
      "bciAvId": 24167,
      "gloss": "to hurry, to rush",
      "glossSv": "skynda sig",
      "pos": "action",
      "explanation": "hurry + action indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        81,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 4310,
      "bciAvId": 24168,
      "gloss": "hurry (in a), hurried, rushed",
      "glossSv": "bråttom",
      "pos": "description",
      "explanation": "hurry + description indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 4311,
      "bciAvId": 24169,
      "gloss": "hydrotherapy",
      "glossSv": "vattenterapi",
      "pos": "noun",
      "explanation": "therapy + activity + water",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        106,
        "/",
        695
      ]
    },
    {
      "id": 4312,
      "bciAvId": 24170,
      "gloss": "ice field",
      "glossSv": "isfält",
      "pos": "noun",
      "explanation": "much + ice",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        394
      ]
    },
    {
      "id": 4313,
      "bciAvId": 24171,
      "gloss": "iceberg",
      "glossSv": "isberg",
      "pos": "noun",
      "explanation": "mountain + ice",
      "isCharacter": false,
      "composition": [
        394,
        "/",
        456
      ]
    },
    {
      "id": 4314,
      "bciAvId": 24172,
      "gloss": "independent",
      "glossSv": "oberoende, självständig",
      "pos": "description",
      "explanation": "ability + self + description indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        86,
        "/",
        2343
      ]
    },
    {
      "id": 4315,
      "bciAvId": 24173,
      "gloss": "invisible",
      "glossSv": "osynlig",
      "pos": "description",
      "explanation": "without + to see + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        303,
        ";",
        86
      ]
    },
    {
      "id": 4316,
      "bciAvId": 24175,
      "gloss": "jaguar",
      "glossSv": "jaguar",
      "pos": "noun",
      "explanation": "animal + group of + spot: fur with small dots within larger rosette markings",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 4317,
      "bciAvId": 24177,
      "gloss": "knot",
      "glossSv": "knut",
      "pos": "noun",
      "explanation": "combination + string + thing indicator",
      "isCharacter": false,
      "composition": [
        232,
        "/",
        428,
        ";",
        97,
        "/",
        823
      ]
    },
    {
      "id": 4318,
      "bciAvId": 24178,
      "gloss": "Lent",
      "glossSv": "fastan",
      "pos": "noun",
      "explanation": "limited time + before + Easter",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        158,
        "/",
        258,
        "/",
        678,
        "/",
        248
      ]
    },
    {
      "id": 4319,
      "bciAvId": 24179,
      "gloss": "liberation",
      "glossSv": "befrielse",
      "pos": "noun",
      "explanation": "cause + freedom",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        336
      ]
    },
    {
      "id": 4320,
      "bciAvId": 24180,
      "gloss": "linear thing (horizontal), bar",
      "glossSv": "rak sak (vågrät), räcke, ribba",
      "pos": "noun",
      "explanation": "horizontal line + thing indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        97
      ]
    },
    {
      "id": 4321,
      "bciAvId": 24181,
      "gloss": "long time",
      "glossSv": "länge",
      "pos": "description",
      "explanation": "limited time + long + description indicator",
      "isCharacter": false,
      "composition": [
        426,
        ";",
        86,
        "/",
        420
      ]
    },
    {
      "id": 4322,
      "bciAvId": 24182,
      "gloss": "lower body",
      "glossSv": "underkropp, nedre kroppshalvan",
      "pos": "noun",
      "explanation": "below + waist",
      "isCharacter": false,
      "composition": [
        676,
        "/",
        690
      ]
    },
    {
      "id": 4323,
      "bciAvId": 24183,
      "gloss": "to make sign of the cross",
      "glossSv": "göra korstecken",
      "pos": "action",
      "explanation": "sign of the cross + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        248
      ]
    },
    {
      "id": 4324,
      "bciAvId": 24184,
      "gloss": "mane (horse)",
      "glossSv": "man (häst)",
      "pos": "noun",
      "explanation": "hair + horse neck",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        1045
      ]
    },
    {
      "id": 4325,
      "bciAvId": 24185,
      "gloss": "manure, fertiliser, fertilizer",
      "glossSv": "gödning, gödsel",
      "pos": "noun",
      "explanation": "addition + to grow + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        206,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 4326,
      "bciAvId": 24186,
      "gloss": "mare",
      "glossSv": "sto",
      "pos": "noun",
      "explanation": "horse + female",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        314
      ]
    },
    {
      "id": 4327,
      "bciAvId": 24187,
      "gloss": "meat (dried), dried meat",
      "glossSv": "kött (torkat)",
      "pos": "noun",
      "explanation": "meat + dry",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        860
      ]
    },
    {
      "id": 4328,
      "bciAvId": 24188,
      "gloss": "medical treatment, medical care",
      "glossSv": "behandling (medicinsk), sjukvård",
      "pos": "noun",
      "explanation": "help + medical",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        958
      ]
    },
    {
      "id": 4329,
      "bciAvId": 24189,
      "gloss": "menstrual blood",
      "glossSv": "mensblod",
      "pos": "noun",
      "explanation": "blood + uterus [contraction]",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        423,
        "/",
        681
      ]
    },
    {
      "id": 4330,
      "bciAvId": 24190,
      "gloss": "metal craft",
      "glossSv": "metallslöjd",
      "pos": "noun",
      "explanation": "craft + metal [contraction]",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        814
      ]
    },
    {
      "id": 4331,
      "bciAvId": 24191,
      "gloss": "to mew, to meow",
      "glossSv": "jama",
      "pos": "action",
      "explanation": "to talk + cat + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        126
      ]
    },
    {
      "id": 4332,
      "bciAvId": 24192,
      "gloss": "minister (government)",
      "glossSv": "minister",
      "pos": "person",
      "explanation": "leader + country",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        243
      ]
    },
    {
      "id": 4333,
      "bciAvId": 24193,
      "gloss": "monarchy",
      "glossSv": "monarki",
      "pos": "noun",
      "explanation": "country + royal",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        798
      ]
    },
    {
      "id": 4334,
      "bciAvId": 24194,
      "gloss": "to moo, to low",
      "glossSv": "råma",
      "pos": "action",
      "explanation": "to talk + cow + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        123,
        "/",
        314
      ]
    },
    {
      "id": 4335,
      "bciAvId": 24195,
      "gloss": "Mother's Day",
      "glossSv": "Mors dag",
      "pos": "noun",
      "explanation": "day + mother",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        455
      ]
    },
    {
      "id": 4336,
      "bciAvId": 24197,
      "gloss": "nature craft",
      "glossSv": "naturslöjd",
      "pos": "noun",
      "explanation": "craft + plant",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        533
      ]
    },
    {
      "id": 4337,
      "bciAvId": 24199,
      "gloss": "to neigh, to whinny",
      "glossSv": "gnägga",
      "pos": "action",
      "explanation": "to talk + horse + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        391
      ]
    },
    {
      "id": 4338,
      "bciAvId": 24200,
      "gloss": "occupational therapy",
      "glossSv": "arbetsterapi",
      "pos": "noun",
      "explanation": "therapy + activity",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        106
      ]
    },
    {
      "id": 4339,
      "bciAvId": 24201,
      "gloss": "occupational therapy room",
      "glossSv": "arbetsterapirum",
      "pos": "noun",
      "explanation": "room + occupational therapy",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        750,
        "/",
        106
      ]
    },
    {
      "id": 4340,
      "bciAvId": 24202,
      "gloss": "organ (body)",
      "glossSv": "organ, inre organ (FD)",
      "pos": "noun",
      "explanation": "generalization + kidney",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        880
      ]
    },
    {
      "id": 4341,
      "bciAvId": 24203,
      "gloss": "paddock",
      "glossSv": "fålla, inhägnad",
      "pos": "noun",
      "explanation": "enclosure + field + small",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        415,
        "/",
        956
      ]
    },
    {
      "id": 4342,
      "bciAvId": 24204,
      "gloss": "paper craft",
      "glossSv": "pappersslöjd, pappslöjd",
      "pos": "noun",
      "explanation": "craft + paper",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        497
      ]
    },
    {
      "id": 4343,
      "bciAvId": 24205,
      "gloss": "parachute harness",
      "glossSv": "fallskärmssele",
      "pos": "noun",
      "explanation": "harness + parachute + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        773
      ]
    },
    {
      "id": 4344,
      "bciAvId": 24206,
      "gloss": "parking lot",
      "glossSv": "parkeringsplats",
      "pos": "noun",
      "explanation": "place + vehicle",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        688
      ]
    },
    {
      "id": 4345,
      "bciAvId": 24207,
      "gloss": "passport",
      "glossSv": "pass",
      "pos": "noun",
      "explanation": "book + permission,allowance + travel",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        960,
        "/",
        667
      ]
    },
    {
      "id": 4346,
      "bciAvId": 24208,
      "gloss": "pasture, enclosed field",
      "glossSv": "hage, inhägnad",
      "pos": "noun",
      "explanation": "enclosure + field",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        415
      ]
    },
    {
      "id": 4347,
      "bciAvId": 24209,
      "gloss": "pavement, sidewalk",
      "glossSv": "trottoar",
      "pos": "noun",
      "explanation": "platform + to walk",
      "isCharacter": false,
      "composition": [
        884,
        "/",
        418
      ]
    },
    {
      "id": 4348,
      "bciAvId": 24211,
      "gloss": "physiotherapy",
      "glossSv": "sjukgymnastik",
      "pos": "noun",
      "explanation": "therapy + muscle",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        718
      ]
    },
    {
      "id": 4349,
      "bciAvId": 24212,
      "gloss": "physiotherapy room",
      "glossSv": "sjukgymnastikrum",
      "pos": "noun",
      "explanation": "room + physiotherapy",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        750,
        "/",
        718
      ]
    },
    {
      "id": 4350,
      "bciAvId": 24213,
      "gloss": "placenta",
      "glossSv": "moderkaka (FD)",
      "pos": "noun",
      "explanation": "organ (body) (OLD) + food + fetus",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        880,
        "/",
        329,
        "/",
        316
      ]
    },
    {
      "id": 4351,
      "bciAvId": 24215,
      "gloss": "politician",
      "glossSv": "politiker",
      "pos": "person",
      "explanation": "person + politics",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        885
      ]
    },
    {
      "id": 4352,
      "bciAvId": 24217,
      "gloss": "pram straps, safety harness",
      "glossSv": "babysele, barnvagnssele",
      "pos": "noun",
      "explanation": "harness + baby + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        140
      ]
    },
    {
      "id": 4353,
      "bciAvId": 24218,
      "gloss": "preceding, previous, former, earlier",
      "glossSv": "föregående",
      "pos": "description",
      "explanation": "first + in front of + description indicator",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        86,
        "/",
        4,
        "/",
        158
      ]
    },
    {
      "id": 4354,
      "bciAvId": 24219,
      "gloss": "prescription",
      "glossSv": "recept (på läkemedel)",
      "pos": "noun",
      "explanation": "paper + medicine",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        216,
        "/",
        958
      ]
    },
    {
      "id": 4355,
      "bciAvId": 24220,
      "gloss": "president",
      "glossSv": "president",
      "pos": "person",
      "explanation": "chairman + country",
      "isCharacter": false,
      "composition": [
        876,
        "/",
        243
      ]
    },
    {
      "id": 4356,
      "bciAvId": 24221,
      "gloss": "prime minister",
      "glossSv": "statsminister",
      "pos": "person",
      "explanation": "leader + country + first",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        243,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 4357,
      "bciAvId": 24222,
      "gloss": "program, programme",
      "glossSv": "program",
      "pos": "noun",
      "explanation": "paper + plan + future: e.g. radio and tv",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        532,
        "/",
        341
      ]
    },
    {
      "id": 4358,
      "bciAvId": 24223,
      "gloss": "protected, saved",
      "glossSv": "fridlyst, skyddad",
      "pos": "description",
      "explanation": "protection + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        84
      ]
    },
    {
      "id": 4359,
      "bciAvId": 24224,
      "gloss": "protection of the environment",
      "glossSv": "miljövård, naturskydd",
      "pos": "noun",
      "explanation": "protection + environment",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        294
      ]
    },
    {
      "id": 4360,
      "bciAvId": 24225,
      "gloss": "prune",
      "glossSv": "katrinplommon",
      "pos": "noun",
      "explanation": "plum + dry",
      "isCharacter": false,
      "composition": [
        537,
        "/",
        860
      ]
    },
    {
      "id": 4361,
      "bciAvId": 24226,
      "gloss": "psychology room",
      "glossSv": "psykologrum",
      "pos": "noun",
      "explanation": "room + psychology (class)",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        412,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 4362,
      "bciAvId": 24227,
      "gloss": "public transport",
      "glossSv": "kollektivtrafik",
      "pos": "noun",
      "explanation": "generalization + bus",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        188
      ]
    },
    {
      "id": 4363,
      "bciAvId": 24228,
      "gloss": "to purr (cat)",
      "glossSv": "spinna (katt)",
      "pos": "action",
      "explanation": "to talk + feeling + cat + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        313,
        "/",
        126
      ]
    },
    {
      "id": 4364,
      "bciAvId": 24230,
      "gloss": "to rack, to single-foot",
      "glossSv": "tölta",
      "pos": "action",
      "explanation": "horse + Iceland + action indicator: a pace typical for Icelandic horses",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        243,
        "/",
        394,
        "/",
        319
      ]
    },
    {
      "id": 4365,
      "bciAvId": 24231,
      "gloss": "raisin(s), currant(s)",
      "glossSv": "russin",
      "pos": "noun",
      "explanation": "grape,grapes + dry",
      "isCharacter": false,
      "composition": [
        365,
        "/",
        860
      ]
    },
    {
      "id": 4366,
      "bciAvId": 24232,
      "gloss": "rash (skin)",
      "glossSv": "utslag",
      "pos": "noun",
      "explanation": "group of + dot + body: where body represents skin [contraction]",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        270,
        "/",
        171
      ]
    },
    {
      "id": 4367,
      "bciAvId": 24233,
      "gloss": "to reclaim (marshes etc)",
      "glossSv": "torrlägga, dränera",
      "pos": "action",
      "explanation": "to dry + land + action indicator",
      "isCharacter": false,
      "composition": [
        860,
        ";",
        81,
        "/",
        281
      ]
    },
    {
      "id": 4368,
      "bciAvId": 24234,
      "gloss": "religious fanatic",
      "glossSv": "fanatiker (religiös)",
      "pos": "person",
      "explanation": "fanatic + religion",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954,
        "/",
        401,
        "/",
        726
      ]
    },
    {
      "id": 4369,
      "bciAvId": 24235,
      "gloss": "religious fanatic (God based)",
      "glossSv": "fanatiker (religiös, gudsbaserad)",
      "pos": "person",
      "explanation": "fanatic + religion (God based)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954,
        "/",
        401,
        "/",
        725
      ]
    },
    {
      "id": 4370,
      "bciAvId": 24236,
      "gloss": "repair room",
      "glossSv": "verkstad (rum)",
      "pos": "noun",
      "explanation": "room + to repair",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        840,
        "/",
        711
      ]
    },
    {
      "id": 4371,
      "bciAvId": 24237,
      "gloss": "repair shop",
      "glossSv": "verkstad (byggnad)",
      "pos": "noun",
      "explanation": "house + to repair",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        840,
        "/",
        711
      ]
    },
    {
      "id": 4372,
      "bciAvId": 24238,
      "gloss": "republic",
      "glossSv": "republik",
      "pos": "noun",
      "explanation": "country + leader + choice",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        736,
        "/",
        223
      ]
    },
    {
      "id": 4373,
      "bciAvId": 24239,
      "gloss": "respirator",
      "glossSv": "respirator",
      "pos": "noun",
      "explanation": "machine + breath",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 4374,
      "bciAvId": 24241,
      "gloss": "responsible",
      "glossSv": "ansvarig, ansvarsfull",
      "pos": "description",
      "explanation": "responsibility + description indicator",
      "isCharacter": false,
      "composition": [
        886,
        ";",
        86
      ]
    },
    {
      "id": 4375,
      "bciAvId": 24242,
      "gloss": "Resurrection of Christ",
      "glossSv": "Kristi uppståndelse",
      "pos": "noun",
      "explanation": "resurrection + Christ",
      "isCharacter": false,
      "composition": [
        678,
        "/",
        259,
        "/",
        433,
        "/",
        248
      ]
    },
    {
      "id": 4376,
      "bciAvId": 24243,
      "gloss": "riding boots",
      "glossSv": "ridstövlar",
      "pos": "noun",
      "explanation": "boots + horse: where horse represents riding [contraction]",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        1052,
        "/",
        391
      ]
    },
    {
      "id": 4377,
      "bciAvId": 24244,
      "gloss": "riding clothes",
      "glossSv": "ridkläder",
      "pos": "noun",
      "explanation": "clothes + horse: where horse represents riding [contraction]",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        391
      ]
    },
    {
      "id": 4378,
      "bciAvId": 24245,
      "gloss": "riding instructor",
      "glossSv": "ridlärare",
      "pos": "person",
      "explanation": "teacher [contraction] + horse: where horse represents riding [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        391
      ]
    },
    {
      "id": 4379,
      "bciAvId": 24246,
      "gloss": "riding school, manege",
      "glossSv": "ridbana, manege",
      "pos": "noun",
      "explanation": "place + knowledge + horse: a place for training",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        412,
        "/",
        391
      ]
    },
    {
      "id": 4380,
      "bciAvId": 24247,
      "gloss": "road (2)",
      "glossSv": "väg, körbana (2)",
      "pos": "noun",
      "explanation": "place + activity + vehicle",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        688
      ]
    },
    {
      "id": 4381,
      "bciAvId": 24248,
      "gloss": "to roar (lion)",
      "glossSv": "ryta (lejon)",
      "pos": "action",
      "explanation": "to talk + lion + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        126,
        "/",
        1054
      ]
    },
    {
      "id": 4382,
      "bciAvId": 24250,
      "gloss": "royal",
      "glossSv": "kunglig",
      "pos": "description",
      "explanation": "crown + description indicator",
      "isCharacter": false,
      "composition": [
        798,
        ";",
        86
      ]
    },
    {
      "id": 4383,
      "bciAvId": 24251,
      "gloss": "royal family",
      "glossSv": "kungafamilj",
      "pos": "noun",
      "explanation": "family + royal",
      "isCharacter": false,
      "composition": [
        730,
        "/",
        798
      ]
    },
    {
      "id": 4384,
      "bciAvId": 24252,
      "gloss": "saddle pad, saddle blanket",
      "glossSv": "sadelfilt",
      "pos": "noun",
      "explanation": "cloth + saddle",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        517,
        "/",
        391
      ]
    },
    {
      "id": 4385,
      "bciAvId": 24253,
      "gloss": "salvation (religious)",
      "glossSv": "frälsning (religiös)",
      "pos": "noun",
      "explanation": "liberation + religious",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        336,
        "/",
        726
      ]
    },
    {
      "id": 4386,
      "bciAvId": 24254,
      "gloss": "scabies",
      "glossSv": "skabb",
      "pos": "noun",
      "explanation": "insect + skin + plural indicator",
      "isCharacter": false,
      "composition": [
        400,
        ";",
        99,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 4387,
      "bciAvId": 24255,
      "gloss": "seat belt",
      "glossSv": "säkerhetsbälte, bilbälte",
      "pos": "noun",
      "explanation": "harness + vehicle + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        688
      ]
    },
    {
      "id": 4388,
      "bciAvId": 24256,
      "gloss": "service (help)",
      "glossSv": "service (hjälp), betjäning",
      "pos": "noun",
      "explanation": "activity + to give + help",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        949,
        "/",
        382
      ]
    },
    {
      "id": 4389,
      "bciAvId": 24257,
      "gloss": "sexual activity",
      "glossSv": "sexualliv",
      "pos": "noun",
      "explanation": "activity + gender,sex",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        347
      ]
    },
    {
      "id": 4390,
      "bciAvId": 24258,
      "gloss": "sexual aid",
      "glossSv": "sexhjälpmedel",
      "pos": "noun",
      "explanation": "aid + gender,sex + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        347
      ]
    },
    {
      "id": 4391,
      "bciAvId": 24259,
      "gloss": "sexual play",
      "glossSv": "sexlek",
      "pos": "noun",
      "explanation": "play + gender,sex",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        678,
        "/",
        347
      ]
    },
    {
      "id": 4392,
      "bciAvId": 24260,
      "gloss": "sexually mature",
      "glossSv": "könsmogen",
      "pos": "description",
      "explanation": "mature + gender,sex + description indicator",
      "isCharacter": false,
      "composition": [
        108,
        ";",
        86,
        "/",
        347
      ]
    },
    {
      "id": 4393,
      "bciAvId": 24261,
      "gloss": "shall, will - (modal aux v)",
      "glossSv": "skall, kommer att",
      "pos": "action",
      "explanation": "then + action indicator: auxiliary verb for future",
      "isCharacter": false,
      "composition": [
        648,
        ";",
        81
      ]
    },
    {
      "id": 4394,
      "bciAvId": 24262,
      "gloss": "to shampoo",
      "glossSv": "tvätta håret",
      "pos": "action",
      "explanation": "shampoo + action indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        81,
        "/",
        372
      ]
    },
    {
      "id": 4395,
      "bciAvId": 24263,
      "gloss": "to shave",
      "glossSv": "raka",
      "pos": "action",
      "explanation": "knife + hair + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        371
      ]
    },
    {
      "id": 4396,
      "bciAvId": 24264,
      "gloss": "should, would - (modal aux v)",
      "glossSv": "skulle",
      "pos": "action",
      "explanation": "then + conditional indicator: auxiliary verb for future conditional",
      "isCharacter": false,
      "composition": [
        648,
        ";",
        83
      ]
    },
    {
      "id": 4397,
      "bciAvId": 24265,
      "gloss": "sign of the cross",
      "glossSv": "korstecken",
      "pos": "noun",
      "explanation": "hand + cross: where the cross represents Christ [contraction]",
      "isCharacter": false,
      "composition": [
        374,
        "/",
        248
      ]
    },
    {
      "id": 4398,
      "bciAvId": 24266,
      "gloss": "skin disease, eczema",
      "glossSv": "hudsjukdom, eksem",
      "pos": "noun",
      "explanation": "illness + skin",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 4399,
      "bciAvId": 24267,
      "gloss": "skytrain, monorail",
      "glossSv": "monorail, skytrain, balktåg",
      "pos": "noun",
      "explanation": "vehicle + above",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        493
      ]
    },
    {
      "id": 4400,
      "bciAvId": 24268,
      "gloss": "slow, slowly",
      "glossSv": "långsam, sakta",
      "pos": "description",
      "explanation": "forward + negative + description indicator",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4401,
      "bciAvId": 24269,
      "gloss": "social",
      "glossSv": "social",
      "pos": "description",
      "explanation": "society + description indicator",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        225,
        ";",
        86
      ]
    },
    {
      "id": 4402,
      "bciAvId": 24270,
      "gloss": "society",
      "glossSv": "samhället",
      "pos": "noun",
      "explanation": "generalization + citizen",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        225
      ]
    },
    {
      "id": 4403,
      "bciAvId": 24273,
      "gloss": "somersault (person)",
      "glossSv": "kullerbytta (2)",
      "pos": "noun",
      "explanation": "somersault + person",
      "isCharacter": false,
      "composition": [
        888,
        "/",
        513
      ]
    },
    {
      "id": 4404,
      "bciAvId": 24274,
      "gloss": "spark",
      "glossSv": "gnista",
      "pos": "noun",
      "explanation": "flame + star",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        622
      ]
    },
    {
      "id": 4405,
      "bciAvId": 24275,
      "gloss": "spasm",
      "glossSv": "spasm, tics",
      "pos": "noun",
      "explanation": "activity + muscle + sudden",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        718,
        "/",
        655,
        "/",
        425
      ]
    },
    {
      "id": 4406,
      "bciAvId": 24276,
      "gloss": "speech therapy",
      "glossSv": "logopedi",
      "pos": "noun",
      "explanation": "therapy + language",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        414
      ]
    },
    {
      "id": 4407,
      "bciAvId": 24277,
      "gloss": "speech therapy room",
      "glossSv": "logopedrum, talklinik",
      "pos": "noun",
      "explanation": "room + speech therapy",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        750,
        "/",
        414
      ]
    },
    {
      "id": 4408,
      "bciAvId": 24278,
      "gloss": "spiritual awareness",
      "glossSv": "andlig medvetenhet",
      "pos": "noun",
      "explanation": "insight + spirit",
      "isCharacter": false,
      "composition": [
        743,
        "/",
        735
      ]
    },
    {
      "id": 4409,
      "bciAvId": 24279,
      "gloss": "splint (orthopedic)",
      "glossSv": "ortos, skena, stödbandage",
      "pos": "noun",
      "explanation": "aid + bones with joint + thing indicator: where bones with joint represents joint [contraction]",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002
      ]
    },
    {
      "id": 4410,
      "bciAvId": 24280,
      "gloss": "sport fanatic",
      "glossSv": "sportfanatiker",
      "pos": "person",
      "explanation": "fanatic + sport",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        954,
        "/",
        401,
        "/",
        719
      ]
    },
    {
      "id": 4411,
      "bciAvId": 24282,
      "gloss": "stallion, entire",
      "glossSv": "hingst",
      "pos": "noun",
      "explanation": "horse + male",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        106
      ]
    },
    {
      "id": 4412,
      "bciAvId": 24283,
      "gloss": "starvation",
      "glossSv": "svält",
      "pos": "noun",
      "explanation": "life + without + food",
      "isCharacter": false,
      "composition": [
        423,
        "/",
        449,
        "/",
        329
      ]
    },
    {
      "id": 4413,
      "bciAvId": 24284,
      "gloss": "station",
      "glossSv": "station",
      "pos": "noun",
      "explanation": "group of + platform",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        884
      ]
    },
    {
      "id": 4414,
      "bciAvId": 24285,
      "gloss": "still, continuing, ongoing",
      "glossSv": "ännu",
      "pos": "description",
      "explanation": "continuance,continuation + description indicator",
      "isCharacter": false,
      "composition": [
        1162,
        ";",
        86
      ]
    },
    {
      "id": 4415,
      "bciAvId": 24286,
      "gloss": "still, continuously",
      "glossSv": "fortfarande",
      "pos": "description",
      "explanation": "time + to continue + description indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        1162
      ]
    },
    {
      "id": 4416,
      "bciAvId": 24287,
      "gloss": "stirrup",
      "glossSv": "stigbygel",
      "pos": "noun",
      "explanation": "support + foot + riding [contraction] + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        330,
        "/",
        391
      ]
    },
    {
      "id": 4417,
      "bciAvId": 24288,
      "gloss": "stomach flu",
      "glossSv": "maginfluensa, kräksjuka",
      "pos": "noun",
      "explanation": "illness + vomit",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        491,
        "/",
        329
      ]
    },
    {
      "id": 4418,
      "bciAvId": 24289,
      "gloss": "stomach illness",
      "glossSv": "magsjukdom",
      "pos": "noun",
      "explanation": "illness + stomach",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        628
      ]
    },
    {
      "id": 4419,
      "bciAvId": 24290,
      "gloss": "stop, platform (vehicle)",
      "glossSv": "hållplats, perrong",
      "pos": "noun",
      "explanation": "platform + vehicle",
      "isCharacter": false,
      "composition": [
        884,
        "/",
        688
      ]
    },
    {
      "id": 4420,
      "bciAvId": 24291,
      "gloss": "to stretch (elongate)",
      "glossSv": "sträcka ut",
      "pos": "action",
      "explanation": "to make + long + action indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        420
      ]
    },
    {
      "id": 4421,
      "bciAvId": 24292,
      "gloss": "to stretch (muscles)",
      "glossSv": "stretcha",
      "pos": "action",
      "explanation": "muscle + long + action indicator",
      "isCharacter": false,
      "composition": [
        718,
        ";",
        81,
        "/",
        420
      ]
    },
    {
      "id": 4422,
      "bciAvId": 24293,
      "gloss": "striped",
      "glossSv": "randig",
      "pos": "description",
      "explanation": "many + line + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        86
      ]
    },
    {
      "id": 4423,
      "bciAvId": 24294,
      "gloss": "to study",
      "glossSv": "studera",
      "pos": "action",
      "explanation": "activity + learning + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        920,
        "/",
        412
      ]
    },
    {
      "id": 4424,
      "bciAvId": 24295,
      "gloss": "stupid, dumb",
      "glossSv": "dum, obegåvad",
      "pos": "description",
      "explanation": "without + smartness + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        447,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 4425,
      "bciAvId": 24296,
      "gloss": "subway, metro, underground, tube",
      "glossSv": "tunnelbana",
      "pos": "noun",
      "explanation": "vehicle + under",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        676
      ]
    },
    {
      "id": 4426,
      "bciAvId": 24297,
      "gloss": "sunflower",
      "glossSv": "solros",
      "pos": "noun",
      "explanation": "flower + sun",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        636
      ]
    },
    {
      "id": 4427,
      "bciAvId": 24298,
      "gloss": "walker, walking aid (1)",
      "glossSv": "gånghjälpmedel",
      "pos": "noun",
      "explanation": "aid + activity + walk + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        106,
        "/",
        418
      ]
    },
    {
      "id": 4428,
      "bciAvId": 24299,
      "gloss": "to switch off, to turn off",
      "glossSv": "stänga av, slå av, släcka",
      "pos": "action",
      "explanation": "switch + minus + action indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        374,
        "/",
        449
      ]
    },
    {
      "id": 4429,
      "bciAvId": 24300,
      "gloss": "to switch on, to turn on",
      "glossSv": "sätta på, slå på, tända",
      "pos": "action",
      "explanation": "switch + plus + action indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        374,
        "/",
        120
      ]
    },
    {
      "id": 4430,
      "bciAvId": 24301,
      "gloss": "tack room",
      "glossSv": "sadelkammare",
      "pos": "noun",
      "explanation": "room + tool + horse",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        660,
        "/",
        391
      ]
    },
    {
      "id": 4431,
      "bciAvId": 24303,
      "gloss": "tail (horse)",
      "glossSv": "hästsvans",
      "pos": "noun",
      "explanation": "hair + horse rump",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        1046
      ]
    },
    {
      "id": 4432,
      "bciAvId": 24304,
      "gloss": "tail lift, lift",
      "glossSv": "lift",
      "pos": "noun",
      "explanation": "platform + up and down",
      "isCharacter": false,
      "composition": [
        884,
        "/",
        723
      ]
    },
    {
      "id": 4433,
      "bciAvId": 24305,
      "gloss": "teamwork",
      "glossSv": "teamarbete, grupparbete, lagarbete",
      "pos": "noun",
      "explanation": "work + together",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        823
      ]
    },
    {
      "id": 4434,
      "bciAvId": 24306,
      "gloss": "teetotalism",
      "glossSv": "absolutism, nykterism",
      "pos": "noun",
      "explanation": "decision + without + alcohol",
      "isCharacter": false,
      "composition": [
        260,
        "/",
        449,
        "/",
        116
      ]
    },
    {
      "id": 4435,
      "bciAvId": 24307,
      "gloss": "temporary",
      "glossSv": "tillfällig",
      "pos": "description",
      "explanation": "limited time + description indicator",
      "isCharacter": false,
      "composition": [
        426,
        ";",
        86
      ]
    },
    {
      "id": 4436,
      "bciAvId": 24308,
      "gloss": "textile craft",
      "glossSv": "textilslöjd, textilhantverk",
      "pos": "noun",
      "explanation": "craft + cloth",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        228
      ]
    },
    {
      "id": 4437,
      "bciAvId": 24310,
      "gloss": "therapeutic riding",
      "glossSv": "ridning (som terapi)",
      "pos": "noun",
      "explanation": "therapy + riding",
      "isCharacter": false,
      "composition": [
        750,
        "/",
        106,
        "/",
        391
      ]
    },
    {
      "id": 4438,
      "bciAvId": 24311,
      "gloss": "to tie, to bind together, to lash",
      "glossSv": "knyta",
      "pos": "action",
      "explanation": "knot + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        232,
        ";",
        81,
        "/",
        428,
        ";",
        97,
        "/",
        823
      ]
    },
    {
      "id": 4439,
      "bciAvId": 24312,
      "gloss": "towel",
      "glossSv": "handduk",
      "pos": "noun",
      "explanation": "cloth + dry",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        860
      ]
    },
    {
      "id": 4440,
      "bciAvId": 24314,
      "gloss": "train station (building)",
      "glossSv": "resecentrum, järnvägsstation",
      "pos": "noun",
      "explanation": "house + train",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 4441,
      "bciAvId": 24315,
      "gloss": "train station (platforms)",
      "glossSv": "järnvägsstation",
      "pos": "noun",
      "explanation": "station + train",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        884,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 4442,
      "bciAvId": 24316,
      "gloss": "tram",
      "glossSv": "spårvagn",
      "pos": "noun",
      "explanation": "vehicle (long) + track",
      "isCharacter": false,
      "composition": [
        892,
        "/",
        849
      ]
    },
    {
      "id": 4443,
      "bciAvId": 24317,
      "gloss": "to treat, to care for (medically)",
      "glossSv": "behandla, vårda (medicinskt)",
      "pos": "action",
      "explanation": "medical treatment + action indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        81,
        "/",
        958
      ]
    },
    {
      "id": 4444,
      "bciAvId": 24318,
      "gloss": "trolleybus",
      "glossSv": "trådbuss",
      "pos": "noun",
      "explanation": "bus + electricity",
      "isCharacter": false,
      "composition": [
        188,
        "/",
        288
      ]
    },
    {
      "id": 4445,
      "bciAvId": 24319,
      "gloss": "to trot (horse)",
      "glossSv": "trava",
      "pos": "action",
      "explanation": "horse + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 4446,
      "bciAvId": 24320,
      "gloss": "tumble-drier, tumble-dryer",
      "glossSv": "torktumlare",
      "pos": "noun",
      "explanation": "machine + dry + cloth",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        860,
        "/",
        228
      ]
    },
    {
      "id": 4447,
      "bciAvId": 24321,
      "gloss": "tunnel, subway, underpass",
      "glossSv": "tunnel",
      "pos": "noun",
      "explanation": "pipe + under",
      "isCharacter": false,
      "composition": [
        527,
        "/",
        676
      ]
    },
    {
      "id": 4448,
      "bciAvId": 24322,
      "gloss": "underground station, subway station",
      "glossSv": "tunnelbanestation",
      "pos": "noun",
      "explanation": "station + under",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        884,
        "/",
        676
      ]
    },
    {
      "id": 4449,
      "bciAvId": 24323,
      "gloss": "to unharness (horse)",
      "glossSv": "sela av",
      "pos": "action",
      "explanation": "to remove + harness + horse + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        391
      ]
    },
    {
      "id": 4450,
      "bciAvId": 24324,
      "gloss": "union (political unit)",
      "glossSv": "union",
      "pos": "noun",
      "explanation": "group of + country + together: Add specific letters for the appropriate union e g NATO.",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        243,
        "/",
        823
      ]
    },
    {
      "id": 4451,
      "bciAvId": 24325,
      "gloss": "upper body",
      "glossSv": "överkropp, övre kroppshalvan",
      "pos": "noun",
      "explanation": "above + waist",
      "isCharacter": false,
      "composition": [
        493,
        "/",
        690
      ]
    },
    {
      "id": 4452,
      "bciAvId": 24326,
      "gloss": "vaginal discharge",
      "glossSv": "flytning (från slidan)",
      "pos": "noun",
      "explanation": "liquid + vagina + down",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        682,
        "/",
        271
      ]
    },
    {
      "id": 4453,
      "bciAvId": 24327,
      "gloss": "to walk (horse)",
      "glossSv": "skritta",
      "pos": "action",
      "explanation": "horse + action indicator",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81
      ]
    },
    {
      "id": 4454,
      "bciAvId": 24328,
      "gloss": "walkway, footpath",
      "glossSv": "gångbana, stig",
      "pos": "noun",
      "explanation": "place + activity + to walk",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        106,
        "/",
        418
      ]
    },
    {
      "id": 4455,
      "bciAvId": 24329,
      "gloss": "wart, papilloma (venereal)",
      "glossSv": "vårta, papillom (venerisk)",
      "pos": "noun",
      "explanation": "dot + genitals",
      "isCharacter": false,
      "composition": [
        270,
        "/",
        349
      ]
    },
    {
      "id": 4456,
      "bciAvId": 24330,
      "gloss": "to water",
      "glossSv": "vattna",
      "pos": "action",
      "explanation": "to give + water + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        695
      ]
    },
    {
      "id": 4457,
      "bciAvId": 24331,
      "gloss": "water bucket",
      "glossSv": "vattenhink, vattenspann",
      "pos": "noun",
      "explanation": "bucket + water",
      "isCharacter": false,
      "composition": [
        495,
        "/",
        695
      ]
    },
    {
      "id": 4458,
      "bciAvId": 24333,
      "gloss": "venereal disease",
      "glossSv": "könssjukdom",
      "pos": "noun",
      "explanation": "illness + sexual",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        347
      ]
    },
    {
      "id": 4459,
      "bciAvId": 24334,
      "gloss": "venereal papilloma",
      "glossSv": "kondylom",
      "pos": "noun",
      "explanation": "group of + wart,papilloma (venereal)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        270,
        "/",
        349
      ]
    },
    {
      "id": 4460,
      "bciAvId": 24335,
      "gloss": "wheelchair straps",
      "glossSv": "rullstolsbälte",
      "pos": "noun",
      "explanation": "harness + wheelchair + thing indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        428,
        ";",
        97,
        "/",
        232,
        "/",
        701
      ]
    },
    {
      "id": 4461,
      "bciAvId": 24336,
      "gloss": "wild strawberry",
      "glossSv": "smultron",
      "pos": "noun",
      "explanation": "strawberry + small",
      "isCharacter": false,
      "composition": [
        631,
        "/",
        956
      ]
    },
    {
      "id": 4462,
      "bciAvId": 24337,
      "gloss": "visa",
      "glossSv": "visum",
      "pos": "noun",
      "explanation": "paper + permission + travel",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        960,
        "/",
        667
      ]
    },
    {
      "id": 4463,
      "bciAvId": 24338,
      "gloss": "to volte (horse)",
      "glossSv": "rida i volt",
      "pos": "action",
      "explanation": "horse + rotation + action indicator: a circular movement executed by a horse in manège",
      "isCharacter": false,
      "composition": [
        391,
        ";",
        81,
        "/",
        887
      ]
    },
    {
      "id": 4464,
      "bciAvId": 24339,
      "gloss": "woodcraft",
      "glossSv": "träslöjd, trähantverk",
      "pos": "noun",
      "explanation": "craft + wood",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        666
      ]
    },
    {
      "id": 4465,
      "bciAvId": 24340,
      "gloss": "wrist splint",
      "glossSv": "handledsskena, handledsortos",
      "pos": "noun",
      "explanation": "aid + bones with joint + wrist + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        1002,
        "/",
        714
      ]
    },
    {
      "id": 4466,
      "bciAvId": 24401,
      "gloss": "to achieve",
      "glossSv": "prestera, uträtta",
      "pos": "action",
      "explanation": "achievement + action indicator",
      "isCharacter": false,
      "composition": [
        284,
        ";",
        81,
        "/",
        313,
        "/",
        493
      ]
    },
    {
      "id": 4467,
      "bciAvId": 24402,
      "gloss": "achievement",
      "glossSv": "prestation",
      "pos": "noun",
      "explanation": "effect + proud",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        313,
        "/",
        493
      ]
    },
    {
      "id": 4468,
      "bciAvId": 24403,
      "gloss": "addict",
      "glossSv": "missbrukare",
      "pos": "person",
      "explanation": "person + addiction",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        516,
        "/",
        467
      ]
    },
    {
      "id": 4469,
      "bciAvId": 24404,
      "gloss": "addiction",
      "glossSv": "missbruk (alkohol etc)",
      "pos": "noun",
      "explanation": "illness + need",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        467
      ]
    },
    {
      "id": 4470,
      "bciAvId": 24405,
      "gloss": "alcoholism, alcohol addiction",
      "glossSv": "alkoholism, alkoholberoende",
      "pos": "noun",
      "explanation": "illness + need",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        467,
        "/",
        116
      ]
    },
    {
      "id": 4471,
      "bciAvId": 24406,
      "gloss": "alcohol abuse, alcohol addiction",
      "glossSv": "alkoholmissbruk, alkoholberoende",
      "pos": "noun",
      "explanation": "negative dependency + alcohol",
      "isCharacter": false,
      "composition": [
        467,
        "/",
        449,
        "/",
        401,
        "/",
        116
      ]
    },
    {
      "id": 4472,
      "bciAvId": 24407,
      "gloss": "allergy, hypersensitivity",
      "glossSv": "allergi, överkänslighet",
      "pos": "noun",
      "explanation": "reaction + body",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        145,
        "/",
        284,
        "/",
        171
      ]
    },
    {
      "id": 4473,
      "bciAvId": 24408,
      "gloss": "baby animal",
      "glossSv": "djurunge",
      "pos": "noun",
      "explanation": "animal + baby",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        140
      ]
    },
    {
      "id": 4474,
      "bciAvId": 24409,
      "gloss": "baby bottle, feeding bottle",
      "glossSv": "nappflaska",
      "pos": "noun",
      "explanation": "bottle + baby",
      "isCharacter": false,
      "composition": [
        174,
        "/",
        140
      ]
    },
    {
      "id": 4475,
      "bciAvId": 24410,
      "gloss": "bacterial infection",
      "glossSv": "bakterieinfektion",
      "pos": "noun",
      "explanation": "illness + bacterium",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        10,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4476,
      "bciAvId": 24411,
      "gloss": "bacterium",
      "glossSv": "bakterie",
      "pos": "noun",
      "explanation": "1 + micro-organism: single cell micro-organism",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4477,
      "bciAvId": 24412,
      "gloss": "to bend",
      "glossSv": "böja",
      "pos": "action",
      "explanation": "curved line + action indicator",
      "isCharacter": false,
      "composition": [
        255,
        ";",
        81
      ]
    },
    {
      "id": 4478,
      "bciAvId": 24413,
      "gloss": "bet",
      "glossSv": "vad, insats",
      "pos": "noun",
      "explanation": "money + competition",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        554
      ]
    },
    {
      "id": 4479,
      "bciAvId": 24414,
      "gloss": "to bet",
      "glossSv": "slå vad",
      "pos": "action",
      "explanation": "bet + action indicator",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        81,
        "/",
        554
      ]
    },
    {
      "id": 4480,
      "bciAvId": 24415,
      "gloss": "betting",
      "glossSv": "vadslagning",
      "pos": "noun",
      "explanation": "activity + bet",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        451,
        "/",
        554
      ]
    },
    {
      "id": 4481,
      "bciAvId": 24416,
      "gloss": "binoculars, field glass",
      "glossSv": "kikare (FD)",
      "pos": "noun",
      "explanation": "tool + to look + distance (OLD)",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        946
      ]
    },
    {
      "id": 4482,
      "bciAvId": 24417,
      "gloss": "blacksmith",
      "glossSv": "smed",
      "pos": "person",
      "explanation": "person + iron [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        814,
        "/",
        463
      ]
    },
    {
      "id": 4483,
      "bciAvId": 24418,
      "gloss": "bottle nipple, teat",
      "glossSv": "flasknapp",
      "pos": "noun",
      "explanation": "bottleneck,bottle opening + baby: modified baby bottle with a pointer, to nipple",
      "isCharacter": false,
      "composition": [
        1003,
        "/",
        140
      ]
    },
    {
      "id": 4484,
      "bciAvId": 24419,
      "gloss": "bruise, contusion, haematoma, hematoma",
      "glossSv": "blåmärke",
      "pos": "noun",
      "explanation": "spot + blue",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        270,
        "/",
        1161,
        "/",
        597
      ]
    },
    {
      "id": 4485,
      "bciAvId": 24420,
      "gloss": "bruise, dent",
      "glossSv": "bula, buckla, svullnad",
      "pos": "noun",
      "explanation": "spot + bump",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        270,
        "/",
        893
      ]
    },
    {
      "id": 4486,
      "bciAvId": 24421,
      "gloss": "bruised, dented",
      "glossSv": "bucklig, svullen",
      "pos": "description",
      "explanation": "bruise,dent + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        270,
        "/",
        893
      ]
    },
    {
      "id": 4487,
      "bciAvId": 24423,
      "gloss": "to bump, to press",
      "glossSv": "stöta",
      "pos": "action",
      "explanation": "bump,press,pressing + action indicator",
      "isCharacter": false,
      "composition": [
        893,
        ";",
        81
      ]
    },
    {
      "id": 4488,
      "bciAvId": 24424,
      "gloss": "cease-fire, armistice",
      "glossSv": "vapenvila",
      "pos": "noun",
      "explanation": "agreement + stop + war",
      "isCharacter": false,
      "composition": [
        113,
        "/",
        292,
        "/",
        693
      ]
    },
    {
      "id": 4489,
      "bciAvId": 24425,
      "gloss": "Ceres (dwarf planet)",
      "glossSv": "Ceres",
      "pos": "noun",
      "explanation": "dwarf planet + middle",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        956,
        "/",
        446
      ]
    },
    {
      "id": 4490,
      "bciAvId": 24426,
      "gloss": "chance, risk",
      "glossSv": "chans, risk",
      "pos": "noun",
      "explanation": "choice + future (uncertain)",
      "isCharacter": false,
      "composition": [
        223,
        "/",
        1042
      ]
    },
    {
      "id": 4491,
      "bciAvId": 24427,
      "gloss": "chive",
      "glossSv": "gräslök",
      "pos": "noun",
      "explanation": "onion + grass",
      "isCharacter": false,
      "composition": [
        686,
        "/",
        366
      ]
    },
    {
      "id": 4492,
      "bciAvId": 24428,
      "gloss": "control",
      "glossSv": "kontroll (FD)",
      "pos": "noun",
      "explanation": "leadership + limit(s),limitation (OLD)",
      "isCharacter": false,
      "composition": [
        803,
        "/",
        427
      ]
    },
    {
      "id": 4493,
      "bciAvId": 24429,
      "gloss": "dependency",
      "glossSv": "beroende (subst.)",
      "pos": "noun",
      "explanation": "need + intensity",
      "isCharacter": false,
      "composition": [
        467,
        "/",
        401
      ]
    },
    {
      "id": 4494,
      "bciAvId": 24430,
      "gloss": "disability benefit",
      "glossSv": "aktivitetsersättning, sjukersättning (FD)",
      "pos": "noun",
      "explanation": "money + disability,handicap,impairment (OLD)",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        101,
        "/",
        427
      ]
    },
    {
      "id": 4495,
      "bciAvId": 24431,
      "gloss": "dish rack",
      "glossSv": "diskställ",
      "pos": "noun",
      "explanation": "sieve + glassware",
      "isCharacter": false,
      "composition": [
        594,
        "/",
        348,
        "/",
        352
      ]
    },
    {
      "id": 4496,
      "bciAvId": 24432,
      "gloss": "domino",
      "glossSv": "domino",
      "pos": "noun",
      "explanation": "game [contraction] + tile",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        899
      ]
    },
    {
      "id": 4497,
      "bciAvId": 24433,
      "gloss": "to dribble",
      "glossSv": "dregla",
      "pos": "action",
      "explanation": "saliva + down + action indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        81,
        "/",
        457,
        "/",
        271
      ]
    },
    {
      "id": 4498,
      "bciAvId": 24434,
      "gloss": "drug addict",
      "glossSv": "drogmissbrukare",
      "pos": "person",
      "explanation": "person + drug addiction [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        467,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        447
      ]
    },
    {
      "id": 4499,
      "bciAvId": 24435,
      "gloss": "drug addiction",
      "glossSv": "drogmissbruk",
      "pos": "noun",
      "explanation": "addiction + drug",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        467,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        447
      ]
    },
    {
      "id": 4500,
      "bciAvId": 24436,
      "gloss": "drug dependency",
      "glossSv": "drogberoende",
      "pos": "noun",
      "explanation": "negative dependency + drug",
      "isCharacter": false,
      "composition": [
        467,
        "/",
        449,
        "/",
        401,
        "/",
        216,
        "/",
        447
      ]
    },
    {
      "id": 4501,
      "bciAvId": 24437,
      "gloss": "dwarf planet",
      "glossSv": "dvärgplanet",
      "pos": "noun",
      "explanation": "planet + small",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        956
      ]
    },
    {
      "id": 4502,
      "bciAvId": 24438,
      "gloss": "Earth, Tellus (planet)",
      "glossSv": "Tellus, Jorden",
      "pos": "noun",
      "explanation": "rock planet + water",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        629,
        "/",
        695
      ]
    },
    {
      "id": 4503,
      "bciAvId": 24439,
      "gloss": "eating disorder",
      "glossSv": "ätstörningar",
      "pos": "noun",
      "explanation": "mental illness + food",
      "isCharacter": false,
      "composition": [
        897,
        "/",
        329
      ]
    },
    {
      "id": 4504,
      "bciAvId": 24440,
      "gloss": "Eris (dwarf planet)",
      "glossSv": "Eris",
      "pos": "noun",
      "explanation": "dwarf planet + angle",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        956,
        "/",
        121
      ]
    },
    {
      "id": 4505,
      "bciAvId": 24441,
      "gloss": "examination, investigation",
      "glossSv": "undersökning",
      "pos": "noun",
      "explanation": "to observe + evaluation",
      "isCharacter": false,
      "composition": [
        931,
        "/",
        297
      ]
    },
    {
      "id": 4506,
      "bciAvId": 24442,
      "gloss": "to examine (medically)",
      "glossSv": "läkarundersöka",
      "pos": "action",
      "explanation": "medical examination + action indicator",
      "isCharacter": false,
      "composition": [
        931,
        ";",
        81,
        "/",
        297,
        "/",
        958
      ]
    },
    {
      "id": 4507,
      "bciAvId": 24444,
      "gloss": "to fail",
      "glossSv": "misslyckas",
      "pos": "action",
      "explanation": "failure + action indicator",
      "isCharacter": false,
      "composition": [
        895,
        ";",
        81
      ]
    },
    {
      "id": 4508,
      "bciAvId": 24446,
      "gloss": "fan club",
      "glossSv": "fan club, supporterklubb",
      "pos": "noun",
      "explanation": "club [contraction] + feeling",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        313
      ]
    },
    {
      "id": 4509,
      "bciAvId": 24447,
      "gloss": "fledgeling",
      "glossSv": "fågelunge",
      "pos": "noun",
      "explanation": "bird + young",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        220
      ]
    },
    {
      "id": 4510,
      "bciAvId": 24448,
      "gloss": "foal",
      "glossSv": "föl",
      "pos": "noun",
      "explanation": "horse + young",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        220
      ]
    },
    {
      "id": 4511,
      "bciAvId": 24449,
      "gloss": "football supporters club",
      "glossSv": "supporterklubb (fotboll), fotbollsklubb",
      "pos": "noun",
      "explanation": "club [contraction] + football [contraction]",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 4512,
      "bciAvId": 24450,
      "gloss": "football team",
      "glossSv": "fotbollslag",
      "pos": "noun",
      "explanation": "group (people) + football [contraction]",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 4513,
      "bciAvId": 24452,
      "gloss": "gamble",
      "glossSv": "spel (om pengar)",
      "pos": "noun",
      "explanation": "competition + money",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        451
      ]
    },
    {
      "id": 4514,
      "bciAvId": 24453,
      "gloss": "to gamble",
      "glossSv": "spela (om pengar)",
      "pos": "action",
      "explanation": "gamble + action indicator",
      "isCharacter": false,
      "composition": [
        554,
        ";",
        81,
        "/",
        451
      ]
    },
    {
      "id": 4515,
      "bciAvId": 24454,
      "gloss": "gambler",
      "glossSv": "spelare (om pengar)",
      "pos": "person",
      "explanation": "person + gamble",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        554,
        "/",
        451
      ]
    },
    {
      "id": 4516,
      "bciAvId": 24455,
      "gloss": "gas planet",
      "glossSv": "gasplanet",
      "pos": "noun",
      "explanation": "planet + gas",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        345
      ]
    },
    {
      "id": 4517,
      "bciAvId": 24456,
      "gloss": "goldsmith",
      "glossSv": "guldsmed",
      "pos": "person",
      "explanation": "person + gold [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        814,
        "/",
        567
      ]
    },
    {
      "id": 4518,
      "bciAvId": 24457,
      "gloss": "Good day (bye)",
      "glossSv": "goddag (avsked)",
      "pos": "expression",
      "explanation": "goodbye + day",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1066,
        "/",
        258
      ]
    },
    {
      "id": 4519,
      "bciAvId": 24458,
      "gloss": "Good day (hello)",
      "glossSv": "goddag (möte)",
      "pos": "expression",
      "explanation": "hello + day",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057,
        "/",
        258
      ]
    },
    {
      "id": 4520,
      "bciAvId": 24459,
      "gloss": "Good evening (bye)",
      "glossSv": "godkväll (avsked)",
      "pos": "expression",
      "explanation": "goodbye + evening",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1066,
        "/",
        298
      ]
    },
    {
      "id": 4521,
      "bciAvId": 24460,
      "gloss": "Good evening (hello)",
      "glossSv": "godkväll (möte)",
      "pos": "expression",
      "explanation": "hello + evening",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057,
        "/",
        298
      ]
    },
    {
      "id": 4522,
      "bciAvId": 24461,
      "gloss": "Good morning (bye)",
      "glossSv": "godmorgon (avsked)",
      "pos": "expression",
      "explanation": "goodbye + morning",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1066,
        "/",
        454
      ]
    },
    {
      "id": 4523,
      "bciAvId": 24462,
      "gloss": "Good morning (hello)",
      "glossSv": "godmorgon (möte)",
      "pos": "expression",
      "explanation": "hello + morning",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057,
        "/",
        454
      ]
    },
    {
      "id": 4524,
      "bciAvId": 24463,
      "gloss": "Good night (bye)",
      "glossSv": "godnatt (avsked)",
      "pos": "expression",
      "explanation": "goodbye + night",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1066,
        "/",
        470
      ]
    },
    {
      "id": 4525,
      "bciAvId": 24464,
      "gloss": "Good night (hello)",
      "glossSv": "godnatt (möte)",
      "pos": "expression",
      "explanation": "hello + night",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1057,
        "/",
        470
      ]
    },
    {
      "id": 4526,
      "bciAvId": 24465,
      "gloss": "guest room",
      "glossSv": "gästrum",
      "pos": "noun",
      "explanation": "room + guest",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        513,
        "/",
        935
      ]
    },
    {
      "id": 4527,
      "bciAvId": 24466,
      "gloss": "to have impact on",
      "glossSv": "inverka på",
      "pos": "action",
      "explanation": "impact + action indicator",
      "isCharacter": false,
      "composition": [
        284,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 4528,
      "bciAvId": 24467,
      "gloss": "impact",
      "glossSv": "inverkan",
      "pos": "noun",
      "explanation": "effect + intensity",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        401
      ]
    },
    {
      "id": 4529,
      "bciAvId": 24468,
      "gloss": "to infect",
      "glossSv": "smitta, infektera",
      "pos": "action",
      "explanation": "to cause + infection + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4530,
      "bciAvId": 24469,
      "gloss": "infected",
      "glossSv": "smittad, infekterad",
      "pos": "description",
      "explanation": "infection + description after the fact indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        516,
        ";",
        84,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4531,
      "bciAvId": 24470,
      "gloss": "infection",
      "glossSv": "infektion",
      "pos": "noun",
      "explanation": "illness + micro-organism + thing indicator",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4532,
      "bciAvId": 24471,
      "gloss": "infectious, contagious",
      "glossSv": "smittsam",
      "pos": "description",
      "explanation": "infection + description before the fact indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        516,
        ";",
        85,
        "/",
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4533,
      "bciAvId": 24472,
      "gloss": "itch",
      "glossSv": "klåda",
      "pos": "noun",
      "explanation": "uncomfortable + scratch",
      "isCharacter": false,
      "composition": [
        264,
        "/",
        318,
        "/",
        144
      ]
    },
    {
      "id": 4534,
      "bciAvId": 24473,
      "gloss": "Jupiter (planet)",
      "glossSv": "Jupiter",
      "pos": "noun",
      "explanation": "gas planet + big",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        345,
        "/",
        936
      ]
    },
    {
      "id": 4535,
      "bciAvId": 24474,
      "gloss": "kitten",
      "glossSv": "kattunge",
      "pos": "noun",
      "explanation": "cat + young",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        220
      ]
    },
    {
      "id": 4536,
      "bciAvId": 24475,
      "gloss": "lamb",
      "glossSv": "lamm",
      "pos": "noun",
      "explanation": "sheep + young",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        228,
        "/",
        220
      ]
    },
    {
      "id": 4537,
      "bciAvId": 24476,
      "gloss": "leek",
      "glossSv": "purjolök",
      "pos": "noun",
      "explanation": "onion + leaf",
      "isCharacter": false,
      "composition": [
        686,
        "/",
        416
      ]
    },
    {
      "id": 4538,
      "bciAvId": 24477,
      "gloss": "lottery, game of chance",
      "glossSv": "lotteri",
      "pos": "noun",
      "explanation": "play [contraction] + money + number",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        451,
        "/",
        478
      ]
    },
    {
      "id": 4539,
      "bciAvId": 24478,
      "gloss": "magnifier, magnifying glass",
      "glossSv": "förstoringsglas",
      "pos": "noun",
      "explanation": "tool + to look + little: tool to look at small things",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        956
      ]
    },
    {
      "id": 4540,
      "bciAvId": 24479,
      "gloss": "Mars (planet)",
      "glossSv": "Mars (planet)",
      "pos": "noun",
      "explanation": "rock planet + dust",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        629,
        "/",
        544
      ]
    },
    {
      "id": 4541,
      "bciAvId": 24480,
      "gloss": "medical examination",
      "glossSv": "läkarundersökning",
      "pos": "noun",
      "explanation": "examination + medical",
      "isCharacter": false,
      "composition": [
        931,
        "/",
        297,
        "/",
        958
      ]
    },
    {
      "id": 4542,
      "bciAvId": 24481,
      "gloss": "meeting room, auditorium",
      "glossSv": "konferensrum, mötesrum",
      "pos": "noun",
      "explanation": "room + gathering",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        346
      ]
    },
    {
      "id": 4543,
      "bciAvId": 24483,
      "gloss": "Mercury (planet)",
      "glossSv": "Merkurius",
      "pos": "noun",
      "explanation": "rock planet + fire",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        629,
        "/",
        319
      ]
    },
    {
      "id": 4544,
      "bciAvId": 24484,
      "gloss": "message",
      "glossSv": "meddelande",
      "pos": "noun",
      "explanation": "information + forward",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        335
      ]
    },
    {
      "id": 4545,
      "bciAvId": 24485,
      "gloss": "message, content (communication)",
      "glossSv": "budskap, mening, innehåll",
      "pos": "noun",
      "explanation": "substance + communication",
      "isCharacter": false,
      "composition": [
        898,
        "/",
        1029,
        "/",
        440
      ]
    },
    {
      "id": 4546,
      "bciAvId": 24486,
      "gloss": "micro-organism",
      "glossSv": "mikroorganism",
      "pos": "noun",
      "explanation": "organism + small + thing indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4547,
      "bciAvId": 24487,
      "gloss": "microscope",
      "glossSv": "mikroskop",
      "pos": "noun",
      "explanation": "tool + to look + cell",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        748
      ]
    },
    {
      "id": 4548,
      "bciAvId": 24488,
      "gloss": "drug, mind-altering drug",
      "glossSv": "drog, narkotika (etc)",
      "pos": "noun",
      "explanation": "chemical product + mind",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        447
      ]
    },
    {
      "id": 4549,
      "bciAvId": 24489,
      "gloss": "money on a regular basis",
      "glossSv": "utbetalning (regelbunden)",
      "pos": "noun",
      "explanation": "money + often: e.g. child allowance",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        368,
        "/",
        655
      ]
    },
    {
      "id": 4550,
      "bciAvId": 24491,
      "gloss": "negative dependency",
      "glossSv": "beroende (negativt, subst.)",
      "pos": "noun",
      "explanation": "dependency + negative",
      "isCharacter": false,
      "composition": [
        467,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4551,
      "bciAvId": 24492,
      "gloss": "Neptune (planet)",
      "glossSv": "Neptunus",
      "pos": "noun",
      "explanation": "gas planet + wind",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        345,
        "/",
        705
      ]
    },
    {
      "id": 4552,
      "bciAvId": 24493,
      "gloss": "old-age pension",
      "glossSv": "ålderspension",
      "pos": "noun",
      "explanation": "money + old",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        368,
        "/",
        716
      ]
    },
    {
      "id": 4553,
      "bciAvId": 24494,
      "gloss": "organism",
      "glossSv": "organism",
      "pos": "noun",
      "explanation": "being + thing indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97
      ]
    },
    {
      "id": 4554,
      "bciAvId": 24495,
      "gloss": "outcome, result, consequence",
      "glossSv": "resultat",
      "pos": "noun",
      "explanation": "effect + activity: consequence of activity",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106
      ]
    },
    {
      "id": 4555,
      "bciAvId": 24496,
      "gloss": "pacifier, dummy",
      "glossSv": "napp",
      "pos": "noun",
      "explanation": "thing + baby + mouth",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        140,
        "/",
        457
      ]
    },
    {
      "id": 4556,
      "bciAvId": 24497,
      "gloss": "pensioner",
      "glossSv": "pensionär",
      "pos": "person",
      "explanation": "person + old age pension",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        451,
        "/",
        368,
        "/",
        716
      ]
    },
    {
      "id": 4557,
      "bciAvId": 24498,
      "gloss": "Pluto (dwarf planet)",
      "glossSv": "Pluto",
      "pos": "noun",
      "explanation": "dwarf planet + ice",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        956,
        "/",
        394
      ]
    },
    {
      "id": 4558,
      "bciAvId": 24499,
      "gloss": "program, programme, presentation",
      "glossSv": "program, presentation",
      "pos": "noun",
      "explanation": "limited time + to see + to hear",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 4559,
      "bciAvId": 24500,
      "gloss": "to react",
      "glossSv": "reagera",
      "pos": "action",
      "explanation": "reaction + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        145,
        "/",
        284
      ]
    },
    {
      "id": 4560,
      "bciAvId": 24501,
      "gloss": "reaction",
      "glossSv": "reaktion",
      "pos": "noun",
      "explanation": "activity + backward,back + effect",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        145,
        "/",
        284
      ]
    },
    {
      "id": 4561,
      "bciAvId": 24502,
      "gloss": "reception",
      "glossSv": "reception",
      "pos": "noun",
      "explanation": "entrance + question",
      "isCharacter": false,
      "composition": [
        402,
        "/",
        553
      ]
    },
    {
      "id": 4562,
      "bciAvId": 24503,
      "gloss": "retirement pension",
      "glossSv": "pension, avtalspension (etc)",
      "pos": "noun",
      "explanation": "money + stop + work",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        292,
        "/",
        711
      ]
    },
    {
      "id": 4563,
      "bciAvId": 24504,
      "gloss": "rock planet, terrestrial planet",
      "glossSv": "stenplanet",
      "pos": "noun",
      "explanation": "planet + stone,rock",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        629
      ]
    },
    {
      "id": 4564,
      "bciAvId": 24505,
      "gloss": "Saturn (planet)",
      "glossSv": "Saturnus",
      "pos": "noun",
      "explanation": "gas planet + ring",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        345,
        "/",
        567
      ]
    },
    {
      "id": 4565,
      "bciAvId": 24506,
      "gloss": "scratch",
      "glossSv": "kliande",
      "pos": "noun",
      "explanation": "finger + back and forth",
      "isCharacter": false,
      "composition": [
        318,
        "/",
        144
      ]
    },
    {
      "id": 4566,
      "bciAvId": 24507,
      "gloss": "to scratch",
      "glossSv": "klia",
      "pos": "action",
      "explanation": "scratch + action indicator",
      "isCharacter": false,
      "composition": [
        318,
        ";",
        81,
        "/",
        144
      ]
    },
    {
      "id": 4567,
      "bciAvId": 24508,
      "gloss": "senior citizen",
      "glossSv": "senior, äldre person",
      "pos": "person",
      "explanation": "person + old",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        368,
        "/",
        716
      ]
    },
    {
      "id": 4568,
      "bciAvId": 24509,
      "gloss": "short message system (SMS), text message",
      "glossSv": "SMS",
      "pos": "noun",
      "explanation": "letter + telephone",
      "isCharacter": false,
      "composition": [
        421,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 4569,
      "bciAvId": 24510,
      "gloss": "silversmith",
      "glossSv": "silversmed",
      "pos": "person",
      "explanation": "person + silver [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        814,
        "/",
        614
      ]
    },
    {
      "id": 4570,
      "bciAvId": 24511,
      "gloss": "sink, basin",
      "glossSv": "tvättställ, handfat (etc)",
      "pos": "noun",
      "explanation": "bath,washing + thing indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        97
      ]
    },
    {
      "id": 4571,
      "bciAvId": 24512,
      "gloss": "smoking addiction (2)",
      "glossSv": "nikotinberoende, nikotinmissbruk (2)",
      "pos": "noun",
      "explanation": "addiction + smoking",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        467,
        "/",
        1085
      ]
    },
    {
      "id": 4572,
      "bciAvId": 24513,
      "gloss": "smoking addiction (1)",
      "glossSv": "nikotinberoende, nikotinmissbruk (1)",
      "pos": "noun",
      "explanation": "negative dependency + smoking",
      "isCharacter": false,
      "composition": [
        467,
        "/",
        449,
        "/",
        401,
        "/",
        1085
      ]
    },
    {
      "id": 4573,
      "bciAvId": 24516,
      "gloss": "tap (1)",
      "glossSv": "vattenkran (1)",
      "pos": "noun",
      "explanation": "tool + water",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        695
      ]
    },
    {
      "id": 4574,
      "bciAvId": 24517,
      "gloss": "tap (2)",
      "glossSv": "vattenkran (2)",
      "pos": "noun",
      "explanation": "tool + to cause + water",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        206,
        "/",
        695
      ]
    },
    {
      "id": 4575,
      "bciAvId": 24519,
      "gloss": "treatment",
      "glossSv": "behandling",
      "pos": "noun",
      "explanation": "generalization + therapy",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        750
      ]
    },
    {
      "id": 4576,
      "bciAvId": 24520,
      "gloss": "Universe",
      "glossSv": "Universum",
      "pos": "noun",
      "explanation": "all + galaxy",
      "isCharacter": false,
      "composition": [
        117,
        "/",
        896
      ]
    },
    {
      "id": 4577,
      "bciAvId": 24521,
      "gloss": "Uranus (planet)",
      "glossSv": "Uranus",
      "pos": "noun",
      "explanation": "gas planet + ice",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        345,
        "/",
        394
      ]
    },
    {
      "id": 4578,
      "bciAvId": 24522,
      "gloss": "Venus (planet)",
      "glossSv": "Venus",
      "pos": "noun",
      "explanation": "rock planet + cloud",
      "isCharacter": false,
      "composition": [
        800,
        "/",
        629,
        "/",
        230
      ]
    },
    {
      "id": 4579,
      "bciAvId": 24523,
      "gloss": "viral infection",
      "glossSv": "virusinfektion",
      "pos": "noun",
      "explanation": "illness + virus",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        894,
        ";",
        97,
        "/",
        956,
        "/",
        963
      ]
    },
    {
      "id": 4580,
      "bciAvId": 24524,
      "gloss": "virus",
      "glossSv": "virus",
      "pos": "noun",
      "explanation": "micro-organism + duplicate: replicating microorganism",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956,
        "/",
        963
      ]
    },
    {
      "id": 4581,
      "bciAvId": 24525,
      "gloss": "young animal",
      "glossSv": "ungdjur",
      "pos": "noun",
      "explanation": "animal + young",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        220
      ]
    },
    {
      "id": 4582,
      "bciAvId": 24601,
      "gloss": "adventure",
      "glossSv": "äventyr (FD)",
      "pos": "noun",
      "explanation": "activity + future (uncertain) + excited",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        1042,
        "/",
        313,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4583,
      "bciAvId": 24602,
      "gloss": "aerial, antenna",
      "glossSv": "antenn",
      "pos": "noun",
      "explanation": "exchange + signal + thing indicator",
      "isCharacter": false,
      "composition": [
        1029,
        ";",
        97,
        "/",
        922
      ]
    },
    {
      "id": 4584,
      "bciAvId": 24603,
      "gloss": "agenda",
      "glossSv": "dagordning",
      "pos": "noun",
      "explanation": "plan + gathering",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        346
      ]
    },
    {
      "id": 4585,
      "bciAvId": 24604,
      "gloss": "anchor",
      "glossSv": "ankare",
      "pos": "noun",
      "explanation": "thing + stop + boat",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        292,
        "/",
        170
      ]
    },
    {
      "id": 4586,
      "bciAvId": 24606,
      "gloss": "band (of frequencies)",
      "glossSv": "frekvensband, frekvensområde (FD)",
      "pos": "noun",
      "explanation": "signal + limit(s),limitation (OLD): signal or frequencies in a certain range",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        427
      ]
    },
    {
      "id": 4587,
      "bciAvId": 24607,
      "gloss": "Bangladesh",
      "glossSv": "Bangladesh",
      "pos": "noun",
      "explanation": "land + tiger",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        126,
        "/",
        428
      ]
    },
    {
      "id": 4588,
      "bciAvId": 24608,
      "gloss": "barley",
      "glossSv": "korn",
      "pos": "noun",
      "explanation": "grain + straw + long: ear of grain with long tassels",
      "isCharacter": false,
      "composition": [
        357,
        "/",
        428,
        ";",
        97,
        "/",
        936
      ]
    },
    {
      "id": 4589,
      "bciAvId": 24610,
      "gloss": "berth, bunk",
      "glossSv": "koj, brits",
      "pos": "noun",
      "explanation": "bed + boat",
      "isCharacter": false,
      "composition": [
        156,
        "/",
        170
      ]
    },
    {
      "id": 4590,
      "bciAvId": 24611,
      "gloss": "board, board of directors, executive",
      "glossSv": "styrelse",
      "pos": "noun",
      "explanation": "group of + leader",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        736
      ]
    },
    {
      "id": 4591,
      "bciAvId": 24612,
      "gloss": "boat ladder",
      "glossSv": "lejdare",
      "pos": "noun",
      "explanation": "ladder + boat",
      "isCharacter": false,
      "composition": [
        413,
        "/",
        170
      ]
    },
    {
      "id": 4592,
      "bciAvId": 24613,
      "gloss": "boot, trunk, roof box, luggage compartment",
      "glossSv": "bagageutrymme, takbox",
      "pos": "noun",
      "explanation": "container + car",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        202
      ]
    },
    {
      "id": 4593,
      "bciAvId": 24614,
      "gloss": "broadband",
      "glossSv": "bredband (FD)",
      "pos": "noun",
      "explanation": "band (of frequencies) (OLD) + fast",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        427,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 4594,
      "bciAvId": 24615,
      "gloss": "to broadcast, to transmit",
      "glossSv": "sända ut, överföra",
      "pos": "action",
      "explanation": "signal + action indicator",
      "isCharacter": false,
      "composition": [
        922,
        ";",
        81
      ]
    },
    {
      "id": 4595,
      "bciAvId": 24616,
      "gloss": "buzzer",
      "glossSv": "summer, larm (etc)",
      "pos": "noun",
      "explanation": "tool + noise",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        608,
        "/",
        401
      ]
    },
    {
      "id": 4596,
      "bciAvId": 24617,
      "gloss": "cabin (boat)",
      "glossSv": "hytt",
      "pos": "noun",
      "explanation": "room + boat",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        170
      ]
    },
    {
      "id": 4597,
      "bciAvId": 24618,
      "gloss": "camper van, RV",
      "glossSv": "husbil",
      "pos": "noun",
      "explanation": "car + house",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        392
      ]
    },
    {
      "id": 4598,
      "bciAvId": 24619,
      "gloss": "canal (water)",
      "glossSv": "kanal",
      "pos": "noun",
      "explanation": "waterway + man-made",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        840
      ]
    },
    {
      "id": 4599,
      "bciAvId": 24620,
      "gloss": "care manager, care plan manager",
      "glossSv": "vårdplanerare",
      "pos": "person",
      "explanation": "leader + help",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        "RK:-2",
        "/",
        382
      ]
    },
    {
      "id": 4600,
      "bciAvId": 24621,
      "gloss": "CD",
      "glossSv": "CD",
      "pos": "noun",
      "explanation": "disc + file",
      "isCharacter": false,
      "composition": [
        1075,
        "/",
        832
      ]
    },
    {
      "id": 4601,
      "bciAvId": 24622,
      "gloss": "channel (programs)",
      "glossSv": "kanal (TV, radio etc)",
      "pos": "noun",
      "explanation": "signal + choice",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        223
      ]
    },
    {
      "id": 4602,
      "bciAvId": 24623,
      "gloss": "Christmas song, carol",
      "glossSv": "julsång",
      "pos": "noun",
      "explanation": "song + Christmas [contraction]",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 4603,
      "bciAvId": 24624,
      "gloss": "communication satellite",
      "glossSv": "kommunikationssatellit",
      "pos": "noun",
      "explanation": "satellite + exchange,substitution: exchange representing communication [contraction]",
      "isCharacter": false,
      "composition": [
        921,
        "/",
        1029
      ]
    },
    {
      "id": 4604,
      "bciAvId": 24625,
      "gloss": "compartment",
      "glossSv": "kupé",
      "pos": "noun",
      "explanation": "room + train",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 4605,
      "bciAvId": 24626,
      "gloss": "compass",
      "glossSv": "kompass",
      "pos": "noun",
      "explanation": "gauge + north + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        472
      ]
    },
    {
      "id": 4606,
      "bciAvId": 24627,
      "gloss": "connection (computer)",
      "glossSv": "anslutning, koppling, kontakt (dator)",
      "pos": "noun",
      "explanation": "entrance + digits (computer)",
      "isCharacter": false,
      "composition": [
        402,
        "/",
        829
      ]
    },
    {
      "id": 4607,
      "bciAvId": 24628,
      "gloss": "connector, interface box",
      "glossSv": "adapter, kopplingsdosa",
      "pos": "noun",
      "explanation": "connection + thing indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        97,
        "/",
        829
      ]
    },
    {
      "id": 4608,
      "bciAvId": 24629,
      "gloss": "corruption",
      "glossSv": "korruption (FD)",
      "pos": "noun",
      "explanation": "abuse [contraction] + power,powerfulness (OLD) [contraction] + selfish",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        803,
        "/",
        427,
        "/",
        964
      ]
    },
    {
      "id": 4609,
      "bciAvId": 24630,
      "gloss": "crack, gap, cleft",
      "glossSv": "spricka",
      "pos": "noun",
      "explanation": "hole + narrow",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        1096
      ]
    },
    {
      "id": 4610,
      "bciAvId": 24631,
      "gloss": "crater",
      "glossSv": "krater",
      "pos": "noun",
      "explanation": "opening + volcano",
      "isCharacter": false,
      "composition": [
        484,
        "/",
        456,
        "/",
        319
      ]
    },
    {
      "id": 4611,
      "bciAvId": 24632,
      "gloss": "credit",
      "glossSv": "kredit",
      "pos": "noun",
      "explanation": "money + future: money you pay after time agreed upon",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        341
      ]
    },
    {
      "id": 4612,
      "bciAvId": 24633,
      "gloss": "credit card",
      "glossSv": "kreditkort",
      "pos": "noun",
      "explanation": "card + credit",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        451,
        "/",
        341
      ]
    },
    {
      "id": 4613,
      "bciAvId": 24634,
      "gloss": "crew, staff",
      "glossSv": "personal, arbetsstyrka, besättning",
      "pos": "person",
      "explanation": "group of + worker",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        711
      ]
    },
    {
      "id": 4614,
      "bciAvId": 24635,
      "gloss": "crew (boat)",
      "glossSv": "besättning (båt)",
      "pos": "person",
      "explanation": "crew,staff + boat",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        711,
        "/",
        170
      ]
    },
    {
      "id": 4615,
      "bciAvId": 24636,
      "gloss": "crew (plane)",
      "glossSv": "besättning (flygplan)",
      "pos": "person",
      "explanation": "crew,staff + airplane",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        711,
        "/",
        115
      ]
    },
    {
      "id": 4616,
      "bciAvId": 24637,
      "gloss": "dependent",
      "glossSv": "beroende (adj.)",
      "pos": "description",
      "explanation": "need + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        467,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 4617,
      "bciAvId": 24639,
      "gloss": "digital signal",
      "glossSv": "signal (digital), digital signal",
      "pos": "noun",
      "explanation": "signal + digits",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        829
      ]
    },
    {
      "id": 4618,
      "bciAvId": 24640,
      "gloss": "digital memory, digital storage",
      "glossSv": "datalagring, digitalt minne, dataminne",
      "pos": "noun",
      "explanation": "file,data file (digital) + future: combination of file and save",
      "isCharacter": false,
      "composition": [
        832,
        "/",
        341
      ]
    },
    {
      "id": 4619,
      "bciAvId": 24641,
      "gloss": "digital storage device",
      "glossSv": "digital lagringsenhet, lagringsminne (digitalt)",
      "pos": "noun",
      "explanation": "digital device + save",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        239,
        "/",
        341
      ]
    },
    {
      "id": 4620,
      "bciAvId": 24642,
      "gloss": "dizzy",
      "glossSv": "yr",
      "pos": "description",
      "explanation": "feeling + rotation + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        887
      ]
    },
    {
      "id": 4621,
      "bciAvId": 24643,
      "gloss": "document (electronic), digital document",
      "glossSv": "dokument (elektroniskt), digitalt dokument",
      "pos": "noun",
      "explanation": "document [contraction] + digits (computer)",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        829
      ]
    },
    {
      "id": 4622,
      "bciAvId": 24644,
      "gloss": "to drop anchor",
      "glossSv": "ankra, kasta ankar",
      "pos": "action",
      "explanation": "anchor + action indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        292,
        "/",
        170
      ]
    },
    {
      "id": 4623,
      "bciAvId": 24645,
      "gloss": "DVD",
      "glossSv": "DVD",
      "pos": "noun",
      "explanation": "recording disk + many + file",
      "isCharacter": false,
      "composition": [
        1075,
        "/",
        368,
        "/",
        832
      ]
    },
    {
      "id": 4624,
      "bciAvId": 24646,
      "gloss": "DVD, movie disc",
      "glossSv": "DVD-film",
      "pos": "noun",
      "explanation": "recording disk + eye + ear: a disk for seeing images and film, and listening to sounds and music",
      "isCharacter": false,
      "composition": [
        1075,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 4625,
      "bciAvId": 24647,
      "gloss": "DVD player",
      "glossSv": "DVD-spelare",
      "pos": "noun",
      "explanation": "machine + DVD,movie disc",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        1075,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 4626,
      "bciAvId": 24648,
      "gloss": "to empower",
      "glossSv": "ge egenmakt, ge rättighet, stärka (FD)",
      "pos": "action",
      "explanation": "empowerment (OLD) + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        803,
        "/",
        427
      ]
    },
    {
      "id": 4627,
      "bciAvId": 24649,
      "gloss": "empowered",
      "glossSv": "berättigad, styrkt (FD)",
      "pos": "description",
      "explanation": "empowerment (OLD) + description indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        86,
        "/",
        803,
        "/",
        427
      ]
    },
    {
      "id": 4628,
      "bciAvId": 24650,
      "gloss": "empowerment",
      "glossSv": "egenmakt, befogenhet (FD)",
      "pos": "noun",
      "explanation": "give + power,powerfulness (OLD) [contraction]",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        803,
        "/",
        427
      ]
    },
    {
      "id": 4629,
      "bciAvId": 24651,
      "gloss": "to erupt",
      "glossSv": "få utbrott (vulkan)",
      "pos": "action",
      "explanation": "eruption + action indicator",
      "isCharacter": false,
      "composition": [
        623,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        456,
        "/",
        319
      ]
    },
    {
      "id": 4630,
      "bciAvId": 24652,
      "gloss": "eruption",
      "glossSv": "vulkanutbrott, utbrott",
      "pos": "noun",
      "explanation": "steam + volcano",
      "isCharacter": false,
      "composition": [
        623,
        "/",
        "RK:-2",
        "/",
        456,
        "/",
        319
      ]
    },
    {
      "id": 4631,
      "bciAvId": 24653,
      "gloss": "exchanger",
      "glossSv": "omvandlare",
      "pos": "noun",
      "explanation": "exchange + thing indicator",
      "isCharacter": false,
      "composition": [
        1029,
        ";",
        97
      ]
    },
    {
      "id": 4632,
      "bciAvId": 24654,
      "gloss": "external hard drive",
      "glossSv": "extern hårddisk",
      "pos": "noun",
      "explanation": "digital storage device + big",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        239,
        "/",
        341,
        "/",
        936
      ]
    },
    {
      "id": 4633,
      "bciAvId": 24655,
      "gloss": "firework",
      "glossSv": "fyrverkeri",
      "pos": "noun",
      "explanation": "explosion + many + colour",
      "isCharacter": false,
      "composition": [
        302,
        "/",
        368,
        "/",
        1161
      ]
    },
    {
      "id": 4634,
      "bciAvId": 24656,
      "gloss": "fish cage",
      "glossSv": "fisksump",
      "pos": "noun",
      "explanation": "cage + fish",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        707,
        "/",
        321
      ]
    },
    {
      "id": 4635,
      "bciAvId": 24657,
      "gloss": "French fries, chips",
      "glossSv": "pommes frites (etc)",
      "pos": "noun",
      "explanation": "potato [contraction] + linear thing + oil + thing indicator",
      "isCharacter": false,
      "composition": [
        685,
        "/",
        428,
        ";",
        97,
        "/",
        480
      ]
    },
    {
      "id": 4636,
      "bciAvId": 24658,
      "gloss": "galley (boat)",
      "glossSv": "kabyss, pentry (båt)",
      "pos": "noun",
      "explanation": "kitchen + boat",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        840,
        "/",
        329,
        "/",
        170
      ]
    },
    {
      "id": 4637,
      "bciAvId": 24659,
      "gloss": "game box",
      "glossSv": "dataspel, game box, spelkonsol",
      "pos": "noun",
      "explanation": "digital device + game [contraction]",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 4638,
      "bciAvId": 24660,
      "gloss": "GPS, satnav",
      "glossSv": "GPS, GPS-navigator, satellitnavigator",
      "pos": "noun",
      "explanation": "digital device + communication satellite + place",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        921,
        "/",
        1029,
        "/",
        531
      ]
    },
    {
      "id": 4639,
      "bciAvId": 24661,
      "gloss": "GPS (system)",
      "glossSv": "GPS (systemet)",
      "pos": "noun",
      "explanation": "group of + communication satellite + place",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        921,
        "/",
        1029,
        "/",
        531
      ]
    },
    {
      "id": 4640,
      "bciAvId": 24662,
      "gloss": "hammock",
      "glossSv": "hängmatta",
      "pos": "noun",
      "explanation": "swing + cloth + lie down + thing indicator",
      "isCharacter": false,
      "composition": [
        989,
        ";",
        97,
        "/",
        228,
        "/",
        515
      ]
    },
    {
      "id": 4641,
      "bciAvId": 24663,
      "gloss": "hard rock",
      "glossSv": "hårdrock",
      "pos": "noun",
      "explanation": "music + up and down + intensity",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        723,
        "/",
        401
      ]
    },
    {
      "id": 4642,
      "bciAvId": 24664,
      "gloss": "I need more time, give me time",
      "glossSv": "ge mig tid",
      "pos": "action",
      "explanation": "need + time + action indicator",
      "isCharacter": false,
      "composition": [
        467,
        ";",
        81,
        "/",
        655
      ]
    },
    {
      "id": 4643,
      "bciAvId": 24680,
      "gloss": "inflammable, flammable",
      "glossSv": "eldfarlig",
      "pos": "description",
      "explanation": "fire + intensity + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        85,
        "/",
        401
      ]
    },
    {
      "id": 4644,
      "bciAvId": 24681,
      "gloss": "invoice",
      "glossSv": "räkning, faktura",
      "pos": "noun",
      "explanation": "paper + before + money",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        158,
        "/",
        451
      ]
    },
    {
      "id": 4645,
      "bciAvId": 24682,
      "gloss": "jackfruit",
      "glossSv": "jackfrukt",
      "pos": "noun",
      "explanation": "fruit + heavy",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        697,
        "/",
        271
      ]
    },
    {
      "id": 4646,
      "bciAvId": 24683,
      "gloss": "janitor, caretaker",
      "glossSv": "vaktmästare, fastighetsskötare",
      "pos": "person",
      "explanation": "person + help + house",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382,
        "/",
        392
      ]
    },
    {
      "id": 4647,
      "bciAvId": 24684,
      "gloss": "lava, magma",
      "glossSv": "lava",
      "pos": "noun",
      "explanation": "liquid + volcano",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        "RK:-2",
        "/",
        456,
        "/",
        319
      ]
    },
    {
      "id": 4648,
      "bciAvId": 24685,
      "gloss": "lee, shelter",
      "glossSv": "lä, vindskydd",
      "pos": "noun",
      "explanation": "place + without + wind",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        449,
        "/",
        705
      ]
    },
    {
      "id": 4649,
      "bciAvId": 24686,
      "gloss": "to let fall, to drop",
      "glossSv": "släppa",
      "pos": "action",
      "explanation": "hand + fall-(to) + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 4650,
      "bciAvId": 24687,
      "gloss": "life-jacket",
      "glossSv": "flytväst",
      "pos": "noun",
      "explanation": "clothes + float-(to)",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        1036
      ]
    },
    {
      "id": 4651,
      "bciAvId": 24688,
      "gloss": "to lower",
      "glossSv": "hala, sänka",
      "pos": "action",
      "explanation": "activity + down + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        271
      ]
    },
    {
      "id": 4652,
      "bciAvId": 24689,
      "gloss": "lullaby",
      "glossSv": "vaggvisa",
      "pos": "noun",
      "explanation": "song + sleep",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        462,
        "/",
        599
      ]
    },
    {
      "id": 4653,
      "bciAvId": 24690,
      "gloss": "lunar eclipse",
      "glossSv": "månförmörkelse",
      "pos": "noun",
      "explanation": "moon + behind + earth",
      "isCharacter": false,
      "composition": [
        453,
        "/",
        109,
        "/",
        280
      ]
    },
    {
      "id": 4654,
      "bciAvId": 24691,
      "gloss": "media player",
      "glossSv": "mediaspelare",
      "pos": "noun",
      "explanation": "digital device + eye + ear",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 4655,
      "bciAvId": 24692,
      "gloss": "member",
      "glossSv": "medlem",
      "pos": "person",
      "explanation": "person + belong to + group",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        160,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 4656,
      "bciAvId": 24693,
      "gloss": "memo, reminder note",
      "glossSv": "minneslapp, kom-ihåg-lapp",
      "pos": "noun",
      "explanation": "paper + memory",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        841
      ]
    },
    {
      "id": 4657,
      "bciAvId": 24694,
      "gloss": "memory stick, USB-memory",
      "glossSv": "USB-minne, minnespinne",
      "pos": "noun",
      "explanation": "digital storage device + small",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        239,
        "/",
        341,
        "/",
        956
      ]
    },
    {
      "id": 4658,
      "bciAvId": 24695,
      "gloss": "metal (music)",
      "glossSv": "heavy metal, metal-musik",
      "pos": "noun",
      "explanation": "rock music + metal [contraction]",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        723,
        "/",
        814
      ]
    },
    {
      "id": 4659,
      "bciAvId": 24696,
      "gloss": "minutes",
      "glossSv": "protokoll, minnesanteckningar",
      "pos": "noun",
      "explanation": "document [contraction] + after + gathering",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        109,
        "/",
        346
      ]
    },
    {
      "id": 4660,
      "bciAvId": 24697,
      "gloss": "misuse",
      "glossSv": "missbruk",
      "pos": "noun",
      "explanation": "use + wrong",
      "isCharacter": false,
      "composition": [
        932,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 4661,
      "bciAvId": 24698,
      "gloss": "to misuse",
      "glossSv": "missbruka",
      "pos": "action",
      "explanation": "misuse + action indicator",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        81,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 4662,
      "bciAvId": 24699,
      "gloss": "MMS",
      "glossSv": "MMS",
      "pos": "noun",
      "explanation": "picture + telephone",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 4663,
      "bciAvId": 24700,
      "gloss": "monument, commemorative work",
      "glossSv": "monument, minnesmärke",
      "pos": "noun",
      "explanation": "work of art,art object + memory + thing indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        841
      ]
    },
    {
      "id": 4664,
      "bciAvId": 24701,
      "gloss": "to move (change position)",
      "glossSv": "röra sig, flytta sig",
      "pos": "action",
      "explanation": "movement,motion (2) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        144
      ]
    },
    {
      "id": 4665,
      "bciAvId": 24702,
      "gloss": "movement, motion (1)",
      "glossSv": "rörelse, förflyttning (1)",
      "pos": "noun",
      "explanation": "generalization + back and forth",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        144
      ]
    },
    {
      "id": 4666,
      "bciAvId": 24703,
      "gloss": "movement, motion (2)",
      "glossSv": "rörelse, förflyttning (2)",
      "pos": "noun",
      "explanation": "activity + back and forth",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        144
      ]
    },
    {
      "id": 4667,
      "bciAvId": 24704,
      "gloss": "navigational sign",
      "glossSv": "sjömärke",
      "pos": "noun",
      "explanation": "sign + boat",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        835,
        "/",
        170
      ]
    },
    {
      "id": 4668,
      "bciAvId": 24705,
      "gloss": "oats",
      "glossSv": "havre",
      "pos": "noun",
      "explanation": "grain + bits: grain gathered in a cluster",
      "isCharacter": false,
      "composition": [
        357,
        "/",
        777
      ]
    },
    {
      "id": 4669,
      "bciAvId": 24706,
      "gloss": "okra, lady's finger",
      "glossSv": "okra",
      "pos": "noun",
      "explanation": "fruit (pointed) + soft",
      "isCharacter": false,
      "composition": [
        1041,
        "/",
        374,
        "/",
        1049
      ]
    },
    {
      "id": 4670,
      "bciAvId": 24707,
      "gloss": "to overspend, to buy over budget",
      "glossSv": "göra av med pengar, spendera",
      "pos": "action",
      "explanation": "buy [contraction] + over + economy",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        81,
        "/",
        493,
        "/",
        191
      ]
    },
    {
      "id": 4671,
      "bciAvId": 24708,
      "gloss": "pay channel",
      "glossSv": "betal-TV",
      "pos": "noun",
      "explanation": "channel (programs) + money",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        223,
        "/",
        451
      ]
    },
    {
      "id": 4672,
      "bciAvId": 24709,
      "gloss": "to pick",
      "glossSv": "plocka",
      "pos": "action",
      "explanation": "finger + to get + action indicator",
      "isCharacter": false,
      "composition": [
        318,
        ";",
        81,
        "/",
        920
      ]
    },
    {
      "id": 4673,
      "bciAvId": 24710,
      "gloss": "to plug in, to connect (digital)",
      "glossSv": "ansluta (digitalt)",
      "pos": "action",
      "explanation": "connection (computer) + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 4674,
      "bciAvId": 24711,
      "gloss": "to plug in, to connect (power)",
      "glossSv": "ansluta (elektriskt)",
      "pos": "action",
      "explanation": "plug [modification] + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        288
      ]
    },
    {
      "id": 4675,
      "bciAvId": 24712,
      "gloss": "port (boat)",
      "glossSv": "babord",
      "pos": "noun",
      "explanation": "left turn,left (position or direction) + boat",
      "isCharacter": false,
      "composition": [
        1051,
        "/",
        170
      ]
    },
    {
      "id": 4676,
      "bciAvId": 24713,
      "gloss": "port (device)",
      "glossSv": "port, kontakt (dator)",
      "pos": "noun",
      "explanation": "opening + connection (computer)",
      "isCharacter": false,
      "composition": [
        484,
        "/",
        402,
        "/",
        829
      ]
    },
    {
      "id": 4677,
      "bciAvId": 24715,
      "gloss": "portable",
      "glossSv": "bärbar, portabel",
      "pos": "description",
      "explanation": "portability + action indicator",
      "isCharacter": false,
      "composition": [
        917,
        ";",
        86
      ]
    },
    {
      "id": 4678,
      "bciAvId": 24716,
      "gloss": "potato chip(s), chip(s), crisp(s)",
      "glossSv": "chips, potatischips (etc)",
      "pos": "noun",
      "explanation": "vegetable (below ground) + disc: potato [contraction]",
      "isCharacter": false,
      "composition": [
        685,
        "/",
        263
      ]
    },
    {
      "id": 4679,
      "bciAvId": 24718,
      "gloss": "power, powerfulness",
      "glossSv": "makt (FD)",
      "pos": "noun",
      "explanation": "ability + control (OLD)",
      "isCharacter": false,
      "composition": [
        101,
        "/",
        803,
        "/",
        427
      ]
    },
    {
      "id": 4680,
      "bciAvId": 24719,
      "gloss": "powerful, mighty",
      "glossSv": "mäktig (FD)",
      "pos": "description",
      "explanation": "power,powerfulness (OLD) + description indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        86,
        "/",
        803,
        "/",
        427
      ]
    },
    {
      "id": 4681,
      "bciAvId": 24720,
      "gloss": "quality",
      "glossSv": "kvalitet",
      "pos": "noun",
      "explanation": "evaluation,value + type,kind,sort,category",
      "isCharacter": false,
      "composition": [
        297,
        "/",
        673
      ]
    },
    {
      "id": 4682,
      "bciAvId": 24721,
      "gloss": "quality (measurement)",
      "glossSv": "kvalitet (mått)",
      "pos": "noun",
      "explanation": "measurement + quality",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        297,
        "/",
        673
      ]
    },
    {
      "id": 4683,
      "bciAvId": 24722,
      "gloss": "quantity (measurement)",
      "glossSv": "kvantitet (mått)",
      "pos": "noun",
      "explanation": "measurement + multitude",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        459,
        ";",
        97
      ]
    },
    {
      "id": 4684,
      "bciAvId": 24723,
      "gloss": "to raise",
      "glossSv": "hissa, höja, resa upp",
      "pos": "action",
      "explanation": "activity + up + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        678
      ]
    },
    {
      "id": 4685,
      "bciAvId": 24724,
      "gloss": "receipt",
      "glossSv": "kvitto",
      "pos": "noun",
      "explanation": "paper + after + money",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        109,
        "/",
        451
      ]
    },
    {
      "id": 4686,
      "bciAvId": 24725,
      "gloss": "receiver",
      "glossSv": "mottagare",
      "pos": "noun",
      "explanation": "receiving + thing indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        97
      ]
    },
    {
      "id": 4687,
      "bciAvId": 24728,
      "gloss": "to reef",
      "glossSv": "reva",
      "pos": "action",
      "explanation": "decrease,reduce-(to) + sail + action indicator",
      "isCharacter": false,
      "composition": [
        956,
        ";",
        81,
        "/",
        720
      ]
    },
    {
      "id": 4688,
      "bciAvId": 24729,
      "gloss": "rein",
      "glossSv": "tygel, töm",
      "pos": "noun",
      "explanation": "linear thing + leadership,guidance + horse + thing indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        803,
        "/",
        391
      ]
    },
    {
      "id": 4689,
      "bciAvId": 24730,
      "gloss": "remote control",
      "glossSv": "fjärrkontroll",
      "pos": "noun",
      "explanation": "tool + channel (programs)",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        922,
        "/",
        223
      ]
    },
    {
      "id": 4690,
      "bciAvId": 24731,
      "gloss": "rent",
      "glossSv": "hyra (subst.)",
      "pos": "noun",
      "explanation": "cost,price + limited time",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        331,
        "/",
        651,
        "/",
        426
      ]
    },
    {
      "id": 4691,
      "bciAvId": 24732,
      "gloss": "to rent, to lease, to let",
      "glossSv": "hyra ut",
      "pos": "action",
      "explanation": "pay,spend-(to) + limited time + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        451,
        "/",
        426
      ]
    },
    {
      "id": 4692,
      "bciAvId": 24733,
      "gloss": "to rent, to lease, to hire, to charter",
      "glossSv": "hyra (verb)",
      "pos": "action",
      "explanation": "get,acquire,receive-(to) + money + limited time + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        451,
        "/",
        426
      ]
    },
    {
      "id": 4693,
      "bciAvId": 24734,
      "gloss": "respiratory illness",
      "glossSv": "luftvägssjukdom, astma (etc)",
      "pos": "noun",
      "explanation": "illness + breathe-(to)",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 4694,
      "bciAvId": 24735,
      "gloss": "road sign, traffic signal",
      "glossSv": "vägmärke",
      "pos": "noun",
      "explanation": "sign + vehicle",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        835,
        "/",
        688
      ]
    },
    {
      "id": 4695,
      "bciAvId": 24736,
      "gloss": "rock music, rock'n'roll, rock",
      "glossSv": "rockmusik",
      "pos": "noun",
      "explanation": "music + up and down",
      "isCharacter": false,
      "composition": [
        278,
        "/",
        462,
        "/",
        723
      ]
    },
    {
      "id": 4696,
      "bciAvId": 24737,
      "gloss": "rough sea",
      "glossSv": "sjögång",
      "pos": "noun",
      "explanation": "much,many,very + wave",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        761
      ]
    },
    {
      "id": 4697,
      "bciAvId": 24738,
      "gloss": "rye",
      "glossSv": "råg",
      "pos": "noun",
      "explanation": "grain + linear thing + small + thing indicator: ear of grain with short tassels",
      "isCharacter": false,
      "composition": [
        357,
        "/",
        428,
        ";",
        97,
        "/",
        956
      ]
    },
    {
      "id": 4698,
      "bciAvId": 24740,
      "gloss": "satellite dish (1)",
      "glossSv": "satellitmottagare (1)",
      "pos": "noun",
      "explanation": "signal receiver (1) + communication satellite",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        97,
        "/",
        921,
        "/",
        1029
      ]
    },
    {
      "id": 4699,
      "bciAvId": 24741,
      "gloss": "satellite dish (2)",
      "glossSv": "satellitmottagare (2)",
      "pos": "noun",
      "explanation": "signal receiver (2) + communication satellite",
      "isCharacter": false,
      "composition": [
        919,
        "/",
        921,
        "/",
        1029
      ]
    },
    {
      "id": 4700,
      "bciAvId": 24742,
      "gloss": "satellite signal",
      "glossSv": "satellitsignal",
      "pos": "noun",
      "explanation": "signal,broadcast,transmitting + satellite",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        921
      ]
    },
    {
      "id": 4701,
      "bciAvId": 24743,
      "gloss": "school uniform",
      "glossSv": "skoluniform",
      "pos": "noun",
      "explanation": "clothes + school [contraction]",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 4702,
      "bciAvId": 24744,
      "gloss": "sea captain, skipper",
      "glossSv": "sjökapten, skeppare",
      "pos": "noun",
      "explanation": "leader + boat",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        170
      ]
    },
    {
      "id": 4703,
      "bciAvId": 24745,
      "gloss": "sea chart",
      "glossSv": "sjökort",
      "pos": "noun",
      "explanation": "paper + water (ground level) (sea [contraction])",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        1117
      ]
    },
    {
      "id": 4704,
      "bciAvId": 24746,
      "gloss": "shadow, shade",
      "glossSv": "skugga",
      "pos": "noun",
      "explanation": "shape + without + light",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        449,
        "/",
        424
      ]
    },
    {
      "id": 4705,
      "bciAvId": 24747,
      "gloss": "shipping forecast",
      "glossSv": "sjörapport",
      "pos": "noun",
      "explanation": "weather forecast + water (ground level) (sea [contraction])",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        341,
        "/",
        696,
        "/",
        1117
      ]
    },
    {
      "id": 4706,
      "bciAvId": 24748,
      "gloss": "shower chair",
      "glossSv": "duschstol",
      "pos": "noun",
      "explanation": "chair + shower",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        591
      ]
    },
    {
      "id": 4707,
      "bciAvId": 24749,
      "gloss": "sign, signal",
      "glossSv": "märke, tecken, signal, skylt",
      "pos": "noun",
      "explanation": "thing + information",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        835
      ]
    },
    {
      "id": 4708,
      "bciAvId": 24751,
      "gloss": "signal receiver (1)",
      "glossSv": "signalmottagare (1)",
      "pos": "noun",
      "explanation": "signal reception + thing indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        97,
        "/",
        922
      ]
    },
    {
      "id": 4709,
      "bciAvId": 24752,
      "gloss": "signal receiver (2)",
      "glossSv": "signalmottagare (2)",
      "pos": "noun",
      "explanation": "receiver,dish + signal",
      "isCharacter": false,
      "composition": [
        919,
        "/",
        922
      ]
    },
    {
      "id": 4710,
      "bciAvId": 24753,
      "gloss": "signal reception",
      "glossSv": "signalmottagning",
      "pos": "noun",
      "explanation": "to get + signal,broadcast,transmitting",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        922
      ]
    },
    {
      "id": 4711,
      "bciAvId": 24754,
      "gloss": "singalong",
      "glossSv": "allsång",
      "pos": "noun",
      "explanation": "activity + song + all",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        457,
        "/",
        462,
        "/",
        117
      ]
    },
    {
      "id": 4712,
      "bciAvId": 24755,
      "gloss": "solar eclipse",
      "glossSv": "solförmörkelse",
      "pos": "noun",
      "explanation": "sun + behind + moon",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        109,
        "/",
        453
      ]
    },
    {
      "id": 4713,
      "bciAvId": 24756,
      "gloss": "speech",
      "glossSv": "tal",
      "pos": "noun",
      "explanation": "activity + mouth",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        457
      ]
    },
    {
      "id": 4714,
      "bciAvId": 24757,
      "gloss": "spending spree",
      "glossSv": "slöseri",
      "pos": "noun",
      "explanation": "to buy + intensity",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        651,
        "/",
        401
      ]
    },
    {
      "id": 4715,
      "bciAvId": 24758,
      "gloss": "to splurge",
      "glossSv": "slösa",
      "pos": "action",
      "explanation": "spending spree + action indicator",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        81,
        "/",
        651,
        "/",
        401
      ]
    },
    {
      "id": 4716,
      "bciAvId": 24759,
      "gloss": "stand-in, substitute, alternate",
      "glossSv": "vikarie, ersättare (etc)",
      "pos": "noun",
      "explanation": "person + activity + another",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        428,
        "/",
        11
      ]
    },
    {
      "id": 4717,
      "bciAvId": 24760,
      "gloss": "starboard",
      "glossSv": "styrbord",
      "pos": "noun",
      "explanation": "right turn,right (position or direction) + boat",
      "isCharacter": false,
      "composition": [
        1078,
        "/",
        170
      ]
    },
    {
      "id": 4718,
      "bciAvId": 24762,
      "gloss": "stranger, unknown (person)",
      "glossSv": "främling, okänd (person)",
      "pos": "person",
      "explanation": "person + unknown",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        746
      ]
    },
    {
      "id": 4719,
      "bciAvId": 24763,
      "gloss": "submerged rock, reef",
      "glossSv": "undervattensgrund",
      "pos": "noun",
      "explanation": "rock + under + water (ground level) (sea [contraction])",
      "isCharacter": false,
      "composition": [
        629,
        "/",
        676,
        "/",
        1117
      ]
    },
    {
      "id": 4720,
      "bciAvId": 24764,
      "gloss": "sun lounger, deck chair",
      "glossSv": "solstol",
      "pos": "noun",
      "explanation": "sofa + sun",
      "isCharacter": false,
      "composition": [
        242,
        "/",
        636
      ]
    },
    {
      "id": 4721,
      "bciAvId": 24765,
      "gloss": "to sunbathe",
      "glossSv": "solbada, sola sig",
      "pos": "action",
      "explanation": "to rest + sun + action indicator",
      "isCharacter": false,
      "composition": [
        562,
        ";",
        81,
        "/",
        636
      ]
    },
    {
      "id": 4722,
      "bciAvId": 24766,
      "gloss": "sunburn",
      "glossSv": "solbränna, solsveda",
      "pos": "noun",
      "explanation": "suntan + intensity",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        284,
        "/",
        636,
        "/",
        401
      ]
    },
    {
      "id": 4723,
      "bciAvId": 24767,
      "gloss": "sunglasses",
      "glossSv": "solglasögon",
      "pos": "noun",
      "explanation": "glasses + sun",
      "isCharacter": false,
      "composition": [
        353,
        "/",
        636
      ]
    },
    {
      "id": 4724,
      "bciAvId": 24768,
      "gloss": "suntan",
      "glossSv": "solbränna",
      "pos": "noun",
      "explanation": "colour + effect + sun",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        284,
        "/",
        636
      ]
    },
    {
      "id": 4725,
      "bciAvId": 24769,
      "gloss": "Take your time!",
      "glossSv": "Ta den tid du behöver!",
      "pos": "action",
      "explanation": "use + time + action indicator",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        81,
        "/",
        655
      ]
    },
    {
      "id": 4726,
      "bciAvId": 24770,
      "gloss": "toilet chair, commode chair",
      "glossSv": "toalettstol",
      "pos": "noun",
      "explanation": "chair + toilet",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        659
      ]
    },
    {
      "id": 4727,
      "bciAvId": 24771,
      "gloss": "tourist",
      "glossSv": "turist",
      "pos": "person",
      "explanation": "visitor + place",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        935,
        "/",
        531
      ]
    },
    {
      "id": 4728,
      "bciAvId": 24772,
      "gloss": "tourist (foreign)",
      "glossSv": "turist (utländsk)",
      "pos": "person",
      "explanation": "visitor + country",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        935,
        "/",
        243
      ]
    },
    {
      "id": 4729,
      "bciAvId": 24773,
      "gloss": "TV programme, TV show, radio programme",
      "glossSv": "TV-program, radioprogram",
      "pos": "noun",
      "explanation": "part of + channel",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        922,
        "/",
        223
      ]
    },
    {
      "id": 4730,
      "bciAvId": 24774,
      "gloss": "TV studio, radio studio",
      "glossSv": "TV-studio, radiostudio",
      "pos": "noun",
      "explanation": "place + signal,broadcast,transmitting",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        922
      ]
    },
    {
      "id": 4731,
      "bciAvId": 24775,
      "gloss": "urine bottle",
      "glossSv": "urinflaska",
      "pos": "noun",
      "explanation": "bottle + urine",
      "isCharacter": false,
      "composition": [
        174,
        "/",
        694,
        "/",
        349
      ]
    },
    {
      "id": 4732,
      "bciAvId": 24776,
      "gloss": "USA",
      "glossSv": "USA",
      "pos": "noun",
      "explanation": "country + star + stripe",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        622,
        "/",
        428
      ]
    },
    {
      "id": 4733,
      "bciAvId": 24777,
      "gloss": "waiter, waitress",
      "glossSv": "servitör, servitris",
      "pos": "person",
      "explanation": "person + bring + food",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        917,
        "/",
        329
      ]
    },
    {
      "id": 4734,
      "bciAvId": 24779,
      "gloss": "weather satellite, spy satellite",
      "glossSv": "vädersatellit, spionsatellit",
      "pos": "noun",
      "explanation": "communication satellite + camera",
      "isCharacter": false,
      "composition": [
        921,
        "/",
        1029,
        "/",
        198
      ]
    },
    {
      "id": 4735,
      "bciAvId": 24780,
      "gloss": "wheat",
      "glossSv": "vete",
      "pos": "noun",
      "explanation": "grain + without + linear thing + thing indicator: ear of grain without tassels",
      "isCharacter": false,
      "composition": [
        357,
        "/",
        449,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 4736,
      "bciAvId": 24781,
      "gloss": "video phone",
      "glossSv": "bildtelefon, videotelefon",
      "pos": "noun",
      "explanation": "telephone + camera",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288,
        "/",
        198
      ]
    },
    {
      "id": 4737,
      "bciAvId": 24782,
      "gloss": "wireless connection, WIFI",
      "glossSv": "trådlös anslutning, WiFi, trådlöst nätverk",
      "pos": "noun",
      "explanation": "digital signal + without + linear thing (wire,cable [contraction]) + thing indicator",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        829,
        "/",
        449,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 4738,
      "bciAvId": 24802,
      "gloss": "bell, chime bar",
      "glossSv": "tonstav, klocka",
      "pos": "noun",
      "explanation": "musical instrument + 1 + musical note",
      "isCharacter": false,
      "composition": [
        865,
        "/",
        10,
        "/",
        462
      ]
    },
    {
      "id": 4739,
      "bciAvId": 24803,
      "gloss": "man-made item, artefact, artifact, product",
      "glossSv": "produkt, tillverkad sak",
      "pos": "noun",
      "explanation": "making,production,fashioning + thing indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97
      ]
    },
    {
      "id": 4740,
      "bciAvId": 24804,
      "gloss": "eagerness, keenness, willingness",
      "glossSv": "iver",
      "pos": "noun",
      "explanation": "feeling + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        401
      ]
    },
    {
      "id": 4741,
      "bciAvId": 24808,
      "gloss": "agreed, in agreement, harmonious",
      "glossSv": "överens, enig",
      "pos": "description",
      "explanation": "harmony,harmoniousness,concord,concordance + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        113
      ]
    },
    {
      "id": 4742,
      "bciAvId": 24809,
      "gloss": "bathtub, bath, tub",
      "glossSv": "badkar",
      "pos": "noun",
      "explanation": "sink,basin + length,longness + thing indicator",
      "isCharacter": false,
      "composition": [
        595,
        ";",
        97,
        "/",
        420
      ]
    },
    {
      "id": 4743,
      "bciAvId": 24810,
      "gloss": "bugle (hunting)",
      "glossSv": "jakthorn",
      "pos": "noun",
      "explanation": "trumpet,horn,cornet (1) + animal",
      "isCharacter": false,
      "composition": [
        389,
        "/",
        122
      ]
    },
    {
      "id": 4744,
      "bciAvId": 24811,
      "gloss": "conductor (music)",
      "glossSv": "dirigent",
      "pos": "person",
      "explanation": "leader,director,guide (1) + musical note (music [contraction])",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        462
      ]
    },
    {
      "id": 4745,
      "bciAvId": 24812,
      "gloss": "government",
      "glossSv": "regering",
      "pos": "noun",
      "explanation": "board,board of directors,executive + country",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        736,
        "/",
        243
      ]
    },
    {
      "id": 4746,
      "bciAvId": 24813,
      "gloss": "homosexual (female), lesbian",
      "glossSv": "homosexuell, lesbisk",
      "pos": "description",
      "explanation": "homosexuality (female),lesbianism + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        1014
      ]
    },
    {
      "id": 4747,
      "bciAvId": 24814,
      "gloss": "homosexual (male), gay",
      "glossSv": "homosexuell, gay",
      "pos": "description",
      "explanation": "homosexuality (male) + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        1015
      ]
    },
    {
      "id": 4748,
      "bciAvId": 24815,
      "gloss": "in love",
      "glossSv": "kär, förälskad",
      "pos": "description",
      "explanation": "love,affection + description indicator",
      "isCharacter": false,
      "composition": [
        431,
        ";",
        86
      ]
    },
    {
      "id": 4749,
      "bciAvId": 24816,
      "gloss": "to massage",
      "glossSv": "massera",
      "pos": "action",
      "explanation": "massage + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        718
      ]
    },
    {
      "id": 4750,
      "bciAvId": 24817,
      "gloss": "niece or nephew",
      "glossSv": "syskonbarn",
      "pos": "person",
      "explanation": "offspring,child + sibling: child of a sibling",
      "isCharacter": false,
      "composition": [
        479,
        "/",
        479,
        "/",
        11
      ]
    },
    {
      "id": 4751,
      "bciAvId": 24818,
      "gloss": "psychology (class)",
      "glossSv": "psykologi (skolämne)",
      "pos": "noun",
      "explanation": "knowledge,class (in combinations) + mind + feeling: where mind + feeling represents psychology [contraction]",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 4752,
      "bciAvId": 24819,
      "gloss": "quickness, rapidity, speediness",
      "glossSv": "snabbhet",
      "pos": "noun",
      "explanation": "forward + intensity",
      "isCharacter": false,
      "composition": [
        335,
        "/",
        401
      ]
    },
    {
      "id": 4753,
      "bciAvId": 24820,
      "gloss": "terrorism",
      "glossSv": "terrorism",
      "pos": "noun",
      "explanation": "cause + terror,panic",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        313,
        "/",
        271,
        "/",
        1042,
        "/",
        401
      ]
    },
    {
      "id": 4754,
      "bciAvId": 24821,
      "gloss": "troublesome",
      "glossSv": "besvärlig",
      "pos": "description",
      "explanation": "trouble + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        1063
      ]
    },
    {
      "id": 4755,
      "bciAvId": 24822,
      "gloss": "upset, disturbance, agitation",
      "glossSv": "upprördhet",
      "pos": "noun",
      "explanation": "feeling + up and down: unsettled feelings",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        723
      ]
    },
    {
      "id": 4756,
      "bciAvId": 24823,
      "gloss": "to cry out, to call",
      "glossSv": "ropa",
      "pos": "action",
      "explanation": "say,speak,talk,tell,express-(to) + intensity + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 4757,
      "bciAvId": 24824,
      "gloss": "laugh, laughter",
      "glossSv": "skratt",
      "pos": "noun",
      "explanation": "happiness + mouth: expression of happiness with the mouth by laughing",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 4758,
      "bciAvId": 24826,
      "gloss": "jewelry, jewellery",
      "glossSv": "smycke",
      "pos": "noun",
      "explanation": "generalization + jewel",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622
      ]
    },
    {
      "id": 4759,
      "bciAvId": 24827,
      "gloss": "boring, dull, depressing",
      "glossSv": "tråkig",
      "pos": "description",
      "explanation": "sadness,sorrow,unhappiness + mouth: mouth displaying an unhappy and bored feeling",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        271,
        "/",
        457
      ]
    },
    {
      "id": 4760,
      "bciAvId": 24828,
      "gloss": "laundry (workplace)",
      "glossSv": "tvättstuga",
      "pos": "noun",
      "explanation": "room + bath,washing + clothing",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        595,
        "/",
        229
      ]
    },
    {
      "id": 4761,
      "bciAvId": 24829,
      "gloss": "great, wonderful, fantastic",
      "glossSv": "fantastisk, underbar, jättebra",
      "pos": "description",
      "explanation": "good,well,fine,ok,okay,all right + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        120,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4762,
      "bciAvId": 24830,
      "gloss": "geyser",
      "glossSv": "gejser, geysir",
      "pos": "noun",
      "explanation": "hot spring + intensity",
      "isCharacter": false,
      "composition": [
        1117,
        "/",
        678,
        "/",
        378,
        "/",
        401
      ]
    },
    {
      "id": 4763,
      "bciAvId": 24831,
      "gloss": "terror, panic",
      "glossSv": "skräck, fasa, panik",
      "pos": "noun",
      "explanation": "fear + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        1042,
        "/",
        401
      ]
    },
    {
      "id": 4764,
      "bciAvId": 24832,
      "gloss": "wait, waiting",
      "glossSv": "väntan",
      "pos": "noun",
      "explanation": "end,arrival,stop + limited time: a halt for a limited time",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        426
      ]
    },
    {
      "id": 4765,
      "bciAvId": 24834,
      "gloss": "want, desire",
      "glossSv": "vilja (subst.)",
      "pos": "noun",
      "explanation": "feeling + fire: an emotional desire, a strong feeling shown by fire",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        319
      ]
    },
    {
      "id": 4766,
      "bciAvId": 24835,
      "gloss": "last month",
      "glossSv": "förra månaden",
      "pos": "noun",
      "explanation": "month + ago,then (past)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        112
      ]
    },
    {
      "id": 4767,
      "bciAvId": 24840,
      "gloss": "anthropologist",
      "glossSv": "antropolog",
      "pos": "person",
      "explanation": "person + anthropology",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        513
      ]
    },
    {
      "id": 4768,
      "bciAvId": 24841,
      "gloss": "children's room",
      "glossSv": "barnrum",
      "pos": "noun",
      "explanation": "room + child",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        220
      ]
    },
    {
      "id": 4769,
      "bciAvId": 24842,
      "gloss": "to cost",
      "glossSv": "kosta",
      "pos": "action",
      "explanation": "cost,price + action indicator",
      "isCharacter": false,
      "composition": [
        451,
        ";",
        81,
        "/",
        331,
        "/",
        651
      ]
    },
    {
      "id": 4770,
      "bciAvId": 24843,
      "gloss": "to expose oneself indecently",
      "glossSv": "blotta sig",
      "pos": "action",
      "explanation": "exhibitionism,immodesty,indecent exposure + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        303,
        "/",
        349
      ]
    },
    {
      "id": 4771,
      "bciAvId": 24844,
      "gloss": "finished, complete, completed, all done, done (finished)",
      "glossSv": "färdig, klar, avslutad",
      "pos": "description",
      "explanation": "to do + all + description indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 4772,
      "bciAvId": 24845,
      "gloss": "light (not dark)",
      "glossSv": "ljus (adj.)",
      "pos": "description",
      "explanation": "light + description indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        86
      ]
    },
    {
      "id": 4773,
      "bciAvId": 24848,
      "gloss": "hug, squeeze, embrace",
      "glossSv": "kram",
      "pos": "noun",
      "explanation": "arm + around",
      "isCharacter": false,
      "composition": [
        132,
        "/",
        134
      ]
    },
    {
      "id": 4774,
      "bciAvId": 24849,
      "gloss": "boss, supervisor",
      "glossSv": "chef, arbetsledare, föreståndare",
      "pos": "person",
      "explanation": "leader,director,guide (1) + work,employment,job",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        711
      ]
    },
    {
      "id": 4775,
      "bciAvId": 24850,
      "gloss": "to brake (general)",
      "glossSv": "bromsa (allmänt)",
      "pos": "action",
      "explanation": "brake (general) + action indicator",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        81,
        "/",
        292
      ]
    },
    {
      "id": 4776,
      "bciAvId": 24851,
      "gloss": "to brake (vehicle)",
      "glossSv": "bromsa (fordon)",
      "pos": "action",
      "explanation": "brake (vehicle) + action indicator",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        81,
        "/",
        292,
        "/",
        974
      ]
    },
    {
      "id": 4777,
      "bciAvId": 24853,
      "gloss": "dance, dancing",
      "glossSv": "dans",
      "pos": "noun",
      "explanation": "legs and feet + musical note: stepping to the rhythm of music",
      "isCharacter": false,
      "composition": [
        418,
        "/",
        462
      ]
    },
    {
      "id": 4778,
      "bciAvId": 24854,
      "gloss": "drowning",
      "glossSv": "drunkning",
      "pos": "noun",
      "explanation": "death + water",
      "isCharacter": false,
      "composition": [
        259,
        "/",
        695
      ]
    },
    {
      "id": 4779,
      "bciAvId": 24856,
      "gloss": "improvement",
      "glossSv": "bättring, förbättring",
      "pos": "noun",
      "explanation": "cause + more + correct: to cause to be better, in a rational sense.",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        937,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 4780,
      "bciAvId": 24857,
      "gloss": "pier",
      "glossSv": "brygga, kaj",
      "pos": "noun",
      "explanation": "platform,stage + boat,ship",
      "isCharacter": false,
      "composition": [
        884,
        "/",
        170
      ]
    },
    {
      "id": 4781,
      "bciAvId": 24871,
      "gloss": "advocacy",
      "glossSv": "förespråkande",
      "pos": "noun",
      "explanation": "mouth + purpose: speaking for a purpose",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        551
      ]
    },
    {
      "id": 4782,
      "bciAvId": 24872,
      "gloss": "advocacy, representation (legal)",
      "glossSv": "representation, försvar (juridiskt)",
      "pos": "noun",
      "explanation": "advocacy + legal [contraction]",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        551,
        "/",
        813
      ]
    },
    {
      "id": 4783,
      "bciAvId": 24873,
      "gloss": "band, orchestra",
      "glossSv": "orkester, musikgrupp (instrumental)",
      "pos": "person",
      "explanation": "group (people) + musical instrument (in combinations)",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        865
      ]
    },
    {
      "id": 4784,
      "bciAvId": 24874,
      "gloss": "to be named, to be called",
      "glossSv": "heta",
      "pos": "action",
      "explanation": "name,label,term,title + action indicator",
      "isCharacter": false,
      "composition": [
        464,
        ";",
        81
      ]
    },
    {
      "id": 4785,
      "bciAvId": 24876,
      "gloss": "board and lodging, room and board",
      "glossSv": "kost och logi",
      "pos": "noun",
      "explanation": "house,building,dwelling,residence + plus + food: dwelling with food",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        120,
        "/",
        329
      ]
    },
    {
      "id": 4786,
      "bciAvId": 24877,
      "gloss": "to build, to construct",
      "glossSv": "bygga, konstruera",
      "pos": "action",
      "explanation": "structure,construction + action indicator",
      "isCharacter": false,
      "composition": [
        633,
        ";",
        81
      ]
    },
    {
      "id": 4787,
      "bciAvId": 24878,
      "gloss": "clearness, clarity, transparency, transparence",
      "glossSv": "genomskinlighet",
      "pos": "noun",
      "explanation": "eye + through: the quality of being possible to see through",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        653
      ]
    },
    {
      "id": 4788,
      "bciAvId": 24882,
      "gloss": "crown (currency)",
      "glossSv": "krona (valuta)",
      "pos": "noun",
      "explanation": "money + crown",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        798
      ]
    },
    {
      "id": 4789,
      "bciAvId": 24885,
      "gloss": "disgust",
      "glossSv": "avsky (subst.)",
      "pos": "noun",
      "explanation": "hate + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        449,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4790,
      "bciAvId": 24886,
      "gloss": "disgusting (general)",
      "glossSv": "avskyvärd",
      "pos": "description",
      "explanation": "disgust + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4791,
      "bciAvId": 24888,
      "gloss": "divided",
      "glossSv": "delad",
      "pos": "description",
      "explanation": "division + description indicator",
      "isCharacter": false,
      "composition": [
        266,
        ";",
        86
      ]
    },
    {
      "id": 4792,
      "bciAvId": 24892,
      "gloss": "eternity, infinity",
      "glossSv": "evighet, oändlighet (FD)",
      "pos": "noun",
      "explanation": "time + infiniteness,boundlessness,limitlessness (OLD)",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        449,
        "/",
        427
      ]
    },
    {
      "id": 4793,
      "bciAvId": 24893,
      "gloss": "experiment",
      "glossSv": "experiment",
      "pos": "noun",
      "explanation": "activity + purpose + answer",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        551,
        "/",
        129
      ]
    },
    {
      "id": 4794,
      "bciAvId": 24894,
      "gloss": "fall, drop, spill, tumble",
      "glossSv": "fall",
      "pos": "noun",
      "explanation": "down + intensity",
      "isCharacter": false,
      "composition": [
        271,
        "/",
        401
      ]
    },
    {
      "id": 4795,
      "bciAvId": 24898,
      "gloss": "fixing, fix, mending, mend, repair, reparation",
      "glossSv": "lagning",
      "pos": "noun",
      "explanation": "to make + to work: making something work again",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        711
      ]
    },
    {
      "id": 4796,
      "bciAvId": 24900,
      "gloss": "fountain",
      "glossSv": "fontän",
      "pos": "noun",
      "explanation": "thing + water (ground level) + up",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        1117,
        "/",
        678
      ]
    },
    {
      "id": 4797,
      "bciAvId": 24901,
      "gloss": "gallop",
      "glossSv": "galopp",
      "pos": "noun",
      "explanation": "canter-(to) + intensity",
      "isCharacter": false,
      "composition": [
        391,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4798,
      "bciAvId": 24902,
      "gloss": "geographer",
      "glossSv": "geograf",
      "pos": "person",
      "explanation": "scientist,academic + earth,globe,world",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        280
      ]
    },
    {
      "id": 4799,
      "bciAvId": 24905,
      "gloss": "growth, growing",
      "glossSv": "tillväxt",
      "pos": "noun",
      "explanation": "flower + up: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a general sense (i.e., growth of children).",
      "isCharacter": false,
      "composition": [
        325,
        "/",
        678
      ]
    },
    {
      "id": 4800,
      "bciAvId": 24908,
      "gloss": "hate, hatred",
      "glossSv": "hat",
      "pos": "noun",
      "explanation": "dislike + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        449,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4801,
      "bciAvId": 24910,
      "gloss": "heterosexual",
      "glossSv": "heterosexuell",
      "pos": "description",
      "explanation": "heterosexuality + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        245
      ]
    },
    {
      "id": 4802,
      "bciAvId": 24911,
      "gloss": "hitchrack, hitching bar",
      "glossSv": "hästräcke",
      "pos": "noun",
      "explanation": "linear thing (horizontal),bar + attachment,appendix,annex + horse: a bar for tying up horses, thus the modification of hitch,tie up,fix up-(to) 24152",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        97,
        "/",
        823,
        "/",
        391
      ]
    },
    {
      "id": 4803,
      "bciAvId": 24914,
      "gloss": "indoor, indoors",
      "glossSv": "inomhus",
      "pos": "description",
      "explanation": "indoor (character) + description indicator",
      "isCharacter": false,
      "composition": [
        775,
        ";",
        86
      ]
    },
    {
      "id": 4804,
      "bciAvId": 24915,
      "gloss": "infiniteness, boundlessness, limitlessness",
      "glossSv": "gränslöshet (FD)",
      "pos": "noun",
      "explanation": "minus,no,without + limit(s),limitation (OLD)",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        427
      ]
    },
    {
      "id": 4805,
      "bciAvId": 24919,
      "gloss": "malodour, malodor, stench",
      "glossSv": "odör, stank",
      "pos": "noun",
      "explanation": "smell,odour + negative",
      "isCharacter": false,
      "composition": [
        600,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4806,
      "bciAvId": 24921,
      "gloss": "next month",
      "glossSv": "nästa månad",
      "pos": "noun",
      "explanation": "month + then (future)",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        648
      ]
    },
    {
      "id": 4807,
      "bciAvId": 24922,
      "gloss": "noise (loud)",
      "glossSv": "oljud, oväsen",
      "pos": "noun",
      "explanation": "sound + intensity",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        401
      ]
    },
    {
      "id": 4808,
      "bciAvId": 24923,
      "gloss": "oere (currency)",
      "glossSv": "öre (valuta)",
      "pos": "noun",
      "explanation": "part,bit,piece,portion,part of + crown (currency)",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        451,
        "/",
        798
      ]
    },
    {
      "id": 4809,
      "bciAvId": 24924,
      "gloss": "oval, elliptic, elliptical",
      "glossSv": "oval, elliptisk",
      "pos": "description",
      "explanation": "oval,ellipse + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86,
        "/",
        651,
        "/",
        842
      ]
    },
    {
      "id": 4810,
      "bciAvId": 24928,
      "gloss": "physicist",
      "glossSv": "fysiker",
      "pos": "person",
      "explanation": "person + physics",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        580,
        "/",
        293
      ]
    },
    {
      "id": 4811,
      "bciAvId": 24929,
      "gloss": "preparation, readying, readiness, preparedness",
      "glossSv": "förberedelse",
      "pos": "noun",
      "explanation": "activity + for (the purpose of) + future: something done in order to be ready for the future",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        332,
        "/",
        341
      ]
    },
    {
      "id": 4812,
      "bciAvId": 24930,
      "gloss": "promise",
      "glossSv": "löfte",
      "pos": "noun",
      "explanation": "mouth + activity + future: to say that something will be done in the future",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        106,
        "/",
        341
      ]
    },
    {
      "id": 4813,
      "bciAvId": 24931,
      "gloss": "protected, sheltered",
      "glossSv": "skyddad",
      "pos": "description",
      "explanation": "protection,shelter + description indicator",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        86
      ]
    },
    {
      "id": 4814,
      "bciAvId": 24933,
      "gloss": "reading",
      "glossSv": "läsning",
      "pos": "noun",
      "explanation": "eye + paper,card,page: the act of seeing and perceiving what is written on the printed page",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        497
      ]
    },
    {
      "id": 4815,
      "bciAvId": 24935,
      "gloss": "to research",
      "glossSv": "forska",
      "pos": "action",
      "explanation": "research + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        826,
        "/",
        299
      ]
    },
    {
      "id": 4816,
      "bciAvId": 24936,
      "gloss": "riding, horseback riding",
      "glossSv": "ridning",
      "pos": "noun",
      "explanation": "activity + horse",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        391
      ]
    },
    {
      "id": 4817,
      "bciAvId": 24939,
      "gloss": "sport (class)",
      "glossSv": "idrott (skolämne)",
      "pos": "noun",
      "explanation": "knowledge,class (in combinations) + sport",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        719
      ]
    },
    {
      "id": 4818,
      "bciAvId": 24942,
      "gloss": "stress (for time)",
      "glossSv": "stress, jäkt",
      "pos": "noun",
      "explanation": "feeling + without + time + activity: a feeling of lacking time for an activity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        449,
        "/",
        655,
        "/",
        106
      ]
    },
    {
      "id": 4819,
      "bciAvId": 24943,
      "gloss": "to stress (for time)",
      "glossSv": "stressa, jäkta",
      "pos": "action",
      "explanation": "stress (for time) + action indicator: acting with a feeling of lacking time for the activity",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        449,
        "/",
        655,
        "/",
        106
      ]
    },
    {
      "id": 4820,
      "bciAvId": 24945,
      "gloss": "supernatural",
      "glossSv": "övernaturlig",
      "pos": "description",
      "explanation": "supernatural-(noun) + description indicator",
      "isCharacter": false,
      "composition": [
        733,
        ";",
        86
      ]
    },
    {
      "id": 4821,
      "bciAvId": 24946,
      "gloss": "sweetness, sweet",
      "glossSv": "sötma",
      "pos": "noun",
      "explanation": "taste + up: pleasant taste",
      "isCharacter": false,
      "composition": [
        642,
        "/",
        678
      ]
    },
    {
      "id": 4822,
      "bciAvId": 24947,
      "gloss": "swimming, swim",
      "glossSv": "simning",
      "pos": "noun",
      "explanation": "through + water: motion through water",
      "isCharacter": false,
      "composition": [
        653,
        "/",
        695
      ]
    },
    {
      "id": 4823,
      "bciAvId": 24948,
      "gloss": "this month",
      "glossSv": "den här månaden",
      "pos": "noun",
      "explanation": "month + now",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        474
      ]
    },
    {
      "id": 4824,
      "bciAvId": 24950,
      "gloss": "vomiting, vomit, puking",
      "glossSv": "kräkning",
      "pos": "noun",
      "explanation": "out of,exit (forward) + food: expelling of food",
      "isCharacter": false,
      "composition": [
        491,
        "/",
        329
      ]
    },
    {
      "id": 4825,
      "bciAvId": 24963,
      "gloss": "aport",
      "glossSv": "babord (riktning)",
      "pos": "description",
      "explanation": "port (boat) + description indicator",
      "isCharacter": false,
      "composition": [
        1051,
        ";",
        86,
        "/",
        170
      ]
    },
    {
      "id": 4826,
      "bciAvId": 24964,
      "gloss": "astarboard",
      "glossSv": "styrbord (riktning)",
      "pos": "description",
      "explanation": "starboard + description indicator",
      "isCharacter": false,
      "composition": [
        1078,
        ";",
        86,
        "/",
        170
      ]
    },
    {
      "id": 4827,
      "bciAvId": 24965,
      "gloss": "hunt, hunting",
      "glossSv": "jakt",
      "pos": "noun",
      "explanation": "gun + animal",
      "isCharacter": false,
      "composition": [
        369,
        "/",
        122
      ]
    },
    {
      "id": 4828,
      "bciAvId": 24966,
      "gloss": "church ruin, temple ruin, wreck, wreckage (church, temple, mosque) (2)",
      "glossSv": "kyrkoruin, tempelruin (2)",
      "pos": "noun",
      "explanation": "church,mosque,temple + deletion,cancellation,destruction",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        355,
        "/",
        939
      ]
    },
    {
      "id": 4829,
      "bciAvId": 24967,
      "gloss": "army, regular army, ground forces",
      "glossSv": "armé, markstyrkor",
      "pos": "noun",
      "explanation": "military,armed forces,armed services + earth,ground,land",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693,
        "/",
        281
      ]
    },
    {
      "id": 4830,
      "bciAvId": 24968,
      "gloss": "destroyed, ruined, demolished, deleted, erased, cancelled",
      "glossSv": "förstörd, borttagen, raderad, struken, utsuddad, utplånad",
      "pos": "description",
      "explanation": "deletion,cancellation,destruction + description indicator",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        86
      ]
    },
    {
      "id": 4831,
      "bciAvId": 25001,
      "gloss": "to access",
      "glossSv": "få tillräde (till), få åtkomst (till), få tillgång (till)",
      "pos": "action",
      "explanation": "accessibility + action indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        81,
        "/",
        653
      ]
    },
    {
      "id": 4832,
      "bciAvId": 25002,
      "gloss": "accessibility, access",
      "glossSv": "tillgänglighet, tillgång, åtkomlighet",
      "pos": "noun",
      "explanation": "being (state of) + through: being possible to get through to",
      "isCharacter": false,
      "composition": [
        894,
        "/",
        653
      ]
    },
    {
      "id": 4833,
      "bciAvId": 25003,
      "gloss": "accessible",
      "glossSv": "tillgänglig, åtkomlig",
      "pos": "description",
      "explanation": "accessibility + description indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        86,
        "/",
        653
      ]
    },
    {
      "id": 4834,
      "bciAvId": 25004,
      "gloss": "to adopt",
      "glossSv": "adoptera",
      "pos": "action",
      "explanation": "adoption + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        813,
        "/",
        500
      ]
    },
    {
      "id": 4835,
      "bciAvId": 25005,
      "gloss": "adoption",
      "glossSv": "adoption",
      "pos": "noun",
      "explanation": "activity + legal + parent: the act of becoming a legal parent of a child",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        813,
        "/",
        500
      ]
    },
    {
      "id": 4836,
      "bciAvId": 25006,
      "gloss": "adventure",
      "glossSv": "äventyr",
      "pos": "noun",
      "explanation": "activity + thrilling + intensity",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        301,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4837,
      "bciAvId": 25007,
      "gloss": "adventurous",
      "glossSv": "äventyrlig",
      "pos": "description",
      "explanation": "adventure + description indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        86,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        301,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 4838,
      "bciAvId": 25008,
      "gloss": "Afghanistan",
      "glossSv": "Afghanistan",
      "pos": "noun",
      "explanation": "country + kite",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        409
      ]
    },
    {
      "id": 4839,
      "bciAvId": 25009,
      "gloss": "ajar",
      "glossSv": "på glänt",
      "pos": "description",
      "explanation": "open + little: slightly open",
      "isCharacter": false,
      "composition": [
        484,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 4840,
      "bciAvId": 25010,
      "gloss": "alcohol, ethanol",
      "glossSv": "alkohol, etanol",
      "pos": "noun",
      "explanation": "chemical product + liquor",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        116
      ]
    },
    {
      "id": 4841,
      "bciAvId": 25012,
      "gloss": "to applaud, to clap",
      "glossSv": "applådera, klappa händerna",
      "pos": "action",
      "explanation": "applause + action indicator",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        374,
        ";",
        81,
        "/",
        401,
        "/",
        608
      ]
    },
    {
      "id": 4842,
      "bciAvId": 25013,
      "gloss": "applause, clapping",
      "glossSv": "applåd, handklappning",
      "pos": "noun",
      "explanation": "2 + hand + intensity + sound: clapping the hands together as a demonstration of approval",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        374,
        "/",
        401,
        "/",
        608
      ]
    },
    {
      "id": 4843,
      "bciAvId": 25014,
      "gloss": "armed",
      "glossSv": "beväpnad",
      "pos": "description",
      "explanation": "weapon + description indicator",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        86,
        "/",
        259
      ]
    },
    {
      "id": 4844,
      "bciAvId": 25015,
      "gloss": "Austria",
      "glossSv": "Österrike",
      "pos": "noun",
      "explanation": "country + musical note (music [contraction]) + mountain",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        462,
        "/",
        456
      ]
    },
    {
      "id": 4845,
      "bciAvId": 25017,
      "gloss": "bandit, armed robber",
      "glossSv": "bandit, rånare (beväpnad)",
      "pos": "person",
      "explanation": "person + getting + weapon: i.e., thief [contraction] using a weapon to steal",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        660,
        "/",
        259
      ]
    },
    {
      "id": 4846,
      "bciAvId": 25018,
      "gloss": "bazaar",
      "glossSv": "basar",
      "pos": "noun",
      "explanation": "group of + store + small",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        819,
        "/",
        956
      ]
    },
    {
      "id": 4847,
      "bciAvId": 25019,
      "gloss": "beggar",
      "glossSv": "tiggare",
      "pos": "person",
      "explanation": "person + ask + being (state of)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        553,
        "/",
        894
      ]
    },
    {
      "id": 4848,
      "bciAvId": 25020,
      "gloss": "Belarus",
      "glossSv": "Vitryssland",
      "pos": "noun",
      "explanation": "country + buffalo + tree (wood [contraction]): the country of the European Bison, or Wisent",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        186,
        "/",
        666
      ]
    },
    {
      "id": 4849,
      "bciAvId": 25021,
      "gloss": "bioenergy",
      "glossSv": "bioenergi",
      "pos": "noun",
      "explanation": "energy + plant",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        533
      ]
    },
    {
      "id": 4850,
      "bciAvId": 25022,
      "gloss": "to braid, to plait",
      "glossSv": "fläta (verb)",
      "pos": "action",
      "explanation": "braid + action indicator",
      "isCharacter": false,
      "composition": [
        783,
        ";",
        81,
        "/",
        12,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 4851,
      "bciAvId": 25023,
      "gloss": "braid, plait, pigtail(s)",
      "glossSv": "fläta (subst.)",
      "pos": "noun",
      "explanation": "to mix + 3 + linear thing: 3 can be replaced by an appropriate number.",
      "isCharacter": false,
      "composition": [
        783,
        "/",
        12,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 4852,
      "bciAvId": 25024,
      "gloss": "Brazil",
      "glossSv": "Brasilien",
      "pos": "noun",
      "explanation": "country + ball + legs and feet: country of football [contraction]",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 4853,
      "bciAvId": 25025,
      "gloss": "to cheer",
      "glossSv": "hurra, heja på",
      "pos": "action",
      "explanation": "cheering + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        332,
        "/",
        401
      ]
    },
    {
      "id": 4854,
      "bciAvId": 25026,
      "gloss": "cheering (the sound)",
      "glossSv": "hurra, leve",
      "pos": "function",
      "explanation": "support (oral) + intensity",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        332,
        "/",
        401
      ]
    },
    {
      "id": 4855,
      "bciAvId": 25027,
      "gloss": "cheerleader",
      "glossSv": "hejarklacksledare",
      "pos": "person",
      "explanation": "leader + cheering",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        457,
        "/",
        332,
        "/",
        401
      ]
    },
    {
      "id": 4856,
      "bciAvId": 25028,
      "gloss": "cheers (toast)",
      "glossSv": "skål",
      "pos": "function",
      "explanation": "say,speak,talk,tell,express-(to) + alcoholic drink + up",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        116,
        "/",
        678
      ]
    },
    {
      "id": 4857,
      "bciAvId": 25029,
      "gloss": "China",
      "glossSv": "Kina",
      "pos": "noun",
      "explanation": "country + middle,centre; 中国 zhōng guó is the official name of China, which literally means middle or central country",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        446
      ]
    },
    {
      "id": 4858,
      "bciAvId": 25030,
      "gloss": "city tour",
      "glossSv": "stadsrundtur (etc)",
      "pos": "noun",
      "explanation": "move + see + village: where village represents city [contraction]",
      "isCharacter": false,
      "composition": [
        974,
        "/",
        303,
        "/",
        368,
        "/",
        392
      ]
    },
    {
      "id": 4859,
      "bciAvId": 25031,
      "gloss": "climate",
      "glossSv": "klimat",
      "pos": "noun",
      "explanation": "generalization + weather",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        696
      ]
    },
    {
      "id": 4860,
      "bciAvId": 25032,
      "gloss": "code, password",
      "glossSv": "kod, lösenord",
      "pos": "noun",
      "explanation": "number + secret",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        583
      ]
    },
    {
      "id": 4861,
      "bciAvId": 25033,
      "gloss": "collection, pile, tussock (etc)",
      "glossSv": "hög, stapel, trave, samling, tuva, knippa, bukett (etc)",
      "pos": "noun",
      "explanation": "group of + together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823
      ]
    },
    {
      "id": 4862,
      "bciAvId": 25034,
      "gloss": "coup, hijack, takeover",
      "glossSv": "kupp, kapning",
      "pos": "noun",
      "explanation": "theft + leadership",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        449,
        "/",
        401,
        "/",
        803
      ]
    },
    {
      "id": 4863,
      "bciAvId": 25035,
      "gloss": "coup, coup d'etat",
      "glossSv": "statskupp, revolt",
      "pos": "noun",
      "explanation": "coup + country",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        449,
        "/",
        401,
        "/",
        803,
        "/",
        243
      ]
    },
    {
      "id": 4864,
      "bciAvId": 25036,
      "gloss": "crime",
      "glossSv": "brott",
      "pos": "noun",
      "explanation": "activity + illegal,criminal",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        449,
        "/",
        813,
        "/",
        497
      ]
    },
    {
      "id": 4865,
      "bciAvId": 25037,
      "gloss": "criminal (person)",
      "glossSv": "brottsling, kriminell person",
      "pos": "person",
      "explanation": "person + illegal,criminal: where illegal represents crime [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        449,
        "/",
        813,
        "/",
        497
      ]
    },
    {
      "id": 4866,
      "bciAvId": 25038,
      "gloss": "criminality, crime",
      "glossSv": "brottslighet, kriminalitet",
      "pos": "noun",
      "explanation": "action + illegal,criminal",
      "isCharacter": false,
      "composition": [
        105,
        "/",
        449,
        "/",
        813,
        "/",
        497
      ]
    },
    {
      "id": 4867,
      "bciAvId": 25039,
      "gloss": "curiosity, curiousness, inquisitiveness, wonder",
      "glossSv": "frågvishet, vetgirighet",
      "pos": "noun",
      "explanation": "wish + knowledge",
      "isCharacter": false,
      "composition": [
        930,
        "/",
        412
      ]
    },
    {
      "id": 4868,
      "bciAvId": 25040,
      "gloss": "curious, inquisitive",
      "glossSv": "nyfiken (positiv), frågvis, vetgirig",
      "pos": "description",
      "explanation": "curiosity + description indicator",
      "isCharacter": false,
      "composition": [
        930,
        ";",
        86,
        "/",
        412
      ]
    },
    {
      "id": 4869,
      "bciAvId": 25041,
      "gloss": "cushion",
      "glossSv": "kudde, dyna",
      "pos": "noun",
      "explanation": "enclosure + imprint,depression: where imprint,depression represents soft [contraction]",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        1049
      ]
    },
    {
      "id": 4870,
      "bciAvId": 25042,
      "gloss": "cushion (seat)",
      "glossSv": "sittdyna",
      "pos": "noun",
      "explanation": "cushion + seat",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        1049,
        "/",
        517
      ]
    },
    {
      "id": 4871,
      "bciAvId": 25043,
      "gloss": "Czech Republic",
      "glossSv": "Tjeckien",
      "pos": "noun",
      "explanation": "country + beer",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        116,
        "/",
        345
      ]
    },
    {
      "id": 4872,
      "bciAvId": 25044,
      "gloss": "to deflate, to let out air",
      "glossSv": "läcka (luft), släppa ut luft",
      "pos": "action",
      "explanation": "out of,exit (forward) + air + action indicator: Air can be replaced by an appropriate specifier.",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        114
      ]
    },
    {
      "id": 4873,
      "bciAvId": 25045,
      "gloss": "detective, investigator",
      "glossSv": "detektiv",
      "pos": "person",
      "explanation": "person + wakefulness,alertness + information: where wakefulness represents search-(to) [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        969,
        "/",
        835
      ]
    },
    {
      "id": 4874,
      "bciAvId": 25046,
      "gloss": "diaphragm, midriff",
      "glossSv": "diafragma, mellangärde",
      "pos": "noun",
      "explanation": "muscle + middle",
      "isCharacter": false,
      "composition": [
        718,
        "/",
        446
      ]
    },
    {
      "id": 4875,
      "bciAvId": 25047,
      "gloss": "disinfectant, antiseptic",
      "glossSv": "desinfektionsmedel, tvättsprit (etc)",
      "pos": "noun",
      "explanation": "chemical product + bath,washing + medical",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        595,
        "/",
        958
      ]
    },
    {
      "id": 4876,
      "bciAvId": 25048,
      "gloss": "drill",
      "glossSv": "borr",
      "pos": "noun",
      "explanation": "tool + rotation + through",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        887,
        "/",
        653
      ]
    },
    {
      "id": 4877,
      "bciAvId": 25049,
      "gloss": "drilling rig (gas)",
      "glossSv": "borrigg (för gas)",
      "pos": "noun",
      "explanation": "machine + rotation + gas",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        887,
        "/",
        345
      ]
    },
    {
      "id": 4878,
      "bciAvId": 25050,
      "gloss": "drilling rig (oil)",
      "glossSv": "borrigg (för olja)",
      "pos": "noun",
      "explanation": "machine + rotation + oil",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        887,
        "/",
        480
      ]
    },
    {
      "id": 4879,
      "bciAvId": 25051,
      "gloss": "drilling rig (water)",
      "glossSv": "borrigg (för vatten)",
      "pos": "noun",
      "explanation": "machine + rotation + water",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        887,
        "/",
        695
      ]
    },
    {
      "id": 4880,
      "bciAvId": 25052,
      "gloss": "each other, one another",
      "glossSv": "varandra",
      "pos": "expression",
      "explanation": "person + back and forth + person",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        144,
        "/",
        513
      ]
    },
    {
      "id": 4881,
      "bciAvId": 25053,
      "gloss": "to encourage",
      "glossSv": "uppmuntra",
      "pos": "action",
      "explanation": "encouragement + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        313,
        "/",
        967
      ]
    },
    {
      "id": 4882,
      "bciAvId": 25054,
      "gloss": "encouragement",
      "glossSv": "uppmuntran",
      "pos": "noun",
      "explanation": "to give + courage",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        313,
        "/",
        967
      ]
    },
    {
      "id": 4883,
      "bciAvId": 25055,
      "gloss": "escape",
      "glossSv": "flykt",
      "pos": "noun",
      "explanation": "out of,exit (forward) + intensity",
      "isCharacter": false,
      "composition": [
        491,
        "/",
        401
      ]
    },
    {
      "id": 4884,
      "bciAvId": 25056,
      "gloss": "to escape",
      "glossSv": "fly",
      "pos": "action",
      "explanation": "escape + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 4885,
      "bciAvId": 25057,
      "gloss": "espionage, spying",
      "glossSv": "spionage",
      "pos": "noun",
      "explanation": "to search + secret + information",
      "isCharacter": false,
      "composition": [
        969,
        "/",
        401,
        "/",
        401,
        "/",
        583,
        "/",
        835
      ]
    },
    {
      "id": 4886,
      "bciAvId": 25058,
      "gloss": "to explore",
      "glossSv": "utforska, upptäcka",
      "pos": "action",
      "explanation": "exploration + action indicator",
      "isCharacter": false,
      "composition": [
        969,
        ";",
        81,
        "/",
        1061
      ]
    },
    {
      "id": 4887,
      "bciAvId": 25059,
      "gloss": "explorer, enquirer",
      "glossSv": "upptäcktsresande (etc)",
      "pos": "person",
      "explanation": "person + explore",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        969,
        "/",
        1061
      ]
    },
    {
      "id": 4888,
      "bciAvId": 25060,
      "gloss": "fart, wind",
      "glossSv": "fis, fjärt, prutt",
      "pos": "noun",
      "explanation": "gas + buttocks,bottom,bum,rear,ass",
      "isCharacter": false,
      "composition": [
        345,
        "/",
        194
      ]
    },
    {
      "id": 4889,
      "bciAvId": 25061,
      "gloss": "fatal, lethal",
      "glossSv": "dödande",
      "pos": "description",
      "explanation": "to cause + death + description indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        86,
        "/",
        259
      ]
    },
    {
      "id": 4890,
      "bciAvId": 25062,
      "gloss": "fossil fuel, coal (etc)",
      "glossSv": "fossilt bränsle, kol (etc)",
      "pos": "noun",
      "explanation": "fuel + plant + passed time",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        533,
        "/",
        503
      ]
    },
    {
      "id": 4891,
      "bciAvId": 25063,
      "gloss": "France",
      "glossSv": "Frankrike",
      "pos": "noun",
      "explanation": "country + champagne",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        365,
        "/",
        345,
        "/",
        401
      ]
    },
    {
      "id": 4892,
      "bciAvId": 25064,
      "gloss": "Friday (day5)",
      "glossSv": "fredag (dag 5)",
      "pos": "noun",
      "explanation": "day + 5 + five (index number): small 5 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        14,
        "/",
        24
      ]
    },
    {
      "id": 4893,
      "bciAvId": 25065,
      "gloss": "Friday (day6)",
      "glossSv": "fredag (dag 6)",
      "pos": "noun",
      "explanation": "day + 6 + five (index number): small 5 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        15,
        "/",
        24
      ]
    },
    {
      "id": 4894,
      "bciAvId": 25066,
      "gloss": "Friday (day7)",
      "glossSv": "fredag (dag 7)",
      "pos": "noun",
      "explanation": "day + 7 + five (index number): small 5 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16,
        "/",
        24
      ]
    },
    {
      "id": 4895,
      "bciAvId": 25067,
      "gloss": "gas (fuel)",
      "glossSv": "gas (bränsle)",
      "pos": "noun",
      "explanation": "fuel + gas",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        345
      ]
    },
    {
      "id": 4896,
      "bciAvId": 25068,
      "gloss": "gas (fuel from biomass)",
      "glossSv": "biogas",
      "pos": "noun",
      "explanation": "fuel + gas + plant",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        345,
        "/",
        533
      ]
    },
    {
      "id": 4897,
      "bciAvId": 25069,
      "gloss": "geothermal energy",
      "glossSv": "geotermisk energi",
      "pos": "noun",
      "explanation": "energy + ground",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        281
      ]
    },
    {
      "id": 4898,
      "bciAvId": 25071,
      "gloss": "Greece",
      "glossSv": "Grekland",
      "pos": "noun",
      "explanation": "country + five (digit),5 + ring: The Olympics [contraction]",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        14,
        "/",
        567
      ]
    },
    {
      "id": 4899,
      "bciAvId": 25072,
      "gloss": "habit, custom",
      "glossSv": "vana, sed",
      "pos": "noun",
      "explanation": "activity + usually",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        968,
        "/",
        655
      ]
    },
    {
      "id": 4900,
      "bciAvId": 25073,
      "gloss": "Hattifatteners",
      "glossSv": "Hattifnattar",
      "pos": "person",
      "explanation": "group of + imaginary person + electricity: Literary figures in the Moomin books by Tove Jansson - tall, thin, ghost-like creatures that become electrical during thunderstorms",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        838,
        "/",
        288
      ]
    },
    {
      "id": 4901,
      "bciAvId": 25074,
      "gloss": "Hemulen",
      "glossSv": "Hemulen",
      "pos": "person",
      "explanation": "imaginary person + 1 + interest: Literary figures in the Moomin books by Tove Jansson - occupied with one specific interest",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        10,
        "/",
        955
      ]
    },
    {
      "id": 4902,
      "bciAvId": 25075,
      "gloss": "hiccup(s) (1)",
      "glossSv": "hicka (1)",
      "pos": "noun",
      "explanation": "sound + diaphragm",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        718,
        "/",
        446
      ]
    },
    {
      "id": 4903,
      "bciAvId": 25076,
      "gloss": "hiccup(s) (2)",
      "glossSv": "hicka (2)",
      "pos": "noun",
      "explanation": "sound + out of body (upward) + repetition",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        1064,
        "/",
        963
      ]
    },
    {
      "id": 4904,
      "bciAvId": 25077,
      "gloss": "to hide, to conceal (secret)",
      "glossSv": "gömma",
      "pos": "action",
      "explanation": "hiding place + action indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81,
        "/",
        583
      ]
    },
    {
      "id": 4905,
      "bciAvId": 25078,
      "gloss": "hide and seek",
      "glossSv": "kurragömma",
      "pos": "noun",
      "explanation": "play,game (in combinations) + hiding place",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        531,
        "/",
        583
      ]
    },
    {
      "id": 4906,
      "bciAvId": 25079,
      "gloss": "hiding place, cache",
      "glossSv": "gömställe",
      "pos": "noun",
      "explanation": "place + secret",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        583
      ]
    },
    {
      "id": 4907,
      "bciAvId": 25081,
      "gloss": "to hijack, to make a coup",
      "glossSv": "kapa, kuppa",
      "pos": "action",
      "explanation": "coup,hijack,takeover + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        449,
        "/",
        401,
        "/",
        803
      ]
    },
    {
      "id": 4908,
      "bciAvId": 25082,
      "gloss": "hijacker, coup maker",
      "glossSv": "kapare, kuppmakare",
      "pos": "person",
      "explanation": "person + coup,hijack,takeover",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        449,
        "/",
        401,
        "/",
        803
      ]
    },
    {
      "id": 4909,
      "bciAvId": 25083,
      "gloss": "to hold, to contain (2)",
      "glossSv": "innehålla, rymma (2)",
      "pos": "action",
      "explanation": "goods,contents + action indicator",
      "isCharacter": false,
      "composition": [
        356,
        ";",
        81
      ]
    },
    {
      "id": 4910,
      "bciAvId": 25084,
      "gloss": "hostage (1)",
      "glossSv": "gisslan (1)",
      "pos": "person",
      "explanation": "person + oppression,captivity,slavery + for (in exchange for)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        975,
        "/",
        331
      ]
    },
    {
      "id": 4911,
      "bciAvId": 25085,
      "gloss": "hostage (2)",
      "glossSv": "gisslan (2)",
      "pos": "person",
      "explanation": "person + oppression,captivity,slavery + for (in exchange for) + money: Money can be replaced by an appropriate specifier.",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        975,
        "/",
        331,
        "/",
        451
      ]
    },
    {
      "id": 4912,
      "bciAvId": 25086,
      "gloss": "hunter",
      "glossSv": "jägare",
      "pos": "person",
      "explanation": "person + hunt,hunting",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        369,
        "/",
        122
      ]
    },
    {
      "id": 4913,
      "bciAvId": 25087,
      "gloss": "hydropower, hydro energy",
      "glossSv": "vattenkraft",
      "pos": "noun",
      "explanation": "energy + water",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        695
      ]
    },
    {
      "id": 4914,
      "bciAvId": 25088,
      "gloss": "identity card",
      "glossSv": "legitimation",
      "pos": "noun",
      "explanation": "card + name + number",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        464,
        "/",
        478
      ]
    },
    {
      "id": 4915,
      "bciAvId": 25089,
      "gloss": "index, list of contents (in a book etc)",
      "glossSv": "innehållsförteckning, index",
      "pos": "noun",
      "explanation": "page + content",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        947
      ]
    },
    {
      "id": 4916,
      "bciAvId": 25090,
      "gloss": "India",
      "glossSv": "Indien",
      "pos": "noun",
      "explanation": "country + flavouring",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        107,
        ";",
        97,
        "/",
        642
      ]
    },
    {
      "id": 4917,
      "bciAvId": 25091,
      "gloss": "to inflate",
      "glossSv": "blåsa upp, pumpa upp",
      "pos": "action",
      "explanation": "entrance + air + action indicator: Air can be replaced by an appropriate specifier.",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        114
      ]
    },
    {
      "id": 4918,
      "bciAvId": 25093,
      "gloss": "invitation (general spoken)",
      "glossSv": "inbjudan (muntlig)",
      "pos": "noun",
      "explanation": "say,speak,talk,tell,express-(to) + fidelity,loyalty,solidarity",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        313,
        "/",
        823
      ]
    },
    {
      "id": 4919,
      "bciAvId": 25094,
      "gloss": "invitation (general written)",
      "glossSv": "inbjudan (skriftlig)",
      "pos": "noun",
      "explanation": "paper + fidelity,loyalty,solidarity",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        313,
        "/",
        823
      ]
    },
    {
      "id": 4920,
      "bciAvId": 25095,
      "gloss": "invitation (spoken)",
      "glossSv": "välkomsthälsning (muntlig)",
      "pos": "noun",
      "explanation": "say,speak,talk,tell,express-(to) + welcome",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        313,
        "/",
        935
      ]
    },
    {
      "id": 4921,
      "bciAvId": 25096,
      "gloss": "invitation (written)",
      "glossSv": "välkomsthälsning (skriftlig)",
      "pos": "noun",
      "explanation": "paper + welcome",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        313,
        "/",
        935
      ]
    },
    {
      "id": 4922,
      "bciAvId": 25097,
      "gloss": "Iraq",
      "glossSv": "Irak",
      "pos": "noun",
      "explanation": "country + garden + stairs: refers to the Hanging Gardens of Babylon - and of queen Semiramis",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        344,
        "/",
        619
      ]
    },
    {
      "id": 4923,
      "bciAvId": 25098,
      "gloss": "Italy",
      "glossSv": "Italien",
      "pos": "noun",
      "explanation": "country + opera",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        457,
        "/",
        462,
        "/",
        723
      ]
    },
    {
      "id": 4924,
      "bciAvId": 25099,
      "gloss": "Japan",
      "glossSv": "Japan",
      "pos": "noun",
      "explanation": "country + sunrise",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        454,
        "/",
        678
      ]
    },
    {
      "id": 4925,
      "bciAvId": 25100,
      "gloss": "to kidnap",
      "glossSv": "kidnappa",
      "pos": "action",
      "explanation": "theft + person + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        449,
        "/",
        401,
        "/",
        513
      ]
    },
    {
      "id": 4926,
      "bciAvId": 25101,
      "gloss": "kidnapper",
      "glossSv": "kidnappare",
      "pos": "person",
      "explanation": "person + kidnap-(to)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        449,
        "/",
        401,
        "/",
        513
      ]
    },
    {
      "id": 4927,
      "bciAvId": 25103,
      "gloss": "killer, murderer",
      "glossSv": "dråpare, mördare",
      "pos": "person",
      "explanation": "person + manslaughter",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        206,
        "/",
        259
      ]
    },
    {
      "id": 4928,
      "bciAvId": 25104,
      "gloss": "killing, murder, slaughter",
      "glossSv": "dråp, mord",
      "pos": "noun",
      "explanation": "cause + death",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        259
      ]
    },
    {
      "id": 4929,
      "bciAvId": 25105,
      "gloss": "to knock, to tap",
      "glossSv": "knacka",
      "pos": "action",
      "explanation": "knock + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        401,
        "/",
        608
      ]
    },
    {
      "id": 4930,
      "bciAvId": 25106,
      "gloss": "knock, tap (sound)",
      "glossSv": "knackning (ljud)",
      "pos": "noun",
      "explanation": "noise (loud) + short",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        401,
        "/",
        965
      ]
    },
    {
      "id": 4931,
      "bciAvId": 25107,
      "gloss": "knocking",
      "glossSv": "knackning",
      "pos": "noun",
      "explanation": "hand + intensity + sound",
      "isCharacter": false,
      "composition": [
        374,
        "/",
        401,
        "/",
        608
      ]
    },
    {
      "id": 4932,
      "bciAvId": 25108,
      "gloss": "to land (rocket)",
      "glossSv": "landa (rymdraket)",
      "pos": "action",
      "explanation": "landing (rocket) + action indicator",
      "isCharacter": false,
      "composition": [
        1088,
        ";",
        81,
        "/",
        273
      ]
    },
    {
      "id": 4933,
      "bciAvId": 25109,
      "gloss": "landing (rocket)",
      "glossSv": "landning (rymdraket)",
      "pos": "noun",
      "explanation": "rocket + downward and forward",
      "isCharacter": false,
      "composition": [
        1088,
        "/",
        273
      ]
    },
    {
      "id": 4934,
      "bciAvId": 25110,
      "gloss": "Little My",
      "glossSv": "Lilla My",
      "pos": "person",
      "explanation": "imaginary person + girl + against,opposed to: Literary figure in the Moomin books by Tove Jansson - she is a small determined fiercely independent Mymble. Little My is brash, aggressive, mischievous and disrespectful.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        351,
        "/",
        111
      ]
    },
    {
      "id": 4935,
      "bciAvId": 25111,
      "gloss": "load",
      "glossSv": "last, lass, packning",
      "pos": "noun",
      "explanation": "group of,much of,many of,quantity of + together + container",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        239
      ]
    },
    {
      "id": 4936,
      "bciAvId": 25112,
      "gloss": "to make a speech",
      "glossSv": "hålla tal",
      "pos": "action",
      "explanation": "speech (event) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        299,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 4937,
      "bciAvId": 25113,
      "gloss": "Monday (day1)",
      "glossSv": "måndag (dag 1)",
      "pos": "noun",
      "explanation": "day + 1 + one (index number): small 1 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        10,
        "/",
        20
      ]
    },
    {
      "id": 4938,
      "bciAvId": 25114,
      "gloss": "Monday (day2)",
      "glossSv": "måndag (dag 2)",
      "pos": "noun",
      "explanation": "day + 2 + one (index number): small 1 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        11,
        "/",
        20
      ]
    },
    {
      "id": 4939,
      "bciAvId": 25115,
      "gloss": "Monday (day3)",
      "glossSv": "måndag (dag 3)",
      "pos": "noun",
      "explanation": "day + 3 + one (index number): small 1 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        12,
        "/",
        20
      ]
    },
    {
      "id": 4940,
      "bciAvId": 25116,
      "gloss": "Moominmamma",
      "glossSv": "Muminmamman",
      "pos": "person",
      "explanation": "Moomintroll [contraction] + mother: Literary figure in the Moomin books by Tove Jansson - she is the mother of Moomintroll.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        "RK:-2",
        "/",
        1049,
        "/",
        455
      ]
    },
    {
      "id": 4941,
      "bciAvId": 25117,
      "gloss": "Moominpappa",
      "glossSv": "Muminpappan",
      "pos": "person",
      "explanation": "Moomintroll [contraction] + father: Literary figure in the Moomin books by Tove Jansson - he is the father of Moomintroll.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        "RK:-2",
        "/",
        1049,
        "/",
        312
      ]
    },
    {
      "id": 4942,
      "bciAvId": 25118,
      "gloss": "Moomintroll",
      "glossSv": "Mumintrollet",
      "pos": "person",
      "explanation": "imaginary person + imprint,depression + M: Literary figure in the Moomin books by Tove Jansson - the main character of most of the books, imprint,depression represents soft [contraction]",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        "RK:-2",
        "/",
        1049,
        "/",
        "XM"
      ]
    },
    {
      "id": 4943,
      "bciAvId": 25120,
      "gloss": "mummy (general)",
      "glossSv": "mumie (generell)",
      "pos": "noun",
      "explanation": "body + dead + cloth",
      "isCharacter": false,
      "composition": [
        171,
        "/",
        259,
        "/",
        228
      ]
    },
    {
      "id": 4944,
      "bciAvId": 25121,
      "gloss": "mummy (imaginary)",
      "glossSv": "mumie (övernaturligt väsen)",
      "pos": "person",
      "explanation": "imaginary person + dead + cloth",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        259,
        "/",
        228
      ]
    },
    {
      "id": 4945,
      "bciAvId": 25122,
      "gloss": "murder",
      "glossSv": "mord",
      "pos": "noun",
      "explanation": "killing + plan",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        259,
        "/",
        532
      ]
    },
    {
      "id": 4946,
      "bciAvId": 25123,
      "gloss": "to murder",
      "glossSv": "mörda",
      "pos": "action",
      "explanation": "murder + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        259,
        "/",
        532
      ]
    },
    {
      "id": 4947,
      "bciAvId": 25124,
      "gloss": "murderer",
      "glossSv": "mördare",
      "pos": "person",
      "explanation": "person + murder",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        206,
        "/",
        259,
        "/",
        532
      ]
    },
    {
      "id": 4948,
      "bciAvId": 25125,
      "gloss": "nosy",
      "glossSv": "nyfiken (negativt)",
      "pos": "description",
      "explanation": "curious,inquisitive + negative + description indicator",
      "isCharacter": false,
      "composition": [
        930,
        ";",
        86,
        "/",
        412,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4949,
      "bciAvId": 25126,
      "gloss": "nuclear fuel",
      "glossSv": "kärnbränsle, atombränsle",
      "pos": "noun",
      "explanation": "fuel + nucleus",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        477
      ]
    },
    {
      "id": 4950,
      "bciAvId": 25127,
      "gloss": "oil (fuel)",
      "glossSv": "olja (bränsle)",
      "pos": "noun",
      "explanation": "fuel + oil",
      "isCharacter": false,
      "composition": [
        339,
        "/",
        480
      ]
    },
    {
      "id": 4951,
      "bciAvId": 25128,
      "gloss": "oil power, oil energy",
      "glossSv": "oljeenergi",
      "pos": "noun",
      "explanation": "energy + oil",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        480
      ]
    },
    {
      "id": 4952,
      "bciAvId": 25129,
      "gloss": "OK, alright",
      "glossSv": "lagom, OK",
      "pos": "description",
      "explanation": "feeling + enough + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        937
      ]
    },
    {
      "id": 4953,
      "bciAvId": 25130,
      "gloss": "Olympics, Olympic games",
      "glossSv": "olympiad, OS",
      "pos": "noun",
      "explanation": "competition + 5 + ring",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        14,
        "/",
        567
      ]
    },
    {
      "id": 4954,
      "bciAvId": 25131,
      "gloss": "oppressed, unfree",
      "glossSv": "ofri, i fångenskap, förtryckt",
      "pos": "description",
      "explanation": "oppression,captivity,slavery + description indicator",
      "isCharacter": false,
      "composition": [
        975,
        ";",
        86
      ]
    },
    {
      "id": 4955,
      "bciAvId": 25136,
      "gloss": "passive",
      "glossSv": "passiv",
      "pos": "description",
      "explanation": "passivity + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        106,
        ";",
        86
      ]
    },
    {
      "id": 4956,
      "bciAvId": 25137,
      "gloss": "passivity",
      "glossSv": "passivitet",
      "pos": "noun",
      "explanation": "without + activity",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        106
      ]
    },
    {
      "id": 4957,
      "bciAvId": 25138,
      "gloss": "pill box",
      "glossSv": "dosett (medicin)",
      "pos": "noun",
      "explanation": "container + time + pill,tablet",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        655,
        "/",
        263,
        "/",
        958
      ]
    },
    {
      "id": 4958,
      "bciAvId": 25139,
      "gloss": "Poland",
      "glossSv": "Polen",
      "pos": "noun",
      "explanation": "country + field",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        317
      ]
    },
    {
      "id": 4959,
      "bciAvId": 25140,
      "gloss": "Portugal",
      "glossSv": "Portugal",
      "pos": "noun",
      "explanation": "country + wakefulness,alertness + new: country of discoveries (search [contraction] + new)",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        969,
        "/",
        1061
      ]
    },
    {
      "id": 4960,
      "bciAvId": 25141,
      "gloss": "power plant, power station",
      "glossSv": "kraftverk, kraftstation",
      "pos": "noun",
      "explanation": "house + energy",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        293
      ]
    },
    {
      "id": 4961,
      "bciAvId": 25142,
      "gloss": "precious, treasured",
      "glossSv": "värdefull, dyrbar",
      "pos": "description",
      "explanation": "value + feeling + and,also,plus,too + description indicator: value characterized by a positive feeling of fond affection for",
      "isCharacter": false,
      "composition": [
        297,
        ";",
        86,
        "/",
        313,
        "/",
        120
      ]
    },
    {
      "id": 4962,
      "bciAvId": 25143,
      "gloss": "precious thing, treasure",
      "glossSv": "dyrbarhet, dyrgrip, värdesak",
      "pos": "noun",
      "explanation": "thing + precious",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        297,
        "/",
        313,
        "/",
        120
      ]
    },
    {
      "id": 4963,
      "bciAvId": 25144,
      "gloss": "prison officer",
      "glossSv": "fångvårdare",
      "pos": "person",
      "explanation": "person + work + barred window: the barred window representing prison [contr]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        707
      ]
    },
    {
      "id": 4964,
      "bciAvId": 25145,
      "gloss": "prisoner",
      "glossSv": "fånge",
      "pos": "person",
      "explanation": "person + barred window: the barred window representing prison [contr]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        707
      ]
    },
    {
      "id": 4965,
      "bciAvId": 25146,
      "gloss": "pump",
      "glossSv": "pump",
      "pos": "noun",
      "explanation": "tool + pressure",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        815
      ]
    },
    {
      "id": 4966,
      "bciAvId": 25147,
      "gloss": "to pump",
      "glossSv": "pumpa",
      "pos": "action",
      "explanation": "pump + action indicator",
      "isCharacter": false,
      "composition": [
        660,
        ";",
        81,
        "/",
        815
      ]
    },
    {
      "id": 4967,
      "bciAvId": 25148,
      "gloss": "rag",
      "glossSv": "trasa, trasor",
      "pos": "noun",
      "explanation": "cloth + broken",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        933
      ]
    },
    {
      "id": 4968,
      "bciAvId": 25149,
      "gloss": "rags (worn-out clothes)",
      "glossSv": "paltor, slitna kläder",
      "pos": "noun",
      "explanation": "clothes + usage,use + end",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        932,
        "/",
        292
      ]
    },
    {
      "id": 4969,
      "bciAvId": 25150,
      "gloss": "to resign, to quit (1)",
      "glossSv": "säga upp sig, sluta (sitt arbete), avgå (1)",
      "pos": "action",
      "explanation": "resignation (1) + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        711
      ]
    },
    {
      "id": 4970,
      "bciAvId": 25151,
      "gloss": "to resign, to quit (2)",
      "glossSv": "säga upp sig, sluta (sitt arbete), avgå (2)",
      "pos": "action",
      "explanation": "resignation (2) + action indicator",
      "isCharacter": false,
      "composition": [
        1525,
        ";",
        81,
        "/",
        711
      ]
    },
    {
      "id": 4971,
      "bciAvId": 25152,
      "gloss": "resignation (1)",
      "glossSv": "uppsägning, avgång (från arbete) (1)",
      "pos": "noun",
      "explanation": "end + work: to stop (a) work",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        711
      ]
    },
    {
      "id": 4972,
      "bciAvId": 25153,
      "gloss": "resignation (2)",
      "glossSv": "uppsägning, avgång (från arbete) (2)",
      "pos": "noun",
      "explanation": "departure + work: to leave (a) work",
      "isCharacter": false,
      "composition": [
        1525,
        "/",
        711
      ]
    },
    {
      "id": 4973,
      "bciAvId": 25154,
      "gloss": "to retire",
      "glossSv": "gå i pension",
      "pos": "action",
      "explanation": "retirement + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        711,
        "/",
        716
      ]
    },
    {
      "id": 4974,
      "bciAvId": 25155,
      "gloss": "retired",
      "glossSv": "pensionerad",
      "pos": "description",
      "explanation": "retirement + description indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        86,
        "/",
        711,
        "/",
        716
      ]
    },
    {
      "id": 4975,
      "bciAvId": 25156,
      "gloss": "retirement",
      "glossSv": "pension, pensionering",
      "pos": "noun",
      "explanation": "resignation (1) + year",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        711,
        "/",
        716
      ]
    },
    {
      "id": 4976,
      "bciAvId": 25157,
      "gloss": "roast, joint (of meat)",
      "glossSv": "stek, köttstycke (större)",
      "pos": "noun",
      "explanation": "meat + big",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        936
      ]
    },
    {
      "id": 4977,
      "bciAvId": 25158,
      "gloss": "robot",
      "glossSv": "robot",
      "pos": "noun",
      "explanation": "machine + activity + person",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        106,
        "/",
        513
      ]
    },
    {
      "id": 4978,
      "bciAvId": 25159,
      "gloss": "to sack, to dismiss",
      "glossSv": "avskeda",
      "pos": "action",
      "explanation": "dismissal + action indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        81,
        "/",
        711,
        "/",
        804
      ]
    },
    {
      "id": 4979,
      "bciAvId": 25160,
      "gloss": "sacked, dismissed",
      "glossSv": "avskedad",
      "pos": "description",
      "explanation": "dismissal + description indicator",
      "isCharacter": false,
      "composition": [
        292,
        ";",
        86,
        "/",
        711,
        "/",
        804
      ]
    },
    {
      "id": 4980,
      "bciAvId": 25161,
      "gloss": "sacking, dismissal",
      "glossSv": "avsked (från arbete)",
      "pos": "noun",
      "explanation": "resignation (1) + force",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        711,
        "/",
        804
      ]
    },
    {
      "id": 4981,
      "bciAvId": 25162,
      "gloss": "safari, wildlife expedition",
      "glossSv": "safari",
      "pos": "noun",
      "explanation": "move,movement + see,look,watch-(to) + animal",
      "isCharacter": false,
      "composition": [
        974,
        "/",
        303,
        "/",
        122
      ]
    },
    {
      "id": 4982,
      "bciAvId": 25163,
      "gloss": "Saturday (day1)",
      "glossSv": "lördag (dag 1)",
      "pos": "noun",
      "explanation": "day + 1 + six (index number): small 6 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        10,
        "/",
        25
      ]
    },
    {
      "id": 4983,
      "bciAvId": 25164,
      "gloss": "Saturday (day6)",
      "glossSv": "lördag (dag 6)",
      "pos": "noun",
      "explanation": "day + 6 + six (index number): small 6 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        15,
        "/",
        25
      ]
    },
    {
      "id": 4984,
      "bciAvId": 25165,
      "gloss": "Saturday (day7)",
      "glossSv": "lördag (dag 7)",
      "pos": "noun",
      "explanation": "day + 7 + six (index number): small 6 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16,
        "/",
        25
      ]
    },
    {
      "id": 4985,
      "bciAvId": 25166,
      "gloss": "scoundrel, villain",
      "glossSv": "bov, skurk, buse",
      "pos": "person",
      "explanation": "person + mean,cruel",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        411
      ]
    },
    {
      "id": 4986,
      "bciAvId": 25167,
      "gloss": "protector, guard",
      "glossSv": "väktare, vakt",
      "pos": "person",
      "explanation": "person + safety,security",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        313,
        "/",
        548
      ]
    },
    {
      "id": 4987,
      "bciAvId": 25168,
      "gloss": "Sniff",
      "glossSv": "Sniff",
      "pos": "person",
      "explanation": "imaginary person + scared: Literary figure in the Moomin books by Tove Jansson - friend of Moomin, a real coward, and very interested in money.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        313,
        "/",
        271,
        "/",
        1042
      ]
    },
    {
      "id": 4988,
      "bciAvId": 25169,
      "gloss": "Snork",
      "glossSv": "Snorken",
      "pos": "person",
      "explanation": "imaginary person + imprint,depression + glasses: Literary figure in the Moomin books by Tove Jansson - The Snork Maiden's brother, wears glasses, inteligent, avid inventor who has strong belief in the power of science, imprint,depression represents soft [contraction]",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        1049,
        "/",
        353
      ]
    },
    {
      "id": 4989,
      "bciAvId": 25170,
      "gloss": "Snork Maiden",
      "glossSv": "Snorkfröken",
      "pos": "person",
      "explanation": "imaginary person + imprint,depression + ring: Literary figure in the Moomin books by Tove Jansson - Moomintroll's fair lady friend and admirer, and sports a golden anklet, imprint,depression represents soft [contraction]",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        1049,
        "/",
        567
      ]
    },
    {
      "id": 4990,
      "bciAvId": 25171,
      "gloss": "Snufkin",
      "glossSv": "Snusmumriken",
      "pos": "person",
      "explanation": "imaginary person + boy + musical instrument: Literary figure in the Moomin books by Tove Jansson - Moomintroll's best friend, who lives in a tent, smokes a pipe, and plays the harmonica.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        178,
        "/",
        865
      ]
    },
    {
      "id": 4991,
      "bciAvId": 25172,
      "gloss": "solar energy, solar power",
      "glossSv": "solenergi",
      "pos": "noun",
      "explanation": "energy + sun",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        636
      ]
    },
    {
      "id": 4992,
      "bciAvId": 25173,
      "gloss": "space travel, space voyage, space flight",
      "glossSv": "rymdfärd",
      "pos": "noun",
      "explanation": "move,movement + galaxy",
      "isCharacter": false,
      "composition": [
        974,
        "/",
        896
      ]
    },
    {
      "id": 4993,
      "bciAvId": 25174,
      "gloss": "speech (event)",
      "glossSv": "tal, anförande",
      "pos": "noun",
      "explanation": "say,speak,talk,tell,express-(to) + event + group of + person",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        299,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 4994,
      "bciAvId": 25175,
      "gloss": "secret agent, spy",
      "glossSv": "spion, hemlig agent",
      "pos": "person",
      "explanation": "person + secret + information",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        583,
        "/",
        835
      ]
    },
    {
      "id": 4995,
      "bciAvId": 25176,
      "gloss": "steak",
      "glossSv": "biff, köttskiva",
      "pos": "noun",
      "explanation": "meat + slice + thing indicator",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        122,
        "/",
        1096,
        ";",
        97
      ]
    },
    {
      "id": 4996,
      "bciAvId": 25177,
      "gloss": "still, calm, peaceful, tranquil",
      "glossSv": "stilla, stillsam, lugn",
      "pos": "description",
      "explanation": "without + back and forth + description indicator: back and forth representing movement,motion (2) [contraction]",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        144,
        ";",
        86
      ]
    },
    {
      "id": 4997,
      "bciAvId": 25178,
      "gloss": "stolen goods",
      "glossSv": "stöldgods",
      "pos": "noun",
      "explanation": "goods + theft",
      "isCharacter": false,
      "composition": [
        356,
        "/",
        920,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 4998,
      "bciAvId": 25179,
      "gloss": "summary, abstract",
      "glossSv": "sammandrag, sammanfattning",
      "pos": "noun",
      "explanation": "filling + information + short",
      "isCharacter": false,
      "composition": [
        947,
        "/",
        835,
        "/",
        965
      ]
    },
    {
      "id": 4999,
      "bciAvId": 25180,
      "gloss": "Sunday (day1)",
      "glossSv": "söndag (dag 1)",
      "pos": "noun",
      "explanation": "day + 1 + seven (index number): small 7 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        10,
        "/",
        26
      ]
    },
    {
      "id": 5000,
      "bciAvId": 25181,
      "gloss": "Sunday (day2)",
      "glossSv": "söndag (dag 2)",
      "pos": "noun",
      "explanation": "day + 2 + seven (index number): small 7 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        11,
        "/",
        26
      ]
    },
    {
      "id": 5001,
      "bciAvId": 25182,
      "gloss": "Sunday (day7)",
      "glossSv": "söndag (dag 7)",
      "pos": "noun",
      "explanation": "day + 7 + seven (index number): small 7 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16,
        "/",
        26
      ]
    },
    {
      "id": 5002,
      "bciAvId": 25183,
      "gloss": "supporters, cheering section",
      "glossSv": "supportrar, hejarklack",
      "pos": "person",
      "explanation": "group (people) + support (oral) + intensity",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        457,
        "/",
        332,
        "/",
        401
      ]
    },
    {
      "id": 5003,
      "bciAvId": 25184,
      "gloss": "Switzerland",
      "glossSv": "Schweiz",
      "pos": "noun",
      "explanation": "country + clock + thing indicator",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        655,
        ";",
        97
      ]
    },
    {
      "id": 5004,
      "bciAvId": 25186,
      "gloss": "to take off (rocket)",
      "glossSv": "starta (rymdraket)",
      "pos": "action",
      "explanation": "takeoff (rocket) + action indicator",
      "isCharacter": false,
      "composition": [
        1088,
        ";",
        81,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 5005,
      "bciAvId": 25187,
      "gloss": "takeoff (rocket)",
      "glossSv": "start (rymdraket)",
      "pos": "noun",
      "explanation": "rocket,spaceship + intensity",
      "isCharacter": false,
      "composition": [
        1088,
        "/",
        678,
        "/",
        401
      ]
    },
    {
      "id": 5006,
      "bciAvId": 25189,
      "gloss": "technology",
      "glossSv": "teknik",
      "pos": "noun",
      "explanation": "generalization + machine",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        432
      ]
    },
    {
      "id": 5007,
      "bciAvId": 25190,
      "gloss": "The Groke",
      "glossSv": "Mårran",
      "pos": "person",
      "explanation": "imaginary person + coldness,cold: Literary figure in the Moomin books by Tove Jansson - She is cold and ghostlike, and represents loneliness and all that is scary in the world of Moomin.",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        1007
      ]
    },
    {
      "id": 5008,
      "bciAvId": 25191,
      "gloss": "theft",
      "glossSv": "stöld",
      "pos": "noun",
      "explanation": "receiving + negative",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 5009,
      "bciAvId": 25192,
      "gloss": "thrilling, scary",
      "glossSv": "spännande, skrämmande",
      "pos": "description",
      "explanation": "feeling + expectation,anticipation + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        301,
        "/",
        401
      ]
    },
    {
      "id": 5010,
      "bciAvId": 25193,
      "gloss": "Thursday (day4)",
      "glossSv": "torsdag (dag 4)",
      "pos": "noun",
      "explanation": "day + 4 + four (index number): small 4 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        13,
        "/",
        23
      ]
    },
    {
      "id": 5011,
      "bciAvId": 25194,
      "gloss": "Thursday (day5)",
      "glossSv": "torsdag (dag 5)",
      "pos": "noun",
      "explanation": "day + 5 + four (index number): small 4 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        14,
        "/",
        23
      ]
    },
    {
      "id": 5012,
      "bciAvId": 25195,
      "gloss": "Thursday (day6)",
      "glossSv": "torsdag (dag 6)",
      "pos": "noun",
      "explanation": "day + 6 + four (index number): small 4 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        15,
        "/",
        23
      ]
    },
    {
      "id": 5013,
      "bciAvId": 25196,
      "gloss": "Toffle",
      "glossSv": "Knyttet",
      "pos": "person",
      "explanation": "imaginary person + sadness,sorrow,unhappiness: Literary figure in the Moomin books by Tove Jansson - Toffles are small creatures, shy, scared and confused. \"Toffle\" is the main character in Who Will Comfort Toffle?",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        313,
        "/",
        271
      ]
    },
    {
      "id": 5014,
      "bciAvId": 25198,
      "gloss": "tour, sightseeing",
      "glossSv": "rundtur, sightseeing",
      "pos": "noun",
      "explanation": "move,movement + to see",
      "isCharacter": false,
      "composition": [
        974,
        "/",
        303
      ]
    },
    {
      "id": 5015,
      "bciAvId": 25199,
      "gloss": "trap",
      "glossSv": "fälla",
      "pos": "noun",
      "explanation": "thing + capture + plan",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        920,
        "/",
        401,
        "/",
        532
      ]
    },
    {
      "id": 5016,
      "bciAvId": 25200,
      "gloss": "to trap",
      "glossSv": "fånga (i fälla)",
      "pos": "action",
      "explanation": "trap + action indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        81,
        "/",
        920,
        "/",
        401,
        "/",
        532
      ]
    },
    {
      "id": 5017,
      "bciAvId": 25201,
      "gloss": "hidden treasure, treasure trove",
      "glossSv": "skatt (hemlig)",
      "pos": "noun",
      "explanation": "jewel + secret",
      "isCharacter": false,
      "composition": [
        629,
        "/",
        622,
        "/",
        583
      ]
    },
    {
      "id": 5018,
      "bciAvId": 25202,
      "gloss": "tropical rain forest, jungle",
      "glossSv": "regnskog, djungel",
      "pos": "noun",
      "explanation": "grove + equator: grove representing forest [contraction]",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        666,
        "/",
        794
      ]
    },
    {
      "id": 5019,
      "bciAvId": 25203,
      "gloss": "Tuesday (day2)",
      "glossSv": "tisdag (dag 2)",
      "pos": "noun",
      "explanation": "day + 2 + two (index number): small 2 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        11,
        "/",
        21
      ]
    },
    {
      "id": 5020,
      "bciAvId": 25204,
      "gloss": "Tuesday (day3)",
      "glossSv": "tisdag (dag 3)",
      "pos": "noun",
      "explanation": "day + 3 + two (index number): small 2 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        12,
        "/",
        21
      ]
    },
    {
      "id": 5021,
      "bciAvId": 25205,
      "gloss": "Tuesday (day4)",
      "glossSv": "tisdag (dag 4)",
      "pos": "noun",
      "explanation": "day + 4 + two (index number): small 2 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        13,
        "/",
        21
      ]
    },
    {
      "id": 5022,
      "bciAvId": 25206,
      "gloss": "Turkey",
      "glossSv": "Turkiet",
      "pos": "noun",
      "explanation": "country + bazaar",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        368,
        "/",
        819,
        "/",
        956
      ]
    },
    {
      "id": 5023,
      "bciAvId": 25207,
      "gloss": "Ukraine",
      "glossSv": "Ukraina",
      "pos": "noun",
      "explanation": "country + wheat",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        357,
        "/",
        449,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 5024,
      "bciAvId": 25208,
      "gloss": "to usually do, to habitually do",
      "glossSv": "bruka, ha för vana",
      "pos": "action",
      "explanation": "habit,custom + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        968,
        "/",
        655
      ]
    },
    {
      "id": 5025,
      "bciAvId": 25209,
      "gloss": "vampire",
      "glossSv": "vampyr",
      "pos": "person",
      "explanation": "imaginary person + blood",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        695,
        "/",
        423
      ]
    },
    {
      "id": 5026,
      "bciAvId": 25210,
      "gloss": "to warn",
      "glossSv": "varna",
      "pos": "action",
      "explanation": "warning + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        256
      ]
    },
    {
      "id": 5027,
      "bciAvId": 25211,
      "gloss": "warning",
      "glossSv": "varning",
      "pos": "noun",
      "explanation": "say,speak,talk,tell,express-(to) + danger",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        256
      ]
    },
    {
      "id": 5028,
      "bciAvId": 25212,
      "gloss": "wave power, wave energy",
      "glossSv": "vågkraft",
      "pos": "noun",
      "explanation": "energy + wave",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        761
      ]
    },
    {
      "id": 5029,
      "bciAvId": 25213,
      "gloss": "weapon",
      "glossSv": "vapen",
      "pos": "noun",
      "explanation": "tool + death",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        259
      ]
    },
    {
      "id": 5030,
      "bciAvId": 25214,
      "gloss": "Wednesday (day3)",
      "glossSv": "onsdag (dag 3)",
      "pos": "noun",
      "explanation": "day + 3 + three (index number): small 3 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        12,
        "/",
        22
      ]
    },
    {
      "id": 5031,
      "bciAvId": 25215,
      "gloss": "Wednesday (day4)",
      "glossSv": "onsdag (dag 4)",
      "pos": "noun",
      "explanation": "day + 4 + three (index number): small 3 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        13,
        "/",
        22
      ]
    },
    {
      "id": 5032,
      "bciAvId": 25216,
      "gloss": "Wednesday (day5)",
      "glossSv": "onsdag (dag 5)",
      "pos": "noun",
      "explanation": "day + 5 + three (index number): small 3 of ISO standard",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        14,
        "/",
        22
      ]
    },
    {
      "id": 5033,
      "bciAvId": 25217,
      "gloss": "weekend",
      "glossSv": "veckoslut",
      "pos": "noun",
      "explanation": "end + week",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        16,
        "/",
        258
      ]
    },
    {
      "id": 5034,
      "bciAvId": 25218,
      "gloss": "werewolf",
      "glossSv": "varulv",
      "pos": "person",
      "explanation": "imaginary person + wolf",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        124,
        "/",
        484
      ]
    },
    {
      "id": 5035,
      "bciAvId": 25220,
      "gloss": "wind power, wind energy, wind farm",
      "glossSv": "vindkraft",
      "pos": "noun",
      "explanation": "energy + wind",
      "isCharacter": false,
      "composition": [
        293,
        "/",
        705
      ]
    },
    {
      "id": 5036,
      "bciAvId": 25221,
      "gloss": "worn-out, raddled",
      "glossSv": "utsliten, utnött",
      "pos": "description",
      "explanation": "usage,use + end + description indicator",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        86,
        "/",
        292
      ]
    },
    {
      "id": 5037,
      "bciAvId": 25222,
      "gloss": "zombie",
      "glossSv": "zombie",
      "pos": "person",
      "explanation": "imaginary person + dead + walk",
      "isCharacter": false,
      "composition": [
        838,
        "/",
        259,
        "/",
        418
      ]
    },
    {
      "id": 5038,
      "bciAvId": 25223,
      "gloss": "touch, touching",
      "glossSv": "beröring",
      "pos": "noun",
      "explanation": "activity + hand",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 5039,
      "bciAvId": 25250,
      "gloss": "airforce, air force",
      "glossSv": "flygvapen",
      "pos": "person",
      "explanation": "military,armed forces,armed services + sky",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693,
        "/",
        597
      ]
    },
    {
      "id": 5040,
      "bciAvId": 25251,
      "gloss": "airport terminal",
      "glossSv": "flygterminal",
      "pos": "noun",
      "explanation": "public room + airplane",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        115
      ]
    },
    {
      "id": 5041,
      "bciAvId": 25252,
      "gloss": "air traffic controller",
      "glossSv": "flygledare",
      "pos": "person",
      "explanation": "leader + group of + airplane",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        368,
        "/",
        115
      ]
    },
    {
      "id": 5042,
      "bciAvId": 25253,
      "gloss": "alarm",
      "glossSv": "larm",
      "pos": "noun",
      "explanation": "tool + noise (loud) + intensity",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        608,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 5043,
      "bciAvId": 25254,
      "gloss": "to stretch, to expand",
      "glossSv": "växla",
      "pos": "action",
      "explanation": "alternation + action indicator",
      "isCharacter": false,
      "composition": [
        1163,
        ";",
        81
      ]
    },
    {
      "id": 5044,
      "bciAvId": 25255,
      "gloss": "stretchy, elastic",
      "glossSv": "växlande, omväxlande",
      "pos": "description",
      "explanation": "alternation + description indicator",
      "isCharacter": false,
      "composition": [
        1163,
        ";",
        86
      ]
    },
    {
      "id": 5045,
      "bciAvId": 25256,
      "gloss": "alternating current, AC",
      "glossSv": "växelström",
      "pos": "noun",
      "explanation": "stream + electricity + alternation",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        288,
        "/",
        144
      ]
    },
    {
      "id": 5046,
      "bciAvId": 25258,
      "gloss": "ammeter",
      "glossSv": "amperemätare",
      "pos": "noun",
      "explanation": "gauge + electric current + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        568,
        "/",
        288
      ]
    },
    {
      "id": 5047,
      "bciAvId": 25259,
      "gloss": "amplitude",
      "glossSv": "amplitud",
      "pos": "noun",
      "explanation": "measurement + height,tallness + wave",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        952,
        "/",
        761
      ]
    },
    {
      "id": 5048,
      "bciAvId": 25260,
      "gloss": "Arabic (language)",
      "glossSv": "arabiska",
      "pos": "noun",
      "explanation": "language + Muslim,Moslem,Islamic",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        622,
        "/",
        453
      ]
    },
    {
      "id": 5049,
      "bciAvId": 25261,
      "gloss": "attack",
      "glossSv": "anfall, attack, angrepp",
      "pos": "noun",
      "explanation": "activity + war",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        693
      ]
    },
    {
      "id": 5050,
      "bciAvId": 25262,
      "gloss": "to attack",
      "glossSv": "anfalla, attackera, angripa",
      "pos": "action",
      "explanation": "attack + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        693
      ]
    },
    {
      "id": 5051,
      "bciAvId": 25263,
      "gloss": "Batman",
      "glossSv": "Batman, Läderlappen",
      "pos": "person",
      "explanation": "make-believe person + bat (animal)",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        152
      ]
    },
    {
      "id": 5052,
      "bciAvId": 25264,
      "gloss": "bedbug, wall louse",
      "glossSv": "vägglus",
      "pos": "noun",
      "explanation": "louse,stinging insect + indoor",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        538,
        "/",
        775
      ]
    },
    {
      "id": 5053,
      "bciAvId": 25265,
      "gloss": "beige",
      "glossSv": "beige",
      "pos": "expression",
      "explanation": "colour + earth,ground,land + snow: combination of brown and white",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        281,
        "/",
        604
      ]
    },
    {
      "id": 5054,
      "bciAvId": 25266,
      "gloss": "biathlon",
      "glossSv": "skidskytte",
      "pos": "noun",
      "explanation": "sport + skies + gun",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        11,
        "/",
        1084,
        "/",
        369
      ]
    },
    {
      "id": 5055,
      "bciAvId": 25268,
      "gloss": "to bless",
      "glossSv": "välsigna",
      "pos": "action",
      "explanation": "give + peace + protection + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        505,
        "/",
        548
      ]
    },
    {
      "id": 5056,
      "bciAvId": 25269,
      "gloss": "to have a view, to have an opinion",
      "glossSv": "tycka, anse, mena, ha åsikt om",
      "pos": "action",
      "explanation": "opinion + action indicator",
      "isCharacter": false,
      "composition": [
        485,
        ";",
        81
      ]
    },
    {
      "id": 5057,
      "bciAvId": 25270,
      "gloss": "cabin (airplane)",
      "glossSv": "kabin (flygplan)",
      "pos": "noun",
      "explanation": "room + airplane",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        115
      ]
    },
    {
      "id": 5058,
      "bciAvId": 25271,
      "gloss": "camping mat, sleeping mat",
      "glossSv": "liggunderlag",
      "pos": "noun",
      "explanation": "cloth + reclining,lying (person lying down): can be viewed as a combination of rug,carpet,mat and reclining",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        515
      ]
    },
    {
      "id": 5059,
      "bciAvId": 25272,
      "gloss": "camping stove",
      "glossSv": "campingkök, stormkök",
      "pos": "noun",
      "explanation": "stove + carry",
      "isCharacter": false,
      "composition": [
        320,
        "/",
        917
      ]
    },
    {
      "id": 5060,
      "bciAvId": 25273,
      "gloss": "to carve",
      "glossSv": "tälja, rista",
      "pos": "action",
      "explanation": "knife + shape + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        303,
        "/",
        651
      ]
    },
    {
      "id": 5061,
      "bciAvId": 25274,
      "gloss": "chase",
      "glossSv": "jagande, jakt",
      "pos": "noun",
      "explanation": "forward + forward",
      "isCharacter": true
    },
    {
      "id": 5062,
      "bciAvId": 25275,
      "gloss": "to chase",
      "glossSv": "jaga, följa efter",
      "pos": "action",
      "explanation": "chase + action indicator",
      "isCharacter": false,
      "composition": [
        5061,
        ";",
        81
      ]
    },
    {
      "id": 5063,
      "bciAvId": 25276,
      "gloss": "cipher",
      "glossSv": "chiffer, kryptering",
      "pos": "noun",
      "explanation": "alphabet,letters (lowercase) (Latin alphabet) + secret",
      "isCharacter": false,
      "composition": [
        "Xa",
        "/",
        "Xb",
        "/",
        "Xc",
        "/",
        583
      ]
    },
    {
      "id": 5064,
      "bciAvId": 25277,
      "gloss": "closed",
      "glossSv": "stängd",
      "pos": "description",
      "explanation": "enclosure + description indicator",
      "isCharacter": false,
      "composition": [
        291,
        ";",
        86
      ]
    },
    {
      "id": 5065,
      "bciAvId": 25278,
      "gloss": "clue",
      "glossSv": "ledtråd",
      "pos": "noun",
      "explanation": "information + to,toward,towards + answer",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        657,
        "/",
        129
      ]
    },
    {
      "id": 5066,
      "bciAvId": 25279,
      "gloss": "cousin (male)",
      "glossSv": "kusin (manlig)",
      "pos": "person",
      "explanation": "son + sibling(s) + parent: the son of an uncle or aunt",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        479,
        "/",
        11,
        "/",
        500
      ]
    },
    {
      "id": 5067,
      "bciAvId": 25280,
      "gloss": "cousin (female)",
      "glossSv": "kusin (kvinnlig)",
      "pos": "person",
      "explanation": "daughter + sibling(s) + parent: the son of an uncle or aunt",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        479,
        "/",
        11,
        "/",
        500
      ]
    },
    {
      "id": 5068,
      "bciAvId": 25281,
      "gloss": "direct current, DC",
      "glossSv": "likström",
      "pos": "noun",
      "explanation": "electric current + forward",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        288,
        "/",
        335
      ]
    },
    {
      "id": 5069,
      "bciAvId": 25282,
      "gloss": "cylinder for breathing",
      "glossSv": "syrgastub",
      "pos": "noun",
      "explanation": "cylinder + breathing",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5070,
      "bciAvId": 25283,
      "gloss": "Danish (language)",
      "glossSv": "danska (FD)",
      "pos": "noun",
      "explanation": "language + three Danish waters (OLD): based on Denmark (OLD) [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        1097
      ]
    },
    {
      "id": 5071,
      "bciAvId": 25285,
      "gloss": "digital memory, RAM",
      "glossSv": "minne (digitalt), RAM-minne",
      "pos": "noun",
      "explanation": "memory + digits (computer)",
      "isCharacter": false,
      "composition": [
        841,
        "/",
        829
      ]
    },
    {
      "id": 5072,
      "bciAvId": 25286,
      "gloss": "Egypt",
      "glossSv": "Egypten",
      "pos": "noun",
      "explanation": "country + pyramid",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        552
      ]
    },
    {
      "id": 5073,
      "bciAvId": 25287,
      "gloss": "electric circuit",
      "glossSv": "elektrisk krets",
      "pos": "noun",
      "explanation": "ring + electricity",
      "isCharacter": false,
      "composition": [
        567,
        "/",
        288
      ]
    },
    {
      "id": 5074,
      "bciAvId": 25288,
      "gloss": "electric conductor",
      "glossSv": "elektrisk ledare",
      "pos": "noun",
      "explanation": "through + electricity + thing indicator",
      "isCharacter": false,
      "composition": [
        653,
        ";",
        97,
        "/",
        288
      ]
    },
    {
      "id": 5075,
      "bciAvId": 25289,
      "gloss": "electric current",
      "glossSv": "elektrisk ström, ström (elektrisk)",
      "pos": "noun",
      "explanation": "stream + electricity",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        288
      ]
    },
    {
      "id": 5076,
      "bciAvId": 25291,
      "gloss": "electric insulator, electrical insulator",
      "glossSv": "elektrisk isolator, isolator (elektricitet)",
      "pos": "noun",
      "explanation": "impermeable material,insulation (material) + electricity",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        292,
        "/",
        288
      ]
    },
    {
      "id": 5077,
      "bciAvId": 25292,
      "gloss": "electro magnet",
      "glossSv": "elektromagnet",
      "pos": "noun",
      "explanation": "thing + magnetism + electricity",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        982,
        "/",
        288
      ]
    },
    {
      "id": 5078,
      "bciAvId": 25293,
      "gloss": "engagement",
      "glossSv": "förlovning",
      "pos": "noun",
      "explanation": "before + marriage",
      "isCharacter": false,
      "composition": [
        158,
        "/",
        437
      ]
    },
    {
      "id": 5079,
      "bciAvId": 25295,
      "gloss": "Estonian (language)",
      "glossSv": "estniska",
      "pos": "noun",
      "explanation": "language + Estonia",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        457,
        "/",
        462
      ]
    },
    {
      "id": 5080,
      "bciAvId": 25296,
      "gloss": "fiance, groom-to-be",
      "glossSv": "fästman",
      "pos": "person",
      "explanation": "man + engagement",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        158,
        "/",
        437
      ]
    },
    {
      "id": 5081,
      "bciAvId": 25297,
      "gloss": "fiancee, bride-to-be",
      "glossSv": "fästmö",
      "pos": "person",
      "explanation": "woman + engagement",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        158,
        "/",
        437
      ]
    },
    {
      "id": 5082,
      "bciAvId": 25298,
      "gloss": "fingerprint",
      "glossSv": "fingeravtryck",
      "pos": "noun",
      "explanation": "imprint + finger",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        893,
        "/",
        318
      ]
    },
    {
      "id": 5083,
      "bciAvId": 25299,
      "gloss": "Finnish (class)",
      "glossSv": "finska (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + Finnish",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        624,
        "/",
        629
      ]
    },
    {
      "id": 5084,
      "bciAvId": 25300,
      "gloss": "Finnish (language)",
      "glossSv": "finska",
      "pos": "noun",
      "explanation": "language + Finland [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        624,
        "/",
        629
      ]
    },
    {
      "id": 5085,
      "bciAvId": 25301,
      "gloss": "fire extinguisher",
      "glossSv": "brandsläckare",
      "pos": "noun",
      "explanation": "cylinder + extinction,extinguishing (fire)",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        1030
      ]
    },
    {
      "id": 5086,
      "bciAvId": 25302,
      "gloss": "fire place, campfire site",
      "glossSv": "eldstad",
      "pos": "noun",
      "explanation": "place + stove",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        320
      ]
    },
    {
      "id": 5087,
      "bciAvId": 25303,
      "gloss": "firecraft",
      "glossSv": "eldkunskap",
      "pos": "noun",
      "explanation": "knowledge + activity + fire",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        106,
        "/",
        319
      ]
    },
    {
      "id": 5088,
      "bciAvId": 25304,
      "gloss": "first aid kit",
      "glossSv": "första hjälpen",
      "pos": "noun",
      "explanation": "medical aid + first + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 5089,
      "bciAvId": 25305,
      "gloss": "fish bone",
      "glossSv": "fiskben",
      "pos": "noun",
      "explanation": "bone + fish",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        321
      ]
    },
    {
      "id": 5090,
      "bciAvId": 25306,
      "gloss": "flight instrument(s)",
      "glossSv": "flygplansinstrument",
      "pos": "noun",
      "explanation": "gauge + airplane + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        115
      ]
    },
    {
      "id": 5091,
      "bciAvId": 25307,
      "gloss": "flight deck, cockpit",
      "glossSv": "cockpit",
      "pos": "noun",
      "explanation": "room + pilot",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        513,
        "/",
        115
      ]
    },
    {
      "id": 5092,
      "bciAvId": 25308,
      "gloss": "footprint",
      "glossSv": "fotspår, fotavtryck",
      "pos": "noun",
      "explanation": "imprint,trace,track + foot",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        893,
        "/",
        330
      ]
    },
    {
      "id": 5093,
      "bciAvId": 25309,
      "gloss": "French (language)",
      "glossSv": "franska",
      "pos": "noun",
      "explanation": "language + France [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        365,
        "/",
        345,
        "/",
        401
      ]
    },
    {
      "id": 5094,
      "bciAvId": 25310,
      "gloss": "frequency (wave motion)",
      "glossSv": "frekvens (vågrörelse)",
      "pos": "noun",
      "explanation": "frequency + wave",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        426,
        "/",
        761
      ]
    },
    {
      "id": 5095,
      "bciAvId": 25312,
      "gloss": "full, satisfied",
      "glossSv": "mätt",
      "pos": "description",
      "explanation": "feeling + full + food + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        947,
        "/",
        329
      ]
    },
    {
      "id": 5096,
      "bciAvId": 25313,
      "gloss": "fuse",
      "glossSv": "propp, säkring",
      "pos": "noun",
      "explanation": "thing + protection + electricity",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        548,
        "/",
        288
      ]
    },
    {
      "id": 5097,
      "bciAvId": 25314,
      "gloss": "fuselage",
      "glossSv": "flygplanskropp",
      "pos": "noun",
      "explanation": "body + airplane",
      "isCharacter": false,
      "composition": [
        171,
        "/",
        115
      ]
    },
    {
      "id": 5098,
      "bciAvId": 25315,
      "gloss": "gas cylinder",
      "glossSv": "gastub",
      "pos": "noun",
      "explanation": "cylinder + gas",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        345
      ]
    },
    {
      "id": 5099,
      "bciAvId": 25316,
      "gloss": "gathering of scouts, jamboree",
      "glossSv": "scoutmöte, jamboree",
      "pos": "noun",
      "explanation": "gathering + scouting",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        412,
        "/",
        106,
        "/",
        382
      ]
    },
    {
      "id": 5100,
      "bciAvId": 25317,
      "gloss": "hangar",
      "glossSv": "hangar",
      "pos": "noun",
      "explanation": "garage + airplane",
      "isCharacter": false,
      "composition": [
        342,
        "/",
        115
      ]
    },
    {
      "id": 5101,
      "bciAvId": 25318,
      "gloss": "head louse",
      "glossSv": "huvudlus",
      "pos": "noun",
      "explanation": "louse,stinging insect + hair",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        538,
        "/",
        371
      ]
    },
    {
      "id": 5102,
      "bciAvId": 25319,
      "gloss": "headset",
      "glossSv": "headset",
      "pos": "noun",
      "explanation": "earmuffs (general) + signal",
      "isCharacter": false,
      "composition": [
        942,
        "/",
        922
      ]
    },
    {
      "id": 5103,
      "bciAvId": 25320,
      "gloss": "to hike",
      "glossSv": "vandra",
      "pos": "action",
      "explanation": "hiking + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        418,
        "/",
        484
      ]
    },
    {
      "id": 5104,
      "bciAvId": 25321,
      "gloss": "hiking",
      "glossSv": "vandring",
      "pos": "noun",
      "explanation": "activity + legs and feet + open",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        418,
        "/",
        484
      ]
    },
    {
      "id": 5105,
      "bciAvId": 25322,
      "gloss": "Icelandic (language)",
      "glossSv": "isländska",
      "pos": "noun",
      "explanation": "language + ice + fire: ice + fire representing Iceland [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        394,
        "/",
        319
      ]
    },
    {
      "id": 5106,
      "bciAvId": 25323,
      "gloss": "to illustrate",
      "glossSv": "illustrera",
      "pos": "action",
      "explanation": "illustration + action indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        303,
        "/",
        291
      ]
    },
    {
      "id": 5107,
      "bciAvId": 25324,
      "gloss": "illustrated, illustrating",
      "glossSv": "illustrerad",
      "pos": "description",
      "explanation": "illustration + description indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        86,
        "/",
        303,
        "/",
        291
      ]
    },
    {
      "id": 5108,
      "bciAvId": 25325,
      "gloss": "illustration",
      "glossSv": "illustration",
      "pos": "noun",
      "explanation": "making,production,fashioning + picture",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        303,
        "/",
        291
      ]
    },
    {
      "id": 5109,
      "bciAvId": 25326,
      "gloss": "impermeable material, insulation (material)",
      "glossSv": "isolering (material)",
      "pos": "noun",
      "explanation": "material + stop",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        292
      ]
    },
    {
      "id": 5110,
      "bciAvId": 25327,
      "gloss": "imprint, trace, track",
      "glossSv": "avtryck, spår",
      "pos": "noun",
      "explanation": "effect + bump,press,pressing",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        893
      ]
    },
    {
      "id": 5111,
      "bciAvId": 25328,
      "gloss": "inhaler",
      "glossSv": "inhalator",
      "pos": "noun",
      "explanation": "medical aid + breath",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5112,
      "bciAvId": 25329,
      "gloss": "insomnia",
      "glossSv": "sömnlöshet, insomnia",
      "pos": "noun",
      "explanation": "state of mind + without + sleep",
      "isCharacter": false,
      "composition": [
        985,
        "/",
        449,
        "/",
        599
      ]
    },
    {
      "id": 5113,
      "bciAvId": 25330,
      "gloss": "Iran",
      "glossSv": "Iran",
      "pos": "noun",
      "explanation": "country + poetry",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        1059,
        "/",
        313
      ]
    },
    {
      "id": 5114,
      "bciAvId": 25331,
      "gloss": "Irish (language)",
      "glossSv": "irländska",
      "pos": "noun",
      "explanation": "language + shamrock: shamrock representing Ireland [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        586
      ]
    },
    {
      "id": 5115,
      "bciAvId": 25332,
      "gloss": "Italian (language)",
      "glossSv": "italienska",
      "pos": "noun",
      "explanation": "language + opera: opera representing Italy [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        457,
        "/",
        462,
        "/",
        723
      ]
    },
    {
      "id": 5116,
      "bciAvId": 25333,
      "gloss": "ladybird",
      "glossSv": "nyckelpiga",
      "pos": "noun",
      "explanation": "bug + dot",
      "isCharacter": false,
      "composition": [
        157,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 5117,
      "bciAvId": 25334,
      "gloss": "landing gear",
      "glossSv": "landningsställ",
      "pos": "noun",
      "explanation": "wheel + airplane",
      "isCharacter": false,
      "composition": [
        700,
        "/",
        115
      ]
    },
    {
      "id": 5118,
      "bciAvId": 25335,
      "gloss": "lifeline",
      "glossSv": "livlina, räddningslina",
      "pos": "noun",
      "explanation": "strap,string,velcro,rope,cord + help",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        823,
        "/",
        382
      ]
    },
    {
      "id": 5119,
      "bciAvId": 25336,
      "gloss": "light (weight)",
      "glossSv": "lätt (vikt)",
      "pos": "description",
      "explanation": "weight + little + description indicator",
      "isCharacter": false,
      "composition": [
        697,
        ";",
        86,
        "/",
        956
      ]
    },
    {
      "id": 5120,
      "bciAvId": 25337,
      "gloss": "liquid",
      "glossSv": "vätska",
      "pos": "noun",
      "explanation": "generalization + water",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        695
      ]
    },
    {
      "id": 5121,
      "bciAvId": 25338,
      "gloss": "magnet",
      "glossSv": "magnet",
      "pos": "noun",
      "explanation": "thing + magnetism",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        982
      ]
    },
    {
      "id": 5122,
      "bciAvId": 25341,
      "gloss": "to make and tend a fire",
      "glossSv": "elda, göra upp eld",
      "pos": "action",
      "explanation": "activity + fire + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        319
      ]
    },
    {
      "id": 5123,
      "bciAvId": 25342,
      "gloss": "medication for breathing",
      "glossSv": "astmamedicin, andningsmedicin",
      "pos": "noun",
      "explanation": "medicine + breath",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        958,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5124,
      "bciAvId": 25343,
      "gloss": "memory game, Kim's game",
      "glossSv": "minneslek, Kims lek",
      "pos": "noun",
      "explanation": "game [contraction] + memory",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        841
      ]
    },
    {
      "id": 5125,
      "bciAvId": 25344,
      "gloss": "national",
      "glossSv": "nationell",
      "pos": "description",
      "explanation": "country + descripton indicator",
      "isCharacter": false,
      "composition": [
        243,
        ";",
        86
      ]
    },
    {
      "id": 5126,
      "bciAvId": 25345,
      "gloss": "national day",
      "glossSv": "nationaldag",
      "pos": "noun",
      "explanation": "day + country",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        243
      ]
    },
    {
      "id": 5127,
      "bciAvId": 25346,
      "gloss": "to navigate airplane",
      "glossSv": "navigera (flygplan)",
      "pos": "action",
      "explanation": "activity + sign,signal + airplane + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        651,
        "/",
        835,
        "/",
        115
      ]
    },
    {
      "id": 5128,
      "bciAvId": 25347,
      "gloss": "Norwegian (language)",
      "glossSv": "norska",
      "pos": "noun",
      "explanation": "language + fjord: fjord representing Norway [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        797
      ]
    },
    {
      "id": 5129,
      "bciAvId": 25348,
      "gloss": "organisation, organising, organization, organizing",
      "glossSv": "ordning, organisation",
      "pos": "noun",
      "explanation": "plan + many + thing",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        368,
        "/",
        651
      ]
    },
    {
      "id": 5130,
      "bciAvId": 25349,
      "gloss": "to orienteer (sport)",
      "glossSv": "orientera (sport)",
      "pos": "action",
      "explanation": "orienteering (sport) + action indicator",
      "isCharacter": false,
      "composition": [
        719,
        ";",
        81,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 5131,
      "bciAvId": 25350,
      "gloss": "to orienteer, to read map",
      "glossSv": "läsa kartan, orientera",
      "pos": "action",
      "explanation": "map reading + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 5132,
      "bciAvId": 25351,
      "gloss": "orienteering (sport)",
      "glossSv": "orientering (sport)",
      "pos": "noun",
      "explanation": "sport + map",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 5133,
      "bciAvId": 25352,
      "gloss": "map reading",
      "glossSv": "kartläsning, orientering",
      "pos": "noun",
      "explanation": "activity + map",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 5134,
      "bciAvId": 25354,
      "gloss": "PEP mask",
      "glossSv": "PEP-mask, andningsmask",
      "pos": "noun",
      "explanation": "breathing aid + pressure + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        473,
        "/",
        457,
        "/",
        815
      ]
    },
    {
      "id": 5135,
      "bciAvId": 25355,
      "gloss": "perch (fish)",
      "glossSv": "abborre",
      "pos": "noun",
      "explanation": "fish + quill(s),spine(s)",
      "isCharacter": false,
      "composition": [
        321,
        "/",
        845
      ]
    },
    {
      "id": 5136,
      "bciAvId": 25356,
      "gloss": "period (wave motion)",
      "glossSv": "period (vågrörelse)",
      "pos": "noun",
      "explanation": "limited time + wave",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        761
      ]
    },
    {
      "id": 5137,
      "bciAvId": 25357,
      "gloss": "permeable material",
      "glossSv": "genomsläppligt material",
      "pos": "noun",
      "explanation": "material + through",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        653
      ]
    },
    {
      "id": 5138,
      "bciAvId": 25358,
      "gloss": "Persian (language)",
      "glossSv": "persiska",
      "pos": "noun",
      "explanation": "language + poetry: poetry representing Iran [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        1059,
        "/",
        313
      ]
    },
    {
      "id": 5139,
      "bciAvId": 25359,
      "gloss": "personal measurement",
      "glossSv": "personliga mått",
      "pos": "noun",
      "explanation": "measurement + self",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        2343
      ]
    },
    {
      "id": 5140,
      "bciAvId": 25360,
      "gloss": "plant-louse",
      "glossSv": "bladlus",
      "pos": "noun",
      "explanation": "louse,stinging insect + plant",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        538,
        "/",
        533
      ]
    },
    {
      "id": 5141,
      "bciAvId": 25363,
      "gloss": "radio (2)",
      "glossSv": "radio (2)",
      "pos": "noun",
      "explanation": "enclosure + ear + signal,broadcast,transmitting: a device for hearing radio transmissions",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        278,
        "/",
        922
      ]
    },
    {
      "id": 5142,
      "bciAvId": 25365,
      "gloss": "rowdy, raucous",
      "glossSv": "stökig, bråkig",
      "pos": "description",
      "explanation": "quarrel,row + description indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        86,
        "/",
        346,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 5143,
      "bciAvId": 25366,
      "gloss": "runway (airport)",
      "glossSv": "landningsbana",
      "pos": "noun",
      "explanation": "place + airplane + ascending and descending",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        115,
        "/",
        988
      ]
    },
    {
      "id": 5144,
      "bciAvId": 25367,
      "gloss": "Russian (language)",
      "glossSv": "ryska",
      "pos": "noun",
      "explanation": "language + Russia",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        925
      ]
    },
    {
      "id": 5145,
      "bciAvId": 25368,
      "gloss": "equal, same",
      "glossSv": "lika, samma",
      "pos": "description",
      "explanation": "same,equal,equality + description indicator",
      "isCharacter": false,
      "composition": [
        578,
        ";",
        86
      ]
    },
    {
      "id": 5146,
      "bciAvId": 25369,
      "gloss": "science centre",
      "glossSv": "vetenskapscenter",
      "pos": "noun",
      "explanation": "activity centre + science",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        106,
        "/",
        580
      ]
    },
    {
      "id": 5147,
      "bciAvId": 25370,
      "gloss": "scout (etc)",
      "glossSv": "scout",
      "pos": "person",
      "explanation": "person + scouting",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        106,
        "/",
        382
      ]
    },
    {
      "id": 5148,
      "bciAvId": 25371,
      "gloss": "scouting (etc)",
      "glossSv": "scouting",
      "pos": "noun",
      "explanation": "knowledge + activity + help",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        106,
        "/",
        382
      ]
    },
    {
      "id": 5149,
      "bciAvId": 25372,
      "gloss": "signal strength meter",
      "glossSv": "signalmätare, mätare för signalstyrka",
      "pos": "noun",
      "explanation": "gauge + signal,broadcast,transmitting + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        922
      ]
    },
    {
      "id": 5150,
      "bciAvId": 25373,
      "gloss": "sleepy",
      "glossSv": "sömnig",
      "pos": "description",
      "explanation": "feeling + without + sleep + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        599
      ]
    },
    {
      "id": 5151,
      "bciAvId": 25374,
      "gloss": "sniffer dog",
      "glossSv": "spårhund",
      "pos": "noun",
      "explanation": "dog + nose + information",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        473,
        "/",
        835
      ]
    },
    {
      "id": 5152,
      "bciAvId": 25375,
      "gloss": "social network, social media",
      "glossSv": "socialt nätverk, Facebook (etc)",
      "pos": "noun",
      "explanation": "exchange + digital world + person: digital world representing the Internet [contraction]",
      "isCharacter": false,
      "composition": [
        1029,
        "/",
        1026,
        "/",
        513
      ]
    },
    {
      "id": 5153,
      "bciAvId": 25376,
      "gloss": "Spain",
      "glossSv": "Spanien",
      "pos": "noun",
      "explanation": "country + castanet",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        263,
        "/",
        318
      ]
    },
    {
      "id": 5154,
      "bciAvId": 25377,
      "gloss": "Spanish, Castilian (language)",
      "glossSv": "spanska, kastilianska",
      "pos": "noun",
      "explanation": "language + castle,palace: Castilian being the \"language of castles\", the main language of Spain",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        825
      ]
    },
    {
      "id": 5155,
      "bciAvId": 25378,
      "gloss": "Spiderman",
      "glossSv": "Spiderman, Spindelmannen",
      "pos": "person",
      "explanation": "make-believe person + spider",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        613
      ]
    },
    {
      "id": 5156,
      "bciAvId": 25380,
      "gloss": "suicide",
      "glossSv": "självmord",
      "pos": "noun",
      "explanation": "cause + death + self",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        259,
        "/",
        2343
      ]
    },
    {
      "id": 5157,
      "bciAvId": 25381,
      "gloss": "Superman",
      "glossSv": "Superman, Stålmannen",
      "pos": "person",
      "explanation": "make-believe person + brave + S",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        313,
        "/",
        967,
        "/",
        "XS"
      ]
    },
    {
      "id": 5158,
      "bciAvId": 25382,
      "gloss": "tail (airplane)",
      "glossSv": "flygplansstjärt",
      "pos": "noun",
      "explanation": "rear,back of a thing + airplane",
      "isCharacter": false,
      "composition": [
        984,
        "/",
        115
      ]
    },
    {
      "id": 5159,
      "bciAvId": 25383,
      "gloss": "tail wing (airplane)",
      "glossSv": "stjärtvinge (flygplan)",
      "pos": "noun",
      "explanation": "wing(s) + tail (airplane)",
      "isCharacter": false,
      "composition": [
        708,
        "/",
        984,
        "/",
        115
      ]
    },
    {
      "id": 5160,
      "bciAvId": 25384,
      "gloss": "to take off (airplane)",
      "glossSv": "lyfta (flygplan)",
      "pos": "action",
      "explanation": "takeoff,take-off,airplane take-off + action indicator",
      "isCharacter": false,
      "composition": [
        115,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        680
      ]
    },
    {
      "id": 5161,
      "bciAvId": 25385,
      "gloss": "Tarzan",
      "glossSv": "Tarzan",
      "pos": "person",
      "explanation": "make-believe person + jungle",
      "isCharacter": false,
      "composition": [
        837,
        "/",
        368,
        "/",
        666,
        "/",
        794
      ]
    },
    {
      "id": 5162,
      "bciAvId": 25386,
      "gloss": "to tie whipping knot",
      "glossSv": "tagla",
      "pos": "action",
      "explanation": "whipping knot + action indicator",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        81,
        "/",
        428,
        ";",
        97,
        "/",
        823
      ]
    },
    {
      "id": 5163,
      "bciAvId": 25388,
      "gloss": "tracker",
      "glossSv": "spårare",
      "pos": "person",
      "explanation": "person + wakefulness,alertness + imprint,trace,track: alertness representing to watch [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        969,
        "/",
        284,
        "/",
        893
      ]
    },
    {
      "id": 5164,
      "bciAvId": 25389,
      "gloss": "turquoise",
      "glossSv": "turkos",
      "pos": "expression",
      "explanation": "colour + sky + grass: a combination of blue and green",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        597,
        "/",
        366
      ]
    },
    {
      "id": 5165,
      "bciAvId": 25390,
      "gloss": "working uniform",
      "glossSv": "uniform",
      "pos": "noun",
      "explanation": "clothes + crew,staff",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        368,
        "/",
        513,
        "/",
        711
      ]
    },
    {
      "id": 5166,
      "bciAvId": 25391,
      "gloss": "wave length",
      "glossSv": "våglängd",
      "pos": "noun",
      "explanation": "length + wave",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        420,
        "/",
        761
      ]
    },
    {
      "id": 5167,
      "bciAvId": 25392,
      "gloss": "veterinarian",
      "glossSv": "veterinär",
      "pos": "person",
      "explanation": "doctor + animal",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        958,
        "/",
        122
      ]
    },
    {
      "id": 5168,
      "bciAvId": 25393,
      "gloss": "whipping knot",
      "glossSv": "tagling",
      "pos": "noun",
      "explanation": "spiral + strap,string,velcro,rope,cord",
      "isCharacter": false,
      "composition": [
        1090,
        "/",
        428,
        ";",
        97,
        "/",
        823
      ]
    },
    {
      "id": 5169,
      "bciAvId": 25394,
      "gloss": "wind turbine",
      "glossSv": "vindkraftverk, vindsnurra",
      "pos": "noun",
      "explanation": "windmill + electricity",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        983,
        "/",
        288
      ]
    },
    {
      "id": 5170,
      "bciAvId": 25395,
      "gloss": "windmill",
      "glossSv": "väderkvarn",
      "pos": "noun",
      "explanation": "tower + propeller,rotor (blades)",
      "isCharacter": false,
      "composition": [
        821,
        "/",
        983
      ]
    },
    {
      "id": 5171,
      "bciAvId": 25397,
      "gloss": "voltmeter",
      "glossSv": "voltmeter",
      "pos": "noun",
      "explanation": "gauge + voltage + thing indicator",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        987
      ]
    },
    {
      "id": 5172,
      "bciAvId": 25398,
      "gloss": "to wrap, to wind",
      "glossSv": "vira, linda, surra",
      "pos": "action",
      "explanation": "spiral + action indicator",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        81
      ]
    },
    {
      "id": 5173,
      "bciAvId": 25399,
      "gloss": "wreck, wreckage (airplane)",
      "glossSv": "flygplansvrak",
      "pos": "noun",
      "explanation": "airplane + deletion,cancellation,destruction",
      "isCharacter": false,
      "composition": [
        115,
        "/",
        939
      ]
    },
    {
      "id": 5174,
      "bciAvId": 25400,
      "gloss": "wreck, wreckage (boat)",
      "glossSv": "båtvrak",
      "pos": "noun",
      "explanation": "boat + deletion,cancellation,destruction",
      "isCharacter": false,
      "composition": [
        170,
        "/",
        939
      ]
    },
    {
      "id": 5175,
      "bciAvId": 25402,
      "gloss": "to land (airplane)",
      "glossSv": "landa (flygplan)",
      "pos": "action",
      "explanation": "landing,airplane landing + action indicator",
      "isCharacter": false,
      "composition": [
        115,
        ";",
        81,
        "/",
        273
      ]
    },
    {
      "id": 5176,
      "bciAvId": 25405,
      "gloss": "different, other, unequal",
      "glossSv": "olika, annorlunda",
      "pos": "description",
      "explanation": "different,other,difference + description indicator",
      "isCharacter": false,
      "composition": [
        262,
        ";",
        86
      ]
    },
    {
      "id": 5177,
      "bciAvId": 25407,
      "gloss": "magnetic pole",
      "glossSv": "magnetpol, magnetisk pol",
      "pos": "noun",
      "explanation": "South Pole + magnetism",
      "isCharacter": false,
      "composition": [
        795,
        "/",
        982
      ]
    },
    {
      "id": 5178,
      "bciAvId": 25409,
      "gloss": "breathing aid",
      "glossSv": "andningshjälpmedel",
      "pos": "noun",
      "explanation": "aid,device,support + breath + thing indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5179,
      "bciAvId": 25410,
      "gloss": "sitting mat",
      "glossSv": "sittunderlag",
      "pos": "noun",
      "explanation": "cloth + seat,sitting (sitting person)",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        517
      ]
    },
    {
      "id": 5180,
      "bciAvId": 25411,
      "gloss": "frequency",
      "glossSv": "frekvens",
      "pos": "noun",
      "explanation": "number + limited time: number of something per time measure",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        426
      ]
    },
    {
      "id": 5181,
      "bciAvId": 25412,
      "gloss": "sleepless",
      "glossSv": "sömnlös",
      "pos": "description",
      "explanation": "insomnia + description indicator",
      "isCharacter": false,
      "composition": [
        985,
        ";",
        86,
        "/",
        449,
        "/",
        599
      ]
    },
    {
      "id": 5182,
      "bciAvId": 25413,
      "gloss": "quarrel, row",
      "glossSv": "stök, bråk",
      "pos": "noun",
      "explanation": "activity + gathering + negative",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        346,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 5183,
      "bciAvId": 25414,
      "gloss": "Germany",
      "glossSv": "Tyskland",
      "pos": "noun",
      "explanation": "country + D + E + U",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        "XD",
        "/",
        "XE",
        "/",
        "XU"
      ]
    },
    {
      "id": 5184,
      "bciAvId": 25415,
      "gloss": "German (language)",
      "glossSv": "tyska",
      "pos": "noun",
      "explanation": "language + Germany",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        "XD",
        "/",
        "XE",
        "/",
        "XU"
      ]
    },
    {
      "id": 5185,
      "bciAvId": 25416,
      "gloss": "Thailand",
      "glossSv": "Thailand",
      "pos": "noun",
      "explanation": "country + T + H + A",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        "XT",
        "/",
        "XH",
        "/",
        "XA"
      ]
    },
    {
      "id": 5186,
      "bciAvId": 25417,
      "gloss": "Romania",
      "glossSv": "Rumänien",
      "pos": "noun",
      "explanation": "country + R + O + U",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        "XR",
        "/",
        "XO",
        "/",
        "XU"
      ]
    },
    {
      "id": 5187,
      "bciAvId": 25418,
      "gloss": "artillery",
      "glossSv": "artilleri",
      "pos": "noun",
      "explanation": "military,armed forces,armed services + cannon,gun",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693,
        "/",
        201
      ]
    },
    {
      "id": 5188,
      "bciAvId": 25419,
      "gloss": "German (class)",
      "glossSv": "tyska (skolämne)",
      "pos": "noun",
      "explanation": "class + German (language)",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        243,
        "/",
        "XD",
        "/",
        "XE",
        "/",
        "XU"
      ]
    },
    {
      "id": 5189,
      "bciAvId": 25420,
      "gloss": "Romanian (class)",
      "glossSv": "rumänska (skolämne)",
      "pos": "noun",
      "explanation": "class + Romanian (language)",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        243,
        "/",
        "XR",
        "/",
        "XO",
        "/",
        "XU"
      ]
    },
    {
      "id": 5190,
      "bciAvId": 25421,
      "gloss": "Romanian (language)",
      "glossSv": "rumänska",
      "pos": "noun",
      "explanation": "language + Romania",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        "XR",
        "/",
        "XO",
        "/",
        "XU"
      ]
    },
    {
      "id": 5191,
      "bciAvId": 25422,
      "gloss": "armoured force, armored force, tank force",
      "glossSv": "pansarstyrka",
      "pos": "noun",
      "explanation": "military,armed forces,armed services + tank",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        693,
        "/",
        641
      ]
    },
    {
      "id": 5192,
      "bciAvId": 25423,
      "gloss": "Thai (class)",
      "glossSv": "thailändska (skolämne)",
      "pos": "noun",
      "explanation": "class + Thai (language)",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        243,
        "/",
        "XT",
        "/",
        "XH",
        "/",
        "XA"
      ]
    },
    {
      "id": 5193,
      "bciAvId": 25424,
      "gloss": "Thai (language)",
      "glossSv": "thailändska",
      "pos": "noun",
      "explanation": "language + Thailand",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        "XT",
        "/",
        "XH",
        "/",
        "XA"
      ]
    },
    {
      "id": 5194,
      "bciAvId": 25430,
      "gloss": "appendix, caecum, cecum",
      "glossSv": "blindtarm, appendix",
      "pos": "noun",
      "explanation": "intestine(s),bowel(s),gut(s) + end,arrival,stop: The intestine that stops in a dead end",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        866,
        "/",
        292
      ]
    },
    {
      "id": 5195,
      "bciAvId": 25431,
      "gloss": "beginning of year",
      "glossSv": "årets början",
      "pos": "noun",
      "explanation": "beginning,start + year",
      "isCharacter": false,
      "composition": [
        159,
        "/",
        716
      ]
    },
    {
      "id": 5196,
      "bciAvId": 25432,
      "gloss": "body painting",
      "glossSv": "kroppsmålning",
      "pos": "noun",
      "explanation": "picture,image,icon,painting + body + brush: Panting on skin made with brush",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        171,
        "/",
        184
      ]
    },
    {
      "id": 5197,
      "bciAvId": 25433,
      "gloss": "bracelet",
      "glossSv": "armband",
      "pos": "noun",
      "explanation": "jewelry + arm",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        132
      ]
    },
    {
      "id": 5198,
      "bciAvId": 25435,
      "gloss": "breastbone, sternum",
      "glossSv": "bröstben",
      "pos": "noun",
      "explanation": "bone + chest",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        218
      ]
    },
    {
      "id": 5199,
      "bciAvId": 25436,
      "gloss": "brooch",
      "glossSv": "brosch, slipsnål (etc)",
      "pos": "noun",
      "explanation": "jewelry + clothing: Jewelry to put on clothes",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        229
      ]
    },
    {
      "id": 5200,
      "bciAvId": 25437,
      "gloss": "cannula (with needle)",
      "glossSv": "kanyl",
      "pos": "noun",
      "explanation": "medical tube,catheter,cannula + needle",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        958,
        "/",
        468
      ]
    },
    {
      "id": 5201,
      "bciAvId": 25438,
      "gloss": "cardiovascular system",
      "glossSv": "hjärt- kärlsystem, kardiovaskulärt system",
      "pos": "noun",
      "explanation": "generalization + organ + heart",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        313,
        ";",
        97
      ]
    },
    {
      "id": 5202,
      "bciAvId": 25439,
      "gloss": "catheter (urine)",
      "glossSv": "kateter",
      "pos": "noun",
      "explanation": "medical tube,catheter,cannula + urine",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        958,
        "/",
        694,
        "/",
        349
      ]
    },
    {
      "id": 5203,
      "bciAvId": 25440,
      "gloss": "cellular fluid",
      "glossSv": "cellvätska",
      "pos": "noun",
      "explanation": "water,fluid,liquid + cell",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        748
      ]
    },
    {
      "id": 5204,
      "bciAvId": 25441,
      "gloss": "Christmas Eve (day)",
      "glossSv": "julafton (dag)",
      "pos": "noun",
      "explanation": "day + before + birth + cross,Christianity (in combinations): where birth + cross represents Christmas [contraction], i.e., the birth of Jesus Christ",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        158,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 5205,
      "bciAvId": 25442,
      "gloss": "Christmas Eve (evening)",
      "glossSv": "julafton (kväll)",
      "pos": "noun",
      "explanation": "evening + before + birth + cross,Christianity (in combinations): where birth + cross represents Christmas [contraction], i.e., the birth of Jesus Christ",
      "isCharacter": false,
      "composition": [
        298,
        "/",
        158,
        "/",
        166,
        "/",
        248
      ]
    },
    {
      "id": 5206,
      "bciAvId": 25443,
      "gloss": "circulatory system",
      "glossSv": "cirkulationssystem (kropp)",
      "pos": "noun",
      "explanation": "generalization + organ + rotation",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        887
      ]
    },
    {
      "id": 5207,
      "bciAvId": 25444,
      "gloss": "collarbone, clavicle",
      "glossSv": "nyckelben",
      "pos": "noun",
      "explanation": "bone + shoulder + in front of: A bone on the upper part of the front of the body, linking the scapula and sternum",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        589,
        "/",
        158
      ]
    },
    {
      "id": 5208,
      "bciAvId": 25445,
      "gloss": "day before holiday",
      "glossSv": "dag före röd dag, afton (dag)",
      "pos": "noun",
      "explanation": "day + before + holiday",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        158,
        "/",
        258,
        "/",
        562
      ]
    },
    {
      "id": 5209,
      "bciAvId": 25446,
      "gloss": "drug (leaf based)",
      "glossSv": "drog (av blad)",
      "pos": "noun",
      "explanation": "leaf + chemical product: where chemical product represents drug [contraction]: Leaves used as drugs",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        "RK:-2",
        "/",
        216
      ]
    },
    {
      "id": 5210,
      "bciAvId": 25447,
      "gloss": "earring",
      "glossSv": "örhänge(n)",
      "pos": "noun",
      "explanation": "jewelry + ear",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        278
      ]
    },
    {
      "id": 5211,
      "bciAvId": 25448,
      "gloss": "end of year",
      "glossSv": "årets slut, årsslut",
      "pos": "noun",
      "explanation": "end,arrival,stop + year",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        716
      ]
    },
    {
      "id": 5212,
      "bciAvId": 25449,
      "gloss": "endocrine system",
      "glossSv": "endokrint system, körtlar (kropp)",
      "pos": "noun",
      "explanation": "generalization + gland: The system involving the glands",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        "RK:-2",
        "/",
        216
      ]
    },
    {
      "id": 5213,
      "bciAvId": 25450,
      "gloss": "feeding tube",
      "glossSv": "sond (för mat)",
      "pos": "noun",
      "explanation": "medical tube,catheter,cannula + food",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        958,
        "/",
        329
      ]
    },
    {
      "id": 5214,
      "bciAvId": 25451,
      "gloss": "gastrointestinal system",
      "glossSv": "matsmältningssystem",
      "pos": "noun",
      "explanation": "generalization + organ + food",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        329
      ]
    },
    {
      "id": 5215,
      "bciAvId": 25452,
      "gloss": "gland",
      "glossSv": "körtel",
      "pos": "noun",
      "explanation": "organ + chemical product: organ that produces chemicals",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        "RK:-2",
        "/",
        216
      ]
    },
    {
      "id": 5216,
      "bciAvId": 25453,
      "gloss": "glitter",
      "glossSv": "glitter, strass",
      "pos": "noun",
      "explanation": "lump(s) + star: Small pieces that shine, like stars",
      "isCharacter": false,
      "composition": [
        777,
        "/",
        622
      ]
    },
    {
      "id": 5217,
      "bciAvId": 25454,
      "gloss": "to have a tea break, to have a coffee break",
      "glossSv": "fika (verb)",
      "pos": "action",
      "explanation": "rest period,break + drink + action indicator: The activity of having a break with beverage",
      "isCharacter": false,
      "composition": [
        426,
        ";",
        81,
        "/",
        562,
        "/",
        275
      ]
    },
    {
      "id": 5218,
      "bciAvId": 25455,
      "gloss": "heel (shoe)",
      "glossSv": "klack",
      "pos": "noun",
      "explanation": "protection + heel: combination of shoe and heel. The heel on the shoe",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        380
      ]
    },
    {
      "id": 5219,
      "bciAvId": 25456,
      "gloss": "high heeled shoes, high heels",
      "glossSv": "högklackade skor",
      "pos": "noun",
      "explanation": "heel (shoe) + high",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        380,
        "/",
        952
      ]
    },
    {
      "id": 5220,
      "bciAvId": 25457,
      "gloss": "humerus, upper arm bone",
      "glossSv": "överarmsben",
      "pos": "noun",
      "explanation": "bone + upper arm",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        132,
        "/",
        493
      ]
    },
    {
      "id": 5221,
      "bciAvId": 25459,
      "gloss": "insulin",
      "glossSv": "insulin",
      "pos": "noun",
      "explanation": "chemical product + cell + work: the chemical substance that regulates the oxidation of sugar, providing the energy needed for the cells to work",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        748,
        "/",
        711
      ]
    },
    {
      "id": 5222,
      "bciAvId": 25460,
      "gloss": "intestine(s), bowel(s), gut(s)",
      "glossSv": "tarm, tarmar",
      "pos": "noun",
      "explanation": "organ + food + tube",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        866
      ]
    },
    {
      "id": 5223,
      "bciAvId": 25461,
      "gloss": "large intestine",
      "glossSv": "tjocktarm",
      "pos": "noun",
      "explanation": "intestine(s),bowel(s),gut(s) + short: the shorter, but wider, part of the intestines",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        866,
        "/",
        965
      ]
    },
    {
      "id": 5224,
      "bciAvId": 25462,
      "gloss": "liver",
      "glossSv": "lever (kropp)",
      "pos": "noun",
      "explanation": "gland + group + action: a gland with many functions",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        368,
        "/",
        106
      ]
    },
    {
      "id": 5225,
      "bciAvId": 25463,
      "gloss": "lower arm",
      "glossSv": "underarm",
      "pos": "noun",
      "explanation": "arm + under",
      "isCharacter": false,
      "composition": [
        132,
        "/",
        676
      ]
    },
    {
      "id": 5226,
      "bciAvId": 25464,
      "gloss": "lower arm bone(s)",
      "glossSv": "underarmsben",
      "pos": "noun",
      "explanation": "bone + lower arm",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        132,
        "/",
        676
      ]
    },
    {
      "id": 5227,
      "bciAvId": 25465,
      "gloss": "lung(s)",
      "glossSv": "lunga, lungor",
      "pos": "noun",
      "explanation": "organ + breath: The major organ for breathing",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5228,
      "bciAvId": 25466,
      "gloss": "lymph",
      "glossSv": "lymfa",
      "pos": "noun",
      "explanation": "cellular fluid + protection",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        748,
        "/",
        548
      ]
    },
    {
      "id": 5229,
      "bciAvId": 25467,
      "gloss": "lymph node, lymph gland",
      "glossSv": "lymfkörtel",
      "pos": "noun",
      "explanation": "organ + lymph: where organ represents gland [contraction]",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        695,
        "/",
        748,
        "/",
        548
      ]
    },
    {
      "id": 5230,
      "bciAvId": 25468,
      "gloss": "lymphatic system",
      "glossSv": "lymfatiskt system",
      "pos": "noun",
      "explanation": "generalization + lymph",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        695,
        "/",
        748,
        "/",
        548
      ]
    },
    {
      "id": 5231,
      "bciAvId": 25469,
      "gloss": "medical tube, catheter, cannula",
      "glossSv": "kateter, kanyl, sond (etc)",
      "pos": "noun",
      "explanation": "tube + medical: a tube used for medical purposes. Add appropriate specifier when needed",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        958
      ]
    },
    {
      "id": 5232,
      "bciAvId": 25470,
      "gloss": "necklace",
      "glossSv": "halsband, halskedja",
      "pos": "noun",
      "explanation": "jewelry + neck",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        465
      ]
    },
    {
      "id": 5233,
      "bciAvId": 25471,
      "gloss": "nerve",
      "glossSv": "nerv",
      "pos": "noun",
      "explanation": "group of + neuron",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        748,
        "/",
        288
      ]
    },
    {
      "id": 5234,
      "bciAvId": 25472,
      "gloss": "nervous system",
      "glossSv": "nervsystem",
      "pos": "noun",
      "explanation": "generalization + neuron",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        748,
        "/",
        288
      ]
    },
    {
      "id": 5235,
      "bciAvId": 25473,
      "gloss": "neuron",
      "glossSv": "nervcell, neuron",
      "pos": "noun",
      "explanation": "cell + electricity",
      "isCharacter": false,
      "composition": [
        748,
        "/",
        288
      ]
    },
    {
      "id": 5236,
      "bciAvId": 25474,
      "gloss": "New Year (general)",
      "glossSv": "nyårsdag",
      "pos": "noun",
      "explanation": "day + beginning + year: First day of a new year (e.g. school, calendar)",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        159,
        "/",
        716
      ]
    },
    {
      "id": 5237,
      "bciAvId": 25475,
      "gloss": "New Year's eve (day)",
      "glossSv": "nyårsafton (dag)",
      "pos": "noun",
      "explanation": "day + before + birth + year: Day before the birth of a year",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        158,
        "/",
        166,
        "/",
        716
      ]
    },
    {
      "id": 5238,
      "bciAvId": 25476,
      "gloss": "New Year's eve (evening)",
      "glossSv": "nyårsafton (kväll)",
      "pos": "noun",
      "explanation": "evening + before + birth + year: Evening before the birth of a year",
      "isCharacter": false,
      "composition": [
        298,
        "/",
        158,
        "/",
        166,
        "/",
        716
      ]
    },
    {
      "id": 5239,
      "bciAvId": 25477,
      "gloss": "New Year's eve, end of year (day)",
      "glossSv": "nyårsafton, årets sista dag",
      "pos": "noun",
      "explanation": "day + end + year: Last day of a year",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        292,
        "/",
        716
      ]
    },
    {
      "id": 5240,
      "bciAvId": 25478,
      "gloss": "New Year's eve, end of year (evening)",
      "glossSv": "nyårssafton, årets sista kväll",
      "pos": "noun",
      "explanation": "evening + end + year: Last evening of a year",
      "isCharacter": false,
      "composition": [
        298,
        "/",
        292,
        "/",
        716
      ]
    },
    {
      "id": 5241,
      "bciAvId": 25479,
      "gloss": "oesophagus, esophagus, gullet",
      "glossSv": "matsrupe",
      "pos": "noun",
      "explanation": "organ + food + receive + tube: The food goes into the container (of the stomach) by a tube",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        920,
        "/",
        866
      ]
    },
    {
      "id": 5242,
      "bciAvId": 25481,
      "gloss": "pancreas",
      "glossSv": "bukspottkörtel",
      "pos": "noun",
      "explanation": "gland + insulin: The gland that produces insulin",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        748,
        "/",
        711
      ]
    },
    {
      "id": 5243,
      "bciAvId": 25482,
      "gloss": "to pierce (jewellery)",
      "glossSv": "pierca, ta hål (för smycke)",
      "pos": "action",
      "explanation": "through + jewelry + action indicator",
      "isCharacter": false,
      "composition": [
        653,
        ";",
        81,
        "/",
        348,
        "/",
        629,
        "/",
        622
      ]
    },
    {
      "id": 5244,
      "bciAvId": 25483,
      "gloss": "to pierce",
      "glossSv": "sticka igenom, genomborra",
      "pos": "action",
      "explanation": "through + knife + action indicator: The knife representing sharp. To penetrate with a sharp instrument",
      "isCharacter": false,
      "composition": [
        653,
        ";",
        81,
        "/",
        411
      ]
    },
    {
      "id": 5245,
      "bciAvId": 25484,
      "gloss": "piercing (thing)",
      "glossSv": "piercingsmycke",
      "pos": "noun",
      "explanation": "jewelry + through",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        653
      ]
    },
    {
      "id": 5246,
      "bciAvId": 25485,
      "gloss": "rectum",
      "glossSv": "ändtarm, rectum",
      "pos": "noun",
      "explanation": "intestine(s),bowel(s),gut(s) + waste",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        866,
        "/",
        694
      ]
    },
    {
      "id": 5247,
      "bciAvId": 25486,
      "gloss": "respiratory system",
      "glossSv": "andningssystem",
      "pos": "noun",
      "explanation": "generalization + lung(s)",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5248,
      "bciAvId": 25487,
      "gloss": "rib(s)",
      "glossSv": "revben (kropp)",
      "pos": "noun",
      "explanation": "bone + side (body)",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        592
      ]
    },
    {
      "id": 5249,
      "bciAvId": 25488,
      "gloss": "ring (finger)",
      "glossSv": "ring (finger)",
      "pos": "noun",
      "explanation": "jewelry + finger",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        629,
        "/",
        622,
        "/",
        318
      ]
    },
    {
      "id": 5250,
      "bciAvId": 25489,
      "gloss": "salivary gland",
      "glossSv": "spottkörtel",
      "pos": "noun",
      "explanation": "organ + saliva: Organ representing gland [contraction]. A gland that produces saliva",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        695,
        "/",
        457
      ]
    },
    {
      "id": 5251,
      "bciAvId": 25490,
      "gloss": "sequin(s), spangle(s)",
      "glossSv": "paljetter",
      "pos": "noun",
      "explanation": "glitter + cloth: Glitter attached to cloth",
      "isCharacter": false,
      "composition": [
        777,
        "/",
        622,
        "/",
        228
      ]
    },
    {
      "id": 5252,
      "bciAvId": 25491,
      "gloss": "shoulder blade, scapula",
      "glossSv": "skulderblad",
      "pos": "noun",
      "explanation": "bone + shoulder + behind",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        589,
        "/",
        109
      ]
    },
    {
      "id": 5253,
      "bciAvId": 25492,
      "gloss": "skull, cranium",
      "glossSv": "skalle, kranium",
      "pos": "noun",
      "explanation": "bone + head",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        376
      ]
    },
    {
      "id": 5254,
      "bciAvId": 25493,
      "gloss": "small intestine",
      "glossSv": "tunntarm",
      "pos": "noun",
      "explanation": "intestine(s),bowel(s),gut(s) + long: The longer, but thinner, part of the intestines",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        866,
        "/",
        420
      ]
    },
    {
      "id": 5255,
      "bciAvId": 25494,
      "gloss": "snuff (nose)",
      "glossSv": "snus (näsa), luktsnus",
      "pos": "noun",
      "explanation": "drug (leaf based) + nose: Leaf based drug that is taken through the nose",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        473
      ]
    },
    {
      "id": 5256,
      "bciAvId": 25495,
      "gloss": "snuff, kat, coca",
      "glossSv": "snus (etc)",
      "pos": "noun",
      "explanation": "drug (leaf based) + mouth: Leaf based drug that is taken through the mouth",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        457
      ]
    },
    {
      "id": 5257,
      "bciAvId": 25496,
      "gloss": "spleen",
      "glossSv": "mjälte",
      "pos": "noun",
      "explanation": "gland + blood: Gland that assists in production of blood cells",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        695,
        "/",
        423
      ]
    },
    {
      "id": 5258,
      "bciAvId": 25497,
      "gloss": "stoma, medical hole",
      "glossSv": "stoma, medicinskt hål",
      "pos": "noun",
      "explanation": "hole + medical",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        958
      ]
    },
    {
      "id": 5259,
      "bciAvId": 25498,
      "gloss": "stomach, tummy, tum",
      "glossSv": "magsäck",
      "pos": "noun",
      "explanation": "organ + food + container",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        239
      ]
    },
    {
      "id": 5260,
      "bciAvId": 25499,
      "gloss": "tattoo (permanent)",
      "glossSv": "tatuering (permanent)",
      "pos": "noun",
      "explanation": "picture + body + needle: where picture + body represents tattoo [contraction], tattoo made with needle",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        171,
        "/",
        468
      ]
    },
    {
      "id": 5261,
      "bciAvId": 25500,
      "gloss": "tattoo (sticker)",
      "glossSv": "tatuering (klisterbild)",
      "pos": "noun",
      "explanation": "picture + body + attachment: where picture + body represents tattoo [contraction], tattoo made from a sticker",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        171,
        "/",
        823
      ]
    },
    {
      "id": 5262,
      "bciAvId": 25501,
      "gloss": "tattoo, picture on skin",
      "glossSv": "tatuering, bild på hud",
      "pos": "noun",
      "explanation": "picture + skin",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 5263,
      "bciAvId": 25502,
      "gloss": "tea break, coffee break",
      "glossSv": "fikapaus",
      "pos": "noun",
      "explanation": "rest period,break + drink: A break to have a non alcoholic drink",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        562,
        "/",
        275
      ]
    },
    {
      "id": 5264,
      "bciAvId": 25503,
      "gloss": "tendon",
      "glossSv": "sena (kropp)",
      "pos": "noun",
      "explanation": "linear thing + muscle + bone: A cord or band of inelastic tissue that connects bones and muscles with each other",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        718,
        "/",
        172
      ]
    },
    {
      "id": 5265,
      "bciAvId": 25504,
      "gloss": "tissue (body)",
      "glossSv": "vävnad (kropp)",
      "pos": "noun",
      "explanation": "group of + cell: An aggregation of cells forms a tissue",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        748
      ]
    },
    {
      "id": 5266,
      "bciAvId": 25505,
      "gloss": "trachea, wind pipe",
      "glossSv": "luftstrupe, luftrör, trakea",
      "pos": "noun",
      "explanation": "lung(s) + tube: The tube that transports the air to and from the lungs",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        473,
        "/",
        457,
        "/",
        866
      ]
    },
    {
      "id": 5267,
      "bciAvId": 25506,
      "gloss": "tracheotomy tube, tracheal tube",
      "glossSv": "trakealtub",
      "pos": "noun",
      "explanation": "medical tube,catheter,cannula + breath: A catheter inserted directly into trachea to help a person to breathe",
      "isCharacter": false,
      "composition": [
        866,
        "/",
        958,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 5268,
      "bciAvId": 25507,
      "gloss": "upper arm",
      "glossSv": "överarm",
      "pos": "noun",
      "explanation": "arm + above",
      "isCharacter": false,
      "composition": [
        132,
        "/",
        493
      ]
    },
    {
      "id": 5269,
      "bciAvId": 25508,
      "gloss": "vascular system",
      "glossSv": "vaskulärt system, kärlsystem",
      "pos": "noun",
      "explanation": "generalization + organ + blood",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        695,
        "/",
        423
      ]
    },
    {
      "id": 5270,
      "bciAvId": 25509,
      "gloss": "work day",
      "glossSv": "arbetsdag, vardag",
      "pos": "noun",
      "explanation": "day + work: all days except weekend",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        711
      ]
    },
    {
      "id": 5271,
      "bciAvId": 25650,
      "gloss": "actor",
      "glossSv": "skådespelare",
      "pos": "person",
      "explanation": "person + play (theatre)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        497,
        "/",
        457
      ]
    },
    {
      "id": 5272,
      "bciAvId": 25651,
      "gloss": "Alice (in Wonderland)",
      "glossSv": "Alice i Underlandet",
      "pos": "person",
      "explanation": "bliss-name + girl + curiosity,curiousness,inquisitiveness",
      "isCharacter": false,
      "composition": [
        753,
        "/",
        351,
        "/",
        930,
        "/",
        412
      ]
    },
    {
      "id": 5273,
      "bciAvId": 25652,
      "gloss": "altruism, selflessness",
      "glossSv": "osjälviskhet, altruism",
      "pos": "noun",
      "explanation": "give,offer,provide-(to) + consideration,thoughtfulness",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        938
      ]
    },
    {
      "id": 5274,
      "bciAvId": 25653,
      "gloss": "among, amongst",
      "glossSv": "bland",
      "pos": "expression",
      "explanation": "between + many",
      "isCharacter": false,
      "composition": [
        162,
        "/",
        368
      ]
    },
    {
      "id": 5275,
      "bciAvId": 25654,
      "gloss": "artist",
      "glossSv": "kostnär",
      "pos": "person",
      "explanation": "person + art",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 5276,
      "bciAvId": 25655,
      "gloss": "baguette",
      "glossSv": "baguette",
      "pos": "noun",
      "explanation": "bread + long",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        420
      ]
    },
    {
      "id": 5277,
      "bciAvId": 25656,
      "gloss": "baking powder",
      "glossSv": "bakpulver",
      "pos": "noun",
      "explanation": "powder + bun + up",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        570,
        "/",
        678
      ]
    },
    {
      "id": 5278,
      "bciAvId": 25657,
      "gloss": "ballot, voting slip",
      "glossSv": "valsedel",
      "pos": "noun",
      "explanation": "paper,card,page + choice,selection,election",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        223
      ]
    },
    {
      "id": 5279,
      "bciAvId": 25658,
      "gloss": "barn",
      "glossSv": "lada",
      "pos": "noun",
      "explanation": "house + grain",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        357
      ]
    },
    {
      "id": 5280,
      "bciAvId": 25659,
      "gloss": "bird nest, birdnest",
      "glossSv": "fågelbo",
      "pos": "noun",
      "explanation": "container + bird + egg",
      "isCharacter": false,
      "composition": [
        239,
        "/",
        163,
        "/",
        285
      ]
    },
    {
      "id": 5281,
      "bciAvId": 25660,
      "gloss": "birdhouse, house for bird",
      "glossSv": "fågelholk",
      "pos": "noun",
      "explanation": "house + bird",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        163
      ]
    },
    {
      "id": 5282,
      "bciAvId": 25661,
      "gloss": "blog, web blog",
      "glossSv": "blogg",
      "pos": "noun",
      "explanation": "book + day + digits (computer)",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        258,
        "/",
        829
      ]
    },
    {
      "id": 5283,
      "bciAvId": 25662,
      "gloss": "boar",
      "glossSv": "galt",
      "pos": "noun",
      "explanation": "pig + male",
      "isCharacter": false,
      "composition": [
        521,
        "/",
        106
      ]
    },
    {
      "id": 5284,
      "bciAvId": 25663,
      "gloss": "boyfriend",
      "glossSv": "pojkvän",
      "pos": "person",
      "explanation": "man + love",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        431
      ]
    },
    {
      "id": 5285,
      "bciAvId": 25664,
      "gloss": "bread (sliced), sliced bread",
      "glossSv": "bröd (skivat), skuret bröd",
      "pos": "noun",
      "explanation": "bread + knife: bread cut into slices",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        411
      ]
    },
    {
      "id": 5286,
      "bciAvId": 25665,
      "gloss": "bread crust",
      "glossSv": "brödskorpa",
      "pos": "noun",
      "explanation": "crust + bread",
      "isCharacter": false,
      "composition": [
        588,
        "/",
        180
      ]
    },
    {
      "id": 5287,
      "bciAvId": 25666,
      "gloss": "bread knife",
      "glossSv": "brödkniv",
      "pos": "noun",
      "explanation": "knife + bread",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        180
      ]
    },
    {
      "id": 5288,
      "bciAvId": 25667,
      "gloss": "bread with fruit",
      "glossSv": "bröd med frukt",
      "pos": "noun",
      "explanation": "bread + fruit",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        338
      ]
    },
    {
      "id": 5289,
      "bciAvId": 25668,
      "gloss": "bread with seeds",
      "glossSv": "bröd med frön",
      "pos": "noun",
      "explanation": "bread + seed",
      "isCharacter": false,
      "composition": [
        180,
        "/",
        584
      ]
    },
    {
      "id": 5290,
      "bciAvId": 25669,
      "gloss": "brother-in-law (husband's brother)",
      "glossSv": "svåger (makens bror)",
      "pos": "person",
      "explanation": "brother + husband",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        11,
        "/",
        393
      ]
    },
    {
      "id": 5291,
      "bciAvId": 25670,
      "gloss": "brother-in-law (partner's brother)",
      "glossSv": "svåger (partners bror)",
      "pos": "person",
      "explanation": "brother + spouse",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        11,
        "/",
        616
      ]
    },
    {
      "id": 5292,
      "bciAvId": 25671,
      "gloss": "brother-in-law (wife's brother)",
      "glossSv": "svåger (makas bror)",
      "pos": "person",
      "explanation": "brother + wife",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        11,
        "/",
        704
      ]
    },
    {
      "id": 5293,
      "bciAvId": 25672,
      "gloss": "bun (soft), roll (soft), scone, brioche",
      "glossSv": "bulle (mjuk yta), scones, brioche",
      "pos": "noun",
      "explanation": "roll + imprint,depression: where imprint,depression represents soft [contraction]",
      "isCharacter": false,
      "composition": [
        570,
        "/",
        1049
      ]
    },
    {
      "id": 5294,
      "bciAvId": 25673,
      "gloss": "business idea",
      "glossSv": "affärsidé",
      "pos": "noun",
      "explanation": "idea + business",
      "isCharacter": false,
      "composition": [
        397,
        "/",
        191
      ]
    },
    {
      "id": 5295,
      "bciAvId": 25674,
      "gloss": "cactus",
      "glossSv": "kaktus",
      "pos": "noun",
      "explanation": "plant + quill(s),spine(s)",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        845
      ]
    },
    {
      "id": 5296,
      "bciAvId": 25675,
      "gloss": "chat (online)",
      "glossSv": "chat (online)",
      "pos": "noun",
      "explanation": "talk + back and forth + digits (computer)",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        144,
        "/",
        829
      ]
    },
    {
      "id": 5297,
      "bciAvId": 25676,
      "gloss": "to chat (online)",
      "glossSv": "chatta (online)",
      "pos": "action",
      "explanation": "chat (online) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        144,
        "/",
        829
      ]
    },
    {
      "id": 5298,
      "bciAvId": 25677,
      "gloss": "to cheat",
      "glossSv": "fuska, lura, luras",
      "pos": "action",
      "explanation": "cheating + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 5299,
      "bciAvId": 25678,
      "gloss": "cheating",
      "glossSv": "fusk, lurendrejeri",
      "pos": "noun",
      "explanation": "activity + without + truth",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 5300,
      "bciAvId": 25679,
      "gloss": "chick",
      "glossSv": "kyckling",
      "pos": "noun",
      "explanation": "chicken (bird) + child",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        329,
        "/",
        220
      ]
    },
    {
      "id": 5301,
      "bciAvId": 25680,
      "gloss": "classmate",
      "glossSv": "klasskamrat",
      "pos": "person",
      "explanation": "person + equal + classroom [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        578,
        "/",
        572,
        "/",
        412
      ]
    },
    {
      "id": 5302,
      "bciAvId": 25682,
      "gloss": "client, customer",
      "glossSv": "kund, klient",
      "pos": "person",
      "explanation": "person + give + help",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        382
      ]
    },
    {
      "id": 5303,
      "bciAvId": 25683,
      "gloss": "colleague",
      "glossSv": "kollega, arbetskamrat",
      "pos": "person",
      "explanation": "person + equal + work",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        578,
        "/",
        711
      ]
    },
    {
      "id": 5304,
      "bciAvId": 25684,
      "gloss": "combine harvester",
      "glossSv": "skördetröska",
      "pos": "noun",
      "explanation": "machine + knife + grain",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        411,
        "/",
        357
      ]
    },
    {
      "id": 5305,
      "bciAvId": 25685,
      "gloss": "compass (drawing)",
      "glossSv": "passare",
      "pos": "noun",
      "explanation": "tool + circle",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        651,
        "/",
        636
      ]
    },
    {
      "id": 5306,
      "bciAvId": 25686,
      "gloss": "cone, conifer cone, strobilus",
      "glossSv": "kotte",
      "pos": "noun",
      "explanation": "fruit + evergreen tree,spruce,fir,fir tree",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        300
      ]
    },
    {
      "id": 5307,
      "bciAvId": 25687,
      "gloss": "core activity",
      "glossSv": "kärnverksamhet",
      "pos": "noun",
      "explanation": "activity + middle",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        446
      ]
    },
    {
      "id": 5308,
      "bciAvId": 25688,
      "gloss": "cowshed",
      "glossSv": "kostall, ladugård",
      "pos": "noun",
      "explanation": "house + animal (bovine,ovine),bovid,bovine",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        123
      ]
    },
    {
      "id": 5309,
      "bciAvId": 25689,
      "gloss": "daughter-in-law",
      "glossSv": "svärdotter",
      "pos": "person",
      "explanation": "wife + offspring,child",
      "isCharacter": false,
      "composition": [
        704,
        "/",
        479
      ]
    },
    {
      "id": 5310,
      "bciAvId": 25690,
      "gloss": "definition",
      "glossSv": "definition, precisering",
      "pos": "noun",
      "explanation": "explanation + meaning",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1103,
        "/",
        440
      ]
    },
    {
      "id": 5311,
      "bciAvId": 25691,
      "gloss": "dice, die",
      "glossSv": "tärning",
      "pos": "noun",
      "explanation": "block,brick + number",
      "isCharacter": false,
      "composition": [
        168,
        "/",
        478
      ]
    },
    {
      "id": 5312,
      "bciAvId": 25692,
      "gloss": "dichotomy, duality",
      "glossSv": "dikotomi",
      "pos": "noun",
      "explanation": "mind + division + 2",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        502,
        "/",
        11
      ]
    },
    {
      "id": 5313,
      "bciAvId": 25693,
      "gloss": "dictator",
      "glossSv": "diktator",
      "pos": "person",
      "explanation": "leader + dictatorship (country)",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        243,
        "/",
        960,
        "/",
        449,
        "/",
        223
      ]
    },
    {
      "id": 5314,
      "bciAvId": 25694,
      "gloss": "dictatorship (country)",
      "glossSv": "diktatur",
      "pos": "noun",
      "explanation": "country + decide + without + choice",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        960,
        "/",
        449,
        "/",
        223
      ]
    },
    {
      "id": 5315,
      "bciAvId": 25695,
      "gloss": "dilemma",
      "glossSv": "dilemma, villrådighet",
      "pos": "noun",
      "explanation": "question + difficult + choice",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        940,
        "/",
        223
      ]
    },
    {
      "id": 5316,
      "bciAvId": 25696,
      "gloss": "doll pram, doll carriage",
      "glossSv": "dockvagn",
      "pos": "noun",
      "explanation": "wagon,cart,truck + doll: a combination of baby carriage,buggy,pram,pushchair,stroller and doll",
      "isCharacter": false,
      "composition": [
        689,
        "/",
        220,
        "/",
        840
      ]
    },
    {
      "id": 5317,
      "bciAvId": 25697,
      "gloss": "dollhouse, doll house",
      "glossSv": "dockskåp",
      "pos": "noun",
      "explanation": "house + doll",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        220,
        "/",
        840
      ]
    },
    {
      "id": 5318,
      "bciAvId": 25698,
      "gloss": "domestic science, home economics",
      "glossSv": "hushållsvetenskap",
      "pos": "noun",
      "explanation": "science + house work,housekeeping,housework",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        711,
        "/",
        392
      ]
    },
    {
      "id": 5319,
      "bciAvId": 25699,
      "gloss": "domestic science, home economics (class)",
      "glossSv": "hemkunskap",
      "pos": "noun",
      "explanation": "class [contraction] + house work,housekeeping,housework",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        711,
        "/",
        392
      ]
    },
    {
      "id": 5320,
      "bciAvId": 25700,
      "gloss": "dormouse (sleepy rodent)",
      "glossSv": "hasselmus, sovmus",
      "pos": "noun",
      "explanation": "rodent + sleep",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        599
      ]
    },
    {
      "id": 5321,
      "bciAvId": 25701,
      "gloss": "drop",
      "glossSv": "droppe",
      "pos": "noun",
      "explanation": "dot + water,fluid,liquid",
      "isCharacter": false,
      "composition": [
        270,
        "/",
        695
      ]
    },
    {
      "id": 5322,
      "bciAvId": 25702,
      "gloss": "employed, working",
      "glossSv": "anställd, arbetande",
      "pos": "description",
      "explanation": "work + description indicator",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        86
      ]
    },
    {
      "id": 5323,
      "bciAvId": 25703,
      "gloss": "employee",
      "glossSv": "antälld (person)",
      "pos": "person",
      "explanation": "person + work + agreement",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        497,
        "/",
        113
      ]
    },
    {
      "id": 5324,
      "bciAvId": 25704,
      "gloss": "equilateral triangle",
      "glossSv": "triangel (liksidig), liksidig triangel",
      "pos": "noun",
      "explanation": "triangle + 3 + equal,same",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        247,
        "/",
        12,
        "/",
        578
      ]
    },
    {
      "id": 5325,
      "bciAvId": 25705,
      "gloss": "ewe",
      "glossSv": "tacka (djur)",
      "pos": "noun",
      "explanation": "sheep + female",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        228,
        "/",
        314
      ]
    },
    {
      "id": 5326,
      "bciAvId": 25706,
      "gloss": "even number",
      "glossSv": "jämnt tal, jämn siffra, jämnt antal",
      "pos": "noun",
      "explanation": "number + multiplication + 2: a number which can be divided evenly into groups of two",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        459,
        "/",
        11
      ]
    },
    {
      "id": 5327,
      "bciAvId": 25707,
      "gloss": "excavator, digger, power shovel",
      "glossSv": "grävmaskin, grävskopa",
      "pos": "noun",
      "explanation": "machine + digging,excavation",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        1024
      ]
    },
    {
      "id": 5328,
      "bciAvId": 25708,
      "gloss": "experience",
      "glossSv": "erfarenhet",
      "pos": "noun",
      "explanation": "knowledge + activity + self",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        106,
        "/",
        2343
      ]
    },
    {
      "id": 5329,
      "bciAvId": 25709,
      "gloss": "explanation, reason",
      "glossSv": "förklaring, skäl",
      "pos": "noun",
      "explanation": "mouth + understanding,comprehension: something said to make something understood",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        1103
      ]
    },
    {
      "id": 5330,
      "bciAvId": 25714,
      "gloss": "farmhouse",
      "glossSv": "bondgård",
      "pos": "noun",
      "explanation": "house + farm",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        311
      ]
    },
    {
      "id": 5331,
      "bciAvId": 25715,
      "gloss": "father-in-law (partner's father)",
      "glossSv": "svärfar",
      "pos": "person",
      "explanation": "father + spouse",
      "isCharacter": false,
      "composition": [
        312,
        "/",
        616
      ]
    },
    {
      "id": 5332,
      "bciAvId": 25716,
      "gloss": "female friend",
      "glossSv": "vän (kvinnlig)",
      "pos": "person",
      "explanation": "woman + friend",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 5333,
      "bciAvId": 25717,
      "gloss": "flower meadow",
      "glossSv": "blomsteräng",
      "pos": "noun",
      "explanation": "meadow + flower",
      "isCharacter": false,
      "composition": [
        415,
        "/",
        325
      ]
    },
    {
      "id": 5334,
      "bciAvId": 25718,
      "gloss": "to get engaged",
      "glossSv": "förlova sig",
      "pos": "action",
      "explanation": "engagement + action indicator",
      "isCharacter": false,
      "composition": [
        158,
        "/",
        437,
        ";",
        81
      ]
    },
    {
      "id": 5335,
      "bciAvId": 25719,
      "gloss": "girlfriend",
      "glossSv": "flickvän",
      "pos": "person",
      "explanation": "woman + love",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        431
      ]
    },
    {
      "id": 5336,
      "bciAvId": 25720,
      "gloss": "grandchild",
      "glossSv": "barnbarn",
      "pos": "person",
      "explanation": "child + grandparents",
      "isCharacter": false,
      "composition": [
        220,
        "/",
        364
      ]
    },
    {
      "id": 5337,
      "bciAvId": 25721,
      "gloss": "to graze",
      "glossSv": "beta",
      "pos": "action",
      "explanation": "eat + grass + action Indicator",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        81,
        "/",
        366
      ]
    },
    {
      "id": 5338,
      "bciAvId": 25722,
      "gloss": "to handcraft, to craft",
      "glossSv": "slöjda, pyssla, tillverka för hand",
      "pos": "action",
      "explanation": "handicraft + action Indicator",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 5339,
      "bciAvId": 25723,
      "gloss": "handmade figure, handicraft (animal)",
      "glossSv": "handgjord sak (djur)",
      "pos": "noun",
      "explanation": "handmade object,handicraft + animal",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        122
      ]
    },
    {
      "id": 5340,
      "bciAvId": 25724,
      "gloss": "handmade figure, handicraft (person)",
      "glossSv": "handgjord sak (figur)",
      "pos": "noun",
      "explanation": "handmade object,handicraft + person",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        374,
        "/",
        513
      ]
    },
    {
      "id": 5341,
      "bciAvId": 25725,
      "gloss": "hare",
      "glossSv": "hare",
      "pos": "noun",
      "explanation": "rodent + ear + big",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        644,
        "/",
        278,
        "/",
        936
      ]
    },
    {
      "id": 5342,
      "bciAvId": 25726,
      "gloss": "height, altitude",
      "glossSv": "höjd, altitud",
      "pos": "noun",
      "explanation": "scale,measurement + height,altitude",
      "isCharacter": false,
      "composition": [
        927,
        "/",
        952
      ]
    },
    {
      "id": 5343,
      "bciAvId": 25727,
      "gloss": "hen",
      "glossSv": "höna",
      "pos": "noun",
      "explanation": "chicken (bird) + female",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        329,
        "/",
        314
      ]
    },
    {
      "id": 5344,
      "bciAvId": 25728,
      "gloss": "henhouse, chicken coop",
      "glossSv": "hönshus",
      "pos": "noun",
      "explanation": "house + chicken (bird)",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        163,
        "/",
        329
      ]
    },
    {
      "id": 5345,
      "bciAvId": 25729,
      "gloss": "home worker",
      "glossSv": "person som arbetar hemifrån",
      "pos": "person",
      "explanation": "person + work + money + house",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        451,
        "/",
        392
      ]
    },
    {
      "id": 5346,
      "bciAvId": 25730,
      "gloss": "to housekeep, to housework",
      "glossSv": "arbeta i hushållet",
      "pos": "action",
      "explanation": "house work,housekeeping,housework + action indicator",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81,
        "/",
        392
      ]
    },
    {
      "id": 5347,
      "bciAvId": 25731,
      "gloss": "housekeeper",
      "glossSv": "hushållsarbetare",
      "pos": "person",
      "explanation": "person + house work,housekeeping,housework",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        392
      ]
    },
    {
      "id": 5348,
      "bciAvId": 25732,
      "gloss": "ice layer",
      "glossSv": "islager",
      "pos": "noun",
      "explanation": "layer,level + ice",
      "isCharacter": false,
      "composition": [
        1116,
        "/",
        394
      ]
    },
    {
      "id": 5349,
      "bciAvId": 25733,
      "gloss": "ice skating rink (indoor)",
      "glossSv": "ishall",
      "pos": "noun",
      "explanation": "house + ice skates: ice skates representing skating [contraction]",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        396
      ]
    },
    {
      "id": 5350,
      "bciAvId": 25734,
      "gloss": "icing",
      "glossSv": "glasyr",
      "pos": "noun",
      "explanation": "spread,paste + powdered sugar,icing sugar",
      "isCharacter": false,
      "composition": [
        617,
        "/",
        107,
        ";",
        97,
        "/",
        678,
        "/",
        544
      ]
    },
    {
      "id": 5351,
      "bciAvId": 25735,
      "gloss": "influence",
      "glossSv": "inflytande, påverkan",
      "pos": "noun",
      "explanation": "cause + change,alteration",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        213
      ]
    },
    {
      "id": 5352,
      "bciAvId": 25736,
      "gloss": "to influence, to affect",
      "glossSv": "ha inflytande, påverka",
      "pos": "action",
      "explanation": "influence + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        213
      ]
    },
    {
      "id": 5353,
      "bciAvId": 25737,
      "gloss": "influenced, affected",
      "glossSv": "influerad, påverkad",
      "pos": "description",
      "explanation": "influence + description indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        86,
        "/",
        213
      ]
    },
    {
      "id": 5354,
      "bciAvId": 25738,
      "gloss": "inspiration",
      "glossSv": "inspiration",
      "pos": "noun",
      "explanation": "cause + want,desire + activity",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        313,
        "/",
        319,
        "/",
        106
      ]
    },
    {
      "id": 5355,
      "bciAvId": 25739,
      "gloss": "to inspire",
      "glossSv": "inspirera",
      "pos": "action",
      "explanation": "inspiration + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        319,
        "/",
        106
      ]
    },
    {
      "id": 5356,
      "bciAvId": 25740,
      "gloss": "inspired",
      "glossSv": "inspirerad",
      "pos": "description",
      "explanation": "inspiration + description indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        86,
        "/",
        313,
        "/",
        319,
        "/",
        106
      ]
    },
    {
      "id": 5357,
      "bciAvId": 25741,
      "gloss": "to interrupt (in conversation)",
      "glossSv": "avbryta (tal)",
      "pos": "action",
      "explanation": "interruption (in conversation) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        104
      ]
    },
    {
      "id": 5358,
      "bciAvId": 25742,
      "gloss": "interruption (in conversation)",
      "glossSv": "avbrytande (tal)",
      "pos": "noun",
      "explanation": "say,speak,talk,tell,express-(to) + across",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        104
      ]
    },
    {
      "id": 5359,
      "bciAvId": 25743,
      "gloss": "intuition",
      "glossSv": "intuition",
      "pos": "noun",
      "explanation": "knowledge + inside",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        398
      ]
    },
    {
      "id": 5360,
      "bciAvId": 25744,
      "gloss": "isosceles triangle",
      "glossSv": "triangel (likbent), likbent triangel",
      "pos": "noun",
      "explanation": "triangle + 2 + same,equal,equality",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        247,
        "/",
        11,
        "/",
        578
      ]
    },
    {
      "id": 5361,
      "bciAvId": 25745,
      "gloss": "jobcentre, job-centre",
      "glossSv": "arbetsförmedling, jobbcenter",
      "pos": "noun",
      "explanation": "house + exchange + work",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        1029,
        "/",
        711
      ]
    },
    {
      "id": 5362,
      "bciAvId": 25746,
      "gloss": "knight",
      "glossSv": "riddare",
      "pos": "person",
      "explanation": "person + shield + knife,sword",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        146,
        "/",
        411
      ]
    },
    {
      "id": 5363,
      "bciAvId": 25747,
      "gloss": "lawn mower, mower",
      "glossSv": "gräsklippare",
      "pos": "noun",
      "explanation": "machine + to cut + grass",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        411,
        "/",
        366
      ]
    },
    {
      "id": 5364,
      "bciAvId": 25749,
      "gloss": "to long for, to yearn",
      "glossSv": "längta",
      "pos": "action",
      "explanation": "longing,yearning + action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        319,
        "/",
        401
      ]
    },
    {
      "id": 5365,
      "bciAvId": 25750,
      "gloss": "longing, yearning",
      "glossSv": "längtan",
      "pos": "noun",
      "explanation": "want,desire + intensity",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        319,
        "/",
        401
      ]
    },
    {
      "id": 5366,
      "bciAvId": 25751,
      "gloss": "to make cheese",
      "glossSv": "ysta",
      "pos": "action",
      "explanation": "to make + cheese",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        81,
        "/",
        215
      ]
    },
    {
      "id": 5367,
      "bciAvId": 25752,
      "gloss": "male friend",
      "glossSv": "vän (manlig)",
      "pos": "person",
      "explanation": "man + friend",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 5368,
      "bciAvId": 25753,
      "gloss": "married (to be)",
      "glossSv": "gift (äktenskap)",
      "pos": "description",
      "explanation": "marriage + description indicator",
      "isCharacter": false,
      "composition": [
        437,
        ";",
        86
      ]
    },
    {
      "id": 5369,
      "bciAvId": 25754,
      "gloss": "measuring cup",
      "glossSv": "mått (kopp)",
      "pos": "noun",
      "explanation": "mug,cup + measurement,measure",
      "isCharacter": false,
      "composition": [
        251,
        "/",
        441
      ]
    },
    {
      "id": 5370,
      "bciAvId": 25755,
      "gloss": "to mislead",
      "glossSv": "vilseleda, förvilla",
      "pos": "action",
      "explanation": "to lead + without + truth + action indicator",
      "isCharacter": false,
      "composition": [
        803,
        ";",
        81,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 5371,
      "bciAvId": 25756,
      "gloss": "molasses, dark syrup, black treacle",
      "glossSv": "sirap (mörk), mörk sirap, melass",
      "pos": "noun",
      "explanation": "syrup [contraction] + dark + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        695,
        "/",
        678,
        "/",
        449,
        "/",
        424
      ]
    },
    {
      "id": 5372,
      "bciAvId": 25757,
      "gloss": "mother-in-law (partner's mother)",
      "glossSv": "svärmor",
      "pos": "person",
      "explanation": "mother + spouse",
      "isCharacter": false,
      "composition": [
        455,
        "/",
        616
      ]
    },
    {
      "id": 5373,
      "bciAvId": 25758,
      "gloss": "to motivate",
      "glossSv": "motivera",
      "pos": "action",
      "explanation": "motivation + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 5374,
      "bciAvId": 25759,
      "gloss": "motivated",
      "glossSv": "motverad",
      "pos": "description",
      "explanation": "motivation + description indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        86,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 5375,
      "bciAvId": 25760,
      "gloss": "motivation",
      "glossSv": "motivation",
      "pos": "noun",
      "explanation": "cause + feeling + activity",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 5376,
      "bciAvId": 25761,
      "gloss": "odd number",
      "glossSv": "udda tal, udda siffra, udda antal",
      "pos": "noun",
      "explanation": "number + multiplication + 2 + plus + 1: a number which cannot be divided evenly into groups of two",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        459,
        "/",
        11,
        "/",
        120,
        "/",
        10
      ]
    },
    {
      "id": 5377,
      "bciAvId": 25762,
      "gloss": "partner (game, dancing, business)",
      "glossSv": "partner (spel, dans, affärer)",
      "pos": "person",
      "explanation": "person + together + person",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        823,
        "/",
        513
      ]
    },
    {
      "id": 5378,
      "bciAvId": 25763,
      "gloss": "pasture",
      "glossSv": "betesmark",
      "pos": "noun",
      "explanation": "meadow + animal",
      "isCharacter": false,
      "composition": [
        415,
        "/",
        122
      ]
    },
    {
      "id": 5379,
      "bciAvId": 25764,
      "gloss": "to pasture, to put out to pasture",
      "glossSv": "släppa på bete",
      "pos": "action",
      "explanation": "pasture + action indicator",
      "isCharacter": false,
      "composition": [
        415,
        ";",
        81,
        "/",
        122
      ]
    },
    {
      "id": 5380,
      "bciAvId": 25765,
      "gloss": "patient, enduring",
      "glossSv": "tålmodig",
      "pos": "description",
      "explanation": "patience + description indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        86,
        "/",
        292,
        "/",
        426
      ]
    },
    {
      "id": 5381,
      "bciAvId": 25766,
      "gloss": "patient (in medical care)",
      "glossSv": "patient",
      "pos": "person",
      "explanation": "person + get + medicine,medical practice: where medicine represents medical treatment,medical care [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        958
      ]
    },
    {
      "id": 5382,
      "bciAvId": 25767,
      "gloss": "pig (wild), boar (wild)",
      "glossSv": "vildsvin",
      "pos": "noun",
      "explanation": "pig + open: where open represents wild",
      "isCharacter": false,
      "composition": [
        521,
        "/",
        484
      ]
    },
    {
      "id": 5383,
      "bciAvId": 25768,
      "gloss": "piggery",
      "glossSv": "svinstia, svinstall",
      "pos": "noun",
      "explanation": "house + pig",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        521
      ]
    },
    {
      "id": 5384,
      "bciAvId": 25769,
      "gloss": "piglet",
      "glossSv": "griskulting",
      "pos": "noun",
      "explanation": "pig + child",
      "isCharacter": false,
      "composition": [
        521,
        "/",
        220
      ]
    },
    {
      "id": 5385,
      "bciAvId": 25770,
      "gloss": "playhouse, play house",
      "glossSv": "lekstuga",
      "pos": "noun",
      "explanation": "house + play [contraction]",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 5386,
      "bciAvId": 25771,
      "gloss": "powdered sugar, icing sugar",
      "glossSv": "florsocker",
      "pos": "noun",
      "explanation": "sugar [contraction] + powder + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        678,
        "/",
        544
      ]
    },
    {
      "id": 5387,
      "bciAvId": 25772,
      "gloss": "principal, headteacher",
      "glossSv": "rektor",
      "pos": "person",
      "explanation": "leader + school [contraction]",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 5388,
      "bciAvId": 25773,
      "gloss": "prize, award, trophy",
      "glossSv": "pris (tävling), pokal, buckla",
      "pos": "noun",
      "explanation": "thing + win-(to)",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        554,
        "/",
        107
      ]
    },
    {
      "id": 5389,
      "bciAvId": 25774,
      "gloss": "publication",
      "glossSv": "publikation, edition",
      "pos": "noun",
      "explanation": "giving + dispersion,dissemination,scattering,spread,spreading",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        941
      ]
    },
    {
      "id": 5390,
      "bciAvId": 25775,
      "gloss": "to publish",
      "glossSv": "publicera, förlägga, ge ut (skrift)",
      "pos": "action",
      "explanation": "publication + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        941
      ]
    },
    {
      "id": 5391,
      "bciAvId": 25776,
      "gloss": "publisher",
      "glossSv": "förläggare, utgivare",
      "pos": "person",
      "explanation": "person + publication",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        949,
        "/",
        941
      ]
    },
    {
      "id": 5392,
      "bciAvId": 25778,
      "gloss": "ram",
      "glossSv": "bagge",
      "pos": "noun",
      "explanation": "sheep + male",
      "isCharacter": false,
      "composition": [
        123,
        "/",
        228,
        "/",
        106
      ]
    },
    {
      "id": 5393,
      "bciAvId": 25780,
      "gloss": "rescue",
      "glossSv": "räddning, undsättning",
      "pos": "noun",
      "explanation": "help + danger",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        256
      ]
    },
    {
      "id": 5394,
      "bciAvId": 25781,
      "gloss": "to rescue",
      "glossSv": "rädda, undsätta",
      "pos": "action",
      "explanation": "rescue + action indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        81,
        "/",
        256
      ]
    },
    {
      "id": 5395,
      "bciAvId": 25782,
      "gloss": "right triangle",
      "glossSv": "triangel (rätvinklig), rätvinklig triangel",
      "pos": "noun",
      "explanation": "triangle + angle (right),right angle",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        247,
        "/",
        566
      ]
    },
    {
      "id": 5396,
      "bciAvId": 25784,
      "gloss": "ruin (castle), castle ruin",
      "glossSv": "slottsruin",
      "pos": "noun",
      "explanation": "castle + deletion,cancellation,destruction",
      "isCharacter": false,
      "composition": [
        825,
        "/",
        939
      ]
    },
    {
      "id": 5397,
      "bciAvId": 25785,
      "gloss": "salesperson, shop owner",
      "glossSv": "försäljare, säljare",
      "pos": "person",
      "explanation": "person + to sell",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        651,
        "/",
        451
      ]
    },
    {
      "id": 5398,
      "bciAvId": 25786,
      "gloss": "scalene triangle",
      "glossSv": "triangel (oliksidig), oliksidig triangel",
      "pos": "noun",
      "explanation": "triangle + different",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        651,
        "/",
        247,
        "/",
        262
      ]
    },
    {
      "id": 5399,
      "bciAvId": 25787,
      "gloss": "sceptical, skeptical, questioning",
      "glossSv": "skeptisk, tvivlande",
      "pos": "description",
      "explanation": "scepticism + description indicator",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        86,
        "/",
        485
      ]
    },
    {
      "id": 5400,
      "bciAvId": 25788,
      "gloss": "scepticism, skepticism",
      "glossSv": "skepsis, skepticism, tvivel",
      "pos": "noun",
      "explanation": "doubt + opinion",
      "isCharacter": false,
      "composition": [
        802,
        "/",
        485
      ]
    },
    {
      "id": 5401,
      "bciAvId": 25789,
      "gloss": "schoolmate",
      "glossSv": "skolkamrat",
      "pos": "person",
      "explanation": "person + equal + school [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        578,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 5402,
      "bciAvId": 25790,
      "gloss": "sculpture",
      "glossSv": "skulptur, staty",
      "pos": "noun",
      "explanation": "work of art,art object + 3 + space,dimension",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        12,
        "/",
        611
      ]
    },
    {
      "id": 5403,
      "bciAvId": 25791,
      "gloss": "self-raising flour",
      "glossSv": "mjöl med jäsmedel",
      "pos": "noun",
      "explanation": "flour + up",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        357,
        "/",
        678
      ]
    },
    {
      "id": 5404,
      "bciAvId": 25792,
      "gloss": "set square",
      "glossSv": "vinkelhake",
      "pos": "noun",
      "explanation": "angle (right),right angle + thing indicator",
      "isCharacter": false,
      "composition": [
        566,
        ";",
        97
      ]
    },
    {
      "id": 5405,
      "bciAvId": 25793,
      "gloss": "sheath",
      "glossSv": "knivslida, svärdslida",
      "pos": "noun",
      "explanation": "protection + knife,sword",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        411
      ]
    },
    {
      "id": 5406,
      "bciAvId": 25794,
      "gloss": "sheep shed, sheep barn",
      "glossSv": "fårhus, fårstall",
      "pos": "noun",
      "explanation": "house + sheep",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 5407,
      "bciAvId": 25795,
      "gloss": "sister-in-law (husband's sister)",
      "glossSv": "svägerska (makes syster)",
      "pos": "person",
      "explanation": "sister + husband",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        11,
        "/",
        393
      ]
    },
    {
      "id": 5408,
      "bciAvId": 25796,
      "gloss": "sister-in-law (partner's sister)",
      "glossSv": "svägerska (partners syster)",
      "pos": "person",
      "explanation": "sister + spouse",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        11,
        "/",
        616
      ]
    },
    {
      "id": 5409,
      "bciAvId": 25797,
      "gloss": "sister-in-law (wife's sister)",
      "glossSv": "svägerska (makas syster)",
      "pos": "person",
      "explanation": "sister + wife",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        11,
        "/",
        704
      ]
    },
    {
      "id": 5410,
      "bciAvId": 25798,
      "gloss": "slaughter",
      "glossSv": "slakt",
      "pos": "noun",
      "explanation": "knife + animal",
      "isCharacter": false,
      "composition": [
        411,
        "/",
        122
      ]
    },
    {
      "id": 5411,
      "bciAvId": 25799,
      "gloss": "to slaughter",
      "glossSv": "slakta",
      "pos": "action",
      "explanation": "slaughter + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        122
      ]
    },
    {
      "id": 5412,
      "bciAvId": 25800,
      "gloss": "slaughterer",
      "glossSv": "slaktare",
      "pos": "person",
      "explanation": "person + slaughter",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        411,
        "/",
        122
      ]
    },
    {
      "id": 5413,
      "bciAvId": 25801,
      "gloss": "slaughterhouse, abattoir",
      "glossSv": "slakteri, slakthus",
      "pos": "noun",
      "explanation": "house + slaughter",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        411,
        "/",
        122
      ]
    },
    {
      "id": 5414,
      "bciAvId": 25802,
      "gloss": "slice of bread, bread slice",
      "glossSv": "brödskiva",
      "pos": "noun",
      "explanation": "slice + bread + thing indicator",
      "isCharacter": false,
      "composition": [
        1096,
        ";",
        97,
        "/",
        411,
        "/",
        180
      ]
    },
    {
      "id": 5415,
      "bciAvId": 25803,
      "gloss": "to slide, to skid, to slip",
      "glossSv": "kana, glida, rutscha",
      "pos": "action",
      "explanation": "downward and forward + action indicator",
      "isCharacter": false,
      "composition": [
        273,
        ";",
        81
      ]
    },
    {
      "id": 5416,
      "bciAvId": 25804,
      "gloss": "smartphone, digital phone",
      "glossSv": "mobiltelefon, mobil, smartphone",
      "pos": "noun",
      "explanation": "digital device + telephone",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        414,
        "/",
        288
      ]
    },
    {
      "id": 5417,
      "bciAvId": 25805,
      "gloss": "son-in-law",
      "glossSv": "svärson",
      "pos": "person",
      "explanation": "husband + offspring: the husband of a son or daughter",
      "isCharacter": false,
      "composition": [
        393,
        "/",
        479
      ]
    },
    {
      "id": 5418,
      "bciAvId": 25806,
      "gloss": "sow",
      "glossSv": "sugga, so",
      "pos": "noun",
      "explanation": "pig + female",
      "isCharacter": false,
      "composition": [
        521,
        "/",
        314
      ]
    },
    {
      "id": 5419,
      "bciAvId": 25807,
      "gloss": "speaker, lecturer",
      "glossSv": "talare, föreläsare",
      "pos": "person",
      "explanation": "person + to talk + limited time",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        457,
        "/",
        426
      ]
    },
    {
      "id": 5420,
      "bciAvId": 25808,
      "gloss": "speech recognition",
      "glossSv": "taligenkänning",
      "pos": "noun",
      "explanation": "software,computer program,application,app + talk + pen: software that recognizes and transcribes speech",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829,
        "/",
        457,
        "/",
        509
      ]
    },
    {
      "id": 5421,
      "bciAvId": 25809,
      "gloss": "spider web, cobweb, orb web",
      "glossSv": "spindelnät",
      "pos": "noun",
      "explanation": "cloth,fabric,material,textile,net + spider",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        613
      ]
    },
    {
      "id": 5422,
      "bciAvId": 25810,
      "gloss": "sports centre",
      "glossSv": "sporthall",
      "pos": "noun",
      "explanation": "house + sport",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        719
      ]
    },
    {
      "id": 5423,
      "bciAvId": 25811,
      "gloss": "stepdaughter",
      "glossSv": "styvdotter",
      "pos": "person",
      "explanation": "daughter + step-parent",
      "isCharacter": false,
      "composition": [
        257,
        "/",
        1120
      ]
    },
    {
      "id": 5424,
      "bciAvId": 25813,
      "gloss": "stepson",
      "glossSv": "styvson",
      "pos": "person",
      "explanation": "son + step-parent",
      "isCharacter": false,
      "composition": [
        607,
        "/",
        1120
      ]
    },
    {
      "id": 5425,
      "bciAvId": 25814,
      "gloss": "strategy",
      "glossSv": "strategi, taktik",
      "pos": "noun",
      "explanation": "plan + stairs: plan to reach a goal step by step",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        619
      ]
    },
    {
      "id": 5426,
      "bciAvId": 25815,
      "gloss": "sugar lump, cube (sugar)",
      "glossSv": "sockerbit",
      "pos": "noun",
      "explanation": "sugar [contraction] + block,brick + thing indicator",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        678,
        "/",
        168
      ]
    },
    {
      "id": 5427,
      "bciAvId": 25816,
      "gloss": "surrounded, encircled, surrounding",
      "glossSv": "omgiven, omringad, omgivande",
      "pos": "description",
      "explanation": "around + description indicator",
      "isCharacter": false,
      "composition": [
        134,
        ";",
        86
      ]
    },
    {
      "id": 5428,
      "bciAvId": 25817,
      "gloss": "swim centre",
      "glossSv": "badhus, simhall",
      "pos": "noun",
      "explanation": "house + swimming",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 5429,
      "bciAvId": 25818,
      "gloss": "swimming hall, indoor swimming pool",
      "glossSv": "simhall",
      "pos": "noun",
      "explanation": "room + swimming",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 5430,
      "bciAvId": 25819,
      "gloss": "synthetic speech, text-to-speech, tts",
      "glossSv": "talsyntes, syntetiskt tal, text-till-tal",
      "pos": "noun",
      "explanation": "speech + digits (computer)",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        457,
        "/",
        829
      ]
    },
    {
      "id": 5431,
      "bciAvId": 25820,
      "gloss": "tablet computer, tablet, tablet PC (1)",
      "glossSv": "datorplatta, pekdator (1)",
      "pos": "noun",
      "explanation": "digital device + enclosure: the enclosure representing the touch screen",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        291
      ]
    },
    {
      "id": 5432,
      "bciAvId": 25821,
      "gloss": "taco, taco shell",
      "glossSv": "tacoskal",
      "pos": "noun",
      "explanation": "shell,crust + corn",
      "isCharacter": false,
      "composition": [
        588,
        "/",
        240
      ]
    },
    {
      "id": 5433,
      "bciAvId": 25823,
      "gloss": "unemployed",
      "glossSv": "arbetslös",
      "pos": "description",
      "explanation": "without + work",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        711,
        ";",
        86
      ]
    },
    {
      "id": 5434,
      "bciAvId": 25824,
      "gloss": "well, water well",
      "glossSv": "brunn, källa, vattenkälla",
      "pos": "noun",
      "explanation": "hole + water",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        695
      ]
    },
    {
      "id": 5435,
      "bciAvId": 25825,
      "gloss": "voluntary",
      "glossSv": "frivillig, ideell, volontär",
      "pos": "description",
      "explanation": "volunteering + description indicator",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        86,
        "/",
        336
      ]
    },
    {
      "id": 5436,
      "bciAvId": 25826,
      "gloss": "voluntary work, unpaid work",
      "glossSv": "frivilligt arbete, ideellt arbete, volontärarbete",
      "pos": "noun",
      "explanation": "work + without + money",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        449,
        "/",
        451
      ]
    },
    {
      "id": 5437,
      "bciAvId": 25827,
      "gloss": "volunteering",
      "glossSv": "frivillighet, idealitet",
      "pos": "noun",
      "explanation": "help + free",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        336
      ]
    },
    {
      "id": 5438,
      "bciAvId": 25828,
      "gloss": "to work from home",
      "glossSv": "arbeta hemifrån",
      "pos": "action",
      "explanation": "working from home + action indicator",
      "isCharacter": false,
      "composition": [
        711,
        ";",
        81,
        "/",
        451,
        "/",
        392
      ]
    },
    {
      "id": 5439,
      "bciAvId": 25829,
      "gloss": "working from home",
      "glossSv": "arbete hemifrån",
      "pos": "noun",
      "explanation": "work + money + house",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        451,
        "/",
        392
      ]
    },
    {
      "id": 5440,
      "bciAvId": 25830,
      "gloss": "yeast",
      "glossSv": "jäst",
      "pos": "noun",
      "explanation": "micro-organism + roll,bun + up",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956,
        "/",
        570,
        "/",
        678
      ]
    },
    {
      "id": 5441,
      "bciAvId": 25831,
      "gloss": "possible",
      "glossSv": "möjlig, eventuell",
      "pos": "description",
      "explanation": "possibility + description indicator",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        86,
        "/",
        699
      ]
    },
    {
      "id": 5442,
      "bciAvId": 25832,
      "gloss": "to question, to be sceptical, to doubt",
      "glossSv": "ifrågasätta, vara skeptisk, betvivla",
      "pos": "action",
      "explanation": "scepticism + action indicator",
      "isCharacter": false,
      "composition": [
        802,
        ";",
        81,
        "/",
        485
      ]
    },
    {
      "id": 5443,
      "bciAvId": 25840,
      "gloss": "age",
      "glossSv": "ålder",
      "pos": "noun",
      "explanation": "number + year",
      "isCharacter": false,
      "composition": [
        478,
        "/",
        716
      ]
    },
    {
      "id": 5444,
      "bciAvId": 25841,
      "gloss": "asteroid",
      "glossSv": "asteroid",
      "pos": "noun",
      "explanation": "similar + dwarf planet",
      "isCharacter": false,
      "composition": [
        1060,
        "/",
        578,
        "/",
        800,
        "/",
        956
      ]
    },
    {
      "id": 5445,
      "bciAvId": 25842,
      "gloss": "balance, sense of balance",
      "glossSv": "balans, balanssinne",
      "pos": "noun",
      "explanation": "information + position + body: information to the brain about body position",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        540,
        "/",
        171
      ]
    },
    {
      "id": 5446,
      "bciAvId": 25843,
      "gloss": "balance (general), poise",
      "glossSv": "balans (generellt)",
      "pos": "noun",
      "explanation": "activity + without + fall,drop,spill,tumble",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        449,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 5447,
      "bciAvId": 25844,
      "gloss": "to balance (general), to poise",
      "glossSv": "hålla balansen",
      "pos": "action",
      "explanation": "balance (general),poise + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        449,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 5448,
      "bciAvId": 25845,
      "gloss": "to balance (walking, standing)",
      "glossSv": "balansera (stående och gående)",
      "pos": "action",
      "explanation": "walk,go-(to) + without + fall,drop,spill,tumble + action indicator: walking without falling, change classifier to “sit”, when more appropriate",
      "isCharacter": false,
      "composition": [
        418,
        ";",
        81,
        "/",
        449,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 5449,
      "bciAvId": 25846,
      "gloss": "barrow, grave mound",
      "glossSv": "dös, gånggrift etc",
      "pos": "noun",
      "explanation": "collection + stone + grave",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        629,
        "/",
        367
      ]
    },
    {
      "id": 5450,
      "bciAvId": 25847,
      "gloss": "bathing rule(s)",
      "glossSv": "badregel, badregler (plur)",
      "pos": "noun",
      "explanation": "rule,regulation + pool",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        539
      ]
    },
    {
      "id": 5451,
      "bciAvId": 25848,
      "gloss": "bike lamp",
      "glossSv": "cykellampa",
      "pos": "noun",
      "explanation": "lamp [contraction] + bike + thing indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 5452,
      "bciAvId": 25849,
      "gloss": "birch",
      "glossSv": "björk",
      "pos": "noun",
      "explanation": "tree + white + north: tree with white trunk, birch is typical in the north",
      "isCharacter": false,
      "composition": [
        666,
        "/",
        1161,
        "/",
        604,
        "/",
        472
      ]
    },
    {
      "id": 5453,
      "bciAvId": 25850,
      "gloss": "birdfeeder, bird table",
      "glossSv": "fågelbord",
      "pos": "noun",
      "explanation": "place + food + comma + bird: place to feed [contraction] birds",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        329,
        "/",
        5,
        "/",
        163
      ]
    },
    {
      "id": 5454,
      "bciAvId": 25851,
      "gloss": "cardboard, paperboard",
      "glossSv": "kartong (papper), tjockt papper",
      "pos": "noun",
      "explanation": "paper + thick",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        1034
      ]
    },
    {
      "id": 5455,
      "bciAvId": 25852,
      "gloss": "chess",
      "glossSv": "schack",
      "pos": "expression",
      "explanation": "game + crown: crown representing king [contraction], the king is the target of the game",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        313,
        "/",
        678,
        "/",
        798
      ]
    },
    {
      "id": 5456,
      "bciAvId": 25853,
      "gloss": "chewing-gum",
      "glossSv": "tuggummi",
      "pos": "noun",
      "explanation": "candy + teeth: candy to chew",
      "isCharacter": false,
      "composition": [
        782,
        "/",
        644
      ]
    },
    {
      "id": 5457,
      "bciAvId": 25854,
      "gloss": "collar",
      "glossSv": "krage",
      "pos": "noun",
      "explanation": "part of + clothes + neck [body]",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        229,
        "/",
        466
      ]
    },
    {
      "id": 5458,
      "bciAvId": 25855,
      "gloss": "cornea",
      "glossSv": "hornhinna, cornea",
      "pos": "noun",
      "explanation": "protection + eye: the cornea covers the eye",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        303
      ]
    },
    {
      "id": 5459,
      "bciAvId": 25856,
      "gloss": "covered, hidden",
      "glossSv": "gömd, täckt, osynliggjord",
      "pos": "description",
      "explanation": "make + invisible + description indicator: made invisible",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        86,
        "/",
        449,
        "/",
        303
      ]
    },
    {
      "id": 5460,
      "bciAvId": 25857,
      "gloss": "dairy",
      "glossSv": "mejeri",
      "pos": "noun",
      "explanation": "factory + milk",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        840,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 5461,
      "bciAvId": 25858,
      "gloss": "darkness",
      "glossSv": "mörker",
      "pos": "noun",
      "explanation": "minus + light",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        424
      ]
    },
    {
      "id": 5462,
      "bciAvId": 25859,
      "gloss": "den, lair",
      "glossSv": "lya, kula, håla, gryt",
      "pos": "noun",
      "explanation": "hole + animal: the hole is the entrance to a hidden place",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        122
      ]
    },
    {
      "id": 5463,
      "bciAvId": 25860,
      "gloss": "dense, thick, compact, tight, jammed",
      "glossSv": "tät, tjock, kompakt",
      "pos": "description",
      "explanation": "density + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        ";",
        86,
        "/",
        1060
      ]
    },
    {
      "id": 5464,
      "bciAvId": 25861,
      "gloss": "density, denseness, compactness, tightness (general)",
      "glossSv": "täthet, kompakthet, (allmänt)",
      "pos": "noun",
      "explanation": "many + thing + closeness",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        "/",
        1060
      ]
    },
    {
      "id": 5465,
      "bciAvId": 25862,
      "gloss": "density, denseness, concentration (measurement)",
      "glossSv": "täthet, koncentration (mått)",
      "pos": "noun",
      "explanation": "measurement + thing + closeness: the spatial property of being crowded together",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        651,
        "/",
        1060
      ]
    },
    {
      "id": 5466,
      "bciAvId": 25863,
      "gloss": "to disagree, to discord, to disaccord",
      "glossSv": "vara oense, vara osams",
      "pos": "action",
      "explanation": "disagreement + action indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        ";",
        81,
        "/",
        113
      ]
    },
    {
      "id": 5467,
      "bciAvId": 25864,
      "gloss": "disagreement, discord",
      "glossSv": "oenighet, skiljaktighet",
      "pos": "noun",
      "explanation": "without + feeling + agreement",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        "/",
        113
      ]
    },
    {
      "id": 5468,
      "bciAvId": 25865,
      "gloss": "discordant",
      "glossSv": "oense, osams",
      "pos": "description",
      "explanation": "disagreement + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313,
        ";",
        86,
        "/",
        113
      ]
    },
    {
      "id": 5469,
      "bciAvId": 25866,
      "gloss": "diver (active under water)",
      "glossSv": "dykare",
      "pos": "person",
      "explanation": "person + diving (activity)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        106,
        "/",
        676,
        "/",
        1117
      ]
    },
    {
      "id": 5470,
      "bciAvId": 25867,
      "gloss": "diver (jump)",
      "glossSv": "simhoppare",
      "pos": "person",
      "explanation": "person + diving (sport)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        719,
        "/",
        836,
        "/",
        1117
      ]
    },
    {
      "id": 5471,
      "bciAvId": 25868,
      "gloss": "diving, activity under water",
      "glossSv": "diving, activity under water",
      "pos": "noun",
      "explanation": "activity + under + water",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        676,
        "/",
        1117
      ]
    },
    {
      "id": 5472,
      "bciAvId": 25869,
      "gloss": "diving equipment, diving gear",
      "glossSv": "dykutrustning",
      "pos": "expression",
      "explanation": "group of + thing + diving: combination of equipment,gear + diving,activity under water",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        "/",
        106,
        "/",
        676,
        "/",
        1117
      ]
    },
    {
      "id": 5473,
      "bciAvId": 25870,
      "gloss": "doorway, gate",
      "glossSv": "grind, port",
      "pos": "noun",
      "explanation": "door + fence",
      "isCharacter": false,
      "composition": [
        269,
        "/",
        315
      ]
    },
    {
      "id": 5474,
      "bciAvId": 25871,
      "gloss": "dove",
      "glossSv": "duva",
      "pos": "noun",
      "explanation": "bird + peace",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        505
      ]
    },
    {
      "id": 5475,
      "bciAvId": 25872,
      "gloss": "dust storm, duster, sirocco",
      "glossSv": "dammstorm, sirocco",
      "pos": "noun",
      "explanation": "storm + dust",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        705,
        "/",
        544
      ]
    },
    {
      "id": 5476,
      "bciAvId": 25873,
      "gloss": "ear, spike, capitulum",
      "glossSv": "ax",
      "pos": "noun",
      "explanation": "many + seed + grain",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        584,
        "/",
        357
      ]
    },
    {
      "id": 5477,
      "bciAvId": 25874,
      "gloss": "eastward",
      "glossSv": "österut",
      "pos": "description",
      "explanation": "forward + east + description indicator: forward representing (direction [contraction])",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        282
      ]
    },
    {
      "id": 5478,
      "bciAvId": 25875,
      "gloss": "equipment, gear",
      "glossSv": "utrustning",
      "pos": "noun",
      "explanation": "group of + thing + activity: a group of things for a certain activity",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        "/",
        106
      ]
    },
    {
      "id": 5479,
      "bciAvId": 25876,
      "gloss": "fable, allegory, parable",
      "glossSv": "fabel, allegori, liknelse",
      "pos": "noun",
      "explanation": "story,report,tale + imaginary + meaning: an imaginary story with a specific meaning",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        945,
        "/",
        440
      ]
    },
    {
      "id": 5480,
      "bciAvId": 25877,
      "gloss": "fairy tale",
      "glossSv": "saga",
      "pos": "noun",
      "explanation": "story,report,tale + imaginary person",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        838
      ]
    },
    {
      "id": 5481,
      "bciAvId": 25879,
      "gloss": "folk tale, legend",
      "glossSv": "folksaga, legend",
      "pos": "noun",
      "explanation": "story,report,tale + past + imaginary person: story from the past about imaginary persons",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        503,
        "/",
        838
      ]
    },
    {
      "id": 5482,
      "bciAvId": 25880,
      "gloss": "football rule(s)",
      "glossSv": "fotbollsregel, fotbollsregler (plur)",
      "pos": "noun",
      "explanation": "rule,regulation + football [contraction]",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 5483,
      "bciAvId": 25881,
      "gloss": "four-leaf clover",
      "glossSv": "fyrklöver",
      "pos": "noun",
      "explanation": "shamrock + 4 + leaf: shamrock representing clover",
      "isCharacter": false,
      "composition": [
        586,
        "/",
        13,
        "/",
        416
      ]
    },
    {
      "id": 5484,
      "bciAvId": 25882,
      "gloss": "free of charge, gratis, for free",
      "glossSv": "gratis, kostnadsfri",
      "pos": "description",
      "explanation": "without + cost + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        451,
        ";",
        86,
        "/",
        331,
        "/",
        651
      ]
    },
    {
      "id": 5485,
      "bciAvId": 25883,
      "gloss": "game rule(s)",
      "glossSv": "spelregel, spelregler (plur)",
      "pos": "noun",
      "explanation": "rule,regulation + game [contraction]",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 5486,
      "bciAvId": 25884,
      "gloss": "to give birth",
      "glossSv": "föda",
      "pos": "action",
      "explanation": "birth,giving birth,parturition,delivery + action indicator",
      "isCharacter": false,
      "composition": [
        165,
        ";",
        81
      ]
    },
    {
      "id": 5487,
      "bciAvId": 25885,
      "gloss": "globe (map)",
      "glossSv": "jordglob",
      "pos": "noun",
      "explanation": "earth,globe,world + man-made",
      "isCharacter": false,
      "composition": [
        280,
        "/",
        840
      ]
    },
    {
      "id": 5488,
      "bciAvId": 25886,
      "gloss": "grave field",
      "glossSv": "gravfält",
      "pos": "noun",
      "explanation": "place + grave + past",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        367,
        "/",
        503
      ]
    },
    {
      "id": 5489,
      "bciAvId": 25887,
      "gloss": "habitation, dwelling place, site",
      "glossSv": "boplats",
      "pos": "noun",
      "explanation": "place + live",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        392
      ]
    },
    {
      "id": 5490,
      "bciAvId": 25888,
      "gloss": "head lamp",
      "glossSv": "pannlampa",
      "pos": "noun",
      "explanation": "lamp [contraction] + head + thing indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        376
      ]
    },
    {
      "id": 5491,
      "bciAvId": 25889,
      "gloss": "heap of sand",
      "glossSv": "sandhög",
      "pos": "noun",
      "explanation": "collection + sand",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 5492,
      "bciAvId": 25890,
      "gloss": "hearing, audition, auditory sense",
      "glossSv": "hörsel, hörselsinne",
      "pos": "noun",
      "explanation": "information + ear: information to the brain from the ears",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        278
      ]
    },
    {
      "id": 5493,
      "bciAvId": 25891,
      "gloss": "homeward",
      "glossSv": "hemåt",
      "pos": "description",
      "explanation": "forward + home + description indicator: forward representing direction [contraction]",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        392,
        "/",
        313
      ]
    },
    {
      "id": 5494,
      "bciAvId": 25892,
      "gloss": "ice coated, ice covered",
      "glossSv": "istäckt",
      "pos": "description",
      "explanation": "ice covering + description indicator",
      "isCharacter": false,
      "composition": [
        394,
        ";",
        86,
        "/",
        588
      ]
    },
    {
      "id": 5495,
      "bciAvId": 25893,
      "gloss": "ice covering, ice crust, ice coating",
      "glossSv": "istäcke, isskorpa",
      "pos": "noun",
      "explanation": "ice + shell: ice like a crust which can cover any side of a thing",
      "isCharacter": false,
      "composition": [
        394,
        "/",
        588
      ]
    },
    {
      "id": 5496,
      "bciAvId": 25897,
      "gloss": "iris (eye)",
      "glossSv": "regnbågshinna, iris",
      "pos": "noun",
      "explanation": "protection + eye + light: muscular diaphragm which thus protects the eye from too much or too little light",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        303,
        "/",
        424
      ]
    },
    {
      "id": 5497,
      "bciAvId": 25898,
      "gloss": "labyrinth, maze",
      "glossSv": "labyrint",
      "pos": "noun",
      "explanation": "place + difficult + out of,exit (forward)",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        940,
        "/",
        491
      ]
    },
    {
      "id": 5498,
      "bciAvId": 25899,
      "gloss": "to lamb",
      "glossSv": "lamma",
      "pos": "action",
      "explanation": "birth + sheep + action indicator",
      "isCharacter": false,
      "composition": [
        165,
        ";",
        81,
        "/",
        123,
        "/",
        228
      ]
    },
    {
      "id": 5499,
      "bciAvId": 25900,
      "gloss": "Sami(s)",
      "glossSv": "same(r), lapp(ar)",
      "pos": "noun",
      "explanation": "people in the north (Lapps,Eskimos) + deer,cervine (animal),cervid: deer representing reindeer [contraction]",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        751,
        "/",
        472,
        "/",
        125
      ]
    },
    {
      "id": 5500,
      "bciAvId": 25901,
      "gloss": "Latvia",
      "glossSv": "Lettland",
      "pos": "noun",
      "explanation": "country + L + A + T",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        "XL",
        "/",
        "XA",
        "/",
        "XT"
      ]
    },
    {
      "id": 5501,
      "bciAvId": 25902,
      "gloss": "Latvian (class)",
      "glossSv": "lettiska (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + Latvian",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        243,
        "/",
        "XL",
        "/",
        "XA",
        "/",
        "XT"
      ]
    },
    {
      "id": 5502,
      "bciAvId": 25903,
      "gloss": "Latvian (language)",
      "glossSv": "lettiska (språk)",
      "pos": "noun",
      "explanation": "language + Latvia",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        243,
        "/",
        "XL",
        "/",
        "XA",
        "/",
        "XT"
      ]
    },
    {
      "id": 5503,
      "bciAvId": 25904,
      "gloss": "leaf, flap",
      "glossSv": "klaff, flik",
      "pos": "noun",
      "explanation": "thing + fold,folding,pleating",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        1038
      ]
    },
    {
      "id": 5504,
      "bciAvId": 25905,
      "gloss": "to lick",
      "glossSv": "slicka",
      "pos": "action",
      "explanation": "tongue + action indicator",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        457,
        ";",
        81,
        "/",
        723
      ]
    },
    {
      "id": 5505,
      "bciAvId": 25906,
      "gloss": "lock",
      "glossSv": "lås",
      "pos": "noun",
      "explanation": "thing + key",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        407
      ]
    },
    {
      "id": 5506,
      "bciAvId": 25907,
      "gloss": "lower leg, shank, shin",
      "glossSv": "vad, underben",
      "pos": "noun",
      "explanation": "leg + under",
      "isCharacter": false,
      "composition": [
        417,
        "/",
        676
      ]
    },
    {
      "id": 5507,
      "bciAvId": 25908,
      "gloss": "magic",
      "glossSv": "magi, magik",
      "pos": "noun",
      "explanation": "cause + mystery",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        746
      ]
    },
    {
      "id": 5508,
      "bciAvId": 25909,
      "gloss": "magical",
      "glossSv": "magisk",
      "pos": "description",
      "explanation": "magic + description indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        86,
        "/",
        746
      ]
    },
    {
      "id": 5509,
      "bciAvId": 25910,
      "gloss": "manhole cover",
      "glossSv": "brunnslock",
      "pos": "noun",
      "explanation": "lid + opening + ground",
      "isCharacter": false,
      "composition": [
        791,
        "/",
        484,
        "/",
        281
      ]
    },
    {
      "id": 5510,
      "bciAvId": 25911,
      "gloss": "midnight sun",
      "glossSv": "midnattssol",
      "pos": "noun",
      "explanation": "sun + night",
      "isCharacter": false,
      "composition": [
        636,
        "/",
        470
      ]
    },
    {
      "id": 5511,
      "bciAvId": 25912,
      "gloss": "milkmaid, dairymaid",
      "glossSv": "säterjänta, fäbodstinta",
      "pos": "person",
      "explanation": "woman + mountain pasture",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        392,
        "/",
        456,
        "/",
        122
      ]
    },
    {
      "id": 5512,
      "bciAvId": 25913,
      "gloss": "millipede, millepede",
      "glossSv": "tusenfoting",
      "pos": "noun",
      "explanation": "insect + group of,much of,many of,quantity of + legs and feet",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        368,
        "/",
        418
      ]
    },
    {
      "id": 5513,
      "bciAvId": 25914,
      "gloss": "mother's milk",
      "glossSv": "modersmjölk",
      "pos": "noun",
      "explanation": "milk + mother",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        423,
        "/",
        455
      ]
    },
    {
      "id": 5514,
      "bciAvId": 25915,
      "gloss": "mountain pasture",
      "glossSv": "fäbod, säter",
      "pos": "noun",
      "explanation": "house + mountain + animal",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        456,
        "/",
        122
      ]
    },
    {
      "id": 5515,
      "bciAvId": 25916,
      "gloss": "mouth (wide-open), open mouth, gape",
      "glossSv": "gap, öppen mun",
      "pos": "noun",
      "explanation": "mouth + open",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        484
      ]
    },
    {
      "id": 5516,
      "bciAvId": 25917,
      "gloss": "myth",
      "glossSv": "myt",
      "pos": "noun",
      "explanation": "story,report,tale + imaginary + event: imaginary tale of an event",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        945,
        "/",
        299
      ]
    },
    {
      "id": 5517,
      "bciAvId": 25918,
      "gloss": "northward",
      "glossSv": "norrut",
      "pos": "description",
      "explanation": "forward + north + description indicator: forward representing direction [contraction]",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        472
      ]
    },
    {
      "id": 5518,
      "bciAvId": 25919,
      "gloss": "to open one's mouth, to hold one's mouth open, to gape",
      "glossSv": "gapa, öppna munnen",
      "pos": "action",
      "explanation": "mouth (wide-open),open mouth,gape + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        484
      ]
    },
    {
      "id": 5519,
      "bciAvId": 25920,
      "gloss": "others (persons)",
      "glossSv": "andra (personer)",
      "pos": "person",
      "explanation": "other + plural indicator",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        99,
        "/",
        11
      ]
    },
    {
      "id": 5520,
      "bciAvId": 25921,
      "gloss": "to overturn, to turn over, to tip over",
      "glossSv": "välta, tippa",
      "pos": "action",
      "explanation": "turn + fall,drop,spill,tumble + action indicator",
      "isCharacter": false,
      "composition": [
        1101,
        ";",
        81,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 5521,
      "bciAvId": 25922,
      "gloss": "paper clip",
      "glossSv": "gem",
      "pos": "noun",
      "explanation": "thing + paper + together",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        497,
        "/",
        823
      ]
    },
    {
      "id": 5522,
      "bciAvId": 25923,
      "gloss": "people in the north (Lapps, Eskimos)",
      "glossSv": "folkgrupper i norr (samer, eskimåer)",
      "pos": "noun",
      "explanation": "people,tribe,clan,folk + north",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        751,
        "/",
        472
      ]
    },
    {
      "id": 5523,
      "bciAvId": 25924,
      "gloss": "place to feed, feeding place, feeding ground",
      "glossSv": "matställe, matplats, foderplats, utfordringsställe",
      "pos": "noun",
      "explanation": "place + give + food: feeding place in general",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        949,
        "/",
        329
      ]
    },
    {
      "id": 5524,
      "bciAvId": 25925,
      "gloss": "plant (edible)",
      "glossSv": "växt, planta (ätlig)",
      "pos": "noun",
      "explanation": "plant + food",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        329
      ]
    },
    {
      "id": 5525,
      "bciAvId": 25926,
      "gloss": "polar bear",
      "glossSv": "isbjörn",
      "pos": "noun",
      "explanation": "bear + ice",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        925,
        "/",
        394
      ]
    },
    {
      "id": 5526,
      "bciAvId": 25927,
      "gloss": "polar night",
      "glossSv": "polarnatt, midvinternatt",
      "pos": "noun",
      "explanation": "night + north",
      "isCharacter": false,
      "composition": [
        470,
        "/",
        472
      ]
    },
    {
      "id": 5527,
      "bciAvId": 25928,
      "gloss": "pupil (eye)",
      "glossSv": "pupill",
      "pos": "noun",
      "explanation": "opening + eye",
      "isCharacter": false,
      "composition": [
        484,
        "/",
        303
      ]
    },
    {
      "id": 5528,
      "bciAvId": 25929,
      "gloss": "raindrop",
      "glossSv": "regndroppe",
      "pos": "noun",
      "explanation": "dot + rain: combination of drop and rain",
      "isCharacter": false,
      "composition": [
        270,
        "/",
        556
      ]
    },
    {
      "id": 5529,
      "bciAvId": 25930,
      "gloss": "to raise one's hand, to put up one's hand",
      "glossSv": "räcka upp handen",
      "pos": "action",
      "explanation": "show of hands + action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        678
      ]
    },
    {
      "id": 5530,
      "bciAvId": 25931,
      "gloss": "reed, bamboo (tall grass)",
      "glossSv": "vass, bambu (högt gräs)",
      "pos": "noun",
      "explanation": "grass + big",
      "isCharacter": false,
      "composition": [
        366,
        "/",
        936
      ]
    },
    {
      "id": 5531,
      "bciAvId": 25932,
      "gloss": "rock (geology)",
      "glossSv": "bergart",
      "pos": "noun",
      "explanation": "type,kind,sort,category + stone",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        629
      ]
    },
    {
      "id": 5532,
      "bciAvId": 25933,
      "gloss": "rope, hawser",
      "glossSv": "rep, tross, tamp, lina",
      "pos": "noun",
      "explanation": "group of + group of + fiber",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        1122
      ]
    },
    {
      "id": 5533,
      "bciAvId": 25934,
      "gloss": "sandstorm",
      "glossSv": "sandstorm",
      "pos": "noun",
      "explanation": "storm + sand",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        705,
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 5534,
      "bciAvId": 25935,
      "gloss": "school way",
      "glossSv": "skolväg",
      "pos": "noun",
      "explanation": "way + school",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        335,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 5535,
      "bciAvId": 25936,
      "gloss": "season of darkness",
      "glossSv": "mörka säsongen, mörka tiden på året",
      "pos": "noun",
      "explanation": "season + darkness",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        716,
        "/",
        449,
        "/",
        424
      ]
    },
    {
      "id": 5536,
      "bciAvId": 25937,
      "gloss": "sense",
      "glossSv": "sinne",
      "pos": "noun",
      "explanation": "generalization + vision + hearing [contraction]: information to the brain, generalization for all senses",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        835,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 5537,
      "bciAvId": 25938,
      "gloss": "show of hands",
      "glossSv": "handuppräckning",
      "pos": "noun",
      "explanation": "hand + up",
      "isCharacter": false,
      "composition": [
        374,
        "/",
        678
      ]
    },
    {
      "id": 5538,
      "bciAvId": 25939,
      "gloss": "sight, vision, visual sense",
      "glossSv": "syn, synsinne",
      "pos": "noun",
      "explanation": "information + eye: information to the brain from the eyes",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        303
      ]
    },
    {
      "id": 5539,
      "bciAvId": 25940,
      "gloss": "smell, sense of smell, olfaction",
      "glossSv": "lukt, luktsinne",
      "pos": "noun",
      "explanation": "information + nose: information to the brain from the nose",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        473
      ]
    },
    {
      "id": 5540,
      "bciAvId": 25941,
      "gloss": "snake (dangerous), viper, boa (etc)",
      "glossSv": "orm (farlig), giftorm, huggorm, boaorm",
      "pos": "noun",
      "explanation": "snake + danger",
      "isCharacter": false,
      "composition": [
        602,
        "/",
        256
      ]
    },
    {
      "id": 5541,
      "bciAvId": 25942,
      "gloss": "snake (not dangerous), grass snake (etc)",
      "glossSv": "orm (ofarlig), snok",
      "pos": "noun",
      "explanation": "snake + minus + danger",
      "isCharacter": false,
      "composition": [
        602,
        "/",
        449,
        "/",
        256
      ]
    },
    {
      "id": 5542,
      "bciAvId": 25943,
      "gloss": "sole (of shoe)",
      "glossSv": "sula, skosula",
      "pos": "noun",
      "explanation": "bottom + shoe",
      "isCharacter": false,
      "composition": [
        990,
        "/",
        548,
        "/",
        330
      ]
    },
    {
      "id": 5543,
      "bciAvId": 25944,
      "gloss": "southward",
      "glossSv": "söderut",
      "pos": "description",
      "explanation": "forward + south + description indicator: forward representing direction [contraction]",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        610
      ]
    },
    {
      "id": 5544,
      "bciAvId": 25945,
      "gloss": "to spill, to slop",
      "glossSv": "spilla, söla",
      "pos": "action",
      "explanation": "cause + dirt + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        368,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 5545,
      "bciAvId": 25946,
      "gloss": "to sprout, to germinate",
      "glossSv": "gro, spira",
      "pos": "action",
      "explanation": "start + growth,growing + action indicator",
      "isCharacter": false,
      "composition": [
        159,
        ";",
        81,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 5546,
      "bciAvId": 25947,
      "gloss": "story (historical), historic story",
      "glossSv": "berättelse (historisk)",
      "pos": "noun",
      "explanation": "story,report,tale + past",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        457,
        "/",
        503
      ]
    },
    {
      "id": 5547,
      "bciAvId": 25948,
      "gloss": "summer day",
      "glossSv": "sommardag",
      "pos": "noun",
      "explanation": "day + summer: only numbers are used, as seasons are different in different parts of the world",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        636,
        "/",
        11
      ]
    },
    {
      "id": 5548,
      "bciAvId": 25949,
      "gloss": "summer house, summerhouse",
      "glossSv": "sommarstuga, sommarbostad",
      "pos": "noun",
      "explanation": "house + summer: only numbers are used, as seasons are different in different parts of the world",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        636,
        "/",
        11
      ]
    },
    {
      "id": 5549,
      "bciAvId": 25950,
      "gloss": "swimming rule(s)",
      "glossSv": "simregel, simregler (plur)",
      "pos": "noun",
      "explanation": "rule,regulation + swimming",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 5550,
      "bciAvId": 25951,
      "gloss": "tanker truck, tank lorry",
      "glossSv": "tankbil",
      "pos": "noun",
      "explanation": "truck,lorry + water,fluid,liquid",
      "isCharacter": false,
      "composition": [
        668,
        "/",
        695
      ]
    },
    {
      "id": 5551,
      "bciAvId": 25952,
      "gloss": "taste, gustation, sense of taste",
      "glossSv": "smak, smaksinne, smak",
      "pos": "noun",
      "explanation": "information + taste; information to the brain from the nose and the mouth",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        642
      ]
    },
    {
      "id": 5552,
      "bciAvId": 25953,
      "gloss": "tear, teardrop",
      "glossSv": "tår (från ögat)",
      "pos": "noun",
      "explanation": "drop + eye",
      "isCharacter": false,
      "composition": [
        270,
        "/",
        695,
        "/",
        303
      ]
    },
    {
      "id": 5553,
      "bciAvId": 25954,
      "gloss": "to tear along, to advance fast, to go fast",
      "glossSv": "rusa iväg, skynda iväg",
      "pos": "action",
      "explanation": "quickness,rapidity,speediness + action indicator: moving fast forward",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        81,
        "/",
        401
      ]
    },
    {
      "id": 5554,
      "bciAvId": 25955,
      "gloss": "thigh, upper leg",
      "glossSv": "lår, överben",
      "pos": "noun",
      "explanation": "leg + over",
      "isCharacter": false,
      "composition": [
        417,
        "/",
        493
      ]
    },
    {
      "id": 5555,
      "bciAvId": 25956,
      "gloss": "thread, string, cord",
      "glossSv": "tråd, snöre, snodd",
      "pos": "noun",
      "explanation": "group of,much of,many of,quantity of + fiber,fibre,fibril,filament,strand",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1122
      ]
    },
    {
      "id": 5556,
      "bciAvId": 25957,
      "gloss": "touch, sense of touch, tactile sense",
      "glossSv": "känsel, känselsinne",
      "pos": "noun",
      "explanation": "information + skin: information to the brain from the skin",
      "isCharacter": false,
      "composition": [
        835,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 5557,
      "bciAvId": 25958,
      "gloss": "traffic rule(s)",
      "glossSv": "trafikregel, trafikregler (plur)",
      "pos": "noun",
      "explanation": "rule,regulation + traffic",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        368,
        "/",
        202
      ]
    },
    {
      "id": 5558,
      "bciAvId": 25959,
      "gloss": "trapeze",
      "glossSv": "trapets",
      "pos": "noun",
      "explanation": "swing + acrobatics [contraction]",
      "isCharacter": false,
      "composition": [
        989,
        ";",
        97,
        "/",
        718,
        "/",
        532,
        "/",
        303
      ]
    },
    {
      "id": 5559,
      "bciAvId": 25960,
      "gloss": "T-shirt, tee shirt, jersey",
      "glossSv": "T-tröja, T-shirt",
      "pos": "noun",
      "explanation": "clothing + chest + T",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        218,
        "/",
        524
      ]
    },
    {
      "id": 5560,
      "bciAvId": 25961,
      "gloss": "tuft of grass, tussock",
      "glossSv": "tuva, grästuva",
      "pos": "noun",
      "explanation": "collection,pile,tussock (etc) + grass",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        366
      ]
    },
    {
      "id": 5561,
      "bciAvId": 25962,
      "gloss": "watchdog",
      "glossSv": "vakthund",
      "pos": "noun",
      "explanation": "dog + watch",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        969,
        "/",
        401
      ]
    },
    {
      "id": 5562,
      "bciAvId": 25963,
      "gloss": "way",
      "glossSv": "väg",
      "pos": "noun",
      "explanation": "place + forward: a place on the ground leading forward",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        335
      ]
    },
    {
      "id": 5563,
      "bciAvId": 25964,
      "gloss": "very much, very many",
      "glossSv": "väldigt mycket, väldigt många",
      "pos": "description",
      "explanation": "very + very + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        ";",
        86,
        "/",
        368
      ]
    },
    {
      "id": 5564,
      "bciAvId": 25965,
      "gloss": "westward",
      "glossSv": "västerut",
      "pos": "description",
      "explanation": "forward + west + description indicator: forward representing direction [contraction]",
      "isCharacter": false,
      "composition": [
        335,
        ";",
        86,
        "/",
        698
      ]
    },
    {
      "id": 5565,
      "bciAvId": 25966,
      "gloss": "wheelchair tricycle",
      "glossSv": "trehjulig rullstol med tre hjul",
      "pos": "noun",
      "explanation": "tricycle + wheelchair",
      "isCharacter": false,
      "composition": [
        12,
        "/",
        700,
        "/",
        701
      ]
    },
    {
      "id": 5566,
      "bciAvId": 25967,
      "gloss": "winter day",
      "glossSv": "vinterdag",
      "pos": "noun",
      "explanation": "day + winter: only numbers are used, as seasons are different in different parts of the world",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        636,
        "/",
        13
      ]
    },
    {
      "id": 5567,
      "bciAvId": 25968,
      "gloss": "winter house",
      "glossSv": "vinterbostad",
      "pos": "noun",
      "explanation": "house + winter: only numbers are used, as seasons are different in different parts of the world",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        636,
        "/",
        13
      ]
    },
    {
      "id": 5568,
      "bciAvId": 25969,
      "gloss": "woodpecker",
      "glossSv": "hackspett",
      "pos": "noun",
      "explanation": "bird + chop-(to)",
      "isCharacter": false,
      "composition": [
        163,
        "/",
        411,
        "/",
        401
      ]
    },
    {
      "id": 5569,
      "bciAvId": 25970,
      "gloss": "work method",
      "glossSv": "arbetsmetod, arbetssätt",
      "pos": "noun",
      "explanation": "plan,design,method,system + work",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        711
      ]
    },
    {
      "id": 5570,
      "bciAvId": 25971,
      "gloss": "zigzag",
      "glossSv": "sicksack, i sicksack",
      "pos": "description",
      "explanation": "zigzag line + description indicator",
      "isCharacter": false,
      "composition": [
        1126,
        ";",
        86
      ]
    },
    {
      "id": 5571,
      "bciAvId": 25980,
      "gloss": "band (of frequencies)",
      "glossSv": "frekvensband, frekvensområde",
      "pos": "noun",
      "explanation": "signal + limit(s),limitation,restriction: signal or frequencies in a certain range",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        1053
      ]
    },
    {
      "id": 5572,
      "bciAvId": 25981,
      "gloss": "beach tennis (activity)",
      "glossSv": "strandtennis (aktivitet)",
      "pos": "noun",
      "explanation": "tennis (activity) + beach",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        555,
        "/",
        153
      ]
    },
    {
      "id": 5573,
      "bciAvId": 25982,
      "gloss": "beach tennis (sport)",
      "glossSv": "strandtennis (sport)",
      "pos": "noun",
      "explanation": "tennis,racket sport,racquet sport + beach",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        555,
        "/",
        153
      ]
    },
    {
      "id": 5574,
      "bciAvId": 25983,
      "gloss": "beyond, past",
      "glossSv": "bortom",
      "pos": "description",
      "explanation": "outside + limit(s),limitation,restriction + description indicator",
      "isCharacter": false,
      "composition": [
        490,
        "/",
        1053,
        ";",
        86
      ]
    },
    {
      "id": 5575,
      "bciAvId": 25984,
      "gloss": "binoculars, field glass",
      "glossSv": "kikare",
      "pos": "noun",
      "explanation": "tool + to look + distance",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        303,
        "/",
        1033
      ]
    },
    {
      "id": 5576,
      "bciAvId": 25985,
      "gloss": "broadband",
      "glossSv": "bredband",
      "pos": "noun",
      "explanation": "band (of frequencies) + fast",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        1053,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 5577,
      "bciAvId": 25986,
      "gloss": "church ruin, temple ruin, wreck, wreckage (church, temple, mosque) (1)",
      "glossSv": "kyrkoruin, tempelruin (1)",
      "pos": "noun",
      "explanation": "ruin,wreck,wreckage (building) (1) + God: combination of ruin and church,mosque,temple",
      "isCharacter": false,
      "composition": [
        1079,
        "/",
        355
      ]
    },
    {
      "id": 5578,
      "bciAvId": 25987,
      "gloss": "control",
      "glossSv": "kontroll",
      "pos": "noun",
      "explanation": "leadership + limit(s),limitation,restriction",
      "isCharacter": false,
      "composition": [
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5579,
      "bciAvId": 25988,
      "gloss": "corruption",
      "glossSv": "korruption",
      "pos": "noun",
      "explanation": "abuse [contraction] + power,powerfulness [contraction] + selfish",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        803,
        "/",
        1053,
        "/",
        964
      ]
    },
    {
      "id": 5580,
      "bciAvId": 25989,
      "gloss": "Danish (class)",
      "glossSv": "danska (skolämne)",
      "pos": "noun",
      "explanation": "class [contraction] + Danish (language)",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        414,
        "/",
        12,
        "/",
        695
      ]
    },
    {
      "id": 5581,
      "bciAvId": 25990,
      "gloss": "Danish (language)",
      "glossSv": "danska",
      "pos": "noun",
      "explanation": "language + 3 + water: based on Denmark [contraction]",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        12,
        "/",
        695
      ]
    },
    {
      "id": 5582,
      "bciAvId": 25991,
      "gloss": "Denmark",
      "glossSv": "Danmark",
      "pos": "noun",
      "explanation": "country + 3 + water: country divided by three channels of water",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        12,
        "/",
        695
      ]
    },
    {
      "id": 5583,
      "bciAvId": 25992,
      "gloss": "disability, handicap, impairment",
      "glossSv": "handikapp, funktionshinder, funktionsnedsättning",
      "pos": "noun",
      "explanation": "ability,capability,capacity,potential + limit(s),limitation,restriction",
      "isCharacter": false,
      "composition": [
        101,
        "/",
        1053
      ]
    },
    {
      "id": 5584,
      "bciAvId": 25993,
      "gloss": "disability benefit",
      "glossSv": "aktivitetsersättning, sjukersättning",
      "pos": "noun",
      "explanation": "money + disability,handicap,impairment",
      "isCharacter": false,
      "composition": [
        451,
        "/",
        101,
        "/",
        1053
      ]
    },
    {
      "id": 5585,
      "bciAvId": 25994,
      "gloss": "disabled, impaired, handicapped (intellectually, mentally)",
      "glossSv": "förståndshandikappad, utvecklingsstörd",
      "pos": "description",
      "explanation": "intellectual impairment,cognitive impairment,mental impairment + description indicator: having limits to one's mental abilities",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        447
      ]
    },
    {
      "id": 5586,
      "bciAvId": 25995,
      "gloss": "disabled, impaired, handicapped (physically)",
      "glossSv": "rörelsehindrad",
      "pos": "description",
      "explanation": "physical impairment,physical disability + description indicator: having limits to one's physical abilities",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        171
      ]
    },
    {
      "id": 5587,
      "bciAvId": 25996,
      "gloss": "distance",
      "glossSv": "avstånd",
      "pos": "noun",
      "explanation": "measurement + farness,remoteness,farawayness",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        1033
      ]
    },
    {
      "id": 5588,
      "bciAvId": 25997,
      "gloss": "to empower",
      "glossSv": "ge egenmakt, ge rättighet, stärka",
      "pos": "action",
      "explanation": "empowerment + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5589,
      "bciAvId": 25998,
      "gloss": "empowered",
      "glossSv": "berättigad, styrkt",
      "pos": "description",
      "explanation": "empowerment + description indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        86,
        "/",
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5590,
      "bciAvId": 25999,
      "gloss": "empowerment",
      "glossSv": "egenmakt, befogenhet",
      "pos": "noun",
      "explanation": "give + power,powerfulness [contraction]",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5591,
      "bciAvId": 26000,
      "gloss": "eternal",
      "glossSv": "evig",
      "pos": "description",
      "explanation": "eternity,infinity + description indicator",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        449,
        "/",
        1053
      ]
    },
    {
      "id": 5592,
      "bciAvId": 26001,
      "gloss": "eternity, infinity",
      "glossSv": "evighet, oändlighet",
      "pos": "noun",
      "explanation": "time + infiniteness,boundlessness,limitlessness",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        449,
        "/",
        1053
      ]
    },
    {
      "id": 5593,
      "bciAvId": 26002,
      "gloss": "far, distant, remote",
      "glossSv": "långt bort, avlägsen, fjärran",
      "pos": "description",
      "explanation": "farness,remoteness,farawayness + description indicator",
      "isCharacter": false,
      "composition": [
        1033,
        ";",
        86
      ]
    },
    {
      "id": 5594,
      "bciAvId": 26003,
      "gloss": "fat, thick",
      "glossSv": "tjock, fet",
      "pos": "description",
      "explanation": "fatness,thickness + description indicator",
      "isCharacter": false,
      "composition": [
        1034,
        ";",
        86
      ]
    },
    {
      "id": 5595,
      "bciAvId": 26004,
      "gloss": "guess, estimation",
      "glossSv": "gissning, uppskattning, bedömning",
      "pos": "noun",
      "explanation": "doubt + plus minus: reason on the basis of information of uncertain accuracy",
      "isCharacter": false,
      "composition": [
        802,
        "/",
        1069
      ]
    },
    {
      "id": 5596,
      "bciAvId": 26005,
      "gloss": "gym, gymnasium",
      "glossSv": "gymnastiksal, gym",
      "pos": "noun",
      "explanation": "room + sport",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        719
      ]
    },
    {
      "id": 5597,
      "bciAvId": 26006,
      "gloss": "gym mat",
      "glossSv": "gymnastikmatta",
      "pos": "noun",
      "explanation": "rug,carpet,mat + sport",
      "isCharacter": false,
      "composition": [
        324,
        "/",
        719
      ]
    },
    {
      "id": 5598,
      "bciAvId": 26007,
      "gloss": "Halloween",
      "glossSv": "Halloween",
      "pos": "noun",
      "explanation": "day + ghost,phantom",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        838,
        "/",
        303,
        "/",
        653
      ]
    },
    {
      "id": 5599,
      "bciAvId": 26008,
      "gloss": "hearing impairment",
      "glossSv": "hörselskada, hörselnedsättning",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + ear: ear representing hearing or to hear",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        278
      ]
    },
    {
      "id": 5600,
      "bciAvId": 26009,
      "gloss": "hearing-impaired",
      "glossSv": "hörselskadad",
      "pos": "description",
      "explanation": "hearing impairment + description indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        278
      ]
    },
    {
      "id": 5601,
      "bciAvId": 26010,
      "gloss": "infinite, limitless",
      "glossSv": "obegränsad, gränslös, oändlig",
      "pos": "description",
      "explanation": "infiniteness,boundlessness,limitlessness + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        1053,
        ";",
        86
      ]
    },
    {
      "id": 5602,
      "bciAvId": 26011,
      "gloss": "infiniteness, boundlessness, limitlessness",
      "glossSv": "gränslöshet, oändlighet",
      "pos": "noun",
      "explanation": "minus,no,without + limit(s),limitation,restriction",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        1053
      ]
    },
    {
      "id": 5603,
      "bciAvId": 26012,
      "gloss": "intellectual impairment, cognitive impairment, mental impairment",
      "glossSv": "förståndshandikappad, utvecklingsstörd",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + mind,intellect,reason: limitation to one's mental abilities",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        447
      ]
    },
    {
      "id": 5604,
      "bciAvId": 26013,
      "gloss": "lacrosse (sport)",
      "glossSv": "lacrosse (sport)",
      "pos": "noun",
      "explanation": "tennis,racket sport,racquet sport + group: group representing team (sport) [contraction]",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        555,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 5605,
      "bciAvId": 26014,
      "gloss": "to limit, to restrict, to restrain, to confine",
      "glossSv": "begränsa, avgränsa, inskränka",
      "pos": "action",
      "explanation": "limit(s),limitation,restriction + description indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        81
      ]
    },
    {
      "id": 5606,
      "bciAvId": 26015,
      "gloss": "limited, restricted, confined",
      "glossSv": "begränsad, avgränsad, inskränkt",
      "pos": "description",
      "explanation": "limit(s),limitation,restriction + action indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86
      ]
    },
    {
      "id": 5607,
      "bciAvId": 26016,
      "gloss": "Loki",
      "glossSv": "Loke",
      "pos": "person",
      "explanation": "Nordic God + lie: the God of falseness",
      "isCharacter": false,
      "composition": [
        355,
        "/",
        472,
        "/",
        449,
        "/",
        670
      ]
    },
    {
      "id": 5608,
      "bciAvId": 26017,
      "gloss": "long jump (sport)",
      "glossSv": "längdhopp (sport)",
      "pos": "noun",
      "explanation": "sport + jump + far,distant",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        836,
        "/",
        1033
      ]
    },
    {
      "id": 5609,
      "bciAvId": 26018,
      "gloss": "louse, stinging insect",
      "glossSv": "lus, stickande insekt",
      "pos": "noun",
      "explanation": "insect + puncture,prick-(to): insect that punctures, the skin or leaves or stems of plants",
      "isCharacter": false,
      "composition": [
        400,
        "/",
        538
      ]
    },
    {
      "id": 5610,
      "bciAvId": 26019,
      "gloss": "odometer",
      "glossSv": "vägmätare, odometer",
      "pos": "noun",
      "explanation": "gauge + farness,remoteness,farawayness + thing indicator: a meter that measures distance",
      "isCharacter": false,
      "composition": [
        927,
        ";",
        97,
        "/",
        1033
      ]
    },
    {
      "id": 5611,
      "bciAvId": 26020,
      "gloss": "physical impairment, physical disability",
      "glossSv": "rörelsehinder",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + body: limitations to one's physical abilities",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        171
      ]
    },
    {
      "id": 5612,
      "bciAvId": 26021,
      "gloss": "placenta",
      "glossSv": "moderkaka, placenta",
      "pos": "noun",
      "explanation": "organ + food + fetus",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        329,
        "/",
        316
      ]
    },
    {
      "id": 5613,
      "bciAvId": 26022,
      "gloss": "power, powerfulness",
      "glossSv": "makt",
      "pos": "noun",
      "explanation": "ability + control",
      "isCharacter": false,
      "composition": [
        101,
        "/",
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5614,
      "bciAvId": 26023,
      "gloss": "powerful, mighty",
      "glossSv": "mäktig",
      "pos": "description",
      "explanation": "power,powerfulness + description indicator",
      "isCharacter": false,
      "composition": [
        101,
        ";",
        86,
        "/",
        803,
        "/",
        1053
      ]
    },
    {
      "id": 5615,
      "bciAvId": 26024,
      "gloss": "sitski, sit ski (sport)",
      "glossSv": "sitski (sport)",
      "pos": "noun",
      "explanation": "sport + sitski,sit ski",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1083
      ]
    },
    {
      "id": 5616,
      "bciAvId": 26025,
      "gloss": "speech impaired",
      "glossSv": "talskadad",
      "pos": "description",
      "explanation": "speech impairment,dysarthria + description indicator: having limits to one's physical abilities",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        457
      ]
    },
    {
      "id": 5617,
      "bciAvId": 26026,
      "gloss": "speech impairment, dysarthria",
      "glossSv": "talskada, dysartri",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + to speak: having difficulties to speak intelligibly",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        457
      ]
    },
    {
      "id": 5618,
      "bciAvId": 26027,
      "gloss": "squash (sport)",
      "glossSv": "squash (sport)",
      "pos": "noun",
      "explanation": "tennis,racket sport,racquet sport + room",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        555,
        "/",
        572
      ]
    },
    {
      "id": 5619,
      "bciAvId": 26028,
      "gloss": "table tennis, ping-pong (activity)",
      "glossSv": "bordtennis (aktivitet)",
      "pos": "noun",
      "explanation": "tennis (activity) + table: game like tennis, played on a table",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        555,
        "/",
        639
      ]
    },
    {
      "id": 5620,
      "bciAvId": 26029,
      "gloss": "table tennis, ping-pong (sport)",
      "glossSv": "bordtennis (sport)",
      "pos": "noun",
      "explanation": "tennis,racket sport,racquet sport + table",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        555,
        "/",
        639
      ]
    },
    {
      "id": 5621,
      "bciAvId": 26030,
      "gloss": "tennis, racket sport, racquet sport",
      "glossSv": "tennis, racketsport",
      "pos": "noun",
      "explanation": "sport + racket,racquet",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        555
      ]
    },
    {
      "id": 5622,
      "bciAvId": 26031,
      "gloss": "tennis (activity)",
      "glossSv": "tennis (aktivitet)",
      "pos": "noun",
      "explanation": "activity + racket,racquet: game played with racquets",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        555
      ]
    },
    {
      "id": 5623,
      "bciAvId": 26032,
      "gloss": "visual impairment",
      "glossSv": "synskada, synnedsättning",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + to see: difficulties to see",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        303
      ]
    },
    {
      "id": 5624,
      "bciAvId": 26033,
      "gloss": "visually impaired",
      "glossSv": "synskadad",
      "pos": "description",
      "explanation": "visual impairment + description indicator: having difficulties to see",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        303
      ]
    },
    {
      "id": 5625,
      "bciAvId": 26100,
      "gloss": "cruelty, mercilessness, ruthlessness",
      "glossSv": "grymhet, hänsynslöshet, hjärtlöshet",
      "pos": "noun",
      "explanation": "feeling + knife: ”sharp”, ”cutting” and harmful behaviour",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        411
      ]
    },
    {
      "id": 5626,
      "bciAvId": 26101,
      "gloss": "democracy",
      "glossSv": "demokrati",
      "pos": "noun",
      "explanation": "permission,allowance + choice",
      "isCharacter": false,
      "composition": [
        960,
        "/",
        223
      ]
    },
    {
      "id": 5627,
      "bciAvId": 26102,
      "gloss": "endlessness",
      "glossSv": "oändlighet",
      "pos": "noun",
      "explanation": "without + end",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        292
      ]
    },
    {
      "id": 5628,
      "bciAvId": 26103,
      "gloss": "floating, afloat",
      "glossSv": "flytande (på vatten)",
      "pos": "description",
      "explanation": "floating container + description indicator",
      "isCharacter": false,
      "composition": [
        1036,
        ";",
        86
      ]
    },
    {
      "id": 5629,
      "bciAvId": 26104,
      "gloss": "interrogation",
      "glossSv": "förhör",
      "pos": "noun",
      "explanation": "question + intensity",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        401
      ]
    },
    {
      "id": 5630,
      "bciAvId": 26105,
      "gloss": "defeat, loss (competition)",
      "glossSv": "förlust (i tävling)",
      "pos": "noun",
      "explanation": "competition + loss",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        634
      ]
    },
    {
      "id": 5631,
      "bciAvId": 26106,
      "gloss": "mourning, grief",
      "glossSv": "sorg, saknad",
      "pos": "noun",
      "explanation": "sadness + loss",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        634
      ]
    },
    {
      "id": 5632,
      "bciAvId": 26107,
      "gloss": "translation",
      "glossSv": "översättning",
      "pos": "noun",
      "explanation": "bridge + language",
      "isCharacter": false,
      "composition": [
        182,
        "/",
        414
      ]
    },
    {
      "id": 5633,
      "bciAvId": 26108,
      "gloss": "underground, below ground",
      "glossSv": "under jord, under marken",
      "pos": "description",
      "explanation": "under (ground level) + description indicator",
      "isCharacter": false,
      "composition": [
        1102,
        ";",
        86
      ]
    },
    {
      "id": 5634,
      "bciAvId": 26120,
      "gloss": "All Saints' Day",
      "glossSv": "Alla Helgons dag, allhelgonadagen",
      "pos": "noun",
      "explanation": "day + all + saint",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        117,
        "/",
        513,
        "/",
        738
      ]
    },
    {
      "id": 5635,
      "bciAvId": 26121,
      "gloss": "animal (cold-blooded), cold-blooded animal, poikilotherm, ectotherm",
      "glossSv": "djur (kallblodigt), kallblodigt djur",
      "pos": "noun",
      "explanation": "animal,beast + temperature + up and down: animal with varying body temperature, generally depending on the external temperature of the environment",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        645,
        "/",
        723
      ]
    },
    {
      "id": 5636,
      "bciAvId": 26122,
      "gloss": "animal (warm-blooded), warm-blooded animal, homeotherm, endotherm",
      "glossSv": "djur (varmblodigt), varmblodigt djur",
      "pos": "noun",
      "explanation": "animal,beast + temperature + same,equal,equality: animal with stable body temperature, generally controlled by internal bodily functions",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        645,
        "/",
        578
      ]
    },
    {
      "id": 5637,
      "bciAvId": 26123,
      "gloss": "arthropod(s)",
      "glossSv": "leddjur",
      "pos": "noun",
      "explanation": "generalization + shellfish (without claws): invertebrate animals having an external skeleton, a segmented body, and jointed appendages, include insects, arachnids (spiders etc.), myriapods, and crustaceans (crabs, crayfish, shrimps etc.)",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        818
      ]
    },
    {
      "id": 5638,
      "bciAvId": 26124,
      "gloss": "assistance dog",
      "glossSv": "ledarhund, assistenthund, hund (för assistans)",
      "pos": "noun",
      "explanation": "dog,canine (animal),canid + help,aid,assistance,support",
      "isCharacter": false,
      "composition": [
        124,
        "/",
        382
      ]
    },
    {
      "id": 5639,
      "bciAvId": 26125,
      "gloss": "atlas, book of maps",
      "glossSv": "atlas, kartbok",
      "pos": "noun",
      "explanation": "book + map",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        497,
        "/",
        281
      ]
    },
    {
      "id": 5640,
      "bciAvId": 26126,
      "gloss": "attempt, effort, try",
      "glossSv": "försök, ansträngning",
      "pos": "noun",
      "explanation": "forward + difficulty: forward move, with difficulty",
      "isCharacter": true
    },
    {
      "id": 5641,
      "bciAvId": 26127,
      "gloss": "attendance list, register list, contact list",
      "glossSv": "närvarolista, kontaktlista, adresslista, lista (person)",
      "pos": "noun",
      "explanation": "paper + group: documentation of a group of people",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 5642,
      "bciAvId": 26128,
      "gloss": "auditory system",
      "glossSv": "hörselorganet",
      "pos": "noun",
      "explanation": "generalization + organ,inner organ,inner body part + ear",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        278
      ]
    },
    {
      "id": 5643,
      "bciAvId": 26129,
      "gloss": "badger",
      "glossSv": "grävling",
      "pos": "noun",
      "explanation": "animal + smell,odour [contraction of mustelid] + many + line",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        600,
        "/",
        368,
        "/",
        428
      ]
    },
    {
      "id": 5644,
      "bciAvId": 26130,
      "gloss": "bedtime",
      "glossSv": "sängdags",
      "pos": "noun",
      "explanation": "time + bed",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        156
      ]
    },
    {
      "id": 5645,
      "bciAvId": 26131,
      "gloss": "bouquet (flowers)",
      "glossSv": "bukett",
      "pos": "noun",
      "explanation": "many + flower + attachment,appendix,annex: many flowers together",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        325,
        "/",
        823
      ]
    },
    {
      "id": 5646,
      "bciAvId": 26132,
      "gloss": "brook, creek",
      "glossSv": "bäck, å",
      "pos": "noun",
      "explanation": "river,stream,current + littleness,smallness: a small stream of water",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        956
      ]
    },
    {
      "id": 5647,
      "bciAvId": 26133,
      "gloss": "burial mound, grave mound",
      "glossSv": "gravhög",
      "pos": "noun",
      "explanation": "grave + group of + stone: a heap of stones and earth placed over typically prehistoric tombs",
      "isCharacter": false,
      "composition": [
        367,
        "/",
        368,
        "/",
        629
      ]
    },
    {
      "id": 5648,
      "bciAvId": 26134,
      "gloss": "capital, capital city",
      "glossSv": "huvudstad",
      "pos": "noun",
      "explanation": "town,city + country,state: the city of primary status in a country, state, or province, usually as its seat of government",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        368,
        "/",
        392,
        "/",
        243
      ]
    },
    {
      "id": 5649,
      "bciAvId": 26135,
      "gloss": "carnivore",
      "glossSv": "djur (köttätare), rovdjur",
      "pos": "noun",
      "explanation": "animal,beast + meat: animal that eats (the meat of) other animals",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        329,
        "/",
        122
      ]
    },
    {
      "id": 5650,
      "bciAvId": 26136,
      "gloss": "carpenter",
      "glossSv": "snickare, timmerman",
      "pos": "noun",
      "explanation": "person + carpentry [contraction with omission of work]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        660,
        "/",
        666
      ]
    },
    {
      "id": 5651,
      "bciAvId": 26137,
      "gloss": "carpentry, wood work",
      "glossSv": "snickeri, träarbete",
      "pos": "noun",
      "explanation": "work + tool + tree [contraction of wood (material + tree)]: work with tools for building with wood",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        660,
        "/",
        666
      ]
    },
    {
      "id": 5652,
      "bciAvId": 26138,
      "gloss": "character (in a story)",
      "glossSv": "person (i en saga eller berättelse)",
      "pos": "noun",
      "explanation": "person + story,tale",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        497,
        "/",
        457
      ]
    },
    {
      "id": 5653,
      "bciAvId": 26139,
      "gloss": "to charge (electricity)",
      "glossSv": "ladda (med elektricitet)",
      "pos": "action",
      "explanation": "fill-(to) + electricity + action indicator",
      "isCharacter": false,
      "composition": [
        947,
        ";",
        81,
        "/",
        288
      ]
    },
    {
      "id": 5654,
      "bciAvId": 26140,
      "gloss": "charged (electricity)",
      "glossSv": "laddad (elektriskt)",
      "pos": "description",
      "explanation": "full + electricity + description indicator",
      "isCharacter": false,
      "composition": [
        947,
        ";",
        86,
        "/",
        288
      ]
    },
    {
      "id": 5655,
      "bciAvId": 26141,
      "gloss": "charger, battery charger",
      "glossSv": "laddare (elektrisk), batteriladdare",
      "pos": "noun",
      "explanation": "thing + filling,fill,fullness + electricity: thing for charging with electricity",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        947,
        "/",
        288
      ]
    },
    {
      "id": 5656,
      "bciAvId": 26142,
      "gloss": "cheetah",
      "glossSv": "gepard",
      "pos": "noun",
      "explanation": "cat,feline (animal),felid + quickness,rapidity,speediness: cat animal that is the swiftest mammal",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 5657,
      "bciAvId": 26143,
      "gloss": "chromosome",
      "glossSv": "kromosom",
      "pos": "noun",
      "explanation": "fiber,fibre,fibril,filament,strand + atom + spiral [the latter two is a contraction of the DNA molecule]: the threadlike body in the cell nucleus that carries the DNA spiral molecule with genes in a linear order",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        136,
        "/",
        1090
      ]
    },
    {
      "id": 5658,
      "bciAvId": 26144,
      "gloss": "clothes line, drying line",
      "glossSv": "klädstreck, tvättlina",
      "pos": "noun",
      "explanation": "filament [contraction of thread,string,cord] + dryness: line for drying clothes etc.",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        860
      ]
    },
    {
      "id": 5659,
      "bciAvId": 26145,
      "gloss": "colouring book, coloring book",
      "glossSv": "målarbok",
      "pos": "noun",
      "explanation": "book + pen + colour",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        509,
        "/",
        1161
      ]
    },
    {
      "id": 5660,
      "bciAvId": 26146,
      "gloss": "communication impaired",
      "glossSv": "kommunikationsnedsättning (peron med)",
      "pos": "description",
      "explanation": "communication impairment + description indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        1029,
        "/",
        440
      ]
    },
    {
      "id": 5661,
      "bciAvId": 26147,
      "gloss": "communication impairment",
      "glossSv": "kommunikationsnedsättning, kommunikationsstörning",
      "pos": "noun",
      "explanation": "limit(s),limitation,restriction + communication",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        1029,
        "/",
        440
      ]
    },
    {
      "id": 5662,
      "bciAvId": 26148,
      "gloss": "compost",
      "glossSv": "kompost",
      "pos": "noun",
      "explanation": "mixture + change,alteration + earth,ground,land: mixture that is transformed into earth",
      "isCharacter": false,
      "composition": [
        783,
        "/",
        213,
        "/",
        281
      ]
    },
    {
      "id": 5663,
      "bciAvId": 26149,
      "gloss": "confusion (feeling)",
      "glossSv": "förvirring (känsla)",
      "pos": "noun",
      "explanation": "feeling,emotion,sensation + mixture: mixed feelings about something",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        783
      ]
    },
    {
      "id": 5664,
      "bciAvId": 26150,
      "gloss": "confusion (mental)",
      "glossSv": "förvirring (mental)",
      "pos": "noun",
      "explanation": "mind,intellect,reason + mixture: mixed thinking about something",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        783
      ]
    },
    {
      "id": 5665,
      "bciAvId": 26151,
      "gloss": "cookbook, cookery book",
      "glossSv": "kokbok",
      "pos": "noun",
      "explanation": "book + cooking,cookery,preparation (general)",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        840,
        "/",
        329
      ]
    },
    {
      "id": 5666,
      "bciAvId": 26152,
      "gloss": "cycle of life, life cycle",
      "glossSv": "livscykel",
      "pos": "noun",
      "explanation": "rotation,circulation,orbit,lap,circle,round + life: the cycle of generation of life, life span, death, and regeneration of new life",
      "isCharacter": false,
      "composition": [
        887,
        "/",
        423
      ]
    },
    {
      "id": 5667,
      "bciAvId": 26153,
      "gloss": "dictionary, lexicon, wordbook",
      "glossSv": "lexikon, ordbok, ordlista",
      "pos": "noun",
      "explanation": "book + word: a reference book containing an alphabetical list of words with information about them",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5668,
      "bciAvId": 26154,
      "gloss": "digital game, video game, computer game",
      "glossSv": "datorspel, videospel",
      "pos": "noun",
      "explanation": "play,game (in combinations) + digits (computer): any kind of digital game on computers, game consoles or mobile devices",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        829
      ]
    },
    {
      "id": 5669,
      "bciAvId": 26155,
      "gloss": "diversity, variety (general)",
      "glossSv": "mångfald",
      "pos": "noun",
      "explanation": "group of,much of,many of,quantity of + different,other,difference: many of something being different in character, a heterogeneous group",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        262
      ]
    },
    {
      "id": 5670,
      "bciAvId": 26156,
      "gloss": "DNA",
      "glossSv": "DNA",
      "pos": "noun",
      "explanation": "atom [contraction of molecule] + life + spiral: the spiral formed DNA molecule of life carrying the genetic code",
      "isCharacter": false,
      "composition": [
        136,
        "/",
        423,
        "/",
        1090
      ]
    },
    {
      "id": 5671,
      "bciAvId": 26157,
      "gloss": "download",
      "glossSv": "nedlddning",
      "pos": "noun",
      "explanation": "receiving + digits (computer): the getting of digital data from a server on the internet",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        829
      ]
    },
    {
      "id": 5672,
      "bciAvId": 26158,
      "gloss": "to download",
      "glossSv": "ladda ned",
      "pos": "action",
      "explanation": "download + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 5673,
      "bciAvId": 26159,
      "gloss": "dragon",
      "glossSv": "drake (sagodjur)",
      "pos": "noun",
      "explanation": "animal,beast + fire",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        319
      ]
    },
    {
      "id": 5674,
      "bciAvId": 26160,
      "gloss": "drying rack",
      "glossSv": "torkställning",
      "pos": "noun",
      "explanation": "structure,construction + dryness,drought: construction for drying something",
      "isCharacter": false,
      "composition": [
        633,
        "/",
        860
      ]
    },
    {
      "id": 5675,
      "bciAvId": 26161,
      "gloss": "drying rack (cloth)",
      "glossSv": "torkställning ( för kläder)",
      "pos": "noun",
      "explanation": "drying rack + cloth",
      "isCharacter": false,
      "composition": [
        633,
        "/",
        860,
        "/",
        228
      ]
    },
    {
      "id": 5676,
      "bciAvId": 26162,
      "gloss": "drying rack (fish)",
      "glossSv": "torkställning (för fisk)",
      "pos": "noun",
      "explanation": "drying rack + fish",
      "isCharacter": false,
      "composition": [
        633,
        "/",
        860,
        "/",
        321
      ]
    },
    {
      "id": 5677,
      "bciAvId": 26163,
      "gloss": "ear bone, ossicle, auditory ossicle",
      "glossSv": "hörselben",
      "pos": "noun",
      "explanation": "bone + ear",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        278
      ]
    },
    {
      "id": 5678,
      "bciAvId": 26164,
      "gloss": "eardrum, tympanic membrane",
      "glossSv": "trummhinna",
      "pos": "noun",
      "explanation": "membrane,drumhead,drum skin + ear",
      "isCharacter": false,
      "composition": [
        1155,
        "/",
        278
      ]
    },
    {
      "id": 5679,
      "bciAvId": 26166,
      "gloss": "equality (social)",
      "glossSv": "jämlikhet (social)",
      "pos": "noun",
      "explanation": "same,equal,equality + society: a certain level of general social equality among citizens of a state or community",
      "isCharacter": false,
      "composition": [
        578,
        "/",
        348,
        "/",
        225
      ]
    },
    {
      "id": 5680,
      "bciAvId": 26167,
      "gloss": "exercise (physical)",
      "glossSv": "motion (fysisk), träning (fysisk)",
      "pos": "noun",
      "explanation": "work + health: work, in order to maintain health",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        377
      ]
    },
    {
      "id": 5681,
      "bciAvId": 26168,
      "gloss": "face painting",
      "glossSv": "ansiktsmålning",
      "pos": "noun",
      "explanation": "picture,image,icon,painting + face + brush: painting on the face made with brush",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        291,
        "/",
        306,
        "/",
        184
      ]
    },
    {
      "id": 5682,
      "bciAvId": 26169,
      "gloss": "fear of heights, acrophobia",
      "glossSv": "höjdskräck",
      "pos": "noun",
      "explanation": "fear,fright,concern + height,tallness",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        1042,
        "/",
        952
      ]
    },
    {
      "id": 5683,
      "bciAvId": 26170,
      "gloss": "fishing line",
      "glossSv": "fiskelina, metrev",
      "pos": "noun",
      "explanation": "filament [contraction of thread,string,cord] + reception + fish: line for catching fish",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        920,
        "/",
        321
      ]
    },
    {
      "id": 5684,
      "bciAvId": 26171,
      "gloss": "fishing rod",
      "glossSv": "metspö, fiskspö",
      "pos": "noun",
      "explanation": "linear thing + reception + fish: rod for catching fish",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        920,
        "/",
        321
      ]
    },
    {
      "id": 5685,
      "bciAvId": 26172,
      "gloss": "fist",
      "glossSv": "näve, knytnäve",
      "pos": "noun",
      "explanation": "hand + fold,folding",
      "isCharacter": false,
      "composition": [
        374,
        "/",
        1038
      ]
    },
    {
      "id": 5686,
      "bciAvId": 26173,
      "gloss": "flight attendant",
      "glossSv": "flygvärdinna, flygvärd, steward",
      "pos": "person",
      "explanation": "worker + airplane,aeroplane,plane",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        115
      ]
    },
    {
      "id": 5687,
      "bciAvId": 26174,
      "gloss": "gene",
      "glossSv": "gen",
      "pos": "noun",
      "explanation": "part,bit,piece,portion,part of + DNA: section of the DNA molecule that encodes the production of a certain polypeptide chain, a unit of heredity",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        136,
        "/",
        423,
        "/",
        1090
      ]
    },
    {
      "id": 5688,
      "bciAvId": 26175,
      "gloss": "genetics",
      "glossSv": "genetik",
      "pos": "noun",
      "explanation": "science,body of learning + atom + spiral: contraction of science + gene",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        136,
        "/",
        1090
      ]
    },
    {
      "id": 5689,
      "bciAvId": 26176,
      "gloss": "gill",
      "glossSv": "gäl",
      "pos": "noun",
      "explanation": "organ,inner organ,inner body part + breath + fish: The respiratory organ of fish and other aquatic animals",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        473,
        "/",
        457,
        "/",
        321
      ]
    },
    {
      "id": 5690,
      "bciAvId": 26177,
      "gloss": "herbivore",
      "glossSv": "växtätare (djur)",
      "pos": "noun",
      "explanation": "animal,beast + food + plant: animals that primarily eat plants",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        329,
        "/",
        533
      ]
    },
    {
      "id": 5691,
      "bciAvId": 26178,
      "gloss": "hierarchy",
      "glossSv": "hierarki",
      "pos": "noun",
      "explanation": "layer,level + plan,design,method,system: a series of ordered groupings or levels of people or things within a system",
      "isCharacter": false,
      "composition": [
        1116,
        "/",
        532
      ]
    },
    {
      "id": 5692,
      "bciAvId": 26179,
      "gloss": "honest, honestly",
      "glossSv": "ärlig, ärligt",
      "pos": "description",
      "explanation": "honesty + description indicator",
      "isCharacter": false,
      "composition": [
        551,
        ";",
        86,
        "/",
        670
      ]
    },
    {
      "id": 5693,
      "bciAvId": 26180,
      "gloss": "honesty",
      "glossSv": "ärlighet",
      "pos": "noun",
      "explanation": "purpose + truth: strive for truth",
      "isCharacter": false,
      "composition": [
        551,
        "/",
        670
      ]
    },
    {
      "id": 5694,
      "bciAvId": 26181,
      "gloss": "hyena",
      "glossSv": "hyena",
      "pos": "noun",
      "explanation": "animal,beast + sound + up,upward + mouth [up + mouth is a contraction of laugh,laughter]: the hyena is known for its laughing sound",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        608,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 5695,
      "bciAvId": 26182,
      "gloss": "indigestion, heartburn",
      "glossSv": "matsmältningsbesvär, halsbränna",
      "pos": "noun",
      "explanation": "feeling + illness + inner organ + food [organ + food is a contraction of stomach,tummy,tum]",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        993,
        "/",
        329
      ]
    },
    {
      "id": 5696,
      "bciAvId": 26183,
      "gloss": "industry",
      "glossSv": "industri",
      "pos": "noun",
      "explanation": "generalization + factory,plant",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        392,
        "/",
        840
      ]
    },
    {
      "id": 5697,
      "bciAvId": 26184,
      "gloss": "inequality",
      "glossSv": "olikhet, ojämlikhet (social)",
      "pos": "noun",
      "explanation": "different,other,difference + society: social inequality among citizens or members of a state or community",
      "isCharacter": false,
      "composition": [
        262,
        "/",
        348,
        "/",
        225
      ]
    },
    {
      "id": 5698,
      "bciAvId": 26185,
      "gloss": "invertebrate",
      "glossSv": "ryggradslös (djur)",
      "pos": "noun",
      "explanation": "animal + without + spine,backbone",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        449,
        "/",
        172,
        "/",
        143
      ]
    },
    {
      "id": 5699,
      "bciAvId": 26186,
      "gloss": "justification",
      "glossSv": "berättigande, rättfärdigande",
      "pos": "noun",
      "explanation": "support (oral) + correctness",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        332,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 5700,
      "bciAvId": 26187,
      "gloss": "justified",
      "glossSv": "motiverat, berättigat",
      "pos": "description",
      "explanation": "justification + description indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        86,
        "/",
        332,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 5701,
      "bciAvId": 26188,
      "gloss": "to justify",
      "glossSv": "motivera, berättiga",
      "pos": "action",
      "explanation": "justification + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        332,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 5702,
      "bciAvId": 26189,
      "gloss": "language development",
      "glossSv": "språkutveckling",
      "pos": "noun",
      "explanation": "development + language",
      "isCharacter": false,
      "composition": [
        6015,
        "/",
        414
      ]
    },
    {
      "id": 5703,
      "bciAvId": 26190,
      "gloss": "lifetime, life-time, lifespan",
      "glossSv": "livstid, livslängd",
      "pos": "noun",
      "explanation": "time + life + all: the period during which something lives or is functional, as between birth and death",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        423,
        "/",
        117
      ]
    },
    {
      "id": 5704,
      "bciAvId": 26191,
      "gloss": "literature",
      "glossSv": "litteratur",
      "pos": "noun",
      "explanation": "generalization + book",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        173
      ]
    },
    {
      "id": 5705,
      "bciAvId": 26192,
      "gloss": "longsightedness, farsightedness, presbyopia, hyperopia",
      "glossSv": "långsynthet",
      "pos": "noun",
      "explanation": "limitation + eye + nearness,closeness,proximity: difficulty to see near objects",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        303,
        "/",
        1060
      ]
    },
    {
      "id": 5706,
      "bciAvId": 26193,
      "gloss": "longsighted, farsighted, presbyopic, hyperopic",
      "glossSv": "långsynt",
      "pos": "description",
      "explanation": "longsightedness,farsightedness,presbyopia,hyperopia + description indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        303,
        "/",
        1060
      ]
    },
    {
      "id": 5707,
      "bciAvId": 26194,
      "gloss": "lynx, bobcat",
      "glossSv": "lo, lodjur",
      "pos": "noun",
      "explanation": "cat + ear + hair: medium sized wild cat with usually tufted ears",
      "isCharacter": false,
      "composition": [
        126,
        "/",
        278,
        "/",
        371
      ]
    },
    {
      "id": 5708,
      "bciAvId": 26195,
      "gloss": "to make compost",
      "glossSv": "kompostera",
      "pos": "action",
      "explanation": "compost + action indicator",
      "isCharacter": false,
      "composition": [
        783,
        ";",
        81,
        "/",
        213,
        "/",
        281
      ]
    },
    {
      "id": 5709,
      "bciAvId": 26196,
      "gloss": "mammal",
      "glossSv": "däggdjur",
      "pos": "noun",
      "explanation": "animal + milk: warm-blooded vertebrate having the skin more or less covered with hair; young are born alive and nourished with milk",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 5710,
      "bciAvId": 26198,
      "gloss": "mink",
      "glossSv": "mink",
      "pos": "noun",
      "explanation": "mustelid (animal) [contraction] + fur: the mink being a mustelid animal valued for its fur",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        600,
        "/",
        340
      ]
    },
    {
      "id": 5711,
      "bciAvId": 26199,
      "gloss": "modem",
      "glossSv": "modem",
      "pos": "noun",
      "explanation": "thing + change + signal,broadcast,transmitting: a device that modulates signal transmissions between different formats",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        213,
        "/",
        922
      ]
    },
    {
      "id": 5712,
      "bciAvId": 26200,
      "gloss": "modern",
      "glossSv": "modern",
      "pos": "description",
      "explanation": "newness,novelty + intensity + description indicator: novelty with some kind of emphasis",
      "isCharacter": false,
      "composition": [
        1061,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 5713,
      "bciAvId": 26201,
      "gloss": "molecule",
      "glossSv": "molekyl",
      "pos": "noun",
      "explanation": "group of + atom: a group of two or more atoms held together by chemical bonds",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        136
      ]
    },
    {
      "id": 5714,
      "bciAvId": 26202,
      "gloss": "mollusk(s), mollusc(s)",
      "glossSv": "mollusk",
      "pos": "noun",
      "explanation": "generalization + snail: invertebrate animals having a soft unsegmented body usually enclosed in a shell",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        601
      ]
    },
    {
      "id": 5715,
      "bciAvId": 26203,
      "gloss": "moon axis",
      "glossSv": "månaxel",
      "pos": "noun",
      "explanation": "axis + moon: the Moon's spin axis, around which it turns in about the same time that it circles the Earth",
      "isCharacter": false,
      "composition": [
        900,
        "/",
        453
      ]
    },
    {
      "id": 5716,
      "bciAvId": 26204,
      "gloss": "moon phase, phase of the moon",
      "glossSv": "månfas",
      "pos": "noun",
      "explanation": "limited time,interval,period + moon: appearances of the Moon's state of illumination: Additional specifier can be added, such as ”full” , ”half”, ”first quarter” and ”last quarter”",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        453
      ]
    },
    {
      "id": 5717,
      "bciAvId": 26205,
      "gloss": "moss",
      "glossSv": "mossa",
      "pos": "noun",
      "explanation": "plant + without + root(s): small flowerless, non-vascular plants, lacking proper root systems, and that usually grow in dense green clumps or mats, in damp or shady locations",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        449,
        "/",
        573
      ]
    },
    {
      "id": 5718,
      "bciAvId": 26206,
      "gloss": "mountain range",
      "glossSv": "bergskedja, bergsmassiv",
      "pos": "noun",
      "explanation": "group of + mountain",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        456
      ]
    },
    {
      "id": 5719,
      "bciAvId": 26207,
      "gloss": "mustelid (animal)",
      "glossSv": "mårddjur, mustelid",
      "pos": "noun",
      "explanation": "animal + smell + intensity: family of carnivorous mammals, including the weasel, badger, etc. Mustelids are typically known for producing a strong-smelling secretion",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        600,
        "/",
        401
      ]
    },
    {
      "id": 5720,
      "bciAvId": 26208,
      "gloss": "national park",
      "glossSv": "nationalpark",
      "pos": "noun",
      "explanation": "park + country,state: an area of land declared by the national government to be public property",
      "isCharacter": false,
      "composition": [
        501,
        "/",
        243
      ]
    },
    {
      "id": 5721,
      "bciAvId": 26209,
      "gloss": "nearsightedness, shortsightedness, myopia",
      "glossSv": "närsynthet",
      "pos": "noun",
      "explanation": "limitation + eye + farness,remoteness: difficulty to see distant objects",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        303,
        "/",
        1033
      ]
    },
    {
      "id": 5722,
      "bciAvId": 26210,
      "gloss": "nearsighted, shortsighted, myopic",
      "glossSv": "närsynt",
      "pos": "description",
      "explanation": "nearsightedness,shortsightedness,myopia + description indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        86,
        "/",
        303,
        "/",
        1033
      ]
    },
    {
      "id": 5723,
      "bciAvId": 26213,
      "gloss": "nutrient, nutrition",
      "glossSv": "näringsämne, näring",
      "pos": "noun",
      "explanation": "substance + giving + health",
      "isCharacter": false,
      "composition": [
        898,
        "/",
        949,
        "/",
        377
      ]
    },
    {
      "id": 5724,
      "bciAvId": 26214,
      "gloss": "omnivore",
      "glossSv": "allätare (djur)",
      "pos": "noun",
      "explanation": "animal + food + animal + plant: an animal or person that feeds on both animal and vegetable food",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        329,
        "/",
        122,
        "/",
        533
      ]
    },
    {
      "id": 5725,
      "bciAvId": 26215,
      "gloss": "once upon a time",
      "glossSv": "det var en gång",
      "pos": "expression",
      "explanation": "1 + time + past",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        655,
        "/",
        "RK:-2",
        "/",
        503
      ]
    },
    {
      "id": 5726,
      "bciAvId": 26216,
      "gloss": "online game, multiplayer game, network game",
      "glossSv": "internetspel, nätverksspel",
      "pos": "noun",
      "explanation": "digital game,video game + internet (1) [contraction]",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        829,
        "/",
        228
      ]
    },
    {
      "id": 5727,
      "bciAvId": 26217,
      "gloss": "orbit of the moon",
      "glossSv": "omloppsbana (månen), månbana",
      "pos": "noun",
      "explanation": "orbit + moon",
      "isCharacter": false,
      "composition": [
        887,
        "/",
        "RK:-2",
        "/",
        453
      ]
    },
    {
      "id": 5728,
      "bciAvId": 26218,
      "gloss": "period of life",
      "glossSv": "livsperiod, period (i livet)",
      "pos": "noun",
      "explanation": "limited time,period + life",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        423
      ]
    },
    {
      "id": 5729,
      "bciAvId": 26219,
      "gloss": "pinch, pincer grip",
      "glossSv": "nypa, pincettgrepp",
      "pos": "noun",
      "explanation": "finger + pliers: a grip with the fingers, as if with pliers or pincer",
      "isCharacter": false,
      "composition": [
        318,
        "/",
        535
      ]
    },
    {
      "id": 5730,
      "bciAvId": 26220,
      "gloss": "to pinch, to pluck, to tweeze",
      "glossSv": "nypa, plocka",
      "pos": "action",
      "explanation": "pinch,pincer grip + action indicator",
      "isCharacter": false,
      "composition": [
        318,
        ";",
        81,
        "/",
        535
      ]
    },
    {
      "id": 5731,
      "bciAvId": 26221,
      "gloss": "plant-book, dictionary of plants",
      "glossSv": "flora (bok), växtbok, växtlexikon",
      "pos": "noun",
      "explanation": "book + plant",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        533
      ]
    },
    {
      "id": 5732,
      "bciAvId": 26222,
      "gloss": "plastic bag",
      "glossSv": "plastkasse, plastpåse",
      "pos": "noun",
      "explanation": "sack,bag + material + chemical product [contraction of plastic]",
      "isCharacter": false,
      "composition": [
        574,
        "/",
        438,
        "/",
        216
      ]
    },
    {
      "id": 5733,
      "bciAvId": 26223,
      "gloss": "plough (ancient), ard, ard plough, scratch plough",
      "glossSv": "årder, plog (forntid)",
      "pos": "noun",
      "explanation": "plough + past: ancient plough",
      "isCharacter": false,
      "composition": [
        536,
        "/",
        503
      ]
    },
    {
      "id": 5734,
      "bciAvId": 26224,
      "gloss": "practice, drill, exercise, rehearsal",
      "glossSv": "övning, repetition",
      "pos": "noun",
      "explanation": "work + repetition: work at something repeatedly to develop skill",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        963
      ]
    },
    {
      "id": 5735,
      "bciAvId": 26225,
      "gloss": "recycling station",
      "glossSv": "återvinningsstation, återvinningscentral",
      "pos": "noun",
      "explanation": "place + waste sorting,garbage sorting",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        673,
        "/",
        694
      ]
    },
    {
      "id": 5736,
      "bciAvId": 26226,
      "gloss": "referee, judge (sport)",
      "glossSv": "domare (sport)",
      "pos": "person",
      "explanation": "person + decision + sport",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        260,
        "/",
        719
      ]
    },
    {
      "id": 5737,
      "bciAvId": 26227,
      "gloss": "referee (football, soccer)",
      "glossSv": "domare (fotboll)",
      "pos": "person",
      "explanation": "person + decision + football,soccer (sport) [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        260,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 5738,
      "bciAvId": 26228,
      "gloss": "reuse, recycling",
      "glossSv": "återanvändning",
      "pos": "noun",
      "explanation": "usage,use + again",
      "isCharacter": false,
      "composition": [
        932,
        "/",
        110
      ]
    },
    {
      "id": 5739,
      "bciAvId": 26229,
      "gloss": "to reuse, to use again, to recycle",
      "glossSv": "återvinna, återanvända",
      "pos": "action",
      "explanation": "reuse,recycling + action indicator",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        81,
        "/",
        110
      ]
    },
    {
      "id": 5740,
      "bciAvId": 26230,
      "gloss": "to rot, to decompose",
      "glossSv": "ruttna, kompostera",
      "pos": "action",
      "explanation": "rot,decomposition,rotting matter + action indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        213,
        ";",
        81,
        "/",
        894,
        ";",
        97,
        "/",
        939
      ]
    },
    {
      "id": 5741,
      "bciAvId": 26231,
      "gloss": "rot, decomposition, rotting matter",
      "glossSv": "ruttnande, kompostering, förruttnelseprocess",
      "pos": "noun",
      "explanation": "change,alteration,conversion + organism + deletion,cancellation,destruction + thing indicator: the decomposing change of organic material performed by organisms, primarily micro-organisms, breaking it down",
      "isCharacter": false,
      "composition": [
        213,
        "/",
        894,
        ";",
        97,
        "/",
        939
      ]
    },
    {
      "id": 5742,
      "bciAvId": 26232,
      "gloss": "rotten, decomposed",
      "glossSv": "rutten, komposterad, förmultnad",
      "pos": "description",
      "explanation": "rot,decomposition,rotting matter + description indicator + thing indicator",
      "isCharacter": false,
      "composition": [
        213,
        ";",
        86,
        "/",
        894,
        ";",
        97,
        "/",
        939
      ]
    },
    {
      "id": 5743,
      "bciAvId": 26233,
      "gloss": "router",
      "glossSv": "router",
      "pos": "noun",
      "explanation": "connector,interface box + signal,broadcast,transmitting + thing indicator: a networking device that forwards data packets between computer networks",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        97,
        "/",
        829,
        "/",
        922
      ]
    },
    {
      "id": 5744,
      "bciAvId": 26234,
      "gloss": "run, jog",
      "glossSv": "löpning, joggning, löpande, joggande",
      "pos": "noun",
      "explanation": "activity + run",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        418,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 5745,
      "bciAvId": 26235,
      "gloss": "salt",
      "glossSv": "salt",
      "pos": "noun",
      "explanation": "flavouring,condiment,seasoning + salt crystal [contraction]",
      "isCharacter": false,
      "composition": [
        107,
        ";",
        97,
        "/",
        642,
        "/",
        250
      ]
    },
    {
      "id": 5746,
      "bciAvId": 26236,
      "gloss": "saltwater, seawater",
      "glossSv": "saltvatten, havsvatten",
      "pos": "noun",
      "explanation": "water + salt crystal [contraction]: water containing salts",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        250
      ]
    },
    {
      "id": 5747,
      "bciAvId": 26237,
      "gloss": "salty",
      "glossSv": "salt (smak)",
      "pos": "description",
      "explanation": "taste + salt crystal [contraction] + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        250
      ]
    },
    {
      "id": 5748,
      "bciAvId": 26238,
      "gloss": "scavenger, carrion eater",
      "glossSv": "asätare (djur)",
      "pos": "noun",
      "explanation": "animal + food + dead: animals that feed on carrion and other dead organisms",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        329,
        "/",
        259
      ]
    },
    {
      "id": 5749,
      "bciAvId": 26239,
      "gloss": "school year",
      "glossSv": "skolår, årskurs",
      "pos": "noun",
      "explanation": "year + school (in combinations)",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        "RK:-2",
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 5750,
      "bciAvId": 26240,
      "gloss": "selfie",
      "glossSv": "selfie självporträtt (foto)",
      "pos": "noun",
      "explanation": "photograph,photo,pic + self: photo taken on oneself",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        198,
        "/",
        2343
      ]
    },
    {
      "id": 5751,
      "bciAvId": 26241,
      "gloss": "server, host (computer)",
      "glossSv": "sever, host (dator)",
      "pos": "noun",
      "explanation": "computer + combination,connection: a computer that provides client stations with access to programs, files, printers etc. as shared resources in a computer network",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        829,
        "/",
        232
      ]
    },
    {
      "id": 5752,
      "bciAvId": 26242,
      "gloss": "sloping, sloped, slanting, slanted",
      "glossSv": "sluttande, lutande",
      "pos": "description",
      "explanation": "downward and forward + description indicator",
      "isCharacter": false,
      "composition": [
        273,
        ";",
        86
      ]
    },
    {
      "id": 5753,
      "bciAvId": 26243,
      "gloss": "to sort, to differentiate, to separate, to classify",
      "glossSv": "sortera, differentiera, separera, klassificera",
      "pos": "action",
      "explanation": "type,kind,sort,category + action indicator",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        81
      ]
    },
    {
      "id": 5754,
      "bciAvId": 26244,
      "gloss": "to sort garbage, to separate waste",
      "glossSv": "sopsortera, sortera (sopor)",
      "pos": "action",
      "explanation": "waste sorting + action indicator",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        81,
        "/",
        694
      ]
    },
    {
      "id": 5755,
      "bciAvId": 26247,
      "gloss": "spine, backbone",
      "glossSv": "ryggrad",
      "pos": "noun",
      "explanation": "bone + back (body)",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        143
      ]
    },
    {
      "id": 5756,
      "bciAvId": 26248,
      "gloss": "steep",
      "glossSv": "brant",
      "pos": "description",
      "explanation": "sloping,sloped,slanting,slanted + intensity + description indicator",
      "isCharacter": false,
      "composition": [
        273,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 5757,
      "bciAvId": 26249,
      "gloss": "stream (digital), data stream",
      "glossSv": "ström (digital)",
      "pos": "noun",
      "explanation": "river,stream,current + digits (computer): a stream of digital data",
      "isCharacter": false,
      "composition": [
        568,
        "/",
        829
      ]
    },
    {
      "id": 5758,
      "bciAvId": 26250,
      "gloss": "to stream (digital data)",
      "glossSv": "strömma (digitalt)",
      "pos": "action",
      "explanation": "stream (digital),data stream + action indicator: to stream digital data, typically media content over the internet",
      "isCharacter": false,
      "composition": [
        568,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 5759,
      "bciAvId": 26251,
      "gloss": "streamed, streaming (digital data)",
      "glossSv": "strömmad (digitalt)",
      "pos": "description",
      "explanation": "stream (digital),data stream + description indicator: digital data, typically media content, streaming over the internet",
      "isCharacter": false,
      "composition": [
        568,
        ";",
        86,
        "/",
        829
      ]
    },
    {
      "id": 5760,
      "bciAvId": 26252,
      "gloss": "sweaty, sweating, perspiring",
      "glossSv": "svett, svettig",
      "pos": "description",
      "explanation": "sweat,perspiration + description indicator",
      "isCharacter": false,
      "composition": [
        695,
        ";",
        86,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 5761,
      "bciAvId": 26253,
      "gloss": "term, semester",
      "glossSv": "termin",
      "pos": "noun",
      "explanation": "season + school (in combinations)",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        716,
        "/",
        "RK:-2",
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 5762,
      "bciAvId": 26254,
      "gloss": "umami",
      "glossSv": "umami (smak)",
      "pos": "noun",
      "explanation": "taste + seaweed: one of the five basic tastes (together with sweetness, sourness, bitterness, and saltiness) first identified in Japan from kombu seaweed",
      "isCharacter": false,
      "composition": [
        642,
        "/",
        847
      ]
    },
    {
      "id": 5763,
      "bciAvId": 26255,
      "gloss": "umami tasting",
      "glossSv": "umamismakande",
      "pos": "description",
      "explanation": "umami + description indicator",
      "isCharacter": false,
      "composition": [
        642,
        ";",
        86,
        "/",
        847
      ]
    },
    {
      "id": 5764,
      "bciAvId": 26256,
      "gloss": "unfinished",
      "glossSv": "oavslutad, ofullbordad",
      "pos": "description",
      "explanation": "without + finished,complete,completed + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        106,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 5765,
      "bciAvId": 26257,
      "gloss": "unicycle, monocycle, one-wheeled vehicle",
      "glossSv": "enhjuling (cykel), monocykel",
      "pos": "noun",
      "explanation": "1 + wheel: one wheeled vehicle",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        700
      ]
    },
    {
      "id": 5766,
      "bciAvId": 26258,
      "gloss": "to unicycle, to ride a one-wheeled vehicle",
      "glossSv": "cykla (på enhjuling), monocykla",
      "pos": "action",
      "explanation": "unicycle,monocycle,one-wheeled vehicle + action indicator",
      "isCharacter": false,
      "composition": [
        10,
        "/",
        700,
        ";",
        81
      ]
    },
    {
      "id": 5767,
      "bciAvId": 26259,
      "gloss": "untrue, false",
      "glossSv": "osann, falsk",
      "pos": "description",
      "explanation": "untruth,falsity,falsehood + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        670,
        ";",
        86
      ]
    },
    {
      "id": 5768,
      "bciAvId": 26260,
      "gloss": "untruth, falsity, falsehood",
      "glossSv": "osanning, falskhet",
      "pos": "noun",
      "explanation": "without + truth",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        670
      ]
    },
    {
      "id": 5769,
      "bciAvId": 26261,
      "gloss": "upload",
      "glossSv": "uppladdning (digital)",
      "pos": "noun",
      "explanation": "giving,gift + digits (computer): the sharing of digital data to a server on the internet",
      "isCharacter": false,
      "composition": [
        949,
        "/",
        829
      ]
    },
    {
      "id": 5770,
      "bciAvId": 26262,
      "gloss": "to upload",
      "glossSv": "ladda upp (digitalt)",
      "pos": "action",
      "explanation": "upload + action indicator",
      "isCharacter": false,
      "composition": [
        949,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 5771,
      "bciAvId": 26263,
      "gloss": "walk, walking",
      "glossSv": "gående, promenerande, promenad",
      "pos": "noun",
      "explanation": "activity + legs and feet: the act of walking (somewhere)",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        418
      ]
    },
    {
      "id": 5772,
      "bciAvId": 26264,
      "gloss": "waste sorting, garbage sorting, source separation (of waste)",
      "glossSv": "sopsortering",
      "pos": "noun",
      "explanation": "type,kind,sort,category + waste,garbage,rubbish,trash: separation of different kinds of waste for recycling",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        694
      ]
    },
    {
      "id": 5773,
      "bciAvId": 26265,
      "gloss": "vertebrate",
      "glossSv": "ryggradsdjur",
      "pos": "noun",
      "explanation": "animal + spine,backbone: animals with a backbone or spinal column",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        172,
        "/",
        143
      ]
    },
    {
      "id": 5774,
      "bciAvId": 26266,
      "gloss": "visible, sighted",
      "glossSv": "synlig",
      "pos": "description",
      "explanation": "eye + description indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        86
      ]
    },
    {
      "id": 5775,
      "bciAvId": 26267,
      "gloss": "X-ray",
      "glossSv": "röntgen",
      "pos": "noun",
      "explanation": "light + through + thing: shortwave radiation passing through otherwise non-transparent things, used in medical diagnosis etc.",
      "isCharacter": false,
      "composition": [
        424,
        "/",
        653,
        "/",
        651
      ]
    },
    {
      "id": 5776,
      "bciAvId": 26268,
      "gloss": "to X-ray",
      "glossSv": "röntga",
      "pos": "action",
      "explanation": "X-ray + action indicator",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        81,
        "/",
        653,
        "/",
        651
      ]
    },
    {
      "id": 5777,
      "bciAvId": 26280,
      "gloss": "to accept",
      "glossSv": "acceptera, godkänna, godta",
      "pos": "action",
      "explanation": "get + mind + action indicator: to receive reasons",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        447
      ]
    },
    {
      "id": 5778,
      "bciAvId": 26281,
      "gloss": "audio book",
      "glossSv": "ljudbok",
      "pos": "noun",
      "explanation": "book + sound",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        608
      ]
    },
    {
      "id": 5779,
      "bciAvId": 26282,
      "gloss": "brace(s) (dental), dental brace(s) (medical)",
      "glossSv": "tandställning (medicinsk)",
      "pos": "noun",
      "explanation": "medical aid + teeth",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        644
      ]
    },
    {
      "id": 5780,
      "bciAvId": 26283,
      "gloss": "brace(s) (dental), dental brace(s)",
      "glossSv": "tandställning",
      "pos": "noun",
      "explanation": "aid + teeth + line: help to set the teeth in a row",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        644,
        "/",
        428
      ]
    },
    {
      "id": 5781,
      "bciAvId": 26284,
      "gloss": "brace (neck, medical), neck brace, cervical collar, neck collar",
      "glossSv": "stödkrage",
      "pos": "noun",
      "explanation": "medical aid + neck",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        958,
        "/",
        466
      ]
    },
    {
      "id": 5782,
      "bciAvId": 26285,
      "gloss": "brain injury",
      "glossSv": "hjärnskada",
      "pos": "noun",
      "explanation": "damage + brain",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        447,
        ";",
        97
      ]
    },
    {
      "id": 5783,
      "bciAvId": 26286,
      "gloss": "cape, poncho, clothing without sleeves",
      "glossSv": "cape, poncho, klädesplagg (utan ärmar)",
      "pos": "noun",
      "explanation": "clothes + without + sleeve [contraction]",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        449,
        "/",
        132
      ]
    },
    {
      "id": 5784,
      "bciAvId": 26287,
      "gloss": "chopstick(s)",
      "glossSv": "ätpinnar",
      "pos": "noun",
      "explanation": "two + linear thing + food: tools for eating food",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        428,
        ";",
        97,
        "/",
        329
      ]
    },
    {
      "id": 5785,
      "bciAvId": 26288,
      "gloss": "CNS injury",
      "glossSv": "CNS-skada",
      "pos": "noun",
      "explanation": "damage + central nervous system",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        991,
        ";",
        97
      ]
    },
    {
      "id": 5786,
      "bciAvId": 26289,
      "gloss": "consciousness, awareness",
      "glossSv": "medvetenhet, medventande",
      "pos": "noun",
      "explanation": "mind + activity: an alert cognitive state in which you are aware",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        106
      ]
    },
    {
      "id": 5787,
      "bciAvId": 26290,
      "gloss": "cooking vessel, pots and pans",
      "glossSv": "kokkärl",
      "pos": "noun",
      "explanation": "generalization + pan: all kinds of cooking pans in a kitchen",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        792
      ]
    },
    {
      "id": 5788,
      "bciAvId": 26291,
      "gloss": "critic, evaluator",
      "glossSv": "kritiker",
      "pos": "person",
      "explanation": "person + evaluate: a person that evaluates things e.g. best restaurant or best film",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        297
      ]
    },
    {
      "id": 5789,
      "bciAvId": 26292,
      "gloss": "dental floss",
      "glossSv": "tandtråd",
      "pos": "noun",
      "explanation": "fibre + teeth: a string for cleaning between the teeth",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        644
      ]
    },
    {
      "id": 5790,
      "bciAvId": 26293,
      "gloss": "diagnosis (medical)",
      "glossSv": "diagnos (medicinsk)",
      "pos": "noun",
      "explanation": "outcome + evaluation + medical",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        297,
        "/",
        958
      ]
    },
    {
      "id": 5791,
      "bciAvId": 26294,
      "gloss": "disappointed",
      "glossSv": "besviken",
      "pos": "description",
      "explanation": "disappointment + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        271,
        "/",
        109,
        "/",
        930
      ]
    },
    {
      "id": 5792,
      "bciAvId": 26295,
      "gloss": "disappointing",
      "glossSv": "nedslående",
      "pos": "description",
      "explanation": "disappointment + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        271,
        "/",
        109,
        "/",
        930
      ]
    },
    {
      "id": 5793,
      "bciAvId": 26296,
      "gloss": "disappointment",
      "glossSv": "besvikelse",
      "pos": "noun",
      "explanation": "sadness + after + desire",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        109,
        "/",
        930
      ]
    },
    {
      "id": 5794,
      "bciAvId": 26297,
      "gloss": "dyscalculia",
      "glossSv": "dyskalkyli",
      "pos": "noun",
      "explanation": "limitation + mathematics [contraction]: limited ability in mathematics",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        478
      ]
    },
    {
      "id": 5795,
      "bciAvId": 26298,
      "gloss": "dysgraphia",
      "glossSv": "dysgrafi",
      "pos": "noun",
      "explanation": "limitation + writing; limited ability to learn to write",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        509
      ]
    },
    {
      "id": 5796,
      "bciAvId": 26299,
      "gloss": "dyslexia",
      "glossSv": "dyslexi",
      "pos": "noun",
      "explanation": "limitation + reading: limited ability to learn to read",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        303,
        "/",
        497
      ]
    },
    {
      "id": 5797,
      "bciAvId": 26300,
      "gloss": "dystonia",
      "glossSv": "dystoni",
      "pos": "noun",
      "explanation": "activity + muscle + up and down; neurological movement disorder with sustained or repetitive muscle contractions",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        718,
        "/",
        723
      ]
    },
    {
      "id": 5798,
      "bciAvId": 26301,
      "gloss": "e-book, digital book",
      "glossSv": "e-bok, bok (digital)",
      "pos": "noun",
      "explanation": "book + digits",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        829
      ]
    },
    {
      "id": 5799,
      "bciAvId": 26302,
      "gloss": "egg white, white of egg, albumin, glair",
      "glossSv": "äggvita",
      "pos": "noun",
      "explanation": "part of egg [contraction] + white: the albumin surrounding the yolk",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        1161,
        "/",
        604
      ]
    },
    {
      "id": 5800,
      "bciAvId": 26303,
      "gloss": "egg yolk, yolk",
      "glossSv": "äggula",
      "pos": "noun",
      "explanation": "part of egg [contraction] + yellow: the center part of an egg,",
      "isCharacter": false,
      "composition": [
        285,
        "/",
        1161,
        "/",
        636
      ]
    },
    {
      "id": 5801,
      "bciAvId": 26304,
      "gloss": "eggshell",
      "glossSv": "äggskal",
      "pos": "noun",
      "explanation": "shell + egg: the shell of an egg",
      "isCharacter": false,
      "composition": [
        588,
        "/",
        285
      ]
    },
    {
      "id": 5802,
      "bciAvId": 26305,
      "gloss": "to faint, to pass out",
      "glossSv": "svimma",
      "pos": "action",
      "explanation": "fainting + action indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        81,
        "/",
        449,
        "/",
        106,
        "/",
        426
      ]
    },
    {
      "id": 5803,
      "bciAvId": 26306,
      "gloss": "fainting, absence",
      "glossSv": "svimning, absens",
      "pos": "noun",
      "explanation": "mind + without + activity + limited time: a spontaneous loss of consciousness for a limited period of time",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        449,
        "/",
        106,
        "/",
        426
      ]
    },
    {
      "id": 5804,
      "bciAvId": 26307,
      "gloss": "hair accessory",
      "glossSv": "hårtillbehör, hårspänne",
      "pos": "noun",
      "explanation": "thing + hair + together",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        372,
        "/",
        823
      ]
    },
    {
      "id": 5805,
      "bciAvId": 26308,
      "gloss": "hair pin, bobby pin",
      "glossSv": "hårnål",
      "pos": "noun",
      "explanation": "thing + hair + linear thing",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        372,
        "/",
        "RK:1",
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 5806,
      "bciAvId": 26309,
      "gloss": "hair tie",
      "glossSv": "hårsnodd, hårband",
      "pos": "noun",
      "explanation": "thing + hair + ring",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        372,
        "/",
        567
      ]
    },
    {
      "id": 5807,
      "bciAvId": 26310,
      "gloss": "hygiene",
      "glossSv": "hygien",
      "pos": "noun",
      "explanation": "activity + protection + health: activity concerned with the maintenance of health",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        548,
        "/",
        377
      ]
    },
    {
      "id": 5808,
      "bciAvId": 26311,
      "gloss": "hygiene (personal)",
      "glossSv": "hygien (personlig)",
      "pos": "noun",
      "explanation": "activity + protection + health + person: activity concerned with the maintenance of personal health",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        548,
        "/",
        377,
        "/",
        513
      ]
    },
    {
      "id": 5809,
      "bciAvId": 26312,
      "gloss": "interdental brush, interdental rager",
      "glossSv": "mellanrumsborste (tandvård)",
      "pos": "noun",
      "explanation": "brush + teeth + between: a small brush made for cleaning between the teeth",
      "isCharacter": false,
      "composition": [
        184,
        "/",
        644,
        "/",
        162
      ]
    },
    {
      "id": 5810,
      "bciAvId": 26313,
      "gloss": "karate",
      "glossSv": "karate",
      "pos": "noun",
      "explanation": "martial arts + kick [contraction]: martial art including fight with hands and feet",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        934,
        "/",
        282,
        "/",
        1052
      ]
    },
    {
      "id": 5811,
      "bciAvId": 26314,
      "gloss": "knitting needle(s)",
      "glossSv": "stickor, strumpstickor",
      "pos": "noun",
      "explanation": "two + linear thing + cloth: needles used for knitting",
      "isCharacter": false,
      "composition": [
        11,
        "/",
        428,
        ";",
        97,
        "/",
        228
      ]
    },
    {
      "id": 5812,
      "bciAvId": 26315,
      "gloss": "leftovers, left overs, food waste (food thrown away)",
      "glossSv": "matrester, rester (mat, slängs)",
      "pos": "noun",
      "explanation": "food + waste: the leftovers of food that is thrown away",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        694
      ]
    },
    {
      "id": 5813,
      "bciAvId": 26316,
      "gloss": "leftovers, left overs (food used again)",
      "glossSv": "matrester, rester (mat, tillvaratas)",
      "pos": "noun",
      "explanation": "food + again: leftovers of food that is served again",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        110
      ]
    },
    {
      "id": 5814,
      "bciAvId": 26317,
      "gloss": "mathematical difficulty",
      "glossSv": "matematiksvårigheter",
      "pos": "noun",
      "explanation": "difficulty + mathematics [contraction]: difficulties with mathematics",
      "isCharacter": false,
      "composition": [
        940,
        "/",
        478
      ]
    },
    {
      "id": 5815,
      "bciAvId": 26318,
      "gloss": "moustache",
      "glossSv": "mustasch",
      "pos": "noun",
      "explanation": "hair + mouth + pointer to the upper lip",
      "isCharacter": false,
      "composition": [
        371,
        "/",
        5995
      ]
    },
    {
      "id": 5816,
      "bciAvId": 26319,
      "gloss": "movie, action film, action movie, film (action)",
      "glossSv": "actionfilm",
      "pos": "noun",
      "explanation": "movie + activity + fast, quick",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        547,
        "/",
        106,
        "/",
        "RK:-2",
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 5817,
      "bciAvId": 26320,
      "gloss": "movie, romance movie, romance film, film (romantic)",
      "glossSv": "romantikfilm",
      "pos": "noun",
      "explanation": "movie + love",
      "isCharacter": false,
      "composition": [
        200,
        "/",
        547,
        "/",
        431
      ]
    },
    {
      "id": 5818,
      "bciAvId": 26321,
      "gloss": "neurological",
      "glossSv": "neurologisk",
      "pos": "description",
      "explanation": "neuron + description indicator",
      "isCharacter": false,
      "composition": [
        748,
        ";",
        86,
        "/",
        288
      ]
    },
    {
      "id": 5819,
      "bciAvId": 26322,
      "gloss": "paralysis, palsy",
      "glossSv": "förlamning",
      "pos": "noun",
      "explanation": "limitation + activity + muscle: a limited ability or loss of a voluntary muscle function",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        106,
        "/",
        718
      ]
    },
    {
      "id": 5820,
      "bciAvId": 26324,
      "gloss": "privy, outhouse",
      "glossSv": "utedass, latrin, uthus",
      "pos": "noun",
      "explanation": "place + bowel movement: a place where a user can defecate",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        694,
        "/",
        194
      ]
    },
    {
      "id": 5821,
      "bciAvId": 26325,
      "gloss": "reading difficulty",
      "glossSv": "lässvårigheter",
      "pos": "noun",
      "explanation": "difficulty + reading: difficulties with reading",
      "isCharacter": false,
      "composition": [
        940,
        "/",
        303,
        "/",
        497
      ]
    },
    {
      "id": 5822,
      "bciAvId": 26326,
      "gloss": "to realise, to realize, to comprehend",
      "glossSv": "inse",
      "pos": "action",
      "explanation": "understand + suddenly [contraction] + action indicator",
      "isCharacter": false,
      "composition": [
        1103,
        ";",
        81,
        "/",
        425
      ]
    },
    {
      "id": 5823,
      "bciAvId": 26327,
      "gloss": "record (achievement)",
      "glossSv": "rekord (prestation)",
      "pos": "noun",
      "explanation": "outcome + most: the extreme outcome",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        968
      ]
    },
    {
      "id": 5824,
      "bciAvId": 26328,
      "gloss": "to regain, to recover, to retrieve",
      "glossSv": "återfå, återhämta",
      "pos": "action",
      "explanation": "get + again: get or find back",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        110
      ]
    },
    {
      "id": 5825,
      "bciAvId": 26329,
      "gloss": "sleeve(s)",
      "glossSv": "ärm",
      "pos": "noun",
      "explanation": "clothes + arm",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        132
      ]
    },
    {
      "id": 5826,
      "bciAvId": 26330,
      "gloss": "suspender(s)",
      "glossSv": "hängslen",
      "pos": "noun",
      "explanation": "linear thing + up + clothes",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        678,
        "/",
        229
      ]
    },
    {
      "id": 5828,
      "bciAvId": 26332,
      "gloss": "tremor, shudder",
      "glossSv": "rysning",
      "pos": "noun",
      "explanation": "activity + muscle + back and forth: an involuntary vibration",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        718,
        "/",
        144
      ]
    },
    {
      "id": 5829,
      "bciAvId": 26333,
      "gloss": "unconscious, comatose",
      "glossSv": "medvetslös",
      "pos": "description",
      "explanation": "unconsciousness + description indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        86,
        "/",
        449,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 5830,
      "bciAvId": 26334,
      "gloss": "unconsciousness, coma, comatoseness",
      "glossSv": "medvetslöshet, koma",
      "pos": "noun",
      "explanation": "mind + without + activity: a state of lacking awareness, sometimes deep and prolonged unconsciousness",
      "isCharacter": false,
      "composition": [
        447,
        "/",
        449,
        "/",
        "RK:-2",
        "/",
        106
      ]
    },
    {
      "id": 5831,
      "bciAvId": 26335,
      "gloss": "vegetarian (food)",
      "glossSv": "vegetarisk (mat)",
      "pos": "description",
      "explanation": "food + plant + description indicator",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        86,
        "/",
        533
      ]
    },
    {
      "id": 5832,
      "bciAvId": 26336,
      "gloss": "vegetarian (person)",
      "glossSv": "vegetarian (person)",
      "pos": "person",
      "explanation": "person + food + plant: a person who eats plants and not any meat",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        329,
        "/",
        533
      ]
    },
    {
      "id": 5833,
      "bciAvId": 26337,
      "gloss": "to wonder, to inquire, to enquire, to be curious",
      "glossSv": "undra, vara nyfiken",
      "pos": "action",
      "explanation": "curiosity + action indicator",
      "isCharacter": false,
      "composition": [
        930,
        ";",
        81,
        "/",
        412
      ]
    },
    {
      "id": 5834,
      "bciAvId": 26338,
      "gloss": "writing difficulty",
      "glossSv": "skrivsvårigheter",
      "pos": "noun",
      "explanation": "difficulty + writing: difficulties with writing",
      "isCharacter": false,
      "composition": [
        940,
        "/",
        509
      ]
    },
    {
      "id": 5835,
      "bciAvId": 26339,
      "gloss": "yarn",
      "glossSv": "garn",
      "pos": "noun",
      "explanation": "thread + fabric: thread used in sewing, knitting and weaving",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1122,
        "/",
        228
      ]
    },
    {
      "id": 5836,
      "bciAvId": 27010,
      "gloss": "beside",
      "glossSv": "brevid, vid sidan av",
      "pos": "expression",
      "explanation": "linear + after,behind",
      "isCharacter": true
    },
    {
      "id": 5837,
      "bciAvId": 27026,
      "gloss": "concept",
      "glossSv": "koncept, grundtanke",
      "pos": "noun",
      "explanation": "small character of thought",
      "isCharacter": true
    },
    {
      "id": 5838,
      "bciAvId": 27031,
      "gloss": "crumbs",
      "glossSv": "smulor",
      "pos": "noun",
      "explanation": "four particles [modification, two in high and two in low positions]: indicating crumbs",
      "isCharacter": true
    },
    {
      "id": 5839,
      "bciAvId": 27062,
      "gloss": "groin",
      "glossSv": "ljumske",
      "pos": "noun",
      "explanation": "body + pointer to groin",
      "isCharacter": true
    },
    {
      "id": 5840,
      "bciAvId": 27080,
      "gloss": "kernel, particle",
      "glossSv": "kärna, partikel",
      "pos": "noun",
      "explanation": "pictograph: showing a particle",
      "isCharacter": true
    },
    {
      "id": 5841,
      "bciAvId": 27081,
      "gloss": "kiosk, booth, stall",
      "glossSv": "kiosk",
      "pos": "noun",
      "explanation": "room + business",
      "isCharacter": true
    },
    {
      "id": 5842,
      "bciAvId": 27085,
      "gloss": "lichen",
      "glossSv": "lav, lavar",
      "pos": "noun",
      "explanation": "pictograph: showing lichen growing on a stone",
      "isCharacter": true
    },
    {
      "id": 5843,
      "bciAvId": 27150,
      "gloss": "transgender person",
      "glossSv": "transperson",
      "pos": "person",
      "explanation": "transgender (gender) + person [modification, the upper part]",
      "isCharacter": true
    },
    {
      "id": 5844,
      "gloss": "transgender (gender)",
      "pos": "noun",
      "explanation": "male + female: female and male overlapping, the state of having an identity involving both or none of male and female gender -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 5845,
      "bciAvId": 27001,
      "gloss": "abstract",
      "glossSv": "abstrakt",
      "pos": "description",
      "explanation": "concept + description indicator",
      "isCharacter": false,
      "composition": [
        5837,
        ";",
        86
      ]
    },
    {
      "id": 5846,
      "bciAvId": 27002,
      "gloss": "adjective",
      "glossSv": "adjektiv",
      "pos": "noun",
      "explanation": "word + evaluation: evaluation words",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        297
      ]
    },
    {
      "id": 5847,
      "bciAvId": 27003,
      "gloss": "adverb",
      "glossSv": "adverb",
      "pos": "noun",
      "explanation": "word + evaluation + action",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        297,
        "/",
        "RK:-2",
        "/",
        105
      ]
    },
    {
      "id": 5848,
      "bciAvId": 27004,
      "gloss": "affix",
      "glossSv": "affix",
      "pos": "noun",
      "explanation": "unit + together + language",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        823,
        "/",
        414
      ]
    },
    {
      "id": 5849,
      "bciAvId": 27005,
      "gloss": "alive",
      "glossSv": "levande",
      "pos": "description",
      "explanation": "life + description indicator",
      "isCharacter": false,
      "composition": [
        423,
        ";",
        86
      ]
    },
    {
      "id": 5850,
      "bciAvId": 27006,
      "gloss": "aluminium foil, tin foil",
      "glossSv": "folie, aluminiumfolie",
      "pos": "noun",
      "explanation": "wrapping + metal [contraction]",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        97,
        "/",
        814
      ]
    },
    {
      "id": 5851,
      "bciAvId": 27007,
      "gloss": "anaesthesia, anesthesia, numbness",
      "glossSv": "bedövning, anestesi",
      "pos": "noun",
      "explanation": "without + feeling: loss of feeling",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        313
      ]
    },
    {
      "id": 5852,
      "bciAvId": 27008,
      "gloss": "anaesthetic, anesthetic",
      "glossSv": "bedövningsmedel",
      "pos": "noun",
      "explanation": "medication + end + feeling",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        958,
        "/",
        292,
        "/",
        313
      ]
    },
    {
      "id": 5853,
      "bciAvId": 27009,
      "gloss": "article",
      "glossSv": "artikel (gramatik)",
      "pos": "noun",
      "explanation": "part + language + the",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        647
      ]
    },
    {
      "id": 5854,
      "bciAvId": 27011,
      "gloss": "bite",
      "glossSv": "bett",
      "pos": "noun",
      "explanation": "effect + to bite: effect of being bitten",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        644
      ]
    },
    {
      "id": 5855,
      "bciAvId": 27012,
      "gloss": "blood circulation",
      "glossSv": "blodcirkulation",
      "pos": "noun",
      "explanation": "circulation + blood",
      "isCharacter": false,
      "composition": [
        887,
        "/",
        695,
        "/",
        423
      ]
    },
    {
      "id": 5856,
      "bciAvId": 27013,
      "gloss": "blood pressure",
      "glossSv": "blodtryck",
      "pos": "noun",
      "explanation": "pressure + blood",
      "isCharacter": false,
      "composition": [
        815,
        "/",
        695,
        "/",
        423
      ]
    },
    {
      "id": 5857,
      "bciAvId": 27014,
      "gloss": "bone fracture, broken bone",
      "glossSv": "benbrott, fraktur",
      "pos": "noun",
      "explanation": "fracture + bone",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        172
      ]
    },
    {
      "id": 5858,
      "bciAvId": 27015,
      "gloss": "bored",
      "glossSv": "uttråkad",
      "pos": "description",
      "explanation": "boring + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        271,
        "/",
        457
      ]
    },
    {
      "id": 5859,
      "bciAvId": 27016,
      "gloss": "burned out, burnt out",
      "glossSv": "utbränd",
      "pos": "description",
      "explanation": "sickness + without + energy (mental) [contraction] + description indicator",
      "isCharacter": false,
      "composition": [
        516,
        ";",
        86,
        "/",
        449,
        "/",
        288
      ]
    },
    {
      "id": 5860,
      "bciAvId": 27017,
      "gloss": "cactus fruit (dragon fruit, cherimoya)",
      "glossSv": "katusfikon, cherimoya",
      "pos": "noun",
      "explanation": "fruit + cactus",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        533,
        "/",
        845
      ]
    },
    {
      "id": 5861,
      "bciAvId": 27018,
      "gloss": "candy (liquorice)",
      "glossSv": "lakrits (-godis)",
      "pos": "noun",
      "explanation": "candy + roots",
      "isCharacter": false,
      "composition": [
        782,
        "/",
        573
      ]
    },
    {
      "id": 5862,
      "bciAvId": 27019,
      "gloss": "cannabis",
      "glossSv": "cannabis",
      "pos": "noun",
      "explanation": "leaf + medical + star",
      "isCharacter": false,
      "composition": [
        416,
        "/",
        958,
        "/",
        622
      ]
    },
    {
      "id": 5863,
      "bciAvId": 27020,
      "gloss": "car light(s)",
      "glossSv": "billycktor, billampor",
      "pos": "noun",
      "explanation": "lamp + car",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        202
      ]
    },
    {
      "id": 5864,
      "bciAvId": 27021,
      "gloss": "cardiac arrest",
      "glossSv": "hjärtstopp, hjärtstillestånd",
      "pos": "noun",
      "explanation": "stop + heart: stop of the heart",
      "isCharacter": false,
      "composition": [
        292,
        "/",
        313,
        ";",
        97
      ]
    },
    {
      "id": 5865,
      "bciAvId": 27022,
      "gloss": "children's rights",
      "glossSv": "barnrätt, barnens rätt (FN)",
      "pos": "noun",
      "explanation": "right + child",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        336,
        "/",
        220
      ]
    },
    {
      "id": 5866,
      "bciAvId": 27023,
      "gloss": "chip shop",
      "glossSv": "gatukök",
      "pos": "noun",
      "explanation": "restaurant [contraction] + French fries",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        685,
        "/",
        428,
        ";",
        97,
        "/",
        480
      ]
    },
    {
      "id": 5867,
      "bciAvId": 27024,
      "gloss": "chronic fatigue syndrome",
      "glossSv": "kroniskt trötthetssyndrom",
      "pos": "noun",
      "explanation": "sickness + tired + intensity + intensity + intensity",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        467,
        "/",
        562,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 5868,
      "bciAvId": 27025,
      "gloss": "co-housing",
      "glossSv": "kollektivboende",
      "pos": "noun",
      "explanation": "village + agreement: A group of housing with agreement",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        392,
        "/",
        113
      ]
    },
    {
      "id": 5869,
      "bciAvId": 27027,
      "gloss": "to conceptualise, to conceptualize",
      "glossSv": "gestalta",
      "pos": "action",
      "explanation": "concept + action indicator",
      "isCharacter": false,
      "composition": [
        5837,
        ";",
        81
      ]
    },
    {
      "id": 5870,
      "bciAvId": 27028,
      "gloss": "concrete",
      "glossSv": "konkret",
      "pos": "description",
      "explanation": "thing + description indicator",
      "isCharacter": false,
      "composition": [
        651,
        ";",
        86
      ]
    },
    {
      "id": 5871,
      "bciAvId": 27029,
      "gloss": "conjunction",
      "glossSv": "konjunktion",
      "pos": "noun",
      "explanation": "word + combination",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        232
      ]
    },
    {
      "id": 5872,
      "bciAvId": 27030,
      "gloss": "courgette, zucchini",
      "glossSv": "squash, zuccini",
      "pos": "noun",
      "explanation": "squash,pumpkin + long",
      "isCharacter": false,
      "composition": [
        618,
        "/",
        420
      ]
    },
    {
      "id": 5874,
      "bciAvId": 27033,
      "gloss": "delicacy, speciality (food)",
      "glossSv": "delikatess, specialitet (-mat)",
      "pos": "noun",
      "explanation": "food + feeling + interesting",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        313,
        "/",
        955
      ]
    },
    {
      "id": 5875,
      "bciAvId": 27034,
      "gloss": "democracy (general)",
      "glossSv": "demokrati (allmänt)",
      "pos": "noun",
      "explanation": "lead + permission + choice",
      "isCharacter": false,
      "composition": [
        803,
        "/",
        960,
        "/",
        223
      ]
    },
    {
      "id": 5876,
      "bciAvId": 27035,
      "gloss": "dictator (general)",
      "glossSv": "diktator (allmänt)",
      "pos": "person",
      "explanation": "leader + permission + without + choice",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        960,
        "/",
        449,
        "/",
        223
      ]
    },
    {
      "id": 5877,
      "bciAvId": 27036,
      "gloss": "dictatorship (general)",
      "glossSv": "diktatur (allmänt)",
      "pos": "noun",
      "explanation": "lead + permission + without + choice",
      "isCharacter": false,
      "composition": [
        803,
        "/",
        960,
        "/",
        449,
        "/",
        223
      ]
    },
    {
      "id": 5878,
      "bciAvId": 27037,
      "gloss": "to discover",
      "glossSv": "upptäcka",
      "pos": "action",
      "explanation": "discovery + action indicator",
      "isCharacter": false,
      "composition": [
        303,
        ";",
        81,
        "/",
        1044,
        "/",
        1061
      ]
    },
    {
      "id": 5879,
      "bciAvId": 27038,
      "gloss": "discovery",
      "glossSv": "upptäckt",
      "pos": "noun",
      "explanation": "find + new",
      "isCharacter": false,
      "composition": [
        303,
        "/",
        1044,
        "/",
        1061
      ]
    },
    {
      "id": 5880,
      "bciAvId": 27039,
      "gloss": "dishwasher",
      "glossSv": "diskmaskin",
      "pos": "noun",
      "explanation": "washer + dish",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        595,
        "/",
        265
      ]
    },
    {
      "id": 5881,
      "bciAvId": 27040,
      "gloss": "drink mix, shake, smoothie",
      "glossSv": "smootie, shake",
      "pos": "noun",
      "explanation": "drink + mix",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        783
      ]
    },
    {
      "id": 5882,
      "bciAvId": 27041,
      "gloss": "dual",
      "glossSv": "dualis",
      "pos": "noun",
      "explanation": "category + [contraction] noun + two",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        11
      ]
    },
    {
      "id": 5883,
      "bciAvId": 27042,
      "gloss": "duty, obligation",
      "glossSv": "plikt, skyldighet",
      "pos": "noun",
      "explanation": "protection + must (a): protected requirements e.g. in law",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        804
      ]
    },
    {
      "id": 5884,
      "bciAvId": 27043,
      "gloss": "earwax",
      "glossSv": "öronvax",
      "pos": "noun",
      "explanation": "substance + ear: substance of the ear",
      "isCharacter": false,
      "composition": [
        898,
        "/",
        278
      ]
    },
    {
      "id": 5885,
      "bciAvId": 27044,
      "gloss": "edible, eatable",
      "glossSv": "ätlig, ätbar",
      "pos": "description",
      "explanation": "food + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        329,
        ";",
        85
      ]
    },
    {
      "id": 5886,
      "bciAvId": 27045,
      "gloss": "electric conductor",
      "glossSv": "elektrisk ledare",
      "pos": "noun",
      "explanation": "material + through + electricity",
      "isCharacter": false,
      "composition": [
        438,
        "/",
        653,
        "/",
        288
      ]
    },
    {
      "id": 5887,
      "bciAvId": 27046,
      "gloss": "electric toothbrush",
      "glossSv": "elektrisk tandborste",
      "pos": "noun",
      "explanation": "toothbrush + electricity",
      "isCharacter": false,
      "composition": [
        184,
        "/",
        644,
        "/",
        288
      ]
    },
    {
      "id": 5888,
      "bciAvId": 27047,
      "gloss": "electric wire, electric cord, cord, cable, lead",
      "glossSv": "elektrisk tråd, elektrisk kabel, elektrisk ledare",
      "pos": "noun",
      "explanation": "fiber + electric",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        288
      ]
    },
    {
      "id": 5889,
      "bciAvId": 27048,
      "gloss": "emergency call, emergency telephone",
      "glossSv": "nödsamtal",
      "pos": "noun",
      "explanation": "call + danger",
      "isCharacter": false,
      "composition": [
        414,
        "/",
        288,
        "/",
        "RK:-2",
        "/",
        256
      ]
    },
    {
      "id": 5890,
      "bciAvId": 27049,
      "gloss": "emergency room (medical)",
      "glossSv": "akutmottagning",
      "pos": "noun",
      "explanation": "room + medical + danger",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        958,
        "/",
        256
      ]
    },
    {
      "id": 5891,
      "bciAvId": 27050,
      "gloss": "epidemic",
      "glossSv": "epidemi",
      "pos": "noun",
      "explanation": "sickness + spread",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        941
      ]
    },
    {
      "id": 5892,
      "bciAvId": 27051,
      "gloss": "epiglottis",
      "glossSv": "epiglottis, struplock",
      "pos": "noun",
      "explanation": "part + throat + lid",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        1142,
        "/",
        791
      ]
    },
    {
      "id": 5893,
      "bciAvId": 27052,
      "gloss": "exhausted, worn out",
      "glossSv": "utmattad, utsliten",
      "pos": "description",
      "explanation": "feeling + without + energy [contraction] + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        288
      ]
    },
    {
      "id": 5894,
      "bciAvId": 27053,
      "gloss": "exploration",
      "glossSv": "utforskning",
      "pos": "noun",
      "explanation": "search [contraction] + new",
      "isCharacter": false,
      "composition": [
        969,
        "/",
        1061
      ]
    },
    {
      "id": 5895,
      "bciAvId": 27054,
      "gloss": "fast food",
      "glossSv": "snabbmat",
      "pos": "noun",
      "explanation": "food + fast",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 5896,
      "bciAvId": 27055,
      "gloss": "first aid",
      "glossSv": "första hjälpen",
      "pos": "noun",
      "explanation": "aid + medical + first",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        958,
        "/",
        10,
        "/",
        4
      ]
    },
    {
      "id": 5897,
      "bciAvId": 27056,
      "gloss": "fish skin",
      "glossSv": "fiskskinn",
      "pos": "noun",
      "explanation": "protection + fish",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        321
      ]
    },
    {
      "id": 5898,
      "bciAvId": 27057,
      "gloss": "future tense",
      "glossSv": "framtid, futurum",
      "pos": "noun",
      "explanation": "category + language + future: language category of future time",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        341
      ]
    },
    {
      "id": 5899,
      "bciAvId": 27058,
      "gloss": "germination",
      "glossSv": "groning, groddning",
      "pos": "noun",
      "explanation": "start + growth",
      "isCharacter": false,
      "composition": [
        159,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 5900,
      "bciAvId": 27059,
      "gloss": "gluten-free",
      "glossSv": "glutenfri",
      "pos": "description",
      "explanation": "without + grain + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        357,
        ";",
        86
      ]
    },
    {
      "id": 5901,
      "bciAvId": 27060,
      "gloss": "grammar (general)",
      "glossSv": "gramatik(-allmänt)",
      "pos": "noun",
      "explanation": "rule + word: rules of the language",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5902,
      "bciAvId": 27061,
      "gloss": "grapheme",
      "glossSv": "grafem",
      "pos": "noun",
      "explanation": "unit + small + different + write: the smallest unit that makes difference in writing",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        956,
        "/",
        262,
        "/",
        509
      ]
    },
    {
      "id": 5903,
      "bciAvId": 27063,
      "gloss": "heart attack",
      "glossSv": "hjärtattack",
      "pos": "noun",
      "explanation": "sickness + heart + lightning",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        313,
        ";",
        97,
        "/",
        425
      ]
    },
    {
      "id": 5904,
      "bciAvId": 27064,
      "gloss": "heart disease",
      "glossSv": "hjärtsjukdom",
      "pos": "noun",
      "explanation": "sickness + heart",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        313,
        ";",
        97
      ]
    },
    {
      "id": 5906,
      "bciAvId": 27066,
      "gloss": "human rights",
      "glossSv": "mänskliga rättigheter",
      "pos": "noun",
      "explanation": "right + person",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        336,
        "/",
        513
      ]
    },
    {
      "id": 5907,
      "bciAvId": 27067,
      "gloss": "immune (medical)",
      "glossSv": "immun (-medicinsk)",
      "pos": "description",
      "explanation": "immunity (medical) + description indicator",
      "isCharacter": false,
      "composition": [
        111,
        ";",
        86,
        "/",
        516
      ]
    },
    {
      "id": 5908,
      "bciAvId": 27068,
      "gloss": "immunity (medical)",
      "glossSv": "immunitet (-medicinsk)",
      "pos": "noun",
      "explanation": "against + sickness",
      "isCharacter": false,
      "composition": [
        111,
        "/",
        516
      ]
    },
    {
      "id": 5909,
      "bciAvId": 27069,
      "gloss": "to improve",
      "glossSv": "förbättra",
      "pos": "action",
      "explanation": "improvement + action indicator: the effect of being better in a rational sense",
      "isCharacter": false,
      "composition": [
        284,
        ";",
        81,
        "/",
        937,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 5910,
      "bciAvId": 27070,
      "gloss": "improvement, enhancement",
      "glossSv": "förbättring, förändring",
      "pos": "noun",
      "explanation": "effect + more + correct +: the effect of being better in a rational sense",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        937,
        "/",
        1012,
        "/",
        401
      ]
    },
    {
      "id": 5911,
      "bciAvId": 27071,
      "gloss": "independent living",
      "glossSv": "självständigt boende",
      "pos": "noun",
      "explanation": "to live (life) + independent",
      "isCharacter": false,
      "composition": [
        423,
        "/",
        101,
        "/",
        2343
      ]
    },
    {
      "id": 5912,
      "bciAvId": 27072,
      "gloss": "infix",
      "glossSv": "infix",
      "pos": "noun",
      "explanation": "unit + language + inside",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        414,
        "/",
        398
      ]
    },
    {
      "id": 5913,
      "bciAvId": 27073,
      "gloss": "inflatable",
      "glossSv": "uppblåsbar",
      "pos": "description",
      "explanation": "to inflate + description before the fact indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        85,
        "/",
        114
      ]
    },
    {
      "id": 5914,
      "bciAvId": 27074,
      "gloss": "interjection",
      "glossSv": "interjektion",
      "pos": "noun",
      "explanation": "word + feeling",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        313
      ]
    },
    {
      "id": 5915,
      "bciAvId": 27075,
      "gloss": "intersection, crossroad",
      "glossSv": "vägkorsning",
      "pos": "noun",
      "explanation": "road (1) + across: one road crossing the other",
      "isCharacter": false,
      "composition": [
        569,
        "/",
        104
      ]
    },
    {
      "id": 5916,
      "bciAvId": 27077,
      "gloss": "joke (general)",
      "glossSv": "skämt (allmänt)",
      "pos": "noun",
      "explanation": "activity + comma + funny",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        5,
        "/",
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 5917,
      "bciAvId": 27078,
      "gloss": "joke (spoken)",
      "glossSv": "skämt (talat)",
      "pos": "noun",
      "explanation": "to say + comma + funny",
      "isCharacter": false,
      "composition": [
        457,
        "/",
        5,
        "/",
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 5918,
      "bciAvId": 27076,
      "gloss": "to joke (general)",
      "glossSv": "skämt (allmänt)",
      "pos": "action",
      "explanation": "joke (general) + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        5,
        "/",
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 5919,
      "bciAvId": 27079,
      "gloss": "kangaroo, wallaby",
      "glossSv": "kängeru, vallaby",
      "pos": "noun",
      "explanation": "animal + container + jump",
      "isCharacter": false,
      "composition": [
        122,
        "/",
        239,
        "/",
        836
      ]
    },
    {
      "id": 5920,
      "bciAvId": 27082,
      "gloss": "kyphosis, scoliosis",
      "glossSv": "skolios, kufos",
      "pos": "noun",
      "explanation": "bone + back + curve",
      "isCharacter": false,
      "composition": [
        172,
        "/",
        143,
        "/",
        255
      ]
    },
    {
      "id": 5921,
      "bciAvId": 27083,
      "gloss": "larynx",
      "glossSv": "struphuvud",
      "pos": "noun",
      "explanation": "part + throat + activity + sound",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        1142,
        "/",
        "RK:-2",
        "/",
        106,
        "/",
        608
      ]
    },
    {
      "id": 5922,
      "bciAvId": 27084,
      "gloss": "learning difficulty",
      "glossSv": "inlärningssvårigheter",
      "pos": "noun",
      "explanation": "limitation + to learn",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        920,
        "/",
        412
      ]
    },
    {
      "id": 5923,
      "bciAvId": 27086,
      "gloss": "lukewarm, handwarm, tepid",
      "glossSv": "fingervarmt",
      "pos": "description",
      "explanation": "warm + little + hand + description indicator",
      "isCharacter": false,
      "composition": [
        378,
        ";",
        86,
        "/",
        956,
        "/",
        374
      ]
    },
    {
      "id": 5924,
      "bciAvId": 27087,
      "gloss": "mammoth",
      "glossSv": "mammut",
      "pos": "noun",
      "explanation": "furred animal + nose",
      "isCharacter": false,
      "composition": [
        1141,
        "/",
        473
      ]
    },
    {
      "id": 5925,
      "bciAvId": 27088,
      "gloss": "marshmallow",
      "glossSv": "mashmallow",
      "pos": "noun",
      "explanation": "candy + [contraction]soft",
      "isCharacter": false,
      "composition": [
        782,
        "/",
        1049
      ]
    },
    {
      "id": 5926,
      "bciAvId": 27089,
      "gloss": "milkshake",
      "glossSv": "milkshake",
      "pos": "noun",
      "explanation": "smoothie + [contraction] milk",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        783,
        "/",
        423
      ]
    },
    {
      "id": 5927,
      "bciAvId": 27090,
      "gloss": "morpheme",
      "glossSv": "morfem",
      "pos": "noun",
      "explanation": "unit + [contraction] + small + different + words [contraction] word: the smallest unit that makes difference in words",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        956,
        "/",
        262,
        "/",
        414
      ]
    },
    {
      "id": 5928,
      "bciAvId": 27091,
      "gloss": "morphology",
      "glossSv": "morfologi",
      "pos": "noun",
      "explanation": "rule + structure + word: rules of the language structure",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        633,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5929,
      "bciAvId": 27092,
      "gloss": "nasal cavity",
      "glossSv": "näshåla",
      "pos": "noun",
      "explanation": "inside + nose",
      "isCharacter": false,
      "composition": [
        398,
        "/",
        473
      ]
    },
    {
      "id": 5930,
      "bciAvId": 27093,
      "gloss": "to navigate (general)",
      "glossSv": "navigera (allmänt)",
      "pos": "action",
      "explanation": "activity + sign + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        651,
        "/",
        835
      ]
    },
    {
      "id": 5931,
      "bciAvId": 27094,
      "gloss": "navigation (general)",
      "glossSv": "navigering (allmänt)",
      "pos": "noun",
      "explanation": "activity + sign",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        651,
        "/",
        835
      ]
    },
    {
      "id": 5932,
      "bciAvId": 27095,
      "gloss": "non-alcoholic",
      "glossSv": "alkoholfri",
      "pos": "description",
      "explanation": "without + alcoholic drink + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        116,
        ";",
        86
      ]
    },
    {
      "id": 5933,
      "bciAvId": 27096,
      "gloss": "noun",
      "glossSv": "substantiv",
      "pos": "noun",
      "explanation": "word + name",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        464
      ]
    },
    {
      "id": 5934,
      "bciAvId": 27097,
      "gloss": "nude, naked",
      "glossSv": "naken",
      "pos": "description",
      "explanation": "nudity + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        ";",
        86,
        "/",
        229
      ]
    },
    {
      "id": 5935,
      "bciAvId": 27098,
      "gloss": "nudity",
      "glossSv": "nakenhet",
      "pos": "noun",
      "explanation": "without + clothes",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        229
      ]
    },
    {
      "id": 5936,
      "bciAvId": 27099,
      "gloss": "number, numeral",
      "glossSv": "nummer, siffra",
      "pos": "noun",
      "explanation": "word + number: numeral words",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        478
      ]
    },
    {
      "id": 5937,
      "bciAvId": 27100,
      "gloss": "oral cavity",
      "glossSv": "munhåla",
      "pos": "noun",
      "explanation": "inside + mouth",
      "isCharacter": false,
      "composition": [
        398,
        "/",
        457
      ]
    },
    {
      "id": 5938,
      "bciAvId": 27101,
      "gloss": "oven paper",
      "glossSv": "bakplåtspapper",
      "pos": "noun",
      "explanation": "paper + oven",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        630
      ]
    },
    {
      "id": 5939,
      "bciAvId": 27102,
      "gloss": "palate, roof of mouth",
      "glossSv": "gom",
      "pos": "noun",
      "explanation": "ceiling + mouth",
      "isCharacter": false,
      "composition": [
        208,
        "/",
        457
      ]
    },
    {
      "id": 5940,
      "bciAvId": 27103,
      "gloss": "pandemic",
      "glossSv": "pandemi",
      "pos": "noun",
      "explanation": "sickness + spread + intensity",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        941,
        "/",
        401
      ]
    },
    {
      "id": 5941,
      "bciAvId": 27104,
      "gloss": "part of speech",
      "glossSv": "dela av tal",
      "pos": "noun",
      "explanation": "category + word",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5942,
      "bciAvId": 27105,
      "gloss": "past tense",
      "glossSv": "dåtid, preteritum",
      "pos": "noun",
      "explanation": "category + language + past: language category of past time",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        503
      ]
    },
    {
      "id": 5943,
      "bciAvId": 27106,
      "gloss": "peanut",
      "glossSv": "jordnöt",
      "pos": "noun",
      "explanation": "seed + combination: seeds joined in combination",
      "isCharacter": false,
      "composition": [
        584,
        "/",
        232
      ]
    },
    {
      "id": 5944,
      "bciAvId": 27107,
      "gloss": "phoneme",
      "glossSv": "fonem",
      "pos": "noun",
      "explanation": "unit + [contraction] + small + different + sound: the smallest sound unit that makes difference",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        956,
        "/",
        262,
        "/",
        608
      ]
    },
    {
      "id": 5945,
      "bciAvId": 27108,
      "gloss": "phonology",
      "glossSv": "fonologi",
      "pos": "noun",
      "explanation": "rule + sound + word: rules of language sounds",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        608,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5946,
      "bciAvId": 27109,
      "gloss": "pizzeria",
      "glossSv": "pizzeria",
      "pos": "noun",
      "explanation": "restaurant [contraction] + pizza [contraction]",
      "isCharacter": false,
      "composition": [
        550,
        "/",
        1068
      ]
    },
    {
      "id": 5947,
      "bciAvId": 27110,
      "gloss": "plague",
      "glossSv": "pest",
      "pos": "noun",
      "explanation": "sickness + first [contraction] + micro-organism + intensity",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        10,
        "/",
        894,
        ";",
        97,
        "/",
        956,
        "/",
        401
      ]
    },
    {
      "id": 5948,
      "bciAvId": 27111,
      "gloss": "plastic wrap",
      "glossSv": "hushållsplast, plastfolie",
      "pos": "noun",
      "explanation": "wrapping + [contraction] plastic",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        97,
        "/",
        216
      ]
    },
    {
      "id": 5949,
      "bciAvId": 27112,
      "gloss": "plural",
      "glossSv": "flertal, plural",
      "pos": "noun",
      "explanation": "category + [contraction] noun + many",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        368
      ]
    },
    {
      "id": 5950,
      "bciAvId": 27113,
      "gloss": "pointer",
      "glossSv": "pekare",
      "pos": "noun",
      "explanation": "pointing + thing indicator",
      "isCharacter": false,
      "composition": [
        844,
        ";",
        97
      ]
    },
    {
      "id": 5951,
      "bciAvId": 27114,
      "gloss": "pole",
      "glossSv": "påle, stång",
      "pos": "noun",
      "explanation": "linear thing + big",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        936
      ]
    },
    {
      "id": 5952,
      "bciAvId": 27115,
      "gloss": "pollen",
      "glossSv": "pollen",
      "pos": "noun",
      "explanation": "powder + flower",
      "isCharacter": false,
      "composition": [
        544,
        "/",
        325
      ]
    },
    {
      "id": 5953,
      "bciAvId": 27116,
      "gloss": "post position",
      "glossSv": "postposition",
      "pos": "noun",
      "explanation": "word + after",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        109
      ]
    },
    {
      "id": 5954,
      "bciAvId": 27117,
      "gloss": "prefix",
      "glossSv": "prefix",
      "pos": "noun",
      "explanation": "unit + language + beginning: language units in the beginning of a word",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        414,
        "/",
        159
      ]
    },
    {
      "id": 5955,
      "bciAvId": 27118,
      "gloss": "preposition",
      "glossSv": "preposition",
      "pos": "noun",
      "explanation": "word + in front of",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        158
      ]
    },
    {
      "id": 5956,
      "bciAvId": 27119,
      "gloss": "present tense",
      "glossSv": "nutid, presens",
      "pos": "noun",
      "explanation": "category + language + present: language category of present time",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        546
      ]
    },
    {
      "id": 5957,
      "bciAvId": 27120,
      "gloss": "pronoun",
      "glossSv": "pronomen",
      "pos": "noun",
      "explanation": "word + in exchange for + name: in exchange for nouns",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        331,
        "/",
        464
      ]
    },
    {
      "id": 5958,
      "bciAvId": 27121,
      "gloss": "right(s)",
      "glossSv": "rättighet, rättigheter",
      "pos": "noun",
      "explanation": "protection + freedom: protection of freedom",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        336
      ]
    },
    {
      "id": 5959,
      "bciAvId": 27122,
      "gloss": "rights of persons with disabilities, disability rights",
      "glossSv": "rättighet för personer med funktionsnedsättning",
      "pos": "noun",
      "explanation": "right + person + limited",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        336,
        "/",
        513,
        "/",
        1053
      ]
    },
    {
      "id": 5960,
      "bciAvId": 27123,
      "gloss": "roundabout",
      "glossSv": "rondell, cirkulationsplats",
      "pos": "noun",
      "explanation": "road (1) + rotate: a road junction at which traffic streams circularly around a central island",
      "isCharacter": false,
      "composition": [
        569,
        "/",
        887
      ]
    },
    {
      "id": 5961,
      "bciAvId": 27124,
      "gloss": "semantics",
      "glossSv": "semantik",
      "pos": "noun",
      "explanation": "science + language + meaning: study/science of linguistic/language meanings",
      "isCharacter": false,
      "composition": [
        580,
        "/",
        414,
        "/",
        440
      ]
    },
    {
      "id": 5962,
      "bciAvId": 27125,
      "gloss": "shared housing",
      "glossSv": "delat boende",
      "pos": "noun",
      "explanation": "house + share: shared housing, groupliving",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        953,
        "/",
        823
      ]
    },
    {
      "id": 5963,
      "bciAvId": 27126,
      "gloss": "singular",
      "glossSv": "ental, singular",
      "pos": "noun",
      "explanation": "category + [contraction] noun + one",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        10
      ]
    },
    {
      "id": 5964,
      "bciAvId": 27127,
      "gloss": "sleep medication",
      "glossSv": "sömnmedel",
      "pos": "noun",
      "explanation": "medication + sleep",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        958,
        "/",
        599
      ]
    },
    {
      "id": 5965,
      "bciAvId": 27128,
      "gloss": "sleeping pill",
      "glossSv": "sömnpiller",
      "pos": "noun",
      "explanation": "pill + sleep",
      "isCharacter": false,
      "composition": [
        263,
        "/",
        958,
        "/",
        599
      ]
    },
    {
      "id": 5966,
      "bciAvId": 27129,
      "gloss": "sleeping place, nest (animals)",
      "glossSv": "boplats, viloplats (djur)",
      "pos": "noun",
      "explanation": "place + sleep + animal",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        599,
        "/",
        122
      ]
    },
    {
      "id": 5967,
      "bciAvId": 27130,
      "gloss": "snot",
      "glossSv": "snor",
      "pos": "noun",
      "explanation": "substance + nose: substance of the nose",
      "isCharacter": false,
      "composition": [
        898,
        "/",
        473
      ]
    },
    {
      "id": 5968,
      "bciAvId": 27131,
      "gloss": "sprout",
      "glossSv": "grodd",
      "pos": "noun",
      "explanation": "plant + start",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        159
      ]
    },
    {
      "id": 5969,
      "bciAvId": 27132,
      "gloss": "starfruit, carambola",
      "glossSv": "stjärnfrukt, carambola",
      "pos": "noun",
      "explanation": "fruit + star",
      "isCharacter": false,
      "composition": [
        338,
        "/",
        622
      ]
    },
    {
      "id": 5970,
      "bciAvId": 27133,
      "gloss": "stethoscope",
      "glossSv": "stetoskop",
      "pos": "noun",
      "explanation": "tool + medical + sound",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        958,
        "/",
        608
      ]
    },
    {
      "id": 5971,
      "bciAvId": 27134,
      "gloss": "sticking plaster, bandaid",
      "glossSv": "plåster",
      "pos": "noun",
      "explanation": "bandage + together: contracted bandage sticky",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        958,
        "/",
        823
      ]
    },
    {
      "id": 5972,
      "bciAvId": 27135,
      "gloss": "to stir",
      "glossSv": "röra ihop",
      "pos": "action",
      "explanation": "mix + spoon + action indicator",
      "isCharacter": false,
      "composition": [
        783,
        ";",
        81,
        "/",
        614
      ]
    },
    {
      "id": 5973,
      "bciAvId": 27136,
      "gloss": "stress",
      "glossSv": "stress",
      "pos": "noun",
      "explanation": "feeling + pressure",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        815
      ]
    },
    {
      "id": 5974,
      "bciAvId": 27137,
      "gloss": "stressed, stressful",
      "glossSv": "stressad, stressande",
      "pos": "description",
      "explanation": "stress + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        815
      ]
    },
    {
      "id": 5975,
      "bciAvId": 27138,
      "gloss": "to stutter",
      "glossSv": "stamma",
      "pos": "action",
      "explanation": "stuttering + action indicator",
      "isCharacter": false,
      "composition": [
        1053,
        ";",
        81,
        "/",
        457,
        "/",
        963
      ]
    },
    {
      "id": 5976,
      "bciAvId": 27139,
      "gloss": "stuttering",
      "glossSv": "stamning",
      "pos": "noun",
      "explanation": "limitation + mouth + repeat: speech limitation, repetition of sounds and blocks",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        457,
        "/",
        963
      ]
    },
    {
      "id": 5977,
      "bciAvId": 27140,
      "gloss": "to suck",
      "glossSv": "suga",
      "pos": "action",
      "explanation": "mouth + into (backward) + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        1123
      ]
    },
    {
      "id": 5978,
      "bciAvId": 27141,
      "gloss": "suffix",
      "glossSv": "suffix",
      "pos": "noun",
      "explanation": "unit + language + end: language units in the end of a word",
      "isCharacter": false,
      "composition": [
        10,
        ";",
        97,
        "/",
        414,
        "/",
        292
      ]
    },
    {
      "id": 5979,
      "bciAvId": 27142,
      "gloss": "sushi",
      "glossSv": "sushi",
      "pos": "noun",
      "explanation": "ball + rice + fish",
      "isCharacter": false,
      "composition": [
        148,
        "/",
        565,
        "/",
        321
      ]
    },
    {
      "id": 5980,
      "bciAvId": 27143,
      "gloss": "syntax",
      "glossSv": "syntax",
      "pos": "noun",
      "explanation": "rule + sentence: rules of the language sentences",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        803,
        "/",
        368,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 5981,
      "bciAvId": 27144,
      "gloss": "tense",
      "glossSv": "tempus",
      "pos": "noun",
      "explanation": "category + language + time: language category of time",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        414,
        "/",
        655
      ]
    },
    {
      "id": 5982,
      "bciAvId": 27145,
      "gloss": "thyroid gland",
      "glossSv": "sköldkörtel",
      "pos": "noun",
      "explanation": "gland + throat: arrow pointing to throat is missing",
      "isCharacter": false,
      "composition": [
        993,
        "/",
        "RK:-2",
        "/",
        216,
        "/",
        1142
      ]
    },
    {
      "id": 5983,
      "bciAvId": 27146,
      "gloss": "tired, weary",
      "glossSv": "trött, uttröttad",
      "pos": "description",
      "explanation": "need + rest + description indicator: need of rest",
      "isCharacter": false,
      "composition": [
        467,
        ";",
        86,
        "/",
        562
      ]
    },
    {
      "id": 5984,
      "bciAvId": 27147,
      "gloss": "tonsils",
      "glossSv": "tonsill",
      "pos": "noun",
      "explanation": "part + throat + immunity: arrow pointing to throat is missing",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        1142,
        "/",
        111,
        "/",
        516
      ]
    },
    {
      "id": 5985,
      "bciAvId": 27148,
      "gloss": "traffic light",
      "glossSv": "trafikljus",
      "pos": "noun",
      "explanation": "lamp + [contraction] traffic",
      "isCharacter": false,
      "composition": [
        424,
        ";",
        97,
        "/",
        688
      ]
    },
    {
      "id": 5986,
      "bciAvId": 27149,
      "gloss": "transgender",
      "glossSv": "transgender",
      "pos": "description",
      "explanation": "transgender (gender) + description indicator",
      "isCharacter": false,
      "composition": [
        5844,
        ";",
        86
      ]
    },
    {
      "id": 5987,
      "bciAvId": 27151,
      "gloss": "vegan food",
      "glossSv": "vegansk kost",
      "pos": "noun",
      "explanation": "food + only + plant",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        894,
        "/",
        10,
        "/",
        533
      ]
    },
    {
      "id": 5988,
      "bciAvId": 27152,
      "gloss": "verb",
      "glossSv": "verb",
      "pos": "noun",
      "explanation": "word + action: action words",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        414,
        "/",
        "RK:-2",
        "/",
        105
      ]
    },
    {
      "id": 5989,
      "bciAvId": 27153,
      "gloss": "wasp",
      "glossSv": "geting",
      "pos": "noun",
      "explanation": "stinging insect + wings + intensity",
      "isCharacter": false,
      "composition": [
        327,
        "/",
        538,
        "/",
        401
      ]
    },
    {
      "id": 5990,
      "bciAvId": 27154,
      "gloss": "to whisk, to beat",
      "glossSv": "vispa",
      "pos": "action",
      "explanation": "mix + kitchen tool,utensil + action indicator",
      "isCharacter": false,
      "composition": [
        783,
        ";",
        81,
        "/",
        786
      ]
    },
    {
      "id": 5991,
      "bciAvId": 27155,
      "gloss": "wire, cable",
      "glossSv": "tråd, kabel",
      "pos": "noun",
      "explanation": "fiber + metal [contraction]",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        814
      ]
    },
    {
      "id": 5992,
      "bciAvId": 27156,
      "gloss": "wireless connection",
      "glossSv": "trådlöst nätverk, wifi, trådlös uppkoppling",
      "pos": "noun",
      "explanation": "digital signal + without + fiber",
      "isCharacter": false,
      "composition": [
        922,
        "/",
        829,
        "/",
        449,
        "/",
        1122
      ]
    },
    {
      "id": 5993,
      "bciAvId": 27157,
      "gloss": "wrapping",
      "glossSv": "omslag",
      "pos": "noun",
      "explanation": "spiral + thing indicator",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        97
      ]
    },
    {
      "id": 5994,
      "bciAvId": 27158,
      "gloss": "wrapping, paper roll",
      "glossSv": "omslagspapper, presentpapper, pappersrulle",
      "pos": "noun",
      "explanation": "wrapping + paper",
      "isCharacter": false,
      "composition": [
        1090,
        ";",
        97,
        "/",
        497
      ]
    },
    {
      "id": 5995,
      "gloss": "upper lip",
      "pos": "noun",
      "explanation": "lip(s) + pointer to upper lip -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 5996,
      "bciAvId": 28044,
      "gloss": "indicator (plural definite)",
      "glossSv": "operator (substantiv;plural, bestämd form)",
      "pos": "function",
      "explanation": "indicator (plural + definite)",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 5997,
      "bciAvId": 28045,
      "gloss": "indicator (thing definite)",
      "glossSv": "operator( konkret substantiv, bestämd form)",
      "pos": "function",
      "explanation": "indicator (thing + definite)",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 5998,
      "bciAvId": 28046,
      "gloss": "indicator (thing plural definite)",
      "glossSv": "operator (sak, plural, bestämd form)",
      "pos": "function",
      "explanation": "indicator (thing + plural + definite)",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 5999,
      "bciAvId": 28052,
      "gloss": "modifier (diminutive form)",
      "glossSv": "modifier (diminutiv form)",
      "pos": "function",
      "explanation": "grammatical modification (small) [half size, crossing baseline]",
      "isCharacter": true
    },
    {
      "id": 6000,
      "bciAvId": 28053,
      "gloss": "modifier (feminine form)",
      "glossSv": "modifier (feminin form)",
      "pos": "function",
      "explanation": "grammatical modification (feminine) [half size, crossing baseline]",
      "isCharacter": true
    },
    {
      "id": 6001,
      "bciAvId": 28056,
      "gloss": "modifier (neuter form)",
      "glossSv": "modifier (neutrumform)",
      "pos": "function",
      "explanation": "grammatical modification (neuter) [bottom part of symbol for person, half size, crossing baseline]",
      "isCharacter": true
    },
    {
      "id": 6002,
      "bciAvId": 28055,
      "gloss": "modifier (masculine form)",
      "glossSv": "modifier (maskulin form)",
      "pos": "function",
      "explanation": "grammatical modification (masculine) [half size, crossing baseline]",
      "isCharacter": true
    },
    {
      "id": 6003,
      "bciAvId": 28057,
      "gloss": "modifier (object form, direct object, accusative)",
      "glossSv": "modifier (direkt objektsform, ackustiv)",
      "pos": "function",
      "explanation": "grammatical modification (to) [half size, crossing baseline]: - Note: The drawing of the symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": true
    },
    {
      "id": 6004,
      "bciAvId": 28001,
      "gloss": "aim, intention",
      "glossSv": "avsikt, syfte, mening",
      "pos": "noun",
      "explanation": "purpose + forward",
      "isCharacter": false,
      "composition": [
        551,
        "/",
        335
      ]
    },
    {
      "id": 6005,
      "bciAvId": 28002,
      "gloss": "allowable, permissable",
      "glossSv": "tillåtelse",
      "pos": "description",
      "explanation": "allow + before fact",
      "isCharacter": false,
      "composition": [
        960,
        ";",
        85
      ]
    },
    {
      "id": 6006,
      "bciAvId": 28003,
      "gloss": "allowed, permitted",
      "glossSv": "tillåtet",
      "pos": "description",
      "explanation": "allow + after fact",
      "isCharacter": false,
      "composition": [
        960,
        ";",
        84
      ]
    },
    {
      "id": 6007,
      "bciAvId": 28004,
      "gloss": "amusement park, theme park",
      "glossSv": "nöjespark, tivoli",
      "pos": "noun",
      "explanation": "park + excitement",
      "isCharacter": false,
      "composition": [
        501,
        "/",
        313,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 6008,
      "bciAvId": 28005,
      "gloss": "arm support",
      "glossSv": "armstöd",
      "pos": "noun",
      "explanation": "aid + arm",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        132
      ]
    },
    {
      "id": 6010,
      "bciAvId": 28007,
      "gloss": "audience",
      "glossSv": "publik, åhörare",
      "pos": "person",
      "explanation": "group + see + hear",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        303,
        "/",
        278
      ]
    },
    {
      "id": 6011,
      "bciAvId": 28008,
      "gloss": "basketball player",
      "glossSv": "basketbollspelare",
      "pos": "person",
      "explanation": "person + basketball [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        148,
        "/",
        1009
      ]
    },
    {
      "id": 6012,
      "bciAvId": 28009,
      "gloss": "carnival",
      "glossSv": "karneval",
      "pos": "noun",
      "explanation": "festival + costume",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        401,
        "/",
        401,
        "/",
        229,
        "/",
        945
      ]
    },
    {
      "id": 6013,
      "bciAvId": 28010,
      "gloss": "climate change",
      "glossSv": "klimatförändring",
      "pos": "noun",
      "explanation": "climate [contraction] + development",
      "isCharacter": true
    },
    {
      "id": 6014,
      "bciAvId": 28011,
      "gloss": "climate emergency",
      "glossSv": "klimathot",
      "pos": "noun",
      "explanation": "climate change + danger",
      "isCharacter": false,
      "composition": [
        6013,
        "/",
        256
      ]
    },
    {
      "id": 6015,
      "bciAvId": 28012,
      "gloss": "development",
      "glossSv": "utveckling",
      "pos": "noun",
      "explanation": "change + forward [modification, short arrow]: change through progression",
      "isCharacter": true
    },
    {
      "id": 6016,
      "bciAvId": 28013,
      "gloss": "to discriminate",
      "glossSv": "diskriminera",
      "pos": "action",
      "explanation": "discrimination + action indicator",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        81,
        "/",
        262
      ]
    },
    {
      "id": 6017,
      "bciAvId": 28014,
      "gloss": "to discriminate (person)",
      "glossSv": "diskriminera (person)",
      "pos": "action",
      "explanation": "discriminate-(to) + person",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        81,
        "/",
        262,
        "/",
        513
      ]
    },
    {
      "id": 6018,
      "bciAvId": 28015,
      "gloss": "discriminated (person)",
      "glossSv": "diskriminerad",
      "pos": "description",
      "explanation": "discriminatory + person",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        86,
        "/",
        262,
        "/",
        513
      ]
    },
    {
      "id": 6019,
      "bciAvId": 28016,
      "gloss": "discrimination",
      "glossSv": "diskriminering",
      "pos": "noun",
      "explanation": "sort + different",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        262
      ]
    },
    {
      "id": 6020,
      "bciAvId": 28017,
      "gloss": "discrimination (person)",
      "glossSv": "diskriminering, fördom",
      "pos": "noun",
      "explanation": "discrimination + person",
      "isCharacter": false,
      "composition": [
        673,
        "/",
        262,
        "/",
        513
      ]
    },
    {
      "id": 6021,
      "bciAvId": 28018,
      "gloss": "discriminatory",
      "glossSv": "diskriminerad",
      "pos": "description",
      "explanation": "discrimination + description indicator",
      "isCharacter": false,
      "composition": [
        673,
        ";",
        86,
        "/",
        262
      ]
    },
    {
      "id": 6022,
      "bciAvId": 28019,
      "gloss": "to ensure, to guarantee",
      "glossSv": "försäkra, garantera",
      "pos": "action",
      "explanation": "certain + action indicator [remove doubt]",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        802,
        ";",
        81
      ]
    },
    {
      "id": 6023,
      "bciAvId": 28020,
      "gloss": "event dressing up, carnival",
      "glossSv": "maskerad, karneval",
      "pos": "noun",
      "explanation": "event + costume",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        229,
        "/",
        945
      ]
    },
    {
      "id": 6024,
      "bciAvId": 28021,
      "gloss": "eye pointing",
      "glossSv": "ögonpekning",
      "pos": "noun",
      "explanation": "pointing + eye",
      "isCharacter": false,
      "composition": [
        844,
        "/",
        303
      ]
    },
    {
      "id": 6025,
      "bciAvId": 28022,
      "gloss": "eye pointing (digital)",
      "glossSv": "ögonpekning (digital)",
      "pos": "noun",
      "explanation": "eye pointing + digital",
      "isCharacter": false,
      "composition": [
        844,
        "/",
        303,
        "/",
        829
      ]
    },
    {
      "id": 6026,
      "bciAvId": 28023,
      "gloss": "fancy dress party",
      "glossSv": "kostymfest, maskerad",
      "pos": "noun",
      "explanation": "gathering + costume",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        229,
        "/",
        945
      ]
    },
    {
      "id": 6027,
      "bciAvId": 28024,
      "gloss": "festival",
      "glossSv": "festival",
      "pos": "noun",
      "explanation": "event + excitement",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 6028,
      "bciAvId": 28025,
      "gloss": "football field, soccer field",
      "glossSv": "fotbollsplan",
      "pos": "noun",
      "explanation": "place + football [contraction]",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 6029,
      "bciAvId": 28026,
      "gloss": "football game, match, soccer game",
      "glossSv": "fotbollsmatch",
      "pos": "noun",
      "explanation": "competition + football [contraction]",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 6030,
      "bciAvId": 28027,
      "gloss": "football player, soccer player",
      "glossSv": "fotbollsspelare",
      "pos": "person",
      "explanation": "person + football [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        148,
        "/",
        418
      ]
    },
    {
      "id": 6031,
      "bciAvId": 28028,
      "gloss": "global warming",
      "glossSv": "global uppvärmning",
      "pos": "noun",
      "explanation": "climate change + temperature + rising",
      "isCharacter": false,
      "composition": [
        6013,
        "/",
        645,
        "/",
        678
      ]
    },
    {
      "id": 6032,
      "bciAvId": 28029,
      "gloss": "goalpost",
      "glossSv": "målstolpe",
      "pos": "noun",
      "explanation": "pole [contraction] + goal",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        354
      ]
    },
    {
      "id": 6033,
      "bciAvId": 28030,
      "gloss": "goal keeper",
      "glossSv": "målvakt",
      "pos": "person",
      "explanation": "person + football [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        354
      ]
    },
    {
      "id": 6034,
      "bciAvId": 28031,
      "gloss": "goal net",
      "glossSv": "målnät",
      "pos": "noun",
      "explanation": "fabric + goal",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        354
      ]
    },
    {
      "id": 6035,
      "bciAvId": 28032,
      "gloss": "goal (result), score",
      "glossSv": "mål",
      "pos": "noun",
      "explanation": "goal + intensity",
      "isCharacter": false,
      "composition": [
        354,
        "/",
        401
      ]
    },
    {
      "id": 6036,
      "bciAvId": 28033,
      "gloss": "goal, target",
      "glossSv": "målsättning, syfte",
      "pos": "noun",
      "explanation": "purpose + end",
      "isCharacter": false,
      "composition": [
        551,
        "/",
        292
      ]
    },
    {
      "id": 6037,
      "bciAvId": 28034,
      "gloss": "handball court",
      "glossSv": "handbollsplan",
      "pos": "noun",
      "explanation": "place + handball [contraction]",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        148,
        "/",
        374
      ]
    },
    {
      "id": 6038,
      "bciAvId": 28035,
      "gloss": "handball game",
      "glossSv": "handbollsmatch",
      "pos": "noun",
      "explanation": "competition + handball [contraction]",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        148,
        "/",
        374
      ]
    },
    {
      "id": 6039,
      "bciAvId": 28036,
      "gloss": "handball player",
      "glossSv": "handbollsspelare",
      "pos": "person",
      "explanation": "person + handball [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        148,
        "/",
        374
      ]
    },
    {
      "id": 6040,
      "bciAvId": 28037,
      "gloss": "head support",
      "glossSv": "huvudstöd",
      "pos": "noun",
      "explanation": "aid + head",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        376
      ]
    },
    {
      "id": 6041,
      "bciAvId": 28038,
      "gloss": "homeland, nationality (loyalty)",
      "glossSv": "hemland, fosterland",
      "pos": "noun",
      "explanation": "country + feeling",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        313
      ]
    },
    {
      "id": 6042,
      "bciAvId": 28039,
      "gloss": "hoodie",
      "glossSv": "huvtröja, hoodie",
      "pos": "noun",
      "explanation": "shirt + protection + head",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        218,
        "/",
        548,
        "/",
        376
      ]
    },
    {
      "id": 6043,
      "bciAvId": 28040,
      "gloss": "ice hockey rink",
      "glossSv": "ishockeyrink",
      "pos": "noun",
      "explanation": "place + ice hockey [contraction]",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        1093,
        "/",
        394
      ]
    },
    {
      "id": 6044,
      "bciAvId": 28041,
      "gloss": "to implement",
      "glossSv": "genomföra, realisera",
      "pos": "action",
      "explanation": "implementation + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        299
      ]
    },
    {
      "id": 6045,
      "bciAvId": 28042,
      "gloss": "implementation, realisation, realization",
      "glossSv": "genomförande, realisering",
      "pos": "noun",
      "explanation": "cause + happen",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        299
      ]
    },
    {
      "id": 6050,
      "bciAvId": 28047,
      "gloss": "to insure",
      "glossSv": "försäkra",
      "pos": "action",
      "explanation": "insurance + action indicator",
      "isCharacter": false,
      "composition": [
        1050,
        ";",
        81
      ]
    },
    {
      "id": 6051,
      "bciAvId": 28048,
      "gloss": "listener",
      "glossSv": "åhörare, lyssnare",
      "pos": "person",
      "explanation": "person + hear",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        278
      ]
    },
    {
      "id": 6052,
      "bciAvId": 28049,
      "gloss": "long lasting, durable",
      "glossSv": "långvarig, varaktig",
      "pos": "description",
      "explanation": "time + long",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        86,
        "/",
        420
      ]
    },
    {
      "id": 6053,
      "bciAvId": 28050,
      "gloss": "manner, manners",
      "glossSv": "sätt, uppträdande",
      "pos": "noun",
      "explanation": "activity + citizen",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        225
      ]
    },
    {
      "id": 6054,
      "bciAvId": 28051,
      "gloss": "manner, way, mode, style (habit)",
      "glossSv": "sätt, bruk, vana",
      "pos": "noun",
      "explanation": "activity + most",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        968
      ]
    },
    {
      "id": 6061,
      "bciAvId": 28058,
      "gloss": "music festival",
      "glossSv": "musikfestival",
      "pos": "noun",
      "explanation": "festival + music [contraction]",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        401,
        "/",
        401,
        "/",
        462
      ]
    },
    {
      "id": 6062,
      "bciAvId": 28059,
      "gloss": "nationality (official)",
      "glossSv": "nationalitet",
      "pos": "noun",
      "explanation": "country + paper",
      "isCharacter": false,
      "composition": [
        243,
        "/",
        497
      ]
    },
    {
      "id": 6063,
      "bciAvId": 28060,
      "gloss": "negative outcome",
      "glossSv": "negativt resultat",
      "pos": "noun",
      "explanation": "consequence + minus",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        449
      ]
    },
    {
      "id": 6064,
      "bciAvId": 28061,
      "gloss": "neck support",
      "glossSv": "nackstöd",
      "pos": "noun",
      "explanation": "aid + neck (head)",
      "isCharacter": false,
      "composition": [
        382,
        ";",
        97,
        "/",
        465
      ]
    },
    {
      "id": 6065,
      "bciAvId": 28062,
      "gloss": "paint box",
      "glossSv": "färglåda",
      "pos": "noun",
      "explanation": "case + paint [contraction]",
      "isCharacter": false,
      "composition": [
        1006,
        "/",
        1161,
        "/",
        695
      ]
    },
    {
      "id": 6066,
      "bciAvId": 28063,
      "gloss": "penalty (sport)",
      "glossSv": "straff (sport)",
      "pos": "noun",
      "explanation": "punishment + sport",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        449,
        "/",
        401,
        "/",
        719
      ]
    },
    {
      "id": 6067,
      "bciAvId": 28064,
      "gloss": "positive outcome",
      "glossSv": "resultat (positivt)",
      "pos": "noun",
      "explanation": "consequence + plus",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        120
      ]
    },
    {
      "id": 6068,
      "bciAvId": 28065,
      "gloss": "pride parade, festival of equality",
      "glossSv": "pridefestival",
      "pos": "noun",
      "explanation": "event + feeling + equality",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        313,
        "/",
        578
      ]
    },
    {
      "id": 6069,
      "bciAvId": 28066,
      "gloss": "punishment",
      "glossSv": "bestraffning",
      "pos": "noun",
      "explanation": "consequence + negative",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 6070,
      "bciAvId": 28067,
      "gloss": "realistic",
      "glossSv": "verklig, realistisk",
      "pos": "description",
      "explanation": "reality + description indicator",
      "isCharacter": false,
      "composition": [
        1118,
        ";",
        86
      ]
    },
    {
      "id": 6071,
      "bciAvId": 28068,
      "gloss": "to realise, to realize",
      "glossSv": "förverkliga",
      "pos": "action",
      "explanation": "to cause + reality",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        1118
      ]
    },
    {
      "id": 6072,
      "bciAvId": 28069,
      "gloss": "red card, penalty card (sports)",
      "glossSv": "rött kort, straffkort (sport)",
      "pos": "noun",
      "explanation": "card + red",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        1161,
        "/",
        457
      ]
    },
    {
      "id": 6073,
      "bciAvId": 28070,
      "gloss": "reference, references, source, sources",
      "glossSv": "uppslag, referenser, källa (till information)",
      "pos": "noun",
      "explanation": "generalization + idea",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        397
      ]
    },
    {
      "id": 6074,
      "bciAvId": 28071,
      "gloss": "reference list",
      "glossSv": "referenslista",
      "pos": "noun",
      "explanation": "paper + references",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        348,
        "/",
        397
      ]
    },
    {
      "id": 6075,
      "bciAvId": 28072,
      "gloss": "reward",
      "glossSv": "belöning",
      "pos": "noun",
      "explanation": "consequence + positive",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        106,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 6076,
      "bciAvId": 28073,
      "gloss": "roller coaster",
      "glossSv": "bergochdalbana",
      "pos": "noun",
      "explanation": "vehicle + up + turn + fast",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        678,
        "/",
        1101,
        "/",
        335,
        "/",
        401
      ]
    },
    {
      "id": 6077,
      "bciAvId": 28074,
      "gloss": "rugby field, football field (N.A.)",
      "glossSv": "rugbyplan",
      "pos": "noun",
      "explanation": "place + rugby [contraction]",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        754,
        "/",
        418
      ]
    },
    {
      "id": 6078,
      "bciAvId": 28075,
      "gloss": "seam (fabric)",
      "glossSv": "söm, tygsöm",
      "pos": "noun",
      "explanation": "attachment + fabric",
      "isCharacter": false,
      "composition": [
        823,
        "/",
        228
      ]
    },
    {
      "id": 6079,
      "bciAvId": 28076,
      "gloss": "spectator",
      "glossSv": "åskådare",
      "pos": "person",
      "explanation": "person + see",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        303
      ]
    },
    {
      "id": 6080,
      "bciAvId": 28077,
      "gloss": "speech generating device, voice output device, speech output device, talker",
      "glossSv": "talapparat, talsyntesapparat",
      "pos": "noun",
      "explanation": "digital device + speak",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        457
      ]
    },
    {
      "id": 6081,
      "bciAvId": 28078,
      "gloss": "to sustain",
      "glossSv": "upprätthålla, bevara",
      "pos": "action",
      "explanation": "protection + action indicator + future",
      "isCharacter": false,
      "composition": [
        548,
        ";",
        81,
        "/",
        341
      ]
    },
    {
      "id": 6082,
      "bciAvId": 28079,
      "gloss": "suture, join, seam (medical)",
      "glossSv": "sutur, stygn (kirurgi)",
      "pos": "noun",
      "explanation": "attachment + medical",
      "isCharacter": false,
      "composition": [
        823,
        "/",
        958
      ]
    },
    {
      "id": 6083,
      "bciAvId": 28080,
      "gloss": "sweater, jumper, pullover",
      "glossSv": "tröja, kofta, jumper, sweater",
      "pos": "noun",
      "explanation": "shirt + over",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        218,
        "/",
        493
      ]
    },
    {
      "id": 6084,
      "bciAvId": 28081,
      "gloss": "uniform",
      "glossSv": "uniform",
      "pos": "noun",
      "explanation": "clothes + group",
      "isCharacter": false,
      "composition": [
        229,
        "/",
        368,
        "/",
        513
      ]
    },
    {
      "id": 6085,
      "bciAvId": 28082,
      "gloss": "water park",
      "glossSv": "vattenpark, vattenland",
      "pos": "noun",
      "explanation": "amusement park + pool",
      "isCharacter": false,
      "composition": [
        501,
        "/",
        313,
        "/",
        401,
        "/",
        401,
        "/",
        539
      ]
    },
    {
      "id": 6086,
      "bciAvId": 28083,
      "gloss": "whoops, oops",
      "glossSv": "hoppsan!, Oj då!",
      "pos": "function",
      "explanation": "emotion + talking + hand+ intensity [superimposed]: something you say to play down a small accident",
      "isCharacter": false,
      "composition": [
        970,
        "/",
        374,
        "/",
        401
      ]
    },
    {
      "id": 6087,
      "bciAvId": 28084,
      "gloss": "yellow card, penalty card (sports)",
      "glossSv": "gult kort, straffkort",
      "pos": "noun",
      "explanation": "card + yellow: warning for bad behavior in sporting game",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        1161,
        "/",
        636
      ]
    },
    {
      "id": 6088,
      "bciAvId": 29001,
      "gloss": "address book, contact list",
      "glossSv": "adressbok",
      "pos": "noun",
      "explanation": "book + address [contraction]",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        464,
        "/",
        531
      ]
    },
    {
      "id": 6089,
      "bciAvId": 29002,
      "gloss": "afterwards",
      "glossSv": "efteråt, därefter",
      "pos": "expression",
      "explanation": "time + after",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        109
      ]
    },
    {
      "id": 6092,
      "bciAvId": 29005,
      "gloss": "another time",
      "glossSv": "en annan gång",
      "pos": "expression",
      "explanation": "time + 2 (digital)",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        11
      ]
    },
    {
      "id": 6093,
      "bciAvId": 29006,
      "gloss": "applicant",
      "glossSv": "sökande",
      "pos": "person",
      "explanation": "person + question + application",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        553,
        "/",
        260
      ]
    },
    {
      "id": 6094,
      "bciAvId": 29007,
      "gloss": "application",
      "glossSv": "ansökan",
      "pos": "noun",
      "explanation": "question + decision",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        260
      ]
    },
    {
      "id": 6095,
      "bciAvId": 29008,
      "gloss": "to apply",
      "glossSv": "ansöka om",
      "pos": "action",
      "explanation": "activity + application + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        553,
        "/",
        260
      ]
    },
    {
      "id": 6096,
      "bciAvId": 29009,
      "gloss": "archive",
      "glossSv": "arkiv",
      "pos": "noun",
      "explanation": "collection + important",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        954
      ]
    },
    {
      "id": 6097,
      "bciAvId": 29010,
      "gloss": "baby shop, baby store",
      "glossSv": "babybutik",
      "pos": "noun",
      "explanation": "shop + thing + baby",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        651,
        "/",
        140
      ]
    },
    {
      "id": 6098,
      "bciAvId": 29011,
      "gloss": "bag shop, bag store, luggage shop, luggage store",
      "glossSv": "väskaffär",
      "pos": "noun",
      "explanation": "shop + bag",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        147
      ]
    },
    {
      "id": 6099,
      "bciAvId": 29012,
      "gloss": "beforehand",
      "glossSv": "innan, på förhand",
      "pos": "expression",
      "explanation": "time + before",
      "isCharacter": false,
      "composition": [
        655,
        "/",
        158
      ]
    },
    {
      "id": 6100,
      "bciAvId": 29013,
      "gloss": "bicycle shop, bicycle store",
      "glossSv": "cykelaffär",
      "pos": "noun",
      "explanation": "shop + bicycle",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6101,
      "bciAvId": 29014,
      "gloss": "binder, ring binder",
      "glossSv": "pärm, ringpärm",
      "pos": "noun",
      "explanation": "folder + ring",
      "isCharacter": false,
      "composition": [
        833,
        "/",
        567
      ]
    },
    {
      "id": 6102,
      "bciAvId": 29015,
      "gloss": "bungee",
      "glossSv": "elastisk stropp, bagagestropp",
      "pos": "noun",
      "explanation": "fiber + stretching + hook",
      "isCharacter": false,
      "composition": [
        1122,
        "/",
        1163,
        "/",
        387
      ]
    },
    {
      "id": 6103,
      "bciAvId": 29016,
      "gloss": "car dealer, car dealership",
      "glossSv": "bilhandlare, bilaffär",
      "pos": "noun",
      "explanation": "shop + car",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        202
      ]
    },
    {
      "id": 6104,
      "bciAvId": 29017,
      "gloss": "computer shop, computer store, electronics shop, electronics store",
      "glossSv": "datoraffär, elektronikaffär",
      "pos": "noun",
      "explanation": "shop + digital device",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        901
      ]
    },
    {
      "id": 6105,
      "bciAvId": 29018,
      "gloss": "concave",
      "glossSv": "konkav",
      "pos": "description",
      "explanation": "concavity + description indicator",
      "isCharacter": false,
      "composition": [
        6106,
        ";",
        86
      ]
    },
    {
      "id": 6106,
      "bciAvId": 29019,
      "gloss": "concavity",
      "glossSv": "kon (formen)",
      "pos": "noun",
      "explanation": "concavity: lines curving inward",
      "isCharacter": true
    },
    {
      "id": 6107,
      "bciAvId": 29020,
      "gloss": "cone (shape)",
      "glossSv": "konform",
      "pos": "noun",
      "explanation": "shape + cone -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        237
      ]
    },
    {
      "id": 6108,
      "bciAvId": 29021,
      "gloss": "convex",
      "glossSv": "konvex",
      "pos": "description",
      "explanation": "convexity + description indicator",
      "isCharacter": false,
      "composition": [
        6109,
        ";",
        86
      ]
    },
    {
      "id": 6109,
      "bciAvId": 29022,
      "gloss": "convexity",
      "glossSv": "lins (konvex)",
      "pos": "noun",
      "explanation": "convexity: lines curving or bulging outward",
      "isCharacter": true
    },
    {
      "id": 6110,
      "bciAvId": 29023,
      "gloss": "Corona virus",
      "glossSv": "coronavirus",
      "pos": "noun",
      "explanation": "virus + crown",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956,
        "/",
        963,
        "/",
        798
      ]
    },
    {
      "id": 6111,
      "bciAvId": 29024,
      "gloss": "Covid 19",
      "glossSv": "covid 19",
      "pos": "noun",
      "explanation": "corona virus + 19",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956,
        "/",
        963,
        "/",
        798,
        "/",
        10,
        "/",
        18
      ]
    },
    {
      "id": 6112,
      "bciAvId": 29025,
      "gloss": "cube (shape)",
      "glossSv": "kub (formen)",
      "pos": "noun",
      "explanation": "shape + cube -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        177
      ]
    },
    {
      "id": 6113,
      "bciAvId": 29026,
      "gloss": "cylinder (shape)",
      "glossSv": "cylinder (formen)",
      "pos": "noun",
      "explanation": "shape + cylinder -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        200
      ]
    },
    {
      "id": 6114,
      "bciAvId": 29027,
      "gloss": "date(1)",
      "glossSv": "datum",
      "pos": "noun",
      "explanation": "year + month + day",
      "isCharacter": false,
      "composition": [
        716,
        "/",
        452,
        "/",
        258
      ]
    },
    {
      "id": 6115,
      "bciAvId": 29028,
      "gloss": "date(2)",
      "glossSv": "datum",
      "pos": "noun",
      "explanation": "day + month + year",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        452,
        "/",
        716
      ]
    },
    {
      "id": 6116,
      "bciAvId": 29029,
      "gloss": "date(3)",
      "glossSv": "datum",
      "pos": "noun",
      "explanation": "month + day + year",
      "isCharacter": false,
      "composition": [
        452,
        "/",
        258,
        "/",
        716
      ]
    },
    {
      "id": 6117,
      "bciAvId": 29030,
      "gloss": "decagon",
      "glossSv": "tiohörning, dekagon",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 10 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        10,
        "/",
        9
      ]
    },
    {
      "id": 6118,
      "bciAvId": 29031,
      "gloss": "digital board, interactive board, smart board",
      "glossSv": "smartboard, elektronisk tavla",
      "pos": "noun",
      "explanation": "enclosed space + pen + digital",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        509,
        "/",
        829
      ]
    },
    {
      "id": 6119,
      "bciAvId": 29032,
      "gloss": "direct, directly",
      "glossSv": "direkt",
      "pos": "description",
      "explanation": "toward + exclamation mark",
      "isCharacter": false,
      "composition": [
        657,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 6120,
      "bciAvId": 29033,
      "gloss": "elastic cord, elastic band",
      "glossSv": "resår, gummiband, gummicord, resårband, gummistropp",
      "pos": "noun",
      "explanation": "string + stretching",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1122,
        "/",
        1163
      ]
    },
    {
      "id": 6121,
      "bciAvId": 29034,
      "gloss": "electrical shop, electrical store",
      "glossSv": "el-affär, el-butik",
      "pos": "noun",
      "explanation": "shop + thing + electricity",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        651,
        "/",
        288
      ]
    },
    {
      "id": 6122,
      "bciAvId": 29035,
      "gloss": "eraser",
      "glossSv": "radergummi, suddgummi, sak att ta bort med",
      "pos": "noun",
      "explanation": "destroy + thing indicator",
      "isCharacter": false,
      "composition": [
        939,
        ";",
        97
      ]
    },
    {
      "id": 6123,
      "bciAvId": 29036,
      "gloss": "everywhere",
      "glossSv": "överallt",
      "pos": "noun",
      "explanation": "all + place",
      "isCharacter": false,
      "composition": [
        117,
        "/",
        531
      ]
    },
    {
      "id": 6124,
      "bciAvId": 29037,
      "gloss": "fabric shop, fabric store",
      "glossSv": "tygaffär",
      "pos": "noun",
      "explanation": "cloth + stretching",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        228
      ]
    },
    {
      "id": 6125,
      "bciAvId": 29038,
      "gloss": "filing cabinet",
      "glossSv": "arkivskåp, dokumentskåp",
      "pos": "noun",
      "explanation": "chest of drawers + folder",
      "isCharacter": false,
      "composition": [
        219,
        "/",
        833
      ]
    },
    {
      "id": 6126,
      "bciAvId": 29039,
      "gloss": "global",
      "glossSv": "global, världsomfattande",
      "pos": "description",
      "explanation": "earth + description indicator",
      "isCharacter": false,
      "composition": [
        280,
        ";",
        86
      ]
    },
    {
      "id": 6127,
      "bciAvId": 29040,
      "gloss": "glue stick, glue tube",
      "glossSv": "klistertub, limstift",
      "pos": "noun",
      "explanation": "glue + tube [pictorial]",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        823,
        "/",
        867
      ]
    },
    {
      "id": 6128,
      "bciAvId": 29041,
      "gloss": "hardware store (goods)",
      "glossSv": "järnhandel",
      "pos": "noun",
      "explanation": "shop + tool",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        660
      ]
    },
    {
      "id": 6129,
      "bciAvId": 29042,
      "gloss": "heart (shape)",
      "glossSv": "hjärta (formen)",
      "pos": "noun",
      "explanation": "shape + heart -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        313
      ]
    },
    {
      "id": 6130,
      "bciAvId": 29043,
      "gloss": "heptagon",
      "glossSv": "sjuhörning, heptagon",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 7 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        16
      ]
    },
    {
      "id": 6131,
      "bciAvId": 29044,
      "gloss": "hexagon",
      "glossSv": "sexhörning, hexagon",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 6 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        15
      ]
    },
    {
      "id": 6132,
      "bciAvId": 29045,
      "gloss": "highlighter, marker",
      "glossSv": "överstrykningspenna, markeringpenna",
      "pos": "noun",
      "explanation": "pen + colour + interest",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        1161,
        "/",
        955
      ]
    },
    {
      "id": 6133,
      "bciAvId": 29046,
      "gloss": "isolation",
      "glossSv": "isolering, avskildhet",
      "pos": "noun",
      "explanation": "being (state of) + 1",
      "isCharacter": false,
      "composition": [
        894,
        "/",
        10
      ]
    },
    {
      "id": 6134,
      "bciAvId": 29047,
      "gloss": "jewelry shop, jewellery store, jewellers",
      "glossSv": "guldsmed (affär), juvelerare (affär)",
      "pos": "noun",
      "explanation": "shop + jewelry",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        348,
        "/",
        629,
        "/",
        622
      ]
    },
    {
      "id": 6135,
      "bciAvId": 29048,
      "gloss": "job application, work application",
      "glossSv": "arbetsansökan, jobbansökan",
      "pos": "noun",
      "explanation": "application + work",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        260,
        "/",
        711
      ]
    },
    {
      "id": 6136,
      "bciAvId": 29049,
      "gloss": "job qualification",
      "glossSv": "yrkeskvalifikation, yrkescertifikatlegitimation (yrke), yrkeslegitimation",
      "pos": "noun",
      "explanation": "card + profession",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        711,
        "/",
        223
      ]
    },
    {
      "id": 6137,
      "bciAvId": 29050,
      "gloss": "local",
      "glossSv": "närliggande, lokal (närområde)",
      "pos": "description",
      "explanation": "place + description indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        86
      ]
    },
    {
      "id": 6138,
      "bciAvId": 29051,
      "gloss": "long time ago",
      "glossSv": "för längesedan, längesedan, längesen",
      "pos": "expression",
      "explanation": "limited time + long + ago",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        420,
        "/",
        112
      ]
    },
    {
      "id": 6139,
      "bciAvId": 29052,
      "gloss": "lycra, spandex, stretchy fabric",
      "glossSv": "elasta, stretchtyg, elastiskt tyg",
      "pos": "noun",
      "explanation": "cloth + stretching",
      "isCharacter": false,
      "composition": [
        228,
        "/",
        1163
      ]
    },
    {
      "id": 6141,
      "bciAvId": 29054,
      "gloss": "minimum",
      "glossSv": "minimum",
      "pos": "noun",
      "explanation": "opposite meaning + maximum",
      "isCharacter": false,
      "composition": [
        486,
        "/",
        968
      ]
    },
    {
      "id": 6142,
      "bciAvId": 29055,
      "gloss": "music shop, music store",
      "glossSv": "musikaffär",
      "pos": "noun",
      "explanation": "shop + record",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        865
      ]
    },
    {
      "id": 6143,
      "bciAvId": 29056,
      "gloss": "nail gun",
      "glossSv": "spikpistol",
      "pos": "noun",
      "explanation": "tool + nail",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        463
      ]
    },
    {
      "id": 6144,
      "bciAvId": 29057,
      "gloss": "notice board, bulletin board",
      "glossSv": "anslagstavla",
      "pos": "noun",
      "explanation": "enclosed space + information",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        835
      ]
    },
    {
      "id": 6145,
      "bciAvId": 29058,
      "gloss": "octagon",
      "glossSv": "octagon, åttahörning, oktagon",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 8 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        17
      ]
    },
    {
      "id": 6146,
      "bciAvId": 29059,
      "gloss": "parallelogram",
      "glossSv": "parallellogram",
      "pos": "noun",
      "explanation": "quadrilateral+ parallel + 2 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        13,
        "/",
        498,
        "/",
        11
      ]
    },
    {
      "id": 6147,
      "bciAvId": 29060,
      "gloss": "pastry shop, patisserie",
      "glossSv": "konditori",
      "pos": "noun",
      "explanation": "shop + cake",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        180,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 6148,
      "bciAvId": 29061,
      "gloss": "pentagon",
      "glossSv": "femhörning, pentagon",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 5 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        14
      ]
    },
    {
      "id": 6149,
      "bciAvId": 29062,
      "gloss": "perfumery",
      "glossSv": "parfymeri",
      "pos": "noun",
      "explanation": "shop + perfume",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        600,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 6150,
      "bciAvId": 29063,
      "gloss": "pet shop, pet store",
      "glossSv": "djuraffär, zooaffär",
      "pos": "noun",
      "explanation": "shop + animal",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        122
      ]
    },
    {
      "id": 6151,
      "bciAvId": 29064,
      "gloss": "polygon (category)",
      "glossSv": "månghörning, polygon",
      "pos": "noun",
      "explanation": "shape + gereralization + corner [contraction] -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        348,
        "/",
        1094
      ]
    },
    {
      "id": 6152,
      "bciAvId": 29065,
      "gloss": "post-it note, reminder note",
      "glossSv": "post-itlapp, minneslapp",
      "pos": "noun",
      "explanation": "paper + memory + attached",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        841,
        "/",
        823
      ]
    },
    {
      "id": 6153,
      "bciAvId": 29066,
      "gloss": "project",
      "glossSv": "projekt",
      "pos": "noun",
      "explanation": "plan + activity + purpose",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        106,
        "/",
        551
      ]
    },
    {
      "id": 6154,
      "bciAvId": 29067,
      "gloss": "pyramid (shape)",
      "glossSv": "pyramid (formen)",
      "pos": "noun",
      "explanation": "shape + pyramid -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        552
      ]
    },
    {
      "id": 6155,
      "bciAvId": 29068,
      "gloss": "quadrilateral",
      "glossSv": "fyrhörning, fyrkant, kvadrat",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 4 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        13
      ]
    },
    {
      "id": 6156,
      "bciAvId": 29069,
      "gloss": "quarantine",
      "glossSv": "karantän",
      "pos": "noun",
      "explanation": "isolation + medicine",
      "isCharacter": false,
      "composition": [
        894,
        "/",
        10,
        "/",
        958
      ]
    },
    {
      "id": 6157,
      "bciAvId": 29070,
      "gloss": "record shop, record store, music shop music store",
      "glossSv": "skivaffär, musikaffär",
      "pos": "noun",
      "explanation": "shop + record",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        1075,
        "/",
        278
      ]
    },
    {
      "id": 6158,
      "bciAvId": 29071,
      "gloss": "report",
      "glossSv": "rapport",
      "pos": "noun",
      "explanation": "full + information",
      "isCharacter": false,
      "composition": [
        947,
        "/",
        835
      ]
    },
    {
      "id": 6159,
      "bciAvId": 29072,
      "gloss": "re-usable, recycable",
      "glossSv": "återanvändbar, återbrukbar",
      "pos": "description",
      "explanation": "use + again + description indicator before the fact",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        85,
        "/",
        110
      ]
    },
    {
      "id": 6160,
      "bciAvId": 29073,
      "gloss": "re-used, recycled",
      "glossSv": "återanvänd, återbrukad",
      "pos": "description",
      "explanation": "use + again + description indicator after the fact",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        84,
        "/",
        110
      ]
    },
    {
      "id": 6161,
      "bciAvId": 29074,
      "gloss": "rubber band",
      "glossSv": "gummiband",
      "pos": "noun",
      "explanation": "ring + stretching",
      "isCharacter": false,
      "composition": [
        567,
        "/",
        1163
      ]
    },
    {
      "id": 6162,
      "bciAvId": 29075,
      "gloss": "scotch tape, adhesive tape",
      "glossSv": "tejp, klisterremsa",
      "pos": "noun",
      "explanation": "linear thing + glue",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        216,
        "/",
        823
      ]
    },
    {
      "id": 6163,
      "bciAvId": 29076,
      "gloss": "second hand",
      "glossSv": "second hand, begagnad",
      "pos": "description",
      "explanation": "second hand + description indicator",
      "isCharacter": false,
      "composition": [
        356,
        ";",
        86,
        "/",
        110
      ]
    },
    {
      "id": 6164,
      "bciAvId": 29077,
      "gloss": "second hand (goods)",
      "glossSv": "second hand (varor), begagnade varor, loppisföremål",
      "pos": "noun",
      "explanation": "goods + again",
      "isCharacter": false,
      "composition": [
        356,
        "/",
        110
      ]
    },
    {
      "id": 6165,
      "bciAvId": 29078,
      "gloss": "second hand clothes shop, second hand clothing shop",
      "glossSv": "second hand affär (kläder)",
      "pos": "noun",
      "explanation": "shop + clothes + second hand [contraction]",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        229,
        "/",
        110
      ]
    },
    {
      "id": 6166,
      "bciAvId": 29079,
      "gloss": "second hand shop, charity shop, vintage shop",
      "glossSv": "secondhandaffär, loppis",
      "pos": "noun",
      "explanation": "shop + second hand",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        356,
        "/",
        110
      ]
    },
    {
      "id": 6167,
      "bciAvId": 29080,
      "gloss": "semicircle, half circle (shape)",
      "glossSv": "halvcirkel",
      "pos": "noun",
      "explanation": "shape + half circle -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        255
      ]
    },
    {
      "id": 6168,
      "bciAvId": 29081,
      "gloss": "shape (in combinations)",
      "glossSv": "form (i kombinationer)",
      "pos": "noun",
      "explanation": "eye + thing -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": true
    },
    {
      "id": 6169,
      "bciAvId": 29082,
      "gloss": "shoe shop, shoe store",
      "glossSv": "skoaffär",
      "pos": "noun",
      "explanation": "shop + shoe",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        548,
        "/",
        330
      ]
    },
    {
      "id": 6170,
      "bciAvId": 29083,
      "gloss": "shredder (paper), paper shredder",
      "glossSv": "dokumentförstörare",
      "pos": "noun",
      "explanation": "machine + destroy + paper",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        939,
        "/",
        497
      ]
    },
    {
      "id": 6171,
      "bciAvId": 29084,
      "gloss": "social distance",
      "glossSv": "social distans, avstånd, distans (socialt)",
      "pos": "noun",
      "explanation": "at a distance + person",
      "isCharacter": false,
      "composition": [
        996,
        "/",
        513
      ]
    },
    {
      "id": 6172,
      "bciAvId": 29085,
      "gloss": "to social distance",
      "glossSv": "hålla avstånd (socialt)",
      "pos": "action",
      "explanation": "at a distance + person + action indicator",
      "isCharacter": false,
      "composition": [
        996,
        ";",
        81,
        "/",
        513
      ]
    },
    {
      "id": 6173,
      "bciAvId": 29086,
      "gloss": "spiral binder",
      "glossSv": "spiralpärm, spiralblock, mapp (med spiral)",
      "pos": "noun",
      "explanation": "folder + spiral",
      "isCharacter": false,
      "composition": [
        833,
        "/",
        1090
      ]
    },
    {
      "id": 6174,
      "bciAvId": 29087,
      "gloss": "staple gun",
      "glossSv": "häftpistol",
      "pos": "noun",
      "explanation": "tool + pin + material",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        524,
        "/",
        438
      ]
    },
    {
      "id": 6175,
      "bciAvId": 29088,
      "gloss": "staple remover",
      "glossSv": "stiftborttagare, borttagare av klammer",
      "pos": "noun",
      "explanation": "tool + remove + pin",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        634,
        "/",
        524
      ]
    },
    {
      "id": 6176,
      "bciAvId": 29089,
      "gloss": "stapler",
      "glossSv": "häftapparat",
      "pos": "noun",
      "explanation": "tool + pin + paper",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        524,
        "/",
        497
      ]
    },
    {
      "id": 6177,
      "bciAvId": 29090,
      "gloss": "star (shape)",
      "glossSv": "stjärnform",
      "pos": "noun",
      "explanation": "shape + star -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        622
      ]
    },
    {
      "id": 6178,
      "bciAvId": 29091,
      "gloss": "stationery shop, stationery store",
      "glossSv": "pappershandel",
      "pos": "noun",
      "explanation": "shop + generalization + pen: pen represents all writing material in the stationery shop -- Note: The drawing of the generalization symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        348,
        "/",
        509
      ]
    },
    {
      "id": 6179,
      "bciAvId": 29092,
      "gloss": "tag, sticker, label",
      "glossSv": "etikett, sticker, namnlapp",
      "pos": "noun",
      "explanation": "card + little + information",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        956,
        "/",
        835
      ]
    },
    {
      "id": 6180,
      "bciAvId": 29093,
      "gloss": "third (ordinal)",
      "glossSv": "tredje",
      "pos": "description",
      "explanation": "3 + decimal point + description indicator",
      "isCharacter": false,
      "composition": [
        12,
        ";",
        86,
        "/",
        4
      ]
    },
    {
      "id": 6181,
      "bciAvId": 29094,
      "gloss": "this afternoon",
      "glossSv": "i eftermiddag",
      "pos": "noun",
      "explanation": "afternoon + now",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        109,
        "/",
        10,
        "/",
        11,
        "/",
        474
      ]
    },
    {
      "id": 6182,
      "bciAvId": 29095,
      "gloss": "this evening",
      "glossSv": "ikväll, i kväll",
      "pos": "noun",
      "explanation": "evening + now",
      "isCharacter": false,
      "composition": [
        298,
        "/",
        474
      ]
    },
    {
      "id": 6183,
      "bciAvId": 29096,
      "gloss": "this morning",
      "glossSv": "imorse, i morse",
      "pos": "noun",
      "explanation": "morning (early) + now",
      "isCharacter": false,
      "composition": [
        454,
        "/",
        474
      ]
    },
    {
      "id": 6184,
      "bciAvId": 29097,
      "gloss": "tiny, mini, minscule, teeny-tiny",
      "glossSv": "pytteliten, mini",
      "pos": "description",
      "explanation": "little,small + intensity",
      "isCharacter": false,
      "composition": [
        956,
        ";",
        86,
        "/",
        401,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 6185,
      "bciAvId": 29098,
      "gloss": "trapezoid, trapezium",
      "glossSv": "parallelltrapets, trapets (geometrisk form)",
      "pos": "noun",
      "explanation": "shape + corner [contraction] + 4 + parallel + 1 -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        1094,
        "/",
        13,
        "/",
        498,
        "/",
        10
      ]
    },
    {
      "id": 6186,
      "bciAvId": 29099,
      "gloss": "tube (shape)",
      "glossSv": "rörform",
      "pos": "noun",
      "explanation": "shape + tube -- Note: The drawing of the shape symbol has been adjusted from the official BCI version due to a suspected drawing inconsistency.",
      "isCharacter": false,
      "composition": [
        6168,
        "/",
        866
      ]
    },
    {
      "id": 6187,
      "bciAvId": 29100,
      "gloss": "used car dealer",
      "glossSv": "affär för begagnade bilar",
      "pos": "noun",
      "explanation": "shop + car + second hand [contraction]",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        202,
        "/",
        110
      ]
    },
    {
      "id": 6188,
      "bciAvId": 29101,
      "gloss": "vaccinate",
      "glossSv": "vaccinera",
      "pos": "action",
      "explanation": "vaccination + action indicator",
      "isCharacter": false,
      "composition": [
        399,
        ";",
        81,
        "/",
        695,
        "/",
        548
      ]
    },
    {
      "id": 6189,
      "bciAvId": 29102,
      "gloss": "vaccinated",
      "glossSv": "vaccinerad",
      "pos": "description",
      "explanation": "vaccination + description indicator after the fact",
      "isCharacter": false,
      "composition": [
        399,
        ";",
        84,
        "/",
        695,
        "/",
        548
      ]
    },
    {
      "id": 6190,
      "bciAvId": 29103,
      "gloss": "vaccination",
      "glossSv": "vaccination",
      "pos": "noun",
      "explanation": "injection + liquid + protection",
      "isCharacter": false,
      "composition": [
        399,
        "/",
        695,
        "/",
        548
      ]
    },
    {
      "id": 6191,
      "bciAvId": 29104,
      "gloss": "vaccine",
      "glossSv": "vaccin",
      "pos": "noun",
      "explanation": "liquid + medicine + protection",
      "isCharacter": false,
      "composition": [
        695,
        "/",
        958,
        "/",
        548
      ]
    },
    {
      "id": 6192,
      "bciAvId": 29105,
      "gloss": "whine - (to) (dog)",
      "glossSv": "gnälla",
      "pos": "action",
      "explanation": "talk + high pitch",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        870
      ]
    },
    {
      "id": 6193,
      "bciAvId": 29106,
      "gloss": "whiteboard",
      "glossSv": "whiteboard",
      "pos": "noun",
      "explanation": "enclosed space + pen + white",
      "isCharacter": false,
      "composition": [
        291,
        "/",
        509,
        "/",
        1161,
        "/",
        604
      ]
    },
    {
      "id": 6194,
      "bciAvId": 29107,
      "gloss": "wood shredder, garden shredder",
      "glossSv": "flistugg, flishugg",
      "pos": "noun",
      "explanation": "machine + destroy + wood",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        939,
        "/",
        666
      ]
    },
    {
      "id": 6195,
      "bciAvId": 29108,
      "gloss": "work interview",
      "glossSv": "anställningsintervju",
      "pos": "noun",
      "explanation": "interview + work",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        513,
        "/",
        711
      ]
    },
    {
      "id": 6196,
      "bciAvId": 29109,
      "gloss": "work schedule",
      "glossSv": "arbetsschema",
      "pos": "noun",
      "explanation": "paper + time + work",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        655,
        "/",
        711
      ]
    },
    {
      "id": 6197,
      "bciAvId": 29110,
      "gloss": "written report",
      "glossSv": "rapport, skriftlig rapport",
      "pos": "noun",
      "explanation": "report + pen",
      "isCharacter": false,
      "composition": [
        947,
        "/",
        835,
        "/",
        509
      ]
    },
    {
      "id": 6198,
      "bciAvId": 29111,
      "gloss": "yarn shop, yarn store, wool shop, wool store",
      "glossSv": "garnaffär",
      "pos": "noun",
      "explanation": "shop + yarn [contraction]",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        1122,
        "/",
        228
      ]
    },
    {
      "id": 6199,
      "bciAvId": 29201,
      "gloss": "aromatic",
      "glossSv": "aromatisk, väldoftande",
      "pos": "description",
      "explanation": "smell + positive + description indicator",
      "isCharacter": false,
      "composition": [
        600,
        ";",
        86,
        "/",
        120,
        "/",
        401
      ]
    },
    {
      "id": 6200,
      "bciAvId": 29202,
      "gloss": "smelly (bad)",
      "glossSv": "illaluktande, stinkande",
      "pos": "description",
      "explanation": "to stink + description indicator",
      "isCharacter": false,
      "composition": [
        600,
        ";",
        86,
        "/",
        449,
        "/",
        401
      ]
    },
    {
      "id": 6201,
      "bciAvId": 29203,
      "gloss": "boiling",
      "glossSv": "kokande",
      "pos": "description",
      "explanation": "to boil (liquid) + description indicator",
      "isCharacter": false,
      "composition": [
        319,
        ";",
        86,
        "/",
        695,
        "/",
        401
      ]
    },
    {
      "id": 6202,
      "bciAvId": 29204,
      "gloss": "caffeine",
      "glossSv": "koffein",
      "pos": "noun",
      "explanation": "substance + coffee",
      "isCharacter": false,
      "composition": [
        898,
        "/",
        275,
        "/",
        154
      ]
    },
    {
      "id": 6203,
      "bciAvId": 29205,
      "gloss": "decaffeinated",
      "glossSv": "koffeinfri",
      "pos": "description",
      "explanation": "without + caffein + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        898,
        ";",
        86,
        "/",
        275,
        "/",
        154
      ]
    },
    {
      "id": 6204,
      "bciAvId": 29206,
      "gloss": "gluten",
      "glossSv": "gluten",
      "pos": "noun",
      "explanation": "part of + grain",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        357
      ]
    },
    {
      "id": 6205,
      "bciAvId": 29207,
      "gloss": "lactose",
      "glossSv": "laktos",
      "pos": "noun",
      "explanation": "part of + milk",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 6206,
      "bciAvId": 29208,
      "gloss": "lactose free",
      "glossSv": "laktosfri",
      "pos": "description",
      "explanation": "without + lactose + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        502,
        "/",
        275,
        ";",
        86,
        "/",
        423
      ]
    },
    {
      "id": 6207,
      "bciAvId": 29209,
      "gloss": "milk free, dairy free",
      "glossSv": "mjölkfri",
      "pos": "description",
      "explanation": "without + milk + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        275,
        ";",
        86,
        "/",
        423
      ]
    },
    {
      "id": 6208,
      "bciAvId": 29210,
      "gloss": "milk product, dairy product",
      "glossSv": "mjölkprodukt",
      "pos": "noun",
      "explanation": "man-made item, product + milk",
      "isCharacter": false,
      "composition": [
        840,
        ";",
        97,
        "/",
        275,
        "/",
        423
      ]
    },
    {
      "id": 6209,
      "bciAvId": 29211,
      "gloss": "kosher food",
      "glossSv": "koshermat",
      "pos": "noun",
      "explanation": "food + law (in combination) + Jewish: food prepared according to Jewish law",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        813,
        "/",
        621
      ]
    },
    {
      "id": 6210,
      "bciAvId": 29212,
      "gloss": "halal food",
      "glossSv": "halalmat",
      "pos": "noun",
      "explanation": "food + law (in combination) + Islamic: food prepared according to Islamic law, shariah",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        813,
        "/",
        6435
      ]
    },
    {
      "id": 6211,
      "bciAvId": 29213,
      "gloss": "ripe, fully developed",
      "glossSv": "mogen",
      "pos": "description",
      "explanation": "development + complete [contraction] + description indicator",
      "isCharacter": false,
      "composition": [
        6015,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 6212,
      "bciAvId": 29214,
      "gloss": "to ripen, to fully develop",
      "glossSv": "mogna",
      "pos": "action",
      "explanation": "development + complete [contraction] + action indicator",
      "isCharacter": false,
      "composition": [
        6015,
        ";",
        81,
        "/",
        117
      ]
    },
    {
      "id": 6213,
      "bciAvId": 29215,
      "gloss": "ripening",
      "glossSv": "omogen",
      "pos": "description",
      "explanation": "ripe,fully developed + description indicator before the fact",
      "isCharacter": false,
      "composition": [
        6015,
        ";",
        85,
        "/",
        117
      ]
    },
    {
      "id": 6214,
      "bciAvId": 29216,
      "gloss": "recycling station worker, garbage station worker",
      "glossSv": "källsorterare, renhållningasarbetare",
      "pos": "person",
      "explanation": "person + to sort + waste, garbage",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        673,
        "/",
        694
      ]
    },
    {
      "id": 6215,
      "bciAvId": 29217,
      "gloss": "garbage man, bin collector",
      "glossSv": "renållningsman, sopgubbe",
      "pos": "person",
      "explanation": "person + work + garbage",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        343
      ]
    },
    {
      "id": 6216,
      "bciAvId": 29218,
      "gloss": "to apprentice, to intern - (to), to serve as an apprentice, to intern, to trainee",
      "glossSv": "prakticera",
      "pos": "action",
      "explanation": "to learn + work + action indicator: to work as an apprentice, intern or trainee",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        412,
        "/",
        711
      ]
    },
    {
      "id": 6217,
      "bciAvId": 29219,
      "gloss": "apprenticeship, internship, professional training, traineeship",
      "glossSv": "praktik",
      "pos": "noun",
      "explanation": "to learn + work: the position of apprentice",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        412,
        "/",
        711
      ]
    },
    {
      "id": 6218,
      "bciAvId": 29220,
      "gloss": "training, practice",
      "glossSv": "övning",
      "pos": "noun",
      "explanation": "to learn + activity",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        412,
        "/",
        106
      ]
    },
    {
      "id": 6219,
      "bciAvId": 29221,
      "gloss": "to train, to practice",
      "glossSv": "öva",
      "pos": "action",
      "explanation": "to learn + activity + action indicator",
      "isCharacter": false,
      "composition": [
        920,
        ";",
        81,
        "/",
        412,
        "/",
        106
      ]
    },
    {
      "id": 6220,
      "bciAvId": 29222,
      "gloss": "part-time employee",
      "glossSv": "deltidsanställd, deltidsarbetare",
      "pos": "person",
      "explanation": "person + work + part of + time",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        502,
        "/",
        655
      ]
    },
    {
      "id": 6221,
      "bciAvId": 29223,
      "gloss": "temporary employee",
      "glossSv": "timanställd (person)",
      "pos": "person",
      "explanation": "employee + limited time, period",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        497,
        "/",
        113,
        "/",
        426
      ]
    },
    {
      "id": 6222,
      "bciAvId": 29224,
      "gloss": "relief, substitute, respite carer",
      "glossSv": "stödperson",
      "pos": "person",
      "explanation": "helper + limited time",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        382,
        "/",
        426
      ]
    },
    {
      "id": 6223,
      "bciAvId": 29225,
      "gloss": "kindergarten teacher, preschool teacher",
      "glossSv": "förskollärare",
      "pos": "person",
      "explanation": "teacher (in combination) + kindergarten, preschool",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        392,
        "/",
        220
      ]
    },
    {
      "id": 6225,
      "bciAvId": 29227,
      "gloss": "coach (sport)",
      "glossSv": "coach, tränare (sport)",
      "pos": "person",
      "explanation": "leader, coach + sport",
      "isCharacter": false,
      "composition": [
        736,
        "/",
        719
      ]
    },
    {
      "id": 6226,
      "bciAvId": 29228,
      "gloss": "swimming instructor, swimming teacher",
      "glossSv": "simlärare",
      "pos": "person",
      "explanation": "teacher, instructor (in combination) + to swim",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        412,
        "/",
        653,
        "/",
        695
      ]
    },
    {
      "id": 6227,
      "bciAvId": 29229,
      "gloss": "bank customer",
      "glossSv": "bankkund",
      "pos": "person",
      "explanation": "client, customer + bank [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        920,
        "/",
        382,
        "/",
        451
      ]
    },
    {
      "id": 6228,
      "bciAvId": 29230,
      "gloss": "banker, bank clerk, bank teller, bank employee",
      "glossSv": "banktjänsteman",
      "pos": "person",
      "explanation": "person + bank",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        392,
        "/",
        451
      ]
    },
    {
      "id": 6229,
      "bciAvId": 29231,
      "gloss": "office worker",
      "glossSv": "kontorsarbetare",
      "pos": "person",
      "explanation": "person + office",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        572,
        "/",
        711,
        "/",
        509
      ]
    },
    {
      "id": 6230,
      "bciAvId": 29232,
      "gloss": "construction worker, builder",
      "glossSv": "konstruktör, byggnadsarbetare",
      "pos": "person",
      "explanation": "person + work + structure",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        633
      ]
    },
    {
      "id": 6231,
      "bciAvId": 29233,
      "gloss": "body guard, security guard",
      "glossSv": "livvakt",
      "pos": "person",
      "explanation": "protector [contr.] + other + intensity",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        548,
        "/",
        2115,
        "/",
        401
      ]
    },
    {
      "id": 6232,
      "bciAvId": 29234,
      "gloss": "delivery (goods)",
      "glossSv": "leverans",
      "pos": "noun",
      "explanation": "goods + to bring",
      "isCharacter": true
    },
    {
      "id": 6233,
      "bciAvId": 29235,
      "gloss": "to deliver (goods)",
      "glossSv": "leverera",
      "pos": "action",
      "explanation": "delivery + action indicator",
      "isCharacter": false,
      "composition": [
        6232,
        ";",
        81
      ]
    },
    {
      "id": 6234,
      "bciAvId": 29236,
      "gloss": "delivery man, deliverer, delivery person, delivery agent",
      "glossSv": "varubud, bud (person)",
      "pos": "person",
      "explanation": "person + delivery",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        6232
      ]
    },
    {
      "id": 6235,
      "bciAvId": 29237,
      "gloss": "cleaner, house maid, maid",
      "glossSv": "lokalvårdare, städare, städerska",
      "pos": "person",
      "explanation": "person + work + clean",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        449,
        "/",
        303,
        "/",
        270
      ]
    },
    {
      "id": 6236,
      "bciAvId": 29238,
      "gloss": "electrician",
      "glossSv": "elektriker",
      "pos": "person",
      "explanation": "person + work + electricity",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        288
      ]
    },
    {
      "id": 6237,
      "bciAvId": 29239,
      "gloss": "expert, specialist",
      "glossSv": "specialist, expert",
      "pos": "person",
      "explanation": "person + most + knowledge",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        968,
        "/",
        412
      ]
    },
    {
      "id": 6238,
      "bciAvId": 29240,
      "gloss": "computer specialist, data expert",
      "glossSv": "dataspecialist, dataexpert",
      "pos": "person",
      "explanation": "specialist + digital",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        968,
        "/",
        412,
        "/",
        829
      ]
    },
    {
      "id": 6239,
      "bciAvId": 29241,
      "gloss": "knowable",
      "glossSv": "begriplig, förståelig",
      "pos": "description",
      "explanation": "knowledge + description indicator before the fact: capable of being known",
      "isCharacter": false,
      "composition": [
        412,
        ";",
        85
      ]
    },
    {
      "id": 6240,
      "bciAvId": 29242,
      "gloss": "known",
      "glossSv": "känd, känt",
      "pos": "description",
      "explanation": "knowledge + description indicator after the fact",
      "isCharacter": false,
      "composition": [
        412,
        ";",
        84
      ]
    },
    {
      "id": 6241,
      "bciAvId": 29243,
      "gloss": "interpreter, translator",
      "glossSv": "översättare, tolk",
      "pos": "person",
      "explanation": "person + to translate, interpret",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        182,
        "/",
        414
      ]
    },
    {
      "id": 6242,
      "bciAvId": 29244,
      "gloss": "plumber",
      "glossSv": "rörmokare, rörläggare",
      "pos": "person",
      "explanation": "person + work + pipe, hose, tube (2)",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        711,
        "/",
        866
      ]
    },
    {
      "id": 6243,
      "bciAvId": 29245,
      "gloss": "to melt (metal)",
      "glossSv": "smälta (metall)",
      "pos": "action",
      "explanation": "metal [contraction] + fluid + action indicator: heat changing solid metal to fluid",
      "isCharacter": false,
      "composition": [
        6437,
        ";",
        81
      ]
    },
    {
      "id": 6244,
      "bciAvId": 29246,
      "gloss": "to weld",
      "glossSv": "svetsa, löda",
      "pos": "action",
      "explanation": "to join + to melt (metal) + action indicator: to join together by melting metal",
      "isCharacter": false,
      "composition": [
        823,
        ";",
        81,
        "/",
        6437
      ]
    },
    {
      "id": 6245,
      "bciAvId": 29247,
      "gloss": "welder",
      "glossSv": "svetsare",
      "pos": "person",
      "explanation": "person + to weld",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        823,
        "/",
        6437
      ]
    },
    {
      "id": 6246,
      "bciAvId": 29248,
      "gloss": "busy",
      "glossSv": "upptagen",
      "pos": "description",
      "explanation": "much + activity + exclamation mark + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        106,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 6247,
      "bciAvId": 29249,
      "gloss": "to tidy",
      "glossSv": "lägga i ordning",
      "pos": "action",
      "explanation": "put-(to) + place + action indicator: to put in place",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81,
        "/",
        531
      ]
    },
    {
      "id": 6248,
      "bciAvId": 29250,
      "gloss": "to tidy up",
      "glossSv": "lägga sak på plats",
      "pos": "action",
      "explanation": "to put+ thing + place + action indicator: to put things in place",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        81,
        "/",
        651,
        "/",
        531
      ]
    },
    {
      "id": 6249,
      "bciAvId": 29251,
      "gloss": "tidy, put in place",
      "glossSv": "i ordning, iordning",
      "pos": "description",
      "explanation": "to tidy up + description indicator",
      "isCharacter": false,
      "composition": [
        531,
        ";",
        86,
        "/",
        651,
        "/",
        531
      ]
    },
    {
      "id": 6250,
      "bciAvId": 29252,
      "gloss": "untidy",
      "glossSv": "stökigt, i oordning",
      "pos": "description",
      "explanation": "not [contraction] + tidy + description indicator: things are not in their right places",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        531,
        ";",
        86,
        "/",
        651,
        "/",
        531
      ]
    },
    {
      "id": 6251,
      "bciAvId": 29253,
      "gloss": "unplanned",
      "glossSv": "oplanerad",
      "pos": "description",
      "explanation": "without + plan + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        532,
        ";",
        86
      ]
    },
    {
      "id": 6252,
      "bciAvId": 29254,
      "gloss": "paper cutter, guillotine (paper)",
      "glossSv": "pappersskärare",
      "pos": "noun",
      "explanation": "tool + to cut + paper",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        411,
        "/",
        497
      ]
    },
    {
      "id": 6253,
      "bciAvId": 29255,
      "gloss": "clipboard",
      "glossSv": "skrivplatta, clipboard",
      "pos": "noun",
      "explanation": "board + paper + to attach",
      "isCharacter": false,
      "composition": [
        731,
        "/",
        497,
        "/",
        823
      ]
    },
    {
      "id": 6254,
      "bciAvId": 29256,
      "gloss": "voicemail, voice message",
      "glossSv": "röstbrevlåda, röstmeddelande",
      "pos": "noun",
      "explanation": "machine + repetition + voice",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        963,
        "/",
        608,
        "/",
        457
      ]
    },
    {
      "id": 6255,
      "bciAvId": 29257,
      "gloss": "vending machine",
      "glossSv": "varuautomat",
      "pos": "noun",
      "explanation": "machine + to sell",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        651,
        "/",
        451
      ]
    },
    {
      "id": 6256,
      "bciAvId": 29258,
      "gloss": "leaf blower",
      "glossSv": "lövblås",
      "pos": "noun",
      "explanation": "machine + to blow + leaf",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        705,
        "/",
        416
      ]
    },
    {
      "id": 6257,
      "bciAvId": 29259,
      "gloss": "snow blower",
      "glossSv": "snöslunga",
      "pos": "noun",
      "explanation": "machine + to blow + snow",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        705,
        "/",
        604
      ]
    },
    {
      "id": 6258,
      "bciAvId": 29260,
      "gloss": "snowplow, snowplough, snow remover",
      "glossSv": "snöplog",
      "pos": "noun",
      "explanation": "vehicle + to take away + snow",
      "isCharacter": false,
      "composition": [
        688,
        "/",
        634,
        "/",
        604
      ]
    },
    {
      "id": 6259,
      "bciAvId": 29261,
      "gloss": "snowfall",
      "glossSv": "snöby",
      "pos": "noun",
      "explanation": "snow + limited time: a lot of snow falls in a short time",
      "isCharacter": false,
      "composition": [
        604,
        "/",
        426
      ]
    },
    {
      "id": 6260,
      "bciAvId": 29262,
      "gloss": "snow pile, pile of snow",
      "glossSv": "snödriva",
      "pos": "noun",
      "explanation": "collection + snow",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        604
      ]
    },
    {
      "id": 6261,
      "bciAvId": 29263,
      "gloss": "sleet",
      "glossSv": "snöblandat regn",
      "pos": "noun",
      "explanation": "rain + snow",
      "isCharacter": false,
      "composition": [
        556,
        "/",
        604
      ]
    },
    {
      "id": 6262,
      "bciAvId": 29264,
      "gloss": "icicle",
      "glossSv": "istapp",
      "pos": "noun",
      "explanation": "ice + linear thing",
      "isCharacter": false,
      "composition": [
        394,
        "/",
        428,
        ";",
        97
      ]
    },
    {
      "id": 6263,
      "bciAvId": 29265,
      "gloss": "to hail",
      "glossSv": "hagla",
      "pos": "action",
      "explanation": "hail + action indicator",
      "isCharacter": false,
      "composition": [
        370,
        ";",
        81
      ]
    },
    {
      "id": 6264,
      "bciAvId": 29266,
      "gloss": "freezing rain",
      "glossSv": "underkylt regn",
      "pos": "noun",
      "explanation": "rain + ice: rain which turns into ice when it hits the cold ground",
      "isCharacter": false,
      "composition": [
        556,
        "/",
        394
      ]
    },
    {
      "id": 6265,
      "bciAvId": 29267,
      "gloss": "drizzle",
      "glossSv": "duggregn",
      "pos": "noun",
      "explanation": "rain + dust: rain with drops as fine as dust",
      "isCharacter": false,
      "composition": [
        556,
        "/",
        544
      ]
    },
    {
      "id": 6266,
      "bciAvId": 29268,
      "gloss": "hoar frost",
      "glossSv": "rimfrost",
      "pos": "noun",
      "explanation": "ice + crystal: ice as crystals",
      "isCharacter": false,
      "composition": [
        394,
        "/",
        250
      ]
    },
    {
      "id": 6267,
      "bciAvId": 29269,
      "gloss": "natural disaster",
      "glossSv": "naturkatastrof",
      "pos": "noun",
      "explanation": "disaster + environment",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        449,
        "/",
        401,
        "/",
        401,
        "/",
        401,
        "/",
        294
      ]
    },
    {
      "id": 6268,
      "bciAvId": 29270,
      "gloss": "landslide",
      "glossSv": "jordskred",
      "pos": "noun",
      "explanation": "earth + to slide + danger: a slide of a large mass of dirt and rock",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        273,
        "/",
        256
      ]
    },
    {
      "id": 6269,
      "bciAvId": 29271,
      "gloss": "sinkhole",
      "glossSv": "slukhål",
      "pos": "noun",
      "explanation": "hole + down + danger",
      "isCharacter": false,
      "composition": [
        386,
        "/",
        271,
        "/",
        256
      ]
    },
    {
      "id": 6270,
      "bciAvId": 29272,
      "gloss": "earthquake epicentre",
      "glossSv": "jordbävningsepicentrum, epicentrum i jordbävning",
      "pos": "noun",
      "explanation": "middle + earthquake: the centre of an earthquake",
      "isCharacter": false,
      "composition": [
        446,
        "/",
        281,
        "/",
        723,
        "/",
        401
      ]
    },
    {
      "id": 6272,
      "bciAvId": 29274,
      "gloss": "Muslim, Moslem, Islamic",
      "glossSv": "muslimsk, islamsk",
      "pos": "description",
      "explanation": "star + moon + description indicator",
      "isCharacter": false,
      "composition": [
        6435,
        ";",
        86
      ]
    },
    {
      "id": 6273,
      "bciAvId": 29275,
      "gloss": "Islam",
      "glossSv": "Islam",
      "pos": "noun",
      "explanation": "religion (God based) + Muslim: religion based on the teaching of the prophet Muhammed",
      "isCharacter": false,
      "composition": [
        725,
        "/",
        6435
      ]
    },
    {
      "id": 6274,
      "bciAvId": 29276,
      "gloss": "Muslim, Moslem",
      "glossSv": "muslim",
      "pos": "person",
      "explanation": "person + Muslim,Moslem,Islamic",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        6435
      ]
    },
    {
      "id": 6275,
      "bciAvId": 29301,
      "gloss": "hotel breakfast",
      "glossSv": "hotellfrukost",
      "pos": "noun",
      "explanation": "breakfast [contraction] + hotel [contraction]",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        10,
        "/",
        392,
        "/",
        667
      ]
    },
    {
      "id": 6276,
      "bciAvId": 29302,
      "gloss": "plane ticket, airline ticket",
      "glossSv": "flygbiljett",
      "pos": "noun",
      "explanation": "ticket + aeroplane",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        402,
        "/",
        115
      ]
    },
    {
      "id": 6277,
      "bciAvId": 29303,
      "gloss": "flight, air travel",
      "glossSv": "flygresa",
      "pos": "noun",
      "explanation": "trip,journey,travel,voyage + aeroplane",
      "isCharacter": false,
      "composition": [
        667,
        "/",
        115
      ]
    },
    {
      "id": 6278,
      "bciAvId": 29304,
      "gloss": "train journey",
      "glossSv": "tågresa",
      "pos": "noun",
      "explanation": "trip,journey,travel,voyage + train",
      "isCharacter": false,
      "composition": [
        667,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 6279,
      "bciAvId": 29305,
      "gloss": "car journey",
      "glossSv": "bilresa",
      "pos": "noun",
      "explanation": "trip,journey,travel,voyage + car",
      "isCharacter": false,
      "composition": [
        667,
        "/",
        202
      ]
    },
    {
      "id": 6280,
      "bciAvId": 29306,
      "gloss": "boat journey, journey by boat, sea voyage",
      "glossSv": "båtresa",
      "pos": "noun",
      "explanation": "trip,journey,travel,voyage + boat",
      "isCharacter": false,
      "composition": [
        667,
        "/",
        170
      ]
    },
    {
      "id": 6281,
      "bciAvId": 29307,
      "gloss": "car outing, car drive",
      "glossSv": "biltur",
      "pos": "noun",
      "explanation": "activity + out + car: a tour by car without a certain goal",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        491,
        "/",
        202
      ]
    },
    {
      "id": 6282,
      "bciAvId": 29308,
      "gloss": "boat trip, outing by boat",
      "glossSv": "båttur",
      "pos": "noun",
      "explanation": "activity + out + boat: a tour by boat without a certain goal",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        491,
        "/",
        170
      ]
    },
    {
      "id": 6283,
      "bciAvId": 29309,
      "gloss": "fishing trip (by boat)",
      "glossSv": "fisketur",
      "pos": "noun",
      "explanation": "activity + out + boat + fish: a fishing tour by boat, just for pleasure",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        491,
        "/",
        170,
        "/",
        321
      ]
    },
    {
      "id": 6284,
      "bciAvId": 29310,
      "gloss": "fishing, angling",
      "pos": "noun",
      "explanation": "getting + fish: catching fish",
      "isCharacter": false,
      "composition": [
        920,
        "/",
        321
      ]
    },
    {
      "id": 6285,
      "bciAvId": 29311,
      "gloss": "sport fishing, fishing, angling (sport)",
      "pos": "noun",
      "explanation": "sport + to fish",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        920,
        "/",
        321
      ]
    },
    {
      "id": 6286,
      "bciAvId": 29312,
      "gloss": "mountain hiking, hill walking",
      "glossSv": "fjällvandring",
      "pos": "noun",
      "explanation": "hike-(to) [contraction] + mountain: hiking in the mountain",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        418,
        "/",
        456
      ]
    },
    {
      "id": 6287,
      "bciAvId": 29313,
      "gloss": "conveyor, conveyor belt",
      "glossSv": "transportband",
      "pos": "noun",
      "explanation": "conveyor,conveyor belt",
      "isCharacter": true
    },
    {
      "id": 6288,
      "bciAvId": 29314,
      "gloss": "baggage handling belt",
      "glossSv": "bagageband",
      "pos": "noun",
      "explanation": "conveyor belt + baggage, luggage, suitcase",
      "isCharacter": false,
      "composition": [
        6287,
        "/",
        147
      ]
    },
    {
      "id": 6289,
      "bciAvId": 29315,
      "gloss": "treadmill",
      "glossSv": "gåband",
      "pos": "noun",
      "explanation": "conveyor belt + health + walking [contraction]: a conveyor belt for healthy walking exercise",
      "isCharacter": false,
      "composition": [
        6287,
        "/",
        377,
        "/",
        418
      ]
    },
    {
      "id": 6290,
      "bciAvId": 29316,
      "gloss": "exercise bike",
      "glossSv": "motionscykel",
      "pos": "noun",
      "explanation": "conveyor belt + health + bike",
      "isCharacter": false,
      "composition": [
        6287,
        "/",
        377,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6291,
      "bciAvId": 29317,
      "gloss": "travelator, moving pavement, moving walkway",
      "glossSv": "rörlig gångväg",
      "pos": "noun",
      "explanation": "conveyor belt + walking [contraction]",
      "isCharacter": false,
      "composition": [
        6287,
        "/",
        418
      ]
    },
    {
      "id": 6292,
      "bciAvId": 29318,
      "gloss": "travelator (up and down a slope)",
      "glossSv": "rörlig gångväg upp eller ner",
      "pos": "noun",
      "explanation": "conveyor belt + walking [contraction]+ ascending and descending",
      "isCharacter": false,
      "composition": [
        6287,
        "/",
        418,
        "/",
        988
      ]
    },
    {
      "id": 6293,
      "bciAvId": 29319,
      "gloss": "to photograph",
      "glossSv": "fotografera, ta kort",
      "pos": "action",
      "explanation": "camera + action indicator",
      "isCharacter": false,
      "composition": [
        198,
        ";",
        81
      ]
    },
    {
      "id": 6294,
      "bciAvId": 29320,
      "gloss": "photo album",
      "glossSv": "fotoalbum",
      "pos": "noun",
      "explanation": "book + photograph,photo,picture",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        497,
        "/",
        198
      ]
    },
    {
      "id": 6295,
      "bciAvId": 29321,
      "gloss": "summer job",
      "glossSv": "sommarjobb",
      "pos": "noun",
      "explanation": "work + summer",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        636,
        "/",
        11,
        "/",
        378
      ]
    },
    {
      "id": 6296,
      "bciAvId": 29322,
      "gloss": "seasonal work",
      "glossSv": "säsongsarbete",
      "pos": "noun",
      "explanation": "work + season",
      "isCharacter": false,
      "composition": [
        711,
        "/",
        502,
        "/",
        716
      ]
    },
    {
      "id": 6297,
      "bciAvId": 29323,
      "gloss": "to embroider",
      "glossSv": "brodera",
      "pos": "action",
      "explanation": "sew-(to) + art + action indicator",
      "isCharacter": false,
      "composition": [
        468,
        ";",
        81,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 6298,
      "bciAvId": 29324,
      "gloss": "embroidery",
      "glossSv": "broderi",
      "pos": "noun",
      "explanation": "art + needle: a form of artistic sewing",
      "isCharacter": false,
      "composition": [
        840,
        "/",
        "RK:-2",
        "/",
        313,
        "/",
        468
      ]
    },
    {
      "id": 6299,
      "bciAvId": 29325,
      "gloss": "sewing",
      "glossSv": "sömnad",
      "pos": "noun",
      "explanation": "activity + needle",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        468
      ]
    },
    {
      "id": 6300,
      "bciAvId": 29326,
      "gloss": "picture (2)",
      "glossSv": "bild",
      "pos": "noun",
      "explanation": "picture",
      "isCharacter": true
    },
    {
      "id": 6301,
      "bciAvId": 29327,
      "gloss": "scrapbook",
      "glossSv": "scrapbook, urklippsalbum, klippbok",
      "pos": "noun",
      "explanation": "book + picture + scissor",
      "isCharacter": false,
      "composition": [
        173,
        "/",
        6300,
        "/",
        581
      ]
    },
    {
      "id": 6302,
      "bciAvId": 29328,
      "gloss": "stamp collection",
      "glossSv": "frimärkssamling",
      "pos": "noun",
      "explanation": "collection + stamp",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        620
      ]
    },
    {
      "id": 6303,
      "bciAvId": 29329,
      "gloss": "coin collection",
      "glossSv": "myntsamling",
      "pos": "noun",
      "explanation": "collection + coin",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        823,
        "/",
        263,
        "/",
        451
      ]
    },
    {
      "id": 6304,
      "bciAvId": 29330,
      "gloss": "crossword",
      "glossSv": "korsord",
      "pos": "noun",
      "explanation": "grid, matrix + word",
      "isCharacter": false,
      "composition": [
        950,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 6305,
      "bciAvId": 29331,
      "gloss": "sudoku",
      "glossSv": "sudoku",
      "pos": "noun",
      "explanation": "grid, matrix + number",
      "isCharacter": false,
      "composition": [
        950,
        "/",
        478
      ]
    },
    {
      "id": 6306,
      "bciAvId": 29332,
      "gloss": "quiz, puzzle",
      "glossSv": "frågesport",
      "pos": "noun",
      "explanation": "question + mind",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        447
      ]
    },
    {
      "id": 6307,
      "bciAvId": 29333,
      "gloss": "letter game, letter puzzle",
      "glossSv": "bokstavslek, bokstavsspel, alfapet",
      "pos": "noun",
      "explanation": "quiz + ABC",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        447,
        "/",
        972
      ]
    },
    {
      "id": 6308,
      "bciAvId": 29334,
      "gloss": "wordplay, pun, punning",
      "glossSv": "ordlek",
      "pos": "noun",
      "explanation": "play, game (in combinations) + word",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        313,
        "/",
        502,
        "/",
        414
      ]
    },
    {
      "id": 6309,
      "bciAvId": 29335,
      "gloss": "picture puzzle, rebus",
      "glossSv": "rebus",
      "pos": "noun",
      "explanation": "quiz + picture",
      "isCharacter": false,
      "composition": [
        553,
        "/",
        447,
        "/",
        6300
      ]
    },
    {
      "id": 6310,
      "bciAvId": 29336,
      "gloss": "wellbeing",
      "glossSv": "välbefinnande",
      "pos": "noun",
      "explanation": "feeling + health",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        377
      ]
    },
    {
      "id": 6311,
      "bciAvId": 29337,
      "gloss": "handcraft, craft (class)",
      "glossSv": "slöjdlektion",
      "pos": "noun",
      "explanation": "knowledge + craft",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        374
      ]
    },
    {
      "id": 6312,
      "bciAvId": 29338,
      "gloss": "anticipatory grief",
      "glossSv": "väntesorg",
      "pos": "noun",
      "explanation": "sadness + anticipation, expectation + loss: the feelings of sadness anticipating an inevitable loss",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        271,
        "/",
        301,
        "/",
        634
      ]
    },
    {
      "id": 6313,
      "bciAvId": 29339,
      "gloss": "luggage strap",
      "glossSv": "bagagerem",
      "pos": "noun",
      "explanation": "strap + luggage",
      "isCharacter": false,
      "composition": [
        428,
        ";",
        97,
        "/",
        823,
        "/",
        147
      ]
    },
    {
      "id": 6314,
      "bciAvId": 29340,
      "gloss": "spa",
      "glossSv": "spa",
      "pos": "noun",
      "explanation": "place + wellbeing + water:A resort area offering wellbeing and healthy bath",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        313,
        "/",
        377,
        "/",
        695
      ]
    },
    {
      "id": 6315,
      "bciAvId": 29341,
      "gloss": "minigolf (sport)",
      "glossSv": "bangolf ( sport)",
      "pos": "noun",
      "explanation": "golf (sport) + little",
      "isCharacter": false,
      "composition": [
        719,
        "/",
        1092,
        "/",
        1010,
        "/",
        956
      ]
    },
    {
      "id": 6316,
      "bciAvId": 29342,
      "gloss": "minigolf (activity)",
      "glossSv": "minigolf",
      "pos": "noun",
      "explanation": "golf (activity) + little",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        1092,
        "/",
        1010,
        "/",
        956
      ]
    },
    {
      "id": 6317,
      "bciAvId": 29401,
      "gloss": "hole punch",
      "glossSv": "låte (gi fra seg et-dyre-læte)",
      "pos": "noun",
      "explanation": "tool + through + paper: a tool, which makes holes in paper",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        653,
        "/",
        497
      ]
    },
    {
      "id": 6318,
      "bciAvId": 29402,
      "gloss": "ethanol, sanitiser, sanitizer, alcohol (chemical)",
      "glossSv": "alkohol (kemisk), etanol, desinfektionsmedel",
      "pos": "noun",
      "explanation": "chemical product + OH",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        "XOH"
      ]
    },
    {
      "id": 6319,
      "bciAvId": 29403,
      "gloss": "hand sanitiser, hand sanitizer",
      "glossSv": "handsprit",
      "pos": "noun",
      "explanation": "ethanol,sanititzer,alcohol (chemical) + hand",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        "XOH",
        "/",
        374
      ]
    },
    {
      "id": 6320,
      "bciAvId": 29404,
      "gloss": "online shop, online store, webstore, webshop",
      "glossSv": "näthandel",
      "pos": "noun",
      "explanation": "digital world + buy",
      "isCharacter": false,
      "composition": [
        1026,
        "/",
        451,
        "/",
        651
      ]
    },
    {
      "id": 6321,
      "bciAvId": 29405,
      "gloss": "minimum (2)",
      "glossSv": "minimum",
      "pos": "noun",
      "explanation": "opposite of most",
      "isCharacter": true
    },
    {
      "id": 6322,
      "bciAvId": 29406,
      "gloss": "fewest, least, minimum (2)",
      "glossSv": "minst, färst",
      "pos": "description",
      "explanation": "opposite of most + description indicator",
      "isCharacter": false,
      "composition": [
        6321,
        ";",
        86
      ]
    },
    {
      "id": 6323,
      "bciAvId": 29407,
      "gloss": "fewer, less (2)",
      "glossSv": "färre, mindre",
      "pos": "description",
      "explanation": "opposite of more + description indicator",
      "isCharacter": false,
      "composition": [
        6438,
        ";",
        86
      ]
    },
    {
      "id": 6324,
      "bciAvId": 29408,
      "gloss": "to hiss (snake)",
      "glossSv": "väsa",
      "pos": "action",
      "explanation": "say + snake + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        602
      ]
    },
    {
      "id": 6325,
      "bciAvId": 29409,
      "gloss": "sound of animal, animal sound",
      "glossSv": "djurläte",
      "pos": "noun",
      "explanation": "sound + animal",
      "isCharacter": false,
      "composition": [
        608,
        "/",
        122
      ]
    },
    {
      "id": 6326,
      "bciAvId": 29410,
      "gloss": "to cluck",
      "glossSv": "klucka",
      "pos": "action",
      "explanation": "say + hen [contraction] + feeling: the sound of a hen at ease",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        163,
        "/",
        329,
        "/",
        313
      ]
    },
    {
      "id": 6327,
      "bciAvId": 29412,
      "gloss": "high pitch",
      "glossSv": "hög tonhöjd",
      "pos": "noun",
      "explanation": "pitch + up: elevated pitch",
      "isCharacter": false,
      "composition": [
        868,
        "/",
        678
      ]
    },
    {
      "id": 6328,
      "bciAvId": 29413,
      "gloss": "to growl, to snarl",
      "glossSv": "morra",
      "pos": "action",
      "explanation": "say + animal + opposition + action indicator: an animal expression against something or someone",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        122,
        "/",
        487
      ]
    },
    {
      "id": 6329,
      "bciAvId": 29414,
      "gloss": "to roar",
      "glossSv": "vråla",
      "pos": "action",
      "explanation": "shout + animal + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        401,
        "/",
        401,
        "/",
        122
      ]
    },
    {
      "id": 6330,
      "bciAvId": 29415,
      "gloss": "to yap",
      "glossSv": "gläfsa",
      "pos": "action",
      "explanation": "",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        401,
        "/",
        122
      ]
    },
    {
      "id": 6331,
      "bciAvId": 29417,
      "gloss": "to growl, to grumble",
      "glossSv": "ryta",
      "pos": "action",
      "explanation": "say + animal + low pitch + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        122,
        "/",
        868,
        "/",
        271
      ]
    },
    {
      "id": 6332,
      "bciAvId": 29418,
      "gloss": "low pitch",
      "glossSv": "låg tonhöjd",
      "pos": "noun",
      "explanation": "pitch + down: lowered pitch",
      "isCharacter": false,
      "composition": [
        868,
        "/",
        271
      ]
    },
    {
      "id": 6333,
      "bciAvId": 29419,
      "gloss": "to howl (wolf)",
      "glossSv": "yla",
      "pos": "action",
      "explanation": "say + wolf + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        122,
        "/",
        484
      ]
    },
    {
      "id": 6334,
      "bciAvId": 29420,
      "gloss": "to sing (bird)",
      "glossSv": "sjunga (fågel)",
      "pos": "action",
      "explanation": "sing + bird + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        462,
        "/",
        163
      ]
    },
    {
      "id": 6335,
      "bciAvId": 29421,
      "gloss": "to crow",
      "glossSv": "gala",
      "pos": "action",
      "explanation": "say + rooster + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        163,
        "/",
        329,
        "/",
        106
      ]
    },
    {
      "id": 6336,
      "bciAvId": 29422,
      "gloss": "to cluck, to cackle",
      "glossSv": "kackla",
      "pos": "action",
      "explanation": "say + chicken + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        163,
        "/",
        329
      ]
    },
    {
      "id": 6337,
      "bciAvId": 29423,
      "gloss": "to buzz, to hum, to drone",
      "glossSv": "surra, brumma",
      "pos": "action",
      "explanation": "say + flying­ insect + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        327
      ]
    },
    {
      "id": 6338,
      "bciAvId": 29425,
      "gloss": "to bellow",
      "glossSv": "bröla",
      "pos": "action",
      "explanation": "say + bull + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        123,
        "/",
        106
      ]
    },
    {
      "id": 6339,
      "bciAvId": 29426,
      "gloss": "to squeak",
      "glossSv": "pipa (djur)",
      "pos": "action",
      "explanation": "say + mouse + action indicator",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        122,
        "/",
        644,
        "/",
        956
      ]
    },
    {
      "id": 6340,
      "bciAvId": 29501,
      "gloss": "to address",
      "glossSv": "adressera",
      "pos": "action",
      "explanation": "address + action indicator",
      "isCharacter": false,
      "composition": [
        464,
        ";",
        81,
        "/",
        531,
        "/",
        392
      ]
    },
    {
      "id": 6341,
      "bciAvId": 29502,
      "gloss": "adverse",
      "glossSv": "ogynnsam",
      "pos": "description",
      "explanation": "adversity,hardship + description indicator",
      "isCharacter": false,
      "composition": [
        1019,
        ";",
        86
      ]
    },
    {
      "id": 6342,
      "bciAvId": 29503,
      "gloss": "airy",
      "glossSv": "luftig",
      "pos": "description",
      "explanation": "air + description indicator",
      "isCharacter": false,
      "composition": [
        114,
        ";",
        86
      ]
    },
    {
      "id": 6343,
      "bciAvId": 29504,
      "gloss": "to bloom, to flower, to blossom",
      "glossSv": "blomma (att)",
      "pos": "action",
      "explanation": "bloom + action indicator",
      "isCharacter": false,
      "composition": [
        1037,
        ";",
        81
      ]
    },
    {
      "id": 6344,
      "bciAvId": 29505,
      "gloss": "to bore",
      "glossSv": "uttråka",
      "pos": "action",
      "explanation": "cause + boredom: to bore someone",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        449,
        "/",
        955
      ]
    },
    {
      "id": 6345,
      "bciAvId": 29506,
      "gloss": "bored, lacking interest",
      "glossSv": "uttråkad",
      "pos": "description",
      "explanation": "boredom + description indicator after the fact: a feeling of being uninterested in anything at all",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        449,
        "/",
        955
      ]
    },
    {
      "id": 6346,
      "bciAvId": 29508,
      "gloss": "boredom, monotony",
      "glossSv": "uttråkning",
      "pos": "noun",
      "explanation": "feeling + without interest",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        449,
        "/",
        955
      ]
    },
    {
      "id": 6347,
      "bciAvId": 29509,
      "gloss": "boring",
      "glossSv": "tråkig",
      "pos": "description",
      "explanation": "boredom + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        449,
        "/",
        955
      ]
    },
    {
      "id": 6348,
      "bciAvId": 29511,
      "gloss": "to feel bored, to be bored",
      "glossSv": "vara uttråkad",
      "pos": "action",
      "explanation": "boredom with action indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        81,
        "/",
        449,
        "/",
        955
      ]
    },
    {
      "id": 6349,
      "bciAvId": 29512,
      "gloss": "bumpy (surface)",
      "glossSv": "ojämn",
      "pos": "description",
      "explanation": "surface + up and down + description indicator: a surface with many bumps",
      "isCharacter": false,
      "composition": [
        6393,
        ";",
        86,
        "/",
        723
      ]
    },
    {
      "id": 6350,
      "bciAvId": 29513,
      "gloss": "card, key, pass (digital)",
      "glossSv": "passerkort",
      "pos": "noun",
      "explanation": "card + digital",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        829
      ]
    },
    {
      "id": 6351,
      "bciAvId": 29514,
      "gloss": "careless",
      "glossSv": "vårdslös, oförsiktig",
      "pos": "noun",
      "explanation": "minus,without + careful + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        931,
        ";",
        86,
        "/",
        401,
        "/",
        401
      ]
    },
    {
      "id": 6352,
      "bciAvId": 29515,
      "gloss": "chaos",
      "glossSv": "kaos",
      "pos": "noun",
      "explanation": "without + plan + total",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        532,
        "/",
        117
      ]
    },
    {
      "id": 6353,
      "bciAvId": 29516,
      "gloss": "chaotic",
      "glossSv": "kaotisk",
      "pos": "description",
      "explanation": "chaos + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        532,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 6354,
      "bciAvId": 29518,
      "gloss": "confused (feeling)",
      "glossSv": "förvirrad (känsla)",
      "pos": "description",
      "explanation": "confusion + description after the fact indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        783
      ]
    },
    {
      "id": 6355,
      "bciAvId": 29519,
      "gloss": "confused (mentally)",
      "glossSv": "förvirrad (mentalt)",
      "pos": "noun",
      "explanation": "confusion + description indicator, after the fact",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        84,
        "/",
        783
      ]
    },
    {
      "id": 6356,
      "bciAvId": 29520,
      "gloss": "confusing (feeling)",
      "glossSv": "förvirrande (känsla)",
      "pos": "description",
      "explanation": "confusion + description indicator",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        783
      ]
    },
    {
      "id": 6357,
      "bciAvId": 29521,
      "gloss": "confusing (mentally)",
      "glossSv": "förvirrande (mentalt)",
      "pos": "noun",
      "explanation": "confusion + description indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        86,
        "/",
        783
      ]
    },
    {
      "id": 6358,
      "bciAvId": 29522,
      "gloss": "depressed",
      "glossSv": "deprimerad",
      "pos": "description",
      "explanation": "depression + after the fact",
      "isCharacter": false,
      "composition": [
        985,
        ";",
        84,
        "/",
        313,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 6359,
      "bciAvId": 29523,
      "gloss": "depressing",
      "pos": "description",
      "explanation": "depression+ before the fact",
      "isCharacter": false,
      "composition": [
        985,
        ";",
        85,
        "/",
        313,
        "/",
        271,
        "/",
        401
      ]
    },
    {
      "id": 6360,
      "bciAvId": 29527,
      "gloss": "dishonest",
      "glossSv": "oärlig, ohederlig",
      "pos": "description",
      "explanation": "minus,without + honest + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        551,
        ";",
        86,
        "/",
        670
      ]
    },
    {
      "id": 6361,
      "bciAvId": 29528,
      "gloss": "to fade, to die, to wither (plant)",
      "glossSv": "vissna",
      "pos": "action",
      "explanation": "die + plant + action indicator: a plant fading or withering towards dying",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        81,
        "/",
        533
      ]
    },
    {
      "id": 6362,
      "bciAvId": 29529,
      "gloss": "faded, withered (plant)",
      "glossSv": "vissen (växt)",
      "pos": "description",
      "explanation": "to fade, wither + description indicator after the fact",
      "isCharacter": false,
      "composition": [
        259,
        ";",
        84,
        "/",
        533
      ]
    },
    {
      "id": 6363,
      "bciAvId": 29530,
      "gloss": "to flush",
      "glossSv": "spola, spola ned",
      "pos": "action",
      "explanation": "cause + down + toilet + action indicator: flush down the content in a toilet",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        271,
        "/",
        659
      ]
    },
    {
      "id": 6364,
      "bciAvId": 29531,
      "gloss": "furious",
      "glossSv": "rasande",
      "pos": "description",
      "explanation": "angry + intensity -- Note: The opposition character has been put there in place of another character in the official BCI version due to a suspected spelling inconsistency.",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        313,
        ";",
        86,
        "/",
        487,
        "/",
        401
      ]
    },
    {
      "id": 6365,
      "bciAvId": 29532,
      "gloss": "to gargle",
      "glossSv": "gurgla, gurgla sig",
      "pos": "action",
      "explanation": "activity + throat + liquid + action indicator",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        1142,
        "/",
        695
      ]
    },
    {
      "id": 6366,
      "bciAvId": 29533,
      "gloss": "glued, stuck",
      "glossSv": "klistrad, fastlimmad, fastklistrad",
      "pos": "description",
      "explanation": "glue,adhesive, paste + description indicator after the fact",
      "isCharacter": false,
      "composition": [
        216,
        ";",
        84,
        "/",
        823
      ]
    },
    {
      "id": 6367,
      "bciAvId": 29534,
      "gloss": "hair product, conditioner, foam, balm, mousse (hair)",
      "glossSv": "hårbalsam, hårprodukt, balsam (hår)",
      "pos": "noun",
      "explanation": "chemical product + hair",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        372
      ]
    },
    {
      "id": 6368,
      "bciAvId": 29535,
      "gloss": "to harvest",
      "glossSv": "skörda",
      "pos": "action",
      "explanation": "harvest + action indicator",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        "RK:-2",
        "/",
        357
      ]
    },
    {
      "id": 6369,
      "bciAvId": 29536,
      "gloss": "irritable",
      "glossSv": "irritabel, retlig",
      "pos": "description",
      "explanation": "irritation + description before the fact indicator: can be irritating",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        85,
        "/",
        487
      ]
    },
    {
      "id": 6370,
      "bciAvId": 29537,
      "gloss": "to irritate, to annoy",
      "glossSv": "irritera, besvära, oroa",
      "pos": "action",
      "explanation": "cause + irritation + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        313,
        "/",
        487
      ]
    },
    {
      "id": 6371,
      "bciAvId": 29538,
      "gloss": "irritated",
      "glossSv": "irriterad",
      "pos": "description",
      "explanation": "irritation + description after the fact indicator: feeling of being irritated by something or someone",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        84,
        "/",
        487
      ]
    },
    {
      "id": 6372,
      "bciAvId": 29539,
      "gloss": "irritating",
      "glossSv": "irriterande",
      "pos": "noun",
      "explanation": "irritation + description indicator: ongoing irritation",
      "isCharacter": false,
      "composition": [
        313,
        ";",
        86,
        "/",
        487
      ]
    },
    {
      "id": 6373,
      "bciAvId": 29540,
      "gloss": "irritation, annoyance",
      "glossSv": "irritation",
      "pos": "noun",
      "explanation": "angry without many",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        487
      ]
    },
    {
      "id": 6374,
      "bciAvId": 29542,
      "gloss": "mess",
      "glossSv": "oordning, röra (saker)",
      "pos": "noun",
      "explanation": "without + plan + many + thing",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        532,
        "/",
        368,
        "/",
        651
      ]
    },
    {
      "id": 6375,
      "bciAvId": 29543,
      "gloss": "messy",
      "glossSv": "stökigt, rörigt (saker)",
      "pos": "description",
      "explanation": "mess + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        532,
        ";",
        86,
        "/",
        368,
        "/",
        651
      ]
    },
    {
      "id": 6376,
      "bciAvId": 29544,
      "gloss": "moisturiser, moisturizer",
      "glossSv": "fuktighetskräm, lotion",
      "pos": "noun",
      "explanation": "chemical product + for + moist: chemical product for the purpose of moisterizing",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        332,
        "/",
        695
      ]
    },
    {
      "id": 6377,
      "bciAvId": 29545,
      "gloss": "to mow",
      "glossSv": "slå, klippa gräs",
      "pos": "action",
      "explanation": "cut + grass",
      "isCharacter": false,
      "composition": [
        411,
        ";",
        81,
        "/",
        366
      ]
    },
    {
      "id": 6378,
      "bciAvId": 29546,
      "gloss": "negative",
      "glossSv": "negativ",
      "pos": "noun",
      "explanation": "not,negative + description indicator",
      "isCharacter": false,
      "composition": [
        449,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 6379,
      "bciAvId": 29547,
      "gloss": "ointment",
      "glossSv": "hudprodukt, hudkräm, salva",
      "pos": "noun",
      "explanation": "chemical product + protection + skin [contraction]",
      "isCharacter": false,
      "composition": [
        216,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 6380,
      "bciAvId": 29548,
      "gloss": "order",
      "glossSv": "ordning",
      "pos": "noun",
      "explanation": "plan, system + total, everything: everything is according to the plan or system",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        117
      ]
    },
    {
      "id": 6381,
      "bciAvId": 29549,
      "gloss": "to order, to place an order",
      "glossSv": "beställa",
      "pos": "action",
      "explanation": "ask + buy",
      "isCharacter": false,
      "composition": [
        553,
        ";",
        81,
        "/",
        451,
        "/",
        651
      ]
    },
    {
      "id": 6382,
      "bciAvId": 29550,
      "gloss": "orderly",
      "glossSv": "ordentlig, välordnad, iordning",
      "pos": "description",
      "explanation": "order + description indicator",
      "isCharacter": false,
      "composition": [
        532,
        ";",
        86,
        "/",
        117
      ]
    },
    {
      "id": 6383,
      "bciAvId": 29551,
      "gloss": "to plough, to plow",
      "glossSv": "plöja",
      "pos": "action",
      "explanation": "plow + action indicator",
      "isCharacter": false,
      "composition": [
        536,
        ";",
        81
      ]
    },
    {
      "id": 6384,
      "bciAvId": 29552,
      "gloss": "to pollinate",
      "glossSv": "pollinera, befrukta (växt)",
      "pos": "action",
      "explanation": "pollen + action indicator",
      "isCharacter": false,
      "composition": [
        544,
        ";",
        81,
        "/",
        325
      ]
    },
    {
      "id": 6385,
      "bciAvId": 29553,
      "gloss": "positively",
      "glossSv": "positiv",
      "pos": "noun",
      "explanation": "positive + description indicator",
      "isCharacter": false,
      "composition": [
        120,
        ";",
        86,
        "/",
        401
      ]
    },
    {
      "id": 6386,
      "bciAvId": 29554,
      "gloss": "to put on makeup",
      "glossSv": "sminka, sminka sig",
      "pos": "action",
      "explanation": "makeup + action indicator",
      "isCharacter": false,
      "composition": [
        1161,
        ";",
        81,
        "/",
        120,
        "/",
        306
      ]
    },
    {
      "id": 6387,
      "bciAvId": 29555,
      "gloss": "to rake",
      "glossSv": "kratta, räfsa-(att)",
      "pos": "action",
      "explanation": "rake + action indicator",
      "isCharacter": false,
      "composition": [
        231,
        ";",
        81,
        "/",
        344
      ]
    },
    {
      "id": 6388,
      "bciAvId": 29556,
      "gloss": "rough, coarse, abrasive (surface)",
      "glossSv": "grov, skrovlig (yta)",
      "pos": "description",
      "explanation": "surface + sand + description indicator: a surface uneven like covered with sand)",
      "isCharacter": false,
      "composition": [
        6393,
        ";",
        86,
        "/",
        544,
        "/",
        629
      ]
    },
    {
      "id": 6389,
      "bciAvId": 29557,
      "gloss": "serious, sincere",
      "glossSv": "allvarlig, seriös, uppriktig",
      "pos": "description",
      "explanation": "state of mind + important + description indicator: thought of as important",
      "isCharacter": false,
      "composition": [
        985,
        ";",
        86,
        "/",
        954
      ]
    },
    {
      "id": 6390,
      "bciAvId": 29558,
      "gloss": "silly, crazy",
      "glossSv": "fånig, löjlig, knäpp",
      "pos": "description",
      "explanation": "activity + nonsense + description indicator: action in a silly way",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        86,
        "/",
        471
      ]
    },
    {
      "id": 6391,
      "bciAvId": 29560,
      "gloss": "smooth (surface)",
      "glossSv": "jämn (yta)",
      "pos": "description",
      "explanation": "surface + glass + description indicator: a surface smooth like a glass",
      "isCharacter": false,
      "composition": [
        6393,
        ";",
        86,
        "/",
        352
      ]
    },
    {
      "id": 6392,
      "bciAvId": 29561,
      "gloss": "sticky, gluey, adhesive",
      "glossSv": "Klibbig, klistrig",
      "pos": "description",
      "explanation": "glue + description indicator",
      "isCharacter": false,
      "composition": [
        216,
        ";",
        86,
        "/",
        823
      ]
    },
    {
      "id": 6393,
      "bciAvId": 29562,
      "gloss": "surface",
      "glossSv": "yta",
      "pos": "description",
      "explanation": "layer + pointer: the pointer indicates the topp part of the top layer) – Character (superimposed)",
      "isCharacter": true
    },
    {
      "id": 6394,
      "bciAvId": 29563,
      "gloss": "to tickle",
      "glossSv": "kittla, killa",
      "pos": "action",
      "explanation": "hand + laugh+ action indicator",
      "isCharacter": false,
      "composition": [
        374,
        ";",
        81,
        "/",
        313,
        "/",
        678,
        "/",
        457
      ]
    },
    {
      "id": 6395,
      "bciAvId": 29564,
      "gloss": "time card",
      "glossSv": "stämpelkort, tidkort",
      "pos": "noun",
      "explanation": "card + time + work",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        655,
        "/",
        711
      ]
    },
    {
      "id": 6396,
      "bciAvId": 29565,
      "gloss": "to undress",
      "glossSv": "klä av, klä av sig",
      "pos": "action",
      "explanation": "remove + clothes",
      "isCharacter": false,
      "composition": [
        634,
        ";",
        81,
        "/",
        229
      ]
    },
    {
      "id": 6397,
      "bciAvId": 29566,
      "gloss": "uneven, not smooth (surface)",
      "glossSv": "ojämn (yta)",
      "pos": "description",
      "explanation": "without + smooth + description indicator: without smoothness",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        6393,
        ";",
        86,
        "/",
        352
      ]
    },
    {
      "id": 6398,
      "bciAvId": 29567,
      "gloss": "to wake",
      "glossSv": "väcka",
      "pos": "action",
      "explanation": "cause-(to) + wake up",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        969
      ]
    },
    {
      "id": 6399,
      "bciAvId": 29568,
      "gloss": "weed",
      "glossSv": "ogräs",
      "pos": "noun",
      "explanation": "plant + minus + want: plants not wanted",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        449,
        "/",
        313,
        "/",
        319
      ]
    },
    {
      "id": 6400,
      "bciAvId": 29569,
      "gloss": "to weed",
      "glossSv": "rensa",
      "pos": "action",
      "explanation": "weed + action indicator",
      "isCharacter": false,
      "composition": [
        533,
        ";",
        81,
        "/",
        449,
        "/",
        313,
        "/",
        319
      ]
    },
    {
      "id": 6401,
      "bciAvId": 29570,
      "gloss": "worried",
      "glossSv": "orolig, ängslig",
      "pos": "description",
      "explanation": "worry + description indicator",
      "isCharacter": false,
      "composition": [
        447,
        ";",
        86,
        "/",
        1063
      ]
    },
    {
      "id": 6402,
      "bciAvId": 29571,
      "gloss": "wrinkled",
      "glossSv": "veckad, rynkad",
      "pos": "description",
      "explanation": "many + fold + description indicator",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        1038,
        ";",
        86
      ]
    },
    {
      "id": 6403,
      "bciAvId": 29580,
      "gloss": "alternating",
      "pos": "description",
      "explanation": "alternation + description indicator",
      "isCharacter": false,
      "composition": [
        144,
        ";",
        86
      ]
    },
    {
      "id": 6404,
      "bciAvId": 29601,
      "gloss": "crop (agriculture), harvest (agriculture)",
      "glossSv": "skörd",
      "pos": "noun",
      "explanation": "outcome,result + to cultivate [contraction]: the outcome of cultivation",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        325,
        "/",
        678
      ]
    },
    {
      "id": 6405,
      "bciAvId": 29602,
      "gloss": "potted plant",
      "glossSv": "krukväxt",
      "pos": "noun",
      "explanation": "plant + container: a plant in a pot",
      "isCharacter": false,
      "composition": [
        533,
        "/",
        239
      ]
    },
    {
      "id": 6406,
      "bciAvId": 29604,
      "gloss": "sugar cane",
      "glossSv": "sockerrör",
      "pos": "noun",
      "explanation": "grass + sweet (taste): a kind of thick sweet grass",
      "isCharacter": false,
      "composition": [
        366,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 6407,
      "bciAvId": 29605,
      "gloss": "transport van",
      "glossSv": "varubil",
      "pos": "noun",
      "explanation": "van, minibus + goods: a car for transport of goods",
      "isCharacter": false,
      "composition": [
        188,
        "/",
        956,
        "/",
        356
      ]
    },
    {
      "id": 6408,
      "bciAvId": 29606,
      "gloss": "school bus",
      "glossSv": "skolbuss",
      "pos": "noun",
      "explanation": "bus + school [in combination]",
      "isCharacter": false,
      "composition": [
        188,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 6409,
      "bciAvId": 29607,
      "gloss": "police car",
      "glossSv": "polisbil",
      "pos": "noun",
      "explanation": "car + police",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        513,
        "/",
        548
      ]
    },
    {
      "id": 6410,
      "bciAvId": 29608,
      "gloss": "mail van",
      "glossSv": "postbil",
      "pos": "noun",
      "explanation": "car + mail,post",
      "isCharacter": false,
      "composition": [
        202,
        "/",
        421
      ]
    },
    {
      "id": 6411,
      "bciAvId": 29609,
      "gloss": "parking app",
      "glossSv": "parkeringsapp",
      "pos": "noun",
      "explanation": "app + parking lot",
      "isCharacter": false,
      "composition": [
        532,
        "/",
        829,
        "/",
        531,
        "/",
        688
      ]
    },
    {
      "id": 6412,
      "bciAvId": 29610,
      "gloss": "car wash",
      "glossSv": "biltvätt",
      "pos": "noun",
      "explanation": "place + wash + car",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        595,
        "/",
        202
      ]
    },
    {
      "id": 6413,
      "bciAvId": 29621,
      "gloss": "hedge",
      "glossSv": "häck",
      "pos": "noun",
      "explanation": "line + many + bushes",
      "isCharacter": false,
      "composition": [
        428,
        "/",
        368,
        "/",
        190
      ]
    },
    {
      "id": 6414,
      "bciAvId": 29622,
      "gloss": "slope (up)",
      "glossSv": "sluttning, lutning (uppåt)",
      "pos": "noun",
      "explanation": "Character",
      "isCharacter": true
    },
    {
      "id": 6415,
      "bciAvId": 29623,
      "gloss": "slope (down)",
      "glossSv": "sluttning, lutning (nedåt)",
      "pos": "noun",
      "explanation": "Character",
      "isCharacter": true
    },
    {
      "id": 6416,
      "bciAvId": 29624,
      "gloss": "upward slope",
      "glossSv": "uppförsbacke, backe (uppför)",
      "pos": "noun",
      "explanation": "earth + slope (up): an uphill slope",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        6414
      ]
    },
    {
      "id": 6417,
      "bciAvId": 29625,
      "gloss": "upward, uphill",
      "glossSv": "backig (uppför), uppför",
      "pos": "description",
      "explanation": "upward slope + description indicator",
      "isCharacter": false,
      "composition": [
        281,
        ";",
        86,
        "/",
        6414
      ]
    },
    {
      "id": 6418,
      "bciAvId": 29626,
      "gloss": "downward slope",
      "glossSv": "utförsbacke, nerförsbacke, backe (nerför)",
      "pos": "noun",
      "explanation": "earth + slope (down): an downhill slope",
      "isCharacter": false,
      "composition": [
        281,
        "/",
        6415
      ]
    },
    {
      "id": 6419,
      "bciAvId": 29627,
      "gloss": "downward, downhill",
      "glossSv": "backig (nerför), nerför",
      "pos": "description",
      "explanation": "downward slope + description indicator",
      "isCharacter": false,
      "composition": [
        281,
        ";",
        86,
        "/",
        6415
      ]
    },
    {
      "id": 6420,
      "bciAvId": 29628,
      "gloss": "slant (forward), skew (forward)",
      "glossSv": "snedd, skevhet",
      "pos": "noun",
      "explanation": "Character",
      "isCharacter": true
    },
    {
      "id": 6421,
      "bciAvId": 29629,
      "gloss": "slanted, slanting",
      "glossSv": "sned",
      "pos": "description",
      "explanation": "slant (forward) + description indicator",
      "isCharacter": false,
      "composition": [
        6420,
        ";",
        86
      ]
    },
    {
      "id": 6422,
      "bciAvId": 29630,
      "gloss": "skew, askew, not straight",
      "glossSv": "skev",
      "pos": "description",
      "explanation": "skew (forward) + parallel + description indicator: the slanted line is skew in comparison with the parallel lines",
      "isCharacter": false,
      "composition": [
        6420,
        ";",
        86,
        "/",
        498
      ]
    },
    {
      "id": 6423,
      "bciAvId": 29631,
      "gloss": "car repair shop",
      "glossSv": "bilverkstad",
      "pos": "noun",
      "explanation": "repair shop [contraction] + car",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        711,
        "/",
        202
      ]
    },
    {
      "id": 6424,
      "bciAvId": 29632,
      "gloss": "baby chair",
      "glossSv": "barnstol (hög)",
      "pos": "noun",
      "explanation": "chair + child",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        220
      ]
    },
    {
      "id": 6425,
      "bciAvId": 29633,
      "gloss": "child seat",
      "glossSv": "bilbarnstol",
      "pos": "noun",
      "explanation": "chair + child + vehicle",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        220,
        "/",
        202
      ]
    },
    {
      "id": 6426,
      "bciAvId": 29634,
      "gloss": "high chair (child)",
      "glossSv": "barnstol (hög)",
      "pos": "noun",
      "explanation": "chair + high + child",
      "isCharacter": false,
      "composition": [
        212,
        "/",
        952,
        "/",
        220
      ]
    },
    {
      "id": 6427,
      "bciAvId": 29635,
      "gloss": "social support, social services",
      "glossSv": "socialhjälp, socialtjänst",
      "pos": "noun",
      "explanation": "support + society [contraction]: support provided by government",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        225
      ]
    },
    {
      "id": 6428,
      "bciAvId": 29636,
      "gloss": "disability support",
      "glossSv": "handikapphjälp",
      "pos": "noun",
      "explanation": "support + society [contraction] + disability [contraction]: support provided by government for people with disabilities",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        225,
        "/",
        1053
      ]
    },
    {
      "id": 6429,
      "bciAvId": 29637,
      "gloss": "transport service",
      "glossSv": "färdtjänst",
      "pos": "noun",
      "explanation": "social support + travel: Support by the society for those with limitations with regard to transportation",
      "isCharacter": false,
      "composition": [
        382,
        "/",
        225,
        "/",
        700
      ]
    },
    {
      "id": 6430,
      "bciAvId": 29638,
      "gloss": "parking meter, parking machine",
      "glossSv": "parkeringsautomat",
      "pos": "noun",
      "explanation": "machine + pay [contraction] + parking lot",
      "isCharacter": false,
      "composition": [
        432,
        "/",
        451,
        "/",
        531,
        "/",
        688
      ]
    },
    {
      "id": 6431,
      "bciAvId": 29639,
      "gloss": "charging plug (vehicle)",
      "glossSv": "laddningsplugg",
      "pos": "noun",
      "explanation": "plug + vehicle",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        97,
        "/",
        288,
        "/",
        688
      ]
    },
    {
      "id": 6432,
      "bciAvId": 29640,
      "gloss": "charging station",
      "glossSv": "laddningsstation",
      "pos": "noun",
      "explanation": "place + electricity +vehicle: a place for charging vehicle batteries",
      "isCharacter": false,
      "composition": [
        531,
        "/",
        288,
        "/",
        688
      ]
    },
    {
      "id": 6433,
      "bciAvId": 29641,
      "gloss": "license plate",
      "glossSv": "registreringsskylt, registreringsplåt",
      "pos": "noun",
      "explanation": "card + number + vehicle",
      "isCharacter": false,
      "composition": [
        824,
        "/",
        478,
        "/",
        688
      ]
    },
    {
      "id": 6434,
      "bciAvId": 29642,
      "gloss": "petrol station, gas station",
      "glossSv": "bensinstation, mack",
      "pos": "noun",
      "explanation": "shop + gasoline, petrol",
      "isCharacter": false,
      "composition": [
        819,
        "/",
        695,
        "/",
        700
      ]
    },
    {
      "id": 6435,
      "gloss": "star and crescent",
      "pos": "noun",
      "explanation": "moon [modification, reversed] + star -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 6436,
      "gloss": "indicator (abstract)",
      "pos": "function",
      "explanation": "mind [quarter-sized]: placed above a symbol to mark abstract sense where ambiguity may arise -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 6437,
      "gloss": "melting (metal)",
      "pos": "noun",
      "explanation": "metal bar + fluid -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 6438,
      "gloss": "comparative less",
      "pos": "expression",
      "explanation": "opposite meaning [modification, half-sized on midline] + comparative more -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 6439,
      "gloss": "indicator (indirect object form)",
      "pos": "function",
      "explanation": "to,toward,towards [quarter-sized, modified - two pointers]: may be placed above a symbol to show that it is representing a word in indirect object form in a natural language. Used restrictively, primarily for language teaching purposes. Note: This entry is part of Blissary View and does not exist as part of the official BCI Authorized.",
      "isCharacter": true,
      "isIndicator": true
    },
    {
      "id": 6440,
      "gloss": "watch, wristwatch",
      "pos": "noun",
      "explanation": "a watch to be worn on the wrist -- Note: This entry is part of Blissary View and does not exist as part of the official BCI Authorized.",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        97,
        "/",
        714
      ]
    },
    {
      "id": 6441,
      "gloss": "smartwatch",
      "pos": "noun",
      "explanation": "a wristwatch type of digital device -- Note: This entry is part of Blissary View and does not exist as part of the official BCI Authorized.",
      "isCharacter": false,
      "composition": [
        901,
        "/",
        655,
        ";",
        97,
        "/",
        714
      ]
    },
    {
      "id": 6442,
      "gloss": "smartwatch",
      "pos": "noun",
      "explanation": "a digital wristwatch -- Note: This entry is part of Blissary View and does not exist as part of the official BCI Authorized.",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        97,
        "/",
        714,
        "/",
        829
      ]
    },
    {
      "id": 6443,
      "bciAvId": 28098,
      "gloss": "resource",
      "pos": "noun",
      "explanation": "all things coming from earth and heaven",
      "isCharacter": true
    },
    {
      "id": 6444,
      "gloss": "state of being",
      "pos": "noun",
      "explanation": "world B712 superimposed with being (state of) B894 -- Note: This symbol does not exist in the official BCI version yet.",
      "isCharacter": true
    },
    {
      "id": 6445,
      "bciAvId": 29701,
      "gloss": "service user",
      "glossSv": "idrottsman, atlet",
      "pos": "person",
      "explanation": "person + use + help; person who use help",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        932,
        "/",
        382
      ]
    },
    {
      "id": 6446,
      "bciAvId": 29702,
      "gloss": "tennis ball",
      "glossSv": "förlorare",
      "pos": "noun",
      "explanation": "ball + racket",
      "isCharacter": false,
      "composition": [
        148,
        "/",
        555
      ]
    },
    {
      "id": 6447,
      "bciAvId": 29703,
      "gloss": "sportsperson, athlete",
      "glossSv": "vinnare",
      "pos": "person",
      "explanation": "person + sport",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        719
      ]
    },
    {
      "id": 6448,
      "bciAvId": 29704,
      "gloss": "loser (game)",
      "glossSv": "seger",
      "pos": "person",
      "explanation": "person + defeat",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        554,
        "/",
        634
      ]
    },
    {
      "id": 6449,
      "bciAvId": 29705,
      "gloss": "winner (game)",
      "glossSv": "tävlingsinriktad",
      "pos": "person",
      "explanation": "person + victory",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        554,
        "/",
        107
      ]
    },
    {
      "id": 6450,
      "bciAvId": 29706,
      "gloss": "victory",
      "glossSv": "konkurransedyktig",
      "pos": "noun",
      "explanation": "victory",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        107
      ]
    },
    {
      "id": 6451,
      "bciAvId": 29707,
      "gloss": "competitive",
      "pos": "description",
      "explanation": "competition + description indicator",
      "isCharacter": false,
      "composition": [
        554,
        ";",
        86
      ]
    },
    {
      "id": 6452,
      "bciAvId": 29708,
      "gloss": "competitor",
      "glossSv": "tävlande, medtävlare",
      "pos": "person",
      "explanation": "person + to compete",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        554
      ]
    },
    {
      "id": 6453,
      "bciAvId": 29709,
      "gloss": "sports equipment",
      "glossSv": "sportutrustning",
      "pos": "noun",
      "explanation": "equipment [contraction] + sport",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        "/",
        719
      ]
    },
    {
      "id": 6454,
      "bciAvId": 29710,
      "gloss": "safety equipment",
      "glossSv": "säkerhetsutrustning",
      "pos": "noun",
      "explanation": "equipment [contraction]+ protection",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        651,
        "/",
        548
      ]
    },
    {
      "id": 6455,
      "bciAvId": 29711,
      "gloss": "stopwatch",
      "glossSv": "stoppur, tidtagarur",
      "pos": "noun",
      "explanation": "clock + stop",
      "isCharacter": false,
      "composition": [
        655,
        ";",
        97,
        "/",
        292
      ]
    },
    {
      "id": 6456,
      "bciAvId": 29712,
      "gloss": "dental guard",
      "glossSv": "tandskydd",
      "pos": "noun",
      "explanation": "protection + exclamation mark + teeth",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        401,
        "/",
        644
      ]
    },
    {
      "id": 6457,
      "bciAvId": 29713,
      "gloss": "bicycle chain",
      "glossSv": "cykelkedja",
      "pos": "noun",
      "explanation": "chain + bicycle",
      "isCharacter": false,
      "composition": [
        759,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6458,
      "bciAvId": 29714,
      "gloss": "bicycle brake",
      "glossSv": "cykelbroms",
      "pos": "noun",
      "explanation": "brake + bicycle",
      "isCharacter": false,
      "composition": [
        660,
        "/",
        292,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6459,
      "bciAvId": 29715,
      "gloss": "bicycle wheel",
      "glossSv": "cykelhjul",
      "pos": "noun",
      "explanation": "wheel + comma + bicycle",
      "isCharacter": false,
      "composition": [
        700,
        "/",
        5,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6460,
      "bciAvId": 29716,
      "gloss": "bicycle tyre, bicycle tire",
      "glossSv": "cykeldäck",
      "pos": "noun",
      "explanation": "tire,tyre, + comma + bicycle",
      "isCharacter": false,
      "composition": [
        656,
        "/",
        5,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6461,
      "bciAvId": 29717,
      "gloss": "bicycle racing, bicycle race",
      "glossSv": "cykeltävling, cykellopp",
      "pos": "noun",
      "explanation": "competition + cycling",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        719,
        "/",
        11,
        "/",
        700
      ]
    },
    {
      "id": 6462,
      "bciAvId": 29719,
      "gloss": "Paralympics, Special Olympics",
      "glossSv": "Paralympics",
      "pos": "noun",
      "explanation": "Olympic games + accessibility",
      "isCharacter": false,
      "composition": [
        554,
        "/",
        14,
        "/",
        567,
        "/",
        894,
        "/",
        653
      ]
    },
    {
      "id": 6463,
      "bciAvId": 29726,
      "gloss": "citizenship",
      "glossSv": "medborgarskap",
      "pos": "noun",
      "explanation": "state of being + citizen; the status of a citizen",
      "isCharacter": false,
      "composition": [
        6444,
        "/",
        512
      ]
    },
    {
      "id": 6464,
      "bciAvId": 29727,
      "gloss": "term, reign",
      "glossSv": "regeringstid",
      "pos": "noun",
      "explanation": "limited time + to govern",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        803,
        "/",
        243
      ]
    },
    {
      "id": 6465,
      "bciAvId": 29728,
      "gloss": "torture",
      "glossSv": "tortyr",
      "pos": "noun",
      "explanation": "cause + intensity + pain; the deliberate causing of pain",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        401,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 6466,
      "bciAvId": 29729,
      "gloss": "to torture",
      "glossSv": "tortera",
      "pos": "action",
      "explanation": "torture + action indicator",
      "isCharacter": false,
      "composition": [
        206,
        ";",
        81,
        "/",
        401,
        "/",
        313,
        "/",
        "RK:-2",
        "/",
        516
      ]
    },
    {
      "id": 6467,
      "bciAvId": 29730,
      "gloss": "refugee, asylum-seeker",
      "glossSv": "flykting, asylsökande",
      "pos": "person",
      "explanation": "person + exit + for the purpose of + protection: person who leaves for the purpose of protection",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        491,
        "/",
        332,
        "/",
        548
      ]
    },
    {
      "id": 6468,
      "bciAvId": 29731,
      "gloss": "immigration",
      "glossSv": "invandring, immigration",
      "pos": "noun",
      "explanation": "entering + country + another [contraction] + to live; entering another country to live",
      "isCharacter": false,
      "composition": [
        402,
        "/",
        243,
        "/",
        11,
        "/",
        423
      ]
    },
    {
      "id": 6469,
      "bciAvId": 29732,
      "gloss": "to immigrate",
      "glossSv": "invandra, immigrera",
      "pos": "action",
      "explanation": "immigration + action indicator",
      "isCharacter": false,
      "composition": [
        402,
        ";",
        81,
        "/",
        243,
        "/",
        11,
        "/",
        423
      ]
    },
    {
      "id": 6470,
      "bciAvId": 29733,
      "gloss": "immigrant",
      "glossSv": "invandrare, immigrant",
      "pos": "person",
      "explanation": "person + immigration; person having entered another country for life",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        402,
        "/",
        243,
        "/",
        11,
        "/",
        423
      ]
    },
    {
      "id": 6471,
      "bciAvId": 29734,
      "gloss": "emigration",
      "glossSv": "utvandring, emigration",
      "pos": "noun",
      "explanation": "exit + country + life; exiting/leaving a country for life",
      "isCharacter": false,
      "composition": [
        491,
        "/",
        243,
        "/",
        423
      ]
    },
    {
      "id": 6472,
      "bciAvId": 29735,
      "gloss": "to emigrate",
      "glossSv": "utvandra, emigrera",
      "pos": "action",
      "explanation": "emigration + action indicator",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        243,
        "/",
        423
      ]
    },
    {
      "id": 6473,
      "bciAvId": 29736,
      "gloss": "emigrant",
      "glossSv": "utvandrare, emigrant",
      "pos": "person",
      "explanation": "person + exit + country + life; person who have left a country for life",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        491,
        "/",
        243,
        "/",
        423
      ]
    },
    {
      "id": 6474,
      "bciAvId": 29741,
      "gloss": "evolution (science, biology)",
      "glossSv": "utvecklingslära, evolution",
      "pos": "noun",
      "explanation": "development + life + time; the development of life over time",
      "isCharacter": false,
      "composition": [
        6015,
        "/",
        423,
        "/",
        655
      ]
    },
    {
      "id": 6475,
      "bciAvId": 29742,
      "gloss": "evolution (general)",
      "glossSv": "utveckling, evolution",
      "pos": "noun",
      "explanation": "development + time",
      "isCharacter": false,
      "composition": [
        6015,
        "/",
        655
      ]
    },
    {
      "id": 6476,
      "bciAvId": 29743,
      "gloss": "immune system, immune defence",
      "glossSv": "immunsystem, immunförsvar",
      "pos": "noun",
      "explanation": "generalization + organ,inner body + against + sickness; the body's protection and defence against disease",
      "isCharacter": false,
      "composition": [
        348,
        "/",
        993,
        "/",
        111,
        "/",
        516
      ]
    },
    {
      "id": 6477,
      "bciAvId": 29744,
      "gloss": "ecosystem",
      "glossSv": "ekosystem",
      "pos": "noun",
      "explanation": "environment + action + together; the action together within the environment",
      "isCharacter": false,
      "composition": [
        294,
        "/",
        106,
        "/",
        823
      ]
    },
    {
      "id": 6478,
      "bciAvId": 29747,
      "gloss": "electron",
      "glossSv": "elektron",
      "pos": "noun",
      "explanation": "part of + atom + negative; a stable subatomic particle with a charge of negative electricity",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        136,
        "/",
        449
      ]
    },
    {
      "id": 6479,
      "bciAvId": 29748,
      "gloss": "proton",
      "glossSv": "proton",
      "pos": "noun",
      "explanation": "part of + nucleus (atom); a stable subatomic particle occurring in all atomic nuclei, with a positive electric charge",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        477,
        "/",
        120
      ]
    },
    {
      "id": 6480,
      "bciAvId": 29749,
      "gloss": "neutron",
      "glossSv": "neutron",
      "pos": "noun",
      "explanation": "part of + nucleus (atom) + zero; a subatomic particle without an electric charge (neutral), present in atomic nuclei",
      "isCharacter": false,
      "composition": [
        502,
        "/",
        477,
        "/",
        9
      ]
    },
    {
      "id": 6481,
      "bciAvId": 29750,
      "gloss": "circumference",
      "glossSv": "omkrets",
      "pos": "noun",
      "explanation": "measurement + around",
      "isCharacter": false,
      "composition": [
        441,
        "/",
        134
      ]
    },
    {
      "id": 6482,
      "bciAvId": 29751,
      "gloss": "sum (mathematics)",
      "glossSv": "summa",
      "pos": "noun",
      "explanation": "result + addition",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        107
      ]
    },
    {
      "id": 6483,
      "bciAvId": 29752,
      "gloss": "product (mathematics)",
      "glossSv": "produkt",
      "pos": "noun",
      "explanation": "result + multiplication",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        459
      ]
    },
    {
      "id": 6484,
      "bciAvId": 29753,
      "gloss": "difference (mathematics)",
      "glossSv": "differens, skillnad (matematik)",
      "pos": "noun",
      "explanation": "result + subtraction",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        634
      ]
    },
    {
      "id": 6485,
      "bciAvId": 29754,
      "gloss": "quotient (mathematics)",
      "glossSv": "kvot",
      "pos": "noun",
      "explanation": "result + division",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        266
      ]
    },
    {
      "id": 6486,
      "bciAvId": 29755,
      "gloss": "ozone layer",
      "glossSv": "ozonlager",
      "pos": "noun",
      "explanation": "layer + gas + ozone",
      "isCharacter": false,
      "composition": [
        1116,
        "/",
        345,
        "/",
        "XO",
        "/",
        22
      ]
    },
    {
      "id": 6487,
      "bciAvId": 29756,
      "gloss": "ozone (gas)",
      "glossSv": "ozon (gas)",
      "pos": "noun",
      "explanation": "gas + ozone",
      "isCharacter": false,
      "composition": [
        345,
        "/",
        "XO",
        "/",
        22
      ]
    },
    {
      "id": 6488,
      "bciAvId": 29757,
      "gloss": "oxygen (gas)",
      "glossSv": "syrgas",
      "pos": "noun",
      "explanation": "gas + oxygen",
      "isCharacter": false,
      "composition": [
        345,
        "/",
        "XO"
      ]
    },
    {
      "id": 6489,
      "bciAvId": 29758,
      "gloss": "carbon dioxide (gas)",
      "glossSv": "koldioxid",
      "pos": "noun",
      "explanation": "gas + carbon dioxide",
      "isCharacter": false,
      "composition": [
        345,
        "/",
        "XC",
        "/",
        "XO",
        "/",
        21
      ]
    },
    {
      "id": 6490,
      "bciAvId": 29760,
      "gloss": "computer science, computer studies",
      "glossSv": "datakunskap",
      "pos": "noun",
      "explanation": "knowledge + digital world",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        1026
      ]
    },
    {
      "id": 6491,
      "bciAvId": 29761,
      "gloss": "social studies, social science",
      "glossSv": "samhällskunskap",
      "pos": "noun",
      "explanation": "knowledge + society",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        348,
        "/",
        225
      ]
    },
    {
      "id": 6492,
      "bciAvId": 29762,
      "gloss": "art (class)",
      "glossSv": "bildkunskap",
      "pos": "noun",
      "explanation": "knowledge + art",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        840,
        "/",
        "RK:-2",
        "/",
        313
      ]
    },
    {
      "id": 6493,
      "bciAvId": 29763,
      "gloss": "music (class)",
      "glossSv": "musikkunskap",
      "pos": "noun",
      "explanation": "knowledge + music",
      "isCharacter": false,
      "composition": [
        412,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 6494,
      "bciAvId": 29764,
      "gloss": "to memorise, to memorize",
      "glossSv": "memorera",
      "pos": "action",
      "explanation": "activity + for + remember: any activity with the purpose to remember",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        332,
        "/",
        841
      ]
    },
    {
      "id": 6495,
      "bciAvId": 29765,
      "gloss": "cooperation",
      "glossSv": "samarbete",
      "pos": "noun",
      "explanation": "activity + agreement: activity which is harmonious",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        113
      ]
    },
    {
      "id": 6496,
      "bciAvId": 29766,
      "gloss": "to cooperate",
      "glossSv": "samarbeta",
      "pos": "action",
      "explanation": "activity + agreement + action indicator: to act harmoniously",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        113
      ]
    },
    {
      "id": 6497,
      "bciAvId": 29767,
      "gloss": "school yard, playground (school)",
      "glossSv": "skolgård",
      "pos": "noun",
      "explanation": "yard + school [in combination]",
      "isCharacter": false,
      "composition": [
        715,
        "/",
        392,
        "/",
        412
      ]
    },
    {
      "id": 6498,
      "bciAvId": 29769,
      "gloss": "demonstration (instruction)",
      "glossSv": "demmonstration (instruktion), förevisning",
      "pos": "noun",
      "explanation": "Noun of show",
      "isCharacter": false,
      "composition": [
        206,
        "/",
        931
      ]
    },
    {
      "id": 6499,
      "bciAvId": 29771,
      "gloss": "monk",
      "glossSv": "munk",
      "pos": "person",
      "explanation": "man + connection + religion + total: a man who dedicated his life to religion",
      "isCharacter": false,
      "composition": [
        433,
        "/",
        232,
        "/",
        726,
        "/",
        117
      ]
    },
    {
      "id": 6500,
      "bciAvId": 29772,
      "gloss": "nun",
      "glossSv": "nunna",
      "pos": "person",
      "explanation": "woman + connection + religion + total: a woman who dedicated her life to religion",
      "isCharacter": false,
      "composition": [
        710,
        "/",
        232,
        "/",
        726,
        "/",
        117
      ]
    },
    {
      "id": 6501,
      "bciAvId": 29773,
      "gloss": "monastery, convent",
      "glossSv": "kloster",
      "pos": "noun",
      "explanation": "home [contraction] + person + connection + religion: home for monks and nuns respectively",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        513,
        "/",
        232,
        "/",
        726
      ]
    },
    {
      "id": 6502,
      "bciAvId": 29780,
      "gloss": "Maundy Thursday",
      "glossSv": "skärtorsdag",
      "pos": "noun",
      "explanation": "Thursday + before + Easter [contraction]: marks the night of the Last Supper before Easter",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        13,
        "/",
        158,
        "/",
        678,
        "/",
        248
      ]
    },
    {
      "id": 6503,
      "bciAvId": 29781,
      "gloss": "Palm Sunday",
      "glossSv": "palmsöndag",
      "pos": "noun",
      "explanation": "Sunday + palm: the crowd waved with palm branches to honour Jesus as he entered Jerusalem",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        16,
        "/",
        496
      ]
    },
    {
      "id": 6504,
      "bciAvId": 29782,
      "gloss": "Pentecost day, Whitsun",
      "glossSv": "pingstdagen",
      "pos": "noun",
      "explanation": "day + Christian + Holy Spirit: the day of the descent of the Holy Spirit upon the Virgin Mary and the Apostles",
      "isCharacter": false,
      "composition": [
        258,
        "/",
        248,
        "/",
        355,
        "/",
        319
      ]
    },
    {
      "id": 6505,
      "bciAvId": 29783,
      "gloss": "pilgrimage",
      "glossSv": "pilgrimsresa, pillgrimsvandring, pilgrimsfärd",
      "pos": "noun",
      "explanation": "journey + holy",
      "isCharacter": false,
      "composition": [
        667,
        "/",
        738,
        "/",
        6435
      ]
    },
    {
      "id": 6506,
      "bciAvId": 29784,
      "gloss": "Eid al-Adha, Id al-Adha",
      "glossSv": "Id",
      "pos": "noun",
      "explanation": "event + end + journey + holy + Islam: marks the end of the pilgrimage in Islam",
      "isCharacter": false,
      "composition": [
        299,
        "/",
        292,
        "/",
        667,
        "/",
        738,
        "/",
        6435
      ]
    },
    {
      "id": 6507,
      "bciAvId": 29785,
      "gloss": "Eid al-Fitr, Id al-Fitr",
      "glossSv": "Eid",
      "pos": "noun",
      "explanation": "party [contraction] + end + Ramadan [contraction]: the feast after Ramadan",
      "isCharacter": false,
      "composition": [
        346,
        "/",
        292,
        "/",
        449,
        "/",
        329,
        "/",
        6435
      ]
    },
    {
      "id": 6508,
      "bciAvId": 29790,
      "gloss": "train driver, engine driver",
      "glossSv": "lokförare",
      "pos": "person",
      "explanation": "person + train: person who drives the train",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        368,
        "/",
        688
      ]
    },
    {
      "id": 6509,
      "bciAvId": 29791,
      "gloss": "gold (colour)",
      "glossSv": "guldfärg",
      "pos": "noun",
      "explanation": "colour + gold: colour of the metal gold",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        814,
        "/",
        567
      ]
    },
    {
      "id": 6510,
      "bciAvId": 29792,
      "gloss": "silver (colour)",
      "glossSv": "silverfärg",
      "pos": "noun",
      "explanation": "colour + silver: colour of the metal silver",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        814,
        "/",
        614
      ]
    },
    {
      "id": 6511,
      "bciAvId": 29793,
      "gloss": "bronze (colour)",
      "glossSv": "bronsfärg",
      "pos": "noun",
      "explanation": "colour + bronze: colour of the metal bronze",
      "isCharacter": false,
      "composition": [
        1161,
        "/",
        814,
        "/",
        251,
        "/",
        542
      ]
    },
    {
      "id": 6512,
      "bciAvId": 29794,
      "gloss": "TV room",
      "glossSv": "TV-rum",
      "pos": "noun",
      "explanation": "room + TV",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        303,
        "/",
        278,
        "/",
        288
      ]
    },
    {
      "id": 6513,
      "bciAvId": 29795,
      "gloss": "computer room",
      "glossSv": "datarum, datorrum",
      "pos": "noun",
      "explanation": "room + computer",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        432,
        "/",
        829
      ]
    },
    {
      "id": 6514,
      "bciAvId": 29796,
      "gloss": "hobby room",
      "glossSv": "hobbyrum",
      "pos": "noun",
      "explanation": "room + hobby",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        106,
        "/",
        955
      ]
    },
    {
      "id": 6515,
      "bciAvId": 29797,
      "gloss": "opera house",
      "glossSv": "operahus",
      "pos": "noun",
      "explanation": "house,building + opera",
      "isCharacter": false,
      "composition": [
        392,
        "/",
        457,
        "/",
        462,
        "/",
        723
      ]
    },
    {
      "id": 6516,
      "bciAvId": 29801,
      "gloss": "arm fracture",
      "glossSv": "armbrott",
      "pos": "noun",
      "explanation": "bone fracture + arm",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        172,
        "/",
        132
      ]
    },
    {
      "id": 6517,
      "bciAvId": 29802,
      "gloss": "leg fracture",
      "glossSv": "benbrott",
      "pos": "noun",
      "explanation": "bone fracture + leg",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        172,
        "/",
        417
      ]
    },
    {
      "id": 6518,
      "bciAvId": 29803,
      "gloss": "high blood pressure",
      "glossSv": "högt blodtryck",
      "pos": "noun",
      "explanation": "blood pressure + high",
      "isCharacter": false,
      "composition": [
        815,
        "/",
        695,
        "/",
        423,
        "/",
        952
      ]
    },
    {
      "id": 6519,
      "bciAvId": 29804,
      "gloss": "low blood pressure",
      "glossSv": "lågt blodtryck",
      "pos": "noun",
      "explanation": "blood pressure + low",
      "isCharacter": false,
      "composition": [
        815,
        "/",
        695,
        "/",
        423,
        "/",
        957
      ]
    },
    {
      "id": 6520,
      "bciAvId": 29805,
      "gloss": "burn",
      "glossSv": "brännsår, brännskada",
      "pos": "noun",
      "explanation": "flame + skin",
      "isCharacter": false,
      "composition": [
        319,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 6521,
      "bciAvId": 29806,
      "gloss": "scar",
      "glossSv": "ärr",
      "pos": "noun",
      "explanation": "result + wound",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        933,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 6522,
      "bciAvId": 29807,
      "gloss": "scab",
      "glossSv": "sårskorpa",
      "pos": "noun",
      "explanation": "crust + skin",
      "isCharacter": false,
      "composition": [
        588,
        "/",
        548,
        "/",
        171
      ]
    },
    {
      "id": 6523,
      "bciAvId": 29808,
      "gloss": "diabetes",
      "glossSv": "diabetes",
      "pos": "noun",
      "explanation": "disease + insulin",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        216,
        "/",
        748,
        "/",
        711
      ]
    },
    {
      "id": 6524,
      "bciAvId": 29809,
      "gloss": "autoimmune disease",
      "glossSv": "autoimmun sjukdom",
      "pos": "noun",
      "explanation": "disease + immunity; a disease affecting the immune system",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        5,
        "/",
        111,
        "/",
        516
      ]
    },
    {
      "id": 6525,
      "bciAvId": 29811,
      "gloss": "HIV virus",
      "glossSv": "HIV",
      "pos": "noun",
      "explanation": "virus + HIV",
      "isCharacter": false,
      "composition": [
        894,
        ";",
        97,
        "/",
        956,
        "/",
        963,
        "/",
        "XH",
        "/",
        "XI",
        "/",
        "XV"
      ]
    },
    {
      "id": 6526,
      "bciAvId": 29812,
      "gloss": "AIDS",
      "glossSv": "AIDS",
      "pos": "noun",
      "explanation": "disease + AIDS",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        "XA",
        "/",
        "XI",
        "/",
        "XD",
        "/",
        "XS"
      ]
    },
    {
      "id": 6527,
      "bciAvId": 29814,
      "gloss": "respiratory disorder",
      "glossSv": "andningsbesvär",
      "pos": "noun",
      "explanation": "limitation + respiratory system [contraction]",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        473,
        "/",
        457
      ]
    },
    {
      "id": 6528,
      "bciAvId": 29815,
      "gloss": "language impairment, language disorder",
      "glossSv": "språkstörning",
      "pos": "noun",
      "explanation": "limitation + language",
      "isCharacter": false,
      "composition": [
        1053,
        "/",
        414
      ]
    },
    {
      "id": 6529,
      "bciAvId": 29816,
      "gloss": "seizure (epileptic), fit (epileptic)",
      "glossSv": "epileptiskt anfall",
      "pos": "noun",
      "explanation": "attack + central nervous system",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        426,
        "/",
        991
      ]
    },
    {
      "id": 6530,
      "bciAvId": 29817,
      "gloss": "epilepsy",
      "glossSv": "epilepsi",
      "pos": "noun",
      "explanation": "disease + central nervous system",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        991
      ]
    },
    {
      "id": 6531,
      "bciAvId": 29818,
      "gloss": "physical violence, physical abuse",
      "glossSv": "fysiskt våld, misshandel, fysiskt övergrepp",
      "pos": "noun",
      "explanation": "violence + body",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        171
      ]
    },
    {
      "id": 6532,
      "bciAvId": 29819,
      "gloss": "mental abuse, emotional abuse",
      "glossSv": "psykiskt våld, psykisk misshandel, psykiskt övergrepp",
      "pos": "noun",
      "explanation": "violence + psychology [contraction]",
      "isCharacter": false,
      "composition": [
        804,
        "/",
        401,
        "/",
        447,
        "/",
        313
      ]
    },
    {
      "id": 6533,
      "bciAvId": 29820,
      "gloss": "throat infection, pharyngitis",
      "glossSv": "halsinfektion, halsfluss",
      "pos": "noun",
      "explanation": "disease + throat",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        1142
      ]
    },
    {
      "id": 6534,
      "bciAvId": 29821,
      "gloss": "sore throat",
      "glossSv": "ont i halsen, halsont",
      "pos": "noun",
      "explanation": "pain + throat",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        1142
      ]
    },
    {
      "id": 6535,
      "bciAvId": 29822,
      "gloss": "tooth damage",
      "glossSv": "tandskada",
      "pos": "noun",
      "explanation": "break + tooth",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        1121
      ]
    },
    {
      "id": 6536,
      "bciAvId": 29823,
      "gloss": "toothache",
      "glossSv": "tandvärk",
      "pos": "noun",
      "explanation": "pain + teeth",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        644
      ]
    },
    {
      "id": 6537,
      "bciAvId": 29824,
      "gloss": "headache",
      "glossSv": "ont i huvudet, huvudvärk",
      "pos": "noun",
      "explanation": "pain + head",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        376
      ]
    },
    {
      "id": 6538,
      "bciAvId": 29825,
      "gloss": "back pain, pain in back",
      "glossSv": "ont i ryggen, ryggskott",
      "pos": "noun",
      "explanation": "pain + back",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        143
      ]
    },
    {
      "id": 6539,
      "bciAvId": 29826,
      "gloss": "earache",
      "glossSv": "ont i örat",
      "pos": "noun",
      "explanation": "pain + ear",
      "isCharacter": false,
      "composition": [
        313,
        "/",
        "RK:-2",
        "/",
        516,
        "/",
        278
      ]
    },
    {
      "id": 6540,
      "bciAvId": 29827,
      "gloss": "ear infection",
      "glossSv": "öroninflammation",
      "pos": "noun",
      "explanation": "disease + ear",
      "isCharacter": false,
      "composition": [
        516,
        "/",
        278
      ]
    },
    {
      "id": 6541,
      "bciAvId": 29828,
      "gloss": "symptom (disease)",
      "glossSv": "symptom",
      "pos": "noun",
      "explanation": "observation + part of + disease",
      "isCharacter": false,
      "composition": [
        931,
        "/",
        502,
        "/",
        516
      ]
    },
    {
      "id": 6542,
      "bciAvId": 29829,
      "gloss": "joint dislocation",
      "glossSv": "ledlluxation",
      "pos": "noun",
      "explanation": "detachment + joint",
      "isCharacter": false,
      "composition": [
        1022,
        "/",
        406
      ]
    },
    {
      "id": 6543,
      "bciAvId": 29830,
      "gloss": "hip dislocation",
      "glossSv": "höftledsluxation",
      "pos": "noun",
      "explanation": "detachment + joint+hip",
      "isCharacter": false,
      "composition": [
        1022,
        "/",
        406,
        "/",
        384
      ]
    },
    {
      "id": 6544,
      "bciAvId": 29831,
      "gloss": "joint injury",
      "glossSv": "ledskada",
      "pos": "noun",
      "explanation": "damage + joint",
      "isCharacter": false,
      "composition": [
        933,
        "/",
        406
      ]
    },
    {
      "id": 6545,
      "bciAvId": 29832,
      "gloss": "sting (insect), insect bite",
      "glossSv": "insektsbett",
      "pos": "noun",
      "explanation": "effect + stinging insect",
      "isCharacter": false,
      "composition": [
        284,
        "/",
        400,
        "/",
        538
      ]
    },
    {
      "id": 6546,
      "bciAvId": 29833,
      "gloss": "to sting",
      "glossSv": "sticka (insekt)",
      "pos": "action",
      "explanation": "to prick + insect",
      "isCharacter": false,
      "composition": [
        538,
        ";",
        81,
        "/",
        400
      ]
    },
    {
      "id": 6547,
      "bciAvId": 29840,
      "gloss": "to misunderstand",
      "glossSv": "missförstå, missuppfatta",
      "pos": "action",
      "explanation": "understand + incorrect + action indicator: understand in the wrong way",
      "isCharacter": false,
      "composition": [
        1103,
        ";",
        81,
        "/",
        1013,
        "/",
        401
      ]
    },
    {
      "id": 6548,
      "bciAvId": 29841,
      "gloss": "complain, grumble, whine - (to) (people)",
      "glossSv": "klaga",
      "pos": "action",
      "explanation": "say + unhappy + action indicator: express discontent, express annoyance, report pain",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        313,
        "/",
        271
      ]
    },
    {
      "id": 6549,
      "bciAvId": 29843,
      "gloss": "to swear",
      "glossSv": "svära",
      "pos": "action",
      "explanation": "coarse slang + action indicator",
      "isCharacter": false,
      "composition": [
        971,
        ";",
        81
      ]
    },
    {
      "id": 6550,
      "bciAvId": 29844,
      "gloss": "to comment",
      "glossSv": "kommentera",
      "pos": "action",
      "explanation": "say + addition + action indicator: make an addition to something said",
      "isCharacter": false,
      "composition": [
        457,
        ";",
        81,
        "/",
        107
      ]
    },
    {
      "id": 6551,
      "bciAvId": 29845,
      "gloss": "to send (digital)",
      "glossSv": "skicka digitalt",
      "pos": "action",
      "explanation": "out of (forward) + digital+action indicator: send digitally",
      "isCharacter": false,
      "composition": [
        491,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 6552,
      "bciAvId": 29846,
      "gloss": "text (writing)",
      "glossSv": "text",
      "pos": "noun",
      "explanation": "pen + language: written language",
      "isCharacter": false,
      "composition": [
        509,
        "/",
        414
      ]
    },
    {
      "id": 6553,
      "bciAvId": 29847,
      "gloss": "edit - (to) (text)",
      "glossSv": "redigera",
      "pos": "action",
      "explanation": "do + better [contraction] + text: revise text",
      "isCharacter": false,
      "composition": [
        106,
        ";",
        81,
        "/",
        937,
        "/",
        509,
        "/",
        414
      ]
    },
    {
      "id": 6554,
      "bciAvId": 29848,
      "gloss": "to text, to write (digital)",
      "glossSv": "skriva digitalt",
      "pos": "action",
      "explanation": "text + digital + action indicator",
      "isCharacter": false,
      "composition": [
        509,
        ";",
        81,
        "/",
        829
      ]
    },
    {
      "id": 6555,
      "bciAvId": 29849,
      "gloss": "volume (sound)",
      "glossSv": "ljudvolym",
      "pos": "noun",
      "explanation": "scale,measurement + sound: measurement of sound volume",
      "isCharacter": false,
      "composition": [
        927,
        "/",
        608
      ]
    },
    {
      "id": 6556,
      "bciAvId": 29850,
      "gloss": "Coca Cola, Coke (drink)",
      "glossSv": "Coca-Cola, coke",
      "pos": "noun",
      "explanation": "soda pop, pop, soft drink + C: a soft drink with the initials C for Coke",
      "isCharacter": false,
      "composition": [
        275,
        "/",
        345,
        "/",
        "XC"
      ]
    },
    {
      "id": 6557,
      "bciAvId": 29851,
      "gloss": "muesli",
      "glossSv": "müsli",
      "pos": "noun",
      "explanation": "grain, cereal + mixture",
      "isCharacter": false,
      "composition": [
        211,
        "/",
        783
      ]
    },
    {
      "id": 6558,
      "bciAvId": 29852,
      "gloss": "seafood",
      "glossSv": "fisk och skaldjur",
      "pos": "noun",
      "explanation": "food + sea",
      "isCharacter": false,
      "composition": [
        329,
        "/",
        368,
        "/",
        368,
        "/",
        1117
      ]
    },
    {
      "id": 6559,
      "bciAvId": 29853,
      "gloss": "ice cream kiosk",
      "glossSv": "glasstånd, glasskiosk",
      "pos": "noun",
      "explanation": "kiosk + ice cream: a small place where ice cream is sold",
      "isCharacter": false,
      "composition": [
        5841,
        "/",
        395
      ]
    },
    {
      "id": 6560,
      "bciAvId": 29855,
      "gloss": "used",
      "glossSv": "använd",
      "pos": "description",
      "explanation": "to use + description indicator after the fact: describing any item previously used",
      "isCharacter": false,
      "composition": [
        932,
        ";",
        84
      ]
    },
    {
      "id": 6561,
      "bciAvId": 29856,
      "gloss": "blunt",
      "glossSv": "slö",
      "pos": "description",
      "explanation": "minus + sharp",
      "isCharacter": false,
      "composition": [
        449,
        "/",
        411,
        ";",
        86
      ]
    },
    {
      "id": 6562,
      "bciAvId": 29860,
      "gloss": "ballet dancer",
      "glossSv": "ballettdansare",
      "pos": "person",
      "explanation": "person + ballet [contraction]",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        658,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 6563,
      "bciAvId": 29861,
      "gloss": "ballet shoes",
      "glossSv": "ballettsko",
      "pos": "noun",
      "explanation": "shoes [contraction] + ballet [contraction]",
      "isCharacter": false,
      "composition": [
        548,
        "/",
        658,
        "/",
        278,
        "/",
        462
      ]
    },
    {
      "id": 6564,
      "bciAvId": 29862,
      "gloss": "string of lights",
      "glossSv": "ljusslinga",
      "pos": "noun",
      "explanation": "many + electric light,lamp [contraction] + chain: many lights connected in a chain",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        424,
        ";",
        97,
        "/",
        232
      ]
    },
    {
      "id": 6565,
      "bciAvId": 29863,
      "gloss": "entertainment",
      "glossSv": "underhållning",
      "pos": "noun",
      "explanation": "activity + purpose + pleasure: an activity for pleasure",
      "isCharacter": false,
      "composition": [
        106,
        "/",
        551,
        "/",
        313,
        "/",
        678
      ]
    },
    {
      "id": 6566,
      "bciAvId": 29864,
      "gloss": "march, parade (general)",
      "glossSv": "marsch, parad",
      "pos": "noun",
      "explanation": "group (people) + walk + purpose: a group of people walking with a particular purpose",
      "isCharacter": false,
      "composition": [
        368,
        "/",
        513,
        "/",
        418,
        "/",
        551
      ]
    },
    {
      "id": 6567,
      "bciAvId": 29865,
      "gloss": "week schedule",
      "glossSv": "veckoschema",
      "pos": "noun",
      "explanation": "schedule, timetable + week: a timetable that covers a full week",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        655,
        "/",
        16,
        "/",
        258
      ]
    },
    {
      "id": 6568,
      "bciAvId": 29866,
      "gloss": "day schedule",
      "glossSv": "dagsschema",
      "pos": "noun",
      "explanation": "schedule, timetable + day: a timetable that covers a full day",
      "isCharacter": false,
      "composition": [
        497,
        "/",
        655,
        "/",
        258
      ]
    },
    {
      "id": 6569,
      "bciAvId": 29867,
      "gloss": "shopping street, high street",
      "glossSv": "affärsgata",
      "pos": "noun",
      "explanation": "street + shop",
      "isCharacter": false,
      "composition": [
        632,
        "/",
        819
      ]
    },
    {
      "id": 6570,
      "bciAvId": 29868,
      "gloss": "home office",
      "glossSv": "hemmakontor",
      "pos": "noun",
      "explanation": "office [contraction] + home",
      "isCharacter": false,
      "composition": [
        572,
        "/",
        711,
        "/",
        392,
        "/",
        313
      ]
    },
    {
      "id": 6571,
      "bciAvId": 29869,
      "gloss": "emergency exit",
      "glossSv": "nödutgång",
      "pos": "noun",
      "explanation": "exit + danger: an exit in case of danger, emergency",
      "isCharacter": false,
      "composition": [
        491,
        "/",
        256
      ]
    },
    {
      "id": 6572,
      "bciAvId": 29870,
      "gloss": "downtown, city centre, city center",
      "glossSv": "centrum (ort, stad)",
      "pos": "noun",
      "explanation": "middle,centre + city; the centre of a city",
      "isCharacter": false,
      "composition": [
        446,
        "/",
        368,
        "/",
        368,
        "/",
        392
      ]
    },
    {
      "id": 6573,
      "bciAvId": 29875,
      "gloss": "pastry chef, pastry cook",
      "glossSv": "konditor",
      "pos": "person",
      "explanation": "person + cake: the person making pastry",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        180,
        "/",
        642,
        "/",
        678
      ]
    },
    {
      "id": 6574,
      "bciAvId": 29876,
      "gloss": "receptionist",
      "glossSv": "receptionist",
      "pos": "person",
      "explanation": "person + work + reception; the person who works at the reception",
      "isCharacter": false,
      "composition": [
        513,
        "/",
        402,
        "/",
        553
      ]
    },
    {
      "id": 6575,
      "bciAvId": 29877,
      "gloss": "workshop, course (educational)",
      "glossSv": "kurs (lärande), workshop",
      "pos": "noun",
      "explanation": "limited time, period + exchange + knowledge; a limited period for learning and teaching",
      "isCharacter": false,
      "composition": [
        426,
        "/",
        1029,
        "/",
        412
      ]
    },
    {
      "id": 6576,
      "bciAvId": 29878,
      "gloss": "contact lens",
      "glossSv": "kontaktlins",
      "pos": "noun",
      "explanation": "thing + curve + eye; a contact lens described as curved thing for the eye",
      "isCharacter": false,
      "composition": [
        651,
        "/",
        255,
        "/",
        303
      ]
    },
    {
      "id": 6577,
      "bciAvId": 29879,
      "gloss": "media",
      "glossSv": "media",
      "pos": "noun",
      "explanation": "resource + information",
      "isCharacter": false,
      "composition": [
        6443,
        "/",
        835
      ]
    },
    {
      "id": 6578,
      "bciAvId": 29880,
      "gloss": "media (digital)",
      "glossSv": "media (digital)",
      "pos": "noun",
      "explanation": "media + digital",
      "isCharacter": false,
      "composition": [
        6443,
        "/",
        835,
        "/",
        829
      ]
    }
  ]
}
